
/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */

(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
    get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
  }) : x)(function(x) {
    if (typeof require !== "undefined")
      return require.apply(this, arguments);
    throw new Error('Dynamic require of "' + x + '" is not supported');
  });
  var __esm = (fn, res) => function __init() {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  };
  var __commonJS = (cb, mod) => function __require2() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from3, except, desc) => {
    if (from3 && typeof from3 === "object" || typeof from3 === "function") {
      for (let key of __getOwnPropNames(from3))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from3[key], enumerable: !(desc = __getOwnPropDesc(from3, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // packages/shared/render/plugins/BackgroundVideo/objectFitPolyfill.basic.js
  var require_objectFitPolyfill_basic = __commonJS({
    "packages/shared/render/plugins/BackgroundVideo/objectFitPolyfill.basic.js"() {
      (function() {
        if (typeof window === "undefined")
          return;
        const edgeVersion = window.navigator.userAgent.match(/Edge\/(\d{2})\./);
        const edgePartialSupport = edgeVersion ? parseInt(edgeVersion[1], 10) >= 16 : false;
        const hasSupport = "objectFit" in document.documentElement.style !== false;
        if (hasSupport && !edgePartialSupport) {
          window.objectFitPolyfill = function() {
            return false;
          };
          return;
        }
        const checkParentContainer = function($container) {
          const styles = window.getComputedStyle($container, null);
          const position = styles.getPropertyValue("position");
          const overflow = styles.getPropertyValue("overflow");
          const display = styles.getPropertyValue("display");
          if (!position || position === "static") {
            $container.style.position = "relative";
          }
          if (overflow !== "hidden") {
            $container.style.overflow = "hidden";
          }
          if (!display || display === "inline") {
            $container.style.display = "block";
          }
          if ($container.clientHeight === 0) {
            $container.style.height = "100%";
          }
          if ($container.className.indexOf("object-fit-polyfill") === -1) {
            $container.className += " object-fit-polyfill";
          }
        };
        const checkMediaProperties = function($media) {
          const styles = window.getComputedStyle($media, null);
          const constraints = {
            "max-width": "none",
            "max-height": "none",
            "min-width": "0px",
            "min-height": "0px",
            top: "auto",
            right: "auto",
            bottom: "auto",
            left: "auto",
            "margin-top": "0px",
            "margin-right": "0px",
            "margin-bottom": "0px",
            "margin-left": "0px"
          };
          for (const property in constraints) {
            const constraint = styles.getPropertyValue(property);
            if (constraint !== constraints[property]) {
              $media.style[property] = constraints[property];
            }
          }
        };
        const objectFit = function($media) {
          const $container = $media.parentNode;
          checkParentContainer($container);
          checkMediaProperties($media);
          $media.style.position = "absolute";
          $media.style.height = "100%";
          $media.style.width = "auto";
          if ($media.clientWidth > $container.clientWidth) {
            $media.style.top = "0";
            $media.style.marginTop = "0";
            $media.style.left = "50%";
            $media.style.marginLeft = $media.clientWidth / -2 + "px";
          } else {
            $media.style.width = "100%";
            $media.style.height = "auto";
            $media.style.left = "0";
            $media.style.marginLeft = "0";
            $media.style.top = "50%";
            $media.style.marginTop = $media.clientHeight / -2 + "px";
          }
        };
        const objectFitPolyfill = function(media) {
          if (typeof media === "undefined" || media instanceof Event) {
            media = document.querySelectorAll("[data-object-fit]");
          } else if (media && media.nodeName) {
            media = [media];
          } else if (typeof media === "object" && media.length && media[0].nodeName) {
            media = media;
          } else {
            return false;
          }
          for (let i = 0; i < media.length; i++) {
            if (!media[i].nodeName)
              continue;
            const mediaType = media[i].nodeName.toLowerCase();
            if (mediaType === "img") {
              if (edgePartialSupport)
                continue;
              if (media[i].complete) {
                objectFit(media[i]);
              } else {
                media[i].addEventListener("load", function() {
                  objectFit(this);
                });
              }
            } else if (mediaType === "video") {
              if (media[i].readyState > 0) {
                objectFit(media[i]);
              } else {
                media[i].addEventListener("loadedmetadata", function() {
                  objectFit(this);
                });
              }
            } else {
              objectFit(media[i]);
            }
          }
          return true;
        };
        if (document.readyState === "loading") {
          document.addEventListener("DOMContentLoaded", objectFitPolyfill);
        } else {
          objectFitPolyfill();
        }
        window.addEventListener("resize", objectFitPolyfill);
        window.objectFitPolyfill = objectFitPolyfill;
      })();
    }
  });

  // packages/shared/render/plugins/BackgroundVideo/webflow-bgvideo.js
  var require_webflow_bgvideo = __commonJS({
    "packages/shared/render/plugins/BackgroundVideo/webflow-bgvideo.js"() {
      (function() {
        if (typeof window === "undefined")
          return;
        function setAllBackgroundVideoStates(shouldPlay) {
          if (Webflow.env("design")) {
            return;
          }
          $("video").each(function() {
            shouldPlay && $(this).prop("autoplay") ? this.play() : this.pause();
          });
          $(".w-background-video--control").each(function() {
            if (shouldPlay) {
              showPauseButton($(this));
            } else {
              showPlayButton($(this));
            }
          });
        }
        function showPlayButton($btn) {
          $btn.find("> span").each(function(i) {
            $(this).prop("hidden", () => i === 0);
          });
        }
        function showPauseButton($btn) {
          $btn.find("> span").each(function(i) {
            $(this).prop("hidden", () => i === 1);
          });
        }
        $(document).ready(() => {
          const watcher = window.matchMedia("(prefers-reduced-motion: reduce)");
          watcher.addEventListener("change", (e) => {
            setAllBackgroundVideoStates(!e.matches);
          });
          if (watcher.matches) {
            setAllBackgroundVideoStates(false);
          }
          $("video:not([autoplay])").each(function() {
            $(this).parent().find(".w-background-video--control").each(function() {
              showPlayButton($(this));
            });
          });
          $(document).on("click", ".w-background-video--control", function(e) {
            if (Webflow.env("design"))
              return;
            const btn = $(e.currentTarget);
            const video = $(`video#${btn.attr("aria-controls")}`).get(0);
            if (!video)
              return;
            if (video.paused) {
              const play = video.play();
              showPauseButton(btn);
              if (play && typeof play.catch === "function") {
                play.catch(() => {
                  showPlayButton(btn);
                });
              }
            } else {
              video.pause();
              showPlayButton(btn);
            }
          });
        });
      })();
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/tram-min.js
  var require_tram_min = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/tram-min.js"() {
      window.tram = function(a) {
        function b(a2, b2) {
          var c2 = new M.Bare();
          return c2.init(a2, b2);
        }
        function c(a2) {
          return a2.replace(/[A-Z]/g, function(a3) {
            return "-" + a3.toLowerCase();
          });
        }
        function d(a2) {
          var b2 = parseInt(a2.slice(1), 16), c2 = b2 >> 16 & 255, d2 = b2 >> 8 & 255, e2 = 255 & b2;
          return [c2, d2, e2];
        }
        function e(a2, b2, c2) {
          return "#" + (1 << 24 | a2 << 16 | b2 << 8 | c2).toString(16).slice(1);
        }
        function f() {
        }
        function g(a2, b2) {
          j("Type warning: Expected: [" + a2 + "] Got: [" + typeof b2 + "] " + b2);
        }
        function h(a2, b2, c2) {
          j("Units do not match [" + a2 + "]: " + b2 + ", " + c2);
        }
        function i(a2, b2, c2) {
          if (void 0 !== b2 && (c2 = b2), void 0 === a2)
            return c2;
          var d2 = c2;
          return $2.test(a2) || !_.test(a2) ? d2 = parseInt(a2, 10) : _.test(a2) && (d2 = 1e3 * parseFloat(a2)), 0 > d2 && (d2 = 0), d2 === d2 ? d2 : c2;
        }
        function j(a2) {
          U.debug && window && window.console.warn(a2);
        }
        function k(a2) {
          for (var b2 = -1, c2 = a2 ? a2.length : 0, d2 = []; ++b2 < c2; ) {
            var e2 = a2[b2];
            e2 && d2.push(e2);
          }
          return d2;
        }
        var l = function(a2, b2, c2) {
          function d2(a3) {
            return "object" == typeof a3;
          }
          function e2(a3) {
            return "function" == typeof a3;
          }
          function f2() {
          }
          function g2(h2, i2) {
            function j2() {
              var a3 = new k2();
              return e2(a3.init) && a3.init.apply(a3, arguments), a3;
            }
            function k2() {
            }
            i2 === c2 && (i2 = h2, h2 = Object), j2.Bare = k2;
            var l2, m2 = f2[a2] = h2[a2], n2 = k2[a2] = j2[a2] = new f2();
            return n2.constructor = j2, j2.mixin = function(b3) {
              return k2[a2] = j2[a2] = g2(j2, b3)[a2], j2;
            }, j2.open = function(a3) {
              if (l2 = {}, e2(a3) ? l2 = a3.call(j2, n2, m2, j2, h2) : d2(a3) && (l2 = a3), d2(l2))
                for (var c3 in l2)
                  b2.call(l2, c3) && (n2[c3] = l2[c3]);
              return e2(n2.init) || (n2.init = h2), j2;
            }, j2.open(i2);
          }
          return g2;
        }("prototype", {}.hasOwnProperty), m = {
          ease: ["ease", function(a2, b2, c2, d2) {
            var e2 = (a2 /= d2) * a2, f2 = e2 * a2;
            return b2 + c2 * (-2.75 * f2 * e2 + 11 * e2 * e2 + -15.5 * f2 + 8 * e2 + 0.25 * a2);
          }],
          "ease-in": ["ease-in", function(a2, b2, c2, d2) {
            var e2 = (a2 /= d2) * a2, f2 = e2 * a2;
            return b2 + c2 * (-1 * f2 * e2 + 3 * e2 * e2 + -3 * f2 + 2 * e2);
          }],
          "ease-out": ["ease-out", function(a2, b2, c2, d2) {
            var e2 = (a2 /= d2) * a2, f2 = e2 * a2;
            return b2 + c2 * (0.3 * f2 * e2 + -1.6 * e2 * e2 + 2.2 * f2 + -1.8 * e2 + 1.9 * a2);
          }],
          "ease-in-out": ["ease-in-out", function(a2, b2, c2, d2) {
            var e2 = (a2 /= d2) * a2, f2 = e2 * a2;
            return b2 + c2 * (2 * f2 * e2 + -5 * e2 * e2 + 2 * f2 + 2 * e2);
          }],
          linear: ["linear", function(a2, b2, c2, d2) {
            return c2 * a2 / d2 + b2;
          }],
          "ease-in-quad": ["cubic-bezier(0.550, 0.085, 0.680, 0.530)", function(a2, b2, c2, d2) {
            return c2 * (a2 /= d2) * a2 + b2;
          }],
          "ease-out-quad": ["cubic-bezier(0.250, 0.460, 0.450, 0.940)", function(a2, b2, c2, d2) {
            return -c2 * (a2 /= d2) * (a2 - 2) + b2;
          }],
          "ease-in-out-quad": ["cubic-bezier(0.455, 0.030, 0.515, 0.955)", function(a2, b2, c2, d2) {
            return (a2 /= d2 / 2) < 1 ? c2 / 2 * a2 * a2 + b2 : -c2 / 2 * (--a2 * (a2 - 2) - 1) + b2;
          }],
          "ease-in-cubic": ["cubic-bezier(0.550, 0.055, 0.675, 0.190)", function(a2, b2, c2, d2) {
            return c2 * (a2 /= d2) * a2 * a2 + b2;
          }],
          "ease-out-cubic": ["cubic-bezier(0.215, 0.610, 0.355, 1)", function(a2, b2, c2, d2) {
            return c2 * ((a2 = a2 / d2 - 1) * a2 * a2 + 1) + b2;
          }],
          "ease-in-out-cubic": ["cubic-bezier(0.645, 0.045, 0.355, 1)", function(a2, b2, c2, d2) {
            return (a2 /= d2 / 2) < 1 ? c2 / 2 * a2 * a2 * a2 + b2 : c2 / 2 * ((a2 -= 2) * a2 * a2 + 2) + b2;
          }],
          "ease-in-quart": ["cubic-bezier(0.895, 0.030, 0.685, 0.220)", function(a2, b2, c2, d2) {
            return c2 * (a2 /= d2) * a2 * a2 * a2 + b2;
          }],
          "ease-out-quart": ["cubic-bezier(0.165, 0.840, 0.440, 1)", function(a2, b2, c2, d2) {
            return -c2 * ((a2 = a2 / d2 - 1) * a2 * a2 * a2 - 1) + b2;
          }],
          "ease-in-out-quart": ["cubic-bezier(0.770, 0, 0.175, 1)", function(a2, b2, c2, d2) {
            return (a2 /= d2 / 2) < 1 ? c2 / 2 * a2 * a2 * a2 * a2 + b2 : -c2 / 2 * ((a2 -= 2) * a2 * a2 * a2 - 2) + b2;
          }],
          "ease-in-quint": ["cubic-bezier(0.755, 0.050, 0.855, 0.060)", function(a2, b2, c2, d2) {
            return c2 * (a2 /= d2) * a2 * a2 * a2 * a2 + b2;
          }],
          "ease-out-quint": ["cubic-bezier(0.230, 1, 0.320, 1)", function(a2, b2, c2, d2) {
            return c2 * ((a2 = a2 / d2 - 1) * a2 * a2 * a2 * a2 + 1) + b2;
          }],
          "ease-in-out-quint": ["cubic-bezier(0.860, 0, 0.070, 1)", function(a2, b2, c2, d2) {
            return (a2 /= d2 / 2) < 1 ? c2 / 2 * a2 * a2 * a2 * a2 * a2 + b2 : c2 / 2 * ((a2 -= 2) * a2 * a2 * a2 * a2 + 2) + b2;
          }],
          "ease-in-sine": ["cubic-bezier(0.470, 0, 0.745, 0.715)", function(a2, b2, c2, d2) {
            return -c2 * Math.cos(a2 / d2 * (Math.PI / 2)) + c2 + b2;
          }],
          "ease-out-sine": ["cubic-bezier(0.390, 0.575, 0.565, 1)", function(a2, b2, c2, d2) {
            return c2 * Math.sin(a2 / d2 * (Math.PI / 2)) + b2;
          }],
          "ease-in-out-sine": ["cubic-bezier(0.445, 0.050, 0.550, 0.950)", function(a2, b2, c2, d2) {
            return -c2 / 2 * (Math.cos(Math.PI * a2 / d2) - 1) + b2;
          }],
          "ease-in-expo": ["cubic-bezier(0.950, 0.050, 0.795, 0.035)", function(a2, b2, c2, d2) {
            return 0 === a2 ? b2 : c2 * Math.pow(2, 10 * (a2 / d2 - 1)) + b2;
          }],
          "ease-out-expo": ["cubic-bezier(0.190, 1, 0.220, 1)", function(a2, b2, c2, d2) {
            return a2 === d2 ? b2 + c2 : c2 * (-Math.pow(2, -10 * a2 / d2) + 1) + b2;
          }],
          "ease-in-out-expo": ["cubic-bezier(1, 0, 0, 1)", function(a2, b2, c2, d2) {
            return 0 === a2 ? b2 : a2 === d2 ? b2 + c2 : (a2 /= d2 / 2) < 1 ? c2 / 2 * Math.pow(2, 10 * (a2 - 1)) + b2 : c2 / 2 * (-Math.pow(2, -10 * --a2) + 2) + b2;
          }],
          "ease-in-circ": ["cubic-bezier(0.600, 0.040, 0.980, 0.335)", function(a2, b2, c2, d2) {
            return -c2 * (Math.sqrt(1 - (a2 /= d2) * a2) - 1) + b2;
          }],
          "ease-out-circ": ["cubic-bezier(0.075, 0.820, 0.165, 1)", function(a2, b2, c2, d2) {
            return c2 * Math.sqrt(1 - (a2 = a2 / d2 - 1) * a2) + b2;
          }],
          "ease-in-out-circ": ["cubic-bezier(0.785, 0.135, 0.150, 0.860)", function(a2, b2, c2, d2) {
            return (a2 /= d2 / 2) < 1 ? -c2 / 2 * (Math.sqrt(1 - a2 * a2) - 1) + b2 : c2 / 2 * (Math.sqrt(1 - (a2 -= 2) * a2) + 1) + b2;
          }],
          "ease-in-back": ["cubic-bezier(0.600, -0.280, 0.735, 0.045)", function(a2, b2, c2, d2, e2) {
            return void 0 === e2 && (e2 = 1.70158), c2 * (a2 /= d2) * a2 * ((e2 + 1) * a2 - e2) + b2;
          }],
          "ease-out-back": ["cubic-bezier(0.175, 0.885, 0.320, 1.275)", function(a2, b2, c2, d2, e2) {
            return void 0 === e2 && (e2 = 1.70158), c2 * ((a2 = a2 / d2 - 1) * a2 * ((e2 + 1) * a2 + e2) + 1) + b2;
          }],
          "ease-in-out-back": ["cubic-bezier(0.680, -0.550, 0.265, 1.550)", function(a2, b2, c2, d2, e2) {
            return void 0 === e2 && (e2 = 1.70158), (a2 /= d2 / 2) < 1 ? c2 / 2 * a2 * a2 * (((e2 *= 1.525) + 1) * a2 - e2) + b2 : c2 / 2 * ((a2 -= 2) * a2 * (((e2 *= 1.525) + 1) * a2 + e2) + 2) + b2;
          }]
        }, n = {
          "ease-in-back": "cubic-bezier(0.600, 0, 0.735, 0.045)",
          "ease-out-back": "cubic-bezier(0.175, 0.885, 0.320, 1)",
          "ease-in-out-back": "cubic-bezier(0.680, 0, 0.265, 1)"
        }, o = document, p = window, q = "bkwld-tram", r = /[\-\.0-9]/g, s = /[A-Z]/, t = "number", u = /^(rgb|#)/, v = /(em|cm|mm|in|pt|pc|px)$/, w = /(em|cm|mm|in|pt|pc|px|%)$/, x = /(deg|rad|turn)$/, y = "unitless", z = /(all|none) 0s ease 0s/, A = /^(width|height)$/, B = " ", C = o.createElement("a"), D = ["Webkit", "Moz", "O", "ms"], E = ["-webkit-", "-moz-", "-o-", "-ms-"], F = function(a2) {
          if (a2 in C.style)
            return {
              dom: a2,
              css: a2
            };
          var b2, c2, d2 = "", e2 = a2.split("-");
          for (b2 = 0; b2 < e2.length; b2++)
            d2 += e2[b2].charAt(0).toUpperCase() + e2[b2].slice(1);
          for (b2 = 0; b2 < D.length; b2++)
            if (c2 = D[b2] + d2, c2 in C.style)
              return {
                dom: c2,
                css: E[b2] + a2
              };
        }, G = b.support = {
          bind: Function.prototype.bind,
          transform: F("transform"),
          transition: F("transition"),
          backface: F("backface-visibility"),
          timing: F("transition-timing-function")
        };
        if (G.transition) {
          var H = G.timing.dom;
          if (C.style[H] = m["ease-in-back"][0], !C.style[H])
            for (var I in n)
              m[I][0] = n[I];
        }
        var J = b.frame = function() {
          var a2 = p.requestAnimationFrame || p.webkitRequestAnimationFrame || p.mozRequestAnimationFrame || p.oRequestAnimationFrame || p.msRequestAnimationFrame;
          return a2 && G.bind ? a2.bind(p) : function(a3) {
            p.setTimeout(a3, 16);
          };
        }(), K = b.now = function() {
          var a2 = p.performance, b2 = a2 && (a2.now || a2.webkitNow || a2.msNow || a2.mozNow);
          return b2 && G.bind ? b2.bind(a2) : Date.now || function() {
            return +/* @__PURE__ */ new Date();
          };
        }(), L = l(function(b2) {
          function d2(a2, b3) {
            var c2 = k(("" + a2).split(B)), d3 = c2[0];
            b3 = b3 || {};
            var e3 = Y[d3];
            if (!e3)
              return j("Unsupported property: " + d3);
            if (!b3.weak || !this.props[d3]) {
              var f3 = e3[0], g3 = this.props[d3];
              return g3 || (g3 = this.props[d3] = new f3.Bare()), g3.init(this.$el, c2, e3, b3), g3;
            }
          }
          function e2(a2, b3, c2) {
            if (a2) {
              var e3 = typeof a2;
              if (b3 || (this.timer && this.timer.destroy(), this.queue = [], this.active = false), "number" == e3 && b3)
                return this.timer = new S({
                  duration: a2,
                  context: this,
                  complete: h2
                }), void (this.active = true);
              if ("string" == e3 && b3) {
                switch (a2) {
                  case "hide":
                    o2.call(this);
                    break;
                  case "stop":
                    l2.call(this);
                    break;
                  case "redraw":
                    p2.call(this);
                    break;
                  default:
                    d2.call(this, a2, c2 && c2[1]);
                }
                return h2.call(this);
              }
              if ("function" == e3)
                return void a2.call(this, this);
              if ("object" == e3) {
                var f3 = 0;
                u2.call(this, a2, function(a3, b4) {
                  a3.span > f3 && (f3 = a3.span), a3.stop(), a3.animate(b4);
                }, function(a3) {
                  "wait" in a3 && (f3 = i(a3.wait, 0));
                }), t2.call(this), f3 > 0 && (this.timer = new S({
                  duration: f3,
                  context: this
                }), this.active = true, b3 && (this.timer.complete = h2));
                var g3 = this, j2 = false, k2 = {};
                J(function() {
                  u2.call(g3, a2, function(a3) {
                    a3.active && (j2 = true, k2[a3.name] = a3.nextStyle);
                  }), j2 && g3.$el.css(k2);
                });
              }
            }
          }
          function f2(a2) {
            a2 = i(a2, 0), this.active ? this.queue.push({
              options: a2
            }) : (this.timer = new S({
              duration: a2,
              context: this,
              complete: h2
            }), this.active = true);
          }
          function g2(a2) {
            return this.active ? (this.queue.push({
              options: a2,
              args: arguments
            }), void (this.timer.complete = h2)) : j("No active transition timer. Use start() or wait() before then().");
          }
          function h2() {
            if (this.timer && this.timer.destroy(), this.active = false, this.queue.length) {
              var a2 = this.queue.shift();
              e2.call(this, a2.options, true, a2.args);
            }
          }
          function l2(a2) {
            this.timer && this.timer.destroy(), this.queue = [], this.active = false;
            var b3;
            "string" == typeof a2 ? (b3 = {}, b3[a2] = 1) : b3 = "object" == typeof a2 && null != a2 ? a2 : this.props, u2.call(this, b3, v2), t2.call(this);
          }
          function m2(a2) {
            l2.call(this, a2), u2.call(this, a2, w2, x2);
          }
          function n2(a2) {
            "string" != typeof a2 && (a2 = "block"), this.el.style.display = a2;
          }
          function o2() {
            l2.call(this), this.el.style.display = "none";
          }
          function p2() {
            this.el.offsetHeight;
          }
          function r2() {
            l2.call(this), a.removeData(this.el, q), this.$el = this.el = null;
          }
          function t2() {
            var a2, b3, c2 = [];
            this.upstream && c2.push(this.upstream);
            for (a2 in this.props)
              b3 = this.props[a2], b3.active && c2.push(b3.string);
            c2 = c2.join(","), this.style !== c2 && (this.style = c2, this.el.style[G.transition.dom] = c2);
          }
          function u2(a2, b3, e3) {
            var f3, g3, h3, i2, j2 = b3 !== v2, k2 = {};
            for (f3 in a2)
              h3 = a2[f3], f3 in Z ? (k2.transform || (k2.transform = {}), k2.transform[f3] = h3) : (s.test(f3) && (f3 = c(f3)), f3 in Y ? k2[f3] = h3 : (i2 || (i2 = {}), i2[f3] = h3));
            for (f3 in k2) {
              if (h3 = k2[f3], g3 = this.props[f3], !g3) {
                if (!j2)
                  continue;
                g3 = d2.call(this, f3);
              }
              b3.call(this, g3, h3);
            }
            e3 && i2 && e3.call(this, i2);
          }
          function v2(a2) {
            a2.stop();
          }
          function w2(a2, b3) {
            a2.set(b3);
          }
          function x2(a2) {
            this.$el.css(a2);
          }
          function y2(a2, c2) {
            b2[a2] = function() {
              return this.children ? A2.call(this, c2, arguments) : (this.el && c2.apply(this, arguments), this);
            };
          }
          function A2(a2, b3) {
            var c2, d3 = this.children.length;
            for (c2 = 0; d3 > c2; c2++)
              a2.apply(this.children[c2], b3);
            return this;
          }
          b2.init = function(b3) {
            if (this.$el = a(b3), this.el = this.$el[0], this.props = {}, this.queue = [], this.style = "", this.active = false, U.keepInherited && !U.fallback) {
              var c2 = W(this.el, "transition");
              c2 && !z.test(c2) && (this.upstream = c2);
            }
            G.backface && U.hideBackface && V(this.el, G.backface.css, "hidden");
          }, y2("add", d2), y2("start", e2), y2("wait", f2), y2("then", g2), y2("next", h2), y2("stop", l2), y2("set", m2), y2("show", n2), y2("hide", o2), y2("redraw", p2), y2("destroy", r2);
        }), M = l(L, function(b2) {
          function c2(b3, c3) {
            var d2 = a.data(b3, q) || a.data(b3, q, new L.Bare());
            return d2.el || d2.init(b3), c3 ? d2.start(c3) : d2;
          }
          b2.init = function(b3, d2) {
            var e2 = a(b3);
            if (!e2.length)
              return this;
            if (1 === e2.length)
              return c2(e2[0], d2);
            var f2 = [];
            return e2.each(function(a2, b4) {
              f2.push(c2(b4, d2));
            }), this.children = f2, this;
          };
        }), N = l(function(a2) {
          function b2() {
            var a3 = this.get();
            this.update("auto");
            var b3 = this.get();
            return this.update(a3), b3;
          }
          function c2(a3, b3, c3) {
            return void 0 !== b3 && (c3 = b3), a3 in m ? a3 : c3;
          }
          function d2(a3) {
            var b3 = /rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(a3);
            return (b3 ? e(b3[1], b3[2], b3[3]) : a3).replace(/#(\w)(\w)(\w)$/, "#$1$1$2$2$3$3");
          }
          var f2 = {
            duration: 500,
            ease: "ease",
            delay: 0
          };
          a2.init = function(a3, b3, d3, e2) {
            this.$el = a3, this.el = a3[0];
            var g2 = b3[0];
            d3[2] && (g2 = d3[2]), X[g2] && (g2 = X[g2]), this.name = g2, this.type = d3[1], this.duration = i(b3[1], this.duration, f2.duration), this.ease = c2(b3[2], this.ease, f2.ease), this.delay = i(b3[3], this.delay, f2.delay), this.span = this.duration + this.delay, this.active = false, this.nextStyle = null, this.auto = A.test(this.name), this.unit = e2.unit || this.unit || U.defaultUnit, this.angle = e2.angle || this.angle || U.defaultAngle, U.fallback || e2.fallback ? this.animate = this.fallback : (this.animate = this.transition, this.string = this.name + B + this.duration + "ms" + ("ease" != this.ease ? B + m[this.ease][0] : "") + (this.delay ? B + this.delay + "ms" : ""));
          }, a2.set = function(a3) {
            a3 = this.convert(a3, this.type), this.update(a3), this.redraw();
          }, a2.transition = function(a3) {
            this.active = true, a3 = this.convert(a3, this.type), this.auto && ("auto" == this.el.style[this.name] && (this.update(this.get()), this.redraw()), "auto" == a3 && (a3 = b2.call(this))), this.nextStyle = a3;
          }, a2.fallback = function(a3) {
            var c3 = this.el.style[this.name] || this.convert(this.get(), this.type);
            a3 = this.convert(a3, this.type), this.auto && ("auto" == c3 && (c3 = this.convert(this.get(), this.type)), "auto" == a3 && (a3 = b2.call(this))), this.tween = new R({
              from: c3,
              to: a3,
              duration: this.duration,
              delay: this.delay,
              ease: this.ease,
              update: this.update,
              context: this
            });
          }, a2.get = function() {
            return W(this.el, this.name);
          }, a2.update = function(a3) {
            V(this.el, this.name, a3);
          }, a2.stop = function() {
            (this.active || this.nextStyle) && (this.active = false, this.nextStyle = null, V(this.el, this.name, this.get()));
            var a3 = this.tween;
            a3 && a3.context && a3.destroy();
          }, a2.convert = function(a3, b3) {
            if ("auto" == a3 && this.auto)
              return a3;
            var c3, e2 = "number" == typeof a3, f3 = "string" == typeof a3;
            switch (b3) {
              case t:
                if (e2)
                  return a3;
                if (f3 && "" === a3.replace(r, ""))
                  return +a3;
                c3 = "number(unitless)";
                break;
              case u:
                if (f3) {
                  if ("" === a3 && this.original)
                    return this.original;
                  if (b3.test(a3))
                    return "#" == a3.charAt(0) && 7 == a3.length ? a3 : d2(a3);
                }
                c3 = "hex or rgb string";
                break;
              case v:
                if (e2)
                  return a3 + this.unit;
                if (f3 && b3.test(a3))
                  return a3;
                c3 = "number(px) or string(unit)";
                break;
              case w:
                if (e2)
                  return a3 + this.unit;
                if (f3 && b3.test(a3))
                  return a3;
                c3 = "number(px) or string(unit or %)";
                break;
              case x:
                if (e2)
                  return a3 + this.angle;
                if (f3 && b3.test(a3))
                  return a3;
                c3 = "number(deg) or string(angle)";
                break;
              case y:
                if (e2)
                  return a3;
                if (f3 && w.test(a3))
                  return a3;
                c3 = "number(unitless) or string(unit or %)";
            }
            return g(c3, a3), a3;
          }, a2.redraw = function() {
            this.el.offsetHeight;
          };
        }), O = l(N, function(a2, b2) {
          a2.init = function() {
            b2.init.apply(this, arguments), this.original || (this.original = this.convert(this.get(), u));
          };
        }), P = l(N, function(a2, b2) {
          a2.init = function() {
            b2.init.apply(this, arguments), this.animate = this.fallback;
          }, a2.get = function() {
            return this.$el[this.name]();
          }, a2.update = function(a3) {
            this.$el[this.name](a3);
          };
        }), Q = l(N, function(a2, b2) {
          function c2(a3, b3) {
            var c3, d2, e2, f2, g2;
            for (c3 in a3)
              f2 = Z[c3], e2 = f2[0], d2 = f2[1] || c3, g2 = this.convert(a3[c3], e2), b3.call(this, d2, g2, e2);
          }
          a2.init = function() {
            b2.init.apply(this, arguments), this.current || (this.current = {}, Z.perspective && U.perspective && (this.current.perspective = U.perspective, V(this.el, this.name, this.style(this.current)), this.redraw()));
          }, a2.set = function(a3) {
            c2.call(this, a3, function(a4, b3) {
              this.current[a4] = b3;
            }), V(this.el, this.name, this.style(this.current)), this.redraw();
          }, a2.transition = function(a3) {
            var b3 = this.values(a3);
            this.tween = new T({
              current: this.current,
              values: b3,
              duration: this.duration,
              delay: this.delay,
              ease: this.ease
            });
            var c3, d2 = {};
            for (c3 in this.current)
              d2[c3] = c3 in b3 ? b3[c3] : this.current[c3];
            this.active = true, this.nextStyle = this.style(d2);
          }, a2.fallback = function(a3) {
            var b3 = this.values(a3);
            this.tween = new T({
              current: this.current,
              values: b3,
              duration: this.duration,
              delay: this.delay,
              ease: this.ease,
              update: this.update,
              context: this
            });
          }, a2.update = function() {
            V(this.el, this.name, this.style(this.current));
          }, a2.style = function(a3) {
            var b3, c3 = "";
            for (b3 in a3)
              c3 += b3 + "(" + a3[b3] + ") ";
            return c3;
          }, a2.values = function(a3) {
            var b3, d2 = {};
            return c2.call(this, a3, function(a4, c3, e2) {
              d2[a4] = c3, void 0 === this.current[a4] && (b3 = 0, ~a4.indexOf("scale") && (b3 = 1), this.current[a4] = this.convert(b3, e2));
            }), d2;
          };
        }), R = l(function(b2) {
          function c2(a2) {
            1 === n2.push(a2) && J(g2);
          }
          function g2() {
            var a2, b3, c3, d2 = n2.length;
            if (d2)
              for (J(g2), b3 = K(), a2 = d2; a2--; )
                c3 = n2[a2], c3 && c3.render(b3);
          }
          function i2(b3) {
            var c3, d2 = a.inArray(b3, n2);
            d2 >= 0 && (c3 = n2.slice(d2 + 1), n2.length = d2, c3.length && (n2 = n2.concat(c3)));
          }
          function j2(a2) {
            return Math.round(a2 * o2) / o2;
          }
          function k2(a2, b3, c3) {
            return e(a2[0] + c3 * (b3[0] - a2[0]), a2[1] + c3 * (b3[1] - a2[1]), a2[2] + c3 * (b3[2] - a2[2]));
          }
          var l2 = {
            ease: m.ease[1],
            from: 0,
            to: 1
          };
          b2.init = function(a2) {
            this.duration = a2.duration || 0, this.delay = a2.delay || 0;
            var b3 = a2.ease || l2.ease;
            m[b3] && (b3 = m[b3][1]), "function" != typeof b3 && (b3 = l2.ease), this.ease = b3, this.update = a2.update || f, this.complete = a2.complete || f, this.context = a2.context || this, this.name = a2.name;
            var c3 = a2.from, d2 = a2.to;
            void 0 === c3 && (c3 = l2.from), void 0 === d2 && (d2 = l2.to), this.unit = a2.unit || "", "number" == typeof c3 && "number" == typeof d2 ? (this.begin = c3, this.change = d2 - c3) : this.format(d2, c3), this.value = this.begin + this.unit, this.start = K(), a2.autoplay !== false && this.play();
          }, b2.play = function() {
            this.active || (this.start || (this.start = K()), this.active = true, c2(this));
          }, b2.stop = function() {
            this.active && (this.active = false, i2(this));
          }, b2.render = function(a2) {
            var b3, c3 = a2 - this.start;
            if (this.delay) {
              if (c3 <= this.delay)
                return;
              c3 -= this.delay;
            }
            if (c3 < this.duration) {
              var d2 = this.ease(c3, 0, 1, this.duration);
              return b3 = this.startRGB ? k2(this.startRGB, this.endRGB, d2) : j2(this.begin + d2 * this.change), this.value = b3 + this.unit, void this.update.call(this.context, this.value);
            }
            b3 = this.endHex || this.begin + this.change, this.value = b3 + this.unit, this.update.call(this.context, this.value), this.complete.call(this.context), this.destroy();
          }, b2.format = function(a2, b3) {
            if (b3 += "", a2 += "", "#" == a2.charAt(0))
              return this.startRGB = d(b3), this.endRGB = d(a2), this.endHex = a2, this.begin = 0, void (this.change = 1);
            if (!this.unit) {
              var c3 = b3.replace(r, ""), e2 = a2.replace(r, "");
              c3 !== e2 && h("tween", b3, a2), this.unit = c3;
            }
            b3 = parseFloat(b3), a2 = parseFloat(a2), this.begin = this.value = b3, this.change = a2 - b3;
          }, b2.destroy = function() {
            this.stop(), this.context = null, this.ease = this.update = this.complete = f;
          };
          var n2 = [], o2 = 1e3;
        }), S = l(R, function(a2) {
          a2.init = function(a3) {
            this.duration = a3.duration || 0, this.complete = a3.complete || f, this.context = a3.context, this.play();
          }, a2.render = function(a3) {
            var b2 = a3 - this.start;
            b2 < this.duration || (this.complete.call(this.context), this.destroy());
          };
        }), T = l(R, function(a2, b2) {
          a2.init = function(a3) {
            this.context = a3.context, this.update = a3.update, this.tweens = [], this.current = a3.current;
            var b3, c2;
            for (b3 in a3.values)
              c2 = a3.values[b3], this.current[b3] !== c2 && this.tweens.push(new R({
                name: b3,
                from: this.current[b3],
                to: c2,
                duration: a3.duration,
                delay: a3.delay,
                ease: a3.ease,
                autoplay: false
              }));
            this.play();
          }, a2.render = function(a3) {
            var b3, c2, d2 = this.tweens.length, e2 = false;
            for (b3 = d2; b3--; )
              c2 = this.tweens[b3], c2.context && (c2.render(a3), this.current[c2.name] = c2.value, e2 = true);
            return e2 ? void (this.update && this.update.call(this.context)) : this.destroy();
          }, a2.destroy = function() {
            if (b2.destroy.call(this), this.tweens) {
              var a3, c2 = this.tweens.length;
              for (a3 = c2; a3--; )
                this.tweens[a3].destroy();
              this.tweens = null, this.current = null;
            }
          };
        }), U = b.config = {
          debug: false,
          defaultUnit: "px",
          defaultAngle: "deg",
          keepInherited: false,
          hideBackface: false,
          perspective: "",
          fallback: !G.transition,
          agentTests: []
        };
        b.fallback = function(a2) {
          if (!G.transition)
            return U.fallback = true;
          U.agentTests.push("(" + a2 + ")");
          var b2 = new RegExp(U.agentTests.join("|"), "i");
          U.fallback = b2.test(navigator.userAgent);
        }, b.fallback("6.0.[2-5] Safari"), b.tween = function(a2) {
          return new R(a2);
        }, b.delay = function(a2, b2, c2) {
          return new S({
            complete: b2,
            duration: a2,
            context: c2
          });
        }, a.fn.tram = function(a2) {
          return b.call(null, this, a2);
        };
        var V = a.style, W = a.css, X = {
          transform: G.transform && G.transform.css
        }, Y = {
          color: [O, u],
          background: [O, u, "background-color"],
          "outline-color": [O, u],
          "border-color": [O, u],
          "border-top-color": [O, u],
          "border-right-color": [O, u],
          "border-bottom-color": [O, u],
          "border-left-color": [O, u],
          "border-width": [N, v],
          "border-top-width": [N, v],
          "border-right-width": [N, v],
          "border-bottom-width": [N, v],
          "border-left-width": [N, v],
          "border-spacing": [N, v],
          "letter-spacing": [N, v],
          margin: [N, v],
          "margin-top": [N, v],
          "margin-right": [N, v],
          "margin-bottom": [N, v],
          "margin-left": [N, v],
          padding: [N, v],
          "padding-top": [N, v],
          "padding-right": [N, v],
          "padding-bottom": [N, v],
          "padding-left": [N, v],
          "outline-width": [N, v],
          opacity: [N, t],
          top: [N, w],
          right: [N, w],
          bottom: [N, w],
          left: [N, w],
          "font-size": [N, w],
          "text-indent": [N, w],
          "word-spacing": [N, w],
          width: [N, w],
          "min-width": [N, w],
          "max-width": [N, w],
          height: [N, w],
          "min-height": [N, w],
          "max-height": [N, w],
          "line-height": [N, y],
          "scroll-top": [P, t, "scrollTop"],
          "scroll-left": [P, t, "scrollLeft"]
        }, Z = {};
        G.transform && (Y.transform = [Q], Z = {
          x: [w, "translateX"],
          y: [w, "translateY"],
          rotate: [x],
          rotateX: [x],
          rotateY: [x],
          scale: [t],
          scaleX: [t],
          scaleY: [t],
          skew: [x],
          skewX: [x],
          skewY: [x]
        }), G.transform && G.backface && (Z.z = [w, "translateZ"], Z.rotateZ = [x], Z.scaleZ = [t], Z.perspective = [v]);
        var $2 = /ms/, _ = /s|\./;
        return a.tram = b;
      }(window.jQuery);
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/underscore-custom.js
  var require_underscore_custom = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/underscore-custom.js"(exports, module) {
      var $2 = window.$;
      var tram = require_tram_min() && $2.tram;
      module.exports = function() {
        var _ = {};
        _.VERSION = "1.6.0-Webflow";
        var breaker = {};
        var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;
        var push = ArrayProto.push, slice = ArrayProto.slice, concat4 = ArrayProto.concat, toString4 = ObjProto.toString, hasOwnProperty3 = ObjProto.hasOwnProperty;
        var nativeForEach = ArrayProto.forEach, nativeMap = ArrayProto.map, nativeReduce = ArrayProto.reduce, nativeReduceRight = ArrayProto.reduceRight, nativeFilter = ArrayProto.filter, nativeEvery = ArrayProto.every, nativeSome = ArrayProto.some, nativeIndexOf = ArrayProto.indexOf, nativeLastIndexOf = ArrayProto.lastIndexOf, nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeBind = FuncProto.bind;
        var each = _.each = _.forEach = function(obj, iterator, context) {
          if (obj == null)
            return obj;
          if (nativeForEach && obj.forEach === nativeForEach) {
            obj.forEach(iterator, context);
          } else if (obj.length === +obj.length) {
            for (var i = 0, length2 = obj.length; i < length2; i++) {
              if (iterator.call(context, obj[i], i, obj) === breaker)
                return;
            }
          } else {
            var keys = _.keys(obj);
            for (var i = 0, length2 = keys.length; i < length2; i++) {
              if (iterator.call(context, obj[keys[i]], keys[i], obj) === breaker)
                return;
            }
          }
          return obj;
        };
        _.map = _.collect = function(obj, iterator, context) {
          var results = [];
          if (obj == null)
            return results;
          if (nativeMap && obj.map === nativeMap)
            return obj.map(iterator, context);
          each(obj, function(value, index, list) {
            results.push(iterator.call(context, value, index, list));
          });
          return results;
        };
        _.find = _.detect = function(obj, predicate, context) {
          var result;
          any(obj, function(value, index, list) {
            if (predicate.call(context, value, index, list)) {
              result = value;
              return true;
            }
          });
          return result;
        };
        _.filter = _.select = function(obj, predicate, context) {
          var results = [];
          if (obj == null)
            return results;
          if (nativeFilter && obj.filter === nativeFilter)
            return obj.filter(predicate, context);
          each(obj, function(value, index, list) {
            if (predicate.call(context, value, index, list))
              results.push(value);
          });
          return results;
        };
        var any = _.some = _.any = function(obj, predicate, context) {
          predicate || (predicate = _.identity);
          var result = false;
          if (obj == null)
            return result;
          if (nativeSome && obj.some === nativeSome)
            return obj.some(predicate, context);
          each(obj, function(value, index, list) {
            if (result || (result = predicate.call(context, value, index, list)))
              return breaker;
          });
          return !!result;
        };
        _.contains = _.include = function(obj, target) {
          if (obj == null)
            return false;
          if (nativeIndexOf && obj.indexOf === nativeIndexOf)
            return obj.indexOf(target) != -1;
          return any(obj, function(value) {
            return value === target;
          });
        };
        _.delay = function(func, wait) {
          var args = slice.call(arguments, 2);
          return setTimeout(function() {
            return func.apply(null, args);
          }, wait);
        };
        _.defer = function(func) {
          return _.delay.apply(_, [func, 1].concat(slice.call(arguments, 1)));
        };
        _.throttle = function(func) {
          var wait, args, context;
          return function() {
            if (wait)
              return;
            wait = true;
            args = arguments;
            context = this;
            tram.frame(function() {
              wait = false;
              func.apply(context, args);
            });
          };
        };
        _.debounce = function(func, wait, immediate) {
          var timeout, args, context, timestamp, result;
          var later = function() {
            var last3 = _.now() - timestamp;
            if (last3 < wait) {
              timeout = setTimeout(later, wait - last3);
            } else {
              timeout = null;
              if (!immediate) {
                result = func.apply(context, args);
                context = args = null;
              }
            }
          };
          return function() {
            context = this;
            args = arguments;
            timestamp = _.now();
            var callNow = immediate && !timeout;
            if (!timeout) {
              timeout = setTimeout(later, wait);
            }
            if (callNow) {
              result = func.apply(context, args);
              context = args = null;
            }
            return result;
          };
        };
        _.defaults = function(obj) {
          if (!_.isObject(obj))
            return obj;
          for (var i = 1, length2 = arguments.length; i < length2; i++) {
            var source = arguments[i];
            for (var prop2 in source) {
              if (obj[prop2] === void 0)
                obj[prop2] = source[prop2];
            }
          }
          return obj;
        };
        _.keys = function(obj) {
          if (!_.isObject(obj))
            return [];
          if (nativeKeys)
            return nativeKeys(obj);
          var keys = [];
          for (var key in obj)
            if (_.has(obj, key))
              keys.push(key);
          return keys;
        };
        _.has = function(obj, key) {
          return hasOwnProperty3.call(obj, key);
        };
        _.isObject = function(obj) {
          return obj === Object(obj);
        };
        _.now = Date.now || function() {
          return (/* @__PURE__ */ new Date()).getTime();
        };
        _.templateSettings = {
          evaluate: /<%([\s\S]+?)%>/g,
          interpolate: /<%=([\s\S]+?)%>/g,
          escape: /<%-([\s\S]+?)%>/g
        };
        var noMatch = /(.)^/;
        var escapes = {
          "'": "'",
          "\\": "\\",
          "\r": "r",
          "\n": "n",
          "\u2028": "u2028",
          "\u2029": "u2029"
        };
        var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
        var escapeChar = function(match2) {
          return "\\" + escapes[match2];
        };
        var bareIdentifier = /^\s*(\w|\$)+\s*$/;
        _.template = function(text, settings, oldSettings) {
          if (!settings && oldSettings)
            settings = oldSettings;
          settings = _.defaults({}, settings, _.templateSettings);
          var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join("|") + "|$", "g");
          var index = 0;
          var source = "__p+='";
          text.replace(matcher, function(match2, escape2, interpolate, evaluate, offset) {
            source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
            index = offset + match2.length;
            if (escape2) {
              source += "'+\n((__t=(" + escape2 + "))==null?'':_.escape(__t))+\n'";
            } else if (interpolate) {
              source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
            } else if (evaluate) {
              source += "';\n" + evaluate + "\n__p+='";
            }
            return match2;
          });
          source += "';\n";
          var argument = settings.variable;
          if (argument) {
            if (!bareIdentifier.test(argument))
              throw new Error("variable is not a bare identifier: " + argument);
          } else {
            source = "with(obj||{}){\n" + source + "}\n";
            argument = "obj";
          }
          source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";
          var render;
          try {
            render = new Function(settings.variable || "obj", "_", source);
          } catch (e) {
            e.source = source;
            throw e;
          }
          var template = function(data) {
            return render.call(this, data, _);
          };
          template.source = "function(" + argument + "){\n" + source + "}";
          return template;
        };
        return _;
      }();
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-lib.js
  var require_webflow_lib = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-lib.js"(exports, module) {
      var Webflow2 = {};
      var modules = {};
      var primary = [];
      var secondary = window.Webflow || [];
      var $2 = window.jQuery;
      var $win = $2(window);
      var $doc = $2(document);
      var isFunction3 = $2.isFunction;
      var _ = Webflow2._ = require_underscore_custom();
      var tram = Webflow2.tram = require_tram_min() && $2.tram;
      var domready = false;
      var destroyed = false;
      tram.config.hideBackface = false;
      tram.config.keepInherited = true;
      Webflow2.define = function(name, factory, options) {
        if (modules[name]) {
          unbindModule(modules[name]);
        }
        var instance = modules[name] = factory($2, _, options) || {};
        bindModule(instance);
        return instance;
      };
      Webflow2.require = function(name) {
        return modules[name];
      };
      function bindModule(module2) {
        if (Webflow2.env()) {
          isFunction3(module2.design) && $win.on("__wf_design", module2.design);
          isFunction3(module2.preview) && $win.on("__wf_preview", module2.preview);
        }
        isFunction3(module2.destroy) && $win.on("__wf_destroy", module2.destroy);
        if (module2.ready && isFunction3(module2.ready)) {
          addReady(module2);
        }
      }
      function addReady(module2) {
        if (domready) {
          module2.ready();
          return;
        }
        if (_.contains(primary, module2.ready)) {
          return;
        }
        primary.push(module2.ready);
      }
      function unbindModule(module2) {
        isFunction3(module2.design) && $win.off("__wf_design", module2.design);
        isFunction3(module2.preview) && $win.off("__wf_preview", module2.preview);
        isFunction3(module2.destroy) && $win.off("__wf_destroy", module2.destroy);
        if (module2.ready && isFunction3(module2.ready)) {
          removeReady(module2);
        }
      }
      function removeReady(module2) {
        primary = _.filter(primary, function(readyFn) {
          return readyFn !== module2.ready;
        });
      }
      Webflow2.push = function(ready) {
        if (domready) {
          isFunction3(ready) && ready();
          return;
        }
        secondary.push(ready);
      };
      Webflow2.env = function(mode) {
        var designFlag = window.__wf_design;
        var inApp = typeof designFlag !== "undefined";
        if (!mode) {
          return inApp;
        }
        if (mode === "design") {
          return inApp && designFlag;
        }
        if (mode === "preview") {
          return inApp && !designFlag;
        }
        if (mode === "slug") {
          return inApp && window.__wf_slug;
        }
        if (mode === "editor") {
          return window.WebflowEditor;
        }
        if (mode === "test") {
          return window.__wf_test;
        }
        if (mode === "frame") {
          return window !== window.top;
        }
      };
      var userAgent = navigator.userAgent.toLowerCase();
      var touch = Webflow2.env.touch = "ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch;
      var chrome = Webflow2.env.chrome = /chrome/.test(userAgent) && /Google/.test(navigator.vendor) && parseInt(userAgent.match(/chrome\/(\d+)\./)[1], 10);
      var ios = Webflow2.env.ios = /(ipod|iphone|ipad)/.test(userAgent);
      Webflow2.env.safari = /safari/.test(userAgent) && !chrome && !ios;
      var touchTarget;
      touch && $doc.on("touchstart mousedown", function(evt) {
        touchTarget = evt.target;
      });
      Webflow2.validClick = touch ? function(clickTarget) {
        return clickTarget === touchTarget || $2.contains(clickTarget, touchTarget);
      } : function() {
        return true;
      };
      var resizeEvents = "resize.webflow orientationchange.webflow load.webflow";
      var scrollEvents = "scroll.webflow " + resizeEvents;
      Webflow2.resize = eventProxy($win, resizeEvents);
      Webflow2.scroll = eventProxy($win, scrollEvents);
      Webflow2.redraw = eventProxy();
      function eventProxy(target, types) {
        var handlers = [];
        var proxy = {};
        proxy.up = _.throttle(function(evt) {
          _.each(handlers, function(h) {
            h(evt);
          });
        });
        if (target && types) {
          target.on(types, proxy.up);
        }
        proxy.on = function(handler) {
          if (typeof handler !== "function") {
            return;
          }
          if (_.contains(handlers, handler)) {
            return;
          }
          handlers.push(handler);
        };
        proxy.off = function(handler) {
          if (!arguments.length) {
            handlers = [];
            return;
          }
          handlers = _.filter(handlers, function(h) {
            return h !== handler;
          });
        };
        return proxy;
      }
      Webflow2.location = function(url) {
        window.location = url;
      };
      if (Webflow2.env()) {
        Webflow2.location = function() {
        };
      }
      Webflow2.ready = function() {
        domready = true;
        if (destroyed) {
          restoreModules();
        } else {
          _.each(primary, callReady);
        }
        _.each(secondary, callReady);
        Webflow2.resize.up();
      };
      function callReady(readyFn) {
        isFunction3(readyFn) && readyFn();
      }
      function restoreModules() {
        destroyed = false;
        _.each(modules, bindModule);
      }
      var deferLoad;
      Webflow2.load = function(handler) {
        deferLoad.then(handler);
      };
      function bindLoad() {
        if (deferLoad) {
          deferLoad.reject();
          $win.off("load", deferLoad.resolve);
        }
        deferLoad = new $2.Deferred();
        $win.on("load", deferLoad.resolve);
      }
      Webflow2.destroy = function(options) {
        options = options || {};
        destroyed = true;
        $win.triggerHandler("__wf_destroy");
        if (options.domready != null) {
          domready = options.domready;
        }
        _.each(modules, unbindModule);
        Webflow2.resize.off();
        Webflow2.scroll.off();
        Webflow2.redraw.off();
        primary = [];
        secondary = [];
        if (deferLoad.state() === "pending") {
          bindLoad();
        }
      };
      $2(Webflow2.ready);
      bindLoad();
      module.exports = window.Webflow = Webflow2;
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-brand.js
  var require_webflow_brand = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-brand.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      Webflow2.define("brand", module.exports = function($2) {
        var api = {};
        var doc = document;
        var $html = $2("html");
        var $body = $2("body");
        var namespace = ".w-webflow-badge";
        var location = window.location;
        var isPhantom = /PhantomJS/i.test(navigator.userAgent);
        var fullScreenEvents = "fullscreenchange webkitfullscreenchange mozfullscreenchange msfullscreenchange";
        var brandElement;
        api.ready = function() {
          var shouldBrand = $html.attr("data-wf-status");
          var publishedDomain = $html.attr("data-wf-domain") || "";
          if (/\.webflow\.io$/i.test(publishedDomain) && location.hostname !== publishedDomain) {
            shouldBrand = true;
          }
          if (shouldBrand && !isPhantom) {
            brandElement = brandElement || createBadge();
            ensureBrand();
            setTimeout(ensureBrand, 500);
            $2(doc).off(fullScreenEvents, onFullScreenChange).on(fullScreenEvents, onFullScreenChange);
          }
        };
        function onFullScreenChange() {
          var fullScreen = doc.fullScreen || doc.mozFullScreen || doc.webkitIsFullScreen || doc.msFullscreenElement || Boolean(doc.webkitFullscreenElement);
          $2(brandElement).attr("style", fullScreen ? "display: none !important;" : "");
        }
        function createBadge() {
          var $brand = $2('<a class="w-webflow-badge"></a>').attr("href", "https://webflow.com?utm_campaign=brandjs");
          var $logoArt = $2("<img>").attr("src", "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-icon-d2.89e12c322e.svg").attr("alt", "").css({
            marginRight: "4px",
            width: "26px"
          });
          var $logoText = $2("<img>").attr("src", "https://d3e54v103j8qbb.cloudfront.net/img/webflow-badge-text-d2.c82cec3b78.svg").attr("alt", "Made in Webflow");
          $brand.append($logoArt, $logoText);
          return $brand[0];
        }
        function ensureBrand() {
          var found = $body.children(namespace);
          var match2 = found.length && found.get(0) === brandElement;
          var inEditor = Webflow2.env("editor");
          if (match2) {
            if (inEditor) {
              found.remove();
            }
            return;
          }
          if (found.length) {
            found.remove();
          }
          if (!inEditor) {
            $body.append(brandElement);
          }
        }
        return api;
      });
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-focus-visible.js
  var require_webflow_focus_visible = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-focus-visible.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      Webflow2.define("focus-visible", module.exports = function() {
        function applyFocusVisiblePolyfill(scope) {
          var hadKeyboardEvent = true;
          var hadFocusVisibleRecently = false;
          var hadFocusVisibleRecentlyTimeout = null;
          var inputTypesAllowlist = {
            text: true,
            search: true,
            url: true,
            tel: true,
            email: true,
            password: true,
            number: true,
            date: true,
            month: true,
            week: true,
            time: true,
            datetime: true,
            "datetime-local": true
          };
          function isValidFocusTarget(el) {
            if (el && el !== document && el.nodeName !== "HTML" && el.nodeName !== "BODY" && "classList" in el && "contains" in el.classList) {
              return true;
            }
            return false;
          }
          function focusTriggersKeyboardModality(el) {
            var type = el.type;
            var tagName = el.tagName;
            if (tagName === "INPUT" && inputTypesAllowlist[type] && !el.readOnly) {
              return true;
            }
            if (tagName === "TEXTAREA" && !el.readOnly) {
              return true;
            }
            if (el.isContentEditable) {
              return true;
            }
            return false;
          }
          function addFocusVisibleAttribute(el) {
            if (el.getAttribute("data-wf-focus-visible")) {
              return;
            }
            el.setAttribute("data-wf-focus-visible", "true");
          }
          function removeFocusVisibleAttribute(el) {
            if (!el.getAttribute("data-wf-focus-visible")) {
              return;
            }
            el.removeAttribute("data-wf-focus-visible");
          }
          function onKeyDown(e) {
            if (e.metaKey || e.altKey || e.ctrlKey) {
              return;
            }
            if (isValidFocusTarget(scope.activeElement)) {
              addFocusVisibleAttribute(scope.activeElement);
            }
            hadKeyboardEvent = true;
          }
          function onPointerDown() {
            hadKeyboardEvent = false;
          }
          function onFocus(e) {
            if (!isValidFocusTarget(e.target)) {
              return;
            }
            if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
              addFocusVisibleAttribute(e.target);
            }
          }
          function onBlur(e) {
            if (!isValidFocusTarget(e.target)) {
              return;
            }
            if (e.target.hasAttribute("data-wf-focus-visible")) {
              hadFocusVisibleRecently = true;
              window.clearTimeout(hadFocusVisibleRecentlyTimeout);
              hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
                hadFocusVisibleRecently = false;
              }, 100);
              removeFocusVisibleAttribute(e.target);
            }
          }
          function onVisibilityChange() {
            if (document.visibilityState === "hidden") {
              if (hadFocusVisibleRecently) {
                hadKeyboardEvent = true;
              }
              addInitialPointerMoveListeners();
            }
          }
          function addInitialPointerMoveListeners() {
            document.addEventListener("mousemove", onInitialPointerMove);
            document.addEventListener("mousedown", onInitialPointerMove);
            document.addEventListener("mouseup", onInitialPointerMove);
            document.addEventListener("pointermove", onInitialPointerMove);
            document.addEventListener("pointerdown", onInitialPointerMove);
            document.addEventListener("pointerup", onInitialPointerMove);
            document.addEventListener("touchmove", onInitialPointerMove);
            document.addEventListener("touchstart", onInitialPointerMove);
            document.addEventListener("touchend", onInitialPointerMove);
          }
          function removeInitialPointerMoveListeners() {
            document.removeEventListener("mousemove", onInitialPointerMove);
            document.removeEventListener("mousedown", onInitialPointerMove);
            document.removeEventListener("mouseup", onInitialPointerMove);
            document.removeEventListener("pointermove", onInitialPointerMove);
            document.removeEventListener("pointerdown", onInitialPointerMove);
            document.removeEventListener("pointerup", onInitialPointerMove);
            document.removeEventListener("touchmove", onInitialPointerMove);
            document.removeEventListener("touchstart", onInitialPointerMove);
            document.removeEventListener("touchend", onInitialPointerMove);
          }
          function onInitialPointerMove(e) {
            if (e.target.nodeName && e.target.nodeName.toLowerCase() === "html") {
              return;
            }
            hadKeyboardEvent = false;
            removeInitialPointerMoveListeners();
          }
          document.addEventListener("keydown", onKeyDown, true);
          document.addEventListener("mousedown", onPointerDown, true);
          document.addEventListener("pointerdown", onPointerDown, true);
          document.addEventListener("touchstart", onPointerDown, true);
          document.addEventListener("visibilitychange", onVisibilityChange, true);
          addInitialPointerMoveListeners();
          scope.addEventListener("focus", onFocus, true);
          scope.addEventListener("blur", onBlur, true);
        }
        function ready() {
          if (typeof document !== "undefined") {
            try {
              document.querySelector(":focus-visible");
            } catch (e) {
              applyFocusVisiblePolyfill(document);
            }
          }
        }
        return {
          ready
        };
      });
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-focus.js
  var require_webflow_focus = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-focus.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      Webflow2.define("focus", module.exports = function() {
        var capturedEvents = [];
        var capturing = false;
        function captureEvent(e) {
          if (capturing) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            capturedEvents.unshift(e);
          }
        }
        function isPolyfilledFocusEvent(e) {
          var el = e.target;
          var tag = el.tagName;
          return /^a$/i.test(tag) && el.href != null || // (A)
          /^(button|textarea)$/i.test(tag) && el.disabled !== true || // (B) (C)
          /^input$/i.test(tag) && /^(button|reset|submit|radio|checkbox)$/i.test(el.type) && !el.disabled || // (D)
          !/^(button|input|textarea|select|a)$/i.test(tag) && !Number.isNaN(Number.parseFloat(el.tabIndex)) || // (E)
          /^audio$/i.test(tag) || // (F)
          /^video$/i.test(tag) && el.controls === true;
        }
        function handler(e) {
          if (isPolyfilledFocusEvent(e)) {
            capturing = true;
            setTimeout(() => {
              capturing = false;
              e.target.focus();
              while (capturedEvents.length > 0) {
                var event = capturedEvents.pop();
                event.target.dispatchEvent(new MouseEvent(event.type, event));
              }
            }, 0);
          }
        }
        function ready() {
          if (typeof document !== "undefined" && document.body.hasAttribute("data-wf-focus-within") && Webflow2.env.safari) {
            document.addEventListener("mousedown", handler, true);
            document.addEventListener("mouseup", captureEvent, true);
            document.addEventListener("click", captureEvent, true);
          }
        }
        return {
          ready
        };
      });
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-ix-events.js
  var require_webflow_ix_events = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-ix-events.js"(exports, module) {
      "use strict";
      var $2 = window.jQuery;
      var api = {};
      var eventQueue = [];
      var namespace = ".w-ix";
      var eventTriggers = {
        reset: function(i, el) {
          el.__wf_intro = null;
        },
        intro: function(i, el) {
          if (el.__wf_intro) {
            return;
          }
          el.__wf_intro = true;
          $2(el).triggerHandler(api.types.INTRO);
        },
        outro: function(i, el) {
          if (!el.__wf_intro) {
            return;
          }
          el.__wf_intro = null;
          $2(el).triggerHandler(api.types.OUTRO);
        }
      };
      api.triggers = {};
      api.types = {
        INTRO: "w-ix-intro" + namespace,
        OUTRO: "w-ix-outro" + namespace
      };
      api.init = function() {
        var count = eventQueue.length;
        for (var i = 0; i < count; i++) {
          var memo = eventQueue[i];
          memo[0](0, memo[1]);
        }
        eventQueue = [];
        $2.extend(api.triggers, eventTriggers);
      };
      api.async = function() {
        for (var key in eventTriggers) {
          var func = eventTriggers[key];
          if (!eventTriggers.hasOwnProperty(key)) {
            continue;
          }
          api.triggers[key] = function(i, el) {
            eventQueue.push([func, el]);
          };
        }
      };
      api.async();
      module.exports = api;
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-ix2-events.js
  var require_webflow_ix2_events = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-ix2-events.js"(exports, module) {
      "use strict";
      var IXEvents = require_webflow_ix_events();
      function dispatchCustomEvent(element, eventName) {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent(eventName, true, true, null);
        element.dispatchEvent(event);
      }
      var $2 = window.jQuery;
      var api = {};
      var namespace = ".w-ix";
      var eventTriggers = {
        reset: function(i, el) {
          IXEvents.triggers.reset(i, el);
        },
        intro: function(i, el) {
          IXEvents.triggers.intro(i, el);
          dispatchCustomEvent(el, "COMPONENT_ACTIVE");
        },
        outro: function(i, el) {
          IXEvents.triggers.outro(i, el);
          dispatchCustomEvent(el, "COMPONENT_INACTIVE");
        }
      };
      api.triggers = {};
      api.types = {
        INTRO: "w-ix-intro" + namespace,
        OUTRO: "w-ix-outro" + namespace
      };
      $2.extend(api.triggers, eventTriggers);
      module.exports = api;
    }
  });

  // node_modules/@babel/runtime/helpers/typeof.js
  var require_typeof = __commonJS({
    "node_modules/@babel/runtime/helpers/typeof.js"(exports, module) {
      function _typeof(obj) {
        "@babel/helpers - typeof";
        return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
          return typeof obj2;
        } : function(obj2) {
          return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(obj);
      }
      module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
  });

  // node_modules/@babel/runtime/helpers/interopRequireWildcard.js
  var require_interopRequireWildcard = __commonJS({
    "node_modules/@babel/runtime/helpers/interopRequireWildcard.js"(exports, module) {
      var _typeof = require_typeof()["default"];
      function _getRequireWildcardCache(nodeInterop) {
        if (typeof WeakMap !== "function")
          return null;
        var cacheBabelInterop = /* @__PURE__ */ new WeakMap();
        var cacheNodeInterop = /* @__PURE__ */ new WeakMap();
        return (_getRequireWildcardCache = function _getRequireWildcardCache2(nodeInterop2) {
          return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
        })(nodeInterop);
      }
      function _interopRequireWildcard(obj, nodeInterop) {
        if (!nodeInterop && obj && obj.__esModule) {
          return obj;
        }
        if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
          return {
            "default": obj
          };
        }
        var cache = _getRequireWildcardCache(nodeInterop);
        if (cache && cache.has(obj)) {
          return cache.get(obj);
        }
        var newObj = {};
        var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for (var key in obj) {
          if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
              Object.defineProperty(newObj, key, desc);
            } else {
              newObj[key] = obj[key];
            }
          }
        }
        newObj["default"] = obj;
        if (cache) {
          cache.set(obj, newObj);
        }
        return newObj;
      }
      module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
  });

  // node_modules/@babel/runtime/helpers/interopRequireDefault.js
  var require_interopRequireDefault = __commonJS({
    "node_modules/@babel/runtime/helpers/interopRequireDefault.js"(exports, module) {
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
          "default": obj
        };
      }
      module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
  });

  // node_modules/core-js/internals/global.js
  var require_global = __commonJS({
    "node_modules/core-js/internals/global.js"(exports, module) {
      var check = function(it) {
        return it && it.Math == Math && it;
      };
      module.exports = // eslint-disable-next-line es/no-global-this -- safe
      check(typeof globalThis == "object" && globalThis) || check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
      check(typeof self == "object" && self) || check(typeof global == "object" && global) || // eslint-disable-next-line no-new-func -- fallback
      function() {
        return this;
      }() || Function("return this")();
    }
  });

  // node_modules/core-js/internals/fails.js
  var require_fails = __commonJS({
    "node_modules/core-js/internals/fails.js"(exports, module) {
      module.exports = function(exec) {
        try {
          return !!exec();
        } catch (error) {
          return true;
        }
      };
    }
  });

  // node_modules/core-js/internals/descriptors.js
  var require_descriptors = __commonJS({
    "node_modules/core-js/internals/descriptors.js"(exports, module) {
      var fails = require_fails();
      module.exports = !fails(function() {
        return Object.defineProperty({}, 1, { get: function() {
          return 7;
        } })[1] != 7;
      });
    }
  });

  // node_modules/core-js/internals/function-call.js
  var require_function_call = __commonJS({
    "node_modules/core-js/internals/function-call.js"(exports, module) {
      var call = Function.prototype.call;
      module.exports = call.bind ? call.bind(call) : function() {
        return call.apply(call, arguments);
      };
    }
  });

  // node_modules/core-js/internals/object-property-is-enumerable.js
  var require_object_property_is_enumerable = __commonJS({
    "node_modules/core-js/internals/object-property-is-enumerable.js"(exports) {
      "use strict";
      var $propertyIsEnumerable = {}.propertyIsEnumerable;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);
      exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
      } : $propertyIsEnumerable;
    }
  });

  // node_modules/core-js/internals/create-property-descriptor.js
  var require_create_property_descriptor = __commonJS({
    "node_modules/core-js/internals/create-property-descriptor.js"(exports, module) {
      module.exports = function(bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value
        };
      };
    }
  });

  // node_modules/core-js/internals/function-uncurry-this.js
  var require_function_uncurry_this = __commonJS({
    "node_modules/core-js/internals/function-uncurry-this.js"(exports, module) {
      var FunctionPrototype = Function.prototype;
      var bind2 = FunctionPrototype.bind;
      var call = FunctionPrototype.call;
      var callBind = bind2 && bind2.bind(call);
      module.exports = bind2 ? function(fn) {
        return fn && callBind(call, fn);
      } : function(fn) {
        return fn && function() {
          return call.apply(fn, arguments);
        };
      };
    }
  });

  // node_modules/core-js/internals/classof-raw.js
  var require_classof_raw = __commonJS({
    "node_modules/core-js/internals/classof-raw.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var toString4 = uncurryThis({}.toString);
      var stringSlice = uncurryThis("".slice);
      module.exports = function(it) {
        return stringSlice(toString4(it), 8, -1);
      };
    }
  });

  // node_modules/core-js/internals/indexed-object.js
  var require_indexed_object = __commonJS({
    "node_modules/core-js/internals/indexed-object.js"(exports, module) {
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      var fails = require_fails();
      var classof = require_classof_raw();
      var Object2 = global2.Object;
      var split4 = uncurryThis("".split);
      module.exports = fails(function() {
        return !Object2("z").propertyIsEnumerable(0);
      }) ? function(it) {
        return classof(it) == "String" ? split4(it, "") : Object2(it);
      } : Object2;
    }
  });

  // node_modules/core-js/internals/require-object-coercible.js
  var require_require_object_coercible = __commonJS({
    "node_modules/core-js/internals/require-object-coercible.js"(exports, module) {
      var global2 = require_global();
      var TypeError2 = global2.TypeError;
      module.exports = function(it) {
        if (it == void 0)
          throw TypeError2("Can't call method on " + it);
        return it;
      };
    }
  });

  // node_modules/core-js/internals/to-indexed-object.js
  var require_to_indexed_object = __commonJS({
    "node_modules/core-js/internals/to-indexed-object.js"(exports, module) {
      var IndexedObject = require_indexed_object();
      var requireObjectCoercible = require_require_object_coercible();
      module.exports = function(it) {
        return IndexedObject(requireObjectCoercible(it));
      };
    }
  });

  // node_modules/core-js/internals/is-callable.js
  var require_is_callable = __commonJS({
    "node_modules/core-js/internals/is-callable.js"(exports, module) {
      module.exports = function(argument) {
        return typeof argument == "function";
      };
    }
  });

  // node_modules/core-js/internals/is-object.js
  var require_is_object = __commonJS({
    "node_modules/core-js/internals/is-object.js"(exports, module) {
      var isCallable = require_is_callable();
      module.exports = function(it) {
        return typeof it == "object" ? it !== null : isCallable(it);
      };
    }
  });

  // node_modules/core-js/internals/get-built-in.js
  var require_get_built_in = __commonJS({
    "node_modules/core-js/internals/get-built-in.js"(exports, module) {
      var global2 = require_global();
      var isCallable = require_is_callable();
      var aFunction = function(argument) {
        return isCallable(argument) ? argument : void 0;
      };
      module.exports = function(namespace, method) {
        return arguments.length < 2 ? aFunction(global2[namespace]) : global2[namespace] && global2[namespace][method];
      };
    }
  });

  // node_modules/core-js/internals/object-is-prototype-of.js
  var require_object_is_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-is-prototype-of.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      module.exports = uncurryThis({}.isPrototypeOf);
    }
  });

  // node_modules/core-js/internals/engine-user-agent.js
  var require_engine_user_agent = __commonJS({
    "node_modules/core-js/internals/engine-user-agent.js"(exports, module) {
      var getBuiltIn = require_get_built_in();
      module.exports = getBuiltIn("navigator", "userAgent") || "";
    }
  });

  // node_modules/core-js/internals/engine-v8-version.js
  var require_engine_v8_version = __commonJS({
    "node_modules/core-js/internals/engine-v8-version.js"(exports, module) {
      var global2 = require_global();
      var userAgent = require_engine_user_agent();
      var process2 = global2.process;
      var Deno = global2.Deno;
      var versions = process2 && process2.versions || Deno && Deno.version;
      var v8 = versions && versions.v8;
      var match2;
      var version;
      if (v8) {
        match2 = v8.split(".");
        version = match2[0] > 0 && match2[0] < 4 ? 1 : +(match2[0] + match2[1]);
      }
      if (!version && userAgent) {
        match2 = userAgent.match(/Edge\/(\d+)/);
        if (!match2 || match2[1] >= 74) {
          match2 = userAgent.match(/Chrome\/(\d+)/);
          if (match2)
            version = +match2[1];
        }
      }
      module.exports = version;
    }
  });

  // node_modules/core-js/internals/native-symbol.js
  var require_native_symbol = __commonJS({
    "node_modules/core-js/internals/native-symbol.js"(exports, module) {
      var V8_VERSION = require_engine_v8_version();
      var fails = require_fails();
      module.exports = !!Object.getOwnPropertySymbols && !fails(function() {
        var symbol = Symbol();
        return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
        !Symbol.sham && V8_VERSION && V8_VERSION < 41;
      });
    }
  });

  // node_modules/core-js/internals/use-symbol-as-uid.js
  var require_use_symbol_as_uid = __commonJS({
    "node_modules/core-js/internals/use-symbol-as-uid.js"(exports, module) {
      var NATIVE_SYMBOL = require_native_symbol();
      module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == "symbol";
    }
  });

  // node_modules/core-js/internals/is-symbol.js
  var require_is_symbol = __commonJS({
    "node_modules/core-js/internals/is-symbol.js"(exports, module) {
      var global2 = require_global();
      var getBuiltIn = require_get_built_in();
      var isCallable = require_is_callable();
      var isPrototypeOf = require_object_is_prototype_of();
      var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
      var Object2 = global2.Object;
      module.exports = USE_SYMBOL_AS_UID ? function(it) {
        return typeof it == "symbol";
      } : function(it) {
        var $Symbol = getBuiltIn("Symbol");
        return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, Object2(it));
      };
    }
  });

  // node_modules/core-js/internals/try-to-string.js
  var require_try_to_string = __commonJS({
    "node_modules/core-js/internals/try-to-string.js"(exports, module) {
      var global2 = require_global();
      var String2 = global2.String;
      module.exports = function(argument) {
        try {
          return String2(argument);
        } catch (error) {
          return "Object";
        }
      };
    }
  });

  // node_modules/core-js/internals/a-callable.js
  var require_a_callable = __commonJS({
    "node_modules/core-js/internals/a-callable.js"(exports, module) {
      var global2 = require_global();
      var isCallable = require_is_callable();
      var tryToString = require_try_to_string();
      var TypeError2 = global2.TypeError;
      module.exports = function(argument) {
        if (isCallable(argument))
          return argument;
        throw TypeError2(tryToString(argument) + " is not a function");
      };
    }
  });

  // node_modules/core-js/internals/get-method.js
  var require_get_method = __commonJS({
    "node_modules/core-js/internals/get-method.js"(exports, module) {
      var aCallable = require_a_callable();
      module.exports = function(V, P) {
        var func = V[P];
        return func == null ? void 0 : aCallable(func);
      };
    }
  });

  // node_modules/core-js/internals/ordinary-to-primitive.js
  var require_ordinary_to_primitive = __commonJS({
    "node_modules/core-js/internals/ordinary-to-primitive.js"(exports, module) {
      var global2 = require_global();
      var call = require_function_call();
      var isCallable = require_is_callable();
      var isObject2 = require_is_object();
      var TypeError2 = global2.TypeError;
      module.exports = function(input, pref) {
        var fn, val;
        if (pref === "string" && isCallable(fn = input.toString) && !isObject2(val = call(fn, input)))
          return val;
        if (isCallable(fn = input.valueOf) && !isObject2(val = call(fn, input)))
          return val;
        if (pref !== "string" && isCallable(fn = input.toString) && !isObject2(val = call(fn, input)))
          return val;
        throw TypeError2("Can't convert object to primitive value");
      };
    }
  });

  // node_modules/core-js/internals/is-pure.js
  var require_is_pure = __commonJS({
    "node_modules/core-js/internals/is-pure.js"(exports, module) {
      module.exports = false;
    }
  });

  // node_modules/core-js/internals/set-global.js
  var require_set_global = __commonJS({
    "node_modules/core-js/internals/set-global.js"(exports, module) {
      var global2 = require_global();
      var defineProperty = Object.defineProperty;
      module.exports = function(key, value) {
        try {
          defineProperty(global2, key, { value, configurable: true, writable: true });
        } catch (error) {
          global2[key] = value;
        }
        return value;
      };
    }
  });

  // node_modules/core-js/internals/shared-store.js
  var require_shared_store = __commonJS({
    "node_modules/core-js/internals/shared-store.js"(exports, module) {
      var global2 = require_global();
      var setGlobal = require_set_global();
      var SHARED = "__core-js_shared__";
      var store = global2[SHARED] || setGlobal(SHARED, {});
      module.exports = store;
    }
  });

  // node_modules/core-js/internals/shared.js
  var require_shared = __commonJS({
    "node_modules/core-js/internals/shared.js"(exports, module) {
      var IS_PURE = require_is_pure();
      var store = require_shared_store();
      (module.exports = function(key, value) {
        return store[key] || (store[key] = value !== void 0 ? value : {});
      })("versions", []).push({
        version: "3.19.0",
        mode: IS_PURE ? "pure" : "global",
        copyright: "\xA9 2021 Denis Pushkarev (zloirock.ru)"
      });
    }
  });

  // node_modules/core-js/internals/to-object.js
  var require_to_object = __commonJS({
    "node_modules/core-js/internals/to-object.js"(exports, module) {
      var global2 = require_global();
      var requireObjectCoercible = require_require_object_coercible();
      var Object2 = global2.Object;
      module.exports = function(argument) {
        return Object2(requireObjectCoercible(argument));
      };
    }
  });

  // node_modules/core-js/internals/has-own-property.js
  var require_has_own_property = __commonJS({
    "node_modules/core-js/internals/has-own-property.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var toObject = require_to_object();
      var hasOwnProperty3 = uncurryThis({}.hasOwnProperty);
      module.exports = Object.hasOwn || function hasOwn4(it, key) {
        return hasOwnProperty3(toObject(it), key);
      };
    }
  });

  // node_modules/core-js/internals/uid.js
  var require_uid = __commonJS({
    "node_modules/core-js/internals/uid.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var id = 0;
      var postfix = Math.random();
      var toString4 = uncurryThis(1 .toString);
      module.exports = function(key) {
        return "Symbol(" + (key === void 0 ? "" : key) + ")_" + toString4(++id + postfix, 36);
      };
    }
  });

  // node_modules/core-js/internals/well-known-symbol.js
  var require_well_known_symbol = __commonJS({
    "node_modules/core-js/internals/well-known-symbol.js"(exports, module) {
      var global2 = require_global();
      var shared = require_shared();
      var hasOwn4 = require_has_own_property();
      var uid = require_uid();
      var NATIVE_SYMBOL = require_native_symbol();
      var USE_SYMBOL_AS_UID = require_use_symbol_as_uid();
      var WellKnownSymbolsStore = shared("wks");
      var Symbol2 = global2.Symbol;
      var symbolFor = Symbol2 && Symbol2["for"];
      var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol2 : Symbol2 && Symbol2.withoutSetter || uid;
      module.exports = function(name) {
        if (!hasOwn4(WellKnownSymbolsStore, name) || !(NATIVE_SYMBOL || typeof WellKnownSymbolsStore[name] == "string")) {
          var description = "Symbol." + name;
          if (NATIVE_SYMBOL && hasOwn4(Symbol2, name)) {
            WellKnownSymbolsStore[name] = Symbol2[name];
          } else if (USE_SYMBOL_AS_UID && symbolFor) {
            WellKnownSymbolsStore[name] = symbolFor(description);
          } else {
            WellKnownSymbolsStore[name] = createWellKnownSymbol(description);
          }
        }
        return WellKnownSymbolsStore[name];
      };
    }
  });

  // node_modules/core-js/internals/to-primitive.js
  var require_to_primitive = __commonJS({
    "node_modules/core-js/internals/to-primitive.js"(exports, module) {
      var global2 = require_global();
      var call = require_function_call();
      var isObject2 = require_is_object();
      var isSymbol = require_is_symbol();
      var getMethod = require_get_method();
      var ordinaryToPrimitive = require_ordinary_to_primitive();
      var wellKnownSymbol = require_well_known_symbol();
      var TypeError2 = global2.TypeError;
      var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
      module.exports = function(input, pref) {
        if (!isObject2(input) || isSymbol(input))
          return input;
        var exoticToPrim = getMethod(input, TO_PRIMITIVE);
        var result;
        if (exoticToPrim) {
          if (pref === void 0)
            pref = "default";
          result = call(exoticToPrim, input, pref);
          if (!isObject2(result) || isSymbol(result))
            return result;
          throw TypeError2("Can't convert object to primitive value");
        }
        if (pref === void 0)
          pref = "number";
        return ordinaryToPrimitive(input, pref);
      };
    }
  });

  // node_modules/core-js/internals/to-property-key.js
  var require_to_property_key = __commonJS({
    "node_modules/core-js/internals/to-property-key.js"(exports, module) {
      var toPrimitive = require_to_primitive();
      var isSymbol = require_is_symbol();
      module.exports = function(argument) {
        var key = toPrimitive(argument, "string");
        return isSymbol(key) ? key : key + "";
      };
    }
  });

  // node_modules/core-js/internals/document-create-element.js
  var require_document_create_element = __commonJS({
    "node_modules/core-js/internals/document-create-element.js"(exports, module) {
      var global2 = require_global();
      var isObject2 = require_is_object();
      var document2 = global2.document;
      var EXISTS = isObject2(document2) && isObject2(document2.createElement);
      module.exports = function(it) {
        return EXISTS ? document2.createElement(it) : {};
      };
    }
  });

  // node_modules/core-js/internals/ie8-dom-define.js
  var require_ie8_dom_define = __commonJS({
    "node_modules/core-js/internals/ie8-dom-define.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var fails = require_fails();
      var createElement = require_document_create_element();
      module.exports = !DESCRIPTORS && !fails(function() {
        return Object.defineProperty(createElement("div"), "a", {
          get: function() {
            return 7;
          }
        }).a != 7;
      });
    }
  });

  // node_modules/core-js/internals/object-get-own-property-descriptor.js
  var require_object_get_own_property_descriptor = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-descriptor.js"(exports) {
      var DESCRIPTORS = require_descriptors();
      var call = require_function_call();
      var propertyIsEnumerableModule = require_object_property_is_enumerable();
      var createPropertyDescriptor = require_create_property_descriptor();
      var toIndexedObject = require_to_indexed_object();
      var toPropertyKey = require_to_property_key();
      var hasOwn4 = require_has_own_property();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPropertyKey(P);
        if (IE8_DOM_DEFINE)
          try {
            return $getOwnPropertyDescriptor(O, P);
          } catch (error) {
          }
        if (hasOwn4(O, P))
          return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
      };
    }
  });

  // node_modules/core-js/internals/an-object.js
  var require_an_object = __commonJS({
    "node_modules/core-js/internals/an-object.js"(exports, module) {
      var global2 = require_global();
      var isObject2 = require_is_object();
      var String2 = global2.String;
      var TypeError2 = global2.TypeError;
      module.exports = function(argument) {
        if (isObject2(argument))
          return argument;
        throw TypeError2(String2(argument) + " is not an object");
      };
    }
  });

  // node_modules/core-js/internals/object-define-property.js
  var require_object_define_property = __commonJS({
    "node_modules/core-js/internals/object-define-property.js"(exports) {
      var global2 = require_global();
      var DESCRIPTORS = require_descriptors();
      var IE8_DOM_DEFINE = require_ie8_dom_define();
      var anObject = require_an_object();
      var toPropertyKey = require_to_property_key();
      var TypeError2 = global2.TypeError;
      var $defineProperty = Object.defineProperty;
      exports.f = DESCRIPTORS ? $defineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPropertyKey(P);
        anObject(Attributes);
        if (IE8_DOM_DEFINE)
          try {
            return $defineProperty(O, P, Attributes);
          } catch (error) {
          }
        if ("get" in Attributes || "set" in Attributes)
          throw TypeError2("Accessors not supported");
        if ("value" in Attributes)
          O[P] = Attributes.value;
        return O;
      };
    }
  });

  // node_modules/core-js/internals/create-non-enumerable-property.js
  var require_create_non_enumerable_property = __commonJS({
    "node_modules/core-js/internals/create-non-enumerable-property.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var definePropertyModule = require_object_define_property();
      var createPropertyDescriptor = require_create_property_descriptor();
      module.exports = DESCRIPTORS ? function(object, key, value) {
        return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
      } : function(object, key, value) {
        object[key] = value;
        return object;
      };
    }
  });

  // node_modules/core-js/internals/inspect-source.js
  var require_inspect_source = __commonJS({
    "node_modules/core-js/internals/inspect-source.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var isCallable = require_is_callable();
      var store = require_shared_store();
      var functionToString = uncurryThis(Function.toString);
      if (!isCallable(store.inspectSource)) {
        store.inspectSource = function(it) {
          return functionToString(it);
        };
      }
      module.exports = store.inspectSource;
    }
  });

  // node_modules/core-js/internals/native-weak-map.js
  var require_native_weak_map = __commonJS({
    "node_modules/core-js/internals/native-weak-map.js"(exports, module) {
      var global2 = require_global();
      var isCallable = require_is_callable();
      var inspectSource = require_inspect_source();
      var WeakMap2 = global2.WeakMap;
      module.exports = isCallable(WeakMap2) && /native code/.test(inspectSource(WeakMap2));
    }
  });

  // node_modules/core-js/internals/shared-key.js
  var require_shared_key = __commonJS({
    "node_modules/core-js/internals/shared-key.js"(exports, module) {
      var shared = require_shared();
      var uid = require_uid();
      var keys = shared("keys");
      module.exports = function(key) {
        return keys[key] || (keys[key] = uid(key));
      };
    }
  });

  // node_modules/core-js/internals/hidden-keys.js
  var require_hidden_keys = __commonJS({
    "node_modules/core-js/internals/hidden-keys.js"(exports, module) {
      module.exports = {};
    }
  });

  // node_modules/core-js/internals/internal-state.js
  var require_internal_state = __commonJS({
    "node_modules/core-js/internals/internal-state.js"(exports, module) {
      var NATIVE_WEAK_MAP = require_native_weak_map();
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      var isObject2 = require_is_object();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var hasOwn4 = require_has_own_property();
      var shared = require_shared_store();
      var sharedKey = require_shared_key();
      var hiddenKeys = require_hidden_keys();
      var OBJECT_ALREADY_INITIALIZED = "Object already initialized";
      var TypeError2 = global2.TypeError;
      var WeakMap2 = global2.WeakMap;
      var set2;
      var get2;
      var has2;
      var enforce = function(it) {
        return has2(it) ? get2(it) : set2(it, {});
      };
      var getterFor = function(TYPE) {
        return function(it) {
          var state;
          if (!isObject2(it) || (state = get2(it)).type !== TYPE) {
            throw TypeError2("Incompatible receiver, " + TYPE + " required");
          }
          return state;
        };
      };
      if (NATIVE_WEAK_MAP || shared.state) {
        store = shared.state || (shared.state = new WeakMap2());
        wmget = uncurryThis(store.get);
        wmhas = uncurryThis(store.has);
        wmset = uncurryThis(store.set);
        set2 = function(it, metadata) {
          if (wmhas(store, it))
            throw new TypeError2(OBJECT_ALREADY_INITIALIZED);
          metadata.facade = it;
          wmset(store, it, metadata);
          return metadata;
        };
        get2 = function(it) {
          return wmget(store, it) || {};
        };
        has2 = function(it) {
          return wmhas(store, it);
        };
      } else {
        STATE = sharedKey("state");
        hiddenKeys[STATE] = true;
        set2 = function(it, metadata) {
          if (hasOwn4(it, STATE))
            throw new TypeError2(OBJECT_ALREADY_INITIALIZED);
          metadata.facade = it;
          createNonEnumerableProperty(it, STATE, metadata);
          return metadata;
        };
        get2 = function(it) {
          return hasOwn4(it, STATE) ? it[STATE] : {};
        };
        has2 = function(it) {
          return hasOwn4(it, STATE);
        };
      }
      var store;
      var wmget;
      var wmhas;
      var wmset;
      var STATE;
      module.exports = {
        set: set2,
        get: get2,
        has: has2,
        enforce,
        getterFor
      };
    }
  });

  // node_modules/core-js/internals/function-name.js
  var require_function_name = __commonJS({
    "node_modules/core-js/internals/function-name.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var hasOwn4 = require_has_own_property();
      var FunctionPrototype = Function.prototype;
      var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
      var EXISTS = hasOwn4(FunctionPrototype, "name");
      var PROPER = EXISTS && function something() {
      }.name === "something";
      var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, "name").configurable);
      module.exports = {
        EXISTS,
        PROPER,
        CONFIGURABLE
      };
    }
  });

  // node_modules/core-js/internals/redefine.js
  var require_redefine = __commonJS({
    "node_modules/core-js/internals/redefine.js"(exports, module) {
      var global2 = require_global();
      var isCallable = require_is_callable();
      var hasOwn4 = require_has_own_property();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var setGlobal = require_set_global();
      var inspectSource = require_inspect_source();
      var InternalStateModule = require_internal_state();
      var CONFIGURABLE_FUNCTION_NAME = require_function_name().CONFIGURABLE;
      var getInternalState = InternalStateModule.get;
      var enforceInternalState = InternalStateModule.enforce;
      var TEMPLATE = String(String).split("String");
      (module.exports = function(O, key, value, options) {
        var unsafe = options ? !!options.unsafe : false;
        var simple = options ? !!options.enumerable : false;
        var noTargetGet = options ? !!options.noTargetGet : false;
        var name = options && options.name !== void 0 ? options.name : key;
        var state;
        if (isCallable(value)) {
          if (String(name).slice(0, 7) === "Symbol(") {
            name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
          }
          if (!hasOwn4(value, "name") || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
            createNonEnumerableProperty(value, "name", name);
          }
          state = enforceInternalState(value);
          if (!state.source) {
            state.source = TEMPLATE.join(typeof name == "string" ? name : "");
          }
        }
        if (O === global2) {
          if (simple)
            O[key] = value;
          else
            setGlobal(key, value);
          return;
        } else if (!unsafe) {
          delete O[key];
        } else if (!noTargetGet && O[key]) {
          simple = true;
        }
        if (simple)
          O[key] = value;
        else
          createNonEnumerableProperty(O, key, value);
      })(Function.prototype, "toString", function toString4() {
        return isCallable(this) && getInternalState(this).source || inspectSource(this);
      });
    }
  });

  // node_modules/core-js/internals/to-integer-or-infinity.js
  var require_to_integer_or_infinity = __commonJS({
    "node_modules/core-js/internals/to-integer-or-infinity.js"(exports, module) {
      var ceil = Math.ceil;
      var floor = Math.floor;
      module.exports = function(argument) {
        var number = +argument;
        return number !== number || number === 0 ? 0 : (number > 0 ? floor : ceil)(number);
      };
    }
  });

  // node_modules/core-js/internals/to-absolute-index.js
  var require_to_absolute_index = __commonJS({
    "node_modules/core-js/internals/to-absolute-index.js"(exports, module) {
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var max2 = Math.max;
      var min = Math.min;
      module.exports = function(index, length2) {
        var integer = toIntegerOrInfinity(index);
        return integer < 0 ? max2(integer + length2, 0) : min(integer, length2);
      };
    }
  });

  // node_modules/core-js/internals/to-length.js
  var require_to_length = __commonJS({
    "node_modules/core-js/internals/to-length.js"(exports, module) {
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var min = Math.min;
      module.exports = function(argument) {
        return argument > 0 ? min(toIntegerOrInfinity(argument), 9007199254740991) : 0;
      };
    }
  });

  // node_modules/core-js/internals/length-of-array-like.js
  var require_length_of_array_like = __commonJS({
    "node_modules/core-js/internals/length-of-array-like.js"(exports, module) {
      var toLength = require_to_length();
      module.exports = function(obj) {
        return toLength(obj.length);
      };
    }
  });

  // node_modules/core-js/internals/array-includes.js
  var require_array_includes = __commonJS({
    "node_modules/core-js/internals/array-includes.js"(exports, module) {
      var toIndexedObject = require_to_indexed_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var lengthOfArrayLike = require_length_of_array_like();
      var createMethod = function(IS_INCLUDES) {
        return function($this, el, fromIndex) {
          var O = toIndexedObject($this);
          var length2 = lengthOfArrayLike(O);
          var index = toAbsoluteIndex(fromIndex, length2);
          var value;
          if (IS_INCLUDES && el != el)
            while (length2 > index) {
              value = O[index++];
              if (value != value)
                return true;
            }
          else
            for (; length2 > index; index++) {
              if ((IS_INCLUDES || index in O) && O[index] === el)
                return IS_INCLUDES || index || 0;
            }
          return !IS_INCLUDES && -1;
        };
      };
      module.exports = {
        // `Array.prototype.includes` method
        // https://tc39.es/ecma262/#sec-array.prototype.includes
        includes: createMethod(true),
        // `Array.prototype.indexOf` method
        // https://tc39.es/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod(false)
      };
    }
  });

  // node_modules/core-js/internals/object-keys-internal.js
  var require_object_keys_internal = __commonJS({
    "node_modules/core-js/internals/object-keys-internal.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var hasOwn4 = require_has_own_property();
      var toIndexedObject = require_to_indexed_object();
      var indexOf = require_array_includes().indexOf;
      var hiddenKeys = require_hidden_keys();
      var push = uncurryThis([].push);
      module.exports = function(object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O)
          !hasOwn4(hiddenKeys, key) && hasOwn4(O, key) && push(result, key);
        while (names.length > i)
          if (hasOwn4(O, key = names[i++])) {
            ~indexOf(result, key) || push(result, key);
          }
        return result;
      };
    }
  });

  // node_modules/core-js/internals/enum-bug-keys.js
  var require_enum_bug_keys = __commonJS({
    "node_modules/core-js/internals/enum-bug-keys.js"(exports, module) {
      module.exports = [
        "constructor",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "toLocaleString",
        "toString",
        "valueOf"
      ];
    }
  });

  // node_modules/core-js/internals/object-get-own-property-names.js
  var require_object_get_own_property_names = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-names.js"(exports) {
      var internalObjectKeys = require_object_keys_internal();
      var enumBugKeys = require_enum_bug_keys();
      var hiddenKeys = enumBugKeys.concat("length", "prototype");
      exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
        return internalObjectKeys(O, hiddenKeys);
      };
    }
  });

  // node_modules/core-js/internals/object-get-own-property-symbols.js
  var require_object_get_own_property_symbols = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-symbols.js"(exports) {
      exports.f = Object.getOwnPropertySymbols;
    }
  });

  // node_modules/core-js/internals/own-keys.js
  var require_own_keys = __commonJS({
    "node_modules/core-js/internals/own-keys.js"(exports, module) {
      var getBuiltIn = require_get_built_in();
      var uncurryThis = require_function_uncurry_this();
      var getOwnPropertyNamesModule = require_object_get_own_property_names();
      var getOwnPropertySymbolsModule = require_object_get_own_property_symbols();
      var anObject = require_an_object();
      var concat4 = uncurryThis([].concat);
      module.exports = getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
        var keys = getOwnPropertyNamesModule.f(anObject(it));
        var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
        return getOwnPropertySymbols ? concat4(keys, getOwnPropertySymbols(it)) : keys;
      };
    }
  });

  // node_modules/core-js/internals/copy-constructor-properties.js
  var require_copy_constructor_properties = __commonJS({
    "node_modules/core-js/internals/copy-constructor-properties.js"(exports, module) {
      var hasOwn4 = require_has_own_property();
      var ownKeys = require_own_keys();
      var getOwnPropertyDescriptorModule = require_object_get_own_property_descriptor();
      var definePropertyModule = require_object_define_property();
      module.exports = function(target, source) {
        var keys = ownKeys(source);
        var defineProperty = definePropertyModule.f;
        var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          if (!hasOwn4(target, key))
            defineProperty(target, key, getOwnPropertyDescriptor(source, key));
        }
      };
    }
  });

  // node_modules/core-js/internals/is-forced.js
  var require_is_forced = __commonJS({
    "node_modules/core-js/internals/is-forced.js"(exports, module) {
      var fails = require_fails();
      var isCallable = require_is_callable();
      var replacement = /#|\.prototype\./;
      var isForced = function(feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true : value == NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
      };
      var normalize = isForced.normalize = function(string) {
        return String(string).replace(replacement, ".").toLowerCase();
      };
      var data = isForced.data = {};
      var NATIVE = isForced.NATIVE = "N";
      var POLYFILL = isForced.POLYFILL = "P";
      module.exports = isForced;
    }
  });

  // node_modules/core-js/internals/export.js
  var require_export = __commonJS({
    "node_modules/core-js/internals/export.js"(exports, module) {
      var global2 = require_global();
      var getOwnPropertyDescriptor = require_object_get_own_property_descriptor().f;
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var redefine = require_redefine();
      var setGlobal = require_set_global();
      var copyConstructorProperties = require_copy_constructor_properties();
      var isForced = require_is_forced();
      module.exports = function(options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var FORCED, target, key, targetProperty, sourceProperty, descriptor;
        if (GLOBAL) {
          target = global2;
        } else if (STATIC) {
          target = global2[TARGET] || setGlobal(TARGET, {});
        } else {
          target = (global2[TARGET] || {}).prototype;
        }
        if (target)
          for (key in source) {
            sourceProperty = source[key];
            if (options.noTargetGet) {
              descriptor = getOwnPropertyDescriptor(target, key);
              targetProperty = descriptor && descriptor.value;
            } else
              targetProperty = target[key];
            FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
            if (!FORCED && targetProperty !== void 0) {
              if (typeof sourceProperty == typeof targetProperty)
                continue;
              copyConstructorProperties(sourceProperty, targetProperty);
            }
            if (options.sham || targetProperty && targetProperty.sham) {
              createNonEnumerableProperty(sourceProperty, "sham", true);
            }
            redefine(target, key, sourceProperty, options);
          }
      };
    }
  });

  // node_modules/core-js/internals/object-keys.js
  var require_object_keys = __commonJS({
    "node_modules/core-js/internals/object-keys.js"(exports, module) {
      var internalObjectKeys = require_object_keys_internal();
      var enumBugKeys = require_enum_bug_keys();
      module.exports = Object.keys || function keys(O) {
        return internalObjectKeys(O, enumBugKeys);
      };
    }
  });

  // node_modules/core-js/internals/object-define-properties.js
  var require_object_define_properties = __commonJS({
    "node_modules/core-js/internals/object-define-properties.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var definePropertyModule = require_object_define_property();
      var anObject = require_an_object();
      var toIndexedObject = require_to_indexed_object();
      var objectKeys2 = require_object_keys();
      module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var props = toIndexedObject(Properties);
        var keys = objectKeys2(Properties);
        var length2 = keys.length;
        var index = 0;
        var key;
        while (length2 > index)
          definePropertyModule.f(O, key = keys[index++], props[key]);
        return O;
      };
    }
  });

  // node_modules/core-js/internals/html.js
  var require_html = __commonJS({
    "node_modules/core-js/internals/html.js"(exports, module) {
      var getBuiltIn = require_get_built_in();
      module.exports = getBuiltIn("document", "documentElement");
    }
  });

  // node_modules/core-js/internals/object-create.js
  var require_object_create = __commonJS({
    "node_modules/core-js/internals/object-create.js"(exports, module) {
      var anObject = require_an_object();
      var defineProperties = require_object_define_properties();
      var enumBugKeys = require_enum_bug_keys();
      var hiddenKeys = require_hidden_keys();
      var html = require_html();
      var documentCreateElement = require_document_create_element();
      var sharedKey = require_shared_key();
      var GT = ">";
      var LT = "<";
      var PROTOTYPE = "prototype";
      var SCRIPT = "script";
      var IE_PROTO = sharedKey("IE_PROTO");
      var EmptyConstructor = function() {
      };
      var scriptTag = function(content) {
        return LT + SCRIPT + GT + content + LT + "/" + SCRIPT + GT;
      };
      var NullProtoObjectViaActiveX = function(activeXDocument2) {
        activeXDocument2.write(scriptTag(""));
        activeXDocument2.close();
        var temp = activeXDocument2.parentWindow.Object;
        activeXDocument2 = null;
        return temp;
      };
      var NullProtoObjectViaIFrame = function() {
        var iframe = documentCreateElement("iframe");
        var JS = "java" + SCRIPT + ":";
        var iframeDocument;
        iframe.style.display = "none";
        html.appendChild(iframe);
        iframe.src = String(JS);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(scriptTag("document.F=Object"));
        iframeDocument.close();
        return iframeDocument.F;
      };
      var activeXDocument;
      var NullProtoObject = function() {
        try {
          activeXDocument = new ActiveXObject("htmlfile");
        } catch (error) {
        }
        NullProtoObject = typeof document != "undefined" ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
        var length2 = enumBugKeys.length;
        while (length2--)
          delete NullProtoObject[PROTOTYPE][enumBugKeys[length2]];
        return NullProtoObject();
      };
      hiddenKeys[IE_PROTO] = true;
      module.exports = Object.create || function create5(O, Properties) {
        var result;
        if (O !== null) {
          EmptyConstructor[PROTOTYPE] = anObject(O);
          result = new EmptyConstructor();
          EmptyConstructor[PROTOTYPE] = null;
          result[IE_PROTO] = O;
        } else
          result = NullProtoObject();
        return Properties === void 0 ? result : defineProperties(result, Properties);
      };
    }
  });

  // node_modules/core-js/internals/add-to-unscopables.js
  var require_add_to_unscopables = __commonJS({
    "node_modules/core-js/internals/add-to-unscopables.js"(exports, module) {
      var wellKnownSymbol = require_well_known_symbol();
      var create5 = require_object_create();
      var definePropertyModule = require_object_define_property();
      var UNSCOPABLES = wellKnownSymbol("unscopables");
      var ArrayPrototype = Array.prototype;
      if (ArrayPrototype[UNSCOPABLES] == void 0) {
        definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
          configurable: true,
          value: create5(null)
        });
      }
      module.exports = function(key) {
        ArrayPrototype[UNSCOPABLES][key] = true;
      };
    }
  });

  // node_modules/core-js/modules/es.array.includes.js
  var require_es_array_includes = __commonJS({
    "node_modules/core-js/modules/es.array.includes.js"() {
      "use strict";
      var $2 = require_export();
      var $includes = require_array_includes().includes;
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        includes: function includes(el) {
          return $includes(this, el, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      addToUnscopables("includes");
    }
  });

  // node_modules/core-js/internals/entry-unbind.js
  var require_entry_unbind = __commonJS({
    "node_modules/core-js/internals/entry-unbind.js"(exports, module) {
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      module.exports = function(CONSTRUCTOR, METHOD) {
        return uncurryThis(global2[CONSTRUCTOR].prototype[METHOD]);
      };
    }
  });

  // node_modules/core-js/es/array/includes.js
  var require_includes = __commonJS({
    "node_modules/core-js/es/array/includes.js"(exports, module) {
      require_es_array_includes();
      var entryUnbind = require_entry_unbind();
      module.exports = entryUnbind("Array", "includes");
    }
  });

  // node_modules/core-js/stable/array/includes.js
  var require_includes2 = __commonJS({
    "node_modules/core-js/stable/array/includes.js"(exports, module) {
      var parent = require_includes();
      module.exports = parent;
    }
  });

  // node_modules/core-js/features/array/includes.js
  var require_includes3 = __commonJS({
    "node_modules/core-js/features/array/includes.js"(exports, module) {
      var parent = require_includes2();
      module.exports = parent;
    }
  });

  // node_modules/lodash/_freeGlobal.js
  var require_freeGlobal = __commonJS({
    "node_modules/lodash/_freeGlobal.js"(exports, module) {
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      module.exports = freeGlobal;
    }
  });

  // node_modules/lodash/_root.js
  var require_root = __commonJS({
    "node_modules/lodash/_root.js"(exports, module) {
      var freeGlobal = require_freeGlobal();
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      module.exports = root;
    }
  });

  // node_modules/lodash/_Symbol.js
  var require_Symbol = __commonJS({
    "node_modules/lodash/_Symbol.js"(exports, module) {
      var root = require_root();
      var Symbol2 = root.Symbol;
      module.exports = Symbol2;
    }
  });

  // node_modules/lodash/_getRawTag.js
  var require_getRawTag = __commonJS({
    "node_modules/lodash/_getRawTag.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      var nativeObjectToString = objectProto.toString;
      var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
      function getRawTag(value) {
        var isOwn = hasOwnProperty3.call(value, symToStringTag), tag = value[symToStringTag];
        try {
          value[symToStringTag] = void 0;
          var unmasked = true;
        } catch (e) {
        }
        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }
      module.exports = getRawTag;
    }
  });

  // node_modules/lodash/_objectToString.js
  var require_objectToString = __commonJS({
    "node_modules/lodash/_objectToString.js"(exports, module) {
      var objectProto = Object.prototype;
      var nativeObjectToString = objectProto.toString;
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      module.exports = objectToString;
    }
  });

  // node_modules/lodash/_baseGetTag.js
  var require_baseGetTag = __commonJS({
    "node_modules/lodash/_baseGetTag.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var getRawTag = require_getRawTag();
      var objectToString = require_objectToString();
      var nullTag = "[object Null]";
      var undefinedTag = "[object Undefined]";
      var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
      function baseGetTag(value) {
        if (value == null) {
          return value === void 0 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }
      module.exports = baseGetTag;
    }
  });

  // node_modules/lodash/_overArg.js
  var require_overArg = __commonJS({
    "node_modules/lodash/_overArg.js"(exports, module) {
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      module.exports = overArg;
    }
  });

  // node_modules/lodash/_getPrototype.js
  var require_getPrototype = __commonJS({
    "node_modules/lodash/_getPrototype.js"(exports, module) {
      var overArg = require_overArg();
      var getPrototype = overArg(Object.getPrototypeOf, Object);
      module.exports = getPrototype;
    }
  });

  // node_modules/lodash/isObjectLike.js
  var require_isObjectLike = __commonJS({
    "node_modules/lodash/isObjectLike.js"(exports, module) {
      function isObjectLike(value) {
        return value != null && typeof value == "object";
      }
      module.exports = isObjectLike;
    }
  });

  // node_modules/lodash/isPlainObject.js
  var require_isPlainObject = __commonJS({
    "node_modules/lodash/isPlainObject.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var getPrototype = require_getPrototype();
      var isObjectLike = require_isObjectLike();
      var objectTag = "[object Object]";
      var funcProto = Function.prototype;
      var objectProto = Object.prototype;
      var funcToString = funcProto.toString;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      var objectCtorString = funcToString.call(Object);
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty3.call(proto, "constructor") && proto.constructor;
        return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      module.exports = isPlainObject;
    }
  });

  // node_modules/symbol-observable/lib/ponyfill.js
  var require_ponyfill = __commonJS({
    "node_modules/symbol-observable/lib/ponyfill.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports["default"] = symbolObservablePonyfill;
      function symbolObservablePonyfill(root) {
        var result;
        var _Symbol = root.Symbol;
        if (typeof _Symbol === "function") {
          if (_Symbol.observable) {
            result = _Symbol.observable;
          } else {
            result = _Symbol("observable");
            _Symbol.observable = result;
          }
        } else {
          result = "@@observable";
        }
        return result;
      }
    }
  });

  // node_modules/symbol-observable/lib/index.js
  var require_lib = __commonJS({
    "node_modules/symbol-observable/lib/index.js"(exports, module) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _ponyfill = require_ponyfill();
      var _ponyfill2 = _interopRequireDefault(_ponyfill);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { "default": obj };
      }
      var root;
      if (typeof self !== "undefined") {
        root = self;
      } else if (typeof window !== "undefined") {
        root = window;
      } else if (typeof global !== "undefined") {
        root = global;
      } else if (typeof module !== "undefined") {
        root = module;
      } else {
        root = Function("return this")();
      }
      var result = (0, _ponyfill2["default"])(root);
      exports["default"] = result;
    }
  });

  // node_modules/redux/lib/createStore.js
  var require_createStore = __commonJS({
    "node_modules/redux/lib/createStore.js"(exports) {
      "use strict";
      exports.__esModule = true;
      exports.ActionTypes = void 0;
      exports["default"] = createStore;
      var _isPlainObject = require_isPlainObject();
      var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
      var _symbolObservable = require_lib();
      var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { "default": obj };
      }
      var ActionTypes = exports.ActionTypes = {
        INIT: "@@redux/INIT"
      };
      function createStore(reducer, preloadedState, enhancer) {
        var _ref2;
        if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
          enhancer = preloadedState;
          preloadedState = void 0;
        }
        if (typeof enhancer !== "undefined") {
          if (typeof enhancer !== "function") {
            throw new Error("Expected the enhancer to be a function.");
          }
          return enhancer(createStore)(reducer, preloadedState);
        }
        if (typeof reducer !== "function") {
          throw new Error("Expected the reducer to be a function.");
        }
        var currentReducer = reducer;
        var currentState = preloadedState;
        var currentListeners = [];
        var nextListeners = currentListeners;
        var isDispatching = false;
        function ensureCanMutateNextListeners() {
          if (nextListeners === currentListeners) {
            nextListeners = currentListeners.slice();
          }
        }
        function getState() {
          return currentState;
        }
        function subscribe(listener) {
          if (typeof listener !== "function") {
            throw new Error("Expected listener to be a function.");
          }
          var isSubscribed = true;
          ensureCanMutateNextListeners();
          nextListeners.push(listener);
          return function unsubscribe() {
            if (!isSubscribed) {
              return;
            }
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
          };
        }
        function dispatch(action) {
          if (!(0, _isPlainObject2["default"])(action)) {
            throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
          }
          if (typeof action.type === "undefined") {
            throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
          }
          if (isDispatching) {
            throw new Error("Reducers may not dispatch actions.");
          }
          try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
          } finally {
            isDispatching = false;
          }
          var listeners = currentListeners = nextListeners;
          for (var i = 0; i < listeners.length; i++) {
            listeners[i]();
          }
          return action;
        }
        function replaceReducer(nextReducer) {
          if (typeof nextReducer !== "function") {
            throw new Error("Expected the nextReducer to be a function.");
          }
          currentReducer = nextReducer;
          dispatch({ type: ActionTypes.INIT });
        }
        function observable() {
          var _ref;
          var outerSubscribe = subscribe;
          return _ref = {
            /**
             * The minimal observable subscription method.
             * @param {Object} observer Any object that can be used as an observer.
             * The observer object should have a `next` method.
             * @returns {subscription} An object with an `unsubscribe` method that can
             * be used to unsubscribe the observable from the store, and prevent further
             * emission of values from the observable.
             */
            subscribe: function subscribe2(observer) {
              if (typeof observer !== "object") {
                throw new TypeError("Expected the observer to be an object.");
              }
              function observeState() {
                if (observer.next) {
                  observer.next(getState());
                }
              }
              observeState();
              var unsubscribe = outerSubscribe(observeState);
              return { unsubscribe };
            }
          }, _ref[_symbolObservable2["default"]] = function() {
            return this;
          }, _ref;
        }
        dispatch({ type: ActionTypes.INIT });
        return _ref2 = {
          dispatch,
          subscribe,
          getState,
          replaceReducer
        }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
      }
    }
  });

  // node_modules/redux/lib/utils/warning.js
  var require_warning = __commonJS({
    "node_modules/redux/lib/utils/warning.js"(exports) {
      "use strict";
      exports.__esModule = true;
      exports["default"] = warning;
      function warning(message) {
        if (typeof console !== "undefined" && typeof console.error === "function") {
          console.error(message);
        }
        try {
          throw new Error(message);
        } catch (e) {
        }
      }
    }
  });

  // node_modules/redux/lib/combineReducers.js
  var require_combineReducers = __commonJS({
    "node_modules/redux/lib/combineReducers.js"(exports) {
      "use strict";
      exports.__esModule = true;
      exports["default"] = combineReducers;
      var _createStore = require_createStore();
      var _isPlainObject = require_isPlainObject();
      var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
      var _warning = require_warning();
      var _warning2 = _interopRequireDefault(_warning);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { "default": obj };
      }
      function getUndefinedStateErrorMessage(key, action) {
        var actionType = action && action.type;
        var actionName = actionType && '"' + actionType.toString() + '"' || "an action";
        return "Given action " + actionName + ', reducer "' + key + '" returned undefined. To ignore an action, you must explicitly return the previous state.';
      }
      function assertReducerSanity(reducers) {
        Object.keys(reducers).forEach(function(key) {
          var reducer = reducers[key];
          var initialState = reducer(void 0, { type: _createStore.ActionTypes.INIT });
          if (typeof initialState === "undefined") {
            throw new Error('Reducer "' + key + '" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined.');
          }
          var type = "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".");
          if (typeof reducer(void 0, { type }) === "undefined") {
            throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined.");
          }
        });
      }
      function combineReducers(reducers) {
        var reducerKeys = Object.keys(reducers);
        var finalReducers = {};
        for (var i = 0; i < reducerKeys.length; i++) {
          var key = reducerKeys[i];
          if (false) {
            if (typeof reducers[key] === "undefined") {
              (0, _warning2["default"])('No reducer provided for key "' + key + '"');
            }
          }
          if (typeof reducers[key] === "function") {
            finalReducers[key] = reducers[key];
          }
        }
        var finalReducerKeys = Object.keys(finalReducers);
        if (false) {
          var unexpectedKeyCache = {};
        }
        var sanityError;
        try {
          assertReducerSanity(finalReducers);
        } catch (e) {
          sanityError = e;
        }
        return function combination() {
          var state = arguments.length <= 0 || arguments[0] === void 0 ? {} : arguments[0];
          var action = arguments[1];
          if (sanityError) {
            throw sanityError;
          }
          if (false) {
            var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
            if (warningMessage) {
              (0, _warning2["default"])(warningMessage);
            }
          }
          var hasChanged = false;
          var nextState = {};
          for (var i2 = 0; i2 < finalReducerKeys.length; i2++) {
            var key2 = finalReducerKeys[i2];
            var reducer = finalReducers[key2];
            var previousStateForKey = state[key2];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
              var errorMessage = getUndefinedStateErrorMessage(key2, action);
              throw new Error(errorMessage);
            }
            nextState[key2] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
          }
          return hasChanged ? nextState : state;
        };
      }
    }
  });

  // node_modules/redux/lib/bindActionCreators.js
  var require_bindActionCreators = __commonJS({
    "node_modules/redux/lib/bindActionCreators.js"(exports) {
      "use strict";
      exports.__esModule = true;
      exports["default"] = bindActionCreators;
      function bindActionCreator(actionCreator, dispatch) {
        return function() {
          return dispatch(actionCreator.apply(void 0, arguments));
        };
      }
      function bindActionCreators(actionCreators, dispatch) {
        if (typeof actionCreators === "function") {
          return bindActionCreator(actionCreators, dispatch);
        }
        if (typeof actionCreators !== "object" || actionCreators === null) {
          throw new Error("bindActionCreators expected an object or a function, instead received " + (actionCreators === null ? "null" : typeof actionCreators) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
        }
        var keys = Object.keys(actionCreators);
        var boundActionCreators = {};
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          var actionCreator = actionCreators[key];
          if (typeof actionCreator === "function") {
            boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
          }
        }
        return boundActionCreators;
      }
    }
  });

  // node_modules/redux/lib/compose.js
  var require_compose = __commonJS({
    "node_modules/redux/lib/compose.js"(exports) {
      "use strict";
      exports.__esModule = true;
      exports["default"] = compose2;
      function compose2() {
        for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
          funcs[_key] = arguments[_key];
        }
        if (funcs.length === 0) {
          return function(arg) {
            return arg;
          };
        }
        if (funcs.length === 1) {
          return funcs[0];
        }
        var last3 = funcs[funcs.length - 1];
        var rest = funcs.slice(0, -1);
        return function() {
          return rest.reduceRight(function(composed, f) {
            return f(composed);
          }, last3.apply(void 0, arguments));
        };
      }
    }
  });

  // node_modules/redux/lib/applyMiddleware.js
  var require_applyMiddleware = __commonJS({
    "node_modules/redux/lib/applyMiddleware.js"(exports) {
      "use strict";
      exports.__esModule = true;
      var _extends = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      exports["default"] = applyMiddleware;
      var _compose = require_compose();
      var _compose2 = _interopRequireDefault(_compose);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { "default": obj };
      }
      function applyMiddleware() {
        for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
          middlewares[_key] = arguments[_key];
        }
        return function(createStore) {
          return function(reducer, preloadedState, enhancer) {
            var store = createStore(reducer, preloadedState, enhancer);
            var _dispatch = store.dispatch;
            var chain = [];
            var middlewareAPI = {
              getState: store.getState,
              dispatch: function dispatch(action) {
                return _dispatch(action);
              }
            };
            chain = middlewares.map(function(middleware) {
              return middleware(middlewareAPI);
            });
            _dispatch = _compose2["default"].apply(void 0, chain)(store.dispatch);
            return _extends({}, store, {
              dispatch: _dispatch
            });
          };
        };
      }
    }
  });

  // node_modules/redux/lib/index.js
  var require_lib2 = __commonJS({
    "node_modules/redux/lib/index.js"(exports) {
      "use strict";
      exports.__esModule = true;
      exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = void 0;
      var _createStore = require_createStore();
      var _createStore2 = _interopRequireDefault(_createStore);
      var _combineReducers = require_combineReducers();
      var _combineReducers2 = _interopRequireDefault(_combineReducers);
      var _bindActionCreators = require_bindActionCreators();
      var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
      var _applyMiddleware = require_applyMiddleware();
      var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
      var _compose = require_compose();
      var _compose2 = _interopRequireDefault(_compose);
      var _warning = require_warning();
      var _warning2 = _interopRequireDefault(_warning);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { "default": obj };
      }
      if (false) {
        (0, _warning2["default"])("You are currently using minified code outside of NODE_ENV === 'production'. This means that you are running a slower development build of Redux. You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) to ensure you have the correct code for your production build.");
      }
      exports.createStore = _createStore2["default"];
      exports.combineReducers = _combineReducers2["default"];
      exports.bindActionCreators = _bindActionCreators2["default"];
      exports.applyMiddleware = _applyMiddleware2["default"];
      exports.compose = _compose2["default"];
    }
  });

  // packages/systems/ix2/shared/constants/trigger-events.js
  var require_trigger_events = __commonJS({
    "packages/systems/ix2/shared/constants/trigger-events.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.QuickEffectIds = exports.QuickEffectDirectionConsts = exports.EventTypeConsts = exports.EventLimitAffectedElements = exports.EventContinuousMouseAxes = exports.EventBasedOn = exports.EventAppliesTo = void 0;
      var EventTypeConsts = {
        NAVBAR_OPEN: "NAVBAR_OPEN",
        NAVBAR_CLOSE: "NAVBAR_CLOSE",
        TAB_ACTIVE: "TAB_ACTIVE",
        TAB_INACTIVE: "TAB_INACTIVE",
        SLIDER_ACTIVE: "SLIDER_ACTIVE",
        SLIDER_INACTIVE: "SLIDER_INACTIVE",
        DROPDOWN_OPEN: "DROPDOWN_OPEN",
        DROPDOWN_CLOSE: "DROPDOWN_CLOSE",
        MOUSE_CLICK: "MOUSE_CLICK",
        MOUSE_SECOND_CLICK: "MOUSE_SECOND_CLICK",
        MOUSE_DOWN: "MOUSE_DOWN",
        MOUSE_UP: "MOUSE_UP",
        MOUSE_OVER: "MOUSE_OVER",
        MOUSE_OUT: "MOUSE_OUT",
        MOUSE_MOVE: "MOUSE_MOVE",
        MOUSE_MOVE_IN_VIEWPORT: "MOUSE_MOVE_IN_VIEWPORT",
        SCROLL_INTO_VIEW: "SCROLL_INTO_VIEW",
        SCROLL_OUT_OF_VIEW: "SCROLL_OUT_OF_VIEW",
        SCROLLING_IN_VIEW: "SCROLLING_IN_VIEW",
        ECOMMERCE_CART_OPEN: "ECOMMERCE_CART_OPEN",
        ECOMMERCE_CART_CLOSE: "ECOMMERCE_CART_CLOSE",
        PAGE_START: "PAGE_START",
        PAGE_FINISH: "PAGE_FINISH",
        PAGE_SCROLL_UP: "PAGE_SCROLL_UP",
        PAGE_SCROLL_DOWN: "PAGE_SCROLL_DOWN",
        PAGE_SCROLL: "PAGE_SCROLL"
      };
      exports.EventTypeConsts = EventTypeConsts;
      var EventAppliesTo = {
        ELEMENT: "ELEMENT",
        CLASS: "CLASS",
        PAGE: "PAGE"
      };
      exports.EventAppliesTo = EventAppliesTo;
      var EventBasedOn = {
        ELEMENT: "ELEMENT",
        VIEWPORT: "VIEWPORT"
      };
      exports.EventBasedOn = EventBasedOn;
      var EventContinuousMouseAxes = {
        X_AXIS: "X_AXIS",
        Y_AXIS: "Y_AXIS"
      };
      exports.EventContinuousMouseAxes = EventContinuousMouseAxes;
      var EventLimitAffectedElements = {
        CHILDREN: "CHILDREN",
        SIBLINGS: "SIBLINGS",
        IMMEDIATE_CHILDREN: "IMMEDIATE_CHILDREN"
      };
      exports.EventLimitAffectedElements = EventLimitAffectedElements;
      var QuickEffectIds = {
        FADE_EFFECT: "FADE_EFFECT",
        SLIDE_EFFECT: "SLIDE_EFFECT",
        GROW_EFFECT: "GROW_EFFECT",
        SHRINK_EFFECT: "SHRINK_EFFECT",
        SPIN_EFFECT: "SPIN_EFFECT",
        FLY_EFFECT: "FLY_EFFECT",
        POP_EFFECT: "POP_EFFECT",
        FLIP_EFFECT: "FLIP_EFFECT",
        JIGGLE_EFFECT: "JIGGLE_EFFECT",
        PULSE_EFFECT: "PULSE_EFFECT",
        DROP_EFFECT: "DROP_EFFECT",
        BLINK_EFFECT: "BLINK_EFFECT",
        BOUNCE_EFFECT: "BOUNCE_EFFECT",
        FLIP_LEFT_TO_RIGHT_EFFECT: "FLIP_LEFT_TO_RIGHT_EFFECT",
        FLIP_RIGHT_TO_LEFT_EFFECT: "FLIP_RIGHT_TO_LEFT_EFFECT",
        RUBBER_BAND_EFFECT: "RUBBER_BAND_EFFECT",
        JELLO_EFFECT: "JELLO_EFFECT",
        GROW_BIG_EFFECT: "GROW_BIG_EFFECT",
        SHRINK_BIG_EFFECT: "SHRINK_BIG_EFFECT",
        PLUGIN_LOTTIE_EFFECT: "PLUGIN_LOTTIE_EFFECT"
      };
      exports.QuickEffectIds = QuickEffectIds;
      var QuickEffectDirectionConsts = {
        LEFT: "LEFT",
        RIGHT: "RIGHT",
        BOTTOM: "BOTTOM",
        TOP: "TOP",
        BOTTOM_LEFT: "BOTTOM_LEFT",
        BOTTOM_RIGHT: "BOTTOM_RIGHT",
        TOP_RIGHT: "TOP_RIGHT",
        TOP_LEFT: "TOP_LEFT",
        CLOCKWISE: "CLOCKWISE",
        COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE"
      };
      exports.QuickEffectDirectionConsts = QuickEffectDirectionConsts;
    }
  });

  // packages/systems/ix2/shared/constants/animation-actions.js
  var require_animation_actions = __commonJS({
    "packages/systems/ix2/shared/constants/animation-actions.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ActionTypeConsts = exports.ActionAppliesTo = void 0;
      var ActionTypeConsts = {
        TRANSFORM_MOVE: "TRANSFORM_MOVE",
        TRANSFORM_SCALE: "TRANSFORM_SCALE",
        TRANSFORM_ROTATE: "TRANSFORM_ROTATE",
        TRANSFORM_SKEW: "TRANSFORM_SKEW",
        STYLE_OPACITY: "STYLE_OPACITY",
        STYLE_SIZE: "STYLE_SIZE",
        STYLE_FILTER: "STYLE_FILTER",
        STYLE_FONT_VARIATION: "STYLE_FONT_VARIATION",
        STYLE_BACKGROUND_COLOR: "STYLE_BACKGROUND_COLOR",
        STYLE_BORDER: "STYLE_BORDER",
        STYLE_TEXT_COLOR: "STYLE_TEXT_COLOR",
        OBJECT_VALUE: "OBJECT_VALUE",
        PLUGIN_LOTTIE: "PLUGIN_LOTTIE",
        PLUGIN_SPLINE: "PLUGIN_SPLINE",
        PLUGIN_VARIABLE: "PLUGIN_VARIABLE",
        GENERAL_DISPLAY: "GENERAL_DISPLAY",
        GENERAL_START_ACTION: "GENERAL_START_ACTION",
        GENERAL_CONTINUOUS_ACTION: "GENERAL_CONTINUOUS_ACTION",
        // TODO: Clean these up below because they're not used at this time
        GENERAL_COMBO_CLASS: "GENERAL_COMBO_CLASS",
        GENERAL_STOP_ACTION: "GENERAL_STOP_ACTION",
        GENERAL_LOOP: "GENERAL_LOOP",
        STYLE_BOX_SHADOW: "STYLE_BOX_SHADOW"
      };
      exports.ActionTypeConsts = ActionTypeConsts;
      var ActionAppliesTo = {
        ELEMENT: "ELEMENT",
        ELEMENT_CLASS: "ELEMENT_CLASS",
        TRIGGER_ELEMENT: "TRIGGER_ELEMENT"
      };
      exports.ActionAppliesTo = ActionAppliesTo;
    }
  });

  // packages/systems/ix2/shared/constants/trigger-interactions.js
  var require_trigger_interactions = __commonJS({
    "packages/systems/ix2/shared/constants/trigger-interactions.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.InteractionTypeConsts = void 0;
      var InteractionTypeConsts = {
        MOUSE_CLICK_INTERACTION: "MOUSE_CLICK_INTERACTION",
        MOUSE_HOVER_INTERACTION: "MOUSE_HOVER_INTERACTION",
        MOUSE_MOVE_INTERACTION: "MOUSE_MOVE_INTERACTION",
        SCROLL_INTO_VIEW_INTERACTION: "SCROLL_INTO_VIEW_INTERACTION",
        SCROLLING_IN_VIEW_INTERACTION: "SCROLLING_IN_VIEW_INTERACTION",
        MOUSE_MOVE_IN_VIEWPORT_INTERACTION: "MOUSE_MOVE_IN_VIEWPORT_INTERACTION",
        PAGE_IS_SCROLLING_INTERACTION: "PAGE_IS_SCROLLING_INTERACTION",
        PAGE_LOAD_INTERACTION: "PAGE_LOAD_INTERACTION",
        PAGE_SCROLLED_INTERACTION: "PAGE_SCROLLED_INTERACTION",
        NAVBAR_INTERACTION: "NAVBAR_INTERACTION",
        DROPDOWN_INTERACTION: "DROPDOWN_INTERACTION",
        ECOMMERCE_CART_INTERACTION: "ECOMMERCE_CART_INTERACTION",
        TAB_INTERACTION: "TAB_INTERACTION",
        SLIDER_INTERACTION: "SLIDER_INTERACTION"
      };
      exports.InteractionTypeConsts = InteractionTypeConsts;
    }
  });

  // packages/systems/ix2/shared/constants/reduced-motion.js
  var require_reduced_motion = __commonJS({
    "packages/systems/ix2/shared/constants/reduced-motion.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ReducedMotionTypes = void 0;
      var _animationActions = require_animation_actions();
      var {
        TRANSFORM_MOVE,
        TRANSFORM_SCALE,
        TRANSFORM_ROTATE,
        TRANSFORM_SKEW,
        STYLE_SIZE,
        STYLE_FILTER,
        STYLE_FONT_VARIATION
      } = _animationActions.ActionTypeConsts;
      var ReducedMotionTypes = {
        [TRANSFORM_MOVE]: true,
        [TRANSFORM_SCALE]: true,
        [TRANSFORM_ROTATE]: true,
        [TRANSFORM_SKEW]: true,
        [STYLE_SIZE]: true,
        [STYLE_FILTER]: true,
        [STYLE_FONT_VARIATION]: true
      };
      exports.ReducedMotionTypes = ReducedMotionTypes;
    }
  });

  // packages/systems/ix2/shared/constants/IX2EngineActionTypes.js
  var require_IX2EngineActionTypes = __commonJS({
    "packages/systems/ix2/shared/constants/IX2EngineActionTypes.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.IX2_VIEWPORT_WIDTH_CHANGED = exports.IX2_TEST_FRAME_RENDERED = exports.IX2_STOP_REQUESTED = exports.IX2_SESSION_STOPPED = exports.IX2_SESSION_STARTED = exports.IX2_SESSION_INITIALIZED = exports.IX2_RAW_DATA_IMPORTED = exports.IX2_PREVIEW_REQUESTED = exports.IX2_PLAYBACK_REQUESTED = exports.IX2_PARAMETER_CHANGED = exports.IX2_MEDIA_QUERIES_DEFINED = exports.IX2_INSTANCE_STARTED = exports.IX2_INSTANCE_REMOVED = exports.IX2_INSTANCE_ADDED = exports.IX2_EVENT_STATE_CHANGED = exports.IX2_EVENT_LISTENER_ADDED = exports.IX2_ELEMENT_STATE_CHANGED = exports.IX2_CLEAR_REQUESTED = exports.IX2_ANIMATION_FRAME_CHANGED = exports.IX2_ACTION_LIST_PLAYBACK_CHANGED = void 0;
      var IX2_RAW_DATA_IMPORTED = "IX2_RAW_DATA_IMPORTED";
      exports.IX2_RAW_DATA_IMPORTED = IX2_RAW_DATA_IMPORTED;
      var IX2_SESSION_INITIALIZED = "IX2_SESSION_INITIALIZED";
      exports.IX2_SESSION_INITIALIZED = IX2_SESSION_INITIALIZED;
      var IX2_SESSION_STARTED = "IX2_SESSION_STARTED";
      exports.IX2_SESSION_STARTED = IX2_SESSION_STARTED;
      var IX2_SESSION_STOPPED = "IX2_SESSION_STOPPED";
      exports.IX2_SESSION_STOPPED = IX2_SESSION_STOPPED;
      var IX2_PREVIEW_REQUESTED = "IX2_PREVIEW_REQUESTED";
      exports.IX2_PREVIEW_REQUESTED = IX2_PREVIEW_REQUESTED;
      var IX2_PLAYBACK_REQUESTED = "IX2_PLAYBACK_REQUESTED";
      exports.IX2_PLAYBACK_REQUESTED = IX2_PLAYBACK_REQUESTED;
      var IX2_STOP_REQUESTED = "IX2_STOP_REQUESTED";
      exports.IX2_STOP_REQUESTED = IX2_STOP_REQUESTED;
      var IX2_CLEAR_REQUESTED = "IX2_CLEAR_REQUESTED";
      exports.IX2_CLEAR_REQUESTED = IX2_CLEAR_REQUESTED;
      var IX2_EVENT_LISTENER_ADDED = "IX2_EVENT_LISTENER_ADDED";
      exports.IX2_EVENT_LISTENER_ADDED = IX2_EVENT_LISTENER_ADDED;
      var IX2_EVENT_STATE_CHANGED = "IX2_EVENT_STATE_CHANGED";
      exports.IX2_EVENT_STATE_CHANGED = IX2_EVENT_STATE_CHANGED;
      var IX2_ANIMATION_FRAME_CHANGED = "IX2_ANIMATION_FRAME_CHANGED";
      exports.IX2_ANIMATION_FRAME_CHANGED = IX2_ANIMATION_FRAME_CHANGED;
      var IX2_PARAMETER_CHANGED = "IX2_PARAMETER_CHANGED";
      exports.IX2_PARAMETER_CHANGED = IX2_PARAMETER_CHANGED;
      var IX2_INSTANCE_ADDED = "IX2_INSTANCE_ADDED";
      exports.IX2_INSTANCE_ADDED = IX2_INSTANCE_ADDED;
      var IX2_INSTANCE_STARTED = "IX2_INSTANCE_STARTED";
      exports.IX2_INSTANCE_STARTED = IX2_INSTANCE_STARTED;
      var IX2_INSTANCE_REMOVED = "IX2_INSTANCE_REMOVED";
      exports.IX2_INSTANCE_REMOVED = IX2_INSTANCE_REMOVED;
      var IX2_ELEMENT_STATE_CHANGED = "IX2_ELEMENT_STATE_CHANGED";
      exports.IX2_ELEMENT_STATE_CHANGED = IX2_ELEMENT_STATE_CHANGED;
      var IX2_ACTION_LIST_PLAYBACK_CHANGED = "IX2_ACTION_LIST_PLAYBACK_CHANGED";
      exports.IX2_ACTION_LIST_PLAYBACK_CHANGED = IX2_ACTION_LIST_PLAYBACK_CHANGED;
      var IX2_VIEWPORT_WIDTH_CHANGED = "IX2_VIEWPORT_WIDTH_CHANGED";
      exports.IX2_VIEWPORT_WIDTH_CHANGED = IX2_VIEWPORT_WIDTH_CHANGED;
      var IX2_MEDIA_QUERIES_DEFINED = "IX2_MEDIA_QUERIES_DEFINED";
      exports.IX2_MEDIA_QUERIES_DEFINED = IX2_MEDIA_QUERIES_DEFINED;
      var IX2_TEST_FRAME_RENDERED = "IX2_TEST_FRAME_RENDERED";
      exports.IX2_TEST_FRAME_RENDERED = IX2_TEST_FRAME_RENDERED;
    }
  });

  // packages/systems/ix2/shared/constants/IX2EngineConstants.js
  var require_IX2EngineConstants = __commonJS({
    "packages/systems/ix2/shared/constants/IX2EngineConstants.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.W_MOD_JS = exports.W_MOD_IX = exports.WILL_CHANGE = exports.WIDTH = exports.WF_PAGE = exports.TRANSLATE_Z = exports.TRANSLATE_Y = exports.TRANSLATE_X = exports.TRANSLATE_3D = exports.TRANSFORM = exports.SKEW_Y = exports.SKEW_X = exports.SKEW = exports.SIBLINGS = exports.SCALE_Z = exports.SCALE_Y = exports.SCALE_X = exports.SCALE_3D = exports.ROTATE_Z = exports.ROTATE_Y = exports.ROTATE_X = exports.RENDER_TRANSFORM = exports.RENDER_STYLE = exports.RENDER_PLUGIN = exports.RENDER_GENERAL = exports.PRESERVE_3D = exports.PLAIN_OBJECT = exports.PARENT = exports.OPACITY = exports.IX2_ID_DELIMITER = exports.IMMEDIATE_CHILDREN = exports.HTML_ELEMENT = exports.HEIGHT = exports.FONT_VARIATION_SETTINGS = exports.FLEX = exports.FILTER = exports.DISPLAY = exports.CONFIG_Z_VALUE = exports.CONFIG_Z_UNIT = exports.CONFIG_Y_VALUE = exports.CONFIG_Y_UNIT = exports.CONFIG_X_VALUE = exports.CONFIG_X_UNIT = exports.CONFIG_VALUE = exports.CONFIG_UNIT = exports.COMMA_DELIMITER = exports.COLOR = exports.COLON_DELIMITER = exports.CHILDREN = exports.BOUNDARY_SELECTOR = exports.BORDER_COLOR = exports.BAR_DELIMITER = exports.BACKGROUND_COLOR = exports.BACKGROUND = exports.AUTO = exports.ABSTRACT_NODE = void 0;
      var IX2_ID_DELIMITER = "|";
      exports.IX2_ID_DELIMITER = IX2_ID_DELIMITER;
      var WF_PAGE = "data-wf-page";
      exports.WF_PAGE = WF_PAGE;
      var W_MOD_JS = "w-mod-js";
      exports.W_MOD_JS = W_MOD_JS;
      var W_MOD_IX = "w-mod-ix";
      exports.W_MOD_IX = W_MOD_IX;
      var BOUNDARY_SELECTOR = ".w-dyn-item";
      exports.BOUNDARY_SELECTOR = BOUNDARY_SELECTOR;
      var CONFIG_X_VALUE = "xValue";
      exports.CONFIG_X_VALUE = CONFIG_X_VALUE;
      var CONFIG_Y_VALUE = "yValue";
      exports.CONFIG_Y_VALUE = CONFIG_Y_VALUE;
      var CONFIG_Z_VALUE = "zValue";
      exports.CONFIG_Z_VALUE = CONFIG_Z_VALUE;
      var CONFIG_VALUE = "value";
      exports.CONFIG_VALUE = CONFIG_VALUE;
      var CONFIG_X_UNIT = "xUnit";
      exports.CONFIG_X_UNIT = CONFIG_X_UNIT;
      var CONFIG_Y_UNIT = "yUnit";
      exports.CONFIG_Y_UNIT = CONFIG_Y_UNIT;
      var CONFIG_Z_UNIT = "zUnit";
      exports.CONFIG_Z_UNIT = CONFIG_Z_UNIT;
      var CONFIG_UNIT = "unit";
      exports.CONFIG_UNIT = CONFIG_UNIT;
      var TRANSFORM = "transform";
      exports.TRANSFORM = TRANSFORM;
      var TRANSLATE_X = "translateX";
      exports.TRANSLATE_X = TRANSLATE_X;
      var TRANSLATE_Y = "translateY";
      exports.TRANSLATE_Y = TRANSLATE_Y;
      var TRANSLATE_Z = "translateZ";
      exports.TRANSLATE_Z = TRANSLATE_Z;
      var TRANSLATE_3D = "translate3d";
      exports.TRANSLATE_3D = TRANSLATE_3D;
      var SCALE_X = "scaleX";
      exports.SCALE_X = SCALE_X;
      var SCALE_Y = "scaleY";
      exports.SCALE_Y = SCALE_Y;
      var SCALE_Z = "scaleZ";
      exports.SCALE_Z = SCALE_Z;
      var SCALE_3D = "scale3d";
      exports.SCALE_3D = SCALE_3D;
      var ROTATE_X = "rotateX";
      exports.ROTATE_X = ROTATE_X;
      var ROTATE_Y = "rotateY";
      exports.ROTATE_Y = ROTATE_Y;
      var ROTATE_Z = "rotateZ";
      exports.ROTATE_Z = ROTATE_Z;
      var SKEW = "skew";
      exports.SKEW = SKEW;
      var SKEW_X = "skewX";
      exports.SKEW_X = SKEW_X;
      var SKEW_Y = "skewY";
      exports.SKEW_Y = SKEW_Y;
      var OPACITY = "opacity";
      exports.OPACITY = OPACITY;
      var FILTER = "filter";
      exports.FILTER = FILTER;
      var FONT_VARIATION_SETTINGS = "font-variation-settings";
      exports.FONT_VARIATION_SETTINGS = FONT_VARIATION_SETTINGS;
      var WIDTH = "width";
      exports.WIDTH = WIDTH;
      var HEIGHT = "height";
      exports.HEIGHT = HEIGHT;
      var BACKGROUND_COLOR = "backgroundColor";
      exports.BACKGROUND_COLOR = BACKGROUND_COLOR;
      var BACKGROUND = "background";
      exports.BACKGROUND = BACKGROUND;
      var BORDER_COLOR = "borderColor";
      exports.BORDER_COLOR = BORDER_COLOR;
      var COLOR = "color";
      exports.COLOR = COLOR;
      var DISPLAY = "display";
      exports.DISPLAY = DISPLAY;
      var FLEX = "flex";
      exports.FLEX = FLEX;
      var WILL_CHANGE = "willChange";
      exports.WILL_CHANGE = WILL_CHANGE;
      var AUTO = "AUTO";
      exports.AUTO = AUTO;
      var COMMA_DELIMITER = ",";
      exports.COMMA_DELIMITER = COMMA_DELIMITER;
      var COLON_DELIMITER = ":";
      exports.COLON_DELIMITER = COLON_DELIMITER;
      var BAR_DELIMITER = "|";
      exports.BAR_DELIMITER = BAR_DELIMITER;
      var CHILDREN = "CHILDREN";
      exports.CHILDREN = CHILDREN;
      var IMMEDIATE_CHILDREN = "IMMEDIATE_CHILDREN";
      exports.IMMEDIATE_CHILDREN = IMMEDIATE_CHILDREN;
      var SIBLINGS = "SIBLINGS";
      exports.SIBLINGS = SIBLINGS;
      var PARENT = "PARENT";
      exports.PARENT = PARENT;
      var PRESERVE_3D = "preserve-3d";
      exports.PRESERVE_3D = PRESERVE_3D;
      var HTML_ELEMENT = "HTML_ELEMENT";
      exports.HTML_ELEMENT = HTML_ELEMENT;
      var PLAIN_OBJECT = "PLAIN_OBJECT";
      exports.PLAIN_OBJECT = PLAIN_OBJECT;
      var ABSTRACT_NODE = "ABSTRACT_NODE";
      exports.ABSTRACT_NODE = ABSTRACT_NODE;
      var RENDER_TRANSFORM = "RENDER_TRANSFORM";
      exports.RENDER_TRANSFORM = RENDER_TRANSFORM;
      var RENDER_GENERAL = "RENDER_GENERAL";
      exports.RENDER_GENERAL = RENDER_GENERAL;
      var RENDER_STYLE = "RENDER_STYLE";
      exports.RENDER_STYLE = RENDER_STYLE;
      var RENDER_PLUGIN = "RENDER_PLUGIN";
      exports.RENDER_PLUGIN = RENDER_PLUGIN;
    }
  });

  // packages/systems/ix2/shared/constants/index.js
  var require_constants = __commonJS({
    "packages/systems/ix2/shared/constants/index.js"(exports) {
      "use strict";
      var _interopRequireWildcard = require_interopRequireWildcard().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _exportNames = {
        IX2EngineActionTypes: true,
        IX2EngineConstants: true
      };
      exports.IX2EngineConstants = exports.IX2EngineActionTypes = void 0;
      var _triggerEvents = require_trigger_events();
      Object.keys(_triggerEvents).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _triggerEvents[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _triggerEvents[key];
          }
        });
      });
      var _animationActions = require_animation_actions();
      Object.keys(_animationActions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _animationActions[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _animationActions[key];
          }
        });
      });
      var _triggerInteractions = require_trigger_interactions();
      Object.keys(_triggerInteractions).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _triggerInteractions[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _triggerInteractions[key];
          }
        });
      });
      var _reducedMotion = require_reduced_motion();
      Object.keys(_reducedMotion).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _reducedMotion[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _reducedMotion[key];
          }
        });
      });
      var IX2EngineActionTypes = _interopRequireWildcard(require_IX2EngineActionTypes());
      exports.IX2EngineActionTypes = IX2EngineActionTypes;
      var IX2EngineConstants = _interopRequireWildcard(require_IX2EngineConstants());
      exports.IX2EngineConstants = IX2EngineConstants;
    }
  });

  // packages/systems/ix2/engine/reducers/IX2DataReducer.js
  var require_IX2DataReducer = __commonJS({
    "packages/systems/ix2/engine/reducers/IX2DataReducer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ixData = void 0;
      var _constants = require_constants();
      var {
        IX2_RAW_DATA_IMPORTED
      } = _constants.IX2EngineActionTypes;
      var ixData = (state = Object.freeze({}), action) => {
        switch (action.type) {
          case IX2_RAW_DATA_IMPORTED: {
            return action.payload.ixData || Object.freeze({});
          }
          default: {
            return state;
          }
        }
      };
      exports.ixData = ixData;
    }
  });

  // node_modules/@babel/runtime/helpers/extends.js
  var require_extends = __commonJS({
    "node_modules/@babel/runtime/helpers/extends.js"(exports, module) {
      function _extends() {
        module.exports = _extends = Object.assign ? Object.assign.bind() : function(target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];
            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }
          return target;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports;
        return _extends.apply(this, arguments);
      }
      module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
  });

  // node_modules/timm/lib/timm.js
  var require_timm = __commonJS({
    "node_modules/timm/lib/timm.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
        return typeof obj;
      } : function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
      exports.clone = clone;
      exports.addLast = addLast;
      exports.addFirst = addFirst;
      exports.removeLast = removeLast;
      exports.removeFirst = removeFirst;
      exports.insert = insert;
      exports.removeAt = removeAt;
      exports.replaceAt = replaceAt;
      exports.getIn = getIn;
      exports.set = set2;
      exports.setIn = setIn;
      exports.update = update;
      exports.updateIn = updateIn;
      exports.merge = merge2;
      exports.mergeDeep = mergeDeep;
      exports.mergeIn = mergeIn;
      exports.omit = omit2;
      exports.addDefaults = addDefaults;
      var INVALID_ARGS = "INVALID_ARGS";
      function throwStr(msg) {
        throw new Error(msg);
      }
      function getKeysAndSymbols(obj) {
        var keys = Object.keys(obj);
        if (Object.getOwnPropertySymbols) {
          return keys.concat(Object.getOwnPropertySymbols(obj));
        }
        return keys;
      }
      var hasOwnProperty3 = {}.hasOwnProperty;
      function clone(obj) {
        if (Array.isArray(obj))
          return obj.slice();
        var keys = getKeysAndSymbols(obj);
        var out = {};
        for (var i = 0; i < keys.length; i++) {
          var key = keys[i];
          out[key] = obj[key];
        }
        return out;
      }
      function doMerge(fAddDefaults, fDeep, first2) {
        var out = first2;
        !(out != null) && throwStr(false ? "At least one object should be provided to merge()" : INVALID_ARGS);
        var fChanged = false;
        for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
          rest[_key - 3] = arguments[_key];
        }
        for (var idx = 0; idx < rest.length; idx++) {
          var obj = rest[idx];
          if (obj == null)
            continue;
          var keys = getKeysAndSymbols(obj);
          if (!keys.length)
            continue;
          for (var j = 0; j <= keys.length; j++) {
            var key = keys[j];
            if (fAddDefaults && out[key] !== void 0)
              continue;
            var nextVal = obj[key];
            if (fDeep && isObject2(out[key]) && isObject2(nextVal)) {
              nextVal = doMerge(fAddDefaults, fDeep, out[key], nextVal);
            }
            if (nextVal === void 0 || nextVal === out[key])
              continue;
            if (!fChanged) {
              fChanged = true;
              out = clone(out);
            }
            out[key] = nextVal;
          }
        }
        return out;
      }
      function isObject2(o) {
        var type = typeof o === "undefined" ? "undefined" : _typeof(o);
        return o != null && (type === "object" || type === "function");
      }
      function addLast(array, val) {
        if (Array.isArray(val))
          return array.concat(val);
        return array.concat([val]);
      }
      function addFirst(array, val) {
        if (Array.isArray(val))
          return val.concat(array);
        return [val].concat(array);
      }
      function removeLast(array) {
        if (!array.length)
          return array;
        return array.slice(0, array.length - 1);
      }
      function removeFirst(array) {
        if (!array.length)
          return array;
        return array.slice(1);
      }
      function insert(array, idx, val) {
        return array.slice(0, idx).concat(Array.isArray(val) ? val : [val]).concat(array.slice(idx));
      }
      function removeAt(array, idx) {
        if (idx >= array.length || idx < 0)
          return array;
        return array.slice(0, idx).concat(array.slice(idx + 1));
      }
      function replaceAt(array, idx, newItem) {
        if (array[idx] === newItem)
          return array;
        var len = array.length;
        var result = Array(len);
        for (var i = 0; i < len; i++) {
          result[i] = array[i];
        }
        result[idx] = newItem;
        return result;
      }
      function getIn(obj, path) {
        !Array.isArray(path) && throwStr(false ? "A path array should be provided when calling getIn()" : INVALID_ARGS);
        if (obj == null)
          return void 0;
        var ptr = obj;
        for (var i = 0; i < path.length; i++) {
          var key = path[i];
          ptr = ptr != null ? ptr[key] : void 0;
          if (ptr === void 0)
            return ptr;
        }
        return ptr;
      }
      function set2(obj, key, val) {
        var fallback = typeof key === "number" ? [] : {};
        var finalObj = obj == null ? fallback : obj;
        if (finalObj[key] === val)
          return finalObj;
        var obj2 = clone(finalObj);
        obj2[key] = val;
        return obj2;
      }
      function doSetIn(obj, path, val, idx) {
        var newValue = void 0;
        var key = path[idx];
        if (idx === path.length - 1) {
          newValue = val;
        } else {
          var nestedObj = isObject2(obj) && isObject2(obj[key]) ? obj[key] : typeof path[idx + 1] === "number" ? [] : {};
          newValue = doSetIn(nestedObj, path, val, idx + 1);
        }
        return set2(obj, key, newValue);
      }
      function setIn(obj, path, val) {
        if (!path.length)
          return val;
        return doSetIn(obj, path, val, 0);
      }
      function update(obj, key, fnUpdate) {
        var prevVal = obj == null ? void 0 : obj[key];
        var nextVal = fnUpdate(prevVal);
        return set2(obj, key, nextVal);
      }
      function updateIn(obj, path, fnUpdate) {
        var prevVal = getIn(obj, path);
        var nextVal = fnUpdate(prevVal);
        return setIn(obj, path, nextVal);
      }
      function merge2(a, b, c, d, e, f) {
        for (var _len2 = arguments.length, rest = Array(_len2 > 6 ? _len2 - 6 : 0), _key2 = 6; _key2 < _len2; _key2++) {
          rest[_key2 - 6] = arguments[_key2];
        }
        return rest.length ? doMerge.call.apply(doMerge, [null, false, false, a, b, c, d, e, f].concat(rest)) : doMerge(false, false, a, b, c, d, e, f);
      }
      function mergeDeep(a, b, c, d, e, f) {
        for (var _len3 = arguments.length, rest = Array(_len3 > 6 ? _len3 - 6 : 0), _key3 = 6; _key3 < _len3; _key3++) {
          rest[_key3 - 6] = arguments[_key3];
        }
        return rest.length ? doMerge.call.apply(doMerge, [null, false, true, a, b, c, d, e, f].concat(rest)) : doMerge(false, true, a, b, c, d, e, f);
      }
      function mergeIn(a, path, b, c, d, e, f) {
        var prevVal = getIn(a, path);
        if (prevVal == null)
          prevVal = {};
        var nextVal = void 0;
        for (var _len4 = arguments.length, rest = Array(_len4 > 7 ? _len4 - 7 : 0), _key4 = 7; _key4 < _len4; _key4++) {
          rest[_key4 - 7] = arguments[_key4];
        }
        if (rest.length) {
          nextVal = doMerge.call.apply(doMerge, [null, false, false, prevVal, b, c, d, e, f].concat(rest));
        } else {
          nextVal = doMerge(false, false, prevVal, b, c, d, e, f);
        }
        return setIn(a, path, nextVal);
      }
      function omit2(obj, attrs) {
        var omitList = Array.isArray(attrs) ? attrs : [attrs];
        var fDoSomething = false;
        for (var i = 0; i < omitList.length; i++) {
          if (hasOwnProperty3.call(obj, omitList[i])) {
            fDoSomething = true;
            break;
          }
        }
        if (!fDoSomething)
          return obj;
        var out = {};
        var keys = getKeysAndSymbols(obj);
        for (var _i = 0; _i < keys.length; _i++) {
          var key = keys[_i];
          if (omitList.indexOf(key) >= 0)
            continue;
          out[key] = obj[key];
        }
        return out;
      }
      function addDefaults(a, b, c, d, e, f) {
        for (var _len5 = arguments.length, rest = Array(_len5 > 6 ? _len5 - 6 : 0), _key5 = 6; _key5 < _len5; _key5++) {
          rest[_key5 - 6] = arguments[_key5];
        }
        return rest.length ? doMerge.call.apply(doMerge, [null, true, false, a, b, c, d, e, f].concat(rest)) : doMerge(true, false, a, b, c, d, e, f);
      }
      var timm = {
        clone,
        addLast,
        addFirst,
        removeLast,
        removeFirst,
        insert,
        removeAt,
        replaceAt,
        getIn,
        // eslint-disable-next-line object-shorthand
        set: set2,
        // so that flow doesn't complain
        setIn,
        update,
        updateIn,
        merge: merge2,
        mergeDeep,
        mergeIn,
        omit: omit2,
        addDefaults
      };
      exports.default = timm;
    }
  });

  // packages/systems/ix2/engine/reducers/IX2RequestReducer.js
  var require_IX2RequestReducer = __commonJS({
    "packages/systems/ix2/engine/reducers/IX2RequestReducer.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ixRequest = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _constants = require_constants();
      var _timm = require_timm();
      var {
        IX2_PREVIEW_REQUESTED,
        IX2_PLAYBACK_REQUESTED,
        IX2_STOP_REQUESTED,
        IX2_CLEAR_REQUESTED
      } = _constants.IX2EngineActionTypes;
      var initialState = {
        preview: {},
        playback: {},
        stop: {},
        clear: {}
      };
      var stateKeys = Object.create(null, {
        [IX2_PREVIEW_REQUESTED]: {
          value: "preview"
        },
        [IX2_PLAYBACK_REQUESTED]: {
          value: "playback"
        },
        [IX2_STOP_REQUESTED]: {
          value: "stop"
        },
        [IX2_CLEAR_REQUESTED]: {
          value: "clear"
        }
      });
      var ixRequest = (state = initialState, action) => {
        if (action.type in stateKeys) {
          const key = [stateKeys[action.type]];
          return (0, _timm.setIn)(state, [key], (0, _extends2.default)({}, action.payload));
        }
        return state;
      };
      exports.ixRequest = ixRequest;
    }
  });

  // packages/systems/ix2/engine/reducers/IX2SessionReducer.js
  var require_IX2SessionReducer = __commonJS({
    "packages/systems/ix2/engine/reducers/IX2SessionReducer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ixSession = void 0;
      var _constants = require_constants();
      var _timm = require_timm();
      var {
        IX2_SESSION_INITIALIZED,
        IX2_SESSION_STARTED,
        IX2_TEST_FRAME_RENDERED,
        IX2_SESSION_STOPPED,
        IX2_EVENT_LISTENER_ADDED,
        IX2_EVENT_STATE_CHANGED,
        IX2_ANIMATION_FRAME_CHANGED,
        IX2_ACTION_LIST_PLAYBACK_CHANGED,
        IX2_VIEWPORT_WIDTH_CHANGED,
        IX2_MEDIA_QUERIES_DEFINED
      } = _constants.IX2EngineActionTypes;
      var initialState = {
        active: false,
        tick: 0,
        eventListeners: [],
        eventState: {},
        playbackState: {},
        viewportWidth: 0,
        mediaQueryKey: null,
        hasBoundaryNodes: false,
        hasDefinedMediaQueries: false,
        reducedMotion: false
      };
      var TEST_FRAME_STEPS_SIZE = 20;
      var ixSession = (state = initialState, action) => {
        switch (action.type) {
          case IX2_SESSION_INITIALIZED: {
            const {
              hasBoundaryNodes,
              reducedMotion
            } = action.payload;
            return (0, _timm.merge)(state, {
              hasBoundaryNodes,
              reducedMotion
            });
          }
          case IX2_SESSION_STARTED: {
            return (0, _timm.set)(state, "active", true);
          }
          case IX2_TEST_FRAME_RENDERED: {
            const {
              payload: {
                step = TEST_FRAME_STEPS_SIZE
              }
            } = action;
            return (0, _timm.set)(state, "tick", state.tick + step);
          }
          case IX2_SESSION_STOPPED: {
            return initialState;
          }
          case IX2_ANIMATION_FRAME_CHANGED: {
            const {
              payload: {
                now
              }
            } = action;
            return (0, _timm.set)(state, "tick", now);
          }
          case IX2_EVENT_LISTENER_ADDED: {
            const eventListeners = (0, _timm.addLast)(state.eventListeners, action.payload);
            return (0, _timm.set)(state, "eventListeners", eventListeners);
          }
          case IX2_EVENT_STATE_CHANGED: {
            const {
              stateKey,
              newState
            } = action.payload;
            return (0, _timm.setIn)(state, ["eventState", stateKey], newState);
          }
          case IX2_ACTION_LIST_PLAYBACK_CHANGED: {
            const {
              actionListId,
              isPlaying
            } = action.payload;
            return (0, _timm.setIn)(state, ["playbackState", actionListId], isPlaying);
          }
          case IX2_VIEWPORT_WIDTH_CHANGED: {
            const {
              width,
              mediaQueries
            } = action.payload;
            const mediaQueryCount = mediaQueries.length;
            let mediaQueryKey = null;
            for (let i = 0; i < mediaQueryCount; i++) {
              const {
                key,
                min,
                max: max2
              } = mediaQueries[i];
              if (width >= min && width <= max2) {
                mediaQueryKey = key;
                break;
              }
            }
            return (0, _timm.merge)(state, {
              viewportWidth: width,
              mediaQueryKey
            });
          }
          case IX2_MEDIA_QUERIES_DEFINED: {
            return (0, _timm.set)(state, "hasDefinedMediaQueries", true);
          }
          default: {
            return state;
          }
        }
      };
      exports.ixSession = ixSession;
    }
  });

  // node_modules/lodash/_listCacheClear.js
  var require_listCacheClear = __commonJS({
    "node_modules/lodash/_listCacheClear.js"(exports, module) {
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      module.exports = listCacheClear;
    }
  });

  // node_modules/lodash/eq.js
  var require_eq = __commonJS({
    "node_modules/lodash/eq.js"(exports, module) {
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      module.exports = eq;
    }
  });

  // node_modules/lodash/_assocIndexOf.js
  var require_assocIndexOf = __commonJS({
    "node_modules/lodash/_assocIndexOf.js"(exports, module) {
      var eq = require_eq();
      function assocIndexOf(array, key) {
        var length2 = array.length;
        while (length2--) {
          if (eq(array[length2][0], key)) {
            return length2;
          }
        }
        return -1;
      }
      module.exports = assocIndexOf;
    }
  });

  // node_modules/lodash/_listCacheDelete.js
  var require_listCacheDelete = __commonJS({
    "node_modules/lodash/_listCacheDelete.js"(exports, module) {
      var assocIndexOf = require_assocIndexOf();
      var arrayProto = Array.prototype;
      var splice = arrayProto.splice;
      function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }
      module.exports = listCacheDelete;
    }
  });

  // node_modules/lodash/_listCacheGet.js
  var require_listCacheGet = __commonJS({
    "node_modules/lodash/_listCacheGet.js"(exports, module) {
      var assocIndexOf = require_assocIndexOf();
      function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? void 0 : data[index][1];
      }
      module.exports = listCacheGet;
    }
  });

  // node_modules/lodash/_listCacheHas.js
  var require_listCacheHas = __commonJS({
    "node_modules/lodash/_listCacheHas.js"(exports, module) {
      var assocIndexOf = require_assocIndexOf();
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      module.exports = listCacheHas;
    }
  });

  // node_modules/lodash/_listCacheSet.js
  var require_listCacheSet = __commonJS({
    "node_modules/lodash/_listCacheSet.js"(exports, module) {
      var assocIndexOf = require_assocIndexOf();
      function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }
      module.exports = listCacheSet;
    }
  });

  // node_modules/lodash/_ListCache.js
  var require_ListCache = __commonJS({
    "node_modules/lodash/_ListCache.js"(exports, module) {
      var listCacheClear = require_listCacheClear();
      var listCacheDelete = require_listCacheDelete();
      var listCacheGet = require_listCacheGet();
      var listCacheHas = require_listCacheHas();
      var listCacheSet = require_listCacheSet();
      function ListCache(entries2) {
        var index = -1, length2 = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index < length2) {
          var entry = entries2[index];
          this.set(entry[0], entry[1]);
        }
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype["delete"] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      module.exports = ListCache;
    }
  });

  // node_modules/lodash/_stackClear.js
  var require_stackClear = __commonJS({
    "node_modules/lodash/_stackClear.js"(exports, module) {
      var ListCache = require_ListCache();
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      module.exports = stackClear;
    }
  });

  // node_modules/lodash/_stackDelete.js
  var require_stackDelete = __commonJS({
    "node_modules/lodash/_stackDelete.js"(exports, module) {
      function stackDelete(key) {
        var data = this.__data__, result = data["delete"](key);
        this.size = data.size;
        return result;
      }
      module.exports = stackDelete;
    }
  });

  // node_modules/lodash/_stackGet.js
  var require_stackGet = __commonJS({
    "node_modules/lodash/_stackGet.js"(exports, module) {
      function stackGet(key) {
        return this.__data__.get(key);
      }
      module.exports = stackGet;
    }
  });

  // node_modules/lodash/_stackHas.js
  var require_stackHas = __commonJS({
    "node_modules/lodash/_stackHas.js"(exports, module) {
      function stackHas(key) {
        return this.__data__.has(key);
      }
      module.exports = stackHas;
    }
  });

  // node_modules/lodash/isObject.js
  var require_isObject = __commonJS({
    "node_modules/lodash/isObject.js"(exports, module) {
      function isObject2(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
      }
      module.exports = isObject2;
    }
  });

  // node_modules/lodash/isFunction.js
  var require_isFunction = __commonJS({
    "node_modules/lodash/isFunction.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isObject2 = require_isObject();
      var asyncTag = "[object AsyncFunction]";
      var funcTag = "[object Function]";
      var genTag = "[object GeneratorFunction]";
      var proxyTag = "[object Proxy]";
      function isFunction3(value) {
        if (!isObject2(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      module.exports = isFunction3;
    }
  });

  // node_modules/lodash/_coreJsData.js
  var require_coreJsData = __commonJS({
    "node_modules/lodash/_coreJsData.js"(exports, module) {
      var root = require_root();
      var coreJsData = root["__core-js_shared__"];
      module.exports = coreJsData;
    }
  });

  // node_modules/lodash/_isMasked.js
  var require_isMasked = __commonJS({
    "node_modules/lodash/_isMasked.js"(exports, module) {
      var coreJsData = require_coreJsData();
      var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
      }();
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      module.exports = isMasked;
    }
  });

  // node_modules/lodash/_toSource.js
  var require_toSource = __commonJS({
    "node_modules/lodash/_toSource.js"(exports, module) {
      var funcProto = Function.prototype;
      var funcToString = funcProto.toString;
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {
          }
          try {
            return func + "";
          } catch (e) {
          }
        }
        return "";
      }
      module.exports = toSource;
    }
  });

  // node_modules/lodash/_baseIsNative.js
  var require_baseIsNative = __commonJS({
    "node_modules/lodash/_baseIsNative.js"(exports, module) {
      var isFunction3 = require_isFunction();
      var isMasked = require_isMasked();
      var isObject2 = require_isObject();
      var toSource = require_toSource();
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var funcProto = Function.prototype;
      var objectProto = Object.prototype;
      var funcToString = funcProto.toString;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      var reIsNative = RegExp(
        "^" + funcToString.call(hasOwnProperty3).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      );
      function baseIsNative(value) {
        if (!isObject2(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction3(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      module.exports = baseIsNative;
    }
  });

  // node_modules/lodash/_getValue.js
  var require_getValue = __commonJS({
    "node_modules/lodash/_getValue.js"(exports, module) {
      function getValue(object, key) {
        return object == null ? void 0 : object[key];
      }
      module.exports = getValue;
    }
  });

  // node_modules/lodash/_getNative.js
  var require_getNative = __commonJS({
    "node_modules/lodash/_getNative.js"(exports, module) {
      var baseIsNative = require_baseIsNative();
      var getValue = require_getValue();
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : void 0;
      }
      module.exports = getNative;
    }
  });

  // node_modules/lodash/_Map.js
  var require_Map = __commonJS({
    "node_modules/lodash/_Map.js"(exports, module) {
      var getNative = require_getNative();
      var root = require_root();
      var Map2 = getNative(root, "Map");
      module.exports = Map2;
    }
  });

  // node_modules/lodash/_nativeCreate.js
  var require_nativeCreate = __commonJS({
    "node_modules/lodash/_nativeCreate.js"(exports, module) {
      var getNative = require_getNative();
      var nativeCreate = getNative(Object, "create");
      module.exports = nativeCreate;
    }
  });

  // node_modules/lodash/_hashClear.js
  var require_hashClear = __commonJS({
    "node_modules/lodash/_hashClear.js"(exports, module) {
      var nativeCreate = require_nativeCreate();
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      module.exports = hashClear;
    }
  });

  // node_modules/lodash/_hashDelete.js
  var require_hashDelete = __commonJS({
    "node_modules/lodash/_hashDelete.js"(exports, module) {
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }
      module.exports = hashDelete;
    }
  });

  // node_modules/lodash/_hashGet.js
  var require_hashGet = __commonJS({
    "node_modules/lodash/_hashGet.js"(exports, module) {
      var nativeCreate = require_nativeCreate();
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? void 0 : result;
        }
        return hasOwnProperty3.call(data, key) ? data[key] : void 0;
      }
      module.exports = hashGet;
    }
  });

  // node_modules/lodash/_hashHas.js
  var require_hashHas = __commonJS({
    "node_modules/lodash/_hashHas.js"(exports, module) {
      var nativeCreate = require_nativeCreate();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== void 0 : hasOwnProperty3.call(data, key);
      }
      module.exports = hashHas;
    }
  });

  // node_modules/lodash/_hashSet.js
  var require_hashSet = __commonJS({
    "node_modules/lodash/_hashSet.js"(exports, module) {
      var nativeCreate = require_nativeCreate();
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
        return this;
      }
      module.exports = hashSet;
    }
  });

  // node_modules/lodash/_Hash.js
  var require_Hash = __commonJS({
    "node_modules/lodash/_Hash.js"(exports, module) {
      var hashClear = require_hashClear();
      var hashDelete = require_hashDelete();
      var hashGet = require_hashGet();
      var hashHas = require_hashHas();
      var hashSet = require_hashSet();
      function Hash(entries2) {
        var index = -1, length2 = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index < length2) {
          var entry = entries2[index];
          this.set(entry[0], entry[1]);
        }
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype["delete"] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      module.exports = Hash;
    }
  });

  // node_modules/lodash/_mapCacheClear.js
  var require_mapCacheClear = __commonJS({
    "node_modules/lodash/_mapCacheClear.js"(exports, module) {
      var Hash = require_Hash();
      var ListCache = require_ListCache();
      var Map2 = require_Map();
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          "hash": new Hash(),
          "map": new (Map2 || ListCache)(),
          "string": new Hash()
        };
      }
      module.exports = mapCacheClear;
    }
  });

  // node_modules/lodash/_isKeyable.js
  var require_isKeyable = __commonJS({
    "node_modules/lodash/_isKeyable.js"(exports, module) {
      function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
      }
      module.exports = isKeyable;
    }
  });

  // node_modules/lodash/_getMapData.js
  var require_getMapData = __commonJS({
    "node_modules/lodash/_getMapData.js"(exports, module) {
      var isKeyable = require_isKeyable();
      function getMapData(map2, key) {
        var data = map2.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
      }
      module.exports = getMapData;
    }
  });

  // node_modules/lodash/_mapCacheDelete.js
  var require_mapCacheDelete = __commonJS({
    "node_modules/lodash/_mapCacheDelete.js"(exports, module) {
      var getMapData = require_getMapData();
      function mapCacheDelete(key) {
        var result = getMapData(this, key)["delete"](key);
        this.size -= result ? 1 : 0;
        return result;
      }
      module.exports = mapCacheDelete;
    }
  });

  // node_modules/lodash/_mapCacheGet.js
  var require_mapCacheGet = __commonJS({
    "node_modules/lodash/_mapCacheGet.js"(exports, module) {
      var getMapData = require_getMapData();
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      module.exports = mapCacheGet;
    }
  });

  // node_modules/lodash/_mapCacheHas.js
  var require_mapCacheHas = __commonJS({
    "node_modules/lodash/_mapCacheHas.js"(exports, module) {
      var getMapData = require_getMapData();
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      module.exports = mapCacheHas;
    }
  });

  // node_modules/lodash/_mapCacheSet.js
  var require_mapCacheSet = __commonJS({
    "node_modules/lodash/_mapCacheSet.js"(exports, module) {
      var getMapData = require_getMapData();
      function mapCacheSet(key, value) {
        var data = getMapData(this, key), size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }
      module.exports = mapCacheSet;
    }
  });

  // node_modules/lodash/_MapCache.js
  var require_MapCache = __commonJS({
    "node_modules/lodash/_MapCache.js"(exports, module) {
      var mapCacheClear = require_mapCacheClear();
      var mapCacheDelete = require_mapCacheDelete();
      var mapCacheGet = require_mapCacheGet();
      var mapCacheHas = require_mapCacheHas();
      var mapCacheSet = require_mapCacheSet();
      function MapCache(entries2) {
        var index = -1, length2 = entries2 == null ? 0 : entries2.length;
        this.clear();
        while (++index < length2) {
          var entry = entries2[index];
          this.set(entry[0], entry[1]);
        }
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype["delete"] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      module.exports = MapCache;
    }
  });

  // node_modules/lodash/_stackSet.js
  var require_stackSet = __commonJS({
    "node_modules/lodash/_stackSet.js"(exports, module) {
      var ListCache = require_ListCache();
      var Map2 = require_Map();
      var MapCache = require_MapCache();
      var LARGE_ARRAY_SIZE = 200;
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      module.exports = stackSet;
    }
  });

  // node_modules/lodash/_Stack.js
  var require_Stack = __commonJS({
    "node_modules/lodash/_Stack.js"(exports, module) {
      var ListCache = require_ListCache();
      var stackClear = require_stackClear();
      var stackDelete = require_stackDelete();
      var stackGet = require_stackGet();
      var stackHas = require_stackHas();
      var stackSet = require_stackSet();
      function Stack(entries2) {
        var data = this.__data__ = new ListCache(entries2);
        this.size = data.size;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype["delete"] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      module.exports = Stack;
    }
  });

  // node_modules/lodash/_setCacheAdd.js
  var require_setCacheAdd = __commonJS({
    "node_modules/lodash/_setCacheAdd.js"(exports, module) {
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      module.exports = setCacheAdd;
    }
  });

  // node_modules/lodash/_setCacheHas.js
  var require_setCacheHas = __commonJS({
    "node_modules/lodash/_setCacheHas.js"(exports, module) {
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      module.exports = setCacheHas;
    }
  });

  // node_modules/lodash/_SetCache.js
  var require_SetCache = __commonJS({
    "node_modules/lodash/_SetCache.js"(exports, module) {
      var MapCache = require_MapCache();
      var setCacheAdd = require_setCacheAdd();
      var setCacheHas = require_setCacheHas();
      function SetCache(values2) {
        var index = -1, length2 = values2 == null ? 0 : values2.length;
        this.__data__ = new MapCache();
        while (++index < length2) {
          this.add(values2[index]);
        }
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      module.exports = SetCache;
    }
  });

  // node_modules/lodash/_arraySome.js
  var require_arraySome = __commonJS({
    "node_modules/lodash/_arraySome.js"(exports, module) {
      function arraySome(array, predicate) {
        var index = -1, length2 = array == null ? 0 : array.length;
        while (++index < length2) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      module.exports = arraySome;
    }
  });

  // node_modules/lodash/_cacheHas.js
  var require_cacheHas = __commonJS({
    "node_modules/lodash/_cacheHas.js"(exports, module) {
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      module.exports = cacheHas;
    }
  });

  // node_modules/lodash/_equalArrays.js
  var require_equalArrays = __commonJS({
    "node_modules/lodash/_equalArrays.js"(exports, module) {
      var SetCache = require_SetCache();
      var arraySome = require_arraySome();
      var cacheHas = require_cacheHas();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
        stack.set(array, other);
        stack.set(other, array);
        while (++index < arrLength) {
          var arrValue = array[index], othValue = other[index];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== void 0) {
            if (compared) {
              continue;
            }
            result = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function(othValue2, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
          }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result;
      }
      module.exports = equalArrays;
    }
  });

  // node_modules/lodash/_Uint8Array.js
  var require_Uint8Array = __commonJS({
    "node_modules/lodash/_Uint8Array.js"(exports, module) {
      var root = require_root();
      var Uint8Array2 = root.Uint8Array;
      module.exports = Uint8Array2;
    }
  });

  // node_modules/lodash/_mapToArray.js
  var require_mapToArray = __commonJS({
    "node_modules/lodash/_mapToArray.js"(exports, module) {
      function mapToArray(map2) {
        var index = -1, result = Array(map2.size);
        map2.forEach(function(value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      module.exports = mapToArray;
    }
  });

  // node_modules/lodash/_setToArray.js
  var require_setToArray = __commonJS({
    "node_modules/lodash/_setToArray.js"(exports, module) {
      function setToArray(set2) {
        var index = -1, result = Array(set2.size);
        set2.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      module.exports = setToArray;
    }
  });

  // node_modules/lodash/_equalByTag.js
  var require_equalByTag = __commonJS({
    "node_modules/lodash/_equalByTag.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var Uint8Array2 = require_Uint8Array();
      var eq = require_eq();
      var equalArrays = require_equalArrays();
      var mapToArray = require_mapToArray();
      var setToArray = require_setToArray();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var errorTag = "[object Error]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var symbolTag = "[object Symbol]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
      var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + "";
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      module.exports = equalByTag;
    }
  });

  // node_modules/lodash/_arrayPush.js
  var require_arrayPush = __commonJS({
    "node_modules/lodash/_arrayPush.js"(exports, module) {
      function arrayPush(array, values2) {
        var index = -1, length2 = values2.length, offset = array.length;
        while (++index < length2) {
          array[offset + index] = values2[index];
        }
        return array;
      }
      module.exports = arrayPush;
    }
  });

  // node_modules/lodash/isArray.js
  var require_isArray = __commonJS({
    "node_modules/lodash/isArray.js"(exports, module) {
      var isArray = Array.isArray;
      module.exports = isArray;
    }
  });

  // node_modules/lodash/_baseGetAllKeys.js
  var require_baseGetAllKeys = __commonJS({
    "node_modules/lodash/_baseGetAllKeys.js"(exports, module) {
      var arrayPush = require_arrayPush();
      var isArray = require_isArray();
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }
      module.exports = baseGetAllKeys;
    }
  });

  // node_modules/lodash/_arrayFilter.js
  var require_arrayFilter = __commonJS({
    "node_modules/lodash/_arrayFilter.js"(exports, module) {
      function arrayFilter(array, predicate) {
        var index = -1, length2 = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length2) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      module.exports = arrayFilter;
    }
  });

  // node_modules/lodash/stubArray.js
  var require_stubArray = __commonJS({
    "node_modules/lodash/stubArray.js"(exports, module) {
      function stubArray() {
        return [];
      }
      module.exports = stubArray;
    }
  });

  // node_modules/lodash/_getSymbols.js
  var require_getSymbols = __commonJS({
    "node_modules/lodash/_getSymbols.js"(exports, module) {
      var arrayFilter = require_arrayFilter();
      var stubArray = require_stubArray();
      var objectProto = Object.prototype;
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      var nativeGetSymbols = Object.getOwnPropertySymbols;
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      module.exports = getSymbols;
    }
  });

  // node_modules/lodash/_baseTimes.js
  var require_baseTimes = __commonJS({
    "node_modules/lodash/_baseTimes.js"(exports, module) {
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      module.exports = baseTimes;
    }
  });

  // node_modules/lodash/_baseIsArguments.js
  var require_baseIsArguments = __commonJS({
    "node_modules/lodash/_baseIsArguments.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var argsTag = "[object Arguments]";
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      module.exports = baseIsArguments;
    }
  });

  // node_modules/lodash/isArguments.js
  var require_isArguments = __commonJS({
    "node_modules/lodash/isArguments.js"(exports, module) {
      var baseIsArguments = require_baseIsArguments();
      var isObjectLike = require_isObjectLike();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      var propertyIsEnumerable = objectProto.propertyIsEnumerable;
      var isArguments = baseIsArguments(function() {
        return arguments;
      }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty3.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
      };
      module.exports = isArguments;
    }
  });

  // node_modules/lodash/stubFalse.js
  var require_stubFalse = __commonJS({
    "node_modules/lodash/stubFalse.js"(exports, module) {
      function stubFalse() {
        return false;
      }
      module.exports = stubFalse;
    }
  });

  // node_modules/lodash/isBuffer.js
  var require_isBuffer = __commonJS({
    "node_modules/lodash/isBuffer.js"(exports, module) {
      var root = require_root();
      var stubFalse = require_stubFalse();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var Buffer2 = moduleExports ? root.Buffer : void 0;
      var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
      var isBuffer = nativeIsBuffer || stubFalse;
      module.exports = isBuffer;
    }
  });

  // node_modules/lodash/_isIndex.js
  var require_isIndex = __commonJS({
    "node_modules/lodash/_isIndex.js"(exports, module) {
      var MAX_SAFE_INTEGER = 9007199254740991;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      function isIndex(value, length2) {
        var type = typeof value;
        length2 = length2 == null ? MAX_SAFE_INTEGER : length2;
        return !!length2 && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length2);
      }
      module.exports = isIndex;
    }
  });

  // node_modules/lodash/isLength.js
  var require_isLength = __commonJS({
    "node_modules/lodash/isLength.js"(exports, module) {
      var MAX_SAFE_INTEGER = 9007199254740991;
      function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      module.exports = isLength;
    }
  });

  // node_modules/lodash/_baseIsTypedArray.js
  var require_baseIsTypedArray = __commonJS({
    "node_modules/lodash/_baseIsTypedArray.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isLength = require_isLength();
      var isObjectLike = require_isObjectLike();
      var argsTag = "[object Arguments]";
      var arrayTag = "[object Array]";
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var errorTag = "[object Error]";
      var funcTag = "[object Function]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var objectTag = "[object Object]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var weakMapTag = "[object WeakMap]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var float32Tag = "[object Float32Array]";
      var float64Tag = "[object Float64Array]";
      var int8Tag = "[object Int8Array]";
      var int16Tag = "[object Int16Array]";
      var int32Tag = "[object Int32Array]";
      var uint8Tag = "[object Uint8Array]";
      var uint8ClampedTag = "[object Uint8ClampedArray]";
      var uint16Tag = "[object Uint16Array]";
      var uint32Tag = "[object Uint32Array]";
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      module.exports = baseIsTypedArray;
    }
  });

  // node_modules/lodash/_baseUnary.js
  var require_baseUnary = __commonJS({
    "node_modules/lodash/_baseUnary.js"(exports, module) {
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      module.exports = baseUnary;
    }
  });

  // node_modules/lodash/_nodeUtil.js
  var require_nodeUtil = __commonJS({
    "node_modules/lodash/_nodeUtil.js"(exports, module) {
      var freeGlobal = require_freeGlobal();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      module.exports = nodeUtil;
    }
  });

  // node_modules/lodash/isTypedArray.js
  var require_isTypedArray = __commonJS({
    "node_modules/lodash/isTypedArray.js"(exports, module) {
      var baseIsTypedArray = require_baseIsTypedArray();
      var baseUnary = require_baseUnary();
      var nodeUtil = require_nodeUtil();
      var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      module.exports = isTypedArray;
    }
  });

  // node_modules/lodash/_arrayLikeKeys.js
  var require_arrayLikeKeys = __commonJS({
    "node_modules/lodash/_arrayLikeKeys.js"(exports, module) {
      var baseTimes = require_baseTimes();
      var isArguments = require_isArguments();
      var isArray = require_isArray();
      var isBuffer = require_isBuffer();
      var isIndex = require_isIndex();
      var isTypedArray = require_isTypedArray();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length2 = result.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty3.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
          (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
          isIndex(key, length2)))) {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = arrayLikeKeys;
    }
  });

  // node_modules/lodash/_isPrototype.js
  var require_isPrototype = __commonJS({
    "node_modules/lodash/_isPrototype.js"(exports, module) {
      var objectProto = Object.prototype;
      function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
      }
      module.exports = isPrototype;
    }
  });

  // node_modules/lodash/_nativeKeys.js
  var require_nativeKeys = __commonJS({
    "node_modules/lodash/_nativeKeys.js"(exports, module) {
      var overArg = require_overArg();
      var nativeKeys = overArg(Object.keys, Object);
      module.exports = nativeKeys;
    }
  });

  // node_modules/lodash/_baseKeys.js
  var require_baseKeys = __commonJS({
    "node_modules/lodash/_baseKeys.js"(exports, module) {
      var isPrototype = require_isPrototype();
      var nativeKeys = require_nativeKeys();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty3.call(object, key) && key != "constructor") {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = baseKeys;
    }
  });

  // node_modules/lodash/isArrayLike.js
  var require_isArrayLike = __commonJS({
    "node_modules/lodash/isArrayLike.js"(exports, module) {
      var isFunction3 = require_isFunction();
      var isLength = require_isLength();
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction3(value);
      }
      module.exports = isArrayLike;
    }
  });

  // node_modules/lodash/keys.js
  var require_keys = __commonJS({
    "node_modules/lodash/keys.js"(exports, module) {
      var arrayLikeKeys = require_arrayLikeKeys();
      var baseKeys = require_baseKeys();
      var isArrayLike = require_isArrayLike();
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      module.exports = keys;
    }
  });

  // node_modules/lodash/_getAllKeys.js
  var require_getAllKeys = __commonJS({
    "node_modules/lodash/_getAllKeys.js"(exports, module) {
      var baseGetAllKeys = require_baseGetAllKeys();
      var getSymbols = require_getSymbols();
      var keys = require_keys();
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      module.exports = getAllKeys;
    }
  });

  // node_modules/lodash/_equalObjects.js
  var require_equalObjects = __commonJS({
    "node_modules/lodash/_equalObjects.js"(exports, module) {
      var getAllKeys = require_getAllKeys();
      var COMPARE_PARTIAL_FLAG = 1;
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty3.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key], othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
          }
          skipCtor || (skipCtor = key == "constructor");
        }
        if (result && !skipCtor) {
          var objCtor = object.constructor, othCtor = other.constructor;
          if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
            result = false;
          }
        }
        stack["delete"](object);
        stack["delete"](other);
        return result;
      }
      module.exports = equalObjects;
    }
  });

  // node_modules/lodash/_DataView.js
  var require_DataView = __commonJS({
    "node_modules/lodash/_DataView.js"(exports, module) {
      var getNative = require_getNative();
      var root = require_root();
      var DataView = getNative(root, "DataView");
      module.exports = DataView;
    }
  });

  // node_modules/lodash/_Promise.js
  var require_Promise = __commonJS({
    "node_modules/lodash/_Promise.js"(exports, module) {
      var getNative = require_getNative();
      var root = require_root();
      var Promise3 = getNative(root, "Promise");
      module.exports = Promise3;
    }
  });

  // node_modules/lodash/_Set.js
  var require_Set = __commonJS({
    "node_modules/lodash/_Set.js"(exports, module) {
      var getNative = require_getNative();
      var root = require_root();
      var Set2 = getNative(root, "Set");
      module.exports = Set2;
    }
  });

  // node_modules/lodash/_WeakMap.js
  var require_WeakMap = __commonJS({
    "node_modules/lodash/_WeakMap.js"(exports, module) {
      var getNative = require_getNative();
      var root = require_root();
      var WeakMap2 = getNative(root, "WeakMap");
      module.exports = WeakMap2;
    }
  });

  // node_modules/lodash/_getTag.js
  var require_getTag = __commonJS({
    "node_modules/lodash/_getTag.js"(exports, module) {
      var DataView = require_DataView();
      var Map2 = require_Map();
      var Promise3 = require_Promise();
      var Set2 = require_Set();
      var WeakMap2 = require_WeakMap();
      var baseGetTag = require_baseGetTag();
      var toSource = require_toSource();
      var mapTag = "[object Map]";
      var objectTag = "[object Object]";
      var promiseTag = "[object Promise]";
      var setTag = "[object Set]";
      var weakMapTag = "[object WeakMap]";
      var dataViewTag = "[object DataView]";
      var dataViewCtorString = toSource(DataView);
      var mapCtorString = toSource(Map2);
      var promiseCtorString = toSource(Promise3);
      var setCtorString = toSource(Set2);
      var weakMapCtorString = toSource(WeakMap2);
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise3 && getTag(Promise3.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
        getTag = function(value) {
          var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result;
        };
      }
      module.exports = getTag;
    }
  });

  // node_modules/lodash/_baseIsEqualDeep.js
  var require_baseIsEqualDeep = __commonJS({
    "node_modules/lodash/_baseIsEqualDeep.js"(exports, module) {
      var Stack = require_Stack();
      var equalArrays = require_equalArrays();
      var equalByTag = require_equalByTag();
      var equalObjects = require_equalObjects();
      var getTag = require_getTag();
      var isArray = require_isArray();
      var isBuffer = require_isBuffer();
      var isTypedArray = require_isTypedArray();
      var COMPARE_PARTIAL_FLAG = 1;
      var argsTag = "[object Arguments]";
      var arrayTag = "[object Array]";
      var objectTag = "[object Object]";
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty3.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty3.call(other, "__wrapped__");
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      module.exports = baseIsEqualDeep;
    }
  });

  // node_modules/lodash/_baseIsEqual.js
  var require_baseIsEqual = __commonJS({
    "node_modules/lodash/_baseIsEqual.js"(exports, module) {
      var baseIsEqualDeep = require_baseIsEqualDeep();
      var isObjectLike = require_isObjectLike();
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      module.exports = baseIsEqual;
    }
  });

  // node_modules/lodash/_baseIsMatch.js
  var require_baseIsMatch = __commonJS({
    "node_modules/lodash/_baseIsMatch.js"(exports, module) {
      var Stack = require_Stack();
      var baseIsEqual = require_baseIsEqual();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length, length2 = index, noCustomizer = !customizer;
        if (object == null) {
          return !length2;
        }
        object = Object(object);
        while (index--) {
          var data = matchData[index];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index < length2) {
          data = matchData[index];
          var key = data[0], objValue = object[key], srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === void 0 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === void 0 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
              return false;
            }
          }
        }
        return true;
      }
      module.exports = baseIsMatch;
    }
  });

  // node_modules/lodash/_isStrictComparable.js
  var require_isStrictComparable = __commonJS({
    "node_modules/lodash/_isStrictComparable.js"(exports, module) {
      var isObject2 = require_isObject();
      function isStrictComparable(value) {
        return value === value && !isObject2(value);
      }
      module.exports = isStrictComparable;
    }
  });

  // node_modules/lodash/_getMatchData.js
  var require_getMatchData = __commonJS({
    "node_modules/lodash/_getMatchData.js"(exports, module) {
      var isStrictComparable = require_isStrictComparable();
      var keys = require_keys();
      function getMatchData(object) {
        var result = keys(object), length2 = result.length;
        while (length2--) {
          var key = result[length2], value = object[key];
          result[length2] = [key, value, isStrictComparable(value)];
        }
        return result;
      }
      module.exports = getMatchData;
    }
  });

  // node_modules/lodash/_matchesStrictComparable.js
  var require_matchesStrictComparable = __commonJS({
    "node_modules/lodash/_matchesStrictComparable.js"(exports, module) {
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== void 0 || key in Object(object));
        };
      }
      module.exports = matchesStrictComparable;
    }
  });

  // node_modules/lodash/_baseMatches.js
  var require_baseMatches = __commonJS({
    "node_modules/lodash/_baseMatches.js"(exports, module) {
      var baseIsMatch = require_baseIsMatch();
      var getMatchData = require_getMatchData();
      var matchesStrictComparable = require_matchesStrictComparable();
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      module.exports = baseMatches;
    }
  });

  // node_modules/lodash/isSymbol.js
  var require_isSymbol = __commonJS({
    "node_modules/lodash/isSymbol.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var symbolTag = "[object Symbol]";
      function isSymbol(value) {
        return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      module.exports = isSymbol;
    }
  });

  // node_modules/lodash/_isKey.js
  var require_isKey = __commonJS({
    "node_modules/lodash/_isKey.js"(exports, module) {
      var isArray = require_isArray();
      var isSymbol = require_isSymbol();
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
      var reIsPlainProp = /^\w*$/;
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
      }
      module.exports = isKey;
    }
  });

  // node_modules/lodash/memoize.js
  var require_memoize = __commonJS({
    "node_modules/lodash/memoize.js"(exports, module) {
      var MapCache = require_MapCache();
      var FUNC_ERROR_TEXT = "Expected a function";
      function memoize2(func, resolver) {
        if (typeof func != "function" || resolver != null && typeof resolver != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };
        memoized.cache = new (memoize2.Cache || MapCache)();
        return memoized;
      }
      memoize2.Cache = MapCache;
      module.exports = memoize2;
    }
  });

  // node_modules/lodash/_memoizeCapped.js
  var require_memoizeCapped = __commonJS({
    "node_modules/lodash/_memoizeCapped.js"(exports, module) {
      var memoize2 = require_memoize();
      var MAX_MEMOIZE_SIZE = 500;
      function memoizeCapped(func) {
        var result = memoize2(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result.cache;
        return result;
      }
      module.exports = memoizeCapped;
    }
  });

  // node_modules/lodash/_stringToPath.js
  var require_stringToPath = __commonJS({
    "node_modules/lodash/_stringToPath.js"(exports, module) {
      var memoizeCapped = require_memoizeCapped();
      var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reEscapeChar = /\\(\\)?/g;
      var stringToPath = memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46) {
          result.push("");
        }
        string.replace(rePropName, function(match2, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match2);
        });
        return result;
      });
      module.exports = stringToPath;
    }
  });

  // node_modules/lodash/_arrayMap.js
  var require_arrayMap = __commonJS({
    "node_modules/lodash/_arrayMap.js"(exports, module) {
      function arrayMap(array, iteratee) {
        var index = -1, length2 = array == null ? 0 : array.length, result = Array(length2);
        while (++index < length2) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      module.exports = arrayMap;
    }
  });

  // node_modules/lodash/_baseToString.js
  var require_baseToString = __commonJS({
    "node_modules/lodash/_baseToString.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var arrayMap = require_arrayMap();
      var isArray = require_isArray();
      var isSymbol = require_isSymbol();
      var INFINITY = 1 / 0;
      var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
      var symbolToString = symbolProto ? symbolProto.toString : void 0;
      function baseToString(value) {
        if (typeof value == "string") {
          return value;
        }
        if (isArray(value)) {
          return arrayMap(value, baseToString) + "";
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : "";
        }
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
      }
      module.exports = baseToString;
    }
  });

  // node_modules/lodash/toString.js
  var require_toString = __commonJS({
    "node_modules/lodash/toString.js"(exports, module) {
      var baseToString = require_baseToString();
      function toString4(value) {
        return value == null ? "" : baseToString(value);
      }
      module.exports = toString4;
    }
  });

  // node_modules/lodash/_castPath.js
  var require_castPath = __commonJS({
    "node_modules/lodash/_castPath.js"(exports, module) {
      var isArray = require_isArray();
      var isKey = require_isKey();
      var stringToPath = require_stringToPath();
      var toString4 = require_toString();
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString4(value));
      }
      module.exports = castPath;
    }
  });

  // node_modules/lodash/_toKey.js
  var require_toKey = __commonJS({
    "node_modules/lodash/_toKey.js"(exports, module) {
      var isSymbol = require_isSymbol();
      var INFINITY = 1 / 0;
      function toKey(value) {
        if (typeof value == "string" || isSymbol(value)) {
          return value;
        }
        var result = value + "";
        return result == "0" && 1 / value == -INFINITY ? "-0" : result;
      }
      module.exports = toKey;
    }
  });

  // node_modules/lodash/_baseGet.js
  var require_baseGet = __commonJS({
    "node_modules/lodash/_baseGet.js"(exports, module) {
      var castPath = require_castPath();
      var toKey = require_toKey();
      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0, length2 = path.length;
        while (object != null && index < length2) {
          object = object[toKey(path[index++])];
        }
        return index && index == length2 ? object : void 0;
      }
      module.exports = baseGet;
    }
  });

  // node_modules/lodash/get.js
  var require_get = __commonJS({
    "node_modules/lodash/get.js"(exports, module) {
      var baseGet = require_baseGet();
      function get2(object, path, defaultValue) {
        var result = object == null ? void 0 : baseGet(object, path);
        return result === void 0 ? defaultValue : result;
      }
      module.exports = get2;
    }
  });

  // node_modules/lodash/_baseHasIn.js
  var require_baseHasIn = __commonJS({
    "node_modules/lodash/_baseHasIn.js"(exports, module) {
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }
      module.exports = baseHasIn;
    }
  });

  // node_modules/lodash/_hasPath.js
  var require_hasPath = __commonJS({
    "node_modules/lodash/_hasPath.js"(exports, module) {
      var castPath = require_castPath();
      var isArguments = require_isArguments();
      var isArray = require_isArray();
      var isIndex = require_isIndex();
      var isLength = require_isLength();
      var toKey = require_toKey();
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1, length2 = path.length, result = false;
        while (++index < length2) {
          var key = toKey(path[index]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index != length2) {
          return result;
        }
        length2 = object == null ? 0 : object.length;
        return !!length2 && isLength(length2) && isIndex(key, length2) && (isArray(object) || isArguments(object));
      }
      module.exports = hasPath;
    }
  });

  // node_modules/lodash/hasIn.js
  var require_hasIn = __commonJS({
    "node_modules/lodash/hasIn.js"(exports, module) {
      var baseHasIn = require_baseHasIn();
      var hasPath = require_hasPath();
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      module.exports = hasIn;
    }
  });

  // node_modules/lodash/_baseMatchesProperty.js
  var require_baseMatchesProperty = __commonJS({
    "node_modules/lodash/_baseMatchesProperty.js"(exports, module) {
      var baseIsEqual = require_baseIsEqual();
      var get2 = require_get();
      var hasIn = require_hasIn();
      var isKey = require_isKey();
      var isStrictComparable = require_isStrictComparable();
      var matchesStrictComparable = require_matchesStrictComparable();
      var toKey = require_toKey();
      var COMPARE_PARTIAL_FLAG = 1;
      var COMPARE_UNORDERED_FLAG = 2;
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get2(object, path);
          return objValue === void 0 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      module.exports = baseMatchesProperty;
    }
  });

  // node_modules/lodash/identity.js
  var require_identity = __commonJS({
    "node_modules/lodash/identity.js"(exports, module) {
      function identity2(value) {
        return value;
      }
      module.exports = identity2;
    }
  });

  // node_modules/lodash/_baseProperty.js
  var require_baseProperty = __commonJS({
    "node_modules/lodash/_baseProperty.js"(exports, module) {
      function baseProperty(key) {
        return function(object) {
          return object == null ? void 0 : object[key];
        };
      }
      module.exports = baseProperty;
    }
  });

  // node_modules/lodash/_basePropertyDeep.js
  var require_basePropertyDeep = __commonJS({
    "node_modules/lodash/_basePropertyDeep.js"(exports, module) {
      var baseGet = require_baseGet();
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }
      module.exports = basePropertyDeep;
    }
  });

  // node_modules/lodash/property.js
  var require_property = __commonJS({
    "node_modules/lodash/property.js"(exports, module) {
      var baseProperty = require_baseProperty();
      var basePropertyDeep = require_basePropertyDeep();
      var isKey = require_isKey();
      var toKey = require_toKey();
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      module.exports = property;
    }
  });

  // node_modules/lodash/_baseIteratee.js
  var require_baseIteratee = __commonJS({
    "node_modules/lodash/_baseIteratee.js"(exports, module) {
      var baseMatches = require_baseMatches();
      var baseMatchesProperty = require_baseMatchesProperty();
      var identity2 = require_identity();
      var isArray = require_isArray();
      var property = require_property();
      function baseIteratee(value) {
        if (typeof value == "function") {
          return value;
        }
        if (value == null) {
          return identity2;
        }
        if (typeof value == "object") {
          return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      module.exports = baseIteratee;
    }
  });

  // node_modules/lodash/_createFind.js
  var require_createFind = __commonJS({
    "node_modules/lodash/_createFind.js"(exports, module) {
      var baseIteratee = require_baseIteratee();
      var isArrayLike = require_isArrayLike();
      var keys = require_keys();
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object(collection);
          if (!isArrayLike(collection)) {
            var iteratee = baseIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) {
              return iteratee(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee ? collection[index] : index] : void 0;
        };
      }
      module.exports = createFind;
    }
  });

  // node_modules/lodash/_baseFindIndex.js
  var require_baseFindIndex = __commonJS({
    "node_modules/lodash/_baseFindIndex.js"(exports, module) {
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length2 = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length2) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      module.exports = baseFindIndex;
    }
  });

  // node_modules/lodash/_trimmedEndIndex.js
  var require_trimmedEndIndex = __commonJS({
    "node_modules/lodash/_trimmedEndIndex.js"(exports, module) {
      var reWhitespace = /\s/;
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      module.exports = trimmedEndIndex;
    }
  });

  // node_modules/lodash/_baseTrim.js
  var require_baseTrim = __commonJS({
    "node_modules/lodash/_baseTrim.js"(exports, module) {
      var trimmedEndIndex = require_trimmedEndIndex();
      var reTrimStart = /^\s+/;
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      module.exports = baseTrim;
    }
  });

  // node_modules/lodash/toNumber.js
  var require_toNumber = __commonJS({
    "node_modules/lodash/toNumber.js"(exports, module) {
      var baseTrim = require_baseTrim();
      var isObject2 = require_isObject();
      var isSymbol = require_isSymbol();
      var NAN = 0 / 0;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsOctal = /^0o[0-7]+$/i;
      var freeParseInt = parseInt;
      function toNumber(value) {
        if (typeof value == "number") {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject2(value)) {
          var other = typeof value.valueOf == "function" ? value.valueOf() : value;
          value = isObject2(other) ? other + "" : other;
        }
        if (typeof value != "string") {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      module.exports = toNumber;
    }
  });

  // node_modules/lodash/toFinite.js
  var require_toFinite = __commonJS({
    "node_modules/lodash/toFinite.js"(exports, module) {
      var toNumber = require_toNumber();
      var INFINITY = 1 / 0;
      var MAX_INTEGER = 17976931348623157e292;
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      module.exports = toFinite;
    }
  });

  // node_modules/lodash/toInteger.js
  var require_toInteger = __commonJS({
    "node_modules/lodash/toInteger.js"(exports, module) {
      var toFinite = require_toFinite();
      function toInteger(value) {
        var result = toFinite(value), remainder = result % 1;
        return result === result ? remainder ? result - remainder : result : 0;
      }
      module.exports = toInteger;
    }
  });

  // node_modules/lodash/findIndex.js
  var require_findIndex = __commonJS({
    "node_modules/lodash/findIndex.js"(exports, module) {
      var baseFindIndex = require_baseFindIndex();
      var baseIteratee = require_baseIteratee();
      var toInteger = require_toInteger();
      var nativeMax = Math.max;
      function findIndex(array, predicate, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length2 + index, 0);
        }
        return baseFindIndex(array, baseIteratee(predicate, 3), index);
      }
      module.exports = findIndex;
    }
  });

  // node_modules/lodash/find.js
  var require_find = __commonJS({
    "node_modules/lodash/find.js"(exports, module) {
      var createFind = require_createFind();
      var findIndex = require_findIndex();
      var find2 = createFind(findIndex);
      module.exports = find2;
    }
  });

  // packages/systems/ix2/shared/logic/IX2BrowserSupport.js
  var require_IX2BrowserSupport = __commonJS({
    "packages/systems/ix2/shared/logic/IX2BrowserSupport.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.withBrowser = exports.TRANSFORM_STYLE_PREFIXED = exports.TRANSFORM_PREFIXED = exports.IS_BROWSER_ENV = exports.FLEX_PREFIXED = exports.ELEMENT_MATCHES = void 0;
      var _find = _interopRequireDefault(require_find());
      var IS_BROWSER_ENV = typeof window !== "undefined";
      exports.IS_BROWSER_ENV = IS_BROWSER_ENV;
      var withBrowser = (fn, fallback) => {
        if (IS_BROWSER_ENV) {
          return fn();
        }
        return fallback;
      };
      exports.withBrowser = withBrowser;
      var ELEMENT_MATCHES = withBrowser(() => {
        return (0, _find.default)(["matches", "matchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector", "webkitMatchesSelector"], (key) => key in Element.prototype);
      });
      exports.ELEMENT_MATCHES = ELEMENT_MATCHES;
      var FLEX_PREFIXED = withBrowser(() => {
        const el = document.createElement("i");
        const values2 = ["flex", "-webkit-flex", "-ms-flexbox", "-moz-box", "-webkit-box"];
        const none = "";
        try {
          const {
            length: length2
          } = values2;
          for (let i = 0; i < length2; i++) {
            const value = values2[i];
            el.style.display = value;
            if (el.style.display === value) {
              return value;
            }
          }
          return none;
        } catch (err) {
          return none;
        }
      }, "flex");
      exports.FLEX_PREFIXED = FLEX_PREFIXED;
      var TRANSFORM_PREFIXED = withBrowser(() => {
        const el = document.createElement("i");
        if (el.style.transform == null) {
          const prefixes = ["Webkit", "Moz", "ms"];
          const suffix = "Transform";
          const {
            length: length2
          } = prefixes;
          for (let i = 0; i < length2; i++) {
            const prop2 = prefixes[i] + suffix;
            if (el.style[prop2] !== void 0) {
              return prop2;
            }
          }
        }
        return "transform";
      }, "transform");
      exports.TRANSFORM_PREFIXED = TRANSFORM_PREFIXED;
      var TRANSFORM_PREFIX = TRANSFORM_PREFIXED.split("transform")[0];
      var TRANSFORM_STYLE_PREFIXED = TRANSFORM_PREFIX ? TRANSFORM_PREFIX + "TransformStyle" : "transformStyle";
      exports.TRANSFORM_STYLE_PREFIXED = TRANSFORM_STYLE_PREFIXED;
    }
  });

  // node_modules/bezier-easing/src/index.js
  var require_src = __commonJS({
    "node_modules/bezier-easing/src/index.js"(exports, module) {
      var NEWTON_ITERATIONS = 4;
      var NEWTON_MIN_SLOPE = 1e-3;
      var SUBDIVISION_PRECISION = 1e-7;
      var SUBDIVISION_MAX_ITERATIONS = 10;
      var kSplineTableSize = 11;
      var kSampleStepSize = 1 / (kSplineTableSize - 1);
      var float32ArraySupported = typeof Float32Array === "function";
      function A(aA1, aA2) {
        return 1 - 3 * aA2 + 3 * aA1;
      }
      function B(aA1, aA2) {
        return 3 * aA2 - 6 * aA1;
      }
      function C(aA1) {
        return 3 * aA1;
      }
      function calcBezier(aT, aA1, aA2) {
        return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
      }
      function getSlope(aT, aA1, aA2) {
        return 3 * A(aA1, aA2) * aT * aT + 2 * B(aA1, aA2) * aT + C(aA1);
      }
      function binarySubdivide(aX, aA, aB, mX1, mX2) {
        var currentX, currentT, i = 0;
        do {
          currentT = aA + (aB - aA) / 2;
          currentX = calcBezier(currentT, mX1, mX2) - aX;
          if (currentX > 0) {
            aB = currentT;
          } else {
            aA = currentT;
          }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
      }
      function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
          var currentSlope = getSlope(aGuessT, mX1, mX2);
          if (currentSlope === 0) {
            return aGuessT;
          }
          var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
          aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
      }
      module.exports = function bezier(mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
          throw new Error("bezier x values must be in [0, 1] range");
        }
        var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
        if (mX1 !== mY1 || mX2 !== mY2) {
          for (var i = 0; i < kSplineTableSize; ++i) {
            sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
          }
        }
        function getTForX(aX) {
          var intervalStart = 0;
          var currentSample = 1;
          var lastSample = kSplineTableSize - 1;
          for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += kSampleStepSize;
          }
          --currentSample;
          var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
          var guessForT = intervalStart + dist * kSampleStepSize;
          var initialSlope = getSlope(guessForT, mX1, mX2);
          if (initialSlope >= NEWTON_MIN_SLOPE) {
            return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
          } else if (initialSlope === 0) {
            return guessForT;
          } else {
            return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
          }
        }
        return function BezierEasing(x) {
          if (mX1 === mY1 && mX2 === mY2) {
            return x;
          }
          if (x === 0) {
            return 0;
          }
          if (x === 1) {
            return 1;
          }
          return calcBezier(getTForX(x), mY1, mY2);
        };
      };
    }
  });

  // packages/systems/ix2/shared/logic/IX2Easings.js
  var require_IX2Easings = __commonJS({
    "packages/systems/ix2/shared/logic/IX2Easings.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.bounce = bounce;
      exports.bouncePast = bouncePast;
      exports.easeOut = exports.easeInOut = exports.easeIn = exports.ease = void 0;
      exports.inBack = inBack;
      exports.inCirc = inCirc;
      exports.inCubic = inCubic;
      exports.inElastic = inElastic;
      exports.inExpo = inExpo;
      exports.inOutBack = inOutBack;
      exports.inOutCirc = inOutCirc;
      exports.inOutCubic = inOutCubic;
      exports.inOutElastic = inOutElastic;
      exports.inOutExpo = inOutExpo;
      exports.inOutQuad = inOutQuad;
      exports.inOutQuart = inOutQuart;
      exports.inOutQuint = inOutQuint;
      exports.inOutSine = inOutSine;
      exports.inQuad = inQuad;
      exports.inQuart = inQuart;
      exports.inQuint = inQuint;
      exports.inSine = inSine;
      exports.outBack = outBack;
      exports.outBounce = outBounce;
      exports.outCirc = outCirc;
      exports.outCubic = outCubic;
      exports.outElastic = outElastic;
      exports.outExpo = outExpo;
      exports.outQuad = outQuad;
      exports.outQuart = outQuart;
      exports.outQuint = outQuint;
      exports.outSine = outSine;
      exports.swingFrom = swingFrom;
      exports.swingFromTo = swingFromTo;
      exports.swingTo = swingTo;
      var _bezierEasing = _interopRequireDefault(require_src());
      var magicSwing = 1.70158;
      var ease = (0, _bezierEasing.default)(0.25, 0.1, 0.25, 1);
      exports.ease = ease;
      var easeIn = (0, _bezierEasing.default)(0.42, 0, 1, 1);
      exports.easeIn = easeIn;
      var easeOut = (0, _bezierEasing.default)(0, 0, 0.58, 1);
      exports.easeOut = easeOut;
      var easeInOut = (0, _bezierEasing.default)(0.42, 0, 0.58, 1);
      exports.easeInOut = easeInOut;
      function inQuad(pos) {
        return Math.pow(pos, 2);
      }
      function outQuad(pos) {
        return -(Math.pow(pos - 1, 2) - 1);
      }
      function inOutQuad(pos) {
        if ((pos /= 0.5) < 1) {
          return 0.5 * Math.pow(pos, 2);
        }
        return -0.5 * ((pos -= 2) * pos - 2);
      }
      function inCubic(pos) {
        return Math.pow(pos, 3);
      }
      function outCubic(pos) {
        return Math.pow(pos - 1, 3) + 1;
      }
      function inOutCubic(pos) {
        if ((pos /= 0.5) < 1) {
          return 0.5 * Math.pow(pos, 3);
        }
        return 0.5 * (Math.pow(pos - 2, 3) + 2);
      }
      function inQuart(pos) {
        return Math.pow(pos, 4);
      }
      function outQuart(pos) {
        return -(Math.pow(pos - 1, 4) - 1);
      }
      function inOutQuart(pos) {
        if ((pos /= 0.5) < 1) {
          return 0.5 * Math.pow(pos, 4);
        }
        return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
      }
      function inQuint(pos) {
        return Math.pow(pos, 5);
      }
      function outQuint(pos) {
        return Math.pow(pos - 1, 5) + 1;
      }
      function inOutQuint(pos) {
        if ((pos /= 0.5) < 1) {
          return 0.5 * Math.pow(pos, 5);
        }
        return 0.5 * (Math.pow(pos - 2, 5) + 2);
      }
      function inSine(pos) {
        return -Math.cos(pos * (Math.PI / 2)) + 1;
      }
      function outSine(pos) {
        return Math.sin(pos * (Math.PI / 2));
      }
      function inOutSine(pos) {
        return -0.5 * (Math.cos(Math.PI * pos) - 1);
      }
      function inExpo(pos) {
        return pos === 0 ? 0 : Math.pow(2, 10 * (pos - 1));
      }
      function outExpo(pos) {
        return pos === 1 ? 1 : -Math.pow(2, -10 * pos) + 1;
      }
      function inOutExpo(pos) {
        if (pos === 0) {
          return 0;
        }
        if (pos === 1) {
          return 1;
        }
        if ((pos /= 0.5) < 1) {
          return 0.5 * Math.pow(2, 10 * (pos - 1));
        }
        return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
      }
      function inCirc(pos) {
        return -(Math.sqrt(1 - pos * pos) - 1);
      }
      function outCirc(pos) {
        return Math.sqrt(1 - Math.pow(pos - 1, 2));
      }
      function inOutCirc(pos) {
        if ((pos /= 0.5) < 1) {
          return -0.5 * (Math.sqrt(1 - pos * pos) - 1);
        }
        return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
      }
      function outBounce(pos) {
        if (pos < 1 / 2.75) {
          return 7.5625 * pos * pos;
        } else if (pos < 2 / 2.75) {
          return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
        } else if (pos < 2.5 / 2.75) {
          return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
        } else {
          return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
        }
      }
      function inBack(pos) {
        const s = magicSwing;
        return pos * pos * ((s + 1) * pos - s);
      }
      function outBack(pos) {
        const s = magicSwing;
        return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
      }
      function inOutBack(pos) {
        let s = magicSwing;
        if ((pos /= 0.5) < 1) {
          return 0.5 * (pos * pos * (((s *= 1.525) + 1) * pos - s));
        }
        return 0.5 * ((pos -= 2) * pos * (((s *= 1.525) + 1) * pos + s) + 2);
      }
      function inElastic(pos) {
        let s = magicSwing;
        let p = 0;
        let a = 1;
        if (pos === 0) {
          return 0;
        }
        if (pos === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        if (a < 1) {
          a = 1;
          s = p / 4;
        } else {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return -(a * Math.pow(2, 10 * (pos -= 1)) * Math.sin((pos - s) * (2 * Math.PI) / p));
      }
      function outElastic(pos) {
        let s = magicSwing;
        let p = 0;
        let a = 1;
        if (pos === 0) {
          return 0;
        }
        if (pos === 1) {
          return 1;
        }
        if (!p) {
          p = 0.3;
        }
        if (a < 1) {
          a = 1;
          s = p / 4;
        } else {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        return a * Math.pow(2, -10 * pos) * Math.sin((pos - s) * (2 * Math.PI) / p) + 1;
      }
      function inOutElastic(pos) {
        let s = magicSwing;
        let p = 0;
        let a = 1;
        if (pos === 0) {
          return 0;
        }
        if ((pos /= 1 / 2) === 2) {
          return 1;
        }
        if (!p) {
          p = 0.3 * 1.5;
        }
        if (a < 1) {
          a = 1;
          s = p / 4;
        } else {
          s = p / (2 * Math.PI) * Math.asin(1 / a);
        }
        if (pos < 1) {
          return -0.5 * (a * Math.pow(2, 10 * (pos -= 1)) * Math.sin((pos - s) * (2 * Math.PI) / p));
        }
        return a * Math.pow(2, -10 * (pos -= 1)) * Math.sin((pos - s) * (2 * Math.PI) / p) * 0.5 + 1;
      }
      function swingFromTo(pos) {
        let s = magicSwing;
        return (pos /= 0.5) < 1 ? 0.5 * (pos * pos * (((s *= 1.525) + 1) * pos - s)) : 0.5 * ((pos -= 2) * pos * (((s *= 1.525) + 1) * pos + s) + 2);
      }
      function swingFrom(pos) {
        const s = magicSwing;
        return pos * pos * ((s + 1) * pos - s);
      }
      function swingTo(pos) {
        const s = magicSwing;
        return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
      }
      function bounce(pos) {
        if (pos < 1 / 2.75) {
          return 7.5625 * pos * pos;
        } else if (pos < 2 / 2.75) {
          return 7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75;
        } else if (pos < 2.5 / 2.75) {
          return 7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375;
        } else {
          return 7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375;
        }
      }
      function bouncePast(pos) {
        if (pos < 1 / 2.75) {
          return 7.5625 * pos * pos;
        } else if (pos < 2 / 2.75) {
          return 2 - (7.5625 * (pos -= 1.5 / 2.75) * pos + 0.75);
        } else if (pos < 2.5 / 2.75) {
          return 2 - (7.5625 * (pos -= 2.25 / 2.75) * pos + 0.9375);
        } else {
          return 2 - (7.5625 * (pos -= 2.625 / 2.75) * pos + 0.984375);
        }
      }
    }
  });

  // packages/systems/ix2/shared/logic/IX2EasingUtils.js
  var require_IX2EasingUtils = __commonJS({
    "packages/systems/ix2/shared/logic/IX2EasingUtils.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      var _interopRequireWildcard = require_interopRequireWildcard().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.applyEasing = applyEasing;
      exports.createBezierEasing = createBezierEasing;
      exports.optimizeFloat = optimizeFloat;
      var easings = _interopRequireWildcard(require_IX2Easings());
      var _bezierEasing = _interopRequireDefault(require_src());
      function optimizeFloat(value, digits = 5, base = 10) {
        const pow = Math.pow(base, digits);
        const float = Number(Math.round(value * pow) / pow);
        return Math.abs(float) > 1e-4 ? float : 0;
      }
      function createBezierEasing(easing) {
        return (0, _bezierEasing.default)(...easing);
      }
      function applyEasing(easing, position, customEasingFn) {
        if (position === 0) {
          return 0;
        }
        if (position === 1) {
          return 1;
        }
        if (customEasingFn) {
          return optimizeFloat(position > 0 ? customEasingFn(position) : position);
        }
        return optimizeFloat(position > 0 && easing && easings[easing] ? easings[easing](position) : position);
      }
    }
  });

  // packages/systems/ix2/shared/reducers/IX2ElementsReducer.js
  var require_IX2ElementsReducer = __commonJS({
    "packages/systems/ix2/shared/reducers/IX2ElementsReducer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.createElementState = createElementState;
      exports.ixElements = void 0;
      exports.mergeActionState = mergeActionState;
      var _timm = require_timm();
      var _constants = require_constants();
      var {
        HTML_ELEMENT,
        PLAIN_OBJECT,
        ABSTRACT_NODE,
        CONFIG_X_VALUE,
        CONFIG_Y_VALUE,
        CONFIG_Z_VALUE,
        CONFIG_VALUE,
        CONFIG_X_UNIT,
        CONFIG_Y_UNIT,
        CONFIG_Z_UNIT,
        CONFIG_UNIT
      } = _constants.IX2EngineConstants;
      var {
        IX2_SESSION_STOPPED,
        IX2_INSTANCE_ADDED,
        IX2_ELEMENT_STATE_CHANGED
      } = _constants.IX2EngineActionTypes;
      var initialState = {};
      var refState = "refState";
      var ixElements = (state = initialState, action = {}) => {
        switch (action.type) {
          case IX2_SESSION_STOPPED: {
            return initialState;
          }
          case IX2_INSTANCE_ADDED: {
            const {
              elementId,
              element: ref,
              origin,
              actionItem,
              refType
            } = action.payload;
            const {
              actionTypeId
            } = actionItem;
            let newState = state;
            if ((0, _timm.getIn)(newState, [elementId, ref]) !== ref) {
              newState = createElementState(newState, ref, refType, elementId, actionItem);
            }
            return mergeActionState(newState, elementId, actionTypeId, origin, actionItem);
          }
          case IX2_ELEMENT_STATE_CHANGED: {
            const {
              elementId,
              actionTypeId,
              current,
              actionItem
            } = action.payload;
            return mergeActionState(state, elementId, actionTypeId, current, actionItem);
          }
          default: {
            return state;
          }
        }
      };
      exports.ixElements = ixElements;
      function createElementState(state, ref, refType, elementId, actionItem) {
        const refId = refType === PLAIN_OBJECT ? (0, _timm.getIn)(actionItem, ["config", "target", "objectId"]) : null;
        return (0, _timm.mergeIn)(state, [elementId], {
          id: elementId,
          ref,
          refId,
          refType
        });
      }
      function mergeActionState(state, elementId, actionTypeId, actionState, actionItem) {
        const units = pickUnits(actionItem);
        const mergePath = [elementId, refState, actionTypeId];
        return (0, _timm.mergeIn)(state, mergePath, actionState, units);
      }
      var valueUnitPairs = [[CONFIG_X_VALUE, CONFIG_X_UNIT], [CONFIG_Y_VALUE, CONFIG_Y_UNIT], [CONFIG_Z_VALUE, CONFIG_Z_UNIT], [CONFIG_VALUE, CONFIG_UNIT]];
      function pickUnits(actionItem) {
        const {
          config
        } = actionItem;
        return valueUnitPairs.reduce((result, pair) => {
          const valueKey = pair[0];
          const unitKey = pair[1];
          const configValue = config[valueKey];
          const configUnit = config[unitKey];
          if (configValue != null && configUnit != null) {
            result[unitKey] = configUnit;
          }
          return result;
        }, {});
      }
    }
  });

  // packages/systems/ix2/plugins/IX2Lottie.js
  var require_IX2Lottie = __commonJS({
    "packages/systems/ix2/plugins/IX2Lottie.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.renderPlugin = exports.getPluginOrigin = exports.getPluginDuration = exports.getPluginDestination = exports.getPluginConfig = exports.createPluginInstance = exports.clearPlugin = void 0;
      var getPluginConfig = (actionItemConfig) => {
        return actionItemConfig.value;
      };
      exports.getPluginConfig = getPluginConfig;
      var getPluginDuration = (element, actionItem) => {
        if (actionItem.config.duration !== "auto") {
          return null;
        }
        const duration = parseFloat(element.getAttribute("data-duration"));
        if (duration > 0) {
          return duration * 1e3;
        }
        return parseFloat(element.getAttribute("data-default-duration")) * 1e3;
      };
      exports.getPluginDuration = getPluginDuration;
      var getPluginOrigin = (refState) => {
        return refState || {
          value: 0
        };
      };
      exports.getPluginOrigin = getPluginOrigin;
      var getPluginDestination = (actionItemConfig) => {
        return {
          value: actionItemConfig.value
        };
      };
      exports.getPluginDestination = getPluginDestination;
      var createPluginInstance = (element) => {
        const instance = window.Webflow.require("lottie").createInstance(element);
        instance.stop();
        instance.setSubframe(true);
        return instance;
      };
      exports.createPluginInstance = createPluginInstance;
      var renderPlugin = (pluginInstance, refState, actionItem) => {
        if (!pluginInstance) {
          return;
        }
        const percent = refState[actionItem.actionTypeId].value / 100;
        pluginInstance.goToFrame(pluginInstance.frames * percent);
      };
      exports.renderPlugin = renderPlugin;
      var clearPlugin = (element) => {
        const instance = window.Webflow.require("lottie").createInstance(element);
        instance.stop();
      };
      exports.clearPlugin = clearPlugin;
    }
  });

  // packages/systems/ix2/plugins/IX2Spline.js
  var require_IX2Spline = __commonJS({
    "packages/systems/ix2/plugins/IX2Spline.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.renderPlugin = exports.getPluginOrigin = exports.getPluginDuration = exports.getPluginDestination = exports.getPluginConfig = exports.createPluginInstance = exports.clearPlugin = void 0;
      var queryContainerElement = (elementId) => document.querySelector(`[data-w-id="${elementId}"]`);
      var getFrontendModule = () => window.Webflow.require("spline");
      var difference = (arr1, arr2) => arr1.filter((x) => !arr2.includes(x));
      var getPluginConfig = (actionItemConfig, key) => {
        return actionItemConfig.value[key];
      };
      exports.getPluginConfig = getPluginConfig;
      var getPluginDuration = () => {
        return null;
      };
      exports.getPluginDuration = getPluginDuration;
      var DEFAULT_VALUES = Object.freeze({
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1
      });
      var getPluginOrigin = (refState, actionItem) => {
        const destination = actionItem.config.value;
        const destinationKeys = Object.keys(destination);
        if (refState) {
          const stateKeys = Object.keys(refState);
          const diffKeys = difference(destinationKeys, stateKeys);
          if (diffKeys.length) {
            const origin2 = diffKeys.reduce((result, key) => {
              result[key] = DEFAULT_VALUES[key];
              return result;
            }, refState);
            return origin2;
          }
          return refState;
        }
        const origin = destinationKeys.reduce((result, key) => {
          result[key] = DEFAULT_VALUES[key];
          return result;
        }, {});
        return origin;
      };
      exports.getPluginOrigin = getPluginOrigin;
      var getPluginDestination = (actionItemConfig) => {
        return actionItemConfig.value;
      };
      exports.getPluginDestination = getPluginDestination;
      var createPluginInstance = (element, actionItem) => {
        var _actionItem$config, _actionItem$config$ta;
        const pluginElementId = actionItem === null || actionItem === void 0 ? void 0 : (_actionItem$config = actionItem.config) === null || _actionItem$config === void 0 ? void 0 : (_actionItem$config$ta = _actionItem$config.target) === null || _actionItem$config$ta === void 0 ? void 0 : _actionItem$config$ta.pluginElement;
        return pluginElementId ? queryContainerElement(pluginElementId) : null;
      };
      exports.createPluginInstance = createPluginInstance;
      var renderPlugin = (containerElement, refState, actionItem) => {
        const instance = getFrontendModule().getInstance(containerElement);
        const objectId = actionItem.config.target.objectId;
        if (!instance || !objectId) {
          return;
        }
        const obj = instance.spline.findObjectById(objectId);
        if (!obj) {
          return;
        }
        const {
          PLUGIN_SPLINE: props
        } = refState;
        if (props.positionX != null) {
          obj.position.x = props.positionX;
        }
        if (props.positionY != null) {
          obj.position.y = props.positionY;
        }
        if (props.positionZ != null) {
          obj.position.z = props.positionZ;
        }
        if (props.rotationX != null) {
          obj.rotation.x = props.rotationX;
        }
        if (props.rotationY != null) {
          obj.rotation.y = props.rotationY;
        }
        if (props.rotationZ != null) {
          obj.rotation.z = props.rotationZ;
        }
        if (props.scaleX != null) {
          obj.scale.x = props.scaleX;
        }
        if (props.scaleY != null) {
          obj.scale.y = props.scaleY;
        }
        if (props.scaleZ != null) {
          obj.scale.z = props.scaleZ;
        }
      };
      exports.renderPlugin = renderPlugin;
      var clearPlugin = () => {
        return null;
      };
      exports.clearPlugin = clearPlugin;
    }
  });

  // packages/systems/ix2/plugins/IX2Variable.js
  var require_IX2Variable = __commonJS({
    "packages/systems/ix2/plugins/IX2Variable.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getPluginOrigin = exports.getPluginDuration = exports.getPluginDestination = exports.getPluginConfig = exports.createPluginInstance = exports.clearPlugin = void 0;
      exports.normalizeColor = normalizeColor;
      exports.renderPlugin = void 0;
      function normalizeColor(inputColor) {
        let red;
        let green;
        let blue;
        let alpha = 1;
        const cleanColor = inputColor.replace(/\s/g, "").toLowerCase();
        if (cleanColor.startsWith("#")) {
          const hex = cleanColor.substring(1);
          if (hex.length === 3) {
            red = parseInt(hex[0] + hex[0], 16);
            green = parseInt(hex[1] + hex[1], 16);
            blue = parseInt(hex[2] + hex[2], 16);
          } else if (hex.length === 6) {
            red = parseInt(hex.substring(0, 2), 16);
            green = parseInt(hex.substring(2, 4), 16);
            blue = parseInt(hex.substring(4, 6), 16);
          }
        } else if (cleanColor.startsWith("rgba")) {
          const rgbaValues = cleanColor.match(/rgba\(([^)]+)\)/)[1].split(",");
          red = parseInt(rgbaValues[0], 10);
          green = parseInt(rgbaValues[1], 10);
          blue = parseInt(rgbaValues[2], 10);
          alpha = parseFloat(rgbaValues[3]);
        } else if (cleanColor.startsWith("rgb")) {
          const rgbValues = cleanColor.match(/rgb\(([^)]+)\)/)[1].split(",");
          red = parseInt(rgbValues[0], 10);
          green = parseInt(rgbValues[1], 10);
          blue = parseInt(rgbValues[2], 10);
        } else if (cleanColor.startsWith("hsla")) {
          const hslaValues = cleanColor.match(/hsla\(([^)]+)\)/)[1].split(",");
          const h = parseFloat(hslaValues[0]);
          const s = parseFloat(hslaValues[1].replace("%", "")) / 100;
          const l = parseFloat(hslaValues[2].replace("%", "")) / 100;
          alpha = parseFloat(hslaValues[3]);
          const C = (1 - Math.abs(2 * l - 1)) * s;
          const X = C * (1 - Math.abs(h / 60 % 2 - 1));
          const m = l - C / 2;
          let R;
          let G;
          let B;
          if (h >= 0 && h < 60) {
            R = C;
            G = X;
            B = 0;
          } else if (h >= 60 && h < 120) {
            R = X;
            G = C;
            B = 0;
          } else if (h >= 120 && h < 180) {
            R = 0;
            G = C;
            B = X;
          } else if (h >= 180 && h < 240) {
            R = 0;
            G = X;
            B = C;
          } else if (h >= 240 && h < 300) {
            R = X;
            G = 0;
            B = C;
          } else {
            R = C;
            G = 0;
            B = X;
          }
          red = Math.round((R + m) * 255);
          green = Math.round((G + m) * 255);
          blue = Math.round((B + m) * 255);
        } else if (cleanColor.startsWith("hsl")) {
          const hslValues = cleanColor.match(/hsl\(([^)]+)\)/)[1].split(",");
          const h = parseFloat(hslValues[0]);
          const s = parseFloat(hslValues[1].replace("%", "")) / 100;
          const l = parseFloat(hslValues[2].replace("%", "")) / 100;
          const C = (1 - Math.abs(2 * l - 1)) * s;
          const X = C * (1 - Math.abs(h / 60 % 2 - 1));
          const m = l - C / 2;
          let R;
          let G;
          let B;
          if (h >= 0 && h < 60) {
            R = C;
            G = X;
            B = 0;
          } else if (h >= 60 && h < 120) {
            R = X;
            G = C;
            B = 0;
          } else if (h >= 120 && h < 180) {
            R = 0;
            G = C;
            B = X;
          } else if (h >= 180 && h < 240) {
            R = 0;
            G = X;
            B = C;
          } else if (h >= 240 && h < 300) {
            R = X;
            G = 0;
            B = C;
          } else {
            R = C;
            G = 0;
            B = X;
          }
          red = Math.round((R + m) * 255);
          green = Math.round((G + m) * 255);
          blue = Math.round((B + m) * 255);
        }
        if (Number.isNaN(red) || Number.isNaN(green) || Number.isNaN(blue)) {
          `Invalid color in [ix2/lugins/IX2Variable.js] '${inputColor}'`;
        }
        return {
          red,
          green,
          blue,
          alpha
        };
      }
      var getPluginConfig = (actionItemConfig, key) => {
        return actionItemConfig.value[key];
      };
      exports.getPluginConfig = getPluginConfig;
      var getPluginDuration = () => {
        return null;
      };
      exports.getPluginDuration = getPluginDuration;
      var getPluginOrigin = (refState, actionItem) => {
        if (refState) {
          return refState;
        }
        const destination = actionItem.config.value;
        const objectId = actionItem.config.target.objectId;
        const computedValue = getComputedStyle(document.documentElement).getPropertyValue(objectId);
        if (destination.size != null) {
          return {
            size: parseInt(computedValue, 10)
          };
        }
        if (destination.red != null && destination.green != null && destination.blue != null) {
          return normalizeColor(computedValue);
        }
      };
      exports.getPluginOrigin = getPluginOrigin;
      var getPluginDestination = (actionItemConfig) => {
        return actionItemConfig.value;
      };
      exports.getPluginDestination = getPluginDestination;
      var createPluginInstance = () => {
        return null;
      };
      exports.createPluginInstance = createPluginInstance;
      var renderPlugin = (_, refState, actionItem) => {
        const objectId = actionItem.config.target.objectId;
        const unit = actionItem.config.value.unit;
        const {
          PLUGIN_VARIABLE: props
        } = refState;
        const {
          size,
          red,
          green,
          blue,
          alpha
        } = props;
        let value;
        if (size != null) {
          value = size + unit;
        }
        if (red != null && blue != null && green != null && alpha != null) {
          value = `rgba(${red}, ${green}, ${blue}, ${alpha})`;
        }
        if (value != null) {
          document.documentElement.style.setProperty(objectId, value);
        }
      };
      exports.renderPlugin = renderPlugin;
      var clearPlugin = (ref, actionItem) => {
        const objectId = actionItem.config.target.objectId;
        document.documentElement.style.removeProperty(objectId);
      };
      exports.clearPlugin = clearPlugin;
    }
  });

  // packages/systems/ix2/plugins/index.js
  var require_plugins = __commonJS({
    "packages/systems/ix2/plugins/index.js"(exports) {
      "use strict";
      var _interopRequireWildcard = require_interopRequireWildcard().default;
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.pluginMethodMap = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _constants = require_constants();
      var lottie = _interopRequireWildcard(require_IX2Lottie());
      var spline = _interopRequireWildcard(require_IX2Spline());
      var variable = _interopRequireWildcard(require_IX2Variable());
      var pluginMethodMap = /* @__PURE__ */ new Map([[_constants.ActionTypeConsts.PLUGIN_LOTTIE, (0, _extends2.default)({}, lottie)], [_constants.ActionTypeConsts.PLUGIN_SPLINE, (0, _extends2.default)({}, spline)], [_constants.ActionTypeConsts.PLUGIN_VARIABLE, (0, _extends2.default)({}, variable)]]);
      exports.pluginMethodMap = pluginMethodMap;
    }
  });

  // packages/systems/ix2/shared/logic/IX2VanillaPlugins.js
  var require_IX2VanillaPlugins = __commonJS({
    "packages/systems/ix2/shared/logic/IX2VanillaPlugins.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getPluginOrigin = exports.getPluginDuration = exports.getPluginDestination = exports.getPluginConfig = exports.createPluginInstance = exports.clearPlugin = void 0;
      exports.isPluginType = isPluginType;
      exports.renderPlugin = void 0;
      var _IX2BrowserSupport = require_IX2BrowserSupport();
      var _plugins = require_plugins();
      function isPluginType(actionTypeId) {
        return _plugins.pluginMethodMap.has(actionTypeId);
      }
      var pluginMethod = (methodName) => (actionTypeId) => {
        if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
          return () => null;
        }
        const plugin = _plugins.pluginMethodMap.get(actionTypeId);
        if (!plugin) {
          throw new Error(`IX2 no plugin configured for: ${actionTypeId}`);
        }
        const method = plugin[methodName];
        if (!method) {
          throw new Error(`IX2 invalid plugin method: ${methodName}`);
        }
        return method;
      };
      var getPluginConfig = pluginMethod("getPluginConfig");
      exports.getPluginConfig = getPluginConfig;
      var getPluginOrigin = pluginMethod("getPluginOrigin");
      exports.getPluginOrigin = getPluginOrigin;
      var getPluginDuration = pluginMethod("getPluginDuration");
      exports.getPluginDuration = getPluginDuration;
      var getPluginDestination = pluginMethod("getPluginDestination");
      exports.getPluginDestination = getPluginDestination;
      var createPluginInstance = pluginMethod("createPluginInstance");
      exports.createPluginInstance = createPluginInstance;
      var renderPlugin = pluginMethod("renderPlugin");
      exports.renderPlugin = renderPlugin;
      var clearPlugin = pluginMethod("clearPlugin");
      exports.clearPlugin = clearPlugin;
    }
  });

  // node_modules/lodash/defaultTo.js
  var require_defaultTo = __commonJS({
    "node_modules/lodash/defaultTo.js"(exports, module) {
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      module.exports = defaultTo;
    }
  });

  // node_modules/lodash/_arrayReduce.js
  var require_arrayReduce = __commonJS({
    "node_modules/lodash/_arrayReduce.js"(exports, module) {
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length2 = array == null ? 0 : array.length;
        if (initAccum && length2) {
          accumulator = array[++index];
        }
        while (++index < length2) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      module.exports = arrayReduce;
    }
  });

  // node_modules/lodash/_createBaseFor.js
  var require_createBaseFor = __commonJS({
    "node_modules/lodash/_createBaseFor.js"(exports, module) {
      function createBaseFor(fromRight) {
        return function(object, iteratee, keysFunc) {
          var index = -1, iterable = Object(object), props = keysFunc(object), length2 = props.length;
          while (length2--) {
            var key = props[fromRight ? length2 : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      module.exports = createBaseFor;
    }
  });

  // node_modules/lodash/_baseFor.js
  var require_baseFor = __commonJS({
    "node_modules/lodash/_baseFor.js"(exports, module) {
      var createBaseFor = require_createBaseFor();
      var baseFor = createBaseFor();
      module.exports = baseFor;
    }
  });

  // node_modules/lodash/_baseForOwn.js
  var require_baseForOwn = __commonJS({
    "node_modules/lodash/_baseForOwn.js"(exports, module) {
      var baseFor = require_baseFor();
      var keys = require_keys();
      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }
      module.exports = baseForOwn;
    }
  });

  // node_modules/lodash/_createBaseEach.js
  var require_createBaseEach = __commonJS({
    "node_modules/lodash/_createBaseEach.js"(exports, module) {
      var isArrayLike = require_isArrayLike();
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }
          var length2 = collection.length, index = fromRight ? length2 : -1, iterable = Object(collection);
          while (fromRight ? index-- : ++index < length2) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      module.exports = createBaseEach;
    }
  });

  // node_modules/lodash/_baseEach.js
  var require_baseEach = __commonJS({
    "node_modules/lodash/_baseEach.js"(exports, module) {
      var baseForOwn = require_baseForOwn();
      var createBaseEach = require_createBaseEach();
      var baseEach = createBaseEach(baseForOwn);
      module.exports = baseEach;
    }
  });

  // node_modules/lodash/_baseReduce.js
  var require_baseReduce = __commonJS({
    "node_modules/lodash/_baseReduce.js"(exports, module) {
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      module.exports = baseReduce;
    }
  });

  // node_modules/lodash/reduce.js
  var require_reduce = __commonJS({
    "node_modules/lodash/reduce.js"(exports, module) {
      var arrayReduce = require_arrayReduce();
      var baseEach = require_baseEach();
      var baseIteratee = require_baseIteratee();
      var baseReduce = require_baseReduce();
      var isArray = require_isArray();
      function reduce2(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
        return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }
      module.exports = reduce2;
    }
  });

  // node_modules/lodash/findLastIndex.js
  var require_findLastIndex = __commonJS({
    "node_modules/lodash/findLastIndex.js"(exports, module) {
      var baseFindIndex = require_baseFindIndex();
      var baseIteratee = require_baseIteratee();
      var toInteger = require_toInteger();
      var nativeMax = Math.max;
      var nativeMin = Math.min;
      function findLastIndex(array, predicate, fromIndex) {
        var length2 = array == null ? 0 : array.length;
        if (!length2) {
          return -1;
        }
        var index = length2 - 1;
        if (fromIndex !== void 0) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length2 + index, 0) : nativeMin(index, length2 - 1);
        }
        return baseFindIndex(array, baseIteratee(predicate, 3), index, true);
      }
      module.exports = findLastIndex;
    }
  });

  // node_modules/lodash/findLast.js
  var require_findLast = __commonJS({
    "node_modules/lodash/findLast.js"(exports, module) {
      var createFind = require_createFind();
      var findLastIndex = require_findLastIndex();
      var findLast = createFind(findLastIndex);
      module.exports = findLast;
    }
  });

  // packages/systems/ix2/shared/logic/shallowEqual.js
  var require_shallowEqual = __commonJS({
    "packages/systems/ix2/shared/logic/shallowEqual.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var hasOwnProperty3 = Object.prototype.hasOwnProperty;
      function is2(x, y) {
        if (x === y) {
          return x !== 0 || y !== 0 || 1 / x === 1 / y;
        }
        return x !== x && y !== y;
      }
      function shallowEqual(objA, objB) {
        if (is2(objA, objB)) {
          return true;
        }
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) {
          return false;
        }
        const keysA = Object.keys(objA);
        const keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) {
          return false;
        }
        for (let i = 0; i < keysA.length; i++) {
          if (!hasOwnProperty3.call(objB, keysA[i]) || !is2(objA[keysA[i]], objB[keysA[i]])) {
            return false;
          }
        }
        return true;
      }
      var _default = shallowEqual;
      exports.default = _default;
    }
  });

  // packages/systems/ix2/shared/logic/IX2VanillaUtils.js
  var require_IX2VanillaUtils = __commonJS({
    "packages/systems/ix2/shared/logic/IX2VanillaUtils.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.cleanupHTMLElement = cleanupHTMLElement;
      exports.clearAllStyles = clearAllStyles;
      exports.clearObjectCache = clearObjectCache;
      exports.getActionListProgress = getActionListProgress;
      exports.getAffectedElements = getAffectedElements;
      exports.getComputedStyle = getComputedStyle2;
      exports.getDestinationValues = getDestinationValues;
      exports.getElementId = getElementId;
      exports.getInstanceId = getInstanceId;
      exports.getInstanceOrigin = getInstanceOrigin;
      exports.getItemConfigByKey = void 0;
      exports.getMaxDurationItemIndex = getMaxDurationItemIndex;
      exports.getNamespacedParameterId = getNamespacedParameterId;
      exports.getRenderType = getRenderType;
      exports.getStyleProp = getStyleProp;
      exports.mediaQueriesEqual = mediaQueriesEqual;
      exports.observeStore = observeStore;
      exports.reduceListToGroup = reduceListToGroup;
      exports.reifyState = reifyState;
      exports.renderHTMLElement = renderHTMLElement;
      Object.defineProperty(exports, "shallowEqual", {
        enumerable: true,
        get: function() {
          return _shallowEqual.default;
        }
      });
      exports.shouldAllowMediaQuery = shouldAllowMediaQuery;
      exports.shouldNamespaceEventParameter = shouldNamespaceEventParameter;
      exports.stringifyTarget = stringifyTarget;
      var _defaultTo = _interopRequireDefault(require_defaultTo());
      var _reduce = _interopRequireDefault(require_reduce());
      var _findLast = _interopRequireDefault(require_findLast());
      var _timm = require_timm();
      var _constants = require_constants();
      var _shallowEqual = _interopRequireDefault(require_shallowEqual());
      var _IX2EasingUtils = require_IX2EasingUtils();
      var _IX2VanillaPlugins = require_IX2VanillaPlugins();
      var _IX2BrowserSupport = require_IX2BrowserSupport();
      var {
        BACKGROUND,
        TRANSFORM,
        TRANSLATE_3D,
        SCALE_3D,
        ROTATE_X,
        ROTATE_Y,
        ROTATE_Z,
        SKEW,
        PRESERVE_3D,
        FLEX,
        OPACITY,
        FILTER,
        FONT_VARIATION_SETTINGS,
        WIDTH,
        HEIGHT,
        BACKGROUND_COLOR,
        BORDER_COLOR,
        COLOR,
        CHILDREN,
        IMMEDIATE_CHILDREN,
        SIBLINGS,
        PARENT,
        DISPLAY,
        WILL_CHANGE,
        AUTO,
        COMMA_DELIMITER,
        COLON_DELIMITER,
        BAR_DELIMITER,
        RENDER_TRANSFORM,
        RENDER_GENERAL,
        RENDER_STYLE,
        RENDER_PLUGIN
      } = _constants.IX2EngineConstants;
      var {
        TRANSFORM_MOVE,
        TRANSFORM_SCALE,
        TRANSFORM_ROTATE,
        TRANSFORM_SKEW,
        STYLE_OPACITY,
        STYLE_FILTER,
        STYLE_FONT_VARIATION,
        STYLE_SIZE,
        STYLE_BACKGROUND_COLOR,
        STYLE_BORDER,
        STYLE_TEXT_COLOR,
        GENERAL_DISPLAY,
        OBJECT_VALUE
      } = _constants.ActionTypeConsts;
      var trim = (v) => v.trim();
      var colorStyleProps = Object.freeze({
        [STYLE_BACKGROUND_COLOR]: BACKGROUND_COLOR,
        [STYLE_BORDER]: BORDER_COLOR,
        [STYLE_TEXT_COLOR]: COLOR
      });
      var willChangeProps = Object.freeze({
        // $FlowFixMe
        [_IX2BrowserSupport.TRANSFORM_PREFIXED]: TRANSFORM,
        [BACKGROUND_COLOR]: BACKGROUND,
        [OPACITY]: OPACITY,
        [FILTER]: FILTER,
        [WIDTH]: WIDTH,
        [HEIGHT]: HEIGHT,
        [FONT_VARIATION_SETTINGS]: FONT_VARIATION_SETTINGS
      });
      var objectCache = /* @__PURE__ */ new Map();
      function clearObjectCache() {
        objectCache.clear();
      }
      var instanceCount = 1;
      function getInstanceId() {
        return "i" + instanceCount++;
      }
      var elementCount = 1;
      function getElementId(ixElements, ref) {
        for (const key in ixElements) {
          const ixEl = ixElements[key];
          if (ixEl && ixEl.ref === ref) {
            return ixEl.id;
          }
        }
        return "e" + elementCount++;
      }
      function reifyState({
        events,
        actionLists,
        site
      } = {}) {
        const eventTypeMap = (0, _reduce.default)(events, (result, event) => {
          const {
            eventTypeId
          } = event;
          if (!result[eventTypeId]) {
            result[eventTypeId] = {};
          }
          result[eventTypeId][event.id] = event;
          return result;
        }, {});
        let mediaQueries = site && site.mediaQueries;
        let mediaQueryKeys = [];
        if (mediaQueries) {
          mediaQueryKeys = mediaQueries.map((mq) => mq.key);
        } else {
          mediaQueries = [];
          console.warn(`IX2 missing mediaQueries in site data`);
        }
        return {
          ixData: {
            events,
            actionLists,
            eventTypeMap,
            mediaQueries,
            mediaQueryKeys
          }
        };
      }
      var strictEqual = (a, b) => a === b;
      function observeStore({
        store,
        select,
        onChange,
        comparator = strictEqual
      }) {
        const {
          getState,
          subscribe
        } = store;
        const unsubscribe = subscribe(handleChange);
        let currentState = select(getState());
        function handleChange() {
          const nextState = select(getState());
          if (nextState == null) {
            unsubscribe();
            return;
          }
          if (!comparator(nextState, currentState)) {
            currentState = nextState;
            onChange(currentState, store);
          }
        }
        return unsubscribe;
      }
      function normalizeTarget(target) {
        const type = typeof target;
        if (type === "string") {
          return {
            id: target
          };
        } else if (target != null && type === "object") {
          const {
            id,
            objectId,
            selector,
            selectorGuids,
            appliesTo,
            useEventTarget
          } = target;
          return {
            id,
            objectId,
            selector,
            selectorGuids,
            appliesTo,
            useEventTarget
          };
        }
        return {};
      }
      function getAffectedElements({
        config,
        event,
        eventTarget,
        elementRoot,
        elementApi
      }) {
        var _event$action$config$, _event$action, _event$action$config;
        if (!elementApi) {
          throw new Error("IX2 missing elementApi");
        }
        const {
          targets
        } = config;
        if (Array.isArray(targets) && targets.length > 0) {
          return targets.reduce((accumulator, target2) => accumulator.concat(getAffectedElements({
            config: {
              target: target2
            },
            event,
            eventTarget,
            elementRoot,
            elementApi
          })), []);
        }
        const {
          getValidDocument,
          getQuerySelector,
          queryDocument,
          getChildElements,
          getSiblingElements,
          matchSelector,
          elementContains,
          isSiblingNode
        } = elementApi;
        const {
          target
        } = config;
        if (!target) {
          return [];
        }
        const {
          id,
          // $FlowFixMe
          objectId,
          // $FlowFixMe
          selector,
          // $FlowFixMe
          selectorGuids,
          // $FlowFixMe
          appliesTo,
          // $FlowFixMe
          useEventTarget
        } = normalizeTarget(target);
        if (objectId) {
          const ref = objectCache.has(objectId) ? objectCache.get(objectId) : objectCache.set(objectId, {}).get(objectId);
          return [ref];
        }
        if (appliesTo === _constants.EventAppliesTo.PAGE) {
          const doc = getValidDocument(id);
          return doc ? [doc] : [];
        }
        const overrides = (_event$action$config$ = event === null || event === void 0 ? void 0 : (_event$action = event.action) === null || _event$action === void 0 ? void 0 : (_event$action$config = _event$action.config) === null || _event$action$config === void 0 ? void 0 : _event$action$config.affectedElements) !== null && _event$action$config$ !== void 0 ? _event$action$config$ : {};
        const override = overrides[id || selector] || {};
        const validOverride = Boolean(override.id || override.selector);
        let limitAffectedElements;
        let baseSelector;
        let finalSelector;
        const eventTargetSelector = event && getQuerySelector(normalizeTarget(event.target));
        if (validOverride) {
          limitAffectedElements = override.limitAffectedElements;
          baseSelector = eventTargetSelector;
          finalSelector = getQuerySelector(override);
        } else {
          baseSelector = finalSelector = getQuerySelector({
            id,
            selector,
            selectorGuids
          });
        }
        if (event && useEventTarget) {
          const eventTargets = eventTarget && (finalSelector || useEventTarget === true) ? [eventTarget] : queryDocument(eventTargetSelector);
          if (finalSelector) {
            if (useEventTarget === PARENT) {
              return queryDocument(finalSelector).filter((parentElement) => eventTargets.some((targetElement) => elementContains(parentElement, targetElement)));
            }
            if (useEventTarget === CHILDREN) {
              return queryDocument(finalSelector).filter((childElement) => eventTargets.some((targetElement) => elementContains(targetElement, childElement)));
            }
            if (useEventTarget === SIBLINGS) {
              return queryDocument(finalSelector).filter((siblingElement) => eventTargets.some((targetElement) => isSiblingNode(targetElement, siblingElement)));
            }
          }
          return eventTargets;
        }
        if (baseSelector == null || finalSelector == null) {
          return [];
        }
        if (_IX2BrowserSupport.IS_BROWSER_ENV && elementRoot) {
          return queryDocument(finalSelector).filter((element) => elementRoot.contains(element));
        }
        if (limitAffectedElements === CHILDREN) {
          return queryDocument(baseSelector, finalSelector);
        } else if (limitAffectedElements === IMMEDIATE_CHILDREN) {
          return getChildElements(queryDocument(baseSelector)).filter(matchSelector(finalSelector));
        } else if (limitAffectedElements === SIBLINGS) {
          return getSiblingElements(queryDocument(baseSelector)).filter(matchSelector(finalSelector));
        } else {
          return queryDocument(finalSelector);
        }
      }
      function getComputedStyle2({
        element,
        actionItem
      }) {
        if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
          return {};
        }
        const {
          actionTypeId
        } = actionItem;
        switch (actionTypeId) {
          case STYLE_SIZE:
          case STYLE_BACKGROUND_COLOR:
          case STYLE_BORDER:
          case STYLE_TEXT_COLOR:
          case GENERAL_DISPLAY:
            return window.getComputedStyle(element);
          default:
            return {};
        }
      }
      var pxValueRegex = /px/;
      var getFilterDefaults = (actionState, filters) => filters.reduce((result, filter2) => {
        if (result[filter2.type] == null) {
          result[filter2.type] = filterDefaults[
            // $FlowFixMe - property `saturation` (did you mean `saturate`?) is missing in `filterDefaults`
            filter2.type
          ];
        }
        return result;
      }, actionState || {});
      var getFontVariationDefaults = (actionState, fontVariations) => fontVariations.reduce((result, fontVariation) => {
        if (result[fontVariation.type] == null) {
          result[fontVariation.type] = fontVariationDefaults[fontVariation.type] || fontVariation.defaultValue || 0;
        }
        return result;
      }, actionState || {});
      function getInstanceOrigin(element, refState = {}, computedStyle = {}, actionItem, elementApi) {
        const {
          getStyle
        } = elementApi;
        const {
          actionTypeId
        } = actionItem;
        if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
          return (0, _IX2VanillaPlugins.getPluginOrigin)(actionTypeId)(refState[actionTypeId], actionItem);
        }
        switch (actionItem.actionTypeId) {
          case TRANSFORM_MOVE:
          case TRANSFORM_SCALE:
          case TRANSFORM_ROTATE:
          case TRANSFORM_SKEW: {
            return refState[actionItem.actionTypeId] || transformDefaults[actionItem.actionTypeId];
          }
          case STYLE_FILTER:
            return getFilterDefaults(refState[actionItem.actionTypeId], actionItem.config.filters);
          case STYLE_FONT_VARIATION:
            return getFontVariationDefaults(refState[actionItem.actionTypeId], actionItem.config.fontVariations);
          case STYLE_OPACITY:
            return {
              value: (0, _defaultTo.default)(parseFloat(getStyle(element, OPACITY)), 1)
            };
          case STYLE_SIZE: {
            const inlineWidth = getStyle(element, WIDTH);
            const inlineHeight = getStyle(element, HEIGHT);
            let widthValue;
            let heightValue;
            if (actionItem.config.widthUnit === AUTO) {
              widthValue = pxValueRegex.test(inlineWidth) ? parseFloat(inlineWidth) : parseFloat(computedStyle.width);
            } else {
              widthValue = (0, _defaultTo.default)(parseFloat(inlineWidth), parseFloat(computedStyle.width));
            }
            if (actionItem.config.heightUnit === AUTO) {
              heightValue = pxValueRegex.test(inlineHeight) ? parseFloat(inlineHeight) : parseFloat(computedStyle.height);
            } else {
              heightValue = (0, _defaultTo.default)(parseFloat(inlineHeight), parseFloat(computedStyle.height));
            }
            return {
              widthValue,
              heightValue
            };
          }
          case STYLE_BACKGROUND_COLOR:
          case STYLE_BORDER:
          case STYLE_TEXT_COLOR:
            return parseColor({
              element,
              actionTypeId: actionItem.actionTypeId,
              computedStyle,
              getStyle
            });
          case GENERAL_DISPLAY:
            return {
              value: (0, _defaultTo.default)(getStyle(element, DISPLAY), computedStyle.display)
            };
          case OBJECT_VALUE:
            return refState[actionItem.actionTypeId] || {
              value: 0
            };
          default: {
            return;
          }
        }
      }
      var reduceFilters = (result, filter2) => {
        if (filter2) {
          result[filter2.type] = filter2.value || 0;
        }
        return result;
      };
      var reduceFontVariations = (result, fontVariation) => {
        if (fontVariation) {
          result[fontVariation.type] = fontVariation.value || 0;
        }
        return result;
      };
      var getItemConfigByKey = (actionTypeId, key, config) => {
        if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
          return (0, _IX2VanillaPlugins.getPluginConfig)(actionTypeId)(config, key);
        }
        switch (actionTypeId) {
          case STYLE_FILTER: {
            const filter2 = (0, _findLast.default)(config.filters, ({
              type
            }) => type === key);
            return filter2 ? filter2.value : 0;
          }
          case STYLE_FONT_VARIATION: {
            const fontVariation = (0, _findLast.default)(config.fontVariations, ({
              type
            }) => type === key);
            return fontVariation ? fontVariation.value : 0;
          }
          default:
            return config[key];
        }
      };
      exports.getItemConfigByKey = getItemConfigByKey;
      function getDestinationValues({
        element,
        actionItem,
        elementApi
      }) {
        if ((0, _IX2VanillaPlugins.isPluginType)(actionItem.actionTypeId)) {
          return (0, _IX2VanillaPlugins.getPluginDestination)(actionItem.actionTypeId)(actionItem.config);
        }
        switch (actionItem.actionTypeId) {
          case TRANSFORM_MOVE:
          case TRANSFORM_SCALE:
          case TRANSFORM_ROTATE:
          case TRANSFORM_SKEW: {
            const {
              xValue,
              yValue,
              zValue
            } = actionItem.config;
            return {
              xValue,
              yValue,
              zValue
            };
          }
          case STYLE_SIZE: {
            const {
              getStyle,
              setStyle,
              getProperty
            } = elementApi;
            const {
              widthUnit,
              heightUnit
            } = actionItem.config;
            let {
              widthValue,
              heightValue
            } = actionItem.config;
            if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
              return {
                widthValue,
                heightValue
              };
            }
            if (widthUnit === AUTO) {
              const temp = getStyle(element, WIDTH);
              setStyle(element, WIDTH, "");
              widthValue = getProperty(element, "offsetWidth");
              setStyle(element, WIDTH, temp);
            }
            if (heightUnit === AUTO) {
              const temp = getStyle(element, HEIGHT);
              setStyle(element, HEIGHT, "");
              heightValue = getProperty(element, "offsetHeight");
              setStyle(element, HEIGHT, temp);
            }
            return {
              widthValue,
              heightValue
            };
          }
          case STYLE_BACKGROUND_COLOR:
          case STYLE_BORDER:
          case STYLE_TEXT_COLOR: {
            const {
              rValue,
              gValue,
              bValue,
              aValue
            } = actionItem.config;
            return {
              rValue,
              gValue,
              bValue,
              aValue
            };
          }
          case STYLE_FILTER: {
            return actionItem.config.filters.reduce(reduceFilters, {});
          }
          case STYLE_FONT_VARIATION: {
            return actionItem.config.fontVariations.reduce(reduceFontVariations, {});
          }
          default: {
            const {
              value
            } = actionItem.config;
            return {
              value
            };
          }
        }
      }
      function getRenderType(actionTypeId) {
        if (/^TRANSFORM_/.test(actionTypeId)) {
          return RENDER_TRANSFORM;
        }
        if (/^STYLE_/.test(actionTypeId)) {
          return RENDER_STYLE;
        }
        if (/^GENERAL_/.test(actionTypeId)) {
          return RENDER_GENERAL;
        }
        if (/^PLUGIN_/.test(actionTypeId)) {
          return RENDER_PLUGIN;
        }
      }
      function getStyleProp(renderType, actionTypeId) {
        return renderType === RENDER_STYLE ? actionTypeId.replace("STYLE_", "").toLowerCase() : null;
      }
      function renderHTMLElement(element, refState, actionState, eventId, actionItem, styleProp, elementApi, renderType, pluginInstance) {
        switch (renderType) {
          case RENDER_TRANSFORM: {
            return renderTransform(element, refState, actionState, actionItem, elementApi);
          }
          case RENDER_STYLE: {
            return renderStyle(element, refState, actionState, actionItem, styleProp, elementApi);
          }
          case RENDER_GENERAL: {
            return renderGeneral(element, actionItem, elementApi);
          }
          case RENDER_PLUGIN: {
            const {
              actionTypeId
            } = actionItem;
            if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
              return (0, _IX2VanillaPlugins.renderPlugin)(actionTypeId)(pluginInstance, refState, actionItem);
            }
          }
        }
      }
      var transformDefaults = {
        [TRANSFORM_MOVE]: Object.freeze({
          xValue: 0,
          yValue: 0,
          zValue: 0
        }),
        [TRANSFORM_SCALE]: Object.freeze({
          xValue: 1,
          yValue: 1,
          zValue: 1
        }),
        [TRANSFORM_ROTATE]: Object.freeze({
          xValue: 0,
          yValue: 0,
          zValue: 0
        }),
        [TRANSFORM_SKEW]: Object.freeze({
          xValue: 0,
          yValue: 0
        })
      };
      var filterDefaults = Object.freeze({
        blur: 0,
        "hue-rotate": 0,
        invert: 0,
        grayscale: 0,
        saturate: 100,
        sepia: 0,
        contrast: 100,
        brightness: 100
      });
      var fontVariationDefaults = Object.freeze({
        wght: 0,
        opsz: 0,
        wdth: 0,
        slnt: 0
      });
      var getFilterUnit = (filterType, actionItemConfig) => {
        const filter2 = (0, _findLast.default)(actionItemConfig.filters, ({
          type
        }) => type === filterType);
        if (filter2 && filter2.unit) {
          return filter2.unit;
        }
        switch (filterType) {
          case "blur":
            return "px";
          case "hue-rotate":
            return "deg";
          default:
            return "%";
        }
      };
      var transformKeys = Object.keys(transformDefaults);
      function renderTransform(element, refState, actionState, actionItem, elementApi) {
        const newTransform = transformKeys.map((actionTypeId) => {
          const defaults = transformDefaults[actionTypeId];
          const {
            xValue = defaults.xValue,
            yValue = defaults.yValue,
            // $FlowFixMe
            zValue = defaults.zValue,
            xUnit = "",
            yUnit = "",
            zUnit = ""
          } = refState[actionTypeId] || {};
          switch (actionTypeId) {
            case TRANSFORM_MOVE:
              return `${TRANSLATE_3D}(${xValue}${xUnit}, ${yValue}${yUnit}, ${zValue}${zUnit})`;
            case TRANSFORM_SCALE:
              return `${SCALE_3D}(${xValue}${xUnit}, ${yValue}${yUnit}, ${zValue}${zUnit})`;
            case TRANSFORM_ROTATE:
              return `${ROTATE_X}(${xValue}${xUnit}) ${ROTATE_Y}(${yValue}${yUnit}) ${ROTATE_Z}(${zValue}${zUnit})`;
            case TRANSFORM_SKEW:
              return `${SKEW}(${xValue}${xUnit}, ${yValue}${yUnit})`;
            default:
              return "";
          }
        }).join(" ");
        const {
          setStyle
        } = elementApi;
        addWillChange(element, _IX2BrowserSupport.TRANSFORM_PREFIXED, elementApi);
        setStyle(element, _IX2BrowserSupport.TRANSFORM_PREFIXED, newTransform);
        if (hasDefined3dTransform(actionItem, actionState)) {
          setStyle(element, _IX2BrowserSupport.TRANSFORM_STYLE_PREFIXED, PRESERVE_3D);
        }
      }
      function renderFilter(element, actionState, actionItemConfig, elementApi) {
        const filterValue = (0, _reduce.default)(actionState, (result, value, type) => `${result} ${type}(${value}${getFilterUnit(type, actionItemConfig)})`, "");
        const {
          setStyle
        } = elementApi;
        addWillChange(element, FILTER, elementApi);
        setStyle(element, FILTER, filterValue);
      }
      function renderFontVariation(element, actionState, actionItemConfig, elementApi) {
        const fontVariationValue = (0, _reduce.default)(actionState, (result, value, type) => {
          result.push(`"${type}" ${value}`);
          return result;
        }, []).join(", ");
        const {
          setStyle
        } = elementApi;
        addWillChange(element, FONT_VARIATION_SETTINGS, elementApi);
        setStyle(element, FONT_VARIATION_SETTINGS, fontVariationValue);
      }
      function hasDefined3dTransform({
        actionTypeId
      }, {
        xValue,
        yValue,
        zValue
      }) {
        return actionTypeId === TRANSFORM_MOVE && zValue !== void 0 || // SCALE_Z
        actionTypeId === TRANSFORM_SCALE && zValue !== void 0 || // ROTATE_X or ROTATE_Y
        actionTypeId === TRANSFORM_ROTATE && (xValue !== void 0 || yValue !== void 0);
      }
      var paramCapture = "\\(([^)]+)\\)";
      var rgbValidRegex = /^rgb/;
      var rgbMatchRegex = RegExp(`rgba?${paramCapture}`);
      function getFirstMatch(regex, value) {
        const match2 = regex.exec(value);
        return match2 ? match2[1] : "";
      }
      function parseColor({
        element,
        actionTypeId,
        computedStyle,
        getStyle
      }) {
        const prop2 = colorStyleProps[actionTypeId];
        const inlineValue = getStyle(element, prop2);
        const value = rgbValidRegex.test(inlineValue) ? inlineValue : computedStyle[prop2];
        const matches = getFirstMatch(rgbMatchRegex, value).split(COMMA_DELIMITER);
        return {
          rValue: (0, _defaultTo.default)(parseInt(matches[0], 10), 255),
          gValue: (0, _defaultTo.default)(parseInt(matches[1], 10), 255),
          bValue: (0, _defaultTo.default)(parseInt(matches[2], 10), 255),
          aValue: (0, _defaultTo.default)(parseFloat(matches[3]), 1)
        };
      }
      function renderStyle(element, refState, actionState, actionItem, styleProp, elementApi) {
        const {
          setStyle
        } = elementApi;
        switch (actionItem.actionTypeId) {
          case STYLE_SIZE: {
            let {
              widthUnit = "",
              heightUnit = ""
            } = actionItem.config;
            const {
              widthValue,
              heightValue
            } = actionState;
            if (widthValue !== void 0) {
              if (widthUnit === AUTO) {
                widthUnit = "px";
              }
              addWillChange(element, WIDTH, elementApi);
              setStyle(element, WIDTH, widthValue + widthUnit);
            }
            if (heightValue !== void 0) {
              if (heightUnit === AUTO) {
                heightUnit = "px";
              }
              addWillChange(element, HEIGHT, elementApi);
              setStyle(element, HEIGHT, heightValue + heightUnit);
            }
            break;
          }
          case STYLE_FILTER: {
            renderFilter(element, actionState, actionItem.config, elementApi);
            break;
          }
          case STYLE_FONT_VARIATION: {
            renderFontVariation(element, actionState, actionItem.config, elementApi);
            break;
          }
          case STYLE_BACKGROUND_COLOR:
          case STYLE_BORDER:
          case STYLE_TEXT_COLOR: {
            const prop2 = colorStyleProps[actionItem.actionTypeId];
            const rValue = Math.round(actionState.rValue);
            const gValue = Math.round(actionState.gValue);
            const bValue = Math.round(actionState.bValue);
            const aValue = actionState.aValue;
            addWillChange(element, prop2, elementApi);
            setStyle(element, prop2, aValue >= 1 ? `rgb(${rValue},${gValue},${bValue})` : `rgba(${rValue},${gValue},${bValue},${aValue})`);
            break;
          }
          default: {
            const {
              unit = ""
            } = actionItem.config;
            addWillChange(element, styleProp, elementApi);
            setStyle(element, styleProp, actionState.value + unit);
            break;
          }
        }
      }
      function renderGeneral(element, actionItem, elementApi) {
        const {
          setStyle
        } = elementApi;
        switch (actionItem.actionTypeId) {
          case GENERAL_DISPLAY: {
            const {
              value
            } = actionItem.config;
            if (value === FLEX && _IX2BrowserSupport.IS_BROWSER_ENV) {
              setStyle(element, DISPLAY, _IX2BrowserSupport.FLEX_PREFIXED);
            } else {
              setStyle(element, DISPLAY, value);
            }
            return;
          }
        }
      }
      function addWillChange(element, prop2, elementApi) {
        if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
          return;
        }
        const validProp = willChangeProps[prop2];
        if (!validProp) {
          return;
        }
        const {
          getStyle,
          setStyle
        } = elementApi;
        const value = getStyle(element, WILL_CHANGE);
        if (!value) {
          setStyle(element, WILL_CHANGE, validProp);
          return;
        }
        const values2 = value.split(COMMA_DELIMITER).map(trim);
        if (values2.indexOf(validProp) === -1) {
          setStyle(element, WILL_CHANGE, values2.concat(validProp).join(COMMA_DELIMITER));
        }
      }
      function removeWillChange(element, prop2, elementApi) {
        if (!_IX2BrowserSupport.IS_BROWSER_ENV) {
          return;
        }
        const validProp = willChangeProps[prop2];
        if (!validProp) {
          return;
        }
        const {
          getStyle,
          setStyle
        } = elementApi;
        const value = getStyle(element, WILL_CHANGE);
        if (!value || value.indexOf(validProp) === -1) {
          return;
        }
        setStyle(element, WILL_CHANGE, value.split(COMMA_DELIMITER).map(trim).filter((v) => v !== validProp).join(COMMA_DELIMITER));
      }
      function clearAllStyles({
        store,
        elementApi
      }) {
        const {
          ixData
        } = store.getState();
        const {
          events = {},
          actionLists = {}
        } = ixData;
        Object.keys(events).forEach((eventId) => {
          const event = events[eventId];
          const {
            config
          } = event.action;
          const {
            actionListId
          } = config;
          const actionList = actionLists[actionListId];
          if (actionList) {
            clearActionListStyles({
              actionList,
              event,
              elementApi
            });
          }
        });
        Object.keys(actionLists).forEach((actionListId) => {
          clearActionListStyles({
            actionList: actionLists[actionListId],
            elementApi
          });
        });
      }
      function clearActionListStyles({
        actionList = {},
        event,
        elementApi
      }) {
        const {
          actionItemGroups,
          continuousParameterGroups
        } = actionList;
        actionItemGroups && actionItemGroups.forEach((actionGroup) => {
          clearActionGroupStyles({
            actionGroup,
            event,
            elementApi
          });
        });
        continuousParameterGroups && continuousParameterGroups.forEach((paramGroup) => {
          const {
            continuousActionGroups
          } = paramGroup;
          continuousActionGroups.forEach((actionGroup) => {
            clearActionGroupStyles({
              actionGroup,
              event,
              elementApi
            });
          });
        });
      }
      function clearActionGroupStyles({
        actionGroup,
        event,
        elementApi
      }) {
        const {
          actionItems
        } = actionGroup;
        actionItems.forEach((actionItem) => {
          const {
            actionTypeId,
            config
          } = actionItem;
          let clearElement;
          if ((0, _IX2VanillaPlugins.isPluginType)(actionTypeId)) {
            clearElement = (ref) => (0, _IX2VanillaPlugins.clearPlugin)(actionTypeId)(ref, actionItem);
          } else {
            clearElement = processElementByType({
              effect: clearStyleProp,
              actionTypeId,
              elementApi
            });
          }
          getAffectedElements({
            config,
            event,
            elementApi
          }).forEach(clearElement);
        });
      }
      function cleanupHTMLElement(element, actionItem, elementApi) {
        const {
          setStyle,
          getStyle
        } = elementApi;
        const {
          actionTypeId
        } = actionItem;
        if (actionTypeId === STYLE_SIZE) {
          const {
            config
          } = actionItem;
          if (config.widthUnit === AUTO) {
            setStyle(element, WIDTH, "");
          }
          if (config.heightUnit === AUTO) {
            setStyle(element, HEIGHT, "");
          }
        }
        if (getStyle(element, WILL_CHANGE)) {
          processElementByType({
            effect: removeWillChange,
            actionTypeId,
            elementApi
          })(element);
        }
      }
      var processElementByType = ({
        effect,
        actionTypeId,
        elementApi
      }) => (element) => {
        switch (actionTypeId) {
          case TRANSFORM_MOVE:
          case TRANSFORM_SCALE:
          case TRANSFORM_ROTATE:
          case TRANSFORM_SKEW:
            effect(element, _IX2BrowserSupport.TRANSFORM_PREFIXED, elementApi);
            break;
          case STYLE_FILTER:
            effect(element, FILTER, elementApi);
            break;
          case STYLE_FONT_VARIATION:
            effect(element, FONT_VARIATION_SETTINGS, elementApi);
            break;
          case STYLE_OPACITY:
            effect(element, OPACITY, elementApi);
            break;
          case STYLE_SIZE:
            effect(element, WIDTH, elementApi);
            effect(element, HEIGHT, elementApi);
            break;
          case STYLE_BACKGROUND_COLOR:
          case STYLE_BORDER:
          case STYLE_TEXT_COLOR:
            effect(element, colorStyleProps[actionTypeId], elementApi);
            break;
          case GENERAL_DISPLAY:
            effect(element, DISPLAY, elementApi);
            break;
        }
      };
      function clearStyleProp(element, prop2, elementApi) {
        const {
          setStyle
        } = elementApi;
        removeWillChange(element, prop2, elementApi);
        setStyle(element, prop2, "");
        if (prop2 === _IX2BrowserSupport.TRANSFORM_PREFIXED) {
          setStyle(element, _IX2BrowserSupport.TRANSFORM_STYLE_PREFIXED, "");
        }
      }
      function getMaxDurationItemIndex(actionItems) {
        let maxDuration = 0;
        let resultIndex = 0;
        actionItems.forEach((actionItem, index) => {
          const {
            config
          } = actionItem;
          const total = config.delay + config.duration;
          if (total >= maxDuration) {
            maxDuration = total;
            resultIndex = index;
          }
        });
        return resultIndex;
      }
      function getActionListProgress(actionList, instance) {
        const {
          actionItemGroups,
          useFirstGroupAsInitialState
        } = actionList;
        const {
          actionItem: instanceItem,
          verboseTimeElapsed = 0
        } = instance;
        let totalDuration = 0;
        let elapsedDuration = 0;
        actionItemGroups.forEach((group, index) => {
          if (useFirstGroupAsInitialState && index === 0) {
            return;
          }
          const {
            actionItems
          } = group;
          const carrierItem = actionItems[getMaxDurationItemIndex(actionItems)];
          const {
            config,
            actionTypeId
          } = carrierItem;
          if (instanceItem.id === carrierItem.id) {
            elapsedDuration = totalDuration + verboseTimeElapsed;
          }
          const duration = getRenderType(actionTypeId) === RENDER_GENERAL ? 0 : config.duration;
          totalDuration += config.delay + duration;
        });
        return totalDuration > 0 ? (0, _IX2EasingUtils.optimizeFloat)(elapsedDuration / totalDuration) : 0;
      }
      function reduceListToGroup({
        actionList,
        actionItemId,
        rawData
      }) {
        const {
          actionItemGroups,
          continuousParameterGroups
        } = actionList;
        const newActionItems = [];
        const takeItemUntilMatch = (actionItem) => {
          newActionItems.push((0, _timm.mergeIn)(actionItem, ["config"], {
            delay: 0,
            duration: 0
          }));
          return actionItem.id === actionItemId;
        };
        actionItemGroups && actionItemGroups.some(({
          actionItems
        }) => {
          return actionItems.some(takeItemUntilMatch);
        });
        continuousParameterGroups && continuousParameterGroups.some((paramGroup) => {
          const {
            continuousActionGroups
          } = paramGroup;
          return continuousActionGroups.some(({
            actionItems
          }) => {
            return actionItems.some(takeItemUntilMatch);
          });
        });
        return (0, _timm.setIn)(rawData, ["actionLists"], {
          [actionList.id]: {
            id: actionList.id,
            actionItemGroups: [{
              actionItems: newActionItems
            }]
          }
        });
      }
      function shouldNamespaceEventParameter(eventTypeId, {
        basedOn
      }) {
        return eventTypeId === _constants.EventTypeConsts.SCROLLING_IN_VIEW && (basedOn === _constants.EventBasedOn.ELEMENT || basedOn == null) || eventTypeId === _constants.EventTypeConsts.MOUSE_MOVE && basedOn === _constants.EventBasedOn.ELEMENT;
      }
      function getNamespacedParameterId(eventStateKey, continuousParameterGroupId) {
        const namespacedParameterId = eventStateKey + COLON_DELIMITER + continuousParameterGroupId;
        return namespacedParameterId;
      }
      function shouldAllowMediaQuery(mediaQueries, mediaQueryKey) {
        if (mediaQueryKey == null) {
          return true;
        }
        return mediaQueries.indexOf(mediaQueryKey) !== -1;
      }
      function mediaQueriesEqual(listA, listB) {
        return (0, _shallowEqual.default)(listA && listA.sort(), listB && listB.sort());
      }
      function stringifyTarget(target) {
        if (typeof target === "string") {
          return target;
        }
        if (target.pluginElement && target.objectId) {
          return target.pluginElement + BAR_DELIMITER + target.objectId;
        }
        if (target.objectId) {
          return target.objectId;
        }
        const {
          id = "",
          selector = "",
          useEventTarget = ""
        } = target;
        return id + BAR_DELIMITER + selector + BAR_DELIMITER + useEventTarget;
      }
    }
  });

  // packages/systems/ix2/shared/index.js
  var require_shared2 = __commonJS({
    "packages/systems/ix2/shared/index.js"(exports) {
      "use strict";
      var _interopRequireWildcard = require_interopRequireWildcard().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.IX2VanillaUtils = exports.IX2VanillaPlugins = exports.IX2ElementsReducer = exports.IX2Easings = exports.IX2EasingUtils = exports.IX2BrowserSupport = void 0;
      var IX2BrowserSupport = _interopRequireWildcard(require_IX2BrowserSupport());
      exports.IX2BrowserSupport = IX2BrowserSupport;
      var IX2Easings = _interopRequireWildcard(require_IX2Easings());
      exports.IX2Easings = IX2Easings;
      var IX2EasingUtils = _interopRequireWildcard(require_IX2EasingUtils());
      exports.IX2EasingUtils = IX2EasingUtils;
      var IX2ElementsReducer = _interopRequireWildcard(require_IX2ElementsReducer());
      exports.IX2ElementsReducer = IX2ElementsReducer;
      var IX2VanillaPlugins = _interopRequireWildcard(require_IX2VanillaPlugins());
      exports.IX2VanillaPlugins = IX2VanillaPlugins;
      var IX2VanillaUtils = _interopRequireWildcard(require_IX2VanillaUtils());
      exports.IX2VanillaUtils = IX2VanillaUtils;
    }
  });

  // packages/systems/ix2/engine/reducers/IX2InstancesReducer.js
  var require_IX2InstancesReducer = __commonJS({
    "packages/systems/ix2/engine/reducers/IX2InstancesReducer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ixInstances = void 0;
      var _constants = require_constants();
      var _shared = require_shared2();
      var _timm = require_timm();
      var {
        IX2_RAW_DATA_IMPORTED,
        IX2_SESSION_STOPPED,
        IX2_INSTANCE_ADDED,
        IX2_INSTANCE_STARTED,
        IX2_INSTANCE_REMOVED,
        IX2_ANIMATION_FRAME_CHANGED
      } = _constants.IX2EngineActionTypes;
      var {
        optimizeFloat,
        applyEasing,
        createBezierEasing
      } = _shared.IX2EasingUtils;
      var {
        RENDER_GENERAL
      } = _constants.IX2EngineConstants;
      var {
        getItemConfigByKey,
        getRenderType,
        getStyleProp
      } = _shared.IX2VanillaUtils;
      var continuousInstance = (state, action) => {
        const {
          position: lastPosition,
          parameterId,
          actionGroups,
          destinationKeys,
          smoothing,
          restingValue,
          actionTypeId,
          customEasingFn,
          skipMotion,
          skipToValue
        } = state;
        const {
          parameters
        } = action.payload;
        let velocity = Math.max(1 - smoothing, 0.01);
        let paramValue = parameters[parameterId];
        if (paramValue == null) {
          velocity = 1;
          paramValue = restingValue;
        }
        const nextPosition = Math.max(paramValue, 0) || 0;
        const positionDiff = optimizeFloat(nextPosition - lastPosition);
        const position = skipMotion ? skipToValue : optimizeFloat(lastPosition + positionDiff * velocity);
        const keyframePosition = position * 100;
        if (position === lastPosition && state.current) {
          return state;
        }
        let fromActionItem;
        let toActionItem;
        let positionOffset;
        let positionRange;
        for (let i = 0, {
          length: length2
        } = actionGroups; i < length2; i++) {
          const {
            keyframe,
            actionItems
          } = actionGroups[i];
          if (i === 0) {
            fromActionItem = actionItems[0];
          }
          if (keyframePosition >= keyframe) {
            fromActionItem = actionItems[0];
            const nextGroup = actionGroups[i + 1];
            const hasNextItem = nextGroup && keyframePosition !== keyframe;
            toActionItem = hasNextItem ? nextGroup.actionItems[0] : null;
            if (hasNextItem) {
              positionOffset = keyframe / 100;
              positionRange = (nextGroup.keyframe - keyframe) / 100;
            }
          }
        }
        const current = {};
        if (fromActionItem && !toActionItem) {
          for (let i = 0, {
            length: length2
          } = destinationKeys; i < length2; i++) {
            const key = destinationKeys[i];
            current[key] = getItemConfigByKey(actionTypeId, key, fromActionItem.config);
          }
        } else if (fromActionItem && toActionItem && positionOffset !== void 0 && positionRange !== void 0) {
          const localPosition = (position - positionOffset) / positionRange;
          const easing = fromActionItem.config.easing;
          const eased = applyEasing(easing, localPosition, customEasingFn);
          for (let i = 0, {
            length: length2
          } = destinationKeys; i < length2; i++) {
            const key = destinationKeys[i];
            const fromVal = getItemConfigByKey(actionTypeId, key, fromActionItem.config);
            const toVal = getItemConfigByKey(actionTypeId, key, toActionItem.config);
            const diff = toVal - fromVal;
            const value = diff * eased + fromVal;
            current[key] = value;
          }
        }
        return (0, _timm.merge)(state, {
          position,
          current
        });
      };
      var timedInstance = (state, action) => {
        const {
          active,
          origin,
          start,
          immediate,
          renderType,
          verbose,
          actionItem,
          destination,
          destinationKeys,
          pluginDuration,
          instanceDelay,
          customEasingFn,
          skipMotion
        } = state;
        const easing = actionItem.config.easing;
        let {
          duration,
          delay
        } = actionItem.config;
        if (pluginDuration != null) {
          duration = pluginDuration;
        }
        delay = instanceDelay != null ? instanceDelay : delay;
        if (renderType === RENDER_GENERAL) {
          duration = 0;
        } else if (immediate || skipMotion) {
          duration = delay = 0;
        }
        const {
          now
        } = action.payload;
        if (active && origin) {
          const delta = now - (start + delay);
          if (verbose) {
            const verboseDelta = now - start;
            const verboseDuration = duration + delay;
            const verbosePosition = optimizeFloat(Math.min(Math.max(0, verboseDelta / verboseDuration), 1));
            state = (0, _timm.set)(state, "verboseTimeElapsed", verboseDuration * verbosePosition);
          }
          if (delta < 0) {
            return state;
          }
          const position = optimizeFloat(Math.min(Math.max(0, delta / duration), 1));
          const eased = applyEasing(easing, position, customEasingFn);
          const newProps = {};
          let current = null;
          if (destinationKeys.length) {
            current = destinationKeys.reduce((result, key) => {
              const destValue = destination[key];
              const originVal = parseFloat(origin[key]) || 0;
              const diff = parseFloat(destValue) - originVal;
              const value = diff * eased + originVal;
              result[key] = value;
              return result;
            }, {});
          }
          newProps.current = current;
          newProps.position = position;
          if (position === 1) {
            newProps.active = false;
            newProps.complete = true;
          }
          return (0, _timm.merge)(state, newProps);
        }
        return state;
      };
      var ixInstances = (state = Object.freeze({}), action) => {
        switch (action.type) {
          case IX2_RAW_DATA_IMPORTED: {
            return action.payload.ixInstances || Object.freeze({});
          }
          case IX2_SESSION_STOPPED: {
            return Object.freeze({});
          }
          case IX2_INSTANCE_ADDED: {
            const {
              instanceId,
              elementId,
              actionItem,
              eventId,
              eventTarget,
              eventStateKey,
              actionListId,
              groupIndex,
              isCarrier,
              origin,
              destination,
              immediate,
              verbose,
              continuous,
              parameterId,
              actionGroups,
              smoothing,
              restingValue,
              pluginInstance,
              pluginDuration,
              instanceDelay,
              skipMotion,
              skipToValue
            } = action.payload;
            const {
              actionTypeId
            } = actionItem;
            const renderType = getRenderType(actionTypeId);
            const styleProp = getStyleProp(renderType, actionTypeId);
            const destinationKeys = Object.keys(destination).filter((key) => (
              // Skip null destination values
              destination[key] != null && // Skip string destination values
              typeof destination[key] !== "string"
            ));
            const {
              easing
            } = actionItem.config;
            return (0, _timm.set)(state, instanceId, {
              id: instanceId,
              elementId,
              active: false,
              position: 0,
              start: 0,
              origin,
              destination,
              destinationKeys,
              immediate,
              verbose,
              current: null,
              actionItem,
              actionTypeId,
              eventId,
              eventTarget,
              eventStateKey,
              actionListId,
              groupIndex,
              renderType,
              isCarrier,
              styleProp,
              continuous,
              parameterId,
              actionGroups,
              smoothing,
              restingValue,
              pluginInstance,
              pluginDuration,
              instanceDelay,
              skipMotion,
              skipToValue,
              customEasingFn: Array.isArray(easing) && easing.length === 4 ? createBezierEasing(easing) : void 0
            });
          }
          case IX2_INSTANCE_STARTED: {
            const {
              instanceId,
              time
            } = action.payload;
            return (0, _timm.mergeIn)(state, [instanceId], {
              active: true,
              complete: false,
              start: time
            });
          }
          case IX2_INSTANCE_REMOVED: {
            const {
              instanceId
            } = action.payload;
            if (!state[instanceId]) {
              return state;
            }
            const newState = {};
            const keys = Object.keys(state);
            const {
              length: length2
            } = keys;
            for (let i = 0; i < length2; i++) {
              const key = keys[i];
              if (key !== instanceId) {
                newState[key] = state[key];
              }
            }
            return newState;
          }
          case IX2_ANIMATION_FRAME_CHANGED: {
            let newState = state;
            const keys = Object.keys(state);
            const {
              length: length2
            } = keys;
            for (let i = 0; i < length2; i++) {
              const key = keys[i];
              const instance = state[key];
              const reducer = instance.continuous ? continuousInstance : timedInstance;
              newState = (0, _timm.set)(newState, key, reducer(instance, action));
            }
            return newState;
          }
          default: {
            return state;
          }
        }
      };
      exports.ixInstances = ixInstances;
    }
  });

  // packages/systems/ix2/engine/reducers/IX2ParametersReducer.js
  var require_IX2ParametersReducer = __commonJS({
    "packages/systems/ix2/engine/reducers/IX2ParametersReducer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.ixParameters = void 0;
      var _constants = require_constants();
      var {
        IX2_RAW_DATA_IMPORTED,
        IX2_SESSION_STOPPED,
        IX2_PARAMETER_CHANGED
      } = _constants.IX2EngineActionTypes;
      var ixParameters = (state = {
        /*mutable flat state*/
      }, action) => {
        switch (action.type) {
          case IX2_RAW_DATA_IMPORTED: {
            return action.payload.ixParameters || {
              /*mutable flat state*/
            };
          }
          case IX2_SESSION_STOPPED: {
            return {
              /*mutable flat state*/
            };
          }
          case IX2_PARAMETER_CHANGED: {
            const {
              key,
              value
            } = action.payload;
            state[key] = value;
            return state;
          }
          default: {
            return state;
          }
        }
      };
      exports.ixParameters = ixParameters;
    }
  });

  // packages/systems/ix2/engine/reducers/IX2Reducer.js
  var require_IX2Reducer = __commonJS({
    "packages/systems/ix2/engine/reducers/IX2Reducer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var _redux = require_lib2();
      var _IX2DataReducer = require_IX2DataReducer();
      var _IX2RequestReducer = require_IX2RequestReducer();
      var _IX2SessionReducer = require_IX2SessionReducer();
      var _shared = require_shared2();
      var _IX2InstancesReducer = require_IX2InstancesReducer();
      var _IX2ParametersReducer = require_IX2ParametersReducer();
      var {
        ixElements
      } = _shared.IX2ElementsReducer;
      var _default = (0, _redux.combineReducers)({
        ixData: _IX2DataReducer.ixData,
        ixRequest: _IX2RequestReducer.ixRequest,
        ixSession: _IX2SessionReducer.ixSession,
        ixElements,
        ixInstances: _IX2InstancesReducer.ixInstances,
        ixParameters: _IX2ParametersReducer.ixParameters
      });
      exports.default = _default;
    }
  });

  // node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js
  var require_objectWithoutPropertiesLoose = __commonJS({
    "node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js"(exports, module) {
      function _objectWithoutPropertiesLoose(source, excluded) {
        if (source == null)
          return {};
        var target = {};
        var sourceKeys = Object.keys(source);
        var key, i;
        for (i = 0; i < sourceKeys.length; i++) {
          key = sourceKeys[i];
          if (excluded.indexOf(key) >= 0)
            continue;
          target[key] = source[key];
        }
        return target;
      }
      module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
  });

  // node_modules/lodash/isString.js
  var require_isString = __commonJS({
    "node_modules/lodash/isString.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isArray = require_isArray();
      var isObjectLike = require_isObjectLike();
      var stringTag = "[object String]";
      function isString(value) {
        return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      module.exports = isString;
    }
  });

  // node_modules/lodash/_asciiSize.js
  var require_asciiSize = __commonJS({
    "node_modules/lodash/_asciiSize.js"(exports, module) {
      var baseProperty = require_baseProperty();
      var asciiSize = baseProperty("length");
      module.exports = asciiSize;
    }
  });

  // node_modules/lodash/_hasUnicode.js
  var require_hasUnicode = __commonJS({
    "node_modules/lodash/_hasUnicode.js"(exports, module) {
      var rsAstralRange = "\\ud800-\\udfff";
      var rsComboMarksRange = "\\u0300-\\u036f";
      var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
      var rsComboSymbolsRange = "\\u20d0-\\u20ff";
      var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
      var rsVarRange = "\\ufe0e\\ufe0f";
      var rsZWJ = "\\u200d";
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      module.exports = hasUnicode;
    }
  });

  // node_modules/lodash/_unicodeSize.js
  var require_unicodeSize = __commonJS({
    "node_modules/lodash/_unicodeSize.js"(exports, module) {
      var rsAstralRange = "\\ud800-\\udfff";
      var rsComboMarksRange = "\\u0300-\\u036f";
      var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
      var rsComboSymbolsRange = "\\u20d0-\\u20ff";
      var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
      var rsVarRange = "\\ufe0e\\ufe0f";
      var rsAstral = "[" + rsAstralRange + "]";
      var rsCombo = "[" + rsComboRange + "]";
      var rsFitz = "\\ud83c[\\udffb-\\udfff]";
      var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
      var rsNonAstral = "[^" + rsAstralRange + "]";
      var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
      var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
      var rsZWJ = "\\u200d";
      var reOptMod = rsModifier + "?";
      var rsOptVar = "[" + rsVarRange + "]?";
      var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
      var rsSeq = rsOptVar + reOptMod + rsOptJoin;
      var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      module.exports = unicodeSize;
    }
  });

  // node_modules/lodash/_stringSize.js
  var require_stringSize = __commonJS({
    "node_modules/lodash/_stringSize.js"(exports, module) {
      var asciiSize = require_asciiSize();
      var hasUnicode = require_hasUnicode();
      var unicodeSize = require_unicodeSize();
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      module.exports = stringSize;
    }
  });

  // node_modules/lodash/size.js
  var require_size = __commonJS({
    "node_modules/lodash/size.js"(exports, module) {
      var baseKeys = require_baseKeys();
      var getTag = require_getTag();
      var isArrayLike = require_isArrayLike();
      var isString = require_isString();
      var stringSize = require_stringSize();
      var mapTag = "[object Map]";
      var setTag = "[object Set]";
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      module.exports = size;
    }
  });

  // node_modules/lodash/negate.js
  var require_negate = __commonJS({
    "node_modules/lodash/negate.js"(exports, module) {
      var FUNC_ERROR_TEXT = "Expected a function";
      function negate(predicate) {
        if (typeof predicate != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      module.exports = negate;
    }
  });

  // node_modules/lodash/_defineProperty.js
  var require_defineProperty = __commonJS({
    "node_modules/lodash/_defineProperty.js"(exports, module) {
      var getNative = require_getNative();
      var defineProperty = function() {
        try {
          var func = getNative(Object, "defineProperty");
          func({}, "", {});
          return func;
        } catch (e) {
        }
      }();
      module.exports = defineProperty;
    }
  });

  // node_modules/lodash/_baseAssignValue.js
  var require_baseAssignValue = __commonJS({
    "node_modules/lodash/_baseAssignValue.js"(exports, module) {
      var defineProperty = require_defineProperty();
      function baseAssignValue(object, key, value) {
        if (key == "__proto__" && defineProperty) {
          defineProperty(object, key, {
            "configurable": true,
            "enumerable": true,
            "value": value,
            "writable": true
          });
        } else {
          object[key] = value;
        }
      }
      module.exports = baseAssignValue;
    }
  });

  // node_modules/lodash/_assignValue.js
  var require_assignValue = __commonJS({
    "node_modules/lodash/_assignValue.js"(exports, module) {
      var baseAssignValue = require_baseAssignValue();
      var eq = require_eq();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty3.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      module.exports = assignValue;
    }
  });

  // node_modules/lodash/_baseSet.js
  var require_baseSet = __commonJS({
    "node_modules/lodash/_baseSet.js"(exports, module) {
      var assignValue = require_assignValue();
      var castPath = require_castPath();
      var isIndex = require_isIndex();
      var isObject2 = require_isObject();
      var toKey = require_toKey();
      function baseSet(object, path, value, customizer) {
        if (!isObject2(object)) {
          return object;
        }
        path = castPath(path, object);
        var index = -1, length2 = path.length, lastIndex = length2 - 1, nested = object;
        while (nested != null && ++index < length2) {
          var key = toKey(path[index]), newValue = value;
          if (key === "__proto__" || key === "constructor" || key === "prototype") {
            return object;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : void 0;
            if (newValue === void 0) {
              newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      module.exports = baseSet;
    }
  });

  // node_modules/lodash/_basePickBy.js
  var require_basePickBy = __commonJS({
    "node_modules/lodash/_basePickBy.js"(exports, module) {
      var baseGet = require_baseGet();
      var baseSet = require_baseSet();
      var castPath = require_castPath();
      function basePickBy(object, paths, predicate) {
        var index = -1, length2 = paths.length, result = {};
        while (++index < length2) {
          var path = paths[index], value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }
        return result;
      }
      module.exports = basePickBy;
    }
  });

  // node_modules/lodash/_getSymbolsIn.js
  var require_getSymbolsIn = __commonJS({
    "node_modules/lodash/_getSymbolsIn.js"(exports, module) {
      var arrayPush = require_arrayPush();
      var getPrototype = require_getPrototype();
      var getSymbols = require_getSymbols();
      var stubArray = require_stubArray();
      var nativeGetSymbols = Object.getOwnPropertySymbols;
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result = [];
        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }
        return result;
      };
      module.exports = getSymbolsIn;
    }
  });

  // node_modules/lodash/_nativeKeysIn.js
  var require_nativeKeysIn = __commonJS({
    "node_modules/lodash/_nativeKeysIn.js"(exports, module) {
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = nativeKeysIn;
    }
  });

  // node_modules/lodash/_baseKeysIn.js
  var require_baseKeysIn = __commonJS({
    "node_modules/lodash/_baseKeysIn.js"(exports, module) {
      var isObject2 = require_isObject();
      var isPrototype = require_isPrototype();
      var nativeKeysIn = require_nativeKeysIn();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function baseKeysIn(object) {
        if (!isObject2(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object), result = [];
        for (var key in object) {
          if (!(key == "constructor" && (isProto || !hasOwnProperty3.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }
      module.exports = baseKeysIn;
    }
  });

  // node_modules/lodash/keysIn.js
  var require_keysIn = __commonJS({
    "node_modules/lodash/keysIn.js"(exports, module) {
      var arrayLikeKeys = require_arrayLikeKeys();
      var baseKeysIn = require_baseKeysIn();
      var isArrayLike = require_isArrayLike();
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      module.exports = keysIn;
    }
  });

  // node_modules/lodash/_getAllKeysIn.js
  var require_getAllKeysIn = __commonJS({
    "node_modules/lodash/_getAllKeysIn.js"(exports, module) {
      var baseGetAllKeys = require_baseGetAllKeys();
      var getSymbolsIn = require_getSymbolsIn();
      var keysIn = require_keysIn();
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      module.exports = getAllKeysIn;
    }
  });

  // node_modules/lodash/pickBy.js
  var require_pickBy = __commonJS({
    "node_modules/lodash/pickBy.js"(exports, module) {
      var arrayMap = require_arrayMap();
      var baseIteratee = require_baseIteratee();
      var basePickBy = require_basePickBy();
      var getAllKeysIn = require_getAllKeysIn();
      function pickBy2(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop2) {
          return [prop2];
        });
        predicate = baseIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }
      module.exports = pickBy2;
    }
  });

  // node_modules/lodash/omitBy.js
  var require_omitBy = __commonJS({
    "node_modules/lodash/omitBy.js"(exports, module) {
      var baseIteratee = require_baseIteratee();
      var negate = require_negate();
      var pickBy2 = require_pickBy();
      function omitBy(object, predicate) {
        return pickBy2(object, negate(baseIteratee(predicate)));
      }
      module.exports = omitBy;
    }
  });

  // node_modules/lodash/isEmpty.js
  var require_isEmpty = __commonJS({
    "node_modules/lodash/isEmpty.js"(exports, module) {
      var baseKeys = require_baseKeys();
      var getTag = require_getTag();
      var isArguments = require_isArguments();
      var isArray = require_isArray();
      var isArrayLike = require_isArrayLike();
      var isBuffer = require_isBuffer();
      var isPrototype = require_isPrototype();
      var isTypedArray = require_isTypedArray();
      var mapTag = "[object Map]";
      var setTag = "[object Set]";
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty3.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      module.exports = isEmpty;
    }
  });

  // node_modules/lodash/mapValues.js
  var require_mapValues = __commonJS({
    "node_modules/lodash/mapValues.js"(exports, module) {
      var baseAssignValue = require_baseAssignValue();
      var baseForOwn = require_baseForOwn();
      var baseIteratee = require_baseIteratee();
      function mapValues2(object, iteratee) {
        var result = {};
        iteratee = baseIteratee(iteratee, 3);
        baseForOwn(object, function(value, key, object2) {
          baseAssignValue(result, key, iteratee(value, key, object2));
        });
        return result;
      }
      module.exports = mapValues2;
    }
  });

  // node_modules/lodash/_arrayEach.js
  var require_arrayEach = __commonJS({
    "node_modules/lodash/_arrayEach.js"(exports, module) {
      function arrayEach(array, iteratee) {
        var index = -1, length2 = array == null ? 0 : array.length;
        while (++index < length2) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      module.exports = arrayEach;
    }
  });

  // node_modules/lodash/_castFunction.js
  var require_castFunction = __commonJS({
    "node_modules/lodash/_castFunction.js"(exports, module) {
      var identity2 = require_identity();
      function castFunction(value) {
        return typeof value == "function" ? value : identity2;
      }
      module.exports = castFunction;
    }
  });

  // node_modules/lodash/forEach.js
  var require_forEach = __commonJS({
    "node_modules/lodash/forEach.js"(exports, module) {
      var arrayEach = require_arrayEach();
      var baseEach = require_baseEach();
      var castFunction = require_castFunction();
      var isArray = require_isArray();
      function forEach(collection, iteratee) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, castFunction(iteratee));
      }
      module.exports = forEach;
    }
  });

  // node_modules/lodash/now.js
  var require_now = __commonJS({
    "node_modules/lodash/now.js"(exports, module) {
      var root = require_root();
      var now = function() {
        return root.Date.now();
      };
      module.exports = now;
    }
  });

  // node_modules/lodash/debounce.js
  var require_debounce = __commonJS({
    "node_modules/lodash/debounce.js"(exports, module) {
      var isObject2 = require_isObject();
      var now = require_now();
      var toNumber = require_toNumber();
      var FUNC_ERROR_TEXT = "Expected a function";
      var nativeMax = Math.max;
      var nativeMin = Math.min;
      function debounce(func, wait, options) {
        var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject2(options)) {
          leading = !!options.leading;
          maxing = "maxWait" in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs, thisArg = lastThis;
          lastArgs = lastThis = void 0;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout(timerExpired, wait);
          return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === void 0 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = void 0;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = void 0;
          return result;
        }
        function cancel() {
          if (timerId !== void 0) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = void 0;
        }
        function flush() {
          return timerId === void 0 ? result : trailingEdge(now());
        }
        function debounced() {
          var time = now(), isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === void 0) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === void 0) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      module.exports = debounce;
    }
  });

  // node_modules/lodash/throttle.js
  var require_throttle = __commonJS({
    "node_modules/lodash/throttle.js"(exports, module) {
      var debounce = require_debounce();
      var isObject2 = require_isObject();
      var FUNC_ERROR_TEXT = "Expected a function";
      function throttle(func, wait, options) {
        var leading = true, trailing = true;
        if (typeof func != "function") {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        if (isObject2(options)) {
          leading = "leading" in options ? !!options.leading : leading;
          trailing = "trailing" in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          "leading": leading,
          "maxWait": wait,
          "trailing": trailing
        });
      }
      module.exports = throttle;
    }
  });

  // packages/systems/ix2/engine/actions/IX2EngineActions.js
  var require_IX2EngineActions = __commonJS({
    "packages/systems/ix2/engine/actions/IX2EngineActions.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.viewportWidthChanged = exports.testFrameRendered = exports.stopRequested = exports.sessionStopped = exports.sessionStarted = exports.sessionInitialized = exports.rawDataImported = exports.previewRequested = exports.playbackRequested = exports.parameterChanged = exports.mediaQueriesDefined = exports.instanceStarted = exports.instanceRemoved = exports.instanceAdded = exports.eventStateChanged = exports.eventListenerAdded = exports.elementStateChanged = exports.clearRequested = exports.animationFrameChanged = exports.actionListPlaybackChanged = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _constants = require_constants();
      var _shared = require_shared2();
      var {
        IX2_RAW_DATA_IMPORTED,
        IX2_SESSION_INITIALIZED,
        IX2_SESSION_STARTED,
        IX2_SESSION_STOPPED,
        IX2_PREVIEW_REQUESTED,
        IX2_PLAYBACK_REQUESTED,
        IX2_STOP_REQUESTED,
        IX2_CLEAR_REQUESTED,
        IX2_EVENT_LISTENER_ADDED,
        IX2_TEST_FRAME_RENDERED,
        IX2_EVENT_STATE_CHANGED,
        IX2_ANIMATION_FRAME_CHANGED,
        IX2_PARAMETER_CHANGED,
        IX2_INSTANCE_ADDED,
        IX2_INSTANCE_STARTED,
        IX2_INSTANCE_REMOVED,
        IX2_ELEMENT_STATE_CHANGED,
        IX2_ACTION_LIST_PLAYBACK_CHANGED,
        IX2_VIEWPORT_WIDTH_CHANGED,
        IX2_MEDIA_QUERIES_DEFINED
      } = _constants.IX2EngineActionTypes;
      var {
        reifyState
      } = _shared.IX2VanillaUtils;
      var rawDataImported = (rawData) => ({
        type: IX2_RAW_DATA_IMPORTED,
        payload: (0, _extends2.default)({}, reifyState(rawData))
      });
      exports.rawDataImported = rawDataImported;
      var sessionInitialized = ({
        hasBoundaryNodes,
        reducedMotion
      }) => ({
        type: IX2_SESSION_INITIALIZED,
        payload: {
          hasBoundaryNodes,
          reducedMotion
        }
      });
      exports.sessionInitialized = sessionInitialized;
      var sessionStarted = () => ({
        type: IX2_SESSION_STARTED
      });
      exports.sessionStarted = sessionStarted;
      var sessionStopped = () => ({
        type: IX2_SESSION_STOPPED
      });
      exports.sessionStopped = sessionStopped;
      var previewRequested = ({
        rawData,
        defer
      }) => ({
        type: IX2_PREVIEW_REQUESTED,
        payload: {
          defer,
          rawData
        }
      });
      exports.previewRequested = previewRequested;
      var playbackRequested = ({
        actionTypeId = _constants.ActionTypeConsts.GENERAL_START_ACTION,
        actionListId,
        actionItemId,
        eventId,
        allowEvents,
        immediate,
        testManual,
        verbose,
        rawData
      }) => ({
        type: IX2_PLAYBACK_REQUESTED,
        payload: {
          actionTypeId,
          actionListId,
          actionItemId,
          testManual,
          eventId,
          allowEvents,
          immediate,
          verbose,
          rawData
        }
      });
      exports.playbackRequested = playbackRequested;
      var stopRequested = (actionListId) => ({
        type: IX2_STOP_REQUESTED,
        payload: {
          actionListId
        }
      });
      exports.stopRequested = stopRequested;
      var clearRequested = () => ({
        type: IX2_CLEAR_REQUESTED
      });
      exports.clearRequested = clearRequested;
      var eventListenerAdded = (target, listenerParams) => ({
        type: IX2_EVENT_LISTENER_ADDED,
        payload: {
          target,
          listenerParams
        }
      });
      exports.eventListenerAdded = eventListenerAdded;
      var testFrameRendered = (step = 1) => ({
        type: IX2_TEST_FRAME_RENDERED,
        payload: {
          step
        }
      });
      exports.testFrameRendered = testFrameRendered;
      var eventStateChanged = (stateKey, newState) => ({
        type: IX2_EVENT_STATE_CHANGED,
        payload: {
          stateKey,
          newState
        }
      });
      exports.eventStateChanged = eventStateChanged;
      var animationFrameChanged = (now, parameters) => ({
        type: IX2_ANIMATION_FRAME_CHANGED,
        payload: {
          now,
          parameters
        }
      });
      exports.animationFrameChanged = animationFrameChanged;
      var parameterChanged = (key, value) => ({
        type: IX2_PARAMETER_CHANGED,
        payload: {
          key,
          value
        }
      });
      exports.parameterChanged = parameterChanged;
      var instanceAdded = (options) => ({
        type: IX2_INSTANCE_ADDED,
        payload: (0, _extends2.default)({}, options)
      });
      exports.instanceAdded = instanceAdded;
      var instanceStarted = (instanceId, time) => ({
        type: IX2_INSTANCE_STARTED,
        payload: {
          instanceId,
          time
        }
      });
      exports.instanceStarted = instanceStarted;
      var instanceRemoved = (instanceId) => ({
        type: IX2_INSTANCE_REMOVED,
        payload: {
          instanceId
        }
      });
      exports.instanceRemoved = instanceRemoved;
      var elementStateChanged = (elementId, actionTypeId, current, actionItem) => ({
        type: IX2_ELEMENT_STATE_CHANGED,
        payload: {
          elementId,
          actionTypeId,
          current,
          actionItem
        }
      });
      exports.elementStateChanged = elementStateChanged;
      var actionListPlaybackChanged = ({
        actionListId,
        isPlaying
      }) => ({
        type: IX2_ACTION_LIST_PLAYBACK_CHANGED,
        payload: {
          actionListId,
          isPlaying
        }
      });
      exports.actionListPlaybackChanged = actionListPlaybackChanged;
      var viewportWidthChanged = ({
        width,
        mediaQueries
      }) => ({
        type: IX2_VIEWPORT_WIDTH_CHANGED,
        payload: {
          width,
          mediaQueries
        }
      });
      exports.viewportWidthChanged = viewportWidthChanged;
      var mediaQueriesDefined = () => ({
        type: IX2_MEDIA_QUERIES_DEFINED
      });
      exports.mediaQueriesDefined = mediaQueriesDefined;
    }
  });

  // packages/systems/ix2/engine/logic/IX2BrowserApi.js
  var require_IX2BrowserApi = __commonJS({
    "packages/systems/ix2/engine/logic/IX2BrowserApi.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.elementContains = elementContains;
      exports.getChildElements = getChildElements;
      exports.getClosestElement = void 0;
      exports.getProperty = getProperty;
      exports.getQuerySelector = getQuerySelector;
      exports.getRefType = getRefType;
      exports.getSiblingElements = getSiblingElements;
      exports.getStyle = getStyle;
      exports.getValidDocument = getValidDocument;
      exports.isSiblingNode = isSiblingNode;
      exports.matchSelector = matchSelector;
      exports.queryDocument = queryDocument;
      exports.setStyle = setStyle;
      var _shared = require_shared2();
      var _constants = require_constants();
      var {
        ELEMENT_MATCHES
      } = _shared.IX2BrowserSupport;
      var {
        IX2_ID_DELIMITER,
        HTML_ELEMENT,
        PLAIN_OBJECT,
        WF_PAGE
      } = _constants.IX2EngineConstants;
      function setStyle(element, prop2, value) {
        element.style[prop2] = value;
      }
      function getStyle(element, prop2) {
        return element.style[prop2];
      }
      function getProperty(element, prop2) {
        return element[prop2];
      }
      function matchSelector(selector) {
        return (element) => element[ELEMENT_MATCHES](selector);
      }
      function getQuerySelector({
        id,
        selector
      }) {
        if (id) {
          let nodeId = id;
          if (id.indexOf(IX2_ID_DELIMITER) !== -1) {
            const pair = id.split(IX2_ID_DELIMITER);
            const pageId = pair[0];
            nodeId = pair[1];
            if (pageId !== document.documentElement.getAttribute(WF_PAGE)) {
              return null;
            }
          }
          return `[data-w-id="${nodeId}"], [data-w-id^="${nodeId}_instance"]`;
        }
        return selector;
      }
      function getValidDocument(pageId) {
        if (pageId == null || // $FlowIgnore — if documentElement is null crash
        pageId === document.documentElement.getAttribute(WF_PAGE)) {
          return document;
        }
        return null;
      }
      function queryDocument(baseSelector, descendantSelector) {
        return Array.prototype.slice.call(document.querySelectorAll(descendantSelector ? baseSelector + " " + descendantSelector : baseSelector));
      }
      function elementContains(parent, child) {
        return parent.contains(child);
      }
      function isSiblingNode(a, b) {
        return a !== b && a.parentNode === b.parentNode;
      }
      function getChildElements(sourceElements) {
        const childElements = [];
        for (let i = 0, {
          length: length2
        } = sourceElements || []; i < length2; i++) {
          const {
            children
          } = sourceElements[i];
          const {
            length: childCount
          } = children;
          if (!childCount) {
            continue;
          }
          for (let j = 0; j < childCount; j++) {
            childElements.push(children[j]);
          }
        }
        return childElements;
      }
      function getSiblingElements(sourceElements = []) {
        const elements = [];
        const parentCache = [];
        for (let i = 0, {
          length: length2
        } = sourceElements; i < length2; i++) {
          const {
            parentNode
          } = sourceElements[i];
          if (!parentNode || !parentNode.children || !parentNode.children.length) {
            continue;
          }
          if (parentCache.indexOf(parentNode) !== -1) {
            continue;
          }
          parentCache.push(parentNode);
          let el = parentNode.firstElementChild;
          while (el != null) {
            if (sourceElements.indexOf(el) === -1) {
              elements.push(el);
            }
            el = el.nextElementSibling;
          }
        }
        return elements;
      }
      var getClosestElement = Element.prototype.closest ? (element, selector) => {
        if (!document.documentElement.contains(element)) {
          return null;
        }
        return element.closest(selector);
      } : (element, selector) => {
        if (!document.documentElement.contains(element)) {
          return null;
        }
        let el = element;
        do {
          if (el[ELEMENT_MATCHES] && el[ELEMENT_MATCHES](selector)) {
            return el;
          }
          el = el.parentNode;
        } while (el != null);
        return null;
      };
      exports.getClosestElement = getClosestElement;
      function getRefType(ref) {
        if (ref != null && typeof ref == "object") {
          return ref instanceof Element ? HTML_ELEMENT : PLAIN_OBJECT;
        }
        return null;
      }
    }
  });

  // node_modules/lodash/_baseCreate.js
  var require_baseCreate = __commonJS({
    "node_modules/lodash/_baseCreate.js"(exports, module) {
      var isObject2 = require_isObject();
      var objectCreate = Object.create;
      var baseCreate = function() {
        function object() {
        }
        return function(proto) {
          if (!isObject2(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object();
          object.prototype = void 0;
          return result;
        };
      }();
      module.exports = baseCreate;
    }
  });

  // node_modules/lodash/_baseLodash.js
  var require_baseLodash = __commonJS({
    "node_modules/lodash/_baseLodash.js"(exports, module) {
      function baseLodash() {
      }
      module.exports = baseLodash;
    }
  });

  // node_modules/lodash/_LodashWrapper.js
  var require_LodashWrapper = __commonJS({
    "node_modules/lodash/_LodashWrapper.js"(exports, module) {
      var baseCreate = require_baseCreate();
      var baseLodash = require_baseLodash();
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = void 0;
      }
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      module.exports = LodashWrapper;
    }
  });

  // node_modules/lodash/_isFlattenable.js
  var require_isFlattenable = __commonJS({
    "node_modules/lodash/_isFlattenable.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var isArguments = require_isArguments();
      var isArray = require_isArray();
      var spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : void 0;
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      module.exports = isFlattenable;
    }
  });

  // node_modules/lodash/_baseFlatten.js
  var require_baseFlatten = __commonJS({
    "node_modules/lodash/_baseFlatten.js"(exports, module) {
      var arrayPush = require_arrayPush();
      var isFlattenable = require_isFlattenable();
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1, length2 = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);
        while (++index < length2) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }
      module.exports = baseFlatten;
    }
  });

  // node_modules/lodash/flatten.js
  var require_flatten = __commonJS({
    "node_modules/lodash/flatten.js"(exports, module) {
      var baseFlatten = require_baseFlatten();
      function flatten(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? baseFlatten(array, 1) : [];
      }
      module.exports = flatten;
    }
  });

  // node_modules/lodash/_apply.js
  var require_apply = __commonJS({
    "node_modules/lodash/_apply.js"(exports, module) {
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      module.exports = apply;
    }
  });

  // node_modules/lodash/_overRest.js
  var require_overRest = __commonJS({
    "node_modules/lodash/_overRest.js"(exports, module) {
      var apply = require_apply();
      var nativeMax = Math.max;
      function overRest(func, start, transform) {
        start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
        return function() {
          var args = arguments, index = -1, length2 = nativeMax(args.length - start, 0), array = Array(length2);
          while (++index < length2) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }
      module.exports = overRest;
    }
  });

  // node_modules/lodash/constant.js
  var require_constant = __commonJS({
    "node_modules/lodash/constant.js"(exports, module) {
      function constant2(value) {
        return function() {
          return value;
        };
      }
      module.exports = constant2;
    }
  });

  // node_modules/lodash/_baseSetToString.js
  var require_baseSetToString = __commonJS({
    "node_modules/lodash/_baseSetToString.js"(exports, module) {
      var constant2 = require_constant();
      var defineProperty = require_defineProperty();
      var identity2 = require_identity();
      var baseSetToString = !defineProperty ? identity2 : function(func, string) {
        return defineProperty(func, "toString", {
          "configurable": true,
          "enumerable": false,
          "value": constant2(string),
          "writable": true
        });
      };
      module.exports = baseSetToString;
    }
  });

  // node_modules/lodash/_shortOut.js
  var require_shortOut = __commonJS({
    "node_modules/lodash/_shortOut.js"(exports, module) {
      var HOT_COUNT = 800;
      var HOT_SPAN = 16;
      var nativeNow = Date.now;
      function shortOut(func) {
        var count = 0, lastCalled = 0;
        return function() {
          var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(void 0, arguments);
        };
      }
      module.exports = shortOut;
    }
  });

  // node_modules/lodash/_setToString.js
  var require_setToString = __commonJS({
    "node_modules/lodash/_setToString.js"(exports, module) {
      var baseSetToString = require_baseSetToString();
      var shortOut = require_shortOut();
      var setToString = shortOut(baseSetToString);
      module.exports = setToString;
    }
  });

  // node_modules/lodash/_flatRest.js
  var require_flatRest = __commonJS({
    "node_modules/lodash/_flatRest.js"(exports, module) {
      var flatten = require_flatten();
      var overRest = require_overRest();
      var setToString = require_setToString();
      function flatRest(func) {
        return setToString(overRest(func, void 0, flatten), func + "");
      }
      module.exports = flatRest;
    }
  });

  // node_modules/lodash/_metaMap.js
  var require_metaMap = __commonJS({
    "node_modules/lodash/_metaMap.js"(exports, module) {
      var WeakMap2 = require_WeakMap();
      var metaMap = WeakMap2 && new WeakMap2();
      module.exports = metaMap;
    }
  });

  // node_modules/lodash/noop.js
  var require_noop = __commonJS({
    "node_modules/lodash/noop.js"(exports, module) {
      function noop2() {
      }
      module.exports = noop2;
    }
  });

  // node_modules/lodash/_getData.js
  var require_getData = __commonJS({
    "node_modules/lodash/_getData.js"(exports, module) {
      var metaMap = require_metaMap();
      var noop2 = require_noop();
      var getData = !metaMap ? noop2 : function(func) {
        return metaMap.get(func);
      };
      module.exports = getData;
    }
  });

  // node_modules/lodash/_realNames.js
  var require_realNames = __commonJS({
    "node_modules/lodash/_realNames.js"(exports, module) {
      var realNames = {};
      module.exports = realNames;
    }
  });

  // node_modules/lodash/_getFuncName.js
  var require_getFuncName = __commonJS({
    "node_modules/lodash/_getFuncName.js"(exports, module) {
      var realNames = require_realNames();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function getFuncName(func) {
        var result = func.name + "", array = realNames[result], length2 = hasOwnProperty3.call(realNames, result) ? array.length : 0;
        while (length2--) {
          var data = array[length2], otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result;
      }
      module.exports = getFuncName;
    }
  });

  // node_modules/lodash/_LazyWrapper.js
  var require_LazyWrapper = __commonJS({
    "node_modules/lodash/_LazyWrapper.js"(exports, module) {
      var baseCreate = require_baseCreate();
      var baseLodash = require_baseLodash();
      var MAX_ARRAY_LENGTH = 4294967295;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      module.exports = LazyWrapper;
    }
  });

  // node_modules/lodash/_copyArray.js
  var require_copyArray = __commonJS({
    "node_modules/lodash/_copyArray.js"(exports, module) {
      function copyArray(source, array) {
        var index = -1, length2 = source.length;
        array || (array = Array(length2));
        while (++index < length2) {
          array[index] = source[index];
        }
        return array;
      }
      module.exports = copyArray;
    }
  });

  // node_modules/lodash/_wrapperClone.js
  var require_wrapperClone = __commonJS({
    "node_modules/lodash/_wrapperClone.js"(exports, module) {
      var LazyWrapper = require_LazyWrapper();
      var LodashWrapper = require_LodashWrapper();
      var copyArray = require_copyArray();
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = copyArray(wrapper.__actions__);
        result.__index__ = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
      }
      module.exports = wrapperClone;
    }
  });

  // node_modules/lodash/wrapperLodash.js
  var require_wrapperLodash = __commonJS({
    "node_modules/lodash/wrapperLodash.js"(exports, module) {
      var LazyWrapper = require_LazyWrapper();
      var LodashWrapper = require_LodashWrapper();
      var baseLodash = require_baseLodash();
      var isArray = require_isArray();
      var isObjectLike = require_isObjectLike();
      var wrapperClone = require_wrapperClone();
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function lodash(value) {
        if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty3.call(value, "__wrapped__")) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      lodash.prototype = baseLodash.prototype;
      lodash.prototype.constructor = lodash;
      module.exports = lodash;
    }
  });

  // node_modules/lodash/_isLaziable.js
  var require_isLaziable = __commonJS({
    "node_modules/lodash/_isLaziable.js"(exports, module) {
      var LazyWrapper = require_LazyWrapper();
      var getData = require_getData();
      var getFuncName = require_getFuncName();
      var lodash = require_wrapperLodash();
      function isLaziable(func) {
        var funcName = getFuncName(func), other = lodash[funcName];
        if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      module.exports = isLaziable;
    }
  });

  // node_modules/lodash/_createFlow.js
  var require_createFlow = __commonJS({
    "node_modules/lodash/_createFlow.js"(exports, module) {
      var LodashWrapper = require_LodashWrapper();
      var flatRest = require_flatRest();
      var getData = require_getData();
      var getFuncName = require_getFuncName();
      var isArray = require_isArray();
      var isLaziable = require_isLaziable();
      var FUNC_ERROR_TEXT = "Expected a function";
      var WRAP_CURRY_FLAG = 8;
      var WRAP_PARTIAL_FLAG = 32;
      var WRAP_ARY_FLAG = 128;
      var WRAP_REARG_FLAG = 256;
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length2 = funcs.length, index = length2, prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != "function") {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == "wrapper") {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length2;
          while (++index < length2) {
            func = funcs[index];
            var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : void 0;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments, value = args[0];
            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }
            var index2 = 0, result = length2 ? funcs[index2].apply(this, args) : value;
            while (++index2 < length2) {
              result = funcs[index2].call(this, result);
            }
            return result;
          };
        });
      }
      module.exports = createFlow;
    }
  });

  // node_modules/lodash/flow.js
  var require_flow = __commonJS({
    "node_modules/lodash/flow.js"(exports, module) {
      var createFlow = require_createFlow();
      var flow = createFlow();
      module.exports = flow;
    }
  });

  // node_modules/lodash/_baseClamp.js
  var require_baseClamp = __commonJS({
    "node_modules/lodash/_baseClamp.js"(exports, module) {
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== void 0) {
            number = number <= upper ? number : upper;
          }
          if (lower !== void 0) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      module.exports = baseClamp;
    }
  });

  // node_modules/lodash/clamp.js
  var require_clamp = __commonJS({
    "node_modules/lodash/clamp.js"(exports, module) {
      var baseClamp = require_baseClamp();
      var toNumber = require_toNumber();
      function clamp(number, lower, upper) {
        if (upper === void 0) {
          upper = lower;
          lower = void 0;
        }
        if (upper !== void 0) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== void 0) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      module.exports = clamp;
    }
  });

  // packages/systems/ix2/engine/logic/IX2VanillaEvents.js
  var require_IX2VanillaEvents = __commonJS({
    "packages/systems/ix2/engine/logic/IX2VanillaEvents.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _flow = _interopRequireDefault(require_flow());
      var _get = _interopRequireDefault(require_get());
      var _clamp = _interopRequireDefault(require_clamp());
      var _constants = require_constants();
      var _IX2VanillaEngine = require_IX2VanillaEngine();
      var _IX2EngineActions = require_IX2EngineActions();
      var _shared = require_shared2();
      var {
        MOUSE_CLICK,
        MOUSE_SECOND_CLICK,
        MOUSE_DOWN,
        MOUSE_UP,
        MOUSE_OVER,
        MOUSE_OUT,
        DROPDOWN_CLOSE,
        DROPDOWN_OPEN,
        SLIDER_ACTIVE,
        SLIDER_INACTIVE,
        TAB_ACTIVE,
        TAB_INACTIVE,
        NAVBAR_CLOSE,
        NAVBAR_OPEN,
        MOUSE_MOVE,
        PAGE_SCROLL_DOWN,
        SCROLL_INTO_VIEW,
        SCROLL_OUT_OF_VIEW,
        PAGE_SCROLL_UP,
        SCROLLING_IN_VIEW,
        PAGE_FINISH,
        ECOMMERCE_CART_CLOSE,
        ECOMMERCE_CART_OPEN,
        PAGE_START,
        PAGE_SCROLL
      } = _constants.EventTypeConsts;
      var COMPONENT_ACTIVE = "COMPONENT_ACTIVE";
      var COMPONENT_INACTIVE = "COMPONENT_INACTIVE";
      var {
        COLON_DELIMITER
      } = _constants.IX2EngineConstants;
      var {
        getNamespacedParameterId
      } = _shared.IX2VanillaUtils;
      var composableFilter = (predicate) => (options) => {
        if (typeof options === "object" && predicate(options)) {
          return true;
        }
        return options;
      };
      var isElement = composableFilter(({
        element,
        nativeEvent
      }) => {
        return element === nativeEvent.target;
      });
      var containsElement = composableFilter(({
        element,
        nativeEvent
      }) => {
        return element.contains(nativeEvent.target);
      });
      var isOrContainsElement = (0, _flow.default)([isElement, containsElement]);
      var getAutoStopEvent = (store, autoStopEventId) => {
        if (autoStopEventId) {
          const {
            ixData
          } = store.getState();
          const {
            events
          } = ixData;
          const eventToStop = events[autoStopEventId];
          if (eventToStop && !AUTO_STOP_DISABLED_EVENTS[eventToStop.eventTypeId]) {
            return eventToStop;
          }
        }
        return null;
      };
      var hasAutoStopEvent = ({
        store,
        event
      }) => {
        const {
          action: eventAction
        } = event;
        const {
          autoStopEventId
        } = eventAction.config;
        return Boolean(getAutoStopEvent(store, autoStopEventId));
      };
      var actionGroupCreator = ({
        store,
        event,
        element,
        eventStateKey
      }, state) => {
        const {
          action: eventAction,
          id: eventId
        } = event;
        const {
          actionListId,
          autoStopEventId
        } = eventAction.config;
        const eventToStop = getAutoStopEvent(store, autoStopEventId);
        if (eventToStop) {
          (0, _IX2VanillaEngine.stopActionGroup)({
            store,
            eventId: autoStopEventId,
            eventTarget: element,
            eventStateKey: autoStopEventId + COLON_DELIMITER + eventStateKey.split(COLON_DELIMITER)[1],
            actionListId: (0, _get.default)(eventToStop, "action.config.actionListId")
          });
        }
        (0, _IX2VanillaEngine.stopActionGroup)({
          store,
          eventId,
          eventTarget: element,
          eventStateKey,
          actionListId
        });
        (0, _IX2VanillaEngine.startActionGroup)({
          store,
          eventId,
          eventTarget: element,
          eventStateKey,
          actionListId
        });
        return state;
      };
      var withFilter = (filter2, handler) => (options, state) => (
        // $FlowFixMe
        filter2(options, state) === true ? handler(options, state) : state
      );
      var baseActionGroupOptions = {
        handler: withFilter(isOrContainsElement, actionGroupCreator)
      };
      var baseActivityActionGroupOptions = (0, _extends2.default)({}, baseActionGroupOptions, {
        types: [COMPONENT_ACTIVE, COMPONENT_INACTIVE].join(" ")
      });
      var SCROLL_EVENT_TYPES = [{
        target: window,
        types: "resize orientationchange",
        throttle: true
      }, {
        target: document,
        types: "scroll wheel readystatechange IX2_PAGE_UPDATE",
        throttle: true
      }];
      var MOUSE_OVER_OUT_TYPES = "mouseover mouseout";
      var baseScrollActionGroupOptions = {
        types: SCROLL_EVENT_TYPES
      };
      var AUTO_STOP_DISABLED_EVENTS = {
        PAGE_START,
        PAGE_FINISH
      };
      var getDocumentState = (() => {
        const supportOffset = window.pageXOffset !== void 0;
        const isCSS1Compat = document.compatMode === "CSS1Compat";
        const rootElement = isCSS1Compat ? document.documentElement : document.body;
        return () => ({
          // $FlowFixMe
          scrollLeft: supportOffset ? window.pageXOffset : rootElement.scrollLeft,
          // $FlowFixMe
          scrollTop: supportOffset ? window.pageYOffset : rootElement.scrollTop,
          // required to remove elasticity in Safari scrolling.
          stiffScrollTop: (0, _clamp.default)(
            // $FlowFixMe
            supportOffset ? window.pageYOffset : rootElement.scrollTop,
            0,
            // $FlowFixMe
            rootElement.scrollHeight - window.innerHeight
          ),
          // $FlowFixMe
          scrollWidth: rootElement.scrollWidth,
          // $FlowFixMe
          scrollHeight: rootElement.scrollHeight,
          // $FlowFixMe
          clientWidth: rootElement.clientWidth,
          // $FlowFixMe
          clientHeight: rootElement.clientHeight,
          innerWidth: window.innerWidth,
          innerHeight: window.innerHeight
        });
      })();
      var areBoxesIntersecting = (a, b) => !(a.left > b.right || a.right < b.left || a.top > b.bottom || a.bottom < b.top);
      var isElementHovered = ({
        element,
        nativeEvent
      }) => {
        const {
          type,
          target,
          relatedTarget
        } = nativeEvent;
        const containsTarget = element.contains(target);
        if (type === "mouseover" && containsTarget) {
          return true;
        }
        const containsRelated = element.contains(relatedTarget);
        if (type === "mouseout" && containsTarget && containsRelated) {
          return true;
        }
        return false;
      };
      var isElementVisible = (options) => {
        const {
          element,
          event: {
            config
          }
        } = options;
        const {
          clientWidth,
          clientHeight
        } = getDocumentState();
        const scrollOffsetValue = config.scrollOffsetValue;
        const scrollOffsetUnit = config.scrollOffsetUnit;
        const isPX = scrollOffsetUnit === "PX";
        const offsetPadding = isPX ? scrollOffsetValue : clientHeight * (scrollOffsetValue || 0) / 100;
        return areBoxesIntersecting(element.getBoundingClientRect(), {
          left: 0,
          top: offsetPadding,
          right: clientWidth,
          bottom: clientHeight - offsetPadding
        });
      };
      var whenComponentActiveChange = (handler) => (options, oldState) => {
        const {
          type
        } = options.nativeEvent;
        const isActive = [COMPONENT_ACTIVE, COMPONENT_INACTIVE].indexOf(type) !== -1 ? type === COMPONENT_ACTIVE : oldState.isActive;
        const newState = (0, _extends2.default)({}, oldState, {
          isActive
        });
        if (!oldState || newState.isActive !== oldState.isActive) {
          return handler(options, newState) || newState;
        }
        return newState;
      };
      var whenElementHoverChange = (handler) => (options, oldState) => {
        const newState = {
          elementHovered: isElementHovered(options)
        };
        if (oldState ? newState.elementHovered !== oldState.elementHovered : newState.elementHovered) {
          return handler(options, newState) || newState;
        }
        return newState;
      };
      var whenElementVisibiltyChange = (handler) => (options, oldState) => {
        const newState = (0, _extends2.default)({}, oldState, {
          elementVisible: isElementVisible(options)
        });
        if (oldState ? newState.elementVisible !== oldState.elementVisible : newState.elementVisible) {
          return handler(options, newState) || newState;
        }
        return newState;
      };
      var whenScrollDirectionChange = (handler) => (
        // $FlowFixMe
        (options, oldState = {}) => {
          const {
            stiffScrollTop: scrollTop,
            scrollHeight,
            innerHeight
          } = getDocumentState();
          const {
            event: {
              config,
              eventTypeId
            }
          } = options;
          const {
            scrollOffsetValue,
            scrollOffsetUnit
          } = config;
          const isPX = scrollOffsetUnit === "PX";
          const scrollHeightBounds = scrollHeight - innerHeight;
          const percentTop = Number((scrollTop / scrollHeightBounds).toFixed(2));
          if (oldState && oldState.percentTop === percentTop) {
            return oldState;
          }
          const scrollTopPadding = (isPX ? scrollOffsetValue : innerHeight * (scrollOffsetValue || 0) / 100) / scrollHeightBounds;
          let scrollingDown;
          let scrollDirectionChanged;
          let anchorTop = 0;
          if (oldState) {
            scrollingDown = percentTop > oldState.percentTop;
            scrollDirectionChanged = oldState.scrollingDown !== scrollingDown;
            anchorTop = scrollDirectionChanged ? percentTop : oldState.anchorTop;
          }
          const inBounds = eventTypeId === PAGE_SCROLL_DOWN ? percentTop >= anchorTop + scrollTopPadding : percentTop <= anchorTop - scrollTopPadding;
          const newState = (0, _extends2.default)({}, oldState, {
            percentTop,
            inBounds,
            anchorTop,
            scrollingDown
          });
          if (oldState && inBounds && (scrollDirectionChanged || newState.inBounds !== oldState.inBounds)) {
            return handler(options, newState) || newState;
          }
          return newState;
        }
      );
      var pointIntersects = (point, rect) => point.left > rect.left && point.left < rect.right && point.top > rect.top && point.top < rect.bottom;
      var whenPageLoadFinish = (handler) => (options, oldState) => {
        const newState = {
          finished: document.readyState === "complete"
        };
        if (newState.finished && !(oldState && oldState.finshed)) {
          handler(options);
        }
        return newState;
      };
      var whenPageLoadStart = (handler) => (options, oldState) => {
        const newState = {
          started: true
        };
        if (!oldState) {
          handler(options);
        }
        return newState;
      };
      var whenClickCountChange = (handler) => (options, oldState = {
        clickCount: 0
      }) => {
        const newState = {
          clickCount: oldState.clickCount % 2 + 1
        };
        if (newState.clickCount !== oldState.clickCount) {
          return handler(options, newState) || newState;
        }
        return newState;
      };
      var getComponentActiveOptions = (allowNestedChildrenEvents = true) => (0, _extends2.default)({}, baseActivityActionGroupOptions, {
        handler: withFilter(allowNestedChildrenEvents ? isOrContainsElement : isElement, whenComponentActiveChange((options, state) => {
          return state.isActive ? baseActionGroupOptions.handler(options, state) : state;
        }))
      });
      var getComponentInactiveOptions = (allowNestedChildrenEvents = true) => (0, _extends2.default)({}, baseActivityActionGroupOptions, {
        handler: withFilter(allowNestedChildrenEvents ? isOrContainsElement : isElement, whenComponentActiveChange((options, state) => {
          return !state.isActive ? baseActionGroupOptions.handler(options, state) : state;
        }))
      });
      var scrollIntoOutOfViewOptions = (0, _extends2.default)({}, baseScrollActionGroupOptions, {
        handler: whenElementVisibiltyChange((options, state) => {
          const {
            elementVisible
          } = state;
          const {
            event,
            store
          } = options;
          const {
            ixData
          } = store.getState();
          const {
            events
          } = ixData;
          if (!events[event.action.config.autoStopEventId] && state.triggered) {
            return state;
          }
          if (event.eventTypeId === SCROLL_INTO_VIEW === elementVisible) {
            actionGroupCreator(options);
            return (0, _extends2.default)({}, state, {
              triggered: true
            });
          } else {
            return state;
          }
        })
      });
      var MOUSE_OUT_ROUND_THRESHOLD = 0.05;
      var _default = {
        [SLIDER_ACTIVE]: getComponentActiveOptions(),
        [SLIDER_INACTIVE]: getComponentInactiveOptions(),
        [DROPDOWN_OPEN]: getComponentActiveOptions(),
        [DROPDOWN_CLOSE]: getComponentInactiveOptions(),
        // navbar elements may contain nested components in the menu. To prevent activity misfires, only listed for activity
        // events where the target is the navbar element, and ignore children that dispatch activitiy events.
        [NAVBAR_OPEN]: getComponentActiveOptions(false),
        [NAVBAR_CLOSE]: getComponentInactiveOptions(false),
        [TAB_ACTIVE]: getComponentActiveOptions(),
        [TAB_INACTIVE]: getComponentInactiveOptions(),
        [ECOMMERCE_CART_OPEN]: {
          types: "ecommerce-cart-open",
          handler: withFilter(isOrContainsElement, actionGroupCreator)
        },
        [ECOMMERCE_CART_CLOSE]: {
          types: "ecommerce-cart-close",
          handler: withFilter(isOrContainsElement, actionGroupCreator)
        },
        [MOUSE_CLICK]: {
          types: "click",
          handler: withFilter(isOrContainsElement, whenClickCountChange((options, {
            clickCount
          }) => {
            if (hasAutoStopEvent(options)) {
              clickCount === 1 && actionGroupCreator(options);
            } else {
              actionGroupCreator(options);
            }
          }))
        },
        [MOUSE_SECOND_CLICK]: {
          types: "click",
          handler: withFilter(isOrContainsElement, whenClickCountChange((options, {
            clickCount
          }) => {
            if (clickCount === 2) {
              actionGroupCreator(options);
            }
          }))
        },
        [MOUSE_DOWN]: (0, _extends2.default)({}, baseActionGroupOptions, {
          types: "mousedown"
        }),
        [MOUSE_UP]: (0, _extends2.default)({}, baseActionGroupOptions, {
          types: "mouseup"
        }),
        [MOUSE_OVER]: {
          types: MOUSE_OVER_OUT_TYPES,
          handler: withFilter(isOrContainsElement, whenElementHoverChange((options, state) => {
            if (state.elementHovered) {
              actionGroupCreator(options);
            }
          }))
        },
        [MOUSE_OUT]: {
          types: MOUSE_OVER_OUT_TYPES,
          handler: withFilter(isOrContainsElement, whenElementHoverChange((options, state) => {
            if (!state.elementHovered) {
              actionGroupCreator(options);
            }
          }))
        },
        [MOUSE_MOVE]: {
          types: "mousemove mouseout scroll",
          handler: ({
            store,
            element,
            eventConfig,
            nativeEvent,
            eventStateKey
          }, state = {
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0
          }) => {
            const {
              basedOn,
              selectedAxis,
              continuousParameterGroupId,
              reverse,
              restingState = 0
            } = eventConfig;
            const {
              clientX = state.clientX,
              clientY = state.clientY,
              pageX = state.pageX,
              pageY = state.pageY
            } = nativeEvent;
            const isXAxis = selectedAxis === "X_AXIS";
            const isMouseOut = nativeEvent.type === "mouseout";
            let value = restingState / 100;
            let namespacedParameterId = continuousParameterGroupId;
            let elementHovered = false;
            switch (basedOn) {
              case _constants.EventBasedOn.VIEWPORT: {
                value = isXAxis ? Math.min(clientX, window.innerWidth) / window.innerWidth : Math.min(clientY, window.innerHeight) / window.innerHeight;
                break;
              }
              case _constants.EventBasedOn.PAGE: {
                const {
                  scrollLeft,
                  scrollTop,
                  scrollWidth,
                  scrollHeight
                } = getDocumentState();
                value = isXAxis ? Math.min(scrollLeft + pageX, scrollWidth) / scrollWidth : Math.min(scrollTop + pageY, scrollHeight) / scrollHeight;
                break;
              }
              case _constants.EventBasedOn.ELEMENT:
              default: {
                namespacedParameterId = getNamespacedParameterId(eventStateKey, continuousParameterGroupId);
                const isMouseEvent = nativeEvent.type.indexOf("mouse") === 0;
                if (isMouseEvent && isOrContainsElement({
                  element,
                  nativeEvent
                }) !== true) {
                  break;
                }
                const rect = element.getBoundingClientRect();
                const {
                  left,
                  top,
                  width,
                  height
                } = rect;
                if (!isMouseEvent && !pointIntersects({
                  left: clientX,
                  top: clientY
                }, rect)) {
                  break;
                }
                elementHovered = true;
                value = isXAxis ? (clientX - left) / width : (clientY - top) / height;
                break;
              }
            }
            if (isMouseOut && (value > 1 - MOUSE_OUT_ROUND_THRESHOLD || value < MOUSE_OUT_ROUND_THRESHOLD)) {
              value = Math.round(value);
            }
            if (basedOn !== _constants.EventBasedOn.ELEMENT || elementHovered || // $FlowFixMe
            elementHovered !== state.elementHovered) {
              value = reverse ? 1 - value : value;
              store.dispatch((0, _IX2EngineActions.parameterChanged)(namespacedParameterId, value));
            }
            return {
              elementHovered,
              clientX,
              clientY,
              pageX,
              pageY
            };
          }
        },
        [PAGE_SCROLL]: {
          types: SCROLL_EVENT_TYPES,
          // $FlowFixMe
          handler: ({
            store,
            eventConfig
          }) => {
            const {
              continuousParameterGroupId,
              reverse
            } = eventConfig;
            const {
              scrollTop,
              scrollHeight,
              clientHeight
            } = getDocumentState();
            let value = scrollTop / (scrollHeight - clientHeight);
            value = reverse ? 1 - value : value;
            store.dispatch((0, _IX2EngineActions.parameterChanged)(continuousParameterGroupId, value));
          }
        },
        [SCROLLING_IN_VIEW]: {
          types: SCROLL_EVENT_TYPES,
          handler: ({
            element,
            store,
            eventConfig,
            eventStateKey
          }, state = {
            scrollPercent: 0
          }) => {
            const {
              scrollLeft,
              scrollTop,
              scrollWidth,
              scrollHeight,
              clientHeight: visibleHeight
            } = getDocumentState();
            const {
              basedOn,
              selectedAxis,
              continuousParameterGroupId,
              startsEntering,
              startsExiting,
              addEndOffset,
              addStartOffset,
              addOffsetValue = 0,
              endOffsetValue = 0
            } = eventConfig;
            const isXAxis = selectedAxis === "X_AXIS";
            if (basedOn === _constants.EventBasedOn.VIEWPORT) {
              const value = isXAxis ? scrollLeft / scrollWidth : scrollTop / scrollHeight;
              if (value !== state.scrollPercent) {
                store.dispatch((0, _IX2EngineActions.parameterChanged)(continuousParameterGroupId, value));
              }
              return {
                scrollPercent: value
              };
            } else {
              const namespacedParameterId = getNamespacedParameterId(eventStateKey, continuousParameterGroupId);
              const elementRect = element.getBoundingClientRect();
              let offsetStartPerc = (addStartOffset ? addOffsetValue : 0) / 100;
              let offsetEndPerc = (addEndOffset ? endOffsetValue : 0) / 100;
              offsetStartPerc = startsEntering ? offsetStartPerc : 1 - offsetStartPerc;
              offsetEndPerc = startsExiting ? offsetEndPerc : 1 - offsetEndPerc;
              const offsetElementTop = elementRect.top + Math.min(elementRect.height * offsetStartPerc, visibleHeight);
              const offsetElementBottom = elementRect.top + elementRect.height * offsetEndPerc;
              const offsetHeight = offsetElementBottom - offsetElementTop;
              const fixedScrollHeight = Math.min(visibleHeight + offsetHeight, scrollHeight);
              const fixedScrollTop = Math.min(Math.max(0, visibleHeight - offsetElementTop), fixedScrollHeight);
              const fixedScrollPerc = fixedScrollTop / fixedScrollHeight;
              if (fixedScrollPerc !== state.scrollPercent) {
                store.dispatch((0, _IX2EngineActions.parameterChanged)(namespacedParameterId, fixedScrollPerc));
              }
              return {
                scrollPercent: fixedScrollPerc
              };
            }
          }
        },
        [SCROLL_INTO_VIEW]: scrollIntoOutOfViewOptions,
        [SCROLL_OUT_OF_VIEW]: scrollIntoOutOfViewOptions,
        [PAGE_SCROLL_DOWN]: (0, _extends2.default)({}, baseScrollActionGroupOptions, {
          handler: whenScrollDirectionChange((options, state) => {
            if (state.scrollingDown) {
              actionGroupCreator(options);
            }
          })
        }),
        [PAGE_SCROLL_UP]: (0, _extends2.default)({}, baseScrollActionGroupOptions, {
          handler: whenScrollDirectionChange((options, state) => {
            if (!state.scrollingDown) {
              actionGroupCreator(options);
            }
          })
        }),
        [PAGE_FINISH]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: withFilter(isElement, whenPageLoadFinish(actionGroupCreator))
        },
        [PAGE_START]: {
          types: "readystatechange IX2_PAGE_UPDATE",
          handler: withFilter(isElement, whenPageLoadStart(actionGroupCreator))
        }
      };
      exports.default = _default;
    }
  });

  // packages/systems/ix2/engine/logic/IX2VanillaEngine.js
  var require_IX2VanillaEngine = __commonJS({
    "packages/systems/ix2/engine/logic/IX2VanillaEngine.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      var _interopRequireWildcard = require_interopRequireWildcard().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.observeRequests = observeRequests;
      exports.startActionGroup = startActionGroup;
      exports.startEngine = startEngine;
      exports.stopActionGroup = stopActionGroup;
      exports.stopAllActionGroups = stopAllActionGroups;
      exports.stopEngine = stopEngine;
      var _extends2 = _interopRequireDefault(require_extends());
      var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require_objectWithoutPropertiesLoose());
      var _find = _interopRequireDefault(require_find());
      var _get = _interopRequireDefault(require_get());
      var _size = _interopRequireDefault(require_size());
      var _omitBy = _interopRequireDefault(require_omitBy());
      var _isEmpty = _interopRequireDefault(require_isEmpty());
      var _mapValues = _interopRequireDefault(require_mapValues());
      var _forEach = _interopRequireDefault(require_forEach());
      var _throttle = _interopRequireDefault(require_throttle());
      var _constants = require_constants();
      var _shared = require_shared2();
      var _IX2EngineActions = require_IX2EngineActions();
      var elementApi = _interopRequireWildcard(require_IX2BrowserApi());
      var _IX2VanillaEvents = _interopRequireDefault(require_IX2VanillaEvents());
      var _excluded = ["store", "computedStyle"];
      var QuickEffectsIdList = Object.keys(_constants.QuickEffectIds);
      var isQuickEffect = (actionTypeId) => QuickEffectsIdList.includes(actionTypeId);
      var {
        COLON_DELIMITER,
        BOUNDARY_SELECTOR,
        HTML_ELEMENT,
        RENDER_GENERAL,
        W_MOD_IX
      } = _constants.IX2EngineConstants;
      var {
        getAffectedElements,
        getElementId,
        getDestinationValues,
        observeStore,
        getInstanceId,
        renderHTMLElement,
        clearAllStyles,
        getMaxDurationItemIndex,
        getComputedStyle: getComputedStyle2,
        getInstanceOrigin,
        reduceListToGroup,
        shouldNamespaceEventParameter,
        getNamespacedParameterId,
        shouldAllowMediaQuery,
        cleanupHTMLElement,
        clearObjectCache,
        stringifyTarget,
        mediaQueriesEqual,
        shallowEqual
      } = _shared.IX2VanillaUtils;
      var {
        isPluginType,
        createPluginInstance,
        getPluginDuration
      } = _shared.IX2VanillaPlugins;
      var ua = navigator.userAgent;
      var IS_MOBILE_SAFARI = ua.match(/iPad/i) || ua.match(/iPhone/);
      var THROTTLED_EVENT_WAIT = 12;
      function observeRequests(store) {
        observeStore({
          store,
          select: ({
            ixRequest
          }) => ixRequest.preview,
          onChange: handlePreviewRequest
        });
        observeStore({
          store,
          select: ({
            ixRequest
          }) => ixRequest.playback,
          onChange: handlePlaybackRequest
        });
        observeStore({
          store,
          select: ({
            ixRequest
          }) => ixRequest.stop,
          onChange: handleStopRequest
        });
        observeStore({
          store,
          select: ({
            ixRequest
          }) => ixRequest.clear,
          onChange: handleClearRequest
        });
      }
      function observeMediaQueryChange(store) {
        observeStore({
          store,
          select: ({
            ixSession
          }) => ixSession.mediaQueryKey,
          onChange: () => {
            stopEngine(store);
            clearAllStyles({
              store,
              elementApi
            });
            startEngine({
              store,
              allowEvents: true
            });
            dispatchPageUpdateEvent();
          }
        });
      }
      function observeOneRenderTick(store, onTick) {
        const unsubscribe = observeStore({
          store,
          select: ({
            ixSession
          }) => ixSession.tick,
          onChange: (tick) => {
            onTick(tick);
            unsubscribe();
          }
        });
      }
      function handlePreviewRequest({
        rawData,
        defer
      }, store) {
        const start = () => {
          startEngine({
            store,
            rawData,
            allowEvents: true
          });
          dispatchPageUpdateEvent();
        };
        defer ? setTimeout(start, 0) : start();
      }
      function dispatchPageUpdateEvent() {
        document.dispatchEvent(new CustomEvent("IX2_PAGE_UPDATE"));
      }
      function handlePlaybackRequest(playback, store) {
        const {
          actionTypeId,
          actionListId,
          actionItemId,
          eventId,
          allowEvents,
          immediate,
          testManual,
          verbose = true
        } = playback;
        let {
          rawData
        } = playback;
        if (actionListId && actionItemId && rawData && immediate) {
          const actionList = rawData.actionLists[actionListId];
          if (actionList) {
            rawData = reduceListToGroup({
              actionList,
              actionItemId,
              rawData
            });
          }
        }
        startEngine({
          store,
          rawData,
          allowEvents,
          testManual
        });
        if (actionListId && actionTypeId === _constants.ActionTypeConsts.GENERAL_START_ACTION || isQuickEffect(actionTypeId)) {
          stopActionGroup({
            store,
            actionListId
          });
          renderInitialGroup({
            store,
            actionListId,
            eventId
          });
          const started = startActionGroup({
            store,
            eventId,
            actionListId,
            immediate,
            verbose
          });
          if (verbose && started) {
            store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
              actionListId,
              isPlaying: !immediate
            }));
          }
        }
      }
      function handleStopRequest({
        actionListId
      }, store) {
        if (actionListId) {
          stopActionGroup({
            store,
            actionListId
          });
        } else {
          stopAllActionGroups({
            store
          });
        }
        stopEngine(store);
      }
      function handleClearRequest(state, store) {
        stopEngine(store);
        clearAllStyles({
          store,
          elementApi
        });
      }
      function startEngine({
        store,
        rawData,
        allowEvents,
        testManual
      }) {
        const {
          ixSession
        } = store.getState();
        if (rawData) {
          store.dispatch((0, _IX2EngineActions.rawDataImported)(rawData));
        }
        if (!ixSession.active) {
          store.dispatch((0, _IX2EngineActions.sessionInitialized)({
            hasBoundaryNodes: Boolean(document.querySelector(BOUNDARY_SELECTOR)),
            reducedMotion: (
              // $FlowFixMe - Remove this attribute on beta launch
              document.body.hasAttribute("data-wf-ix-vacation") && window.matchMedia("(prefers-reduced-motion)").matches
            )
          }));
          if (allowEvents) {
            bindEvents(store);
            addDocumentClass();
            if (store.getState().ixSession.hasDefinedMediaQueries) {
              observeMediaQueryChange(store);
            }
          }
          store.dispatch((0, _IX2EngineActions.sessionStarted)());
          startRenderLoop(store, testManual);
        }
      }
      function addDocumentClass() {
        const {
          documentElement
        } = document;
        if (documentElement.className.indexOf(W_MOD_IX) === -1) {
          documentElement.className += ` ${W_MOD_IX}`;
        }
      }
      function startRenderLoop(store, testManual) {
        const handleFrame = (now) => {
          const {
            ixSession,
            ixParameters
          } = store.getState();
          if (ixSession.active) {
            store.dispatch((0, _IX2EngineActions.animationFrameChanged)(now, ixParameters));
            if (testManual) {
              observeOneRenderTick(store, handleFrame);
            } else {
              requestAnimationFrame(handleFrame);
            }
          }
        };
        handleFrame(window.performance.now());
      }
      function stopEngine(store) {
        const {
          ixSession
        } = store.getState();
        if (ixSession.active) {
          const {
            eventListeners
          } = ixSession;
          eventListeners.forEach(clearEventListener);
          clearObjectCache();
          store.dispatch((0, _IX2EngineActions.sessionStopped)());
        }
      }
      function clearEventListener({
        target,
        listenerParams
      }) {
        target.removeEventListener.apply(target, listenerParams);
      }
      function createGroupInstances({
        store,
        eventStateKey,
        eventTarget,
        eventId,
        eventConfig,
        actionListId,
        parameterGroup,
        smoothing,
        restingValue
      }) {
        const {
          ixData,
          ixSession
        } = store.getState();
        const {
          events
        } = ixData;
        const event = events[eventId];
        const {
          eventTypeId
        } = event;
        const targetCache = {};
        const instanceActionGroups = {};
        const instanceConfigs = [];
        const {
          continuousActionGroups
        } = parameterGroup;
        let {
          id: parameterId
        } = parameterGroup;
        if (shouldNamespaceEventParameter(eventTypeId, eventConfig)) {
          parameterId = getNamespacedParameterId(eventStateKey, parameterId);
        }
        const eventElementRoot = ixSession.hasBoundaryNodes && eventTarget ? elementApi.getClosestElement(eventTarget, BOUNDARY_SELECTOR) : null;
        continuousActionGroups.forEach((actionGroup) => {
          const {
            keyframe,
            actionItems
          } = actionGroup;
          actionItems.forEach((actionItem) => {
            const {
              actionTypeId
            } = actionItem;
            const {
              target
            } = actionItem.config;
            if (!target) {
              return;
            }
            const elementRoot = target.boundaryMode ? eventElementRoot : null;
            const key = stringifyTarget(target) + COLON_DELIMITER + actionTypeId;
            instanceActionGroups[key] = appendActionItem(instanceActionGroups[key], keyframe, actionItem);
            if (!targetCache[key]) {
              targetCache[key] = true;
              const {
                config
              } = actionItem;
              getAffectedElements({
                config,
                event,
                eventTarget,
                elementRoot,
                elementApi
              }).forEach((element) => {
                instanceConfigs.push({
                  element,
                  key
                });
              });
            }
          });
        });
        instanceConfigs.forEach(({
          element,
          key
        }) => {
          const actionGroups = instanceActionGroups[key];
          const actionItem = (0, _get.default)(actionGroups, `[0].actionItems[0]`, {});
          const {
            actionTypeId
          } = actionItem;
          const pluginInstance = isPluginType(actionTypeId) ? (
            // $FlowFixMe
            createPluginInstance(actionTypeId)(element, actionItem)
          ) : null;
          const destination = getDestinationValues(
            {
              element,
              actionItem,
              elementApi
            },
            // $FlowFixMe
            pluginInstance
          );
          createInstance({
            store,
            element,
            eventId,
            actionListId,
            actionItem,
            destination,
            continuous: true,
            parameterId,
            actionGroups,
            smoothing,
            restingValue,
            pluginInstance
          });
        });
      }
      function appendActionItem(actionGroups = [], keyframe, actionItem) {
        const newActionGroups = [...actionGroups];
        let groupIndex;
        newActionGroups.some((group, index) => {
          if (group.keyframe === keyframe) {
            groupIndex = index;
            return true;
          }
          return false;
        });
        if (groupIndex == null) {
          groupIndex = newActionGroups.length;
          newActionGroups.push({
            keyframe,
            actionItems: []
          });
        }
        newActionGroups[groupIndex].actionItems.push(actionItem);
        return newActionGroups;
      }
      function bindEvents(store) {
        const {
          ixData
        } = store.getState();
        const {
          eventTypeMap
        } = ixData;
        updateViewportWidth(store);
        (0, _forEach.default)(eventTypeMap, (events, key) => {
          const logic = _IX2VanillaEvents.default[key];
          if (!logic) {
            console.warn(`IX2 event type not configured: ${key}`);
            return;
          }
          bindEventType({
            logic,
            store,
            events
          });
        });
        const {
          ixSession
        } = store.getState();
        if (ixSession.eventListeners.length) {
          bindResizeEvents(store);
        }
      }
      var WINDOW_RESIZE_EVENTS = ["resize", "orientationchange"];
      function bindResizeEvents(store) {
        const handleResize = () => {
          updateViewportWidth(store);
        };
        WINDOW_RESIZE_EVENTS.forEach((type) => {
          window.addEventListener(type, handleResize);
          store.dispatch((0, _IX2EngineActions.eventListenerAdded)(window, [type, handleResize]));
        });
        handleResize();
      }
      function updateViewportWidth(store) {
        const {
          ixSession,
          ixData
        } = store.getState();
        const width = window.innerWidth;
        if (width !== ixSession.viewportWidth) {
          const {
            mediaQueries
          } = ixData;
          store.dispatch((0, _IX2EngineActions.viewportWidthChanged)({
            width,
            mediaQueries
          }));
        }
      }
      var mapFoundValues = (object, iteratee) => (0, _omitBy.default)((0, _mapValues.default)(object, iteratee), _isEmpty.default);
      var forEachEventTarget = (eventTargets, eventCallback) => {
        (0, _forEach.default)(eventTargets, (elements, eventId) => {
          elements.forEach((element, index) => {
            const eventStateKey = eventId + COLON_DELIMITER + index;
            eventCallback(element, eventId, eventStateKey);
          });
        });
      };
      var getAffectedForEvent = (event) => {
        const config = {
          target: event.target,
          targets: event.targets
        };
        return getAffectedElements({
          config,
          elementApi
        });
      };
      function bindEventType({
        logic,
        store,
        events
      }) {
        injectBehaviorCSSFixes(events);
        const {
          types: eventTypes,
          handler: eventHandler
        } = logic;
        const {
          ixData
        } = store.getState();
        const {
          actionLists
        } = ixData;
        const eventTargets = mapFoundValues(events, getAffectedForEvent);
        if (!(0, _size.default)(eventTargets)) {
          return;
        }
        (0, _forEach.default)(eventTargets, (elements, key) => {
          const event = events[key];
          const {
            action: eventAction,
            id: eventId,
            mediaQueries = ixData.mediaQueryKeys
          } = event;
          const {
            actionListId
          } = eventAction.config;
          if (!mediaQueriesEqual(mediaQueries, ixData.mediaQueryKeys)) {
            store.dispatch((0, _IX2EngineActions.mediaQueriesDefined)());
          }
          if (eventAction.actionTypeId === _constants.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION) {
            const configs = Array.isArray(event.config) ? event.config : [event.config];
            configs.forEach((eventConfig) => {
              const {
                continuousParameterGroupId
              } = eventConfig;
              const paramGroups = (0, _get.default)(actionLists, `${actionListId}.continuousParameterGroups`, []);
              const parameterGroup = (0, _find.default)(paramGroups, ({
                id
              }) => id === continuousParameterGroupId);
              const smoothing = (eventConfig.smoothing || 0) / 100;
              const restingValue = (eventConfig.restingState || 0) / 100;
              if (!parameterGroup) {
                return;
              }
              elements.forEach((eventTarget, index) => {
                const eventStateKey = eventId + COLON_DELIMITER + index;
                createGroupInstances({
                  store,
                  eventStateKey,
                  eventTarget,
                  eventId,
                  eventConfig,
                  actionListId,
                  parameterGroup,
                  smoothing,
                  restingValue
                });
              });
            });
          }
          if (eventAction.actionTypeId === _constants.ActionTypeConsts.GENERAL_START_ACTION || isQuickEffect(eventAction.actionTypeId)) {
            renderInitialGroup({
              store,
              actionListId,
              eventId
            });
          }
        });
        const handleEvent = (nativeEvent) => {
          const {
            ixSession
          } = store.getState();
          forEachEventTarget(eventTargets, (element, eventId, eventStateKey) => {
            const event = events[eventId];
            const oldState = ixSession.eventState[eventStateKey];
            const {
              action: eventAction,
              mediaQueries = ixData.mediaQueryKeys
            } = event;
            if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
              return;
            }
            const handleEventWithConfig = (eventConfig = {}) => {
              const newState = eventHandler({
                store,
                element,
                event,
                eventConfig,
                nativeEvent,
                eventStateKey
              }, oldState);
              if (!shallowEqual(newState, oldState)) {
                store.dispatch((0, _IX2EngineActions.eventStateChanged)(eventStateKey, newState));
              }
            };
            if (eventAction.actionTypeId === _constants.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION) {
              const configs = Array.isArray(event.config) ? event.config : [event.config];
              configs.forEach(handleEventWithConfig);
            } else {
              handleEventWithConfig();
            }
          });
        };
        const handleEventThrottled = (0, _throttle.default)(handleEvent, THROTTLED_EVENT_WAIT);
        const addListeners = ({
          target = document,
          types,
          throttle: shouldThrottle
        }) => {
          types.split(" ").filter(Boolean).forEach((type) => {
            const handlerFunc = shouldThrottle ? handleEventThrottled : handleEvent;
            target.addEventListener(type, handlerFunc);
            store.dispatch((0, _IX2EngineActions.eventListenerAdded)(target, [type, handlerFunc]));
          });
        };
        if (Array.isArray(eventTypes)) {
          eventTypes.forEach(addListeners);
        } else if (typeof eventTypes === "string") {
          addListeners(logic);
        }
      }
      function injectBehaviorCSSFixes(events) {
        if (!IS_MOBILE_SAFARI) {
          return;
        }
        const injectedSelectors = {};
        let cssText = "";
        for (const eventId in events) {
          const {
            eventTypeId,
            target
          } = events[eventId];
          const selector = elementApi.getQuerySelector(target);
          if (injectedSelectors[selector]) {
            continue;
          }
          if (eventTypeId === _constants.EventTypeConsts.MOUSE_CLICK || eventTypeId === _constants.EventTypeConsts.MOUSE_SECOND_CLICK) {
            injectedSelectors[selector] = true;
            cssText += // $FlowFixMe
            selector + "{cursor: pointer;touch-action: manipulation;}";
          }
        }
        if (cssText) {
          const style = document.createElement("style");
          style.textContent = cssText;
          document.body.appendChild(style);
        }
      }
      function renderInitialGroup({
        store,
        actionListId,
        eventId
      }) {
        const {
          ixData,
          ixSession
        } = store.getState();
        const {
          actionLists,
          events
        } = ixData;
        const event = events[eventId];
        const actionList = actionLists[actionListId];
        if (actionList && actionList.useFirstGroupAsInitialState) {
          const initialStateItems = (0, _get.default)(actionList, "actionItemGroups[0].actionItems", []);
          const mediaQueries = (0, _get.default)(event, "mediaQueries", ixData.mediaQueryKeys);
          if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
            return;
          }
          initialStateItems.forEach((actionItem) => {
            var _itemConfig$target;
            const {
              config: itemConfig,
              actionTypeId
            } = actionItem;
            const config = (
              // When useEventTarget is explicitly true, use event target/targets to query elements
              (itemConfig === null || itemConfig === void 0 ? void 0 : (_itemConfig$target = itemConfig.target) === null || _itemConfig$target === void 0 ? void 0 : _itemConfig$target.useEventTarget) === true ? {
                target: event.target,
                targets: event.targets
              } : itemConfig
            );
            const itemElements = getAffectedElements({
              config,
              event,
              elementApi
            });
            const shouldUsePlugin = isPluginType(actionTypeId);
            itemElements.forEach((element) => {
              const pluginInstance = shouldUsePlugin ? (
                // $FlowFixMe
                createPluginInstance(actionTypeId)(element, actionItem)
              ) : null;
              createInstance({
                destination: getDestinationValues(
                  {
                    element,
                    actionItem,
                    elementApi
                  },
                  // $FlowFixMe
                  pluginInstance
                ),
                immediate: true,
                store,
                element,
                eventId,
                actionItem,
                actionListId,
                pluginInstance
              });
            });
          });
        }
      }
      function stopAllActionGroups({
        store
      }) {
        const {
          ixInstances
        } = store.getState();
        (0, _forEach.default)(ixInstances, (instance) => {
          if (!instance.continuous) {
            const {
              actionListId,
              verbose
            } = instance;
            removeInstance(instance, store);
            if (verbose) {
              store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
                actionListId,
                isPlaying: false
              }));
            }
          }
        });
      }
      function stopActionGroup({
        store,
        // $FlowFixMe
        eventId,
        // $FlowFixMe
        eventTarget,
        // $FlowFixMe
        eventStateKey,
        actionListId
      }) {
        const {
          ixInstances,
          ixSession
        } = store.getState();
        const eventElementRoot = ixSession.hasBoundaryNodes && eventTarget ? elementApi.getClosestElement(eventTarget, BOUNDARY_SELECTOR) : null;
        (0, _forEach.default)(ixInstances, (instance) => {
          const boundaryMode = (0, _get.default)(instance, "actionItem.config.target.boundaryMode");
          const validEventKey = eventStateKey ? instance.eventStateKey === eventStateKey : true;
          if (instance.actionListId === actionListId && instance.eventId === eventId && validEventKey) {
            if (eventElementRoot && boundaryMode && !elementApi.elementContains(eventElementRoot, instance.element)) {
              return;
            }
            removeInstance(instance, store);
            if (instance.verbose) {
              store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
                actionListId,
                isPlaying: false
              }));
            }
          }
        });
      }
      function startActionGroup({
        store,
        eventId,
        // $FlowFixMe
        eventTarget,
        // $FlowFixMe
        eventStateKey,
        actionListId,
        groupIndex = 0,
        // $FlowFixMe
        immediate,
        // $FlowFixMe
        verbose
      }) {
        var _event$action;
        const {
          ixData,
          ixSession
        } = store.getState();
        const {
          events
        } = ixData;
        const event = events[eventId] || {};
        const {
          mediaQueries = ixData.mediaQueryKeys
        } = event;
        const actionList = (0, _get.default)(ixData, `actionLists.${actionListId}`, {});
        const {
          actionItemGroups,
          useFirstGroupAsInitialState
        } = actionList;
        if (!actionItemGroups || !actionItemGroups.length) {
          return false;
        }
        if (groupIndex >= actionItemGroups.length && (0, _get.default)(event, "config.loop")) {
          groupIndex = 0;
        }
        if (groupIndex === 0 && useFirstGroupAsInitialState) {
          groupIndex++;
        }
        const isFirstGroup = groupIndex === 0 || groupIndex === 1 && useFirstGroupAsInitialState;
        const instanceDelay = isFirstGroup && isQuickEffect((_event$action = event.action) === null || _event$action === void 0 ? void 0 : _event$action.actionTypeId) ? event.config.delay : void 0;
        const actionItems = (0, _get.default)(actionItemGroups, [groupIndex, "actionItems"], []);
        if (!actionItems.length) {
          return false;
        }
        if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
          return false;
        }
        const eventElementRoot = ixSession.hasBoundaryNodes && eventTarget ? elementApi.getClosestElement(eventTarget, BOUNDARY_SELECTOR) : null;
        const carrierIndex = getMaxDurationItemIndex(actionItems);
        let groupStartResult = false;
        actionItems.forEach((actionItem, actionIndex) => {
          const {
            config,
            actionTypeId
          } = actionItem;
          const shouldUsePlugin = isPluginType(actionTypeId);
          const {
            target
          } = config;
          if (!target) {
            return;
          }
          const elementRoot = target.boundaryMode ? eventElementRoot : null;
          const elements = getAffectedElements({
            config,
            event,
            eventTarget,
            elementRoot,
            elementApi
          });
          elements.forEach((element, elementIndex) => {
            const pluginInstance = shouldUsePlugin ? (
              // $FlowFixMe
              createPluginInstance(actionTypeId)(element, actionItem)
            ) : null;
            const pluginDuration = shouldUsePlugin ? (
              // $FlowFixMe
              getPluginDuration(actionTypeId)(element, actionItem)
            ) : null;
            groupStartResult = true;
            const isCarrier = carrierIndex === actionIndex && elementIndex === 0;
            const computedStyle = getComputedStyle2({
              element,
              actionItem
            });
            const destination = getDestinationValues(
              {
                element,
                actionItem,
                elementApi
              },
              // $FlowFixMe
              pluginInstance
            );
            createInstance({
              store,
              element,
              actionItem,
              eventId,
              eventTarget,
              eventStateKey,
              actionListId,
              groupIndex,
              isCarrier,
              computedStyle,
              destination,
              immediate,
              verbose,
              pluginInstance,
              pluginDuration,
              instanceDelay
            });
          });
        });
        return groupStartResult;
      }
      function createInstance(options) {
        var _ixData$events$eventI;
        const {
          store,
          computedStyle
        } = options, rest = (0, _objectWithoutPropertiesLoose2.default)(options, _excluded);
        const {
          element,
          actionItem,
          // $FlowIgnore - Flow 0.121.0
          immediate,
          pluginInstance,
          // $FlowIgnore - Flow 0.121.0
          continuous,
          // $FlowIgnore - Flow 0.121.0
          restingValue,
          eventId
        } = rest;
        const autoStart = !continuous;
        const instanceId = getInstanceId();
        const {
          ixElements,
          ixSession,
          ixData
        } = store.getState();
        const elementId = getElementId(ixElements, element);
        const {
          refState
        } = ixElements[elementId] || {};
        const refType = elementApi.getRefType(element);
        const skipMotion = ixSession.reducedMotion && _constants.ReducedMotionTypes[actionItem.actionTypeId];
        let skipToValue;
        if (skipMotion && continuous) {
          switch ((_ixData$events$eventI = ixData.events[eventId]) === null || _ixData$events$eventI === void 0 ? void 0 : _ixData$events$eventI.eventTypeId) {
            case _constants.EventTypeConsts.MOUSE_MOVE:
            case _constants.EventTypeConsts.MOUSE_MOVE_IN_VIEWPORT:
              skipToValue = restingValue;
              break;
            default:
              skipToValue = 0.5;
              break;
          }
        }
        const origin = getInstanceOrigin(
          element,
          refState,
          computedStyle,
          actionItem,
          elementApi,
          // $FlowFixMe
          pluginInstance
        );
        store.dispatch((0, _IX2EngineActions.instanceAdded)((0, _extends2.default)({
          instanceId,
          elementId,
          origin,
          refType,
          skipMotion,
          skipToValue
        }, rest)));
        dispatchCustomEvent(document.body, "ix2-animation-started", instanceId);
        if (immediate) {
          renderImmediateInstance(store, instanceId);
          return;
        }
        observeStore({
          store,
          select: ({
            ixInstances
          }) => ixInstances[instanceId],
          onChange: handleInstanceChange
        });
        if (autoStart) {
          store.dispatch((0, _IX2EngineActions.instanceStarted)(instanceId, ixSession.tick));
        }
      }
      function removeInstance(instance, store) {
        dispatchCustomEvent(document.body, "ix2-animation-stopping", {
          instanceId: instance.id,
          state: store.getState()
        });
        const {
          elementId,
          actionItem
        } = instance;
        const {
          ixElements
        } = store.getState();
        const {
          ref,
          refType
        } = ixElements[elementId] || {};
        if (refType === HTML_ELEMENT) {
          cleanupHTMLElement(ref, actionItem, elementApi);
        }
        store.dispatch((0, _IX2EngineActions.instanceRemoved)(instance.id));
      }
      function dispatchCustomEvent(element, eventName, detail) {
        const event = document.createEvent("CustomEvent");
        event.initCustomEvent(eventName, true, true, detail);
        element.dispatchEvent(event);
      }
      function renderImmediateInstance(store, instanceId) {
        const {
          ixParameters
        } = store.getState();
        store.dispatch((0, _IX2EngineActions.instanceStarted)(instanceId, 0));
        store.dispatch((0, _IX2EngineActions.animationFrameChanged)(performance.now(), ixParameters));
        const {
          ixInstances
        } = store.getState();
        handleInstanceChange(ixInstances[instanceId], store);
      }
      function handleInstanceChange(instance, store) {
        const {
          active,
          continuous,
          complete,
          elementId,
          actionItem,
          actionTypeId,
          renderType,
          current,
          groupIndex,
          eventId,
          eventTarget,
          eventStateKey,
          actionListId,
          isCarrier,
          styleProp,
          verbose,
          pluginInstance
        } = instance;
        const {
          ixData,
          ixSession
        } = store.getState();
        const {
          events
        } = ixData;
        const event = events[eventId] || {};
        const {
          mediaQueries = ixData.mediaQueryKeys
        } = event;
        if (!shouldAllowMediaQuery(mediaQueries, ixSession.mediaQueryKey)) {
          return;
        }
        if (continuous || active || complete) {
          if (current || renderType === RENDER_GENERAL && complete) {
            store.dispatch((0, _IX2EngineActions.elementStateChanged)(elementId, actionTypeId, current, actionItem));
            const {
              ixElements
            } = store.getState();
            const {
              ref,
              refType,
              refState
            } = ixElements[elementId] || {};
            const actionState = refState && refState[actionTypeId];
            if (refType === HTML_ELEMENT || isPluginType(actionTypeId)) {
              renderHTMLElement(ref, refState, actionState, eventId, actionItem, styleProp, elementApi, renderType, pluginInstance);
            }
          }
          if (complete) {
            if (isCarrier) {
              const started = startActionGroup({
                store,
                eventId,
                eventTarget,
                eventStateKey,
                actionListId,
                groupIndex: groupIndex + 1,
                verbose
              });
              if (verbose && !started) {
                store.dispatch((0, _IX2EngineActions.actionListPlaybackChanged)({
                  actionListId,
                  isPlaying: false
                }));
              }
            }
            removeInstance(instance, store);
          }
        }
      }
    }
  });

  // packages/systems/ix2/engine/index.js
  var require_engine = __commonJS({
    "packages/systems/ix2/engine/index.js"(exports) {
      "use strict";
      var _interopRequireWildcard = require_interopRequireWildcard().default;
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.actions = void 0;
      exports.destroy = destroy;
      exports.init = init;
      exports.setEnv = setEnv;
      exports.store = void 0;
      require_includes3();
      var _redux = require_lib2();
      var _IX2Reducer = _interopRequireDefault(require_IX2Reducer());
      var _IX2VanillaEngine = require_IX2VanillaEngine();
      var actions = _interopRequireWildcard(require_IX2EngineActions());
      exports.actions = actions;
      var store = (0, _redux.createStore)(_IX2Reducer.default);
      exports.store = store;
      function setEnv(env) {
        if (env()) {
          (0, _IX2VanillaEngine.observeRequests)(store);
        }
      }
      function init(rawData) {
        destroy();
        (0, _IX2VanillaEngine.startEngine)({
          store,
          rawData,
          allowEvents: true
        });
      }
      function destroy() {
        (0, _IX2VanillaEngine.stopEngine)(store);
      }
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-ix2.js
  var require_webflow_ix2 = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-ix2.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      var ix2 = require_engine();
      ix2.setEnv(Webflow2.env);
      Webflow2.define("ix2", module.exports = function() {
        return ix2;
      });
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-links.js
  var require_webflow_links = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-links.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      Webflow2.define("links", module.exports = function($2, _) {
        var api = {};
        var $win = $2(window);
        var designer;
        var inApp = Webflow2.env();
        var location = window.location;
        var tempLink = document.createElement("a");
        var linkCurrent = "w--current";
        var indexPage = /index\.(html|php)$/;
        var dirList = /\/$/;
        var anchors;
        var slug;
        api.ready = api.design = api.preview = init;
        function init() {
          designer = inApp && Webflow2.env("design");
          slug = Webflow2.env("slug") || location.pathname || "";
          Webflow2.scroll.off(scroll);
          anchors = [];
          var links = document.links;
          for (var i = 0; i < links.length; ++i) {
            select(links[i]);
          }
          if (anchors.length) {
            Webflow2.scroll.on(scroll);
            scroll();
          }
        }
        function select(link) {
          var href = designer && link.getAttribute("href-disabled") || link.getAttribute("href");
          tempLink.href = href;
          if (href.indexOf(":") >= 0) {
            return;
          }
          var $link = $2(link);
          if (tempLink.hash.length > 1 && tempLink.host + tempLink.pathname === location.host + location.pathname) {
            if (!/^#[a-zA-Z0-9\-\_]+$/.test(tempLink.hash)) {
              return;
            }
            var $section = $2(tempLink.hash);
            $section.length && anchors.push({
              link: $link,
              sec: $section,
              active: false
            });
            return;
          }
          if (href === "#" || href === "") {
            return;
          }
          var match2 = tempLink.href === location.href || href === slug || indexPage.test(href) && dirList.test(slug);
          setClass($link, linkCurrent, match2);
        }
        function scroll() {
          var viewTop = $win.scrollTop();
          var viewHeight = $win.height();
          _.each(anchors, function(anchor) {
            var $link = anchor.link;
            var $section = anchor.sec;
            var top = $section.offset().top;
            var height = $section.outerHeight();
            var offset = viewHeight * 0.5;
            var active = $section.is(":visible") && top + height - offset >= viewTop && top + offset <= viewTop + viewHeight;
            if (anchor.active === active) {
              return;
            }
            anchor.active = active;
            setClass($link, linkCurrent, active);
          });
        }
        function setClass($elem, className, add2) {
          var exists = $elem.hasClass(className);
          if (add2 && exists) {
            return;
          }
          if (!add2 && !exists) {
            return;
          }
          add2 ? $elem.addClass(className) : $elem.removeClass(className);
        }
        return api;
      });
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-scroll.js
  var require_webflow_scroll = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-scroll.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      Webflow2.define("scroll", module.exports = function($2) {
        var NS_EVENTS = {
          WF_CLICK_EMPTY: "click.wf-empty-link",
          WF_CLICK_SCROLL: "click.wf-scroll"
        };
        var loc = window.location;
        var history = inIframe() ? null : window.history;
        var $win = $2(window);
        var $doc = $2(document);
        var $body = $2(document.body);
        var animate = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) {
          window.setTimeout(fn, 15);
        };
        var rootTag = Webflow2.env("editor") ? ".w-editor-body" : "body";
        var headerSelector = "header, " + rootTag + " > .header, " + rootTag + " > .w-nav:not([data-no-scroll])";
        var emptyHrefSelector = 'a[href="#"]';
        var localHrefSelector = 'a[href*="#"]:not(.w-tab-link):not(' + emptyHrefSelector + ")";
        var scrollTargetOutlineCSS = '.wf-force-outline-none[tabindex="-1"]:focus{outline:none;}';
        var focusStylesEl = document.createElement("style");
        focusStylesEl.appendChild(document.createTextNode(scrollTargetOutlineCSS));
        function inIframe() {
          try {
            return Boolean(window.frameElement);
          } catch (e) {
            return true;
          }
        }
        var validHash = /^#[a-zA-Z0-9][\w:.-]*$/;
        function linksToCurrentPage(link) {
          return validHash.test(link.hash) && link.host + link.pathname === loc.host + loc.pathname;
        }
        const reducedMotionMediaQuery = typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)");
        function reducedMotionEnabled() {
          return document.body.getAttribute("data-wf-scroll-motion") === "none" || reducedMotionMediaQuery.matches;
        }
        function setFocusable($el, action) {
          var initialTabindex;
          switch (action) {
            case "add":
              initialTabindex = $el.attr("tabindex");
              if (initialTabindex) {
                $el.attr("data-wf-tabindex-swap", initialTabindex);
              } else {
                $el.attr("tabindex", "-1");
              }
              break;
            case "remove":
              initialTabindex = $el.attr("data-wf-tabindex-swap");
              if (initialTabindex) {
                $el.attr("tabindex", initialTabindex);
                $el.removeAttr("data-wf-tabindex-swap");
              } else {
                $el.removeAttr("tabindex");
              }
              break;
          }
          $el.toggleClass("wf-force-outline-none", action === "add");
        }
        function validateScroll(evt) {
          var target = evt.currentTarget;
          if (
            // Bail if in Designer
            Webflow2.env("design") || // Ignore links being used by jQuery mobile
            window.$.mobile && /(?:^|\s)ui-link(?:$|\s)/.test(target.className)
          ) {
            return;
          }
          var hash = linksToCurrentPage(target) ? target.hash : "";
          if (hash === "")
            return;
          var $el = $2(hash);
          if (!$el.length) {
            return;
          }
          if (evt) {
            evt.preventDefault();
            evt.stopPropagation();
          }
          updateHistory(hash, evt);
          window.setTimeout(function() {
            scroll($el, function setFocus() {
              setFocusable($el, "add");
              $el.get(0).focus({
                preventScroll: true
              });
              setFocusable($el, "remove");
            });
          }, evt ? 0 : 300);
        }
        function updateHistory(hash) {
          if (loc.hash !== hash && history && history.pushState && // Navigation breaks Chrome when the protocol is `file:`.
          !(Webflow2.env.chrome && loc.protocol === "file:")) {
            var oldHash = history.state && history.state.hash;
            if (oldHash !== hash) {
              history.pushState({
                hash
              }, "", hash);
            }
          }
        }
        function scroll($targetEl, cb) {
          var start = $win.scrollTop();
          var end = calculateScrollEndPosition($targetEl);
          if (start === end)
            return;
          var duration = calculateScrollDuration($targetEl, start, end);
          var clock = Date.now();
          var step = function() {
            var elapsed = Date.now() - clock;
            window.scroll(0, getY(start, end, elapsed, duration));
            if (elapsed <= duration) {
              animate(step);
            } else if (typeof cb === "function") {
              cb();
            }
          };
          animate(step);
        }
        function calculateScrollEndPosition($targetEl) {
          var $header = $2(headerSelector);
          var offsetY = $header.css("position") === "fixed" ? $header.outerHeight() : 0;
          var end = $targetEl.offset().top - offsetY;
          if ($targetEl.data("scroll") === "mid") {
            var available = $win.height() - offsetY;
            var elHeight = $targetEl.outerHeight();
            if (elHeight < available) {
              end -= Math.round((available - elHeight) / 2);
            }
          }
          return end;
        }
        function calculateScrollDuration($targetEl, start, end) {
          if (reducedMotionEnabled())
            return 0;
          var mult = 1;
          $body.add($targetEl).each(function(_, el) {
            var time = parseFloat(el.getAttribute("data-scroll-time"));
            if (!isNaN(time) && time >= 0) {
              mult = time;
            }
          });
          return (472.143 * Math.log(Math.abs(start - end) + 125) - 2e3) * mult;
        }
        function getY(start, end, elapsed, duration) {
          if (elapsed > duration) {
            return end;
          }
          return start + (end - start) * ease(elapsed / duration);
        }
        function ease(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        }
        function ready() {
          var {
            WF_CLICK_EMPTY,
            WF_CLICK_SCROLL
          } = NS_EVENTS;
          $doc.on(WF_CLICK_SCROLL, localHrefSelector, validateScroll);
          $doc.on(WF_CLICK_EMPTY, emptyHrefSelector, function(e) {
            e.preventDefault();
          });
          document.head.insertBefore(focusStylesEl, document.head.firstChild);
        }
        return {
          ready
        };
      });
    }
  });

  // packages/shared/render/plugins/BaseSiteModules/webflow-touch.js
  var require_webflow_touch = __commonJS({
    "packages/shared/render/plugins/BaseSiteModules/webflow-touch.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      Webflow2.define("touch", module.exports = function($2) {
        var api = {};
        var getSelection = window.getSelection;
        $2.event.special.tap = {
          bindType: "click",
          delegateType: "click"
        };
        api.init = function(el) {
          el = typeof el === "string" ? $2(el).get(0) : el;
          return el ? new Touch(el) : null;
        };
        function Touch(el) {
          var active = false;
          var useTouch = false;
          var thresholdX = Math.min(Math.round(window.innerWidth * 0.04), 40);
          var startX;
          var lastX;
          el.addEventListener("touchstart", start, false);
          el.addEventListener("touchmove", move, false);
          el.addEventListener("touchend", end, false);
          el.addEventListener("touchcancel", cancel, false);
          el.addEventListener("mousedown", start, false);
          el.addEventListener("mousemove", move, false);
          el.addEventListener("mouseup", end, false);
          el.addEventListener("mouseout", cancel, false);
          function start(evt) {
            var touches = evt.touches;
            if (touches && touches.length > 1) {
              return;
            }
            active = true;
            if (touches) {
              useTouch = true;
              startX = touches[0].clientX;
            } else {
              startX = evt.clientX;
            }
            lastX = startX;
          }
          function move(evt) {
            if (!active) {
              return;
            }
            if (useTouch && evt.type === "mousemove") {
              evt.preventDefault();
              evt.stopPropagation();
              return;
            }
            var touches = evt.touches;
            var x = touches ? touches[0].clientX : evt.clientX;
            var velocityX = x - lastX;
            lastX = x;
            if (Math.abs(velocityX) > thresholdX && getSelection && String(getSelection()) === "") {
              triggerEvent("swipe", evt, {
                direction: velocityX > 0 ? "right" : "left"
              });
              cancel();
            }
          }
          function end(evt) {
            if (!active) {
              return;
            }
            active = false;
            if (useTouch && evt.type === "mouseup") {
              evt.preventDefault();
              evt.stopPropagation();
              useTouch = false;
              return;
            }
          }
          function cancel() {
            active = false;
          }
          function destroy() {
            el.removeEventListener("touchstart", start, false);
            el.removeEventListener("touchmove", move, false);
            el.removeEventListener("touchend", end, false);
            el.removeEventListener("touchcancel", cancel, false);
            el.removeEventListener("mousedown", start, false);
            el.removeEventListener("mousemove", move, false);
            el.removeEventListener("mouseup", end, false);
            el.removeEventListener("mouseout", cancel, false);
            el = null;
          }
          this.destroy = destroy;
        }
        function triggerEvent(type, evt, data) {
          var newEvent = $2.Event(type, {
            originalEvent: evt
          });
          $2(evt.target).trigger(newEvent, data);
        }
        api.instance = api.init(document);
        return api;
      });
    }
  });

  // node_modules/custom-event-polyfill/polyfill.js
  var require_polyfill = __commonJS({
    "node_modules/custom-event-polyfill/polyfill.js"() {
      (function() {
        if (typeof window === "undefined") {
          return;
        }
        try {
          var ce = new window.CustomEvent("test", { cancelable: true });
          ce.preventDefault();
          if (ce.defaultPrevented !== true) {
            throw new Error("Could not prevent default");
          }
        } catch (e) {
          var CustomEvent2 = function(event, params) {
            var evt, origPrevent;
            params = params || {};
            params.bubbles = !!params.bubbles;
            params.cancelable = !!params.cancelable;
            evt = document.createEvent("CustomEvent");
            evt.initCustomEvent(
              event,
              params.bubbles,
              params.cancelable,
              params.detail
            );
            origPrevent = evt.preventDefault;
            evt.preventDefault = function() {
              origPrevent.call(this);
              try {
                Object.defineProperty(this, "defaultPrevented", {
                  get: function() {
                    return true;
                  }
                });
              } catch (e2) {
                this.defaultPrevented = true;
              }
            };
            return evt;
          };
          CustomEvent2.prototype = window.Event.prototype;
          window.CustomEvent = CustomEvent2;
        }
      })();
    }
  });

  // node_modules/core-js/internals/is-array.js
  var require_is_array = __commonJS({
    "node_modules/core-js/internals/is-array.js"(exports, module) {
      var classof = require_classof_raw();
      module.exports = Array.isArray || function isArray(argument) {
        return classof(argument) == "Array";
      };
    }
  });

  // node_modules/core-js/internals/create-property.js
  var require_create_property = __commonJS({
    "node_modules/core-js/internals/create-property.js"(exports, module) {
      "use strict";
      var toPropertyKey = require_to_property_key();
      var definePropertyModule = require_object_define_property();
      var createPropertyDescriptor = require_create_property_descriptor();
      module.exports = function(object, key, value) {
        var propertyKey = toPropertyKey(key);
        if (propertyKey in object)
          definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
        else
          object[propertyKey] = value;
      };
    }
  });

  // node_modules/core-js/internals/to-string-tag-support.js
  var require_to_string_tag_support = __commonJS({
    "node_modules/core-js/internals/to-string-tag-support.js"(exports, module) {
      var wellKnownSymbol = require_well_known_symbol();
      var TO_STRING_TAG = wellKnownSymbol("toStringTag");
      var test2 = {};
      test2[TO_STRING_TAG] = "z";
      module.exports = String(test2) === "[object z]";
    }
  });

  // node_modules/core-js/internals/classof.js
  var require_classof = __commonJS({
    "node_modules/core-js/internals/classof.js"(exports, module) {
      var global2 = require_global();
      var TO_STRING_TAG_SUPPORT = require_to_string_tag_support();
      var isCallable = require_is_callable();
      var classofRaw = require_classof_raw();
      var wellKnownSymbol = require_well_known_symbol();
      var TO_STRING_TAG = wellKnownSymbol("toStringTag");
      var Object2 = global2.Object;
      var CORRECT_ARGUMENTS = classofRaw(function() {
        return arguments;
      }()) == "Arguments";
      var tryGet = function(it, key) {
        try {
          return it[key];
        } catch (error) {
        }
      };
      module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function(it) {
        var O, tag, result;
        return it === void 0 ? "Undefined" : it === null ? "Null" : typeof (tag = tryGet(O = Object2(it), TO_STRING_TAG)) == "string" ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) == "Object" && isCallable(O.callee) ? "Arguments" : result;
      };
    }
  });

  // node_modules/core-js/internals/is-constructor.js
  var require_is_constructor = __commonJS({
    "node_modules/core-js/internals/is-constructor.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var fails = require_fails();
      var isCallable = require_is_callable();
      var classof = require_classof();
      var getBuiltIn = require_get_built_in();
      var inspectSource = require_inspect_source();
      var noop2 = function() {
      };
      var empty3 = [];
      var construct = getBuiltIn("Reflect", "construct");
      var constructorRegExp = /^\s*(?:class|function)\b/;
      var exec = uncurryThis(constructorRegExp.exec);
      var INCORRECT_TO_STRING = !constructorRegExp.exec(noop2);
      var isConstructorModern = function(argument) {
        if (!isCallable(argument))
          return false;
        try {
          construct(noop2, empty3, argument);
          return true;
        } catch (error) {
          return false;
        }
      };
      var isConstructorLegacy = function(argument) {
        if (!isCallable(argument))
          return false;
        switch (classof(argument)) {
          case "AsyncFunction":
          case "GeneratorFunction":
          case "AsyncGeneratorFunction":
            return false;
        }
        return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
      };
      module.exports = !construct || fails(function() {
        var called;
        return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function() {
          called = true;
        }) || called;
      }) ? isConstructorLegacy : isConstructorModern;
    }
  });

  // node_modules/core-js/internals/array-species-constructor.js
  var require_array_species_constructor = __commonJS({
    "node_modules/core-js/internals/array-species-constructor.js"(exports, module) {
      var global2 = require_global();
      var isArray = require_is_array();
      var isConstructor = require_is_constructor();
      var isObject2 = require_is_object();
      var wellKnownSymbol = require_well_known_symbol();
      var SPECIES = wellKnownSymbol("species");
      var Array2 = global2.Array;
      module.exports = function(originalArray) {
        var C;
        if (isArray(originalArray)) {
          C = originalArray.constructor;
          if (isConstructor(C) && (C === Array2 || isArray(C.prototype)))
            C = void 0;
          else if (isObject2(C)) {
            C = C[SPECIES];
            if (C === null)
              C = void 0;
          }
        }
        return C === void 0 ? Array2 : C;
      };
    }
  });

  // node_modules/core-js/internals/array-species-create.js
  var require_array_species_create = __commonJS({
    "node_modules/core-js/internals/array-species-create.js"(exports, module) {
      var arraySpeciesConstructor = require_array_species_constructor();
      module.exports = function(originalArray, length2) {
        return new (arraySpeciesConstructor(originalArray))(length2 === 0 ? 0 : length2);
      };
    }
  });

  // node_modules/core-js/internals/array-method-has-species-support.js
  var require_array_method_has_species_support = __commonJS({
    "node_modules/core-js/internals/array-method-has-species-support.js"(exports, module) {
      var fails = require_fails();
      var wellKnownSymbol = require_well_known_symbol();
      var V8_VERSION = require_engine_v8_version();
      var SPECIES = wellKnownSymbol("species");
      module.exports = function(METHOD_NAME) {
        return V8_VERSION >= 51 || !fails(function() {
          var array = [];
          var constructor = array.constructor = {};
          constructor[SPECIES] = function() {
            return { foo: 1 };
          };
          return array[METHOD_NAME](Boolean).foo !== 1;
        });
      };
    }
  });

  // node_modules/core-js/modules/es.array.concat.js
  var require_es_array_concat = __commonJS({
    "node_modules/core-js/modules/es.array.concat.js"() {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var fails = require_fails();
      var isArray = require_is_array();
      var isObject2 = require_is_object();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var createProperty = require_create_property();
      var arraySpeciesCreate = require_array_species_create();
      var arrayMethodHasSpeciesSupport = require_array_method_has_species_support();
      var wellKnownSymbol = require_well_known_symbol();
      var V8_VERSION = require_engine_v8_version();
      var IS_CONCAT_SPREADABLE = wellKnownSymbol("isConcatSpreadable");
      var MAX_SAFE_INTEGER = 9007199254740991;
      var MAXIMUM_ALLOWED_INDEX_EXCEEDED = "Maximum allowed index exceeded";
      var TypeError2 = global2.TypeError;
      var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function() {
        var array = [];
        array[IS_CONCAT_SPREADABLE] = false;
        return array.concat()[0] !== array;
      });
      var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("concat");
      var isConcatSpreadable = function(O) {
        if (!isObject2(O))
          return false;
        var spreadable = O[IS_CONCAT_SPREADABLE];
        return spreadable !== void 0 ? !!spreadable : isArray(O);
      };
      var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;
      $2({ target: "Array", proto: true, forced: FORCED }, {
        // eslint-disable-next-line no-unused-vars -- required for `.length`
        concat: function concat4(arg) {
          var O = toObject(this);
          var A = arraySpeciesCreate(O, 0);
          var n = 0;
          var i, k, length2, len, E;
          for (i = -1, length2 = arguments.length; i < length2; i++) {
            E = i === -1 ? O : arguments[i];
            if (isConcatSpreadable(E)) {
              len = lengthOfArrayLike(E);
              if (n + len > MAX_SAFE_INTEGER)
                throw TypeError2(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
              for (k = 0; k < len; k++, n++)
                if (k in E)
                  createProperty(A, n, E[k]);
            } else {
              if (n >= MAX_SAFE_INTEGER)
                throw TypeError2(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
              createProperty(A, n++, E);
            }
          }
          A.length = n;
          return A;
        }
      });
    }
  });

  // node_modules/core-js/internals/object-to-string.js
  var require_object_to_string = __commonJS({
    "node_modules/core-js/internals/object-to-string.js"(exports, module) {
      "use strict";
      var TO_STRING_TAG_SUPPORT = require_to_string_tag_support();
      var classof = require_classof();
      module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString4() {
        return "[object " + classof(this) + "]";
      };
    }
  });

  // node_modules/core-js/modules/es.object.to-string.js
  var require_es_object_to_string = __commonJS({
    "node_modules/core-js/modules/es.object.to-string.js"() {
      var TO_STRING_TAG_SUPPORT = require_to_string_tag_support();
      var redefine = require_redefine();
      var toString4 = require_object_to_string();
      if (!TO_STRING_TAG_SUPPORT) {
        redefine(Object.prototype, "toString", toString4, { unsafe: true });
      }
    }
  });

  // node_modules/core-js/internals/function-apply.js
  var require_function_apply = __commonJS({
    "node_modules/core-js/internals/function-apply.js"(exports, module) {
      var FunctionPrototype = Function.prototype;
      var apply = FunctionPrototype.apply;
      var bind2 = FunctionPrototype.bind;
      var call = FunctionPrototype.call;
      module.exports = typeof Reflect == "object" && Reflect.apply || (bind2 ? call.bind(apply) : function() {
        return call.apply(apply, arguments);
      });
    }
  });

  // node_modules/core-js/internals/to-string.js
  var require_to_string = __commonJS({
    "node_modules/core-js/internals/to-string.js"(exports, module) {
      var global2 = require_global();
      var classof = require_classof();
      var String2 = global2.String;
      module.exports = function(argument) {
        if (classof(argument) === "Symbol")
          throw TypeError("Cannot convert a Symbol value to a string");
        return String2(argument);
      };
    }
  });

  // node_modules/core-js/internals/array-slice.js
  var require_array_slice = __commonJS({
    "node_modules/core-js/internals/array-slice.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      module.exports = uncurryThis([].slice);
    }
  });

  // node_modules/core-js/internals/object-get-own-property-names-external.js
  var require_object_get_own_property_names_external = __commonJS({
    "node_modules/core-js/internals/object-get-own-property-names-external.js"(exports, module) {
      var classof = require_classof_raw();
      var toIndexedObject = require_to_indexed_object();
      var $getOwnPropertyNames = require_object_get_own_property_names().f;
      var arraySlice = require_array_slice();
      var windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
      var getWindowNames = function(it) {
        try {
          return $getOwnPropertyNames(it);
        } catch (error) {
          return arraySlice(windowNames);
        }
      };
      module.exports.f = function getOwnPropertyNames(it) {
        return windowNames && classof(it) == "Window" ? getWindowNames(it) : $getOwnPropertyNames(toIndexedObject(it));
      };
    }
  });

  // node_modules/core-js/internals/well-known-symbol-wrapped.js
  var require_well_known_symbol_wrapped = __commonJS({
    "node_modules/core-js/internals/well-known-symbol-wrapped.js"(exports) {
      var wellKnownSymbol = require_well_known_symbol();
      exports.f = wellKnownSymbol;
    }
  });

  // node_modules/core-js/internals/path.js
  var require_path = __commonJS({
    "node_modules/core-js/internals/path.js"(exports, module) {
      var global2 = require_global();
      module.exports = global2;
    }
  });

  // node_modules/core-js/internals/define-well-known-symbol.js
  var require_define_well_known_symbol = __commonJS({
    "node_modules/core-js/internals/define-well-known-symbol.js"(exports, module) {
      var path = require_path();
      var hasOwn4 = require_has_own_property();
      var wrappedWellKnownSymbolModule = require_well_known_symbol_wrapped();
      var defineProperty = require_object_define_property().f;
      module.exports = function(NAME) {
        var Symbol2 = path.Symbol || (path.Symbol = {});
        if (!hasOwn4(Symbol2, NAME))
          defineProperty(Symbol2, NAME, {
            value: wrappedWellKnownSymbolModule.f(NAME)
          });
      };
    }
  });

  // node_modules/core-js/internals/set-to-string-tag.js
  var require_set_to_string_tag = __commonJS({
    "node_modules/core-js/internals/set-to-string-tag.js"(exports, module) {
      var defineProperty = require_object_define_property().f;
      var hasOwn4 = require_has_own_property();
      var wellKnownSymbol = require_well_known_symbol();
      var TO_STRING_TAG = wellKnownSymbol("toStringTag");
      module.exports = function(it, TAG, STATIC) {
        if (it && !hasOwn4(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
          defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
        }
      };
    }
  });

  // node_modules/core-js/internals/function-bind-context.js
  var require_function_bind_context = __commonJS({
    "node_modules/core-js/internals/function-bind-context.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var aCallable = require_a_callable();
      var bind2 = uncurryThis(uncurryThis.bind);
      module.exports = function(fn, that) {
        aCallable(fn);
        return that === void 0 ? fn : bind2 ? bind2(fn, that) : function() {
          return fn.apply(that, arguments);
        };
      };
    }
  });

  // node_modules/core-js/internals/array-iteration.js
  var require_array_iteration = __commonJS({
    "node_modules/core-js/internals/array-iteration.js"(exports, module) {
      var bind2 = require_function_bind_context();
      var uncurryThis = require_function_uncurry_this();
      var IndexedObject = require_indexed_object();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var arraySpeciesCreate = require_array_species_create();
      var push = uncurryThis([].push);
      var createMethod = function(TYPE) {
        var IS_MAP = TYPE == 1;
        var IS_FILTER = TYPE == 2;
        var IS_SOME = TYPE == 3;
        var IS_EVERY = TYPE == 4;
        var IS_FIND_INDEX = TYPE == 6;
        var IS_FILTER_REJECT = TYPE == 7;
        var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
        return function($this, callbackfn, that, specificCreate) {
          var O = toObject($this);
          var self2 = IndexedObject(O);
          var boundFunction = bind2(callbackfn, that);
          var length2 = lengthOfArrayLike(self2);
          var index = 0;
          var create5 = specificCreate || arraySpeciesCreate;
          var target = IS_MAP ? create5($this, length2) : IS_FILTER || IS_FILTER_REJECT ? create5($this, 0) : void 0;
          var value, result;
          for (; length2 > index; index++)
            if (NO_HOLES || index in self2) {
              value = self2[index];
              result = boundFunction(value, index, O);
              if (TYPE) {
                if (IS_MAP)
                  target[index] = result;
                else if (result)
                  switch (TYPE) {
                    case 3:
                      return true;
                    case 5:
                      return value;
                    case 6:
                      return index;
                    case 2:
                      push(target, value);
                  }
                else
                  switch (TYPE) {
                    case 4:
                      return false;
                    case 7:
                      push(target, value);
                  }
              }
            }
          return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
        };
      };
      module.exports = {
        // `Array.prototype.forEach` method
        // https://tc39.es/ecma262/#sec-array.prototype.foreach
        forEach: createMethod(0),
        // `Array.prototype.map` method
        // https://tc39.es/ecma262/#sec-array.prototype.map
        map: createMethod(1),
        // `Array.prototype.filter` method
        // https://tc39.es/ecma262/#sec-array.prototype.filter
        filter: createMethod(2),
        // `Array.prototype.some` method
        // https://tc39.es/ecma262/#sec-array.prototype.some
        some: createMethod(3),
        // `Array.prototype.every` method
        // https://tc39.es/ecma262/#sec-array.prototype.every
        every: createMethod(4),
        // `Array.prototype.find` method
        // https://tc39.es/ecma262/#sec-array.prototype.find
        find: createMethod(5),
        // `Array.prototype.findIndex` method
        // https://tc39.es/ecma262/#sec-array.prototype.findIndex
        findIndex: createMethod(6),
        // `Array.prototype.filterReject` method
        // https://github.com/tc39/proposal-array-filtering
        filterReject: createMethod(7)
      };
    }
  });

  // node_modules/core-js/modules/es.symbol.js
  var require_es_symbol = __commonJS({
    "node_modules/core-js/modules/es.symbol.js"() {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var getBuiltIn = require_get_built_in();
      var apply = require_function_apply();
      var call = require_function_call();
      var uncurryThis = require_function_uncurry_this();
      var IS_PURE = require_is_pure();
      var DESCRIPTORS = require_descriptors();
      var NATIVE_SYMBOL = require_native_symbol();
      var fails = require_fails();
      var hasOwn4 = require_has_own_property();
      var isArray = require_is_array();
      var isCallable = require_is_callable();
      var isObject2 = require_is_object();
      var isPrototypeOf = require_object_is_prototype_of();
      var isSymbol = require_is_symbol();
      var anObject = require_an_object();
      var toObject = require_to_object();
      var toIndexedObject = require_to_indexed_object();
      var toPropertyKey = require_to_property_key();
      var $toString = require_to_string();
      var createPropertyDescriptor = require_create_property_descriptor();
      var nativeObjectCreate = require_object_create();
      var objectKeys2 = require_object_keys();
      var getOwnPropertyNamesModule = require_object_get_own_property_names();
      var getOwnPropertyNamesExternal = require_object_get_own_property_names_external();
      var getOwnPropertySymbolsModule = require_object_get_own_property_symbols();
      var getOwnPropertyDescriptorModule = require_object_get_own_property_descriptor();
      var definePropertyModule = require_object_define_property();
      var propertyIsEnumerableModule = require_object_property_is_enumerable();
      var arraySlice = require_array_slice();
      var redefine = require_redefine();
      var shared = require_shared();
      var sharedKey = require_shared_key();
      var hiddenKeys = require_hidden_keys();
      var uid = require_uid();
      var wellKnownSymbol = require_well_known_symbol();
      var wrappedWellKnownSymbolModule = require_well_known_symbol_wrapped();
      var defineWellKnownSymbol = require_define_well_known_symbol();
      var setToStringTag = require_set_to_string_tag();
      var InternalStateModule = require_internal_state();
      var $forEach = require_array_iteration().forEach;
      var HIDDEN = sharedKey("hidden");
      var SYMBOL = "Symbol";
      var PROTOTYPE = "prototype";
      var TO_PRIMITIVE = wellKnownSymbol("toPrimitive");
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(SYMBOL);
      var ObjectPrototype = Object[PROTOTYPE];
      var $Symbol = global2.Symbol;
      var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
      var TypeError2 = global2.TypeError;
      var QObject = global2.QObject;
      var $stringify = getBuiltIn("JSON", "stringify");
      var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
      var nativeDefineProperty = definePropertyModule.f;
      var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
      var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
      var push = uncurryThis([].push);
      var AllSymbols = shared("symbols");
      var ObjectPrototypeSymbols = shared("op-symbols");
      var StringToSymbolRegistry = shared("string-to-symbol-registry");
      var SymbolToStringRegistry = shared("symbol-to-string-registry");
      var WellKnownSymbolsStore = shared("wks");
      var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
      var setSymbolDescriptor = DESCRIPTORS && fails(function() {
        return nativeObjectCreate(nativeDefineProperty({}, "a", {
          get: function() {
            return nativeDefineProperty(this, "a", { value: 7 }).a;
          }
        })).a != 7;
      }) ? function(O, P, Attributes) {
        var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
        if (ObjectPrototypeDescriptor)
          delete ObjectPrototype[P];
        nativeDefineProperty(O, P, Attributes);
        if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
          nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
        }
      } : nativeDefineProperty;
      var wrap2 = function(tag, description) {
        var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
        setInternalState(symbol, {
          type: SYMBOL,
          tag,
          description
        });
        if (!DESCRIPTORS)
          symbol.description = description;
        return symbol;
      };
      var $defineProperty = function defineProperty(O, P, Attributes) {
        if (O === ObjectPrototype)
          $defineProperty(ObjectPrototypeSymbols, P, Attributes);
        anObject(O);
        var key = toPropertyKey(P);
        anObject(Attributes);
        if (hasOwn4(AllSymbols, key)) {
          if (!Attributes.enumerable) {
            if (!hasOwn4(O, HIDDEN))
              nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
            O[HIDDEN][key] = true;
          } else {
            if (hasOwn4(O, HIDDEN) && O[HIDDEN][key])
              O[HIDDEN][key] = false;
            Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
          }
          return setSymbolDescriptor(O, key, Attributes);
        }
        return nativeDefineProperty(O, key, Attributes);
      };
      var $defineProperties = function defineProperties(O, Properties) {
        anObject(O);
        var properties = toIndexedObject(Properties);
        var keys = objectKeys2(properties).concat($getOwnPropertySymbols(properties));
        $forEach(keys, function(key) {
          if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key))
            $defineProperty(O, key, properties[key]);
        });
        return O;
      };
      var $create = function create5(O, Properties) {
        return Properties === void 0 ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
      };
      var $propertyIsEnumerable = function propertyIsEnumerable(V) {
        var P = toPropertyKey(V);
        var enumerable = call(nativePropertyIsEnumerable, this, P);
        if (this === ObjectPrototype && hasOwn4(AllSymbols, P) && !hasOwn4(ObjectPrototypeSymbols, P))
          return false;
        return enumerable || !hasOwn4(this, P) || !hasOwn4(AllSymbols, P) || hasOwn4(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
      };
      var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
        var it = toIndexedObject(O);
        var key = toPropertyKey(P);
        if (it === ObjectPrototype && hasOwn4(AllSymbols, key) && !hasOwn4(ObjectPrototypeSymbols, key))
          return;
        var descriptor = nativeGetOwnPropertyDescriptor(it, key);
        if (descriptor && hasOwn4(AllSymbols, key) && !(hasOwn4(it, HIDDEN) && it[HIDDEN][key])) {
          descriptor.enumerable = true;
        }
        return descriptor;
      };
      var $getOwnPropertyNames = function getOwnPropertyNames(O) {
        var names = nativeGetOwnPropertyNames(toIndexedObject(O));
        var result = [];
        $forEach(names, function(key) {
          if (!hasOwn4(AllSymbols, key) && !hasOwn4(hiddenKeys, key))
            push(result, key);
        });
        return result;
      };
      var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
        var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
        var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
        var result = [];
        $forEach(names, function(key) {
          if (hasOwn4(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn4(ObjectPrototype, key))) {
            push(result, AllSymbols[key]);
          }
        });
        return result;
      };
      if (!NATIVE_SYMBOL) {
        $Symbol = function Symbol2() {
          if (isPrototypeOf(SymbolPrototype, this))
            throw TypeError2("Symbol is not a constructor");
          var description = !arguments.length || arguments[0] === void 0 ? void 0 : $toString(arguments[0]);
          var tag = uid(description);
          var setter = function(value) {
            if (this === ObjectPrototype)
              call(setter, ObjectPrototypeSymbols, value);
            if (hasOwn4(this, HIDDEN) && hasOwn4(this[HIDDEN], tag))
              this[HIDDEN][tag] = false;
            setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
          };
          if (DESCRIPTORS && USE_SETTER)
            setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
          return wrap2(tag, description);
        };
        SymbolPrototype = $Symbol[PROTOTYPE];
        redefine(SymbolPrototype, "toString", function toString4() {
          return getInternalState(this).tag;
        });
        redefine($Symbol, "withoutSetter", function(description) {
          return wrap2(uid(description), description);
        });
        propertyIsEnumerableModule.f = $propertyIsEnumerable;
        definePropertyModule.f = $defineProperty;
        getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
        getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
        getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;
        wrappedWellKnownSymbolModule.f = function(name) {
          return wrap2(wellKnownSymbol(name), name);
        };
        if (DESCRIPTORS) {
          nativeDefineProperty(SymbolPrototype, "description", {
            configurable: true,
            get: function description() {
              return getInternalState(this).description;
            }
          });
          if (!IS_PURE) {
            redefine(ObjectPrototype, "propertyIsEnumerable", $propertyIsEnumerable, { unsafe: true });
          }
        }
      }
      $2({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
        Symbol: $Symbol
      });
      $forEach(objectKeys2(WellKnownSymbolsStore), function(name) {
        defineWellKnownSymbol(name);
      });
      $2({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
        // `Symbol.for` method
        // https://tc39.es/ecma262/#sec-symbol.for
        "for": function(key) {
          var string = $toString(key);
          if (hasOwn4(StringToSymbolRegistry, string))
            return StringToSymbolRegistry[string];
          var symbol = $Symbol(string);
          StringToSymbolRegistry[string] = symbol;
          SymbolToStringRegistry[symbol] = string;
          return symbol;
        },
        // `Symbol.keyFor` method
        // https://tc39.es/ecma262/#sec-symbol.keyfor
        keyFor: function keyFor(sym) {
          if (!isSymbol(sym))
            throw TypeError2(sym + " is not a symbol");
          if (hasOwn4(SymbolToStringRegistry, sym))
            return SymbolToStringRegistry[sym];
        },
        useSetter: function() {
          USE_SETTER = true;
        },
        useSimple: function() {
          USE_SETTER = false;
        }
      });
      $2({ target: "Object", stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
        // `Object.create` method
        // https://tc39.es/ecma262/#sec-object.create
        create: $create,
        // `Object.defineProperty` method
        // https://tc39.es/ecma262/#sec-object.defineproperty
        defineProperty: $defineProperty,
        // `Object.defineProperties` method
        // https://tc39.es/ecma262/#sec-object.defineproperties
        defineProperties: $defineProperties,
        // `Object.getOwnPropertyDescriptor` method
        // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
        getOwnPropertyDescriptor: $getOwnPropertyDescriptor
      });
      $2({ target: "Object", stat: true, forced: !NATIVE_SYMBOL }, {
        // `Object.getOwnPropertyNames` method
        // https://tc39.es/ecma262/#sec-object.getownpropertynames
        getOwnPropertyNames: $getOwnPropertyNames,
        // `Object.getOwnPropertySymbols` method
        // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
        getOwnPropertySymbols: $getOwnPropertySymbols
      });
      $2({ target: "Object", stat: true, forced: fails(function() {
        getOwnPropertySymbolsModule.f(1);
      }) }, {
        getOwnPropertySymbols: function getOwnPropertySymbols(it) {
          return getOwnPropertySymbolsModule.f(toObject(it));
        }
      });
      if ($stringify) {
        FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function() {
          var symbol = $Symbol();
          return $stringify([symbol]) != "[null]" || $stringify({ a: symbol }) != "{}" || $stringify(Object(symbol)) != "{}";
        });
        $2({ target: "JSON", stat: true, forced: FORCED_JSON_STRINGIFY }, {
          // eslint-disable-next-line no-unused-vars -- required for `.length`
          stringify: function stringify4(it, replacer, space) {
            var args = arraySlice(arguments);
            var $replacer = replacer;
            if (!isObject2(replacer) && it === void 0 || isSymbol(it))
              return;
            if (!isArray(replacer))
              replacer = function(key, value) {
                if (isCallable($replacer))
                  value = call($replacer, this, key, value);
                if (!isSymbol(value))
                  return value;
              };
            args[1] = replacer;
            return apply($stringify, null, args);
          }
        });
      }
      var FORCED_JSON_STRINGIFY;
      if (!SymbolPrototype[TO_PRIMITIVE]) {
        valueOf = SymbolPrototype.valueOf;
        redefine(SymbolPrototype, TO_PRIMITIVE, function(hint) {
          return call(valueOf, this);
        });
      }
      var valueOf;
      setToStringTag($Symbol, SYMBOL);
      hiddenKeys[HIDDEN] = true;
    }
  });

  // node_modules/core-js/modules/es.symbol.async-iterator.js
  var require_es_symbol_async_iterator = __commonJS({
    "node_modules/core-js/modules/es.symbol.async-iterator.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("asyncIterator");
    }
  });

  // node_modules/core-js/modules/es.symbol.description.js
  var require_es_symbol_description = __commonJS({
    "node_modules/core-js/modules/es.symbol.description.js"() {
      "use strict";
      var $2 = require_export();
      var DESCRIPTORS = require_descriptors();
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      var hasOwn4 = require_has_own_property();
      var isCallable = require_is_callable();
      var isPrototypeOf = require_object_is_prototype_of();
      var toString4 = require_to_string();
      var defineProperty = require_object_define_property().f;
      var copyConstructorProperties = require_copy_constructor_properties();
      var NativeSymbol = global2.Symbol;
      var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;
      if (DESCRIPTORS && isCallable(NativeSymbol) && (!("description" in SymbolPrototype) || // Safari 12 bug
      NativeSymbol().description !== void 0)) {
        EmptyStringDescriptionStore = {};
        SymbolWrapper = function Symbol2() {
          var description = arguments.length < 1 || arguments[0] === void 0 ? void 0 : toString4(arguments[0]);
          var result = isPrototypeOf(SymbolPrototype, this) ? new NativeSymbol(description) : description === void 0 ? NativeSymbol() : NativeSymbol(description);
          if (description === "")
            EmptyStringDescriptionStore[result] = true;
          return result;
        };
        copyConstructorProperties(SymbolWrapper, NativeSymbol);
        SymbolWrapper.prototype = SymbolPrototype;
        SymbolPrototype.constructor = SymbolWrapper;
        NATIVE_SYMBOL = String(NativeSymbol("test")) == "Symbol(test)";
        symbolToString = uncurryThis(SymbolPrototype.toString);
        symbolValueOf = uncurryThis(SymbolPrototype.valueOf);
        regexp = /^Symbol\((.*)\)[^)]+$/;
        replace2 = uncurryThis("".replace);
        stringSlice = uncurryThis("".slice);
        defineProperty(SymbolPrototype, "description", {
          configurable: true,
          get: function description() {
            var symbol = symbolValueOf(this);
            var string = symbolToString(symbol);
            if (hasOwn4(EmptyStringDescriptionStore, symbol))
              return "";
            var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace2(string, regexp, "$1");
            return desc === "" ? void 0 : desc;
          }
        });
        $2({ global: true, forced: true }, {
          Symbol: SymbolWrapper
        });
      }
      var EmptyStringDescriptionStore;
      var SymbolWrapper;
      var NATIVE_SYMBOL;
      var symbolToString;
      var symbolValueOf;
      var regexp;
      var replace2;
      var stringSlice;
    }
  });

  // node_modules/core-js/modules/es.symbol.has-instance.js
  var require_es_symbol_has_instance = __commonJS({
    "node_modules/core-js/modules/es.symbol.has-instance.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("hasInstance");
    }
  });

  // node_modules/core-js/modules/es.symbol.is-concat-spreadable.js
  var require_es_symbol_is_concat_spreadable = __commonJS({
    "node_modules/core-js/modules/es.symbol.is-concat-spreadable.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("isConcatSpreadable");
    }
  });

  // node_modules/core-js/modules/es.symbol.iterator.js
  var require_es_symbol_iterator = __commonJS({
    "node_modules/core-js/modules/es.symbol.iterator.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("iterator");
    }
  });

  // node_modules/core-js/modules/es.symbol.match.js
  var require_es_symbol_match = __commonJS({
    "node_modules/core-js/modules/es.symbol.match.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("match");
    }
  });

  // node_modules/core-js/modules/es.symbol.match-all.js
  var require_es_symbol_match_all = __commonJS({
    "node_modules/core-js/modules/es.symbol.match-all.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("matchAll");
    }
  });

  // node_modules/core-js/modules/es.symbol.replace.js
  var require_es_symbol_replace = __commonJS({
    "node_modules/core-js/modules/es.symbol.replace.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("replace");
    }
  });

  // node_modules/core-js/modules/es.symbol.search.js
  var require_es_symbol_search = __commonJS({
    "node_modules/core-js/modules/es.symbol.search.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("search");
    }
  });

  // node_modules/core-js/modules/es.symbol.species.js
  var require_es_symbol_species = __commonJS({
    "node_modules/core-js/modules/es.symbol.species.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("species");
    }
  });

  // node_modules/core-js/modules/es.symbol.split.js
  var require_es_symbol_split = __commonJS({
    "node_modules/core-js/modules/es.symbol.split.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("split");
    }
  });

  // node_modules/core-js/modules/es.symbol.to-primitive.js
  var require_es_symbol_to_primitive = __commonJS({
    "node_modules/core-js/modules/es.symbol.to-primitive.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("toPrimitive");
    }
  });

  // node_modules/core-js/modules/es.symbol.to-string-tag.js
  var require_es_symbol_to_string_tag = __commonJS({
    "node_modules/core-js/modules/es.symbol.to-string-tag.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("toStringTag");
    }
  });

  // node_modules/core-js/modules/es.symbol.unscopables.js
  var require_es_symbol_unscopables = __commonJS({
    "node_modules/core-js/modules/es.symbol.unscopables.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("unscopables");
    }
  });

  // node_modules/core-js/modules/es.json.to-string-tag.js
  var require_es_json_to_string_tag = __commonJS({
    "node_modules/core-js/modules/es.json.to-string-tag.js"() {
      var global2 = require_global();
      var setToStringTag = require_set_to_string_tag();
      setToStringTag(global2.JSON, "JSON", true);
    }
  });

  // node_modules/core-js/modules/es.math.to-string-tag.js
  var require_es_math_to_string_tag = __commonJS({
    "node_modules/core-js/modules/es.math.to-string-tag.js"() {
      var setToStringTag = require_set_to_string_tag();
      setToStringTag(Math, "Math", true);
    }
  });

  // node_modules/core-js/modules/es.reflect.to-string-tag.js
  var require_es_reflect_to_string_tag = __commonJS({
    "node_modules/core-js/modules/es.reflect.to-string-tag.js"() {
      var $2 = require_export();
      var global2 = require_global();
      var setToStringTag = require_set_to_string_tag();
      $2({ global: true }, { Reflect: {} });
      setToStringTag(global2.Reflect, "Reflect", true);
    }
  });

  // node_modules/core-js/es/symbol/index.js
  var require_symbol = __commonJS({
    "node_modules/core-js/es/symbol/index.js"(exports, module) {
      require_es_array_concat();
      require_es_object_to_string();
      require_es_symbol();
      require_es_symbol_async_iterator();
      require_es_symbol_description();
      require_es_symbol_has_instance();
      require_es_symbol_is_concat_spreadable();
      require_es_symbol_iterator();
      require_es_symbol_match();
      require_es_symbol_match_all();
      require_es_symbol_replace();
      require_es_symbol_search();
      require_es_symbol_species();
      require_es_symbol_split();
      require_es_symbol_to_primitive();
      require_es_symbol_to_string_tag();
      require_es_symbol_unscopables();
      require_es_json_to_string_tag();
      require_es_math_to_string_tag();
      require_es_reflect_to_string_tag();
      var path = require_path();
      module.exports = path.Symbol;
    }
  });

  // node_modules/core-js/internals/dom-iterables.js
  var require_dom_iterables = __commonJS({
    "node_modules/core-js/internals/dom-iterables.js"(exports, module) {
      module.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      };
    }
  });

  // node_modules/core-js/internals/dom-token-list-prototype.js
  var require_dom_token_list_prototype = __commonJS({
    "node_modules/core-js/internals/dom-token-list-prototype.js"(exports, module) {
      var documentCreateElement = require_document_create_element();
      var classList = documentCreateElement("span").classList;
      var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;
      module.exports = DOMTokenListPrototype === Object.prototype ? void 0 : DOMTokenListPrototype;
    }
  });

  // node_modules/core-js/internals/iterators.js
  var require_iterators = __commonJS({
    "node_modules/core-js/internals/iterators.js"(exports, module) {
      module.exports = {};
    }
  });

  // node_modules/core-js/internals/correct-prototype-getter.js
  var require_correct_prototype_getter = __commonJS({
    "node_modules/core-js/internals/correct-prototype-getter.js"(exports, module) {
      var fails = require_fails();
      module.exports = !fails(function() {
        function F() {
        }
        F.prototype.constructor = null;
        return Object.getPrototypeOf(new F()) !== F.prototype;
      });
    }
  });

  // node_modules/core-js/internals/object-get-prototype-of.js
  var require_object_get_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-get-prototype-of.js"(exports, module) {
      var global2 = require_global();
      var hasOwn4 = require_has_own_property();
      var isCallable = require_is_callable();
      var toObject = require_to_object();
      var sharedKey = require_shared_key();
      var CORRECT_PROTOTYPE_GETTER = require_correct_prototype_getter();
      var IE_PROTO = sharedKey("IE_PROTO");
      var Object2 = global2.Object;
      var ObjectPrototype = Object2.prototype;
      module.exports = CORRECT_PROTOTYPE_GETTER ? Object2.getPrototypeOf : function(O) {
        var object = toObject(O);
        if (hasOwn4(object, IE_PROTO))
          return object[IE_PROTO];
        var constructor = object.constructor;
        if (isCallable(constructor) && object instanceof constructor) {
          return constructor.prototype;
        }
        return object instanceof Object2 ? ObjectPrototype : null;
      };
    }
  });

  // node_modules/core-js/internals/iterators-core.js
  var require_iterators_core = __commonJS({
    "node_modules/core-js/internals/iterators-core.js"(exports, module) {
      "use strict";
      var fails = require_fails();
      var isCallable = require_is_callable();
      var create5 = require_object_create();
      var getPrototypeOf = require_object_get_prototype_of();
      var redefine = require_redefine();
      var wellKnownSymbol = require_well_known_symbol();
      var IS_PURE = require_is_pure();
      var ITERATOR = wellKnownSymbol("iterator");
      var BUGGY_SAFARI_ITERATORS = false;
      var IteratorPrototype;
      var PrototypeOfArrayIteratorPrototype;
      var arrayIterator;
      if ([].keys) {
        arrayIterator = [].keys();
        if (!("next" in arrayIterator))
          BUGGY_SAFARI_ITERATORS = true;
        else {
          PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
          if (PrototypeOfArrayIteratorPrototype !== Object.prototype)
            IteratorPrototype = PrototypeOfArrayIteratorPrototype;
        }
      }
      var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == void 0 || fails(function() {
        var test2 = {};
        return IteratorPrototype[ITERATOR].call(test2) !== test2;
      });
      if (NEW_ITERATOR_PROTOTYPE)
        IteratorPrototype = {};
      else if (IS_PURE)
        IteratorPrototype = create5(IteratorPrototype);
      if (!isCallable(IteratorPrototype[ITERATOR])) {
        redefine(IteratorPrototype, ITERATOR, function() {
          return this;
        });
      }
      module.exports = {
        IteratorPrototype,
        BUGGY_SAFARI_ITERATORS
      };
    }
  });

  // node_modules/core-js/internals/create-iterator-constructor.js
  var require_create_iterator_constructor = __commonJS({
    "node_modules/core-js/internals/create-iterator-constructor.js"(exports, module) {
      "use strict";
      var IteratorPrototype = require_iterators_core().IteratorPrototype;
      var create5 = require_object_create();
      var createPropertyDescriptor = require_create_property_descriptor();
      var setToStringTag = require_set_to_string_tag();
      var Iterators = require_iterators();
      var returnThis3 = function() {
        return this;
      };
      module.exports = function(IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + " Iterator";
        IteratorConstructor.prototype = create5(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
        Iterators[TO_STRING_TAG] = returnThis3;
        return IteratorConstructor;
      };
    }
  });

  // node_modules/core-js/internals/a-possible-prototype.js
  var require_a_possible_prototype = __commonJS({
    "node_modules/core-js/internals/a-possible-prototype.js"(exports, module) {
      var global2 = require_global();
      var isCallable = require_is_callable();
      var String2 = global2.String;
      var TypeError2 = global2.TypeError;
      module.exports = function(argument) {
        if (typeof argument == "object" || isCallable(argument))
          return argument;
        throw TypeError2("Can't set " + String2(argument) + " as a prototype");
      };
    }
  });

  // node_modules/core-js/internals/object-set-prototype-of.js
  var require_object_set_prototype_of = __commonJS({
    "node_modules/core-js/internals/object-set-prototype-of.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var anObject = require_an_object();
      var aPossiblePrototype = require_a_possible_prototype();
      module.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
        var CORRECT_SETTER = false;
        var test2 = {};
        var setter;
        try {
          setter = uncurryThis(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
          setter(test2, []);
          CORRECT_SETTER = test2 instanceof Array;
        } catch (error) {
        }
        return function setPrototypeOf2(O, proto) {
          anObject(O);
          aPossiblePrototype(proto);
          if (CORRECT_SETTER)
            setter(O, proto);
          else
            O.__proto__ = proto;
          return O;
        };
      }() : void 0);
    }
  });

  // node_modules/core-js/internals/define-iterator.js
  var require_define_iterator = __commonJS({
    "node_modules/core-js/internals/define-iterator.js"(exports, module) {
      "use strict";
      var $2 = require_export();
      var call = require_function_call();
      var IS_PURE = require_is_pure();
      var FunctionName = require_function_name();
      var isCallable = require_is_callable();
      var createIteratorConstructor = require_create_iterator_constructor();
      var getPrototypeOf = require_object_get_prototype_of();
      var setPrototypeOf2 = require_object_set_prototype_of();
      var setToStringTag = require_set_to_string_tag();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var redefine = require_redefine();
      var wellKnownSymbol = require_well_known_symbol();
      var Iterators = require_iterators();
      var IteratorsCore = require_iterators_core();
      var PROPER_FUNCTION_NAME = FunctionName.PROPER;
      var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
      var IteratorPrototype = IteratorsCore.IteratorPrototype;
      var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
      var ITERATOR = wellKnownSymbol("iterator");
      var KEYS = "keys";
      var VALUES = "values";
      var ENTRIES = "entries";
      var returnThis3 = function() {
        return this;
      };
      module.exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);
        var getIterationMethod = function(KIND) {
          if (KIND === DEFAULT && defaultIterator)
            return defaultIterator;
          if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype)
            return IterablePrototype[KIND];
          switch (KIND) {
            case KEYS:
              return function keys() {
                return new IteratorConstructor(this, KIND);
              };
            case VALUES:
              return function values2() {
                return new IteratorConstructor(this, KIND);
              };
            case ENTRIES:
              return function entries2() {
                return new IteratorConstructor(this, KIND);
              };
          }
          return function() {
            return new IteratorConstructor(this);
          };
        };
        var TO_STRING_TAG = NAME + " Iterator";
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY;
        if (anyNativeIterator) {
          CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
          if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
              if (setPrototypeOf2) {
                setPrototypeOf2(CurrentIteratorPrototype, IteratorPrototype);
              } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
                redefine(CurrentIteratorPrototype, ITERATOR, returnThis3);
              }
            }
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if (IS_PURE)
              Iterators[TO_STRING_TAG] = returnThis3;
          }
        }
        if (PROPER_FUNCTION_NAME && DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
          if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
            createNonEnumerableProperty(IterablePrototype, "name", VALUES);
          } else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values2() {
              return call(nativeIterator, this);
            };
          }
        }
        if (DEFAULT) {
          methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
          };
          if (FORCED)
            for (KEY in methods) {
              if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
                redefine(IterablePrototype, KEY, methods[KEY]);
              }
            }
          else
            $2({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
        }
        if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
          redefine(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
        }
        Iterators[NAME] = defaultIterator;
        return methods;
      };
    }
  });

  // node_modules/core-js/modules/es.array.iterator.js
  var require_es_array_iterator = __commonJS({
    "node_modules/core-js/modules/es.array.iterator.js"(exports, module) {
      "use strict";
      var toIndexedObject = require_to_indexed_object();
      var addToUnscopables = require_add_to_unscopables();
      var Iterators = require_iterators();
      var InternalStateModule = require_internal_state();
      var defineIterator = require_define_iterator();
      var ARRAY_ITERATOR = "Array Iterator";
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
      module.exports = defineIterator(Array, "Array", function(iterated, kind) {
        setInternalState(this, {
          type: ARRAY_ITERATOR,
          target: toIndexedObject(iterated),
          // target
          index: 0,
          // next index
          kind
          // kind
        });
      }, function() {
        var state = getInternalState(this);
        var target = state.target;
        var kind = state.kind;
        var index = state.index++;
        if (!target || index >= target.length) {
          state.target = void 0;
          return { value: void 0, done: true };
        }
        if (kind == "keys")
          return { value: index, done: false };
        if (kind == "values")
          return { value: target[index], done: false };
        return { value: [index, target[index]], done: false };
      }, "values");
      Iterators.Arguments = Iterators.Array;
      addToUnscopables("keys");
      addToUnscopables("values");
      addToUnscopables("entries");
    }
  });

  // node_modules/core-js/modules/web.dom-collections.iterator.js
  var require_web_dom_collections_iterator = __commonJS({
    "node_modules/core-js/modules/web.dom-collections.iterator.js"() {
      var global2 = require_global();
      var DOMIterables = require_dom_iterables();
      var DOMTokenListPrototype = require_dom_token_list_prototype();
      var ArrayIteratorMethods = require_es_array_iterator();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var wellKnownSymbol = require_well_known_symbol();
      var ITERATOR = wellKnownSymbol("iterator");
      var TO_STRING_TAG = wellKnownSymbol("toStringTag");
      var ArrayValues = ArrayIteratorMethods.values;
      var handlePrototype = function(CollectionPrototype, COLLECTION_NAME2) {
        if (CollectionPrototype) {
          if (CollectionPrototype[ITERATOR] !== ArrayValues)
            try {
              createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
            } catch (error) {
              CollectionPrototype[ITERATOR] = ArrayValues;
            }
          if (!CollectionPrototype[TO_STRING_TAG]) {
            createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME2);
          }
          if (DOMIterables[COLLECTION_NAME2])
            for (var METHOD_NAME in ArrayIteratorMethods) {
              if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME])
                try {
                  createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
                } catch (error) {
                  CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
                }
            }
        }
      };
      for (COLLECTION_NAME in DOMIterables) {
        handlePrototype(global2[COLLECTION_NAME] && global2[COLLECTION_NAME].prototype, COLLECTION_NAME);
      }
      var COLLECTION_NAME;
      handlePrototype(DOMTokenListPrototype, "DOMTokenList");
    }
  });

  // node_modules/core-js/stable/symbol/index.js
  var require_symbol2 = __commonJS({
    "node_modules/core-js/stable/symbol/index.js"(exports, module) {
      var parent = require_symbol();
      require_web_dom_collections_iterator();
      module.exports = parent;
    }
  });

  // node_modules/core-js/modules/esnext.symbol.async-dispose.js
  var require_esnext_symbol_async_dispose = __commonJS({
    "node_modules/core-js/modules/esnext.symbol.async-dispose.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("asyncDispose");
    }
  });

  // node_modules/core-js/modules/esnext.symbol.dispose.js
  var require_esnext_symbol_dispose = __commonJS({
    "node_modules/core-js/modules/esnext.symbol.dispose.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("dispose");
    }
  });

  // node_modules/core-js/modules/esnext.symbol.matcher.js
  var require_esnext_symbol_matcher = __commonJS({
    "node_modules/core-js/modules/esnext.symbol.matcher.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("matcher");
    }
  });

  // node_modules/core-js/modules/esnext.symbol.metadata.js
  var require_esnext_symbol_metadata = __commonJS({
    "node_modules/core-js/modules/esnext.symbol.metadata.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("metadata");
    }
  });

  // node_modules/core-js/modules/esnext.symbol.observable.js
  var require_esnext_symbol_observable = __commonJS({
    "node_modules/core-js/modules/esnext.symbol.observable.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("observable");
    }
  });

  // node_modules/core-js/modules/esnext.symbol.pattern-match.js
  var require_esnext_symbol_pattern_match = __commonJS({
    "node_modules/core-js/modules/esnext.symbol.pattern-match.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("patternMatch");
    }
  });

  // node_modules/core-js/modules/esnext.symbol.replace-all.js
  var require_esnext_symbol_replace_all = __commonJS({
    "node_modules/core-js/modules/esnext.symbol.replace-all.js"() {
      var defineWellKnownSymbol = require_define_well_known_symbol();
      defineWellKnownSymbol("replaceAll");
    }
  });

  // node_modules/core-js/features/symbol/index.js
  var require_symbol3 = __commonJS({
    "node_modules/core-js/features/symbol/index.js"(exports, module) {
      var parent = require_symbol2();
      require_esnext_symbol_async_dispose();
      require_esnext_symbol_dispose();
      require_esnext_symbol_matcher();
      require_esnext_symbol_metadata();
      require_esnext_symbol_observable();
      require_esnext_symbol_pattern_match();
      require_esnext_symbol_replace_all();
      module.exports = parent;
    }
  });

  // node_modules/core-js/internals/iterator-close.js
  var require_iterator_close = __commonJS({
    "node_modules/core-js/internals/iterator-close.js"(exports, module) {
      var call = require_function_call();
      var anObject = require_an_object();
      var getMethod = require_get_method();
      module.exports = function(iterator, kind, value) {
        var innerResult, innerError;
        anObject(iterator);
        try {
          innerResult = getMethod(iterator, "return");
          if (!innerResult) {
            if (kind === "throw")
              throw value;
            return value;
          }
          innerResult = call(innerResult, iterator);
        } catch (error) {
          innerError = true;
          innerResult = error;
        }
        if (kind === "throw")
          throw value;
        if (innerError)
          throw innerResult;
        anObject(innerResult);
        return value;
      };
    }
  });

  // node_modules/core-js/internals/call-with-safe-iteration-closing.js
  var require_call_with_safe_iteration_closing = __commonJS({
    "node_modules/core-js/internals/call-with-safe-iteration-closing.js"(exports, module) {
      var anObject = require_an_object();
      var iteratorClose = require_iterator_close();
      module.exports = function(iterator, fn, value, ENTRIES) {
        try {
          return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
        } catch (error) {
          iteratorClose(iterator, "throw", error);
        }
      };
    }
  });

  // node_modules/core-js/internals/is-array-iterator-method.js
  var require_is_array_iterator_method = __commonJS({
    "node_modules/core-js/internals/is-array-iterator-method.js"(exports, module) {
      var wellKnownSymbol = require_well_known_symbol();
      var Iterators = require_iterators();
      var ITERATOR = wellKnownSymbol("iterator");
      var ArrayPrototype = Array.prototype;
      module.exports = function(it) {
        return it !== void 0 && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
      };
    }
  });

  // node_modules/core-js/internals/get-iterator-method.js
  var require_get_iterator_method = __commonJS({
    "node_modules/core-js/internals/get-iterator-method.js"(exports, module) {
      var classof = require_classof();
      var getMethod = require_get_method();
      var Iterators = require_iterators();
      var wellKnownSymbol = require_well_known_symbol();
      var ITERATOR = wellKnownSymbol("iterator");
      module.exports = function(it) {
        if (it != void 0)
          return getMethod(it, ITERATOR) || getMethod(it, "@@iterator") || Iterators[classof(it)];
      };
    }
  });

  // node_modules/core-js/internals/get-iterator.js
  var require_get_iterator = __commonJS({
    "node_modules/core-js/internals/get-iterator.js"(exports, module) {
      var global2 = require_global();
      var call = require_function_call();
      var aCallable = require_a_callable();
      var anObject = require_an_object();
      var tryToString = require_try_to_string();
      var getIteratorMethod = require_get_iterator_method();
      var TypeError2 = global2.TypeError;
      module.exports = function(argument, usingIterator) {
        var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
        if (aCallable(iteratorMethod))
          return anObject(call(iteratorMethod, argument));
        throw TypeError2(tryToString(argument) + " is not iterable");
      };
    }
  });

  // node_modules/core-js/internals/array-from.js
  var require_array_from = __commonJS({
    "node_modules/core-js/internals/array-from.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var bind2 = require_function_bind_context();
      var call = require_function_call();
      var toObject = require_to_object();
      var callWithSafeIterationClosing = require_call_with_safe_iteration_closing();
      var isArrayIteratorMethod = require_is_array_iterator_method();
      var isConstructor = require_is_constructor();
      var lengthOfArrayLike = require_length_of_array_like();
      var createProperty = require_create_property();
      var getIterator = require_get_iterator();
      var getIteratorMethod = require_get_iterator_method();
      var Array2 = global2.Array;
      module.exports = function from3(arrayLike) {
        var O = toObject(arrayLike);
        var IS_CONSTRUCTOR = isConstructor(this);
        var argumentsLength = arguments.length;
        var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
        var mapping = mapfn !== void 0;
        if (mapping)
          mapfn = bind2(mapfn, argumentsLength > 2 ? arguments[2] : void 0);
        var iteratorMethod = getIteratorMethod(O);
        var index = 0;
        var length2, result, step, iterator, next, value;
        if (iteratorMethod && !(this == Array2 && isArrayIteratorMethod(iteratorMethod))) {
          iterator = getIterator(O, iteratorMethod);
          next = iterator.next;
          result = IS_CONSTRUCTOR ? new this() : [];
          for (; !(step = call(next, iterator)).done; index++) {
            value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
            createProperty(result, index, value);
          }
        } else {
          length2 = lengthOfArrayLike(O);
          result = IS_CONSTRUCTOR ? new this(length2) : Array2(length2);
          for (; length2 > index; index++) {
            value = mapping ? mapfn(O[index], index) : O[index];
            createProperty(result, index, value);
          }
        }
        result.length = index;
        return result;
      };
    }
  });

  // node_modules/core-js/internals/check-correctness-of-iteration.js
  var require_check_correctness_of_iteration = __commonJS({
    "node_modules/core-js/internals/check-correctness-of-iteration.js"(exports, module) {
      var wellKnownSymbol = require_well_known_symbol();
      var ITERATOR = wellKnownSymbol("iterator");
      var SAFE_CLOSING = false;
      try {
        called = 0;
        iteratorWithReturn = {
          next: function() {
            return { done: !!called++ };
          },
          "return": function() {
            SAFE_CLOSING = true;
          }
        };
        iteratorWithReturn[ITERATOR] = function() {
          return this;
        };
        Array.from(iteratorWithReturn, function() {
          throw 2;
        });
      } catch (error) {
      }
      var called;
      var iteratorWithReturn;
      module.exports = function(exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING)
          return false;
        var ITERATION_SUPPORT = false;
        try {
          var object = {};
          object[ITERATOR] = function() {
            return {
              next: function() {
                return { done: ITERATION_SUPPORT = true };
              }
            };
          };
          exec(object);
        } catch (error) {
        }
        return ITERATION_SUPPORT;
      };
    }
  });

  // node_modules/core-js/modules/es.array.from.js
  var require_es_array_from = __commonJS({
    "node_modules/core-js/modules/es.array.from.js"() {
      var $2 = require_export();
      var from3 = require_array_from();
      var checkCorrectnessOfIteration = require_check_correctness_of_iteration();
      var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function(iterable) {
        Array.from(iterable);
      });
      $2({ target: "Array", stat: true, forced: INCORRECT_ITERATION }, {
        from: from3
      });
    }
  });

  // node_modules/core-js/modules/es.array.is-array.js
  var require_es_array_is_array = __commonJS({
    "node_modules/core-js/modules/es.array.is-array.js"() {
      var $2 = require_export();
      var isArray = require_is_array();
      $2({ target: "Array", stat: true }, {
        isArray
      });
    }
  });

  // node_modules/core-js/modules/es.array.of.js
  var require_es_array_of = __commonJS({
    "node_modules/core-js/modules/es.array.of.js"() {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var fails = require_fails();
      var isConstructor = require_is_constructor();
      var createProperty = require_create_property();
      var Array2 = global2.Array;
      var ISNT_GENERIC = fails(function() {
        function F() {
        }
        return !(Array2.of.call(F) instanceof F);
      });
      $2({ target: "Array", stat: true, forced: ISNT_GENERIC }, {
        of: function of() {
          var index = 0;
          var argumentsLength = arguments.length;
          var result = new (isConstructor(this) ? this : Array2)(argumentsLength);
          while (argumentsLength > index)
            createProperty(result, index, arguments[index++]);
          result.length = argumentsLength;
          return result;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.at.js
  var require_es_array_at = __commonJS({
    "node_modules/core-js/modules/es.array.at.js"() {
      "use strict";
      var $2 = require_export();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        at: function at(index) {
          var O = toObject(this);
          var len = lengthOfArrayLike(O);
          var relativeIndex = toIntegerOrInfinity(index);
          var k = relativeIndex >= 0 ? relativeIndex : len + relativeIndex;
          return k < 0 || k >= len ? void 0 : O[k];
        }
      });
      addToUnscopables("at");
    }
  });

  // node_modules/core-js/internals/array-copy-within.js
  var require_array_copy_within = __commonJS({
    "node_modules/core-js/internals/array-copy-within.js"(exports, module) {
      "use strict";
      var toObject = require_to_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var lengthOfArrayLike = require_length_of_array_like();
      var min = Math.min;
      module.exports = [].copyWithin || function copyWithin(target, start) {
        var O = toObject(this);
        var len = lengthOfArrayLike(O);
        var to = toAbsoluteIndex(target, len);
        var from3 = toAbsoluteIndex(start, len);
        var end = arguments.length > 2 ? arguments[2] : void 0;
        var count = min((end === void 0 ? len : toAbsoluteIndex(end, len)) - from3, len - to);
        var inc2 = 1;
        if (from3 < to && to < from3 + count) {
          inc2 = -1;
          from3 += count - 1;
          to += count - 1;
        }
        while (count-- > 0) {
          if (from3 in O)
            O[to] = O[from3];
          else
            delete O[to];
          to += inc2;
          from3 += inc2;
        }
        return O;
      };
    }
  });

  // node_modules/core-js/modules/es.array.copy-within.js
  var require_es_array_copy_within = __commonJS({
    "node_modules/core-js/modules/es.array.copy-within.js"() {
      var $2 = require_export();
      var copyWithin = require_array_copy_within();
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        copyWithin
      });
      addToUnscopables("copyWithin");
    }
  });

  // node_modules/core-js/internals/array-method-is-strict.js
  var require_array_method_is_strict = __commonJS({
    "node_modules/core-js/internals/array-method-is-strict.js"(exports, module) {
      "use strict";
      var fails = require_fails();
      module.exports = function(METHOD_NAME, argument) {
        var method = [][METHOD_NAME];
        return !!method && fails(function() {
          method.call(null, argument || function() {
            throw 1;
          }, 1);
        });
      };
    }
  });

  // node_modules/core-js/modules/es.array.every.js
  var require_es_array_every = __commonJS({
    "node_modules/core-js/modules/es.array.every.js"() {
      "use strict";
      var $2 = require_export();
      var $every = require_array_iteration().every;
      var arrayMethodIsStrict = require_array_method_is_strict();
      var STRICT_METHOD = arrayMethodIsStrict("every");
      $2({ target: "Array", proto: true, forced: !STRICT_METHOD }, {
        every: function every(callbackfn) {
          return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/internals/array-fill.js
  var require_array_fill = __commonJS({
    "node_modules/core-js/internals/array-fill.js"(exports, module) {
      "use strict";
      var toObject = require_to_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var lengthOfArrayLike = require_length_of_array_like();
      module.exports = function fill(value) {
        var O = toObject(this);
        var length2 = lengthOfArrayLike(O);
        var argumentsLength = arguments.length;
        var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : void 0, length2);
        var end = argumentsLength > 2 ? arguments[2] : void 0;
        var endPos = end === void 0 ? length2 : toAbsoluteIndex(end, length2);
        while (endPos > index)
          O[index++] = value;
        return O;
      };
    }
  });

  // node_modules/core-js/modules/es.array.fill.js
  var require_es_array_fill = __commonJS({
    "node_modules/core-js/modules/es.array.fill.js"() {
      var $2 = require_export();
      var fill = require_array_fill();
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        fill
      });
      addToUnscopables("fill");
    }
  });

  // node_modules/core-js/modules/es.array.filter.js
  var require_es_array_filter = __commonJS({
    "node_modules/core-js/modules/es.array.filter.js"() {
      "use strict";
      var $2 = require_export();
      var $filter = require_array_iteration().filter;
      var arrayMethodHasSpeciesSupport = require_array_method_has_species_support();
      var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("filter");
      $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT }, {
        filter: function filter2(callbackfn) {
          return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.find.js
  var require_es_array_find = __commonJS({
    "node_modules/core-js/modules/es.array.find.js"() {
      "use strict";
      var $2 = require_export();
      var $find = require_array_iteration().find;
      var addToUnscopables = require_add_to_unscopables();
      var FIND = "find";
      var SKIPS_HOLES = true;
      if (FIND in [])
        Array(1)[FIND](function() {
          SKIPS_HOLES = false;
        });
      $2({ target: "Array", proto: true, forced: SKIPS_HOLES }, {
        find: function find2(callbackfn) {
          return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      addToUnscopables(FIND);
    }
  });

  // node_modules/core-js/modules/es.array.find-index.js
  var require_es_array_find_index = __commonJS({
    "node_modules/core-js/modules/es.array.find-index.js"() {
      "use strict";
      var $2 = require_export();
      var $findIndex = require_array_iteration().findIndex;
      var addToUnscopables = require_add_to_unscopables();
      var FIND_INDEX = "findIndex";
      var SKIPS_HOLES = true;
      if (FIND_INDEX in [])
        Array(1)[FIND_INDEX](function() {
          SKIPS_HOLES = false;
        });
      $2({ target: "Array", proto: true, forced: SKIPS_HOLES }, {
        findIndex: function findIndex(callbackfn) {
          return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      addToUnscopables(FIND_INDEX);
    }
  });

  // node_modules/core-js/internals/flatten-into-array.js
  var require_flatten_into_array = __commonJS({
    "node_modules/core-js/internals/flatten-into-array.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var isArray = require_is_array();
      var lengthOfArrayLike = require_length_of_array_like();
      var bind2 = require_function_bind_context();
      var TypeError2 = global2.TypeError;
      var flattenIntoArray = function(target, original, source, sourceLen, start, depth, mapper, thisArg) {
        var targetIndex = start;
        var sourceIndex = 0;
        var mapFn = mapper ? bind2(mapper, thisArg) : false;
        var element, elementLen;
        while (sourceIndex < sourceLen) {
          if (sourceIndex in source) {
            element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
            if (depth > 0 && isArray(element)) {
              elementLen = lengthOfArrayLike(element);
              targetIndex = flattenIntoArray(target, original, element, elementLen, targetIndex, depth - 1) - 1;
            } else {
              if (targetIndex >= 9007199254740991)
                throw TypeError2("Exceed the acceptable array length");
              target[targetIndex] = element;
            }
            targetIndex++;
          }
          sourceIndex++;
        }
        return targetIndex;
      };
      module.exports = flattenIntoArray;
    }
  });

  // node_modules/core-js/modules/es.array.flat.js
  var require_es_array_flat = __commonJS({
    "node_modules/core-js/modules/es.array.flat.js"() {
      "use strict";
      var $2 = require_export();
      var flattenIntoArray = require_flatten_into_array();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var arraySpeciesCreate = require_array_species_create();
      $2({ target: "Array", proto: true }, {
        flat: function flat2() {
          var depthArg = arguments.length ? arguments[0] : void 0;
          var O = toObject(this);
          var sourceLen = lengthOfArrayLike(O);
          var A = arraySpeciesCreate(O, 0);
          A.length = flattenIntoArray(A, O, O, sourceLen, 0, depthArg === void 0 ? 1 : toIntegerOrInfinity(depthArg));
          return A;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.flat-map.js
  var require_es_array_flat_map = __commonJS({
    "node_modules/core-js/modules/es.array.flat-map.js"() {
      "use strict";
      var $2 = require_export();
      var flattenIntoArray = require_flatten_into_array();
      var aCallable = require_a_callable();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var arraySpeciesCreate = require_array_species_create();
      $2({ target: "Array", proto: true }, {
        flatMap: function flatMap2(callbackfn) {
          var O = toObject(this);
          var sourceLen = lengthOfArrayLike(O);
          var A;
          aCallable(callbackfn);
          A = arraySpeciesCreate(O, 0);
          A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
          return A;
        }
      });
    }
  });

  // node_modules/core-js/internals/array-for-each.js
  var require_array_for_each = __commonJS({
    "node_modules/core-js/internals/array-for-each.js"(exports, module) {
      "use strict";
      var $forEach = require_array_iteration().forEach;
      var arrayMethodIsStrict = require_array_method_is_strict();
      var STRICT_METHOD = arrayMethodIsStrict("forEach");
      module.exports = !STRICT_METHOD ? function forEach(callbackfn) {
        return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
      } : [].forEach;
    }
  });

  // node_modules/core-js/modules/es.array.for-each.js
  var require_es_array_for_each = __commonJS({
    "node_modules/core-js/modules/es.array.for-each.js"() {
      "use strict";
      var $2 = require_export();
      var forEach = require_array_for_each();
      $2({ target: "Array", proto: true, forced: [].forEach != forEach }, {
        forEach
      });
    }
  });

  // node_modules/core-js/modules/es.array.index-of.js
  var require_es_array_index_of = __commonJS({
    "node_modules/core-js/modules/es.array.index-of.js"() {
      "use strict";
      var $2 = require_export();
      var uncurryThis = require_function_uncurry_this();
      var $IndexOf = require_array_includes().indexOf;
      var arrayMethodIsStrict = require_array_method_is_strict();
      var un$IndexOf = uncurryThis([].indexOf);
      var NEGATIVE_ZERO = !!un$IndexOf && 1 / un$IndexOf([1], 1, -0) < 0;
      var STRICT_METHOD = arrayMethodIsStrict("indexOf");
      $2({ target: "Array", proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD }, {
        indexOf: function indexOf(searchElement) {
          var fromIndex = arguments.length > 1 ? arguments[1] : void 0;
          return NEGATIVE_ZERO ? un$IndexOf(this, searchElement, fromIndex) || 0 : $IndexOf(this, searchElement, fromIndex);
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.join.js
  var require_es_array_join = __commonJS({
    "node_modules/core-js/modules/es.array.join.js"() {
      "use strict";
      var $2 = require_export();
      var uncurryThis = require_function_uncurry_this();
      var IndexedObject = require_indexed_object();
      var toIndexedObject = require_to_indexed_object();
      var arrayMethodIsStrict = require_array_method_is_strict();
      var un$Join = uncurryThis([].join);
      var ES3_STRINGS = IndexedObject != Object;
      var STRICT_METHOD = arrayMethodIsStrict("join", ",");
      $2({ target: "Array", proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
        join: function join(separator) {
          return un$Join(toIndexedObject(this), separator === void 0 ? "," : separator);
        }
      });
    }
  });

  // node_modules/core-js/internals/array-last-index-of.js
  var require_array_last_index_of = __commonJS({
    "node_modules/core-js/internals/array-last-index-of.js"(exports, module) {
      "use strict";
      var apply = require_function_apply();
      var toIndexedObject = require_to_indexed_object();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var lengthOfArrayLike = require_length_of_array_like();
      var arrayMethodIsStrict = require_array_method_is_strict();
      var min = Math.min;
      var $lastIndexOf = [].lastIndexOf;
      var NEGATIVE_ZERO = !!$lastIndexOf && 1 / [1].lastIndexOf(1, -0) < 0;
      var STRICT_METHOD = arrayMethodIsStrict("lastIndexOf");
      var FORCED = NEGATIVE_ZERO || !STRICT_METHOD;
      module.exports = FORCED ? function lastIndexOf(searchElement) {
        if (NEGATIVE_ZERO)
          return apply($lastIndexOf, this, arguments) || 0;
        var O = toIndexedObject(this);
        var length2 = lengthOfArrayLike(O);
        var index = length2 - 1;
        if (arguments.length > 1)
          index = min(index, toIntegerOrInfinity(arguments[1]));
        if (index < 0)
          index = length2 + index;
        for (; index >= 0; index--)
          if (index in O && O[index] === searchElement)
            return index || 0;
        return -1;
      } : $lastIndexOf;
    }
  });

  // node_modules/core-js/modules/es.array.last-index-of.js
  var require_es_array_last_index_of = __commonJS({
    "node_modules/core-js/modules/es.array.last-index-of.js"() {
      var $2 = require_export();
      var lastIndexOf = require_array_last_index_of();
      $2({ target: "Array", proto: true, forced: lastIndexOf !== [].lastIndexOf }, {
        lastIndexOf
      });
    }
  });

  // node_modules/core-js/modules/es.array.map.js
  var require_es_array_map = __commonJS({
    "node_modules/core-js/modules/es.array.map.js"() {
      "use strict";
      var $2 = require_export();
      var $map = require_array_iteration().map;
      var arrayMethodHasSpeciesSupport = require_array_method_has_species_support();
      var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("map");
      $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT }, {
        map: function map2(callbackfn) {
          return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/internals/array-reduce.js
  var require_array_reduce = __commonJS({
    "node_modules/core-js/internals/array-reduce.js"(exports, module) {
      var global2 = require_global();
      var aCallable = require_a_callable();
      var toObject = require_to_object();
      var IndexedObject = require_indexed_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var TypeError2 = global2.TypeError;
      var createMethod = function(IS_RIGHT) {
        return function(that, callbackfn, argumentsLength, memo) {
          aCallable(callbackfn);
          var O = toObject(that);
          var self2 = IndexedObject(O);
          var length2 = lengthOfArrayLike(O);
          var index = IS_RIGHT ? length2 - 1 : 0;
          var i = IS_RIGHT ? -1 : 1;
          if (argumentsLength < 2)
            while (true) {
              if (index in self2) {
                memo = self2[index];
                index += i;
                break;
              }
              index += i;
              if (IS_RIGHT ? index < 0 : length2 <= index) {
                throw TypeError2("Reduce of empty array with no initial value");
              }
            }
          for (; IS_RIGHT ? index >= 0 : length2 > index; index += i)
            if (index in self2) {
              memo = callbackfn(memo, self2[index], index, O);
            }
          return memo;
        };
      };
      module.exports = {
        // `Array.prototype.reduce` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduce
        left: createMethod(false),
        // `Array.prototype.reduceRight` method
        // https://tc39.es/ecma262/#sec-array.prototype.reduceright
        right: createMethod(true)
      };
    }
  });

  // node_modules/core-js/internals/engine-is-node.js
  var require_engine_is_node = __commonJS({
    "node_modules/core-js/internals/engine-is-node.js"(exports, module) {
      var classof = require_classof_raw();
      var global2 = require_global();
      module.exports = classof(global2.process) == "process";
    }
  });

  // node_modules/core-js/modules/es.array.reduce.js
  var require_es_array_reduce = __commonJS({
    "node_modules/core-js/modules/es.array.reduce.js"() {
      "use strict";
      var $2 = require_export();
      var $reduce = require_array_reduce().left;
      var arrayMethodIsStrict = require_array_method_is_strict();
      var CHROME_VERSION = require_engine_v8_version();
      var IS_NODE = require_engine_is_node();
      var STRICT_METHOD = arrayMethodIsStrict("reduce");
      var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
      $2({ target: "Array", proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
        reduce: function reduce2(callbackfn) {
          var length2 = arguments.length;
          return $reduce(this, callbackfn, length2, length2 > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.reduce-right.js
  var require_es_array_reduce_right = __commonJS({
    "node_modules/core-js/modules/es.array.reduce-right.js"() {
      "use strict";
      var $2 = require_export();
      var $reduceRight = require_array_reduce().right;
      var arrayMethodIsStrict = require_array_method_is_strict();
      var CHROME_VERSION = require_engine_v8_version();
      var IS_NODE = require_engine_is_node();
      var STRICT_METHOD = arrayMethodIsStrict("reduceRight");
      var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
      $2({ target: "Array", proto: true, forced: !STRICT_METHOD || CHROME_BUG }, {
        reduceRight: function reduceRight(callbackfn) {
          return $reduceRight(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.reverse.js
  var require_es_array_reverse = __commonJS({
    "node_modules/core-js/modules/es.array.reverse.js"() {
      "use strict";
      var $2 = require_export();
      var uncurryThis = require_function_uncurry_this();
      var isArray = require_is_array();
      var un$Reverse = uncurryThis([].reverse);
      var test2 = [1, 2];
      $2({ target: "Array", proto: true, forced: String(test2) === String(test2.reverse()) }, {
        reverse: function reverse() {
          if (isArray(this))
            this.length = this.length;
          return un$Reverse(this);
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.slice.js
  var require_es_array_slice = __commonJS({
    "node_modules/core-js/modules/es.array.slice.js"() {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var isArray = require_is_array();
      var isConstructor = require_is_constructor();
      var isObject2 = require_is_object();
      var toAbsoluteIndex = require_to_absolute_index();
      var lengthOfArrayLike = require_length_of_array_like();
      var toIndexedObject = require_to_indexed_object();
      var createProperty = require_create_property();
      var wellKnownSymbol = require_well_known_symbol();
      var arrayMethodHasSpeciesSupport = require_array_method_has_species_support();
      var un$Slice = require_array_slice();
      var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("slice");
      var SPECIES = wellKnownSymbol("species");
      var Array2 = global2.Array;
      var max2 = Math.max;
      $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT }, {
        slice: function slice(start, end) {
          var O = toIndexedObject(this);
          var length2 = lengthOfArrayLike(O);
          var k = toAbsoluteIndex(start, length2);
          var fin = toAbsoluteIndex(end === void 0 ? length2 : end, length2);
          var Constructor, result, n;
          if (isArray(O)) {
            Constructor = O.constructor;
            if (isConstructor(Constructor) && (Constructor === Array2 || isArray(Constructor.prototype))) {
              Constructor = void 0;
            } else if (isObject2(Constructor)) {
              Constructor = Constructor[SPECIES];
              if (Constructor === null)
                Constructor = void 0;
            }
            if (Constructor === Array2 || Constructor === void 0) {
              return un$Slice(O, k, fin);
            }
          }
          result = new (Constructor === void 0 ? Array2 : Constructor)(max2(fin - k, 0));
          for (n = 0; k < fin; k++, n++)
            if (k in O)
              createProperty(result, n, O[k]);
          result.length = n;
          return result;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.some.js
  var require_es_array_some = __commonJS({
    "node_modules/core-js/modules/es.array.some.js"() {
      "use strict";
      var $2 = require_export();
      var $some = require_array_iteration().some;
      var arrayMethodIsStrict = require_array_method_is_strict();
      var STRICT_METHOD = arrayMethodIsStrict("some");
      $2({ target: "Array", proto: true, forced: !STRICT_METHOD }, {
        some: function some(callbackfn) {
          return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
    }
  });

  // node_modules/core-js/internals/array-sort.js
  var require_array_sort = __commonJS({
    "node_modules/core-js/internals/array-sort.js"(exports, module) {
      var arraySlice = require_array_slice();
      var floor = Math.floor;
      var mergeSort = function(array, comparefn) {
        var length2 = array.length;
        var middle = floor(length2 / 2);
        return length2 < 8 ? insertionSort(array, comparefn) : merge2(
          array,
          mergeSort(arraySlice(array, 0, middle), comparefn),
          mergeSort(arraySlice(array, middle), comparefn),
          comparefn
        );
      };
      var insertionSort = function(array, comparefn) {
        var length2 = array.length;
        var i = 1;
        var element, j;
        while (i < length2) {
          j = i;
          element = array[i];
          while (j && comparefn(array[j - 1], element) > 0) {
            array[j] = array[--j];
          }
          if (j !== i++)
            array[j] = element;
        }
        return array;
      };
      var merge2 = function(array, left, right, comparefn) {
        var llength = left.length;
        var rlength = right.length;
        var lindex = 0;
        var rindex = 0;
        while (lindex < llength || rindex < rlength) {
          array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
        }
        return array;
      };
      module.exports = mergeSort;
    }
  });

  // node_modules/core-js/internals/engine-ff-version.js
  var require_engine_ff_version = __commonJS({
    "node_modules/core-js/internals/engine-ff-version.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      var firefox = userAgent.match(/firefox\/(\d+)/i);
      module.exports = !!firefox && +firefox[1];
    }
  });

  // node_modules/core-js/internals/engine-is-ie-or-edge.js
  var require_engine_is_ie_or_edge = __commonJS({
    "node_modules/core-js/internals/engine-is-ie-or-edge.js"(exports, module) {
      var UA = require_engine_user_agent();
      module.exports = /MSIE|Trident/.test(UA);
    }
  });

  // node_modules/core-js/internals/engine-webkit-version.js
  var require_engine_webkit_version = __commonJS({
    "node_modules/core-js/internals/engine-webkit-version.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);
      module.exports = !!webkit && +webkit[1];
    }
  });

  // node_modules/core-js/modules/es.array.sort.js
  var require_es_array_sort = __commonJS({
    "node_modules/core-js/modules/es.array.sort.js"() {
      "use strict";
      var $2 = require_export();
      var uncurryThis = require_function_uncurry_this();
      var aCallable = require_a_callable();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var toString4 = require_to_string();
      var fails = require_fails();
      var internalSort = require_array_sort();
      var arrayMethodIsStrict = require_array_method_is_strict();
      var FF = require_engine_ff_version();
      var IE_OR_EDGE = require_engine_is_ie_or_edge();
      var V8 = require_engine_v8_version();
      var WEBKIT = require_engine_webkit_version();
      var test2 = [];
      var un$Sort = uncurryThis(test2.sort);
      var push = uncurryThis(test2.push);
      var FAILS_ON_UNDEFINED = fails(function() {
        test2.sort(void 0);
      });
      var FAILS_ON_NULL = fails(function() {
        test2.sort(null);
      });
      var STRICT_METHOD = arrayMethodIsStrict("sort");
      var STABLE_SORT = !fails(function() {
        if (V8)
          return V8 < 70;
        if (FF && FF > 3)
          return;
        if (IE_OR_EDGE)
          return true;
        if (WEBKIT)
          return WEBKIT < 603;
        var result = "";
        var code, chr, value, index;
        for (code = 65; code < 76; code++) {
          chr = String.fromCharCode(code);
          switch (code) {
            case 66:
            case 69:
            case 70:
            case 72:
              value = 3;
              break;
            case 68:
            case 71:
              value = 4;
              break;
            default:
              value = 2;
          }
          for (index = 0; index < 47; index++) {
            test2.push({ k: chr + index, v: value });
          }
        }
        test2.sort(function(a, b) {
          return b.v - a.v;
        });
        for (index = 0; index < test2.length; index++) {
          chr = test2[index].k.charAt(0);
          if (result.charAt(result.length - 1) !== chr)
            result += chr;
        }
        return result !== "DGBEFHACIJK";
      });
      var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;
      var getSortCompare = function(comparefn) {
        return function(x, y) {
          if (y === void 0)
            return -1;
          if (x === void 0)
            return 1;
          if (comparefn !== void 0)
            return +comparefn(x, y) || 0;
          return toString4(x) > toString4(y) ? 1 : -1;
        };
      };
      $2({ target: "Array", proto: true, forced: FORCED }, {
        sort: function sort(comparefn) {
          if (comparefn !== void 0)
            aCallable(comparefn);
          var array = toObject(this);
          if (STABLE_SORT)
            return comparefn === void 0 ? un$Sort(array) : un$Sort(array, comparefn);
          var items = [];
          var arrayLength = lengthOfArrayLike(array);
          var itemsLength, index;
          for (index = 0; index < arrayLength; index++) {
            if (index in array)
              push(items, array[index]);
          }
          internalSort(items, getSortCompare(comparefn));
          itemsLength = items.length;
          index = 0;
          while (index < itemsLength)
            array[index] = items[index++];
          while (index < arrayLength)
            delete array[index++];
          return array;
        }
      });
    }
  });

  // node_modules/core-js/internals/set-species.js
  var require_set_species = __commonJS({
    "node_modules/core-js/internals/set-species.js"(exports, module) {
      "use strict";
      var getBuiltIn = require_get_built_in();
      var definePropertyModule = require_object_define_property();
      var wellKnownSymbol = require_well_known_symbol();
      var DESCRIPTORS = require_descriptors();
      var SPECIES = wellKnownSymbol("species");
      module.exports = function(CONSTRUCTOR_NAME) {
        var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
        var defineProperty = definePropertyModule.f;
        if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
          defineProperty(Constructor, SPECIES, {
            configurable: true,
            get: function() {
              return this;
            }
          });
        }
      };
    }
  });

  // node_modules/core-js/modules/es.array.species.js
  var require_es_array_species = __commonJS({
    "node_modules/core-js/modules/es.array.species.js"() {
      var setSpecies = require_set_species();
      setSpecies("Array");
    }
  });

  // node_modules/core-js/modules/es.array.splice.js
  var require_es_array_splice = __commonJS({
    "node_modules/core-js/modules/es.array.splice.js"() {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var toAbsoluteIndex = require_to_absolute_index();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var lengthOfArrayLike = require_length_of_array_like();
      var toObject = require_to_object();
      var arraySpeciesCreate = require_array_species_create();
      var createProperty = require_create_property();
      var arrayMethodHasSpeciesSupport = require_array_method_has_species_support();
      var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport("splice");
      var TypeError2 = global2.TypeError;
      var max2 = Math.max;
      var min = Math.min;
      var MAX_SAFE_INTEGER = 9007199254740991;
      var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = "Maximum allowed length exceeded";
      $2({ target: "Array", proto: true, forced: !HAS_SPECIES_SUPPORT }, {
        splice: function splice(start, deleteCount) {
          var O = toObject(this);
          var len = lengthOfArrayLike(O);
          var actualStart = toAbsoluteIndex(start, len);
          var argumentsLength = arguments.length;
          var insertCount, actualDeleteCount, A, k, from3, to;
          if (argumentsLength === 0) {
            insertCount = actualDeleteCount = 0;
          } else if (argumentsLength === 1) {
            insertCount = 0;
            actualDeleteCount = len - actualStart;
          } else {
            insertCount = argumentsLength - 2;
            actualDeleteCount = min(max2(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
          }
          if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER) {
            throw TypeError2(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
          }
          A = arraySpeciesCreate(O, actualDeleteCount);
          for (k = 0; k < actualDeleteCount; k++) {
            from3 = actualStart + k;
            if (from3 in O)
              createProperty(A, k, O[from3]);
          }
          A.length = actualDeleteCount;
          if (insertCount < actualDeleteCount) {
            for (k = actualStart; k < len - actualDeleteCount; k++) {
              from3 = k + actualDeleteCount;
              to = k + insertCount;
              if (from3 in O)
                O[to] = O[from3];
              else
                delete O[to];
            }
            for (k = len; k > len - actualDeleteCount + insertCount; k--)
              delete O[k - 1];
          } else if (insertCount > actualDeleteCount) {
            for (k = len - actualDeleteCount; k > actualStart; k--) {
              from3 = k + actualDeleteCount - 1;
              to = k + insertCount - 1;
              if (from3 in O)
                O[to] = O[from3];
              else
                delete O[to];
            }
          }
          for (k = 0; k < insertCount; k++) {
            O[k + actualStart] = arguments[k + 2];
          }
          O.length = len - actualDeleteCount + insertCount;
          return A;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.array.unscopables.flat.js
  var require_es_array_unscopables_flat = __commonJS({
    "node_modules/core-js/modules/es.array.unscopables.flat.js"() {
      var addToUnscopables = require_add_to_unscopables();
      addToUnscopables("flat");
    }
  });

  // node_modules/core-js/modules/es.array.unscopables.flat-map.js
  var require_es_array_unscopables_flat_map = __commonJS({
    "node_modules/core-js/modules/es.array.unscopables.flat-map.js"() {
      var addToUnscopables = require_add_to_unscopables();
      addToUnscopables("flatMap");
    }
  });

  // node_modules/core-js/internals/string-multibyte.js
  var require_string_multibyte = __commonJS({
    "node_modules/core-js/internals/string-multibyte.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var toString4 = require_to_string();
      var requireObjectCoercible = require_require_object_coercible();
      var charAt = uncurryThis("".charAt);
      var charCodeAt = uncurryThis("".charCodeAt);
      var stringSlice = uncurryThis("".slice);
      var createMethod = function(CONVERT_TO_STRING) {
        return function($this, pos) {
          var S = toString4(requireObjectCoercible($this));
          var position = toIntegerOrInfinity(pos);
          var size = S.length;
          var first2, second;
          if (position < 0 || position >= size)
            return CONVERT_TO_STRING ? "" : void 0;
          first2 = charCodeAt(S, position);
          return first2 < 55296 || first2 > 56319 || position + 1 === size || (second = charCodeAt(S, position + 1)) < 56320 || second > 57343 ? CONVERT_TO_STRING ? charAt(S, position) : first2 : CONVERT_TO_STRING ? stringSlice(S, position, position + 2) : (first2 - 55296 << 10) + (second - 56320) + 65536;
        };
      };
      module.exports = {
        // `String.prototype.codePointAt` method
        // https://tc39.es/ecma262/#sec-string.prototype.codepointat
        codeAt: createMethod(false),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: createMethod(true)
      };
    }
  });

  // node_modules/core-js/modules/es.string.iterator.js
  var require_es_string_iterator = __commonJS({
    "node_modules/core-js/modules/es.string.iterator.js"() {
      "use strict";
      var charAt = require_string_multibyte().charAt;
      var toString4 = require_to_string();
      var InternalStateModule = require_internal_state();
      var defineIterator = require_define_iterator();
      var STRING_ITERATOR = "String Iterator";
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
      defineIterator(String, "String", function(iterated) {
        setInternalState(this, {
          type: STRING_ITERATOR,
          string: toString4(iterated),
          index: 0
        });
      }, function next() {
        var state = getInternalState(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length)
          return { value: void 0, done: true };
        point = charAt(string, index);
        state.index += point.length;
        return { value: point, done: false };
      });
    }
  });

  // node_modules/core-js/es/array/index.js
  var require_array = __commonJS({
    "node_modules/core-js/es/array/index.js"(exports, module) {
      require_es_array_from();
      require_es_array_is_array();
      require_es_array_of();
      require_es_array_at();
      require_es_array_concat();
      require_es_array_copy_within();
      require_es_array_every();
      require_es_array_fill();
      require_es_array_filter();
      require_es_array_find();
      require_es_array_find_index();
      require_es_array_flat();
      require_es_array_flat_map();
      require_es_array_for_each();
      require_es_array_includes();
      require_es_array_index_of();
      require_es_array_iterator();
      require_es_array_join();
      require_es_array_last_index_of();
      require_es_array_map();
      require_es_array_reduce();
      require_es_array_reduce_right();
      require_es_array_reverse();
      require_es_array_slice();
      require_es_array_some();
      require_es_array_sort();
      require_es_array_species();
      require_es_array_splice();
      require_es_array_unscopables_flat();
      require_es_array_unscopables_flat_map();
      require_es_object_to_string();
      require_es_string_iterator();
      var path = require_path();
      module.exports = path.Array;
    }
  });

  // node_modules/core-js/stable/array/index.js
  var require_array2 = __commonJS({
    "node_modules/core-js/stable/array/index.js"(exports, module) {
      var parent = require_array();
      module.exports = parent;
    }
  });

  // node_modules/core-js/internals/freezing.js
  var require_freezing = __commonJS({
    "node_modules/core-js/internals/freezing.js"(exports, module) {
      var fails = require_fails();
      module.exports = !fails(function() {
        return Object.isExtensible(Object.preventExtensions({}));
      });
    }
  });

  // node_modules/core-js/internals/internal-metadata.js
  var require_internal_metadata = __commonJS({
    "node_modules/core-js/internals/internal-metadata.js"(exports, module) {
      var $2 = require_export();
      var uncurryThis = require_function_uncurry_this();
      var hiddenKeys = require_hidden_keys();
      var isObject2 = require_is_object();
      var hasOwn4 = require_has_own_property();
      var defineProperty = require_object_define_property().f;
      var getOwnPropertyNamesModule = require_object_get_own_property_names();
      var getOwnPropertyNamesExternalModule = require_object_get_own_property_names_external();
      var uid = require_uid();
      var FREEZING = require_freezing();
      var REQUIRED = false;
      var METADATA = uid("meta");
      var id = 0;
      var isExtensible = Object.isExtensible || function() {
        return true;
      };
      var setMetadata = function(it) {
        defineProperty(it, METADATA, { value: {
          objectID: "O" + id++,
          // object ID
          weakData: {}
          // weak collections IDs
        } });
      };
      var fastKey = function(it, create5) {
        if (!isObject2(it))
          return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
        if (!hasOwn4(it, METADATA)) {
          if (!isExtensible(it))
            return "F";
          if (!create5)
            return "E";
          setMetadata(it);
        }
        return it[METADATA].objectID;
      };
      var getWeakData = function(it, create5) {
        if (!hasOwn4(it, METADATA)) {
          if (!isExtensible(it))
            return true;
          if (!create5)
            return false;
          setMetadata(it);
        }
        return it[METADATA].weakData;
      };
      var onFreeze = function(it) {
        if (FREEZING && REQUIRED && isExtensible(it) && !hasOwn4(it, METADATA))
          setMetadata(it);
        return it;
      };
      var enable = function() {
        meta.enable = function() {
        };
        REQUIRED = true;
        var getOwnPropertyNames = getOwnPropertyNamesModule.f;
        var splice = uncurryThis([].splice);
        var test2 = {};
        test2[METADATA] = 1;
        if (getOwnPropertyNames(test2).length) {
          getOwnPropertyNamesModule.f = function(it) {
            var result = getOwnPropertyNames(it);
            for (var i = 0, length2 = result.length; i < length2; i++) {
              if (result[i] === METADATA) {
                splice(result, i, 1);
                break;
              }
            }
            return result;
          };
          $2({ target: "Object", stat: true, forced: true }, {
            getOwnPropertyNames: getOwnPropertyNamesExternalModule.f
          });
        }
      };
      var meta = module.exports = {
        enable,
        fastKey,
        getWeakData,
        onFreeze
      };
      hiddenKeys[METADATA] = true;
    }
  });

  // node_modules/core-js/internals/iterate.js
  var require_iterate = __commonJS({
    "node_modules/core-js/internals/iterate.js"(exports, module) {
      var global2 = require_global();
      var bind2 = require_function_bind_context();
      var call = require_function_call();
      var anObject = require_an_object();
      var tryToString = require_try_to_string();
      var isArrayIteratorMethod = require_is_array_iterator_method();
      var lengthOfArrayLike = require_length_of_array_like();
      var isPrototypeOf = require_object_is_prototype_of();
      var getIterator = require_get_iterator();
      var getIteratorMethod = require_get_iterator_method();
      var iteratorClose = require_iterator_close();
      var TypeError2 = global2.TypeError;
      var Result = function(stopped, result) {
        this.stopped = stopped;
        this.result = result;
      };
      var ResultPrototype = Result.prototype;
      module.exports = function(iterable, unboundFunction, options) {
        var that = options && options.that;
        var AS_ENTRIES = !!(options && options.AS_ENTRIES);
        var IS_ITERATOR = !!(options && options.IS_ITERATOR);
        var INTERRUPTED = !!(options && options.INTERRUPTED);
        var fn = bind2(unboundFunction, that);
        var iterator, iterFn, index, length2, result, next, step;
        var stop = function(condition) {
          if (iterator)
            iteratorClose(iterator, "normal", condition);
          return new Result(true, condition);
        };
        var callFn = function(value) {
          if (AS_ENTRIES) {
            anObject(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
          }
          return INTERRUPTED ? fn(value, stop) : fn(value);
        };
        if (IS_ITERATOR) {
          iterator = iterable;
        } else {
          iterFn = getIteratorMethod(iterable);
          if (!iterFn)
            throw TypeError2(tryToString(iterable) + " is not iterable");
          if (isArrayIteratorMethod(iterFn)) {
            for (index = 0, length2 = lengthOfArrayLike(iterable); length2 > index; index++) {
              result = callFn(iterable[index]);
              if (result && isPrototypeOf(ResultPrototype, result))
                return result;
            }
            return new Result(false);
          }
          iterator = getIterator(iterable, iterFn);
        }
        next = iterator.next;
        while (!(step = call(next, iterator)).done) {
          try {
            result = callFn(step.value);
          } catch (error) {
            iteratorClose(iterator, "throw", error);
          }
          if (typeof result == "object" && result && isPrototypeOf(ResultPrototype, result))
            return result;
        }
        return new Result(false);
      };
    }
  });

  // node_modules/core-js/internals/an-instance.js
  var require_an_instance = __commonJS({
    "node_modules/core-js/internals/an-instance.js"(exports, module) {
      var global2 = require_global();
      var isPrototypeOf = require_object_is_prototype_of();
      var TypeError2 = global2.TypeError;
      module.exports = function(it, Prototype) {
        if (isPrototypeOf(Prototype, it))
          return it;
        throw TypeError2("Incorrect invocation");
      };
    }
  });

  // node_modules/core-js/internals/inherit-if-required.js
  var require_inherit_if_required = __commonJS({
    "node_modules/core-js/internals/inherit-if-required.js"(exports, module) {
      var isCallable = require_is_callable();
      var isObject2 = require_is_object();
      var setPrototypeOf2 = require_object_set_prototype_of();
      module.exports = function($this, dummy, Wrapper) {
        var NewTarget, NewTargetPrototype;
        if (
          // it can work only with native `setPrototypeOf`
          setPrototypeOf2 && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
          isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject2(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype
        )
          setPrototypeOf2($this, NewTargetPrototype);
        return $this;
      };
    }
  });

  // node_modules/core-js/internals/collection.js
  var require_collection = __commonJS({
    "node_modules/core-js/internals/collection.js"(exports, module) {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      var isForced = require_is_forced();
      var redefine = require_redefine();
      var InternalMetadataModule = require_internal_metadata();
      var iterate = require_iterate();
      var anInstance = require_an_instance();
      var isCallable = require_is_callable();
      var isObject2 = require_is_object();
      var fails = require_fails();
      var checkCorrectnessOfIteration = require_check_correctness_of_iteration();
      var setToStringTag = require_set_to_string_tag();
      var inheritIfRequired = require_inherit_if_required();
      module.exports = function(CONSTRUCTOR_NAME, wrapper, common) {
        var IS_MAP = CONSTRUCTOR_NAME.indexOf("Map") !== -1;
        var IS_WEAK = CONSTRUCTOR_NAME.indexOf("Weak") !== -1;
        var ADDER = IS_MAP ? "set" : "add";
        var NativeConstructor = global2[CONSTRUCTOR_NAME];
        var NativePrototype = NativeConstructor && NativeConstructor.prototype;
        var Constructor = NativeConstructor;
        var exported = {};
        var fixMethod = function(KEY) {
          var uncurriedNativeMethod = uncurryThis(NativePrototype[KEY]);
          redefine(
            NativePrototype,
            KEY,
            KEY == "add" ? function add2(value) {
              uncurriedNativeMethod(this, value === 0 ? 0 : value);
              return this;
            } : KEY == "delete" ? function(key) {
              return IS_WEAK && !isObject2(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
            } : KEY == "get" ? function get2(key) {
              return IS_WEAK && !isObject2(key) ? void 0 : uncurriedNativeMethod(this, key === 0 ? 0 : key);
            } : KEY == "has" ? function has2(key) {
              return IS_WEAK && !isObject2(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
            } : function set2(key, value) {
              uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
              return this;
            }
          );
        };
        var REPLACE = isForced(
          CONSTRUCTOR_NAME,
          !isCallable(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !fails(function() {
            new NativeConstructor().entries().next();
          }))
        );
        if (REPLACE) {
          Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
          InternalMetadataModule.enable();
        } else if (isForced(CONSTRUCTOR_NAME, true)) {
          var instance = new Constructor();
          var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
          var THROWS_ON_PRIMITIVES = fails(function() {
            instance.has(1);
          });
          var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function(iterable) {
            new NativeConstructor(iterable);
          });
          var BUGGY_ZERO = !IS_WEAK && fails(function() {
            var $instance = new NativeConstructor();
            var index = 5;
            while (index--)
              $instance[ADDER](index, index);
            return !$instance.has(-0);
          });
          if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
              anInstance(dummy, NativePrototype);
              var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
              if (iterable != void 0)
                iterate(iterable, that[ADDER], { that, AS_ENTRIES: IS_MAP });
              return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
          }
          if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod("delete");
            fixMethod("has");
            IS_MAP && fixMethod("get");
          }
          if (BUGGY_ZERO || HASNT_CHAINING)
            fixMethod(ADDER);
          if (IS_WEAK && NativePrototype.clear)
            delete NativePrototype.clear;
        }
        exported[CONSTRUCTOR_NAME] = Constructor;
        $2({ global: true, forced: Constructor != NativeConstructor }, exported);
        setToStringTag(Constructor, CONSTRUCTOR_NAME);
        if (!IS_WEAK)
          common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
        return Constructor;
      };
    }
  });

  // node_modules/core-js/internals/redefine-all.js
  var require_redefine_all = __commonJS({
    "node_modules/core-js/internals/redefine-all.js"(exports, module) {
      var redefine = require_redefine();
      module.exports = function(target, src, options) {
        for (var key in src)
          redefine(target, key, src[key], options);
        return target;
      };
    }
  });

  // node_modules/core-js/internals/collection-strong.js
  var require_collection_strong = __commonJS({
    "node_modules/core-js/internals/collection-strong.js"(exports, module) {
      "use strict";
      var defineProperty = require_object_define_property().f;
      var create5 = require_object_create();
      var redefineAll = require_redefine_all();
      var bind2 = require_function_bind_context();
      var anInstance = require_an_instance();
      var iterate = require_iterate();
      var defineIterator = require_define_iterator();
      var setSpecies = require_set_species();
      var DESCRIPTORS = require_descriptors();
      var fastKey = require_internal_metadata().fastKey;
      var InternalStateModule = require_internal_state();
      var setInternalState = InternalStateModule.set;
      var internalStateGetterFor = InternalStateModule.getterFor;
      module.exports = {
        getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
          var Constructor = wrapper(function(that, iterable) {
            anInstance(that, Prototype);
            setInternalState(that, {
              type: CONSTRUCTOR_NAME,
              index: create5(null),
              first: void 0,
              last: void 0,
              size: 0
            });
            if (!DESCRIPTORS)
              that.size = 0;
            if (iterable != void 0)
              iterate(iterable, that[ADDER], { that, AS_ENTRIES: IS_MAP });
          });
          var Prototype = Constructor.prototype;
          var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);
          var define2 = function(that, key, value) {
            var state = getInternalState(that);
            var entry = getEntry(that, key);
            var previous, index;
            if (entry) {
              entry.value = value;
            } else {
              state.last = entry = {
                index: index = fastKey(key, true),
                key,
                value,
                previous: previous = state.last,
                next: void 0,
                removed: false
              };
              if (!state.first)
                state.first = entry;
              if (previous)
                previous.next = entry;
              if (DESCRIPTORS)
                state.size++;
              else
                that.size++;
              if (index !== "F")
                state.index[index] = entry;
            }
            return that;
          };
          var getEntry = function(that, key) {
            var state = getInternalState(that);
            var index = fastKey(key);
            var entry;
            if (index !== "F")
              return state.index[index];
            for (entry = state.first; entry; entry = entry.next) {
              if (entry.key == key)
                return entry;
            }
          };
          redefineAll(Prototype, {
            // `{ Map, Set }.prototype.clear()` methods
            // https://tc39.es/ecma262/#sec-map.prototype.clear
            // https://tc39.es/ecma262/#sec-set.prototype.clear
            clear: function clear() {
              var that = this;
              var state = getInternalState(that);
              var data = state.index;
              var entry = state.first;
              while (entry) {
                entry.removed = true;
                if (entry.previous)
                  entry.previous = entry.previous.next = void 0;
                delete data[entry.index];
                entry = entry.next;
              }
              state.first = state.last = void 0;
              if (DESCRIPTORS)
                state.size = 0;
              else
                that.size = 0;
            },
            // `{ Map, Set }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.delete
            // https://tc39.es/ecma262/#sec-set.prototype.delete
            "delete": function(key) {
              var that = this;
              var state = getInternalState(that);
              var entry = getEntry(that, key);
              if (entry) {
                var next = entry.next;
                var prev = entry.previous;
                delete state.index[entry.index];
                entry.removed = true;
                if (prev)
                  prev.next = next;
                if (next)
                  next.previous = prev;
                if (state.first == entry)
                  state.first = next;
                if (state.last == entry)
                  state.last = prev;
                if (DESCRIPTORS)
                  state.size--;
                else
                  that.size--;
              }
              return !!entry;
            },
            // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.foreach
            // https://tc39.es/ecma262/#sec-set.prototype.foreach
            forEach: function forEach(callbackfn) {
              var state = getInternalState(this);
              var boundFunction = bind2(callbackfn, arguments.length > 1 ? arguments[1] : void 0);
              var entry;
              while (entry = entry ? entry.next : state.first) {
                boundFunction(entry.value, entry.key, this);
                while (entry && entry.removed)
                  entry = entry.previous;
              }
            },
            // `{ Map, Set}.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-map.prototype.has
            // https://tc39.es/ecma262/#sec-set.prototype.has
            has: function has2(key) {
              return !!getEntry(this, key);
            }
          });
          redefineAll(Prototype, IS_MAP ? {
            // `Map.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-map.prototype.get
            get: function get2(key) {
              var entry = getEntry(this, key);
              return entry && entry.value;
            },
            // `Map.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-map.prototype.set
            set: function set2(key, value) {
              return define2(this, key === 0 ? 0 : key, value);
            }
          } : {
            // `Set.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-set.prototype.add
            add: function add2(value) {
              return define2(this, value = value === 0 ? 0 : value, value);
            }
          });
          if (DESCRIPTORS)
            defineProperty(Prototype, "size", {
              get: function() {
                return getInternalState(this).size;
              }
            });
          return Constructor;
        },
        setStrong: function(Constructor, CONSTRUCTOR_NAME, IS_MAP) {
          var ITERATOR_NAME = CONSTRUCTOR_NAME + " Iterator";
          var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
          var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
          defineIterator(Constructor, CONSTRUCTOR_NAME, function(iterated, kind) {
            setInternalState(this, {
              type: ITERATOR_NAME,
              target: iterated,
              state: getInternalCollectionState(iterated),
              kind,
              last: void 0
            });
          }, function() {
            var state = getInternalIteratorState(this);
            var kind = state.kind;
            var entry = state.last;
            while (entry && entry.removed)
              entry = entry.previous;
            if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
              state.target = void 0;
              return { value: void 0, done: true };
            }
            if (kind == "keys")
              return { value: entry.key, done: false };
            if (kind == "values")
              return { value: entry.value, done: false };
            return { value: [entry.key, entry.value], done: false };
          }, IS_MAP ? "entries" : "values", !IS_MAP, true);
          setSpecies(CONSTRUCTOR_NAME);
        }
      };
    }
  });

  // node_modules/core-js/modules/es.map.js
  var require_es_map = __commonJS({
    "node_modules/core-js/modules/es.map.js"() {
      "use strict";
      var collection = require_collection();
      var collectionStrong = require_collection_strong();
      collection("Map", function(init) {
        return function Map2() {
          return init(this, arguments.length ? arguments[0] : void 0);
        };
      }, collectionStrong);
    }
  });

  // node_modules/core-js/internals/native-promise-constructor.js
  var require_native_promise_constructor = __commonJS({
    "node_modules/core-js/internals/native-promise-constructor.js"(exports, module) {
      var global2 = require_global();
      module.exports = global2.Promise;
    }
  });

  // node_modules/core-js/internals/a-constructor.js
  var require_a_constructor = __commonJS({
    "node_modules/core-js/internals/a-constructor.js"(exports, module) {
      var global2 = require_global();
      var isConstructor = require_is_constructor();
      var tryToString = require_try_to_string();
      var TypeError2 = global2.TypeError;
      module.exports = function(argument) {
        if (isConstructor(argument))
          return argument;
        throw TypeError2(tryToString(argument) + " is not a constructor");
      };
    }
  });

  // node_modules/core-js/internals/species-constructor.js
  var require_species_constructor = __commonJS({
    "node_modules/core-js/internals/species-constructor.js"(exports, module) {
      var anObject = require_an_object();
      var aConstructor = require_a_constructor();
      var wellKnownSymbol = require_well_known_symbol();
      var SPECIES = wellKnownSymbol("species");
      module.exports = function(O, defaultConstructor) {
        var C = anObject(O).constructor;
        var S;
        return C === void 0 || (S = anObject(C)[SPECIES]) == void 0 ? defaultConstructor : aConstructor(S);
      };
    }
  });

  // node_modules/core-js/internals/engine-is-ios.js
  var require_engine_is_ios = __commonJS({
    "node_modules/core-js/internals/engine-is-ios.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);
    }
  });

  // node_modules/core-js/internals/task.js
  var require_task = __commonJS({
    "node_modules/core-js/internals/task.js"(exports, module) {
      var global2 = require_global();
      var apply = require_function_apply();
      var bind2 = require_function_bind_context();
      var isCallable = require_is_callable();
      var hasOwn4 = require_has_own_property();
      var fails = require_fails();
      var html = require_html();
      var arraySlice = require_array_slice();
      var createElement = require_document_create_element();
      var IS_IOS = require_engine_is_ios();
      var IS_NODE = require_engine_is_node();
      var set2 = global2.setImmediate;
      var clear = global2.clearImmediate;
      var process2 = global2.process;
      var Dispatch = global2.Dispatch;
      var Function2 = global2.Function;
      var MessageChannel = global2.MessageChannel;
      var String2 = global2.String;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = "onreadystatechange";
      var location;
      var defer;
      var channel;
      var port;
      try {
        location = global2.location;
      } catch (error) {
      }
      var run = function(id) {
        if (hasOwn4(queue, id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      var runner = function(id) {
        return function() {
          run(id);
        };
      };
      var listener = function(event) {
        run(event.data);
      };
      var post = function(id) {
        global2.postMessage(String2(id), location.protocol + "//" + location.host);
      };
      if (!set2 || !clear) {
        set2 = function setImmediate2(fn) {
          var args = arraySlice(arguments, 1);
          queue[++counter] = function() {
            apply(isCallable(fn) ? fn : Function2(fn), void 0, args);
          };
          defer(counter);
          return counter;
        };
        clear = function clearImmediate(id) {
          delete queue[id];
        };
        if (IS_NODE) {
          defer = function(id) {
            process2.nextTick(runner(id));
          };
        } else if (Dispatch && Dispatch.now) {
          defer = function(id) {
            Dispatch.now(runner(id));
          };
        } else if (MessageChannel && !IS_IOS) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = bind2(port.postMessage, port);
        } else if (global2.addEventListener && isCallable(global2.postMessage) && !global2.importScripts && location && location.protocol !== "file:" && !fails(post)) {
          defer = post;
          global2.addEventListener("message", listener, false);
        } else if (ONREADYSTATECHANGE in createElement("script")) {
          defer = function(id) {
            html.appendChild(createElement("script"))[ONREADYSTATECHANGE] = function() {
              html.removeChild(this);
              run(id);
            };
          };
        } else {
          defer = function(id) {
            setTimeout(runner(id), 0);
          };
        }
      }
      module.exports = {
        set: set2,
        clear
      };
    }
  });

  // node_modules/core-js/internals/engine-is-ios-pebble.js
  var require_engine_is_ios_pebble = __commonJS({
    "node_modules/core-js/internals/engine-is-ios-pebble.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      var global2 = require_global();
      module.exports = /ipad|iphone|ipod/i.test(userAgent) && global2.Pebble !== void 0;
    }
  });

  // node_modules/core-js/internals/engine-is-webos-webkit.js
  var require_engine_is_webos_webkit = __commonJS({
    "node_modules/core-js/internals/engine-is-webos-webkit.js"(exports, module) {
      var userAgent = require_engine_user_agent();
      module.exports = /web0s(?!.*chrome)/i.test(userAgent);
    }
  });

  // node_modules/core-js/internals/microtask.js
  var require_microtask = __commonJS({
    "node_modules/core-js/internals/microtask.js"(exports, module) {
      var global2 = require_global();
      var bind2 = require_function_bind_context();
      var getOwnPropertyDescriptor = require_object_get_own_property_descriptor().f;
      var macrotask = require_task().set;
      var IS_IOS = require_engine_is_ios();
      var IS_IOS_PEBBLE = require_engine_is_ios_pebble();
      var IS_WEBOS_WEBKIT = require_engine_is_webos_webkit();
      var IS_NODE = require_engine_is_node();
      var MutationObserver = global2.MutationObserver || global2.WebKitMutationObserver;
      var document2 = global2.document;
      var process2 = global2.process;
      var Promise3 = global2.Promise;
      var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global2, "queueMicrotask");
      var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
      var flush;
      var head2;
      var last3;
      var notify;
      var toggle;
      var node;
      var promise;
      var then;
      if (!queueMicrotask) {
        flush = function() {
          var parent, fn;
          if (IS_NODE && (parent = process2.domain))
            parent.exit();
          while (head2) {
            fn = head2.fn;
            head2 = head2.next;
            try {
              fn();
            } catch (error) {
              if (head2)
                notify();
              else
                last3 = void 0;
              throw error;
            }
          }
          last3 = void 0;
          if (parent)
            parent.enter();
        };
        if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document2) {
          toggle = true;
          node = document2.createTextNode("");
          new MutationObserver(flush).observe(node, { characterData: true });
          notify = function() {
            node.data = toggle = !toggle;
          };
        } else if (!IS_IOS_PEBBLE && Promise3 && Promise3.resolve) {
          promise = Promise3.resolve(void 0);
          promise.constructor = Promise3;
          then = bind2(promise.then, promise);
          notify = function() {
            then(flush);
          };
        } else if (IS_NODE) {
          notify = function() {
            process2.nextTick(flush);
          };
        } else {
          macrotask = bind2(macrotask, global2);
          notify = function() {
            macrotask(flush);
          };
        }
      }
      module.exports = queueMicrotask || function(fn) {
        var task = { fn, next: void 0 };
        if (last3)
          last3.next = task;
        if (!head2) {
          head2 = task;
          notify();
        }
        last3 = task;
      };
    }
  });

  // node_modules/core-js/internals/new-promise-capability.js
  var require_new_promise_capability = __commonJS({
    "node_modules/core-js/internals/new-promise-capability.js"(exports, module) {
      "use strict";
      var aCallable = require_a_callable();
      var PromiseCapability = function(C) {
        var resolve2, reject2;
        this.promise = new C(function($$resolve, $$reject) {
          if (resolve2 !== void 0 || reject2 !== void 0)
            throw TypeError("Bad Promise constructor");
          resolve2 = $$resolve;
          reject2 = $$reject;
        });
        this.resolve = aCallable(resolve2);
        this.reject = aCallable(reject2);
      };
      module.exports.f = function(C) {
        return new PromiseCapability(C);
      };
    }
  });

  // node_modules/core-js/internals/promise-resolve.js
  var require_promise_resolve = __commonJS({
    "node_modules/core-js/internals/promise-resolve.js"(exports, module) {
      var anObject = require_an_object();
      var isObject2 = require_is_object();
      var newPromiseCapability = require_new_promise_capability();
      module.exports = function(C, x) {
        anObject(C);
        if (isObject2(x) && x.constructor === C)
          return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve2 = promiseCapability.resolve;
        resolve2(x);
        return promiseCapability.promise;
      };
    }
  });

  // node_modules/core-js/internals/host-report-errors.js
  var require_host_report_errors = __commonJS({
    "node_modules/core-js/internals/host-report-errors.js"(exports, module) {
      var global2 = require_global();
      module.exports = function(a, b) {
        var console2 = global2.console;
        if (console2 && console2.error) {
          arguments.length == 1 ? console2.error(a) : console2.error(a, b);
        }
      };
    }
  });

  // node_modules/core-js/internals/perform.js
  var require_perform = __commonJS({
    "node_modules/core-js/internals/perform.js"(exports, module) {
      module.exports = function(exec) {
        try {
          return { error: false, value: exec() };
        } catch (error) {
          return { error: true, value: error };
        }
      };
    }
  });

  // node_modules/core-js/internals/engine-is-browser.js
  var require_engine_is_browser = __commonJS({
    "node_modules/core-js/internals/engine-is-browser.js"(exports, module) {
      module.exports = typeof window == "object";
    }
  });

  // node_modules/core-js/modules/es.promise.js
  var require_es_promise = __commonJS({
    "node_modules/core-js/modules/es.promise.js"() {
      "use strict";
      var $2 = require_export();
      var IS_PURE = require_is_pure();
      var global2 = require_global();
      var getBuiltIn = require_get_built_in();
      var call = require_function_call();
      var NativePromise = require_native_promise_constructor();
      var redefine = require_redefine();
      var redefineAll = require_redefine_all();
      var setPrototypeOf2 = require_object_set_prototype_of();
      var setToStringTag = require_set_to_string_tag();
      var setSpecies = require_set_species();
      var aCallable = require_a_callable();
      var isCallable = require_is_callable();
      var isObject2 = require_is_object();
      var anInstance = require_an_instance();
      var inspectSource = require_inspect_source();
      var iterate = require_iterate();
      var checkCorrectnessOfIteration = require_check_correctness_of_iteration();
      var speciesConstructor = require_species_constructor();
      var task = require_task().set;
      var microtask = require_microtask();
      var promiseResolve = require_promise_resolve();
      var hostReportErrors = require_host_report_errors();
      var newPromiseCapabilityModule = require_new_promise_capability();
      var perform = require_perform();
      var InternalStateModule = require_internal_state();
      var isForced = require_is_forced();
      var wellKnownSymbol = require_well_known_symbol();
      var IS_BROWSER = require_engine_is_browser();
      var IS_NODE = require_engine_is_node();
      var V8_VERSION = require_engine_v8_version();
      var SPECIES = wellKnownSymbol("species");
      var PROMISE = "Promise";
      var getInternalState = InternalStateModule.get;
      var setInternalState = InternalStateModule.set;
      var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
      var NativePromisePrototype = NativePromise && NativePromise.prototype;
      var PromiseConstructor = NativePromise;
      var PromisePrototype = NativePromisePrototype;
      var TypeError2 = global2.TypeError;
      var document2 = global2.document;
      var process2 = global2.process;
      var newPromiseCapability = newPromiseCapabilityModule.f;
      var newGenericPromiseCapability = newPromiseCapability;
      var DISPATCH_EVENT = !!(document2 && document2.createEvent && global2.dispatchEvent);
      var NATIVE_REJECTION_EVENT = isCallable(global2.PromiseRejectionEvent);
      var UNHANDLED_REJECTION = "unhandledrejection";
      var REJECTION_HANDLED = "rejectionhandled";
      var PENDING = 0;
      var FULFILLED = 1;
      var REJECTED = 2;
      var HANDLED = 1;
      var UNHANDLED = 2;
      var SUBCLASSING = false;
      var Internal;
      var OwnPromiseCapability;
      var PromiseWrapper;
      var nativeThen;
      var FORCED = isForced(PROMISE, function() {
        var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
        var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
        if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66)
          return true;
        if (IS_PURE && !PromisePrototype["finally"])
          return true;
        if (V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE))
          return false;
        var promise = new PromiseConstructor(function(resolve2) {
          resolve2(1);
        });
        var FakePromise = function(exec) {
          exec(function() {
          }, function() {
          });
        };
        var constructor = promise.constructor = {};
        constructor[SPECIES] = FakePromise;
        SUBCLASSING = promise.then(function() {
        }) instanceof FakePromise;
        if (!SUBCLASSING)
          return true;
        return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
      });
      var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function(iterable) {
        PromiseConstructor.all(iterable)["catch"](function() {
        });
      });
      var isThenable = function(it) {
        var then;
        return isObject2(it) && isCallable(then = it.then) ? then : false;
      };
      var notify = function(state, isReject) {
        if (state.notified)
          return;
        state.notified = true;
        var chain = state.reactions;
        microtask(function() {
          var value = state.value;
          var ok = state.state == FULFILLED;
          var index = 0;
          while (chain.length > index) {
            var reaction = chain[index++];
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve2 = reaction.resolve;
            var reject2 = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
              if (handler) {
                if (!ok) {
                  if (state.rejection === UNHANDLED)
                    onHandleUnhandled(state);
                  state.rejection = HANDLED;
                }
                if (handler === true)
                  result = value;
                else {
                  if (domain)
                    domain.enter();
                  result = handler(value);
                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }
                if (result === reaction.promise) {
                  reject2(TypeError2("Promise-chain cycle"));
                } else if (then = isThenable(result)) {
                  call(then, result, resolve2, reject2);
                } else
                  resolve2(result);
              } else
                reject2(value);
            } catch (error) {
              if (domain && !exited)
                domain.exit();
              reject2(error);
            }
          }
          state.reactions = [];
          state.notified = false;
          if (isReject && !state.rejection)
            onUnhandled(state);
        });
      };
      var dispatchEvent = function(name, promise, reason) {
        var event, handler;
        if (DISPATCH_EVENT) {
          event = document2.createEvent("Event");
          event.promise = promise;
          event.reason = reason;
          event.initEvent(name, false, true);
          global2.dispatchEvent(event);
        } else
          event = { promise, reason };
        if (!NATIVE_REJECTION_EVENT && (handler = global2["on" + name]))
          handler(event);
        else if (name === UNHANDLED_REJECTION)
          hostReportErrors("Unhandled promise rejection", reason);
      };
      var onUnhandled = function(state) {
        call(task, global2, function() {
          var promise = state.facade;
          var value = state.value;
          var IS_UNHANDLED = isUnhandled(state);
          var result;
          if (IS_UNHANDLED) {
            result = perform(function() {
              if (IS_NODE) {
                process2.emit("unhandledRejection", value, promise);
              } else
                dispatchEvent(UNHANDLED_REJECTION, promise, value);
            });
            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
            if (result.error)
              throw result.value;
          }
        });
      };
      var isUnhandled = function(state) {
        return state.rejection !== HANDLED && !state.parent;
      };
      var onHandleUnhandled = function(state) {
        call(task, global2, function() {
          var promise = state.facade;
          if (IS_NODE) {
            process2.emit("rejectionHandled", promise);
          } else
            dispatchEvent(REJECTION_HANDLED, promise, state.value);
        });
      };
      var bind2 = function(fn, state, unwrap) {
        return function(value) {
          fn(state, value, unwrap);
        };
      };
      var internalReject = function(state, value, unwrap) {
        if (state.done)
          return;
        state.done = true;
        if (unwrap)
          state = unwrap;
        state.value = value;
        state.state = REJECTED;
        notify(state, true);
      };
      var internalResolve = function(state, value, unwrap) {
        if (state.done)
          return;
        state.done = true;
        if (unwrap)
          state = unwrap;
        try {
          if (state.facade === value)
            throw TypeError2("Promise can't be resolved itself");
          var then = isThenable(value);
          if (then) {
            microtask(function() {
              var wrapper = { done: false };
              try {
                call(
                  then,
                  value,
                  bind2(internalResolve, wrapper, state),
                  bind2(internalReject, wrapper, state)
                );
              } catch (error) {
                internalReject(wrapper, error, state);
              }
            });
          } else {
            state.value = value;
            state.state = FULFILLED;
            notify(state, false);
          }
        } catch (error) {
          internalReject({ done: false }, error, state);
        }
      };
      if (FORCED) {
        PromiseConstructor = function Promise3(executor) {
          anInstance(this, PromisePrototype);
          aCallable(executor);
          call(Internal, this);
          var state = getInternalState(this);
          try {
            executor(bind2(internalResolve, state), bind2(internalReject, state));
          } catch (error) {
            internalReject(state, error);
          }
        };
        PromisePrototype = PromiseConstructor.prototype;
        Internal = function Promise3(executor) {
          setInternalState(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: PENDING,
            value: void 0
          });
        };
        Internal.prototype = redefineAll(PromisePrototype, {
          // `Promise.prototype.then` method
          // https://tc39.es/ecma262/#sec-promise.prototype.then
          then: function then(onFulfilled, onRejected) {
            var state = getInternalPromiseState(this);
            var reactions = state.reactions;
            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
            reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
            reaction.fail = isCallable(onRejected) && onRejected;
            reaction.domain = IS_NODE ? process2.domain : void 0;
            state.parent = true;
            reactions[reactions.length] = reaction;
            if (state.state != PENDING)
              notify(state, false);
            return reaction.promise;
          },
          // `Promise.prototype.catch` method
          // https://tc39.es/ecma262/#sec-promise.prototype.catch
          "catch": function(onRejected) {
            return this.then(void 0, onRejected);
          }
        });
        OwnPromiseCapability = function() {
          var promise = new Internal();
          var state = getInternalState(promise);
          this.promise = promise;
          this.resolve = bind2(internalResolve, state);
          this.reject = bind2(internalReject, state);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function(C) {
          return C === PromiseConstructor || C === PromiseWrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
        };
        if (!IS_PURE && isCallable(NativePromise) && NativePromisePrototype !== Object.prototype) {
          nativeThen = NativePromisePrototype.then;
          if (!SUBCLASSING) {
            redefine(NativePromisePrototype, "then", function then(onFulfilled, onRejected) {
              var that = this;
              return new PromiseConstructor(function(resolve2, reject2) {
                call(nativeThen, that, resolve2, reject2);
              }).then(onFulfilled, onRejected);
            }, { unsafe: true });
            redefine(NativePromisePrototype, "catch", PromisePrototype["catch"], { unsafe: true });
          }
          try {
            delete NativePromisePrototype.constructor;
          } catch (error) {
          }
          if (setPrototypeOf2) {
            setPrototypeOf2(NativePromisePrototype, PromisePrototype);
          }
        }
      }
      $2({ global: true, wrap: true, forced: FORCED }, {
        Promise: PromiseConstructor
      });
      setToStringTag(PromiseConstructor, PROMISE, false, true);
      setSpecies(PROMISE);
      PromiseWrapper = getBuiltIn(PROMISE);
      $2({ target: PROMISE, stat: true, forced: FORCED }, {
        // `Promise.reject` method
        // https://tc39.es/ecma262/#sec-promise.reject
        reject: function reject2(r) {
          var capability = newPromiseCapability(this);
          call(capability.reject, void 0, r);
          return capability.promise;
        }
      });
      $2({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
        // `Promise.resolve` method
        // https://tc39.es/ecma262/#sec-promise.resolve
        resolve: function resolve2(x) {
          return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
        }
      });
      $2({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
        // `Promise.all` method
        // https://tc39.es/ecma262/#sec-promise.all
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve2 = capability.resolve;
          var reject2 = capability.reject;
          var result = perform(function() {
            var $promiseResolve = aCallable(C.resolve);
            var values2 = [];
            var counter = 0;
            var remaining = 1;
            iterate(iterable, function(promise) {
              var index = counter++;
              var alreadyCalled = false;
              remaining++;
              call($promiseResolve, C, promise).then(function(value) {
                if (alreadyCalled)
                  return;
                alreadyCalled = true;
                values2[index] = value;
                --remaining || resolve2(values2);
              }, reject2);
            });
            --remaining || resolve2(values2);
          });
          if (result.error)
            reject2(result.value);
          return capability.promise;
        },
        // `Promise.race` method
        // https://tc39.es/ecma262/#sec-promise.race
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject2 = capability.reject;
          var result = perform(function() {
            var $promiseResolve = aCallable(C.resolve);
            iterate(iterable, function(promise) {
              call($promiseResolve, C, promise).then(capability.resolve, reject2);
            });
          });
          if (result.error)
            reject2(result.value);
          return capability.promise;
        }
      });
    }
  });

  // node_modules/core-js/internals/async-iterator-prototype.js
  var require_async_iterator_prototype = __commonJS({
    "node_modules/core-js/internals/async-iterator-prototype.js"(exports, module) {
      var global2 = require_global();
      var shared = require_shared_store();
      var isCallable = require_is_callable();
      var create5 = require_object_create();
      var getPrototypeOf = require_object_get_prototype_of();
      var redefine = require_redefine();
      var wellKnownSymbol = require_well_known_symbol();
      var IS_PURE = require_is_pure();
      var USE_FUNCTION_CONSTRUCTOR = "USE_FUNCTION_CONSTRUCTOR";
      var ASYNC_ITERATOR = wellKnownSymbol("asyncIterator");
      var AsyncIterator = global2.AsyncIterator;
      var PassedAsyncIteratorPrototype = shared.AsyncIteratorPrototype;
      var AsyncIteratorPrototype;
      var prototype3;
      if (PassedAsyncIteratorPrototype) {
        AsyncIteratorPrototype = PassedAsyncIteratorPrototype;
      } else if (isCallable(AsyncIterator)) {
        AsyncIteratorPrototype = AsyncIterator.prototype;
      } else if (shared[USE_FUNCTION_CONSTRUCTOR] || global2[USE_FUNCTION_CONSTRUCTOR]) {
        try {
          prototype3 = getPrototypeOf(getPrototypeOf(getPrototypeOf(Function("return async function*(){}()")())));
          if (getPrototypeOf(prototype3) === Object.prototype)
            AsyncIteratorPrototype = prototype3;
        } catch (error) {
        }
      }
      if (!AsyncIteratorPrototype)
        AsyncIteratorPrototype = {};
      else if (IS_PURE)
        AsyncIteratorPrototype = create5(AsyncIteratorPrototype);
      if (!isCallable(AsyncIteratorPrototype[ASYNC_ITERATOR])) {
        redefine(AsyncIteratorPrototype, ASYNC_ITERATOR, function() {
          return this;
        });
      }
      module.exports = AsyncIteratorPrototype;
    }
  });

  // node_modules/core-js/internals/async-from-sync-iterator.js
  var require_async_from_sync_iterator = __commonJS({
    "node_modules/core-js/internals/async-from-sync-iterator.js"(exports, module) {
      "use strict";
      var apply = require_function_apply();
      var anObject = require_an_object();
      var create5 = require_object_create();
      var getMethod = require_get_method();
      var redefineAll = require_redefine_all();
      var InternalStateModule = require_internal_state();
      var getBuiltIn = require_get_built_in();
      var AsyncIteratorPrototype = require_async_iterator_prototype();
      var Promise3 = getBuiltIn("Promise");
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.get;
      var asyncFromSyncIteratorContinuation = function(result, resolve2, reject2) {
        var done = result.done;
        Promise3.resolve(result.value).then(function(value) {
          resolve2({ done, value });
        }, reject2);
      };
      var AsyncFromSyncIterator = function AsyncIterator(iterator) {
        setInternalState(this, {
          iterator: anObject(iterator),
          next: iterator.next
        });
      };
      AsyncFromSyncIterator.prototype = redefineAll(create5(AsyncIteratorPrototype), {
        next: function next(arg) {
          var state = getInternalState(this);
          var hasArg = !!arguments.length;
          return new Promise3(function(resolve2, reject2) {
            var result = anObject(apply(state.next, state.iterator, hasArg ? [arg] : []));
            asyncFromSyncIteratorContinuation(result, resolve2, reject2);
          });
        },
        "return": function(arg) {
          var iterator = getInternalState(this).iterator;
          var hasArg = !!arguments.length;
          return new Promise3(function(resolve2, reject2) {
            var $return = getMethod(iterator, "return");
            if ($return === void 0)
              return resolve2({ done: true, value: arg });
            var result = anObject(apply($return, iterator, hasArg ? [arg] : []));
            asyncFromSyncIteratorContinuation(result, resolve2, reject2);
          });
        },
        "throw": function(arg) {
          var iterator = getInternalState(this).iterator;
          var hasArg = !!arguments.length;
          return new Promise3(function(resolve2, reject2) {
            var $throw = getMethod(iterator, "throw");
            if ($throw === void 0)
              return reject2(arg);
            var result = anObject(apply($throw, iterator, hasArg ? [arg] : []));
            asyncFromSyncIteratorContinuation(result, resolve2, reject2);
          });
        }
      });
      module.exports = AsyncFromSyncIterator;
    }
  });

  // node_modules/core-js/internals/get-async-iterator.js
  var require_get_async_iterator = __commonJS({
    "node_modules/core-js/internals/get-async-iterator.js"(exports, module) {
      var call = require_function_call();
      var AsyncFromSyncIterator = require_async_from_sync_iterator();
      var anObject = require_an_object();
      var getIterator = require_get_iterator();
      var getMethod = require_get_method();
      var wellKnownSymbol = require_well_known_symbol();
      var ASYNC_ITERATOR = wellKnownSymbol("asyncIterator");
      module.exports = function(it, usingIterator) {
        var method = arguments.length < 2 ? getMethod(it, ASYNC_ITERATOR) : usingIterator;
        return method ? anObject(call(method, it)) : new AsyncFromSyncIterator(getIterator(it));
      };
    }
  });

  // node_modules/core-js/internals/entry-virtual.js
  var require_entry_virtual = __commonJS({
    "node_modules/core-js/internals/entry-virtual.js"(exports, module) {
      var global2 = require_global();
      module.exports = function(CONSTRUCTOR) {
        return global2[CONSTRUCTOR].prototype;
      };
    }
  });

  // node_modules/core-js/internals/async-iterator-iteration.js
  var require_async_iterator_iteration = __commonJS({
    "node_modules/core-js/internals/async-iterator-iteration.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var call = require_function_call();
      var aCallable = require_a_callable();
      var anObject = require_an_object();
      var getBuiltIn = require_get_built_in();
      var getMethod = require_get_method();
      var MAX_SAFE_INTEGER = 9007199254740991;
      var TypeError2 = global2.TypeError;
      var createMethod = function(TYPE) {
        var IS_TO_ARRAY = TYPE == 0;
        var IS_FOR_EACH = TYPE == 1;
        var IS_EVERY = TYPE == 2;
        var IS_SOME = TYPE == 3;
        return function(iterator, fn, target) {
          anObject(iterator);
          var Promise3 = getBuiltIn("Promise");
          var next = aCallable(iterator.next);
          var index = 0;
          var MAPPING = fn !== void 0;
          if (MAPPING || !IS_TO_ARRAY)
            aCallable(fn);
          return new Promise3(function(resolve2, reject2) {
            var closeIteration = function(method, argument) {
              try {
                var returnMethod = getMethod(iterator, "return");
                if (returnMethod) {
                  return Promise3.resolve(call(returnMethod, iterator)).then(function() {
                    method(argument);
                  }, function(error) {
                    reject2(error);
                  });
                }
              } catch (error2) {
                return reject2(error2);
              }
              method(argument);
            };
            var onError2 = function(error) {
              closeIteration(reject2, error);
            };
            var loop = function() {
              try {
                if (IS_TO_ARRAY && index > MAX_SAFE_INTEGER && MAPPING) {
                  throw TypeError2("The allowed number of iterations has been exceeded");
                }
                Promise3.resolve(anObject(call(next, iterator))).then(function(step) {
                  try {
                    if (anObject(step).done) {
                      if (IS_TO_ARRAY) {
                        target.length = index;
                        resolve2(target);
                      } else
                        resolve2(IS_SOME ? false : IS_EVERY || void 0);
                    } else {
                      var value = step.value;
                      if (MAPPING) {
                        Promise3.resolve(IS_TO_ARRAY ? fn(value, index) : fn(value)).then(function(result) {
                          if (IS_FOR_EACH) {
                            loop();
                          } else if (IS_EVERY) {
                            result ? loop() : closeIteration(resolve2, false);
                          } else if (IS_TO_ARRAY) {
                            target[index++] = result;
                            loop();
                          } else {
                            result ? closeIteration(resolve2, IS_SOME || value) : loop();
                          }
                        }, onError2);
                      } else {
                        target[index++] = value;
                        loop();
                      }
                    }
                  } catch (error) {
                    onError2(error);
                  }
                }, onError2);
              } catch (error2) {
                onError2(error2);
              }
            };
            loop();
          });
        };
      };
      module.exports = {
        toArray: createMethod(0),
        forEach: createMethod(1),
        every: createMethod(2),
        some: createMethod(3),
        find: createMethod(4)
      };
    }
  });

  // node_modules/core-js/internals/array-from-async.js
  var require_array_from_async = __commonJS({
    "node_modules/core-js/internals/array-from-async.js"(exports, module) {
      "use strict";
      var bind2 = require_function_bind_context();
      var toObject = require_to_object();
      var isConstructor = require_is_constructor();
      var getAsyncIterator = require_get_async_iterator();
      var getIterator = require_get_iterator();
      var getIteratorMethod = require_get_iterator_method();
      var getMethod = require_get_method();
      var getVirtual = require_entry_virtual();
      var getBuiltIn = require_get_built_in();
      var wellKnownSymbol = require_well_known_symbol();
      var AsyncFromSyncIterator = require_async_from_sync_iterator();
      var toArray = require_async_iterator_iteration().toArray;
      var ASYNC_ITERATOR = wellKnownSymbol("asyncIterator");
      var arrayIterator = getVirtual("Array").values;
      module.exports = function fromAsync(asyncItems) {
        var C = this;
        var argumentsLength = arguments.length;
        var mapfn = argumentsLength > 1 ? arguments[1] : void 0;
        var thisArg = argumentsLength > 2 ? arguments[2] : void 0;
        return new (getBuiltIn("Promise"))(function(resolve2) {
          var O = toObject(asyncItems);
          if (mapfn !== void 0)
            mapfn = bind2(mapfn, thisArg);
          var usingAsyncIterator = getMethod(O, ASYNC_ITERATOR);
          var usingSyncIterator = usingAsyncIterator ? void 0 : getIteratorMethod(O) || arrayIterator;
          var A = isConstructor(C) ? new C() : [];
          var iterator = usingAsyncIterator ? getAsyncIterator(O, usingAsyncIterator) : new AsyncFromSyncIterator(getIterator(O, usingSyncIterator));
          resolve2(toArray(iterator, mapfn, A));
        });
      };
    }
  });

  // node_modules/core-js/modules/esnext.array.from-async.js
  var require_esnext_array_from_async = __commonJS({
    "node_modules/core-js/modules/esnext.array.from-async.js"() {
      var $2 = require_export();
      var fromAsync = require_array_from_async();
      $2({ target: "Array", stat: true }, {
        fromAsync
      });
    }
  });

  // node_modules/core-js/modules/esnext.array.at.js
  var require_esnext_array_at = __commonJS({
    "node_modules/core-js/modules/esnext.array.at.js"() {
      require_es_array_at();
    }
  });

  // node_modules/core-js/modules/esnext.array.filter-out.js
  var require_esnext_array_filter_out = __commonJS({
    "node_modules/core-js/modules/esnext.array.filter-out.js"() {
      "use strict";
      var $2 = require_export();
      var $filterReject = require_array_iteration().filterReject;
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        filterOut: function filterOut(callbackfn) {
          return $filterReject(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      addToUnscopables("filterOut");
    }
  });

  // node_modules/core-js/modules/esnext.array.filter-reject.js
  var require_esnext_array_filter_reject = __commonJS({
    "node_modules/core-js/modules/esnext.array.filter-reject.js"() {
      "use strict";
      var $2 = require_export();
      var $filterReject = require_array_iteration().filterReject;
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        filterReject: function filterReject(callbackfn) {
          return $filterReject(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      addToUnscopables("filterReject");
    }
  });

  // node_modules/core-js/internals/array-iteration-from-last.js
  var require_array_iteration_from_last = __commonJS({
    "node_modules/core-js/internals/array-iteration-from-last.js"(exports, module) {
      var bind2 = require_function_bind_context();
      var IndexedObject = require_indexed_object();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var createMethod = function(TYPE) {
        var IS_FIND_LAST_INDEX = TYPE == 1;
        return function($this, callbackfn, that) {
          var O = toObject($this);
          var self2 = IndexedObject(O);
          var boundFunction = bind2(callbackfn, that);
          var index = lengthOfArrayLike(self2);
          var value, result;
          while (index-- > 0) {
            value = self2[index];
            result = boundFunction(value, index, O);
            if (result)
              switch (TYPE) {
                case 0:
                  return value;
                case 1:
                  return index;
              }
          }
          return IS_FIND_LAST_INDEX ? -1 : void 0;
        };
      };
      module.exports = {
        // `Array.prototype.findLast` method
        // https://github.com/tc39/proposal-array-find-from-last
        findLast: createMethod(0),
        // `Array.prototype.findLastIndex` method
        // https://github.com/tc39/proposal-array-find-from-last
        findLastIndex: createMethod(1)
      };
    }
  });

  // node_modules/core-js/modules/esnext.array.find-last.js
  var require_esnext_array_find_last = __commonJS({
    "node_modules/core-js/modules/esnext.array.find-last.js"() {
      "use strict";
      var $2 = require_export();
      var $findLast = require_array_iteration_from_last().findLast;
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        findLast: function findLast(callbackfn) {
          return $findLast(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      addToUnscopables("findLast");
    }
  });

  // node_modules/core-js/modules/esnext.array.find-last-index.js
  var require_esnext_array_find_last_index = __commonJS({
    "node_modules/core-js/modules/esnext.array.find-last-index.js"() {
      "use strict";
      var $2 = require_export();
      var $findLastIndex = require_array_iteration_from_last().findLastIndex;
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        findLastIndex: function findLastIndex(callbackfn) {
          return $findLastIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
        }
      });
      addToUnscopables("findLastIndex");
    }
  });

  // node_modules/core-js/internals/array-from-constructor-and-list.js
  var require_array_from_constructor_and_list = __commonJS({
    "node_modules/core-js/internals/array-from-constructor-and-list.js"(exports, module) {
      module.exports = function(Constructor, list) {
        var index = 0;
        var length2 = list.length;
        var result = new Constructor(length2);
        while (length2 > index)
          result[index] = list[index++];
        return result;
      };
    }
  });

  // node_modules/core-js/internals/array-group-by.js
  var require_array_group_by = __commonJS({
    "node_modules/core-js/internals/array-group-by.js"(exports, module) {
      var global2 = require_global();
      var bind2 = require_function_bind_context();
      var uncurryThis = require_function_uncurry_this();
      var IndexedObject = require_indexed_object();
      var toObject = require_to_object();
      var toPropertyKey = require_to_property_key();
      var lengthOfArrayLike = require_length_of_array_like();
      var objectCreate = require_object_create();
      var arrayFromConstructorAndList = require_array_from_constructor_and_list();
      var Array2 = global2.Array;
      var push = uncurryThis([].push);
      module.exports = function($this, callbackfn, that, specificConstructor) {
        var O = toObject($this);
        var self2 = IndexedObject(O);
        var boundFunction = bind2(callbackfn, that);
        var target = objectCreate(null);
        var length2 = lengthOfArrayLike(self2);
        var index = 0;
        var Constructor, key, value;
        for (; length2 > index; index++) {
          value = self2[index];
          key = toPropertyKey(boundFunction(value, index, O));
          if (key in target)
            push(target[key], value);
          else
            target[key] = [value];
        }
        if (specificConstructor) {
          Constructor = specificConstructor(O);
          if (Constructor !== Array2) {
            for (key in target)
              target[key] = arrayFromConstructorAndList(Constructor, target[key]);
          }
        }
        return target;
      };
    }
  });

  // node_modules/core-js/modules/esnext.array.group-by.js
  var require_esnext_array_group_by = __commonJS({
    "node_modules/core-js/modules/esnext.array.group-by.js"() {
      "use strict";
      var $2 = require_export();
      var $groupBy = require_array_group_by();
      var arraySpeciesConstructor = require_array_species_constructor();
      var addToUnscopables = require_add_to_unscopables();
      $2({ target: "Array", proto: true }, {
        groupBy: function groupBy(callbackfn) {
          var thisArg = arguments.length > 1 ? arguments[1] : void 0;
          return $groupBy(this, callbackfn, thisArg, arraySpeciesConstructor);
        }
      });
      addToUnscopables("groupBy");
    }
  });

  // node_modules/core-js/modules/esnext.array.is-template-object.js
  var require_esnext_array_is_template_object = __commonJS({
    "node_modules/core-js/modules/esnext.array.is-template-object.js"() {
      var $2 = require_export();
      var isArray = require_is_array();
      var isFrozen = Object.isFrozen;
      var isFrozenStringArray = function(array, allowUndefined) {
        if (!isFrozen || !isArray(array) || !isFrozen(array))
          return false;
        var index = 0;
        var length2 = array.length;
        var element;
        while (index < length2) {
          element = array[index++];
          if (!(typeof element == "string" || allowUndefined && typeof element == "undefined")) {
            return false;
          }
        }
        return length2 !== 0;
      };
      $2({ target: "Array", stat: true }, {
        isTemplateObject: function isTemplateObject(value) {
          if (!isFrozenStringArray(value, true))
            return false;
          var raw = value.raw;
          if (raw.length !== value.length || !isFrozenStringArray(raw, false))
            return false;
          return true;
        }
      });
    }
  });

  // node_modules/core-js/modules/esnext.array.last-item.js
  var require_esnext_array_last_item = __commonJS({
    "node_modules/core-js/modules/esnext.array.last-item.js"() {
      "use strict";
      var DESCRIPTORS = require_descriptors();
      var addToUnscopables = require_add_to_unscopables();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var defineProperty = require_object_define_property().f;
      if (DESCRIPTORS && !("lastItem" in [])) {
        defineProperty(Array.prototype, "lastItem", {
          configurable: true,
          get: function lastItem() {
            var O = toObject(this);
            var len = lengthOfArrayLike(O);
            return len == 0 ? void 0 : O[len - 1];
          },
          set: function lastItem(value) {
            var O = toObject(this);
            var len = lengthOfArrayLike(O);
            return O[len == 0 ? 0 : len - 1] = value;
          }
        });
        addToUnscopables("lastItem");
      }
    }
  });

  // node_modules/core-js/modules/esnext.array.last-index.js
  var require_esnext_array_last_index = __commonJS({
    "node_modules/core-js/modules/esnext.array.last-index.js"() {
      "use strict";
      var DESCRIPTORS = require_descriptors();
      var addToUnscopables = require_add_to_unscopables();
      var toObject = require_to_object();
      var lengthOfArrayLike = require_length_of_array_like();
      var defineProperty = require_object_define_property().f;
      if (DESCRIPTORS && !("lastIndex" in [])) {
        defineProperty(Array.prototype, "lastIndex", {
          configurable: true,
          get: function lastIndex() {
            var O = toObject(this);
            var len = lengthOfArrayLike(O);
            return len == 0 ? 0 : len - 1;
          }
        });
        addToUnscopables("lastIndex");
      }
    }
  });

  // node_modules/core-js/internals/array-unique-by.js
  var require_array_unique_by = __commonJS({
    "node_modules/core-js/internals/array-unique-by.js"(exports, module) {
      "use strict";
      var getBuiltIn = require_get_built_in();
      var uncurryThis = require_function_uncurry_this();
      var aCallable = require_a_callable();
      var lengthOfArrayLike = require_length_of_array_like();
      var toObject = require_to_object();
      var arraySpeciesCreate = require_array_species_create();
      var Map2 = getBuiltIn("Map");
      var MapPrototype = Map2.prototype;
      var mapForEach = uncurryThis(MapPrototype.forEach);
      var mapHas = uncurryThis(MapPrototype.has);
      var mapSet = uncurryThis(MapPrototype.set);
      var push = uncurryThis([].push);
      module.exports = function uniqueBy(resolver) {
        var that = toObject(this);
        var length2 = lengthOfArrayLike(that);
        var result = arraySpeciesCreate(that, 0);
        var map2 = new Map2();
        var resolverFunction = resolver != null ? aCallable(resolver) : function(value) {
          return value;
        };
        var index, item, key;
        for (index = 0; index < length2; index++) {
          item = that[index];
          key = resolverFunction(item);
          if (!mapHas(map2, key))
            mapSet(map2, key, item);
        }
        mapForEach(map2, function(value) {
          push(result, value);
        });
        return result;
      };
    }
  });

  // node_modules/core-js/modules/esnext.array.unique-by.js
  var require_esnext_array_unique_by = __commonJS({
    "node_modules/core-js/modules/esnext.array.unique-by.js"() {
      "use strict";
      var $2 = require_export();
      var addToUnscopables = require_add_to_unscopables();
      var uniqueBy = require_array_unique_by();
      $2({ target: "Array", proto: true }, {
        uniqueBy
      });
      addToUnscopables("uniqueBy");
    }
  });

  // node_modules/core-js/features/array/index.js
  var require_array3 = __commonJS({
    "node_modules/core-js/features/array/index.js"(exports, module) {
      var parent = require_array2();
      require_es_map();
      require_es_promise();
      require_esnext_array_from_async();
      require_esnext_array_at();
      require_esnext_array_filter_out();
      require_esnext_array_filter_reject();
      require_esnext_array_find_last();
      require_esnext_array_find_last_index();
      require_esnext_array_group_by();
      require_esnext_array_is_template_object();
      require_esnext_array_last_item();
      require_esnext_array_last_index();
      require_esnext_array_unique_by();
      module.exports = parent;
    }
  });

  // node_modules/core-js/internals/string-repeat.js
  var require_string_repeat = __commonJS({
    "node_modules/core-js/internals/string-repeat.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var toString4 = require_to_string();
      var requireObjectCoercible = require_require_object_coercible();
      var RangeError = global2.RangeError;
      module.exports = function repeat(count) {
        var str = toString4(requireObjectCoercible(this));
        var result = "";
        var n = toIntegerOrInfinity(count);
        if (n < 0 || n == Infinity)
          throw RangeError("Wrong number of repetitions");
        for (; n > 0; (n >>>= 1) && (str += str))
          if (n & 1)
            result += str;
        return result;
      };
    }
  });

  // node_modules/core-js/modules/es.string.repeat.js
  var require_es_string_repeat = __commonJS({
    "node_modules/core-js/modules/es.string.repeat.js"() {
      var $2 = require_export();
      var repeat = require_string_repeat();
      $2({ target: "String", proto: true }, {
        repeat
      });
    }
  });

  // node_modules/core-js/es/string/repeat.js
  var require_repeat = __commonJS({
    "node_modules/core-js/es/string/repeat.js"(exports, module) {
      require_es_string_repeat();
      var entryUnbind = require_entry_unbind();
      module.exports = entryUnbind("String", "repeat");
    }
  });

  // node_modules/core-js/stable/string/repeat.js
  var require_repeat2 = __commonJS({
    "node_modules/core-js/stable/string/repeat.js"(exports, module) {
      var parent = require_repeat();
      module.exports = parent;
    }
  });

  // node_modules/core-js/features/string/repeat.js
  var require_repeat3 = __commonJS({
    "node_modules/core-js/features/string/repeat.js"(exports, module) {
      var parent = require_repeat2();
      module.exports = parent;
    }
  });

  // node_modules/core-js/internals/object-to-array.js
  var require_object_to_array = __commonJS({
    "node_modules/core-js/internals/object-to-array.js"(exports, module) {
      var DESCRIPTORS = require_descriptors();
      var uncurryThis = require_function_uncurry_this();
      var objectKeys2 = require_object_keys();
      var toIndexedObject = require_to_indexed_object();
      var $propertyIsEnumerable = require_object_property_is_enumerable().f;
      var propertyIsEnumerable = uncurryThis($propertyIsEnumerable);
      var push = uncurryThis([].push);
      var createMethod = function(TO_ENTRIES) {
        return function(it) {
          var O = toIndexedObject(it);
          var keys = objectKeys2(O);
          var length2 = keys.length;
          var i = 0;
          var result = [];
          var key;
          while (length2 > i) {
            key = keys[i++];
            if (!DESCRIPTORS || propertyIsEnumerable(O, key)) {
              push(result, TO_ENTRIES ? [key, O[key]] : O[key]);
            }
          }
          return result;
        };
      };
      module.exports = {
        // `Object.entries` method
        // https://tc39.es/ecma262/#sec-object.entries
        entries: createMethod(true),
        // `Object.values` method
        // https://tc39.es/ecma262/#sec-object.values
        values: createMethod(false)
      };
    }
  });

  // node_modules/core-js/modules/es.object.entries.js
  var require_es_object_entries = __commonJS({
    "node_modules/core-js/modules/es.object.entries.js"() {
      var $2 = require_export();
      var $entries = require_object_to_array().entries;
      $2({ target: "Object", stat: true }, {
        entries: function entries2(O) {
          return $entries(O);
        }
      });
    }
  });

  // node_modules/core-js/es/object/entries.js
  var require_entries = __commonJS({
    "node_modules/core-js/es/object/entries.js"(exports, module) {
      require_es_object_entries();
      var path = require_path();
      module.exports = path.Object.entries;
    }
  });

  // node_modules/core-js/stable/object/entries.js
  var require_entries2 = __commonJS({
    "node_modules/core-js/stable/object/entries.js"(exports, module) {
      var parent = require_entries();
      module.exports = parent;
    }
  });

  // node_modules/core-js/features/object/entries.js
  var require_entries3 = __commonJS({
    "node_modules/core-js/features/object/entries.js"(exports, module) {
      var parent = require_entries2();
      module.exports = parent;
    }
  });

  // node_modules/core-js/modules/web.dom-collections.for-each.js
  var require_web_dom_collections_for_each = __commonJS({
    "node_modules/core-js/modules/web.dom-collections.for-each.js"() {
      var global2 = require_global();
      var DOMIterables = require_dom_iterables();
      var DOMTokenListPrototype = require_dom_token_list_prototype();
      var forEach = require_array_for_each();
      var createNonEnumerableProperty = require_create_non_enumerable_property();
      var handlePrototype = function(CollectionPrototype) {
        if (CollectionPrototype && CollectionPrototype.forEach !== forEach)
          try {
            createNonEnumerableProperty(CollectionPrototype, "forEach", forEach);
          } catch (error) {
            CollectionPrototype.forEach = forEach;
          }
      };
      for (COLLECTION_NAME in DOMIterables) {
        if (DOMIterables[COLLECTION_NAME]) {
          handlePrototype(global2[COLLECTION_NAME] && global2[COLLECTION_NAME].prototype);
        }
      }
      var COLLECTION_NAME;
      handlePrototype(DOMTokenListPrototype);
    }
  });

  // node_modules/core-js/stable/dom-collections/for-each.js
  var require_for_each = __commonJS({
    "node_modules/core-js/stable/dom-collections/for-each.js"(exports, module) {
      require_web_dom_collections_for_each();
      var parent = require_array_for_each();
      module.exports = parent;
    }
  });

  // node_modules/core-js/features/dom-collections/for-each.js
  var require_for_each2 = __commonJS({
    "node_modules/core-js/features/dom-collections/for-each.js"(exports, module) {
      var parent = require_for_each();
      module.exports = parent;
    }
  });

  // node_modules/core-js/internals/this-number-value.js
  var require_this_number_value = __commonJS({
    "node_modules/core-js/internals/this-number-value.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      module.exports = uncurryThis(1 .valueOf);
    }
  });

  // node_modules/core-js/internals/whitespaces.js
  var require_whitespaces = __commonJS({
    "node_modules/core-js/internals/whitespaces.js"(exports, module) {
      module.exports = "	\n\v\f\r \xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
    }
  });

  // node_modules/core-js/internals/string-trim.js
  var require_string_trim = __commonJS({
    "node_modules/core-js/internals/string-trim.js"(exports, module) {
      var uncurryThis = require_function_uncurry_this();
      var requireObjectCoercible = require_require_object_coercible();
      var toString4 = require_to_string();
      var whitespaces = require_whitespaces();
      var replace2 = uncurryThis("".replace);
      var whitespace = "[" + whitespaces + "]";
      var ltrim = RegExp("^" + whitespace + whitespace + "*");
      var rtrim = RegExp(whitespace + whitespace + "*$");
      var createMethod = function(TYPE) {
        return function($this) {
          var string = toString4(requireObjectCoercible($this));
          if (TYPE & 1)
            string = replace2(string, ltrim, "");
          if (TYPE & 2)
            string = replace2(string, rtrim, "");
          return string;
        };
      };
      module.exports = {
        // `String.prototype.{ trimLeft, trimStart }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimstart
        start: createMethod(1),
        // `String.prototype.{ trimRight, trimEnd }` methods
        // https://tc39.es/ecma262/#sec-string.prototype.trimend
        end: createMethod(2),
        // `String.prototype.trim` method
        // https://tc39.es/ecma262/#sec-string.prototype.trim
        trim: createMethod(3)
      };
    }
  });

  // node_modules/core-js/modules/es.number.constructor.js
  var require_es_number_constructor = __commonJS({
    "node_modules/core-js/modules/es.number.constructor.js"() {
      "use strict";
      var DESCRIPTORS = require_descriptors();
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      var isForced = require_is_forced();
      var redefine = require_redefine();
      var hasOwn4 = require_has_own_property();
      var inheritIfRequired = require_inherit_if_required();
      var isPrototypeOf = require_object_is_prototype_of();
      var isSymbol = require_is_symbol();
      var toPrimitive = require_to_primitive();
      var fails = require_fails();
      var getOwnPropertyNames = require_object_get_own_property_names().f;
      var getOwnPropertyDescriptor = require_object_get_own_property_descriptor().f;
      var defineProperty = require_object_define_property().f;
      var thisNumberValue = require_this_number_value();
      var trim = require_string_trim().trim;
      var NUMBER = "Number";
      var NativeNumber = global2[NUMBER];
      var NumberPrototype = NativeNumber.prototype;
      var TypeError2 = global2.TypeError;
      var arraySlice = uncurryThis("".slice);
      var charCodeAt = uncurryThis("".charCodeAt);
      var toNumeric = function(value) {
        var primValue = toPrimitive(value, "number");
        return typeof primValue == "bigint" ? primValue : toNumber(primValue);
      };
      var toNumber = function(argument) {
        var it = toPrimitive(argument, "number");
        var first2, third, radix, maxCode, digits, length2, index, code;
        if (isSymbol(it))
          throw TypeError2("Cannot convert a Symbol value to a number");
        if (typeof it == "string" && it.length > 2) {
          it = trim(it);
          first2 = charCodeAt(it, 0);
          if (first2 === 43 || first2 === 45) {
            third = charCodeAt(it, 2);
            if (third === 88 || third === 120)
              return NaN;
          } else if (first2 === 48) {
            switch (charCodeAt(it, 1)) {
              case 66:
              case 98:
                radix = 2;
                maxCode = 49;
                break;
              case 79:
              case 111:
                radix = 8;
                maxCode = 55;
                break;
              default:
                return +it;
            }
            digits = arraySlice(it, 2);
            length2 = digits.length;
            for (index = 0; index < length2; index++) {
              code = charCodeAt(digits, index);
              if (code < 48 || code > maxCode)
                return NaN;
            }
            return parseInt(digits, radix);
          }
        }
        return +it;
      };
      if (isForced(NUMBER, !NativeNumber(" 0o1") || !NativeNumber("0b1") || NativeNumber("+0x1"))) {
        NumberWrapper = function Number2(value) {
          var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
          var dummy = this;
          return isPrototypeOf(NumberPrototype, dummy) && fails(function() {
            thisNumberValue(dummy);
          }) ? inheritIfRequired(Object(n), dummy, NumberWrapper) : n;
        };
        for (keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
          // ES3:
          "MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,fromString,range".split(",")
        ), j = 0; keys.length > j; j++) {
          if (hasOwn4(NativeNumber, key = keys[j]) && !hasOwn4(NumberWrapper, key)) {
            defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
          }
        }
        NumberWrapper.prototype = NumberPrototype;
        NumberPrototype.constructor = NumberWrapper;
        redefine(global2, NUMBER, NumberWrapper);
      }
      var NumberWrapper;
      var keys;
      var j;
      var key;
    }
  });

  // node_modules/core-js/modules/es.number.epsilon.js
  var require_es_number_epsilon = __commonJS({
    "node_modules/core-js/modules/es.number.epsilon.js"() {
      var $2 = require_export();
      $2({ target: "Number", stat: true }, {
        EPSILON: Math.pow(2, -52)
      });
    }
  });

  // node_modules/core-js/internals/number-is-finite.js
  var require_number_is_finite = __commonJS({
    "node_modules/core-js/internals/number-is-finite.js"(exports, module) {
      var global2 = require_global();
      var globalIsFinite = global2.isFinite;
      module.exports = Number.isFinite || function isFinite2(it) {
        return typeof it == "number" && globalIsFinite(it);
      };
    }
  });

  // node_modules/core-js/modules/es.number.is-finite.js
  var require_es_number_is_finite = __commonJS({
    "node_modules/core-js/modules/es.number.is-finite.js"() {
      var $2 = require_export();
      var numberIsFinite = require_number_is_finite();
      $2({ target: "Number", stat: true }, { isFinite: numberIsFinite });
    }
  });

  // node_modules/core-js/internals/is-integral-number.js
  var require_is_integral_number = __commonJS({
    "node_modules/core-js/internals/is-integral-number.js"(exports, module) {
      var isObject2 = require_is_object();
      var floor = Math.floor;
      module.exports = Number.isInteger || function isInteger(it) {
        return !isObject2(it) && isFinite(it) && floor(it) === it;
      };
    }
  });

  // node_modules/core-js/modules/es.number.is-integer.js
  var require_es_number_is_integer = __commonJS({
    "node_modules/core-js/modules/es.number.is-integer.js"() {
      var $2 = require_export();
      var isIntegralNumber = require_is_integral_number();
      $2({ target: "Number", stat: true }, {
        isInteger: isIntegralNumber
      });
    }
  });

  // node_modules/core-js/modules/es.number.is-nan.js
  var require_es_number_is_nan = __commonJS({
    "node_modules/core-js/modules/es.number.is-nan.js"() {
      var $2 = require_export();
      $2({ target: "Number", stat: true }, {
        isNaN: function isNaN2(number) {
          return number != number;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.number.is-safe-integer.js
  var require_es_number_is_safe_integer = __commonJS({
    "node_modules/core-js/modules/es.number.is-safe-integer.js"() {
      var $2 = require_export();
      var isIntegralNumber = require_is_integral_number();
      var abs = Math.abs;
      $2({ target: "Number", stat: true }, {
        isSafeInteger: function isSafeInteger(number) {
          return isIntegralNumber(number) && abs(number) <= 9007199254740991;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.number.max-safe-integer.js
  var require_es_number_max_safe_integer = __commonJS({
    "node_modules/core-js/modules/es.number.max-safe-integer.js"() {
      var $2 = require_export();
      $2({ target: "Number", stat: true }, {
        MAX_SAFE_INTEGER: 9007199254740991
      });
    }
  });

  // node_modules/core-js/modules/es.number.min-safe-integer.js
  var require_es_number_min_safe_integer = __commonJS({
    "node_modules/core-js/modules/es.number.min-safe-integer.js"() {
      var $2 = require_export();
      $2({ target: "Number", stat: true }, {
        MIN_SAFE_INTEGER: -9007199254740991
      });
    }
  });

  // node_modules/core-js/internals/number-parse-float.js
  var require_number_parse_float = __commonJS({
    "node_modules/core-js/internals/number-parse-float.js"(exports, module) {
      var global2 = require_global();
      var fails = require_fails();
      var uncurryThis = require_function_uncurry_this();
      var toString4 = require_to_string();
      var trim = require_string_trim().trim;
      var whitespaces = require_whitespaces();
      var charAt = uncurryThis("".charAt);
      var n$ParseFloat = global2.parseFloat;
      var Symbol2 = global2.Symbol;
      var ITERATOR = Symbol2 && Symbol2.iterator;
      var FORCED = 1 / n$ParseFloat(whitespaces + "-0") !== -Infinity || ITERATOR && !fails(function() {
        n$ParseFloat(Object(ITERATOR));
      });
      module.exports = FORCED ? function parseFloat2(string) {
        var trimmedString = trim(toString4(string));
        var result = n$ParseFloat(trimmedString);
        return result === 0 && charAt(trimmedString, 0) == "-" ? -0 : result;
      } : n$ParseFloat;
    }
  });

  // node_modules/core-js/modules/es.number.parse-float.js
  var require_es_number_parse_float = __commonJS({
    "node_modules/core-js/modules/es.number.parse-float.js"() {
      var $2 = require_export();
      var parseFloat2 = require_number_parse_float();
      $2({ target: "Number", stat: true, forced: Number.parseFloat != parseFloat2 }, {
        parseFloat: parseFloat2
      });
    }
  });

  // node_modules/core-js/internals/number-parse-int.js
  var require_number_parse_int = __commonJS({
    "node_modules/core-js/internals/number-parse-int.js"(exports, module) {
      var global2 = require_global();
      var fails = require_fails();
      var uncurryThis = require_function_uncurry_this();
      var toString4 = require_to_string();
      var trim = require_string_trim().trim;
      var whitespaces = require_whitespaces();
      var $parseInt = global2.parseInt;
      var Symbol2 = global2.Symbol;
      var ITERATOR = Symbol2 && Symbol2.iterator;
      var hex = /^[+-]?0x/i;
      var exec = uncurryThis(hex.exec);
      var FORCED = $parseInt(whitespaces + "08") !== 8 || $parseInt(whitespaces + "0x16") !== 22 || ITERATOR && !fails(function() {
        $parseInt(Object(ITERATOR));
      });
      module.exports = FORCED ? function parseInt2(string, radix) {
        var S = trim(toString4(string));
        return $parseInt(S, radix >>> 0 || (exec(hex, S) ? 16 : 10));
      } : $parseInt;
    }
  });

  // node_modules/core-js/modules/es.number.parse-int.js
  var require_es_number_parse_int = __commonJS({
    "node_modules/core-js/modules/es.number.parse-int.js"() {
      var $2 = require_export();
      var parseInt2 = require_number_parse_int();
      $2({ target: "Number", stat: true, forced: Number.parseInt != parseInt2 }, {
        parseInt: parseInt2
      });
    }
  });

  // node_modules/core-js/modules/es.number.to-fixed.js
  var require_es_number_to_fixed = __commonJS({
    "node_modules/core-js/modules/es.number.to-fixed.js"() {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var thisNumberValue = require_this_number_value();
      var $repeat = require_string_repeat();
      var fails = require_fails();
      var RangeError = global2.RangeError;
      var String2 = global2.String;
      var floor = Math.floor;
      var repeat = uncurryThis($repeat);
      var stringSlice = uncurryThis("".slice);
      var un$ToFixed = uncurryThis(1 .toFixed);
      var pow = function(x, n, acc) {
        return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
      };
      var log = function(x) {
        var n = 0;
        var x2 = x;
        while (x2 >= 4096) {
          n += 12;
          x2 /= 4096;
        }
        while (x2 >= 2) {
          n += 1;
          x2 /= 2;
        }
        return n;
      };
      var multiply = function(data, n, c) {
        var index = -1;
        var c2 = c;
        while (++index < 6) {
          c2 += n * data[index];
          data[index] = c2 % 1e7;
          c2 = floor(c2 / 1e7);
        }
      };
      var divide = function(data, n) {
        var index = 6;
        var c = 0;
        while (--index >= 0) {
          c += data[index];
          data[index] = floor(c / n);
          c = c % n * 1e7;
        }
      };
      var dataToString = function(data) {
        var index = 6;
        var s = "";
        while (--index >= 0) {
          if (s !== "" || index === 0 || data[index] !== 0) {
            var t = String2(data[index]);
            s = s === "" ? t : s + repeat("0", 7 - t.length) + t;
          }
        }
        return s;
      };
      var FORCED = fails(function() {
        return un$ToFixed(8e-5, 3) !== "0.000" || un$ToFixed(0.9, 0) !== "1" || un$ToFixed(1.255, 2) !== "1.25" || un$ToFixed(1000000000000000100, 0) !== "1000000000000000128";
      }) || !fails(function() {
        un$ToFixed({});
      });
      $2({ target: "Number", proto: true, forced: FORCED }, {
        toFixed: function toFixed(fractionDigits) {
          var number = thisNumberValue(this);
          var fractDigits = toIntegerOrInfinity(fractionDigits);
          var data = [0, 0, 0, 0, 0, 0];
          var sign = "";
          var result = "0";
          var e, z, j, k;
          if (fractDigits < 0 || fractDigits > 20)
            throw RangeError("Incorrect fraction digits");
          if (number != number)
            return "NaN";
          if (number <= -1e21 || number >= 1e21)
            return String2(number);
          if (number < 0) {
            sign = "-";
            number = -number;
          }
          if (number > 1e-21) {
            e = log(number * pow(2, 69, 1)) - 69;
            z = e < 0 ? number * pow(2, -e, 1) : number / pow(2, e, 1);
            z *= 4503599627370496;
            e = 52 - e;
            if (e > 0) {
              multiply(data, 0, z);
              j = fractDigits;
              while (j >= 7) {
                multiply(data, 1e7, 0);
                j -= 7;
              }
              multiply(data, pow(10, j, 1), 0);
              j = e - 1;
              while (j >= 23) {
                divide(data, 1 << 23);
                j -= 23;
              }
              divide(data, 1 << j);
              multiply(data, 1, 1);
              divide(data, 2);
              result = dataToString(data);
            } else {
              multiply(data, 0, z);
              multiply(data, 1 << -e, 0);
              result = dataToString(data) + repeat("0", fractDigits);
            }
          }
          if (fractDigits > 0) {
            k = result.length;
            result = sign + (k <= fractDigits ? "0." + repeat("0", fractDigits - k) + result : stringSlice(result, 0, k - fractDigits) + "." + stringSlice(result, k - fractDigits));
          } else {
            result = sign + result;
          }
          return result;
        }
      });
    }
  });

  // node_modules/core-js/modules/es.number.to-precision.js
  var require_es_number_to_precision = __commonJS({
    "node_modules/core-js/modules/es.number.to-precision.js"() {
      "use strict";
      var $2 = require_export();
      var uncurryThis = require_function_uncurry_this();
      var fails = require_fails();
      var thisNumberValue = require_this_number_value();
      var un$ToPrecision = uncurryThis(1 .toPrecision);
      var FORCED = fails(function() {
        return un$ToPrecision(1, void 0) !== "1";
      }) || !fails(function() {
        un$ToPrecision({});
      });
      $2({ target: "Number", proto: true, forced: FORCED }, {
        toPrecision: function toPrecision(precision) {
          return precision === void 0 ? un$ToPrecision(thisNumberValue(this)) : un$ToPrecision(thisNumberValue(this), precision);
        }
      });
    }
  });

  // node_modules/core-js/es/number/index.js
  var require_number = __commonJS({
    "node_modules/core-js/es/number/index.js"(exports, module) {
      require_es_number_constructor();
      require_es_number_epsilon();
      require_es_number_is_finite();
      require_es_number_is_integer();
      require_es_number_is_nan();
      require_es_number_is_safe_integer();
      require_es_number_max_safe_integer();
      require_es_number_min_safe_integer();
      require_es_number_parse_float();
      require_es_number_parse_int();
      require_es_number_to_fixed();
      require_es_number_to_precision();
      var path = require_path();
      module.exports = path.Number;
    }
  });

  // node_modules/core-js/stable/number/index.js
  var require_number2 = __commonJS({
    "node_modules/core-js/stable/number/index.js"(exports, module) {
      var parent = require_number();
      module.exports = parent;
    }
  });

  // node_modules/core-js/modules/esnext.number.from-string.js
  var require_esnext_number_from_string = __commonJS({
    "node_modules/core-js/modules/esnext.number.from-string.js"() {
      "use strict";
      var $2 = require_export();
      var global2 = require_global();
      var uncurryThis = require_function_uncurry_this();
      var toIntegerOrInfinity = require_to_integer_or_infinity();
      var parseInt2 = require_number_parse_int();
      var INVALID_NUMBER_REPRESENTATION = "Invalid number representation";
      var INVALID_RADIX = "Invalid radix";
      var RangeError = global2.RangeError;
      var SyntaxError2 = global2.SyntaxError;
      var TypeError2 = global2.TypeError;
      var valid = /^[\da-z]+$/;
      var charAt = uncurryThis("".charAt);
      var exec = uncurryThis(valid.exec);
      var numberToString = uncurryThis(1 .toString);
      var stringSlice = uncurryThis("".slice);
      $2({ target: "Number", stat: true }, {
        fromString: function fromString(string, radix) {
          var sign = 1;
          var R, mathNum;
          if (typeof string != "string")
            throw TypeError2(INVALID_NUMBER_REPRESENTATION);
          if (!string.length)
            throw SyntaxError2(INVALID_NUMBER_REPRESENTATION);
          if (charAt(string, 0) == "-") {
            sign = -1;
            string = stringSlice(string, 1);
            if (!string.length)
              throw SyntaxError2(INVALID_NUMBER_REPRESENTATION);
          }
          R = radix === void 0 ? 10 : toIntegerOrInfinity(radix);
          if (R < 2 || R > 36)
            throw RangeError(INVALID_RADIX);
          if (!exec(valid, string) || numberToString(mathNum = parseInt2(string, R), R) !== string) {
            throw SyntaxError2(INVALID_NUMBER_REPRESENTATION);
          }
          return sign * mathNum;
        }
      });
    }
  });

  // node_modules/core-js/internals/numeric-range-iterator.js
  var require_numeric_range_iterator = __commonJS({
    "node_modules/core-js/internals/numeric-range-iterator.js"(exports, module) {
      "use strict";
      var global2 = require_global();
      var InternalStateModule = require_internal_state();
      var createIteratorConstructor = require_create_iterator_constructor();
      var isObject2 = require_is_object();
      var defineProperties = require_object_define_properties();
      var DESCRIPTORS = require_descriptors();
      var INCORRECT_RANGE = "Incorrect Number.range arguments";
      var NUMERIC_RANGE_ITERATOR = "NumericRangeIterator";
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(NUMERIC_RANGE_ITERATOR);
      var RangeError = global2.RangeError;
      var TypeError2 = global2.TypeError;
      var $RangeIterator = createIteratorConstructor(function NumericRangeIterator(start, end, option, type, zero, one) {
        if (typeof start != type || end !== Infinity && end !== -Infinity && typeof end != type) {
          throw new TypeError2(INCORRECT_RANGE);
        }
        if (start === Infinity || start === -Infinity) {
          throw new RangeError(INCORRECT_RANGE);
        }
        var ifIncrease = end > start;
        var inclusiveEnd = false;
        var step;
        if (option === void 0) {
          step = void 0;
        } else if (isObject2(option)) {
          step = option.step;
          inclusiveEnd = !!option.inclusive;
        } else if (typeof option == type) {
          step = option;
        } else {
          throw new TypeError2(INCORRECT_RANGE);
        }
        if (step == null) {
          step = ifIncrease ? one : -one;
        }
        if (typeof step != type) {
          throw new TypeError2(INCORRECT_RANGE);
        }
        if (step === Infinity || step === -Infinity || step === zero && start !== end) {
          throw new RangeError(INCORRECT_RANGE);
        }
        var hitsEnd = start != start || end != end || step != step || end > start !== step > zero;
        setInternalState(this, {
          type: NUMERIC_RANGE_ITERATOR,
          start,
          end,
          step,
          inclusiveEnd,
          hitsEnd,
          currentCount: zero,
          zero
        });
        if (!DESCRIPTORS) {
          this.start = start;
          this.end = end;
          this.step = step;
          this.inclusive = inclusiveEnd;
        }
      }, NUMERIC_RANGE_ITERATOR, function next() {
        var state = getInternalState(this);
        if (state.hitsEnd)
          return { value: void 0, done: true };
        var start = state.start;
        var end = state.end;
        var step = state.step;
        var currentYieldingValue = start + step * state.currentCount++;
        if (currentYieldingValue === end)
          state.hitsEnd = true;
        var inclusiveEnd = state.inclusiveEnd;
        var endCondition;
        if (end > start) {
          endCondition = inclusiveEnd ? currentYieldingValue > end : currentYieldingValue >= end;
        } else {
          endCondition = inclusiveEnd ? end > currentYieldingValue : end >= currentYieldingValue;
        }
        if (endCondition) {
          return { value: void 0, done: state.hitsEnd = true };
        }
        return { value: currentYieldingValue, done: false };
      });
      var getter = function(fn) {
        return { get: fn, set: function() {
        }, configurable: true, enumerable: false };
      };
      if (DESCRIPTORS) {
        defineProperties($RangeIterator.prototype, {
          start: getter(function() {
            return getInternalState(this).start;
          }),
          end: getter(function() {
            return getInternalState(this).end;
          }),
          inclusive: getter(function() {
            return getInternalState(this).inclusiveEnd;
          }),
          step: getter(function() {
            return getInternalState(this).step;
          })
        });
      }
      module.exports = $RangeIterator;
    }
  });

  // node_modules/core-js/modules/esnext.number.range.js
  var require_esnext_number_range = __commonJS({
    "node_modules/core-js/modules/esnext.number.range.js"() {
      "use strict";
      var $2 = require_export();
      var NumericRangeIterator = require_numeric_range_iterator();
      $2({ target: "Number", stat: true }, {
        range: function range(start, end, option) {
          return new NumericRangeIterator(start, end, option, "number", 0, 1);
        }
      });
    }
  });

  // node_modules/core-js/features/number/index.js
  var require_number3 = __commonJS({
    "node_modules/core-js/features/number/index.js"(exports, module) {
      var parent = require_number2();
      module.exports = parent;
      require_es_object_to_string();
      require_esnext_number_from_string();
      require_esnext_number_range();
    }
  });

  // node_modules/fast-json-stable-stringify/index.js
  var require_fast_json_stable_stringify = __commonJS({
    "node_modules/fast-json-stable-stringify/index.js"(exports, module) {
      "use strict";
      module.exports = function(data, opts) {
        if (!opts)
          opts = {};
        if (typeof opts === "function")
          opts = { cmp: opts };
        var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
        var cmp = opts.cmp && function(f) {
          return function(node) {
            return function(a, b) {
              var aobj = { key: a, value: node[a] };
              var bobj = { key: b, value: node[b] };
              return f(aobj, bobj);
            };
          };
        }(opts.cmp);
        var seen = [];
        return function stringify4(node) {
          if (node && node.toJSON && typeof node.toJSON === "function") {
            node = node.toJSON();
          }
          if (node === void 0)
            return;
          if (typeof node == "number")
            return isFinite(node) ? "" + node : "null";
          if (typeof node !== "object")
            return JSON.stringify(node);
          var i, out;
          if (Array.isArray(node)) {
            out = "[";
            for (i = 0; i < node.length; i++) {
              if (i)
                out += ",";
              out += stringify4(node[i]) || "null";
            }
            return out + "]";
          }
          if (node === null)
            return "null";
          if (seen.indexOf(node) !== -1) {
            if (cycles)
              return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
          }
          var seenIndex = seen.push(node) - 1;
          var keys = Object.keys(node).sort(cmp && cmp(node));
          out = "";
          for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify4(node[key]);
            if (!value)
              continue;
            if (out)
              out += ",";
            out += JSON.stringify(key) + ":" + value;
          }
          seen.splice(seenIndex, 1);
          return "{" + out + "}";
        }(data);
      };
    }
  });

  // node_modules/apollo-utilities/lib/bundle.umd.js
  var require_bundle_umd = __commonJS({
    "node_modules/apollo-utilities/lib/bundle.umd.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require_fast_json_stable_stringify()) : typeof define === "function" && define.amd ? define(["exports", "fast-json-stable-stringify"], factory) : factory((global2.apollo = global2.apollo || {}, global2.apollo.utilities = {}), null);
      })(exports, function(exports2, stringify4) {
        "use strict";
        stringify4 = stringify4 && stringify4.hasOwnProperty("default") ? stringify4["default"] : stringify4;
        var __assign14 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        function isScalarValue(value) {
          return ["StringValue", "BooleanValue", "EnumValue"].indexOf(value.kind) > -1;
        }
        function isNumberValue(value) {
          return ["IntValue", "FloatValue"].indexOf(value.kind) > -1;
        }
        function isStringValue2(value) {
          return value.kind === "StringValue";
        }
        function isBooleanValue2(value) {
          return value.kind === "BooleanValue";
        }
        function isIntValue2(value) {
          return value.kind === "IntValue";
        }
        function isFloatValue2(value) {
          return value.kind === "FloatValue";
        }
        function isVariable2(value) {
          return value.kind === "Variable";
        }
        function isObjectValue2(value) {
          return value.kind === "ObjectValue";
        }
        function isListValue2(value) {
          return value.kind === "ListValue";
        }
        function isEnumValue2(value) {
          return value.kind === "EnumValue";
        }
        function isNullValue2(value) {
          return value.kind === "NullValue";
        }
        function valueToObjectRepresentation2(argObj, name, value, variables) {
          if (isIntValue2(value) || isFloatValue2(value)) {
            argObj[name.value] = Number(value.value);
          } else if (isBooleanValue2(value) || isStringValue2(value)) {
            argObj[name.value] = value.value;
          } else if (isObjectValue2(value)) {
            var nestedArgObj_1 = {};
            value.fields.map(function(obj) {
              return valueToObjectRepresentation2(nestedArgObj_1, obj.name, obj.value, variables);
            });
            argObj[name.value] = nestedArgObj_1;
          } else if (isVariable2(value)) {
            var variableValue = (variables || {})[value.name.value];
            argObj[name.value] = variableValue;
          } else if (isListValue2(value)) {
            argObj[name.value] = value.values.map(function(listValue) {
              var nestedArgArrayObj = {};
              valueToObjectRepresentation2(nestedArgArrayObj, name, listValue, variables);
              return nestedArgArrayObj[name.value];
            });
          } else if (isEnumValue2(value)) {
            argObj[name.value] = value.value;
          } else if (isNullValue2(value)) {
            argObj[name.value] = null;
          } else {
            throw new Error('The inline argument "' + name.value + '" of kind "' + value.kind + '" is not supported.\n                    Use variables instead of inline arguments to overcome this limitation.');
          }
        }
        function storeKeyNameFromField2(field, variables) {
          var directivesObj = null;
          if (field.directives) {
            directivesObj = {};
            field.directives.forEach(function(directive) {
              directivesObj[directive.name.value] = {};
              if (directive.arguments) {
                directive.arguments.forEach(function(_a4) {
                  var name = _a4.name, value = _a4.value;
                  return valueToObjectRepresentation2(directivesObj[directive.name.value], name, value, variables);
                });
              }
            });
          }
          var argObj = null;
          if (field.arguments && field.arguments.length) {
            argObj = {};
            field.arguments.forEach(function(_a4) {
              var name = _a4.name, value = _a4.value;
              return valueToObjectRepresentation2(argObj, name, value, variables);
            });
          }
          return getStoreKeyName2(field.name.value, argObj, directivesObj);
        }
        var KNOWN_DIRECTIVES2 = [
          "connection",
          "include",
          "skip",
          "client",
          "rest",
          "export"
        ];
        function getStoreKeyName2(fieldName, args, directives) {
          if (directives && directives["connection"] && directives["connection"]["key"]) {
            if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
              var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
              filterKeys.sort();
              var queryArgs_1 = args;
              var filteredArgs_1 = {};
              filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
              });
              return directives["connection"]["key"] + "(" + JSON.stringify(filteredArgs_1) + ")";
            } else {
              return directives["connection"]["key"];
            }
          }
          var completeFieldName = fieldName;
          if (args) {
            var stringifiedArgs = stringify4(args);
            completeFieldName += "(" + stringifiedArgs + ")";
          }
          if (directives) {
            Object.keys(directives).forEach(function(key) {
              if (KNOWN_DIRECTIVES2.indexOf(key) !== -1)
                return;
              if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
              } else {
                completeFieldName += "@" + key;
              }
            });
          }
          return completeFieldName;
        }
        function argumentsObjectFromField2(field, variables) {
          if (field.arguments && field.arguments.length) {
            var argObj_1 = {};
            field.arguments.forEach(function(_a4) {
              var name = _a4.name, value = _a4.value;
              return valueToObjectRepresentation2(argObj_1, name, value, variables);
            });
            return argObj_1;
          }
          return null;
        }
        function resultKeyNameFromField2(field) {
          return field.alias ? field.alias.value : field.name.value;
        }
        function isField2(selection) {
          return selection.kind === "Field";
        }
        function isInlineFragment2(selection) {
          return selection.kind === "InlineFragment";
        }
        function isIdValue2(idObject) {
          return idObject && idObject.type === "id";
        }
        function toIdValue2(idConfig, generated) {
          if (generated === void 0) {
            generated = false;
          }
          return __assign14({ type: "id", generated }, typeof idConfig === "string" ? { id: idConfig, typename: void 0 } : idConfig);
        }
        function isJsonValue2(jsonObject) {
          return jsonObject != null && typeof jsonObject === "object" && jsonObject.type === "json";
        }
        function defaultValueFromVariable(node) {
          throw new Error("Variable nodes are not supported by valueFromNode");
        }
        function valueFromNode(node, onVariable) {
          if (onVariable === void 0) {
            onVariable = defaultValueFromVariable;
          }
          switch (node.kind) {
            case "Variable":
              return onVariable(node);
            case "NullValue":
              return null;
            case "IntValue":
              return parseInt(node.value, 10);
            case "FloatValue":
              return parseFloat(node.value);
            case "ListValue":
              return node.values.map(function(v) {
                return valueFromNode(v, onVariable);
              });
            case "ObjectValue": {
              var value = {};
              for (var _i = 0, _a4 = node.fields; _i < _a4.length; _i++) {
                var field = _a4[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
              }
              return value;
            }
            default:
              return node.value;
          }
        }
        function getDirectiveInfoFromField2(field, variables) {
          if (field.directives && field.directives.length) {
            var directiveObj_1 = {};
            field.directives.forEach(function(directive) {
              directiveObj_1[directive.name.value] = argumentsObjectFromField2(directive, variables);
            });
            return directiveObj_1;
          }
          return null;
        }
        function shouldInclude2(selection, variables) {
          if (variables === void 0) {
            variables = {};
          }
          if (!selection.directives) {
            return true;
          }
          var res = true;
          selection.directives.forEach(function(directive) {
            if (directive.name.value !== "skip" && directive.name.value !== "include") {
              return;
            }
            var directiveArguments = directive.arguments || [];
            var directiveName = directive.name.value;
            if (directiveArguments.length !== 1) {
              throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
            }
            var ifArgument = directiveArguments[0];
            if (!ifArgument.name || ifArgument.name.value !== "if") {
              throw new Error("Invalid argument for the @" + directiveName + " directive.");
            }
            var ifValue = directiveArguments[0].value;
            var evaledValue = false;
            if (!ifValue || ifValue.kind !== "BooleanValue") {
              if (ifValue.kind !== "Variable") {
                throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
              } else {
                evaledValue = variables[ifValue.name.value];
                if (evaledValue === void 0) {
                  throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
                }
              }
            } else {
              evaledValue = ifValue.value;
            }
            if (directiveName === "skip") {
              evaledValue = !evaledValue;
            }
            if (!evaledValue) {
              res = false;
            }
          });
          return res;
        }
        function flattenSelections(selection) {
          if (!selection.selectionSet || !(selection.selectionSet.selections.length > 0))
            return [selection];
          return [selection].concat(selection.selectionSet.selections.map(function(selectionNode) {
            return [selectionNode].concat(flattenSelections(selectionNode));
          }).reduce(function(selections, selected) {
            return selections.concat(selected);
          }, []));
        }
        function getDirectiveNames(doc) {
          var directiveNames = doc.definitions.filter(function(definition) {
            return definition.selectionSet && definition.selectionSet.selections;
          }).map(function(x) {
            return flattenSelections(x);
          }).reduce(function(selections, selected) {
            return selections.concat(selected);
          }, []).filter(function(selection) {
            return selection.directives && selection.directives.length > 0;
          }).map(function(selection) {
            return selection.directives;
          }).reduce(function(directives, directive) {
            return directives.concat(directive);
          }, []).map(function(directive) {
            return directive.name.value;
          });
          return directiveNames;
        }
        function hasDirectives(names, doc) {
          return getDirectiveNames(doc).some(function(name) {
            return names.indexOf(name) > -1;
          });
        }
        var __assign$1 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        function getFragmentQueryDocument2(document2, fragmentName) {
          var actualFragmentName = fragmentName;
          var fragments = [];
          document2.definitions.forEach(function(definition) {
            if (definition.kind === "OperationDefinition") {
              throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : "") + ". No operations are allowed when using a fragment as a query. Only fragments are allowed.");
            }
            if (definition.kind === "FragmentDefinition") {
              fragments.push(definition);
            }
          });
          if (typeof actualFragmentName === "undefined") {
            if (fragments.length !== 1) {
              throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
            }
            actualFragmentName = fragments[0].name.value;
          }
          var query = __assign$1({}, document2, { definitions: [
            {
              kind: "OperationDefinition",
              operation: "query",
              selectionSet: {
                kind: "SelectionSet",
                selections: [
                  {
                    kind: "FragmentSpread",
                    name: {
                      kind: "Name",
                      value: actualFragmentName
                    }
                  }
                ]
              }
            }
          ].concat(document2.definitions) });
          return query;
        }
        function assign2(target) {
          var sources = [];
          for (var _i = 1; _i < arguments.length; _i++) {
            sources[_i - 1] = arguments[_i];
          }
          sources.forEach(function(source) {
            if (typeof source === "undefined" || source === null) {
              return;
            }
            Object.keys(source).forEach(function(key) {
              target[key] = source[key];
            });
          });
          return target;
        }
        function getMutationDefinition(doc) {
          checkDocument2(doc);
          var mutationDef = doc.definitions.filter(function(definition) {
            return definition.kind === "OperationDefinition" && definition.operation === "mutation";
          })[0];
          if (!mutationDef) {
            throw new Error("Must contain a mutation definition.");
          }
          return mutationDef;
        }
        function checkDocument2(doc) {
          if (doc.kind !== "Document") {
            throw new Error('Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql');
          }
          var operations = doc.definitions.filter(function(d) {
            return d.kind !== "FragmentDefinition";
          }).map(function(definition) {
            if (definition.kind !== "OperationDefinition") {
              throw new Error('Schema type definitions not allowed in queries. Found: "' + definition.kind + '"');
            }
            return definition;
          });
          if (operations.length > 1) {
            throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
          }
        }
        function getOperationDefinition2(doc) {
          checkDocument2(doc);
          return doc.definitions.filter(function(definition) {
            return definition.kind === "OperationDefinition";
          })[0];
        }
        function getOperationDefinitionOrDie2(document2) {
          var def = getOperationDefinition2(document2);
          if (!def) {
            throw new Error("GraphQL document is missing an operation");
          }
          return def;
        }
        function getOperationName3(doc) {
          return doc.definitions.filter(function(definition) {
            return definition.kind === "OperationDefinition" && definition.name;
          }).map(function(x) {
            return x.name.value;
          })[0] || null;
        }
        function getFragmentDefinitions2(doc) {
          return doc.definitions.filter(function(definition) {
            return definition.kind === "FragmentDefinition";
          });
        }
        function getQueryDefinition2(doc) {
          var queryDef = getOperationDefinition2(doc);
          if (!queryDef || queryDef.operation !== "query") {
            throw new Error("Must contain a query definition.");
          }
          return queryDef;
        }
        function getFragmentDefinition(doc) {
          if (doc.kind !== "Document") {
            throw new Error('Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql');
          }
          if (doc.definitions.length > 1) {
            throw new Error("Fragment must have exactly one definition.");
          }
          var fragmentDef = doc.definitions[0];
          if (fragmentDef.kind !== "FragmentDefinition") {
            throw new Error("Must be a fragment definition.");
          }
          return fragmentDef;
        }
        function getMainDefinition2(queryDoc) {
          checkDocument2(queryDoc);
          var fragmentDefinition;
          for (var _i = 0, _a4 = queryDoc.definitions; _i < _a4.length; _i++) {
            var definition = _a4[_i];
            if (definition.kind === "OperationDefinition") {
              var operation = definition.operation;
              if (operation === "query" || operation === "mutation" || operation === "subscription") {
                return definition;
              }
            }
            if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
              fragmentDefinition = definition;
            }
          }
          if (fragmentDefinition) {
            return fragmentDefinition;
          }
          throw new Error("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.");
        }
        function createFragmentMap2(fragments) {
          if (fragments === void 0) {
            fragments = [];
          }
          var symTable = {};
          fragments.forEach(function(fragment) {
            symTable[fragment.name.value] = fragment;
          });
          return symTable;
        }
        function getDefaultValues2(definition) {
          if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
            var defaultValues = definition.variableDefinitions.filter(function(_a4) {
              var defaultValue = _a4.defaultValue;
              return defaultValue;
            }).map(function(_a4) {
              var variable = _a4.variable, defaultValue = _a4.defaultValue;
              var defaultValueObj = {};
              valueToObjectRepresentation2(defaultValueObj, variable.name, defaultValue);
              return defaultValueObj;
            });
            return assign2.apply(void 0, [{}].concat(defaultValues));
          }
          return {};
        }
        function variablesInOperation(operation) {
          var names = /* @__PURE__ */ new Set();
          if (operation.variableDefinitions) {
            for (var _i = 0, _a4 = operation.variableDefinitions; _i < _a4.length; _i++) {
              var definition = _a4[_i];
              names.add(definition.variable.name.value);
            }
          }
          return names;
        }
        function cloneDeep2(value) {
          if (Array.isArray(value)) {
            return value.map(function(item) {
              return cloneDeep2(item);
            });
          }
          if (value !== null && typeof value === "object") {
            var nextValue = {};
            for (var key in value) {
              if (value.hasOwnProperty(key)) {
                nextValue[key] = cloneDeep2(value[key]);
              }
            }
            return nextValue;
          }
          return value;
        }
        var TYPENAME_FIELD2 = {
          kind: "Field",
          name: {
            kind: "Name",
            value: "__typename"
          }
        };
        function isNotEmpty(op, fragments) {
          return op.selectionSet.selections.filter(function(selectionSet) {
            return !(selectionSet && // look into fragments to verify they should stay
            selectionSet.kind === "FragmentSpread" && // see if the fragment in the map is valid (recursively)
            !isNotEmpty(fragments[selectionSet.name.value], fragments));
          }).length > 0;
        }
        function getDirectiveMatcher(directives) {
          return function directiveMatcher(directive) {
            return directives.some(function(dir) {
              if (dir.name && dir.name === directive.name.value)
                return true;
              if (dir.test && dir.test(directive))
                return true;
              return false;
            });
          };
        }
        function addTypenameToSelectionSet2(selectionSet, isRoot) {
          if (isRoot === void 0) {
            isRoot = false;
          }
          if (selectionSet.selections) {
            if (!isRoot) {
              var alreadyHasThisField = selectionSet.selections.some(function(selection) {
                return selection.kind === "Field" && selection.name.value === "__typename";
              });
              if (!alreadyHasThisField) {
                selectionSet.selections.push(TYPENAME_FIELD2);
              }
            }
            selectionSet.selections.forEach(function(selection) {
              if (selection.kind === "Field") {
                if (selection.name.value.lastIndexOf("__", 0) !== 0 && selection.selectionSet) {
                  addTypenameToSelectionSet2(selection.selectionSet);
                }
              } else if (selection.kind === "InlineFragment") {
                if (selection.selectionSet) {
                  addTypenameToSelectionSet2(selection.selectionSet);
                }
              }
            });
          }
        }
        function removeDirectivesFromSelectionSet(directives, selectionSet) {
          if (!selectionSet.selections)
            return selectionSet;
          var agressiveRemove = directives.some(function(dir) {
            return dir.remove;
          });
          selectionSet.selections = selectionSet.selections.map(function(selection) {
            if (selection.kind !== "Field" || !selection || !selection.directives)
              return selection;
            var directiveMatcher = getDirectiveMatcher(directives);
            var remove;
            selection.directives = selection.directives.filter(function(directive) {
              var shouldKeep = !directiveMatcher(directive);
              if (!remove && !shouldKeep && agressiveRemove)
                remove = true;
              return shouldKeep;
            });
            return remove ? null : selection;
          }).filter(function(x) {
            return !!x;
          });
          selectionSet.selections.forEach(function(selection) {
            if ((selection.kind === "Field" || selection.kind === "InlineFragment") && selection.selectionSet) {
              removeDirectivesFromSelectionSet(directives, selection.selectionSet);
            }
          });
          return selectionSet;
        }
        function removeDirectivesFromDocument(directives, doc) {
          var docClone = cloneDeep2(doc);
          docClone.definitions.forEach(function(definition) {
            removeDirectivesFromSelectionSet(directives, definition.selectionSet);
          });
          var operation = getOperationDefinitionOrDie2(docClone);
          var fragments = createFragmentMap2(getFragmentDefinitions2(docClone));
          return isNotEmpty(operation, fragments) ? docClone : null;
        }
        function addTypenameToDocument2(doc) {
          checkDocument2(doc);
          var docClone = cloneDeep2(doc);
          docClone.definitions.forEach(function(definition) {
            var isRoot = definition.kind === "OperationDefinition";
            addTypenameToSelectionSet2(definition.selectionSet, isRoot);
          });
          return docClone;
        }
        var connectionRemoveConfig = {
          test: function(directive) {
            var willRemove = directive.name.value === "connection";
            if (willRemove) {
              if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
              })) {
                console.warn("Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key.");
              }
            }
            return willRemove;
          }
        };
        function removeConnectionDirectiveFromDocument(doc) {
          checkDocument2(doc);
          return removeDirectivesFromDocument([connectionRemoveConfig], doc);
        }
        function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
          if (nestedCheck === void 0) {
            nestedCheck = true;
          }
          if (!(selectionSet && selectionSet.selections)) {
            return false;
          }
          var matchedSelections = selectionSet.selections.filter(function(selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
          });
          return matchedSelections.length > 0;
        }
        function hasDirectivesInSelection(directives, selection, nestedCheck) {
          if (nestedCheck === void 0) {
            nestedCheck = true;
          }
          if (selection.kind !== "Field" || !selection) {
            return true;
          }
          if (!selection.directives) {
            return false;
          }
          var directiveMatcher = getDirectiveMatcher(directives);
          var matchedDirectives = selection.directives.filter(directiveMatcher);
          return matchedDirectives.length > 0 || nestedCheck && hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
        }
        function getDirectivesFromSelectionSet(directives, selectionSet) {
          selectionSet.selections = selectionSet.selections.filter(function(selection) {
            return hasDirectivesInSelection(directives, selection, true);
          }).map(function(selection) {
            if (hasDirectivesInSelection(directives, selection, false)) {
              return selection;
            }
            if ((selection.kind === "Field" || selection.kind === "InlineFragment") && selection.selectionSet) {
              selection.selectionSet = getDirectivesFromSelectionSet(directives, selection.selectionSet);
            }
            return selection;
          });
          return selectionSet;
        }
        function getDirectivesFromDocument(directives, doc, includeAllFragments) {
          if (includeAllFragments === void 0) {
            includeAllFragments = false;
          }
          checkDocument2(doc);
          var docClone = cloneDeep2(doc);
          docClone.definitions = docClone.definitions.map(function(definition) {
            if ((definition.kind === "OperationDefinition" || definition.kind === "FragmentDefinition" && !includeAllFragments) && definition.selectionSet) {
              definition.selectionSet = getDirectivesFromSelectionSet(directives, definition.selectionSet);
            }
            return definition;
          });
          var operation = getOperationDefinitionOrDie2(docClone);
          var fragments = createFragmentMap2(getFragmentDefinitions2(docClone));
          return isNotEmpty(operation, fragments) ? docClone : null;
        }
        function getEnv2() {
          if (typeof process !== "undefined" && "production") {
            return "production";
          }
          return "development";
        }
        function isEnv2(env) {
          return getEnv2() === env;
        }
        function isProduction2() {
          return isEnv2("production") === true;
        }
        function isDevelopment() {
          return isEnv2("development") === true;
        }
        function isTest2() {
          return isEnv2("test") === true;
        }
        function tryFunctionOrLogError(f) {
          try {
            return f();
          } catch (e) {
            if (console.error) {
              console.error(e);
            }
          }
        }
        function graphQLResultHasError(result) {
          return result.errors && result.errors.length;
        }
        function isEqual3(a, b) {
          if (a === b) {
            return true;
          }
          if (a instanceof Date && b instanceof Date) {
            return a.getTime() === b.getTime();
          }
          if (a != null && typeof a === "object" && b != null && typeof b === "object") {
            for (var key in a) {
              if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                  return false;
                }
                if (!isEqual3(a[key], b[key])) {
                  return false;
                }
              }
            }
            for (var key in b) {
              if (!Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
              }
            }
            return true;
          }
          return false;
        }
        function deepFreeze(o) {
          Object.freeze(o);
          Object.getOwnPropertyNames(o).forEach(function(prop2) {
            if (o[prop2] !== null && (typeof o[prop2] === "object" || typeof o[prop2] === "function") && !Object.isFrozen(o[prop2])) {
              deepFreeze(o[prop2]);
            }
          });
          return o;
        }
        function maybeDeepFreeze(obj) {
          if (isDevelopment() || isTest2()) {
            var symbolIsPolyfilled = typeof Symbol === "function" && typeof Symbol("") === "string";
            if (!symbolIsPolyfilled) {
              return deepFreeze(obj);
            }
          }
          return obj;
        }
        var haveWarned3 = /* @__PURE__ */ Object.create({});
        function warnOnceInDevelopment2(msg, type) {
          if (type === void 0) {
            type = "warn";
          }
          if (isProduction2()) {
            return;
          }
          if (!haveWarned3[msg]) {
            if (!isTest2()) {
              haveWarned3[msg] = true;
            }
            switch (type) {
              case "error":
                console.error(msg);
                break;
              default:
                console.warn(msg);
            }
          }
        }
        function stripSymbols(data) {
          return JSON.parse(JSON.stringify(data));
        }
        exports2.getDirectiveInfoFromField = getDirectiveInfoFromField2;
        exports2.shouldInclude = shouldInclude2;
        exports2.flattenSelections = flattenSelections;
        exports2.getDirectiveNames = getDirectiveNames;
        exports2.hasDirectives = hasDirectives;
        exports2.getFragmentQueryDocument = getFragmentQueryDocument2;
        exports2.getMutationDefinition = getMutationDefinition;
        exports2.checkDocument = checkDocument2;
        exports2.getOperationDefinition = getOperationDefinition2;
        exports2.getOperationDefinitionOrDie = getOperationDefinitionOrDie2;
        exports2.getOperationName = getOperationName3;
        exports2.getFragmentDefinitions = getFragmentDefinitions2;
        exports2.getQueryDefinition = getQueryDefinition2;
        exports2.getFragmentDefinition = getFragmentDefinition;
        exports2.getMainDefinition = getMainDefinition2;
        exports2.createFragmentMap = createFragmentMap2;
        exports2.getDefaultValues = getDefaultValues2;
        exports2.variablesInOperation = variablesInOperation;
        exports2.removeDirectivesFromDocument = removeDirectivesFromDocument;
        exports2.addTypenameToDocument = addTypenameToDocument2;
        exports2.removeConnectionDirectiveFromDocument = removeConnectionDirectiveFromDocument;
        exports2.getDirectivesFromDocument = getDirectivesFromDocument;
        exports2.isScalarValue = isScalarValue;
        exports2.isNumberValue = isNumberValue;
        exports2.valueToObjectRepresentation = valueToObjectRepresentation2;
        exports2.storeKeyNameFromField = storeKeyNameFromField2;
        exports2.getStoreKeyName = getStoreKeyName2;
        exports2.argumentsObjectFromField = argumentsObjectFromField2;
        exports2.resultKeyNameFromField = resultKeyNameFromField2;
        exports2.isField = isField2;
        exports2.isInlineFragment = isInlineFragment2;
        exports2.isIdValue = isIdValue2;
        exports2.toIdValue = toIdValue2;
        exports2.isJsonValue = isJsonValue2;
        exports2.valueFromNode = valueFromNode;
        exports2.assign = assign2;
        exports2.cloneDeep = cloneDeep2;
        exports2.getEnv = getEnv2;
        exports2.isEnv = isEnv2;
        exports2.isProduction = isProduction2;
        exports2.isDevelopment = isDevelopment;
        exports2.isTest = isTest2;
        exports2.tryFunctionOrLogError = tryFunctionOrLogError;
        exports2.graphQLResultHasError = graphQLResultHasError;
        exports2.isEqual = isEqual3;
        exports2.maybeDeepFreeze = maybeDeepFreeze;
        exports2.warnOnceInDevelopment = warnOnceInDevelopment2;
        exports2.stripSymbols = stripSymbols;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/zen-observable/lib/Observable.js
  var require_Observable = __commonJS({
    "node_modules/zen-observable/lib/Observable.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _createClass = function() {
        function defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor)
              descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }
        return function(Constructor, protoProps, staticProps) {
          if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
          if (staticProps)
            defineProperties(Constructor, staticProps);
          return Constructor;
        };
      }();
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      var hasSymbols = function() {
        return typeof Symbol === "function";
      };
      var hasSymbol = function(name) {
        return hasSymbols() && Boolean(Symbol[name]);
      };
      var getSymbol = function(name) {
        return hasSymbol(name) ? Symbol[name] : "@@" + name;
      };
      if (hasSymbols() && !hasSymbol("observable")) {
        Symbol.observable = Symbol("observable");
      }
      function getMethod(obj, key) {
        var value = obj[key];
        if (value == null)
          return void 0;
        if (typeof value !== "function")
          throw new TypeError(value + " is not a function");
        return value;
      }
      function getSpecies(obj) {
        var ctor = obj.constructor;
        if (ctor !== void 0) {
          ctor = ctor[getSymbol("species")];
          if (ctor === null) {
            ctor = void 0;
          }
        }
        return ctor !== void 0 ? ctor : Observable5;
      }
      function isObservable(x) {
        return x instanceof Observable5;
      }
      function hostReportError(e) {
        if (hostReportError.log) {
          hostReportError.log(e);
        } else {
          setTimeout(function() {
            throw e;
          });
        }
      }
      function enqueue(fn) {
        Promise.resolve().then(function() {
          try {
            fn();
          } catch (e) {
            hostReportError(e);
          }
        });
      }
      function cleanupSubscription(subscription) {
        var cleanup = subscription._cleanup;
        if (cleanup === void 0)
          return;
        subscription._cleanup = void 0;
        if (!cleanup) {
          return;
        }
        try {
          if (typeof cleanup === "function") {
            cleanup();
          } else {
            var unsubscribe = getMethod(cleanup, "unsubscribe");
            if (unsubscribe) {
              unsubscribe.call(cleanup);
            }
          }
        } catch (e) {
          hostReportError(e);
        }
      }
      function closeSubscription(subscription) {
        subscription._observer = void 0;
        subscription._queue = void 0;
        subscription._state = "closed";
      }
      function flushSubscription(subscription) {
        var queue = subscription._queue;
        if (!queue) {
          return;
        }
        subscription._queue = void 0;
        subscription._state = "ready";
        for (var i = 0; i < queue.length; ++i) {
          notifySubscription(subscription, queue[i].type, queue[i].value);
          if (subscription._state === "closed")
            break;
        }
      }
      function notifySubscription(subscription, type, value) {
        subscription._state = "running";
        var observer = subscription._observer;
        try {
          var m = getMethod(observer, type);
          switch (type) {
            case "next":
              if (m)
                m.call(observer, value);
              break;
            case "error":
              closeSubscription(subscription);
              if (m)
                m.call(observer, value);
              else
                throw value;
              break;
            case "complete":
              closeSubscription(subscription);
              if (m)
                m.call(observer);
              break;
          }
        } catch (e) {
          hostReportError(e);
        }
        if (subscription._state === "closed")
          cleanupSubscription(subscription);
        else if (subscription._state === "running")
          subscription._state = "ready";
      }
      function onNotify(subscription, type, value) {
        if (subscription._state === "closed")
          return;
        if (subscription._state === "buffering") {
          subscription._queue.push({ type, value });
          return;
        }
        if (subscription._state !== "ready") {
          subscription._state = "buffering";
          subscription._queue = [{ type, value }];
          enqueue(function() {
            return flushSubscription(subscription);
          });
          return;
        }
        notifySubscription(subscription, type, value);
      }
      var Subscription = function() {
        function Subscription2(observer, subscriber) {
          _classCallCheck(this, Subscription2);
          this._cleanup = void 0;
          this._observer = observer;
          this._queue = void 0;
          this._state = "initializing";
          var subscriptionObserver = new SubscriptionObserver(this);
          try {
            this._cleanup = subscriber.call(void 0, subscriptionObserver);
          } catch (e) {
            subscriptionObserver.error(e);
          }
          if (this._state === "initializing")
            this._state = "ready";
        }
        _createClass(Subscription2, [{
          key: "unsubscribe",
          value: function unsubscribe() {
            if (this._state !== "closed") {
              closeSubscription(this);
              cleanupSubscription(this);
            }
          }
        }, {
          key: "closed",
          get: function() {
            return this._state === "closed";
          }
        }]);
        return Subscription2;
      }();
      var SubscriptionObserver = function() {
        function SubscriptionObserver2(subscription) {
          _classCallCheck(this, SubscriptionObserver2);
          this._subscription = subscription;
        }
        _createClass(SubscriptionObserver2, [{
          key: "next",
          value: function next(value) {
            onNotify(this._subscription, "next", value);
          }
        }, {
          key: "error",
          value: function error(value) {
            onNotify(this._subscription, "error", value);
          }
        }, {
          key: "complete",
          value: function complete() {
            onNotify(this._subscription, "complete");
          }
        }, {
          key: "closed",
          get: function() {
            return this._subscription._state === "closed";
          }
        }]);
        return SubscriptionObserver2;
      }();
      var Observable5 = exports.Observable = function() {
        function Observable6(subscriber) {
          _classCallCheck(this, Observable6);
          if (!(this instanceof Observable6))
            throw new TypeError("Observable cannot be called as a function");
          if (typeof subscriber !== "function")
            throw new TypeError("Observable initializer must be a function");
          this._subscriber = subscriber;
        }
        _createClass(Observable6, [{
          key: "subscribe",
          value: function subscribe(observer) {
            if (typeof observer !== "object" || observer === null) {
              observer = {
                next: observer,
                error: arguments[1],
                complete: arguments[2]
              };
            }
            return new Subscription(observer, this._subscriber);
          }
        }, {
          key: "forEach",
          value: function forEach(fn) {
            var _this = this;
            return new Promise(function(resolve2, reject2) {
              if (typeof fn !== "function") {
                reject2(new TypeError(fn + " is not a function"));
                return;
              }
              function done() {
                subscription.unsubscribe();
                resolve2();
              }
              var subscription = _this.subscribe({
                next: function(value) {
                  try {
                    fn(value, done);
                  } catch (e) {
                    reject2(e);
                    subscription.unsubscribe();
                  }
                },
                error: reject2,
                complete: resolve2
              });
            });
          }
        }, {
          key: "map",
          value: function map2(fn) {
            var _this2 = this;
            if (typeof fn !== "function")
              throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
              return _this2.subscribe({
                next: function(value) {
                  try {
                    value = fn(value);
                  } catch (e) {
                    return observer.error(e);
                  }
                  observer.next(value);
                },
                error: function(e) {
                  observer.error(e);
                },
                complete: function() {
                  observer.complete();
                }
              });
            });
          }
        }, {
          key: "filter",
          value: function filter2(fn) {
            var _this3 = this;
            if (typeof fn !== "function")
              throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
              return _this3.subscribe({
                next: function(value) {
                  try {
                    if (!fn(value))
                      return;
                  } catch (e) {
                    return observer.error(e);
                  }
                  observer.next(value);
                },
                error: function(e) {
                  observer.error(e);
                },
                complete: function() {
                  observer.complete();
                }
              });
            });
          }
        }, {
          key: "reduce",
          value: function reduce2(fn) {
            var _this4 = this;
            if (typeof fn !== "function")
              throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            var hasSeed = arguments.length > 1;
            var hasValue = false;
            var seed = arguments[1];
            var acc = seed;
            return new C(function(observer) {
              return _this4.subscribe({
                next: function(value) {
                  var first2 = !hasValue;
                  hasValue = true;
                  if (!first2 || hasSeed) {
                    try {
                      acc = fn(acc, value);
                    } catch (e) {
                      return observer.error(e);
                    }
                  } else {
                    acc = value;
                  }
                },
                error: function(e) {
                  observer.error(e);
                },
                complete: function() {
                  if (!hasValue && !hasSeed)
                    return observer.error(new TypeError("Cannot reduce an empty sequence"));
                  observer.next(acc);
                  observer.complete();
                }
              });
            });
          }
        }, {
          key: "concat",
          value: function concat4() {
            var _this5 = this;
            for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
              sources[_key] = arguments[_key];
            }
            var C = getSpecies(this);
            return new C(function(observer) {
              var subscription = void 0;
              function startNext(next) {
                subscription = next.subscribe({
                  next: function(v) {
                    observer.next(v);
                  },
                  error: function(e) {
                    observer.error(e);
                  },
                  complete: function() {
                    if (sources.length === 0) {
                      subscription = void 0;
                      observer.complete();
                    } else {
                      startNext(C.from(sources.shift()));
                    }
                  }
                });
              }
              startNext(_this5);
              return function() {
                if (subscription) {
                  subscription = void 0;
                  subscription.unsubscribe();
                }
              };
            });
          }
        }, {
          key: "flatMap",
          value: function flatMap2(fn) {
            var _this6 = this;
            if (typeof fn !== "function")
              throw new TypeError(fn + " is not a function");
            var C = getSpecies(this);
            return new C(function(observer) {
              var subscriptions = [];
              var outer = _this6.subscribe({
                next: function(value) {
                  if (fn) {
                    try {
                      value = fn(value);
                    } catch (e) {
                      return observer.error(e);
                    }
                  }
                  var inner = C.from(value).subscribe({
                    next: function(value2) {
                      observer.next(value2);
                    },
                    error: function(e) {
                      observer.error(e);
                    },
                    complete: function() {
                      var i = subscriptions.indexOf(inner);
                      if (i >= 0)
                        subscriptions.splice(i, 1);
                      completeIfDone();
                    }
                  });
                  subscriptions.push(inner);
                },
                error: function(e) {
                  observer.error(e);
                },
                complete: function() {
                  completeIfDone();
                }
              });
              function completeIfDone() {
                if (outer.closed && subscriptions.length === 0)
                  observer.complete();
              }
              return function() {
                subscriptions.forEach(function(s) {
                  return s.unsubscribe();
                });
                outer.unsubscribe();
              };
            });
          }
        }, {
          key: getSymbol("observable"),
          value: function() {
            return this;
          }
        }], [{
          key: "from",
          value: function from3(x) {
            var C = typeof this === "function" ? this : Observable6;
            if (x == null)
              throw new TypeError(x + " is not an object");
            var method = getMethod(x, getSymbol("observable"));
            if (method) {
              var observable = method.call(x);
              if (Object(observable) !== observable)
                throw new TypeError(observable + " is not an object");
              if (isObservable(observable) && observable.constructor === C)
                return observable;
              return new C(function(observer) {
                return observable.subscribe(observer);
              });
            }
            if (hasSymbol("iterator")) {
              method = getMethod(x, getSymbol("iterator"));
              if (method) {
                return new C(function(observer) {
                  enqueue(function() {
                    if (observer.closed)
                      return;
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = void 0;
                    try {
                      for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed)
                          return;
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }
                    observer.complete();
                  });
                });
              }
            }
            if (Array.isArray(x)) {
              return new C(function(observer) {
                enqueue(function() {
                  if (observer.closed)
                    return;
                  for (var i = 0; i < x.length; ++i) {
                    observer.next(x[i]);
                    if (observer.closed)
                      return;
                  }
                  observer.complete();
                });
              });
            }
            throw new TypeError(x + " is not observable");
          }
        }, {
          key: "of",
          value: function of() {
            for (var _len2 = arguments.length, items = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              items[_key2] = arguments[_key2];
            }
            var C = typeof this === "function" ? this : Observable6;
            return new C(function(observer) {
              enqueue(function() {
                if (observer.closed)
                  return;
                for (var i = 0; i < items.length; ++i) {
                  observer.next(items[i]);
                  if (observer.closed)
                    return;
                }
                observer.complete();
              });
            });
          }
        }, {
          key: getSymbol("species"),
          get: function() {
            return this;
          }
        }]);
        return Observable6;
      }();
      if (hasSymbols()) {
        Object.defineProperty(Observable5, Symbol("extensions"), {
          value: {
            symbol: getSymbol("observable"),
            hostReportError
          },
          configurabe: true
        });
      }
    }
  });

  // node_modules/zen-observable/index.js
  var require_zen_observable = __commonJS({
    "node_modules/zen-observable/index.js"(exports, module) {
      module.exports = require_Observable().Observable;
    }
  });

  // node_modules/zen-observable-ts/lib/bundle.umd.js
  var require_bundle_umd2 = __commonJS({
    "node_modules/zen-observable-ts/lib/bundle.umd.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require_zen_observable()) : typeof define === "function" && define.amd ? define(["exports", "zen-observable"], factory) : factory((global2.apolloLink = global2.apolloLink || {}, global2.apolloLink.zenObservable = {}), global2.Observable);
      })(exports, function(exports2, zenObservable3) {
        "use strict";
        zenObservable3 = zenObservable3 && zenObservable3.hasOwnProperty("default") ? zenObservable3["default"] : zenObservable3;
        var Observable5 = zenObservable3;
        exports2.default = Observable5;
        exports2.Observable = Observable5;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/graphql/language/visitor.js
  var require_visitor = __commonJS({
    "node_modules/graphql/language/visitor.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.visit = visit3;
      exports.visitInParallel = visitInParallel;
      exports.visitWithTypeInfo = visitWithTypeInfo;
      exports.getVisitFn = getVisitFn;
      var QueryDocumentKeys2 = exports.QueryDocumentKeys = {
        Name: [],
        Document: ["definitions"],
        OperationDefinition: ["name", "variableDefinitions", "directives", "selectionSet"],
        VariableDefinition: ["variable", "type", "defaultValue"],
        Variable: ["name"],
        SelectionSet: ["selections"],
        Field: ["alias", "name", "arguments", "directives", "selectionSet"],
        Argument: ["name", "value"],
        FragmentSpread: ["name", "directives"],
        InlineFragment: ["typeCondition", "directives", "selectionSet"],
        FragmentDefinition: [
          "name",
          // Note: fragment variable definitions are experimental and may be changed
          // or removed in the future.
          "variableDefinitions",
          "typeCondition",
          "directives",
          "selectionSet"
        ],
        IntValue: [],
        FloatValue: [],
        StringValue: [],
        BooleanValue: [],
        NullValue: [],
        EnumValue: [],
        ListValue: ["values"],
        ObjectValue: ["fields"],
        ObjectField: ["name", "value"],
        Directive: ["name", "arguments"],
        NamedType: ["name"],
        ListType: ["type"],
        NonNullType: ["type"],
        SchemaDefinition: ["directives", "operationTypes"],
        OperationTypeDefinition: ["type"],
        ScalarTypeDefinition: ["description", "name", "directives"],
        ObjectTypeDefinition: ["description", "name", "interfaces", "directives", "fields"],
        FieldDefinition: ["description", "name", "arguments", "type", "directives"],
        InputValueDefinition: ["description", "name", "type", "defaultValue", "directives"],
        InterfaceTypeDefinition: ["description", "name", "directives", "fields"],
        UnionTypeDefinition: ["description", "name", "directives", "types"],
        EnumTypeDefinition: ["description", "name", "directives", "values"],
        EnumValueDefinition: ["description", "name", "directives"],
        InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
        ScalarTypeExtension: ["name", "directives"],
        ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
        InterfaceTypeExtension: ["name", "directives", "fields"],
        UnionTypeExtension: ["name", "directives", "types"],
        EnumTypeExtension: ["name", "directives", "values"],
        InputObjectTypeExtension: ["name", "directives", "fields"],
        DirectiveDefinition: ["description", "name", "arguments", "locations"]
      };
      var BREAK = exports.BREAK = {};
      function visit3(root, visitor) {
        var visitorKeys = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : QueryDocumentKeys2;
        var stack = void 0;
        var inArray = Array.isArray(root);
        var keys = [root];
        var index = -1;
        var edits = [];
        var node = void 0;
        var key = void 0;
        var parent = void 0;
        var path = [];
        var ancestors = [];
        var newRoot = root;
        do {
          index++;
          var isLeaving = index === keys.length;
          var isEdited = isLeaving && edits.length !== 0;
          if (isLeaving) {
            key = ancestors.length === 0 ? void 0 : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
              if (inArray) {
                node = node.slice();
              } else {
                var clone = {};
                for (var k in node) {
                  if (node.hasOwnProperty(k)) {
                    clone[k] = node[k];
                  }
                }
                node = clone;
              }
              var editOffset = 0;
              for (var ii = 0; ii < edits.length; ii++) {
                var editKey = edits[ii][0];
                var editValue = edits[ii][1];
                if (inArray) {
                  editKey -= editOffset;
                }
                if (inArray && editValue === null) {
                  node.splice(editKey, 1);
                  editOffset++;
                } else {
                  node[editKey] = editValue;
                }
              }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
          } else {
            key = parent ? inArray ? index : keys[index] : void 0;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === void 0) {
              continue;
            }
            if (parent) {
              path.push(key);
            }
          }
          var result = void 0;
          if (!Array.isArray(node)) {
            if (!isNode(node)) {
              throw new Error("Invalid AST Node: " + JSON.stringify(node));
            }
            var visitFn = getVisitFn(visitor, node.kind, isLeaving);
            if (visitFn) {
              result = visitFn.call(visitor, node, key, parent, path, ancestors);
              if (result === BREAK) {
                break;
              }
              if (result === false) {
                if (!isLeaving) {
                  path.pop();
                  continue;
                }
              } else if (result !== void 0) {
                edits.push([key, result]);
                if (!isLeaving) {
                  if (isNode(result)) {
                    node = result;
                  } else {
                    path.pop();
                    continue;
                  }
                }
              }
            }
          }
          if (result === void 0 && isEdited) {
            edits.push([key, node]);
          }
          if (isLeaving) {
            path.pop();
          } else {
            stack = { inArray, index, keys, edits, prev: stack };
            inArray = Array.isArray(node);
            keys = inArray ? node : visitorKeys[node.kind] || [];
            index = -1;
            edits = [];
            if (parent) {
              ancestors.push(parent);
            }
            parent = node;
          }
        } while (stack !== void 0);
        if (edits.length !== 0) {
          newRoot = edits[edits.length - 1][1];
        }
        return newRoot;
      }
      function isNode(maybeNode) {
        return Boolean(maybeNode && typeof maybeNode.kind === "string");
      }
      function visitInParallel(visitors) {
        var skipping = new Array(visitors.length);
        return {
          enter: function enter(node) {
            for (var i = 0; i < visitors.length; i++) {
              if (!skipping[i]) {
                var fn = getVisitFn(
                  visitors[i],
                  node.kind,
                  /* isLeaving */
                  false
                );
                if (fn) {
                  var result = fn.apply(visitors[i], arguments);
                  if (result === false) {
                    skipping[i] = node;
                  } else if (result === BREAK) {
                    skipping[i] = BREAK;
                  } else if (result !== void 0) {
                    return result;
                  }
                }
              }
            }
          },
          leave: function leave(node) {
            for (var i = 0; i < visitors.length; i++) {
              if (!skipping[i]) {
                var fn = getVisitFn(
                  visitors[i],
                  node.kind,
                  /* isLeaving */
                  true
                );
                if (fn) {
                  var result = fn.apply(visitors[i], arguments);
                  if (result === BREAK) {
                    skipping[i] = BREAK;
                  } else if (result !== void 0 && result !== false) {
                    return result;
                  }
                }
              } else if (skipping[i] === node) {
                skipping[i] = null;
              }
            }
          }
        };
      }
      function visitWithTypeInfo(typeInfo, visitor) {
        return {
          enter: function enter(node) {
            typeInfo.enter(node);
            var fn = getVisitFn(
              visitor,
              node.kind,
              /* isLeaving */
              false
            );
            if (fn) {
              var result = fn.apply(visitor, arguments);
              if (result !== void 0) {
                typeInfo.leave(node);
                if (isNode(result)) {
                  typeInfo.enter(result);
                }
              }
              return result;
            }
          },
          leave: function leave(node) {
            var fn = getVisitFn(
              visitor,
              node.kind,
              /* isLeaving */
              true
            );
            var result = void 0;
            if (fn) {
              result = fn.apply(visitor, arguments);
            }
            typeInfo.leave(node);
            return result;
          }
        };
      }
      function getVisitFn(visitor, kind, isLeaving) {
        var kindVisitor = visitor[kind];
        if (kindVisitor) {
          if (!isLeaving && typeof kindVisitor === "function") {
            return kindVisitor;
          }
          var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
          if (typeof kindSpecificVisitor === "function") {
            return kindSpecificVisitor;
          }
        } else {
          var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
          if (specificVisitor) {
            if (typeof specificVisitor === "function") {
              return specificVisitor;
            }
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === "function") {
              return specificKindVisitor;
            }
          }
        }
      }
    }
  });

  // node_modules/graphql/language/printer.js
  var require_printer = __commonJS({
    "node_modules/graphql/language/printer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.print = print3;
      var _visitor = require_visitor();
      function print3(ast) {
        return (0, _visitor.visit)(ast, { leave: printDocASTReducer });
      }
      var printDocASTReducer = {
        Name: function Name(node) {
          return node.value;
        },
        Variable: function Variable(node) {
          return "$" + node.name;
        },
        // Document
        Document: function Document(node) {
          return join(node.definitions, "\n\n") + "\n";
        },
        OperationDefinition: function OperationDefinition(node) {
          var op = node.operation;
          var name = node.name;
          var varDefs = wrap2("(", join(node.variableDefinitions, ", "), ")");
          var directives = join(node.directives, " ");
          var selectionSet = node.selectionSet;
          return !name && !directives && !varDefs && op === "query" ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], " ");
        },
        VariableDefinition: function VariableDefinition(_ref) {
          var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue;
          return variable + ": " + type + wrap2(" = ", defaultValue);
        },
        SelectionSet: function SelectionSet(_ref2) {
          var selections = _ref2.selections;
          return block(selections);
        },
        Field: function Field(_ref3) {
          var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
          return join([wrap2("", alias, ": ") + name + wrap2("(", join(args, ", "), ")"), join(directives, " "), selectionSet], " ");
        },
        Argument: function Argument(_ref4) {
          var name = _ref4.name, value = _ref4.value;
          return name + ": " + value;
        },
        // Fragments
        FragmentSpread: function FragmentSpread(_ref5) {
          var name = _ref5.name, directives = _ref5.directives;
          return "..." + name + wrap2(" ", join(directives, " "));
        },
        InlineFragment: function InlineFragment(_ref6) {
          var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
          return join(["...", wrap2("on ", typeCondition), join(directives, " "), selectionSet], " ");
        },
        FragmentDefinition: function FragmentDefinition(_ref7) {
          var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
          return (
            // Note: fragment variable definitions are experimental and may be changed
            // or removed in the future.
            "fragment " + name + wrap2("(", join(variableDefinitions, ", "), ")") + " " + ("on " + typeCondition + " " + wrap2("", join(directives, " "), " ")) + selectionSet
          );
        },
        // Value
        IntValue: function IntValue(_ref8) {
          var value = _ref8.value;
          return value;
        },
        FloatValue: function FloatValue(_ref9) {
          var value = _ref9.value;
          return value;
        },
        StringValue: function StringValue(_ref10, key) {
          var value = _ref10.value, isBlockString = _ref10.block;
          return isBlockString ? printBlockString(value, key === "description") : JSON.stringify(value);
        },
        BooleanValue: function BooleanValue(_ref11) {
          var value = _ref11.value;
          return value ? "true" : "false";
        },
        NullValue: function NullValue() {
          return "null";
        },
        EnumValue: function EnumValue(_ref12) {
          var value = _ref12.value;
          return value;
        },
        ListValue: function ListValue(_ref13) {
          var values2 = _ref13.values;
          return "[" + join(values2, ", ") + "]";
        },
        ObjectValue: function ObjectValue(_ref14) {
          var fields = _ref14.fields;
          return "{" + join(fields, ", ") + "}";
        },
        ObjectField: function ObjectField(_ref15) {
          var name = _ref15.name, value = _ref15.value;
          return name + ": " + value;
        },
        // Directive
        Directive: function Directive(_ref16) {
          var name = _ref16.name, args = _ref16.arguments;
          return "@" + name + wrap2("(", join(args, ", "), ")");
        },
        // Type
        NamedType: function NamedType(_ref17) {
          var name = _ref17.name;
          return name;
        },
        ListType: function ListType(_ref18) {
          var type = _ref18.type;
          return "[" + type + "]";
        },
        NonNullType: function NonNullType(_ref19) {
          var type = _ref19.type;
          return type + "!";
        },
        // Type System Definitions
        SchemaDefinition: function SchemaDefinition(_ref20) {
          var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
          return join(["schema", join(directives, " "), block(operationTypes)], " ");
        },
        OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
          var operation = _ref21.operation, type = _ref21.type;
          return operation + ": " + type;
        },
        ScalarTypeDefinition: addDescription(function(_ref22) {
          var name = _ref22.name, directives = _ref22.directives;
          return join(["scalar", name, join(directives, " ")], " ");
        }),
        ObjectTypeDefinition: addDescription(function(_ref23) {
          var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
          return join(["type", name, wrap2("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
        }),
        FieldDefinition: addDescription(function(_ref24) {
          var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
          return name + wrap2("(", join(args, ", "), ")") + ": " + type + wrap2(" ", join(directives, " "));
        }),
        InputValueDefinition: addDescription(function(_ref25) {
          var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
          return join([name + ": " + type, wrap2("= ", defaultValue), join(directives, " ")], " ");
        }),
        InterfaceTypeDefinition: addDescription(function(_ref26) {
          var name = _ref26.name, directives = _ref26.directives, fields = _ref26.fields;
          return join(["interface", name, join(directives, " "), block(fields)], " ");
        }),
        UnionTypeDefinition: addDescription(function(_ref27) {
          var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
          return join(["union", name, join(directives, " "), types && types.length !== 0 ? "= " + join(types, " | ") : ""], " ");
        }),
        EnumTypeDefinition: addDescription(function(_ref28) {
          var name = _ref28.name, directives = _ref28.directives, values2 = _ref28.values;
          return join(["enum", name, join(directives, " "), block(values2)], " ");
        }),
        EnumValueDefinition: addDescription(function(_ref29) {
          var name = _ref29.name, directives = _ref29.directives;
          return join([name, join(directives, " ")], " ");
        }),
        InputObjectTypeDefinition: addDescription(function(_ref30) {
          var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
          return join(["input", name, join(directives, " "), block(fields)], " ");
        }),
        ScalarTypeExtension: function ScalarTypeExtension(_ref31) {
          var name = _ref31.name, directives = _ref31.directives;
          return join(["extend scalar", name, join(directives, " ")], " ");
        },
        ObjectTypeExtension: function ObjectTypeExtension(_ref32) {
          var name = _ref32.name, interfaces = _ref32.interfaces, directives = _ref32.directives, fields = _ref32.fields;
          return join(["extend type", name, wrap2("implements ", join(interfaces, " & ")), join(directives, " "), block(fields)], " ");
        },
        InterfaceTypeExtension: function InterfaceTypeExtension(_ref33) {
          var name = _ref33.name, directives = _ref33.directives, fields = _ref33.fields;
          return join(["extend interface", name, join(directives, " "), block(fields)], " ");
        },
        UnionTypeExtension: function UnionTypeExtension(_ref34) {
          var name = _ref34.name, directives = _ref34.directives, types = _ref34.types;
          return join(["extend union", name, join(directives, " "), types && types.length !== 0 ? "= " + join(types, " | ") : ""], " ");
        },
        EnumTypeExtension: function EnumTypeExtension(_ref35) {
          var name = _ref35.name, directives = _ref35.directives, values2 = _ref35.values;
          return join(["extend enum", name, join(directives, " "), block(values2)], " ");
        },
        InputObjectTypeExtension: function InputObjectTypeExtension(_ref36) {
          var name = _ref36.name, directives = _ref36.directives, fields = _ref36.fields;
          return join(["extend input", name, join(directives, " "), block(fields)], " ");
        },
        DirectiveDefinition: addDescription(function(_ref37) {
          var name = _ref37.name, args = _ref37.arguments, locations = _ref37.locations;
          return "directive @" + name + wrap2("(", join(args, ", "), ")") + " on " + join(locations, " | ");
        })
      };
      function addDescription(cb) {
        return function(node) {
          return join([node.description, cb(node)], "\n");
        };
      }
      function join(maybeArray, separator) {
        return maybeArray ? maybeArray.filter(function(x) {
          return x;
        }).join(separator || "") : "";
      }
      function block(array) {
        return array && array.length !== 0 ? "{\n" + indent(join(array, "\n")) + "\n}" : "";
      }
      function wrap2(start, maybeString, end) {
        return maybeString ? start + maybeString + (end || "") : "";
      }
      function indent(maybeString) {
        return maybeString && "  " + maybeString.replace(/\n/g, "\n  ");
      }
      function printBlockString(value, isDescription) {
        var escaped = value.replace(/"""/g, '\\"""');
        return (value[0] === " " || value[0] === "	") && value.indexOf("\n") === -1 ? '"""' + escaped.replace(/"$/, '"\n') + '"""' : '"""\n' + (isDescription ? escaped : indent(escaped)) + '\n"""';
      }
    }
  });

  // node_modules/apollo-link/lib/bundle.umd.js
  var require_bundle_umd3 = __commonJS({
    "node_modules/apollo-link/lib/bundle.umd.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require_bundle_umd(), require_bundle_umd2(), require_printer()) : typeof define === "function" && define.amd ? define(["exports", "apollo-utilities", "zen-observable-ts", "graphql/language/printer"], factory) : factory((global2.apolloLink = global2.apolloLink || {}, global2.apolloLink.core = {}), global2.apollo.utilities, global2.apolloLink.zenObservable, global2.printer);
      })(exports, function(exports2, apolloUtilities, Observable5, printer) {
        "use strict";
        Observable5 = Observable5 && Observable5.hasOwnProperty("default") ? Observable5["default"] : Observable5;
        var __extends8 = function() {
          var extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
            d.__proto__ = b;
          } || function(d, b) {
            for (var p in b)
              if (b.hasOwnProperty(p))
                d[p] = b[p];
          };
          return function(d, b) {
            extendStatics4(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var __assign14 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        function validateOperation3(operation) {
          var OPERATION_FIELDS = [
            "query",
            "operationName",
            "variables",
            "extensions",
            "context"
          ];
          for (var _i = 0, _a4 = Object.keys(operation); _i < _a4.length; _i++) {
            var key = _a4[_i];
            if (OPERATION_FIELDS.indexOf(key) < 0) {
              throw new Error("illegal argument: " + key);
            }
          }
          return operation;
        }
        var LinkError3 = (
          /** @class */
          function(_super) {
            __extends8(LinkError4, _super);
            function LinkError4(message, link) {
              var _this = _super.call(this, message) || this;
              _this.link = link;
              return _this;
            }
            return LinkError4;
          }(Error)
        );
        function isTerminating3(link) {
          return link.request.length <= 1;
        }
        function toPromise(observable) {
          var completed = false;
          return new Promise(function(resolve2, reject2) {
            observable.subscribe({
              next: function(data) {
                if (completed) {
                  console.warn("Promise Wrapper does not support multiple results from Observable");
                } else {
                  completed = true;
                  resolve2(data);
                }
              },
              error: reject2
            });
          });
        }
        var makePromise = toPromise;
        function fromPromise(promise) {
          return new Observable5(function(observer) {
            promise.then(function(value) {
              observer.next(value);
              observer.complete();
            }).catch(observer.error.bind(observer));
          });
        }
        function fromError2(errorValue) {
          return new Observable5(function(observer) {
            observer.error(errorValue);
          });
        }
        function transformOperation3(operation) {
          var transformedOperation = {
            variables: operation.variables || {},
            extensions: operation.extensions || {},
            operationName: operation.operationName,
            query: operation.query
          };
          if (!transformedOperation.operationName) {
            transformedOperation.operationName = typeof transformedOperation.query !== "string" ? apolloUtilities.getOperationName(transformedOperation.query) : "";
          }
          return transformedOperation;
        }
        function createOperation3(starting, operation) {
          var context = __assign14({}, starting);
          var setContext = function(next) {
            if (typeof next === "function") {
              context = __assign14({}, context, next(context));
            } else {
              context = __assign14({}, context, next);
            }
          };
          var getContext = function() {
            return __assign14({}, context);
          };
          Object.defineProperty(operation, "setContext", {
            enumerable: false,
            value: setContext
          });
          Object.defineProperty(operation, "getContext", {
            enumerable: false,
            value: getContext
          });
          Object.defineProperty(operation, "toKey", {
            enumerable: false,
            value: function() {
              return getKey3(operation);
            }
          });
          return operation;
        }
        function getKey3(operation) {
          return printer.print(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
        }
        var passthrough3 = function(op, forward) {
          return forward ? forward(op) : Observable5.of();
        };
        var toLink3 = function(handler) {
          return typeof handler === "function" ? new ApolloLink6(handler) : handler;
        };
        var empty3 = function() {
          return new ApolloLink6(function(op, forward) {
            return Observable5.of();
          });
        };
        var from3 = function(links) {
          if (links.length === 0)
            return empty3();
          return links.map(toLink3).reduce(function(x, y) {
            return x.concat(y);
          });
        };
        var split4 = function(test2, left, right) {
          if (right === void 0) {
            right = new ApolloLink6(passthrough3);
          }
          var leftLink = toLink3(left);
          var rightLink = toLink3(right);
          if (isTerminating3(leftLink) && isTerminating3(rightLink)) {
            return new ApolloLink6(function(operation) {
              return test2(operation) ? leftLink.request(operation) || Observable5.of() : rightLink.request(operation) || Observable5.of();
            });
          } else {
            return new ApolloLink6(function(operation, forward) {
              return test2(operation) ? leftLink.request(operation, forward) || Observable5.of() : rightLink.request(operation, forward) || Observable5.of();
            });
          }
        };
        var concat4 = function(first2, second) {
          var firstLink = toLink3(first2);
          if (isTerminating3(firstLink)) {
            console.warn(new LinkError3("You are calling concat on a terminating link, which will have no effect", firstLink));
            return firstLink;
          }
          var nextLink = toLink3(second);
          if (isTerminating3(nextLink)) {
            return new ApolloLink6(function(operation) {
              return firstLink.request(operation, function(op) {
                return nextLink.request(op) || Observable5.of();
              }) || Observable5.of();
            });
          } else {
            return new ApolloLink6(function(operation, forward) {
              return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || Observable5.of();
              }) || Observable5.of();
            });
          }
        };
        var ApolloLink6 = (
          /** @class */
          function() {
            function ApolloLink7(request) {
              if (request)
                this.request = request;
            }
            ApolloLink7.prototype.split = function(test2, left, right) {
              if (right === void 0) {
                right = new ApolloLink7(passthrough3);
              }
              return this.concat(split4(test2, left, right));
            };
            ApolloLink7.prototype.concat = function(next) {
              return concat4(this, next);
            };
            ApolloLink7.prototype.request = function(operation, forward) {
              throw new Error("request is not implemented");
            };
            ApolloLink7.empty = empty3;
            ApolloLink7.from = from3;
            ApolloLink7.split = split4;
            ApolloLink7.execute = execute3;
            return ApolloLink7;
          }()
        );
        function execute3(link, operation) {
          return link.request(createOperation3(operation.context, transformOperation3(validateOperation3(operation)))) || Observable5.of();
        }
        exports2.Observable = Observable5;
        exports2.createOperation = createOperation3;
        exports2.makePromise = makePromise;
        exports2.toPromise = toPromise;
        exports2.fromPromise = fromPromise;
        exports2.fromError = fromError2;
        exports2.empty = empty3;
        exports2.from = from3;
        exports2.split = split4;
        exports2.concat = concat4;
        exports2.ApolloLink = ApolloLink6;
        exports2.execute = execute3;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/apollo-link-dedup/lib/bundle.umd.js
  var require_bundle_umd4 = __commonJS({
    "node_modules/apollo-link-dedup/lib/bundle.umd.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require_bundle_umd3()) : typeof define === "function" && define.amd ? define(["exports", "apollo-link"], factory) : factory((global2.apolloLink = global2.apolloLink || {}, global2.apolloLink.dedup = {}), global2.apolloLink.core);
      })(exports, function(exports2, apolloLink) {
        "use strict";
        var __extends8 = function() {
          var extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
            d.__proto__ = b;
          } || function(d, b) {
            for (var p in b)
              if (b.hasOwnProperty(p))
                d[p] = b[p];
          };
          return function(d, b) {
            extendStatics4(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var DedupLink = (
          /** @class */
          function(_super) {
            __extends8(DedupLink2, _super);
            function DedupLink2() {
              var _this = _super !== null && _super.apply(this, arguments) || this;
              _this.inFlightRequestObservables = /* @__PURE__ */ new Map();
              _this.subscribers = /* @__PURE__ */ new Map();
              return _this;
            }
            DedupLink2.prototype.request = function(operation, forward) {
              var _this = this;
              if (operation.getContext().forceFetch) {
                return forward(operation);
              }
              var key = operation.toKey();
              var cleanup = function(key2) {
                _this.inFlightRequestObservables.delete(key2);
                var prev = _this.subscribers.get(key2);
                return prev;
              };
              if (!this.inFlightRequestObservables.get(key)) {
                var singleObserver_1 = forward(operation);
                var subscription_1;
                var sharedObserver = new apolloLink.Observable(function(observer) {
                  var prev = _this.subscribers.get(key);
                  if (!prev)
                    prev = { next: [], error: [], complete: [] };
                  _this.subscribers.set(key, {
                    next: prev.next.concat([observer.next.bind(observer)]),
                    error: prev.error.concat([observer.error.bind(observer)]),
                    complete: prev.complete.concat([observer.complete.bind(observer)])
                  });
                  if (!subscription_1) {
                    subscription_1 = singleObserver_1.subscribe({
                      next: function(result) {
                        var prev2 = cleanup(key);
                        _this.subscribers.delete(key);
                        if (prev2) {
                          prev2.next.forEach(function(next) {
                            return next(result);
                          });
                          prev2.complete.forEach(function(complete) {
                            return complete();
                          });
                        }
                      },
                      error: function(error) {
                        var prev2 = cleanup(key);
                        _this.subscribers.delete(key);
                        if (prev2)
                          prev2.error.forEach(function(err) {
                            return err(error);
                          });
                      }
                    });
                  }
                  return function() {
                    if (subscription_1)
                      subscription_1.unsubscribe();
                    _this.inFlightRequestObservables.delete(key);
                  };
                });
                this.inFlightRequestObservables.set(key, sharedObserver);
              }
              return this.inFlightRequestObservables.get(key);
            };
            return DedupLink2;
          }(apolloLink.ApolloLink)
        );
        exports2.DedupLink = DedupLink;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/apollo-client/bundle.umd.js
  var require_bundle_umd5 = __commonJS({
    "node_modules/apollo-client/bundle.umd.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory(exports, require_bundle_umd3(), require_lib(), require_bundle_umd(), require_printer(), require_bundle_umd4()) : typeof define === "function" && define.amd ? define(["exports", "apollo-link", "symbol-observable", "apollo-utilities", "graphql/language/printer", "apollo-link-dedup"], factory) : factory((global2.apollo = global2.apollo || {}, global2.apollo.core = {}), global2.apolloLink.core, null, global2.apollo.utilities, null, global2.apolloLink.dedup);
      })(exports, function(exports2, apolloLink, $$observable, apolloUtilities, printer, apolloLinkDedup) {
        "use strict";
        $$observable = $$observable && $$observable.hasOwnProperty("default") ? $$observable["default"] : $$observable;
        (function(NetworkStatus) {
          NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
          NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
          NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
          NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
          NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
          NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
          NetworkStatus[NetworkStatus["error"] = 8] = "error";
        })(exports2.NetworkStatus || (exports2.NetworkStatus = {}));
        function isNetworkRequestInFlight(networkStatus) {
          return networkStatus < 7;
        }
        var __extends8 = function() {
          var extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
            d.__proto__ = b;
          } || function(d, b) {
            for (var p in b)
              if (b.hasOwnProperty(p))
                d[p] = b[p];
          };
          return function(d, b) {
            extendStatics4(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var Observable5 = (
          /** @class */
          function(_super) {
            __extends8(Observable6, _super);
            function Observable6() {
              return _super !== null && _super.apply(this, arguments) || this;
            }
            Observable6.prototype[$$observable] = function() {
              return this;
            };
            Observable6.prototype["@@observable"] = function() {
              return this;
            };
            return Observable6;
          }(apolloLink.Observable)
        );
        var __extends$1 = function() {
          var extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
            d.__proto__ = b;
          } || function(d, b) {
            for (var p in b)
              if (b.hasOwnProperty(p))
                d[p] = b[p];
          };
          return function(d, b) {
            extendStatics4(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        function isApolloError(err) {
          return err.hasOwnProperty("graphQLErrors");
        }
        var generateErrorMessage = function(err) {
          var message = "";
          if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
            err.graphQLErrors.forEach(function(graphQLError) {
              var errorMessage = graphQLError ? graphQLError.message : "Error message not found.";
              message += "GraphQL error: " + errorMessage + "\n";
            });
          }
          if (err.networkError) {
            message += "Network error: " + err.networkError.message + "\n";
          }
          message = message.replace(/\n$/, "");
          return message;
        };
        var ApolloError = (
          /** @class */
          function(_super) {
            __extends$1(ApolloError2, _super);
            function ApolloError2(_a4) {
              var graphQLErrors = _a4.graphQLErrors, networkError = _a4.networkError, errorMessage = _a4.errorMessage, extraInfo = _a4.extraInfo;
              var _this = _super.call(this, errorMessage) || this;
              _this.graphQLErrors = graphQLErrors || [];
              _this.networkError = networkError || null;
              if (!errorMessage) {
                _this.message = generateErrorMessage(_this);
              } else {
                _this.message = errorMessage;
              }
              _this.extraInfo = extraInfo;
              _this.__proto__ = ApolloError2.prototype;
              return _this;
            }
            return ApolloError2;
          }(Error)
        );
        (function(FetchType) {
          FetchType[FetchType["normal"] = 1] = "normal";
          FetchType[FetchType["refetch"] = 2] = "refetch";
          FetchType[FetchType["poll"] = 3] = "poll";
        })(exports2.FetchType || (exports2.FetchType = {}));
        var __extends$2 = function() {
          var extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
            d.__proto__ = b;
          } || function(d, b) {
            for (var p in b)
              if (b.hasOwnProperty(p))
                d[p] = b[p];
          };
          return function(d, b) {
            extendStatics4(d, b);
            function __() {
              this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
          };
        }();
        var __assign14 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        var hasError = function(storeValue, policy) {
          if (policy === void 0) {
            policy = "none";
          }
          return storeValue && (storeValue.graphQLErrors && storeValue.graphQLErrors.length > 0 && policy === "none" || storeValue.networkError);
        };
        var ObservableQuery = (
          /** @class */
          function(_super) {
            __extends$2(ObservableQuery2, _super);
            function ObservableQuery2(_a4) {
              var scheduler = _a4.scheduler, options = _a4.options, _b = _a4.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
              var _this = _super.call(this, function(observer) {
                return _this.onSubscribe(observer);
              }) || this;
              _this.isCurrentlyPolling = false;
              _this.isTornDown = false;
              _this.options = options;
              _this.variables = options.variables || {};
              _this.queryId = scheduler.queryManager.generateQueryId();
              _this.shouldSubscribe = shouldSubscribe;
              _this.scheduler = scheduler;
              _this.queryManager = scheduler.queryManager;
              _this.observers = [];
              _this.subscriptionHandles = [];
              return _this;
            }
            ObservableQuery2.prototype.result = function() {
              var that = this;
              return new Promise(function(resolve2, reject2) {
                var subscription;
                var observer = {
                  next: function(result) {
                    resolve2(result);
                    if (!that.observers.some(function(obs) {
                      return obs !== observer;
                    })) {
                      that.queryManager.removeQuery(that.queryId);
                    }
                    setTimeout(function() {
                      subscription.unsubscribe();
                    }, 0);
                  },
                  error: function(error) {
                    reject2(error);
                  }
                };
                subscription = that.subscribe(observer);
              });
            };
            ObservableQuery2.prototype.currentResult = function() {
              if (this.isTornDown) {
                return {
                  data: this.lastError ? {} : this.lastResult ? this.lastResult.data : {},
                  error: this.lastError,
                  loading: false,
                  networkStatus: exports2.NetworkStatus.error
                };
              }
              var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
              if (hasError(queryStoreValue, this.options.errorPolicy)) {
                return {
                  data: {},
                  loading: false,
                  networkStatus: queryStoreValue.networkStatus,
                  error: new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                  })
                };
              }
              var _a4 = this.queryManager.getCurrentQueryResult(this), data = _a4.data, partial = _a4.partial;
              var queryLoading = !queryStoreValue || queryStoreValue.networkStatus === exports2.NetworkStatus.loading;
              var loading = this.options.fetchPolicy === "network-only" && queryLoading || partial && this.options.fetchPolicy !== "cache-only";
              var networkStatus;
              if (queryStoreValue) {
                networkStatus = queryStoreValue.networkStatus;
              } else {
                networkStatus = loading ? exports2.NetworkStatus.loading : exports2.NetworkStatus.ready;
              }
              var result = {
                data,
                loading: isNetworkRequestInFlight(networkStatus),
                networkStatus
              };
              if (queryStoreValue && queryStoreValue.graphQLErrors && this.options.errorPolicy === "all") {
                result.errors = queryStoreValue.graphQLErrors;
              }
              if (!partial) {
                var stale = false;
                this.lastResult = __assign14({}, result, { stale });
              }
              return __assign14({}, result, { partial });
            };
            ObservableQuery2.prototype.getLastResult = function() {
              return this.lastResult;
            };
            ObservableQuery2.prototype.getLastError = function() {
              return this.lastError;
            };
            ObservableQuery2.prototype.resetLastResults = function() {
              delete this.lastResult;
              delete this.lastError;
              this.isTornDown = false;
            };
            ObservableQuery2.prototype.refetch = function(variables) {
              var fetchPolicy = this.options.fetchPolicy;
              if (fetchPolicy === "cache-only") {
                return Promise.reject(new Error("cache-only fetchPolicy option should not be used together with query refetch."));
              }
              if (!apolloUtilities.isEqual(this.variables, variables)) {
                this.variables = Object.assign({}, this.variables, variables);
              }
              if (!apolloUtilities.isEqual(this.options.variables, this.variables)) {
                this.options.variables = Object.assign({}, this.options.variables, this.variables);
              }
              var isNetworkFetchPolicy = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
              var combinedOptions = __assign14({}, this.options, { fetchPolicy: isNetworkFetchPolicy ? fetchPolicy : "network-only" });
              return this.queryManager.fetchQuery(this.queryId, combinedOptions, exports2.FetchType.refetch).then(function(result) {
                return apolloUtilities.maybeDeepFreeze(result);
              });
            };
            ObservableQuery2.prototype.fetchMore = function(fetchMoreOptions) {
              var _this = this;
              if (!fetchMoreOptions.updateQuery) {
                throw new Error("updateQuery option is required. This function defines how to update the query data with the new results.");
              }
              var combinedOptions;
              return Promise.resolve().then(function() {
                var qid = _this.queryManager.generateQueryId();
                if (fetchMoreOptions.query) {
                  combinedOptions = fetchMoreOptions;
                } else {
                  combinedOptions = __assign14({}, _this.options, fetchMoreOptions, { variables: Object.assign({}, _this.variables, fetchMoreOptions.variables) });
                }
                combinedOptions.fetchPolicy = "network-only";
                return _this.queryManager.fetchQuery(qid, combinedOptions, exports2.FetchType.normal, _this.queryId);
              }).then(function(fetchMoreResult) {
                _this.updateQuery(function(previousResult) {
                  return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                  });
                });
                return fetchMoreResult;
              });
            };
            ObservableQuery2.prototype.subscribeToMore = function(options) {
              var _this = this;
              var subscription = this.queryManager.startGraphQLSubscription({
                query: options.document,
                variables: options.variables
              }).subscribe({
                next: function(data) {
                  if (options.updateQuery) {
                    _this.updateQuery(function(previous, _a4) {
                      var variables = _a4.variables;
                      return options.updateQuery(previous, {
                        subscriptionData: data,
                        variables
                      });
                    });
                  }
                },
                error: function(err) {
                  if (options.onError) {
                    options.onError(err);
                    return;
                  }
                  console.error("Unhandled GraphQL subscription error", err);
                }
              });
              this.subscriptionHandles.push(subscription);
              return function() {
                var i = _this.subscriptionHandles.indexOf(subscription);
                if (i >= 0) {
                  _this.subscriptionHandles.splice(i, 1);
                  subscription.unsubscribe();
                }
              };
            };
            ObservableQuery2.prototype.setOptions = function(opts) {
              var oldOptions = this.options;
              this.options = Object.assign({}, this.options, opts);
              if (opts.pollInterval) {
                this.startPolling(opts.pollInterval);
              } else if (opts.pollInterval === 0) {
                this.stopPolling();
              }
              var tryFetch = oldOptions.fetchPolicy !== "network-only" && opts.fetchPolicy === "network-only" || oldOptions.fetchPolicy === "cache-only" && opts.fetchPolicy !== "cache-only" || oldOptions.fetchPolicy === "standby" && opts.fetchPolicy !== "standby" || false;
              return this.setVariables(this.options.variables, tryFetch, opts.fetchResults);
            };
            ObservableQuery2.prototype.setVariables = function(variables, tryFetch, fetchResults) {
              if (tryFetch === void 0) {
                tryFetch = false;
              }
              if (fetchResults === void 0) {
                fetchResults = true;
              }
              this.isTornDown = false;
              var newVariables = variables ? variables : this.variables;
              if (apolloUtilities.isEqual(newVariables, this.variables) && !tryFetch) {
                if (this.observers.length === 0 || !fetchResults) {
                  return new Promise(function(resolve2) {
                    return resolve2();
                  });
                }
                return this.result();
              } else {
                this.variables = newVariables;
                this.options.variables = newVariables;
                if (this.observers.length === 0) {
                  return new Promise(function(resolve2) {
                    return resolve2();
                  });
                }
                return this.queryManager.fetchQuery(this.queryId, __assign14({}, this.options, { variables: this.variables })).then(function(result) {
                  return apolloUtilities.maybeDeepFreeze(result);
                });
              }
            };
            ObservableQuery2.prototype.updateQuery = function(mapFn) {
              var _a4 = this.queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a4.previousResult, variables = _a4.variables, document2 = _a4.document;
              var newResult = apolloUtilities.tryFunctionOrLogError(function() {
                return mapFn(previousResult, { variables });
              });
              if (newResult) {
                this.queryManager.dataStore.markUpdateQueryResult(document2, variables, newResult);
                this.queryManager.broadcastQueries();
              }
            };
            ObservableQuery2.prototype.stopPolling = function() {
              if (this.isCurrentlyPolling) {
                this.scheduler.stopPollingQuery(this.queryId);
                this.options.pollInterval = void 0;
                this.isCurrentlyPolling = false;
              }
            };
            ObservableQuery2.prototype.startPolling = function(pollInterval) {
              if (this.options.fetchPolicy === "cache-first" || this.options.fetchPolicy === "cache-only") {
                throw new Error("Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.");
              }
              if (this.isCurrentlyPolling) {
                this.scheduler.stopPollingQuery(this.queryId);
                this.isCurrentlyPolling = false;
              }
              this.options.pollInterval = pollInterval;
              this.isCurrentlyPolling = true;
              this.scheduler.startPollingQuery(this.options, this.queryId);
            };
            ObservableQuery2.prototype.onSubscribe = function(observer) {
              var _this = this;
              if (observer._subscription && observer._subscription._observer && !observer._subscription._observer.error) {
                observer._subscription._observer.error = function(error) {
                  console.error("Unhandled error", error.message, error.stack);
                };
              }
              this.observers.push(observer);
              if (observer.next && this.lastResult)
                observer.next(this.lastResult);
              if (observer.error && this.lastError)
                observer.error(this.lastError);
              if (this.observers.length === 1)
                this.setUpQuery();
              return function() {
                _this.observers = _this.observers.filter(function(obs) {
                  return obs !== observer;
                });
                if (_this.observers.length === 0) {
                  _this.tearDownQuery();
                }
              };
            };
            ObservableQuery2.prototype.setUpQuery = function() {
              var _this = this;
              if (this.shouldSubscribe) {
                this.queryManager.addObservableQuery(this.queryId, this);
              }
              if (!!this.options.pollInterval) {
                if (this.options.fetchPolicy === "cache-first" || this.options.fetchPolicy === "cache-only") {
                  throw new Error("Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.");
                }
                this.isCurrentlyPolling = true;
                this.scheduler.startPollingQuery(this.options, this.queryId);
              }
              var observer = {
                next: function(result) {
                  _this.lastResult = result;
                  _this.observers.forEach(function(obs) {
                    return obs.next && obs.next(result);
                  });
                },
                error: function(error) {
                  _this.lastError = error;
                  _this.observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                  });
                }
              };
              this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
            };
            ObservableQuery2.prototype.tearDownQuery = function() {
              this.isTornDown = true;
              if (this.isCurrentlyPolling) {
                this.scheduler.stopPollingQuery(this.queryId);
                this.isCurrentlyPolling = false;
              }
              this.subscriptionHandles.forEach(function(sub) {
                return sub.unsubscribe();
              });
              this.subscriptionHandles = [];
              this.queryManager.removeObservableQuery(this.queryId);
              this.queryManager.stopQuery(this.queryId);
              this.observers = [];
            };
            return ObservableQuery2;
          }(Observable5)
        );
        var __assign$1 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        var QueryScheduler = (
          /** @class */
          function() {
            function QueryScheduler2(_a4) {
              var queryManager = _a4.queryManager, ssrMode = _a4.ssrMode;
              this.inFlightQueries = {};
              this.registeredQueries = {};
              this.intervalQueries = {};
              this.pollingTimers = {};
              this.ssrMode = false;
              this.queryManager = queryManager;
              this.ssrMode = ssrMode || false;
            }
            QueryScheduler2.prototype.checkInFlight = function(queryId) {
              var query = this.queryManager.queryStore.get(queryId);
              return query && query.networkStatus !== exports2.NetworkStatus.ready && query.networkStatus !== exports2.NetworkStatus.error;
            };
            QueryScheduler2.prototype.fetchQuery = function(queryId, options, fetchType) {
              var _this = this;
              return new Promise(function(resolve2, reject2) {
                _this.queryManager.fetchQuery(queryId, options, fetchType).then(function(result) {
                  resolve2(result);
                }).catch(function(error) {
                  reject2(error);
                });
              });
            };
            QueryScheduler2.prototype.startPollingQuery = function(options, queryId, listener) {
              if (!options.pollInterval) {
                throw new Error("Attempted to start a polling query without a polling interval.");
              }
              if (this.ssrMode)
                return queryId;
              this.registeredQueries[queryId] = options;
              if (listener) {
                this.queryManager.addQueryListener(queryId, listener);
              }
              this.addQueryOnInterval(queryId, options);
              return queryId;
            };
            QueryScheduler2.prototype.stopPollingQuery = function(queryId) {
              delete this.registeredQueries[queryId];
            };
            QueryScheduler2.prototype.fetchQueriesOnInterval = function(interval) {
              var _this = this;
              this.intervalQueries[interval] = this.intervalQueries[interval].filter(function(queryId) {
                if (!(_this.registeredQueries.hasOwnProperty(queryId) && _this.registeredQueries[queryId].pollInterval === interval)) {
                  return false;
                }
                if (_this.checkInFlight(queryId)) {
                  return true;
                }
                var queryOptions = _this.registeredQueries[queryId];
                var pollingOptions = __assign$1({}, queryOptions);
                pollingOptions.fetchPolicy = "network-only";
                _this.fetchQuery(queryId, pollingOptions, exports2.FetchType.poll).catch(function() {
                });
                return true;
              });
              if (this.intervalQueries[interval].length === 0) {
                clearInterval(this.pollingTimers[interval]);
                delete this.intervalQueries[interval];
              }
            };
            QueryScheduler2.prototype.addQueryOnInterval = function(queryId, queryOptions) {
              var _this = this;
              var interval = queryOptions.pollInterval;
              if (!interval) {
                throw new Error("A poll interval is required to start polling query with id '" + queryId + "'.");
              }
              if (this.intervalQueries.hasOwnProperty(interval.toString()) && this.intervalQueries[interval].length > 0) {
                this.intervalQueries[interval].push(queryId);
              } else {
                this.intervalQueries[interval] = [queryId];
                this.pollingTimers[interval] = setInterval(function() {
                  _this.fetchQueriesOnInterval(interval);
                }, interval);
              }
            };
            QueryScheduler2.prototype.registerPollingQuery = function(queryOptions) {
              if (!queryOptions.pollInterval) {
                throw new Error("Attempted to register a non-polling query with the scheduler.");
              }
              return new ObservableQuery({
                scheduler: this,
                options: queryOptions
              });
            };
            return QueryScheduler2;
          }()
        );
        var MutationStore = (
          /** @class */
          function() {
            function MutationStore2() {
              this.store = {};
            }
            MutationStore2.prototype.getStore = function() {
              return this.store;
            };
            MutationStore2.prototype.get = function(mutationId) {
              return this.store[mutationId];
            };
            MutationStore2.prototype.initMutation = function(mutationId, mutationString, variables) {
              this.store[mutationId] = {
                mutationString,
                variables: variables || {},
                loading: true,
                error: null
              };
            };
            MutationStore2.prototype.markMutationError = function(mutationId, error) {
              var mutation = this.store[mutationId];
              if (!mutation) {
                return;
              }
              mutation.loading = false;
              mutation.error = error;
            };
            MutationStore2.prototype.markMutationResult = function(mutationId) {
              var mutation = this.store[mutationId];
              if (!mutation) {
                return;
              }
              mutation.loading = false;
              mutation.error = null;
            };
            MutationStore2.prototype.reset = function() {
              this.store = {};
            };
            return MutationStore2;
          }()
        );
        var __assign$2 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        var QueryStore = (
          /** @class */
          function() {
            function QueryStore2() {
              this.store = {};
            }
            QueryStore2.prototype.getStore = function() {
              return this.store;
            };
            QueryStore2.prototype.get = function(queryId) {
              return this.store[queryId];
            };
            QueryStore2.prototype.initQuery = function(query) {
              var previousQuery = this.store[query.queryId];
              if (previousQuery && previousQuery.document !== query.document && printer.print(previousQuery.document) !== printer.print(query.document)) {
                throw new Error("Internal Error: may not update existing query string in store");
              }
              var isSetVariables = false;
              var previousVariables = null;
              if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== exports2.NetworkStatus.loading) {
                if (!apolloUtilities.isEqual(previousQuery.variables, query.variables)) {
                  isSetVariables = true;
                  previousVariables = previousQuery.variables;
                }
              }
              var networkStatus;
              if (isSetVariables) {
                networkStatus = exports2.NetworkStatus.setVariables;
              } else if (query.isPoll) {
                networkStatus = exports2.NetworkStatus.poll;
              } else if (query.isRefetch) {
                networkStatus = exports2.NetworkStatus.refetch;
              } else {
                networkStatus = exports2.NetworkStatus.loading;
              }
              var graphQLErrors = [];
              if (previousQuery && previousQuery.graphQLErrors) {
                graphQLErrors = previousQuery.graphQLErrors;
              }
              this.store[query.queryId] = {
                document: query.document,
                variables: query.variables,
                previousVariables,
                networkError: null,
                graphQLErrors,
                networkStatus,
                metadata: query.metadata
              };
              if (typeof query.fetchMoreForQueryId === "string" && this.store[query.fetchMoreForQueryId]) {
                this.store[query.fetchMoreForQueryId].networkStatus = exports2.NetworkStatus.fetchMore;
              }
            };
            QueryStore2.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
              if (!this.store[queryId])
                return;
              this.store[queryId].networkError = null;
              this.store[queryId].graphQLErrors = result.errors && result.errors.length ? result.errors : [];
              this.store[queryId].previousVariables = null;
              this.store[queryId].networkStatus = exports2.NetworkStatus.ready;
              if (typeof fetchMoreForQueryId === "string" && this.store[fetchMoreForQueryId]) {
                this.store[fetchMoreForQueryId].networkStatus = exports2.NetworkStatus.ready;
              }
            };
            QueryStore2.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
              if (!this.store[queryId])
                return;
              this.store[queryId].networkError = error;
              this.store[queryId].networkStatus = exports2.NetworkStatus.error;
              if (typeof fetchMoreForQueryId === "string") {
                this.markQueryResultClient(fetchMoreForQueryId, true);
              }
            };
            QueryStore2.prototype.markQueryResultClient = function(queryId, complete) {
              if (!this.store[queryId])
                return;
              this.store[queryId].networkError = null;
              this.store[queryId].previousVariables = null;
              this.store[queryId].networkStatus = complete ? exports2.NetworkStatus.ready : exports2.NetworkStatus.loading;
            };
            QueryStore2.prototype.stopQuery = function(queryId) {
              delete this.store[queryId];
            };
            QueryStore2.prototype.reset = function(observableQueryIds) {
              var _this = this;
              this.store = Object.keys(this.store).filter(function(queryId) {
                return observableQueryIds.indexOf(queryId) > -1;
              }).reduce(function(res, key) {
                res[key] = __assign$2({}, _this.store[key], { networkStatus: exports2.NetworkStatus.loading });
                return res;
              }, {});
            };
            return QueryStore2;
          }()
        );
        var __assign$3 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        var defaultQueryInfo = {
          listeners: [],
          invalidated: false,
          document: null,
          newData: null,
          lastRequestId: null,
          observableQuery: null,
          subscriptions: []
        };
        var QueryManager = (
          /** @class */
          function() {
            function QueryManager2(_a4) {
              var link = _a4.link, _b = _a4.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a4.store, _c = _a4.onBroadcast, onBroadcast = _c === void 0 ? function() {
                return void 0;
              } : _c, _d = _a4.ssrMode, ssrMode = _d === void 0 ? false : _d;
              this.mutationStore = new MutationStore();
              this.queryStore = new QueryStore();
              this.idCounter = 1;
              this.queries = /* @__PURE__ */ new Map();
              this.fetchQueryPromises = /* @__PURE__ */ new Map();
              this.queryIdsByName = {};
              this.link = link;
              this.deduplicator = apolloLink.ApolloLink.from([new apolloLinkDedup.DedupLink(), link]);
              this.queryDeduplication = queryDeduplication;
              this.dataStore = store;
              this.onBroadcast = onBroadcast;
              this.scheduler = new QueryScheduler({ queryManager: this, ssrMode });
            }
            QueryManager2.prototype.mutate = function(_a4) {
              var _this = this;
              var mutation = _a4.mutation, variables = _a4.variables, optimisticResponse = _a4.optimisticResponse, updateQueriesByName = _a4.updateQueries, _b = _a4.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, updateWithProxyFn = _a4.update, _c = _a4.errorPolicy, errorPolicy = _c === void 0 ? "none" : _c, fetchPolicy = _a4.fetchPolicy, _d = _a4.context, context = _d === void 0 ? {} : _d;
              if (!mutation) {
                throw new Error("mutation option is required. You must specify your GraphQL document in the mutation option.");
              }
              if (fetchPolicy && fetchPolicy !== "no-cache") {
                throw new Error("fetchPolicy for mutations currently only supports the 'no-cache' policy");
              }
              var mutationId = this.generateQueryId();
              var cache = this.dataStore.getCache();
              mutation = cache.transformDocument(mutation), variables = apolloUtilities.assign({}, apolloUtilities.getDefaultValues(apolloUtilities.getMutationDefinition(mutation)), variables);
              var mutationString = printer.print(mutation);
              this.setQuery(mutationId, function() {
                return { document: mutation };
              });
              var generateUpdateQueriesInfo = function() {
                var ret = {};
                if (updateQueriesByName) {
                  Object.keys(updateQueriesByName).forEach(function(queryName) {
                    return (_this.queryIdsByName[queryName] || []).forEach(function(queryId) {
                      ret[queryId] = {
                        updater: updateQueriesByName[queryName],
                        query: _this.queryStore.get(queryId)
                      };
                    });
                  });
                }
                return ret;
              };
              this.mutationStore.initMutation(mutationId, mutationString, variables);
              this.dataStore.markMutationInit({
                mutationId,
                document: mutation,
                variables: variables || {},
                updateQueries: generateUpdateQueriesInfo(),
                update: updateWithProxyFn,
                optimisticResponse
              });
              this.broadcastQueries();
              return new Promise(function(resolve2, reject2) {
                var storeResult;
                var error;
                var operation = _this.buildOperationForLink(mutation, variables, __assign$3({}, context, { optimisticResponse }));
                apolloLink.execute(_this.link, operation).subscribe({
                  next: function(result) {
                    if (apolloUtilities.graphQLResultHasError(result) && errorPolicy === "none") {
                      error = new ApolloError({
                        graphQLErrors: result.errors
                      });
                      return;
                    }
                    _this.mutationStore.markMutationResult(mutationId);
                    if (fetchPolicy !== "no-cache") {
                      _this.dataStore.markMutationResult({
                        mutationId,
                        result,
                        document: mutation,
                        variables: variables || {},
                        updateQueries: generateUpdateQueriesInfo(),
                        update: updateWithProxyFn
                      });
                    }
                    storeResult = result;
                  },
                  error: function(err) {
                    _this.mutationStore.markMutationError(mutationId, err);
                    _this.dataStore.markMutationComplete({
                      mutationId,
                      optimisticResponse
                    });
                    _this.broadcastQueries();
                    _this.setQuery(mutationId, function() {
                      return { document: void 0 };
                    });
                    reject2(new ApolloError({
                      networkError: err
                    }));
                  },
                  complete: function() {
                    if (error) {
                      _this.mutationStore.markMutationError(mutationId, error);
                    }
                    _this.dataStore.markMutationComplete({
                      mutationId,
                      optimisticResponse
                    });
                    _this.broadcastQueries();
                    if (error) {
                      reject2(error);
                      return;
                    }
                    if (typeof refetchQueries === "function") {
                      refetchQueries = refetchQueries(storeResult);
                    }
                    if (refetchQueries) {
                      refetchQueries.forEach(function(refetchQuery) {
                        if (typeof refetchQuery === "string") {
                          _this.refetchQueryByName(refetchQuery);
                          return;
                        }
                        _this.query({
                          query: refetchQuery.query,
                          variables: refetchQuery.variables,
                          fetchPolicy: "network-only"
                        });
                      });
                    }
                    _this.setQuery(mutationId, function() {
                      return { document: void 0 };
                    });
                    if (errorPolicy === "ignore" && storeResult && apolloUtilities.graphQLResultHasError(storeResult)) {
                      delete storeResult.errors;
                    }
                    resolve2(storeResult);
                  }
                });
              });
            };
            QueryManager2.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
              var _this = this;
              var _a4 = options.variables, variables = _a4 === void 0 ? {} : _a4, _b = options.metadata, metadata = _b === void 0 ? null : _b, _c = options.fetchPolicy, fetchPolicy = _c === void 0 ? "cache-first" : _c;
              var cache = this.dataStore.getCache();
              var query = cache.transformDocument(options.query);
              var storeResult;
              var needToFetch = fetchPolicy === "network-only" || fetchPolicy === "no-cache";
              if (fetchType !== exports2.FetchType.refetch && fetchPolicy !== "network-only" && fetchPolicy !== "no-cache") {
                var _d = this.dataStore.getCache().diff({
                  query,
                  variables,
                  returnPartialData: true,
                  optimistic: false
                }), complete = _d.complete, result = _d.result;
                needToFetch = !complete || fetchPolicy === "cache-and-network";
                storeResult = result;
              }
              var shouldFetch = needToFetch && fetchPolicy !== "cache-only" && fetchPolicy !== "standby";
              if (apolloUtilities.hasDirectives(["live"], query))
                shouldFetch = true;
              var requestId = this.generateRequestId();
              var cancel = this.updateQueryWatch(queryId, query, options);
              this.setQuery(queryId, function() {
                return {
                  document: query,
                  lastRequestId: requestId,
                  invalidated: true,
                  cancel
                };
              });
              this.invalidate(true, fetchMoreForQueryId);
              this.queryStore.initQuery({
                queryId,
                document: query,
                storePreviousVariables: shouldFetch,
                variables,
                isPoll: fetchType === exports2.FetchType.poll,
                isRefetch: fetchType === exports2.FetchType.refetch,
                metadata,
                fetchMoreForQueryId
              });
              this.broadcastQueries();
              var shouldDispatchClientResult = !shouldFetch || fetchPolicy === "cache-and-network";
              if (shouldDispatchClientResult) {
                this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                this.invalidate(true, queryId, fetchMoreForQueryId);
                this.broadcastQueries();
              }
              if (shouldFetch) {
                var networkResult = this.fetchRequest({
                  requestId,
                  queryId,
                  document: query,
                  options,
                  fetchMoreForQueryId
                }).catch(function(error) {
                  if (isApolloError(error)) {
                    throw error;
                  } else {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                      _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                      _this.invalidate(true, queryId, fetchMoreForQueryId);
                      _this.broadcastQueries();
                    }
                    _this.removeFetchQueryPromise(requestId);
                    throw new ApolloError({ networkError: error });
                  }
                });
                if (fetchPolicy !== "cache-and-network") {
                  return networkResult;
                } else {
                  networkResult.catch(function() {
                  });
                }
              }
              return Promise.resolve({ data: storeResult });
            };
            QueryManager2.prototype.queryListenerForObserver = function(queryId, options, observer) {
              var _this = this;
              var previouslyHadError = false;
              return function(queryStoreValue, newData) {
                _this.invalidate(false, queryId);
                if (!queryStoreValue)
                  return;
                var observableQuery = _this.getQuery(queryId).observableQuery;
                var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
                if (fetchPolicy === "standby")
                  return;
                var errorPolicy = observableQuery ? observableQuery.options.errorPolicy : options.errorPolicy;
                var lastResult = observableQuery ? observableQuery.getLastResult() : null;
                var lastError = observableQuery ? observableQuery.getLastError() : null;
                var shouldNotifyIfLoading = !newData && queryStoreValue.previousVariables != null || fetchPolicy === "cache-only" || fetchPolicy === "cache-and-network";
                var networkStatusChanged = Boolean(lastResult && queryStoreValue.networkStatus !== lastResult.networkStatus);
                var errorStatusChanged = errorPolicy && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors && errorPolicy !== "none";
                if (!isNetworkRequestInFlight(queryStoreValue.networkStatus) || networkStatusChanged && options.notifyOnNetworkStatusChange || shouldNotifyIfLoading) {
                  if ((!errorPolicy || errorPolicy === "none") && queryStoreValue.graphQLErrors && queryStoreValue.graphQLErrors.length > 0 || queryStoreValue.networkError) {
                    var apolloError_1 = new ApolloError({
                      graphQLErrors: queryStoreValue.graphQLErrors,
                      networkError: queryStoreValue.networkError
                    });
                    previouslyHadError = true;
                    if (observer.error) {
                      try {
                        observer.error(apolloError_1);
                      } catch (e) {
                        setTimeout(function() {
                          throw e;
                        }, 0);
                      }
                    } else {
                      setTimeout(function() {
                        throw apolloError_1;
                      }, 0);
                      if (!apolloUtilities.isProduction()) {
                        console.info("An unhandled error was thrown because no error handler is registered for the query " + printer.print(queryStoreValue.document));
                      }
                    }
                    return;
                  }
                  try {
                    var data = void 0;
                    var isMissing = void 0;
                    if (newData) {
                      _this.setQuery(queryId, function() {
                        return { newData: null };
                      });
                      data = newData.result;
                      isMissing = !newData.complete ? !newData.complete : false;
                    } else {
                      if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                      } else {
                        var document_1 = _this.getQuery(queryId).document;
                        var readResult = _this.dataStore.getCache().diff({
                          query: document_1,
                          variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                          optimistic: true
                        });
                        data = readResult.result;
                        isMissing = !readResult.complete;
                      }
                    }
                    var resultFromStore = void 0;
                    if (isMissing && fetchPolicy !== "cache-only") {
                      resultFromStore = {
                        data: lastResult && lastResult.data,
                        loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                        networkStatus: queryStoreValue.networkStatus,
                        stale: true
                      };
                    } else {
                      resultFromStore = {
                        data,
                        loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                        networkStatus: queryStoreValue.networkStatus,
                        stale: false
                      };
                    }
                    if (errorPolicy === "all" && queryStoreValue.graphQLErrors && queryStoreValue.graphQLErrors.length > 0) {
                      resultFromStore.errors = queryStoreValue.graphQLErrors;
                    }
                    if (observer.next) {
                      var isDifferentResult = !(lastResult && resultFromStore && lastResult.networkStatus === resultFromStore.networkStatus && lastResult.stale === resultFromStore.stale && // We can do a strict equality check here because we include a `previousResult`
                      // with `readQueryFromStore`. So if the results are the same they will be
                      // referentially equal.
                      lastResult.data === resultFromStore.data);
                      if (isDifferentResult || previouslyHadError) {
                        try {
                          observer.next(apolloUtilities.maybeDeepFreeze(resultFromStore));
                        } catch (e) {
                          setTimeout(function() {
                            throw e;
                          }, 0);
                        }
                      }
                    }
                    previouslyHadError = false;
                  } catch (error) {
                    previouslyHadError = true;
                    if (observer.error)
                      observer.error(new ApolloError({ networkError: error }));
                    return;
                  }
                }
              };
            };
            QueryManager2.prototype.watchQuery = function(options, shouldSubscribe) {
              if (shouldSubscribe === void 0) {
                shouldSubscribe = true;
              }
              if (options.fetchPolicy === "standby") {
                throw new Error('client.watchQuery cannot be called with fetchPolicy set to "standby"');
              }
              var queryDefinition = apolloUtilities.getQueryDefinition(options.query);
              if (queryDefinition.variableDefinitions && queryDefinition.variableDefinitions.length) {
                var defaultValues = apolloUtilities.getDefaultValues(queryDefinition);
                options.variables = apolloUtilities.assign({}, defaultValues, options.variables);
              }
              if (typeof options.notifyOnNetworkStatusChange === "undefined") {
                options.notifyOnNetworkStatusChange = false;
              }
              var transformedOptions = __assign$3({}, options);
              return new ObservableQuery({
                scheduler: this.scheduler,
                options: transformedOptions,
                shouldSubscribe
              });
            };
            QueryManager2.prototype.query = function(options) {
              var _this = this;
              if (!options.query) {
                throw new Error("query option is required. You must specify your GraphQL document in the query option.");
              }
              if (options.query.kind !== "Document") {
                throw new Error('You must wrap the query string in a "gql" tag.');
              }
              if (options.returnPartialData) {
                throw new Error("returnPartialData option only supported on watchQuery.");
              }
              if (options.pollInterval) {
                throw new Error("pollInterval option only supported on watchQuery.");
              }
              var requestId = this.idCounter;
              return new Promise(function(resolve2, reject2) {
                _this.addFetchQueryPromise(requestId, resolve2, reject2);
                return _this.watchQuery(options, false).result().then(function(result) {
                  _this.removeFetchQueryPromise(requestId);
                  resolve2(result);
                }).catch(function(error) {
                  _this.removeFetchQueryPromise(requestId);
                  reject2(error);
                });
              });
            };
            QueryManager2.prototype.generateQueryId = function() {
              var queryId = this.idCounter.toString();
              this.idCounter++;
              return queryId;
            };
            QueryManager2.prototype.stopQueryInStore = function(queryId) {
              this.queryStore.stopQuery(queryId);
              this.invalidate(true, queryId);
              this.broadcastQueries();
            };
            QueryManager2.prototype.addQueryListener = function(queryId, listener) {
              this.setQuery(queryId, function(_a4) {
                var _b = _a4.listeners, listeners = _b === void 0 ? [] : _b;
                return {
                  listeners: listeners.concat([listener]),
                  invalidate: false
                };
              });
            };
            QueryManager2.prototype.updateQueryWatch = function(queryId, document2, options) {
              var _this = this;
              var cancel = this.getQuery(queryId).cancel;
              if (cancel)
                cancel();
              var previousResult = function() {
                var previousResult2 = null;
                var observableQuery = _this.getQuery(queryId).observableQuery;
                if (observableQuery) {
                  var lastResult = observableQuery.getLastResult();
                  if (lastResult) {
                    previousResult2 = lastResult.data;
                  }
                }
                return previousResult2;
              };
              return this.dataStore.getCache().watch({
                query: document2,
                variables: options.variables,
                optimistic: true,
                previousResult,
                callback: function(newData) {
                  _this.setQuery(queryId, function() {
                    return { invalidated: true, newData };
                  });
                }
              });
            };
            QueryManager2.prototype.addFetchQueryPromise = function(requestId, resolve2, reject2) {
              this.fetchQueryPromises.set(requestId.toString(), {
                resolve: resolve2,
                reject: reject2
              });
            };
            QueryManager2.prototype.removeFetchQueryPromise = function(requestId) {
              this.fetchQueryPromises.delete(requestId.toString());
            };
            QueryManager2.prototype.addObservableQuery = function(queryId, observableQuery) {
              this.setQuery(queryId, function() {
                return { observableQuery };
              });
              var queryDef = apolloUtilities.getQueryDefinition(observableQuery.options.query);
              if (queryDef.name && queryDef.name.value) {
                var queryName = queryDef.name.value;
                this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
                this.queryIdsByName[queryName].push(observableQuery.queryId);
              }
            };
            QueryManager2.prototype.removeObservableQuery = function(queryId) {
              var _a4 = this.getQuery(queryId), observableQuery = _a4.observableQuery, cancel = _a4.cancel;
              if (cancel)
                cancel();
              if (!observableQuery)
                return;
              var definition = apolloUtilities.getQueryDefinition(observableQuery.options.query);
              var queryName = definition.name ? definition.name.value : null;
              this.setQuery(queryId, function() {
                return { observableQuery: null };
              });
              if (queryName) {
                this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function(val) {
                  return !(observableQuery.queryId === val);
                });
              }
            };
            QueryManager2.prototype.clearStore = function() {
              this.fetchQueryPromises.forEach(function(_a4) {
                var reject2 = _a4.reject;
                reject2(new Error("Store reset while query was in flight(not completed in link chain)"));
              });
              var resetIds = [];
              this.queries.forEach(function(_a4, queryId) {
                var observableQuery = _a4.observableQuery;
                if (observableQuery)
                  resetIds.push(queryId);
              });
              this.queryStore.reset(resetIds);
              this.mutationStore.reset();
              var reset = this.dataStore.reset();
              return reset;
            };
            QueryManager2.prototype.resetStore = function() {
              var _this = this;
              return this.clearStore().then(function() {
                return _this.reFetchObservableQueries();
              });
            };
            QueryManager2.prototype.getObservableQueryPromises = function(includeStandby) {
              var _this = this;
              var observableQueryPromises = [];
              this.queries.forEach(function(_a4, queryId) {
                var observableQuery = _a4.observableQuery;
                if (!observableQuery)
                  return;
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== "cache-only" && (includeStandby || fetchPolicy !== "standby")) {
                  observableQueryPromises.push(observableQuery.refetch());
                }
                _this.setQuery(queryId, function() {
                  return { newData: null };
                });
                _this.invalidate(true, queryId);
              });
              return observableQueryPromises;
            };
            QueryManager2.prototype.reFetchObservableQueries = function(includeStandby) {
              var observableQueryPromises = this.getObservableQueryPromises(includeStandby);
              this.broadcastQueries();
              return Promise.all(observableQueryPromises);
            };
            QueryManager2.prototype.startQuery = function(queryId, options, listener) {
              this.addQueryListener(queryId, listener);
              this.fetchQuery(queryId, options).catch(function() {
                return void 0;
              });
              return queryId;
            };
            QueryManager2.prototype.startGraphQLSubscription = function(options) {
              var _this = this;
              var query = options.query;
              var cache = this.dataStore.getCache();
              var transformedDoc = cache.transformDocument(query);
              var variables = apolloUtilities.assign({}, apolloUtilities.getDefaultValues(apolloUtilities.getOperationDefinition(query)), options.variables);
              var sub;
              var observers = [];
              return new Observable5(function(observer) {
                observers.push(observer);
                if (observers.length === 1) {
                  var handler = {
                    next: function(result) {
                      _this.dataStore.markSubscriptionResult(result, transformedDoc, variables);
                      _this.broadcastQueries();
                      observers.forEach(function(obs) {
                        if (obs.next)
                          obs.next(result);
                      });
                    },
                    error: function(error) {
                      observers.forEach(function(obs) {
                        if (obs.error)
                          obs.error(error);
                      });
                    }
                  };
                  var operation = _this.buildOperationForLink(transformedDoc, variables);
                  sub = apolloLink.execute(_this.link, operation).subscribe(handler);
                }
                return function() {
                  observers = observers.filter(function(obs) {
                    return obs !== observer;
                  });
                  if (observers.length === 0 && sub) {
                    sub.unsubscribe();
                  }
                };
              });
            };
            QueryManager2.prototype.stopQuery = function(queryId) {
              this.stopQueryInStore(queryId);
              this.removeQuery(queryId);
            };
            QueryManager2.prototype.removeQuery = function(queryId) {
              var subscriptions = this.getQuery(queryId).subscriptions;
              subscriptions.forEach(function(x) {
                return x.unsubscribe();
              });
              this.queries.delete(queryId);
            };
            QueryManager2.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
              if (optimistic === void 0) {
                optimistic = true;
              }
              var _a4 = observableQuery.options, variables = _a4.variables, query = _a4.query;
              var lastResult = observableQuery.getLastResult();
              var newData = this.getQuery(observableQuery.queryId).newData;
              if (newData) {
                return apolloUtilities.maybeDeepFreeze({ data: newData.result, partial: false });
              } else {
                try {
                  var data = this.dataStore.getCache().read({
                    query,
                    variables,
                    previousResult: lastResult ? lastResult.data : void 0,
                    optimistic
                  });
                  return apolloUtilities.maybeDeepFreeze({ data, partial: false });
                } catch (e) {
                  return apolloUtilities.maybeDeepFreeze({ data: {}, partial: true });
                }
              }
            };
            QueryManager2.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
              var observableQuery;
              if (typeof queryIdOrObservable === "string") {
                var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
                if (!foundObserveableQuery) {
                  throw new Error("ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
                }
                observableQuery = foundObserveableQuery;
              } else {
                observableQuery = queryIdOrObservable;
              }
              var _a4 = observableQuery.options, variables = _a4.variables, query = _a4.query;
              var data = this.getCurrentQueryResult(observableQuery, false).data;
              return {
                previousResult: data,
                variables,
                document: query
              };
            };
            QueryManager2.prototype.broadcastQueries = function() {
              var _this = this;
              this.onBroadcast();
              this.queries.forEach(function(info, id) {
                if (!info.invalidated || !info.listeners)
                  return;
                info.listeners.filter(function(x) {
                  return !!x;
                }).forEach(function(listener) {
                  listener(_this.queryStore.get(id), info.newData);
                });
              });
            };
            QueryManager2.prototype.fetchRequest = function(_a4) {
              var _this = this;
              var requestId = _a4.requestId, queryId = _a4.queryId, document2 = _a4.document, options = _a4.options, fetchMoreForQueryId = _a4.fetchMoreForQueryId;
              var variables = options.variables, context = options.context, _b = options.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, fetchPolicy = options.fetchPolicy;
              var operation = this.buildOperationForLink(document2, variables, __assign$3({}, context, {
                // TODO: Should this be included for all entry points via
                // buildOperationForLink?
                forceFetch: !this.queryDeduplication
              }));
              var resultFromStore;
              var errorsFromStore;
              return new Promise(function(resolve2, reject2) {
                _this.addFetchQueryPromise(requestId, resolve2, reject2);
                var subscription = apolloLink.execute(_this.deduplicator, operation).subscribe({
                  next: function(result) {
                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                    if (requestId >= (lastRequestId || 1)) {
                      if (fetchPolicy !== "no-cache") {
                        try {
                          _this.dataStore.markQueryResult(result, document2, variables, fetchMoreForQueryId, errorPolicy === "ignore" || errorPolicy === "all");
                        } catch (e) {
                          reject2(e);
                          return;
                        }
                      } else {
                        _this.setQuery(queryId, function() {
                          return {
                            newData: { result: result.data, complete: true }
                          };
                        });
                      }
                      _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                      _this.invalidate(true, queryId, fetchMoreForQueryId);
                      _this.broadcastQueries();
                    }
                    if (result.errors && errorPolicy === "none") {
                      reject2(new ApolloError({
                        graphQLErrors: result.errors
                      }));
                      return;
                    } else if (errorPolicy === "all") {
                      errorsFromStore = result.errors;
                    }
                    if (fetchMoreForQueryId || fetchPolicy === "no-cache") {
                      resultFromStore = result.data;
                    } else {
                      try {
                        resultFromStore = _this.dataStore.getCache().read({
                          variables,
                          query: document2,
                          optimistic: false
                        });
                      } catch (e) {
                      }
                    }
                  },
                  error: function(error) {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function(_a5) {
                      var subscriptions = _a5.subscriptions;
                      return {
                        subscriptions: subscriptions.filter(function(x) {
                          return x !== subscription;
                        })
                      };
                    });
                    reject2(error);
                  },
                  complete: function() {
                    _this.removeFetchQueryPromise(requestId);
                    _this.setQuery(queryId, function(_a5) {
                      var subscriptions = _a5.subscriptions;
                      return {
                        subscriptions: subscriptions.filter(function(x) {
                          return x !== subscription;
                        })
                      };
                    });
                    resolve2({
                      data: resultFromStore,
                      errors: errorsFromStore,
                      loading: false,
                      networkStatus: exports2.NetworkStatus.ready,
                      stale: false
                    });
                  }
                });
                _this.setQuery(queryId, function(_a5) {
                  var subscriptions = _a5.subscriptions;
                  return {
                    subscriptions: subscriptions.concat([subscription])
                  };
                });
              });
            };
            QueryManager2.prototype.refetchQueryByName = function(queryName) {
              var _this = this;
              var refetchedQueries = this.queryIdsByName[queryName];
              if (refetchedQueries === void 0)
                return;
              return Promise.all(refetchedQueries.map(function(id) {
                return _this.getQuery(id).observableQuery;
              }).filter(function(x) {
                return !!x;
              }).map(function(x) {
                return x.refetch();
              }));
            };
            QueryManager2.prototype.generateRequestId = function() {
              var requestId = this.idCounter;
              this.idCounter++;
              return requestId;
            };
            QueryManager2.prototype.getQuery = function(queryId) {
              return this.queries.get(queryId) || __assign$3({}, defaultQueryInfo);
            };
            QueryManager2.prototype.setQuery = function(queryId, updater) {
              var prev = this.getQuery(queryId);
              var newInfo = __assign$3({}, prev, updater(prev));
              this.queries.set(queryId, newInfo);
            };
            QueryManager2.prototype.invalidate = function(invalidated, queryId, fetchMoreForQueryId) {
              if (queryId)
                this.setQuery(queryId, function() {
                  return { invalidated };
                });
              if (fetchMoreForQueryId) {
                this.setQuery(fetchMoreForQueryId, function() {
                  return { invalidated };
                });
              }
            };
            QueryManager2.prototype.buildOperationForLink = function(document2, variables, extraContext) {
              var cache = this.dataStore.getCache();
              return {
                query: cache.transformForLink ? cache.transformForLink(document2) : document2,
                variables,
                operationName: apolloUtilities.getOperationName(document2) || void 0,
                context: __assign$3({}, extraContext, {
                  cache,
                  // getting an entry's cache key is useful for cacheResolvers & state-link
                  getCacheKey: function(obj) {
                    if (cache.config) {
                      return cache.config.dataIdFromObject(obj);
                    } else {
                      throw new Error("To use context.getCacheKey, you need to use a cache that has a configurable dataIdFromObject, like apollo-cache-inmemory.");
                    }
                  }
                })
              };
            };
            return QueryManager2;
          }()
        );
        var DataStore = (
          /** @class */
          function() {
            function DataStore2(initialCache) {
              this.cache = initialCache;
            }
            DataStore2.prototype.getCache = function() {
              return this.cache;
            };
            DataStore2.prototype.markQueryResult = function(result, document2, variables, fetchMoreForQueryId, ignoreErrors) {
              if (ignoreErrors === void 0) {
                ignoreErrors = false;
              }
              var writeWithErrors = !apolloUtilities.graphQLResultHasError(result);
              if (ignoreErrors && apolloUtilities.graphQLResultHasError(result) && result.data) {
                writeWithErrors = true;
              }
              if (!fetchMoreForQueryId && writeWithErrors) {
                this.cache.write({
                  result: result.data,
                  dataId: "ROOT_QUERY",
                  query: document2,
                  variables
                });
              }
            };
            DataStore2.prototype.markSubscriptionResult = function(result, document2, variables) {
              if (!apolloUtilities.graphQLResultHasError(result)) {
                this.cache.write({
                  result: result.data,
                  dataId: "ROOT_SUBSCRIPTION",
                  query: document2,
                  variables
                });
              }
            };
            DataStore2.prototype.markMutationInit = function(mutation) {
              var _this = this;
              if (mutation.optimisticResponse) {
                var optimistic_1;
                if (typeof mutation.optimisticResponse === "function") {
                  optimistic_1 = mutation.optimisticResponse(mutation.variables);
                } else {
                  optimistic_1 = mutation.optimisticResponse;
                }
                var changeFn_1 = function() {
                  _this.markMutationResult({
                    mutationId: mutation.mutationId,
                    result: { data: optimistic_1 },
                    document: mutation.document,
                    variables: mutation.variables,
                    updateQueries: mutation.updateQueries,
                    update: mutation.update
                  });
                };
                this.cache.recordOptimisticTransaction(function(c) {
                  var orig = _this.cache;
                  _this.cache = c;
                  try {
                    changeFn_1();
                  } finally {
                    _this.cache = orig;
                  }
                }, mutation.mutationId);
              }
            };
            DataStore2.prototype.markMutationResult = function(mutation) {
              var _this = this;
              if (!apolloUtilities.graphQLResultHasError(mutation.result)) {
                var cacheWrites_1 = [];
                cacheWrites_1.push({
                  result: mutation.result.data,
                  dataId: "ROOT_MUTATION",
                  query: mutation.document,
                  variables: mutation.variables
                });
                if (mutation.updateQueries) {
                  Object.keys(mutation.updateQueries).filter(function(id) {
                    return mutation.updateQueries[id];
                  }).forEach(function(queryId) {
                    var _a4 = mutation.updateQueries[queryId], query = _a4.query, updater = _a4.updater;
                    var _b = _this.cache.diff({
                      query: query.document,
                      variables: query.variables,
                      returnPartialData: true,
                      optimistic: false
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (!complete) {
                      return;
                    }
                    var nextQueryResult = apolloUtilities.tryFunctionOrLogError(function() {
                      return updater(currentQueryResult, {
                        mutationResult: mutation.result,
                        queryName: apolloUtilities.getOperationName(query.document) || void 0,
                        queryVariables: query.variables
                      });
                    });
                    if (nextQueryResult) {
                      cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: query.document,
                        variables: query.variables
                      });
                    }
                  });
                }
                this.cache.performTransaction(function(c) {
                  cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                  });
                });
                var update_1 = mutation.update;
                if (update_1) {
                  this.cache.performTransaction(function(c) {
                    apolloUtilities.tryFunctionOrLogError(function() {
                      return update_1(c, mutation.result);
                    });
                  });
                }
              }
            };
            DataStore2.prototype.markMutationComplete = function(_a4) {
              var mutationId = _a4.mutationId, optimisticResponse = _a4.optimisticResponse;
              if (!optimisticResponse)
                return;
              this.cache.removeOptimistic(mutationId);
            };
            DataStore2.prototype.markUpdateQueryResult = function(document2, variables, newResult) {
              this.cache.write({
                result: newResult,
                dataId: "ROOT_QUERY",
                variables,
                query: document2
              });
            };
            DataStore2.prototype.reset = function() {
              return this.cache.reset();
            };
            return DataStore2;
          }()
        );
        var version = "2.3.4";
        var __assign$4 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        var hasSuggestedDevtools = false;
        var supportedDirectives = new apolloLink.ApolloLink(function(operation, forward) {
          operation.query = apolloUtilities.removeConnectionDirectiveFromDocument(operation.query);
          return forward(operation);
        });
        var ApolloClient2 = (
          /** @class */
          function() {
            function ApolloClient3(options) {
              var _this = this;
              this.defaultOptions = {};
              this.resetStoreCallbacks = [];
              var link = options.link, cache = options.cache, _a4 = options.ssrMode, ssrMode = _a4 === void 0 ? false : _a4, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions2 = options.defaultOptions;
              if (!link || !cache) {
                throw new Error("\n        In order to initialize Apollo Client, you must specify link & cache properties on the config object.\n        This is part of the required upgrade when migrating from Apollo Client 1.0 to Apollo Client 2.0.\n        For more information, please visit:\n          https://www.apollographql.com/docs/react/basics/setup.html\n        to help you get started.\n      ");
              }
              this.link = supportedDirectives.concat(link);
              this.cache = cache;
              this.store = new DataStore(cache);
              this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
              this.queryDeduplication = queryDeduplication;
              this.ssrMode = ssrMode;
              this.defaultOptions = defaultOptions2 || {};
              if (ssrForceFetchDelay) {
                setTimeout(function() {
                  return _this.disableNetworkFetches = false;
                }, ssrForceFetchDelay);
              }
              this.watchQuery = this.watchQuery.bind(this);
              this.query = this.query.bind(this);
              this.mutate = this.mutate.bind(this);
              this.resetStore = this.resetStore.bind(this);
              this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
              var defaultConnectToDevTools = !apolloUtilities.isProduction() && typeof window !== "undefined" && !window.__APOLLO_CLIENT__;
              if (typeof connectToDevTools === "undefined" ? defaultConnectToDevTools : connectToDevTools && typeof window !== "undefined") {
                window.__APOLLO_CLIENT__ = this;
              }
              if (!hasSuggestedDevtools && !apolloUtilities.isProduction()) {
                hasSuggestedDevtools = true;
                if (typeof window !== "undefined" && window.document && window.top === window.self) {
                  if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === "undefined") {
                    if (window.navigator && window.navigator.userAgent.indexOf("Chrome") > -1) {
                      console.debug("Download the Apollo DevTools for a better development experience: https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm");
                    }
                  }
                }
              }
              this.version = version;
            }
            ApolloClient3.prototype.watchQuery = function(options) {
              this.initQueryManager();
              if (this.defaultOptions.watchQuery) {
                options = __assign$4({}, this.defaultOptions.watchQuery, options);
              }
              if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) {
                options = __assign$4({}, options, { fetchPolicy: "cache-first" });
              }
              return this.queryManager.watchQuery(options);
            };
            ApolloClient3.prototype.query = function(options) {
              this.initQueryManager();
              if (this.defaultOptions.query) {
                options = __assign$4({}, this.defaultOptions.query, options);
              }
              if (options.fetchPolicy === "cache-and-network") {
                throw new Error("cache-and-network fetchPolicy can only be used with watchQuery");
              }
              if (this.disableNetworkFetches && options.fetchPolicy === "network-only") {
                options = __assign$4({}, options, { fetchPolicy: "cache-first" });
              }
              return this.queryManager.query(options);
            };
            ApolloClient3.prototype.mutate = function(options) {
              this.initQueryManager();
              if (this.defaultOptions.mutate) {
                options = __assign$4({}, this.defaultOptions.mutate, options);
              }
              return this.queryManager.mutate(options);
            };
            ApolloClient3.prototype.subscribe = function(options) {
              this.initQueryManager();
              return this.queryManager.startGraphQLSubscription(options);
            };
            ApolloClient3.prototype.readQuery = function(options) {
              return this.initProxy().readQuery(options);
            };
            ApolloClient3.prototype.readFragment = function(options) {
              return this.initProxy().readFragment(options);
            };
            ApolloClient3.prototype.writeQuery = function(options) {
              var result = this.initProxy().writeQuery(options);
              this.queryManager.broadcastQueries();
              return result;
            };
            ApolloClient3.prototype.writeFragment = function(options) {
              var result = this.initProxy().writeFragment(options);
              this.queryManager.broadcastQueries();
              return result;
            };
            ApolloClient3.prototype.writeData = function(options) {
              var result = this.initProxy().writeData(options);
              this.queryManager.broadcastQueries();
              return result;
            };
            ApolloClient3.prototype.__actionHookForDevTools = function(cb) {
              this.devToolsHookCb = cb;
            };
            ApolloClient3.prototype.__requestRaw = function(payload) {
              return apolloLink.execute(this.link, payload);
            };
            ApolloClient3.prototype.initQueryManager = function() {
              var _this = this;
              if (this.queryManager)
                return;
              this.queryManager = new QueryManager({
                link: this.link,
                store: this.store,
                queryDeduplication: this.queryDeduplication,
                ssrMode: this.ssrMode,
                onBroadcast: function() {
                  if (_this.devToolsHookCb) {
                    _this.devToolsHookCb({
                      action: {},
                      state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                      },
                      dataWithOptimisticResults: _this.cache.extract(true)
                    });
                  }
                }
              });
            };
            ApolloClient3.prototype.resetStore = function() {
              var _this = this;
              return Promise.resolve().then(function() {
                return _this.queryManager ? _this.queryManager.clearStore() : Promise.resolve(null);
              }).then(function() {
                return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                  return fn();
                }));
              }).then(function() {
                return _this.queryManager && _this.queryManager.reFetchObservableQueries ? _this.queryManager.reFetchObservableQueries() : Promise.resolve(null);
              });
            };
            ApolloClient3.prototype.onResetStore = function(cb) {
              var _this = this;
              this.resetStoreCallbacks.push(cb);
              return function() {
                _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                  return c !== cb;
                });
              };
            };
            ApolloClient3.prototype.reFetchObservableQueries = function(includeStandby) {
              return this.queryManager ? this.queryManager.reFetchObservableQueries(includeStandby) : Promise.resolve(null);
            };
            ApolloClient3.prototype.extract = function(optimistic) {
              return this.initProxy().extract(optimistic);
            };
            ApolloClient3.prototype.restore = function(serializedState) {
              return this.initProxy().restore(serializedState);
            };
            ApolloClient3.prototype.initProxy = function() {
              if (!this.proxy) {
                this.initQueryManager();
                this.proxy = this.cache;
              }
              return this.proxy;
            };
            return ApolloClient3;
          }()
        );
        exports2.printAST = printer.print;
        exports2.ApolloClient = ApolloClient2;
        exports2.default = ApolloClient2;
        exports2.ObservableQuery = ObservableQuery;
        exports2.ApolloError = ApolloError;
        Object.defineProperty(exports2, "__esModule", { value: true });
      });
    }
  });

  // node_modules/apollo-link-batch-http/node_modules/apollo-link-http-common/lib/index.js
  var import_printer, __assign, defaultHttpOptions, defaultHeaders, defaultOptions, fallbackHttpConfig, throwServerError, parseAndCheckHttpResponse, checkFetcher, createSignalIfSupported, selectHttpOptionsAndBody, serializeFetchParameter, selectURI;
  var init_lib = __esm({
    "node_modules/apollo-link-batch-http/node_modules/apollo-link-http-common/lib/index.js"() {
      import_printer = __toESM(require_printer());
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
      };
      defaultHeaders = {
        // headers are case insensitive (https://stackoverflow.com/a/5259004)
        accept: "*/*",
        "content-type": "application/json"
      };
      defaultOptions = {
        method: "POST"
      };
      fallbackHttpConfig = {
        http: defaultHttpOptions,
        headers: defaultHeaders,
        options: defaultOptions
      };
      throwServerError = function(response, result, message) {
        var error = new Error(message);
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
      };
      parseAndCheckHttpResponse = function(operations) {
        return function(response) {
          return response.text().then(function(bodyText) {
            try {
              return JSON.parse(bodyText);
            } catch (err) {
              var parseError = err;
              parseError.response = response;
              parseError.statusCode = response.status;
              parseError.bodyText = bodyText;
              return Promise.reject(parseError);
            }
          }).then(function(result) {
            if (response.status >= 300) {
              throwServerError(response, result, "Response not successful: Received status code " + response.status);
            }
            if (!Array.isArray(result) && !result.hasOwnProperty("data") && !result.hasOwnProperty("errors")) {
              throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
              }) : operations.operationName) + "'.");
            }
            return result;
          });
        };
      };
      checkFetcher = function(fetcher) {
        if (!fetcher && typeof fetch === "undefined") {
          var library = "unfetch";
          if (typeof window === "undefined")
            library = "node-fetch";
          throw new Error("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
        }
      };
      createSignalIfSupported = function() {
        if (typeof AbortController === "undefined")
          return { controller: false, signal: false };
        var controller = new AbortController();
        var signal = controller.signal;
        return { controller, signal };
      };
      selectHttpOptionsAndBody = function(operation, fallbackConfig) {
        var configs = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          configs[_i - 2] = arguments[_i];
        }
        var options = __assign({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
          options = __assign({}, options, config.options, { headers: __assign({}, options.headers, config.headers) });
          if (config.credentials)
            options.credentials = config.credentials;
          http = __assign({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = { operationName, variables };
        if (http.includeExtensions)
          body.extensions = extensions;
        if (http.includeQuery)
          body.query = (0, import_printer.print)(query);
        return {
          options,
          body
        };
      };
      serializeFetchParameter = function(p, label) {
        var serialized;
        try {
          serialized = JSON.stringify(p);
        } catch (e) {
          var parseError = new Error("Network request failed. " + label + " is not serializable: " + e.message);
          parseError.parseError = e;
          throw parseError;
        }
        return serialized;
      };
      selectURI = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) {
          return contextURI;
        } else if (typeof fallbackURI === "function") {
          return fallbackURI(operation);
        } else {
          return fallbackURI || "/graphql";
        }
      };
    }
  });

  // node_modules/apollo-link-batch/lib/batching.js
  var import_apollo_link, __assign2, OperationBatcher;
  var init_batching = __esm({
    "node_modules/apollo-link-batch/lib/batching.js"() {
      import_apollo_link = __toESM(require_bundle_umd3());
      __assign2 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      OperationBatcher = /** @class */
      function() {
        function OperationBatcher2(_a4) {
          var batchInterval = _a4.batchInterval, _b = _a4.batchMax, batchMax = _b === void 0 ? 0 : _b, batchHandler = _a4.batchHandler, _c = _a4.batchKey, batchKey = _c === void 0 ? function() {
            return "";
          } : _c;
          this.queuedRequests = /* @__PURE__ */ new Map();
          this.batchInterval = batchInterval;
          this.batchMax = batchMax;
          this.batchHandler = batchHandler;
          this.batchKey = batchKey;
        }
        OperationBatcher2.prototype.enqueueRequest = function(request) {
          var _this = this;
          var requestCopy = __assign2({}, request);
          var queued = false;
          var key = this.batchKey(request.operation);
          if (!requestCopy.observable) {
            requestCopy.observable = new import_apollo_link.Observable(function(observer) {
              if (!_this.queuedRequests.has(key)) {
                _this.queuedRequests.set(key, []);
              }
              if (!queued) {
                _this.queuedRequests.get(key).push(requestCopy);
                queued = true;
              }
              requestCopy.next = requestCopy.next || [];
              if (observer.next)
                requestCopy.next.push(observer.next.bind(observer));
              requestCopy.error = requestCopy.error || [];
              if (observer.error)
                requestCopy.error.push(observer.error.bind(observer));
              requestCopy.complete = requestCopy.complete || [];
              if (observer.complete)
                requestCopy.complete.push(observer.complete.bind(observer));
              if (_this.queuedRequests.get(key).length === 1) {
                _this.scheduleQueueConsumption(key);
              }
              if (_this.queuedRequests.get(key).length === _this.batchMax) {
                _this.consumeQueue(key);
              }
            });
          }
          return requestCopy.observable;
        };
        OperationBatcher2.prototype.consumeQueue = function(key) {
          if (key === void 0) {
            key = "";
          }
          var queuedRequests = this.queuedRequests.get(key);
          if (!queuedRequests) {
            return;
          }
          this.queuedRequests.delete(key);
          var requests = queuedRequests.map(function(queuedRequest) {
            return queuedRequest.operation;
          });
          var forwards = queuedRequests.map(function(queuedRequest) {
            return queuedRequest.forward;
          });
          var observables = [];
          var nexts = [];
          var errors = [];
          var completes = [];
          queuedRequests.forEach(function(batchableRequest, index) {
            observables.push(batchableRequest.observable);
            nexts.push(batchableRequest.next);
            errors.push(batchableRequest.error);
            completes.push(batchableRequest.complete);
          });
          var batchedObservable = this.batchHandler(requests, forwards) || import_apollo_link.Observable.of();
          var onError2 = function(error) {
            errors.forEach(function(rejecters) {
              if (rejecters) {
                rejecters.forEach(function(e) {
                  return e(error);
                });
              }
            });
          };
          batchedObservable.subscribe({
            next: function(results) {
              if (!Array.isArray(results)) {
                results = [results];
              }
              if (nexts.length !== results.length) {
                var error = new Error("server returned results with length " + results.length + ", expected length of " + nexts.length);
                error.result = results;
                return onError2(error);
              }
              results.forEach(function(result, index) {
                requests[index].setContext({ response: result });
                if (nexts[index]) {
                  nexts[index].forEach(function(next) {
                    return next(result);
                  });
                }
              });
            },
            error: onError2,
            complete: function() {
              completes.forEach(function(complete) {
                if (complete) {
                  complete.forEach(function(c) {
                    return c();
                  });
                }
              });
            }
          });
          return observables;
        };
        OperationBatcher2.prototype.scheduleQueueConsumption = function(key) {
          var _this = this;
          if (key === void 0) {
            key = "";
          }
          setTimeout(function() {
            if (_this.queuedRequests.get(key) && _this.queuedRequests.get(key).length) {
              _this.consumeQueue(key);
            }
          }, this.batchInterval);
        };
        return OperationBatcher2;
      }();
    }
  });

  // node_modules/apollo-link-batch/lib/batchLink.js
  var import_apollo_link2, __extends, BatchLink;
  var init_batchLink = __esm({
    "node_modules/apollo-link-batch/lib/batchLink.js"() {
      import_apollo_link2 = __toESM(require_bundle_umd3());
      init_batching();
      init_batching();
      __extends = function() {
        var extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
          d.__proto__ = b;
        } || function(d, b) {
          for (var p in b)
            if (b.hasOwnProperty(p))
              d[p] = b[p];
        };
        return function(d, b) {
          extendStatics4(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      BatchLink = /** @class */
      function(_super) {
        __extends(BatchLink2, _super);
        function BatchLink2(fetchParams) {
          if (fetchParams === void 0) {
            fetchParams = {};
          }
          var _this = _super.call(this) || this;
          var _a4 = fetchParams.batchInterval, batchInterval = _a4 === void 0 ? 10 : _a4, _b = fetchParams.batchMax, batchMax = _b === void 0 ? 0 : _b, _c = fetchParams.batchHandler, batchHandler = _c === void 0 ? function() {
            return null;
          } : _c, _d = fetchParams.batchKey, batchKey = _d === void 0 ? function() {
            return "";
          } : _d;
          _this.batcher = new OperationBatcher({
            batchInterval,
            batchMax,
            batchHandler,
            batchKey
          });
          if (fetchParams.batchHandler.length <= 1) {
            _this.request = function(operation) {
              return _this.batcher.enqueueRequest({ operation });
            };
          }
          return _this;
        }
        BatchLink2.prototype.request = function(operation, forward) {
          return this.batcher.enqueueRequest({
            operation,
            forward
          });
        };
        return BatchLink2;
      }(import_apollo_link2.ApolloLink);
    }
  });

  // node_modules/apollo-link-batch/lib/index.js
  var init_lib2 = __esm({
    "node_modules/apollo-link-batch/lib/index.js"() {
      init_batchLink();
    }
  });

  // node_modules/apollo-link-batch-http/lib/batchHttpLink.js
  var import_apollo_link3, __extends2, __rest, BatchHttpLink;
  var init_batchHttpLink = __esm({
    "node_modules/apollo-link-batch-http/lib/batchHttpLink.js"() {
      import_apollo_link3 = __toESM(require_bundle_umd3());
      init_lib();
      init_lib2();
      __extends2 = function() {
        var extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
          d.__proto__ = b;
        } || function(d, b) {
          for (var p in b)
            if (b.hasOwnProperty(p))
              d[p] = b[p];
        };
        return function(d, b) {
          extendStatics4(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      __rest = function(s, e) {
        var t = {};
        for (var p in s)
          if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function") {
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
              t[p[i]] = s[p[i]];
        }
        return t;
      };
      BatchHttpLink = /** @class */
      function(_super) {
        __extends2(BatchHttpLink2, _super);
        function BatchHttpLink2(fetchParams) {
          if (fetchParams === void 0) {
            fetchParams = {};
          }
          var _this = _super.call(this) || this;
          var _a4 = fetchParams.uri, uri = _a4 === void 0 ? "/graphql" : _a4, fetcher = fetchParams.fetch, includeExtensions = fetchParams.includeExtensions, batchInterval = fetchParams.batchInterval, batchMax = fetchParams.batchMax, batchKey = fetchParams.batchKey, requestOptions = __rest(fetchParams, ["uri", "fetch", "includeExtensions", "batchInterval", "batchMax", "batchKey"]);
          checkFetcher(fetcher);
          if (!fetcher) {
            fetcher = fetch;
          }
          var linkConfig = {
            http: { includeExtensions },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
          };
          _this.batchInterval = batchInterval || 10;
          _this.batchMax = batchMax || 10;
          var batchHandler = function(operations) {
            var chosenURI = selectURI(operations[0], uri);
            var context = operations[0].getContext();
            var contextConfig = {
              http: context.http,
              options: context.fetchOptions,
              credentials: context.credentials,
              headers: context.headers
            };
            var optsAndBody = operations.map(function(operation) {
              return selectHttpOptionsAndBody(operation, fallbackHttpConfig, linkConfig, contextConfig);
            });
            var body = optsAndBody.map(function(_a6) {
              var body2 = _a6.body;
              return body2;
            });
            var options = optsAndBody[0].options;
            if (options.method === "GET") {
              return (0, import_apollo_link3.fromError)(new Error("apollo-link-batch-http does not support GET requests"));
            }
            try {
              options.body = serializeFetchParameter(body, "Payload");
            } catch (parseError) {
              return (0, import_apollo_link3.fromError)(parseError);
            }
            var controller;
            if (!options.signal) {
              var _a5 = createSignalIfSupported(), _controller = _a5.controller, signal = _a5.signal;
              controller = _controller;
              if (controller)
                options.signal = signal;
            }
            return new import_apollo_link3.Observable(function(observer) {
              fetcher(chosenURI, options).then(parseAndCheckHttpResponse(operations)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
              }).catch(function(err) {
                if (err.name === "AbortError")
                  return;
                if (err.result && err.result.errors && err.result.data) {
                  observer.next(err.result);
                }
                observer.error(err);
              });
              return function() {
                if (controller)
                  controller.abort();
              };
            });
          };
          batchKey = batchKey || function(operation) {
            var context = operation.getContext();
            var contextConfig = {
              http: context.http,
              options: context.fetchOptions,
              credentials: context.credentials,
              headers: context.headers
            };
            return selectURI(operation, uri) + JSON.stringify(contextConfig);
          };
          _this.batcher = new BatchLink({
            batchInterval: _this.batchInterval,
            batchMax: _this.batchMax,
            batchKey,
            batchHandler
          });
          return _this;
        }
        BatchHttpLink2.prototype.request = function(operation) {
          return this.batcher.request(operation);
        };
        return BatchHttpLink2;
      }(import_apollo_link3.ApolloLink);
    }
  });

  // node_modules/apollo-link-batch-http/lib/index.js
  var init_lib3 = __esm({
    "node_modules/apollo-link-batch-http/lib/index.js"() {
      init_batchHttpLink();
    }
  });

  // node_modules/apollo-cache-inmemory/lib/fixPolyfills.js
  var testMap, set_1, testSet, add_1, frozen, wrap2;
  var init_fixPolyfills = __esm({
    "node_modules/apollo-cache-inmemory/lib/fixPolyfills.js"() {
      testMap = /* @__PURE__ */ new Map();
      if (testMap.set(1, 2) !== testMap) {
        set_1 = testMap.set;
        Map.prototype.set = function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          set_1.apply(this, args);
          return this;
        };
      }
      testSet = /* @__PURE__ */ new Set();
      if (testSet.add(3) !== testSet) {
        add_1 = testSet.add;
        Set.prototype.add = function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          add_1.apply(this, args);
          return this;
        };
      }
      frozen = {};
      if (typeof Object.freeze === "function") {
        Object.freeze(frozen);
      }
      try {
        testMap.set(frozen, frozen).delete(frozen);
      } catch (_a4) {
        wrap2 = function(method) {
          return method && function(obj) {
            try {
              testMap.set(obj, obj).delete(obj);
            } finally {
              return method.call(Object, obj);
            }
          };
        };
        Object.freeze = wrap2(Object.freeze);
        Object.seal = wrap2(Object.seal);
        Object.preventExtensions = wrap2(Object.preventExtensions);
      }
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/storeUtils.js
  function isStringValue(value) {
    return value.kind === "StringValue";
  }
  function isBooleanValue(value) {
    return value.kind === "BooleanValue";
  }
  function isIntValue(value) {
    return value.kind === "IntValue";
  }
  function isFloatValue(value) {
    return value.kind === "FloatValue";
  }
  function isVariable(value) {
    return value.kind === "Variable";
  }
  function isObjectValue(value) {
    return value.kind === "ObjectValue";
  }
  function isListValue(value) {
    return value.kind === "ListValue";
  }
  function isEnumValue(value) {
    return value.kind === "EnumValue";
  }
  function isNullValue(value) {
    return value.kind === "NullValue";
  }
  function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
      argObj[name.value] = Number(value.value);
    } else if (isBooleanValue(value) || isStringValue(value)) {
      argObj[name.value] = value.value;
    } else if (isObjectValue(value)) {
      var nestedArgObj_1 = {};
      value.fields.map(function(obj) {
        return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
      });
      argObj[name.value] = nestedArgObj_1;
    } else if (isVariable(value)) {
      var variableValue = (variables || {})[value.name.value];
      argObj[name.value] = variableValue;
    } else if (isListValue(value)) {
      argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
      });
    } else if (isEnumValue(value)) {
      argObj[name.value] = value.value;
    } else if (isNullValue(value)) {
      argObj[name.value] = null;
    } else {
      throw new Error('The inline argument "' + name.value + '" of kind "' + value.kind + '"is not supported. Use variables instead of inline arguments to overcome this limitation.');
    }
  }
  function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
      directivesObj = {};
      field.directives.forEach(function(directive) {
        directivesObj[directive.name.value] = {};
        if (directive.arguments) {
          directive.arguments.forEach(function(_a4) {
            var name = _a4.name, value = _a4.value;
            return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
          });
        }
      });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
      argObj = {};
      field.arguments.forEach(function(_a4) {
        var name = _a4.name, value = _a4.value;
        return valueToObjectRepresentation(argObj, name, value, variables);
      });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
  }
  function getStoreKeyName(fieldName, args, directives) {
    if (directives && directives["connection"] && directives["connection"]["key"]) {
      if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
        var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
        filterKeys.sort();
        var queryArgs_1 = args;
        var filteredArgs_1 = {};
        filterKeys.forEach(function(key) {
          filteredArgs_1[key] = queryArgs_1[key];
        });
        return directives["connection"]["key"] + "(" + JSON.stringify(filteredArgs_1) + ")";
      } else {
        return directives["connection"]["key"];
      }
    }
    var completeFieldName = fieldName;
    if (args) {
      var stringifiedArgs = (0, import_fast_json_stable_stringify.default)(args);
      completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
      Object.keys(directives).forEach(function(key) {
        if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
          return;
        if (directives[key] && Object.keys(directives[key]).length) {
          completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        } else {
          completeFieldName += "@" + key;
        }
      });
    }
    return completeFieldName;
  }
  function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
      var argObj_1 = {};
      field.arguments.forEach(function(_a4) {
        var name = _a4.name, value = _a4.value;
        return valueToObjectRepresentation(argObj_1, name, value, variables);
      });
      return argObj_1;
    }
    return null;
  }
  function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
  }
  function isField(selection) {
    return selection.kind === "Field";
  }
  function isInlineFragment(selection) {
    return selection.kind === "InlineFragment";
  }
  function isIdValue(idObject) {
    return idObject && idObject.type === "id" && typeof idObject.generated === "boolean";
  }
  function toIdValue(idConfig, generated) {
    if (generated === void 0) {
      generated = false;
    }
    return __assign3({ type: "id", generated }, typeof idConfig === "string" ? { id: idConfig, typename: void 0 } : idConfig);
  }
  function isJsonValue(jsonObject) {
    return jsonObject != null && typeof jsonObject === "object" && jsonObject.type === "json";
  }
  var import_fast_json_stable_stringify, __assign3, KNOWN_DIRECTIVES;
  var init_storeUtils = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/storeUtils.js"() {
      import_fast_json_stable_stringify = __toESM(require_fast_json_stable_stringify());
      __assign3 = function() {
        __assign3 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign3.apply(this, arguments);
      };
      KNOWN_DIRECTIVES = [
        "connection",
        "include",
        "skip",
        "client",
        "rest",
        "export"
      ];
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/directives.js
  function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
      var directiveObj_1 = {};
      field.directives.forEach(function(directive) {
        directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
      });
      return directiveObj_1;
    }
    return null;
  }
  function shouldInclude(selection, variables) {
    if (variables === void 0) {
      variables = {};
    }
    if (!selection.directives) {
      return true;
    }
    var res = true;
    selection.directives.forEach(function(directive) {
      if (directive.name.value !== "skip" && directive.name.value !== "include") {
        return;
      }
      var directiveArguments = directive.arguments || [];
      var directiveName = directive.name.value;
      if (directiveArguments.length !== 1) {
        throw new Error("Incorrect number of arguments for the @" + directiveName + " directive.");
      }
      var ifArgument = directiveArguments[0];
      if (!ifArgument.name || ifArgument.name.value !== "if") {
        throw new Error("Invalid argument for the @" + directiveName + " directive.");
      }
      var ifValue = directiveArguments[0].value;
      var evaledValue = false;
      if (!ifValue || ifValue.kind !== "BooleanValue") {
        if (ifValue.kind !== "Variable") {
          throw new Error("Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
        } else {
          evaledValue = variables[ifValue.name.value];
          if (evaledValue === void 0) {
            throw new Error("Invalid variable referenced in @" + directiveName + " directive.");
          }
        }
      } else {
        evaledValue = ifValue.value;
      }
      if (directiveName === "skip") {
        evaledValue = !evaledValue;
      }
      if (!evaledValue) {
        res = false;
      }
    });
    return res;
  }
  var init_directives = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/directives.js"() {
      init_storeUtils();
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/fragments.js
  function getFragmentQueryDocument(document2, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document2.definitions.forEach(function(definition) {
      if (definition.kind === "OperationDefinition") {
        throw new Error("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : "") + ". No operations are allowed when using a fragment as a query. Only fragments are allowed.");
      }
      if (definition.kind === "FragmentDefinition") {
        fragments.push(definition);
      }
    });
    if (typeof actualFragmentName === "undefined") {
      if (fragments.length !== 1) {
        throw new Error("Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
      }
      actualFragmentName = fragments[0].name.value;
    }
    var query = __assign4({}, document2, { definitions: [
      {
        kind: "OperationDefinition",
        operation: "query",
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "FragmentSpread",
              name: {
                kind: "Name",
                value: actualFragmentName
              }
            }
          ]
        }
      }
    ].concat(document2.definitions) });
    return query;
  }
  var __assign4;
  var init_fragments = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/fragments.js"() {
      __assign4 = function() {
        __assign4 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign4.apply(this, arguments);
      };
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/assign.js
  function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function(source) {
      if (typeof source === "undefined" || source === null) {
        return;
      }
      Object.keys(source).forEach(function(key) {
        target[key] = source[key];
      });
    });
    return target;
  }
  var init_assign = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/assign.js"() {
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/getFromAST.js
  function checkDocument(doc) {
    if (doc.kind !== "Document") {
      throw new Error('Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql');
    }
    var operations = doc.definitions.filter(function(d) {
      return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
      if (definition.kind !== "OperationDefinition") {
        throw new Error('Schema type definitions not allowed in queries. Found: "' + definition.kind + '"');
      }
      return definition;
    });
    if (operations.length > 1) {
      throw new Error("Ambiguous GraphQL document: contains " + operations.length + " operations");
    }
  }
  function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function(definition) {
      return definition.kind === "OperationDefinition";
    })[0];
  }
  function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function(definition) {
      return definition.kind === "FragmentDefinition";
    });
  }
  function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
    if (!queryDef || queryDef.operation !== "query") {
      throw new Error("Must contain a query definition.");
    }
    return queryDef;
  }
  function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a4 = queryDoc.definitions; _i < _a4.length; _i++) {
      var definition = _a4[_i];
      if (definition.kind === "OperationDefinition") {
        var operation = definition.operation;
        if (operation === "query" || operation === "mutation" || operation === "subscription") {
          return definition;
        }
      }
      if (definition.kind === "FragmentDefinition" && !fragmentDefinition) {
        fragmentDefinition = definition;
      }
    }
    if (fragmentDefinition) {
      return fragmentDefinition;
    }
    throw new Error("Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.");
  }
  function createFragmentMap(fragments) {
    if (fragments === void 0) {
      fragments = [];
    }
    var symTable = {};
    fragments.forEach(function(fragment) {
      symTable[fragment.name.value] = fragment;
    });
    return symTable;
  }
  function getDefaultValues(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
      var defaultValues = definition.variableDefinitions.filter(function(_a4) {
        var defaultValue = _a4.defaultValue;
        return defaultValue;
      }).map(function(_a4) {
        var variable = _a4.variable, defaultValue = _a4.defaultValue;
        var defaultValueObj = {};
        valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
        return defaultValueObj;
      });
      return assign.apply(void 0, [{}].concat(defaultValues));
    }
    return {};
  }
  var init_getFromAST = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/getFromAST.js"() {
      init_assign();
      init_storeUtils();
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/cloneDeep.js
  function cloneDeep(value) {
    return cloneDeepHelper(value, /* @__PURE__ */ new Map());
  }
  function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
      case "[object Array]": {
        if (seen.has(val))
          return seen.get(val);
        var copy_1 = val.slice(0);
        seen.set(val, copy_1);
        copy_1.forEach(function(child, i) {
          copy_1[i] = cloneDeepHelper(child, seen);
        });
        return copy_1;
      }
      case "[object Object]": {
        if (seen.has(val))
          return seen.get(val);
        var copy_2 = Object.create(Object.getPrototypeOf(val));
        seen.set(val, copy_2);
        Object.keys(val).forEach(function(key) {
          copy_2[key] = cloneDeepHelper(val[key], seen);
        });
        return copy_2;
      }
      default:
        return val;
    }
  }
  var toString;
  var init_cloneDeep = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/cloneDeep.js"() {
      toString = Object.prototype.toString;
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/transform.js
  function addTypenameToSelectionSet(selectionSet, isRoot) {
    if (isRoot === void 0) {
      isRoot = false;
    }
    if (selectionSet.selections) {
      if (!isRoot) {
        var alreadyHasThisField = selectionSet.selections.some(function(selection) {
          return selection.kind === "Field" && selection.name.value === "__typename";
        });
        if (!alreadyHasThisField) {
          selectionSet.selections.push(TYPENAME_FIELD);
        }
      }
      selectionSet.selections.forEach(function(selection) {
        if (selection.kind === "Field") {
          if (selection.name.value.lastIndexOf("__", 0) !== 0 && selection.selectionSet) {
            addTypenameToSelectionSet(selection.selectionSet);
          }
        } else if (selection.kind === "InlineFragment") {
          if (selection.selectionSet) {
            addTypenameToSelectionSet(selection.selectionSet);
          }
        }
      });
    }
  }
  function addTypenameToDocument(doc) {
    checkDocument(doc);
    var docClone = cloneDeep(doc);
    docClone.definitions.forEach(function(definition) {
      var isRoot = definition.kind === "OperationDefinition";
      addTypenameToSelectionSet(definition.selectionSet, isRoot);
    });
    return docClone;
  }
  var TYPENAME_FIELD;
  var init_transform = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/transform.js"() {
      init_cloneDeep();
      init_getFromAST();
      TYPENAME_FIELD = {
        kind: "Field",
        name: {
          kind: "Name",
          value: "__typename"
        }
      };
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/environment.js
  function getEnv() {
    if (typeof process !== "undefined" && "production") {
      return "production";
    }
    return "development";
  }
  function isEnv(env) {
    return getEnv() === env;
  }
  function isProduction() {
    return isEnv("production") === true;
  }
  function isTest() {
    return isEnv("test") === true;
  }
  var init_environment = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/environment.js"() {
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/errorHandling.js
  var init_errorHandling = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/errorHandling.js"() {
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/isEqual.js
  function isEqual(a, b) {
    if (a === b) {
      return true;
    }
    if (a instanceof Date && b instanceof Date) {
      return a.getTime() === b.getTime();
    }
    if (a != null && typeof a === "object" && b != null && typeof b === "object") {
      for (var key in a) {
        if (Object.prototype.hasOwnProperty.call(a, key)) {
          if (!Object.prototype.hasOwnProperty.call(b, key)) {
            return false;
          }
          if (!isEqual(a[key], b[key])) {
            return false;
          }
        }
      }
      for (var key in b) {
        if (Object.prototype.hasOwnProperty.call(b, key) && !Object.prototype.hasOwnProperty.call(a, key)) {
          return false;
        }
      }
      return true;
    }
    return false;
  }
  var init_isEqual = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/isEqual.js"() {
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/maybeDeepFreeze.js
  var init_maybeDeepFreeze = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/maybeDeepFreeze.js"() {
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/warnOnce.js
  function warnOnceInDevelopment(msg, type) {
    if (type === void 0) {
      type = "warn";
    }
    if (isProduction()) {
      return;
    }
    if (!haveWarned[msg]) {
      if (!isTest()) {
        haveWarned[msg] = true;
      }
      switch (type) {
        case "error":
          console.error(msg);
          break;
        default:
          console.warn(msg);
      }
    }
  }
  var haveWarned;
  var init_warnOnce = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/warnOnce.js"() {
      init_environment();
      haveWarned = /* @__PURE__ */ Object.create({});
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/stripSymbols.js
  var init_stripSymbols = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/util/stripSymbols.js"() {
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/index.js
  var init_lib4 = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-utilities/lib/index.js"() {
      init_directives();
      init_fragments();
      init_getFromAST();
      init_transform();
      init_storeUtils();
      init_assign();
      init_cloneDeep();
      init_environment();
      init_errorHandling();
      init_isEqual();
      init_maybeDeepFreeze();
      init_warnOnce();
      init_stripSymbols();
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/utils.js
  function queryFromPojo(obj) {
    var op = {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "GeneratedClientQuery"
      },
      selectionSet: selectionSetFromObj(obj)
    };
    var out = {
      kind: "Document",
      definitions: [op]
    };
    return out;
  }
  function fragmentFromPojo(obj, typename) {
    var frag = {
      kind: "FragmentDefinition",
      typeCondition: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: typename || "__FakeType"
        }
      },
      name: {
        kind: "Name",
        value: "GeneratedClientQuery"
      },
      selectionSet: selectionSetFromObj(obj)
    };
    var out = {
      kind: "Document",
      definitions: [frag]
    };
    return out;
  }
  function selectionSetFromObj(obj) {
    if (typeof obj === "number" || typeof obj === "boolean" || typeof obj === "string" || typeof obj === "undefined" || obj === null) {
      return null;
    }
    if (Array.isArray(obj)) {
      return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function(key) {
      var field = {
        kind: "Field",
        name: {
          kind: "Name",
          value: key
        }
      };
      var nestedSelSet = selectionSetFromObj(obj[key]);
      if (nestedSelSet) {
        field.selectionSet = nestedSelSet;
      }
      selections.push(field);
    });
    var selectionSet = {
      kind: "SelectionSet",
      selections
    };
    return selectionSet;
  }
  var justTypenameQuery;
  var init_utils = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/utils.js"() {
      justTypenameQuery = {
        kind: "Document",
        definitions: [
          {
            kind: "OperationDefinition",
            operation: "query",
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  alias: null,
                  name: {
                    kind: "Name",
                    value: "__typename"
                  },
                  arguments: [],
                  directives: [],
                  selectionSet: null
                }
              ]
            }
          }
        ]
      };
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/cache.js
  var ApolloCache;
  var init_cache = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/cache.js"() {
      init_lib4();
      init_utils();
      ApolloCache = function() {
        function ApolloCache2() {
        }
        ApolloCache2.prototype.transformDocument = function(document2) {
          return document2;
        };
        ApolloCache2.prototype.transformForLink = function(document2) {
          return document2;
        };
        ApolloCache2.prototype.readQuery = function(options, optimistic) {
          if (optimistic === void 0) {
            optimistic = false;
          }
          return this.read({
            query: options.query,
            variables: options.variables,
            optimistic
          });
        };
        ApolloCache2.prototype.readFragment = function(options, optimistic) {
          if (optimistic === void 0) {
            optimistic = false;
          }
          return this.read({
            query: getFragmentQueryDocument(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic
          });
        };
        ApolloCache2.prototype.writeQuery = function(options) {
          this.write({
            dataId: "ROOT_QUERY",
            result: options.data,
            query: options.query,
            variables: options.variables
          });
        };
        ApolloCache2.prototype.writeFragment = function(options) {
          this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: getFragmentQueryDocument(options.fragment, options.fragmentName)
          });
        };
        ApolloCache2.prototype.writeData = function(_a4) {
          var id = _a4.id, data = _a4.data;
          if (typeof id !== "undefined") {
            var typenameResult = null;
            try {
              typenameResult = this.read({
                rootId: id,
                optimistic: false,
                query: justTypenameQuery
              });
            } catch (e) {
            }
            var __typename = typenameResult && typenameResult.__typename || "__ClientData";
            var dataToWrite = Object.assign({ __typename }, data);
            this.writeFragment({
              id,
              fragment: fragmentFromPojo(dataToWrite, __typename),
              data: dataToWrite
            });
          } else {
            this.writeQuery({ query: queryFromPojo(data), data });
          }
        };
        return ApolloCache2;
      }();
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/types/Cache.js
  var Cache;
  var init_Cache = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/types/Cache.js"() {
      (function(Cache2) {
      })(Cache || (Cache = {}));
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/types/index.js
  var init_types = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/types/index.js"() {
      init_Cache();
    }
  });

  // node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/index.js
  var init_lib5 = __esm({
    "node_modules/apollo-cache-inmemory/node_modules/apollo-cache/lib/index.js"() {
      init_cache();
      init_types();
    }
  });

  // node_modules/apollo-cache-inmemory/lib/fragmentMatcher.js
  var haveWarned2, HeuristicFragmentMatcher, IntrospectionFragmentMatcher;
  var init_fragmentMatcher = __esm({
    "node_modules/apollo-cache-inmemory/lib/fragmentMatcher.js"() {
      init_lib4();
      haveWarned2 = false;
      HeuristicFragmentMatcher = function() {
        function HeuristicFragmentMatcher2() {
        }
        HeuristicFragmentMatcher2.prototype.ensureReady = function() {
          return Promise.resolve();
        };
        HeuristicFragmentMatcher2.prototype.canBypassInit = function() {
          return true;
        };
        HeuristicFragmentMatcher2.prototype.match = function(idValue, typeCondition, context) {
          var obj = context.store.get(idValue.id);
          if (!obj && idValue.id === "ROOT_QUERY") {
            return true;
          }
          if (!obj) {
            return false;
          }
          if (!obj.__typename) {
            if (!haveWarned2) {
              console.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
              console.warn("Could not find __typename on Fragment ", typeCondition, obj);
              console.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
              if (!isTest()) {
                haveWarned2 = true;
              }
            }
            return "heuristic";
          }
          if (obj.__typename === typeCondition) {
            return true;
          }
          warnOnceInDevelopment("You are using the simple (heuristic) fragment matcher, but your queries contain union or interface types. Apollo Client will not be able to accurately map fragments. To make this error go away, use the `IntrospectionFragmentMatcher` as described in the docs: https://www.apollographql.com/docs/react/recipes/fragment-matching.html", "error");
          return "heuristic";
        };
        return HeuristicFragmentMatcher2;
      }();
      IntrospectionFragmentMatcher = function() {
        function IntrospectionFragmentMatcher2(options) {
          if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
          } else {
            this.isReady = false;
          }
          this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher2.prototype.match = function(idValue, typeCondition, context) {
          if (!this.isReady) {
            throw new Error("FragmentMatcher.match() was called before FragmentMatcher.init()");
          }
          var obj = context.store.get(idValue.id);
          if (!obj) {
            return false;
          }
          if (!obj.__typename) {
            throw new Error("Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
          }
          if (obj.__typename === typeCondition) {
            return true;
          }
          var implementingTypes = this.possibleTypesMap[typeCondition];
          if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
            return true;
          }
          return false;
        };
        IntrospectionFragmentMatcher2.prototype.parseIntrospectionResult = function(introspectionResultData) {
          var typeMap = {};
          introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === "UNION" || type.kind === "INTERFACE") {
              typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
              });
            }
          });
          return typeMap;
        };
        return IntrospectionFragmentMatcher2;
      }();
    }
  });

  // node_modules/optimism/lib/cache.js
  var require_cache = __commonJS({
    "node_modules/optimism/lib/cache.js"(exports) {
      "use strict";
      function Cache2(options) {
        this.map = /* @__PURE__ */ new Map();
        this.newest = null;
        this.oldest = null;
        this.max = options && options.max;
        this.dispose = options && options.dispose;
      }
      exports.Cache = Cache2;
      var Cp = Cache2.prototype;
      Cp.has = function(key) {
        return this.map.has(key);
      };
      Cp.get = function(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      };
      function getEntry(cache, key) {
        var entry = cache.map.get(key);
        if (entry && entry !== cache.newest) {
          var older = entry.older;
          var newer = entry.newer;
          if (newer) {
            newer.older = older;
          }
          if (older) {
            older.newer = newer;
          }
          entry.older = cache.newest;
          entry.older.newer = entry;
          entry.newer = null;
          cache.newest = entry;
          if (entry === cache.oldest) {
            cache.oldest = newer;
          }
        }
        return entry;
      }
      Cp.set = function(key, value) {
        var entry = getEntry(this, key);
        if (entry) {
          return entry.value = value;
        }
        entry = {
          key,
          value,
          newer: null,
          older: this.newest
        };
        if (this.newest) {
          this.newest.newer = entry;
        }
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        if (typeof this.max === "number") {
          while (this.oldest && this.map.size > this.max) {
            this.delete(this.oldest.key);
          }
        }
        return entry.value;
      };
      Cp.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
          if (entry === this.newest) {
            this.newest = entry.older;
          }
          if (entry === this.oldest) {
            this.oldest = entry.newer;
          }
          if (entry.newer) {
            entry.newer.older = entry.older;
          }
          if (entry.older) {
            entry.older.newer = entry.newer;
          }
          this.map.delete(key);
          if (typeof this.dispose === "function") {
            this.dispose(key, entry.value);
          }
          return true;
        }
        return false;
      };
    }
  });

  // node_modules/immutable-tuple/dist/tuple.js
  var require_tuple = __commonJS({
    "node_modules/immutable-tuple/dist/tuple.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", { value: true });
      var UniversalWeakMap = function UniversalWeakMap2() {
        this._weakMap = null;
        this._strongMap = null;
        this.data = null;
      };
      UniversalWeakMap.prototype.get = function get2(key) {
        var map2 = this._getMap(key, false);
        if (map2) {
          return map2.get(key);
        }
      };
      UniversalWeakMap.prototype.set = function set2(key, value) {
        this._getMap(key, true).set(key, value);
        return value;
      };
      UniversalWeakMap.prototype._getMap = function _getMap(key, canCreate) {
        if (!canCreate) {
          return isObjRef(key) ? this._weakMap : this._strongMap;
        }
        if (isObjRef(key)) {
          return this._weakMap || (this._weakMap = /* @__PURE__ */ new WeakMap());
        }
        return this._strongMap || (this._strongMap = /* @__PURE__ */ new Map());
      };
      function isObjRef(value) {
        switch (typeof value) {
          case "object":
            if (value === null) {
              return false;
            }
          case "function":
            return true;
          default:
            return false;
        }
      }
      var useSymbol = typeof Symbol === "function";
      var brand = useSymbol ? Symbol.for("immutable-tuple") : "@@__IMMUTABLE_TUPLE__@@";
      var globalKey = useSymbol ? Symbol.for("immutable-tuple-root") : "@@__IMMUTABLE_TUPLE_ROOT__@@";
      function def(obj, name, value, enumerable) {
        Object.defineProperty(obj, name, {
          value,
          enumerable: !!enumerable,
          writable: false,
          configurable: false
        });
        return value;
      }
      var freeze = Object.freeze || function(obj) {
        return obj;
      };
      function forEachArrayMethod(fn) {
        function call(name, mustConvertThisToArray) {
          var desc = Object.getOwnPropertyDescriptor(Array.prototype, name);
          fn(name, desc, !!mustConvertThisToArray);
        }
        call("every");
        call("filter");
        call("find");
        call("findIndex");
        call("forEach");
        call("includes");
        call("indexOf");
        call("join");
        call("lastIndexOf");
        call("map");
        call("reduce");
        call("reduceRight");
        call("slice");
        call("some");
        call("toLocaleString");
        call("toString");
        call("reverse", true);
        call("sort", true);
        call(useSymbol && Symbol.iterator || "@@iterator");
      }
      var root = Array[globalKey] || def(Array, globalKey, new UniversalWeakMap(), false);
      function lookup2() {
        var arguments$1 = arguments;
        var node = root;
        var argc = arguments.length;
        for (var i = 0; i < argc; ++i) {
          var item = arguments$1[i];
          node = node.get(item) || node.set(item, new UniversalWeakMap());
        }
        return node.data || (node.data = /* @__PURE__ */ Object.create(null));
      }
      function tuple() {
        var arguments$1 = arguments;
        var node = lookup2.apply(null, arguments);
        if (node.tuple) {
          return node.tuple;
        }
        var t = Object.create(tuple.prototype);
        var argc = arguments.length;
        for (var i = 0; i < argc; ++i) {
          t[i] = arguments$1[i];
        }
        def(t, "length", argc, false);
        return freeze(node.tuple = t);
      }
      def(tuple.prototype, brand, true, false);
      function isTuple(that) {
        return !!(that && that[brand] === true);
      }
      tuple.isTuple = isTuple;
      function toArray(tuple2) {
        var array = [];
        var i = tuple2.length;
        while (i--) {
          array[i] = tuple2[i];
        }
        return array;
      }
      forEachArrayMethod(function(name, desc, mustConvertThisToArray) {
        var method = desc && desc.value;
        if (typeof method === "function") {
          desc.value = function() {
            var args = [], len = arguments.length;
            while (len--)
              args[len] = arguments[len];
            var result = method.apply(
              mustConvertThisToArray ? toArray(this) : this,
              args
            );
            return Array.isArray(result) ? tuple.apply(void 0, result) : result;
          };
          Object.defineProperty(tuple.prototype, name, desc);
        }
      });
      var ref = Array.prototype;
      var concat4 = ref.concat;
      tuple.prototype.concat = function() {
        var args = [], len = arguments.length;
        while (len--)
          args[len] = arguments[len];
        return tuple.apply(void 0, concat4.apply(toArray(this), args.map(
          function(item) {
            return isTuple(item) ? toArray(item) : item;
          }
        )));
      };
      exports.default = tuple;
      exports.tuple = tuple;
      exports.lookup = lookup2;
    }
  });

  // node_modules/optimism/lib/local.js
  var require_local = __commonJS({
    "node_modules/optimism/lib/local.js"(exports, module) {
      "use strict";
      var fakeNullFiber = new function Fiber2() {
      }();
      var localKey = "_optimism_local";
      function getCurrentFiber() {
        return fakeNullFiber;
      }
      if (typeof module === "object") {
        try {
          Fiber = module["eriuqer".split("").reverse().join("")]("fibers");
          getCurrentFiber = function() {
            return Fiber.current || fakeNullFiber;
          };
        } catch (e) {
        }
      }
      var Fiber;
      exports.get = function() {
        var fiber = getCurrentFiber();
        return fiber[localKey] || (fiber[localKey] = /* @__PURE__ */ Object.create(null));
      };
    }
  });

  // node_modules/optimism/lib/entry.js
  var require_entry = __commonJS({
    "node_modules/optimism/lib/entry.js"(exports) {
      "use strict";
      var getLocal = require_local().get;
      var UNKNOWN_VALUE = /* @__PURE__ */ Object.create(null);
      var emptySetPool = [];
      var entryPool = [];
      exports.POOL_TARGET_SIZE = 100;
      function assert(condition, optionalMessage) {
        if (!condition) {
          throw new Error(optionalMessage || "assertion failure");
        }
      }
      function Entry(fn, key, args) {
        this.parents = /* @__PURE__ */ new Set();
        this.childValues = /* @__PURE__ */ new Map();
        this.dirtyChildren = null;
        reset(this, fn, key, args);
        ++Entry.count;
      }
      Entry.count = 0;
      function reset(entry, fn, key, args) {
        entry.fn = fn;
        entry.key = key;
        entry.args = args;
        entry.value = UNKNOWN_VALUE;
        entry.dirty = true;
        entry.subscribe = null;
        entry.unsubscribe = null;
        entry.recomputing = false;
        entry.reportOrphan = null;
      }
      Entry.acquire = function(fn, key, args) {
        var entry = entryPool.pop();
        if (entry) {
          reset(entry, fn, key, args);
          return entry;
        }
        return new Entry(fn, key, args);
      };
      function release(entry) {
        assert(entry.parents.size === 0);
        assert(entry.childValues.size === 0);
        assert(entry.dirtyChildren === null);
        if (entryPool.length < exports.POOL_TARGET_SIZE) {
          entryPool.push(entry);
        }
      }
      exports.Entry = Entry;
      var Ep = Entry.prototype;
      Ep.recompute = function recompute() {
        if (!rememberParent(this) && maybeReportOrphan(this)) {
          return;
        }
        return recomputeIfDirty(this);
      };
      function maybeReportOrphan(entry) {
        var report = entry.reportOrphan;
        return typeof report === "function" && entry.parents.size === 0 && report(entry) === true;
      }
      Ep.setDirty = function setDirty() {
        if (this.dirty)
          return;
        this.dirty = true;
        this.value = UNKNOWN_VALUE;
        reportDirty(this);
        unsubscribe(this);
      };
      Ep.dispose = function dispose() {
        var entry = this;
        forgetChildren(entry).forEach(maybeReportOrphan);
        unsubscribe(entry);
        entry.parents.forEach(function(parent) {
          parent.setDirty();
          forgetChild(parent, entry);
        });
        release(entry);
      };
      function setClean(entry) {
        entry.dirty = false;
        if (mightBeDirty(entry)) {
          return;
        }
        reportClean(entry);
      }
      function reportDirty(entry) {
        entry.parents.forEach(function(parent) {
          reportDirtyChild(parent, entry);
        });
      }
      function reportClean(entry) {
        entry.parents.forEach(function(parent) {
          reportCleanChild(parent, entry);
        });
      }
      function mightBeDirty(entry) {
        return entry.dirty || entry.dirtyChildren && entry.dirtyChildren.size;
      }
      function reportDirtyChild(entry, child) {
        assert(entry.childValues.has(child));
        assert(mightBeDirty(child));
        if (!entry.dirtyChildren) {
          entry.dirtyChildren = emptySetPool.pop() || /* @__PURE__ */ new Set();
        } else if (entry.dirtyChildren.has(child)) {
          return;
        }
        entry.dirtyChildren.add(child);
        reportDirty(entry);
      }
      function reportCleanChild(entry, child) {
        var cv = entry.childValues;
        assert(cv.has(child));
        assert(!mightBeDirty(child));
        var childValue = cv.get(child);
        if (childValue === UNKNOWN_VALUE) {
          cv.set(child, child.value);
        } else if (childValue !== child.value) {
          entry.setDirty();
        }
        removeDirtyChild(entry, child);
        if (mightBeDirty(entry)) {
          return;
        }
        reportClean(entry);
      }
      function removeDirtyChild(entry, child) {
        var dc = entry.dirtyChildren;
        if (dc) {
          dc.delete(child);
          if (dc.size === 0) {
            if (emptySetPool.length < exports.POOL_TARGET_SIZE) {
              emptySetPool.push(dc);
            }
            entry.dirtyChildren = null;
          }
        }
      }
      function rememberParent(entry) {
        var local = getLocal();
        var parent = local.currentParentEntry;
        if (parent) {
          entry.parents.add(parent);
          if (!parent.childValues.has(entry)) {
            parent.childValues.set(entry, UNKNOWN_VALUE);
          }
          if (mightBeDirty(entry)) {
            reportDirtyChild(parent, entry);
          } else {
            reportCleanChild(parent, entry);
          }
          return parent;
        }
      }
      function recomputeIfDirty(entry) {
        if (entry.dirty) {
          return reallyRecompute(entry);
        }
        if (mightBeDirty(entry)) {
          entry.dirtyChildren.forEach(function(child) {
            assert(entry.childValues.has(child));
            try {
              recomputeIfDirty(child);
            } catch (e) {
              entry.setDirty();
            }
          });
          if (entry.dirty) {
            return reallyRecompute(entry);
          }
        }
        assert(entry.value !== UNKNOWN_VALUE);
        return entry.value;
      }
      function reallyRecompute(entry) {
        assert(!entry.recomputing, "already recomputing");
        entry.recomputing = true;
        var originalChildren = forgetChildren(entry);
        var local = getLocal();
        var parent = local.currentParentEntry;
        local.currentParentEntry = entry;
        var threw = true;
        try {
          entry.value = entry.fn.apply(null, entry.args);
          threw = false;
        } finally {
          entry.recomputing = false;
          assert(local.currentParentEntry === entry);
          local.currentParentEntry = parent;
          if (threw || !subscribe(entry)) {
            entry.setDirty();
          } else {
            setClean(entry);
          }
        }
        originalChildren.forEach(maybeReportOrphan);
        return entry.value;
      }
      var reusableEmptyArray = [];
      function forgetChildren(entry) {
        var children = reusableEmptyArray;
        if (entry.childValues.size > 0) {
          children = [];
          entry.childValues.forEach(function(value, child) {
            forgetChild(entry, child);
            children.push(child);
          });
        }
        assert(entry.dirtyChildren === null);
        return children;
      }
      function forgetChild(entry, child) {
        child.parents.delete(entry);
        entry.childValues.delete(child);
        removeDirtyChild(entry, child);
      }
      function subscribe(entry) {
        if (typeof entry.subscribe === "function") {
          try {
            unsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
          } catch (e) {
            entry.setDirty();
            return false;
          }
        }
        return true;
      }
      function unsubscribe(entry) {
        var unsub = entry.unsubscribe;
        if (typeof unsub === "function") {
          entry.unsubscribe = null;
          unsub();
        }
      }
    }
  });

  // node_modules/optimism/lib/index.js
  var require_lib3 = __commonJS({
    "node_modules/optimism/lib/index.js"(exports) {
      "use strict";
      var Cache2 = require_cache().Cache;
      var tuple = require_tuple().tuple;
      var Entry = require_entry().Entry;
      var getLocal = require_local().get;
      function defaultMakeCacheKey() {
        return tuple.apply(null, arguments);
      }
      exports.defaultMakeCacheKey = defaultMakeCacheKey;
      function normalizeOptions(options) {
        options = options || /* @__PURE__ */ Object.create(null);
        if (typeof options.makeCacheKey !== "function") {
          options.makeCacheKey = defaultMakeCacheKey;
        }
        if (typeof options.max !== "number") {
          options.max = Math.pow(2, 16);
        }
        return options;
      }
      function wrap2(fn, options) {
        options = normalizeOptions(options);
        var disposable = !!options.disposable;
        var cache = new Cache2({
          max: options.max,
          dispose: function(key, entry) {
            entry.dispose();
          }
        });
        function reportOrphan(entry) {
          if (disposable) {
            cache.delete(entry.key);
            return true;
          }
        }
        function optimistic() {
          if (disposable && !getLocal().currentParentEntry) {
            return;
          }
          var key = options.makeCacheKey.apply(null, arguments);
          if (!key) {
            return fn.apply(null, arguments);
          }
          var args = [], len = arguments.length;
          while (len--)
            args[len] = arguments[len];
          var entry = cache.get(key);
          if (entry) {
            entry.args = args;
          } else {
            cache.set(key, entry = Entry.acquire(fn, key, args));
            entry.subscribe = options.subscribe;
            if (disposable) {
              entry.reportOrphan = reportOrphan;
            }
          }
          var value = entry.recompute();
          if (!disposable) {
            return value;
          }
        }
        optimistic.dirty = function() {
          var key = options.makeCacheKey.apply(null, arguments);
          if (!key) {
            return;
          }
          if (!cache.has(key)) {
            return;
          }
          cache.get(key).setDirty();
        };
        return optimistic;
      }
      exports.wrap = wrap2;
    }
  });

  // node_modules/apollo-cache-inmemory/lib/optimism.js
  var wrap, CacheKeyNode;
  var init_optimism = __esm({
    "node_modules/apollo-cache-inmemory/lib/optimism.js"() {
      wrap = require_lib3().wrap;
      CacheKeyNode = function() {
        function CacheKeyNode2() {
          this.children = null;
          this.key = null;
        }
        CacheKeyNode2.prototype.lookup = function() {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return this.lookupArray(args);
        };
        CacheKeyNode2.prototype.lookupArray = function(array) {
          var node = this;
          array.forEach(function(value) {
            node = node.getOrCreate(value);
          });
          return node.key || (node.key = /* @__PURE__ */ Object.create(null));
        };
        CacheKeyNode2.prototype.getOrCreate = function(value) {
          var map2 = this.children || (this.children = /* @__PURE__ */ new Map());
          var node = map2.get(value);
          if (!node) {
            map2.set(value, node = new CacheKeyNode2());
          }
          return node;
        };
        return CacheKeyNode2;
      }();
    }
  });

  // node_modules/apollo-cache-inmemory/lib/depTrackingCache.js
  function defaultNormalizedCacheFactory(seed) {
    return new DepTrackingCache(seed);
  }
  var hasOwn, DepTrackingCache;
  var init_depTrackingCache = __esm({
    "node_modules/apollo-cache-inmemory/lib/depTrackingCache.js"() {
      init_optimism();
      hasOwn = Object.prototype.hasOwnProperty;
      DepTrackingCache = function() {
        function DepTrackingCache2(data) {
          if (data === void 0) {
            data = /* @__PURE__ */ Object.create(null);
          }
          var _this = this;
          this.data = data;
          this.depend = wrap(function(dataId) {
            return _this.data[dataId];
          }, {
            disposable: true,
            makeCacheKey: function(dataId) {
              return dataId;
            }
          });
        }
        DepTrackingCache2.prototype.toObject = function() {
          return this.data;
        };
        DepTrackingCache2.prototype.get = function(dataId) {
          this.depend(dataId);
          return this.data[dataId];
        };
        DepTrackingCache2.prototype.set = function(dataId, value) {
          var oldValue = this.data[dataId];
          if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
          }
        };
        DepTrackingCache2.prototype.delete = function(dataId) {
          if (hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
          }
        };
        DepTrackingCache2.prototype.clear = function() {
          this.replace(null);
        };
        DepTrackingCache2.prototype.replace = function(newData) {
          var _this = this;
          if (newData) {
            Object.keys(newData).forEach(function(dataId) {
              _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
              if (!hasOwn.call(newData, dataId)) {
                _this.delete(dataId);
              }
            });
          } else {
            Object.keys(this.data).forEach(function(dataId) {
              _this.delete(dataId);
            });
          }
        };
        return DepTrackingCache2;
      }();
    }
  });

  // node_modules/apollo-cache-inmemory/lib/queryKeyMaker.js
  function safeSortedKeys(object) {
    var keys = Object.keys(object);
    var keyCount = keys.length;
    var knownKeys = typeof object.kind === "string" && queryKeyMap[object.kind];
    var target = 0;
    for (var source = target; source < keyCount; ++source) {
      var key = keys[source];
      var value = object[key];
      var isObjectOrArray = value !== null && typeof value === "object";
      if (!isObjectOrArray || !knownKeys || knownKeys[key] === true) {
        keys[target++] = key;
      }
    }
    keys.length = target;
    return keys.sort();
  }
  var import_visitor, __assign5, CIRCULAR, objToStr, QueryKeyMaker, PerQueryKeyMaker, queryKeyMap;
  var init_queryKeyMaker = __esm({
    "node_modules/apollo-cache-inmemory/lib/queryKeyMaker.js"() {
      import_visitor = __toESM(require_visitor());
      __assign5 = function() {
        __assign5 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign5.apply(this, arguments);
      };
      CIRCULAR = /* @__PURE__ */ Object.create(null);
      objToStr = Object.prototype.toString;
      QueryKeyMaker = function() {
        function QueryKeyMaker2(cacheKeyRoot) {
          this.cacheKeyRoot = cacheKeyRoot;
          this.perQueryKeyMakers = /* @__PURE__ */ new Map();
        }
        QueryKeyMaker2.prototype.forQuery = function(document2) {
          if (!this.perQueryKeyMakers.has(document2)) {
            this.perQueryKeyMakers.set(document2, new PerQueryKeyMaker(this.cacheKeyRoot, document2));
          }
          return this.perQueryKeyMakers.get(document2);
        };
        return QueryKeyMaker2;
      }();
      PerQueryKeyMaker = function() {
        function PerQueryKeyMaker2(cacheKeyRoot, query) {
          this.cacheKeyRoot = cacheKeyRoot;
          this.query = query;
          this.cache = /* @__PURE__ */ new Map();
          this.lookupArray = this.cacheMethod(this.lookupArray);
          this.lookupObject = this.cacheMethod(this.lookupObject);
          this.lookupFragmentSpread = this.cacheMethod(this.lookupFragmentSpread);
        }
        PerQueryKeyMaker2.prototype.cacheMethod = function(method) {
          var _this = this;
          return function(value) {
            if (_this.cache.has(value)) {
              var cached = _this.cache.get(value);
              if (cached === CIRCULAR) {
                throw new Error("QueryKeyMaker cannot handle circular query structures");
              }
              return cached;
            }
            _this.cache.set(value, CIRCULAR);
            try {
              var result = method.call(_this, value);
              _this.cache.set(value, result);
              return result;
            } catch (e) {
              _this.cache.delete(value);
              throw e;
            }
          };
        };
        PerQueryKeyMaker2.prototype.lookupQuery = function(document2) {
          return this.lookupObject(document2);
        };
        PerQueryKeyMaker2.prototype.lookupSelectionSet = function(selectionSet) {
          return this.lookupObject(selectionSet);
        };
        PerQueryKeyMaker2.prototype.lookupFragmentSpread = function(fragmentSpread) {
          var name = fragmentSpread.name.value;
          var fragment = null;
          this.query.definitions.some(function(definition) {
            if (definition.kind === "FragmentDefinition" && definition.name.value === name) {
              fragment = definition;
              return true;
            }
            return false;
          });
          return this.lookupObject(__assign5({}, fragmentSpread, { fragment }));
        };
        PerQueryKeyMaker2.prototype.lookupAny = function(value) {
          if (Array.isArray(value)) {
            return this.lookupArray(value);
          }
          if (typeof value === "object" && value !== null) {
            if (value.kind === "FragmentSpread") {
              return this.lookupFragmentSpread(value);
            }
            return this.lookupObject(value);
          }
          return value;
        };
        PerQueryKeyMaker2.prototype.lookupArray = function(array) {
          var elements = array.map(this.lookupAny, this);
          return this.cacheKeyRoot.lookup(objToStr.call(array), this.cacheKeyRoot.lookupArray(elements));
        };
        PerQueryKeyMaker2.prototype.lookupObject = function(object) {
          var _this = this;
          var keys = safeSortedKeys(object);
          var values2 = keys.map(function(key) {
            return _this.lookupAny(object[key]);
          });
          return this.cacheKeyRoot.lookup(objToStr.call(object), this.cacheKeyRoot.lookupArray(keys), this.cacheKeyRoot.lookupArray(values2));
        };
        return PerQueryKeyMaker2;
      }();
      queryKeyMap = /* @__PURE__ */ Object.create(null);
      Object.keys(import_visitor.QueryDocumentKeys).forEach(function(parentKind) {
        var childKeys = queryKeyMap[parentKind] = /* @__PURE__ */ Object.create(null);
        import_visitor.QueryDocumentKeys[parentKind].forEach(function(childKey) {
          childKeys[childKey] = true;
        });
        if (parentKind === "FragmentSpread") {
          childKeys["fragment"] = true;
        }
      });
    }
  });

  // node_modules/apollo-cache-inmemory/lib/readFromStore.js
  function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && isIdValue(value)) {
      throw new Error("Missing selection set for object of type " + value.typename + " returned for query field " + field.name.value);
    }
  }
  function defaultFragmentMatcher() {
    return true;
  }
  function readStoreResolver(object, typename, fieldName, args, context, _a4) {
    var resultKey = _a4.resultKey, directives = _a4.directives;
    var storeKeyName = fieldName;
    if (args || directives) {
      storeKeyName = getStoreKeyName(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (object) {
      fieldValue = object[storeKeyName];
      if (typeof fieldValue === "undefined" && context.cacheRedirects && typeof typename === "string") {
        var type = context.cacheRedirects[typename];
        if (type) {
          var resolver = type[fieldName];
          if (resolver) {
            fieldValue = resolver(object, args, {
              getCacheKey: function(storeObj) {
                return toIdValue({
                  id: context.dataIdFromObject(storeObj),
                  typename: storeObj.__typename
                });
              }
            });
          }
        }
      }
    }
    if (typeof fieldValue === "undefined") {
      return {
        result: fieldValue,
        missing: [{
          object,
          fieldName: storeKeyName,
          tolerable: false
        }]
      };
    }
    if (isJsonValue(fieldValue)) {
      fieldValue = fieldValue.json;
    }
    return {
      result: fieldValue
    };
  }
  function merge(target, sources) {
    var pastCopies = [];
    sources.forEach(function(source) {
      mergeHelper(target, source, pastCopies);
    });
    return target;
  }
  function mergeHelper(target, source, pastCopies) {
    if (source !== null && typeof source === "object") {
      if (Object.isExtensible && !Object.isExtensible(target)) {
        target = shallowCopyForMerge(target, pastCopies);
      }
      Object.keys(source).forEach(function(sourceKey) {
        var sourceValue = source[sourceKey];
        if (hasOwn2.call(target, sourceKey)) {
          var targetValue = target[sourceKey];
          if (sourceValue !== targetValue) {
            target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
          }
        } else {
          target[sourceKey] = sourceValue;
        }
      });
    }
    return target;
  }
  function shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === "object" && pastCopies.indexOf(value) < 0) {
      if (Array.isArray(value)) {
        value = value.slice(0);
      } else {
        value = __assign6({}, value);
      }
      pastCopies.push(value);
    }
    return value;
  }
  var __assign6, StoreReader, hasOwn2;
  var init_readFromStore = __esm({
    "node_modules/apollo-cache-inmemory/lib/readFromStore.js"() {
      init_lib4();
      init_optimism();
      init_depTrackingCache();
      init_queryKeyMaker();
      __assign6 = function() {
        __assign6 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign6.apply(this, arguments);
      };
      StoreReader = function() {
        function StoreReader2(cacheKeyRoot) {
          if (cacheKeyRoot === void 0) {
            cacheKeyRoot = new CacheKeyNode();
          }
          var _this = this;
          this.cacheKeyRoot = cacheKeyRoot;
          var reader = this;
          var executeStoreQuery = reader.executeStoreQuery, executeSelectionSet = reader.executeSelectionSet;
          reader.keyMaker = new QueryKeyMaker(cacheKeyRoot);
          this.executeStoreQuery = wrap(function(options) {
            return executeStoreQuery.call(_this, options);
          }, {
            makeCacheKey: function(_a4) {
              var query = _a4.query, rootValue = _a4.rootValue, contextValue = _a4.contextValue, variableValues = _a4.variableValues, fragmentMatcher = _a4.fragmentMatcher;
              if (contextValue.store instanceof DepTrackingCache) {
                return reader.cacheKeyRoot.lookup(reader.keyMaker.forQuery(query).lookupQuery(query), contextValue.store, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
              }
              return;
            }
          });
          this.executeSelectionSet = wrap(function(options) {
            return executeSelectionSet.call(_this, options);
          }, {
            makeCacheKey: function(_a4) {
              var selectionSet = _a4.selectionSet, rootValue = _a4.rootValue, execContext = _a4.execContext;
              if (execContext.contextValue.store instanceof DepTrackingCache) {
                return reader.cacheKeyRoot.lookup(reader.keyMaker.forQuery(execContext.query).lookupSelectionSet(selectionSet), execContext.contextValue.store, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
              }
              return;
            }
          });
        }
        StoreReader2.prototype.readQueryFromStore = function(options) {
          var optsPatch = { returnPartialData: false };
          return this.diffQueryAgainstStore(__assign6({}, options, optsPatch)).result;
        };
        StoreReader2.prototype.diffQueryAgainstStore = function(_a4) {
          var store = _a4.store, query = _a4.query, variables = _a4.variables, previousResult = _a4.previousResult, _b = _a4.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a4.rootId, rootId = _c === void 0 ? "ROOT_QUERY" : _c, fragmentMatcherFunction = _a4.fragmentMatcherFunction, config = _a4.config;
          var queryDefinition = getQueryDefinition(query);
          variables = assign({}, getDefaultValues(queryDefinition), variables);
          var context = {
            store,
            dataIdFromObject: config && config.dataIdFromObject || null,
            cacheRedirects: config && config.cacheRedirects || {}
          };
          var execResult = this.executeStoreQuery({
            query,
            rootValue: {
              type: "id",
              id: rootId,
              generated: true,
              typename: "Query"
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
          });
          var hasMissingFields = execResult.missing && execResult.missing.length > 0;
          if (hasMissingFields && !returnPartialData) {
            execResult.missing.forEach(function(info) {
              if (info.tolerable)
                return;
              throw new Error("Can't find field " + info.fieldName + " on object " + JSON.stringify(info.object, null, 2) + ".");
            });
          }
          if (previousResult) {
            if (isEqual(previousResult, execResult.result)) {
              execResult.result = previousResult;
            }
          }
          return {
            result: execResult.result,
            complete: !hasMissingFields
          };
        };
        StoreReader2.prototype.executeStoreQuery = function(_a4) {
          var query = _a4.query, rootValue = _a4.rootValue, contextValue = _a4.contextValue, variableValues = _a4.variableValues, _b = _a4.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
          var mainDefinition = getMainDefinition(query);
          var fragments = getFragmentDefinitions(query);
          var fragmentMap = createFragmentMap(fragments);
          var execContext = {
            query,
            fragmentMap,
            contextValue,
            variableValues,
            fragmentMatcher
          };
          return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue,
            execContext
          });
        };
        StoreReader2.prototype.executeSelectionSet = function(_a4) {
          var _this = this;
          var selectionSet = _a4.selectionSet, rootValue = _a4.rootValue, execContext = _a4.execContext;
          var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
          var finalResult = {
            result: {}
          };
          var objectsToMerge = [];
          var object = contextValue.store.get(rootValue.id);
          var typename = object && object.__typename || rootValue.id === "ROOT_QUERY" && "Query" || void 0;
          function handleMissing(result) {
            var _a5;
            if (result.missing) {
              finalResult.missing = finalResult.missing || [];
              (_a5 = finalResult.missing).push.apply(_a5, result.missing);
            }
            return result.result;
          }
          selectionSet.selections.forEach(function(selection) {
            var _a5;
            if (!shouldInclude(selection, variables)) {
              return;
            }
            if (isField(selection)) {
              var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
              if (typeof fieldResult !== "undefined") {
                objectsToMerge.push((_a5 = {}, _a5[resultKeyNameFromField(selection)] = fieldResult, _a5));
              }
            } else {
              var fragment = void 0;
              if (isInlineFragment(selection)) {
                fragment = selection;
              } else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) {
                  throw new Error("No fragment named " + selection.name.value);
                }
              }
              var typeCondition = fragment.typeCondition.name.value;
              var match2 = execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
              if (match2) {
                var fragmentExecResult = _this.executeSelectionSet({
                  selectionSet: fragment.selectionSet,
                  rootValue,
                  execContext
                });
                if (match2 === "heuristic" && fragmentExecResult.missing) {
                  fragmentExecResult = __assign6({}, fragmentExecResult, { missing: fragmentExecResult.missing.map(function(info) {
                    return __assign6({}, info, { tolerable: true });
                  }) });
                }
                objectsToMerge.push(handleMissing(fragmentExecResult));
              }
            }
          });
          merge(finalResult.result, objectsToMerge);
          return finalResult;
        };
        StoreReader2.prototype.executeField = function(object, typename, field, execContext) {
          var variables = execContext.variableValues, contextValue = execContext.contextValue;
          var fieldName = field.name.value;
          var args = argumentsObjectFromField(field, variables);
          var info = {
            resultKey: resultKeyNameFromField(field),
            directives: getDirectiveInfoFromField(field, variables)
          };
          var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
          if (Array.isArray(readStoreResult.result)) {
            return this.combineExecResults(readStoreResult, this.executeSubSelectedArray(field, readStoreResult.result, execContext));
          }
          if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            return readStoreResult;
          }
          if (readStoreResult.result == null) {
            return readStoreResult;
          }
          return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext
          }));
        };
        StoreReader2.prototype.combineExecResults = function() {
          var execResults = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            execResults[_i] = arguments[_i];
          }
          var missing = null;
          execResults.forEach(function(execResult) {
            if (execResult.missing) {
              missing = missing || [];
              missing.push.apply(missing, execResult.missing);
            }
          });
          return {
            result: execResults.pop().result,
            missing
          };
        };
        StoreReader2.prototype.executeSubSelectedArray = function(field, result, execContext) {
          var _this = this;
          var missing = null;
          function handleMissing(childResult) {
            if (childResult.missing) {
              missing = missing || [];
              missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
          }
          result = result.map(function(item) {
            if (item === null) {
              return null;
            }
            if (Array.isArray(item)) {
              return handleMissing(_this.executeSubSelectedArray(field, item, execContext));
            }
            if (field.selectionSet) {
              return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext
              }));
            }
            assertSelectionSetForIdValue(field, item);
            return item;
          });
          return { result, missing };
        };
        return StoreReader2;
      }();
      hasOwn2 = Object.prototype.hasOwnProperty;
    }
  });

  // node_modules/apollo-cache-inmemory/lib/objectCache.js
  var ObjectCache;
  var init_objectCache = __esm({
    "node_modules/apollo-cache-inmemory/lib/objectCache.js"() {
      ObjectCache = function() {
        function ObjectCache2(data) {
          if (data === void 0) {
            data = /* @__PURE__ */ Object.create(null);
          }
          this.data = data;
        }
        ObjectCache2.prototype.toObject = function() {
          return this.data;
        };
        ObjectCache2.prototype.get = function(dataId) {
          return this.data[dataId];
        };
        ObjectCache2.prototype.set = function(dataId, value) {
          this.data[dataId] = value;
        };
        ObjectCache2.prototype.delete = function(dataId) {
          this.data[dataId] = void 0;
        };
        ObjectCache2.prototype.clear = function() {
          this.data = /* @__PURE__ */ Object.create(null);
        };
        ObjectCache2.prototype.replace = function(newData) {
          this.data = newData || /* @__PURE__ */ Object.create(null);
        };
        return ObjectCache2;
      }();
    }
  });

  // node_modules/apollo-cache-inmemory/lib/writeToStore.js
  function enhanceErrorWithDocument(error, document2) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + (0, import_printer2.print)(document2));
    enhancedError.message += "\n" + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
  }
  function isGeneratedId(id) {
    return id[0] === "$";
  }
  function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) {
      return false;
    }
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
      var value = generated[key];
      var realValue = real[key];
      if (isIdValue(value) && isGeneratedId(value.id) && isIdValue(realValue) && !isEqual(value, realValue) && mergeWithGenerated(value.id, realValue.id, cache)) {
        madeChanges = true;
      }
    });
    cache.delete(generatedKey);
    var newRealValue = __assign7({}, generated, real);
    if (isEqual(newRealValue, real)) {
      return madeChanges;
    }
    cache.set(realKey, newRealValue);
    return true;
  }
  function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
      return false;
    }
    if (processedData[dataId]) {
      if (processedData[dataId].indexOf(field) >= 0) {
        return true;
      } else {
        processedData[dataId].push(field);
      }
    } else {
      processedData[dataId] = [field];
    }
    return false;
  }
  var import_printer2, __extends3, __assign7, WriteError, StoreWriter;
  var init_writeToStore = __esm({
    "node_modules/apollo-cache-inmemory/lib/writeToStore.js"() {
      import_printer2 = __toESM(require_printer());
      init_lib4();
      init_objectCache();
      init_depTrackingCache();
      __extends3 = function() {
        var extendStatics4 = function(d, b) {
          extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
          } || function(d2, b2) {
            for (var p in b2)
              if (b2.hasOwnProperty(p))
                d2[p] = b2[p];
          };
          return extendStatics4(d, b);
        };
        return function(d, b) {
          extendStatics4(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      __assign7 = function() {
        __assign7 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign7.apply(this, arguments);
      };
      WriteError = function(_super) {
        __extends3(WriteError2, _super);
        function WriteError2() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          _this.type = "WriteError";
          return _this;
        }
        return WriteError2;
      }(Error);
      StoreWriter = function() {
        function StoreWriter2() {
        }
        StoreWriter2.prototype.writeQueryToStore = function(_a4) {
          var query = _a4.query, result = _a4.result, _b = _a4.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a4.variables, dataIdFromObject = _a4.dataIdFromObject, fragmentMatcherFunction = _a4.fragmentMatcherFunction;
          return this.writeResultToStore({
            dataId: "ROOT_QUERY",
            result,
            document: query,
            store,
            variables,
            dataIdFromObject,
            fragmentMatcherFunction
          });
        };
        StoreWriter2.prototype.writeResultToStore = function(_a4) {
          var dataId = _a4.dataId, result = _a4.result, document2 = _a4.document, _b = _a4.store, store = _b === void 0 ? defaultNormalizedCacheFactory() : _b, variables = _a4.variables, dataIdFromObject = _a4.dataIdFromObject, fragmentMatcherFunction = _a4.fragmentMatcherFunction;
          var operationDefinition = getOperationDefinition(document2);
          try {
            return this.writeSelectionSetToStore({
              result,
              dataId,
              selectionSet: operationDefinition.selectionSet,
              context: {
                store,
                processedData: {},
                variables: assign({}, getDefaultValues(operationDefinition), variables),
                dataIdFromObject,
                fragmentMap: createFragmentMap(getFragmentDefinitions(document2)),
                fragmentMatcherFunction
              }
            });
          } catch (e) {
            throw enhanceErrorWithDocument(e, document2);
          }
        };
        StoreWriter2.prototype.writeSelectionSetToStore = function(_a4) {
          var _this = this;
          var result = _a4.result, dataId = _a4.dataId, selectionSet = _a4.selectionSet, context = _a4.context;
          var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
          selectionSet.selections.forEach(function(selection) {
            if (!shouldInclude(selection, variables)) {
              return;
            }
            if (isField(selection)) {
              var resultFieldKey = resultKeyNameFromField(selection);
              var value = result[resultFieldKey];
              if (typeof value !== "undefined") {
                _this.writeFieldToStore({
                  dataId,
                  value,
                  field: selection,
                  context
                });
              } else {
                var isDefered = selection.directives && selection.directives.length && selection.directives.some(function(directive) {
                  return directive.name && directive.name.value === "defer";
                });
                if (!isDefered && context.fragmentMatcherFunction) {
                  if (!isProduction()) {
                    console.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                  }
                }
              }
            } else {
              var fragment = void 0;
              if (isInlineFragment(selection)) {
                fragment = selection;
              } else {
                fragment = (fragmentMap || {})[selection.name.value];
                if (!fragment) {
                  throw new Error("No fragment named " + selection.name.value + ".");
                }
              }
              var matches = true;
              if (context.fragmentMatcherFunction && fragment.typeCondition) {
                var idValue = toIdValue({ id: "self", typename: void 0 });
                var fakeContext = {
                  store: new ObjectCache({ self: result }),
                  cacheRedirects: {}
                };
                var match2 = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                if (!isProduction() && match2 === "heuristic") {
                  console.error("WARNING: heuristic fragment matching going on!");
                }
                matches = !!match2;
              }
              if (matches) {
                _this.writeSelectionSetToStore({
                  result,
                  selectionSet: fragment.selectionSet,
                  dataId,
                  context
                });
              }
            }
          });
          return store;
        };
        StoreWriter2.prototype.writeFieldToStore = function(_a4) {
          var field = _a4.field, value = _a4.value, dataId = _a4.dataId, context = _a4.context;
          var _b;
          var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
          var storeValue;
          var storeObject;
          var storeFieldName = storeKeyNameFromField(field, variables);
          if (!field.selectionSet || value === null) {
            storeValue = value != null && typeof value === "object" ? { type: "json", json: value } : value;
          } else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
          } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) {
              valueDataId = "$" + valueDataId;
            }
            if (dataIdFromObject) {
              var semanticId = dataIdFromObject(value);
              if (semanticId && isGeneratedId(semanticId)) {
                throw new Error('IDs returned by dataIdFromObject cannot begin with the "$" character.');
              }
              if (semanticId || typeof semanticId === "number" && semanticId === 0) {
                valueDataId = semanticId;
                generated = false;
              }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) {
              this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context
              });
            }
            var typename = value.__typename;
            storeValue = toIdValue({ id: valueDataId, typename }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && isIdValue(escapedId)) {
              var hadTypename = escapedId.typename !== void 0;
              var hasTypename = typename !== void 0;
              var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
              if (generated && !escapedId.generated && !typenameChanged) {
                throw new Error("Store error: the application attempted to write an object with no provided id" + (" but the store already contains an id of " + escapedId.id + " for this object. The selectionSet") + " that was trying to be written is:\n" + (0, import_printer2.print)(field));
              }
              if (hadTypename && !hasTypename) {
                throw new Error("Store error: the application attempted to write an object with no provided typename" + (" but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet") + " that was trying to be written is:\n" + (0, import_printer2.print)(field));
              }
              if (escapedId.generated) {
                if (typenameChanged) {
                  if (!generated) {
                    store.delete(escapedId.id);
                  }
                } else {
                  mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
              }
            }
          }
          storeObject = store.get(dataId);
          if (!storeObject || !isEqual(storeValue, storeObject[storeFieldName])) {
            store.set(dataId, __assign7({}, storeObject, (_b = {}, _b[storeFieldName] = storeValue, _b)));
          }
        };
        StoreWriter2.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
          var _this = this;
          return value.map(function(item, index) {
            if (item === null) {
              return null;
            }
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) {
              return _this.processArrayValue(item, itemDataId, selectionSet, context);
            }
            var generated = true;
            if (context.dataIdFromObject) {
              var semanticId = context.dataIdFromObject(item);
              if (semanticId) {
                itemDataId = semanticId;
                generated = false;
              }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
              _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet,
                context
              });
            }
            return toIdValue({ id: itemDataId, typename: item.__typename }, generated);
          });
        };
        return StoreWriter2;
      }();
    }
  });

  // node_modules/apollo-cache-inmemory/lib/recordingCache.js
  function record(startingState, transaction) {
    var recordingCache = new RecordingCache(startingState);
    return recordingCache.record(transaction);
  }
  var __assign8, RecordingCache;
  var init_recordingCache = __esm({
    "node_modules/apollo-cache-inmemory/lib/recordingCache.js"() {
      __assign8 = function() {
        __assign8 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign8.apply(this, arguments);
      };
      RecordingCache = function() {
        function RecordingCache2(data) {
          if (data === void 0) {
            data = {};
          }
          this.data = data;
          this.recordedData = {};
        }
        RecordingCache2.prototype.record = function(transaction) {
          transaction(this);
          var recordedData = this.recordedData;
          this.recordedData = {};
          return recordedData;
        };
        RecordingCache2.prototype.toObject = function() {
          return __assign8({}, this.data, this.recordedData);
        };
        RecordingCache2.prototype.get = function(dataId) {
          if (this.recordedData.hasOwnProperty(dataId)) {
            return this.recordedData[dataId];
          }
          return this.data[dataId];
        };
        RecordingCache2.prototype.set = function(dataId, value) {
          if (this.get(dataId) !== value) {
            this.recordedData[dataId] = value;
          }
        };
        RecordingCache2.prototype.delete = function(dataId) {
          this.recordedData[dataId] = void 0;
        };
        RecordingCache2.prototype.clear = function() {
          var _this = this;
          Object.keys(this.data).forEach(function(dataId) {
            return _this.delete(dataId);
          });
          this.recordedData = {};
        };
        RecordingCache2.prototype.replace = function(newData) {
          this.clear();
          this.recordedData = __assign8({}, newData);
        };
        return RecordingCache2;
      }();
    }
  });

  // node_modules/apollo-cache-inmemory/lib/inMemoryCache.js
  function defaultDataIdFromObject(result) {
    if (result.__typename) {
      if (result.id !== void 0) {
        return result.__typename + ":" + result.id;
      }
      if (result._id !== void 0) {
        return result.__typename + ":" + result._id;
      }
    }
    return null;
  }
  var __extends4, __assign9, defaultConfig, InMemoryCache;
  var init_inMemoryCache = __esm({
    "node_modules/apollo-cache-inmemory/lib/inMemoryCache.js"() {
      init_fixPolyfills();
      init_lib5();
      init_lib4();
      init_fragmentMatcher();
      init_readFromStore();
      init_writeToStore();
      init_depTrackingCache();
      init_optimism();
      init_recordingCache();
      __extends4 = function() {
        var extendStatics4 = function(d, b) {
          extendStatics4 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
            d2.__proto__ = b2;
          } || function(d2, b2) {
            for (var p in b2)
              if (b2.hasOwnProperty(p))
                d2[p] = b2[p];
          };
          return extendStatics4(d, b);
        };
        return function(d, b) {
          extendStatics4(d, b);
          function __() {
            this.constructor = d;
          }
          d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
      }();
      __assign9 = function() {
        __assign9 = Object.assign || function(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign9.apply(this, arguments);
      };
      defaultConfig = {
        fragmentMatcher: new HeuristicFragmentMatcher(),
        dataIdFromObject: defaultDataIdFromObject,
        addTypename: true
      };
      InMemoryCache = function(_super) {
        __extends4(InMemoryCache2, _super);
        function InMemoryCache2(config) {
          if (config === void 0) {
            config = {};
          }
          var _this = _super.call(this) || this;
          _this.optimistic = [];
          _this.watches = /* @__PURE__ */ new Set();
          _this.typenameDocumentCache = /* @__PURE__ */ new Map();
          _this.cacheKeyRoot = new CacheKeyNode();
          _this.silenceBroadcast = false;
          _this.config = __assign9({}, defaultConfig, config);
          if (_this.config.customResolvers) {
            console.warn("customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.");
            _this.config.cacheRedirects = _this.config.customResolvers;
          }
          if (_this.config.cacheResolvers) {
            console.warn("cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.");
            _this.config.cacheRedirects = _this.config.cacheResolvers;
          }
          _this.addTypename = _this.config.addTypename;
          _this.data = defaultNormalizedCacheFactory();
          _this.storeReader = new StoreReader(_this.cacheKeyRoot);
          _this.storeWriter = new StoreWriter();
          var cache = _this;
          var maybeBroadcastWatch = cache.maybeBroadcastWatch;
          _this.maybeBroadcastWatch = wrap(function(c) {
            return maybeBroadcastWatch.call(_this, c);
          }, {
            makeCacheKey: function(c) {
              if (c.optimistic && cache.optimistic.length > 0) {
                return;
              }
              if (c.previousResult) {
                return;
              }
              if (cache.data instanceof DepTrackingCache) {
                return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
              }
            }
          });
          return _this;
        }
        InMemoryCache2.prototype.restore = function(data) {
          if (data)
            this.data.replace(data);
          return this;
        };
        InMemoryCache2.prototype.extract = function(optimistic) {
          if (optimistic === void 0) {
            optimistic = false;
          }
          if (optimistic && this.optimistic.length > 0) {
            var patches = this.optimistic.map(function(opt) {
              return opt.data;
            });
            return Object.assign.apply(Object, [{}, this.data.toObject()].concat(patches));
          }
          return this.data.toObject();
        };
        InMemoryCache2.prototype.read = function(query) {
          if (query.rootId && this.data.get(query.rootId) === void 0) {
            return null;
          }
          var store = query.optimistic && this.optimistic.length ? defaultNormalizedCacheFactory(this.extract(true)) : this.data;
          return this.storeReader.readQueryFromStore({
            store,
            query: this.transformDocument(query.query),
            variables: query.variables,
            rootId: query.rootId,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            previousResult: query.previousResult,
            config: this.config
          });
        };
        InMemoryCache2.prototype.write = function(write) {
          this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: this.config.fragmentMatcher.match
          });
          this.broadcastWatches();
        };
        InMemoryCache2.prototype.diff = function(query) {
          var store = query.optimistic && this.optimistic.length ? defaultNormalizedCacheFactory(this.extract(true)) : this.data;
          return this.storeReader.diffQueryAgainstStore({
            store,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            config: this.config
          });
        };
        InMemoryCache2.prototype.watch = function(watch) {
          var _this = this;
          this.watches.add(watch);
          return function() {
            _this.watches.delete(watch);
          };
        };
        InMemoryCache2.prototype.evict = function(query) {
          throw new Error("eviction is not implemented on InMemory Cache");
        };
        InMemoryCache2.prototype.reset = function() {
          this.data.clear();
          this.broadcastWatches();
          return Promise.resolve();
        };
        InMemoryCache2.prototype.removeOptimistic = function(id) {
          var _this = this;
          var toPerform = this.optimistic.filter(function(item) {
            return item.id !== id;
          });
          this.optimistic = [];
          toPerform.forEach(function(change) {
            _this.recordOptimisticTransaction(change.transaction, change.id);
          });
          this.broadcastWatches();
        };
        InMemoryCache2.prototype.performTransaction = function(transaction) {
          var alreadySilenced = this.silenceBroadcast;
          this.silenceBroadcast = true;
          transaction(this);
          if (!alreadySilenced) {
            this.silenceBroadcast = false;
          }
          this.broadcastWatches();
        };
        InMemoryCache2.prototype.recordOptimisticTransaction = function(transaction, id) {
          var _this = this;
          this.silenceBroadcast = true;
          var patch = record(this.extract(true), function(recordingCache) {
            var dataCache = _this.data;
            _this.data = recordingCache;
            _this.performTransaction(transaction);
            _this.data = dataCache;
          });
          this.optimistic.push({
            id,
            transaction,
            data: patch
          });
          this.silenceBroadcast = false;
          this.broadcastWatches();
        };
        InMemoryCache2.prototype.transformDocument = function(document2) {
          if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document2);
            if (!result) {
              result = addTypenameToDocument(document2);
              this.typenameDocumentCache.set(document2, result);
              this.typenameDocumentCache.set(result, result);
            }
            return result;
          }
          return document2;
        };
        InMemoryCache2.prototype.readQuery = function(options, optimistic) {
          if (optimistic === void 0) {
            optimistic = false;
          }
          return this.read({
            query: options.query,
            variables: options.variables,
            optimistic
          });
        };
        InMemoryCache2.prototype.readFragment = function(options, optimistic) {
          if (optimistic === void 0) {
            optimistic = false;
          }
          return this.read({
            query: this.transformDocument(getFragmentQueryDocument(options.fragment, options.fragmentName)),
            variables: options.variables,
            rootId: options.id,
            optimistic
          });
        };
        InMemoryCache2.prototype.writeQuery = function(options) {
          this.write({
            dataId: "ROOT_QUERY",
            result: options.data,
            query: this.transformDocument(options.query),
            variables: options.variables
          });
        };
        InMemoryCache2.prototype.writeFragment = function(options) {
          this.write({
            dataId: options.id,
            result: options.data,
            query: this.transformDocument(getFragmentQueryDocument(options.fragment, options.fragmentName)),
            variables: options.variables
          });
        };
        InMemoryCache2.prototype.broadcastWatches = function() {
          var _this = this;
          if (!this.silenceBroadcast) {
            var optimistic_1 = this.optimistic.length > 0;
            this.watches.forEach(function(c) {
              _this.maybeBroadcastWatch(c);
              if (optimistic_1) {
                _this.maybeBroadcastWatch.dirty(c);
              }
            });
          }
        };
        InMemoryCache2.prototype.maybeBroadcastWatch = function(c) {
          c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
          }));
        };
        return InMemoryCache2;
      }(ApolloCache);
    }
  });

  // node_modules/apollo-cache-inmemory/lib/index.js
  var init_lib6 = __esm({
    "node_modules/apollo-cache-inmemory/lib/index.js"() {
      init_inMemoryCache();
      init_readFromStore();
      init_writeToStore();
      init_fragmentMatcher();
      init_objectCache();
      init_recordingCache();
    }
  });

  // node_modules/apollo-link-error/node_modules/tslib/tslib.es6.js
  function __extends5(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }
  var extendStatics, __assign10;
  var init_tslib_es6 = __esm({
    "node_modules/apollo-link-error/node_modules/tslib/tslib.es6.js"() {
      extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      __assign10 = function() {
        __assign10 = Object.assign || function __assign14(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign10.apply(this, arguments);
      };
    }
  });

  // node_modules/apollo-link-error/node_modules/zen-observable-ts/lib/bundle.esm.js
  var import_zen_observable, Observable3, bundle_esm_default;
  var init_bundle_esm = __esm({
    "node_modules/apollo-link-error/node_modules/zen-observable-ts/lib/bundle.esm.js"() {
      import_zen_observable = __toESM(require_zen_observable());
      Observable3 = import_zen_observable.default;
      bundle_esm_default = Observable3;
    }
  });

  // node_modules/ts-invariant/node_modules/tslib/tslib.es6.js
  function __extends6(d, b) {
    extendStatics2(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }
  var extendStatics2;
  var init_tslib_es62 = __esm({
    "node_modules/ts-invariant/node_modules/tslib/tslib.es6.js"() {
      extendStatics2 = function(d, b) {
        extendStatics2 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics2(d, b);
      };
    }
  });

  // node_modules/ts-invariant/lib/invariant.esm.js
  function invariant(condition, message) {
    if (!condition) {
      throw new InvariantError(message);
    }
  }
  function wrapConsoleMethod(method) {
    return function() {
      return console[method].apply(console, arguments);
    };
  }
  var genericMessage, _a, setPrototypeOf, InvariantError, processStub;
  var init_invariant_esm = __esm({
    "node_modules/ts-invariant/lib/invariant.esm.js"() {
      init_tslib_es62();
      genericMessage = "Invariant Violation";
      _a = Object.setPrototypeOf;
      setPrototypeOf = _a === void 0 ? function(obj, proto) {
        obj.__proto__ = proto;
        return obj;
      } : _a;
      InvariantError = /** @class */
      function(_super) {
        __extends6(InvariantError2, _super);
        function InvariantError2(message) {
          if (message === void 0) {
            message = genericMessage;
          }
          var _this = _super.call(this, typeof message === "number" ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
          _this.framesToPop = 1;
          _this.name = genericMessage;
          setPrototypeOf(_this, InvariantError2.prototype);
          return _this;
        }
        return InvariantError2;
      }(Error);
      (function(invariant2) {
        invariant2.warn = wrapConsoleMethod("warn");
        invariant2.error = wrapConsoleMethod("error");
      })(invariant || (invariant = {}));
      processStub = { env: {} };
      if (typeof process === "object") {
        processStub = process;
      } else
        try {
          Function("stub", "process = stub")(processStub);
        } catch (atLeastWeTried) {
        }
    }
  });

  // node_modules/apollo-link-error/node_modules/apollo-utilities/node_modules/tslib/tslib.es6.js
  var init_tslib_es63 = __esm({
    "node_modules/apollo-link-error/node_modules/apollo-utilities/node_modules/tslib/tslib.es6.js"() {
    }
  });

  // node_modules/apollo-link-error/node_modules/@wry/equality/lib/equality.esm.js
  var _a2, toString2, hasOwnProperty;
  var init_equality_esm = __esm({
    "node_modules/apollo-link-error/node_modules/@wry/equality/lib/equality.esm.js"() {
      _a2 = Object.prototype;
      toString2 = _a2.toString;
      hasOwnProperty = _a2.hasOwnProperty;
    }
  });

  // node_modules/apollo-link-error/node_modules/apollo-utilities/lib/bundle.esm.js
  function getOperationName(doc) {
    return doc.definitions.filter(function(definition) {
      return definition.kind === "OperationDefinition" && definition.name;
    }).map(function(x) {
      return x.name.value;
    })[0] || null;
  }
  var import_visitor2, import_fast_json_stable_stringify2, canUseWeakMap;
  var init_bundle_esm2 = __esm({
    "node_modules/apollo-link-error/node_modules/apollo-utilities/lib/bundle.esm.js"() {
      import_visitor2 = __toESM(require_visitor());
      init_invariant_esm();
      init_tslib_es63();
      import_fast_json_stable_stringify2 = __toESM(require_fast_json_stable_stringify());
      init_equality_esm();
      canUseWeakMap = typeof WeakMap === "function" && !(typeof navigator === "object" && navigator.product === "ReactNative");
    }
  });

  // node_modules/apollo-link-error/node_modules/apollo-link/lib/bundle.esm.js
  function validateOperation(operation) {
    var OPERATION_FIELDS = [
      "query",
      "operationName",
      "variables",
      "extensions",
      "context"
    ];
    for (var _i = 0, _a4 = Object.keys(operation); _i < _a4.length; _i++) {
      var key = _a4[_i];
      if (OPERATION_FIELDS.indexOf(key) < 0) {
        throw true ? new InvariantError(2) : new InvariantError("illegal argument: " + key);
      }
    }
    return operation;
  }
  function isTerminating(link) {
    return link.request.length <= 1;
  }
  function transformOperation(operation) {
    var transformedOperation = {
      variables: operation.variables || {},
      extensions: operation.extensions || {},
      operationName: operation.operationName,
      query: operation.query
    };
    if (!transformedOperation.operationName) {
      transformedOperation.operationName = typeof transformedOperation.query !== "string" ? getOperationName(transformedOperation.query) : "";
    }
    return transformedOperation;
  }
  function createOperation(starting, operation) {
    var context = __assign10({}, starting);
    var setContext = function(next) {
      if (typeof next === "function") {
        context = __assign10({}, context, next(context));
      } else {
        context = __assign10({}, context, next);
      }
    };
    var getContext = function() {
      return __assign10({}, context);
    };
    Object.defineProperty(operation, "setContext", {
      enumerable: false,
      value: setContext
    });
    Object.defineProperty(operation, "getContext", {
      enumerable: false,
      value: getContext
    });
    Object.defineProperty(operation, "toKey", {
      enumerable: false,
      value: function() {
        return getKey(operation);
      }
    });
    return operation;
  }
  function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
  }
  function passthrough(op, forward) {
    return forward ? forward(op) : bundle_esm_default.of();
  }
  function toLink(handler) {
    return typeof handler === "function" ? new ApolloLink3(handler) : handler;
  }
  function empty() {
    return new ApolloLink3(function() {
      return bundle_esm_default.of();
    });
  }
  function from(links) {
    if (links.length === 0)
      return empty();
    return links.map(toLink).reduce(function(x, y) {
      return x.concat(y);
    });
  }
  function split(test2, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink3(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
      return new ApolloLink3(function(operation) {
        return test2(operation) ? leftLink.request(operation) || bundle_esm_default.of() : rightLink.request(operation) || bundle_esm_default.of();
      });
    } else {
      return new ApolloLink3(function(operation, forward) {
        return test2(operation) ? leftLink.request(operation, forward) || bundle_esm_default.of() : rightLink.request(operation, forward) || bundle_esm_default.of();
      });
    }
  }
  function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || bundle_esm_default.of();
  }
  var LinkError, concat, ApolloLink3;
  var init_bundle_esm3 = __esm({
    "node_modules/apollo-link-error/node_modules/apollo-link/lib/bundle.esm.js"() {
      init_bundle_esm();
      init_bundle_esm();
      init_invariant_esm();
      init_tslib_es6();
      init_bundle_esm2();
      LinkError = function(_super) {
        __extends5(LinkError3, _super);
        function LinkError3(message, link) {
          var _this = _super.call(this, message) || this;
          _this.link = link;
          return _this;
        }
        return LinkError3;
      }(Error);
      concat = function(first2, second) {
        var firstLink = toLink(first2);
        if (isTerminating(firstLink)) {
          return firstLink;
        }
        var nextLink = toLink(second);
        if (isTerminating(nextLink)) {
          return new ApolloLink3(function(operation) {
            return firstLink.request(operation, function(op) {
              return nextLink.request(op) || bundle_esm_default.of();
            }) || bundle_esm_default.of();
          });
        } else {
          return new ApolloLink3(function(operation, forward) {
            return firstLink.request(operation, function(op) {
              return nextLink.request(op, forward) || bundle_esm_default.of();
            }) || bundle_esm_default.of();
          });
        }
      };
      ApolloLink3 = function() {
        function ApolloLink6(request) {
          if (request)
            this.request = request;
        }
        ApolloLink6.prototype.split = function(test2, left, right) {
          return this.concat(split(test2, left, right || new ApolloLink6(passthrough)));
        };
        ApolloLink6.prototype.concat = function(next) {
          return concat(this, next);
        };
        ApolloLink6.prototype.request = function(operation, forward) {
          throw true ? new InvariantError(1) : new InvariantError("request is not implemented");
        };
        ApolloLink6.empty = empty;
        ApolloLink6.from = from;
        ApolloLink6.split = split;
        ApolloLink6.execute = execute;
        return ApolloLink6;
      }();
    }
  });

  // node_modules/apollo-link-error/lib/bundle.esm.js
  function onError(errorHandler) {
    return new ApolloLink3(function(operation, forward) {
      return new bundle_esm_default(function(observer) {
        var sub;
        var retriedSub;
        var retriedResult;
        try {
          sub = forward(operation).subscribe({
            next: function(result) {
              if (result.errors) {
                retriedResult = errorHandler({
                  graphQLErrors: result.errors,
                  response: result,
                  operation,
                  forward
                });
                if (retriedResult) {
                  retriedSub = retriedResult.subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                  });
                  return;
                }
              }
              observer.next(result);
            },
            error: function(networkError) {
              retriedResult = errorHandler({
                operation,
                networkError,
                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                forward
              });
              if (retriedResult) {
                retriedSub = retriedResult.subscribe({
                  next: observer.next.bind(observer),
                  error: observer.error.bind(observer),
                  complete: observer.complete.bind(observer)
                });
                return;
              }
              observer.error(networkError);
            },
            complete: function() {
              if (!retriedResult) {
                observer.complete.bind(observer)();
              }
            }
          });
        } catch (e) {
          errorHandler({ networkError: e, operation, forward });
          observer.error(e);
        }
        return function() {
          if (sub)
            sub.unsubscribe();
          if (retriedSub)
            sub.unsubscribe();
        };
      });
    });
  }
  var ErrorLink;
  var init_bundle_esm4 = __esm({
    "node_modules/apollo-link-error/lib/bundle.esm.js"() {
      init_tslib_es6();
      init_bundle_esm3();
      ErrorLink = function(_super) {
        __extends5(ErrorLink2, _super);
        function ErrorLink2(errorHandler) {
          var _this = _super.call(this) || this;
          _this.link = onError(errorHandler);
          return _this;
        }
        ErrorLink2.prototype.request = function(operation, forward) {
          return this.link.request(operation, forward);
        };
        return ErrorLink2;
      }(ApolloLink3);
    }
  });

  // packages/utilities/apolloClient/customFetchers/fetchWithCsrf.ts
  function fetchWithCsrf(uri, options) {
    if (window.Webflow.env("design") || window.Webflow.env("preview")) {
      return fetch(uri, options);
    }
    const localCsrvCookie = getLocalCsrfCookie();
    const requestHeaders = options?.headers || {};
    return new Promise(
      (resolve2, reject2) => {
        if (hasFetchedCsrfCookie && localCsrvCookie) {
          requestHeaders["X-Wf-Csrf"] = localCsrvCookie;
          resolve2(
            fetch(uri, {
              ...options,
              headers: requestHeaders
            })
          );
        } else {
          fetch(WF_CSRF_URI, {
            method: "POST",
            credentials: "include",
            headers: { "X-Requested-With": "XMLHttpRequest" }
          }).then(() => {
            const newWfCsrfCookie = getLocalCsrfCookie();
            if (newWfCsrfCookie) {
              hasFetchedCsrfCookie = true;
              requestHeaders["X-Wf-Csrf"] = newWfCsrfCookie;
              resolve2(
                fetch(uri, {
                  ...options,
                  headers: requestHeaders
                })
              );
            } else {
              reject2(new Error("Did not receive CSRF token"));
            }
          }).catch((err) => reject2(err));
        }
      }
    );
  }
  function getLocalCsrfCookie() {
    const wfCsrfCookieArray = document.cookie.match(WF_CSRF_COOKIE_REGEX);
    return wfCsrfCookieArray ? wfCsrfCookieArray.pop() : null;
  }
  var WF_CSRF_COOKIE_REGEX, WF_CSRF_URI, hasFetchedCsrfCookie;
  var init_fetchWithCsrf = __esm({
    "packages/utilities/apolloClient/customFetchers/fetchWithCsrf.ts"() {
      "use strict";
      WF_CSRF_COOKIE_REGEX = "(^|;)\\s*wf-csrf\\s*=\\s*([^;]+)";
      WF_CSRF_URI = "/.wf_graphql/csrf";
      hasFetchedCsrfCookie = false;
    }
  });

  // node_modules/apollo-link-retry/node_modules/tslib/tslib.es6.js
  function __extends7(d, b) {
    extendStatics3(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }
  function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve2, reject2) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject2(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject2(e);
        }
      }
      function step(result) {
        result.done ? resolve2(result.value) : new P(function(resolve3) {
          resolve3(result.value);
        }).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }
  function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() {
      if (t[0] & 1)
        throw t[1];
      return t[1];
    }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function verb(n) {
      return function(v) {
        return step([n, v]);
      };
    }
    function step(op) {
      if (f)
        throw new TypeError("Generator is already executing.");
      while (_)
        try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
            return t;
          if (y = 0, t)
            op = [op[0] & 2, t.value];
          switch (op[0]) {
            case 0:
            case 1:
              t = op;
              break;
            case 4:
              _.label++;
              return { value: op[1], done: false };
            case 5:
              _.label++;
              y = op[1];
              op = [0];
              continue;
            case 7:
              op = _.ops.pop();
              _.trys.pop();
              continue;
            default:
              if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                _ = 0;
                continue;
              }
              if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                _.label = op[1];
                break;
              }
              if (op[0] === 6 && _.label < t[1]) {
                _.label = t[1];
                t = op;
                break;
              }
              if (t && _.label < t[2]) {
                _.label = t[2];
                _.ops.push(op);
                break;
              }
              if (t[2])
                _.ops.pop();
              _.trys.pop();
              continue;
          }
          op = body.call(thisArg, _);
        } catch (e) {
          op = [6, e];
          y = 0;
        } finally {
          f = t = 0;
        }
      if (op[0] & 5)
        throw op[1];
      return { value: op[0] ? op[1] : void 0, done: true };
    }
  }
  var extendStatics3, __assign12;
  var init_tslib_es64 = __esm({
    "node_modules/apollo-link-retry/node_modules/tslib/tslib.es6.js"() {
      extendStatics3 = function(d, b) {
        extendStatics3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (b2.hasOwnProperty(p))
              d2[p] = b2[p];
        };
        return extendStatics3(d, b);
      };
      __assign12 = function() {
        __assign12 = Object.assign || function __assign14(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
          }
          return t;
        };
        return __assign12.apply(this, arguments);
      };
    }
  });

  // node_modules/apollo-link-retry/node_modules/zen-observable-ts/lib/bundle.esm.js
  var import_zen_observable2, Observable4, bundle_esm_default2;
  var init_bundle_esm5 = __esm({
    "node_modules/apollo-link-retry/node_modules/zen-observable-ts/lib/bundle.esm.js"() {
      import_zen_observable2 = __toESM(require_zen_observable());
      Observable4 = import_zen_observable2.default;
      bundle_esm_default2 = Observable4;
    }
  });

  // node_modules/apollo-link-retry/node_modules/apollo-utilities/node_modules/tslib/tslib.es6.js
  var init_tslib_es65 = __esm({
    "node_modules/apollo-link-retry/node_modules/apollo-utilities/node_modules/tslib/tslib.es6.js"() {
    }
  });

  // node_modules/apollo-link-retry/node_modules/@wry/equality/lib/equality.esm.js
  var _a3, toString3, hasOwnProperty2;
  var init_equality_esm2 = __esm({
    "node_modules/apollo-link-retry/node_modules/@wry/equality/lib/equality.esm.js"() {
      _a3 = Object.prototype;
      toString3 = _a3.toString;
      hasOwnProperty2 = _a3.hasOwnProperty;
    }
  });

  // node_modules/apollo-link-retry/node_modules/apollo-utilities/lib/bundle.esm.js
  function getOperationName2(doc) {
    return doc.definitions.filter(function(definition) {
      return definition.kind === "OperationDefinition" && definition.name;
    }).map(function(x) {
      return x.name.value;
    })[0] || null;
  }
  var import_visitor3, import_fast_json_stable_stringify3, canUseWeakMap2;
  var init_bundle_esm6 = __esm({
    "node_modules/apollo-link-retry/node_modules/apollo-utilities/lib/bundle.esm.js"() {
      import_visitor3 = __toESM(require_visitor());
      init_invariant_esm();
      init_tslib_es65();
      import_fast_json_stable_stringify3 = __toESM(require_fast_json_stable_stringify());
      init_equality_esm2();
      canUseWeakMap2 = typeof WeakMap === "function" && !(typeof navigator === "object" && navigator.product === "ReactNative");
    }
  });

  // node_modules/apollo-link-retry/node_modules/apollo-link/lib/bundle.esm.js
  function validateOperation2(operation) {
    var OPERATION_FIELDS = [
      "query",
      "operationName",
      "variables",
      "extensions",
      "context"
    ];
    for (var _i = 0, _a4 = Object.keys(operation); _i < _a4.length; _i++) {
      var key = _a4[_i];
      if (OPERATION_FIELDS.indexOf(key) < 0) {
        throw true ? new InvariantError(2) : new InvariantError("illegal argument: " + key);
      }
    }
    return operation;
  }
  function isTerminating2(link) {
    return link.request.length <= 1;
  }
  function transformOperation2(operation) {
    var transformedOperation = {
      variables: operation.variables || {},
      extensions: operation.extensions || {},
      operationName: operation.operationName,
      query: operation.query
    };
    if (!transformedOperation.operationName) {
      transformedOperation.operationName = typeof transformedOperation.query !== "string" ? getOperationName2(transformedOperation.query) : "";
    }
    return transformedOperation;
  }
  function createOperation2(starting, operation) {
    var context = __assign12({}, starting);
    var setContext = function(next) {
      if (typeof next === "function") {
        context = __assign12({}, context, next(context));
      } else {
        context = __assign12({}, context, next);
      }
    };
    var getContext = function() {
      return __assign12({}, context);
    };
    Object.defineProperty(operation, "setContext", {
      enumerable: false,
      value: setContext
    });
    Object.defineProperty(operation, "getContext", {
      enumerable: false,
      value: getContext
    });
    Object.defineProperty(operation, "toKey", {
      enumerable: false,
      value: function() {
        return getKey2(operation);
      }
    });
    return operation;
  }
  function getKey2(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
  }
  function passthrough2(op, forward) {
    return forward ? forward(op) : bundle_esm_default2.of();
  }
  function toLink2(handler) {
    return typeof handler === "function" ? new ApolloLink4(handler) : handler;
  }
  function empty2() {
    return new ApolloLink4(function() {
      return bundle_esm_default2.of();
    });
  }
  function from2(links) {
    if (links.length === 0)
      return empty2();
    return links.map(toLink2).reduce(function(x, y) {
      return x.concat(y);
    });
  }
  function split2(test2, left, right) {
    var leftLink = toLink2(left);
    var rightLink = toLink2(right || new ApolloLink4(passthrough2));
    if (isTerminating2(leftLink) && isTerminating2(rightLink)) {
      return new ApolloLink4(function(operation) {
        return test2(operation) ? leftLink.request(operation) || bundle_esm_default2.of() : rightLink.request(operation) || bundle_esm_default2.of();
      });
    } else {
      return new ApolloLink4(function(operation, forward) {
        return test2(operation) ? leftLink.request(operation, forward) || bundle_esm_default2.of() : rightLink.request(operation, forward) || bundle_esm_default2.of();
      });
    }
  }
  function execute2(link, operation) {
    return link.request(createOperation2(operation.context, transformOperation2(validateOperation2(operation)))) || bundle_esm_default2.of();
  }
  var LinkError2, concat2, ApolloLink4;
  var init_bundle_esm7 = __esm({
    "node_modules/apollo-link-retry/node_modules/apollo-link/lib/bundle.esm.js"() {
      init_bundle_esm5();
      init_bundle_esm5();
      init_invariant_esm();
      init_tslib_es64();
      init_bundle_esm6();
      LinkError2 = function(_super) {
        __extends7(LinkError3, _super);
        function LinkError3(message, link) {
          var _this = _super.call(this, message) || this;
          _this.link = link;
          return _this;
        }
        return LinkError3;
      }(Error);
      concat2 = function(first2, second) {
        var firstLink = toLink2(first2);
        if (isTerminating2(firstLink)) {
          return firstLink;
        }
        var nextLink = toLink2(second);
        if (isTerminating2(nextLink)) {
          return new ApolloLink4(function(operation) {
            return firstLink.request(operation, function(op) {
              return nextLink.request(op) || bundle_esm_default2.of();
            }) || bundle_esm_default2.of();
          });
        } else {
          return new ApolloLink4(function(operation, forward) {
            return firstLink.request(operation, function(op) {
              return nextLink.request(op, forward) || bundle_esm_default2.of();
            }) || bundle_esm_default2.of();
          });
        }
      };
      ApolloLink4 = function() {
        function ApolloLink6(request) {
          if (request)
            this.request = request;
        }
        ApolloLink6.prototype.split = function(test2, left, right) {
          return this.concat(split2(test2, left, right || new ApolloLink6(passthrough2)));
        };
        ApolloLink6.prototype.concat = function(next) {
          return concat2(this, next);
        };
        ApolloLink6.prototype.request = function(operation, forward) {
          throw true ? new InvariantError(1) : new InvariantError("request is not implemented");
        };
        ApolloLink6.empty = empty2;
        ApolloLink6.from = from2;
        ApolloLink6.split = split2;
        ApolloLink6.execute = execute2;
        return ApolloLink6;
      }();
    }
  });

  // node_modules/apollo-link-retry/lib/bundle.esm.js
  function buildDelayFunction(delayOptions) {
    var _a4 = delayOptions || {}, _b = _a4.initial, initial = _b === void 0 ? 300 : _b, _c = _a4.jitter, jitter = _c === void 0 ? true : _c, _d = _a4.max, max2 = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
      var delay = Math.min(max2, baseDelay * Math.pow(2, count));
      if (jitter) {
        delay = Math.random() * delay;
      }
      return delay;
    };
  }
  function buildRetryFunction(retryOptions) {
    var _a4 = retryOptions || {}, retryIf = _a4.retryIf, _b = _a4.max, max2 = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
      if (count >= max2)
        return false;
      return retryIf ? retryIf(error, operation) : !!error;
    };
  }
  var RetryableOperation, RetryLink;
  var init_bundle_esm8 = __esm({
    "node_modules/apollo-link-retry/lib/bundle.esm.js"() {
      init_tslib_es64();
      init_bundle_esm7();
      RetryableOperation = function() {
        function RetryableOperation2(operation, nextLink, delayFor, retryIf) {
          var _this = this;
          this.operation = operation;
          this.nextLink = nextLink;
          this.delayFor = delayFor;
          this.retryIf = retryIf;
          this.retryCount = 0;
          this.values = [];
          this.complete = false;
          this.canceled = false;
          this.observers = [];
          this.currentSubscription = null;
          this.onNext = function(value) {
            _this.values.push(value);
            for (var _i = 0, _a4 = _this.observers; _i < _a4.length; _i++) {
              var observer = _a4[_i];
              if (!observer)
                continue;
              observer.next(value);
            }
          };
          this.onComplete = function() {
            _this.complete = true;
            for (var _i = 0, _a4 = _this.observers; _i < _a4.length; _i++) {
              var observer = _a4[_i];
              if (!observer)
                continue;
              observer.complete();
            }
          };
          this.onError = function(error) {
            return __awaiter(_this, void 0, void 0, function() {
              var shouldRetry, _i, _a4, observer;
              return __generator(this, function(_b) {
                switch (_b.label) {
                  case 0:
                    this.retryCount += 1;
                    return [4, this.retryIf(this.retryCount, this.operation, error)];
                  case 1:
                    shouldRetry = _b.sent();
                    if (shouldRetry) {
                      this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                      return [2];
                    }
                    this.error = error;
                    for (_i = 0, _a4 = this.observers; _i < _a4.length; _i++) {
                      observer = _a4[_i];
                      if (!observer)
                        continue;
                      observer.error(error);
                    }
                    return [2];
                }
              });
            });
          };
        }
        RetryableOperation2.prototype.subscribe = function(observer) {
          if (this.canceled) {
            throw new Error("Subscribing to a retryable link that was canceled is not supported");
          }
          this.observers.push(observer);
          for (var _i = 0, _a4 = this.values; _i < _a4.length; _i++) {
            var value = _a4[_i];
            observer.next(value);
          }
          if (this.complete) {
            observer.complete();
          } else if (this.error) {
            observer.error(this.error);
          }
        };
        RetryableOperation2.prototype.unsubscribe = function(observer) {
          var index = this.observers.indexOf(observer);
          if (index < 0) {
            throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
          }
          this.observers[index] = null;
          if (this.observers.every(function(o) {
            return o === null;
          })) {
            this.cancel();
          }
        };
        RetryableOperation2.prototype.start = function() {
          if (this.currentSubscription)
            return;
          this.try();
        };
        RetryableOperation2.prototype.cancel = function() {
          if (this.currentSubscription) {
            this.currentSubscription.unsubscribe();
          }
          clearTimeout(this.timerId);
          this.timerId = null;
          this.currentSubscription = null;
          this.canceled = true;
        };
        RetryableOperation2.prototype.try = function() {
          this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
          });
        };
        RetryableOperation2.prototype.scheduleRetry = function(delay) {
          var _this = this;
          if (this.timerId) {
            throw new Error("RetryLink BUG! Encountered overlapping retries");
          }
          this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
          }, delay);
        };
        return RetryableOperation2;
      }();
      RetryLink = function(_super) {
        __extends7(RetryLink2, _super);
        function RetryLink2(options) {
          var _this = _super.call(this) || this;
          var _a4 = options || {}, attempts = _a4.attempts, delay = _a4.delay;
          _this.delayFor = typeof delay === "function" ? delay : buildDelayFunction(delay);
          _this.retryIf = typeof attempts === "function" ? attempts : buildRetryFunction(attempts);
          return _this;
        }
        RetryLink2.prototype.request = function(operation, nextLink) {
          var retryable = new RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
          retryable.start();
          return new bundle_esm_default2(function(observer) {
            retryable.subscribe(observer);
            return function() {
              retryable.unsubscribe(observer);
            };
          });
        };
        return RetryLink2;
      }(ApolloLink4);
    }
  });

  // packages/utilities/apolloClient/helpers.ts
  var waitForInFlightQueries, createRetryLink;
  var init_helpers = __esm({
    "packages/utilities/apolloClient/helpers.ts"() {
      "use strict";
      init_bundle_esm8();
      waitForInFlightQueries = (apolloClient) => {
        if (!apolloClient || !apolloClient.queryManager) {
          return Promise.resolve(null);
        }
        const {
          queryManager: { queries }
        } = apolloClient;
        const promises = Array.from(queries.values()).reduce(
          // @ts-expect-error - TS2345 - Argument of type '(memo: any[], { observableQuery }: { observableQuery: any; }) => any[]' is not assignable to parameter of type '(previousValue: any[], currentValue: unknown, currentIndex: number, array: unknown[]) => any[]'.
          (memo, { observableQuery }) => {
            const loading = observableQuery && observableQuery.currentResult().loading || false;
            return loading ? memo.concat(observableQuery.result()) : memo;
          },
          []
        );
        return Promise.all(promises).then(() => null);
      };
      createRetryLink = ({
        maxAttempts,
        retryOnCorsErrors = true,
        retriedServerErrors = "all"
      }) => {
        return new RetryLink({
          attempts: (count, operation, error) => {
            if (count >= maxAttempts) {
              return false;
            }
            if (error && (retriedServerErrors === "all" && error.statusCode >= 500 || retriedServerErrors === "bad-gateway" && error.statusCode === 502)) {
              return true;
            }
            if (retryOnCorsErrors && error && error.result && error.result.code === "BadCrossOriginRequest") {
              return true;
            }
            return false;
          },
          delay: (count) => {
            return count * 500 + Math.random() * 500;
          }
        });
      };
    }
  });

  // packages/utilities/apolloClient/createApolloClient.ts
  var import_apollo_client, import_apollo_link6, createApolloClient, buildApolloClientUri;
  var init_createApolloClient = __esm({
    "packages/utilities/apolloClient/createApolloClient.ts"() {
      "use strict";
      import_apollo_client = __toESM(require_bundle_umd5());
      init_lib3();
      init_lib6();
      import_apollo_link6 = __toESM(require_bundle_umd3());
      init_bundle_esm4();
      init_fetchWithCsrf();
      init_helpers();
      createApolloClient = ({
        origin = "",
        path,
        publicationId,
        previewKey,
        ssrMode = false,
        credentials = "same-origin",
        headers = {},
        useCsrf = false,
        retryConfig = {
          maxAttempts: 1
        },
        onError: onError2,
        disableBatching = false
      }) => {
        const uri = buildApolloClientUri({ origin, path, publicationId, previewKey });
        const requestHeaders = {
          Accept: "application/json"
        };
        Object.keys(headers).forEach((headerKey) => {
          requestHeaders[headerKey] = headers[headerKey];
        });
        const batchLinkArgs = {
          uri,
          headers: requestHeaders,
          credentials
        };
        if (disableBatching) {
          batchLinkArgs.batchMax = 1;
          batchLinkArgs.batchInterval = 0;
        }
        if (useCsrf) {
          batchLinkArgs.fetch = fetchWithCsrf;
        }
        const batchLink = new BatchHttpLink(batchLinkArgs);
        const links = [];
        if (retryConfig.maxAttempts > 1) {
          links.push(createRetryLink(retryConfig));
        }
        if (onError2) {
          links.push(onError(onError2));
        }
        const apolloClient = new import_apollo_client.default({
          link: import_apollo_link6.ApolloLink.from([...links, batchLink]),
          cache: new InMemoryCache({
            dataIdFromObject: (object) => {
              switch (object.__typename) {
                case "sku_props":
                  return null;
                default: {
                  if (object.cmsLocaleId) {
                    return `${object.id}_${object.cmsLocaleId}`;
                  }
                  return object.id;
                }
              }
            }
          }),
          ssrMode
        });
        return apolloClient;
      };
      buildApolloClientUri = ({
        origin = "",
        path,
        publicationId,
        previewKey
      }) => {
        const params = [];
        if (publicationId) {
          params.push(`pub=${publicationId}`);
        }
        if (previewKey) {
          params.push(`preview=${previewKey}`);
        }
        const cleanPath = `${origin}${path}`.replace(/([^:])\/\/+/g, "$1/");
        return `${cleanPath}${params.length ? `?${params.join("&")}` : ""}`;
      };
    }
  });

  // packages/utilities/apolloClient/index.ts
  var apolloClient_exports = {};
  __export(apolloClient_exports, {
    createApolloClient: () => createApolloClient,
    waitForInFlightQueries: () => waitForInFlightQueries
  });
  var init_apolloClient = __esm({
    "packages/utilities/apolloClient/index.ts"() {
      init_createApolloClient();
      init_helpers();
    }
  });

  // node_modules/@babel/runtime/helpers/defineProperty.js
  var require_defineProperty2 = __commonJS({
    "node_modules/@babel/runtime/helpers/defineProperty.js"(exports, module) {
      function _defineProperty(obj, key, value) {
        if (key in obj) {
          Object.defineProperty(obj, key, {
            value,
            enumerable: true,
            configurable: true,
            writable: true
          });
        } else {
          obj[key] = value;
        }
        return obj;
      }
      module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }
  });

  // node_modules/lodash/_assignMergeValue.js
  var require_assignMergeValue = __commonJS({
    "node_modules/lodash/_assignMergeValue.js"(exports, module) {
      var baseAssignValue = require_baseAssignValue();
      var eq = require_eq();
      function assignMergeValue(object, key, value) {
        if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      module.exports = assignMergeValue;
    }
  });

  // node_modules/lodash/_cloneBuffer.js
  var require_cloneBuffer = __commonJS({
    "node_modules/lodash/_cloneBuffer.js"(exports, module) {
      var root = require_root();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var Buffer2 = moduleExports ? root.Buffer : void 0;
      var allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length2 = buffer.length, result = allocUnsafe ? allocUnsafe(length2) : new buffer.constructor(length2);
        buffer.copy(result);
        return result;
      }
      module.exports = cloneBuffer;
    }
  });

  // node_modules/lodash/_cloneArrayBuffer.js
  var require_cloneArrayBuffer = __commonJS({
    "node_modules/lodash/_cloneArrayBuffer.js"(exports, module) {
      var Uint8Array2 = require_Uint8Array();
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
        return result;
      }
      module.exports = cloneArrayBuffer;
    }
  });

  // node_modules/lodash/_cloneTypedArray.js
  var require_cloneTypedArray = __commonJS({
    "node_modules/lodash/_cloneTypedArray.js"(exports, module) {
      var cloneArrayBuffer = require_cloneArrayBuffer();
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      module.exports = cloneTypedArray;
    }
  });

  // node_modules/lodash/_initCloneObject.js
  var require_initCloneObject = __commonJS({
    "node_modules/lodash/_initCloneObject.js"(exports, module) {
      var baseCreate = require_baseCreate();
      var getPrototype = require_getPrototype();
      var isPrototype = require_isPrototype();
      function initCloneObject(object) {
        return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      module.exports = initCloneObject;
    }
  });

  // node_modules/lodash/isArrayLikeObject.js
  var require_isArrayLikeObject = __commonJS({
    "node_modules/lodash/isArrayLikeObject.js"(exports, module) {
      var isArrayLike = require_isArrayLike();
      var isObjectLike = require_isObjectLike();
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      module.exports = isArrayLikeObject;
    }
  });

  // node_modules/lodash/_safeGet.js
  var require_safeGet = __commonJS({
    "node_modules/lodash/_safeGet.js"(exports, module) {
      function safeGet(object, key) {
        if (key === "constructor" && typeof object[key] === "function") {
          return;
        }
        if (key == "__proto__") {
          return;
        }
        return object[key];
      }
      module.exports = safeGet;
    }
  });

  // node_modules/lodash/_copyObject.js
  var require_copyObject = __commonJS({
    "node_modules/lodash/_copyObject.js"(exports, module) {
      var assignValue = require_assignValue();
      var baseAssignValue = require_baseAssignValue();
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1, length2 = props.length;
        while (++index < length2) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
          if (newValue === void 0) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      module.exports = copyObject;
    }
  });

  // node_modules/lodash/toPlainObject.js
  var require_toPlainObject = __commonJS({
    "node_modules/lodash/toPlainObject.js"(exports, module) {
      var copyObject = require_copyObject();
      var keysIn = require_keysIn();
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      module.exports = toPlainObject;
    }
  });

  // node_modules/lodash/_baseMergeDeep.js
  var require_baseMergeDeep = __commonJS({
    "node_modules/lodash/_baseMergeDeep.js"(exports, module) {
      var assignMergeValue = require_assignMergeValue();
      var cloneBuffer = require_cloneBuffer();
      var cloneTypedArray = require_cloneTypedArray();
      var copyArray = require_copyArray();
      var initCloneObject = require_initCloneObject();
      var isArguments = require_isArguments();
      var isArray = require_isArray();
      var isArrayLikeObject = require_isArrayLikeObject();
      var isBuffer = require_isBuffer();
      var isFunction3 = require_isFunction();
      var isObject2 = require_isObject();
      var isPlainObject = require_isPlainObject();
      var isTypedArray = require_isTypedArray();
      var safeGet = require_safeGet();
      var toPlainObject = require_toPlainObject();
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
        var isCommon = newValue === void 0;
        if (isCommon) {
          var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject2(objValue) || isFunction3(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack["delete"](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      module.exports = baseMergeDeep;
    }
  });

  // node_modules/lodash/_baseMerge.js
  var require_baseMerge = __commonJS({
    "node_modules/lodash/_baseMerge.js"(exports, module) {
      var Stack = require_Stack();
      var assignMergeValue = require_assignMergeValue();
      var baseFor = require_baseFor();
      var baseMergeDeep = require_baseMergeDeep();
      var isObject2 = require_isObject();
      var keysIn = require_keysIn();
      var safeGet = require_safeGet();
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack());
          if (isObject2(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
            if (newValue === void 0) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      module.exports = baseMerge;
    }
  });

  // node_modules/lodash/_baseRest.js
  var require_baseRest = __commonJS({
    "node_modules/lodash/_baseRest.js"(exports, module) {
      var identity2 = require_identity();
      var overRest = require_overRest();
      var setToString = require_setToString();
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity2), func + "");
      }
      module.exports = baseRest;
    }
  });

  // node_modules/lodash/_isIterateeCall.js
  var require_isIterateeCall = __commonJS({
    "node_modules/lodash/_isIterateeCall.js"(exports, module) {
      var eq = require_eq();
      var isArrayLike = require_isArrayLike();
      var isIndex = require_isIndex();
      var isObject2 = require_isObject();
      function isIterateeCall(value, index, object) {
        if (!isObject2(object)) {
          return false;
        }
        var type = typeof index;
        if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
          return eq(object[index], value);
        }
        return false;
      }
      module.exports = isIterateeCall;
    }
  });

  // node_modules/lodash/_createAssigner.js
  var require_createAssigner = __commonJS({
    "node_modules/lodash/_createAssigner.js"(exports, module) {
      var baseRest = require_baseRest();
      var isIterateeCall = require_isIterateeCall();
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index = -1, length2 = sources.length, customizer = length2 > 1 ? sources[length2 - 1] : void 0, guard = length2 > 2 ? sources[2] : void 0;
          customizer = assigner.length > 3 && typeof customizer == "function" ? (length2--, customizer) : void 0;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length2 < 3 ? void 0 : customizer;
            length2 = 1;
          }
          object = Object(object);
          while (++index < length2) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }
      module.exports = createAssigner;
    }
  });

  // node_modules/lodash/merge.js
  var require_merge = __commonJS({
    "node_modules/lodash/merge.js"(exports, module) {
      var baseMerge = require_baseMerge();
      var createAssigner = require_createAssigner();
      var merge2 = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      module.exports = merge2;
    }
  });

  // node_modules/tinycolor2/tinycolor.js
  var require_tinycolor = __commonJS({
    "node_modules/tinycolor2/tinycolor.js"(exports, module) {
      (function(Math2) {
        var trimLeft = /^\s+/, trimRight = /\s+$/, tinyCounter = 0, mathRound = Math2.round, mathMin = Math2.min, mathMax = Math2.max, mathRandom = Math2.random;
        function tinycolor(color, opts) {
          color = color ? color : "";
          opts = opts || {};
          if (color instanceof tinycolor) {
            return color;
          }
          if (!(this instanceof tinycolor)) {
            return new tinycolor(color, opts);
          }
          var rgb = inputToRGB(color);
          this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = mathRound(100 * this._a) / 100, this._format = opts.format || rgb.format;
          this._gradientType = opts.gradientType;
          if (this._r < 1) {
            this._r = mathRound(this._r);
          }
          if (this._g < 1) {
            this._g = mathRound(this._g);
          }
          if (this._b < 1) {
            this._b = mathRound(this._b);
          }
          this._ok = rgb.ok;
          this._tc_id = tinyCounter++;
        }
        tinycolor.prototype = {
          isDark: function() {
            return this.getBrightness() < 128;
          },
          isLight: function() {
            return !this.isDark();
          },
          isValid: function() {
            return this._ok;
          },
          getOriginalInput: function() {
            return this._originalInput;
          },
          getFormat: function() {
            return this._format;
          },
          getAlpha: function() {
            return this._a;
          },
          getBrightness: function() {
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
          },
          getLuminance: function() {
            var rgb = this.toRgb();
            var RsRGB, GsRGB, BsRGB, R, G, B;
            RsRGB = rgb.r / 255;
            GsRGB = rgb.g / 255;
            BsRGB = rgb.b / 255;
            if (RsRGB <= 0.03928) {
              R = RsRGB / 12.92;
            } else {
              R = Math2.pow((RsRGB + 0.055) / 1.055, 2.4);
            }
            if (GsRGB <= 0.03928) {
              G = GsRGB / 12.92;
            } else {
              G = Math2.pow((GsRGB + 0.055) / 1.055, 2.4);
            }
            if (BsRGB <= 0.03928) {
              B = BsRGB / 12.92;
            } else {
              B = Math2.pow((BsRGB + 0.055) / 1.055, 2.4);
            }
            return 0.2126 * R + 0.7152 * G + 0.0722 * B;
          },
          setAlpha: function(value) {
            this._a = boundAlpha(value);
            this._roundA = mathRound(100 * this._a) / 100;
            return this;
          },
          toHsv: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
          },
          toHsvString: function() {
            var hsv = rgbToHsv(this._r, this._g, this._b);
            var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
            return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
          },
          toHsl: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
          },
          toHslString: function() {
            var hsl = rgbToHsl(this._r, this._g, this._b);
            var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
            return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
          },
          toHex: function(allow3Char) {
            return rgbToHex(this._r, this._g, this._b, allow3Char);
          },
          toHexString: function(allow3Char) {
            return "#" + this.toHex(allow3Char);
          },
          toHex8: function(allow4Char) {
            return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
          },
          toHex8String: function(allow4Char) {
            return "#" + this.toHex8(allow4Char);
          },
          toRgb: function() {
            return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
          },
          toRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" : "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
          },
          toPercentageRgb: function() {
            return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
          },
          toPercentageRgbString: function() {
            return this._a == 1 ? "rgb(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" : "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
          },
          toName: function() {
            if (this._a === 0) {
              return "transparent";
            }
            if (this._a < 1) {
              return false;
            }
            return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
          },
          toFilter: function(secondColor) {
            var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
            var secondHex8String = hex8String;
            var gradientType = this._gradientType ? "GradientType = 1, " : "";
            if (secondColor) {
              var s = tinycolor(secondColor);
              secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
            }
            return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
          },
          toString: function(format) {
            var formatSet = !!format;
            format = format || this._format;
            var formattedString = false;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
            if (needsAlphaFormat) {
              if (format === "name" && this._a === 0) {
                return this.toName();
              }
              return this.toRgbString();
            }
            if (format === "rgb") {
              formattedString = this.toRgbString();
            }
            if (format === "prgb") {
              formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
              formattedString = this.toHexString();
            }
            if (format === "hex3") {
              formattedString = this.toHexString(true);
            }
            if (format === "hex4") {
              formattedString = this.toHex8String(true);
            }
            if (format === "hex8") {
              formattedString = this.toHex8String();
            }
            if (format === "name") {
              formattedString = this.toName();
            }
            if (format === "hsl") {
              formattedString = this.toHslString();
            }
            if (format === "hsv") {
              formattedString = this.toHsvString();
            }
            return formattedString || this.toHexString();
          },
          clone: function() {
            return tinycolor(this.toString());
          },
          _applyModification: function(fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
          },
          lighten: function() {
            return this._applyModification(lighten, arguments);
          },
          brighten: function() {
            return this._applyModification(brighten, arguments);
          },
          darken: function() {
            return this._applyModification(darken, arguments);
          },
          desaturate: function() {
            return this._applyModification(desaturate, arguments);
          },
          saturate: function() {
            return this._applyModification(saturate, arguments);
          },
          greyscale: function() {
            return this._applyModification(greyscale, arguments);
          },
          spin: function() {
            return this._applyModification(spin, arguments);
          },
          _applyCombination: function(fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
          },
          analogous: function() {
            return this._applyCombination(analogous, arguments);
          },
          complement: function() {
            return this._applyCombination(complement2, arguments);
          },
          monochromatic: function() {
            return this._applyCombination(monochromatic, arguments);
          },
          splitcomplement: function() {
            return this._applyCombination(splitcomplement, arguments);
          },
          triad: function() {
            return this._applyCombination(triad, arguments);
          },
          tetrad: function() {
            return this._applyCombination(tetrad, arguments);
          }
        };
        tinycolor.fromRatio = function(color, opts) {
          if (typeof color == "object") {
            var newColor = {};
            for (var i in color) {
              if (color.hasOwnProperty(i)) {
                if (i === "a") {
                  newColor[i] = color[i];
                } else {
                  newColor[i] = convertToPercentage(color[i]);
                }
              }
            }
            color = newColor;
          }
          return tinycolor(color, opts);
        };
        function inputToRGB(color) {
          var rgb = { r: 0, g: 0, b: 0 };
          var a = 1;
          var s = null;
          var v = null;
          var l = null;
          var ok = false;
          var format = false;
          if (typeof color == "string") {
            color = stringInputToObject(color);
          }
          if (typeof color == "object") {
            if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
              rgb = rgbToRgb(color.r, color.g, color.b);
              ok = true;
              format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
              s = convertToPercentage(color.s);
              v = convertToPercentage(color.v);
              rgb = hsvToRgb(color.h, s, v);
              ok = true;
              format = "hsv";
            } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
              s = convertToPercentage(color.s);
              l = convertToPercentage(color.l);
              rgb = hslToRgb(color.h, s, l);
              ok = true;
              format = "hsl";
            }
            if (color.hasOwnProperty("a")) {
              a = color.a;
            }
          }
          a = boundAlpha(a);
          return {
            ok,
            format: color.format || format,
            r: mathMin(255, mathMax(rgb.r, 0)),
            g: mathMin(255, mathMax(rgb.g, 0)),
            b: mathMin(255, mathMax(rgb.b, 0)),
            a
          };
        }
        function rgbToRgb(r, g, b) {
          return {
            r: bound01(r, 255) * 255,
            g: bound01(g, 255) * 255,
            b: bound01(b, 255) * 255
          };
        }
        function rgbToHsl(r, g, b) {
          r = bound01(r, 255);
          g = bound01(g, 255);
          b = bound01(b, 255);
          var max2 = mathMax(r, g, b), min = mathMin(r, g, b);
          var h, s, l = (max2 + min) / 2;
          if (max2 == min) {
            h = s = 0;
          } else {
            var d = max2 - min;
            s = l > 0.5 ? d / (2 - max2 - min) : d / (max2 + min);
            switch (max2) {
              case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
              case g:
                h = (b - r) / d + 2;
                break;
              case b:
                h = (r - g) / d + 4;
                break;
            }
            h /= 6;
          }
          return { h, s, l };
        }
        function hslToRgb(h, s, l) {
          var r, g, b;
          h = bound01(h, 360);
          s = bound01(s, 100);
          l = bound01(l, 100);
          function hue2rgb(p2, q2, t) {
            if (t < 0)
              t += 1;
            if (t > 1)
              t -= 1;
            if (t < 1 / 6)
              return p2 + (q2 - p2) * 6 * t;
            if (t < 1 / 2)
              return q2;
            if (t < 2 / 3)
              return p2 + (q2 - p2) * (2 / 3 - t) * 6;
            return p2;
          }
          if (s === 0) {
            r = g = b = l;
          } else {
            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
          }
          return { r: r * 255, g: g * 255, b: b * 255 };
        }
        function rgbToHsv(r, g, b) {
          r = bound01(r, 255);
          g = bound01(g, 255);
          b = bound01(b, 255);
          var max2 = mathMax(r, g, b), min = mathMin(r, g, b);
          var h, s, v = max2;
          var d = max2 - min;
          s = max2 === 0 ? 0 : d / max2;
          if (max2 == min) {
            h = 0;
          } else {
            switch (max2) {
              case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
              case g:
                h = (b - r) / d + 2;
                break;
              case b:
                h = (r - g) / d + 4;
                break;
            }
            h /= 6;
          }
          return { h, s, v };
        }
        function hsvToRgb(h, s, v) {
          h = bound01(h, 360) * 6;
          s = bound01(s, 100);
          v = bound01(v, 100);
          var i = Math2.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [v, q, p, p, t, v][mod], g = [t, v, v, q, p, p][mod], b = [p, p, t, v, v, q][mod];
          return { r: r * 255, g: g * 255, b: b * 255 };
        }
        function rgbToHex(r, g, b, allow3Char) {
          var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
          ];
          if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
          }
          return hex.join("");
        }
        function rgbaToHex(r, g, b, a, allow4Char) {
          var hex = [
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16)),
            pad2(convertDecimalToHex(a))
          ];
          if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
            return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
          }
          return hex.join("");
        }
        function rgbaToArgbHex(r, g, b, a) {
          var hex = [
            pad2(convertDecimalToHex(a)),
            pad2(mathRound(r).toString(16)),
            pad2(mathRound(g).toString(16)),
            pad2(mathRound(b).toString(16))
          ];
          return hex.join("");
        }
        tinycolor.equals = function(color1, color2) {
          if (!color1 || !color2) {
            return false;
          }
          return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
        };
        tinycolor.random = function() {
          return tinycolor.fromRatio({
            r: mathRandom(),
            g: mathRandom(),
            b: mathRandom()
          });
        };
        function desaturate(color, amount) {
          amount = amount === 0 ? 0 : amount || 10;
          var hsl = tinycolor(color).toHsl();
          hsl.s -= amount / 100;
          hsl.s = clamp01(hsl.s);
          return tinycolor(hsl);
        }
        function saturate(color, amount) {
          amount = amount === 0 ? 0 : amount || 10;
          var hsl = tinycolor(color).toHsl();
          hsl.s += amount / 100;
          hsl.s = clamp01(hsl.s);
          return tinycolor(hsl);
        }
        function greyscale(color) {
          return tinycolor(color).desaturate(100);
        }
        function lighten(color, amount) {
          amount = amount === 0 ? 0 : amount || 10;
          var hsl = tinycolor(color).toHsl();
          hsl.l += amount / 100;
          hsl.l = clamp01(hsl.l);
          return tinycolor(hsl);
        }
        function brighten(color, amount) {
          amount = amount === 0 ? 0 : amount || 10;
          var rgb = tinycolor(color).toRgb();
          rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * -(amount / 100))));
          rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * -(amount / 100))));
          rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * -(amount / 100))));
          return tinycolor(rgb);
        }
        function darken(color, amount) {
          amount = amount === 0 ? 0 : amount || 10;
          var hsl = tinycolor(color).toHsl();
          hsl.l -= amount / 100;
          hsl.l = clamp01(hsl.l);
          return tinycolor(hsl);
        }
        function spin(color, amount) {
          var hsl = tinycolor(color).toHsl();
          var hue = (hsl.h + amount) % 360;
          hsl.h = hue < 0 ? 360 + hue : hue;
          return tinycolor(hsl);
        }
        function complement2(color) {
          var hsl = tinycolor(color).toHsl();
          hsl.h = (hsl.h + 180) % 360;
          return tinycolor(hsl);
        }
        function triad(color) {
          var hsl = tinycolor(color).toHsl();
          var h = hsl.h;
          return [
            tinycolor(color),
            tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
          ];
        }
        function tetrad(color) {
          var hsl = tinycolor(color).toHsl();
          var h = hsl.h;
          return [
            tinycolor(color),
            tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
          ];
        }
        function splitcomplement(color) {
          var hsl = tinycolor(color).toHsl();
          var h = hsl.h;
          return [
            tinycolor(color),
            tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l }),
            tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l })
          ];
        }
        function analogous(color, results, slices) {
          results = results || 6;
          slices = slices || 30;
          var hsl = tinycolor(color).toHsl();
          var part = 360 / slices;
          var ret = [tinycolor(color)];
          for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
            hsl.h = (hsl.h + part) % 360;
            ret.push(tinycolor(hsl));
          }
          return ret;
        }
        function monochromatic(color, results) {
          results = results || 6;
          var hsv = tinycolor(color).toHsv();
          var h = hsv.h, s = hsv.s, v = hsv.v;
          var ret = [];
          var modification = 1 / results;
          while (results--) {
            ret.push(tinycolor({ h, s, v }));
            v = (v + modification) % 1;
          }
          return ret;
        }
        tinycolor.mix = function(color1, color2, amount) {
          amount = amount === 0 ? 0 : amount || 50;
          var rgb1 = tinycolor(color1).toRgb();
          var rgb2 = tinycolor(color2).toRgb();
          var p = amount / 100;
          var rgba = {
            r: (rgb2.r - rgb1.r) * p + rgb1.r,
            g: (rgb2.g - rgb1.g) * p + rgb1.g,
            b: (rgb2.b - rgb1.b) * p + rgb1.b,
            a: (rgb2.a - rgb1.a) * p + rgb1.a
          };
          return tinycolor(rgba);
        };
        tinycolor.readability = function(color1, color2) {
          var c1 = tinycolor(color1);
          var c2 = tinycolor(color2);
          return (Math2.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math2.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
        };
        tinycolor.isReadable = function(color1, color2, wcag2) {
          var readability = tinycolor.readability(color1, color2);
          var wcag2Parms, out;
          out = false;
          wcag2Parms = validateWCAG2Parms(wcag2);
          switch (wcag2Parms.level + wcag2Parms.size) {
            case "AAsmall":
            case "AAAlarge":
              out = readability >= 4.5;
              break;
            case "AAlarge":
              out = readability >= 3;
              break;
            case "AAAsmall":
              out = readability >= 7;
              break;
          }
          return out;
        };
        tinycolor.mostReadable = function(baseColor, colorList, args) {
          var bestColor = null;
          var bestScore = 0;
          var readability;
          var includeFallbackColors, level, size;
          args = args || {};
          includeFallbackColors = args.includeFallbackColors;
          level = args.level;
          size = args.size;
          for (var i = 0; i < colorList.length; i++) {
            readability = tinycolor.readability(baseColor, colorList[i]);
            if (readability > bestScore) {
              bestScore = readability;
              bestColor = tinycolor(colorList[i]);
            }
          }
          if (tinycolor.isReadable(baseColor, bestColor, { "level": level, "size": size }) || !includeFallbackColors) {
            return bestColor;
          } else {
            args.includeFallbackColors = false;
            return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
          }
        };
        var names = tinycolor.names = {
          aliceblue: "f0f8ff",
          antiquewhite: "faebd7",
          aqua: "0ff",
          aquamarine: "7fffd4",
          azure: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "000",
          blanchedalmond: "ffebcd",
          blue: "00f",
          blueviolet: "8a2be2",
          brown: "a52a2a",
          burlywood: "deb887",
          burntsienna: "ea7e5d",
          cadetblue: "5f9ea0",
          chartreuse: "7fff00",
          chocolate: "d2691e",
          coral: "ff7f50",
          cornflowerblue: "6495ed",
          cornsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "0ff",
          darkblue: "00008b",
          darkcyan: "008b8b",
          darkgoldenrod: "b8860b",
          darkgray: "a9a9a9",
          darkgreen: "006400",
          darkgrey: "a9a9a9",
          darkkhaki: "bdb76b",
          darkmagenta: "8b008b",
          darkolivegreen: "556b2f",
          darkorange: "ff8c00",
          darkorchid: "9932cc",
          darkred: "8b0000",
          darksalmon: "e9967a",
          darkseagreen: "8fbc8f",
          darkslateblue: "483d8b",
          darkslategray: "2f4f4f",
          darkslategrey: "2f4f4f",
          darkturquoise: "00ced1",
          darkviolet: "9400d3",
          deeppink: "ff1493",
          deepskyblue: "00bfff",
          dimgray: "696969",
          dimgrey: "696969",
          dodgerblue: "1e90ff",
          firebrick: "b22222",
          floralwhite: "fffaf0",
          forestgreen: "228b22",
          fuchsia: "f0f",
          gainsboro: "dcdcdc",
          ghostwhite: "f8f8ff",
          gold: "ffd700",
          goldenrod: "daa520",
          gray: "808080",
          green: "008000",
          greenyellow: "adff2f",
          grey: "808080",
          honeydew: "f0fff0",
          hotpink: "ff69b4",
          indianred: "cd5c5c",
          indigo: "4b0082",
          ivory: "fffff0",
          khaki: "f0e68c",
          lavender: "e6e6fa",
          lavenderblush: "fff0f5",
          lawngreen: "7cfc00",
          lemonchiffon: "fffacd",
          lightblue: "add8e6",
          lightcoral: "f08080",
          lightcyan: "e0ffff",
          lightgoldenrodyellow: "fafad2",
          lightgray: "d3d3d3",
          lightgreen: "90ee90",
          lightgrey: "d3d3d3",
          lightpink: "ffb6c1",
          lightsalmon: "ffa07a",
          lightseagreen: "20b2aa",
          lightskyblue: "87cefa",
          lightslategray: "789",
          lightslategrey: "789",
          lightsteelblue: "b0c4de",
          lightyellow: "ffffe0",
          lime: "0f0",
          limegreen: "32cd32",
          linen: "faf0e6",
          magenta: "f0f",
          maroon: "800000",
          mediumaquamarine: "66cdaa",
          mediumblue: "0000cd",
          mediumorchid: "ba55d3",
          mediumpurple: "9370db",
          mediumseagreen: "3cb371",
          mediumslateblue: "7b68ee",
          mediumspringgreen: "00fa9a",
          mediumturquoise: "48d1cc",
          mediumvioletred: "c71585",
          midnightblue: "191970",
          mintcream: "f5fffa",
          mistyrose: "ffe4e1",
          moccasin: "ffe4b5",
          navajowhite: "ffdead",
          navy: "000080",
          oldlace: "fdf5e6",
          olive: "808000",
          olivedrab: "6b8e23",
          orange: "ffa500",
          orangered: "ff4500",
          orchid: "da70d6",
          palegoldenrod: "eee8aa",
          palegreen: "98fb98",
          paleturquoise: "afeeee",
          palevioletred: "db7093",
          papayawhip: "ffefd5",
          peachpuff: "ffdab9",
          peru: "cd853f",
          pink: "ffc0cb",
          plum: "dda0dd",
          powderblue: "b0e0e6",
          purple: "800080",
          rebeccapurple: "663399",
          red: "f00",
          rosybrown: "bc8f8f",
          royalblue: "4169e1",
          saddlebrown: "8b4513",
          salmon: "fa8072",
          sandybrown: "f4a460",
          seagreen: "2e8b57",
          seashell: "fff5ee",
          sienna: "a0522d",
          silver: "c0c0c0",
          skyblue: "87ceeb",
          slateblue: "6a5acd",
          slategray: "708090",
          slategrey: "708090",
          snow: "fffafa",
          springgreen: "00ff7f",
          steelblue: "4682b4",
          tan: "d2b48c",
          teal: "008080",
          thistle: "d8bfd8",
          tomato: "ff6347",
          turquoise: "40e0d0",
          violet: "ee82ee",
          wheat: "f5deb3",
          white: "fff",
          whitesmoke: "f5f5f5",
          yellow: "ff0",
          yellowgreen: "9acd32"
        };
        var hexNames = tinycolor.hexNames = flip2(names);
        function flip2(o) {
          var flipped = {};
          for (var i in o) {
            if (o.hasOwnProperty(i)) {
              flipped[o[i]] = i;
            }
          }
          return flipped;
        }
        function boundAlpha(a) {
          a = parseFloat(a);
          if (isNaN(a) || a < 0 || a > 1) {
            a = 1;
          }
          return a;
        }
        function bound01(n, max2) {
          if (isOnePointZero(n)) {
            n = "100%";
          }
          var processPercent = isPercentage(n);
          n = mathMin(max2, mathMax(0, parseFloat(n)));
          if (processPercent) {
            n = parseInt(n * max2, 10) / 100;
          }
          if (Math2.abs(n - max2) < 1e-6) {
            return 1;
          }
          return n % max2 / parseFloat(max2);
        }
        function clamp01(val) {
          return mathMin(1, mathMax(0, val));
        }
        function parseIntFromHex(val) {
          return parseInt(val, 16);
        }
        function isOnePointZero(n) {
          return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
        }
        function isPercentage(n) {
          return typeof n === "string" && n.indexOf("%") != -1;
        }
        function pad2(c) {
          return c.length == 1 ? "0" + c : "" + c;
        }
        function convertToPercentage(n) {
          if (n <= 1) {
            n = n * 100 + "%";
          }
          return n;
        }
        function convertDecimalToHex(d) {
          return Math2.round(parseFloat(d) * 255).toString(16);
        }
        function convertHexToDecimal(h) {
          return parseIntFromHex(h) / 255;
        }
        var matchers = function() {
          var CSS_INTEGER = "[-\\+]?\\d+%?";
          var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
          var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
          var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
          var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
          return {
            CSS_UNIT: new RegExp(CSS_UNIT),
            rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
            rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
            hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
            hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
            hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
            hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
            hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
            hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
            hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
          };
        }();
        function isValidCSSUnit(color) {
          return !!matchers.CSS_UNIT.exec(color);
        }
        function stringInputToObject(color) {
          color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
          var named = false;
          if (names[color]) {
            color = names[color];
            named = true;
          } else if (color == "transparent") {
            return { r: 0, g: 0, b: 0, a: 0, format: "name" };
          }
          var match2;
          if (match2 = matchers.rgb.exec(color)) {
            return { r: match2[1], g: match2[2], b: match2[3] };
          }
          if (match2 = matchers.rgba.exec(color)) {
            return { r: match2[1], g: match2[2], b: match2[3], a: match2[4] };
          }
          if (match2 = matchers.hsl.exec(color)) {
            return { h: match2[1], s: match2[2], l: match2[3] };
          }
          if (match2 = matchers.hsla.exec(color)) {
            return { h: match2[1], s: match2[2], l: match2[3], a: match2[4] };
          }
          if (match2 = matchers.hsv.exec(color)) {
            return { h: match2[1], s: match2[2], v: match2[3] };
          }
          if (match2 = matchers.hsva.exec(color)) {
            return { h: match2[1], s: match2[2], v: match2[3], a: match2[4] };
          }
          if (match2 = matchers.hex8.exec(color)) {
            return {
              r: parseIntFromHex(match2[1]),
              g: parseIntFromHex(match2[2]),
              b: parseIntFromHex(match2[3]),
              a: convertHexToDecimal(match2[4]),
              format: named ? "name" : "hex8"
            };
          }
          if (match2 = matchers.hex6.exec(color)) {
            return {
              r: parseIntFromHex(match2[1]),
              g: parseIntFromHex(match2[2]),
              b: parseIntFromHex(match2[3]),
              format: named ? "name" : "hex"
            };
          }
          if (match2 = matchers.hex4.exec(color)) {
            return {
              r: parseIntFromHex(match2[1] + "" + match2[1]),
              g: parseIntFromHex(match2[2] + "" + match2[2]),
              b: parseIntFromHex(match2[3] + "" + match2[3]),
              a: convertHexToDecimal(match2[4] + "" + match2[4]),
              format: named ? "name" : "hex8"
            };
          }
          if (match2 = matchers.hex3.exec(color)) {
            return {
              r: parseIntFromHex(match2[1] + "" + match2[1]),
              g: parseIntFromHex(match2[2] + "" + match2[2]),
              b: parseIntFromHex(match2[3] + "" + match2[3]),
              format: named ? "name" : "hex"
            };
          }
          return false;
        }
        function validateWCAG2Parms(parms) {
          var level, size;
          parms = parms || { "level": "AA", "size": "small" };
          level = (parms.level || "AA").toUpperCase();
          size = (parms.size || "small").toLowerCase();
          if (level !== "AA" && level !== "AAA") {
            level = "AA";
          }
          if (size !== "small" && size !== "large") {
            size = "small";
          }
          return { "level": level, "size": size };
        }
        if (typeof module !== "undefined" && module.exports) {
          module.exports = tinycolor;
        } else if (typeof define === "function" && define.amd) {
          define(function() {
            return tinycolor;
          });
        } else {
          window.tinycolor = tinycolor;
        }
      })(Math);
    }
  });

  // packages/systems/style/breakpoint-ids/index.ts
  var breakpoint_ids_exports = {};
  __export(breakpoint_ids_exports, {
    BREAKPOINT_ID_LARGE: () => BREAKPOINT_ID_LARGE,
    BREAKPOINT_ID_MAIN: () => BREAKPOINT_ID_MAIN,
    BREAKPOINT_ID_MEDIUM: () => BREAKPOINT_ID_MEDIUM,
    BREAKPOINT_ID_SMALL: () => BREAKPOINT_ID_SMALL,
    BREAKPOINT_ID_TINY: () => BREAKPOINT_ID_TINY,
    BREAKPOINT_ID_XL: () => BREAKPOINT_ID_XL,
    BREAKPOINT_ID_XXL: () => BREAKPOINT_ID_XXL,
    DEFAULT_BREAKPOINT_IDS: () => DEFAULT_BREAKPOINT_IDS
  });
  var BREAKPOINT_ID_XXL, BREAKPOINT_ID_XL, BREAKPOINT_ID_LARGE, BREAKPOINT_ID_MAIN, BREAKPOINT_ID_MEDIUM, BREAKPOINT_ID_SMALL, BREAKPOINT_ID_TINY, DEFAULT_BREAKPOINT_IDS;
  var init_breakpoint_ids = __esm({
    "packages/systems/style/breakpoint-ids/index.ts"() {
      BREAKPOINT_ID_XXL = "xxl";
      BREAKPOINT_ID_XL = "xl";
      BREAKPOINT_ID_LARGE = "large";
      BREAKPOINT_ID_MAIN = "main";
      BREAKPOINT_ID_MEDIUM = "medium";
      BREAKPOINT_ID_SMALL = "small";
      BREAKPOINT_ID_TINY = "tiny";
      DEFAULT_BREAKPOINT_IDS = [
        BREAKPOINT_ID_MAIN,
        BREAKPOINT_ID_MEDIUM,
        BREAKPOINT_ID_SMALL,
        BREAKPOINT_ID_TINY
      ];
    }
  });

  // packages/systems/style/breakpoints-config/index.js
  var require_breakpoints_config = __commonJS({
    "packages/systems/style/breakpoints-config/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.LARGER_BREAKPOINTS_WORDING = exports.LARGER_BREAKPOINTS_CONFIG = exports.DEFAULT_BREAKPOINTS_CONFIG = void 0;
      var _breakpointIds = (init_breakpoint_ids(), __toCommonJS(breakpoint_ids_exports));
      var DEFAULT_BREAKPOINTS_CONFIG = {
        [_breakpointIds.BREAKPOINT_ID_MAIN]: {
          maxWidth: 1e4
        },
        [_breakpointIds.BREAKPOINT_ID_MEDIUM]: {
          maxWidth: 991
        },
        [_breakpointIds.BREAKPOINT_ID_SMALL]: {
          maxWidth: 767
        },
        [_breakpointIds.BREAKPOINT_ID_TINY]: {
          maxWidth: 479
        }
      };
      exports.DEFAULT_BREAKPOINTS_CONFIG = DEFAULT_BREAKPOINTS_CONFIG;
      var LARGER_BREAKPOINTS_CONFIG = {
        [_breakpointIds.BREAKPOINT_ID_MAIN]: {
          maxWidth: 1e4
        },
        [_breakpointIds.BREAKPOINT_ID_XXL]: {
          minWidth: 1920
        },
        [_breakpointIds.BREAKPOINT_ID_XL]: {
          minWidth: 1440
        },
        [_breakpointIds.BREAKPOINT_ID_LARGE]: {
          minWidth: 1280
        },
        [_breakpointIds.BREAKPOINT_ID_MEDIUM]: {
          maxWidth: 991
        },
        [_breakpointIds.BREAKPOINT_ID_SMALL]: {
          maxWidth: 767
        },
        [_breakpointIds.BREAKPOINT_ID_TINY]: {
          maxWidth: 479
        }
      };
      exports.LARGER_BREAKPOINTS_CONFIG = LARGER_BREAKPOINTS_CONFIG;
      var LARGER_BREAKPOINTS_WORDING = {
        [_breakpointIds.BREAKPOINT_ID_XXL]: {
          label: "1920px and up",
          description: null,
          copy: "Styles added here will apply at 1920px and up."
        },
        [_breakpointIds.BREAKPOINT_ID_XL]: {
          label: "1440px and up",
          description: null,
          copy: "Styles added here will apply at 1440px and up, unless they\u2019re edited at a larger breakpoint."
        },
        [_breakpointIds.BREAKPOINT_ID_LARGE]: {
          label: "1280px and up",
          description: null,
          copy: "Styles added here will apply at 1280px and up, unless they\u2019re edited at a larger breakpoint."
        },
        [_breakpointIds.BREAKPOINT_ID_MAIN]: {
          label: "Desktop",
          description: "Base breakpoint",
          copy: "Desktop styles apply at all breakpoints, unless they\u2019re edited at a larger or smaller breakpoint. Start your styling here."
        },
        [_breakpointIds.BREAKPOINT_ID_MEDIUM]: {
          label: "Tablet",
          description: "991px and down",
          copy: "Styles added here will apply at 991px and down, unless they\u2019re edited at a smaller breakpoint."
        },
        [_breakpointIds.BREAKPOINT_ID_SMALL]: {
          label: "Mobile landscape",
          description: "767px and down",
          copy: "Styles added here will apply at 767px and down, unless they\u2019re edited at a smaller breakpoint."
        },
        [_breakpointIds.BREAKPOINT_ID_TINY]: {
          label: "Mobile portrait",
          description: "478px and down",
          copy: "Styles added here will apply at 478px and down."
        }
      };
      exports.LARGER_BREAKPOINTS_WORDING = LARGER_BREAKPOINTS_WORDING;
    }
  });

  // packages/shared/render/plugins/Commerce/StyleMapObserver.js
  var require_StyleMapObserver = __commonJS({
    "packages/shared/render/plugins/Commerce/StyleMapObserver.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _defineProperty2 = _interopRequireDefault(require_defineProperty2());
      var _merge = _interopRequireDefault(require_merge());
      var _tinycolor = _interopRequireDefault(require_tinycolor());
      var _breakpointsConfig = require_breakpoints_config();
      var _breakpointIds = (init_breakpoint_ids(), __toCommonJS(breakpoint_ids_exports));
      var STYLE_MAP_ATTR = "data-wf-style-map";
      var orderedBreakpointIds = [_breakpointIds.BREAKPOINT_ID_MAIN, _breakpointIds.BREAKPOINT_ID_LARGE, _breakpointIds.BREAKPOINT_ID_XL, _breakpointIds.BREAKPOINT_ID_XXL, _breakpointIds.BREAKPOINT_ID_MEDIUM, _breakpointIds.BREAKPOINT_ID_SMALL, _breakpointIds.BREAKPOINT_ID_TINY];
      var ORDERED_MEDIA_QUERIES = orderedBreakpointIds.map((breakpointId) => {
        const config = _breakpointsConfig.LARGER_BREAKPOINTS_CONFIG[breakpointId];
        let prop2;
        let value;
        if ("minWidth" in config) {
          prop2 = "min-width";
          value = config.minWidth;
        }
        if ("maxWidth" in config) {
          prop2 = "max-width";
          value = config.maxWidth;
        }
        if (prop2 === void 0 || value === void 0) {
          throw new Error('Bad breakpoint config, expected either "minWidth" or "maxWidth".');
        }
        return {
          name: breakpointId,
          query: `(${prop2}: ${value}px)`
        };
      });
      var StyleMapObserver = class {
        constructor(element, options) {
          (0, _defineProperty2.default)(this, "styles", void 0);
          (0, _defineProperty2.default)(this, "observer", void 0);
          (0, _defineProperty2.default)(this, "mediaQueries", []);
          (0, _defineProperty2.default)(this, "options", {
            onChange: () => {
            }
          });
          (0, _defineProperty2.default)(this, "dispatch", () => {
            this.options.onChange(this.getAppliedStyles());
          });
          (0, _defineProperty2.default)(this, "handleMutationObserver", (mutationList) => {
            mutationList.forEach((mutation) => {
              if (mutation.type === "attributes" && mutation.attributeName === STYLE_MAP_ATTR && mutation.target.hasAttribute(STYLE_MAP_ATTR)) {
                const styleMapJSON = mutation.target.getAttribute(STYLE_MAP_ATTR);
                if (styleMapJSON) {
                  this.setStylesFromJSON(styleMapJSON);
                  this.dispatch();
                }
              }
            });
          });
          this.options = options;
          if (element.hasAttribute(STYLE_MAP_ATTR)) {
            const styleMapJSON = element.getAttribute(STYLE_MAP_ATTR);
            if (styleMapJSON) {
              this.setStylesFromJSON(styleMapJSON);
              const doc = element.ownerDocument;
              const win = doc.defaultView;
              this.mediaQueries = ORDERED_MEDIA_QUERIES.map((mq) => (0, _extends2.default)({}, mq, {
                listener: win.matchMedia(mq.query)
              }));
              this.observer = new win.MutationObserver(this.handleMutationObserver);
              this.observer.observe(element, {
                attributes: true
              });
              this.mediaQueries.forEach(({
                listener
              }) => {
                listener.addListener(this.dispatch);
              });
              this.dispatch();
            }
          }
        }
        setStylesFromJSON(styleMapJSON) {
          try {
            this.styles = JSON.parse(styleMapJSON);
          } catch (e) {
            this.styles = {};
          }
        }
        getAppliedStyles() {
          if (!this.styles) {
            return;
          }
          const styles = this.styles;
          const appliedStyles = this.mediaQueries.reduce((stylesMap, {
            listener,
            name
          }) => listener.matches ? (0, _merge.default)(stylesMap, styles[name]) : stylesMap, {});
          return appliedStyles;
        }
        destroy() {
          if (this.observer) {
            this.observer.disconnect();
          }
          this.mediaQueries.forEach(({
            listener
          }) => {
            listener.removeListener(this.dispatch);
          });
        }
      };
      exports.default = StyleMapObserver;
      (0, _defineProperty2.default)(StyleMapObserver, "appliedStylesToStripeElementStyles", (appliedStylesMap) => {
        if (!appliedStylesMap) {
          return {};
        }
        const appliedStylesMapWithUpdatedColorValues = Object.keys(appliedStylesMap).reduce((updatedStyles, styleKey) => {
          const colorVal = appliedStylesMap[styleKey].color;
          const textShadowVal = appliedStylesMap[styleKey].textShadow && appliedStylesMap[styleKey].textShadow.split(/(?=hsla)/);
          updatedStyles[styleKey] = appliedStylesMap[styleKey];
          if (colorVal) {
            updatedStyles[styleKey].color = (0, _tinycolor.default)(colorVal).toRgbString();
          }
          if (textShadowVal && textShadowVal.length > 1) {
            updatedStyles[styleKey].textShadow = textShadowVal[0] + (0, _tinycolor.default)(textShadowVal[1]).toRgbString();
          }
          return updatedStyles;
        }, {});
        const styles = (0, _extends2.default)({}, appliedStylesMapWithUpdatedColorValues.noPseudo, {
          ":hover": appliedStylesMapWithUpdatedColorValues.hover,
          ":focus": appliedStylesMapWithUpdatedColorValues.focus,
          "::placeholder": appliedStylesMapWithUpdatedColorValues.placeholder
        });
        return {
          base: styles,
          invalid: styles,
          empty: styles,
          complete: styles
        };
      });
    }
  });

  // packages/shared/render/plugins/Commerce/modules/debug.js
  var require_debug = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/debug.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var _default = {
        log: (...args) => {
          if (false) {
            console.log(...args);
          }
        },
        error: (...args) => {
          if (false) {
            console.log(...args);
          }
        }
      };
      exports.default = _default;
    }
  });

  // node_modules/lodash/_baseSlice.js
  var require_baseSlice = __commonJS({
    "node_modules/lodash/_baseSlice.js"(exports, module) {
      function baseSlice(array, start, end) {
        var index = -1, length2 = array.length;
        if (start < 0) {
          start = -start > length2 ? 0 : length2 + start;
        }
        end = end > length2 ? length2 : end;
        if (end < 0) {
          end += length2;
        }
        length2 = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result = Array(length2);
        while (++index < length2) {
          result[index] = array[index + start];
        }
        return result;
      }
      module.exports = baseSlice;
    }
  });

  // node_modules/lodash/_castSlice.js
  var require_castSlice = __commonJS({
    "node_modules/lodash/_castSlice.js"(exports, module) {
      var baseSlice = require_baseSlice();
      function castSlice(array, start, end) {
        var length2 = array.length;
        end = end === void 0 ? length2 : end;
        return !start && end >= length2 ? array : baseSlice(array, start, end);
      }
      module.exports = castSlice;
    }
  });

  // node_modules/lodash/_asciiToArray.js
  var require_asciiToArray = __commonJS({
    "node_modules/lodash/_asciiToArray.js"(exports, module) {
      function asciiToArray(string) {
        return string.split("");
      }
      module.exports = asciiToArray;
    }
  });

  // node_modules/lodash/_unicodeToArray.js
  var require_unicodeToArray = __commonJS({
    "node_modules/lodash/_unicodeToArray.js"(exports, module) {
      var rsAstralRange = "\\ud800-\\udfff";
      var rsComboMarksRange = "\\u0300-\\u036f";
      var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
      var rsComboSymbolsRange = "\\u20d0-\\u20ff";
      var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
      var rsVarRange = "\\ufe0e\\ufe0f";
      var rsAstral = "[" + rsAstralRange + "]";
      var rsCombo = "[" + rsComboRange + "]";
      var rsFitz = "\\ud83c[\\udffb-\\udfff]";
      var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
      var rsNonAstral = "[^" + rsAstralRange + "]";
      var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
      var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
      var rsZWJ = "\\u200d";
      var reOptMod = rsModifier + "?";
      var rsOptVar = "[" + rsVarRange + "]?";
      var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
      var rsSeq = rsOptVar + reOptMod + rsOptJoin;
      var rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      module.exports = unicodeToArray;
    }
  });

  // node_modules/lodash/_stringToArray.js
  var require_stringToArray = __commonJS({
    "node_modules/lodash/_stringToArray.js"(exports, module) {
      var asciiToArray = require_asciiToArray();
      var hasUnicode = require_hasUnicode();
      var unicodeToArray = require_unicodeToArray();
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      module.exports = stringToArray;
    }
  });

  // node_modules/lodash/_createCaseFirst.js
  var require_createCaseFirst = __commonJS({
    "node_modules/lodash/_createCaseFirst.js"(exports, module) {
      var castSlice = require_castSlice();
      var hasUnicode = require_hasUnicode();
      var stringToArray = require_stringToArray();
      var toString4 = require_toString();
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString4(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      module.exports = createCaseFirst;
    }
  });

  // node_modules/lodash/upperFirst.js
  var require_upperFirst = __commonJS({
    "node_modules/lodash/upperFirst.js"(exports, module) {
      var createCaseFirst = require_createCaseFirst();
      var upperFirst = createCaseFirst("toUpperCase");
      module.exports = upperFirst;
    }
  });

  // node_modules/lodash/capitalize.js
  var require_capitalize = __commonJS({
    "node_modules/lodash/capitalize.js"(exports, module) {
      var toString4 = require_toString();
      var upperFirst = require_upperFirst();
      function capitalize(string) {
        return upperFirst(toString4(string).toLowerCase());
      }
      module.exports = capitalize;
    }
  });

  // node_modules/lodash/_basePropertyOf.js
  var require_basePropertyOf = __commonJS({
    "node_modules/lodash/_basePropertyOf.js"(exports, module) {
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? void 0 : object[key];
        };
      }
      module.exports = basePropertyOf;
    }
  });

  // node_modules/lodash/_deburrLetter.js
  var require_deburrLetter = __commonJS({
    "node_modules/lodash/_deburrLetter.js"(exports, module) {
      var basePropertyOf = require_basePropertyOf();
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var deburrLetter = basePropertyOf(deburredLetters);
      module.exports = deburrLetter;
    }
  });

  // node_modules/lodash/deburr.js
  var require_deburr = __commonJS({
    "node_modules/lodash/deburr.js"(exports, module) {
      var deburrLetter = require_deburrLetter();
      var toString4 = require_toString();
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var rsComboMarksRange = "\\u0300-\\u036f";
      var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
      var rsComboSymbolsRange = "\\u20d0-\\u20ff";
      var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
      var rsCombo = "[" + rsComboRange + "]";
      var reComboMark = RegExp(rsCombo, "g");
      function deburr(string) {
        string = toString4(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
      }
      module.exports = deburr;
    }
  });

  // node_modules/lodash/_asciiWords.js
  var require_asciiWords = __commonJS({
    "node_modules/lodash/_asciiWords.js"(exports, module) {
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      module.exports = asciiWords;
    }
  });

  // node_modules/lodash/_hasUnicodeWord.js
  var require_hasUnicodeWord = __commonJS({
    "node_modules/lodash/_hasUnicodeWord.js"(exports, module) {
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      module.exports = hasUnicodeWord;
    }
  });

  // node_modules/lodash/_unicodeWords.js
  var require_unicodeWords = __commonJS({
    "node_modules/lodash/_unicodeWords.js"(exports, module) {
      var rsAstralRange = "\\ud800-\\udfff";
      var rsComboMarksRange = "\\u0300-\\u036f";
      var reComboHalfMarksRange = "\\ufe20-\\ufe2f";
      var rsComboSymbolsRange = "\\u20d0-\\u20ff";
      var rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
      var rsDingbatRange = "\\u2700-\\u27bf";
      var rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff";
      var rsMathOpRange = "\\xac\\xb1\\xd7\\xf7";
      var rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf";
      var rsPunctuationRange = "\\u2000-\\u206f";
      var rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000";
      var rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde";
      var rsVarRange = "\\ufe0e\\ufe0f";
      var rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]";
      var rsBreak = "[" + rsBreakRange + "]";
      var rsCombo = "[" + rsComboRange + "]";
      var rsDigits = "\\d+";
      var rsDingbat = "[" + rsDingbatRange + "]";
      var rsLower = "[" + rsLowerRange + "]";
      var rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]";
      var rsFitz = "\\ud83c[\\udffb-\\udfff]";
      var rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")";
      var rsNonAstral = "[^" + rsAstralRange + "]";
      var rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}";
      var rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]";
      var rsUpper = "[" + rsUpperRange + "]";
      var rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")";
      var rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")";
      var rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?";
      var rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?";
      var reOptMod = rsModifier + "?";
      var rsOptVar = "[" + rsVarRange + "]?";
      var rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*";
      var rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])";
      var rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])";
      var rsSeq = rsOptVar + reOptMod + rsOptJoin;
      var rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq;
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      module.exports = unicodeWords;
    }
  });

  // node_modules/lodash/words.js
  var require_words = __commonJS({
    "node_modules/lodash/words.js"(exports, module) {
      var asciiWords = require_asciiWords();
      var hasUnicodeWord = require_hasUnicodeWord();
      var toString4 = require_toString();
      var unicodeWords = require_unicodeWords();
      function words(string, pattern, guard) {
        string = toString4(string);
        pattern = guard ? void 0 : pattern;
        if (pattern === void 0) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      module.exports = words;
    }
  });

  // node_modules/lodash/_createCompounder.js
  var require_createCompounder = __commonJS({
    "node_modules/lodash/_createCompounder.js"(exports, module) {
      var arrayReduce = require_arrayReduce();
      var deburr = require_deburr();
      var words = require_words();
      var rsApos = "['\u2019]";
      var reApos = RegExp(rsApos, "g");
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
        };
      }
      module.exports = createCompounder;
    }
  });

  // node_modules/lodash/camelCase.js
  var require_camelCase = __commonJS({
    "node_modules/lodash/camelCase.js"(exports, module) {
      var capitalize = require_capitalize();
      var createCompounder = require_createCompounder();
      var camelCase = createCompounder(function(result, word, index) {
        word = word.toLowerCase();
        return result + (index ? capitalize(word) : word);
      });
      module.exports = camelCase;
    }
  });

  // packages/systems/commerce/constants/pluginConstants.js
  var require_pluginConstants = __commonJS({
    "packages/systems/commerce/constants/pluginConstants.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.NODE_TYPE_COMMERCE_CART_ERROR = exports.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER = exports.NODE_TYPE_COMMERCE_CART_CONTAINER = exports.NODE_TYPE_COMMERCE_CART_CLOSE_LINK = exports.NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON = exports.NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON = exports.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON = exports.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP = exports.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL = exports.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT = exports.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST = exports.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM = exports.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR = exports.NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON = exports.NODE_TYPE_ADD_TO_CART_ERROR = exports.NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT = exports.NEEDS_REFRESH = exports.LOADING_TEXT_DEFAULT = exports.LOADING_TEXT = exports.HIDE_CART_WHEN_EMPTY_KEYPATH = exports.HIDE_CART_WHEN_EMPTY_KEY = exports.HIDE_CART_WHEN_EMPTY_DEFAULT = exports.HIDE_CART_COUNT_KEY = exports.HIDE_CART_COUNT_DEFAULT = exports.EDITABLE_STYLE_NAMES = exports.EASINGS = exports.EASE_DEFAULT = exports.DEFAULT_SKU_SLUG = exports.DATA_ATTR_SUBSCRIPTION_TEXT = exports.DATA_ATTR_PUBLISHABLE_KEY = exports.DATA_ATTR_PRESELECT_DEFAULT_VARIANT = exports.DATA_ATTR_OPEN_PRODUCT = exports.DATA_ATTR_OPEN_ON_HOVER = exports.DATA_ATTR_NODE_TYPE = exports.DATA_ATTR_LOADING_TEXT = exports.DATA_ATTR_DEFAULT_TEXT = exports.DATA_ATTR_COUNT_HIDE_RULE = exports.DATA_ATTR_COMMERCE_SKU_ID = exports.DATA_ATTR_COMMERCE_PRODUCT_ID = exports.DATA_ATTR_COMMERCE_PRODUCT_CURRENT_SKU_VALUES = exports.DATA_ATTR_COMMERCE_OPTION_SET_ID = exports.DATA_ATTR_ANIMATION_EASING = exports.DATA_ATTR_ANIMATION_DURATION = exports.COMMERCE_SKU_FIELD_SLUG = exports.COMMERCE_SKU_COLLECTION_SLUG = exports.COMMERCE_PRODUCT_FIELD_SLUG = exports.COMMERCE_PRODUCT_COLLECTION_SLUG = exports.COMMERCE_PLUGIN_KEY = exports.COMMERCE_ERROR_CATEGORY = exports.COMMERCE_DEFAULT_COPY = exports.COMMERCE_CATEGORY_COLLECTION_SLUG = exports.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR = exports.COMMERCE_CART_PUBLISHED_SITE_ACTIONS = exports.COMMERCE_CART_ITEM_ID_ATTR = exports.CHECKOUT_STATES = exports.CHECKOUT_STATE = exports.CHECKOUT_QUERY = exports.CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT = exports.CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT = exports.CHECKOUT_ERRORS = exports.CHECKOUT_DISABLED_ERROR_MESSAGE = exports.CHECKOUT_BINDING_ROOT_QUERY_PATH = exports.CHANGE_CART_EVENT = exports.CART_TYPE_KEY = exports.CART_TYPE_DROPDOWN_ON_OPEN_KEY = exports.CART_TYPE_DROPDOWN_ON_OPEN = exports.CART_TYPES = exports.CART_TYPE = exports.CART_STATES_AUTOMATION = exports.CART_STATES = exports.CART_STATE = exports.CART_QUERY = exports.CART_PRODUCT_ADDED_KEYPATH = exports.CART_PRODUCT_ADDED_KEY = exports.CART_PRODUCT_ADDED_DEFAULT = exports.CART_OPEN = exports.CART_GENERAL_ERROR_MESSAGE = exports.CART_ERROR_MESSAGE_SELECTOR = exports.CART_ERROR_MESSAGE = exports.CART_ERRORS = exports.CART_COUNT_HIDE_RULES = exports.CART_CHECKOUT_LOADING_TEXT_DEFAULT = exports.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR = exports.CART_CHECKOUT_ERROR_MESSAGE = exports.CART_CHECKOUT_BUTTON_TEXT_DEFAULT = exports.BILLING_ADDRESS_TOGGLE_KEYPATH = exports.BILLING_ADDRESS_TOGGLE_KEY = exports.BILLING_ADDRESS_TOGGLE_DEFAULT = exports.ANIMATION_EASING_KEYPATH = exports.ANIMATION_EASING_KEY = exports.ANIMATION_EASING_DEFAULT = exports.ANIMATION_DURATION_KEYPATH = exports.ANIMATION_DURATION_KEY = exports.ANIMATION_DURATION_DEFAULT = exports.ALIGN_KEY = exports.ALIGN_DEFAULT = exports.ADD_TO_CART_STATES = exports.ADD_TO_CART_LOADING = exports.ADD_TO_CART_ERROR_MESSAGE = exports.ADD_TO_CART_ERRORS = void 0;
      exports.symbolMap = exports.getCheckoutErrorMessageForType = exports.getCartErrorMessageForType = exports.getATCErrorMessageForType = exports.WF_TEMPLATE_TYPE = exports.WF_TEMPLATE_ID_DATA_KEY = exports.WF_SKU_CONDITION_DATA_KEY = exports.WF_SKU_BINDING_DATA_KEY = exports.WF_CONDITION_DATA_KEY = exports.WF_COLLECTION_DATA_KEY = exports.WF_BINDING_DATA_KEY = exports.STRIPE_ELEMENT_TYPE = exports.STRIPE_ELEMENT_STYLE = exports.STRIPE_ELEMENT_INSTANCE = exports.STRIPE_ECOMMERCE_KEY = exports.STRIPE_ECOMMERCE_ACCOUNT_ID = exports.STATE = exports.SHIPPING_METHODS_STATES = exports.SHIPPING_METHODS_STATE = exports.SECTION_NAMES = exports.REQUIRES_SHIPPING = exports.REQUIRES_ACTION = exports.RENDER_TREE_EVENT = exports.QUICK_CHECKOUT_STATE_KEYPATH = exports.QUICK_CHECKOUT_STATES = exports.QUICK_CHECKOUT_STATE = exports.QUICK_CHECKOUT_AUTOMATION = exports.QUANTITY_ENABLED = exports.PREVIEW_ITEMS_KEYPATH = exports.PREVIEW_ITEMS_KEY = exports.PREVIEW_ITEMS_DEFAULT = exports.PAYPAL_ELEMENT_INSTANCE = exports.PAYPAL_BUTTON_ELEMENT_INSTANCE = exports.ORDER_TYPE = exports.ORDER_QUERY = exports.OPEN_STATE_KEYPATH = exports.OPEN_STATE_KEY = exports.OPEN_STATE_DEFAULT = exports.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER = exports.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE = exports.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER = exports.NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON = exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER = exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST = exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE = exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD = exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER = exports.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON = exports.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER = exports.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE = exports.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT = exports.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM = exports.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER = exports.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD = exports.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER = exports.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX = exports.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO = exports.NODE_TYPE_COMMERCE_CART_WRAPPER = exports.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON = exports.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS = exports.NODE_TYPE_COMMERCE_CART_OPEN_LINK = exports.NODE_TYPE_COMMERCE_CART_FORM = void 0;
      var DATA_ATTR_COMMERCE_SKU_ID = "data-commerce-sku-id";
      exports.DATA_ATTR_COMMERCE_SKU_ID = DATA_ATTR_COMMERCE_SKU_ID;
      var DATA_ATTR_COMMERCE_PRODUCT_CURRENT_SKU_VALUES = "data-commerce-product-sku-values";
      exports.DATA_ATTR_COMMERCE_PRODUCT_CURRENT_SKU_VALUES = DATA_ATTR_COMMERCE_PRODUCT_CURRENT_SKU_VALUES;
      var DATA_ATTR_COMMERCE_OPTION_SET_ID = "data-commerce-option-set-id";
      exports.DATA_ATTR_COMMERCE_OPTION_SET_ID = DATA_ATTR_COMMERCE_OPTION_SET_ID;
      var DATA_ATTR_COMMERCE_PRODUCT_ID = "data-commerce-product-id";
      exports.DATA_ATTR_COMMERCE_PRODUCT_ID = DATA_ATTR_COMMERCE_PRODUCT_ID;
      var DATA_ATTR_NODE_TYPE = "data-node-type";
      exports.DATA_ATTR_NODE_TYPE = DATA_ATTR_NODE_TYPE;
      var DATA_ATTR_LOADING_TEXT = "data-loading-text";
      exports.DATA_ATTR_LOADING_TEXT = DATA_ATTR_LOADING_TEXT;
      var DATA_ATTR_OPEN_PRODUCT = "data-open-product";
      exports.DATA_ATTR_OPEN_PRODUCT = DATA_ATTR_OPEN_PRODUCT;
      var DATA_ATTR_OPEN_ON_HOVER = "data-open-on-hover";
      exports.DATA_ATTR_OPEN_ON_HOVER = DATA_ATTR_OPEN_ON_HOVER;
      var DATA_ATTR_COUNT_HIDE_RULE = "data-count-hide-rule";
      exports.DATA_ATTR_COUNT_HIDE_RULE = DATA_ATTR_COUNT_HIDE_RULE;
      var DATA_ATTR_PRESELECT_DEFAULT_VARIANT = "data-preselect-default-variant";
      exports.DATA_ATTR_PRESELECT_DEFAULT_VARIANT = DATA_ATTR_PRESELECT_DEFAULT_VARIANT;
      var DATA_ATTR_DEFAULT_TEXT = "data-default-text";
      exports.DATA_ATTR_DEFAULT_TEXT = DATA_ATTR_DEFAULT_TEXT;
      var DATA_ATTR_SUBSCRIPTION_TEXT = "data-subscription-text";
      exports.DATA_ATTR_SUBSCRIPTION_TEXT = DATA_ATTR_SUBSCRIPTION_TEXT;
      var NODE_TYPE_COMMERCE_ADD_TO_CART_FORM = "commerce-add-to-cart-form";
      exports.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM = NODE_TYPE_COMMERCE_ADD_TO_CART_FORM;
      var NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR = "commerce-add-to-cart-error";
      exports.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR = NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR;
      var NODE_TYPE_COMMERCE_CART_ERROR = "commerce-cart-error";
      exports.NODE_TYPE_COMMERCE_CART_ERROR = NODE_TYPE_COMMERCE_CART_ERROR;
      var NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT = "commerce-add-to-cart-option-select";
      exports.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT = NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT;
      var NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST = "commerce-add-to-cart-option-list";
      exports.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST = NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST;
      var NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP = "commerce-add-to-cart-pill-group";
      exports.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP = NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP;
      var NODE_TYPE_COMMERCE_ADD_TO_CART_PILL = "commerce-add-to-cart-pill";
      exports.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL = NODE_TYPE_COMMERCE_ADD_TO_CART_PILL;
      var NODE_TYPE_COMMERCE_CART_WRAPPER = "commerce-cart-wrapper";
      exports.NODE_TYPE_COMMERCE_CART_WRAPPER = NODE_TYPE_COMMERCE_CART_WRAPPER;
      var NODE_TYPE_COMMERCE_CART_OPEN_LINK = "commerce-cart-open-link";
      exports.NODE_TYPE_COMMERCE_CART_OPEN_LINK = NODE_TYPE_COMMERCE_CART_OPEN_LINK;
      var NODE_TYPE_COMMERCE_CART_CLOSE_LINK = "commerce-cart-close-link";
      exports.NODE_TYPE_COMMERCE_CART_CLOSE_LINK = NODE_TYPE_COMMERCE_CART_CLOSE_LINK;
      var NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER = "commerce-cart-container-wrapper";
      exports.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER = NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER;
      var NODE_TYPE_COMMERCE_CART_CONTAINER = "commerce-cart-container";
      exports.NODE_TYPE_COMMERCE_CART_CONTAINER = NODE_TYPE_COMMERCE_CART_CONTAINER;
      var NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON = "cart-checkout-button";
      exports.NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON = NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON;
      var NODE_TYPE_COMMERCE_CART_FORM = "commerce-cart-form";
      exports.NODE_TYPE_COMMERCE_CART_FORM = NODE_TYPE_COMMERCE_CART_FORM;
      var NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT = "commerce-add-to-cart-quantity-input";
      exports.NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT = NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT;
      var NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER = "commerce-checkout-form-container";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER = NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER;
      var NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER = "commerce-checkout-customer-info-wrapper";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER = NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER;
      var NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER = "commerce-checkout-shipping-address-wrapper";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER = NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER;
      var NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD = "commerce-checkout-shipping-zip-field";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD = NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD;
      var NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD = "commerce-checkout-billing-zip-field";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD = NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD;
      var NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER = "commerce-checkout-billing-address-wrapper";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER = NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER;
      var NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER = "commerce-checkout-shipping-methods-wrapper";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER = NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER;
      var NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST = "commerce-checkout-shipping-methods-list";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST = NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST;
      var NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE = "commerce-checkout-shipping-methods-empty-state";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE = NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE;
      var NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX = "commerce-checkout-billing-address-toggle-checkbox";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX = NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX;
      var NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON = "commerce-checkout-place-order-button";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON = NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON;
      var NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE = "commerce-checkout-error-state";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE = NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE;
      var NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER = "commerce-order-confirmation-wrapper";
      exports.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER = NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER;
      var NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS = "commerce-cart-quick-checkout-actions";
      exports.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS = NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS;
      var NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON = "commerce-cart-quick-checkout-button";
      exports.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON = NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON;
      var NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON = "commerce-cart-apple-pay-button";
      exports.NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON = NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON;
      var NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO = "commerce-checkout-additional-info";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO = NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO;
      var NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER = "commerce-paypal-checkout-form-container";
      exports.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER = NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER;
      var NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE = "commerce-checkout-error-state";
      exports.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE = NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE;
      var NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM = "commerce-checkout-discount-form";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM = NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM;
      var NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT = "commerce-checkout-discount-input";
      exports.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT = NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT;
      var NODE_TYPE_COMMERCE_BUY_NOW_BUTTON = "commerce-buy-now-button";
      exports.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON = NODE_TYPE_COMMERCE_BUY_NOW_BUTTON;
      var NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON = "commerce-downloads-button";
      exports.NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON = NODE_TYPE_COMMERCE_DOWNLOADS_BUTTON;
      var NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON = "commerce-add-to-cart-button";
      exports.NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON = NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON;
      var NODE_TYPE_ADD_TO_CART_ERROR = "commerce-add-to-cart-error";
      exports.NODE_TYPE_ADD_TO_CART_ERROR = NODE_TYPE_ADD_TO_CART_ERROR;
      var ADD_TO_CART_STATES = {
        DEFAULT: "DEFAULT",
        OUT_OF_STOCK: "OUT_OF_STOCK",
        ERROR: "ERROR"
      };
      exports.ADD_TO_CART_STATES = ADD_TO_CART_STATES;
      var CART_STATES = {
        DEFAULT: "DEFAULT",
        EMPTY: "EMPTY",
        ERROR: "ERROR"
      };
      exports.CART_STATES = CART_STATES;
      var CART_STATES_AUTOMATION = {
        DEFAULT: "cart-default-button",
        EMPTY: "cart-empty-button",
        ERROR: "cart-error-button"
      };
      exports.CART_STATES_AUTOMATION = CART_STATES_AUTOMATION;
      var CHECKOUT_STATES = {
        DEFAULT: "DEFAULT",
        ERROR: "ERROR"
      };
      exports.CHECKOUT_STATES = CHECKOUT_STATES;
      var SHIPPING_METHODS_STATES = {
        DEFAULT: "DEFAULT",
        EMPTY: "EMPTY"
      };
      exports.SHIPPING_METHODS_STATES = SHIPPING_METHODS_STATES;
      var CART_TYPE_DROPDOWN_ON_OPEN = {
        CLICK: "CLICK",
        HOVER: "HOVER"
      };
      exports.CART_TYPE_DROPDOWN_ON_OPEN = CART_TYPE_DROPDOWN_ON_OPEN;
      var CART_TYPES = {
        MODAL: "modal",
        LEFT_SIDEBAR: "leftSidebar",
        RIGHT_SIDEBAR: "rightSidebar",
        LEFT_DROPDOWN: "leftDropdown",
        RIGHT_DROPDOWN: "rightDropdown",
        DROPDOWN: "dropdown"
      };
      exports.CART_TYPES = CART_TYPES;
      var CART_COUNT_HIDE_RULES = {
        ALWAYS: "always",
        EMPTY: "empty"
      };
      exports.CART_COUNT_HIDE_RULES = CART_COUNT_HIDE_RULES;
      var QUICK_CHECKOUT_STATES = {
        NONE: "NONE",
        PAY_NOW: "PAY_NOW",
        APPLE_PAY: "APPLE_PAY"
      };
      exports.QUICK_CHECKOUT_STATES = QUICK_CHECKOUT_STATES;
      var QUICK_CHECKOUT_AUTOMATION = {
        PAY_NOW: "quick-checkout-default-button",
        APPLE_PAY: "quick-checkout-apple-pay-button"
      };
      exports.QUICK_CHECKOUT_AUTOMATION = QUICK_CHECKOUT_AUTOMATION;
      var PREVIEW_ITEMS_DEFAULT = 3;
      exports.PREVIEW_ITEMS_DEFAULT = PREVIEW_ITEMS_DEFAULT;
      var PREVIEW_ITEMS_KEY = "previewItems";
      exports.PREVIEW_ITEMS_KEY = PREVIEW_ITEMS_KEY;
      var PREVIEW_ITEMS_KEYPATH = ["data", "temp", PREVIEW_ITEMS_KEY];
      exports.PREVIEW_ITEMS_KEYPATH = PREVIEW_ITEMS_KEYPATH;
      var QUANTITY_ENABLED = "quantityEnabled";
      exports.QUANTITY_ENABLED = QUANTITY_ENABLED;
      var STATE = "state";
      exports.STATE = STATE;
      var CART_STATE = "state";
      exports.CART_STATE = CART_STATE;
      var QUICK_CHECKOUT_STATE = "state";
      exports.QUICK_CHECKOUT_STATE = QUICK_CHECKOUT_STATE;
      var QUICK_CHECKOUT_STATE_KEYPATH = ["data", "temp", QUICK_CHECKOUT_STATE];
      exports.QUICK_CHECKOUT_STATE_KEYPATH = QUICK_CHECKOUT_STATE_KEYPATH;
      var CHECKOUT_STATE = "state";
      exports.CHECKOUT_STATE = CHECKOUT_STATE;
      var SHIPPING_METHODS_STATE = "shippingMethodsState";
      exports.SHIPPING_METHODS_STATE = SHIPPING_METHODS_STATE;
      var OPEN_STATE_KEY = "isOpen";
      exports.OPEN_STATE_KEY = OPEN_STATE_KEY;
      var OPEN_STATE_KEYPATH = ["data", "temp", OPEN_STATE_KEY];
      exports.OPEN_STATE_KEYPATH = OPEN_STATE_KEYPATH;
      var OPEN_STATE_DEFAULT = false;
      exports.OPEN_STATE_DEFAULT = OPEN_STATE_DEFAULT;
      var BILLING_ADDRESS_TOGGLE_KEY = "isBillingAddressOpen";
      exports.BILLING_ADDRESS_TOGGLE_KEY = BILLING_ADDRESS_TOGGLE_KEY;
      var BILLING_ADDRESS_TOGGLE_KEYPATH = ["data", "temp", BILLING_ADDRESS_TOGGLE_KEY];
      exports.BILLING_ADDRESS_TOGGLE_KEYPATH = BILLING_ADDRESS_TOGGLE_KEYPATH;
      var BILLING_ADDRESS_TOGGLE_DEFAULT = true;
      exports.BILLING_ADDRESS_TOGGLE_DEFAULT = BILLING_ADDRESS_TOGGLE_DEFAULT;
      var HIDE_CART_WHEN_EMPTY_KEY = "hideCartWhenEmpty";
      exports.HIDE_CART_WHEN_EMPTY_KEY = HIDE_CART_WHEN_EMPTY_KEY;
      var HIDE_CART_WHEN_EMPTY_KEYPATH = ["data", "commerce", HIDE_CART_WHEN_EMPTY_KEY];
      exports.HIDE_CART_WHEN_EMPTY_KEYPATH = HIDE_CART_WHEN_EMPTY_KEYPATH;
      var HIDE_CART_WHEN_EMPTY_DEFAULT = false;
      exports.HIDE_CART_WHEN_EMPTY_DEFAULT = HIDE_CART_WHEN_EMPTY_DEFAULT;
      var HIDE_CART_COUNT_KEY = "hideCartCount";
      exports.HIDE_CART_COUNT_KEY = HIDE_CART_COUNT_KEY;
      var HIDE_CART_COUNT_DEFAULT = false;
      exports.HIDE_CART_COUNT_DEFAULT = HIDE_CART_COUNT_DEFAULT;
      var LOADING_TEXT = "loadingText";
      exports.LOADING_TEXT = LOADING_TEXT;
      var LOADING_TEXT_DEFAULT = "Adding to cart...";
      exports.LOADING_TEXT_DEFAULT = LOADING_TEXT_DEFAULT;
      var CART_CHECKOUT_BUTTON_TEXT_DEFAULT = "Continue to Checkout";
      exports.CART_CHECKOUT_BUTTON_TEXT_DEFAULT = CART_CHECKOUT_BUTTON_TEXT_DEFAULT;
      var CART_CHECKOUT_LOADING_TEXT_DEFAULT = "Hang Tight...";
      exports.CART_CHECKOUT_LOADING_TEXT_DEFAULT = CART_CHECKOUT_LOADING_TEXT_DEFAULT;
      var CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT = "Place Order";
      exports.CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT = CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT;
      var CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT = "Placing Order...";
      exports.CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT = CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT;
      var CART_TYPE_KEY = "cartType";
      exports.CART_TYPE_KEY = CART_TYPE_KEY;
      var ALIGN_KEY = "align";
      exports.ALIGN_KEY = ALIGN_KEY;
      var ALIGN_DEFAULT = "rightDropdown";
      exports.ALIGN_DEFAULT = ALIGN_DEFAULT;
      var CART_TYPE_DROPDOWN_ON_OPEN_KEY = "openOn";
      exports.CART_TYPE_DROPDOWN_ON_OPEN_KEY = CART_TYPE_DROPDOWN_ON_OPEN_KEY;
      var CART_PRODUCT_ADDED_KEY = "openWhenProductAdded";
      exports.CART_PRODUCT_ADDED_KEY = CART_PRODUCT_ADDED_KEY;
      var CART_PRODUCT_ADDED_KEYPATH = ["data", "commerce", CART_PRODUCT_ADDED_KEY];
      exports.CART_PRODUCT_ADDED_KEYPATH = CART_PRODUCT_ADDED_KEYPATH;
      var CART_PRODUCT_ADDED_DEFAULT = true;
      exports.CART_PRODUCT_ADDED_DEFAULT = CART_PRODUCT_ADDED_DEFAULT;
      var COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR = "data-wf-cart-action";
      exports.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR = COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR;
      var COMMERCE_CART_PUBLISHED_SITE_ACTIONS = {
        UPDATE_ITEM_QUANTITY: "update-item-quantity",
        REMOVE_ITEM: "remove-item"
      };
      exports.COMMERCE_CART_PUBLISHED_SITE_ACTIONS = COMMERCE_CART_PUBLISHED_SITE_ACTIONS;
      var COMMERCE_CART_ITEM_ID_ATTR = "data-wf-item-id";
      exports.COMMERCE_CART_ITEM_ID_ATTR = COMMERCE_CART_ITEM_ID_ATTR;
      var COMMERCE_SKU_COLLECTION_SLUG = "sku";
      exports.COMMERCE_SKU_COLLECTION_SLUG = COMMERCE_SKU_COLLECTION_SLUG;
      var COMMERCE_SKU_FIELD_SLUG = "sku";
      exports.COMMERCE_SKU_FIELD_SLUG = COMMERCE_SKU_FIELD_SLUG;
      var COMMERCE_PRODUCT_COLLECTION_SLUG = "product";
      exports.COMMERCE_PRODUCT_COLLECTION_SLUG = COMMERCE_PRODUCT_COLLECTION_SLUG;
      var COMMERCE_PRODUCT_FIELD_SLUG = "product";
      exports.COMMERCE_PRODUCT_FIELD_SLUG = COMMERCE_PRODUCT_FIELD_SLUG;
      var COMMERCE_CATEGORY_COLLECTION_SLUG = "category";
      exports.COMMERCE_CATEGORY_COLLECTION_SLUG = COMMERCE_CATEGORY_COLLECTION_SLUG;
      var COMMERCE_PLUGIN_KEY = "ecommerce";
      exports.COMMERCE_PLUGIN_KEY = COMMERCE_PLUGIN_KEY;
      var DEFAULT_SKU_SLUG = "default-sku";
      exports.DEFAULT_SKU_SLUG = DEFAULT_SKU_SLUG;
      var WF_BINDING_DATA_KEY = "data-wf-bindings";
      exports.WF_BINDING_DATA_KEY = WF_BINDING_DATA_KEY;
      var WF_CONDITION_DATA_KEY = "data-wf-conditions";
      exports.WF_CONDITION_DATA_KEY = WF_CONDITION_DATA_KEY;
      var WF_COLLECTION_DATA_KEY = "data-wf-collection";
      exports.WF_COLLECTION_DATA_KEY = WF_COLLECTION_DATA_KEY;
      var WF_TEMPLATE_ID_DATA_KEY = "data-wf-template-id";
      exports.WF_TEMPLATE_ID_DATA_KEY = WF_TEMPLATE_ID_DATA_KEY;
      var WF_SKU_BINDING_DATA_KEY = "data-wf-sku-bindings";
      exports.WF_SKU_BINDING_DATA_KEY = WF_SKU_BINDING_DATA_KEY;
      var WF_SKU_CONDITION_DATA_KEY = "data-wf-sku-conditions";
      exports.WF_SKU_CONDITION_DATA_KEY = WF_SKU_CONDITION_DATA_KEY;
      var WF_TEMPLATE_TYPE = "text/x-wf-template";
      exports.WF_TEMPLATE_TYPE = WF_TEMPLATE_TYPE;
      var INFO_ERR = "INFO_ERROR";
      var SHIPPING_ERR = "SHIPPING_ERROR";
      var BILLING_ERR = "BILLING_ERROR";
      var PAYMENT_ERR = "PAYMENT_ERROR";
      var PRICING_ERR = "PRICING_ERROR";
      var ORDER_MIN_ERR = "ORDER_MINIMUM_ERROR";
      var ORDER_EXTRAS_ERR = "ORDER_EXTRAS_ERROR";
      var PRODUCT_ERR = "PRODUCT_ERROR";
      var INVALID_DISCOUNT_ERR = "INVALID_DISCOUNT_ERROR";
      var EXPIRED_DISCOUNT_ERR = "EXPIRED_DISCOUNT_ERROR";
      var USAGE_REACHED_DISCOUNT_ERR = "USAGE_REACHED_DISCOUNT_ERROR";
      var REQUIREMENTS_NOT_MET_DISCOUNT_ERR = "REQUIREMENTS_NOT_MET_DISCOUNT_ERROR";
      var COMMERCE_ERROR_CATEGORY = {
        GENERAL: {
          id: "GENERAL",
          label: "General Errors"
        },
        PRODUCT: {
          id: "PRODUCT",
          label: "Product Errors"
        },
        BILLING: {
          id: "BILLING",
          label: "Billing Errors"
        },
        DISCOUNT: {
          id: "DISCOUNT",
          label: "Discount Errors"
        },
        SUBSCRIPTION: {
          id: "SUBSCRIPTION",
          label: "Subscription Errors"
        }
      };
      exports.COMMERCE_ERROR_CATEGORY = COMMERCE_ERROR_CATEGORY;
      var CHECKOUT_ERRORS = {
        INFO: {
          id: INFO_ERR,
          name: "General customer info error",
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          copy: "There was an error processing your customer info. Please try again, or contact us if you continue to have problems.",
          path: ["data", "commerce", INFO_ERR]
        },
        SHIPPING: {
          id: SHIPPING_ERR,
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Shipping not available",
          copy: "Sorry. We can\u2019t ship your order to the address provided.",
          path: ["data", "commerce", SHIPPING_ERR]
        },
        EXTRAS: {
          id: ORDER_EXTRAS_ERR,
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Merchant setting changed",
          copy: "A merchant setting has changed that impacts your cart. Please refresh and try again.",
          path: ["data", "commerce", ORDER_EXTRAS_ERR],
          requiresRefresh: true
        },
        PRICING: {
          id: PRICING_ERR,
          category: COMMERCE_ERROR_CATEGORY.PRODUCT,
          name: "Product price changed",
          copy: "The prices of one or more items in your cart have changed. Please refresh this page and try again.",
          path: ["data", "commerce", PRICING_ERR],
          requiresRefresh: true
        },
        PRODUCT: {
          id: PRODUCT_ERR,
          category: COMMERCE_ERROR_CATEGORY.PRODUCT,
          name: "Product removed",
          copy: "One or more of the products in your cart have been removed. Please refresh the page and try again.",
          path: ["data", "commerce", PRODUCT_ERR],
          requiresRefresh: true
        },
        PAYMENT: {
          id: PAYMENT_ERR,
          category: COMMERCE_ERROR_CATEGORY.BILLING,
          name: "General payment error",
          copy: "There was an error processing your payment. Please try again, or contact us if you continue to have problems.",
          path: ["data", "commerce", PAYMENT_ERR]
        },
        BILLING: {
          id: BILLING_ERR,
          category: COMMERCE_ERROR_CATEGORY.BILLING,
          name: "Card declined",
          copy: "Your payment could not be completed with the payment information provided. Please make sure that your card and billing address information is correct, or try a different payment card, to complete this order. Contact us if you continue to have problems.",
          path: ["data", "commerce", BILLING_ERR]
        },
        MINIMUM: {
          id: ORDER_MIN_ERR,
          category: COMMERCE_ERROR_CATEGORY.BILLING,
          name: "Order minimum not met",
          copy: "The order minimum was not met. Add more items to your cart to continue.",
          path: ["data", "commerce", ORDER_MIN_ERR],
          note: {
            copy: "You can customize this message with the exact minimum based on your Stripe account's settlement currency.",
            cta: {
              copy: "Go to Stripe docs",
              link: "https://stripe.com/docs/currencies#minimum-and-maximum-charge-amounts"
            }
          }
        },
        INVALID_DISCOUNT: {
          id: INVALID_DISCOUNT_ERR,
          category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
          name: "Invalid discount error",
          copy: "This discount is invalid.",
          path: ["data", "commerce", INVALID_DISCOUNT_ERR]
        },
        EXPIRED_DISCOUNT: {
          id: EXPIRED_DISCOUNT_ERR,
          category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
          name: "Discount expired",
          copy: "This discount is no longer available.",
          path: ["data", "commerce", EXPIRED_DISCOUNT_ERR]
        },
        USAGE_REACHED_DISCOUNT: {
          id: USAGE_REACHED_DISCOUNT_ERR,
          category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
          name: "Discount usage limit reached",
          copy: "This discount is no longer available.",
          path: ["data", "commerce", USAGE_REACHED_DISCOUNT_ERR]
        },
        REQUIREMENTS_NOT_MET_DISCOUNT: {
          id: REQUIREMENTS_NOT_MET_DISCOUNT_ERR,
          category: COMMERCE_ERROR_CATEGORY.DISCOUNT,
          name: "Discount requirements not met",
          copy: "Your order does not meet the requirements for this discount.",
          path: ["data", "commerce", REQUIREMENTS_NOT_MET_DISCOUNT_ERR]
        }
      };
      exports.CHECKOUT_ERRORS = CHECKOUT_ERRORS;
      var QUANTITY_ERR = "QUANTITY_ERROR";
      var CHECKOUT_ERR = "CHECKOUT_ERROR";
      var GENERAL_ERR = "GENERAL_ERROR";
      var CART_ORDER_MIN_ERR = "CART_ORDER_MIN_ERROR";
      var SUBSCRIPTION_ERR = "SUBSCRIPTION_ERR";
      var CART_ERRORS = {
        QUANTITY: {
          id: QUANTITY_ERR,
          name: "Quantity not available",
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          copy: "Product is not available in this quantity.",
          path: ["data", "commerce", QUANTITY_ERR]
        },
        GENERAL: {
          id: GENERAL_ERR,
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "General error",
          copy: "Something went wrong when adding this item to the cart.",
          path: ["data", "commerce", GENERAL_ERR]
        },
        CHECKOUT: {
          id: CHECKOUT_ERR,
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Checkout disabled",
          copy: "Checkout is disabled on this site.",
          path: ["data", "commerce", CHECKOUT_ERR]
        },
        CART_ORDER_MIN: {
          id: CART_ORDER_MIN_ERR,
          category: COMMERCE_ERROR_CATEGORY.BILLING,
          name: "Order minimum not met",
          copy: "The order minimum was not met. Add more items to your cart to continue.",
          path: ["data", "commerce", CART_ORDER_MIN_ERR]
        },
        SUBSCRIPTION_ERROR: {
          id: SUBSCRIPTION_ERR,
          category: COMMERCE_ERROR_CATEGORY.SUBSCRIPTION,
          name: "Subscription not verified",
          copy: "Before you purchase, please use your email invite to verify your address so we can send order updates.",
          path: ["data", "commerce", SUBSCRIPTION_ERR]
        }
      };
      exports.CART_ERRORS = CART_ERRORS;
      var ADD_TO_CART_QUANTITY_ERR = "ADD_TO_CART_QUANTITY_ERROR";
      var ADD_TO_CART_GENERAL_ERR = "ADD_TO_CART_GENERAL_ERROR";
      var ADD_TO_CART_MIXED_ERR = "ADD_TO_CART_MIXED_ERROR";
      var ADD_TO_CART_ERRORS = {
        QUANTITY: {
          id: ADD_TO_CART_QUANTITY_ERR,
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Quantity not available",
          copy: "Product is not available in this quantity.",
          path: ["data", "commerce", ADD_TO_CART_QUANTITY_ERR]
        },
        GENERAL: {
          id: ADD_TO_CART_GENERAL_ERR,
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Add to Cart error",
          copy: "Something went wrong when adding this item to the cart.",
          path: ["data", "commerce", ADD_TO_CART_GENERAL_ERR]
        },
        MIXED_CART: {
          id: ADD_TO_CART_MIXED_ERR,
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Add to mixed Cart error",
          copy: "You can\u2019t purchase another product with a subscription."
        },
        BUY_NOW: {
          id: "BUY_NOW_ERROR",
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Buy now error",
          copy: "Something went wrong when trying to purchase this item."
        },
        CHECKOUT_DISABLED: {
          id: "CHECKOUT_DISABLED_ERROR",
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Checkout disabled",
          copy: "Checkout is disabled on this site."
        },
        SELECT_ALL_OPTIONS: {
          id: "SELECT_ALL_OPTIONS",
          category: COMMERCE_ERROR_CATEGORY.GENERAL,
          name: "Option selection required",
          copy: "Please select an option in each set.",
          path: ["data", "commerce", "SELECT_ALL_OPTIONS"]
        }
      };
      exports.ADD_TO_CART_ERRORS = ADD_TO_CART_ERRORS;
      var DATA_ATTR_ANIMATION_EASING = "data-wf-cart-easing";
      exports.DATA_ATTR_ANIMATION_EASING = DATA_ATTR_ANIMATION_EASING;
      var ANIMATION_EASING_DEFAULT = "ease-out-quad";
      exports.ANIMATION_EASING_DEFAULT = ANIMATION_EASING_DEFAULT;
      var ANIMATION_EASING_KEY = "easingType";
      exports.ANIMATION_EASING_KEY = ANIMATION_EASING_KEY;
      var ANIMATION_EASING_KEYPATH = ["data", "commerce", ANIMATION_EASING_KEY];
      exports.ANIMATION_EASING_KEYPATH = ANIMATION_EASING_KEYPATH;
      var DATA_ATTR_ANIMATION_DURATION = "data-wf-cart-duration";
      exports.DATA_ATTR_ANIMATION_DURATION = DATA_ATTR_ANIMATION_DURATION;
      var ANIMATION_DURATION_DEFAULT = 300;
      exports.ANIMATION_DURATION_DEFAULT = ANIMATION_DURATION_DEFAULT;
      var ANIMATION_DURATION_KEY = "duration";
      exports.ANIMATION_DURATION_KEY = ANIMATION_DURATION_KEY;
      var ANIMATION_DURATION_KEYPATH = ["data", "commerce", ANIMATION_DURATION_KEY];
      exports.ANIMATION_DURATION_KEYPATH = ANIMATION_DURATION_KEYPATH;
      var DATA_ATTR_PUBLISHABLE_KEY = "data-publishable-key";
      exports.DATA_ATTR_PUBLISHABLE_KEY = DATA_ATTR_PUBLISHABLE_KEY;
      var EDITABLE_STYLE_NAMES = ["backgroundColor", "backgroundSize", "backgroundPosition", "backgroundImage", "backgroundRepeat", "border", "borderRadius", "boxShadow", "clear", "color", "cursor", "direction", "display", "filter", "float", "fontFamily", "fontSize", "fontStyle", "fontWeight", "height", "lineHeight", "letterSpacing", "listStyleType", "marginBottom", "marginLeft", "marginRight", "marginTop", "maxHeight", "minHeight", "maxWidth", "minWidth", "mixBlendMode", "opacity", "overflow", "outlineColor", "outlineOffset", "outlineStyle", "outlineWidth", "paddingBottom", "paddingLeft", "paddingRight", "paddingTop", "position", "textAlign", "textColumns", "textDecoration", "textIndent", "textTransform", "textShadow", "transform", "transition", "whiteSpace", "width"];
      exports.EDITABLE_STYLE_NAMES = EDITABLE_STYLE_NAMES;
      var symbolMap = {
        aed: "\u062F.\u0625",
        afn: "\u060B",
        all: "L",
        amd: "\u058F",
        ang: "\u0192",
        aoa: "Kz",
        ars: "$",
        aud: "$",
        awg: "\u0192",
        azn: "\u20BC",
        bam: "KM",
        bbd: "$",
        bdt: "\u09F3",
        bgn: "\u043B\u0432",
        bhd: ".\u062F.\u0628",
        bif: "FBu",
        bmd: "$",
        bnd: "$",
        bob: "$b",
        brl: "R$",
        bsd: "$",
        btc: "\u0E3F",
        btn: "Nu.",
        bwp: "P",
        byr: "Br",
        byn: "Br",
        bzd: "BZ$",
        cad: "$",
        cdf: "FC",
        chf: "CHF",
        clp: "$",
        cny: "\xA5",
        cop: "$",
        crc: "\u20A1",
        cuc: "$",
        cup: "\u20B1",
        cve: "$",
        czk: "K\u010D",
        djf: "Fdj",
        dkk: "kr",
        dop: "RD$",
        dzd: "\u062F\u062C",
        eek: "kr",
        egp: "\xA3",
        ern: "Nfk",
        etb: "Br",
        eth: "\u039E",
        eur: "\u20AC",
        fjd: "$",
        fkp: "\xA3",
        gbp: "\xA3",
        gel: "\u20BE",
        ggp: "\xA3",
        ghc: "\u20B5",
        ghs: "GH\u20B5",
        gip: "\xA3",
        gmd: "D",
        gnf: "FG",
        gtq: "Q",
        gyd: "$",
        hkd: "$",
        hnl: "L",
        hrk: "kn",
        htg: "G",
        huf: "Ft",
        idr: "Rp",
        ils: "\u20AA",
        imp: "\xA3",
        inr: "\u20B9",
        iqd: "\u0639.\u062F",
        irr: "\uFDFC",
        isk: "kr",
        jep: "\xA3",
        jmd: "J$",
        jod: "JD",
        jpy: "\xA5",
        kes: "KSh",
        kgs: "\u043B\u0432",
        khr: "\u17DB",
        kmf: "CF",
        kpw: "\u20A9",
        krw: "\u20A9",
        kwd: "KD",
        kyd: "$",
        kzt: "\u043B\u0432",
        lak: "\u20AD",
        lbp: "\xA3",
        lkr: "\u20A8",
        lrd: "$",
        lsl: "M",
        ltc: "\u0141",
        ltl: "Lt",
        lvl: "Ls",
        lyd: "LD",
        mad: "MAD",
        mdl: "lei",
        mga: "Ar",
        mkd: "\u0434\u0435\u043D",
        mmk: "K",
        mnt: "\u20AE",
        mop: "MOP$",
        mro: "UM",
        mru: "UM",
        mur: "\u20A8",
        mvr: "Rf",
        mwk: "MK",
        mxn: "$",
        myr: "RM",
        mzn: "MT",
        nad: "$",
        ngn: "\u20A6",
        nio: "C$",
        nok: "kr",
        npr: "\u20A8",
        nzd: "$",
        omr: "\uFDFC",
        pab: "B/.",
        pen: "S/.",
        pgk: "K",
        php: "\u20B1",
        pkr: "\u20A8",
        pln: "z\u0142",
        pyg: "Gs",
        qar: "\uFDFC",
        rmb: "\uFFE5",
        ron: "lei",
        rsd: "\u0414\u0438\u043D.",
        rub: "\u20BD",
        rwf: "R\u20A3",
        sar: "\uFDFC",
        sbd: "$",
        scr: "\u20A8",
        sdg: "\u062C.\u0633.",
        sek: "kr",
        sgd: "$",
        shp: "\xA3",
        sll: "Le",
        sos: "S",
        srd: "$",
        ssp: "\xA3",
        std: "Db",
        stn: "Db",
        svc: "$",
        syp: "\xA3",
        szl: "E",
        thb: "\u0E3F",
        tjs: "SM",
        tmt: "T",
        tnd: "\u062F.\u062A",
        top: "T$",
        trl: "\u20A4",
        try: "\u20BA",
        ttd: "TT$",
        tvd: "$",
        twd: "NT$",
        tzs: "TSh",
        uah: "\u20B4",
        ugx: "USh",
        usd: "$",
        uyu: "$U",
        uzs: "\u043B\u0432",
        vef: "Bs",
        vnd: "\u20AB",
        vuv: "VT",
        wst: "WS$",
        xaf: "FCFA",
        xbt: "\u0243",
        xcd: "$",
        xof: "CFA",
        xpf: "\u20A3",
        yer: "\uFDFC",
        zar: "R",
        zwd: "Z$"
      };
      exports.symbolMap = symbolMap;
      var CHECKOUT_BINDING_ROOT_QUERY_PATH = ["database", "commerceOrder"];
      exports.CHECKOUT_BINDING_ROOT_QUERY_PATH = CHECKOUT_BINDING_ROOT_QUERY_PATH;
      var ORDER_TYPE = {
        REQUIRE_SHIPPING: "shipping",
        NO_SHIPPING: "noShipping"
      };
      exports.ORDER_TYPE = ORDER_TYPE;
      var RENDER_TREE_EVENT = "wf-render-tree";
      exports.RENDER_TREE_EVENT = RENDER_TREE_EVENT;
      var NEEDS_REFRESH = "data-wf-needs-refresh";
      exports.NEEDS_REFRESH = NEEDS_REFRESH;
      var REQUIRES_SHIPPING = "data-wf-order-requires-shipping";
      exports.REQUIRES_SHIPPING = REQUIRES_SHIPPING;
      var STRIPE_ELEMENT_INSTANCE = "data-wf-stripe-element-instance";
      exports.STRIPE_ELEMENT_INSTANCE = STRIPE_ELEMENT_INSTANCE;
      var STRIPE_ELEMENT_TYPE = "data-wf-stripe-element-type";
      exports.STRIPE_ELEMENT_TYPE = STRIPE_ELEMENT_TYPE;
      var STRIPE_ELEMENT_STYLE = "data-wf-stripe-style";
      exports.STRIPE_ELEMENT_STYLE = STRIPE_ELEMENT_STYLE;
      var ADD_TO_CART_LOADING = "data-wf-atc-loading";
      exports.ADD_TO_CART_LOADING = ADD_TO_CART_LOADING;
      var CHANGE_CART_EVENT = "wf-change-cart-state";
      exports.CHANGE_CART_EVENT = CHANGE_CART_EVENT;
      var ADD_TO_CART_ERROR_MESSAGE = ".w-add-to-cart-error-msg";
      exports.ADD_TO_CART_ERROR_MESSAGE = ADD_TO_CART_ERROR_MESSAGE;
      var getATCErrorMessageForType = (errorType) => `data-w-add-to-cart-${errorType}-error`;
      exports.getATCErrorMessageForType = getATCErrorMessageForType;
      var CHECKOUT_DISABLED_ERROR_MESSAGE = "data-w-add-to-cart-checkout-disabled-error";
      exports.CHECKOUT_DISABLED_ERROR_MESSAGE = CHECKOUT_DISABLED_ERROR_MESSAGE;
      var CHECKOUT_QUERY = "data-wf-checkout-query";
      exports.CHECKOUT_QUERY = CHECKOUT_QUERY;
      var getCheckoutErrorMessageForType = (errorType) => `data-w-${errorType}-error`;
      exports.getCheckoutErrorMessageForType = getCheckoutErrorMessageForType;
      var REQUIRES_ACTION = "requires_action";
      exports.REQUIRES_ACTION = REQUIRES_ACTION;
      var CART_GENERAL_ERROR_MESSAGE = "data-w-cart-general-error";
      exports.CART_GENERAL_ERROR_MESSAGE = CART_GENERAL_ERROR_MESSAGE;
      var CART_CHECKOUT_ERROR_MESSAGE = "data-w-cart-checkout-error";
      exports.CART_CHECKOUT_ERROR_MESSAGE = CART_CHECKOUT_ERROR_MESSAGE;
      var CART_CHECKOUT_ERROR_MESSAGE_SELECTOR = ".w-checkout-error-msg";
      exports.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR = CART_CHECKOUT_ERROR_MESSAGE_SELECTOR;
      var CART_ERROR_MESSAGE = "cart-error-msg";
      exports.CART_ERROR_MESSAGE = CART_ERROR_MESSAGE;
      var CART_ERROR_MESSAGE_SELECTOR = `.w-${CART_ERROR_MESSAGE}`;
      exports.CART_ERROR_MESSAGE_SELECTOR = CART_ERROR_MESSAGE_SELECTOR;
      var CART_OPEN = "data-cart-open";
      exports.CART_OPEN = CART_OPEN;
      var CART_TYPE = "data-wf-cart-type";
      exports.CART_TYPE = CART_TYPE;
      var CART_QUERY = "data-wf-cart-query";
      exports.CART_QUERY = CART_QUERY;
      var PAYPAL_ELEMENT_INSTANCE = "data-wf-paypal-element";
      exports.PAYPAL_ELEMENT_INSTANCE = PAYPAL_ELEMENT_INSTANCE;
      var PAYPAL_BUTTON_ELEMENT_INSTANCE = "data-wf-paypal-button";
      exports.PAYPAL_BUTTON_ELEMENT_INSTANCE = PAYPAL_BUTTON_ELEMENT_INSTANCE;
      var getCartErrorMessageForType = (errorType) => `data-w-cart-${errorType}-error`;
      exports.getCartErrorMessageForType = getCartErrorMessageForType;
      var ORDER_QUERY = "data-wf-order-query";
      exports.ORDER_QUERY = ORDER_QUERY;
      var STRIPE_ECOMMERCE_KEY = "data-wf-ecomm-key";
      exports.STRIPE_ECOMMERCE_KEY = STRIPE_ECOMMERCE_KEY;
      var STRIPE_ECOMMERCE_ACCOUNT_ID = "data-wf-ecomm-acct-id";
      exports.STRIPE_ECOMMERCE_ACCOUNT_ID = STRIPE_ECOMMERCE_ACCOUNT_ID;
      var EASINGS = {
        ease: "Ease",
        "ease-in": "Ease In",
        "ease-out": "Ease Out",
        "ease-in-out": "Ease In Out",
        linear: "Linear",
        "ease-in-quad": "Ease In Quad",
        "ease-in-cubic": "Ease In Cubic",
        "ease-in-quart": "Ease In Quart",
        "ease-in-quint": "Ease In Quint",
        "ease-in-sine": "Ease In Sine",
        "ease-in-expo": "Ease In Expo",
        "ease-in-circ": "Ease In Circ",
        "ease-in-back": "Ease In Back",
        "ease-out-quad": "Ease Out Quad",
        "ease-out-cubic": "Ease Out Cubic",
        "ease-out-quart": "Ease Out Quart",
        "ease-out-quint": "Ease Out Quint",
        "ease-out-sine": "Ease Out Sine",
        "ease-out-expo": "Ease Out Expo",
        "ease-out-circ": "Ease Out Circ",
        "ease-out-back": "Ease Out Back",
        "ease-in-out-quad": "Ease In Out Quad",
        "ease-in-out-cubic": "Ease In Out Cubic",
        "ease-in-out-quart": "Ease In Out Quart",
        "ease-in-out-quint": "Ease In Out Quint",
        "ease-in-out-sine": "Ease In Out Sine",
        "ease-in-out-expo": "Ease In Out Expo",
        "ease-in-out-circ": "Ease In Out Circ",
        "ease-in-out-back": "Ease In Out Back"
      };
      exports.EASINGS = EASINGS;
      var EASE_DEFAULT = "ease-out-quad";
      exports.EASE_DEFAULT = EASE_DEFAULT;
      var SECTION_NAMES = {
        ECOMMERCE: "Ecommerce",
        CHECKOUT_PAGE: "Checkout Page",
        ORDER_CONFIRMATION_PAGE: "Order Confirmation Page",
        PAYPAL_CHECKOUT_PAGE: "Checkout (PayPal) Page"
      };
      exports.SECTION_NAMES = SECTION_NAMES;
      var COMMERCE_DEFAULT_COPY = {
        INFO_ERROR: CHECKOUT_ERRORS.INFO.copy,
        SHIPPING_ERROR: CHECKOUT_ERRORS.SHIPPING.copy,
        ORDER_EXTRAS_ERROR: CHECKOUT_ERRORS.EXTRAS.copy,
        PRICING_ERROR: CHECKOUT_ERRORS.PRICING.copy,
        PRODUCT_ERROR: CHECKOUT_ERRORS.PRODUCT.copy,
        PAYMENT_ERROR: CHECKOUT_ERRORS.PAYMENT.copy,
        BILLING_ERROR: CHECKOUT_ERRORS.BILLING.copy,
        ORDER_MINIMUM_ERROR: CHECKOUT_ERRORS.MINIMUM.copy,
        INVALID_DISCOUNT_ERROR: CHECKOUT_ERRORS.INVALID_DISCOUNT.copy,
        EXPIRED_DISCOUNT_ERROR: CHECKOUT_ERRORS.EXPIRED_DISCOUNT.copy,
        USAGE_REACHED_DISCOUNT_ERROR: CHECKOUT_ERRORS.USAGE_REACHED_DISCOUNT.copy,
        REQUIREMENTS_NOT_MET_DISCOUNT_ERROR: CHECKOUT_ERRORS.REQUIREMENTS_NOT_MET_DISCOUNT.copy,
        COMMERCE_ADD_TO_CART_BUTTON_DEFAULT: "Add to Cart",
        COMMERCE_ADD_TO_CART_BUTTON_WAITING: "Adding to cart...",
        COMMERCE_BUY_NOW_BUTTON_DEFAULT: "Buy now",
        SUBSCRIPTION_BUTTON_DEFAULT: "Subscribe now",
        QUANTITY_ERROR: "Product is not available in this quantity.",
        GENERAL_ERROR: "Something went wrong when adding this item to the cart.",
        CHECKOUT_ERROR: "Checkout is disabled on this site.",
        CART_ORDER_MIN_ERROR: "The order minimum was not met. Add more items to your cart to continue.",
        SUBSCRIPTION_ERR: "Before you purchase, please use your email invite to verify your address so we can send order updates.",
        ADD_TO_CART_QUANTITY_ERROR: "Product is not available in this quantity.",
        ADD_TO_CART_GENERAL_ERROR: "Something went wrong when adding this item to the cart.",
        ADD_TO_CART_MIXED_ERROR: "You can\u2019t purchase another product with a subscription.",
        BUY_NOW_ERROR: "Something went wrong when trying to purchase this item.",
        CHECKOUT_DISABLED_ERROR: "Checkout is disabled on this site.",
        SELECT_ALL_OPTIONS: "Please select an option in each set."
      };
      exports.COMMERCE_DEFAULT_COPY = COMMERCE_DEFAULT_COPY;
    }
  });

  // packages/systems/commerce/constants/bindingContextConstants.js
  var require_bindingContextConstants = __commonJS({
    "packages/systems/commerce/constants/bindingContextConstants.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY = void 0;
      var PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY = "commerce-products-type";
      exports.PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY = PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY;
    }
  });

  // packages/systems/commerce/constants/paypalCurrencyList.js
  var require_paypalCurrencyList = __commonJS({
    "packages/systems/commerce/constants/paypalCurrencyList.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.paypalCurrencyList = void 0;
      var paypalCurrencyList = [
        /*
         * ----------------------------------------------------------------------------
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         *
         * This const is duplicated to @packages/systems/core/constants/SharedConfig.js
         * to avoid bundling this entire SharedConfig file in the webflow.js published
         * site bundle. Once we have support for bundling for the Dashboard (this
         * config is injected in to window.SharedConfig for angular), we should
         * be able to delete the const in SharedConfig and use the commerce/consts
         * package whenever `paypalCurrencyList` const is needed.
         *
         * In the meantime, if you make changes to this const, please make sure to
         * update in the other location as well.
         *
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * ----------------------------------------------------------------------------
         */
        {
          code: "AUD",
          digits: 2,
          minCharge: 1,
          name: "Australian Dollar"
        },
        {
          code: "BRL",
          digits: 2,
          minCharge: 1,
          name: "Brazilian Real"
        },
        {
          code: "CAD",
          digits: 2,
          minCharge: 1,
          name: "Canadian Dollar"
        },
        {
          code: "CNY",
          digits: 2,
          minCharge: 1,
          name: "Chinese Renmenbi"
        },
        {
          code: "CZK",
          digits: 2,
          minCharge: 1,
          name: "Czech Koruna"
        },
        {
          code: "DKK",
          digits: 2,
          minCharge: 1,
          name: "Danish Krone"
        },
        {
          code: "EUR",
          digits: 2,
          minCharge: 1,
          name: "Euro"
        },
        {
          code: "HKD",
          digits: 2,
          minCharge: 1,
          name: "Hong Kong Dollar"
        },
        // HUF is currently disabled, due to issues with PayPal's 0-decimal implementation
        // See: https://github.com/webflow/webflow/issues/32865
        // {code: 'HUF', digits: 0, minCharge: 1, name: 'Hungarian Forint'},
        {
          code: "INR",
          digits: 2,
          minCharge: 1,
          name: "Indian Rupee"
        },
        {
          code: "ILS",
          digits: 2,
          minCharge: 1,
          name: "Israeli New Sheqel"
        },
        {
          code: "JPY",
          digits: 0,
          minCharge: 1,
          name: "Japanese Yen"
        },
        {
          code: "MYR",
          digits: 2,
          minCharge: 1,
          name: "Malaysian Ringgit"
        },
        {
          code: "MXN",
          digits: 2,
          minCharge: 1,
          name: "Mexican Peso"
        },
        {
          code: "TWD",
          digits: 0,
          minCharge: 1,
          name: "New Taiwan Dollar"
        },
        {
          code: "NZD",
          digits: 2,
          minCharge: 1,
          name: "New Zealand Dollar"
        },
        {
          code: "NOK",
          digits: 2,
          minCharge: 1,
          name: "Norwegian Krone"
        },
        {
          code: "PHP",
          digits: 2,
          minCharge: 1,
          name: "Philippine Peso"
        },
        {
          code: "PLN",
          digits: 2,
          minCharge: 1,
          name: "Polish Z\u0142oty"
        },
        {
          code: "GBP",
          digits: 2,
          minCharge: 1,
          name: "British Pound"
        },
        {
          code: "RUB",
          digits: 2,
          minCharge: 1,
          name: "Russian Ruble"
        },
        {
          code: "SGD",
          digits: 2,
          minCharge: 1,
          name: "Singapore Dollar"
        },
        {
          code: "SEK",
          digits: 2,
          minCharge: 1,
          name: "Swedish Krona"
        },
        {
          code: "CHF",
          digits: 2,
          minCharge: 1,
          name: "Swiss Franc"
        },
        {
          code: "THB",
          digits: 2,
          minCharge: 1,
          name: "Thai Baht"
        },
        {
          code: "USD",
          digits: 2,
          minCharge: 1,
          name: "United States Dollar"
        }
      ];
      exports.paypalCurrencyList = paypalCurrencyList;
    }
  });

  // packages/systems/commerce/constants/stripeCurrencyList.js
  var require_stripeCurrencyList = __commonJS({
    "packages/systems/commerce/constants/stripeCurrencyList.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.stripeCurrencyList = void 0;
      var stripeCurrencyList = [
        /*
         * ----------------------------------------------------------------------------
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         *
         * This const is duplicated to @packages/systems/core/constants/SharedConfig.js
         * to avoid bundling this entire SharedConfig file in the webflow.js published
         * site bundle. Once we have support for bundling for the Dashboard (this
         * config is injected in to window.SharedConfig for angular), we should
         * be able to delete the const in SharedConfig and use the commerce/consts
         * package whenever `stripeCurrencyList` const is needed.
         *
         * In the meantime, if you make changes to this const, please make sure to
         * update in the other location as well.
         *
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE NOTE
         * ----------------------------------------------------------------------------
         */
        {
          code: "AED",
          digits: 2,
          minCharge: 0,
          name: "United Arab Emirates Dirham"
        },
        {
          code: "AFN",
          digits: 2,
          minCharge: 0,
          name: "Afghanistan Afghani"
        },
        {
          code: "ALL",
          digits: 2,
          minCharge: 0,
          name: "Albanian Lek"
        },
        {
          code: "AMD",
          digits: 2,
          minCharge: 0,
          name: "Armenia Dram"
        },
        {
          code: "ANG",
          digits: 2,
          minCharge: 0,
          name: "Netherlands Antillean Gulden"
        },
        {
          code: "AOA",
          digits: 2,
          minCharge: 0,
          name: "Angola Kwanza"
        },
        {
          code: "ARS",
          digits: 2,
          minCharge: 0,
          name: "Argentine Peso"
        },
        {
          code: "AUD",
          digits: 2,
          minCharge: 50,
          name: "Australian Dollar"
        },
        {
          code: "AWG",
          digits: 2,
          minCharge: 0,
          name: "Aruban Florin"
        },
        {
          code: "AZN",
          digits: 2,
          minCharge: 0,
          name: "Azerbaijan Manat"
        },
        {
          code: "BAM",
          digits: 2,
          minCharge: 0,
          name: "Bosnia and Herzegovina Convertible Marka"
        },
        {
          code: "BBD",
          digits: 2,
          minCharge: 0,
          name: "Barbadian Dollar"
        },
        {
          code: "BDT",
          digits: 2,
          minCharge: 0,
          name: "Bangladeshi Taka"
        },
        {
          code: "BGN",
          digits: 2,
          minCharge: 0,
          name: "Bulgaria Lev"
        },
        {
          code: "BIF",
          digits: 0,
          minCharge: 0,
          name: "Burundian Franc"
        },
        {
          code: "BMD",
          digits: 2,
          minCharge: 0,
          name: "Bermudian Dollar"
        },
        {
          code: "BND",
          digits: 2,
          minCharge: 0,
          name: "Brunei Dollar"
        },
        {
          code: "BOB",
          digits: 2,
          minCharge: 0,
          name: "Bolivian Boliviano"
        },
        {
          code: "BRL",
          digits: 2,
          minCharge: 50,
          name: "Brazilian Real"
        },
        {
          code: "BSD",
          digits: 2,
          minCharge: 0,
          name: "Bahamian Dollar"
        },
        {
          code: "BWP",
          digits: 2,
          minCharge: 0,
          name: "Botswana Pula"
        },
        {
          code: "BZD",
          digits: 2,
          minCharge: 0,
          name: "Belize Dollar"
        },
        {
          code: "CAD",
          digits: 2,
          minCharge: 50,
          name: "Canadian Dollar"
        },
        {
          code: "CDF",
          digits: 2,
          minCharge: 0,
          name: "Congo/Kinshasa Franc"
        },
        {
          code: "CHF",
          digits: 2,
          minCharge: 50,
          name: "Swiss Franc"
        },
        {
          code: "CLP",
          digits: 0,
          minCharge: 0,
          name: "Chilean Peso"
        },
        {
          code: "CNY",
          digits: 2,
          minCharge: 0,
          name: "Chinese Renminbi Yuan"
        },
        {
          code: "COP",
          digits: 2,
          minCharge: 0,
          name: "Colombian Peso"
        },
        {
          code: "CRC",
          digits: 2,
          minCharge: 0,
          name: "Costa Rican Col\xF3n"
        },
        {
          code: "CVE",
          digits: 2,
          minCharge: 0,
          name: "Cape Verdean Escudo"
        },
        // See above.
        {
          code: "CZK",
          digits: 2,
          minCharge: 0,
          name: "Czech Koruna"
        },
        {
          code: "DJF",
          digits: 0,
          minCharge: 0,
          name: "Djiboutian Franc"
        },
        {
          code: "DKK",
          digits: 2,
          minCharge: 250,
          name: "Danish Krone"
        },
        {
          code: "DOP",
          digits: 2,
          minCharge: 0,
          name: "Dominican Peso"
        },
        {
          code: "DZD",
          digits: 2,
          minCharge: 0,
          name: "Algerian Dinar"
        },
        {
          code: "EGP",
          digits: 2,
          minCharge: 0,
          name: "Egyptian Pound"
        },
        {
          code: "ETB",
          digits: 2,
          minCharge: 0,
          name: "Ethiopian Birr"
        },
        {
          code: "EUR",
          digits: 2,
          minCharge: 50,
          name: "Euro"
        },
        {
          code: "FJD",
          digits: 2,
          minCharge: 0,
          name: "Fijian Dollar"
        },
        {
          code: "FKP",
          digits: 2,
          minCharge: 0,
          name: "Falkland Islands Pound"
        },
        {
          code: "GBP",
          digits: 2,
          minCharge: 30,
          name: "British Pound"
        },
        {
          code: "GEL",
          digits: 2,
          minCharge: 0,
          name: "Georgia Lari"
        },
        {
          code: "GIP",
          digits: 2,
          minCharge: 0,
          name: "Gibraltar Pound"
        },
        {
          code: "GMD",
          digits: 2,
          minCharge: 0,
          name: "Gambian Dalasi"
        },
        {
          code: "GNF",
          digits: 0,
          minCharge: 0,
          name: "Guinean Franc"
        },
        {
          code: "GTQ",
          digits: 2,
          minCharge: 0,
          name: "Guatemalan Quetzal"
        },
        {
          code: "GYD",
          digits: 2,
          minCharge: 0,
          name: "Guyanese Dollar"
        },
        {
          code: "HKD",
          digits: 2,
          minCharge: 400,
          name: "Hong Kong Dollar"
        },
        {
          code: "HNL",
          digits: 2,
          minCharge: 0,
          name: "Honduran Lempira"
        },
        {
          code: "HRK",
          digits: 2,
          minCharge: 0,
          name: "Croatian Kuna"
        },
        {
          code: "HTG",
          digits: 2,
          minCharge: 0,
          name: "Haitian Gourde"
        },
        {
          code: "HUF",
          digits: 2,
          minCharge: 0,
          name: "Hungarian Forint"
        },
        {
          code: "IDR",
          digits: 2,
          minCharge: 0,
          name: "Indonesian Rupiah"
        },
        {
          code: "ILS",
          digits: 2,
          minCharge: 0,
          name: "Israeli New Sheqel"
        },
        {
          code: "INR",
          digits: 2,
          minCharge: 50,
          name: "Indian Rupee"
        },
        {
          code: "ISK",
          digits: 2,
          minCharge: 0,
          name: "Icelandic Kr\xF3na"
        },
        // See above.
        {
          code: "JMD",
          digits: 2,
          minCharge: 0,
          name: "Jamaican Dollar"
        },
        {
          code: "JPY",
          digits: 0,
          minCharge: 50,
          name: "Japanese Yen"
        },
        {
          code: "KES",
          digits: 2,
          minCharge: 0,
          name: "Kenyan Shilling"
        },
        {
          code: "KGS",
          digits: 2,
          minCharge: 0,
          name: "Kyrgyzstan Som"
        },
        {
          code: "KHR",
          digits: 2,
          minCharge: 0,
          name: "Cambodian Riel"
        },
        {
          code: "KMF",
          digits: 0,
          minCharge: 0,
          name: "Comorian Franc"
        },
        {
          code: "KRW",
          digits: 0,
          minCharge: 0,
          name: "South Korean Won"
        },
        {
          code: "KYD",
          digits: 2,
          minCharge: 0,
          name: "Cayman Islands Dollar"
        },
        {
          code: "KZT",
          digits: 2,
          minCharge: 0,
          name: "Kazakhstani Tenge"
        },
        {
          code: "LAK",
          digits: 2,
          minCharge: 0,
          name: "Lao Kip"
        },
        {
          code: "LBP",
          digits: 2,
          minCharge: 0,
          name: "Lebanese Pound"
        },
        {
          code: "LKR",
          digits: 2,
          minCharge: 0,
          name: "Sri Lankan Rupee"
        },
        {
          code: "LRD",
          digits: 2,
          minCharge: 0,
          name: "Liberian Dollar"
        },
        {
          code: "LSL",
          digits: 2,
          minCharge: 0,
          name: "Lesotho Loti"
        },
        {
          code: "MAD",
          digits: 2,
          minCharge: 0,
          name: "Moroccan Dirham"
        },
        {
          code: "MDL",
          digits: 2,
          minCharge: 0,
          name: "Moldovan Leu"
        },
        {
          code: "MGA",
          digits: 0,
          minCharge: 0,
          name: "Madagascar Ariary"
        },
        // See above.
        {
          code: "MKD",
          digits: 2,
          minCharge: 0,
          name: "Macedonia Denar"
        },
        {
          code: "MMK",
          digits: 2,
          minCharge: 0,
          name: "Myanmar (Burma) Kyat"
        },
        {
          code: "MNT",
          digits: 2,
          minCharge: 0,
          name: "Mongolian T\xF6gr\xF6g"
        },
        {
          code: "MOP",
          digits: 2,
          minCharge: 0,
          name: "Macanese Pataca"
        },
        {
          code: "MRO",
          digits: 2,
          minCharge: 0,
          name: "Mauritanian Ouguiya"
        },
        {
          code: "MUR",
          digits: 2,
          minCharge: 0,
          name: "Mauritian Rupee"
        },
        {
          code: "MVR",
          digits: 2,
          minCharge: 0,
          name: "Maldivian Rufiyaa"
        },
        {
          code: "MWK",
          digits: 2,
          minCharge: 0,
          name: "Malawian Kwacha"
        },
        {
          code: "MXN",
          digits: 2,
          minCharge: 1e3,
          name: "Mexican Peso"
        },
        {
          code: "MYR",
          digits: 2,
          minCharge: 200,
          name: "Malaysian Ringgit"
        },
        {
          code: "MZN",
          digits: 2,
          minCharge: 0,
          name: "Mozambique Metical"
        },
        {
          code: "NAD",
          digits: 2,
          minCharge: 0,
          name: "Namibian Dollar"
        },
        {
          code: "NGN",
          digits: 2,
          minCharge: 0,
          name: "Nigerian Naira"
        },
        {
          code: "NIO",
          digits: 2,
          minCharge: 0,
          name: "Nicaraguan C\xF3rdoba"
        },
        {
          code: "NOK",
          digits: 2,
          minCharge: 300,
          name: "Norwegian Krone"
        },
        {
          code: "NPR",
          digits: 2,
          minCharge: 0,
          name: "Nepalese Rupee"
        },
        {
          code: "NZD",
          digits: 2,
          minCharge: 50,
          name: "New Zealand Dollar"
        },
        {
          code: "PAB",
          digits: 2,
          minCharge: 0,
          name: "Panamanian Balboa"
        },
        {
          code: "PEN",
          digits: 2,
          minCharge: 0,
          name: "Peruvian Nuevo Sol"
        },
        {
          code: "PGK",
          digits: 2,
          minCharge: 0,
          name: "Papua New Guinean Kina"
        },
        {
          code: "PHP",
          digits: 2,
          minCharge: 0,
          name: "Philippine Peso"
        },
        {
          code: "PKR",
          digits: 2,
          minCharge: 0,
          name: "Pakistani Rupee"
        },
        {
          code: "PLN",
          digits: 2,
          minCharge: 200,
          name: "Polish Z\u0142oty"
        },
        {
          code: "PYG",
          digits: 0,
          minCharge: 0,
          name: "Paraguayan Guaran\xED"
        },
        {
          code: "QAR",
          digits: 2,
          minCharge: 0,
          name: "Qatari Riyal"
        },
        {
          code: "RON",
          digits: 2,
          minCharge: 0,
          name: "Romania Leu"
        },
        {
          code: "RSD",
          digits: 2,
          minCharge: 0,
          name: "Serbia Dinar"
        },
        {
          code: "RUB",
          digits: 2,
          minCharge: 0,
          name: "Russian Ruble"
        },
        {
          code: "RWF",
          digits: 0,
          minCharge: 0,
          name: "Rwanda Franc"
        },
        {
          code: "SAR",
          digits: 2,
          minCharge: 0,
          name: "Saudi Riyal"
        },
        {
          code: "SBD",
          digits: 2,
          minCharge: 0,
          name: "Solomon Islands Dollar"
        },
        {
          code: "SCR",
          digits: 2,
          minCharge: 0,
          name: "Seychellois Rupee"
        },
        {
          code: "SEK",
          digits: 2,
          minCharge: 300,
          name: "Swedish Krona"
        },
        {
          code: "SGD",
          digits: 2,
          minCharge: 50,
          name: "Singapore Dollar"
        },
        {
          code: "SHP",
          digits: 2,
          minCharge: 0,
          name: "Saint Helenian Pound"
        },
        {
          code: "SLL",
          digits: 2,
          minCharge: 0,
          name: "Sierra Leonean Leone"
        },
        {
          code: "SOS",
          digits: 2,
          minCharge: 0,
          name: "Somali Shilling"
        },
        {
          code: "SRD",
          digits: 2,
          minCharge: 0,
          name: "Suriname Dollar"
        },
        {
          code: "STD",
          digits: 2,
          minCharge: 0,
          name: "S\xE3o Tom\xE9 and Pr\xEDncipe Dobra"
        },
        {
          code: "SZL",
          digits: 2,
          minCharge: 0,
          name: "Swazi Lilangeni"
        },
        {
          code: "THB",
          digits: 2,
          minCharge: 0,
          name: "Thai Baht"
        },
        {
          code: "TJS",
          digits: 2,
          minCharge: 0,
          name: "Tajikistan Somoni"
        },
        {
          code: "TOP",
          digits: 2,
          minCharge: 0,
          name: "Tongan Pa\u02BBanga"
        },
        {
          code: "TRY",
          digits: 2,
          minCharge: 0,
          name: "Turkey Lira"
        },
        {
          code: "TTD",
          digits: 2,
          minCharge: 0,
          name: "Trinidad and Tobago Dollar"
        },
        {
          code: "TWD",
          digits: 2,
          minCharge: 0,
          name: "New Taiwan Dollar"
        },
        {
          code: "TZS",
          digits: 2,
          minCharge: 0,
          name: "Tanzanian Shilling"
        },
        {
          code: "UAH",
          digits: 2,
          minCharge: 0,
          name: "Ukrainian Hryvnia"
        },
        {
          code: "UGX",
          digits: 0,
          minCharge: 0,
          name: "Ugandan Shilling"
        },
        // See above.
        {
          code: "USD",
          digits: 2,
          minCharge: 50,
          name: "United States Dollar"
        },
        {
          code: "UYU",
          digits: 2,
          minCharge: 0,
          name: "Uruguayan Peso"
        },
        {
          code: "UZS",
          digits: 2,
          minCharge: 0,
          name: "Uzbekistani Som"
        },
        {
          code: "VND",
          digits: 0,
          minCharge: 0,
          name: "Vietnamese \u0110\u1ED3ng"
        },
        {
          code: "VUV",
          digits: 0,
          minCharge: 0,
          name: "Vanuatu Vatu"
        },
        {
          code: "WST",
          digits: 2,
          minCharge: 0,
          name: "Samoan Tala"
        },
        {
          code: "XAF",
          digits: 0,
          minCharge: 0,
          name: "Central African Cfa Franc"
        },
        {
          code: "XCD",
          digits: 2,
          minCharge: 0,
          name: "East Caribbean Dollar"
        },
        {
          code: "XOF",
          digits: 0,
          minCharge: 0,
          name: "West African Cfa Franc"
        },
        {
          code: "XPF",
          digits: 0,
          minCharge: 0,
          name: "Cfp Franc"
        },
        {
          code: "YER",
          digits: 2,
          minCharge: 0,
          name: "Yemeni Rial"
        },
        {
          code: "ZAR",
          digits: 2,
          minCharge: 0,
          name: "South African Rand"
        },
        {
          code: "ZMW",
          digits: 2,
          minCharge: 0,
          name: "Zambia Kwacha"
        }
      ];
      exports.stripeCurrencyList = stripeCurrencyList;
    }
  });

  // packages/systems/commerce/constants/index.js
  var require_constants2 = __commonJS({
    "packages/systems/commerce/constants/index.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _exportNames = {
        ORDER_ID_RE: true,
        SHIPPING_METHODS: true,
        DEFAULT_TAX_CATEGORY: true,
        INVENTORY_TYPE_FINITE: true,
        INVENTORY_TYPE_INFINITE: true,
        INFINITE_INVENTORY: true,
        MAX_TOTAL_ORDER_PRICE: true,
        MAX_PRODUCT_DIMENSION: true,
        MAX_MEMBERSHIP_PRODUCTS: true,
        MAX_SEARCH_LIMIT: true,
        PRICE_TEMPLATE_CURRENCY_SYMBOL: true,
        PRICE_TEMPLATE_AMOUNT: true,
        PRICE_TEMPLATE_CURRENCY_CODE: true,
        PRICE_TEMPLATE_OPTIONS: true,
        DEFAULT_PRICE_TEMPLATE_VALUE: true,
        CSV_CURRENCY_TEMPLATE: true,
        CSV_INTEGRATION_CURRENCY_TEMPLATE: true,
        DOWNLOAD_FILES_FAKE_DATA: true,
        DOWNLOAD_FILES_KEY_PATH: true,
        DOWNLOAD_FILES_EDITABLE_FIELDS: true,
        SUBSCRIPTION_INTERVAL_ENUM: true,
        SUBSCRIPTION_STATUS_ENUM: true,
        SUBSCRIPTION_STATUS_PRETTY_ENUM: true,
        STRIPE_SUBSCRIPTION_STATUS_ENUM: true,
        ACTIVE_STRIPE_SUBSCRIPTION_STATUSES: true,
        ECOMMERCE_PROVIDER_NAME_ENUM: true,
        BILLING_METHOD_TYPES: true,
        PHYSICAL_PRODUCT_TYPE: true,
        DIGITAL_PRODUCT_TYPE: true,
        SERVICE_PRODUCT_TYPE: true,
        MEMBERSHIP_PRODUCT_TYPE: true,
        ADVANCED_PRODUCT_TYPE: true,
        TEMPLATE_PRODUCT_TYPES: true,
        PRODUCT_TYPE_HELP_TEXT: true,
        DEFAULT_PRODUCT_TYPE_ID: true,
        DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS: true,
        REQUIRED_DISCOUNT_IMPORT_FIELDS: true,
        STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE: true,
        ORDER_SORT_MODES: true,
        SUBSCRIPTION_SORT_MODES: true,
        PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY: true,
        paypalCurrencyList: true,
        stripeCurrencyList: true
      };
      exports.PRICE_TEMPLATE_OPTIONS = exports.PRICE_TEMPLATE_CURRENCY_SYMBOL = exports.PRICE_TEMPLATE_CURRENCY_CODE = exports.PRICE_TEMPLATE_AMOUNT = exports.PHYSICAL_PRODUCT_TYPE = exports.ORDER_SORT_MODES = exports.ORDER_ID_RE = exports.MEMBERSHIP_PRODUCT_TYPE = exports.MAX_TOTAL_ORDER_PRICE = exports.MAX_SEARCH_LIMIT = exports.MAX_PRODUCT_DIMENSION = exports.MAX_MEMBERSHIP_PRODUCTS = exports.INVENTORY_TYPE_INFINITE = exports.INVENTORY_TYPE_FINITE = exports.INFINITE_INVENTORY = exports.ECOMMERCE_PROVIDER_NAME_ENUM = exports.DOWNLOAD_FILES_KEY_PATH = exports.DOWNLOAD_FILES_FAKE_DATA = exports.DOWNLOAD_FILES_EDITABLE_FIELDS = exports.DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS = exports.DIGITAL_PRODUCT_TYPE = exports.DEFAULT_TAX_CATEGORY = exports.DEFAULT_PRODUCT_TYPE_ID = exports.DEFAULT_PRICE_TEMPLATE_VALUE = exports.CSV_INTEGRATION_CURRENCY_TEMPLATE = exports.CSV_CURRENCY_TEMPLATE = exports.BILLING_METHOD_TYPES = exports.ADVANCED_PRODUCT_TYPE = exports.ACTIVE_STRIPE_SUBSCRIPTION_STATUSES = void 0;
      Object.defineProperty(exports, "PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY", {
        enumerable: true,
        get: function() {
          return _bindingContextConstants.PRODUCTS_BINDING_CONTEXT_EXTERNAL_KEY;
        }
      });
      exports.TEMPLATE_PRODUCT_TYPES = exports.SUBSCRIPTION_STATUS_PRETTY_ENUM = exports.SUBSCRIPTION_STATUS_ENUM = exports.SUBSCRIPTION_SORT_MODES = exports.SUBSCRIPTION_INTERVAL_ENUM = exports.STRIPE_SUBSCRIPTION_STATUS_ENUM = exports.STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE = exports.SHIPPING_METHODS = exports.SERVICE_PRODUCT_TYPE = exports.REQUIRED_DISCOUNT_IMPORT_FIELDS = exports.PRODUCT_TYPE_HELP_TEXT = void 0;
      Object.defineProperty(exports, "paypalCurrencyList", {
        enumerable: true,
        get: function() {
          return _paypalCurrencyList.paypalCurrencyList;
        }
      });
      Object.defineProperty(exports, "stripeCurrencyList", {
        enumerable: true,
        get: function() {
          return _stripeCurrencyList.stripeCurrencyList;
        }
      });
      var _extends2 = _interopRequireDefault(require_extends());
      var _camelCase = _interopRequireDefault(require_camelCase());
      var _pluginConstants = require_pluginConstants();
      Object.keys(_pluginConstants).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _pluginConstants[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _pluginConstants[key];
          }
        });
      });
      var _bindingContextConstants = require_bindingContextConstants();
      var _paypalCurrencyList = require_paypalCurrencyList();
      var _stripeCurrencyList = require_stripeCurrencyList();
      var ORDER_ID_RE = /^[0-9a-f]{5,}$/;
      exports.ORDER_ID_RE = ORDER_ID_RE;
      var SHIPPING_METHOD_FLAT = "flat-rate";
      var SHIPPING_METHOD_PERCENTAGE = "percentage";
      var SHIPPING_METHOD_PRICE = "price";
      var SHIPPING_METHOD_QUANTITY = "quantity";
      var SHIPPING_METHOD_WEIGHT = "weight";
      var SHIPPING_METHODS = Object.freeze({
        FLAT: SHIPPING_METHOD_FLAT,
        PERCENTAGE: SHIPPING_METHOD_PERCENTAGE,
        PRICE: SHIPPING_METHOD_PRICE,
        QUANTITY: SHIPPING_METHOD_QUANTITY,
        WEIGHT: SHIPPING_METHOD_WEIGHT
      });
      exports.SHIPPING_METHODS = SHIPPING_METHODS;
      var DEFAULT_TAX_CATEGORY = "standard-taxable";
      exports.DEFAULT_TAX_CATEGORY = DEFAULT_TAX_CATEGORY;
      var INVENTORY_TYPE_FINITE = "finite";
      exports.INVENTORY_TYPE_FINITE = INVENTORY_TYPE_FINITE;
      var INVENTORY_TYPE_INFINITE = "infinite";
      exports.INVENTORY_TYPE_INFINITE = INVENTORY_TYPE_INFINITE;
      var INFINITE_INVENTORY = {
        inventoryType: INVENTORY_TYPE_INFINITE,
        quantity: 0
      };
      exports.INFINITE_INVENTORY = INFINITE_INVENTORY;
      var MAX_TOTAL_ORDER_PRICE = 99999999;
      exports.MAX_TOTAL_ORDER_PRICE = MAX_TOTAL_ORDER_PRICE;
      var MAX_PRODUCT_DIMENSION = 9e15;
      exports.MAX_PRODUCT_DIMENSION = MAX_PRODUCT_DIMENSION;
      var MAX_MEMBERSHIP_PRODUCTS = 20;
      exports.MAX_MEMBERSHIP_PRODUCTS = MAX_MEMBERSHIP_PRODUCTS;
      var MAX_SEARCH_LIMIT = 100;
      exports.MAX_SEARCH_LIMIT = MAX_SEARCH_LIMIT;
      function _withDerivedValue({
        label,
        type = "PlainText",
        path = (0, _camelCase.default)(label),
        options = {
          readOnly: false,
          isNotAddable: false
        }
      }) {
        return (0, _extends2.default)({
          label,
          type
        }, options, {
          value: JSON.stringify({
            path,
            type
          })
        });
      }
      var PRICE_TEMPLATE_CURRENCY_SYMBOL = _withDerivedValue({
        label: "Currency symbol",
        path: "symbol"
      });
      exports.PRICE_TEMPLATE_CURRENCY_SYMBOL = PRICE_TEMPLATE_CURRENCY_SYMBOL;
      var PRICE_TEMPLATE_AMOUNT = _withDerivedValue({
        label: "Amount",
        type: "CommercePrice",
        options: {
          readOnly: true,
          isNotAddable: true
        }
      });
      exports.PRICE_TEMPLATE_AMOUNT = PRICE_TEMPLATE_AMOUNT;
      var PRICE_TEMPLATE_CURRENCY_CODE = _withDerivedValue({
        label: "Currency code"
      });
      exports.PRICE_TEMPLATE_CURRENCY_CODE = PRICE_TEMPLATE_CURRENCY_CODE;
      var PRICE_TEMPLATE_OPTIONS = [PRICE_TEMPLATE_CURRENCY_SYMBOL, PRICE_TEMPLATE_AMOUNT, PRICE_TEMPLATE_CURRENCY_CODE];
      exports.PRICE_TEMPLATE_OPTIONS = PRICE_TEMPLATE_OPTIONS;
      var _intoToken = (option) => `{{wf ${option.value} }}`;
      var DEFAULT_PRICE_TEMPLATE_VALUE = [_intoToken(PRICE_TEMPLATE_CURRENCY_SYMBOL), " ", _intoToken(PRICE_TEMPLATE_AMOUNT), " ", _intoToken(PRICE_TEMPLATE_CURRENCY_CODE)].join("");
      exports.DEFAULT_PRICE_TEMPLATE_VALUE = DEFAULT_PRICE_TEMPLATE_VALUE;
      var CSV_CURRENCY_TEMPLATE = [_intoToken(PRICE_TEMPLATE_CURRENCY_SYMBOL), _intoToken(PRICE_TEMPLATE_AMOUNT)].join("");
      exports.CSV_CURRENCY_TEMPLATE = CSV_CURRENCY_TEMPLATE;
      var CSV_INTEGRATION_CURRENCY_TEMPLATE = [_intoToken(PRICE_TEMPLATE_AMOUNT), " ", _intoToken(PRICE_TEMPLATE_CURRENCY_CODE)].join("");
      exports.CSV_INTEGRATION_CURRENCY_TEMPLATE = CSV_INTEGRATION_CURRENCY_TEMPLATE;
      var DOWNLOAD_FILES_FAKE_DATA = [{
        id: "5d8fcb6d94dd1853060fb3b3",
        name: "The modern web design process - Webflow Ebook.pdf",
        url: "https://assets-global.website-files.com/5cf6b7202bf8199f50d43e6c/5e9dd8a680b972888929747b_The%20modern%20web%20design%20process%20-%20Webflow%20Ebook.pdf"
      }, {
        id: "5d8fcb6d94dd1853060fb3b4",
        name: "The freelance web designers guide - Webflow Ebook.pdf",
        url: "https://assets-global.website-files.com/5cf6b7202bf8199f50d43e6c/5e9dd8e6abe52b33243a22cf_The%20freelance%20web%20designer%E2%80%99s%20guide%20-%20Webflow%20Ebook.pdf"
      }];
      exports.DOWNLOAD_FILES_FAKE_DATA = DOWNLOAD_FILES_FAKE_DATA;
      var DOWNLOAD_FILES_KEY_PATH = "download-files";
      exports.DOWNLOAD_FILES_KEY_PATH = DOWNLOAD_FILES_KEY_PATH;
      var DOWNLOAD_FILES_EDITABLE_FIELDS = {
        name: true,
        url: true
      };
      exports.DOWNLOAD_FILES_EDITABLE_FIELDS = DOWNLOAD_FILES_EDITABLE_FIELDS;
      var SUBSCRIPTION_INTERVAL_ENUM = ["day", "week", "month", "year"];
      exports.SUBSCRIPTION_INTERVAL_ENUM = SUBSCRIPTION_INTERVAL_ENUM;
      var SUBSCRIPTION_STATUS_ENUM = {
        active: "active",
        pastdue: "pastdue",
        unpaid: "unpaid",
        canceled: "canceled",
        cancelPending: "cancelPending",
        incomplete: "incomplete",
        incompleteExpired: "incompleteExpired",
        trialing: "trialing",
        unknown: `unknown`
      };
      exports.SUBSCRIPTION_STATUS_ENUM = SUBSCRIPTION_STATUS_ENUM;
      var SUBSCRIPTION_STATUS_PRETTY_ENUM = {
        active: "active",
        pastdue: "pastdue",
        unpaid: "unpaid",
        canceled: "canceled",
        cancelPending: "cancelPending",
        incomplete: "incomplete",
        incompleteExpired: "incompleteExpired",
        trialing: "in trial",
        unknown: `unknown`
      };
      exports.SUBSCRIPTION_STATUS_PRETTY_ENUM = SUBSCRIPTION_STATUS_PRETTY_ENUM;
      var STRIPE_SUBSCRIPTION_STATUS_ENUM = {
        active: "active",
        past_due: "past_due",
        unpaid: "unpaid",
        canceled: "canceled",
        incomplete: "incomplete",
        incomplete_expired: "incomplete_expired",
        trialing: "trialing"
      };
      exports.STRIPE_SUBSCRIPTION_STATUS_ENUM = STRIPE_SUBSCRIPTION_STATUS_ENUM;
      var ACTIVE_STRIPE_SUBSCRIPTION_STATUSES = [STRIPE_SUBSCRIPTION_STATUS_ENUM.active, STRIPE_SUBSCRIPTION_STATUS_ENUM.past_due, STRIPE_SUBSCRIPTION_STATUS_ENUM.trialing];
      exports.ACTIVE_STRIPE_SUBSCRIPTION_STATUSES = ACTIVE_STRIPE_SUBSCRIPTION_STATUSES;
      var ECOMMERCE_PROVIDER_NAME_ENUM = {
        stripe: "stripe"
      };
      exports.ECOMMERCE_PROVIDER_NAME_ENUM = ECOMMERCE_PROVIDER_NAME_ENUM;
      var BILLING_METHOD_TYPES = {
        subscription: "subscription",
        oneTime: "one-time"
      };
      exports.BILLING_METHOD_TYPES = BILLING_METHOD_TYPES;
      var DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS = [{
        fieldSlug: "name",
        required: true
      }, {
        fieldSlug: "slug",
        required: true
      }, {
        fieldSlug: "sku-properties",
        required: false
      }, {
        fieldSlug: "category",
        required: false
      }, {
        fieldSlug: "description",
        required: false
      }, {
        fieldSlug: "tax-category",
        required: false
      }, {
        fieldSlug: "default-sku",
        required: false
      }, {
        fieldSlug: "ec-product-type",
        required: false
      }, {
        fieldSlug: "options",
        required: false
      }];
      var DEFAULT_PRODUCT_TYPE_SKU_FIELDS = [{
        fieldSlug: "sku-values",
        required: false
      }, {
        fieldSlug: "product",
        required: false
      }, {
        fieldSlug: "main-image",
        required: false
      }, {
        fieldSlug: "more-images",
        required: false
      }, {
        fieldSlug: "price",
        required: true
      }, {
        fieldSlug: "compare-at-price",
        required: false
      }, {
        fieldSlug: "ec-sku-subscription-plan",
        required: false
      }, {
        fieldSlug: "sku",
        required: false
      }, {
        fieldSlug: "ec-sku-billing-method",
        required: false
      }, {
        fieldSlug: "track-inventory",
        required: false
      }, {
        fieldSlug: "quantity",
        required: false
      }];
      var PHYSICAL_PRODUCT_TYPE = {
        name: "Physical",
        id: "ff42fee0113744f693a764e3431a9cc2",
        fields: {
          product: [...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS, {
            fieldSlug: "shippable",
            required: false
          }],
          sku: [...DEFAULT_PRODUCT_TYPE_SKU_FIELDS, {
            fieldSlug: "weight",
            required: false
          }, {
            fieldSlug: "width",
            required: false
          }, {
            fieldSlug: "height",
            required: false
          }, {
            fieldSlug: "length",
            required: false
          }]
        }
      };
      exports.PHYSICAL_PRODUCT_TYPE = PHYSICAL_PRODUCT_TYPE;
      var DIGITAL_PRODUCT_TYPE = {
        name: "Digital",
        id: "f22027db68002190aef89a4a2b7ac8a1",
        fields: {
          product: [...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS],
          sku: [...DEFAULT_PRODUCT_TYPE_SKU_FIELDS, {
            fieldSlug: "download-files",
            required: true
          }]
        }
      };
      exports.DIGITAL_PRODUCT_TYPE = DIGITAL_PRODUCT_TYPE;
      var SERVICE_PRODUCT_TYPE = {
        name: "Service",
        id: "c599e43b1a1c34d5a323aedf75d3adf6",
        fields: {
          product: [...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS],
          sku: [...DEFAULT_PRODUCT_TYPE_SKU_FIELDS]
        }
      };
      exports.SERVICE_PRODUCT_TYPE = SERVICE_PRODUCT_TYPE;
      var MEMBERSHIP_PRODUCT_TYPE = {
        name: "Membership",
        id: "e348fd487d0102946c9179d2a94bb613",
        fields: {
          product: [...DEFAULT_PRODUCT_TYPE_PRODUCT_FIELDS, {
            fieldSlug: "shippable",
            required: false
          }],
          sku: [...DEFAULT_PRODUCT_TYPE_SKU_FIELDS, {
            fieldSlug: "weight",
            required: false
          }, {
            fieldSlug: "width",
            required: false
          }, {
            fieldSlug: "height",
            required: false
          }, {
            fieldSlug: "length",
            required: false
          }, {
            fieldSlug: "download-files",
            required: false
          }, {
            fieldSlug: "include-downloads",
            required: false
          }]
        }
      };
      exports.MEMBERSHIP_PRODUCT_TYPE = MEMBERSHIP_PRODUCT_TYPE;
      var ADVANCED_PRODUCT_TYPE = {
        name: "Advanced",
        id: "b6ccc1830db4b1babeb06a9ac5f6dd76"
      };
      exports.ADVANCED_PRODUCT_TYPE = ADVANCED_PRODUCT_TYPE;
      var TEMPLATE_PRODUCT_TYPES = [PHYSICAL_PRODUCT_TYPE, DIGITAL_PRODUCT_TYPE, SERVICE_PRODUCT_TYPE, MEMBERSHIP_PRODUCT_TYPE, ADVANCED_PRODUCT_TYPE];
      exports.TEMPLATE_PRODUCT_TYPES = TEMPLATE_PRODUCT_TYPES;
      var templateProductTypeIds = TEMPLATE_PRODUCT_TYPES.reduce((ids, t) => {
        ids[t.id] = "";
        return ids;
      }, {});
      var PRODUCT_TYPE_HELP_TEXT = {
        [PHYSICAL_PRODUCT_TYPE.id]: "Physical products are shipped to the customer (e.g., merchandise, apparel).",
        [DIGITAL_PRODUCT_TYPE.id]: "Digital products are immediately downloadable by the customer after checkout (e.g., audio files, ebooks).",
        [SERVICE_PRODUCT_TYPE.id]: "Service products do not require a shipping address during checkout (e.g., classes, consultations).",
        [MEMBERSHIP_PRODUCT_TYPE.id]: "Membership products give users access to gated content through recurring or one-time payment (e.g., subscriptions, one-time membership fee). Membership products require a user login and can only be purchased once.",
        [ADVANCED_PRODUCT_TYPE.id]: "Advanced products provide all available customizable options."
      };
      exports.PRODUCT_TYPE_HELP_TEXT = PRODUCT_TYPE_HELP_TEXT;
      var DEFAULT_PRODUCT_TYPE_ID = PHYSICAL_PRODUCT_TYPE.id;
      exports.DEFAULT_PRODUCT_TYPE_ID = DEFAULT_PRODUCT_TYPE_ID;
      var DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS = [
        "name",
        "code",
        "notes",
        "type",
        "percentOff",
        "amountOff",
        "validOn",
        "expiresOn",
        "enabled",
        // 'active' is being replaced with 'enabled'
        "orderMinimum",
        // archived is disabled until we have UI for it
        // 'archived',
        "totalUsage",
        "maxAmountOff",
        // NOTE: for dot-notation fields to be properly expanded
        // during import, you need to add the camel-case flattened property to
        // the 'KEYS_TO_EXPAND' variable in `entrypoints/server/lib/ecommerce/csvImport/discountCsvImport.js`
        // Example: 'usage.limit.total' -> 'usageLimitTotal'
        "usage.limit.total",
        "usage.limit.customer",
        "appliesTo.scope",
        "appliesTo.filter",
        "appliesTo.applyOnce"
      ];
      exports.DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS = DISCOUNTS_CSV_IMPORT_EXPORT_COLUMNS;
      var REQUIRED_DISCOUNT_IMPORT_FIELDS = [
        "name",
        "code",
        "type",
        ["percentOff", "amountOff"]
        // we want either percentOff or amountOff present or both
      ];
      exports.REQUIRED_DISCOUNT_IMPORT_FIELDS = REQUIRED_DISCOUNT_IMPORT_FIELDS;
      var STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE = "Stripe disconnect attempted with non-canceled subscriptions";
      exports.STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE = STRIPE_DISCONNECT_SUBSCRIPTIONS_ERROR_MESSAGE;
      var ORDER_SORT_MODES = Object.freeze({
        "-count": "-purchasedItemsCount -_id",
        count: "purchasedItemsCount _id",
        "-name": "-customerInfo.fullName -_id",
        name: "customerInfo.fullName _id",
        "-orderid": "-orderId",
        orderid: "orderId",
        "-paid": "-customerPaid.unit -customerPaid.value -_id",
        paid: "customerPaid.unit customerPaid.value _id",
        "-status": "-statusCode -_id",
        status: "statusCode _id",
        "-time": "-acceptedOn -_id",
        time: "acceptedOn _id"
      });
      exports.ORDER_SORT_MODES = ORDER_SORT_MODES;
      var SUBSCRIPTION_SORT_MODES = Object.freeze({
        "-lastBilled": "-lastInvoiced -_id",
        lastBilled: "lastInvoiced _id",
        "-nextBilling": "-paidUntil -_id",
        nextBilling: "paidUntil _id",
        "-orderid": "-orderId",
        orderid: "orderId",
        "-purchased": "-subCreatedOn -_id",
        purchased: "subCreatedOn _id",
        "-status": "-status -_id",
        status: "status _id",
        "-trialing": "-trialing -_id",
        trialing: "trialing _id"
      });
      exports.SUBSCRIPTION_SORT_MODES = SUBSCRIPTION_SORT_MODES;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/stripeStore.js
  var require_stripeStore = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/stripeStore.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.generateShippingOptionsFromMethods = exports.generateDisplayItemsFromOrder = exports.StripeStore = void 0;
      var _StyleMapObserver = _interopRequireDefault(require_StyleMapObserver());
      var _debug = _interopRequireDefault(require_debug());
      var _constants = require_constants2();
      var StripeStore = class {
        constructor(docElement) {
          if (window.Webflow.env("design") || window.Webflow.env("preview")) {
            return;
          }
          const stripeJsElement = docElement.querySelector(`[${_constants.STRIPE_ECOMMERCE_KEY}]`);
          if (!stripeJsElement) {
            this.store = {
              initialized: false,
              stripe: {},
              elements: [],
              elementInstances: [],
              cartPaymentRequests: [],
              styleMapObservers: {}
            };
            return _debug.default.error("Stripe has not been set up for this project \u2013 Go to the project's Ecommerce Payment settings in the Designer to link Stripe.");
          }
          const ecommKey = stripeJsElement.getAttribute(_constants.STRIPE_ECOMMERCE_KEY);
          const ecommAccountId = stripeJsElement.getAttribute(_constants.STRIPE_ECOMMERCE_ACCOUNT_ID);
          const stripeOpts = ecommAccountId ? {
            stripeAccount: ecommAccountId,
            apiVersion: "2020-03-02"
          } : null;
          const stripe = window.Stripe(ecommKey, stripeOpts);
          this.store = {
            initialized: true,
            stripe,
            elements: [],
            elementInstances: [],
            cartPaymentRequests: [],
            styleMapObservers: {}
          };
        }
        isInitialized() {
          return this.store.initialized;
        }
        getStripeInstance() {
          return this.store.stripe;
        }
        getElementsInstance(index) {
          return this.store.elements[index];
        }
        getElement(type, index) {
          return this.store.elementInstances[index][type];
        }
        createElementsInstance(index) {
          if (this.store.elements[index]) {
            throw new Error(`Storage already exists for checkout form instance ${index}`);
          } else {
            const stripeInstance = this.getStripeInstance();
            this.store.elements[index] = stripeInstance.elements();
            this.store.elementInstances[index] = {};
          }
        }
        // FIXME: weak type is used
        // eslint-disable-next-line flowtype/no-weak-types
        createElement(type, index, options) {
          if (!this.isInitialized()) {
            throw new Error("Stripe has not been set up for this project \u2013 Go to the project's Ecommerce Payment settings in the Designer to link Stripe.");
          }
          if (this.store.elementInstances[index][type]) {
            throw new Error(`Stripe Element of type ${type} for instance ${index} already exists on this page`);
          }
          const el = this.store.elements[index].create(type, options);
          this.store.elementInstances[index][type] = el;
          return el;
        }
        // FIXME: weak type is used
        // eslint-disable-next-line flowtype/no-weak-types
        updateCartPaymentRequest(index, orderData, siteData) {
          const stripeInstance = this.getStripeInstance();
          const requiresShipping = Boolean(orderData.statusFlags.requiresShipping);
          const options = {
            country: siteData.businessAddress.country || siteData.defaultCountry || "US",
            currency: siteData.defaultCurrency.toLowerCase(),
            total: {
              amount: orderData.subtotal.value,
              label: "Subtotal",
              pending: true
            },
            displayItems: generateDisplayItemsFromOrder(orderData, false),
            requestPayerName: true,
            requestPayerEmail: true,
            requestPayerPhone: false,
            requestShipping: requiresShipping
          };
          try {
            this.store.cartPaymentRequests[index] = stripeInstance.paymentRequest(options);
          } catch (error) {
            let ignoreError = false;
            if (error.name === "IntegrationError") {
              const unsupportedCountryPattern = /country should be one of the following strings(?:.*)You specified: (.*)./;
              const matches = error.message.match(unsupportedCountryPattern);
              ignoreError = Boolean(matches);
            }
            if (!ignoreError) {
              throw error;
            } else {
              console.error(error);
            }
          }
          return this.store.cartPaymentRequests[index];
        }
        getCartPaymentRequest(index) {
          return this.store.cartPaymentRequests[index];
        }
      };
      exports.StripeStore = StripeStore;
      var generateDisplayItemsFromOrder = (orderData, showExtraItems) => [...orderData.userItems.map((item) => ({
        label: `${item.product.f_name_} ${item.count > 1 ? `(${item.count})` : ""}`,
        amount: item.rowTotal.value
      })), ...showExtraItems ? orderData.extraItems.map((item) => ({
        label: item.name,
        amount: item.price.value
      })) : []];
      exports.generateDisplayItemsFromOrder = generateDisplayItemsFromOrder;
      var generateShippingOptionsFromMethods = (shippingMethods) => shippingMethods.map((method) => ({
        id: method.id,
        label: method.name,
        detail: method.description || "",
        amount: method.price.value
      }));
      exports.generateShippingOptionsFromMethods = generateShippingOptionsFromMethods;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/eventHandlerProxyWithApolloClient.js
  var require_eventHandlerProxyWithApolloClient = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/eventHandlerProxyWithApolloClient.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = void 0;
      var _defineProperty2 = _interopRequireDefault(require_defineProperty2());
      var _extends2 = _interopRequireDefault(require_extends());
      var _stripeStore = require_stripeStore();
      var enumeratePrototypeProps = (obj, propNames = []) => {
        if (obj == null) {
          return propNames;
        }
        return propNames.concat(enumeratePrototypeProps(Object.getPrototypeOf(obj))).concat(Object.keys(obj));
      };
      var createEventProxy = (event, currentTarget) => {
        const propertyDefinitions = enumeratePrototypeProps(event).filter((propName) => propName !== "currentTarget").reduce((proxies, propName) => {
          proxies[propName] = // $FlowFixMe Object.keys is "unsound", always infers `string` as output
          typeof event[propName] === "function" ? (
            // Proxy all the event methods so they will act on the original event:
            // $FlowFixMe Object.keys is "unsound", always infers `string` as output
            {
              value: (...args) => event[propName](...args)
            }
          ) : (
            // Proxy static props/getters because invoking them directly may result in "Illegal invokation" error.
            // $FlowFixMe Object.keys is "unsound", always infers `string` as output
            {
              get: () => event[propName]
            }
          );
          return proxies;
        }, {});
        const retargetedEvent = Object.create(event, (0, _extends2.default)({
          // set currentTarget to the matched node:
          currentTarget: {
            value: currentTarget
          }
        }, propertyDefinitions));
        return retargetedEvent;
      };
      var EventHandlerProxyWithApolloClient = class {
        // FIXME: weak type is used
        // eslint-disable-next-line flowtype/no-weak-types
        constructor(apolloClient, stripeStore) {
          (0, _defineProperty2.default)(this, "on", (eventName, eventMatcher, handler) => {
            const existingHandlers = this.eventHandlers[eventName] instanceof Array ? this.eventHandlers[eventName] : [];
            this.eventHandlers[eventName] = [...existingHandlers, this.createHandlerProxy(eventName, eventMatcher, handler)];
            return this;
          });
          (0, _defineProperty2.default)(this, "createHandlerProxy", (eventName, eventMatcher, handler) => (event) => {
            const match2 = eventMatcher(event);
            const eventProxy = match2 instanceof Element ? createEventProxy(event, match2) : event;
            if (match2) {
              handler(eventProxy, this.apolloClient, this.stripeStore);
            }
          });
          (0, _defineProperty2.default)(this, "attachHandlers", (target) => {
            Object.keys(this.eventHandlers).forEach((eventName) => {
              const handlerProxies = this.eventHandlers[eventName];
              handlerProxies.forEach((handlerProxy) => target.addEventListener(eventName, handlerProxy, true));
            });
            return this;
          });
          (0, _defineProperty2.default)(this, "removeHandlers", (target) => {
            Object.keys(this.eventHandlers).forEach((eventName) => {
              const handlerProxies = this.eventHandlers[eventName];
              handlerProxies.forEach((handlerProxy) => target.removeEventListener(eventName, handlerProxy, true));
            });
            return this;
          });
          this.eventHandlers = {};
          this.apolloClient = apolloClient;
          this.stripeStore = stripeStore;
        }
      };
      exports.default = EventHandlerProxyWithApolloClient;
    }
  });

  // node_modules/graphql/jsutils/invariant.js
  var require_invariant = __commonJS({
    "node_modules/graphql/jsutils/invariant.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = invariant2;
      function invariant2(condition, message) {
        if (!condition) {
          throw new Error(message);
        }
      }
    }
  });

  // node_modules/graphql/language/source.js
  var require_source = __commonJS({
    "node_modules/graphql/language/source.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.Source = void 0;
      var _invariant = require_invariant();
      var _invariant2 = _interopRequireDefault(_invariant);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }
      function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
          throw new TypeError("Cannot call a class as a function");
        }
      }
      var Source = exports.Source = function Source2(body, name, locationOffset) {
        _classCallCheck(this, Source2);
        this.body = body;
        this.name = name || "GraphQL request";
        this.locationOffset = locationOffset || { line: 1, column: 1 };
        !(this.locationOffset.line > 0) ? (0, _invariant2.default)(0, "line in locationOffset is 1-indexed and must be positive") : void 0;
        !(this.locationOffset.column > 0) ? (0, _invariant2.default)(0, "column in locationOffset is 1-indexed and must be positive") : void 0;
      };
    }
  });

  // node_modules/graphql/language/location.js
  var require_location = __commonJS({
    "node_modules/graphql/language/location.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getLocation = getLocation;
      function getLocation(source, position) {
        var lineRegexp = /\r\n|[\n\r]/g;
        var line = 1;
        var column = position + 1;
        var match2 = void 0;
        while ((match2 = lineRegexp.exec(source.body)) && match2.index < position) {
          line += 1;
          column = position + 1 - (match2.index + match2[0].length);
        }
        return { line, column };
      }
    }
  });

  // node_modules/graphql/error/printError.js
  var require_printError = __commonJS({
    "node_modules/graphql/error/printError.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.printError = printError;
      var _location = require_location();
      function printError(error) {
        var printedLocations = [];
        if (error.nodes) {
          error.nodes.forEach(function(node) {
            if (node.loc) {
              printedLocations.push(highlightSourceAtLocation(node.loc.source, (0, _location.getLocation)(node.loc.source, node.loc.start)));
            }
          });
        } else if (error.source && error.locations) {
          var source = error.source;
          error.locations.forEach(function(location) {
            printedLocations.push(highlightSourceAtLocation(source, location));
          });
        }
        return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join("\n\n") + "\n";
      }
      function highlightSourceAtLocation(source, location) {
        var line = location.line;
        var lineOffset = source.locationOffset.line - 1;
        var columnOffset = getColumnOffset(source, location);
        var contextLine = line + lineOffset;
        var contextColumn = location.column + columnOffset;
        var prevLineNum = (contextLine - 1).toString();
        var lineNum = contextLine.toString();
        var nextLineNum = (contextLine + 1).toString();
        var padLen = nextLineNum.length;
        var lines = source.body.split(/\r\n|[\n\r]/g);
        lines[0] = whitespace(source.locationOffset.column - 1) + lines[0];
        var outputLines = [source.name + " (" + contextLine + ":" + contextColumn + ")", line >= 2 && lpad(padLen, prevLineNum) + ": " + lines[line - 2], lpad(padLen, lineNum) + ": " + lines[line - 1], whitespace(2 + padLen + contextColumn - 1) + "^", line < lines.length && lpad(padLen, nextLineNum) + ": " + lines[line]];
        return outputLines.filter(Boolean).join("\n");
      }
      function getColumnOffset(source, location) {
        return location.line === 1 ? source.locationOffset.column - 1 : 0;
      }
      function whitespace(len) {
        return Array(len + 1).join(" ");
      }
      function lpad(len, str) {
        return whitespace(len - str.length) + str;
      }
    }
  });

  // node_modules/graphql/error/GraphQLError.js
  var require_GraphQLError = __commonJS({
    "node_modules/graphql/error/GraphQLError.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.GraphQLError = GraphQLError;
      var _printError = require_printError();
      var _location = require_location();
      function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : void 0 : nodes ? [nodes] : void 0;
        var _source = source;
        if (!_source && _nodes) {
          var node = _nodes[0];
          _source = node && node.loc && node.loc.source;
        }
        var _positions = positions;
        if (!_positions && _nodes) {
          _positions = _nodes.reduce(function(list, node2) {
            if (node2.loc) {
              list.push(node2.loc.start);
            }
            return list;
          }, []);
        }
        if (_positions && _positions.length === 0) {
          _positions = void 0;
        }
        var _locations = void 0;
        if (positions && source) {
          _locations = positions.map(function(pos) {
            return (0, _location.getLocation)(source, pos);
          });
        } else if (_nodes) {
          _locations = _nodes.reduce(function(list, node2) {
            if (node2.loc) {
              list.push((0, _location.getLocation)(node2.loc.source, node2.loc.start));
            }
            return list;
          }, []);
        }
        Object.defineProperties(this, {
          message: {
            value: message,
            // By being enumerable, JSON.stringify will include `message` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true,
            writable: true
          },
          locations: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: _locations || void 0,
            // By being enumerable, JSON.stringify will include `locations` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true
          },
          path: {
            // Coercing falsey values to undefined ensures they will not be included
            // in JSON.stringify() when not provided.
            value: path || void 0,
            // By being enumerable, JSON.stringify will include `path` in the
            // resulting output. This ensures that the simplest possible GraphQL
            // service adheres to the spec.
            enumerable: true
          },
          nodes: {
            value: _nodes || void 0
          },
          source: {
            value: _source || void 0
          },
          positions: {
            value: _positions || void 0
          },
          originalError: {
            value: originalError
          },
          extensions: {
            value: extensions || originalError && originalError.extensions
          }
        });
        if (originalError && originalError.stack) {
          Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
          });
        } else if (Error.captureStackTrace) {
          Error.captureStackTrace(this, GraphQLError);
        } else {
          Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
          });
        }
      }
      GraphQLError.prototype = Object.create(Error.prototype, {
        constructor: { value: GraphQLError },
        name: { value: "GraphQLError" },
        toString: {
          value: function toString4() {
            return (0, _printError.printError)(this);
          }
        }
      });
    }
  });

  // node_modules/graphql/error/syntaxError.js
  var require_syntaxError = __commonJS({
    "node_modules/graphql/error/syntaxError.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.syntaxError = syntaxError;
      var _GraphQLError = require_GraphQLError();
      function syntaxError(source, position, description) {
        return new _GraphQLError.GraphQLError("Syntax Error: " + description, void 0, source, [position]);
      }
    }
  });

  // node_modules/graphql/error/locatedError.js
  var require_locatedError = __commonJS({
    "node_modules/graphql/error/locatedError.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.locatedError = locatedError;
      var _GraphQLError = require_GraphQLError();
      function locatedError(originalError, nodes, path) {
        if (originalError && Array.isArray(originalError.path)) {
          return originalError;
        }
        return new _GraphQLError.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
      }
    }
  });

  // node_modules/graphql/error/formatError.js
  var require_formatError = __commonJS({
    "node_modules/graphql/error/formatError.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _extends = Object.assign || function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
      exports.formatError = formatError;
      var _invariant = require_invariant();
      var _invariant2 = _interopRequireDefault(_invariant);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }
      function formatError(error) {
        !error ? (0, _invariant2.default)(0, "Received null or undefined error.") : void 0;
        return _extends({}, error.extensions, {
          message: error.message || "An unknown error occurred.",
          locations: error.locations,
          path: error.path
        });
      }
    }
  });

  // node_modules/graphql/error/index.js
  var require_error = __commonJS({
    "node_modules/graphql/error/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _GraphQLError = require_GraphQLError();
      Object.defineProperty(exports, "GraphQLError", {
        enumerable: true,
        get: function get2() {
          return _GraphQLError.GraphQLError;
        }
      });
      var _syntaxError = require_syntaxError();
      Object.defineProperty(exports, "syntaxError", {
        enumerable: true,
        get: function get2() {
          return _syntaxError.syntaxError;
        }
      });
      var _locatedError = require_locatedError();
      Object.defineProperty(exports, "locatedError", {
        enumerable: true,
        get: function get2() {
          return _locatedError.locatedError;
        }
      });
      var _printError = require_printError();
      Object.defineProperty(exports, "printError", {
        enumerable: true,
        get: function get2() {
          return _printError.printError;
        }
      });
      var _formatError = require_formatError();
      Object.defineProperty(exports, "formatError", {
        enumerable: true,
        get: function get2() {
          return _formatError.formatError;
        }
      });
    }
  });

  // node_modules/graphql/language/blockStringValue.js
  var require_blockStringValue = __commonJS({
    "node_modules/graphql/language/blockStringValue.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.default = blockStringValue;
      function blockStringValue(rawString) {
        var lines = rawString.split(/\r\n|[\n\r]/g);
        var commonIndent = null;
        for (var i = 1; i < lines.length; i++) {
          var line = lines[i];
          var indent = leadingWhitespace(line);
          if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
            commonIndent = indent;
            if (commonIndent === 0) {
              break;
            }
          }
        }
        if (commonIndent) {
          for (var _i = 1; _i < lines.length; _i++) {
            lines[_i] = lines[_i].slice(commonIndent);
          }
        }
        while (lines.length > 0 && isBlank(lines[0])) {
          lines.shift();
        }
        while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
          lines.pop();
        }
        return lines.join("\n");
      }
      function leadingWhitespace(str) {
        var i = 0;
        while (i < str.length && (str[i] === " " || str[i] === "	")) {
          i++;
        }
        return i;
      }
      function isBlank(str) {
        return leadingWhitespace(str) === str.length;
      }
    }
  });

  // node_modules/graphql/language/lexer.js
  var require_lexer = __commonJS({
    "node_modules/graphql/language/lexer.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.TokenKind = void 0;
      exports.createLexer = createLexer;
      exports.getTokenDesc = getTokenDesc;
      var _error = require_error();
      var _blockStringValue = require_blockStringValue();
      var _blockStringValue2 = _interopRequireDefault(_blockStringValue);
      function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : { default: obj };
      }
      function createLexer(source, options) {
        var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
        var lexer = {
          source,
          options,
          lastToken: startOfFileToken,
          token: startOfFileToken,
          line: 1,
          lineStart: 0,
          advance: advanceLexer,
          lookahead
        };
        return lexer;
      }
      function advanceLexer() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
      }
      function lookahead() {
        var token = this.token;
        if (token.kind !== TokenKind.EOF) {
          do {
            token = token.next || (token.next = readToken(this, token));
          } while (token.kind === TokenKind.COMMENT);
        }
        return token;
      }
      var TokenKind = exports.TokenKind = Object.freeze({
        SOF: "<SOF>",
        EOF: "<EOF>",
        BANG: "!",
        DOLLAR: "$",
        AMP: "&",
        PAREN_L: "(",
        PAREN_R: ")",
        SPREAD: "...",
        COLON: ":",
        EQUALS: "=",
        AT: "@",
        BRACKET_L: "[",
        BRACKET_R: "]",
        BRACE_L: "{",
        PIPE: "|",
        BRACE_R: "}",
        NAME: "Name",
        INT: "Int",
        FLOAT: "Float",
        STRING: "String",
        BLOCK_STRING: "BlockString",
        COMMENT: "Comment"
      });
      function getTokenDesc(token) {
        var value = token.value;
        return value ? token.kind + ' "' + value + '"' : token.kind;
      }
      var charCodeAt = String.prototype.charCodeAt;
      var slice = String.prototype.slice;
      function Tok(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
      }
      Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
        return {
          kind: this.kind,
          value: this.value,
          line: this.line,
          column: this.column
        };
      };
      function printCharCode(code) {
        return (
          // NaN/undefined represents access beyond the end of the file.
          isNaN(code) ? TokenKind.EOF : (
            // Trust JSON for ASCII.
            code < 127 ? JSON.stringify(String.fromCharCode(code)) : (
              // Otherwise print the escaped form.
              '"\\u' + ("00" + code.toString(16).toUpperCase()).slice(-4) + '"'
            )
          )
        );
      }
      function readToken(lexer, prev) {
        var source = lexer.source;
        var body = source.body;
        var bodyLength = body.length;
        var pos = positionAfterWhitespace(body, prev.end, lexer);
        var line = lexer.line;
        var col = 1 + pos - lexer.lineStart;
        if (pos >= bodyLength) {
          return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
        }
        var code = charCodeAt.call(body, pos);
        if (code < 32 && code !== 9 && code !== 10 && code !== 13) {
          throw (0, _error.syntaxError)(source, pos, "Cannot contain the invalid character " + printCharCode(code) + ".");
        }
        switch (code) {
          case 33:
            return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
          case 35:
            return readComment(source, pos, line, col, prev);
          case 36:
            return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
          case 38:
            return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
          case 40:
            return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
          case 41:
            return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
          case 46:
            if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
              return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
            }
            break;
          case 58:
            return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
          case 61:
            return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
          case 64:
            return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
          case 91:
            return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
          case 93:
            return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
          case 123:
            return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
          case 124:
            return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
          case 125:
            return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
          case 65:
          case 66:
          case 67:
          case 68:
          case 69:
          case 70:
          case 71:
          case 72:
          case 73:
          case 74:
          case 75:
          case 76:
          case 77:
          case 78:
          case 79:
          case 80:
          case 81:
          case 82:
          case 83:
          case 84:
          case 85:
          case 86:
          case 87:
          case 88:
          case 89:
          case 90:
          case 95:
          case 97:
          case 98:
          case 99:
          case 100:
          case 101:
          case 102:
          case 103:
          case 104:
          case 105:
          case 106:
          case 107:
          case 108:
          case 109:
          case 110:
          case 111:
          case 112:
          case 113:
          case 114:
          case 115:
          case 116:
          case 117:
          case 118:
          case 119:
          case 120:
          case 121:
          case 122:
            return readName(source, pos, line, col, prev);
          case 45:
          case 48:
          case 49:
          case 50:
          case 51:
          case 52:
          case 53:
          case 54:
          case 55:
          case 56:
          case 57:
            return readNumber(source, pos, code, line, col, prev);
          case 34:
            if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
              return readBlockString(source, pos, line, col, prev);
            }
            return readString(source, pos, line, col, prev);
        }
        throw (0, _error.syntaxError)(source, pos, unexpectedCharacterMessage(code));
      }
      function unexpectedCharacterMessage(code) {
        if (code === 39) {
          return `Unexpected single quote character ('), did you mean to use a double quote (")?`;
        }
        return "Cannot parse the unexpected character " + printCharCode(code) + ".";
      }
      function positionAfterWhitespace(body, startPosition, lexer) {
        var bodyLength = body.length;
        var position = startPosition;
        while (position < bodyLength) {
          var code = charCodeAt.call(body, position);
          if (code === 9 || code === 32 || code === 44 || code === 65279) {
            ++position;
          } else if (code === 10) {
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
          } else if (code === 13) {
            if (charCodeAt.call(body, position + 1) === 10) {
              position += 2;
            } else {
              ++position;
            }
            ++lexer.line;
            lexer.lineStart = position;
          } else {
            break;
          }
        }
        return position;
      }
      function readComment(source, start, line, col, prev) {
        var body = source.body;
        var code = void 0;
        var position = start;
        do {
          code = charCodeAt.call(body, ++position);
        } while (code !== null && // SourceCharacter but not LineTerminator
        (code > 31 || code === 9));
        return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
      }
      function readNumber(source, start, firstCode, line, col, prev) {
        var body = source.body;
        var code = firstCode;
        var position = start;
        var isFloat = false;
        if (code === 45) {
          code = charCodeAt.call(body, ++position);
        }
        if (code === 48) {
          code = charCodeAt.call(body, ++position);
          if (code >= 48 && code <= 57) {
            throw (0, _error.syntaxError)(source, position, "Invalid number, unexpected digit after 0: " + printCharCode(code) + ".");
          }
        } else {
          position = readDigits(source, position, code);
          code = charCodeAt.call(body, position);
        }
        if (code === 46) {
          isFloat = true;
          code = charCodeAt.call(body, ++position);
          position = readDigits(source, position, code);
          code = charCodeAt.call(body, position);
        }
        if (code === 69 || code === 101) {
          isFloat = true;
          code = charCodeAt.call(body, ++position);
          if (code === 43 || code === 45) {
            code = charCodeAt.call(body, ++position);
          }
          position = readDigits(source, position, code);
        }
        return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
      }
      function readDigits(source, start, firstCode) {
        var body = source.body;
        var position = start;
        var code = firstCode;
        if (code >= 48 && code <= 57) {
          do {
            code = charCodeAt.call(body, ++position);
          } while (code >= 48 && code <= 57);
          return position;
        }
        throw (0, _error.syntaxError)(source, position, "Invalid number, expected digit but got: " + printCharCode(code) + ".");
      }
      function readString(source, start, line, col, prev) {
        var body = source.body;
        var position = start + 1;
        var chunkStart = position;
        var code = 0;
        var value = "";
        while (position < body.length && (code = charCodeAt.call(body, position)) !== null && // not LineTerminator
        code !== 10 && code !== 13) {
          if (code === 34) {
            value += slice.call(body, chunkStart, position);
            return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
          }
          if (code < 32 && code !== 9) {
            throw (0, _error.syntaxError)(source, position, "Invalid character within String: " + printCharCode(code) + ".");
          }
          ++position;
          if (code === 92) {
            value += slice.call(body, chunkStart, position - 1);
            code = charCodeAt.call(body, position);
            switch (code) {
              case 34:
                value += '"';
                break;
              case 47:
                value += "/";
                break;
              case 92:
                value += "\\";
                break;
              case 98:
                value += "\b";
                break;
              case 102:
                value += "\f";
                break;
              case 110:
                value += "\n";
                break;
              case 114:
                value += "\r";
                break;
              case 116:
                value += "	";
                break;
              case 117:
                var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));
                if (charCode < 0) {
                  throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: " + ("\\u" + body.slice(position + 1, position + 5) + "."));
                }
                value += String.fromCharCode(charCode);
                position += 4;
                break;
              default:
                throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: \\" + String.fromCharCode(code) + ".");
            }
            ++position;
            chunkStart = position;
          }
        }
        throw (0, _error.syntaxError)(source, position, "Unterminated string.");
      }
      function readBlockString(source, start, line, col, prev) {
        var body = source.body;
        var position = start + 3;
        var chunkStart = position;
        var code = 0;
        var rawValue = "";
        while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
          if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
            rawValue += slice.call(body, chunkStart, position);
            return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringValue2.default)(rawValue));
          }
          if (code < 32 && code !== 9 && code !== 10 && code !== 13) {
            throw (0, _error.syntaxError)(source, position, "Invalid character within String: " + printCharCode(code) + ".");
          }
          if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
            rawValue += slice.call(body, chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
          } else {
            ++position;
          }
        }
        throw (0, _error.syntaxError)(source, position, "Unterminated string.");
      }
      function uniCharCode(a, b, c, d) {
        return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
      }
      function char2hex(a) {
        return a >= 48 && a <= 57 ? a - 48 : a >= 65 && a <= 70 ? a - 55 : a >= 97 && a <= 102 ? a - 87 : -1;
      }
      function readName(source, start, line, col, prev) {
        var body = source.body;
        var bodyLength = body.length;
        var position = start + 1;
        var code = 0;
        while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
        code >= 48 && code <= 57 || // 0-9
        code >= 65 && code <= 90 || // A-Z
        code >= 97 && code <= 122)) {
          ++position;
        }
        return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
      }
    }
  });

  // node_modules/graphql/language/kinds.js
  var require_kinds = __commonJS({
    "node_modules/graphql/language/kinds.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var Kind = exports.Kind = Object.freeze({
        // Name
        NAME: "Name",
        // Document
        DOCUMENT: "Document",
        OPERATION_DEFINITION: "OperationDefinition",
        VARIABLE_DEFINITION: "VariableDefinition",
        VARIABLE: "Variable",
        SELECTION_SET: "SelectionSet",
        FIELD: "Field",
        ARGUMENT: "Argument",
        // Fragments
        FRAGMENT_SPREAD: "FragmentSpread",
        INLINE_FRAGMENT: "InlineFragment",
        FRAGMENT_DEFINITION: "FragmentDefinition",
        // Values
        INT: "IntValue",
        FLOAT: "FloatValue",
        STRING: "StringValue",
        BOOLEAN: "BooleanValue",
        NULL: "NullValue",
        ENUM: "EnumValue",
        LIST: "ListValue",
        OBJECT: "ObjectValue",
        OBJECT_FIELD: "ObjectField",
        // Directives
        DIRECTIVE: "Directive",
        // Types
        NAMED_TYPE: "NamedType",
        LIST_TYPE: "ListType",
        NON_NULL_TYPE: "NonNullType",
        // Type System Definitions
        SCHEMA_DEFINITION: "SchemaDefinition",
        OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
        // Type Definitions
        SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
        OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
        FIELD_DEFINITION: "FieldDefinition",
        INPUT_VALUE_DEFINITION: "InputValueDefinition",
        INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
        UNION_TYPE_DEFINITION: "UnionTypeDefinition",
        ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
        ENUM_VALUE_DEFINITION: "EnumValueDefinition",
        INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
        // Type Extensions
        SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
        OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
        INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
        UNION_TYPE_EXTENSION: "UnionTypeExtension",
        ENUM_TYPE_EXTENSION: "EnumTypeExtension",
        INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension",
        // Directive Definitions
        DIRECTIVE_DEFINITION: "DirectiveDefinition"
      });
    }
  });

  // node_modules/graphql/language/directiveLocation.js
  var require_directiveLocation = __commonJS({
    "node_modules/graphql/language/directiveLocation.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var DirectiveLocation = exports.DirectiveLocation = Object.freeze({
        // Request Definitions
        QUERY: "QUERY",
        MUTATION: "MUTATION",
        SUBSCRIPTION: "SUBSCRIPTION",
        FIELD: "FIELD",
        FRAGMENT_DEFINITION: "FRAGMENT_DEFINITION",
        FRAGMENT_SPREAD: "FRAGMENT_SPREAD",
        INLINE_FRAGMENT: "INLINE_FRAGMENT",
        // Type System Definitions
        SCHEMA: "SCHEMA",
        SCALAR: "SCALAR",
        OBJECT: "OBJECT",
        FIELD_DEFINITION: "FIELD_DEFINITION",
        ARGUMENT_DEFINITION: "ARGUMENT_DEFINITION",
        INTERFACE: "INTERFACE",
        UNION: "UNION",
        ENUM: "ENUM",
        ENUM_VALUE: "ENUM_VALUE",
        INPUT_OBJECT: "INPUT_OBJECT",
        INPUT_FIELD_DEFINITION: "INPUT_FIELD_DEFINITION"
      });
    }
  });

  // node_modules/graphql/language/parser.js
  var require_parser = __commonJS({
    "node_modules/graphql/language/parser.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.parse = parse;
      exports.parseValue = parseValue;
      exports.parseType = parseType;
      exports.parseConstValue = parseConstValue;
      exports.parseTypeReference = parseTypeReference;
      exports.parseNamedType = parseNamedType;
      var _source = require_source();
      var _error = require_error();
      var _lexer = require_lexer();
      var _kinds = require_kinds();
      var _directiveLocation = require_directiveLocation();
      function parse(source, options) {
        var sourceObj = typeof source === "string" ? new _source.Source(source) : source;
        if (!(sourceObj instanceof _source.Source)) {
          throw new TypeError("Must provide Source. Received: " + String(sourceObj));
        }
        var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
        return parseDocument(lexer);
      }
      function parseValue(source, options) {
        var sourceObj = typeof source === "string" ? new _source.Source(source) : source;
        var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
        expect(lexer, _lexer.TokenKind.SOF);
        var value = parseValueLiteral(lexer, false);
        expect(lexer, _lexer.TokenKind.EOF);
        return value;
      }
      function parseType(source, options) {
        var sourceObj = typeof source === "string" ? new _source.Source(source) : source;
        var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
        expect(lexer, _lexer.TokenKind.SOF);
        var type = parseTypeReference(lexer);
        expect(lexer, _lexer.TokenKind.EOF);
        return type;
      }
      function parseName(lexer) {
        var token = expect(lexer, _lexer.TokenKind.NAME);
        return {
          kind: _kinds.Kind.NAME,
          value: token.value,
          loc: loc(lexer, token)
        };
      }
      function parseDocument(lexer) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.SOF);
        var definitions = [];
        do {
          definitions.push(parseDefinition(lexer));
        } while (!skip(lexer, _lexer.TokenKind.EOF));
        return {
          kind: _kinds.Kind.DOCUMENT,
          definitions,
          loc: loc(lexer, start)
        };
      }
      function parseDefinition(lexer) {
        if (peek(lexer, _lexer.TokenKind.NAME)) {
          switch (lexer.token.value) {
            case "query":
            case "mutation":
            case "subscription":
            case "fragment":
              return parseExecutableDefinition(lexer);
            case "schema":
            case "scalar":
            case "type":
            case "interface":
            case "union":
            case "enum":
            case "input":
            case "extend":
            case "directive":
              return parseTypeSystemDefinition(lexer);
          }
        } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
          return parseExecutableDefinition(lexer);
        } else if (peekDescription(lexer)) {
          return parseTypeSystemDefinition(lexer);
        }
        throw unexpected(lexer);
      }
      function parseExecutableDefinition(lexer) {
        if (peek(lexer, _lexer.TokenKind.NAME)) {
          switch (lexer.token.value) {
            case "query":
            case "mutation":
            case "subscription":
              return parseOperationDefinition(lexer);
            case "fragment":
              return parseFragmentDefinition(lexer);
          }
        } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
          return parseOperationDefinition(lexer);
        }
        throw unexpected(lexer);
      }
      function parseOperationDefinition(lexer) {
        var start = lexer.token;
        if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
          return {
            kind: _kinds.Kind.OPERATION_DEFINITION,
            operation: "query",
            name: void 0,
            variableDefinitions: [],
            directives: [],
            selectionSet: parseSelectionSet(lexer),
            loc: loc(lexer, start)
          };
        }
        var operation = parseOperationType(lexer);
        var name = void 0;
        if (peek(lexer, _lexer.TokenKind.NAME)) {
          name = parseName(lexer);
        }
        return {
          kind: _kinds.Kind.OPERATION_DEFINITION,
          operation,
          name,
          variableDefinitions: parseVariableDefinitions(lexer),
          directives: parseDirectives(lexer, false),
          selectionSet: parseSelectionSet(lexer),
          loc: loc(lexer, start)
        };
      }
      function parseOperationType(lexer) {
        var operationToken = expect(lexer, _lexer.TokenKind.NAME);
        switch (operationToken.value) {
          case "query":
            return "query";
          case "mutation":
            return "mutation";
          case "subscription":
            return "subscription";
        }
        throw unexpected(lexer, operationToken);
      }
      function parseVariableDefinitions(lexer) {
        return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
      }
      function parseVariableDefinition(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.Kind.VARIABLE_DEFINITION,
          variable: parseVariable(lexer),
          type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
          defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : void 0,
          loc: loc(lexer, start)
        };
      }
      function parseVariable(lexer) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.DOLLAR);
        return {
          kind: _kinds.Kind.VARIABLE,
          name: parseName(lexer),
          loc: loc(lexer, start)
        };
      }
      function parseSelectionSet(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.Kind.SELECTION_SET,
          selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
          loc: loc(lexer, start)
        };
      }
      function parseSelection(lexer) {
        return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
      }
      function parseField(lexer) {
        var start = lexer.token;
        var nameOrAlias = parseName(lexer);
        var alias = void 0;
        var name = void 0;
        if (skip(lexer, _lexer.TokenKind.COLON)) {
          alias = nameOrAlias;
          name = parseName(lexer);
        } else {
          name = nameOrAlias;
        }
        return {
          kind: _kinds.Kind.FIELD,
          alias,
          name,
          arguments: parseArguments(lexer, false),
          directives: parseDirectives(lexer, false),
          selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : void 0,
          loc: loc(lexer, start)
        };
      }
      function parseArguments(lexer, isConst) {
        var item = isConst ? parseConstArgument : parseArgument;
        return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, item, _lexer.TokenKind.PAREN_R) : [];
      }
      function parseArgument(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.Kind.ARGUMENT,
          name: parseName(lexer),
          value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
          loc: loc(lexer, start)
        };
      }
      function parseConstArgument(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.Kind.ARGUMENT,
          name: parseName(lexer),
          value: (expect(lexer, _lexer.TokenKind.COLON), parseConstValue(lexer)),
          loc: loc(lexer, start)
        };
      }
      function parseFragment(lexer) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.SPREAD);
        if (peek(lexer, _lexer.TokenKind.NAME) && lexer.token.value !== "on") {
          return {
            kind: _kinds.Kind.FRAGMENT_SPREAD,
            name: parseFragmentName(lexer),
            directives: parseDirectives(lexer, false),
            loc: loc(lexer, start)
          };
        }
        var typeCondition = void 0;
        if (lexer.token.value === "on") {
          lexer.advance();
          typeCondition = parseNamedType(lexer);
        }
        return {
          kind: _kinds.Kind.INLINE_FRAGMENT,
          typeCondition,
          directives: parseDirectives(lexer, false),
          selectionSet: parseSelectionSet(lexer),
          loc: loc(lexer, start)
        };
      }
      function parseFragmentDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "fragment");
        if (lexer.options.experimentalFragmentVariables) {
          return {
            kind: _kinds.Kind.FRAGMENT_DEFINITION,
            name: parseFragmentName(lexer),
            variableDefinitions: parseVariableDefinitions(lexer),
            typeCondition: (expectKeyword(lexer, "on"), parseNamedType(lexer)),
            directives: parseDirectives(lexer, false),
            selectionSet: parseSelectionSet(lexer),
            loc: loc(lexer, start)
          };
        }
        return {
          kind: _kinds.Kind.FRAGMENT_DEFINITION,
          name: parseFragmentName(lexer),
          typeCondition: (expectKeyword(lexer, "on"), parseNamedType(lexer)),
          directives: parseDirectives(lexer, false),
          selectionSet: parseSelectionSet(lexer),
          loc: loc(lexer, start)
        };
      }
      function parseFragmentName(lexer) {
        if (lexer.token.value === "on") {
          throw unexpected(lexer);
        }
        return parseName(lexer);
      }
      function parseValueLiteral(lexer, isConst) {
        var token = lexer.token;
        switch (token.kind) {
          case _lexer.TokenKind.BRACKET_L:
            return parseList(lexer, isConst);
          case _lexer.TokenKind.BRACE_L:
            return parseObject(lexer, isConst);
          case _lexer.TokenKind.INT:
            lexer.advance();
            return {
              kind: _kinds.Kind.INT,
              value: token.value,
              loc: loc(lexer, token)
            };
          case _lexer.TokenKind.FLOAT:
            lexer.advance();
            return {
              kind: _kinds.Kind.FLOAT,
              value: token.value,
              loc: loc(lexer, token)
            };
          case _lexer.TokenKind.STRING:
          case _lexer.TokenKind.BLOCK_STRING:
            return parseStringLiteral(lexer);
          case _lexer.TokenKind.NAME:
            if (token.value === "true" || token.value === "false") {
              lexer.advance();
              return {
                kind: _kinds.Kind.BOOLEAN,
                value: token.value === "true",
                loc: loc(lexer, token)
              };
            } else if (token.value === "null") {
              lexer.advance();
              return {
                kind: _kinds.Kind.NULL,
                loc: loc(lexer, token)
              };
            }
            lexer.advance();
            return {
              kind: _kinds.Kind.ENUM,
              value: token.value,
              loc: loc(lexer, token)
            };
          case _lexer.TokenKind.DOLLAR:
            if (!isConst) {
              return parseVariable(lexer);
            }
            break;
        }
        throw unexpected(lexer);
      }
      function parseStringLiteral(lexer) {
        var token = lexer.token;
        lexer.advance();
        return {
          kind: _kinds.Kind.STRING,
          value: token.value,
          block: token.kind === _lexer.TokenKind.BLOCK_STRING,
          loc: loc(lexer, token)
        };
      }
      function parseConstValue(lexer) {
        return parseValueLiteral(lexer, true);
      }
      function parseValueValue(lexer) {
        return parseValueLiteral(lexer, false);
      }
      function parseList(lexer, isConst) {
        var start = lexer.token;
        var item = isConst ? parseConstValue : parseValueValue;
        return {
          kind: _kinds.Kind.LIST,
          values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
          loc: loc(lexer, start)
        };
      }
      function parseObject(lexer, isConst) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.BRACE_L);
        var fields = [];
        while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
          fields.push(parseObjectField(lexer, isConst));
        }
        return {
          kind: _kinds.Kind.OBJECT,
          fields,
          loc: loc(lexer, start)
        };
      }
      function parseObjectField(lexer, isConst) {
        var start = lexer.token;
        return {
          kind: _kinds.Kind.OBJECT_FIELD,
          name: parseName(lexer),
          value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
          loc: loc(lexer, start)
        };
      }
      function parseDirectives(lexer, isConst) {
        var directives = [];
        while (peek(lexer, _lexer.TokenKind.AT)) {
          directives.push(parseDirective(lexer, isConst));
        }
        return directives;
      }
      function parseDirective(lexer, isConst) {
        var start = lexer.token;
        expect(lexer, _lexer.TokenKind.AT);
        return {
          kind: _kinds.Kind.DIRECTIVE,
          name: parseName(lexer),
          arguments: parseArguments(lexer, isConst),
          loc: loc(lexer, start)
        };
      }
      function parseTypeReference(lexer) {
        var start = lexer.token;
        var type = void 0;
        if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
          type = parseTypeReference(lexer);
          expect(lexer, _lexer.TokenKind.BRACKET_R);
          type = {
            kind: _kinds.Kind.LIST_TYPE,
            type,
            loc: loc(lexer, start)
          };
        } else {
          type = parseNamedType(lexer);
        }
        if (skip(lexer, _lexer.TokenKind.BANG)) {
          return {
            kind: _kinds.Kind.NON_NULL_TYPE,
            type,
            loc: loc(lexer, start)
          };
        }
        return type;
      }
      function parseNamedType(lexer) {
        var start = lexer.token;
        return {
          kind: _kinds.Kind.NAMED_TYPE,
          name: parseName(lexer),
          loc: loc(lexer, start)
        };
      }
      function parseTypeSystemDefinition(lexer) {
        var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;
        if (keywordToken.kind === _lexer.TokenKind.NAME) {
          switch (keywordToken.value) {
            case "schema":
              return parseSchemaDefinition(lexer);
            case "scalar":
              return parseScalarTypeDefinition(lexer);
            case "type":
              return parseObjectTypeDefinition(lexer);
            case "interface":
              return parseInterfaceTypeDefinition(lexer);
            case "union":
              return parseUnionTypeDefinition(lexer);
            case "enum":
              return parseEnumTypeDefinition(lexer);
            case "input":
              return parseInputObjectTypeDefinition(lexer);
            case "extend":
              return parseTypeExtension(lexer);
            case "directive":
              return parseDirectiveDefinition(lexer);
          }
        }
        throw unexpected(lexer, keywordToken);
      }
      function peekDescription(lexer) {
        return peek(lexer, _lexer.TokenKind.STRING) || peek(lexer, _lexer.TokenKind.BLOCK_STRING);
      }
      function parseDescription(lexer) {
        if (peekDescription(lexer)) {
          return parseStringLiteral(lexer);
        }
      }
      function parseSchemaDefinition(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "schema");
        var directives = parseDirectives(lexer, true);
        var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
        return {
          kind: _kinds.Kind.SCHEMA_DEFINITION,
          directives,
          operationTypes,
          loc: loc(lexer, start)
        };
      }
      function parseOperationTypeDefinition(lexer) {
        var start = lexer.token;
        var operation = parseOperationType(lexer);
        expect(lexer, _lexer.TokenKind.COLON);
        var type = parseNamedType(lexer);
        return {
          kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
          operation,
          type,
          loc: loc(lexer, start)
        };
      }
      function parseScalarTypeDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        expectKeyword(lexer, "scalar");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        return {
          kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
          description,
          name,
          directives,
          loc: loc(lexer, start)
        };
      }
      function parseObjectTypeDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        expectKeyword(lexer, "type");
        var name = parseName(lexer);
        var interfaces = parseImplementsInterfaces(lexer);
        var directives = parseDirectives(lexer, true);
        var fields = parseFieldsDefinition(lexer);
        return {
          kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
          description,
          name,
          interfaces,
          directives,
          fields,
          loc: loc(lexer, start)
        };
      }
      function parseImplementsInterfaces(lexer) {
        var types = [];
        if (lexer.token.value === "implements") {
          lexer.advance();
          skip(lexer, _lexer.TokenKind.AMP);
          do {
            types.push(parseNamedType(lexer));
          } while (skip(lexer, _lexer.TokenKind.AMP) || // Legacy support for the SDL?
          lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, _lexer.TokenKind.NAME));
        }
        return types;
      }
      function parseFieldsDefinition(lexer) {
        if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, _lexer.TokenKind.BRACE_L) && lexer.lookahead().kind === _lexer.TokenKind.BRACE_R) {
          lexer.advance();
          lexer.advance();
          return [];
        }
        return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R) : [];
      }
      function parseFieldDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        var name = parseName(lexer);
        var args = parseArgumentDefs(lexer);
        expect(lexer, _lexer.TokenKind.COLON);
        var type = parseTypeReference(lexer);
        var directives = parseDirectives(lexer, true);
        return {
          kind: _kinds.Kind.FIELD_DEFINITION,
          description,
          name,
          arguments: args,
          type,
          directives,
          loc: loc(lexer, start)
        };
      }
      function parseArgumentDefs(lexer) {
        if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
          return [];
        }
        return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
      }
      function parseInputValueDef(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        var name = parseName(lexer);
        expect(lexer, _lexer.TokenKind.COLON);
        var type = parseTypeReference(lexer);
        var defaultValue = void 0;
        if (skip(lexer, _lexer.TokenKind.EQUALS)) {
          defaultValue = parseConstValue(lexer);
        }
        var directives = parseDirectives(lexer, true);
        return {
          kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
          description,
          name,
          type,
          defaultValue,
          directives,
          loc: loc(lexer, start)
        };
      }
      function parseInterfaceTypeDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        expectKeyword(lexer, "interface");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var fields = parseFieldsDefinition(lexer);
        return {
          kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
          description,
          name,
          directives,
          fields,
          loc: loc(lexer, start)
        };
      }
      function parseUnionTypeDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        expectKeyword(lexer, "union");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var types = parseUnionMemberTypes(lexer);
        return {
          kind: _kinds.Kind.UNION_TYPE_DEFINITION,
          description,
          name,
          directives,
          types,
          loc: loc(lexer, start)
        };
      }
      function parseUnionMemberTypes(lexer) {
        var types = [];
        if (skip(lexer, _lexer.TokenKind.EQUALS)) {
          skip(lexer, _lexer.TokenKind.PIPE);
          do {
            types.push(parseNamedType(lexer));
          } while (skip(lexer, _lexer.TokenKind.PIPE));
        }
        return types;
      }
      function parseEnumTypeDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        expectKeyword(lexer, "enum");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var values2 = parseEnumValuesDefinition(lexer);
        return {
          kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
          description,
          name,
          directives,
          values: values2,
          loc: loc(lexer, start)
        };
      }
      function parseEnumValuesDefinition(lexer) {
        return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R) : [];
      }
      function parseEnumValueDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        return {
          kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
          description,
          name,
          directives,
          loc: loc(lexer, start)
        };
      }
      function parseInputObjectTypeDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        expectKeyword(lexer, "input");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var fields = parseInputFieldsDefinition(lexer);
        return {
          kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
          description,
          name,
          directives,
          fields,
          loc: loc(lexer, start)
        };
      }
      function parseInputFieldsDefinition(lexer) {
        return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R) : [];
      }
      function parseTypeExtension(lexer) {
        var keywordToken = lexer.lookahead();
        if (keywordToken.kind === _lexer.TokenKind.NAME) {
          switch (keywordToken.value) {
            case "scalar":
              return parseScalarTypeExtension(lexer);
            case "type":
              return parseObjectTypeExtension(lexer);
            case "interface":
              return parseInterfaceTypeExtension(lexer);
            case "union":
              return parseUnionTypeExtension(lexer);
            case "enum":
              return parseEnumTypeExtension(lexer);
            case "input":
              return parseInputObjectTypeExtension(lexer);
          }
        }
        throw unexpected(lexer, keywordToken);
      }
      function parseScalarTypeExtension(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "extend");
        expectKeyword(lexer, "scalar");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        if (directives.length === 0) {
          throw unexpected(lexer);
        }
        return {
          kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
          name,
          directives,
          loc: loc(lexer, start)
        };
      }
      function parseObjectTypeExtension(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "extend");
        expectKeyword(lexer, "type");
        var name = parseName(lexer);
        var interfaces = parseImplementsInterfaces(lexer);
        var directives = parseDirectives(lexer, true);
        var fields = parseFieldsDefinition(lexer);
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
          throw unexpected(lexer);
        }
        return {
          kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
          name,
          interfaces,
          directives,
          fields,
          loc: loc(lexer, start)
        };
      }
      function parseInterfaceTypeExtension(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "extend");
        expectKeyword(lexer, "interface");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var fields = parseFieldsDefinition(lexer);
        if (directives.length === 0 && fields.length === 0) {
          throw unexpected(lexer);
        }
        return {
          kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
          name,
          directives,
          fields,
          loc: loc(lexer, start)
        };
      }
      function parseUnionTypeExtension(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "extend");
        expectKeyword(lexer, "union");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var types = parseUnionMemberTypes(lexer);
        if (directives.length === 0 && types.length === 0) {
          throw unexpected(lexer);
        }
        return {
          kind: _kinds.Kind.UNION_TYPE_EXTENSION,
          name,
          directives,
          types,
          loc: loc(lexer, start)
        };
      }
      function parseEnumTypeExtension(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "extend");
        expectKeyword(lexer, "enum");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var values2 = parseEnumValuesDefinition(lexer);
        if (directives.length === 0 && values2.length === 0) {
          throw unexpected(lexer);
        }
        return {
          kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
          name,
          directives,
          values: values2,
          loc: loc(lexer, start)
        };
      }
      function parseInputObjectTypeExtension(lexer) {
        var start = lexer.token;
        expectKeyword(lexer, "extend");
        expectKeyword(lexer, "input");
        var name = parseName(lexer);
        var directives = parseDirectives(lexer, true);
        var fields = parseInputFieldsDefinition(lexer);
        if (directives.length === 0 && fields.length === 0) {
          throw unexpected(lexer);
        }
        return {
          kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
          name,
          directives,
          fields,
          loc: loc(lexer, start)
        };
      }
      function parseDirectiveDefinition(lexer) {
        var start = lexer.token;
        var description = parseDescription(lexer);
        expectKeyword(lexer, "directive");
        expect(lexer, _lexer.TokenKind.AT);
        var name = parseName(lexer);
        var args = parseArgumentDefs(lexer);
        expectKeyword(lexer, "on");
        var locations = parseDirectiveLocations(lexer);
        return {
          kind: _kinds.Kind.DIRECTIVE_DEFINITION,
          description,
          name,
          arguments: args,
          locations,
          loc: loc(lexer, start)
        };
      }
      function parseDirectiveLocations(lexer) {
        skip(lexer, _lexer.TokenKind.PIPE);
        var locations = [];
        do {
          locations.push(parseDirectiveLocation(lexer));
        } while (skip(lexer, _lexer.TokenKind.PIPE));
        return locations;
      }
      function parseDirectiveLocation(lexer) {
        var start = lexer.token;
        var name = parseName(lexer);
        if (_directiveLocation.DirectiveLocation.hasOwnProperty(name.value)) {
          return name;
        }
        throw unexpected(lexer, start);
      }
      function loc(lexer, startToken) {
        if (!lexer.options.noLocation) {
          return new Loc(startToken, lexer.lastToken, lexer.source);
        }
      }
      function Loc(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
      }
      Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
        return { start: this.start, end: this.end };
      };
      function peek(lexer, kind) {
        return lexer.token.kind === kind;
      }
      function skip(lexer, kind) {
        var match2 = lexer.token.kind === kind;
        if (match2) {
          lexer.advance();
        }
        return match2;
      }
      function expect(lexer, kind) {
        var token = lexer.token;
        if (token.kind === kind) {
          lexer.advance();
          return token;
        }
        throw (0, _error.syntaxError)(lexer.source, token.start, "Expected " + kind + ", found " + (0, _lexer.getTokenDesc)(token));
      }
      function expectKeyword(lexer, value) {
        var token = lexer.token;
        if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
          lexer.advance();
          return token;
        }
        throw (0, _error.syntaxError)(lexer.source, token.start, 'Expected "' + value + '", found ' + (0, _lexer.getTokenDesc)(token));
      }
      function unexpected(lexer, atToken) {
        var token = atToken || lexer.token;
        return (0, _error.syntaxError)(lexer.source, token.start, "Unexpected " + (0, _lexer.getTokenDesc)(token));
      }
      function any(lexer, openKind, parseFn, closeKind) {
        expect(lexer, openKind);
        var nodes = [];
        while (!skip(lexer, closeKind)) {
          nodes.push(parseFn(lexer));
        }
        return nodes;
      }
      function many(lexer, openKind, parseFn, closeKind) {
        expect(lexer, openKind);
        var nodes = [parseFn(lexer)];
        while (!skip(lexer, closeKind)) {
          nodes.push(parseFn(lexer));
        }
        return nodes;
      }
    }
  });

  // node_modules/graphql-tag/lib/graphql-tag.umd.js
  var require_graphql_tag_umd = __commonJS({
    "node_modules/graphql-tag/lib/graphql-tag.umd.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? factory() : typeof define === "function" && define.amd ? define(factory) : factory();
      })(exports, function() {
        "use strict";
        var parser = require_parser();
        var parse = parser.parse;
        function normalize(string) {
          return string.replace(/[\s,]+/g, " ").trim();
        }
        var docCache = {};
        var fragmentSourceMap = {};
        function cacheKeyFromLoc(loc) {
          return normalize(loc.source.body.substring(loc.start, loc.end));
        }
        function resetCaches() {
          docCache = {};
          fragmentSourceMap = {};
        }
        var printFragmentWarnings = true;
        function processFragments(ast) {
          var astFragmentMap = {};
          var definitions = [];
          for (var i = 0; i < ast.definitions.length; i++) {
            var fragmentDefinition = ast.definitions[i];
            if (fragmentDefinition.kind === "FragmentDefinition") {
              var fragmentName = fragmentDefinition.name.value;
              var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
              if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {
                if (printFragmentWarnings) {
                  console.warn("Warning: fragment with name " + fragmentName + " already exists.\ngraphql-tag enforces all fragment names across your application to be unique; read more about\nthis in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
                fragmentSourceMap[fragmentName][sourceKey] = true;
              } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
                fragmentSourceMap[fragmentName] = {};
                fragmentSourceMap[fragmentName][sourceKey] = true;
              }
              if (!astFragmentMap[sourceKey]) {
                astFragmentMap[sourceKey] = true;
                definitions.push(fragmentDefinition);
              }
            } else {
              definitions.push(fragmentDefinition);
            }
          }
          ast.definitions = definitions;
          return ast;
        }
        function disableFragmentWarnings() {
          printFragmentWarnings = false;
        }
        function stripLoc(doc, removeLocAtThisLevel) {
          var docType = Object.prototype.toString.call(doc);
          if (docType === "[object Array]") {
            return doc.map(function(d) {
              return stripLoc(d, removeLocAtThisLevel);
            });
          }
          if (docType !== "[object Object]") {
            throw new Error("Unexpected input.");
          }
          if (removeLocAtThisLevel && doc.loc) {
            delete doc.loc;
          }
          if (doc.loc) {
            delete doc.loc.startToken;
            delete doc.loc.endToken;
          }
          var keys = Object.keys(doc);
          var key;
          var value;
          var valueType;
          for (key in keys) {
            if (keys.hasOwnProperty(key)) {
              value = doc[keys[key]];
              valueType = Object.prototype.toString.call(value);
              if (valueType === "[object Object]" || valueType === "[object Array]") {
                doc[keys[key]] = stripLoc(value, true);
              }
            }
          }
          return doc;
        }
        var experimentalFragmentVariables = false;
        function parseDocument(doc) {
          var cacheKey = normalize(doc);
          if (docCache[cacheKey]) {
            return docCache[cacheKey];
          }
          var parsed = parse(doc, { experimentalFragmentVariables });
          if (!parsed || parsed.kind !== "Document") {
            throw new Error("Not a valid GraphQL document.");
          }
          parsed = processFragments(parsed);
          parsed = stripLoc(parsed, false);
          docCache[cacheKey] = parsed;
          return parsed;
        }
        function enableExperimentalFragmentVariables() {
          experimentalFragmentVariables = true;
        }
        function disableExperimentalFragmentVariables() {
          experimentalFragmentVariables = false;
        }
        function gql() {
          var args = Array.prototype.slice.call(arguments);
          var literals = args[0];
          var result = typeof literals === "string" ? literals : literals[0];
          for (var i = 1; i < args.length; i++) {
            if (args[i] && args[i].kind && args[i].kind === "Document") {
              result += args[i].loc.source.body;
            } else {
              result += args[i];
            }
            result += literals[i];
          }
          return parseDocument(result);
        }
        gql.default = gql;
        gql.resetCaches = resetCaches;
        gql.disableFragmentWarnings = disableFragmentWarnings;
        gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
        gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;
        module.exports = gql;
      });
    }
  });

  // packages/utilities/fp/utils/Const.ts
  var create, VALUE, prototype, Const, getConst;
  var init_Const = __esm({
    "packages/utilities/fp/utils/Const.ts"() {
      "use strict";
      ({ create } = Object);
      VALUE = "@webflow/Const/value";
      prototype = {
        // map(f) { // eslint-disable-line no-unused-vars
        map() {
          return this;
        }
      };
      Const = (value) => {
        const object = create(prototype);
        object[VALUE] = value;
        return object;
      };
      getConst = (con) => con[VALUE];
    }
  });

  // packages/utilities/fp/utils/Identity.ts
  var create2, VALUE2, prototype2, Identity, runIdentity;
  var init_Identity = __esm({
    "packages/utilities/fp/utils/Identity.ts"() {
      "use strict";
      ({ create: create2 } = Object);
      VALUE2 = "@webflow/Identity/value";
      prototype2 = {
        // @ts-expect-error - TS7023 - 'map' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
        map(f) {
          return Identity(f(this[VALUE2]));
        }
      };
      Identity = (value) => {
        const object = create2(prototype2);
        object[VALUE2] = value;
        return object;
      };
      runIdentity = (object) => object[VALUE2];
    }
  });

  // packages/utilities/fp/option/index.ts
  var create3, returnThis, VALUE3, None, Some, SomePrototype, maybe;
  var init_option = __esm({
    "packages/utilities/fp/option/index.ts"() {
      "use strict";
      ({ create: create3 } = Object);
      returnThis = function() {
        return this;
      };
      VALUE3 = "@webflow/Option";
      None = create3({
        map: returnThis,
        chain: returnThis,
        alt: (alternativeOption) => alternativeOption,
        ap: returnThis,
        concat: (other) => other,
        /**
         * Returns a default fallback value if the `Option` is a `None`.
         */
        foldOption: (fallback) => fallback
      });
      Some = (value) => {
        const object = create3(SomePrototype);
        object[VALUE3] = value;
        return object;
      };
      SomePrototype = {
        /**
         * Transform the value inside of a `Option` by applying a unary function to it.
         */
        map(f) {
          return Some(f(this[VALUE3]));
        },
        /**
         * Sequence computations by applying a function to the value
         * contained in the `Option`. The function must return an `Option`.
         */
        chain(f) {
          return f(this[VALUE3]);
        },
        /**
         * Provide an alternative option that will be returned if this option is None.
         */
        alt: returnThis,
        /**
         * Allows you to apply the Option's value with another Option's value,
         * returning another Option.
         */
        ap(m) {
          return m.map(this[VALUE3]);
        },
        concat(other) {
          return other.foldOption(
            this,
            (otherValue) => (
              // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '"@webflow/Option"' can't be used to index type '{ readonly map: (f: any) => any; readonly chain: (f: any) => any; readonly alt: () => any; readonly ap: (m: any) => any; readonly concat: (other: any) => any; readonly foldOption: (fallback: any, mapValue: any) => any; }'.
              Some(this[VALUE3].concat(otherValue))
            )
          );
        },
        /**
         * Applies a function to the value contained in an `Option`
         * if the `Option` is a `Some`.
         */
        foldOption(fallback, mapValue) {
          return mapValue(this[VALUE3]);
        }
      };
      maybe = (fallback) => (mapValue) => (option) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore private foldOption
        option.foldOption(fallback, mapValue)
      );
    }
  });

  // packages/utilities/fp/result/index.ts
  var create4, returnThis2, VALUE4, ERROR, Err, Ok, ErrPrototype, OkPrototype, either;
  var init_result = __esm({
    "packages/utilities/fp/result/index.ts"() {
      "use strict";
      ({ create: create4 } = Object);
      returnThis2 = function() {
        return this;
      };
      VALUE4 = "@webflow/Result/value";
      ERROR = "@webflow/Result/error";
      Err = (error) => {
        const object = create4(ErrPrototype);
        object[ERROR] = error;
        return object;
      };
      Ok = (value) => {
        const object = create4(OkPrototype);
        object[VALUE4] = value;
        return object;
      };
      ErrPrototype = {};
      OkPrototype = {};
      ErrPrototype.map = returnThis2;
      OkPrototype.map = function(f) {
        return Ok(f(this[VALUE4]));
      };
      ErrPrototype.chain = returnThis2;
      OkPrototype.chain = function(f) {
        return f(this[VALUE4]);
      };
      ErrPrototype.ap = returnThis2;
      OkPrototype.ap = function(m) {
        return m.map(this[VALUE4]);
      };
      ErrPrototype.foldResult = function(errorHandler) {
        return errorHandler(this[ERROR]);
      };
      OkPrototype.foldResult = function(errorHandler, valueHandler) {
        return valueHandler(this[VALUE4]);
      };
      either = (mapErr) => (mapVal) => (result) => (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore private foldResult
        result.foldResult(mapErr, mapVal)
      );
    }
  });

  // packages/utilities/fp/utils/index.ts
  var utils_exports = {};
  __export(utils_exports, {
    add: () => add,
    adjust: () => adjust,
    allPass: () => allPass,
    anyPass: () => anyPass,
    append: () => append,
    assoc: () => assoc,
    blackbird: () => blackbird,
    both: () => both,
    complement: () => complement,
    compose: () => compose,
    concat: () => concat3,
    concatTo: () => concatTo,
    constant: () => constant,
    constantFalse: () => constantFalse,
    constantIdentity: () => constantIdentity,
    constantNone: () => constantNone,
    constantTrue: () => constantTrue,
    dissoc: () => dissoc,
    either: () => either2,
    emptyArray: () => emptyArray,
    emptyObject: () => emptyObject,
    entries: () => entries,
    equals: () => equals,
    errToOption: () => errToOption,
    extractArray: () => extractArray,
    extractBool: () => extractBool,
    extractFunctionFromOption: () => extractFunctionFromOption,
    extractFunctionFromResult: () => extractFunctionFromResult,
    filter: () => filter,
    find: () => find,
    flat: () => flat,
    flatMap: () => flatMap,
    flip: () => flip,
    getDeepestValues: () => getDeepestValues,
    has: () => has,
    head: () => head,
    identity: () => identity,
    inc: () => inc,
    isNil: () => isNil,
    last: () => last,
    length: () => length,
    lens: () => lens,
    lensProp: () => lensProp,
    lookup: () => lookup,
    lookupWithDefault: () => lookupWithDefault,
    map: () => map,
    mapArray: () => mapArray,
    mapValues: () => mapValues,
    match: () => match,
    max: () => max,
    noneToErr: () => noneToErr,
    not: () => not,
    notEqual: () => notEqual,
    notNil: () => notNil,
    nth: () => nth,
    objOf: () => objOf,
    objectKeys: () => objectKeys,
    okToOption: () => okToOption,
    omit: () => omit,
    optionToArray: () => optionToArray,
    optionToBool: () => optionToBool,
    over: () => over,
    parseIntWithRadix: () => parseIntWithRadix,
    pick: () => pick,
    pickBy: () => pickBy,
    pipe: () => pipe,
    prop: () => prop,
    reduce: () => reduce,
    reduceObject: () => reduceObject,
    replace: () => replace,
    resultToBool: () => resultToBool,
    safeParseInt: () => safeParseInt,
    set: () => set,
    split: () => split3,
    substitution: () => substitution,
    tail: () => tail,
    tap: () => tap,
    test: () => test,
    thrush: () => thrush,
    traverseObjectResults: () => traverseObjectResults,
    traverseOptions: () => traverseOptions,
    traverseResults: () => traverseResults,
    union: () => union,
    unionTo: () => unionTo,
    unionWith: () => unionWith,
    values: () => values,
    view: () => view,
    when: () => when,
    zip: () => zip,
    zipCat: () => zipCat,
    zipWith: () => zipWith
  });
  function getMinLength(arrays) {
    if (arrays.length === 0)
      return 0;
    if (arrays.length === 1)
      return arrays[0].length;
    let min = arrays[0].length;
    for (let i = 1, len = arrays.length; i < len; i++) {
      const arr_len = arrays[i].length;
      if (arr_len < min)
        min = arr_len;
    }
    return min;
  }
  function zipCat(fn) {
    return function zipCat_inner(arrays) {
      const zipLength = getMinLength(arrays);
      const rv = [];
      for (let i = 0, len = arrays.length; i < len; i++) {
        const array = arrays[i];
        for (let j = 0, array_len = array.length; j < array_len; j++) {
          const item = array[j];
          if (j < zipLength) {
            const existing = rv[j];
            if (typeof existing !== "undefined") {
              rv[j] = fn(existing)(item);
            } else {
              rv[j] = item;
            }
          } else {
            rv.push(item);
          }
        }
      }
      return rv;
    };
  }
  var hasOwn3, objectKeys, emptyArray, emptyObject, identity, constant, compose, blackbird, flip, thrush, substitution, constantFalse, constantTrue, not, complement, anyPass, allPass, optionToBool, resultToBool, equals, notEqual, isNil, notNil, either2, both, when, has, prop, assocReducer, assoc, dissocReducer, dissoc, adjust, unionWith, union, unionTo, omitReducer, omit, pickReducer, pick, pickByReducer, pickBy, lookup, lookupWithDefault, find, binaryThrush, pipe, zipWith, zip, map, mapArray, filter, reduce, reduceObject, objOf, concat3, concatTo, append, constantIdentity, add, inc, max, parseIntWithRadix, safeParseInt, head, last, tail, length, flatMap, flat, test, match, replace, split3, lens, lensProp, view, over, set, constantNone, noneToErr, okToOption, errToOption, tap, extractBool, extractArray, extractFunctionFromOption, extractFunctionFromResult, optionToArray, optionOfEmptyArray, traverseOptions, resultOfEmptyArray, traverseResults, resultOfEmptyObject, traverseObjectResults, mapValues, values, entries, getDeepestValues, nth;
  var init_utils2 = __esm({
    "packages/utilities/fp/utils/index.ts"() {
      init_Const();
      init_Identity();
      init_option();
      init_result();
      hasOwn3 = Object.prototype.hasOwnProperty;
      objectKeys = Object.keys;
      emptyArray = [];
      emptyObject = {};
      if (false) {
        const proxy = (sharedConstantName) => ({
          // @ts-expect-error - TS7006 - Parameter 'target' implicitly has an 'any' type. | TS7006 - Parameter 'prop' implicitly has an 'any' type. | TS7006 - Parameter 'value' implicitly has an 'any' type.
          set: (target, prop2, value) => {
            console.error(
              'Invalid mutation of shared constant. Property "%s" was set on "%s".',
              prop2,
              sharedConstantName
            );
            target[prop2] = value;
          }
        });
        emptyArray = new Proxy(emptyArray, proxy("emptyArray"));
        emptyObject = new Proxy(
          emptyObject,
          // @ts-expect-error - TS2345 - Argument of type '{ set: (target: any, prop: any, value: any) => void; }' is not assignable to parameter of type 'ProxyHandler<any>'.
          proxy("emptyObject")
        );
      }
      identity = (x) => x;
      constant = (x) => (
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (y) => x
      );
      compose = (f) => (g) => (x) => f(g(x));
      blackbird = (f) => (g) => (x) => (y) => f(g(x)(y));
      flip = (f) => (x) => (y) => f(y)(x);
      thrush = (x) => (f) => f(x);
      substitution = (f) => (g) => (x) => f(x)(g(x));
      constantFalse = constant(false);
      constantTrue = constant(true);
      not = (x) => !x;
      complement = compose(not);
      anyPass = (preds) => (value) => preds.some(thrush(value));
      allPass = (preds) => (value) => preds.every(thrush(value));
      optionToBool = maybe(false)(constantTrue);
      resultToBool = either(constantFalse)(constantTrue);
      equals = (a) => (b) => a === b;
      notEqual = (a) => (b) => a !== b;
      isNil = (value) => value == null;
      notNil = complement(isNil);
      either2 = (predicateA, predicateB) => (...args) => predicateA(...args) || predicateB(...args);
      both = (predicateA, predicateB) => (...args) => predicateA(...args) && predicateB(...args);
      when = (predicate) => (whenTrueFn) => (value) => predicate(value) ? whenTrueFn(value) : value;
      has = (key) => (object) => hasOwn3.call(object, key);
      prop = (key) => (object) => object[key];
      assocReducer = (acc, key) => {
        acc.result[key] = acc.source[key];
        return acc;
      };
      assoc = (key) => {
        const hasKey = has(key);
        return (value) => (object) => {
          if (hasKey(object) && object[key] === value) {
            return object;
          }
          const result = objectKeys(object).reduce(assocReducer, {
            source: object,
            result: {}
          }).result;
          result[key] = value;
          return result;
        };
      };
      dissocReducer = (acc, key) => {
        if (acc.exclude !== key) {
          acc.result[key] = acc.source[key];
        }
        return acc;
      };
      dissoc = (key) => {
        const hasKey = has(key);
        return (object) => hasKey(object) ? objectKeys(object).reduce(dissocReducer, {
          source: object,
          result: {},
          exclude: key
        }).result : object;
      };
      adjust = (f) => (key) => {
        const hasKey = has(key);
        return (obj) => (
          // @ts-expect-error - TS2345 - Argument of type 'a | undefined' is not assignable to parameter of type 'a'.
          hasKey(obj) ? assoc(key)(f(obj[key]))(obj) : obj
        );
      };
      unionWith = (combine) => (first2) => first2 === emptyObject ? identity : (second) => {
        if (second === emptyObject)
          return first2;
        let changedFromFirst = false;
        let changedFromSecond = false;
        const result = {};
        for (const key in second) {
          const secondVal = second[key];
          if (key in first2) {
            const firstVal = first2[key];
            const finalVal = combine(firstVal)(secondVal);
            if (finalVal !== secondVal) {
              changedFromSecond = true;
            }
            if (finalVal !== firstVal) {
              changedFromFirst = true;
            }
            result[key] = finalVal;
          } else {
            changedFromFirst = true;
            result[key] = secondVal;
          }
        }
        for (const key in first2) {
          if (key in result)
            continue;
          changedFromSecond = true;
          result[key] = first2[key];
        }
        if (!changedFromFirst)
          return first2;
        if (!changedFromSecond)
          return second;
        return result;
      };
      union = unionWith(
        constant
      );
      unionTo = flip(union);
      omitReducer = (acc, key) => {
        if (acc.exclude.includes(key)) {
          acc.changed = true;
        } else {
          acc.result[key] = acc.source[key];
        }
        return acc;
      };
      omit = (keys) => {
        const len = keys.length;
        if (len === 0) {
          return identity;
        }
        if (len === 1) {
          return dissoc(keys[0]);
        }
        return (object) => {
          const { result, changed } = objectKeys(object).reduce(omitReducer, {
            source: object,
            exclude: keys,
            changed: false,
            result: {}
          });
          return changed ? result : object;
        };
      };
      pickReducer = (acc, key) => {
        if (hasOwn3.call(acc.source, key)) {
          acc.result[key] = acc.source[key];
        }
        return acc;
      };
      pick = (keys) => (source) => keys.reduce(pickReducer, { source, result: {} }).result;
      pickByReducer = (acc, key) => {
        const value = acc.source[key];
        if (acc.predicate(value)) {
          acc.result[key] = value;
        } else {
          acc.changed = true;
        }
        return acc;
      };
      pickBy = (predicate) => (object) => {
        const { result, changed } = objectKeys(object).reduce(pickByReducer, {
          source: object,
          predicate,
          changed: false,
          result: {}
        });
        return changed ? result : object;
      };
      lookup = (key) => {
        const hasKey = has(key);
        return (object) => (
          // @ts-expect-error - TS2322 - Type 'Option<a> | Option<Partial<Record<k, a>>[k]>' is not assignable to type 'Option<a>'.
          hasKey(object) ? Some(object[key]) : None
        );
      };
      lookupWithDefault = (defaultValue) => (key) => {
        const hasKey = has(key);
        return (object) => hasKey(object) ? object[key] : defaultValue;
      };
      find = (pred) => (array) => {
        const index = array.findIndex(pred);
        return index === -1 ? None : Some(array[index]);
      };
      binaryThrush = (v, f) => f(v);
      pipe = (fns) => (value) => fns.reduce(binaryThrush, value);
      zipWith = (f) => (xs) => (ys) => {
        const rv = [];
        let idx = 0;
        const len = Math.min(xs.length, ys.length);
        while (idx < len) {
          rv[idx] = f(xs[idx])(ys[idx]);
          idx += 1;
        }
        return rv;
      };
      zip = zipWith((x) => (y) => [x, y]);
      map = (f) => (xs) => xs.map(f);
      mapArray = (f) => (xs) => {
        let changed = false;
        const ys = xs.reduce((res, x) => {
          const newX = f(x);
          if (newX !== x) {
            changed = true;
          }
          res.push(newX);
          return res;
        }, []);
        return changed ? ys : xs;
      };
      filter = (f) => (xs) => xs.filter(f);
      reduce = (reducer) => (init) => (xs) => xs.reduce(reducer, init);
      reduceObject = (reducer) => (init) => (obj) => (
        // @ts-expect-error - TS2345 - Argument of type 'a | undefined' is not assignable to parameter of type 'a'.
        objectKeys(obj).reduce((result, key) => reducer(result)(obj[key]), init)
      );
      objOf = (key) => (value) => ({ [key]: value });
      concat3 = (ys) => ys.length ? (xs) => xs.length ? xs.concat(ys) : ys : identity;
      concatTo = flip(concat3);
      append = (value) => concat3([value]);
      constantIdentity = constant(identity);
      add = (x) => (y) => x + y;
      inc = (x) => x + 1;
      max = (x) => (y) => x > y ? x : y;
      parseIntWithRadix = (radix) => (num) => {
        const parsed = parseInt(num, radix);
        return isNaN(parsed) ? None : Some(parsed);
      };
      safeParseInt = parseIntWithRadix(10);
      head = (xs) => xs.length ? Some(xs[0]) : None;
      last = (xs) => xs.length ? Some(xs[xs.length - 1]) : None;
      tail = (xs) => xs.slice(1);
      length = (xs) => xs.length;
      flatMap = (f) => (
        // @ts-expect-error - TS2322 - Type '(arg1: unknown[]) => unknown' is not assignable to type '(arg1: a[]) => b[]'.
        reduce((result, item) => {
          const ys = f(item);
          if (!ys.length) {
            return result;
          }
          const nextResult = result.length ? result : [];
          nextResult.push.apply(nextResult, ys);
          return nextResult;
        })(emptyArray)
      );
      flat = flatMap(
        identity
      );
      test = (regex) => (string) => {
        regex.lastIndex = 0;
        const result = regex.test(string);
        regex.lastIndex = 0;
        return result;
      };
      match = (regex) => (string) => {
        const result = string.match(regex);
        return result ? Some(result[0]) : None;
      };
      replace = (pattern) => (replacement) => (string) => string.replace(pattern, replacement);
      split3 = (pattern) => (string) => string.split(pattern);
      lens = (getter) => (setter) => (toFunctor) => (target) => toFunctor(getter(target)).map((focus) => setter(focus)(target));
      lensProp = (key) => lens(prop(key))(assoc(key));
      view = // @ts-expect-error Argument of type '<A>(arg1: (arg2: A) => unknown) => (arg3: A) => unknown' is not assignable to parameter of type '(arg1: unknown) => (arg3: unknown) => unknown'.  Types of parameters 'arg1' and 'arg1' are incompatible.  Type 'unknown' is not assignable to type '(arg2: unknown) => unknown'.
      compose(compose(getConst))(thrush(Const));
      over = (l) => (f) => {
        const toFunctor = compose(Identity)(f);
        return compose(runIdentity)(l(toFunctor));
      };
      set = (l) => compose(over(l))(constant);
      constantNone = constant(None);
      noneToErr = (error) => maybe(Err(error))(Ok);
      okToOption = either(constantNone)(Some);
      errToOption = either(Some)(constantNone);
      tap = (unsafeFn) => (value) => {
        unsafeFn(value);
        return value;
      };
      extractBool = maybe(false)(identity);
      extractArray = maybe(emptyArray)(identity);
      extractFunctionFromOption = maybe(identity)(identity);
      extractFunctionFromResult = either(constantIdentity)(identity);
      optionToArray = maybe(
        emptyArray
      )(Array.of);
      optionOfEmptyArray = Some(emptyArray);
      traverseOptions = (f) => (xs) => xs.reduce(
        (option, x) => f(x).map(append).ap(option),
        optionOfEmptyArray
      );
      resultOfEmptyArray = Ok(emptyArray);
      traverseResults = (f) => (xs) => xs.reduce(
        (result, x) => f(x).map(append).ap(result),
        resultOfEmptyArray
      );
      resultOfEmptyObject = Ok(emptyObject);
      traverseObjectResults = (f) => (obj) => objectKeys(obj).reduce(
        // @ts-expect-error - TS2345 - Argument of type 'a | undefined' is not assignable to parameter of type 'a'.
        (result, key) => f(obj[key]).map(assoc(key)).ap(result),
        resultOfEmptyObject
      );
      mapValues = (f) => (obj) => {
        let changed = false;
        const newObj = objectKeys(obj).reduce(
          (result, key) => {
            const oldVal = obj[key];
            const newVal = f(oldVal);
            if (oldVal !== newVal) {
              changed = true;
            }
            result[key] = newVal;
            return result;
          },
          {}
        );
        return changed ? newObj : (
          // @ts-expect-error - TS2352 - Conversion of type '{ [key: string]: a; }' to type '{ [key: string]: b; }' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
          obj
        );
      };
      values = (obj) => Object.keys(obj).map((k) => obj[k]);
      entries = (obj) => {
        const keys = Object.keys(obj);
        return keys.map((key) => [key, obj[key]]);
      };
      getDeepestValues = (obj) => {
        return Object.keys(obj).flatMap(
          (k) => obj[k] && typeof obj[k] === "object" ? getDeepestValues(
            obj[k]
          ) : [obj[k]]
        );
      };
      nth = (index) => (a) => index < 0 || index >= a.length ? None : Some(a[index]);
    }
  });

  // packages/systems/users/constants/types.js
  var require_types = __commonJS({
    "packages/systems/users/constants/types.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.USYS_ACCESS_TYPES = void 0;
      var USYS_ACCESS_TYPES = {
        LOGGED_IN: "LOGGED_IN",
        ADMIN_ALWAYS_VISIBLE: "ADMIN_ALWAYS_VISIBLE"
      };
      exports.USYS_ACCESS_TYPES = USYS_ACCESS_TYPES;
    }
  });

  // packages/systems/users/constants/errorStates.js
  var require_errorStates = __commonJS({
    "packages/systems/users/constants/errorStates.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.updatePasswordErrorStates = exports.updateAccountErrorStates = exports.signUpErrorStates = exports.resetPasswordErrorStates = exports.logInErrorStates = exports.__DEPRECATED__logInErrorStates = exports.USER_FILE_UPLOAD_ERRORS = exports.UPDATE_PASSWORD_UI_ERROR_CODES = exports.UPDATE_ACCOUNT_ERROR_CODES = exports.SIGNUP_UI_ERROR_CODES = exports.SIGNUP_ERROR_CATEGORY = exports.SERVER_DATA_VALIDATION_ERRORS = exports.RESET_PASSWORD_UI_ERROR_CODES = exports.LOGIN_UI_ERROR_CODES = exports.FORM_TYPE_ERROR_PATH = exports.FORM_TOO_SMALL_ERROR_PATH = exports.FORM_TOO_LARGE_ERROR_PATH = exports.FORM_REQUIRED_ERROR_PATH = exports.FORM_GENERIC_ERROR_PATH = exports.ErrorStateToCopy = exports.ERROR_STATE = exports.ERROR_MSG_CLASS = exports.ERROR_ATTRIBUTE_PREFIX = void 0;
      var ERROR_MSG_CLASS = "user-form-error-msg";
      exports.ERROR_MSG_CLASS = ERROR_MSG_CLASS;
      var ERROR_STATE = {
        SIGNUP: "signup-error-state",
        LOGIN: "login-error-state",
        UPDATE_PASSWORD: "update-password-error-state",
        RESET_PASSWORD: "reset-password-error-state",
        ACCOUNT_UPDATE: "account-update-error-state"
      };
      exports.ERROR_STATE = ERROR_STATE;
      var ErrorStateToCopy = (errorStateType, id) => {
        if (errorStateType === "signup-error-state") {
          var _signUpErrorStates$id, _signUpErrorStates$id2;
          return (_signUpErrorStates$id = (_signUpErrorStates$id2 = signUpErrorStates[id]) === null || _signUpErrorStates$id2 === void 0 ? void 0 : _signUpErrorStates$id2.copy) !== null && _signUpErrorStates$id !== void 0 ? _signUpErrorStates$id : null;
        }
        if (errorStateType === "login-error-state") {
          var _logInErrorStates$id$, _logInErrorStates$id;
          return (_logInErrorStates$id$ = (_logInErrorStates$id = logInErrorStates[id]) === null || _logInErrorStates$id === void 0 ? void 0 : _logInErrorStates$id.copy) !== null && _logInErrorStates$id$ !== void 0 ? _logInErrorStates$id$ : null;
        }
        if (errorStateType === "update-password-error-state") {
          var _updatePasswordErrorS, _updatePasswordErrorS2;
          return (_updatePasswordErrorS = (_updatePasswordErrorS2 = updatePasswordErrorStates[id]) === null || _updatePasswordErrorS2 === void 0 ? void 0 : _updatePasswordErrorS2.copy) !== null && _updatePasswordErrorS !== void 0 ? _updatePasswordErrorS : null;
        }
        if (errorStateType === "reset-password-error-state") {
          var _resetPasswordErrorSt, _resetPasswordErrorSt2;
          return (_resetPasswordErrorSt = (_resetPasswordErrorSt2 = resetPasswordErrorStates[id]) === null || _resetPasswordErrorSt2 === void 0 ? void 0 : _resetPasswordErrorSt2.copy) !== null && _resetPasswordErrorSt !== void 0 ? _resetPasswordErrorSt : null;
        }
        if (errorStateType === "account-update-error-state") {
          var _updateAccountErrorSt, _updateAccountErrorSt2;
          return (_updateAccountErrorSt = (_updateAccountErrorSt2 = updateAccountErrorStates[id]) === null || _updateAccountErrorSt2 === void 0 ? void 0 : _updateAccountErrorSt2.copy) !== null && _updateAccountErrorSt !== void 0 ? _updateAccountErrorSt : null;
        }
        console.error(`copy for ${errorStateType} not found`);
        return null;
      };
      exports.ErrorStateToCopy = ErrorStateToCopy;
      var SERVER_DATA_VALIDATION_ERRORS = {
        RequiredError: "EmptyValue",
        MinSizeError: "MinSizeError",
        MaxSizeError: "MaxSizeError",
        ExtensionsError: "ExtensionsError",
        DefaultError: "DefaultError"
      };
      exports.SERVER_DATA_VALIDATION_ERRORS = SERVER_DATA_VALIDATION_ERRORS;
      var LOGIN_UI_ERROR_CODES = {
        GENERAL_ERROR: "GENERAL_ERROR",
        INVALID_EMAIL_OR_PASSWORD: "INVALID_EMAIL_OR_PASSWORD"
      };
      exports.LOGIN_UI_ERROR_CODES = LOGIN_UI_ERROR_CODES;
      var SIGNUP_UI_ERROR_CODES = {
        GENERAL_ERROR: "GENERAL_ERROR",
        NOT_ALLOWED: "NOT_ALLOWED",
        NOT_VERIFIED: "NOT_VERIFIED",
        EMAIL_ALREADY_EXIST: "EMAIL_ALREADY_EXIST",
        USE_INVITE_EMAIL: "USE_INVITE_EMAIL",
        INVALID_EMAIL: "INVALID_EMAIL",
        INVALID_PASSWORD: "INVALID_PASSWORD",
        EXPIRED_TOKEN: "EXPIRED_TOKEN",
        VALIDATION_FAILED: "VALIDATION_FAILED",
        REQUIRED: "REQUIRED"
      };
      exports.SIGNUP_UI_ERROR_CODES = SIGNUP_UI_ERROR_CODES;
      var ERROR_ATTRIBUTE_PREFIX = {
        SIGNUP: "wf-signup-form",
        LOGIN: "wf-login-form",
        RESET_PASSWORD: "wf-reset-pw-form",
        UPDATE_PASSWORD: "wf-update-pw-form",
        ACCOUNT_UPDATE: "wf-account-update-form"
      };
      exports.ERROR_ATTRIBUTE_PREFIX = ERROR_ATTRIBUTE_PREFIX;
      var UPDATE_PASSWORD_UI_ERROR_CODES = {
        GENERAL_ERROR: "GENERAL_ERROR",
        WEAK_PASSWORD: "WEAK_PASSWORD"
      };
      exports.UPDATE_PASSWORD_UI_ERROR_CODES = UPDATE_PASSWORD_UI_ERROR_CODES;
      var RESET_PASSWORD_UI_ERROR_CODES = {
        GENERAL_ERROR: "GENERAL_ERROR"
      };
      exports.RESET_PASSWORD_UI_ERROR_CODES = RESET_PASSWORD_UI_ERROR_CODES;
      var TOO_LARGE_ERR = "TOO_LARGE_ERROR";
      var TOO_SMALL_ERR = "TOO_SMALL_ERROR";
      var TYPE_ERR = "TYPE_ERROR";
      var GENERIC_ERR = "GENERIC_ERROR";
      var REQUIRED_ERR = "REQUIRED_ERROR";
      var USER_FILE_UPLOAD_ERRORS = {
        GENERIC: {
          id: GENERIC_ERR,
          msg: "Upload failed. Something went wrong. Please retry.",
          path: ["data", "form", GENERIC_ERR]
        },
        TOO_LARGE: {
          id: TOO_LARGE_ERR,
          msg: "Upload failed. File too large.",
          path: ["data", "form", TOO_LARGE_ERR]
        },
        TOO_SMALL: {
          id: TOO_SMALL_ERR,
          msg: "Upload failed. File too small.",
          path: ["data", "form", TOO_SMALL_ERR]
        },
        TYPE: {
          id: TYPE_ERR,
          msg: "Upload failed. Invalid file type.",
          path: ["data", "form", TYPE_ERR]
        },
        REQUIRED: {
          id: REQUIRED_ERR,
          msg: "Please upload a file.",
          path: ["data", "form", REQUIRED_ERR]
        }
      };
      exports.USER_FILE_UPLOAD_ERRORS = USER_FILE_UPLOAD_ERRORS;
      var FORM_PATH = [{
        in: "Record",
        at: "form"
      }];
      var FORM_TOO_LARGE_ERROR_PATH = [...FORM_PATH, {
        in: "Record",
        at: TOO_LARGE_ERR
      }];
      exports.FORM_TOO_LARGE_ERROR_PATH = FORM_TOO_LARGE_ERROR_PATH;
      var FORM_TOO_SMALL_ERROR_PATH = [...FORM_PATH, {
        in: "Record",
        at: TOO_SMALL_ERR
      }];
      exports.FORM_TOO_SMALL_ERROR_PATH = FORM_TOO_SMALL_ERROR_PATH;
      var FORM_TYPE_ERROR_PATH = [...FORM_PATH, {
        in: "Record",
        at: TYPE_ERR
      }];
      exports.FORM_TYPE_ERROR_PATH = FORM_TYPE_ERROR_PATH;
      var FORM_GENERIC_ERROR_PATH = [...FORM_PATH, {
        in: "Record",
        at: GENERIC_ERR
      }];
      exports.FORM_GENERIC_ERROR_PATH = FORM_GENERIC_ERROR_PATH;
      var FORM_REQUIRED_ERROR_PATH = [...FORM_PATH, {
        in: "Record",
        at: REQUIRED_ERR
      }];
      exports.FORM_REQUIRED_ERROR_PATH = FORM_REQUIRED_ERROR_PATH;
      var __DEPRECATED__logInErrorStates = {
        [LOGIN_UI_ERROR_CODES.GENERAL_ERROR]: {
          id: LOGIN_UI_ERROR_CODES.GENERAL_ERROR,
          name: "General error",
          copy: "We're having trouble logging you in. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", LOGIN_UI_ERROR_CODES.GENERAL_ERROR]
        }
      };
      exports.__DEPRECATED__logInErrorStates = __DEPRECATED__logInErrorStates;
      var logInErrorStates = {
        [LOGIN_UI_ERROR_CODES.GENERAL_ERROR]: {
          id: LOGIN_UI_ERROR_CODES.GENERAL_ERROR,
          name: "General error",
          copy: "We're having trouble logging you in. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", LOGIN_UI_ERROR_CODES.GENERAL_ERROR]
        },
        [LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD]: {
          id: LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD,
          name: "Wrong email or password",
          copy: "Invalid email or password. Please try again.",
          path: ["data", "users", LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD]
        }
      };
      exports.logInErrorStates = logInErrorStates;
      var SIGNUP_ERROR_CATEGORY = {
        GENERAL: {
          id: "GENERAL",
          label: "General Errors"
        },
        EMAIL: {
          id: "EMAIL",
          label: "Email Errors"
        },
        PASSWORD: {
          id: "PASSWORD",
          label: "Password Errors"
        },
        INVITE: {
          id: "INVITE",
          label: "Invitation Errors"
        },
        VERFIICATION: {
          id: "VERIFCATION",
          label: "Verification Errors"
        },
        VALIDATION: {
          id: "VALIDATION",
          label: "Validation Errors"
        }
      };
      exports.SIGNUP_ERROR_CATEGORY = SIGNUP_ERROR_CATEGORY;
      var signUpErrorStates = {
        [SIGNUP_UI_ERROR_CODES.GENERAL_ERROR]: {
          id: SIGNUP_UI_ERROR_CODES.GENERAL_ERROR,
          category: SIGNUP_ERROR_CATEGORY.GENERAL,
          name: "General error",
          copy: "There was an error signing you up. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.GENERAL_ERROR]
        },
        [SIGNUP_UI_ERROR_CODES.NOT_ALLOWED]: {
          id: SIGNUP_UI_ERROR_CODES.NOT_ALLOWED,
          category: SIGNUP_ERROR_CATEGORY.EMAIL,
          name: "Email not allowed",
          copy: "You're not allowed to access this site, please contact the admin for support.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.NOT_ALLOWED]
        },
        // email errors
        [SIGNUP_UI_ERROR_CODES.INVALID_EMAIL]: {
          id: SIGNUP_UI_ERROR_CODES.INVALID_EMAIL,
          category: SIGNUP_ERROR_CATEGORY.EMAIL,
          name: "Invalid email",
          copy: "Make sure your email exists and is properly formatted (e.g., user@domain.com).",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.INVALID_EMAIL]
        },
        [SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST]: {
          id: SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST,
          category: SIGNUP_ERROR_CATEGORY.EMAIL,
          name: "Email already exists",
          copy: "An account with this email address already exists. Log in or reset your password.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST]
        },
        // invitation errors
        [SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL]: {
          id: SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL,
          category: SIGNUP_ERROR_CATEGORY.INVITE,
          name: "Must use invite email",
          copy: "Use the same email address your invitation was sent to.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL]
        },
        // password errors
        [SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD]: {
          id: SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD,
          category: SIGNUP_ERROR_CATEGORY.PASSWORD,
          name: "Invalid password",
          copy: "Your password must be at least 8 characters.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD]
        },
        // verification errors
        [SIGNUP_UI_ERROR_CODES.NOT_VERIFIED]: {
          id: SIGNUP_UI_ERROR_CODES.NOT_VERIFIED,
          category: SIGNUP_ERROR_CATEGORY.VERFIICATION,
          name: "Verification failed",
          copy: "We couldn't verify your account. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.NOT_VERIFIED]
        },
        [SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN]: {
          id: SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN,
          category: SIGNUP_ERROR_CATEGORY.VERFIICATION,
          name: "Verification expired",
          copy: "This link has expired. A new link has been sent to your email. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN]
        },
        [SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED]: {
          id: SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED,
          category: SIGNUP_ERROR_CATEGORY.VALIDATION,
          name: "Validation error",
          copy: "There was an error in some of the information provided.",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED]
        },
        [SIGNUP_UI_ERROR_CODES.REQUIRED]: {
          id: SIGNUP_UI_ERROR_CODES.REQUIRED,
          category: SIGNUP_ERROR_CATEGORY.VALIDATION,
          name: "Missing information",
          copy: "Fill out all required fields",
          path: ["data", "users", SIGNUP_UI_ERROR_CODES.REQUIRED]
        }
      };
      exports.signUpErrorStates = signUpErrorStates;
      var updatePasswordErrorStates = {
        [UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR]: {
          id: UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR,
          name: "General error",
          copy: "There was an error updating your password. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR]
        },
        [UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD]: {
          id: UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD,
          name: "Weak password",
          copy: "Your password must be at least 8 characters.",
          path: ["data", "users", UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD]
        }
      };
      exports.updatePasswordErrorStates = updatePasswordErrorStates;
      var resetPasswordErrorStates = {
        [RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR]: {
          id: RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR,
          name: "General error",
          copy: "There was an error resetting your password. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR]
        }
      };
      exports.resetPasswordErrorStates = resetPasswordErrorStates;
      var UPDATE_ACCOUNT_ERROR_CODES = {
        GENERAL_ERROR: "GENERAL_ERROR"
      };
      exports.UPDATE_ACCOUNT_ERROR_CODES = UPDATE_ACCOUNT_ERROR_CODES;
      var updateAccountErrorStates = {
        [UPDATE_ACCOUNT_ERROR_CODES.GENERAL_ERROR]: {
          id: UPDATE_ACCOUNT_ERROR_CODES.GENERAL_ERROR,
          name: "General error",
          copy: "There was an error updating your account. Please try again, or contact us if you continue to have problems.",
          path: ["data", "users", UPDATE_ACCOUNT_ERROR_CODES.GENERAL_ERROR]
        }
      };
      exports.updateAccountErrorStates = updateAccountErrorStates;
    }
  });

  // packages/systems/users/constants/index.js
  var require_constants3 = __commonJS({
    "packages/systems/users/constants/index.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _exportNames = {
        RESERVED_USER_PREFIX: true,
        RESERVED_USER_FIELDS: true,
        KEY_FROM_RESERVED_USER_FIELD: true,
        NAMES_FROM_USER_FIELDS: true,
        TEXT_INPUT_TYPE_TO_FIELD_TYPE: true,
        USYS_UTILITY_KEYS: true,
        USYS_DATA_ATTRS: true,
        USYS_DOM_CLASS_NAMES: true,
        USYS_FORM_TYPES: true,
        USYS_INPUT_TYPES: true,
        USYS_INPUT_SIGN_UP_IDS: true,
        USYS_USER_STATES: true,
        USYS_PAGE_SETTINGS: true,
        USYS_RESERVED_SLUGS: true,
        USYS_PAGE_UTIL_KEYS: true,
        DEFAULT_STYLES: true,
        PASSWORD_MIN_LENGTH: true,
        PASSWORD_MAX_LENGTH: true,
        SESSION_COOKIE_NAME: true,
        LOGGEDIN_COOKIE_NAME: true,
        DEFAULT_SESSION_DURATION_IN_MS: true,
        DEFAULT_SESSION_TOKEN_DURATION_IN_MS: true,
        DEFAULT_TOKEN_AGE_MS: true,
        STARTER_MAX_NUM_USERS: true,
        BASIC_MAX_NUM_USERS: true,
        BUSINESS_MAX_NUM_USERS: true,
        ECOMM_STANDARD_MAX_NUM_USERS: true,
        ECOMM_PLUS_MAX_NUM_USERS: true,
        HARD_LIMIT_MAX_NUM_USERS: true,
        SUBSCRIPTION_USER_LIMITS: true,
        MAX_NUM_GROUPS: true,
        MIN_GROUP_ID_LENGTH: true,
        MAX_GROUP_ID_LENGTH: true,
        USYS_TOKEN_TYPES: true,
        ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG: true,
        ACCESS_GROUP_ADMISSION_TYPE: true,
        ACCESS_GROUP_FREE_TYPE: true,
        SUBSCRIPTION_EMAIL_TYPES: true,
        MEMBERSHIPS_EMAIL_KEYS: true,
        EMAIL_TEMPLATE_TYPES: true,
        CONFIRM_UNSAVED_CHANGES_COPY: true,
        USER_FIELD_FORM_ID: true,
        NEW_USER_FIELD_ID: true,
        USER_FIELD_DEFAULTS: true,
        DEFAULT_USER_FIELDS: true,
        SETUP_GUIDE_KEYS: true,
        SETUP_GUIDE_ALL_KEYS: true,
        MAX_USER_DATA_FIELDS: true,
        MAX_UPDATE_USER_DATA_FIELDS: true,
        USYS_FIELD_PATH: true,
        USYS_CONTEXT_PATH: true,
        TEMP_STATE_PATH: true,
        USER_ACCESS_META_OPTIONS: true,
        EXCEEDS_MAX_FILE_SIZE_ERROR: true,
        EXCEEDS_MAX_IMAGE_SIZE_ERROR: true,
        NO_REQUIRED_ATTRIBUTE: true,
        USER_STATUSES: true,
        USER_PAGE_SIZE: true,
        USER_CSV_IMPORT_STATUS_POLLING_INTERVAL: true,
        USER_CSV_IMPORT_STATUS_MAX_TRIES: true
      };
      exports.USYS_UTILITY_KEYS = exports.USYS_USER_STATES = exports.USYS_TOKEN_TYPES = exports.USYS_RESERVED_SLUGS = exports.USYS_PAGE_UTIL_KEYS = exports.USYS_PAGE_SETTINGS = exports.USYS_INPUT_TYPES = exports.USYS_INPUT_SIGN_UP_IDS = exports.USYS_FORM_TYPES = exports.USYS_FIELD_PATH = exports.USYS_DOM_CLASS_NAMES = exports.USYS_DATA_ATTRS = exports.USYS_CONTEXT_PATH = exports.USER_STATUSES = exports.USER_PAGE_SIZE = exports.USER_FIELD_FORM_ID = exports.USER_FIELD_DEFAULTS = exports.USER_CSV_IMPORT_STATUS_POLLING_INTERVAL = exports.USER_CSV_IMPORT_STATUS_MAX_TRIES = exports.USER_ACCESS_META_OPTIONS = exports.TEXT_INPUT_TYPE_TO_FIELD_TYPE = exports.TEMP_STATE_PATH = exports.SUBSCRIPTION_USER_LIMITS = exports.SUBSCRIPTION_EMAIL_TYPES = exports.STARTER_MAX_NUM_USERS = exports.SETUP_GUIDE_KEYS = exports.SETUP_GUIDE_ALL_KEYS = exports.SESSION_COOKIE_NAME = exports.RESERVED_USER_PREFIX = exports.RESERVED_USER_FIELDS = exports.PASSWORD_MIN_LENGTH = exports.PASSWORD_MAX_LENGTH = exports.NO_REQUIRED_ATTRIBUTE = exports.NEW_USER_FIELD_ID = exports.NAMES_FROM_USER_FIELDS = exports.MIN_GROUP_ID_LENGTH = exports.MEMBERSHIPS_EMAIL_KEYS = exports.MAX_USER_DATA_FIELDS = exports.MAX_UPDATE_USER_DATA_FIELDS = exports.MAX_NUM_GROUPS = exports.MAX_GROUP_ID_LENGTH = exports.LOGGEDIN_COOKIE_NAME = exports.KEY_FROM_RESERVED_USER_FIELD = exports.HARD_LIMIT_MAX_NUM_USERS = exports.EXCEEDS_MAX_IMAGE_SIZE_ERROR = exports.EXCEEDS_MAX_FILE_SIZE_ERROR = exports.EMAIL_TEMPLATE_TYPES = exports.ECOMM_STANDARD_MAX_NUM_USERS = exports.ECOMM_PLUS_MAX_NUM_USERS = exports.DEFAULT_USER_FIELDS = exports.DEFAULT_TOKEN_AGE_MS = exports.DEFAULT_STYLES = exports.DEFAULT_SESSION_TOKEN_DURATION_IN_MS = exports.DEFAULT_SESSION_DURATION_IN_MS = exports.CONFIRM_UNSAVED_CHANGES_COPY = exports.BUSINESS_MAX_NUM_USERS = exports.BASIC_MAX_NUM_USERS = exports.ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG = exports.ACCESS_GROUP_FREE_TYPE = exports.ACCESS_GROUP_ADMISSION_TYPE = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _utils = (init_utils2(), __toCommonJS(utils_exports));
      var _types = require_types();
      Object.keys(_types).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _types[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _types[key];
          }
        });
      });
      var _errorStates = require_errorStates();
      Object.keys(_errorStates).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _errorStates[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _errorStates[key];
          }
        });
      });
      var RESERVED_USER_PREFIX = "wf-user-field-";
      exports.RESERVED_USER_PREFIX = RESERVED_USER_PREFIX;
      var RESERVED_USER_FIELDS = {
        name: RESERVED_USER_PREFIX + "name",
        acceptPrivacy: RESERVED_USER_PREFIX + "accept-privacy",
        acceptCommunications: RESERVED_USER_PREFIX + "accept-communications"
      };
      exports.RESERVED_USER_FIELDS = RESERVED_USER_FIELDS;
      var KEY_FROM_RESERVED_USER_FIELD = {
        [RESERVED_USER_PREFIX + "name"]: "name",
        [RESERVED_USER_PREFIX + "accept-privacy"]: "acceptPrivacy",
        [RESERVED_USER_PREFIX + "accept-communications"]: "acceptCommunications"
      };
      exports.KEY_FROM_RESERVED_USER_FIELD = KEY_FROM_RESERVED_USER_FIELD;
      var NAMES_FROM_USER_FIELDS = {
        [RESERVED_USER_PREFIX + "name"]: "Name",
        [RESERVED_USER_PREFIX + "accept-privacy"]: "Accept privacy policy",
        [RESERVED_USER_PREFIX + "accept-communications"]: "Accept communications",
        PRIVACY_POLICY: "Accept privacy policy",
        PASSWORD: "Password",
        EMAIL: "Email"
      };
      exports.NAMES_FROM_USER_FIELDS = NAMES_FROM_USER_FIELDS;
      var TEXT_INPUT_TYPE_TO_FIELD_TYPE = {
        text: "PlainText",
        password: "Password",
        email: "Email",
        number: "PlainText",
        tel: "PlainText"
      };
      exports.TEXT_INPUT_TYPE_TO_FIELD_TYPE = TEXT_INPUT_TYPE_TO_FIELD_TYPE;
      var USYS_UTILITY_KEYS = {
        "usys-log-in": "usys-log-in",
        "usys-sign-up": "usys-sign-up",
        "usys-reset-password": "usys-reset-password",
        "usys-update-password": "usys-update-password",
        "usys-access-denied": "usys-access-denied",
        "usys-user-account": "usys-user-account"
      };
      exports.USYS_UTILITY_KEYS = USYS_UTILITY_KEYS;
      var USYS_DATA_ATTRS = {
        formType: "data-wf-user-form-type",
        inputType: "data-wf-user-form-input-type",
        logout: "data-wf-user-logout",
        login: "data-wf-user-login",
        formError: "data-wf-user-form-error",
        redirectUrl: "data-wf-user-form-redirect",
        formVerification: "data-wf-user-form-verification",
        userSubscriptions: "data-wf-user-subscriptions-list",
        userSubscriptionsEmptyState: "data-wf-user-subscriptions-empty",
        userAccount: "data-wf-user-account",
        subscriptionCancel: "data-wf-user-subscription-cancel",
        userId: "data-wf-user-id",
        field: "data-wf-user-field",
        fieldType: "data-wf-user-field-type",
        fileUploadKey: "data-wf-user-file-upload-key",
        unsavedFileUploadKey: "data-wf-unsaved-user-file-upload-key"
      };
      exports.USYS_DATA_ATTRS = USYS_DATA_ATTRS;
      var USYS_DOM_CLASS_NAMES = {
        formSuccess: "w-form-success",
        formVerfication: "w-form-verification",
        formError: "w-form-fail"
      };
      exports.USYS_DOM_CLASS_NAMES = USYS_DOM_CLASS_NAMES;
      var USYS_FORM_TYPES = {
        login: "login",
        signup: "signup",
        updatePassword: "updatePassword",
        resetPassword: "resetPassword",
        account: "userAccount"
      };
      exports.USYS_FORM_TYPES = USYS_FORM_TYPES;
      var USYS_INPUT_TYPES = {
        email: "email",
        name: "name",
        password: "password",
        acceptPrivacy: "accept-privacy"
      };
      exports.USYS_INPUT_TYPES = USYS_INPUT_TYPES;
      var USYS_INPUT_SIGN_UP_IDS = {
        email: "wf-sign-up-email",
        name: "wf-sign-up-name",
        password: "wf-sign-up-password",
        acceptPrivacy: "wf-sign-up-accept-privacy",
        acceptCommunications: "wf-sign-up-accept-communications"
      };
      exports.USYS_INPUT_SIGN_UP_IDS = USYS_INPUT_SIGN_UP_IDS;
      var USYS_USER_STATES = {
        loggedIn: "loggedIn",
        loggedOut: "loggedOut"
      };
      exports.USYS_USER_STATES = USYS_USER_STATES;
      var USYS_PAGE_SETTINGS = {
        login: {
          parent: null,
          sortPos: 0,
          utilKey: "usys-log-in",
          slug: "log-in",
          title: "Log In"
        },
        signup: {
          parent: null,
          sortPos: 1,
          utilKey: "usys-sign-up",
          slug: "sign-up",
          title: "Sign Up"
        },
        resetPassword: {
          parent: null,
          sortPos: 2,
          utilKey: "usys-reset-password",
          slug: "reset-password",
          title: "Reset Password"
        },
        updatePassword: {
          parent: null,
          sortPos: 3,
          utilKey: "usys-update-password",
          slug: "update-password",
          title: "Update Password"
        },
        accessDenied: {
          parent: null,
          sortPos: 4,
          utilKey: "usys-access-denied",
          slug: "access-denied",
          title: "Access Denied"
        },
        userAccount: {
          parent: null,
          sortPos: 5,
          utilKey: "usys-user-account",
          slug: "user-account",
          title: "User Account"
        }
      };
      exports.USYS_PAGE_SETTINGS = USYS_PAGE_SETTINGS;
      var USYS_RESERVED_SLUGS = (0, _utils.values)(USYS_PAGE_SETTINGS).map((pageSettings) => pageSettings.slug);
      exports.USYS_RESERVED_SLUGS = USYS_RESERVED_SLUGS;
      var USYS_PAGE_UTIL_KEYS = (0, _utils.values)(USYS_PAGE_SETTINGS).map((pageSettings) => pageSettings.utilKey);
      exports.USYS_PAGE_UTIL_KEYS = USYS_PAGE_UTIL_KEYS;
      var DEFAULT_STYLES = {
        accentColor: "#468EE5",
        bgColor: "#F5F6F7",
        includeWfBrand: true
      };
      exports.DEFAULT_STYLES = DEFAULT_STYLES;
      var PASSWORD_MIN_LENGTH = 8;
      exports.PASSWORD_MIN_LENGTH = PASSWORD_MIN_LENGTH;
      var PASSWORD_MAX_LENGTH = 72;
      exports.PASSWORD_MAX_LENGTH = PASSWORD_MAX_LENGTH;
      var SECOND2 = 1e3;
      var MINUTE2 = 60 * SECOND2;
      var HOUR2 = 60 * MINUTE2;
      var DAY2 = 24 * HOUR2;
      var SESSION_COOKIE_NAME = "wf_sid";
      exports.SESSION_COOKIE_NAME = SESSION_COOKIE_NAME;
      var LOGGEDIN_COOKIE_NAME = "wf_loggedin";
      exports.LOGGEDIN_COOKIE_NAME = LOGGEDIN_COOKIE_NAME;
      var DEFAULT_SESSION_DURATION_IN_MS = 7 * DAY2;
      exports.DEFAULT_SESSION_DURATION_IN_MS = DEFAULT_SESSION_DURATION_IN_MS;
      var DEFAULT_SESSION_TOKEN_DURATION_IN_MS = 4 * HOUR2;
      exports.DEFAULT_SESSION_TOKEN_DURATION_IN_MS = DEFAULT_SESSION_TOKEN_DURATION_IN_MS;
      var DEFAULT_TOKEN_AGE_MS = HOUR2;
      exports.DEFAULT_TOKEN_AGE_MS = DEFAULT_TOKEN_AGE_MS;
      var STARTER_MAX_NUM_USERS = 100;
      exports.STARTER_MAX_NUM_USERS = STARTER_MAX_NUM_USERS;
      var BASIC_MAX_NUM_USERS = 2e4;
      exports.BASIC_MAX_NUM_USERS = BASIC_MAX_NUM_USERS;
      var BUSINESS_MAX_NUM_USERS = 2e4;
      exports.BUSINESS_MAX_NUM_USERS = BUSINESS_MAX_NUM_USERS;
      var ECOMM_STANDARD_MAX_NUM_USERS = 2e4;
      exports.ECOMM_STANDARD_MAX_NUM_USERS = ECOMM_STANDARD_MAX_NUM_USERS;
      var ECOMM_PLUS_MAX_NUM_USERS = 2e4;
      exports.ECOMM_PLUS_MAX_NUM_USERS = ECOMM_PLUS_MAX_NUM_USERS;
      var HARD_LIMIT_MAX_NUM_USERS = 100 * 1e3;
      exports.HARD_LIMIT_MAX_NUM_USERS = HARD_LIMIT_MAX_NUM_USERS;
      var SUBSCRIPTION_USER_LIMITS = {
        free: STARTER_MAX_NUM_USERS,
        static: BASIC_MAX_NUM_USERS,
        cms: BUSINESS_MAX_NUM_USERS,
        business: BUSINESS_MAX_NUM_USERS,
        ecommerce_standard: ECOMM_STANDARD_MAX_NUM_USERS,
        ecommerce_plus: ECOMM_PLUS_MAX_NUM_USERS,
        ecommerce_advanced: BUSINESS_MAX_NUM_USERS,
        enterprise: BUSINESS_MAX_NUM_USERS,
        enterprise_lite: BUSINESS_MAX_NUM_USERS
      };
      exports.SUBSCRIPTION_USER_LIMITS = SUBSCRIPTION_USER_LIMITS;
      var MAX_NUM_GROUPS = 20;
      exports.MAX_NUM_GROUPS = MAX_NUM_GROUPS;
      var MIN_GROUP_ID_LENGTH = 2;
      exports.MIN_GROUP_ID_LENGTH = MIN_GROUP_ID_LENGTH;
      var MAX_GROUP_ID_LENGTH = 2;
      exports.MAX_GROUP_ID_LENGTH = MAX_GROUP_ID_LENGTH;
      var USYS_TOKEN_TYPES = {
        inviteUser: "inviteUser",
        resetPassword: "resetPassword",
        verifyEmail: "verifyEmail"
      };
      exports.USYS_TOKEN_TYPES = USYS_TOKEN_TYPES;
      var ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG = "access-group-membership-product";
      exports.ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG = ACCESS_GROUP_INLINE_PRODUCT_FIELD_SLUG;
      var ACCESS_GROUP_ADMISSION_TYPE = {
        free: "free",
        paid: "paid"
      };
      exports.ACCESS_GROUP_ADMISSION_TYPE = ACCESS_GROUP_ADMISSION_TYPE;
      var ACCESS_GROUP_FREE_TYPE = {
        all: "all",
        admin: "admin"
      };
      exports.ACCESS_GROUP_FREE_TYPE = ACCESS_GROUP_FREE_TYPE;
      var SUBSCRIPTION_EMAIL_TYPES = {
        PAYMENT_FAILED: "paymentFailed",
        PAYMENT_SUCCESSFUL: "paymentSuccessful",
        SUBSCRIPTION_CANCELED: "subscriptionCanceled",
        VERIFY_PAYMENT: "verifyPayment"
      };
      exports.SUBSCRIPTION_EMAIL_TYPES = SUBSCRIPTION_EMAIL_TYPES;
      var MEMBERSHIPS_EMAIL_KEYS = {
        invite: "invite",
        resetPassword: "resetPassword",
        updatedPassword: "updatedPassword",
        welcome: "welcome",
        verify: "verify"
      };
      exports.MEMBERSHIPS_EMAIL_KEYS = MEMBERSHIPS_EMAIL_KEYS;
      var EMAIL_TEMPLATE_TYPES = {
        invite: "MEMBERSHIPS_INVITE",
        resetPassword: "MEMBERSHIPS_RESET_PASSWORD",
        updatedPassword: "MEMBERSHIPS_UPDATED_PASSWORD",
        verify: "MEMBERSHIPS_VERIFY",
        welcome: "MEMBERSHIPS_WELCOME"
      };
      exports.EMAIL_TEMPLATE_TYPES = EMAIL_TEMPLATE_TYPES;
      var CONFIRM_UNSAVED_CHANGES_COPY = {
        title: "Continue without saving?",
        content: "Your changes will be lost.",
        iconType: "warning",
        submit: {
          label: "Continue",
          intent: "danger"
        },
        cancel: {
          label: "Cancel",
          intent: "default"
        }
      };
      exports.CONFIRM_UNSAVED_CHANGES_COPY = CONFIRM_UNSAVED_CHANGES_COPY;
      var USER_FIELD_FORM_ID = "UserFieldForm";
      exports.USER_FIELD_FORM_ID = USER_FIELD_FORM_ID;
      var NEW_USER_FIELD_ID = "mint-user-field";
      exports.NEW_USER_FIELD_ID = NEW_USER_FIELD_ID;
      var USER_FIELD_DEFAULTS = {
        PlainText: {
          id: NEW_USER_FIELD_ID,
          name: "",
          slug: "",
          required: false,
          type: "PlainText",
          validations: {}
        },
        Email: {
          id: NEW_USER_FIELD_ID,
          name: "",
          slug: "",
          required: false,
          type: "Email",
          validations: {}
        },
        Bool: {
          id: NEW_USER_FIELD_ID,
          name: "",
          slug: "",
          required: false,
          type: "Bool",
          validations: {}
        },
        FileRef: {
          id: NEW_USER_FIELD_ID,
          name: "",
          slug: "",
          required: false,
          type: "FileRef",
          validations: {}
        },
        Option: {
          id: NEW_USER_FIELD_ID,
          name: "",
          slug: "",
          required: false,
          type: "Option",
          validations: {
            options: []
          }
        },
        Password: {
          id: NEW_USER_FIELD_ID,
          name: "Password",
          slug: "",
          required: true,
          type: "Password",
          validations: {}
        },
        Number: {
          id: NEW_USER_FIELD_ID,
          name: "",
          slug: "",
          required: false,
          type: "Number",
          validations: {
            min: 0,
            step: 1
          }
        },
        Link: {
          id: NEW_USER_FIELD_ID,
          name: "",
          slug: "",
          required: false,
          type: "Link",
          validations: {}
        }
      };
      exports.USER_FIELD_DEFAULTS = USER_FIELD_DEFAULTS;
      var DEFAULT_USER_FIELDS = [{
        id: "name",
        name: "Name",
        required: false,
        slug: "name",
        type: "PlainText",
        validations: {}
      }, {
        id: "email",
        name: "Email",
        required: true,
        slug: "email",
        type: "Email",
        validations: {}
      }, {
        id: "password",
        name: "Password",
        required: true,
        slug: "password",
        type: "Password",
        validations: {}
      }, {
        id: "acceptPrivacy",
        name: "Accept privacy",
        required: false,
        slug: "accept-privacy",
        type: "Bool",
        validations: {}
      }, {
        id: "acceptCommunications",
        name: "Accept communications",
        required: false,
        slug: "accept-communications",
        type: "Bool",
        validations: {}
      }];
      exports.DEFAULT_USER_FIELDS = DEFAULT_USER_FIELDS;
      var SETUP_GUIDE_KEYS = {
        hasVisitedAccessDeniedPage: "hasVisitedAccessDeniedPage",
        hasVisitedLoginPage: "hasVisitedLoginPage",
        hasVisitedSignUpPage: "hasVisitedSignUpPage",
        hasVisitedUserAccountSettings: "hasVisitedUserAccountSettings",
        hasVisitedUserAccountPage: "hasVisitedUserAccountPage"
      };
      exports.SETUP_GUIDE_KEYS = SETUP_GUIDE_KEYS;
      var SETUP_GUIDE_ALL_KEYS = (0, _extends2.default)({}, SETUP_GUIDE_KEYS, {
        hasHostingPlan: "hasHostingPlan",
        hasEcommerce: "hasEcommerce",
        hasEnabledSSL: "hasEnabledSSL",
        hasUsers: "hasUsers",
        hasAccessGroups: "hasAccessGroups",
        hasRestrictedContent: "hasRestrictedContent",
        hasRestrictedProducts: "hasRestrictedProducts"
      });
      exports.SETUP_GUIDE_ALL_KEYS = SETUP_GUIDE_ALL_KEYS;
      var MAX_USER_DATA_FIELDS = 20;
      exports.MAX_USER_DATA_FIELDS = MAX_USER_DATA_FIELDS;
      var MAX_UPDATE_USER_DATA_FIELDS = MAX_USER_DATA_FIELDS + 2;
      exports.MAX_UPDATE_USER_DATA_FIELDS = MAX_UPDATE_USER_DATA_FIELDS;
      var USYS_FIELD_PATH = [{
        in: "Record",
        at: "users"
      }, {
        in: "Record",
        at: "field"
      }];
      exports.USYS_FIELD_PATH = USYS_FIELD_PATH;
      var USYS_CONTEXT_PATH = [{
        in: "Record",
        at: "users"
      }, {
        in: "Record",
        at: "context"
      }];
      exports.USYS_CONTEXT_PATH = USYS_CONTEXT_PATH;
      var TEMP_PATH = [{
        in: "Record",
        at: "temp"
      }];
      var TEMP_STATE_PATH = [...TEMP_PATH, {
        in: "Record",
        at: "state"
      }];
      exports.TEMP_STATE_PATH = TEMP_STATE_PATH;
      var USER_ACCESS_META_OPTIONS = [_types.USYS_ACCESS_TYPES.LOGGED_IN];
      exports.USER_ACCESS_META_OPTIONS = USER_ACCESS_META_OPTIONS;
      var EXCEEDS_MAX_FILE_SIZE_ERROR = "Maximum size allowed for a file upload is 10000kb / 10mb.";
      exports.EXCEEDS_MAX_FILE_SIZE_ERROR = EXCEEDS_MAX_FILE_SIZE_ERROR;
      var EXCEEDS_MAX_IMAGE_SIZE_ERROR = "Maximum size allowed for a image upload is 4000kb / 4mb.";
      exports.EXCEEDS_MAX_IMAGE_SIZE_ERROR = EXCEEDS_MAX_IMAGE_SIZE_ERROR;
      var NO_REQUIRED_ATTRIBUTE = ["FileRef", "Bool"];
      exports.NO_REQUIRED_ATTRIBUTE = NO_REQUIRED_ATTRIBUTE;
      var USER_STATUSES = {
        invited: "Invited",
        verified: "Verified",
        unverified: "Unverified"
      };
      exports.USER_STATUSES = USER_STATUSES;
      var USER_PAGE_SIZE = 100;
      exports.USER_PAGE_SIZE = USER_PAGE_SIZE;
      var USER_CSV_IMPORT_STATUS_POLLING_TIMEOUT = 20 * 60 * 1e3;
      var USER_CSV_IMPORT_STATUS_POLLING_INTERVAL = 5e3;
      exports.USER_CSV_IMPORT_STATUS_POLLING_INTERVAL = USER_CSV_IMPORT_STATUS_POLLING_INTERVAL;
      var USER_CSV_IMPORT_STATUS_MAX_TRIES = Math.floor(USER_CSV_IMPORT_STATUS_POLLING_TIMEOUT / USER_CSV_IMPORT_STATUS_POLLING_INTERVAL);
      exports.USER_CSV_IMPORT_STATUS_MAX_TRIES = USER_CSV_IMPORT_STATUS_MAX_TRIES;
    }
  });

  // packages/systems/dynamo/constants/index.ts
  var constants_exports = {};
  __export(constants_exports, {
    CLASS_NAME_W_DYN_BIND_EMPTY: () => CLASS_NAME_W_DYN_BIND_EMPTY,
    COLLECTION_TYPES: () => COLLECTION_TYPES,
    CONDITION_INVISIBLE_CLASS: () => CONDITION_INVISIBLE_CLASS,
    DATETIME_FORMAT_OPTIONS: () => DATETIME_FORMAT_OPTIONS,
    DATE_FORMAT_OPTIONS: () => DATE_FORMAT_OPTIONS,
    DEFAULT_COLLECTION_LIMIT: () => DEFAULT_COLLECTION_LIMIT,
    DEFAULT_NESTED_COLLECTION_LIMIT: () => DEFAULT_NESTED_COLLECTION_LIMIT,
    DYNAMIC_CONTENT_COMPLEXITY_LIMIT: () => DYNAMIC_CONTENT_COMPLEXITY_LIMIT,
    FUTURE: () => FUTURE,
    MAX_COLLECTION_LIST_LIMIT: () => MAX_COLLECTION_LIST_LIMIT,
    MAX_NESTED_COLLECTION_LIST_LIMIT: () => MAX_NESTED_COLLECTION_LIST_LIMIT,
    MIN_COLLECTION_LIST_OFFSET: () => MIN_COLLECTION_LIST_OFFSET,
    NON_EXISTING_ITEM_ID: () => NON_EXISTING_ITEM_ID,
    PAST: () => PAST,
    QUERY_FILTER_FOR_STATES: () => QUERY_FILTER_FOR_STATES,
    SCHEDULED_PUBLISH_GRACE_PERIOD_IN_MS: () => SCHEDULED_PUBLISH_GRACE_PERIOD_IN_MS,
    SCHEDULED_PUBLISH_GRANULARITY_IN_MIN: () => SCHEDULED_PUBLISH_GRANULARITY_IN_MIN,
    SCHEDULED_PUBLISH_LIMIT_IN_MS: () => SCHEDULED_PUBLISH_LIMIT_IN_MS,
    SET_FIELD_MAX_ITEMS: () => SET_FIELD_MAX_ITEMS,
    SHARED_ALLOWED_FIELD_TYPES: () => SHARED_ALLOWED_FIELD_TYPES,
    TENSES_ENUM: () => TENSES_ENUM,
    TENSES_TO_HUMAN_PHRASES_MAP: () => TENSES_TO_HUMAN_PHRASES_MAP,
    TIME_INTERVALS_ENUM: () => TIME_INTERVALS_ENUM
  });
  var SECOND, MINUTE, HOUR, DAY, YEAR, TIME_INTERVALS_ENUM, FUTURE, PAST, TENSES_ENUM, TENSES_TO_HUMAN_PHRASES_MAP, CLASS_NAME_W_DYN_BIND_EMPTY, CONDITION_INVISIBLE_CLASS, NON_EXISTING_ITEM_ID, QUERY_FILTER_FOR_STATES, SET_FIELD_MAX_ITEMS, SCHEDULED_PUBLISH_GRANULARITY_IN_MIN, SCHEDULED_PUBLISH_LIMIT_IN_MS, SCHEDULED_PUBLISH_GRACE_PERIOD_IN_MS, COLLECTION_TYPES, DEFAULT_NESTED_COLLECTION_LIMIT, DEFAULT_COLLECTION_LIMIT, DYNAMIC_CONTENT_COMPLEXITY_LIMIT, MAX_COLLECTION_LIST_LIMIT, MAX_NESTED_COLLECTION_LIST_LIMIT, MIN_COLLECTION_LIST_OFFSET, SHARED_ALLOWED_FIELD_TYPES, DATETIME_FORMAT_OPTIONS, DATE_FORMAT_OPTIONS;
  var init_constants = __esm({
    "packages/systems/dynamo/constants/index.ts"() {
      SECOND = 1e3;
      MINUTE = 60 * SECOND;
      HOUR = 60 * MINUTE;
      DAY = 24 * HOUR;
      YEAR = 365 * DAY;
      TIME_INTERVALS_ENUM = {
        days: "days",
        weeks: "weeks",
        months: "months",
        years: "years"
      };
      FUTURE = "FUTURE";
      PAST = "PAST";
      TENSES_ENUM = {
        FUTURE,
        PAST
      };
      TENSES_TO_HUMAN_PHRASES_MAP = {
        FUTURE: "in the future",
        PAST: "in the past"
      };
      CLASS_NAME_W_DYN_BIND_EMPTY = "w-dyn-bind-empty";
      CONDITION_INVISIBLE_CLASS = "w-condition-invisible";
      NON_EXISTING_ITEM_ID = "000000000000000000000000";
      QUERY_FILTER_FOR_STATES = {
        ALL: "ALL",
        ANY: "ANY"
      };
      SET_FIELD_MAX_ITEMS = 25;
      SCHEDULED_PUBLISH_GRANULARITY_IN_MIN = 5;
      SCHEDULED_PUBLISH_LIMIT_IN_MS = 5 * YEAR;
      SCHEDULED_PUBLISH_GRACE_PERIOD_IN_MS = 30 * MINUTE;
      COLLECTION_TYPES = {
        CATEGORIES: "CATEGORIES",
        CMS_COLLECTIONS: "CMS_COLLECTIONS",
        PRODUCTS: "PRODUCTS",
        SKUS: "SKUS"
      };
      DEFAULT_NESTED_COLLECTION_LIMIT = 5;
      DEFAULT_COLLECTION_LIMIT = 100;
      DYNAMIC_CONTENT_COMPLEXITY_LIMIT = 2400;
      MAX_COLLECTION_LIST_LIMIT = DEFAULT_COLLECTION_LIMIT;
      MAX_NESTED_COLLECTION_LIST_LIMIT = DEFAULT_NESTED_COLLECTION_LIMIT;
      MIN_COLLECTION_LIST_OFFSET = 0;
      SHARED_ALLOWED_FIELD_TYPES = {
        innerHTML: {
          PlainText: "innerText",
          HighlightedText: "innerText",
          RichText: "innerHTML",
          Number: "innerText",
          Video: "innerHTML",
          Option: "innerText",
          Date: "innerText",
          Phone: "innerText",
          Email: "innerText",
          CommercePrice: "innerHTML",
          Link: "innerText",
          ImageRef: false,
          FileRef: false,
          ItemRef: false,
          CommercePropValues: "innerText"
        },
        "style.color": {
          Color: true
        },
        "style.background-color": {
          Color: true
        },
        "style.border-color": {
          Color: true
        },
        "style.background-image": {
          ImageRef: true
        },
        src: ["ImageRef"],
        alt: [
          "PlainText",
          "Option",
          "Number",
          "Date",
          "Phone",
          "Email",
          "Video",
          "Link"
        ],
        href: ["Phone", "Email", "Video", "Link", "FileRef"],
        id: ["PlainText"],
        for: ["PlainText"],
        value: ["Number", "PlainText"],
        checked: ["Bool"],
        dataWHref: ["PlainText", "FullSlug"]
      };
      DATETIME_FORMAT_OPTIONS = [
        "MMMM D, YYYY",
        "MMMM D, YYYY h:mm A",
        "MMMM D, YYYY H:mm",
        "MMM D, YYYY",
        "MMM D, YYYY h:mm A",
        "MMM D, YYYY H:mm",
        "dddd, MMMM D, YYYY",
        "M/D/YYYY",
        "M.D.YYYY",
        "D/M/YYYY",
        "D.M.YYYY",
        "M/D/YYYY h:mm A",
        "M/D/YYYY H:mm",
        "M.D.YYYY h:mm A",
        "M.D.YYYY H:mm",
        "D/M/YYYY h:mm A",
        "D/M/YYYY H:mm",
        "D.M.YYYY h:mm A",
        "D.M.YYYY H:mm",
        "M/D/YY",
        "M.D.YY",
        "D/M/YY",
        "D.M.YY",
        "M/D/YY h:mm a",
        "M/D/YY H:mm",
        "M.D.YY h:mm a",
        "M.D.YY H:mm",
        "D/M/YY h:mm a",
        "D/M/YY H:mm",
        "D.M.YY h:mm a",
        "D.M.YY H:mm",
        "YYYY-MM-DD",
        "YYYY-MM-DD h:mm a",
        "YYYY-MM-DD H:mm",
        "MMM D",
        "D MMM",
        "MMMM YYYY",
        "MMM YYYY",
        "MM/YYYY",
        "h:mm a",
        "H:mm",
        "D",
        "DD",
        "ddd",
        "dddd",
        "M",
        "MM",
        "MMM",
        "MMMM",
        "YY",
        "YYYY"
      ];
      DATE_FORMAT_OPTIONS = DATETIME_FORMAT_OPTIONS.filter(
        (format) => !/[hHmaA]/.test(format)
      );
    }
  });

  // packages/shared/render/plugins/Dynamo/constants.js
  var require_constants4 = __commonJS({
    "packages/shared/render/plugins/Dynamo/constants.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getColumnNumberClassName = exports.CLASS_NAME_DYNAMIC_WRAPPER = exports.CLASS_NAME_DYNAMIC_LIST_ROW = exports.CLASS_NAME_DYNAMIC_LIST_REPEATER_REF = exports.CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM = exports.CLASS_NAME_DYNAMIC_LIST_ITEM = exports.CLASS_NAME_DYNAMIC_LIST_COLUMN = exports.CLASS_NAME_DYNAMIC_LIST = void 0;
      var CLASS_NAME_DYNAMIC_WRAPPER = "w-dyn-list";
      exports.CLASS_NAME_DYNAMIC_WRAPPER = CLASS_NAME_DYNAMIC_WRAPPER;
      var CLASS_NAME_DYNAMIC_LIST = "w-dyn-items";
      exports.CLASS_NAME_DYNAMIC_LIST = CLASS_NAME_DYNAMIC_LIST;
      var CLASS_NAME_DYNAMIC_LIST_REPEATER_REF = "w-dyn-items-repeater-ref";
      exports.CLASS_NAME_DYNAMIC_LIST_REPEATER_REF = CLASS_NAME_DYNAMIC_LIST_REPEATER_REF;
      var CLASS_NAME_DYNAMIC_LIST_ITEM = "w-dyn-item";
      exports.CLASS_NAME_DYNAMIC_LIST_ITEM = CLASS_NAME_DYNAMIC_LIST_ITEM;
      var CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM = "w-dyn-repeater-item";
      exports.CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM = CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM;
      var CLASS_NAME_DYNAMIC_LIST_ROW = "w-row";
      exports.CLASS_NAME_DYNAMIC_LIST_ROW = CLASS_NAME_DYNAMIC_LIST_ROW;
      var CLASS_NAME_DYNAMIC_LIST_COLUMN = "w-col";
      exports.CLASS_NAME_DYNAMIC_LIST_COLUMN = CLASS_NAME_DYNAMIC_LIST_COLUMN;
      var getColumnNumberClassName = (cols) => `w-col-${cols}`;
      exports.getColumnNumberClassName = getColumnNumberClassName;
    }
  });

  // packages/shared/render/plugins/Lightbox/utils.js
  var require_utils = __commonJS({
    "packages/shared/render/plugins/Lightbox/utils.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.createJsonFromBoundMedia = void 0;
      var createJsonItemFromBoundMedia = (binding) => {
        if (binding) {
          if (binding.metadata) {
            const {
              html,
              height,
              width,
              thumbnail_url: thumbnailUrl
            } = binding.metadata;
            return {
              url: binding.url,
              html,
              height,
              width,
              thumbnailUrl,
              type: "video"
            };
          } else {
            return {
              url: binding.url,
              type: "image"
            };
          }
        }
        return null;
      };
      var createJsonFromBoundMedia = (binding, nodeJsonData) => {
        const jsonItem = createJsonItemFromBoundMedia(binding);
        return jsonItem !== null ? {
          items: [jsonItem],
          group: nodeJsonData ? nodeJsonData.group : void 0
        } : null;
      };
      exports.createJsonFromBoundMedia = createJsonFromBoundMedia;
    }
  });

  // packages/shared/site/utils/Commerce.js
  var require_Commerce = __commonJS({
    "packages/shared/site/utils/Commerce.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.simplifySkuValues = exports.getProductOptionValueName = void 0;
      var simplifySkuValues = (skuValues) => skuValues.reduce((acc, pair) => {
        acc[pair.property.id] = pair.value.id;
        return acc;
      }, {});
      exports.simplifySkuValues = simplifySkuValues;
      var getProductOptionValueName = (property, simplifiedSkuValues) => {
        if (property.id && property.enum) {
          const propValueId = simplifiedSkuValues[property.id];
          const propValue = property.enum.find((value) => value.id === propValueId);
          if (propValue && typeof propValue.name === "string") {
            return propValue.name;
          }
        }
        return "";
      };
      exports.getProductOptionValueName = getProductOptionValueName;
    }
  });

  // packages/shared/site/index.js
  var require_site = __commonJS({
    "packages/shared/site/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _Commerce = require_Commerce();
      Object.keys(_Commerce).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports && exports[key] === _Commerce[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _Commerce[key];
          }
        });
      });
    }
  });

  // packages/shared/render/plugins/Commerce/modules/commerceUtils.js
  var require_commerceUtils = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/commerceUtils.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.triggerRender = exports.trackOrder = exports.showElement = exports.setElementLoading = exports.safeParseJson = exports.isProtocolHttps = exports.isProductionLikeEnv = exports.isFreeOrder = exports.hideElement = exports.hasSubscription = exports.formToObject = exports.findElementByNodeType = exports.findClosestElementWithAttribute = exports.findClosestElementByNodeType = exports.findClosestElementByClassName = exports.findAllElementsByNodeType = exports.fetchOrderStatusFlags = exports.executeLoadingCallbacks = exports.customDataFormToArray = exports.addLoadingCallback = void 0;
      var _apolloClient = _interopRequireDefault(require_bundle_umd5());
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var _constants = require_constants2();
      var safeParseJson = (jsonString) => {
        let json = null;
        try {
          if (jsonString != null) {
            json = JSON.parse(decodeURIComponent(jsonString));
          }
        } catch (e) {
          if (!(e instanceof SyntaxError && e.message.match(/\bJSON\b/i))) {
            throw e;
          }
        } finally {
          return json;
        }
      };
      exports.safeParseJson = safeParseJson;
      var findElementByNodeType = (type, scope = document) => {
        return scope.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${type}"]`);
      };
      exports.findElementByNodeType = findElementByNodeType;
      var findAllElementsByNodeType = (type, scope = document) => {
        return Array.from(scope.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${type}"]`));
      };
      exports.findAllElementsByNodeType = findAllElementsByNodeType;
      var findClosestElementByNodeType = (nodeType, element) => {
        let target = element;
        while (target) {
          if (target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === nodeType) {
            return target;
          } else {
            target = target instanceof Element ? target.parentElement : null;
          }
        }
        return target;
      };
      exports.findClosestElementByNodeType = findClosestElementByNodeType;
      var findClosestElementWithAttribute = (dataAttribute, element) => {
        let target = element;
        while (target) {
          if (target instanceof Element && target.hasAttribute(dataAttribute)) {
            return target;
          } else {
            target = target instanceof Element ? target.parentElement : null;
          }
        }
        return target;
      };
      exports.findClosestElementWithAttribute = findClosestElementWithAttribute;
      var findClosestElementByClassName = (className, element) => {
        let target = element;
        while (target) {
          if (target instanceof Element && target.classList.contains(className)) {
            return target;
          } else {
            target = target instanceof Element ? target.parentElement : null;
          }
        }
        return target;
      };
      exports.findClosestElementByClassName = findClosestElementByClassName;
      var triggerRender = (error, isInitial = false) => {
        const renderEvent = new CustomEvent(_constants.RENDER_TREE_EVENT, {
          detail: {
            error,
            isInitial
          }
        });
        window.dispatchEvent(renderEvent);
      };
      exports.triggerRender = triggerRender;
      var isProductionLikeEnv = () => true;
      exports.isProductionLikeEnv = isProductionLikeEnv;
      var isProtocolHttps = () => !isProductionLikeEnv() || window.location.protocol === "https:";
      exports.isProtocolHttps = isProtocolHttps;
      var formToObject = (form, toString4) => {
        const values2 = {};
        Array.from(form.elements).forEach((element) => {
          const name = element.getAttribute("name");
          if (name && name !== "") {
            const value = toString4 ? String(element.value).trim() : element.value;
            values2[name] = value == null || value === "" ? null : value;
          }
        });
        return values2;
      };
      exports.formToObject = formToObject;
      var customDataFormToArray = (form) => {
        const customData = [];
        if (!form || !(form instanceof HTMLFormElement)) {
          return customData;
        }
        Array.from(form.elements).forEach((element) => {
          const name = element.getAttribute("name");
          if (element instanceof HTMLTextAreaElement && element.value) {
            customData.push({
              name: name ? name : "Textarea",
              textArea: element.value
            });
          } else if (element instanceof HTMLInputElement) {
            if (element.type === "checkbox") {
              customData.push({
                name: name ? name : "Checkbox",
                checkbox: element.checked
              });
            } else if (element.value) {
              customData.push({
                name: name ? name : "Text Input",
                textInput: element.value
              });
            }
          }
        });
        return customData;
      };
      exports.customDataFormToArray = customDataFormToArray;
      var setElementLoading = (el) => {
        const tr = window.Webflow.tram(el);
        tr.set({
          opacity: 0.2
        });
        tr.add("opacity 500ms ease-in-out");
        const animate = () => {
          tr.start({
            opacity: 0.2
          }).then({
            opacity: 0.4
          }).then(animate);
        };
        animate();
        return () => tr.destroy();
      };
      exports.setElementLoading = setElementLoading;
      var loadingCallbacks = [];
      var addLoadingCallback = (cb) => {
        loadingCallbacks.push(cb);
      };
      exports.addLoadingCallback = addLoadingCallback;
      var executeLoadingCallbacks = () => {
        let finishLoading;
        while ((finishLoading = loadingCallbacks.shift()) !== void 0) {
          finishLoading();
        }
      };
      exports.executeLoadingCallbacks = executeLoadingCallbacks;
      var isFreeOrder = (response) => response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.statusFlags && response.data.database.commerceOrder.statusFlags.isFreeOrder === true;
      exports.isFreeOrder = isFreeOrder;
      var hasSubscription = (response) => response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.statusFlags && response.data.database.commerceOrder.statusFlags.hasSubscription === true;
      exports.hasSubscription = hasSubscription;
      var showElement = (element) => element.style.removeProperty("display");
      exports.showElement = showElement;
      var hideElement = (element) => element.style.setProperty("display", "none");
      exports.hideElement = hideElement;
      var orderStatusFlagsQuery = (0, _graphqlTag.default)`
  query FetchCartInfo {
    database @client {
      id
      commerceOrder {
        statusFlags {
          requiresShipping
          isFreeOrder
          hasSubscription
        }
      }
    }
  }
`;
      var fetchOrderStatusFlags = (apolloClient) => apolloClient.query({
        query: orderStatusFlagsQuery
      }).then((data) => {
        return data && data.data && data.data.database && data.data.database.commerceOrder && data.data.database.commerceOrder.statusFlags;
      });
      exports.fetchOrderStatusFlags = fetchOrderStatusFlags;
      var acceptedOrderDataQuery = (0, _graphqlTag.default)`
  query FetchAcceptedOrderData(
    $finalizedOrder: commerce_order_finalized_order_args
  ) {
    database {
      id
      commerceOrder(finalizedOrder: $finalizedOrder) {
        id
        total {
          decimalValue
          unit
        }
        userItems {
          count
          product {
            f_name_
          }
          sku {
            id
          }
          price {
            decimalValue
          }
        }
      }
    }
  }
`;
      var fetchAcceptedOrderData = (apolloClient, finalizedOrder) => apolloClient.query({
        query: acceptedOrderDataQuery,
        variables: {
          finalizedOrder
        }
      }).then((data) => {
        var _data$data, _data$data$database;
        return data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : (_data$data$database = _data$data.database) === null || _data$data$database === void 0 ? void 0 : _data$data$database.commerceOrder;
      });
      var trackOrder = (apolloClient, finalizedOrder) => {
        if (typeof fbq === "undefined" && typeof gtag === "undefined") {
          return;
        }
        let trackedOrders = {};
        try {
          const storedTrackedOrders = window.localStorage.getItem("wf-seen-orders");
          if (storedTrackedOrders) {
            trackedOrders = JSON.parse(storedTrackedOrders);
          }
        } catch (err) {
          return;
        }
        if (trackedOrders[finalizedOrder.orderId]) {
          return;
        }
        fetchAcceptedOrderData(apolloClient, finalizedOrder).then((order) => {
          if (!order) {
            return;
          }
          const {
            decimalValue,
            unit
          } = order.total;
          if (typeof fbq !== "undefined" && typeof fbq === "function") {
            fbq("track", "Purchase", {
              value: decimalValue,
              currency: unit,
              content_ids: (order.userItems || []).map((item) => item.sku.id),
              content_type: "product",
              contents: (order.userItems || []).map((item) => ({
                id: item.sku.id,
                quantity: item.count,
                item_price: item.price.decimalValue
              }))
            });
          }
          if (typeof gtag !== "undefined" && typeof gtag === "function") {
            gtag("event", "purchase", {
              transaction_id: order.id,
              value: decimalValue,
              currency: unit,
              items: (order.userItems || []).map((item) => ({
                id: item.sku.id,
                name: item.product.f_name_,
                quantity: item.count,
                price: item.price.decimalValue
              }))
            });
          }
          trackedOrders[finalizedOrder.orderId] = true;
          try {
            window.localStorage.setItem("wf-seen-orders", JSON.stringify(trackedOrders));
          } catch (err) {
            return;
          }
        });
      };
      exports.trackOrder = trackOrder;
    }
  });

  // node_modules/moment-timezone/node_modules/moment/moment.js
  var require_moment = __commonJS({
    "node_modules/moment-timezone/node_modules/moment/moment.js"(exports, module) {
      (function(global2, factory) {
        typeof exports === "object" && typeof module !== "undefined" ? module.exports = factory() : typeof define === "function" && define.amd ? define(factory) : global2.moment = factory();
      })(exports, function() {
        "use strict";
        var hookCallback;
        function hooks() {
          return hookCallback.apply(null, arguments);
        }
        function setHookCallback(callback) {
          hookCallback = callback;
        }
        function isArray(input) {
          return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
        }
        function isObject2(input) {
          return input != null && Object.prototype.toString.call(input) === "[object Object]";
        }
        function isObjectEmpty(obj) {
          if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
          } else {
            var k;
            for (k in obj) {
              if (obj.hasOwnProperty(k)) {
                return false;
              }
            }
            return true;
          }
        }
        function isUndefined(input) {
          return input === void 0;
        }
        function isNumber(input) {
          return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
        }
        function isDate(input) {
          return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
        }
        function map2(arr, fn) {
          var res = [], i;
          for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
          }
          return res;
        }
        function hasOwnProp(a, b) {
          return Object.prototype.hasOwnProperty.call(a, b);
        }
        function extend(a, b) {
          for (var i in b) {
            if (hasOwnProp(b, i)) {
              a[i] = b[i];
            }
          }
          if (hasOwnProp(b, "toString")) {
            a.toString = b.toString;
          }
          if (hasOwnProp(b, "valueOf")) {
            a.valueOf = b.valueOf;
          }
          return a;
        }
        function createUTC(input, format2, locale2, strict) {
          return createLocalOrUTC(input, format2, locale2, strict, true).utc();
        }
        function defaultParsingFlags() {
          return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
          };
        }
        function getParsingFlags(m) {
          if (m._pf == null) {
            m._pf = defaultParsingFlags();
          }
          return m._pf;
        }
        var some;
        if (Array.prototype.some) {
          some = Array.prototype.some;
        } else {
          some = function(fun) {
            var t = Object(this);
            var len = t.length >>> 0;
            for (var i = 0; i < len; i++) {
              if (i in t && fun.call(this, t[i], i, t)) {
                return true;
              }
            }
            return false;
          };
        }
        function isValid(m) {
          if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function(i) {
              return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) {
              isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
            }
            if (Object.isFrozen == null || !Object.isFrozen(m)) {
              m._isValid = isNowValid;
            } else {
              return isNowValid;
            }
          }
          return m._isValid;
        }
        function createInvalid(flags) {
          var m = createUTC(NaN);
          if (flags != null) {
            extend(getParsingFlags(m), flags);
          } else {
            getParsingFlags(m).userInvalidated = true;
          }
          return m;
        }
        var momentProperties = hooks.momentProperties = [];
        function copyConfig(to2, from4) {
          var i, prop2, val;
          if (!isUndefined(from4._isAMomentObject)) {
            to2._isAMomentObject = from4._isAMomentObject;
          }
          if (!isUndefined(from4._i)) {
            to2._i = from4._i;
          }
          if (!isUndefined(from4._f)) {
            to2._f = from4._f;
          }
          if (!isUndefined(from4._l)) {
            to2._l = from4._l;
          }
          if (!isUndefined(from4._strict)) {
            to2._strict = from4._strict;
          }
          if (!isUndefined(from4._tzm)) {
            to2._tzm = from4._tzm;
          }
          if (!isUndefined(from4._isUTC)) {
            to2._isUTC = from4._isUTC;
          }
          if (!isUndefined(from4._offset)) {
            to2._offset = from4._offset;
          }
          if (!isUndefined(from4._pf)) {
            to2._pf = getParsingFlags(from4);
          }
          if (!isUndefined(from4._locale)) {
            to2._locale = from4._locale;
          }
          if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
              prop2 = momentProperties[i];
              val = from4[prop2];
              if (!isUndefined(val)) {
                to2[prop2] = val;
              }
            }
          }
          return to2;
        }
        var updateInProgress = false;
        function Moment(config) {
          copyConfig(this, config);
          this._d = new Date(config._d != null ? config._d.getTime() : NaN);
          if (!this.isValid()) {
            this._d = /* @__PURE__ */ new Date(NaN);
          }
          if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
          }
        }
        function isMoment(obj) {
          return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
        }
        function absFloor(number) {
          if (number < 0) {
            return Math.ceil(number) || 0;
          } else {
            return Math.floor(number);
          }
        }
        function toInt(argumentForCoercion) {
          var coercedNumber = +argumentForCoercion, value = 0;
          if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
          }
          return value;
        }
        function compareArrays(array1, array2, dontConvert) {
          var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
          for (i = 0; i < len; i++) {
            if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
              diffs++;
            }
          }
          return diffs + lengthDiff;
        }
        function warn(msg) {
          if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
            console.warn("Deprecation warning: " + msg);
          }
        }
        function deprecate(msg, fn) {
          var firstTime = true;
          return extend(function() {
            if (hooks.deprecationHandler != null) {
              hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
              var args = [];
              var arg;
              for (var i = 0; i < arguments.length; i++) {
                arg = "";
                if (typeof arguments[i] === "object") {
                  arg += "\n[" + i + "] ";
                  for (var key in arguments[0]) {
                    arg += key + ": " + arguments[0][key] + ", ";
                  }
                  arg = arg.slice(0, -2);
                } else {
                  arg = arguments[i];
                }
                args.push(arg);
              }
              warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
              firstTime = false;
            }
            return fn.apply(this, arguments);
          }, fn);
        }
        var deprecations = {};
        function deprecateSimple(name, msg) {
          if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
          }
          if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
          }
        }
        hooks.suppressDeprecationWarnings = false;
        hooks.deprecationHandler = null;
        function isFunction3(input) {
          return input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
        }
        function set2(config) {
          var prop2, i;
          for (i in config) {
            prop2 = config[i];
            if (isFunction3(prop2)) {
              this[i] = prop2;
            } else {
              this["_" + i] = prop2;
            }
          }
          this._config = config;
          this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
          );
        }
        function mergeConfigs(parentConfig, childConfig) {
          var res = extend({}, parentConfig), prop2;
          for (prop2 in childConfig) {
            if (hasOwnProp(childConfig, prop2)) {
              if (isObject2(parentConfig[prop2]) && isObject2(childConfig[prop2])) {
                res[prop2] = {};
                extend(res[prop2], parentConfig[prop2]);
                extend(res[prop2], childConfig[prop2]);
              } else if (childConfig[prop2] != null) {
                res[prop2] = childConfig[prop2];
              } else {
                delete res[prop2];
              }
            }
          }
          for (prop2 in parentConfig) {
            if (hasOwnProp(parentConfig, prop2) && !hasOwnProp(childConfig, prop2) && isObject2(parentConfig[prop2])) {
              res[prop2] = extend({}, res[prop2]);
            }
          }
          return res;
        }
        function Locale(config) {
          if (config != null) {
            this.set(config);
          }
        }
        var keys;
        if (Object.keys) {
          keys = Object.keys;
        } else {
          keys = function(obj) {
            var i, res = [];
            for (i in obj) {
              if (hasOwnProp(obj, i)) {
                res.push(i);
              }
            }
            return res;
          };
        }
        var defaultCalendar = {
          sameDay: "[Today at] LT",
          nextDay: "[Tomorrow at] LT",
          nextWeek: "dddd [at] LT",
          lastDay: "[Yesterday at] LT",
          lastWeek: "[Last] dddd [at] LT",
          sameElse: "L"
        };
        function calendar(key, mom, now2) {
          var output = this._calendar[key] || this._calendar["sameElse"];
          return isFunction3(output) ? output.call(mom, now2) : output;
        }
        var defaultLongDateFormat = {
          LTS: "h:mm:ss A",
          LT: "h:mm A",
          L: "MM/DD/YYYY",
          LL: "MMMM D, YYYY",
          LLL: "MMMM D, YYYY h:mm A",
          LLLL: "dddd, MMMM D, YYYY h:mm A"
        };
        function longDateFormat(key) {
          var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
          if (format2 || !formatUpper) {
            return format2;
          }
          this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function(val) {
            return val.slice(1);
          });
          return this._longDateFormat[key];
        }
        var defaultInvalidDate = "Invalid date";
        function invalidDate() {
          return this._invalidDate;
        }
        var defaultOrdinal = "%d";
        var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
        function ordinal(number) {
          return this._ordinal.replace("%d", number);
        }
        var defaultRelativeTime = {
          future: "in %s",
          past: "%s ago",
          s: "a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        };
        function relativeTime(number, withoutSuffix, string, isFuture) {
          var output = this._relativeTime[string];
          return isFunction3(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
        }
        function pastFuture(diff2, output) {
          var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
          return isFunction3(format2) ? format2(output) : format2.replace(/%s/i, output);
        }
        var aliases = {};
        function addUnitAlias(unit, shorthand) {
          var lowerCase = unit.toLowerCase();
          aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
        }
        function normalizeUnits(units) {
          return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
        }
        function normalizeObjectUnits(inputObject) {
          var normalizedInput = {}, normalizedProp, prop2;
          for (prop2 in inputObject) {
            if (hasOwnProp(inputObject, prop2)) {
              normalizedProp = normalizeUnits(prop2);
              if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop2];
              }
            }
          }
          return normalizedInput;
        }
        var priorities = {};
        function addUnitPriority(unit, priority) {
          priorities[unit] = priority;
        }
        function getPrioritizedUnits(unitsObj) {
          var units = [];
          for (var u in unitsObj) {
            units.push({ unit: u, priority: priorities[u] });
          }
          units.sort(function(a, b) {
            return a.priority - b.priority;
          });
          return units;
        }
        function zeroFill(number, targetLength, forceSign) {
          var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
          return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
        }
        var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
        var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
        var formatFunctions = {};
        var formatTokenFunctions = {};
        function addFormatToken(token2, padded, ordinal2, callback) {
          var func = callback;
          if (typeof callback === "string") {
            func = function() {
              return this[callback]();
            };
          }
          if (token2) {
            formatTokenFunctions[token2] = func;
          }
          if (padded) {
            formatTokenFunctions[padded[0]] = function() {
              return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
          }
          if (ordinal2) {
            formatTokenFunctions[ordinal2] = function() {
              return this.localeData().ordinal(func.apply(this, arguments), token2);
            };
          }
        }
        function removeFormattingTokens(input) {
          if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, "");
          }
          return input.replace(/\\/g, "");
        }
        function makeFormatFunction(format2) {
          var array = format2.match(formattingTokens), i, length2;
          for (i = 0, length2 = array.length; i < length2; i++) {
            if (formatTokenFunctions[array[i]]) {
              array[i] = formatTokenFunctions[array[i]];
            } else {
              array[i] = removeFormattingTokens(array[i]);
            }
          }
          return function(mom) {
            var output = "", i2;
            for (i2 = 0; i2 < length2; i2++) {
              output += isFunction3(array[i2]) ? array[i2].call(mom, format2) : array[i2];
            }
            return output;
          };
        }
        function formatMoment(m, format2) {
          if (!m.isValid()) {
            return m.localeData().invalidDate();
          }
          format2 = expandFormat(format2, m.localeData());
          formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
          return formatFunctions[format2](m);
        }
        function expandFormat(format2, locale2) {
          var i = 5;
          function replaceLongDateFormatTokens(input) {
            return locale2.longDateFormat(input) || input;
          }
          localFormattingTokens.lastIndex = 0;
          while (i >= 0 && localFormattingTokens.test(format2)) {
            format2 = format2.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
          }
          return format2;
        }
        var match1 = /\d/;
        var match2 = /\d\d/;
        var match3 = /\d{3}/;
        var match4 = /\d{4}/;
        var match6 = /[+-]?\d{6}/;
        var match1to2 = /\d\d?/;
        var match3to4 = /\d\d\d\d?/;
        var match5to6 = /\d\d\d\d\d\d?/;
        var match1to3 = /\d{1,3}/;
        var match1to4 = /\d{1,4}/;
        var match1to6 = /[+-]?\d{1,6}/;
        var matchUnsigned = /\d+/;
        var matchSigned = /[+-]?\d+/;
        var matchOffset = /Z|[+-]\d\d:?\d\d/gi;
        var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi;
        var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/;
        var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
        var regexes = {};
        function addRegexToken(token2, regex, strictRegex) {
          regexes[token2] = isFunction3(regex) ? regex : function(isStrict, localeData2) {
            return isStrict && strictRegex ? strictRegex : regex;
          };
        }
        function getParseRegexForToken(token2, config) {
          if (!hasOwnProp(regexes, token2)) {
            return new RegExp(unescapeFormat(token2));
          }
          return regexes[token2](config._strict, config._locale);
        }
        function unescapeFormat(s) {
          return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
          }));
        }
        function regexEscape(s) {
          return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
        }
        var tokens = {};
        function addParseToken(token2, callback) {
          var i, func = callback;
          if (typeof token2 === "string") {
            token2 = [token2];
          }
          if (isNumber(callback)) {
            func = function(input, array) {
              array[callback] = toInt(input);
            };
          }
          for (i = 0; i < token2.length; i++) {
            tokens[token2[i]] = func;
          }
        }
        function addWeekParseToken(token2, callback) {
          addParseToken(token2, function(input, array, config, token3) {
            config._w = config._w || {};
            callback(input, config._w, config, token3);
          });
        }
        function addTimeToArrayFromToken(token2, input, config) {
          if (input != null && hasOwnProp(tokens, token2)) {
            tokens[token2](input, config._a, config, token2);
          }
        }
        var YEAR2 = 0;
        var MONTH = 1;
        var DATE = 2;
        var HOUR2 = 3;
        var MINUTE2 = 4;
        var SECOND2 = 5;
        var MILLISECOND = 6;
        var WEEK = 7;
        var WEEKDAY = 8;
        addFormatToken("Y", 0, 0, function() {
          var y = this.year();
          return y <= 9999 ? "" + y : "+" + y;
        });
        addFormatToken(0, ["YY", 2], 0, function() {
          return this.year() % 100;
        });
        addFormatToken(0, ["YYYY", 4], 0, "year");
        addFormatToken(0, ["YYYYY", 5], 0, "year");
        addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
        addUnitAlias("year", "y");
        addUnitPriority("year", 1);
        addRegexToken("Y", matchSigned);
        addRegexToken("YY", match1to2, match2);
        addRegexToken("YYYY", match1to4, match4);
        addRegexToken("YYYYY", match1to6, match6);
        addRegexToken("YYYYYY", match1to6, match6);
        addParseToken(["YYYYY", "YYYYYY"], YEAR2);
        addParseToken("YYYY", function(input, array) {
          array[YEAR2] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
        });
        addParseToken("YY", function(input, array) {
          array[YEAR2] = hooks.parseTwoDigitYear(input);
        });
        addParseToken("Y", function(input, array) {
          array[YEAR2] = parseInt(input, 10);
        });
        function daysInYear(year) {
          return isLeapYear(year) ? 366 : 365;
        }
        function isLeapYear(year) {
          return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        }
        hooks.parseTwoDigitYear = function(input) {
          return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
        };
        var getSetYear = makeGetSet("FullYear", true);
        function getIsLeapYear() {
          return isLeapYear(this.year());
        }
        function makeGetSet(unit, keepTime) {
          return function(value) {
            if (value != null) {
              set$1(this, unit, value);
              hooks.updateOffset(this, keepTime);
              return this;
            } else {
              return get2(this, unit);
            }
          };
        }
        function get2(mom, unit) {
          return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
        }
        function set$1(mom, unit, value) {
          if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
              mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else {
              mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
            }
          }
        }
        function stringGet(units) {
          units = normalizeUnits(units);
          if (isFunction3(this[units])) {
            return this[units]();
          }
          return this;
        }
        function stringSet(units, value) {
          if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
              this[prioritized[i].unit](units[prioritized[i].unit]);
            }
          } else {
            units = normalizeUnits(units);
            if (isFunction3(this[units])) {
              return this[units](value);
            }
          }
          return this;
        }
        function mod(n, x) {
          return (n % x + x) % x;
        }
        var indexOf;
        if (Array.prototype.indexOf) {
          indexOf = Array.prototype.indexOf;
        } else {
          indexOf = function(o) {
            var i;
            for (i = 0; i < this.length; ++i) {
              if (this[i] === o) {
                return i;
              }
            }
            return -1;
          };
        }
        function daysInMonth(year, month) {
          if (isNaN(year) || isNaN(month)) {
            return NaN;
          }
          var modMonth = mod(month, 12);
          year += (month - modMonth) / 12;
          return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
        }
        addFormatToken("M", ["MM", 2], "Mo", function() {
          return this.month() + 1;
        });
        addFormatToken("MMM", 0, 0, function(format2) {
          return this.localeData().monthsShort(this, format2);
        });
        addFormatToken("MMMM", 0, 0, function(format2) {
          return this.localeData().months(this, format2);
        });
        addUnitAlias("month", "M");
        addUnitPriority("month", 8);
        addRegexToken("M", match1to2);
        addRegexToken("MM", match1to2, match2);
        addRegexToken("MMM", function(isStrict, locale2) {
          return locale2.monthsShortRegex(isStrict);
        });
        addRegexToken("MMMM", function(isStrict, locale2) {
          return locale2.monthsRegex(isStrict);
        });
        addParseToken(["M", "MM"], function(input, array) {
          array[MONTH] = toInt(input) - 1;
        });
        addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
          var month = config._locale.monthsParse(input, token2, config._strict);
          if (month != null) {
            array[MONTH] = month;
          } else {
            getParsingFlags(config).invalidMonth = input;
          }
        });
        var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
        var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_");
        function localeMonths(m, format2) {
          if (!m) {
            return isArray(this._months) ? this._months : this._months["standalone"];
          }
          return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
        }
        var defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_");
        function localeMonthsShort(m, format2) {
          if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
          }
          return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
        }
        function handleStrictParse(monthName, format2, strict) {
          var i, ii, mom, llc = monthName.toLocaleLowerCase();
          if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
              mom = createUTC([2e3, i]);
              this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
              this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
          }
          if (strict) {
            if (format2 === "MMM") {
              ii = indexOf.call(this._shortMonthsParse, llc);
              return ii !== -1 ? ii : null;
            } else {
              ii = indexOf.call(this._longMonthsParse, llc);
              return ii !== -1 ? ii : null;
            }
          } else {
            if (format2 === "MMM") {
              ii = indexOf.call(this._shortMonthsParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._longMonthsParse, llc);
              return ii !== -1 ? ii : null;
            } else {
              ii = indexOf.call(this._longMonthsParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._shortMonthsParse, llc);
              return ii !== -1 ? ii : null;
            }
          }
        }
        function localeMonthsParse(monthName, format2, strict) {
          var i, mom, regex;
          if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format2, strict);
          }
          if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
          }
          for (i = 0; i < 12; i++) {
            mom = createUTC([2e3, i]);
            if (strict && !this._longMonthsParse[i]) {
              this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
              this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
              regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
              this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
              return i;
            } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
              return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
              return i;
            }
          }
        }
        function setMonth(mom, value) {
          var dayOfMonth;
          if (!mom.isValid()) {
            return mom;
          }
          if (typeof value === "string") {
            if (/^\d+$/.test(value)) {
              value = toInt(value);
            } else {
              value = mom.localeData().monthsParse(value);
              if (!isNumber(value)) {
                return mom;
              }
            }
          }
          dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
          mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
          return mom;
        }
        function getSetMonth(value) {
          if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
          } else {
            return get2(this, "Month");
          }
        }
        function getDaysInMonth() {
          return daysInMonth(this.year(), this.month());
        }
        var defaultMonthsShortRegex = matchWord;
        function monthsShortRegex(isStrict) {
          if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) {
              computeMonthsParse.call(this);
            }
            if (isStrict) {
              return this._monthsShortStrictRegex;
            } else {
              return this._monthsShortRegex;
            }
          } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) {
              this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
          }
        }
        var defaultMonthsRegex = matchWord;
        function monthsRegex(isStrict) {
          if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) {
              computeMonthsParse.call(this);
            }
            if (isStrict) {
              return this._monthsStrictRegex;
            } else {
              return this._monthsRegex;
            }
          } else {
            if (!hasOwnProp(this, "_monthsRegex")) {
              this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
          }
        }
        function computeMonthsParse() {
          function cmpLenRev(a, b) {
            return b.length - a.length;
          }
          var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
          for (i = 0; i < 12; i++) {
            mom = createUTC([2e3, i]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
          }
          shortPieces.sort(cmpLenRev);
          longPieces.sort(cmpLenRev);
          mixedPieces.sort(cmpLenRev);
          for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
          }
          for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
          }
          this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
          this._monthsShortRegex = this._monthsRegex;
          this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
          this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        }
        function createDate(y, m, d, h, M, s, ms) {
          var date = new Date(y, m, d, h, M, s, ms);
          if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
          }
          return date;
        }
        function createUTCDate(y) {
          var date = new Date(Date.UTC.apply(null, arguments));
          if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
          }
          return date;
        }
        function firstWeekOffset(year, dow, doy) {
          var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
          return -fwdlw + fwd - 1;
        }
        function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
          var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
          if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
          } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
          } else {
            resYear = year;
            resDayOfYear = dayOfYear;
          }
          return {
            year: resYear,
            dayOfYear: resDayOfYear
          };
        }
        function weekOfYear(mom, dow, doy) {
          var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
          if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
          } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
          } else {
            resYear = mom.year();
            resWeek = week;
          }
          return {
            week: resWeek,
            year: resYear
          };
        }
        function weeksInYear(year, dow, doy) {
          var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
          return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
        }
        addFormatToken("w", ["ww", 2], "wo", "week");
        addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
        addUnitAlias("week", "w");
        addUnitAlias("isoWeek", "W");
        addUnitPriority("week", 5);
        addUnitPriority("isoWeek", 5);
        addRegexToken("w", match1to2);
        addRegexToken("ww", match1to2, match2);
        addRegexToken("W", match1to2);
        addRegexToken("WW", match1to2, match2);
        addWeekParseToken(["w", "ww", "W", "WW"], function(input, week, config, token2) {
          week[token2.substr(0, 1)] = toInt(input);
        });
        function localeWeek(mom) {
          return weekOfYear(mom, this._week.dow, this._week.doy).week;
        }
        var defaultLocaleWeek = {
          dow: 0,
          // Sunday is the first day of the week.
          doy: 6
          // The week that contains Jan 1st is the first week of the year.
        };
        function localeFirstDayOfWeek() {
          return this._week.dow;
        }
        function localeFirstDayOfYear() {
          return this._week.doy;
        }
        function getSetWeek(input) {
          var week = this.localeData().week(this);
          return input == null ? week : this.add((input - week) * 7, "d");
        }
        function getSetISOWeek(input) {
          var week = weekOfYear(this, 1, 4).week;
          return input == null ? week : this.add((input - week) * 7, "d");
        }
        addFormatToken("d", 0, "do", "day");
        addFormatToken("dd", 0, 0, function(format2) {
          return this.localeData().weekdaysMin(this, format2);
        });
        addFormatToken("ddd", 0, 0, function(format2) {
          return this.localeData().weekdaysShort(this, format2);
        });
        addFormatToken("dddd", 0, 0, function(format2) {
          return this.localeData().weekdays(this, format2);
        });
        addFormatToken("e", 0, 0, "weekday");
        addFormatToken("E", 0, 0, "isoWeekday");
        addUnitAlias("day", "d");
        addUnitAlias("weekday", "e");
        addUnitAlias("isoWeekday", "E");
        addUnitPriority("day", 11);
        addUnitPriority("weekday", 11);
        addUnitPriority("isoWeekday", 11);
        addRegexToken("d", match1to2);
        addRegexToken("e", match1to2);
        addRegexToken("E", match1to2);
        addRegexToken("dd", function(isStrict, locale2) {
          return locale2.weekdaysMinRegex(isStrict);
        });
        addRegexToken("ddd", function(isStrict, locale2) {
          return locale2.weekdaysShortRegex(isStrict);
        });
        addRegexToken("dddd", function(isStrict, locale2) {
          return locale2.weekdaysRegex(isStrict);
        });
        addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
          var weekday = config._locale.weekdaysParse(input, token2, config._strict);
          if (weekday != null) {
            week.d = weekday;
          } else {
            getParsingFlags(config).invalidWeekday = input;
          }
        });
        addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
          week[token2] = toInt(input);
        });
        function parseWeekday(input, locale2) {
          if (typeof input !== "string") {
            return input;
          }
          if (!isNaN(input)) {
            return parseInt(input, 10);
          }
          input = locale2.weekdaysParse(input);
          if (typeof input === "number") {
            return input;
          }
          return null;
        }
        function parseIsoWeekday(input, locale2) {
          if (typeof input === "string") {
            return locale2.weekdaysParse(input) % 7 || 7;
          }
          return isNaN(input) ? null : input;
        }
        var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_");
        function localeWeekdays(m, format2) {
          if (!m) {
            return isArray(this._weekdays) ? this._weekdays : this._weekdays["standalone"];
          }
          return isArray(this._weekdays) ? this._weekdays[m.day()] : this._weekdays[this._weekdays.isFormat.test(format2) ? "format" : "standalone"][m.day()];
        }
        var defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_");
        function localeWeekdaysShort(m) {
          return m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
        }
        var defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_");
        function localeWeekdaysMin(m) {
          return m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
        }
        function handleStrictParse$1(weekdayName, format2, strict) {
          var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
          if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for (i = 0; i < 7; ++i) {
              mom = createUTC([2e3, 1]).day(i);
              this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
              this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
              this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
          }
          if (strict) {
            if (format2 === "dddd") {
              ii = indexOf.call(this._weekdaysParse, llc);
              return ii !== -1 ? ii : null;
            } else if (format2 === "ddd") {
              ii = indexOf.call(this._shortWeekdaysParse, llc);
              return ii !== -1 ? ii : null;
            } else {
              ii = indexOf.call(this._minWeekdaysParse, llc);
              return ii !== -1 ? ii : null;
            }
          } else {
            if (format2 === "dddd") {
              ii = indexOf.call(this._weekdaysParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._shortWeekdaysParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._minWeekdaysParse, llc);
              return ii !== -1 ? ii : null;
            } else if (format2 === "ddd") {
              ii = indexOf.call(this._shortWeekdaysParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._weekdaysParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._minWeekdaysParse, llc);
              return ii !== -1 ? ii : null;
            } else {
              ii = indexOf.call(this._minWeekdaysParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._weekdaysParse, llc);
              if (ii !== -1) {
                return ii;
              }
              ii = indexOf.call(this._shortWeekdaysParse, llc);
              return ii !== -1 ? ii : null;
            }
          }
        }
        function localeWeekdaysParse(weekdayName, format2, strict) {
          var i, mom, regex;
          if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format2, strict);
          }
          if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
          }
          for (i = 0; i < 7; i++) {
            mom = createUTC([2e3, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
              this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
              this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
              this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
              regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
              this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
              return i;
            } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
              return i;
            } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
              return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
              return i;
            }
          }
        }
        function getSetDayOfWeek(input) {
          if (!this.isValid()) {
            return input != null ? this : NaN;
          }
          var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
          if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
          } else {
            return day;
          }
        }
        function getSetLocaleDayOfWeek(input) {
          if (!this.isValid()) {
            return input != null ? this : NaN;
          }
          var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
          return input == null ? weekday : this.add(input - weekday, "d");
        }
        function getSetISODayOfWeek(input) {
          if (!this.isValid()) {
            return input != null ? this : NaN;
          }
          if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
          } else {
            return this.day() || 7;
          }
        }
        var defaultWeekdaysRegex = matchWord;
        function weekdaysRegex(isStrict) {
          if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) {
              computeWeekdaysParse.call(this);
            }
            if (isStrict) {
              return this._weekdaysStrictRegex;
            } else {
              return this._weekdaysRegex;
            }
          } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) {
              this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
          }
        }
        var defaultWeekdaysShortRegex = matchWord;
        function weekdaysShortRegex(isStrict) {
          if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) {
              computeWeekdaysParse.call(this);
            }
            if (isStrict) {
              return this._weekdaysShortStrictRegex;
            } else {
              return this._weekdaysShortRegex;
            }
          } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) {
              this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
          }
        }
        var defaultWeekdaysMinRegex = matchWord;
        function weekdaysMinRegex(isStrict) {
          if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) {
              computeWeekdaysParse.call(this);
            }
            if (isStrict) {
              return this._weekdaysMinStrictRegex;
            } else {
              return this._weekdaysMinRegex;
            }
          } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) {
              this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
          }
        }
        function computeWeekdaysParse() {
          function cmpLenRev(a, b) {
            return b.length - a.length;
          }
          var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
          for (i = 0; i < 7; i++) {
            mom = createUTC([2e3, 1]).day(i);
            minp = this.weekdaysMin(mom, "");
            shortp = this.weekdaysShort(mom, "");
            longp = this.weekdays(mom, "");
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
          }
          minPieces.sort(cmpLenRev);
          shortPieces.sort(cmpLenRev);
          longPieces.sort(cmpLenRev);
          mixedPieces.sort(cmpLenRev);
          for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
          }
          this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
          this._weekdaysShortRegex = this._weekdaysRegex;
          this._weekdaysMinRegex = this._weekdaysRegex;
          this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
          this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
          this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
        }
        function hFormat() {
          return this.hours() % 12 || 12;
        }
        function kFormat() {
          return this.hours() || 24;
        }
        addFormatToken("H", ["HH", 2], 0, "hour");
        addFormatToken("h", ["hh", 2], 0, hFormat);
        addFormatToken("k", ["kk", 2], 0, kFormat);
        addFormatToken("hmm", 0, 0, function() {
          return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
        });
        addFormatToken("hmmss", 0, 0, function() {
          return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
        });
        addFormatToken("Hmm", 0, 0, function() {
          return "" + this.hours() + zeroFill(this.minutes(), 2);
        });
        addFormatToken("Hmmss", 0, 0, function() {
          return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
        });
        function meridiem(token2, lowercase) {
          addFormatToken(token2, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
          });
        }
        meridiem("a", true);
        meridiem("A", false);
        addUnitAlias("hour", "h");
        addUnitPriority("hour", 13);
        function matchMeridiem(isStrict, locale2) {
          return locale2._meridiemParse;
        }
        addRegexToken("a", matchMeridiem);
        addRegexToken("A", matchMeridiem);
        addRegexToken("H", match1to2);
        addRegexToken("h", match1to2);
        addRegexToken("k", match1to2);
        addRegexToken("HH", match1to2, match2);
        addRegexToken("hh", match1to2, match2);
        addRegexToken("kk", match1to2, match2);
        addRegexToken("hmm", match3to4);
        addRegexToken("hmmss", match5to6);
        addRegexToken("Hmm", match3to4);
        addRegexToken("Hmmss", match5to6);
        addParseToken(["H", "HH"], HOUR2);
        addParseToken(["k", "kk"], function(input, array, config) {
          var kInput = toInt(input);
          array[HOUR2] = kInput === 24 ? 0 : kInput;
        });
        addParseToken(["a", "A"], function(input, array, config) {
          config._isPm = config._locale.isPM(input);
          config._meridiem = input;
        });
        addParseToken(["h", "hh"], function(input, array, config) {
          array[HOUR2] = toInt(input);
          getParsingFlags(config).bigHour = true;
        });
        addParseToken("hmm", function(input, array, config) {
          var pos = input.length - 2;
          array[HOUR2] = toInt(input.substr(0, pos));
          array[MINUTE2] = toInt(input.substr(pos));
          getParsingFlags(config).bigHour = true;
        });
        addParseToken("hmmss", function(input, array, config) {
          var pos1 = input.length - 4;
          var pos2 = input.length - 2;
          array[HOUR2] = toInt(input.substr(0, pos1));
          array[MINUTE2] = toInt(input.substr(pos1, 2));
          array[SECOND2] = toInt(input.substr(pos2));
          getParsingFlags(config).bigHour = true;
        });
        addParseToken("Hmm", function(input, array, config) {
          var pos = input.length - 2;
          array[HOUR2] = toInt(input.substr(0, pos));
          array[MINUTE2] = toInt(input.substr(pos));
        });
        addParseToken("Hmmss", function(input, array, config) {
          var pos1 = input.length - 4;
          var pos2 = input.length - 2;
          array[HOUR2] = toInt(input.substr(0, pos1));
          array[MINUTE2] = toInt(input.substr(pos1, 2));
          array[SECOND2] = toInt(input.substr(pos2));
        });
        function localeIsPM(input) {
          return (input + "").toLowerCase().charAt(0) === "p";
        }
        var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
        function localeMeridiem(hours2, minutes2, isLower) {
          if (hours2 > 11) {
            return isLower ? "pm" : "PM";
          } else {
            return isLower ? "am" : "AM";
          }
        }
        var getSetHour = makeGetSet("Hours", true);
        var baseConfig = {
          calendar: defaultCalendar,
          longDateFormat: defaultLongDateFormat,
          invalidDate: defaultInvalidDate,
          ordinal: defaultOrdinal,
          dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
          relativeTime: defaultRelativeTime,
          months: defaultLocaleMonths,
          monthsShort: defaultLocaleMonthsShort,
          week: defaultLocaleWeek,
          weekdays: defaultLocaleWeekdays,
          weekdaysMin: defaultLocaleWeekdaysMin,
          weekdaysShort: defaultLocaleWeekdaysShort,
          meridiemParse: defaultLocaleMeridiemParse
        };
        var locales = {};
        var localeFamilies = {};
        var globalLocale;
        function normalizeLocale(key) {
          return key ? key.toLowerCase().replace("_", "-") : key;
        }
        function chooseLocale(names) {
          var i = 0, j, next, locale2, split4;
          while (i < names.length) {
            split4 = normalizeLocale(names[i]).split("-");
            j = split4.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while (j > 0) {
              locale2 = loadLocale(split4.slice(0, j).join("-"));
              if (locale2) {
                return locale2;
              }
              if (next && next.length >= j && compareArrays(split4, next, true) >= j - 1) {
                break;
              }
              j--;
            }
            i++;
          }
          return globalLocale;
        }
        function loadLocale(name) {
          var oldLocale = null;
          if (!locales[name] && typeof module !== "undefined" && module && module.exports) {
            try {
              oldLocale = globalLocale._abbr;
              var aliasedRequire = __require;
              aliasedRequire("./locale/" + name);
              getSetGlobalLocale(oldLocale);
            } catch (e) {
            }
          }
          return locales[name];
        }
        function getSetGlobalLocale(key, values2) {
          var data;
          if (key) {
            if (isUndefined(values2)) {
              data = getLocale(key);
            } else {
              data = defineLocale(key, values2);
            }
            if (data) {
              globalLocale = data;
            } else {
              if (typeof console !== "undefined" && console.warn) {
                console.warn("Locale " + key + " not found. Did you forget to load it?");
              }
            }
          }
          return globalLocale._abbr;
        }
        function defineLocale(name, config) {
          if (config !== null) {
            var locale2, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
              deprecateSimple(
                "defineLocaleOverride",
                "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
              );
              parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
              if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
              } else {
                locale2 = loadLocale(config.parentLocale);
                if (locale2 != null) {
                  parentConfig = locale2._config;
                } else {
                  if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                  }
                  localeFamilies[config.parentLocale].push({
                    name,
                    config
                  });
                  return null;
                }
              }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) {
              localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
              });
            }
            getSetGlobalLocale(name);
            return locales[name];
          } else {
            delete locales[name];
            return null;
          }
        }
        function updateLocale(name, config) {
          if (config != null) {
            var locale2, tmpLocale, parentConfig = baseConfig;
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
              parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale2 = new Locale(config);
            locale2.parentLocale = locales[name];
            locales[name] = locale2;
            getSetGlobalLocale(name);
          } else {
            if (locales[name] != null) {
              if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
              } else if (locales[name] != null) {
                delete locales[name];
              }
            }
          }
          return locales[name];
        }
        function getLocale(key) {
          var locale2;
          if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
          }
          if (!key) {
            return globalLocale;
          }
          if (!isArray(key)) {
            locale2 = loadLocale(key);
            if (locale2) {
              return locale2;
            }
            key = [key];
          }
          return chooseLocale(key);
        }
        function listLocales() {
          return keys(locales);
        }
        function checkOverflow(m) {
          var overflow;
          var a = m._a;
          if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR2], a[MONTH]) ? DATE : a[HOUR2] < 0 || a[HOUR2] > 24 || a[HOUR2] === 24 && (a[MINUTE2] !== 0 || a[SECOND2] !== 0 || a[MILLISECOND] !== 0) ? HOUR2 : a[MINUTE2] < 0 || a[MINUTE2] > 59 ? MINUTE2 : a[SECOND2] < 0 || a[SECOND2] > 59 ? SECOND2 : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR2 || overflow > DATE)) {
              overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
              overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
              overflow = WEEKDAY;
            }
            getParsingFlags(m).overflow = overflow;
          }
          return m;
        }
        function defaults(a, b, c) {
          if (a != null) {
            return a;
          }
          if (b != null) {
            return b;
          }
          return c;
        }
        function currentDateArray(config) {
          var nowValue = new Date(hooks.now());
          if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
          }
          return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
        }
        function configFromArray(config) {
          var i, date, input = [], currentDate, expectedWeekday, yearToUse;
          if (config._d) {
            return;
          }
          currentDate = currentDateArray(config);
          if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
          }
          if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR2], currentDate[YEAR2]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
              getParsingFlags(config)._overflowDayOfYear = true;
            }
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
          }
          for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
          }
          for (; i < 7; i++) {
            config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
          }
          if (config._a[HOUR2] === 24 && config._a[MINUTE2] === 0 && config._a[SECOND2] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR2] = 0;
          }
          config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
          expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
          if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
          }
          if (config._nextDay) {
            config._a[HOUR2] = 24;
          }
          if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
          }
        }
        function dayOfYearFromWeekInfo(config) {
          var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
          w = config._w;
          if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            weekYear = defaults(w.GG, config._a[YEAR2], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
              weekdayOverflow = true;
            }
          } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            var curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR2], curWeek.year);
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
              weekday = w.d;
              if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
              }
            } else if (w.e != null) {
              weekday = w.e + dow;
              if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
              }
            } else {
              weekday = dow;
            }
          }
          if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
          } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
          } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR2] = temp.year;
            config._dayOfYear = temp.dayOfYear;
          }
        }
        var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
        var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
        var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
        var isoDates = [
          ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
          ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
          ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
          ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
          ["YYYY-DDD", /\d{4}-\d{3}/],
          ["YYYY-MM", /\d{4}-\d\d/, false],
          ["YYYYYYMMDD", /[+-]\d{10}/],
          ["YYYYMMDD", /\d{8}/],
          // YYYYMM is NOT allowed by the standard
          ["GGGG[W]WWE", /\d{4}W\d{3}/],
          ["GGGG[W]WW", /\d{4}W\d{2}/, false],
          ["YYYYDDD", /\d{7}/]
        ];
        var isoTimes = [
          ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
          ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
          ["HH:mm:ss", /\d\d:\d\d:\d\d/],
          ["HH:mm", /\d\d:\d\d/],
          ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
          ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
          ["HHmmss", /\d\d\d\d\d\d/],
          ["HHmm", /\d\d\d\d/],
          ["HH", /\d\d/]
        ];
        var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
        function configFromISO(config) {
          var i, l, string = config._i, match5 = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat;
          if (match5) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
              if (isoDates[i][1].exec(match5[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
              }
            }
            if (dateFormat == null) {
              config._isValid = false;
              return;
            }
            if (match5[3]) {
              for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match5[3])) {
                  timeFormat = (match5[2] || " ") + isoTimes[i][0];
                  break;
                }
              }
              if (timeFormat == null) {
                config._isValid = false;
                return;
              }
            }
            if (!allowTime && timeFormat != null) {
              config._isValid = false;
              return;
            }
            if (match5[4]) {
              if (tzRegex.exec(match5[4])) {
                tzFormat = "Z";
              } else {
                config._isValid = false;
                return;
              }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
          } else {
            config._isValid = false;
          }
        }
        var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
        function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
          var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
          ];
          if (secondStr) {
            result.push(parseInt(secondStr, 10));
          }
          return result;
        }
        function untruncateYear(yearStr) {
          var year = parseInt(yearStr, 10);
          if (year <= 49) {
            return 2e3 + year;
          } else if (year <= 999) {
            return 1900 + year;
          }
          return year;
        }
        function preprocessRFC2822(s) {
          return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
        }
        function checkWeekday(weekdayStr, parsedInput, config) {
          if (weekdayStr) {
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
              getParsingFlags(config).weekdayMismatch = true;
              config._isValid = false;
              return false;
            }
          }
          return true;
        }
        var obsOffsets = {
          UT: 0,
          GMT: 0,
          EDT: -4 * 60,
          EST: -5 * 60,
          CDT: -5 * 60,
          CST: -6 * 60,
          MDT: -6 * 60,
          MST: -7 * 60,
          PDT: -7 * 60,
          PST: -8 * 60
        };
        function calculateOffset(obsOffset, militaryOffset, numOffset) {
          if (obsOffset) {
            return obsOffsets[obsOffset];
          } else if (militaryOffset) {
            return 0;
          } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
          }
        }
        function configFromRFC2822(config) {
          var match5 = rfc2822.exec(preprocessRFC2822(config._i));
          if (match5) {
            var parsedArray = extractFromRFC2822Strings(match5[4], match5[3], match5[2], match5[5], match5[6], match5[7]);
            if (!checkWeekday(match5[1], parsedArray, config)) {
              return;
            }
            config._a = parsedArray;
            config._tzm = calculateOffset(match5[8], match5[9], match5[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
          } else {
            config._isValid = false;
          }
        }
        function configFromString(config) {
          var matched = aspNetJsonRegex.exec(config._i);
          if (matched !== null) {
            config._d = /* @__PURE__ */ new Date(+matched[1]);
            return;
          }
          configFromISO(config);
          if (config._isValid === false) {
            delete config._isValid;
          } else {
            return;
          }
          configFromRFC2822(config);
          if (config._isValid === false) {
            delete config._isValid;
          } else {
            return;
          }
          hooks.createFromInputFallback(config);
        }
        hooks.createFromInputFallback = deprecate(
          "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
          function(config) {
            config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
          }
        );
        hooks.ISO_8601 = function() {
        };
        hooks.RFC_2822 = function() {
        };
        function configFromStringAndFormat(config) {
          if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
          }
          if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
          }
          config._a = [];
          getParsingFlags(config).empty = true;
          var string = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0;
          tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
          for (i = 0; i < tokens2.length; i++) {
            token2 = tokens2[i];
            parsedInput = (string.match(getParseRegexForToken(token2, config)) || [])[0];
            if (parsedInput) {
              skipped = string.substr(0, string.indexOf(parsedInput));
              if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
              }
              string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
              totalParsedInputLength += parsedInput.length;
            }
            if (formatTokenFunctions[token2]) {
              if (parsedInput) {
                getParsingFlags(config).empty = false;
              } else {
                getParsingFlags(config).unusedTokens.push(token2);
              }
              addTimeToArrayFromToken(token2, parsedInput, config);
            } else if (config._strict && !parsedInput) {
              getParsingFlags(config).unusedTokens.push(token2);
            }
          }
          getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
          if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
          }
          if (config._a[HOUR2] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR2] > 0) {
            getParsingFlags(config).bigHour = void 0;
          }
          getParsingFlags(config).parsedDateParts = config._a.slice(0);
          getParsingFlags(config).meridiem = config._meridiem;
          config._a[HOUR2] = meridiemFixWrap(config._locale, config._a[HOUR2], config._meridiem);
          configFromArray(config);
          checkOverflow(config);
        }
        function meridiemFixWrap(locale2, hour, meridiem2) {
          var isPm;
          if (meridiem2 == null) {
            return hour;
          }
          if (locale2.meridiemHour != null) {
            return locale2.meridiemHour(hour, meridiem2);
          } else if (locale2.isPM != null) {
            isPm = locale2.isPM(meridiem2);
            if (isPm && hour < 12) {
              hour += 12;
            }
            if (!isPm && hour === 12) {
              hour = 0;
            }
            return hour;
          } else {
            return hour;
          }
        }
        function configFromStringAndArray(config) {
          var tempConfig, bestMoment, scoreToBeat, i, currentScore;
          if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = /* @__PURE__ */ new Date(NaN);
            return;
          }
          for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
              tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (!isValid(tempConfig)) {
              continue;
            }
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (scoreToBeat == null || currentScore < scoreToBeat) {
              scoreToBeat = currentScore;
              bestMoment = tempConfig;
            }
          }
          extend(config, bestMoment || tempConfig);
        }
        function configFromObject(config) {
          if (config._d) {
            return;
          }
          var i = normalizeObjectUnits(config._i);
          config._a = map2([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function(obj) {
            return obj && parseInt(obj, 10);
          });
          configFromArray(config);
        }
        function createFromConfig(config) {
          var res = new Moment(checkOverflow(prepareConfig(config)));
          if (res._nextDay) {
            res.add(1, "d");
            res._nextDay = void 0;
          }
          return res;
        }
        function prepareConfig(config) {
          var input = config._i, format2 = config._f;
          config._locale = config._locale || getLocale(config._l);
          if (input === null || format2 === void 0 && input === "") {
            return createInvalid({ nullInput: true });
          }
          if (typeof input === "string") {
            config._i = input = config._locale.preparse(input);
          }
          if (isMoment(input)) {
            return new Moment(checkOverflow(input));
          } else if (isDate(input)) {
            config._d = input;
          } else if (isArray(format2)) {
            configFromStringAndArray(config);
          } else if (format2) {
            configFromStringAndFormat(config);
          } else {
            configFromInput(config);
          }
          if (!isValid(config)) {
            config._d = null;
          }
          return config;
        }
        function configFromInput(config) {
          var input = config._i;
          if (isUndefined(input)) {
            config._d = new Date(hooks.now());
          } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
          } else if (typeof input === "string") {
            configFromString(config);
          } else if (isArray(input)) {
            config._a = map2(input.slice(0), function(obj) {
              return parseInt(obj, 10);
            });
            configFromArray(config);
          } else if (isObject2(input)) {
            configFromObject(config);
          } else if (isNumber(input)) {
            config._d = new Date(input);
          } else {
            hooks.createFromInputFallback(config);
          }
        }
        function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
          var c = {};
          if (locale2 === true || locale2 === false) {
            strict = locale2;
            locale2 = void 0;
          }
          if (isObject2(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
            input = void 0;
          }
          c._isAMomentObject = true;
          c._useUTC = c._isUTC = isUTC;
          c._l = locale2;
          c._i = input;
          c._f = format2;
          c._strict = strict;
          return createFromConfig(c);
        }
        function createLocal(input, format2, locale2, strict) {
          return createLocalOrUTC(input, format2, locale2, strict, false);
        }
        var prototypeMin = deprecate(
          "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
          function() {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
              return other < this ? this : other;
            } else {
              return createInvalid();
            }
          }
        );
        var prototypeMax = deprecate(
          "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
          function() {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
              return other > this ? this : other;
            } else {
              return createInvalid();
            }
          }
        );
        function pickBy2(fn, moments) {
          var res, i;
          if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
          }
          if (!moments.length) {
            return createLocal();
          }
          res = moments[0];
          for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
              res = moments[i];
            }
          }
          return res;
        }
        function min() {
          var args = [].slice.call(arguments, 0);
          return pickBy2("isBefore", args);
        }
        function max2() {
          var args = [].slice.call(arguments, 0);
          return pickBy2("isAfter", args);
        }
        var now = function() {
          return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
        };
        var ordering = ["year", "quarter", "month", "week", "day", "hour", "minute", "second", "millisecond"];
        function isDurationValid(m) {
          for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
              return false;
            }
          }
          var unitHasDecimal = false;
          for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
              if (unitHasDecimal) {
                return false;
              }
              if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
              }
            }
          }
          return true;
        }
        function isValid$1() {
          return this._isValid;
        }
        function createInvalid$1() {
          return createDuration(NaN);
        }
        function Duration(duration) {
          var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
          this._isValid = isDurationValid(normalizedInput);
          this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
          minutes2 * 6e4 + // 1000 * 60
          hours2 * 1e3 * 60 * 60;
          this._days = +days2 + weeks2 * 7;
          this._months = +months2 + quarters * 3 + years2 * 12;
          this._data = {};
          this._locale = getLocale();
          this._bubble();
        }
        function isDuration(obj) {
          return obj instanceof Duration;
        }
        function absRound(number) {
          if (number < 0) {
            return Math.round(-1 * number) * -1;
          } else {
            return Math.round(number);
          }
        }
        function offset(token2, separator) {
          addFormatToken(token2, 0, 0, function() {
            var offset2 = this.utcOffset();
            var sign2 = "+";
            if (offset2 < 0) {
              offset2 = -offset2;
              sign2 = "-";
            }
            return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
          });
        }
        offset("Z", ":");
        offset("ZZ", "");
        addRegexToken("Z", matchShortOffset);
        addRegexToken("ZZ", matchShortOffset);
        addParseToken(["Z", "ZZ"], function(input, array, config) {
          config._useUTC = true;
          config._tzm = offsetFromString(matchShortOffset, input);
        });
        var chunkOffset = /([\+\-]|\d\d)/gi;
        function offsetFromString(matcher, string) {
          var matches = (string || "").match(matcher);
          if (matches === null) {
            return null;
          }
          var chunk = matches[matches.length - 1] || [];
          var parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
          var minutes2 = +(parts[1] * 60) + toInt(parts[2]);
          return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
        }
        function cloneWithOffset(input, model) {
          var res, diff2;
          if (model._isUTC) {
            res = model.clone();
            diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            res._d.setTime(res._d.valueOf() + diff2);
            hooks.updateOffset(res, false);
            return res;
          } else {
            return createLocal(input).local();
          }
        }
        function getDateOffset(m) {
          return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
        }
        hooks.updateOffset = function() {
        };
        function getSetOffset(input, keepLocalTime, keepMinutes) {
          var offset2 = this._offset || 0, localAdjust;
          if (!this.isValid()) {
            return input != null ? this : NaN;
          }
          if (input != null) {
            if (typeof input === "string") {
              input = offsetFromString(matchShortOffset, input);
              if (input === null) {
                return this;
              }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
              input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
              localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
              this.add(localAdjust, "m");
            }
            if (offset2 !== input) {
              if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset2, "m"), 1, false);
              } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
              }
            }
            return this;
          } else {
            return this._isUTC ? offset2 : getDateOffset(this);
          }
        }
        function getSetZone(input, keepLocalTime) {
          if (input != null) {
            if (typeof input !== "string") {
              input = -input;
            }
            this.utcOffset(input, keepLocalTime);
            return this;
          } else {
            return -this.utcOffset();
          }
        }
        function setOffsetToUTC(keepLocalTime) {
          return this.utcOffset(0, keepLocalTime);
        }
        function setOffsetToLocal(keepLocalTime) {
          if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) {
              this.subtract(getDateOffset(this), "m");
            }
          }
          return this;
        }
        function setOffsetToParsedOffset() {
          if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
          } else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
              this.utcOffset(tZone);
            } else {
              this.utcOffset(0, true);
            }
          }
          return this;
        }
        function hasAlignedHourOffset(input) {
          if (!this.isValid()) {
            return false;
          }
          input = input ? createLocal(input).utcOffset() : 0;
          return (this.utcOffset() - input) % 60 === 0;
        }
        function isDaylightSavingTime() {
          return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
        }
        function isDaylightSavingTimeShifted() {
          if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
          }
          var c = {};
          copyConfig(c, this);
          c = prepareConfig(c);
          if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
          } else {
            this._isDSTShifted = false;
          }
          return this._isDSTShifted;
        }
        function isLocal() {
          return this.isValid() ? !this._isUTC : false;
        }
        function isUtcOffset() {
          return this.isValid() ? this._isUTC : false;
        }
        function isUtc() {
          return this.isValid() ? this._isUTC && this._offset === 0 : false;
        }
        var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
        var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
        function createDuration(input, key) {
          var duration = input, match5 = null, sign2, ret, diffRes;
          if (isDuration(input)) {
            duration = {
              ms: input._milliseconds,
              d: input._days,
              M: input._months
            };
          } else if (isNumber(input)) {
            duration = {};
            if (key) {
              duration[key] = input;
            } else {
              duration.milliseconds = input;
            }
          } else if (!!(match5 = aspNetRegex.exec(input))) {
            sign2 = match5[1] === "-" ? -1 : 1;
            duration = {
              y: 0,
              d: toInt(match5[DATE]) * sign2,
              h: toInt(match5[HOUR2]) * sign2,
              m: toInt(match5[MINUTE2]) * sign2,
              s: toInt(match5[SECOND2]) * sign2,
              ms: toInt(absRound(match5[MILLISECOND] * 1e3)) * sign2
              // the millisecond decimal point is included in the match
            };
          } else if (!!(match5 = isoRegex.exec(input))) {
            sign2 = match5[1] === "-" ? -1 : match5[1] === "+" ? 1 : 1;
            duration = {
              y: parseIso(match5[2], sign2),
              M: parseIso(match5[3], sign2),
              w: parseIso(match5[4], sign2),
              d: parseIso(match5[5], sign2),
              h: parseIso(match5[6], sign2),
              m: parseIso(match5[7], sign2),
              s: parseIso(match5[8], sign2)
            };
          } else if (duration == null) {
            duration = {};
          } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
          }
          ret = new Duration(duration);
          if (isDuration(input) && hasOwnProp(input, "_locale")) {
            ret._locale = input._locale;
          }
          return ret;
        }
        createDuration.fn = Duration.prototype;
        createDuration.invalid = createInvalid$1;
        function parseIso(inp, sign2) {
          var res = inp && parseFloat(inp.replace(",", "."));
          return (isNaN(res) ? 0 : res) * sign2;
        }
        function positiveMomentsDifference(base, other) {
          var res = { milliseconds: 0, months: 0 };
          res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
          if (base.clone().add(res.months, "M").isAfter(other)) {
            --res.months;
          }
          res.milliseconds = +other - +base.clone().add(res.months, "M");
          return res;
        }
        function momentsDifference(base, other) {
          var res;
          if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
          }
          other = cloneWithOffset(other, base);
          if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
          } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
          }
          return res;
        }
        function createAdder(direction, name) {
          return function(val, period) {
            var dur, tmp;
            if (period !== null && !isNaN(+period)) {
              deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
              tmp = val;
              val = period;
              period = tmp;
            }
            val = typeof val === "string" ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
          };
        }
        function addSubtract(mom, duration, isAdding, updateOffset) {
          var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
          if (!mom.isValid()) {
            return;
          }
          updateOffset = updateOffset == null ? true : updateOffset;
          if (months2) {
            setMonth(mom, get2(mom, "Month") + months2 * isAdding);
          }
          if (days2) {
            set$1(mom, "Date", get2(mom, "Date") + days2 * isAdding);
          }
          if (milliseconds2) {
            mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
          }
          if (updateOffset) {
            hooks.updateOffset(mom, days2 || months2);
          }
        }
        var add2 = createAdder(1, "add");
        var subtract = createAdder(-1, "subtract");
        function getCalendarFormat(myMoment, now2) {
          var diff2 = myMoment.diff(now2, "days", true);
          return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
        }
        function calendar$1(time, formats) {
          var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse";
          var output = formats && (isFunction3(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
          return this.format(output || this.localeData().calendar(format2, this, createLocal(now2)));
        }
        function clone() {
          return new Moment(this);
        }
        function isAfter(input, units) {
          var localInput = isMoment(input) ? input : createLocal(input);
          if (!(this.isValid() && localInput.isValid())) {
            return false;
          }
          units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
          if (units === "millisecond") {
            return this.valueOf() > localInput.valueOf();
          } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
          }
        }
        function isBefore(input, units) {
          var localInput = isMoment(input) ? input : createLocal(input);
          if (!(this.isValid() && localInput.isValid())) {
            return false;
          }
          units = normalizeUnits(!isUndefined(units) ? units : "millisecond");
          if (units === "millisecond") {
            return this.valueOf() < localInput.valueOf();
          } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
          }
        }
        function isBetween(from4, to2, units, inclusivity) {
          inclusivity = inclusivity || "()";
          return (inclusivity[0] === "(" ? this.isAfter(from4, units) : !this.isBefore(from4, units)) && (inclusivity[1] === ")" ? this.isBefore(to2, units) : !this.isAfter(to2, units));
        }
        function isSame(input, units) {
          var localInput = isMoment(input) ? input : createLocal(input), inputMs;
          if (!(this.isValid() && localInput.isValid())) {
            return false;
          }
          units = normalizeUnits(units || "millisecond");
          if (units === "millisecond") {
            return this.valueOf() === localInput.valueOf();
          } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
          }
        }
        function isSameOrAfter(input, units) {
          return this.isSame(input, units) || this.isAfter(input, units);
        }
        function isSameOrBefore(input, units) {
          return this.isSame(input, units) || this.isBefore(input, units);
        }
        function diff(input, units, asFloat) {
          var that, zoneDelta, output;
          if (!this.isValid()) {
            return NaN;
          }
          that = cloneWithOffset(input, this);
          if (!that.isValid()) {
            return NaN;
          }
          zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
          units = normalizeUnits(units);
          switch (units) {
            case "year":
              output = monthDiff(this, that) / 12;
              break;
            case "month":
              output = monthDiff(this, that);
              break;
            case "quarter":
              output = monthDiff(this, that) / 3;
              break;
            case "second":
              output = (this - that) / 1e3;
              break;
            case "minute":
              output = (this - that) / 6e4;
              break;
            case "hour":
              output = (this - that) / 36e5;
              break;
            case "day":
              output = (this - that - zoneDelta) / 864e5;
              break;
            case "week":
              output = (this - that - zoneDelta) / 6048e5;
              break;
            default:
              output = this - that;
          }
          return asFloat ? output : absFloor(output);
        }
        function monthDiff(a, b) {
          var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust2;
          if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            adjust2 = (b - anchor) / (anchor - anchor2);
          } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            adjust2 = (b - anchor) / (anchor2 - anchor);
          }
          return -(wholeMonthDiff + adjust2) || 0;
        }
        hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
        hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
        function toString4() {
          return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
        }
        function toISOString(keepOffset) {
          if (!this.isValid()) {
            return null;
          }
          var utc = keepOffset !== true;
          var m = utc ? this.clone().utc() : this;
          if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
          }
          if (isFunction3(Date.prototype.toISOString)) {
            if (utc) {
              return this.toDate().toISOString();
            } else {
              return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
            }
          }
          return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
        }
        function inspect() {
          if (!this.isValid()) {
            return "moment.invalid(/* " + this._i + " */)";
          }
          var func = "moment";
          var zone = "";
          if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
          }
          var prefix = "[" + func + '("]';
          var year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
          var datetime = "-MM-DD[T]HH:mm:ss.SSS";
          var suffix = zone + '[")]';
          return this.format(prefix + year + datetime + suffix);
        }
        function format(inputString) {
          if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
          }
          var output = formatMoment(this, inputString);
          return this.localeData().postformat(output);
        }
        function from3(time, withoutSuffix) {
          if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
          } else {
            return this.localeData().invalidDate();
          }
        }
        function fromNow(withoutSuffix) {
          return this.from(createLocal(), withoutSuffix);
        }
        function to(time, withoutSuffix) {
          if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
            return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
          } else {
            return this.localeData().invalidDate();
          }
        }
        function toNow(withoutSuffix) {
          return this.to(createLocal(), withoutSuffix);
        }
        function locale(key) {
          var newLocaleData;
          if (key === void 0) {
            return this._locale._abbr;
          } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
              this._locale = newLocaleData;
            }
            return this;
          }
        }
        var lang = deprecate(
          "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
          function(key) {
            if (key === void 0) {
              return this.localeData();
            } else {
              return this.locale(key);
            }
          }
        );
        function localeData() {
          return this._locale;
        }
        function startOf(units) {
          units = normalizeUnits(units);
          switch (units) {
            case "year":
              this.month(0);
            case "quarter":
            case "month":
              this.date(1);
            case "week":
            case "isoWeek":
            case "day":
            case "date":
              this.hours(0);
            case "hour":
              this.minutes(0);
            case "minute":
              this.seconds(0);
            case "second":
              this.milliseconds(0);
          }
          if (units === "week") {
            this.weekday(0);
          }
          if (units === "isoWeek") {
            this.isoWeekday(1);
          }
          if (units === "quarter") {
            this.month(Math.floor(this.month() / 3) * 3);
          }
          return this;
        }
        function endOf(units) {
          units = normalizeUnits(units);
          if (units === void 0 || units === "millisecond") {
            return this;
          }
          if (units === "date") {
            units = "day";
          }
          return this.startOf(units).add(1, units === "isoWeek" ? "week" : units).subtract(1, "ms");
        }
        function valueOf() {
          return this._d.valueOf() - (this._offset || 0) * 6e4;
        }
        function unix() {
          return Math.floor(this.valueOf() / 1e3);
        }
        function toDate() {
          return new Date(this.valueOf());
        }
        function toArray() {
          var m = this;
          return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
        }
        function toObject() {
          var m = this;
          return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
          };
        }
        function toJSON() {
          return this.isValid() ? this.toISOString() : null;
        }
        function isValid$2() {
          return isValid(this);
        }
        function parsingFlags() {
          return extend({}, getParsingFlags(this));
        }
        function invalidAt() {
          return getParsingFlags(this).overflow;
        }
        function creationData() {
          return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
          };
        }
        addFormatToken(0, ["gg", 2], 0, function() {
          return this.weekYear() % 100;
        });
        addFormatToken(0, ["GG", 2], 0, function() {
          return this.isoWeekYear() % 100;
        });
        function addWeekYearFormatToken(token2, getter) {
          addFormatToken(0, [token2, token2.length], 0, getter);
        }
        addWeekYearFormatToken("gggg", "weekYear");
        addWeekYearFormatToken("ggggg", "weekYear");
        addWeekYearFormatToken("GGGG", "isoWeekYear");
        addWeekYearFormatToken("GGGGG", "isoWeekYear");
        addUnitAlias("weekYear", "gg");
        addUnitAlias("isoWeekYear", "GG");
        addUnitPriority("weekYear", 1);
        addUnitPriority("isoWeekYear", 1);
        addRegexToken("G", matchSigned);
        addRegexToken("g", matchSigned);
        addRegexToken("GG", match1to2, match2);
        addRegexToken("gg", match1to2, match2);
        addRegexToken("GGGG", match1to4, match4);
        addRegexToken("gggg", match1to4, match4);
        addRegexToken("GGGGG", match1to6, match6);
        addRegexToken("ggggg", match1to6, match6);
        addWeekParseToken(["gggg", "ggggg", "GGGG", "GGGGG"], function(input, week, config, token2) {
          week[token2.substr(0, 2)] = toInt(input);
        });
        addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
          week[token2] = hooks.parseTwoDigitYear(input);
        });
        function getSetWeekYear(input) {
          return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
          );
        }
        function getSetISOWeekYear(input) {
          return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
          );
        }
        function getISOWeeksInYear() {
          return weeksInYear(this.year(), 1, 4);
        }
        function getWeeksInYear() {
          var weekInfo = this.localeData()._week;
          return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        }
        function getSetWeekYearHelper(input, week, weekday, dow, doy) {
          var weeksTarget;
          if (input == null) {
            return weekOfYear(this, dow, doy).year;
          } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
              week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
          }
        }
        function setWeekAll(weekYear, week, weekday, dow, doy) {
          var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
          this.year(date.getUTCFullYear());
          this.month(date.getUTCMonth());
          this.date(date.getUTCDate());
          return this;
        }
        addFormatToken("Q", 0, "Qo", "quarter");
        addUnitAlias("quarter", "Q");
        addUnitPriority("quarter", 7);
        addRegexToken("Q", match1);
        addParseToken("Q", function(input, array) {
          array[MONTH] = (toInt(input) - 1) * 3;
        });
        function getSetQuarter(input) {
          return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        }
        addFormatToken("D", ["DD", 2], "Do", "date");
        addUnitAlias("date", "D");
        addUnitPriority("date", 9);
        addRegexToken("D", match1to2);
        addRegexToken("DD", match1to2, match2);
        addRegexToken("Do", function(isStrict, locale2) {
          return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
        });
        addParseToken(["D", "DD"], DATE);
        addParseToken("Do", function(input, array) {
          array[DATE] = toInt(input.match(match1to2)[0]);
        });
        var getSetDayOfMonth = makeGetSet("Date", true);
        addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
        addUnitAlias("dayOfYear", "DDD");
        addUnitPriority("dayOfYear", 4);
        addRegexToken("DDD", match1to3);
        addRegexToken("DDDD", match3);
        addParseToken(["DDD", "DDDD"], function(input, array, config) {
          config._dayOfYear = toInt(input);
        });
        function getSetDayOfYear(input) {
          var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
          return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
        }
        addFormatToken("m", ["mm", 2], 0, "minute");
        addUnitAlias("minute", "m");
        addUnitPriority("minute", 14);
        addRegexToken("m", match1to2);
        addRegexToken("mm", match1to2, match2);
        addParseToken(["m", "mm"], MINUTE2);
        var getSetMinute = makeGetSet("Minutes", false);
        addFormatToken("s", ["ss", 2], 0, "second");
        addUnitAlias("second", "s");
        addUnitPriority("second", 15);
        addRegexToken("s", match1to2);
        addRegexToken("ss", match1to2, match2);
        addParseToken(["s", "ss"], SECOND2);
        var getSetSecond = makeGetSet("Seconds", false);
        addFormatToken("S", 0, 0, function() {
          return ~~(this.millisecond() / 100);
        });
        addFormatToken(0, ["SS", 2], 0, function() {
          return ~~(this.millisecond() / 10);
        });
        addFormatToken(0, ["SSS", 3], 0, "millisecond");
        addFormatToken(0, ["SSSS", 4], 0, function() {
          return this.millisecond() * 10;
        });
        addFormatToken(0, ["SSSSS", 5], 0, function() {
          return this.millisecond() * 100;
        });
        addFormatToken(0, ["SSSSSS", 6], 0, function() {
          return this.millisecond() * 1e3;
        });
        addFormatToken(0, ["SSSSSSS", 7], 0, function() {
          return this.millisecond() * 1e4;
        });
        addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
          return this.millisecond() * 1e5;
        });
        addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
          return this.millisecond() * 1e6;
        });
        addUnitAlias("millisecond", "ms");
        addUnitPriority("millisecond", 16);
        addRegexToken("S", match1to3, match1);
        addRegexToken("SS", match1to3, match2);
        addRegexToken("SSS", match1to3, match3);
        var token;
        for (token = "SSSS"; token.length <= 9; token += "S") {
          addRegexToken(token, matchUnsigned);
        }
        function parseMs(input, array) {
          array[MILLISECOND] = toInt(("0." + input) * 1e3);
        }
        for (token = "S"; token.length <= 9; token += "S") {
          addParseToken(token, parseMs);
        }
        var getSetMillisecond = makeGetSet("Milliseconds", false);
        addFormatToken("z", 0, 0, "zoneAbbr");
        addFormatToken("zz", 0, 0, "zoneName");
        function getZoneAbbr() {
          return this._isUTC ? "UTC" : "";
        }
        function getZoneName() {
          return this._isUTC ? "Coordinated Universal Time" : "";
        }
        var proto = Moment.prototype;
        proto.add = add2;
        proto.calendar = calendar$1;
        proto.clone = clone;
        proto.diff = diff;
        proto.endOf = endOf;
        proto.format = format;
        proto.from = from3;
        proto.fromNow = fromNow;
        proto.to = to;
        proto.toNow = toNow;
        proto.get = stringGet;
        proto.invalidAt = invalidAt;
        proto.isAfter = isAfter;
        proto.isBefore = isBefore;
        proto.isBetween = isBetween;
        proto.isSame = isSame;
        proto.isSameOrAfter = isSameOrAfter;
        proto.isSameOrBefore = isSameOrBefore;
        proto.isValid = isValid$2;
        proto.lang = lang;
        proto.locale = locale;
        proto.localeData = localeData;
        proto.max = prototypeMax;
        proto.min = prototypeMin;
        proto.parsingFlags = parsingFlags;
        proto.set = stringSet;
        proto.startOf = startOf;
        proto.subtract = subtract;
        proto.toArray = toArray;
        proto.toObject = toObject;
        proto.toDate = toDate;
        proto.toISOString = toISOString;
        proto.inspect = inspect;
        proto.toJSON = toJSON;
        proto.toString = toString4;
        proto.unix = unix;
        proto.valueOf = valueOf;
        proto.creationData = creationData;
        proto.year = getSetYear;
        proto.isLeapYear = getIsLeapYear;
        proto.weekYear = getSetWeekYear;
        proto.isoWeekYear = getSetISOWeekYear;
        proto.quarter = proto.quarters = getSetQuarter;
        proto.month = getSetMonth;
        proto.daysInMonth = getDaysInMonth;
        proto.week = proto.weeks = getSetWeek;
        proto.isoWeek = proto.isoWeeks = getSetISOWeek;
        proto.weeksInYear = getWeeksInYear;
        proto.isoWeeksInYear = getISOWeeksInYear;
        proto.date = getSetDayOfMonth;
        proto.day = proto.days = getSetDayOfWeek;
        proto.weekday = getSetLocaleDayOfWeek;
        proto.isoWeekday = getSetISODayOfWeek;
        proto.dayOfYear = getSetDayOfYear;
        proto.hour = proto.hours = getSetHour;
        proto.minute = proto.minutes = getSetMinute;
        proto.second = proto.seconds = getSetSecond;
        proto.millisecond = proto.milliseconds = getSetMillisecond;
        proto.utcOffset = getSetOffset;
        proto.utc = setOffsetToUTC;
        proto.local = setOffsetToLocal;
        proto.parseZone = setOffsetToParsedOffset;
        proto.hasAlignedHourOffset = hasAlignedHourOffset;
        proto.isDST = isDaylightSavingTime;
        proto.isLocal = isLocal;
        proto.isUtcOffset = isUtcOffset;
        proto.isUtc = isUtc;
        proto.isUTC = isUtc;
        proto.zoneAbbr = getZoneAbbr;
        proto.zoneName = getZoneName;
        proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
        proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
        proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
        proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
        proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
        function createUnix(input) {
          return createLocal(input * 1e3);
        }
        function createInZone() {
          return createLocal.apply(null, arguments).parseZone();
        }
        function preParsePostFormat(string) {
          return string;
        }
        var proto$1 = Locale.prototype;
        proto$1.calendar = calendar;
        proto$1.longDateFormat = longDateFormat;
        proto$1.invalidDate = invalidDate;
        proto$1.ordinal = ordinal;
        proto$1.preparse = preParsePostFormat;
        proto$1.postformat = preParsePostFormat;
        proto$1.relativeTime = relativeTime;
        proto$1.pastFuture = pastFuture;
        proto$1.set = set2;
        proto$1.months = localeMonths;
        proto$1.monthsShort = localeMonthsShort;
        proto$1.monthsParse = localeMonthsParse;
        proto$1.monthsRegex = monthsRegex;
        proto$1.monthsShortRegex = monthsShortRegex;
        proto$1.week = localeWeek;
        proto$1.firstDayOfYear = localeFirstDayOfYear;
        proto$1.firstDayOfWeek = localeFirstDayOfWeek;
        proto$1.weekdays = localeWeekdays;
        proto$1.weekdaysMin = localeWeekdaysMin;
        proto$1.weekdaysShort = localeWeekdaysShort;
        proto$1.weekdaysParse = localeWeekdaysParse;
        proto$1.weekdaysRegex = weekdaysRegex;
        proto$1.weekdaysShortRegex = weekdaysShortRegex;
        proto$1.weekdaysMinRegex = weekdaysMinRegex;
        proto$1.isPM = localeIsPM;
        proto$1.meridiem = localeMeridiem;
        function get$1(format2, index, field, setter) {
          var locale2 = getLocale();
          var utc = createUTC().set(setter, index);
          return locale2[field](utc, format2);
        }
        function listMonthsImpl(format2, index, field) {
          if (isNumber(format2)) {
            index = format2;
            format2 = void 0;
          }
          format2 = format2 || "";
          if (index != null) {
            return get$1(format2, index, field, "month");
          }
          var i;
          var out = [];
          for (i = 0; i < 12; i++) {
            out[i] = get$1(format2, i, field, "month");
          }
          return out;
        }
        function listWeekdaysImpl(localeSorted, format2, index, field) {
          if (typeof localeSorted === "boolean") {
            if (isNumber(format2)) {
              index = format2;
              format2 = void 0;
            }
            format2 = format2 || "";
          } else {
            format2 = localeSorted;
            index = format2;
            localeSorted = false;
            if (isNumber(format2)) {
              index = format2;
              format2 = void 0;
            }
            format2 = format2 || "";
          }
          var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0;
          if (index != null) {
            return get$1(format2, (index + shift) % 7, field, "day");
          }
          var i;
          var out = [];
          for (i = 0; i < 7; i++) {
            out[i] = get$1(format2, (i + shift) % 7, field, "day");
          }
          return out;
        }
        function listMonths(format2, index) {
          return listMonthsImpl(format2, index, "months");
        }
        function listMonthsShort(format2, index) {
          return listMonthsImpl(format2, index, "monthsShort");
        }
        function listWeekdays(localeSorted, format2, index) {
          return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
        }
        function listWeekdaysShort(localeSorted, format2, index) {
          return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
        }
        function listWeekdaysMin(localeSorted, format2, index) {
          return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
        }
        getSetGlobalLocale("en", {
          dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
          ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
          }
        });
        hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
        hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
        var mathAbs = Math.abs;
        function abs() {
          var data = this._data;
          this._milliseconds = mathAbs(this._milliseconds);
          this._days = mathAbs(this._days);
          this._months = mathAbs(this._months);
          data.milliseconds = mathAbs(data.milliseconds);
          data.seconds = mathAbs(data.seconds);
          data.minutes = mathAbs(data.minutes);
          data.hours = mathAbs(data.hours);
          data.months = mathAbs(data.months);
          data.years = mathAbs(data.years);
          return this;
        }
        function addSubtract$1(duration, input, value, direction) {
          var other = createDuration(input, value);
          duration._milliseconds += direction * other._milliseconds;
          duration._days += direction * other._days;
          duration._months += direction * other._months;
          return duration._bubble();
        }
        function add$1(input, value) {
          return addSubtract$1(this, input, value, 1);
        }
        function subtract$1(input, value) {
          return addSubtract$1(this, input, value, -1);
        }
        function absCeil(number) {
          if (number < 0) {
            return Math.floor(number);
          } else {
            return Math.ceil(number);
          }
        }
        function bubble() {
          var milliseconds2 = this._milliseconds;
          var days2 = this._days;
          var months2 = this._months;
          var data = this._data;
          var seconds2, minutes2, hours2, years2, monthsFromDays;
          if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
            milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
            days2 = 0;
            months2 = 0;
          }
          data.milliseconds = milliseconds2 % 1e3;
          seconds2 = absFloor(milliseconds2 / 1e3);
          data.seconds = seconds2 % 60;
          minutes2 = absFloor(seconds2 / 60);
          data.minutes = minutes2 % 60;
          hours2 = absFloor(minutes2 / 60);
          data.hours = hours2 % 24;
          days2 += absFloor(hours2 / 24);
          monthsFromDays = absFloor(daysToMonths(days2));
          months2 += monthsFromDays;
          days2 -= absCeil(monthsToDays(monthsFromDays));
          years2 = absFloor(months2 / 12);
          months2 %= 12;
          data.days = days2;
          data.months = months2;
          data.years = years2;
          return this;
        }
        function daysToMonths(days2) {
          return days2 * 4800 / 146097;
        }
        function monthsToDays(months2) {
          return months2 * 146097 / 4800;
        }
        function as(units) {
          if (!this.isValid()) {
            return NaN;
          }
          var days2;
          var months2;
          var milliseconds2 = this._milliseconds;
          units = normalizeUnits(units);
          if (units === "month" || units === "year") {
            days2 = this._days + milliseconds2 / 864e5;
            months2 = this._months + daysToMonths(days2);
            return units === "month" ? months2 : months2 / 12;
          } else {
            days2 = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
              case "week":
                return days2 / 7 + milliseconds2 / 6048e5;
              case "day":
                return days2 + milliseconds2 / 864e5;
              case "hour":
                return days2 * 24 + milliseconds2 / 36e5;
              case "minute":
                return days2 * 1440 + milliseconds2 / 6e4;
              case "second":
                return days2 * 86400 + milliseconds2 / 1e3;
              case "millisecond":
                return Math.floor(days2 * 864e5) + milliseconds2;
              default:
                throw new Error("Unknown unit " + units);
            }
          }
        }
        function valueOf$1() {
          if (!this.isValid()) {
            return NaN;
          }
          return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
        }
        function makeAs(alias) {
          return function() {
            return this.as(alias);
          };
        }
        var asMilliseconds = makeAs("ms");
        var asSeconds = makeAs("s");
        var asMinutes = makeAs("m");
        var asHours = makeAs("h");
        var asDays = makeAs("d");
        var asWeeks = makeAs("w");
        var asMonths = makeAs("M");
        var asYears = makeAs("y");
        function clone$1() {
          return createDuration(this);
        }
        function get$2(units) {
          units = normalizeUnits(units);
          return this.isValid() ? this[units + "s"]() : NaN;
        }
        function makeGetter(name) {
          return function() {
            return this.isValid() ? this._data[name] : NaN;
          };
        }
        var milliseconds = makeGetter("milliseconds");
        var seconds = makeGetter("seconds");
        var minutes = makeGetter("minutes");
        var hours = makeGetter("hours");
        var days = makeGetter("days");
        var months = makeGetter("months");
        var years = makeGetter("years");
        function weeks() {
          return absFloor(this.days() / 7);
        }
        var round = Math.round;
        var thresholds = {
          ss: 44,
          // a few seconds to seconds
          s: 45,
          // seconds to minute
          m: 45,
          // minutes to hour
          h: 22,
          // hours to day
          d: 26,
          // days to month
          M: 11
          // months to year
        };
        function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale2) {
          return locale2.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
        }
        function relativeTime$1(posNegDuration, withoutSuffix, locale2) {
          var duration = createDuration(posNegDuration).abs();
          var seconds2 = round(duration.as("s"));
          var minutes2 = round(duration.as("m"));
          var hours2 = round(duration.as("h"));
          var days2 = round(duration.as("d"));
          var months2 = round(duration.as("M"));
          var years2 = round(duration.as("y"));
          var a = seconds2 <= thresholds.ss && ["s", seconds2] || seconds2 < thresholds.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds.d && ["dd", days2] || months2 <= 1 && ["M"] || months2 < thresholds.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
          a[2] = withoutSuffix;
          a[3] = +posNegDuration > 0;
          a[4] = locale2;
          return substituteTimeAgo.apply(null, a);
        }
        function getSetRelativeTimeRounding(roundingFunction) {
          if (roundingFunction === void 0) {
            return round;
          }
          if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
          }
          return false;
        }
        function getSetRelativeTimeThreshold(threshold, limit) {
          if (thresholds[threshold] === void 0) {
            return false;
          }
          if (limit === void 0) {
            return thresholds[threshold];
          }
          thresholds[threshold] = limit;
          if (threshold === "s") {
            thresholds.ss = limit - 1;
          }
          return true;
        }
        function humanize(withSuffix) {
          if (!this.isValid()) {
            return this.localeData().invalidDate();
          }
          var locale2 = this.localeData();
          var output = relativeTime$1(this, !withSuffix, locale2);
          if (withSuffix) {
            output = locale2.pastFuture(+this, output);
          }
          return locale2.postformat(output);
        }
        var abs$1 = Math.abs;
        function sign(x) {
          return (x > 0) - (x < 0) || +x;
        }
        function toISOString$1() {
          if (!this.isValid()) {
            return this.localeData().invalidDate();
          }
          var seconds2 = abs$1(this._milliseconds) / 1e3;
          var days2 = abs$1(this._days);
          var months2 = abs$1(this._months);
          var minutes2, hours2, years2;
          minutes2 = absFloor(seconds2 / 60);
          hours2 = absFloor(minutes2 / 60);
          seconds2 %= 60;
          minutes2 %= 60;
          years2 = absFloor(months2 / 12);
          months2 %= 12;
          var Y = years2;
          var M = months2;
          var D = days2;
          var h = hours2;
          var m = minutes2;
          var s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
          var total = this.asSeconds();
          if (!total) {
            return "P0D";
          }
          var totalSign = total < 0 ? "-" : "";
          var ymSign = sign(this._months) !== sign(total) ? "-" : "";
          var daysSign = sign(this._days) !== sign(total) ? "-" : "";
          var hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
          return totalSign + "P" + (Y ? ymSign + Y + "Y" : "") + (M ? ymSign + M + "M" : "") + (D ? daysSign + D + "D" : "") + (h || m || s ? "T" : "") + (h ? hmsSign + h + "H" : "") + (m ? hmsSign + m + "M" : "") + (s ? hmsSign + s + "S" : "");
        }
        var proto$2 = Duration.prototype;
        proto$2.isValid = isValid$1;
        proto$2.abs = abs;
        proto$2.add = add$1;
        proto$2.subtract = subtract$1;
        proto$2.as = as;
        proto$2.asMilliseconds = asMilliseconds;
        proto$2.asSeconds = asSeconds;
        proto$2.asMinutes = asMinutes;
        proto$2.asHours = asHours;
        proto$2.asDays = asDays;
        proto$2.asWeeks = asWeeks;
        proto$2.asMonths = asMonths;
        proto$2.asYears = asYears;
        proto$2.valueOf = valueOf$1;
        proto$2._bubble = bubble;
        proto$2.clone = clone$1;
        proto$2.get = get$2;
        proto$2.milliseconds = milliseconds;
        proto$2.seconds = seconds;
        proto$2.minutes = minutes;
        proto$2.hours = hours;
        proto$2.days = days;
        proto$2.weeks = weeks;
        proto$2.months = months;
        proto$2.years = years;
        proto$2.humanize = humanize;
        proto$2.toISOString = toISOString$1;
        proto$2.toString = toISOString$1;
        proto$2.toJSON = toISOString$1;
        proto$2.locale = locale;
        proto$2.localeData = localeData;
        proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
        proto$2.lang = lang;
        addFormatToken("X", 0, 0, "unix");
        addFormatToken("x", 0, 0, "valueOf");
        addRegexToken("x", matchSigned);
        addRegexToken("X", matchTimestamp);
        addParseToken("X", function(input, array, config) {
          config._d = new Date(parseFloat(input, 10) * 1e3);
        });
        addParseToken("x", function(input, array, config) {
          config._d = new Date(toInt(input));
        });
        hooks.version = "2.22.2";
        setHookCallback(createLocal);
        hooks.fn = proto;
        hooks.min = min;
        hooks.max = max2;
        hooks.now = now;
        hooks.utc = createUTC;
        hooks.unix = createUnix;
        hooks.months = listMonths;
        hooks.isDate = isDate;
        hooks.locale = getSetGlobalLocale;
        hooks.invalid = createInvalid;
        hooks.duration = createDuration;
        hooks.isMoment = isMoment;
        hooks.weekdays = listWeekdays;
        hooks.parseZone = createInZone;
        hooks.localeData = getLocale;
        hooks.isDuration = isDuration;
        hooks.monthsShort = listMonthsShort;
        hooks.weekdaysMin = listWeekdaysMin;
        hooks.defineLocale = defineLocale;
        hooks.updateLocale = updateLocale;
        hooks.locales = listLocales;
        hooks.weekdaysShort = listWeekdaysShort;
        hooks.normalizeUnits = normalizeUnits;
        hooks.relativeTimeRounding = getSetRelativeTimeRounding;
        hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
        hooks.calendarFormat = getCalendarFormat;
        hooks.prototype = proto;
        hooks.HTML5_FMT = {
          DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
          // <input type="datetime-local" />
          DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
          // <input type="datetime-local" step="1" />
          DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
          // <input type="datetime-local" step="0.001" />
          DATE: "YYYY-MM-DD",
          // <input type="date" />
          TIME: "HH:mm",
          // <input type="time" />
          TIME_SECONDS: "HH:mm:ss",
          // <input type="time" step="1" />
          TIME_MS: "HH:mm:ss.SSS",
          // <input type="time" step="0.001" />
          WEEK: "YYYY-[W]WW",
          // <input type="week" />
          MONTH: "YYYY-MM"
          // <input type="month" />
        };
        return hooks;
      });
    }
  });

  // node_modules/moment-timezone/moment-timezone.js
  var require_moment_timezone = __commonJS({
    "node_modules/moment-timezone/moment-timezone.js"(exports, module) {
      (function(root, factory) {
        "use strict";
        if (typeof module === "object" && module.exports) {
          module.exports = factory(require_moment());
        } else if (typeof define === "function" && define.amd) {
          define(["moment"], factory);
        } else {
          factory(root.moment);
        }
      })(exports, function(moment) {
        "use strict";
        if (moment.version === void 0 && moment.default) {
          moment = moment.default;
        }
        var VERSION = "0.5.31", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
        if (!moment || typeof moment.version !== "string") {
          logError("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/");
        }
        var momentVersion = moment.version.split("."), major = +momentVersion[0], minor = +momentVersion[1];
        if (major < 2 || major === 2 && minor < 6) {
          logError("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + moment.version + ". See momentjs.com");
        }
        function charCodeToInt(charCode) {
          if (charCode > 96) {
            return charCode - 87;
          } else if (charCode > 64) {
            return charCode - 29;
          }
          return charCode - 48;
        }
        function unpackBase60(string) {
          var i = 0, parts = string.split("."), whole = parts[0], fractional = parts[1] || "", multiplier = 1, num, out = 0, sign = 1;
          if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
          }
          for (i; i < whole.length; i++) {
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
          }
          for (i = 0; i < fractional.length; i++) {
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
          }
          return out * sign;
        }
        function arrayToInt(array) {
          for (var i = 0; i < array.length; i++) {
            array[i] = unpackBase60(array[i]);
          }
        }
        function intToUntil(array, length2) {
          for (var i = 0; i < length2; i++) {
            array[i] = Math.round((array[i - 1] || 0) + array[i] * 6e4);
          }
          array[length2 - 1] = Infinity;
        }
        function mapIndices(source, indices) {
          var out = [], i;
          for (i = 0; i < indices.length; i++) {
            out[i] = source[indices[i]];
          }
          return out;
        }
        function unpack(string) {
          var data = string.split("|"), offsets = data[2].split(" "), indices = data[3].split(""), untils = data[4].split(" ");
          arrayToInt(offsets);
          arrayToInt(indices);
          arrayToInt(untils);
          intToUntil(untils, indices.length);
          return {
            name: data[0],
            abbrs: mapIndices(data[1].split(" "), indices),
            offsets: mapIndices(offsets, indices),
            untils,
            population: data[5] | 0
          };
        }
        function Zone(packedString) {
          if (packedString) {
            this._set(unpack(packedString));
          }
        }
        Zone.prototype = {
          _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
          },
          _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            for (i = 0; i < untils.length; i++) {
              if (target < untils[i]) {
                return i;
              }
            }
          },
          countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
              return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
          },
          parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max2 = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for (i = 0; i < max2; i++) {
              offset = offsets[i];
              offsetNext = offsets[i + 1];
              offsetPrev = offsets[i ? i - 1 : i];
              if (offset < offsetNext && tz.moveAmbiguousForward) {
                offset = offsetNext;
              } else if (offset > offsetPrev && tz.moveInvalidForward) {
                offset = offsetPrev;
              }
              if (target < untils[i] - offset * 6e4) {
                return offsets[i];
              }
            }
            return offsets[max2];
          },
          abbr: function(mom) {
            return this.abbrs[this._index(mom)];
          },
          offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
          },
          utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
          }
        };
        function Country(country_name, zone_names) {
          this.name = country_name;
          this.zones = zone_names;
        }
        function OffsetAt(at) {
          var timeString = at.toTimeString();
          var abbr = timeString.match(/\([a-z ]+\)/i);
          if (abbr && abbr[0]) {
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join("") : void 0;
          } else {
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : void 0;
          }
          if (abbr === "GMT") {
            abbr = void 0;
          }
          this.at = +at;
          this.abbr = abbr;
          this.offset = at.getTimezoneOffset();
        }
        function ZoneScore(zone) {
          this.zone = zone;
          this.offsetScore = 0;
          this.abbrScore = 0;
        }
        ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
          this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
          if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, "") !== offsetAt.abbr) {
            this.abbrScore++;
          }
        };
        function findChange(low, high) {
          var mid, diff;
          while (diff = ((high.at - low.at) / 12e4 | 0) * 6e4) {
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) {
              low = mid;
            } else {
              high = mid;
            }
          }
          return low;
        }
        function userOffsets() {
          var startYear = (/* @__PURE__ */ new Date()).getFullYear() - 2, last3 = new OffsetAt(new Date(startYear, 0, 1)), offsets = [last3], change, next, i;
          for (i = 1; i < 48; i++) {
            next = new OffsetAt(new Date(startYear, i, 1));
            if (next.offset !== last3.offset) {
              change = findChange(last3, next);
              offsets.push(change);
              offsets.push(new OffsetAt(new Date(change.at + 6e4)));
            }
            last3 = next;
          }
          for (i = 0; i < 4; i++) {
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
          }
          return offsets;
        }
        function sortZoneScores(a, b) {
          if (a.offsetScore !== b.offsetScore) {
            return a.offsetScore - b.offsetScore;
          }
          if (a.abbrScore !== b.abbrScore) {
            return a.abbrScore - b.abbrScore;
          }
          if (a.zone.population !== b.zone.population) {
            return b.zone.population - a.zone.population;
          }
          return b.zone.name.localeCompare(a.zone.name);
        }
        function addToGuesses(name, offsets) {
          var i, offset;
          arrayToInt(offsets);
          for (i = 0; i < offsets.length; i++) {
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
          }
        }
        function guessesForUserOffsets(offsets) {
          var offsetsLength = offsets.length, filteredGuesses = {}, out = [], i, j, guessesOffset;
          for (i = 0; i < offsetsLength; i++) {
            guessesOffset = guesses[offsets[i].offset] || {};
            for (j in guessesOffset) {
              if (guessesOffset.hasOwnProperty(j)) {
                filteredGuesses[j] = true;
              }
            }
          }
          for (i in filteredGuesses) {
            if (filteredGuesses.hasOwnProperty(i)) {
              out.push(names[i]);
            }
          }
          return out;
        }
        function rebuildGuess() {
          try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
              var name = names[normalizeName(intlName)];
              if (name) {
                return name;
              }
              logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
          } catch (e) {
          }
          var offsets = userOffsets(), offsetsLength = offsets.length, guesses2 = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
          for (i = 0; i < guesses2.length; i++) {
            zoneScore = new ZoneScore(getZone(guesses2[i]), offsetsLength);
            for (j = 0; j < offsetsLength; j++) {
              zoneScore.scoreOffsetAt(offsets[j]);
            }
            zoneScores.push(zoneScore);
          }
          zoneScores.sort(sortZoneScores);
          return zoneScores.length > 0 ? zoneScores[0].zone.name : void 0;
        }
        function guess(ignoreCache) {
          if (!cachedGuess || ignoreCache) {
            cachedGuess = rebuildGuess();
          }
          return cachedGuess;
        }
        function normalizeName(name) {
          return (name || "").toLowerCase().replace(/\//g, "_");
        }
        function addZone(packed) {
          var i, name, split4, normalized;
          if (typeof packed === "string") {
            packed = [packed];
          }
          for (i = 0; i < packed.length; i++) {
            split4 = packed[i].split("|");
            name = split4[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split4[2].split(" "));
          }
        }
        function getZone(name, caller) {
          name = normalizeName(name);
          var zone = zones[name];
          var link;
          if (zone instanceof Zone) {
            return zone;
          }
          if (typeof zone === "string") {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
          }
          if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
          }
          return null;
        }
        function getNames() {
          var i, out = [];
          for (i in names) {
            if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
              out.push(names[i]);
            }
          }
          return out.sort();
        }
        function getCountryNames() {
          return Object.keys(countries);
        }
        function addLink(aliases) {
          var i, alias, normal0, normal1;
          if (typeof aliases === "string") {
            aliases = [aliases];
          }
          for (i = 0; i < aliases.length; i++) {
            alias = aliases[i].split("|");
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
          }
        }
        function addCountries(data) {
          var i, country_code, country_zones, split4;
          if (!data || !data.length)
            return;
          for (i = 0; i < data.length; i++) {
            split4 = data[i].split("|");
            country_code = split4[0].toUpperCase();
            country_zones = split4[1].split(" ");
            countries[country_code] = new Country(
              country_code,
              country_zones
            );
          }
        }
        function getCountry(name) {
          name = name.toUpperCase();
          return countries[name] || null;
        }
        function zonesForCountry(country, with_offset) {
          country = getCountry(country);
          if (!country)
            return null;
          var zones2 = country.zones.sort();
          if (with_offset) {
            return zones2.map(function(zone_name) {
              var zone = getZone(zone_name);
              return {
                name: zone_name,
                offset: zone.utcOffset(/* @__PURE__ */ new Date())
              };
            });
          }
          return zones2;
        }
        function loadData(data) {
          addZone(data.zones);
          addLink(data.links);
          addCountries(data.countries);
          tz.dataVersion = data.version;
        }
        function zoneExists(name) {
          if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
          }
          return !!getZone(name);
        }
        function needsOffset(m) {
          var isUnixTimestamp = m._f === "X" || m._f === "x";
          return !!(m._a && m._tzm === void 0 && !isUnixTimestamp);
        }
        function logError(message) {
          if (typeof console !== "undefined" && typeof console.error === "function") {
            console.error(message);
          }
        }
        function tz(input) {
          var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], zone = getZone(name), out = moment.utc.apply(null, args);
          if (zone && !moment.isMoment(input) && needsOffset(out)) {
            out.add(zone.parse(out), "minutes");
          }
          out.tz(name);
          return out;
        }
        tz.version = VERSION;
        tz.dataVersion = "";
        tz._zones = zones;
        tz._links = links;
        tz._names = names;
        tz._countries = countries;
        tz.add = addZone;
        tz.link = addLink;
        tz.load = loadData;
        tz.zone = getZone;
        tz.zoneExists = zoneExists;
        tz.guess = guess;
        tz.names = getNames;
        tz.Zone = Zone;
        tz.unpack = unpack;
        tz.unpackBase60 = unpackBase60;
        tz.needsOffset = needsOffset;
        tz.moveInvalidForward = true;
        tz.moveAmbiguousForward = false;
        tz.countries = getCountryNames;
        tz.zonesForCountry = zonesForCountry;
        var fn = moment.fn;
        moment.tz = tz;
        moment.defaultZone = null;
        moment.updateOffset = function(mom, keepTime) {
          var zone = moment.defaultZone, offset;
          if (mom._z === void 0) {
            if (zone && needsOffset(mom) && !mom._isUTC) {
              mom._d = moment.utc(mom._a)._d;
              mom.utc().add(zone.parse(mom), "minutes");
            }
            mom._z = zone;
          }
          if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) {
              offset = offset / 60;
            }
            if (mom.utcOffset !== void 0) {
              var z = mom._z;
              mom.utcOffset(-offset, keepTime);
              mom._z = z;
            } else {
              mom.zone(offset, keepTime);
            }
          }
        };
        fn.tz = function(name, keepTime) {
          if (name) {
            if (typeof name !== "string") {
              throw new Error("Time zone name must be a string, got " + name + " [" + typeof name + "]");
            }
            this._z = getZone(name);
            if (this._z) {
              moment.updateOffset(this, keepTime);
            } else {
              logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            }
            return this;
          }
          if (this._z) {
            return this._z.name;
          }
        };
        function abbrWrap(old) {
          return function() {
            if (this._z) {
              return this._z.abbr(this);
            }
            return old.call(this);
          };
        }
        function resetZoneWrap(old) {
          return function() {
            this._z = null;
            return old.apply(this, arguments);
          };
        }
        function resetZoneWrap2(old) {
          return function() {
            if (arguments.length > 0)
              this._z = null;
            return old.apply(this, arguments);
          };
        }
        fn.zoneName = abbrWrap(fn.zoneName);
        fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
        fn.utc = resetZoneWrap(fn.utc);
        fn.local = resetZoneWrap(fn.local);
        fn.utcOffset = resetZoneWrap2(fn.utcOffset);
        moment.tz.setDefault = function(name) {
          if (major < 2 || major === 2 && minor < 9) {
            logError("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + moment.version + ".");
          }
          moment.defaultZone = name ? getZone(name) : null;
          return moment;
        };
        var momentProperties = moment.momentProperties;
        if (Object.prototype.toString.call(momentProperties) === "[object Array]") {
          momentProperties.push("_z");
          momentProperties.push("_a");
        } else if (momentProperties) {
          momentProperties._z = null;
        }
        return moment;
      });
    }
  });

  // node_modules/moment-timezone/data/packed/latest.json
  var require_latest = __commonJS({
    "node_modules/moment-timezone/data/packed/latest.json"(exports, module) {
      module.exports = {
        version: "2020a",
        zones: [
          "Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5",
          "Africa/Accra|LMT GMT +0020|.Q 0 -k|012121212121212121212121212121212121212121212121|-26BbX.8 6tzX.8 MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE 1BAk MnE 1C0k MnE 1BAk MnE 1BAk MnE|41e5",
          "Africa/Nairobi|LMT EAT +0230 +0245|-2r.g -30 -2u -2J|01231|-1F3Cr.g 3Dzr.g okMu MFXJ|47e5",
          "Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5",
          "Africa/Lagos|LMT WAT|-d.A -10|01|-22y0d.A|17e6",
          "Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4",
          "Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5",
          "Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6",
          "Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5",
          "Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3",
          "Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4",
          "Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5",
          "Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|01212121212121212121212121212121213|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0|",
          "Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5",
          "Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5",
          "Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5",
          "Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|",
          "Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5",
          "Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5",
          "Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4",
          "America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326",
          "America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4",
          "America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3",
          "America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4",
          "America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
          "America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
          "America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|",
          "America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|",
          "America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
          "America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|",
          "America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|",
          "America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|",
          "America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|",
          "America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|",
          "America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|",
          "America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|",
          "America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4",
          "America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5",
          "America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2",
          "America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3",
          "America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5",
          "America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4",
          "America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5",
          "America/Belize|LMT CST -0530 CDT|5Q.M 60 5u 50|01212121212121212121212121212121212121212121212121213131|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1f0Mu qn0 lxB0 mn0|57e3",
          "America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2",
          "America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2",
          "America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5",
          "America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4",
          "America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2",
          "America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4",
          "America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4",
          "America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5",
          "America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3",
          "America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5",
          "America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5",
          "America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4",
          "America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5",
          "America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2",
          "America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4",
          "America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8",
          "America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3",
          "America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|13e2",
          "America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5",
          "America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5",
          "America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5",
          "America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3",
          "America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5",
          "America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5",
          "America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2",
          "America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5",
          "America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
          "America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3",
          "America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2",
          "America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|01212121212121212121212121212121212121212121212121212121212121212121212121232121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 5Ip0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2",
          "America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5",
          "America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5",
          "America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4",
          "America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4",
          "America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5",
          "America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4",
          "America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2",
          "America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2",
          "America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4",
          "America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3",
          "America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5",
          "America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6",
          "America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6",
          "America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4",
          "America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5",
          "America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5",
          "America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4",
          "America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4",
          "America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4",
          "America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2",
          "America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5",
          "America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
          "America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6",
          "America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2",
          "America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3",
          "America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5",
          "America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5",
          "America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5",
          "America/Nassau|LMT EST EDT|59.u 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2kNuO.u 26XdO.u 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4",
          "America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6",
          "America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2",
          "America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2",
          "America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2",
          "America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3",
          "America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2",
          "America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4",
          "America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5",
          "America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
          "America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4",
          "America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4",
          "America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5",
          "America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|",
          "America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842",
          "America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2",
          "America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5",
          "America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4",
          "America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229",
          "America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4",
          "America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5",
          "America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5",
          "America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6",
          "America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452",
          "America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2",
          "America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
          "America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3",
          "America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5",
          "America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656",
          "America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4",
          "America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5",
          "America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|01010230405656565656565656565656565656565656565656565656565656565656565656565656565656565657|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|23e3",
          "America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4",
          "America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642",
          "America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3",
          "Antarctica/Casey|-00 +08 +11|0 -80 -b0|01212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10|10",
          "Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70",
          "Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80",
          "Antarctica/Macquarie|AEST AEDT -00 +11|-a0 -b0 0 -b0|0102010101010101010101010101010101010101010101010101010101010101010101010101010101010101013|-29E80 19X0 4SL0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0|1",
          "Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60",
          "Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5",
          "Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40",
          "Antarctica/Rothera|-00 -03|0 30|01|gOo0|130",
          "Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20",
          "Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40",
          "Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25",
          "Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4",
          "Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5",
          "Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5",
          "Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5",
          "Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3",
          "Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4",
          "Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4",
          "Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4",
          "Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
          "Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5",
          "Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4",
          "Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5",
          "Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6",
          "Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|",
          "Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5",
          "Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4",
          "Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4",
          "Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6",
          "Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4",
          "Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3",
          "Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6",
          "Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5",
          "Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6",
          "Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5",
          "Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4",
          "Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5",
          "Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4",
          "Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
          "Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|0101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|18e5",
          "Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2q0 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 pBd0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nz0 1220 1qL0 WN0 1qL0 WN0 1qL0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0 Wo0 1rc0 11c0 1oo0 11c0 1oo0 11c0 1oo0 11c0 1rc0|25e4",
          "Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5",
          "Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5",
          "Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3",
          "Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
          "Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6",
          "Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6",
          "Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4",
          "Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|012121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyMk.E 5Rb0 10r0 1px0 10N0 1pz0 16p0 1jB0 16p0 1jx0 3LB0 Em0 or0 1cn0 1dB0 16n0 10O0 1ja0 1tC0 14o0 1cM0 1a00 11A0 1Na0 An0 1MP0 AJ0 1Kp0 LC0 1oo0 Wl0 EQN0 Db0 1fB0 Rb0 bXd0 gM0 8Q00 IM0 1wM0 11z0 1C10 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4",
          "Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5",
          "Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4",
          "Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6",
          "Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5",
          "Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5",
          "Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2",
          "Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5",
          "Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5",
          "Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4",
          "Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4",
          "Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3",
          "Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5",
          "Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6",
          "Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4",
          "Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4",
          "Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5",
          "Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5",
          "Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4",
          "Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4",
          "Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5",
          "Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|",
          "Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4",
          "Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5",
          "Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4",
          "Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4",
          "Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6",
          "Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2",
          "Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5",
          "Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5",
          "Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5",
          "Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6",
          "Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3",
          "Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6",
          "Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5",
          "Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5",
          "Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2",
          "Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4",
          "Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4",
          "Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5",
          "Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5",
          "Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4",
          "Atlantic/Bermuda|LMT AST ADT|4j.i 40 30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1BnRE.G 1LTbE.G 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3",
          "Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
          "Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4",
          "Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3",
          "Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4",
          "Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4",
          "Atlantic/South_Georgia|-02|20|0||30",
          "Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2",
          "Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5",
          "Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5",
          "Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5",
          "Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3",
          "Australia/Currie|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|746",
          "Australia/Darwin|ACST ACDT|-9u -au|010101010|-293lt xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0|12e4",
          "Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293kI xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368",
          "Australia/Hobart|AEST AEDT|-a0 -b0|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 19X0 10jd0 yL0 1cN0 1cL0 1fB0 19X0 VfB0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4",
          "Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347",
          "Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10",
          "Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293lX xcX 10jd0 yL0 1cN0 1cL0 1fB0 19X0 17c10 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5",
          "Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293jX xcX 10jd0 yL0 1cN0 1cL0 1gSp0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5",
          "CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
          "Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2",
          "CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
          "Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
          "EST|EST|50|0||",
          "EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "Etc/GMT-0|GMT|0|0||",
          "Etc/GMT-1|+01|-10|0||",
          "Pacific/Port_Moresby|+10|-a0|0||25e4",
          "Etc/GMT-11|+11|-b0|0||",
          "Pacific/Tarawa|+12|-c0|0||29e3",
          "Etc/GMT-13|+13|-d0|0||",
          "Etc/GMT-14|+14|-e0|0||",
          "Etc/GMT-2|+02|-20|0||",
          "Etc/GMT-3|+03|-30|0||",
          "Etc/GMT-4|+04|-40|0||",
          "Etc/GMT-5|+05|-50|0||",
          "Etc/GMT-6|+06|-60|0||",
          "Indian/Christmas|+07|-70|0||21e2",
          "Etc/GMT-8|+08|-80|0||",
          "Pacific/Palau|+09|-90|0||21e3",
          "Etc/GMT+1|-01|10|0||",
          "Etc/GMT+10|-10|a0|0||",
          "Etc/GMT+11|-11|b0|0||",
          "Etc/GMT+12|-12|c0|0||",
          "Etc/GMT+3|-03|30|0||",
          "Etc/GMT+4|-04|40|0||",
          "Etc/GMT+5|-05|50|0||",
          "Etc/GMT+6|-06|60|0||",
          "Etc/GMT+7|-07|70|0||",
          "Etc/GMT+8|-08|80|0||",
          "Etc/GMT+9|-09|90|0||",
          "Etc/UTC|UTC|0|0||",
          "Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5",
          "Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3",
          "Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5",
          "Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5",
          "Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6",
          "Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
          "Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5",
          "Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5",
          "Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5",
          "Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5",
          "Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1ip0 17b0 1op0 1tb0 Q2m0 3Ne0 WM0 1fA0 1cM0 1cM0 1oJ0 1dc0 1030 1fA0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1iM0 1fA0 8Ha0 Rb0 1wN0 Rb0 1BB0 Lz0 1C20 LB0 SNX0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
          "Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4",
          "Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4",
          "Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
          "Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3",
          "Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
          "Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4",
          "Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5",
          "Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4",
          "Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5",
          "Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
          "Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5",
          "Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
          "Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5",
          "Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3",
          "Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6",
          "Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco8.l cNb8.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6",
          "Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4",
          "Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5",
          "Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5",
          "Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|",
          "Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4",
          "Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5",
          "Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5",
          "Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4",
          "Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4",
          "Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5",
          "Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4",
          "Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5",
          "Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4",
          "Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0|10e5",
          "Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5",
          "Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4",
          "HST|HST|a0|0||",
          "Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2",
          "Indian/Cocos|+0630|-6u|0||596",
          "Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130",
          "Indian/Mahe|LMT +04|-3F.M -40|01|-2yO3F.M|79e3",
          "Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4",
          "Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4",
          "Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4",
          "Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3",
          "MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|",
          "MST|MST|70|0||",
          "MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600",
          "Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3",
          "Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4",
          "Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3",
          "Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|0121212121212121212121|-2l9nd.g 2Szcd.g 1cL0 1oN0 10L0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3",
          "Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1",
          "Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483",
          "Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4",
          "Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3",
          "Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125",
          "Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4",
          "Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4",
          "Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4",
          "Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2",
          "Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2",
          "Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3",
          "Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2",
          "Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2",
          "Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3",
          "Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2",
          "Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4",
          "Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3",
          "Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56",
          "Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3",
          "Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3",
          "Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4",
          "Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3",
          "PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|",
          "WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"
        ],
        links: [
          "Africa/Abidjan|Africa/Bamako",
          "Africa/Abidjan|Africa/Banjul",
          "Africa/Abidjan|Africa/Conakry",
          "Africa/Abidjan|Africa/Dakar",
          "Africa/Abidjan|Africa/Freetown",
          "Africa/Abidjan|Africa/Lome",
          "Africa/Abidjan|Africa/Nouakchott",
          "Africa/Abidjan|Africa/Ouagadougou",
          "Africa/Abidjan|Africa/Timbuktu",
          "Africa/Abidjan|Atlantic/St_Helena",
          "Africa/Cairo|Egypt",
          "Africa/Johannesburg|Africa/Maseru",
          "Africa/Johannesburg|Africa/Mbabane",
          "Africa/Lagos|Africa/Bangui",
          "Africa/Lagos|Africa/Brazzaville",
          "Africa/Lagos|Africa/Douala",
          "Africa/Lagos|Africa/Kinshasa",
          "Africa/Lagos|Africa/Libreville",
          "Africa/Lagos|Africa/Luanda",
          "Africa/Lagos|Africa/Malabo",
          "Africa/Lagos|Africa/Niamey",
          "Africa/Lagos|Africa/Porto-Novo",
          "Africa/Maputo|Africa/Blantyre",
          "Africa/Maputo|Africa/Bujumbura",
          "Africa/Maputo|Africa/Gaborone",
          "Africa/Maputo|Africa/Harare",
          "Africa/Maputo|Africa/Kigali",
          "Africa/Maputo|Africa/Lubumbashi",
          "Africa/Maputo|Africa/Lusaka",
          "Africa/Nairobi|Africa/Addis_Ababa",
          "Africa/Nairobi|Africa/Asmara",
          "Africa/Nairobi|Africa/Asmera",
          "Africa/Nairobi|Africa/Dar_es_Salaam",
          "Africa/Nairobi|Africa/Djibouti",
          "Africa/Nairobi|Africa/Kampala",
          "Africa/Nairobi|Africa/Mogadishu",
          "Africa/Nairobi|Indian/Antananarivo",
          "Africa/Nairobi|Indian/Comoro",
          "Africa/Nairobi|Indian/Mayotte",
          "Africa/Tripoli|Libya",
          "America/Adak|America/Atka",
          "America/Adak|US/Aleutian",
          "America/Anchorage|US/Alaska",
          "America/Argentina/Buenos_Aires|America/Buenos_Aires",
          "America/Argentina/Catamarca|America/Argentina/ComodRivadavia",
          "America/Argentina/Catamarca|America/Catamarca",
          "America/Argentina/Cordoba|America/Cordoba",
          "America/Argentina/Cordoba|America/Rosario",
          "America/Argentina/Jujuy|America/Jujuy",
          "America/Argentina/Mendoza|America/Mendoza",
          "America/Atikokan|America/Coral_Harbour",
          "America/Chicago|US/Central",
          "America/Curacao|America/Aruba",
          "America/Curacao|America/Kralendijk",
          "America/Curacao|America/Lower_Princes",
          "America/Denver|America/Shiprock",
          "America/Denver|Navajo",
          "America/Denver|US/Mountain",
          "America/Detroit|US/Michigan",
          "America/Edmonton|Canada/Mountain",
          "America/Fort_Wayne|America/Indiana/Indianapolis",
          "America/Fort_Wayne|America/Indianapolis",
          "America/Fort_Wayne|US/East-Indiana",
          "America/Godthab|America/Nuuk",
          "America/Halifax|Canada/Atlantic",
          "America/Havana|Cuba",
          "America/Indiana/Knox|America/Knox_IN",
          "America/Indiana/Knox|US/Indiana-Starke",
          "America/Jamaica|Jamaica",
          "America/Kentucky/Louisville|America/Louisville",
          "America/Los_Angeles|US/Pacific",
          "America/Los_Angeles|US/Pacific-New",
          "America/Manaus|Brazil/West",
          "America/Mazatlan|Mexico/BajaSur",
          "America/Mexico_City|Mexico/General",
          "America/New_York|US/Eastern",
          "America/Noronha|Brazil/DeNoronha",
          "America/Panama|America/Cayman",
          "America/Phoenix|US/Arizona",
          "America/Port_of_Spain|America/Anguilla",
          "America/Port_of_Spain|America/Antigua",
          "America/Port_of_Spain|America/Dominica",
          "America/Port_of_Spain|America/Grenada",
          "America/Port_of_Spain|America/Guadeloupe",
          "America/Port_of_Spain|America/Marigot",
          "America/Port_of_Spain|America/Montserrat",
          "America/Port_of_Spain|America/St_Barthelemy",
          "America/Port_of_Spain|America/St_Kitts",
          "America/Port_of_Spain|America/St_Lucia",
          "America/Port_of_Spain|America/St_Thomas",
          "America/Port_of_Spain|America/St_Vincent",
          "America/Port_of_Spain|America/Tortola",
          "America/Port_of_Spain|America/Virgin",
          "America/Regina|Canada/Saskatchewan",
          "America/Rio_Branco|America/Porto_Acre",
          "America/Rio_Branco|Brazil/Acre",
          "America/Santiago|Chile/Continental",
          "America/Sao_Paulo|Brazil/East",
          "America/St_Johns|Canada/Newfoundland",
          "America/Tijuana|America/Ensenada",
          "America/Tijuana|America/Santa_Isabel",
          "America/Tijuana|Mexico/BajaNorte",
          "America/Toronto|America/Montreal",
          "America/Toronto|Canada/Eastern",
          "America/Vancouver|Canada/Pacific",
          "America/Whitehorse|Canada/Yukon",
          "America/Winnipeg|Canada/Central",
          "Asia/Ashgabat|Asia/Ashkhabad",
          "Asia/Bangkok|Asia/Phnom_Penh",
          "Asia/Bangkok|Asia/Vientiane",
          "Asia/Dhaka|Asia/Dacca",
          "Asia/Dubai|Asia/Muscat",
          "Asia/Ho_Chi_Minh|Asia/Saigon",
          "Asia/Hong_Kong|Hongkong",
          "Asia/Jerusalem|Asia/Tel_Aviv",
          "Asia/Jerusalem|Israel",
          "Asia/Kathmandu|Asia/Katmandu",
          "Asia/Kolkata|Asia/Calcutta",
          "Asia/Kuala_Lumpur|Asia/Singapore",
          "Asia/Kuala_Lumpur|Singapore",
          "Asia/Macau|Asia/Macao",
          "Asia/Makassar|Asia/Ujung_Pandang",
          "Asia/Nicosia|Europe/Nicosia",
          "Asia/Qatar|Asia/Bahrain",
          "Asia/Rangoon|Asia/Yangon",
          "Asia/Riyadh|Asia/Aden",
          "Asia/Riyadh|Asia/Kuwait",
          "Asia/Seoul|ROK",
          "Asia/Shanghai|Asia/Chongqing",
          "Asia/Shanghai|Asia/Chungking",
          "Asia/Shanghai|Asia/Harbin",
          "Asia/Shanghai|PRC",
          "Asia/Taipei|ROC",
          "Asia/Tehran|Iran",
          "Asia/Thimphu|Asia/Thimbu",
          "Asia/Tokyo|Japan",
          "Asia/Ulaanbaatar|Asia/Ulan_Bator",
          "Asia/Urumqi|Asia/Kashgar",
          "Atlantic/Faroe|Atlantic/Faeroe",
          "Atlantic/Reykjavik|Iceland",
          "Atlantic/South_Georgia|Etc/GMT+2",
          "Australia/Adelaide|Australia/South",
          "Australia/Brisbane|Australia/Queensland",
          "Australia/Broken_Hill|Australia/Yancowinna",
          "Australia/Darwin|Australia/North",
          "Australia/Hobart|Australia/Tasmania",
          "Australia/Lord_Howe|Australia/LHI",
          "Australia/Melbourne|Australia/Victoria",
          "Australia/Perth|Australia/West",
          "Australia/Sydney|Australia/ACT",
          "Australia/Sydney|Australia/Canberra",
          "Australia/Sydney|Australia/NSW",
          "Etc/GMT-0|Etc/GMT",
          "Etc/GMT-0|Etc/GMT+0",
          "Etc/GMT-0|Etc/GMT0",
          "Etc/GMT-0|Etc/Greenwich",
          "Etc/GMT-0|GMT",
          "Etc/GMT-0|GMT+0",
          "Etc/GMT-0|GMT-0",
          "Etc/GMT-0|GMT0",
          "Etc/GMT-0|Greenwich",
          "Etc/UTC|Etc/UCT",
          "Etc/UTC|Etc/Universal",
          "Etc/UTC|Etc/Zulu",
          "Etc/UTC|UCT",
          "Etc/UTC|UTC",
          "Etc/UTC|Universal",
          "Etc/UTC|Zulu",
          "Europe/Belgrade|Europe/Ljubljana",
          "Europe/Belgrade|Europe/Podgorica",
          "Europe/Belgrade|Europe/Sarajevo",
          "Europe/Belgrade|Europe/Skopje",
          "Europe/Belgrade|Europe/Zagreb",
          "Europe/Chisinau|Europe/Tiraspol",
          "Europe/Dublin|Eire",
          "Europe/Helsinki|Europe/Mariehamn",
          "Europe/Istanbul|Asia/Istanbul",
          "Europe/Istanbul|Turkey",
          "Europe/Lisbon|Portugal",
          "Europe/London|Europe/Belfast",
          "Europe/London|Europe/Guernsey",
          "Europe/London|Europe/Isle_of_Man",
          "Europe/London|Europe/Jersey",
          "Europe/London|GB",
          "Europe/London|GB-Eire",
          "Europe/Moscow|W-SU",
          "Europe/Oslo|Arctic/Longyearbyen",
          "Europe/Oslo|Atlantic/Jan_Mayen",
          "Europe/Prague|Europe/Bratislava",
          "Europe/Rome|Europe/San_Marino",
          "Europe/Rome|Europe/Vatican",
          "Europe/Warsaw|Poland",
          "Europe/Zurich|Europe/Busingen",
          "Europe/Zurich|Europe/Vaduz",
          "Indian/Christmas|Etc/GMT-7",
          "Pacific/Auckland|Antarctica/McMurdo",
          "Pacific/Auckland|Antarctica/South_Pole",
          "Pacific/Auckland|NZ",
          "Pacific/Chatham|NZ-CHAT",
          "Pacific/Chuuk|Pacific/Truk",
          "Pacific/Chuuk|Pacific/Yap",
          "Pacific/Easter|Chile/EasterIsland",
          "Pacific/Guam|Pacific/Saipan",
          "Pacific/Honolulu|Pacific/Johnston",
          "Pacific/Honolulu|US/Hawaii",
          "Pacific/Kwajalein|Kwajalein",
          "Pacific/Pago_Pago|Pacific/Midway",
          "Pacific/Pago_Pago|Pacific/Samoa",
          "Pacific/Pago_Pago|US/Samoa",
          "Pacific/Palau|Etc/GMT-9",
          "Pacific/Pohnpei|Pacific/Ponape",
          "Pacific/Port_Moresby|Etc/GMT-10",
          "Pacific/Tarawa|Etc/GMT-12",
          "Pacific/Tarawa|Pacific/Funafuti",
          "Pacific/Tarawa|Pacific/Wake",
          "Pacific/Tarawa|Pacific/Wallis"
        ],
        countries: [
          "AD|Europe/Andorra",
          "AE|Asia/Dubai",
          "AF|Asia/Kabul",
          "AG|America/Port_of_Spain America/Antigua",
          "AI|America/Port_of_Spain America/Anguilla",
          "AL|Europe/Tirane",
          "AM|Asia/Yerevan",
          "AO|Africa/Lagos Africa/Luanda",
          "AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo",
          "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia",
          "AS|Pacific/Pago_Pago",
          "AT|Europe/Vienna",
          "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla",
          "AW|America/Curacao America/Aruba",
          "AX|Europe/Helsinki Europe/Mariehamn",
          "AZ|Asia/Baku",
          "BA|Europe/Belgrade Europe/Sarajevo",
          "BB|America/Barbados",
          "BD|Asia/Dhaka",
          "BE|Europe/Brussels",
          "BF|Africa/Abidjan Africa/Ouagadougou",
          "BG|Europe/Sofia",
          "BH|Asia/Qatar Asia/Bahrain",
          "BI|Africa/Maputo Africa/Bujumbura",
          "BJ|Africa/Lagos Africa/Porto-Novo",
          "BL|America/Port_of_Spain America/St_Barthelemy",
          "BM|Atlantic/Bermuda",
          "BN|Asia/Brunei",
          "BO|America/La_Paz",
          "BQ|America/Curacao America/Kralendijk",
          "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco",
          "BS|America/Nassau",
          "BT|Asia/Thimphu",
          "BW|Africa/Maputo Africa/Gaborone",
          "BY|Europe/Minsk",
          "BZ|America/Belize",
          "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson",
          "CC|Indian/Cocos",
          "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi",
          "CF|Africa/Lagos Africa/Bangui",
          "CG|Africa/Lagos Africa/Brazzaville",
          "CH|Europe/Zurich",
          "CI|Africa/Abidjan",
          "CK|Pacific/Rarotonga",
          "CL|America/Santiago America/Punta_Arenas Pacific/Easter",
          "CM|Africa/Lagos Africa/Douala",
          "CN|Asia/Shanghai Asia/Urumqi",
          "CO|America/Bogota",
          "CR|America/Costa_Rica",
          "CU|America/Havana",
          "CV|Atlantic/Cape_Verde",
          "CW|America/Curacao",
          "CX|Indian/Christmas",
          "CY|Asia/Nicosia Asia/Famagusta",
          "CZ|Europe/Prague",
          "DE|Europe/Zurich Europe/Berlin Europe/Busingen",
          "DJ|Africa/Nairobi Africa/Djibouti",
          "DK|Europe/Copenhagen",
          "DM|America/Port_of_Spain America/Dominica",
          "DO|America/Santo_Domingo",
          "DZ|Africa/Algiers",
          "EC|America/Guayaquil Pacific/Galapagos",
          "EE|Europe/Tallinn",
          "EG|Africa/Cairo",
          "EH|Africa/El_Aaiun",
          "ER|Africa/Nairobi Africa/Asmara",
          "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary",
          "ET|Africa/Nairobi Africa/Addis_Ababa",
          "FI|Europe/Helsinki",
          "FJ|Pacific/Fiji",
          "FK|Atlantic/Stanley",
          "FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae",
          "FO|Atlantic/Faroe",
          "FR|Europe/Paris",
          "GA|Africa/Lagos Africa/Libreville",
          "GB|Europe/London",
          "GD|America/Port_of_Spain America/Grenada",
          "GE|Asia/Tbilisi",
          "GF|America/Cayenne",
          "GG|Europe/London Europe/Guernsey",
          "GH|Africa/Accra",
          "GI|Europe/Gibraltar",
          "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule",
          "GM|Africa/Abidjan Africa/Banjul",
          "GN|Africa/Abidjan Africa/Conakry",
          "GP|America/Port_of_Spain America/Guadeloupe",
          "GQ|Africa/Lagos Africa/Malabo",
          "GR|Europe/Athens",
          "GS|Atlantic/South_Georgia",
          "GT|America/Guatemala",
          "GU|Pacific/Guam",
          "GW|Africa/Bissau",
          "GY|America/Guyana",
          "HK|Asia/Hong_Kong",
          "HN|America/Tegucigalpa",
          "HR|Europe/Belgrade Europe/Zagreb",
          "HT|America/Port-au-Prince",
          "HU|Europe/Budapest",
          "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura",
          "IE|Europe/Dublin",
          "IL|Asia/Jerusalem",
          "IM|Europe/London Europe/Isle_of_Man",
          "IN|Asia/Kolkata",
          "IO|Indian/Chagos",
          "IQ|Asia/Baghdad",
          "IR|Asia/Tehran",
          "IS|Atlantic/Reykjavik",
          "IT|Europe/Rome",
          "JE|Europe/London Europe/Jersey",
          "JM|America/Jamaica",
          "JO|Asia/Amman",
          "JP|Asia/Tokyo",
          "KE|Africa/Nairobi",
          "KG|Asia/Bishkek",
          "KH|Asia/Bangkok Asia/Phnom_Penh",
          "KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati",
          "KM|Africa/Nairobi Indian/Comoro",
          "KN|America/Port_of_Spain America/St_Kitts",
          "KP|Asia/Pyongyang",
          "KR|Asia/Seoul",
          "KW|Asia/Riyadh Asia/Kuwait",
          "KY|America/Panama America/Cayman",
          "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral",
          "LA|Asia/Bangkok Asia/Vientiane",
          "LB|Asia/Beirut",
          "LC|America/Port_of_Spain America/St_Lucia",
          "LI|Europe/Zurich Europe/Vaduz",
          "LK|Asia/Colombo",
          "LR|Africa/Monrovia",
          "LS|Africa/Johannesburg Africa/Maseru",
          "LT|Europe/Vilnius",
          "LU|Europe/Luxembourg",
          "LV|Europe/Riga",
          "LY|Africa/Tripoli",
          "MA|Africa/Casablanca",
          "MC|Europe/Monaco",
          "MD|Europe/Chisinau",
          "ME|Europe/Belgrade Europe/Podgorica",
          "MF|America/Port_of_Spain America/Marigot",
          "MG|Africa/Nairobi Indian/Antananarivo",
          "MH|Pacific/Majuro Pacific/Kwajalein",
          "MK|Europe/Belgrade Europe/Skopje",
          "ML|Africa/Abidjan Africa/Bamako",
          "MM|Asia/Yangon",
          "MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan",
          "MO|Asia/Macau",
          "MP|Pacific/Guam Pacific/Saipan",
          "MQ|America/Martinique",
          "MR|Africa/Abidjan Africa/Nouakchott",
          "MS|America/Port_of_Spain America/Montserrat",
          "MT|Europe/Malta",
          "MU|Indian/Mauritius",
          "MV|Indian/Maldives",
          "MW|Africa/Maputo Africa/Blantyre",
          "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas",
          "MY|Asia/Kuala_Lumpur Asia/Kuching",
          "MZ|Africa/Maputo",
          "NA|Africa/Windhoek",
          "NC|Pacific/Noumea",
          "NE|Africa/Lagos Africa/Niamey",
          "NF|Pacific/Norfolk",
          "NG|Africa/Lagos",
          "NI|America/Managua",
          "NL|Europe/Amsterdam",
          "NO|Europe/Oslo",
          "NP|Asia/Kathmandu",
          "NR|Pacific/Nauru",
          "NU|Pacific/Niue",
          "NZ|Pacific/Auckland Pacific/Chatham",
          "OM|Asia/Dubai Asia/Muscat",
          "PA|America/Panama",
          "PE|America/Lima",
          "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier",
          "PG|Pacific/Port_Moresby Pacific/Bougainville",
          "PH|Asia/Manila",
          "PK|Asia/Karachi",
          "PL|Europe/Warsaw",
          "PM|America/Miquelon",
          "PN|Pacific/Pitcairn",
          "PR|America/Puerto_Rico",
          "PS|Asia/Gaza Asia/Hebron",
          "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores",
          "PW|Pacific/Palau",
          "PY|America/Asuncion",
          "QA|Asia/Qatar",
          "RE|Indian/Reunion",
          "RO|Europe/Bucharest",
          "RS|Europe/Belgrade",
          "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr",
          "RW|Africa/Maputo Africa/Kigali",
          "SA|Asia/Riyadh",
          "SB|Pacific/Guadalcanal",
          "SC|Indian/Mahe",
          "SD|Africa/Khartoum",
          "SE|Europe/Stockholm",
          "SG|Asia/Singapore",
          "SH|Africa/Abidjan Atlantic/St_Helena",
          "SI|Europe/Belgrade Europe/Ljubljana",
          "SJ|Europe/Oslo Arctic/Longyearbyen",
          "SK|Europe/Prague Europe/Bratislava",
          "SL|Africa/Abidjan Africa/Freetown",
          "SM|Europe/Rome Europe/San_Marino",
          "SN|Africa/Abidjan Africa/Dakar",
          "SO|Africa/Nairobi Africa/Mogadishu",
          "SR|America/Paramaribo",
          "SS|Africa/Juba",
          "ST|Africa/Sao_Tome",
          "SV|America/El_Salvador",
          "SX|America/Curacao America/Lower_Princes",
          "SY|Asia/Damascus",
          "SZ|Africa/Johannesburg Africa/Mbabane",
          "TC|America/Grand_Turk",
          "TD|Africa/Ndjamena",
          "TF|Indian/Reunion Indian/Kerguelen",
          "TG|Africa/Abidjan Africa/Lome",
          "TH|Asia/Bangkok",
          "TJ|Asia/Dushanbe",
          "TK|Pacific/Fakaofo",
          "TL|Asia/Dili",
          "TM|Asia/Ashgabat",
          "TN|Africa/Tunis",
          "TO|Pacific/Tongatapu",
          "TR|Europe/Istanbul",
          "TT|America/Port_of_Spain",
          "TV|Pacific/Funafuti",
          "TW|Asia/Taipei",
          "TZ|Africa/Nairobi Africa/Dar_es_Salaam",
          "UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye",
          "UG|Africa/Nairobi Africa/Kampala",
          "UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway",
          "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu",
          "UY|America/Montevideo",
          "UZ|Asia/Samarkand Asia/Tashkent",
          "VA|Europe/Rome Europe/Vatican",
          "VC|America/Port_of_Spain America/St_Vincent",
          "VE|America/Caracas",
          "VG|America/Port_of_Spain America/Tortola",
          "VI|America/Port_of_Spain America/St_Thomas",
          "VN|Asia/Bangkok Asia/Ho_Chi_Minh",
          "VU|Pacific/Efate",
          "WF|Pacific/Wallis",
          "WS|Pacific/Apia",
          "YE|Asia/Riyadh Asia/Aden",
          "YT|Africa/Nairobi Indian/Mayotte",
          "ZA|Africa/Johannesburg",
          "ZM|Africa/Maputo Africa/Lusaka",
          "ZW|Africa/Maputo Africa/Harare"
        ]
      };
    }
  });

  // node_modules/moment-timezone/index.js
  var require_moment_timezone2 = __commonJS({
    "node_modules/moment-timezone/index.js"(exports, module) {
      var moment = module.exports = require_moment_timezone();
      moment.tz.load(require_latest());
    }
  });

  // node_modules/lodash/head.js
  var require_head = __commonJS({
    "node_modules/lodash/head.js"(exports, module) {
      function head2(array) {
        return array && array.length ? array[0] : void 0;
      }
      module.exports = head2;
    }
  });

  // node_modules/lodash/first.js
  var require_first = __commonJS({
    "node_modules/lodash/first.js"(exports, module) {
      module.exports = require_head();
    }
  });

  // node_modules/lodash/last.js
  var require_last = __commonJS({
    "node_modules/lodash/last.js"(exports, module) {
      function last3(array) {
        var length2 = array == null ? 0 : array.length;
        return length2 ? array[length2 - 1] : void 0;
      }
      module.exports = last3;
    }
  });

  // packages/systems/dynamo/utils/ParamFieldPathUtils/index.ts
  var ParamFieldPathUtils_exports = {};
  __export(ParamFieldPathUtils_exports, {
    createFieldPath: () => createFieldPath,
    fieldPathsEqual: () => fieldPathsEqual,
    getItemRefSlug: () => getItemRefSlug,
    getValueFieldSlug: () => getValueFieldSlug,
    isEmptyFieldPath: () => isEmptyFieldPath,
    isFauxDynContextField: () => isFauxDynContextField,
    isFieldOfItemRef: () => isFieldOfItemRef
  });
  var import_first, import_last, SEPARATOR, EMPTY_STRING, isFieldOfItemRef, getValueFieldSlug, getItemRefSlug, createFieldPath, isEmptyFieldPath, fieldPathsEqual, isFauxDynContextField;
  var init_ParamFieldPathUtils = __esm({
    "packages/systems/dynamo/utils/ParamFieldPathUtils/index.ts"() {
      import_first = __toESM(require_first());
      import_last = __toESM(require_last());
      SEPARATOR = ":";
      EMPTY_STRING = "";
      isFieldOfItemRef = (fieldPath) => fieldPath.indexOf(SEPARATOR) !== -1;
      getValueFieldSlug = (fieldPath) => (
        // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
        (0, import_last.default)(fieldPath.split(SEPARATOR))
      );
      getItemRefSlug = (fieldPath) => (
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string | null'.
        isFieldOfItemRef(fieldPath) ? (0, import_first.default)(fieldPath.split(SEPARATOR)) : null
      );
      createFieldPath = (...fieldSlugs) => fieldSlugs.join(SEPARATOR);
      isEmptyFieldPath = (a) => a === EMPTY_STRING;
      fieldPathsEqual = (a, b) => a === b;
      isFauxDynContextField = (fieldPath) => !isFieldOfItemRef(fieldPath) && getValueFieldSlug(fieldPath) === "_id";
    }
  });

  // packages/systems/dynamo/utils/FilterUtils/FilterUtils.js
  var require_FilterUtils = __commonJS({
    "packages/systems/dynamo/utils/FilterUtils/FilterUtils.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.normalizeConditionFields = exports.convertConditionFieldsFromObjectToArray = void 0;
      var _utils = (init_utils2(), __toCommonJS(utils_exports));
      var convertConditionFieldsFromObjectToArray = (fields) => {
        const mapper = (fieldPath) => {
          const type = fields[fieldPath].type;
          return Object.entries(fields[fieldPath]).reduce((conditionFields, [operatorName, value]) => {
            if (operatorName === "type") {
              return conditionFields;
            }
            conditionFields.push({
              fieldPath,
              operatorName,
              value,
              type
            });
            return conditionFields;
          }, []);
        };
        return (0, _utils.flatMap)(mapper)(Object.keys(fields));
      };
      exports.convertConditionFieldsFromObjectToArray = convertConditionFieldsFromObjectToArray;
      var normalizeConditionFields = (fields = []) => {
        if (Array.isArray(fields)) {
          return fields;
        }
        return convertConditionFieldsFromObjectToArray(fields);
      };
      exports.normalizeConditionFields = normalizeConditionFields;
    }
  });

  // packages/systems/dynamo/utils/FilterUtils/index.js
  var require_FilterUtils2 = __commonJS({
    "packages/systems/dynamo/utils/FilterUtils/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _FilterUtils = require_FilterUtils();
      Object.keys(_FilterUtils).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports && exports[key] === _FilterUtils[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _FilterUtils[key];
          }
        });
      });
    }
  });

  // packages/systems/dynamo/utils/DynamoConditionUtils/index.js
  var require_DynamoConditionUtils = __commonJS({
    "packages/systems/dynamo/utils/DynamoConditionUtils/index.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.EXAMPLE_IMG_URL = void 0;
      exports.castConditionValue = castConditionValue;
      exports.castItemValue = castItemValue;
      exports.getItemFieldValue = getItemFieldValue;
      exports.parseDate = parseDate;
      exports.test = test2;
      var _momentTimezone = _interopRequireDefault(require_moment_timezone2());
      var _ParamFieldPathUtils = (init_ParamFieldPathUtils(), __toCommonJS(ParamFieldPathUtils_exports));
      var _FilterUtils = require_FilterUtils2();
      var EXAMPLE_IMG_URL = "https://d3e54v103j8qbb.cloudfront.net/img/image-placeholder.svg";
      exports.EXAMPLE_IMG_URL = EXAMPLE_IMG_URL;
      var OPERATOR_FNS = {
        eq: function(a, b) {
          return a == b;
        },
        ne: function(a, b) {
          return a != b;
        },
        gt: function(a, b) {
          return a > b;
        },
        lt: function(a, b) {
          return a < b;
        },
        gte: function(a, b) {
          return a >= b;
        },
        lte: function(a, b) {
          return a <= b;
        },
        exists: function(a, b) {
          function getATruthiness() {
            if (a != null) {
              if (Array.isArray(a)) {
                return a.length > 0;
              } else if (typeof a === "object") {
                return a.url !== EXAMPLE_IMG_URL;
              } else if (typeof a === "number") {
                return !Number.isNaN(a);
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
          function getBTruthiness() {
            return b === "yes";
          }
          const aIsTruthy = getATruthiness();
          const bIsTruthy = getBTruthiness();
          return aIsTruthy === bIsTruthy;
        },
        idin: function(a, b) {
          return containsResolver(a, b);
        },
        idnin: function(a, b) {
          return !containsResolver(a, b);
        },
        type: false
        // ensure the `type` property will never resolve to a function
      };
      var containsResolver = (a, b) => {
        if (Array.isArray(a) && typeof b === "string") {
          return a.includes(b);
        }
        if (Array.isArray(a) && Array.isArray(b)) {
          return b.some((id) => a.includes(id));
        }
        if (typeof a === "string" && Array.isArray(b)) {
          return b.includes(a);
        }
        return false;
      };
      function test2(itemData, conditionData, timezone) {
        const conditionFields = (0, _FilterUtils.normalizeConditionFields)(conditionData.fields);
        for (const conditionField of conditionFields) {
          const result = testSingleCondition({
            conditionField,
            itemData,
            timezone
          });
          if (!result) {
            return false;
          }
        }
        return true;
      }
      function testSingleCondition({
        conditionField,
        itemData,
        timezone
      }) {
        const {
          fieldPath,
          operatorName,
          value,
          type
        } = conditionField;
        const opFn = OPERATOR_FNS[operatorName];
        if (!opFn) {
          console.warn(`Ignoring unsupported condition operator: ${operatorName}`);
          return true;
        }
        const itemFieldValue = itemData.hasOwnProperty(fieldPath) ? itemData[fieldPath] : getItemFieldValue(itemData, fieldPath);
        const itemFieldType = type ? convertFieldTypeToLegacyItemType(type) : _getLegacyItemType(fieldPath, itemFieldValue);
        const resolvedFieldValue = castItemFieldValue(itemFieldValue, itemFieldType);
        const resolvedConditionValue = castConditionValue(value, operatorName, itemFieldType, timezone);
        return opFn(resolvedFieldValue, resolvedConditionValue);
      }
      function castItemValue({
        operator,
        value,
        type,
        timezone
      }) {
        if (value !== void 0) {
          switch (type) {
            case "Bool":
              return function() {
                if (typeof value === "boolean") {
                  return value;
                } else if (typeof value === "string") {
                  return value.toLowerCase() === "true";
                } else {
                  return Boolean(value);
                }
              }();
            case "Number":
              return parseFloat(value);
            case "Date":
              return parseDate({
                operator,
                value,
                timezone
              });
            default:
              return value;
          }
        } else {
          return value;
        }
      }
      function castConditionValue(value, op, type, timezone) {
        if (op === "exists") {
          return value;
        } else {
          return castItemValue({
            operator: op,
            timezone,
            type,
            value
          });
        }
      }
      var OPERATOR_LTE_NAME = "lte";
      var NOW_REGEX = /^now$/i;
      var END_OF_TODAY_REGEX = /^(end of )?(today)$/i;
      var DEPRECATED_END_OF_TOMORROW_YESTERDAY_REGEX = /^(end of )?(tomorrow|yesterday)$/i;
      var DEPRECATED_RELATIVE_TIME_COMPLEX_REGEX = /^((?:\d+ (?:year|quarter|month|week|day|hour|minute|second)s? )+)(ago|from now)(?: (?:starting (?:now|(?:(end of )?(today|yesterday|tomorrow)))))?$/i;
      var RELATIVE_TIME_COMPLEX_REGEX = /^((?:\d+ (?:year|quarter|month|week|day|hour|minute|second)s? )+)in the (future|past)$/i;
      var FULL_TIME_LENGTH_INTERVAL_STRING_REGEX = /\d+ (?:year|quarter|month|week|day|hour|minute|second)s?/gi;
      var isDeprecatedDatePattern = (str) => DEPRECATED_END_OF_TOMORROW_YESTERDAY_REGEX.test(str) || DEPRECATED_RELATIVE_TIME_COMPLEX_REGEX.test(str);
      function handleDeprecatedParseDate({
        value,
        timezone,
        momentNowUtc
      }) {
        function getToday() {
          return momentNowUtc.tz(timezone).startOf("day");
        }
        function getEndOfToday() {
          return momentNowUtc.tz(timezone).endOf("day");
        }
        function getNow() {
          return momentNowUtc.tz(timezone);
        }
        const simpleResults = value.match(DEPRECATED_END_OF_TOMORROW_YESTERDAY_REGEX);
        if (simpleResults) {
          const [, endOf, relativeDate] = simpleResults;
          const getStart = endOf ? getEndOfToday : getToday;
          if (relativeDate === "tomorrow") {
            return getStart().add(1, "day").toDate();
          }
          if (relativeDate === "yesterday") {
            return getStart().subtract(1, "day").toDate();
          }
        }
        const complexResults = value.match(DEPRECATED_RELATIVE_TIME_COMPLEX_REGEX);
        if (complexResults) {
          const [, values2, mode, endOf, relativeDate] = complexResults;
          const getStart = endOf ? getEndOfToday : getToday;
          let time;
          switch (relativeDate) {
            case "today":
              time = getStart();
              break;
            case "tomorrow":
              time = getStart().add(1, "day");
              break;
            case "yesterday":
              time = getStart().subtract(1, "day");
              break;
            default:
              time = getNow();
              break;
          }
          const timeLengthIntervalItems = values2.match(FULL_TIME_LENGTH_INTERVAL_STRING_REGEX);
          if (!timeLengthIntervalItems) {
            return null;
          }
          const method = mode === "from now" ? "add" : "subtract";
          timeLengthIntervalItems.forEach((item) => {
            const [length2, interval] = item.split(" ");
            time[method](parseInt(length2, 10), interval);
          });
          return time.toDate();
        }
      }
      function parseDate({
        operator,
        value,
        timezone,
        nowUtcString
      }) {
        timezone = timezone || "UTC";
        const momentNowUtc = nowUtcString ? _momentTimezone.default.utc(nowUtcString) : _momentTimezone.default.utc();
        function getToday() {
          return momentNowUtc.tz(timezone).startOf("day");
        }
        function getEndOfToday() {
          return momentNowUtc.tz(timezone).endOf("day");
        }
        function getNow() {
          return momentNowUtc.tz(timezone);
        }
        const stringValue = String(value).toLowerCase();
        if (NOW_REGEX.test(stringValue)) {
          return getNow().toDate();
        }
        if (isDeprecatedDatePattern(stringValue)) {
          return handleDeprecatedParseDate({
            value: stringValue,
            timezone,
            momentNowUtc
          });
        }
        const simpleResults = stringValue.match(END_OF_TODAY_REGEX);
        if (simpleResults) {
          const [, endOf] = simpleResults;
          return endOf ? getEndOfToday().toDate() : getToday().toDate();
        }
        const complexResults = stringValue.match(RELATIVE_TIME_COMPLEX_REGEX);
        if (complexResults) {
          const [, fullTimeLengthIntervalString, tense] = complexResults;
          const timeLengthIntervalItems = fullTimeLengthIntervalString.match(FULL_TIME_LENGTH_INTERVAL_STRING_REGEX);
          if (!timeLengthIntervalItems) {
            return null;
          }
          const getStart = operator && operator === OPERATOR_LTE_NAME ? getEndOfToday : getToday;
          const TENSE_METHODS_MAP = {
            future: "add",
            past: "subtract"
          };
          const tenseMethod = TENSE_METHODS_MAP[tense];
          const reducedDateTime = timeLengthIntervalItems.reduce((accumulatedMoment, item) => {
            const [length2, interval] = item.split(" ");
            return accumulatedMoment[tenseMethod](parseInt(length2, 10), interval);
          }, getStart());
          return reducedDateTime.toDate();
        }
        const isoMoment = _momentTimezone.default.utc(value, _momentTimezone.default.ISO_8601).tz(timezone);
        if (!isoMoment || !isoMoment.isValid()) {
          return null;
        }
        return isoMoment.toDate();
      }
      function castItemFieldValue(fieldValue, fieldType) {
        switch (fieldType) {
          case "CommercePrice": {
            return fieldValue !== null && typeof fieldValue === "object" && typeof fieldValue.value === "number" ? fieldValue.value / 100 : NaN;
          }
          case "ItemRef": {
            return fieldValue !== null && typeof fieldValue === "object" ? fieldValue._id : fieldValue;
          }
          case "ItemRefSet": {
            return Array.isArray(fieldValue) ? fieldValue.map(function(itemRef) {
              return itemRef._id;
            }) : [];
          }
          case "Option": {
            return fieldValue !== null && typeof fieldValue === "object" ? fieldValue.id : fieldValue;
          }
          case "Number": {
            return fieldValue === null ? NaN : fieldValue;
          }
          default: {
            return fieldValue;
          }
        }
      }
      function getItemFieldValue(itemData, fieldPath) {
        const itemRefSlug = (0, _ParamFieldPathUtils.getItemRefSlug)(fieldPath);
        const valueFieldSlug = (0, _ParamFieldPathUtils.getValueFieldSlug)(fieldPath);
        return (0, _ParamFieldPathUtils.isFieldOfItemRef)(fieldPath) ? itemData[itemRefSlug] && itemData[itemRefSlug][valueFieldSlug] : itemData[valueFieldSlug];
      }
      function convertFieldTypeToLegacyItemType(fieldType) {
        switch (fieldType) {
          case "Bool":
          case "CommercePrice":
          case "Date":
          case "ImageRef":
          case "ItemRef":
          case "ItemRefSet":
          case "Number":
          case "Option":
          case "Set": {
            return fieldType;
          }
          case "FileRef":
          case "Video": {
            return "ImageRef";
          }
          case "Email":
          case "Phone":
          case "PlainText":
          case "RichText":
          case "Link": {
            return "String";
          }
          default: {
            return "String";
          }
        }
      }
      function _getLegacyItemType(name, value) {
        if (name === "_id") {
          return "Id";
        } else {
          switch (typeof value) {
            case "number":
              return "Number";
            case "boolean":
              return "Bool";
            case "object":
              return function() {
                if (value) {
                  if (value instanceof Date) {
                    return "Date";
                  } else if ("_id" in value && "_cid" in value) {
                    return "ItemRef";
                  } else if (Array.isArray(value)) {
                    return "ItemRefSet";
                  } else if ("url" in value) {
                    return "ImageRef";
                  } else if ("value" in value && "unit" in value) {
                    return "CommercePrice";
                  } else {
                    return "Option";
                  }
                } else {
                  return "Option";
                }
              }();
            default:
              return "String";
          }
        }
      }
    }
  });

  // node_modules/lodash/_baseInverter.js
  var require_baseInverter = __commonJS({
    "node_modules/lodash/_baseInverter.js"(exports, module) {
      var baseForOwn = require_baseForOwn();
      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function(value, key, object2) {
          setter(accumulator, iteratee(value), key, object2);
        });
        return accumulator;
      }
      module.exports = baseInverter;
    }
  });

  // node_modules/lodash/_createInverter.js
  var require_createInverter = __commonJS({
    "node_modules/lodash/_createInverter.js"(exports, module) {
      var baseInverter = require_baseInverter();
      function createInverter(setter, toIteratee) {
        return function(object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }
      module.exports = createInverter;
    }
  });

  // node_modules/lodash/invert.js
  var require_invert = __commonJS({
    "node_modules/lodash/invert.js"(exports, module) {
      var constant2 = require_constant();
      var createInverter = require_createInverter();
      var identity2 = require_identity();
      var objectProto = Object.prototype;
      var nativeObjectToString = objectProto.toString;
      var invert2 = createInverter(function(result, value, key) {
        if (value != null && typeof value.toString != "function") {
          value = nativeObjectToString.call(value);
        }
        result[value] = key;
      }, constant2(identity2));
      module.exports = invert2;
    }
  });

  // packages/systems/dynamo/utils/SchemaEncoder/SchemaEncoder.ts
  function _crapCode(str) {
    str = String(str);
    const right = [];
    const left = str.replace(/[^a-z0-9]/gi, (substr, idx) => {
      const hex = substr.charCodeAt(0).toString(16);
      const letters = hex.replace(/./g, (ch) => hex_lookup[ch]);
      right.push(String(idx) + letters);
      return "_";
    });
    return left + "_" + right.join("");
  }
  var import_invert, hex_lookup, reverse_hex_lookup, collSlug, fieldSlug, restoreSlug;
  var init_SchemaEncoder = __esm({
    "packages/systems/dynamo/utils/SchemaEncoder/SchemaEncoder.ts"() {
      "use strict";
      import_invert = __toESM(require_invert());
      hex_lookup = {
        "0": "b",
        "1": "c",
        "2": "d",
        "3": "f",
        "4": "g",
        "5": "h",
        "6": "j",
        "7": "k",
        "8": "l",
        "9": "m",
        a: "n",
        b: "p",
        c: "q",
        d: "r",
        e: "s",
        f: "t"
      };
      reverse_hex_lookup = (0, import_invert.default)(hex_lookup);
      collSlug = (coll) => "c_" + _crapCode(coll.slug);
      fieldSlug = (field) => "f_" + _crapCode(field.slug);
      restoreSlug = (slugWithPrefixAndCrapCode) => {
        const results = slugWithPrefixAndCrapCode.match(
          /^[fc]_([_A-Za-z0-9]+)_([0-9bcdfghjklmnpqrst]*)$/
        );
        if (!results || results.length < 3) {
          return slugWithPrefixAndCrapCode;
        }
        const left = results[1];
        const right = results[2];
        if (!right) {
          return left;
        }
        const decrapified = left.split("");
        const re = /(\d+)([bcdfghjklmnpqrst]+)/g;
        let matches = re.exec(right);
        while (matches !== null && matches.length > 2) {
          const idx = Number(matches[1]);
          const letters = matches[2];
          const hex = letters.replace(/./g, (ch) => reverse_hex_lookup[ch]);
          const char = String.fromCharCode(parseInt(hex, 16));
          decrapified[idx] = char;
          matches = re.exec(right);
        }
        return decrapified.join("");
      };
    }
  });

  // packages/systems/dynamo/utils/SchemaEncoder/index.ts
  var init_SchemaEncoder2 = __esm({
    "packages/systems/dynamo/utils/SchemaEncoder/index.ts"() {
      "use strict";
      init_SchemaEncoder();
    }
  });

  // packages/systems/dynamo/utils/SlugUtils/SlugUtils.ts
  var fieldSlug2, DYNAMO_GQL_FIELD_SLUG, isDynamoGraphQLFieldSlug, collectionSlug;
  var init_SlugUtils = __esm({
    "packages/systems/dynamo/utils/SlugUtils/SlugUtils.ts"() {
      "use strict";
      init_SchemaEncoder2();
      init_SchemaEncoder2();
      fieldSlug2 = (slug) => fieldSlug({ slug });
      DYNAMO_GQL_FIELD_SLUG = "f_";
      isDynamoGraphQLFieldSlug = (str) => str.startsWith(DYNAMO_GQL_FIELD_SLUG);
      collectionSlug = (slug) => collSlug({ slug });
    }
  });

  // packages/systems/dynamo/utils/SlugUtils/index.ts
  var SlugUtils_exports = {};
  __export(SlugUtils_exports, {
    collectionSlug: () => collectionSlug,
    fieldSlug: () => fieldSlug2,
    isDynamoGraphQLFieldSlug: () => isDynamoGraphQLFieldSlug,
    restoreSlug: () => restoreSlug
  });
  var init_SlugUtils2 = __esm({
    "packages/systems/dynamo/utils/SlugUtils/index.ts"() {
      init_SlugUtils();
    }
  });

  // node_modules/reselect/lib/index.js
  var require_lib4 = __commonJS({
    "node_modules/reselect/lib/index.js"(exports) {
      "use strict";
      exports.__esModule = true;
      exports.defaultMemoize = defaultMemoize2;
      exports.createSelectorCreator = createSelectorCreator;
      exports.createSelector = createSelector;
      exports.createStructuredSelector = createStructuredSelector;
      function _toConsumableArray(arr) {
        if (Array.isArray(arr)) {
          for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++)
            arr2[i] = arr[i];
          return arr2;
        } else {
          return Array.from(arr);
        }
      }
      function defaultEqualityCheck(a, b) {
        return a === b;
      }
      function defaultMemoize2(func) {
        var equalityCheck = arguments.length <= 1 || arguments[1] === void 0 ? defaultEqualityCheck : arguments[1];
        var lastArgs = null;
        var lastResult = null;
        return function() {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastArgs !== null && lastArgs.length === args.length && args.every(function(value, index) {
            return equalityCheck(value, lastArgs[index]);
          })) {
            return lastResult;
          }
          lastArgs = args;
          lastResult = func.apply(void 0, args);
          return lastResult;
        };
      }
      function getDependencies(funcs) {
        var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
        if (!dependencies.every(function(dep) {
          return typeof dep === "function";
        })) {
          var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep;
          }).join(", ");
          throw new Error("Selector creators expect all input-selectors to be functions, " + ("instead received the following types: [" + dependencyTypes + "]"));
        }
        return dependencies;
      }
      function createSelectorCreator(memoize2) {
        for (var _len2 = arguments.length, memoizeOptions = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          memoizeOptions[_key2 - 1] = arguments[_key2];
        }
        return function() {
          for (var _len3 = arguments.length, funcs = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
            funcs[_key3] = arguments[_key3];
          }
          var recomputations = 0;
          var resultFunc = funcs.pop();
          var dependencies = getDependencies(funcs);
          var memoizedResultFunc = memoize2.apply(void 0, [function() {
            recomputations++;
            return resultFunc.apply(void 0, arguments);
          }].concat(memoizeOptions));
          var selector = function selector2(state, props) {
            for (var _len4 = arguments.length, args = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
              args[_key4 - 2] = arguments[_key4];
            }
            var params = dependencies.map(function(dependency) {
              return dependency.apply(void 0, [state, props].concat(args));
            });
            return memoizedResultFunc.apply(void 0, _toConsumableArray(params));
          };
          selector.recomputations = function() {
            return recomputations;
          };
          selector.resetRecomputations = function() {
            return recomputations = 0;
          };
          return selector;
        };
      }
      function createSelector() {
        return createSelectorCreator(defaultMemoize2).apply(void 0, arguments);
      }
      function createStructuredSelector(selectors) {
        var selectorCreator = arguments.length <= 1 || arguments[1] === void 0 ? createSelector : arguments[1];
        if (typeof selectors !== "object") {
          throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
        }
        var objectKeys2 = Object.keys(selectors);
        return selectorCreator(objectKeys2.map(function(key) {
          return selectors[key];
        }), function() {
          for (var _len5 = arguments.length, values2 = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
            values2[_key5] = arguments[_key5];
          }
          return values2.reduce(function(composition, value, index) {
            composition[objectKeys2[index]] = value;
            return composition;
          }, {});
        });
      }
    }
  });

  // node_modules/yallist/iterator.js
  var require_iterator = __commonJS({
    "node_modules/yallist/iterator.js"(exports, module) {
      "use strict";
      module.exports = function(Yallist) {
        Yallist.prototype[Symbol.iterator] = function* () {
          for (let walker = this.head; walker; walker = walker.next) {
            yield walker.value;
          }
        };
      };
    }
  });

  // node_modules/yallist/yallist.js
  var require_yallist = __commonJS({
    "node_modules/yallist/yallist.js"(exports, module) {
      "use strict";
      module.exports = Yallist;
      Yallist.Node = Node;
      Yallist.create = Yallist;
      function Yallist(list) {
        var self2 = this;
        if (!(self2 instanceof Yallist)) {
          self2 = new Yallist();
        }
        self2.tail = null;
        self2.head = null;
        self2.length = 0;
        if (list && typeof list.forEach === "function") {
          list.forEach(function(item) {
            self2.push(item);
          });
        } else if (arguments.length > 0) {
          for (var i = 0, l = arguments.length; i < l; i++) {
            self2.push(arguments[i]);
          }
        }
        return self2;
      }
      Yallist.prototype.removeNode = function(node) {
        if (node.list !== this) {
          throw new Error("removing node which does not belong to this list");
        }
        var next = node.next;
        var prev = node.prev;
        if (next) {
          next.prev = prev;
        }
        if (prev) {
          prev.next = next;
        }
        if (node === this.head) {
          this.head = next;
        }
        if (node === this.tail) {
          this.tail = prev;
        }
        node.list.length--;
        node.next = null;
        node.prev = null;
        node.list = null;
        return next;
      };
      Yallist.prototype.unshiftNode = function(node) {
        if (node === this.head) {
          return;
        }
        if (node.list) {
          node.list.removeNode(node);
        }
        var head2 = this.head;
        node.list = this;
        node.next = head2;
        if (head2) {
          head2.prev = node;
        }
        this.head = node;
        if (!this.tail) {
          this.tail = node;
        }
        this.length++;
      };
      Yallist.prototype.pushNode = function(node) {
        if (node === this.tail) {
          return;
        }
        if (node.list) {
          node.list.removeNode(node);
        }
        var tail2 = this.tail;
        node.list = this;
        node.prev = tail2;
        if (tail2) {
          tail2.next = node;
        }
        this.tail = node;
        if (!this.head) {
          this.head = node;
        }
        this.length++;
      };
      Yallist.prototype.push = function() {
        for (var i = 0, l = arguments.length; i < l; i++) {
          push(this, arguments[i]);
        }
        return this.length;
      };
      Yallist.prototype.unshift = function() {
        for (var i = 0, l = arguments.length; i < l; i++) {
          unshift(this, arguments[i]);
        }
        return this.length;
      };
      Yallist.prototype.pop = function() {
        if (!this.tail) {
          return void 0;
        }
        var res = this.tail.value;
        this.tail = this.tail.prev;
        if (this.tail) {
          this.tail.next = null;
        } else {
          this.head = null;
        }
        this.length--;
        return res;
      };
      Yallist.prototype.shift = function() {
        if (!this.head) {
          return void 0;
        }
        var res = this.head.value;
        this.head = this.head.next;
        if (this.head) {
          this.head.prev = null;
        } else {
          this.tail = null;
        }
        this.length--;
        return res;
      };
      Yallist.prototype.forEach = function(fn, thisp) {
        thisp = thisp || this;
        for (var walker = this.head, i = 0; walker !== null; i++) {
          fn.call(thisp, walker.value, i, this);
          walker = walker.next;
        }
      };
      Yallist.prototype.forEachReverse = function(fn, thisp) {
        thisp = thisp || this;
        for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
          fn.call(thisp, walker.value, i, this);
          walker = walker.prev;
        }
      };
      Yallist.prototype.get = function(n) {
        for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
          walker = walker.next;
        }
        if (i === n && walker !== null) {
          return walker.value;
        }
      };
      Yallist.prototype.getReverse = function(n) {
        for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
          walker = walker.prev;
        }
        if (i === n && walker !== null) {
          return walker.value;
        }
      };
      Yallist.prototype.map = function(fn, thisp) {
        thisp = thisp || this;
        var res = new Yallist();
        for (var walker = this.head; walker !== null; ) {
          res.push(fn.call(thisp, walker.value, this));
          walker = walker.next;
        }
        return res;
      };
      Yallist.prototype.mapReverse = function(fn, thisp) {
        thisp = thisp || this;
        var res = new Yallist();
        for (var walker = this.tail; walker !== null; ) {
          res.push(fn.call(thisp, walker.value, this));
          walker = walker.prev;
        }
        return res;
      };
      Yallist.prototype.reduce = function(fn, initial) {
        var acc;
        var walker = this.head;
        if (arguments.length > 1) {
          acc = initial;
        } else if (this.head) {
          walker = this.head.next;
          acc = this.head.value;
        } else {
          throw new TypeError("Reduce of empty list with no initial value");
        }
        for (var i = 0; walker !== null; i++) {
          acc = fn(acc, walker.value, i);
          walker = walker.next;
        }
        return acc;
      };
      Yallist.prototype.reduceReverse = function(fn, initial) {
        var acc;
        var walker = this.tail;
        if (arguments.length > 1) {
          acc = initial;
        } else if (this.tail) {
          walker = this.tail.prev;
          acc = this.tail.value;
        } else {
          throw new TypeError("Reduce of empty list with no initial value");
        }
        for (var i = this.length - 1; walker !== null; i--) {
          acc = fn(acc, walker.value, i);
          walker = walker.prev;
        }
        return acc;
      };
      Yallist.prototype.toArray = function() {
        var arr = new Array(this.length);
        for (var i = 0, walker = this.head; walker !== null; i++) {
          arr[i] = walker.value;
          walker = walker.next;
        }
        return arr;
      };
      Yallist.prototype.toArrayReverse = function() {
        var arr = new Array(this.length);
        for (var i = 0, walker = this.tail; walker !== null; i++) {
          arr[i] = walker.value;
          walker = walker.prev;
        }
        return arr;
      };
      Yallist.prototype.slice = function(from3, to) {
        to = to || this.length;
        if (to < 0) {
          to += this.length;
        }
        from3 = from3 || 0;
        if (from3 < 0) {
          from3 += this.length;
        }
        var ret = new Yallist();
        if (to < from3 || to < 0) {
          return ret;
        }
        if (from3 < 0) {
          from3 = 0;
        }
        if (to > this.length) {
          to = this.length;
        }
        for (var i = 0, walker = this.head; walker !== null && i < from3; i++) {
          walker = walker.next;
        }
        for (; walker !== null && i < to; i++, walker = walker.next) {
          ret.push(walker.value);
        }
        return ret;
      };
      Yallist.prototype.sliceReverse = function(from3, to) {
        to = to || this.length;
        if (to < 0) {
          to += this.length;
        }
        from3 = from3 || 0;
        if (from3 < 0) {
          from3 += this.length;
        }
        var ret = new Yallist();
        if (to < from3 || to < 0) {
          return ret;
        }
        if (from3 < 0) {
          from3 = 0;
        }
        if (to > this.length) {
          to = this.length;
        }
        for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
          walker = walker.prev;
        }
        for (; walker !== null && i > from3; i--, walker = walker.prev) {
          ret.push(walker.value);
        }
        return ret;
      };
      Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
        if (start > this.length) {
          start = this.length - 1;
        }
        if (start < 0) {
          start = this.length + start;
        }
        for (var i = 0, walker = this.head; walker !== null && i < start; i++) {
          walker = walker.next;
        }
        var ret = [];
        for (var i = 0; walker && i < deleteCount; i++) {
          ret.push(walker.value);
          walker = this.removeNode(walker);
        }
        if (walker === null) {
          walker = this.tail;
        }
        if (walker !== this.head && walker !== this.tail) {
          walker = walker.prev;
        }
        for (var i = 0; i < nodes.length; i++) {
          walker = insert(this, walker, nodes[i]);
        }
        return ret;
      };
      Yallist.prototype.reverse = function() {
        var head2 = this.head;
        var tail2 = this.tail;
        for (var walker = head2; walker !== null; walker = walker.prev) {
          var p = walker.prev;
          walker.prev = walker.next;
          walker.next = p;
        }
        this.head = tail2;
        this.tail = head2;
        return this;
      };
      function insert(self2, node, value) {
        var inserted = node === self2.head ? new Node(value, null, node, self2) : new Node(value, node, node.next, self2);
        if (inserted.next === null) {
          self2.tail = inserted;
        }
        if (inserted.prev === null) {
          self2.head = inserted;
        }
        self2.length++;
        return inserted;
      }
      function push(self2, item) {
        self2.tail = new Node(item, self2.tail, null, self2);
        if (!self2.head) {
          self2.head = self2.tail;
        }
        self2.length++;
      }
      function unshift(self2, item) {
        self2.head = new Node(item, null, self2.head, self2);
        if (!self2.tail) {
          self2.tail = self2.head;
        }
        self2.length++;
      }
      function Node(value, prev, next, list) {
        if (!(this instanceof Node)) {
          return new Node(value, prev, next, list);
        }
        this.list = list;
        this.value = value;
        if (prev) {
          prev.next = this;
          this.prev = prev;
        } else {
          this.prev = null;
        }
        if (next) {
          next.prev = this;
          this.next = next;
        } else {
          this.next = null;
        }
      }
      try {
        require_iterator()(Yallist);
      } catch (er) {
      }
    }
  });

  // node_modules/lru-cache/index.js
  var require_lru_cache = __commonJS({
    "node_modules/lru-cache/index.js"(exports, module) {
      "use strict";
      var Yallist = require_yallist();
      var MAX = Symbol("max");
      var LENGTH = Symbol("length");
      var LENGTH_CALCULATOR = Symbol("lengthCalculator");
      var ALLOW_STALE = Symbol("allowStale");
      var MAX_AGE = Symbol("maxAge");
      var DISPOSE = Symbol("dispose");
      var NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
      var LRU_LIST = Symbol("lruList");
      var CACHE = Symbol("cache");
      var UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
      var naiveLength = () => 1;
      var LRUCache = class {
        constructor(options) {
          if (typeof options === "number")
            options = { max: options };
          if (!options)
            options = {};
          if (options.max && (typeof options.max !== "number" || options.max < 0))
            throw new TypeError("max must be a non-negative number");
          const max2 = this[MAX] = options.max || Infinity;
          const lc = options.length || naiveLength;
          this[LENGTH_CALCULATOR] = typeof lc !== "function" ? naiveLength : lc;
          this[ALLOW_STALE] = options.stale || false;
          if (options.maxAge && typeof options.maxAge !== "number")
            throw new TypeError("maxAge must be a number");
          this[MAX_AGE] = options.maxAge || 0;
          this[DISPOSE] = options.dispose;
          this[NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
          this[UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
          this.reset();
        }
        // resize the cache when the max changes.
        set max(mL) {
          if (typeof mL !== "number" || mL < 0)
            throw new TypeError("max must be a non-negative number");
          this[MAX] = mL || Infinity;
          trim(this);
        }
        get max() {
          return this[MAX];
        }
        set allowStale(allowStale) {
          this[ALLOW_STALE] = !!allowStale;
        }
        get allowStale() {
          return this[ALLOW_STALE];
        }
        set maxAge(mA) {
          if (typeof mA !== "number")
            throw new TypeError("maxAge must be a non-negative number");
          this[MAX_AGE] = mA;
          trim(this);
        }
        get maxAge() {
          return this[MAX_AGE];
        }
        // resize the cache when the lengthCalculator changes.
        set lengthCalculator(lC) {
          if (typeof lC !== "function")
            lC = naiveLength;
          if (lC !== this[LENGTH_CALCULATOR]) {
            this[LENGTH_CALCULATOR] = lC;
            this[LENGTH] = 0;
            this[LRU_LIST].forEach((hit) => {
              hit.length = this[LENGTH_CALCULATOR](hit.value, hit.key);
              this[LENGTH] += hit.length;
            });
          }
          trim(this);
        }
        get lengthCalculator() {
          return this[LENGTH_CALCULATOR];
        }
        get length() {
          return this[LENGTH];
        }
        get itemCount() {
          return this[LRU_LIST].length;
        }
        rforEach(fn, thisp) {
          thisp = thisp || this;
          for (let walker = this[LRU_LIST].tail; walker !== null; ) {
            const prev = walker.prev;
            forEachStep(this, fn, walker, thisp);
            walker = prev;
          }
        }
        forEach(fn, thisp) {
          thisp = thisp || this;
          for (let walker = this[LRU_LIST].head; walker !== null; ) {
            const next = walker.next;
            forEachStep(this, fn, walker, thisp);
            walker = next;
          }
        }
        keys() {
          return this[LRU_LIST].toArray().map((k) => k.key);
        }
        values() {
          return this[LRU_LIST].toArray().map((k) => k.value);
        }
        reset() {
          if (this[DISPOSE] && this[LRU_LIST] && this[LRU_LIST].length) {
            this[LRU_LIST].forEach((hit) => this[DISPOSE](hit.key, hit.value));
          }
          this[CACHE] = /* @__PURE__ */ new Map();
          this[LRU_LIST] = new Yallist();
          this[LENGTH] = 0;
        }
        dump() {
          return this[LRU_LIST].map((hit) => isStale(this, hit) ? false : {
            k: hit.key,
            v: hit.value,
            e: hit.now + (hit.maxAge || 0)
          }).toArray().filter((h) => h);
        }
        dumpLru() {
          return this[LRU_LIST];
        }
        set(key, value, maxAge) {
          maxAge = maxAge || this[MAX_AGE];
          if (maxAge && typeof maxAge !== "number")
            throw new TypeError("maxAge must be a number");
          const now = maxAge ? Date.now() : 0;
          const len = this[LENGTH_CALCULATOR](value, key);
          if (this[CACHE].has(key)) {
            if (len > this[MAX]) {
              del(this, this[CACHE].get(key));
              return false;
            }
            const node = this[CACHE].get(key);
            const item = node.value;
            if (this[DISPOSE]) {
              if (!this[NO_DISPOSE_ON_SET])
                this[DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            trim(this);
            return true;
          }
          const hit = new Entry(key, value, len, now, maxAge);
          if (hit.length > this[MAX]) {
            if (this[DISPOSE])
              this[DISPOSE](key, value);
            return false;
          }
          this[LENGTH] += hit.length;
          this[LRU_LIST].unshift(hit);
          this[CACHE].set(key, this[LRU_LIST].head);
          trim(this);
          return true;
        }
        has(key) {
          if (!this[CACHE].has(key))
            return false;
          const hit = this[CACHE].get(key).value;
          return !isStale(this, hit);
        }
        get(key) {
          return get2(this, key, true);
        }
        peek(key) {
          return get2(this, key, false);
        }
        pop() {
          const node = this[LRU_LIST].tail;
          if (!node)
            return null;
          del(this, node);
          return node.value;
        }
        del(key) {
          del(this, this[CACHE].get(key));
        }
        load(arr) {
          this.reset();
          const now = Date.now();
          for (let l = arr.length - 1; l >= 0; l--) {
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0)
              this.set(hit.k, hit.v);
            else {
              const maxAge = expiresAt - now;
              if (maxAge > 0) {
                this.set(hit.k, hit.v, maxAge);
              }
            }
          }
        }
        prune() {
          this[CACHE].forEach((value, key) => get2(this, key, false));
        }
      };
      var get2 = (self2, key, doUse) => {
        const node = self2[CACHE].get(key);
        if (node) {
          const hit = node.value;
          if (isStale(self2, hit)) {
            del(self2, node);
            if (!self2[ALLOW_STALE])
              return void 0;
          } else {
            if (doUse) {
              if (self2[UPDATE_AGE_ON_GET])
                node.value.now = Date.now();
              self2[LRU_LIST].unshiftNode(node);
            }
          }
          return hit.value;
        }
      };
      var isStale = (self2, hit) => {
        if (!hit || !hit.maxAge && !self2[MAX_AGE])
          return false;
        const diff = Date.now() - hit.now;
        return hit.maxAge ? diff > hit.maxAge : self2[MAX_AGE] && diff > self2[MAX_AGE];
      };
      var trim = (self2) => {
        if (self2[LENGTH] > self2[MAX]) {
          for (let walker = self2[LRU_LIST].tail; self2[LENGTH] > self2[MAX] && walker !== null; ) {
            const prev = walker.prev;
            del(self2, walker);
            walker = prev;
          }
        }
      };
      var del = (self2, node) => {
        if (node) {
          const hit = node.value;
          if (self2[DISPOSE])
            self2[DISPOSE](hit.key, hit.value);
          self2[LENGTH] -= hit.length;
          self2[CACHE].delete(hit.key);
          self2[LRU_LIST].removeNode(node);
        }
      };
      var Entry = class {
        constructor(key, value, length2, now, maxAge) {
          this.key = key;
          this.value = value;
          this.length = length2;
          this.now = now;
          this.maxAge = maxAge || 0;
        }
      };
      var forEachStep = (self2, fn, node, thisp) => {
        let hit = node.value;
        if (isStale(self2, hit)) {
          del(self2, node);
          if (!self2[ALLOW_STALE])
            hit = void 0;
        }
        if (hit)
          fn.call(thisp, hit.value, hit.key, self2);
      };
      module.exports = LRUCache;
    }
  });

  // node_modules/lodash/isBoolean.js
  var require_isBoolean = __commonJS({
    "node_modules/lodash/isBoolean.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var boolTag = "[object Boolean]";
      function isBoolean2(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      module.exports = isBoolean2;
    }
  });

  // packages/utilities/memo/index.ts
  var memo_exports = {};
  __export(memo_exports, {
    cacheMemo: () => cacheMemo,
    isEqual: () => isEqual2,
    memoize: () => memoize,
    once: () => once,
    singleMemo: () => singleMemo,
    weakMemo: () => weakMemo
  });
  function memoize(fn) {
    return (0, import_reselect.defaultMemoize)(fn, isEqual2);
  }
  function weakMemo(fn) {
    if (false) {
      if (!isFunction(fn)) {
        console.error(
          `Expected a function as argument to weakMemo but got ${fn}.`
        );
      }
    }
    const map2 = /* @__PURE__ */ new WeakMap();
    const memFn = (arg) => {
      if (!(0, import_isObject.default)(arg) && !(0, import_isBoolean.default)(arg)) {
        const errorMessage = `Expected an object or boolean as an argument to "${// @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'F'.
        fn.displayName || fn.name}()", but received ${String(arg)}.`;
        const fnString = fn.toString().slice(0, 2e5);
        throw new WeakMemoError({ message: errorMessage, fn: fnString });
      }
      const key = typeof arg === "boolean" ? arg && True || False : arg;
      if (!map2.has(key)) {
        map2.set(key, fn(arg));
      }
      const result = map2.get(key);
      return result;
    };
    if (false) {
      memFn.displayName = // @ts-expect-error - TS2339 - Property 'displayName' does not exist on type 'F'. | TS2339 - Property 'name' does not exist on type 'F'. | TS2339 - Property 'toString' does not exist on type 'F'.
      "weakMemo(" + (fn.displayName || fn.name || fn.toString()) + ")";
    }
    return memFn;
  }
  var import_reselect, import_lru_cache, import_isBoolean, import_isFunction, import_isObject, True, False, is, isEqual2, cacheMemo, defaultLastArg, singleMemo, once, WeakMemoError;
  var init_memo = __esm({
    "packages/utilities/memo/index.ts"() {
      import_reselect = __toESM(require_lib4());
      import_lru_cache = __toESM(require_lru_cache());
      import_isBoolean = __toESM(require_isBoolean());
      import_isFunction = __toESM(require_isFunction());
      import_isObject = __toESM(require_isObject());
      True = { "@webflow/Boolean": true };
      False = { "@webflow/Boolean": false };
      is = (valueA, valueB) => {
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
          return true;
        }
        if (!valueA || !valueB) {
          return false;
        }
        if (typeof valueA.valueOf === "function" && typeof valueB.valueOf === "function") {
          valueA = valueA.valueOf();
          valueB = valueB.valueOf();
          if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
            return true;
          }
          if (!valueA || !valueB) {
            return false;
          }
        }
        if (typeof valueA.equals === "function" && typeof valueB.equals === "function" && valueA.equals(valueB)) {
          return true;
        }
        return false;
      };
      isEqual2 = (a, b) => {
        if (is(a, b)) {
          return true;
        }
        if (typeof a !== "object" || a === null || typeof b !== "object" || b === null) {
          return false;
        }
        for (const k in a) {
          if (!is(a[k], b[k])) {
            return false;
          }
        }
        return Object.keys(a).length === Object.keys(b).length;
      };
      cacheMemo = (depth) => {
        const memoizeFn = (fn) => {
          const cache = new import_lru_cache.default({
            max: depth
          });
          return function(arg) {
            if (!cache.has(arg)) {
              cache.set(arg, fn(arg));
            }
            return cache.get(arg);
          };
        };
        return memoizeFn;
      };
      defaultLastArg = Symbol();
      singleMemo = (fn) => {
        let lastArg = defaultLastArg;
        let lastResult;
        return (arg) => {
          if (arg !== lastArg) {
            lastResult = fn(arg);
            lastArg = arg;
          }
          return lastResult;
        };
      };
      once = (fn) => {
        let result;
        return () => {
          if (fn) {
            result = fn();
            fn = void 0;
          }
          return result;
        };
      };
      WeakMemoError = class extends TypeError {
        fn;
        constructor(opts) {
          super();
          if (TypeError.captureStackTrace) {
            TypeError.captureStackTrace(this, WeakMemoError);
          }
          this.name = "WeakMemoError";
          this.message = opts.message;
          this.fn = opts.fn;
        }
      };
    }
  });

  // packages/systems/dynamo/utils/ConditionUtils/ConditionUtils.js
  var require_ConditionUtils = __commonJS({
    "packages/systems/dynamo/utils/ConditionUtils/ConditionUtils.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.testCondition = void 0;
      var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require_objectWithoutPropertiesLoose());
      var _extends2 = _interopRequireDefault(require_extends());
      var _DynamoConditionUtils = require_DynamoConditionUtils();
      var _momentTimezone = _interopRequireDefault(require_moment_timezone2());
      var _SlugUtils = (init_SlugUtils2(), __toCommonJS(SlugUtils_exports));
      var _memo = (init_memo(), __toCommonJS(memo_exports));
      var _ParamFieldPathUtils = (init_ParamFieldPathUtils(), __toCommonJS(ParamFieldPathUtils_exports));
      var _constants = (init_constants(), __toCommonJS(constants_exports));
      var _FilterUtils = require_FilterUtils2();
      var _excluded = ["id"];
      var getId = (record2) => {
        return record2._id || record2.id || (record2.get ? record2.get("_id", record2.get("id")) : null);
      };
      var isDateStringWithoutTime = (dateString) => /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(dateString);
      var toGraphQLSlug = (originalSlug) => {
        const slug = handleId(originalSlug);
        return slug === "id" || (0, _SlugUtils.isDynamoGraphQLFieldSlug)(slug) || // Don't want to namespace field slug when retrieving product inventory data
        slug === "ecSkuInventoryQuantity" ? slug : (0, _SlugUtils.fieldSlug)(slug);
      };
      var handleId = (slug) => slug === "_id" ? "id" : slug;
      var isObj = (x) => x !== null && typeof x === "object" && !Array.isArray(x);
      var isMap = (x) => x && Boolean(x["@@__IMMUTABLE_MAP__@@"]);
      var isList = (x) => x && Boolean(x["@@__IMMUTABLE_LIST__@@"]);
      var isRecord = (x) => x && Boolean(x["@@__IMMUTABLE_RECORD__@@"]);
      var memoizedToJS = (0, _memo.weakMemo)((imm) => imm.toJS());
      var convertImmutableDataStructure = (value) => {
        if (isMap(value) || isList(value) || isRecord(value)) {
          return memoizedToJS(value);
        }
        return value;
      };
      var getFieldsFromConditions = (conditions) => isMap(conditions) ? conditions.get("fields") : conditions.fields;
      var testCondition = ({
        item,
        contextItem,
        timezone,
        condition,
        graphQLSlugs
      }) => {
        const cleanSlug = graphQLSlugs ? toGraphQLSlug : handleId;
        const plainCondition = convertImmutableDataStructure(condition);
        const plainItem = withCleanedSlugs(convertImmutableDataStructure(item), cleanSlug);
        const conditionData = reifyConditions(plainCondition, contextItem, cleanSlug);
        const conditionFields = (0, _FilterUtils.normalizeConditionFields)(conditionData.fields);
        const itemData = conditionFields.reduce((acc, field) => {
          const {
            fieldPath,
            type
          } = field;
          const itemFieldValue = (0, _DynamoConditionUtils.getItemFieldValue)(plainItem, fieldPath);
          if (itemFieldValue == null) {
            return acc;
          }
          acc[fieldPath] = castFieldValue(itemFieldValue, type, timezone);
          return acc;
        }, {});
        return (0, _DynamoConditionUtils.test)(itemData, conditionData, timezone);
      };
      exports.testCondition = testCondition;
      var fieldConditionsUpdater = (contextItem, cleanSlug) => (fields) => {
        const plainFields = convertImmutableDataStructure(fields);
        if (Array.isArray(fields)) {
          return plainFields.map(reifyQueryField(contextItem, cleanSlug));
        }
        return Object.entries(plainFields).reduce((acc, plainField) => {
          const [path, item] = reifyCondition(contextItem, cleanSlug)(plainField);
          acc[path] = item;
          return acc;
        }, {});
      };
      var withCleanedSlugs = (obj, cleanSlug) => {
        return Object.keys(obj).reduce((objWithCleanSlugs, slug) => {
          objWithCleanSlugs[cleanSlug(slug)] = obj[slug];
          return objWithCleanSlugs;
        }, {});
      };
      var reifyConditions = (conditions, contextItem, cleanSlug) => (0, _extends2.default)({}, conditions, {
        fields: fieldConditionsUpdater(contextItem, cleanSlug)(getFieldsFromConditions(conditions))
      });
      var createNewFieldPath = (fieldPath, cleanSlug) => {
        const itemRefFieldSlug = (0, _ParamFieldPathUtils.getItemRefSlug)(fieldPath);
        const valueFieldSlug = (0, _ParamFieldPathUtils.getValueFieldSlug)(fieldPath);
        return itemRefFieldSlug ? (0, _ParamFieldPathUtils.createFieldPath)(cleanSlug(itemRefFieldSlug), cleanSlug(valueFieldSlug)) : (0, _ParamFieldPathUtils.createFieldPath)(cleanSlug(valueFieldSlug));
      };
      var reifyCondition = (contextItem, cleanSlug) => (fieldEntry) => {
        const [fieldPath, operation] = fieldEntry;
        const newFieldPath = createNewFieldPath(fieldPath, cleanSlug);
        const pageItemDataReducer = replacePageItemData(contextItem, cleanSlug);
        return [newFieldPath, Object.entries(operation).reduce((acc, entry) => {
          const [key, value] = entry;
          return pageItemDataReducer(acc, value, key);
        }, {})];
      };
      var reifyQueryField = (contextItem, cleanSlug) => (field) => {
        const {
          fieldPath,
          value
        } = field;
        const newFieldPath = createNewFieldPath(fieldPath, cleanSlug);
        return (0, _extends2.default)({}, field, {
          fieldPath: newFieldPath,
          value: replaceValueBasedOnPageItemData(contextItem, cleanSlug, value)
        });
      };
      var replacePageItemData = (contextItem, cleanSlug) => (acc, value, key) => {
        acc[key] = replaceValueBasedOnPageItemData(contextItem, cleanSlug, value);
        return acc;
      };
      var replaceValueBasedOnPageItemData = (contextItem, cleanSlug, value) => {
        const plainPageItem = convertImmutableDataStructure(contextItem);
        const pageItemId = plainPageItem ? getId(plainPageItem) : null;
        if (typeof value === "string") {
          if (value === "DYN_CONTEXT") {
            if (pageItemId) {
              return pageItemId;
            }
          }
          if (/^DYN_CONTEXT/.test(value)) {
            const dynContextFieldSlug = value.replace(/^DYN_CONTEXT\./, "");
            const dynContextFieldValue = plainPageItem && plainPageItem[cleanSlug(dynContextFieldSlug)];
            const conditionValue = Array.isArray(dynContextFieldValue) ? dynContextFieldValue.map(dynContextFieldValueId) : dynContextFieldValueId(dynContextFieldValue);
            if (plainPageItem) {
              return conditionValue || _constants.NON_EXISTING_ITEM_ID;
            }
          }
        }
        return value;
      };
      var dynContextFieldValueId = (dynContextFieldValue) => {
        return isObj(dynContextFieldValue) ? getId(dynContextFieldValue) : dynContextFieldValue;
      };
      var castFieldValue = (fieldValue, fieldType, timezone) => {
        switch (fieldType) {
          case "Date": {
            const dateStringWithoutTime = isDateStringWithoutTime(fieldValue);
            return dateStringWithoutTime ? _momentTimezone.default.tz(fieldValue, timezone).toDate() : _momentTimezone.default.utc(fieldValue).toDate();
          }
          case "Option":
          case "ItemRef": {
            return isObj(fieldValue) ? getId(fieldValue) : fieldValue;
          }
          case "ItemRefSet": {
            return Array.isArray(fieldValue) && fieldValue.length ? Object.values(fieldValue).map((ref) => {
              if (typeof ref === "string") {
                return {
                  _id: ref
                };
              }
              const restOfRef = (0, _objectWithoutPropertiesLoose2.default)(ref, _excluded);
              return (0, _extends2.default)({}, restOfRef, {
                _id: getId(ref)
              });
            }) : null;
          }
          default: {
            return fieldValue;
          }
        }
      };
    }
  });

  // packages/systems/dynamo/utils/ConditionUtils/index.js
  var require_ConditionUtils2 = __commonJS({
    "packages/systems/dynamo/utils/ConditionUtils/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _ConditionUtils = require_ConditionUtils();
      Object.keys(_ConditionUtils).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports && exports[key] === _ConditionUtils[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _ConditionUtils[key];
          }
        });
      });
    }
  });

  // packages/systems/dynamo/utils/RenderingUtils/RenderingUtils.js
  var require_RenderingUtils = __commonJS({
    "packages/systems/dynamo/utils/RenderingUtils/RenderingUtils.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.removeWDynBindEmptyClass = exports.applyConditionToNode = void 0;
      exports.walkDOM = walkDOM;
      var _constants = (init_constants(), __toCommonJS(constants_exports));
      var _ConditionUtils = require_ConditionUtils2();
      var removeClass = (node, className) => {
        if (node.classList.contains(className)) {
          node.classList.remove(className);
          if (node.classList.length === 0) {
            node.removeAttribute("class");
          }
        }
      };
      var removeWDynBindEmptyClass = (node) => removeClass(node, _constants.CLASS_NAME_W_DYN_BIND_EMPTY);
      exports.removeWDynBindEmptyClass = removeWDynBindEmptyClass;
      var addConditionalVisibilityClass = (node) => {
        node.classList.add(_constants.CONDITION_INVISIBLE_CLASS);
      };
      var removeConditionalVisibilityClass = (node) => removeClass(node, _constants.CONDITION_INVISIBLE_CLASS);
      var applyConditionToNode = (node, item, conditionData, graphQLSlugs = false) => {
        if (!conditionData) {
          return;
        }
        const {
          condition,
          timezone
        } = conditionData;
        if (item) {
          const isVisible = (0, _ConditionUtils.testCondition)({
            item,
            contextItem: null,
            timezone,
            condition,
            graphQLSlugs
          });
          if (isVisible) {
            removeConditionalVisibilityClass(node);
          } else {
            addConditionalVisibilityClass(node);
          }
        }
      };
      exports.applyConditionToNode = applyConditionToNode;
      function walkDOM(el, fn) {
        fn(el);
        if (!el || !el.children) {
          return el;
        }
        const children = Array.from(el.children);
        if (!children.length) {
          return el;
        }
        children.forEach((child) => walkDOM(child, fn));
        return el;
      }
    }
  });

  // packages/systems/dynamo/utils/RenderingUtils/index.js
  var require_RenderingUtils2 = __commonJS({
    "packages/systems/dynamo/utils/RenderingUtils/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _RenderingUtils = require_RenderingUtils();
      Object.keys(_RenderingUtils).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports && exports[key] === _RenderingUtils[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _RenderingUtils[key];
          }
        });
      });
    }
  });

  // node_modules/lodash/_arrayAggregator.js
  var require_arrayAggregator = __commonJS({
    "node_modules/lodash/_arrayAggregator.js"(exports, module) {
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length2 = array == null ? 0 : array.length;
        while (++index < length2) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      module.exports = arrayAggregator;
    }
  });

  // node_modules/lodash/_baseAggregator.js
  var require_baseAggregator = __commonJS({
    "node_modules/lodash/_baseAggregator.js"(exports, module) {
      var baseEach = require_baseEach();
      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function(value, key, collection2) {
          setter(accumulator, value, iteratee(value), collection2);
        });
        return accumulator;
      }
      module.exports = baseAggregator;
    }
  });

  // node_modules/lodash/_createAggregator.js
  var require_createAggregator = __commonJS({
    "node_modules/lodash/_createAggregator.js"(exports, module) {
      var arrayAggregator = require_arrayAggregator();
      var baseAggregator = require_baseAggregator();
      var baseIteratee = require_baseIteratee();
      var isArray = require_isArray();
      function createAggregator(setter, initializer) {
        return function(collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
          return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
        };
      }
      module.exports = createAggregator;
    }
  });

  // node_modules/lodash/keyBy.js
  var require_keyBy = __commonJS({
    "node_modules/lodash/keyBy.js"(exports, module) {
      var baseAssignValue = require_baseAssignValue();
      var createAggregator = require_createAggregator();
      var keyBy = createAggregator(function(result, value, key) {
        baseAssignValue(result, key, value);
      });
      module.exports = keyBy;
    }
  });

  // node_modules/lodash/isNumber.js
  var require_isNumber = __commonJS({
    "node_modules/lodash/isNumber.js"(exports, module) {
      var baseGetTag = require_baseGetTag();
      var isObjectLike = require_isObjectLike();
      var numberTag = "[object Number]";
      function isNumber(value) {
        return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      module.exports = isNumber;
    }
  });

  // packages/systems/core/utils/CurrencyUtils/CurrencyUtils.js
  var require_CurrencyUtils = __commonJS({
    "packages/systems/core/utils/CurrencyUtils/CurrencyUtils.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports._invalid = _invalid;
      exports.convertPaypalAmountToWFPrice = convertPaypalAmountToWFPrice;
      exports.convertWFPriceToPaypalAmount = convertWFPriceToPaypalAmount;
      exports.convertWFPriceToPaypalAmountWithBreakdown = convertWFPriceToPaypalAmountWithBreakdown;
      exports.currencyInfoByCodePaypal = exports.currencyInfoByCode = void 0;
      exports.equalPrice = equalPrice;
      exports.formatPrice = formatPrice;
      exports.getCurrencyInfo = getCurrencyInfo;
      exports.getCurrencyInfoPaypal = getCurrencyInfoPaypal;
      exports.intToUnsafeFloat = exports.getCurrencySymbol = void 0;
      exports.parsePrice = parsePrice;
      exports.renderPrice = renderPrice;
      exports.scalePrice = scalePrice;
      exports.subtractPrice = subtractPrice;
      exports.sumPrice = sumPrice;
      exports.unsafeFloatToInt = void 0;
      exports.validatePrice = validatePrice;
      exports.zeroUnitPaypal = zeroUnitPaypal;
      exports.zeroUnitWF = zeroUnitWF;
      var _extends2 = _interopRequireDefault(require_extends());
      var _keyBy = _interopRequireDefault(require_keyBy());
      var _memoize = _interopRequireDefault(require_memoize());
      var _isString = _interopRequireDefault(require_isString());
      var _isNumber = _interopRequireDefault(require_isNumber());
      var _constants = require_constants2();
      var currencyInfoByCode = (0, _keyBy.default)(_constants.stripeCurrencyList, "code");
      exports.currencyInfoByCode = currencyInfoByCode;
      var currencyInfoByCodePaypal = (0, _keyBy.default)(_constants.paypalCurrencyList, "code");
      exports.currencyInfoByCodePaypal = currencyInfoByCodePaypal;
      function getCurrencyInfo(code, platform = "stripe") {
        if (isValidCurrency(code)) {
          return platform === "stripe" ? (
            // $FlowIgnore
            currencyInfoByCode[code.toUpperCase()]
          ) : (
            // $FlowIgnore
            currencyInfoByCodePaypal[code.toUpperCase()]
          );
        }
        return {
          code: "???",
          digits: 2,
          minCharge: 0,
          name: `Unknown currency`
        };
      }
      function getCurrencyInfoPaypal(code) {
        return getCurrencyInfo(code, "paypal");
      }
      var isValidCurrency = (currencyCode) => typeof currencyCode === "string" && currencyInfoByCode.hasOwnProperty(currencyCode.toUpperCase());
      var NullNumberFormat = class {
        format(_value) {
          return "NaN";
        }
      };
      var getNumberFormat = (0, _memoize.default)(
        (unit, currencyDisplay = "symbol") => (
          // HACK: for some reason, GraphQL is returning a currency of '???' for null
          // prices; we're temporarily glossing over this fact, and will address the
          // backend at a later time..
          unit != null && isValidCurrency(unit) ? new Intl.NumberFormat("en-US", {
            currency: unit,
            style: "currency",
            currencyDisplay
          }) : new NullNumberFormat()
        ),
        /* cache key function **/
        (unit, currencyDisplay = "symbol") => {
          return [String(unit), currencyDisplay].join("::");
        }
      );
      var getCurrencySymbol = (unit) => {
        const symbol = String(getNumberFormat(unit).format(0)).match(/^([^0-9\s]*)/);
        return symbol ? symbol[0] : unit;
      };
      exports.getCurrencySymbol = getCurrencySymbol;
      var unsafeFloatToInt = (floatValue, currency, round = Math.round) => {
        const currencyInfo = typeof currency === "object" ? currency : getCurrencyInfo(currency);
        return round(floatValue * Math.pow(10, currencyInfo.digits));
      };
      exports.unsafeFloatToInt = unsafeFloatToInt;
      var intToUnsafeFloat = (intValue, currency) => {
        const currencyInfo = typeof currency === "object" ? currency : getCurrencyInfo(currency);
        return intValue / Math.pow(10, currencyInfo.digits);
      };
      exports.intToUnsafeFloat = intToUnsafeFloat;
      function renderPrice(price, opts = {}) {
        const {
          isoFormat = false,
          noCurrency = false
        } = opts;
        price = validatePrice(price) ? price : _invalid();
        const normal_value = Number(price.value);
        const currencyInfo = getCurrencyInfo(price.unit);
        const float_value = intToUnsafeFloat(normal_value, currencyInfo);
        if (Number.isNaN(float_value)) {
          return "NaN";
        }
        if (noCurrency) {
          return String(float_value);
        }
        const fmt = getNumberFormat(price.unit, isoFormat ? "code" : "symbol");
        return fmt.format(float_value);
      }
      function formatPrice(price) {
        price = validatePrice(price) ? price : _invalid();
        const string = renderPrice(price);
        return {
          unit: price.unit,
          value: price.value,
          string
        };
      }
      function validatePrice(a) {
        if (!a || typeof a !== "object") {
          return false;
        }
        if (!(0, _isNumber.default)(a.value)) {
          return false;
        }
        if (!(0, _isString.default)(a.unit)) {
          return false;
        }
        if (!isValidCurrency(a.unit)) {
          return false;
        }
        return true;
      }
      function sumPrice(a, b) {
        if (!validatePrice(a) || !validatePrice(b)) {
          return _invalid();
        }
        if (a.unit !== b.unit) {
          return _invalid();
        }
        return {
          value: a.value + b.value,
          unit: a.unit
        };
      }
      function subtractPrice(a, b) {
        if (!validatePrice(a) || !validatePrice(b)) {
          return _invalid();
        }
        if (a.unit !== b.unit) {
          return _invalid();
        }
        return {
          value: a.value - b.value,
          unit: a.unit
        };
      }
      function scalePrice(a, scalar) {
        if (!validatePrice(a) || !(0, _isNumber.default)(scalar)) {
          return _invalid();
        }
        const value = Math.round(a.value * scalar);
        const unit = a.unit;
        return {
          value,
          unit
        };
      }
      function equalPrice(a, b) {
        return Boolean(a && b && a.value === b.value && a.unit === b.unit);
      }
      function parsePrice(priceString, unit, fallback) {
        if (typeof priceString !== "string") {
          throw new Error("parsePrice must be called with a string");
        }
        if (!isValidCurrency(unit)) {
          throw new Error(`parsePrice called with invalid currency ${unit}`);
        }
        if (!priceString) {
          return fallback;
        }
        const rawNumber = Number(priceString);
        if (Number.isNaN(rawNumber)) {
          return fallback;
        }
        return {
          value: unsafeFloatToInt(rawNumber, unit),
          unit
        };
      }
      function _invalid() {
        return {
          value: NaN,
          unit: "???"
        };
      }
      function zeroUnitWF(unit) {
        return {
          unit,
          value: 0
        };
      }
      function zeroUnitPaypal(unit) {
        return convertWFPriceToPaypalAmount(zeroUnitWF(unit));
      }
      function convertWFPriceToPaypalAmountWithBreakdown(orderPrices) {
        const {
          total,
          subtotal,
          shipping,
          tax,
          discount,
          discountShipping
        } = orderPrices;
        const convertOrZero = (price, scalar) => price ? convertWFPriceToPaypalAmount(price, scalar) : zeroUnitPaypal(total.unit);
        return (0, _extends2.default)({}, convertWFPriceToPaypalAmount(total), {
          breakdown: {
            item_total: convertOrZero(subtotal),
            shipping: convertOrZero(shipping),
            tax_total: convertOrZero(tax),
            discount: convertOrZero(discount, -1),
            shipping_discount: convertOrZero(discountShipping, -1)
          }
        });
      }
      function convertWFPriceToPaypalAmount(a, scalar) {
        const unitInfo = getCurrencyInfoPaypal(a.unit);
        const wfValue = scalar ? scalePrice(a, scalar).value : a.value;
        const value = intToUnsafeFloat(wfValue, unitInfo).toFixed(unitInfo.digits);
        return {
          currency_code: a.unit,
          value
        };
      }
      function convertPaypalAmountToWFPrice(a) {
        const unitInfo = getCurrencyInfoPaypal(a.currency_code);
        const value = unsafeFloatToInt(parseFloat(a.value), unitInfo);
        return {
          unit: a.currency_code,
          value
        };
      }
    }
  });

  // node_modules/lodash/isInteger.js
  var require_isInteger = __commonJS({
    "node_modules/lodash/isInteger.js"(exports, module) {
      var toInteger = require_toInteger();
      function isInteger(value) {
        return typeof value == "number" && value == toInteger(value);
      }
      module.exports = isInteger;
    }
  });

  // node_modules/accounting/accounting.js
  var require_accounting = __commonJS({
    "node_modules/accounting/accounting.js"(exports, module) {
      (function(root, undefined2) {
        var lib = {};
        lib.version = "0.4.1";
        lib.settings = {
          currency: {
            symbol: "$",
            // default currency symbol is '$'
            format: "%s%v",
            // controls output: %s = symbol, %v = value (can be object, see docs)
            decimal: ".",
            // decimal point separator
            thousand: ",",
            // thousands separator
            precision: 2,
            // decimal places
            grouping: 3
            // digit grouping (not implemented yet)
          },
          number: {
            precision: 0,
            // default precision on numbers is 0
            grouping: 3,
            // digit grouping (not implemented yet)
            thousand: ",",
            decimal: "."
          }
        };
        var nativeMap = Array.prototype.map, nativeIsArray = Array.isArray, toString4 = Object.prototype.toString;
        function isString(obj) {
          return !!(obj === "" || obj && obj.charCodeAt && obj.substr);
        }
        function isArray(obj) {
          return nativeIsArray ? nativeIsArray(obj) : toString4.call(obj) === "[object Array]";
        }
        function isObject2(obj) {
          return obj && toString4.call(obj) === "[object Object]";
        }
        function defaults(object, defs) {
          var key;
          object = object || {};
          defs = defs || {};
          for (key in defs) {
            if (defs.hasOwnProperty(key)) {
              if (object[key] == null)
                object[key] = defs[key];
            }
          }
          return object;
        }
        function map2(obj, iterator, context) {
          var results = [], i, j;
          if (!obj)
            return results;
          if (nativeMap && obj.map === nativeMap)
            return obj.map(iterator, context);
          for (i = 0, j = obj.length; i < j; i++) {
            results[i] = iterator.call(context, obj[i], i, obj);
          }
          return results;
        }
        function checkPrecision(val, base) {
          val = Math.round(Math.abs(val));
          return isNaN(val) ? base : val;
        }
        function checkCurrencyFormat(format) {
          var defaults2 = lib.settings.currency.format;
          if (typeof format === "function")
            format = format();
          if (isString(format) && format.match("%v")) {
            return {
              pos: format,
              neg: format.replace("-", "").replace("%v", "-%v"),
              zero: format
            };
          } else if (!format || !format.pos || !format.pos.match("%v")) {
            return !isString(defaults2) ? defaults2 : lib.settings.currency.format = {
              pos: defaults2,
              neg: defaults2.replace("%v", "-%v"),
              zero: defaults2
            };
          }
          return format;
        }
        var unformat = lib.unformat = lib.parse = function(value, decimal) {
          if (isArray(value)) {
            return map2(value, function(val) {
              return unformat(val, decimal);
            });
          }
          value = value || 0;
          if (typeof value === "number")
            return value;
          decimal = decimal || lib.settings.number.decimal;
          var regex = new RegExp("[^0-9-" + decimal + "]", ["g"]), unformatted = parseFloat(
            ("" + value).replace(/\((.*)\)/, "-$1").replace(regex, "").replace(decimal, ".")
            // make sure decimal point is standard
          );
          return !isNaN(unformatted) ? unformatted : 0;
        };
        var toFixed = lib.toFixed = function(value, precision) {
          precision = checkPrecision(precision, lib.settings.number.precision);
          var power = Math.pow(10, precision);
          return (Math.round(lib.unformat(value) * power) / power).toFixed(precision);
        };
        var formatNumber2 = lib.formatNumber = lib.format = function(number, precision, thousand, decimal) {
          if (isArray(number)) {
            return map2(number, function(val) {
              return formatNumber2(val, precision, thousand, decimal);
            });
          }
          number = unformat(number);
          var opts = defaults(
            isObject2(precision) ? precision : {
              precision,
              thousand,
              decimal
            },
            lib.settings.number
          ), usePrecision = checkPrecision(opts.precision), negative = number < 0 ? "-" : "", base = parseInt(toFixed(Math.abs(number || 0), usePrecision), 10) + "", mod = base.length > 3 ? base.length % 3 : 0;
          return negative + (mod ? base.substr(0, mod) + opts.thousand : "") + base.substr(mod).replace(/(\d{3})(?=\d)/g, "$1" + opts.thousand) + (usePrecision ? opts.decimal + toFixed(Math.abs(number), usePrecision).split(".")[1] : "");
        };
        var formatMoney = lib.formatMoney = function(number, symbol, precision, thousand, decimal, format) {
          if (isArray(number)) {
            return map2(number, function(val) {
              return formatMoney(val, symbol, precision, thousand, decimal, format);
            });
          }
          number = unformat(number);
          var opts = defaults(
            isObject2(symbol) ? symbol : {
              symbol,
              precision,
              thousand,
              decimal,
              format
            },
            lib.settings.currency
          ), formats = checkCurrencyFormat(opts.format), useFormat = number > 0 ? formats.pos : number < 0 ? formats.neg : formats.zero;
          return useFormat.replace("%s", opts.symbol).replace("%v", formatNumber2(Math.abs(number), checkPrecision(opts.precision), opts.thousand, opts.decimal));
        };
        lib.formatColumn = function(list, symbol, precision, thousand, decimal, format) {
          if (!list)
            return [];
          var opts = defaults(
            isObject2(symbol) ? symbol : {
              symbol,
              precision,
              thousand,
              decimal,
              format
            },
            lib.settings.currency
          ), formats = checkCurrencyFormat(opts.format), padAfterSymbol = formats.pos.indexOf("%s") < formats.pos.indexOf("%v") ? true : false, maxLength = 0, formatted = map2(list, function(val, i) {
            if (isArray(val)) {
              return lib.formatColumn(val, opts);
            } else {
              val = unformat(val);
              var useFormat = val > 0 ? formats.pos : val < 0 ? formats.neg : formats.zero, fVal = useFormat.replace("%s", opts.symbol).replace("%v", formatNumber2(Math.abs(val), checkPrecision(opts.precision), opts.thousand, opts.decimal));
              if (fVal.length > maxLength)
                maxLength = fVal.length;
              return fVal;
            }
          });
          return map2(formatted, function(val, i) {
            if (isString(val) && val.length < maxLength) {
              return padAfterSymbol ? val.replace(opts.symbol, opts.symbol + new Array(maxLength - val.length + 1).join(" ")) : new Array(maxLength - val.length + 1).join(" ") + val;
            }
            return val;
          });
        };
        if (typeof exports !== "undefined") {
          if (typeof module !== "undefined" && module.exports) {
            exports = module.exports = lib;
          }
          exports.accounting = lib;
        } else if (typeof define === "function" && define.amd) {
          define([], function() {
            return lib;
          });
        } else {
          lib.noConflict = function(oldAccounting) {
            return function() {
              root.accounting = oldAccounting;
              lib.noConflict = undefined2;
              return lib;
            };
          }(root.accounting);
          root["accounting"] = lib;
        }
      })(exports);
    }
  });

  // node_modules/lodash/_unescapeHtmlChar.js
  var require_unescapeHtmlChar = __commonJS({
    "node_modules/lodash/_unescapeHtmlChar.js"(exports, module) {
      var basePropertyOf = require_basePropertyOf();
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      module.exports = unescapeHtmlChar;
    }
  });

  // node_modules/lodash/unescape.js
  var require_unescape = __commonJS({
    "node_modules/lodash/unescape.js"(exports, module) {
      var toString4 = require_toString();
      var unescapeHtmlChar = require_unescapeHtmlChar();
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g;
      var reHasEscapedHtml = RegExp(reEscapedHtml.source);
      function unescape3(string) {
        string = toString4(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      module.exports = unescape3;
    }
  });

  // packages/systems/core/utils/EmbedUtils/shared/index.ts
  function parseTokenJson(string) {
    if (string.match(getWfTokenPattern())) {
      let token;
      try {
        token = JSON.parse((0, import_unescape.default)(extractToken(string).replace(/\\}/g, "}")));
      } catch (err) {
        return null;
      }
      if (!token || !token.path || !token.type) {
        return null;
      } else {
        return token;
      }
    } else {
      return null;
    }
  }
  function extractToken(string, {
    shortHand
  } = {}) {
    return shortHand ? string.replace(getCatchAllTokenPattern(), (match2, subMatch) => {
      return stripLegacyShorthandSuffix(subMatch);
    }) : string.replace(getWfTokenPattern(), "$1");
  }
  function stripLegacyShorthandSuffix(tokenPath) {
    return tokenPath.split(":").map((part) => part.split(".")[0]).join(":");
  }
  var import_unescape, getWfTokenPattern, getCatchAllTokenPattern;
  var init_shared = __esm({
    "packages/systems/core/utils/EmbedUtils/shared/index.ts"() {
      "use strict";
      import_unescape = __toESM(require_unescape());
      getWfTokenPattern = function() {
        return /{{\s*wf\s*({.*?})\s*}}/g;
      };
      getCatchAllTokenPattern = function() {
        return /{{\s*(.*?)\s*}}/g;
      };
    }
  });

  // packages/systems/core/utils/EmbedUtils/simpleReplaceTokens/index.ts
  var simpleReplaceTokens_exports = {};
  __export(simpleReplaceTokens_exports, {
    simpleReplaceTokens: () => simpleReplaceTokens
  });
  function simpleReplaceTokens(replaceable, item) {
    return replaceable.replace(getWfTokenPattern(), function(match2) {
      const token = parseTokenJson(match2) || {};
      const path = token.path.split(".");
      return (0, import_isFunction2.default)(item.getIn) ? item.getIn(path, "") : (0, import_get.default)(item, path, "");
    });
  }
  var import_isFunction2, import_get;
  var init_simpleReplaceTokens = __esm({
    "packages/systems/core/utils/EmbedUtils/simpleReplaceTokens/index.ts"() {
      import_isFunction2 = __toESM(require_isFunction());
      import_get = __toESM(require_get());
      init_shared();
    }
  });

  // packages/systems/core/utils/CurrencyUtils/renderPrice.js
  var require_renderPrice = __commonJS({
    "packages/systems/core/utils/CurrencyUtils/renderPrice.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.formatPriceFromSettings = formatPriceFromSettings;
      exports.getCurrencySettingsFromCommerceSettings = getCurrencySettingsFromCommerceSettings;
      exports.renderAmountFromSettings = renderAmountFromSettings;
      exports.renderPriceFromSettings = renderPriceFromSettings;
      var _get = _interopRequireDefault(require_get());
      var _isInteger = _interopRequireDefault(require_isInteger());
      var _accounting = require_accounting();
      var _simpleReplaceTokens = (init_simpleReplaceTokens(), __toCommonJS(simpleReplaceTokens_exports));
      var _CurrencyUtils = require_CurrencyUtils();
      function formatPriceFromSettings(price, currencySettings) {
        price = (0, _CurrencyUtils.validatePrice)(price) ? price : (0, _CurrencyUtils._invalid)();
        const string = renderPriceFromSettings(price, currencySettings);
        return {
          unit: price.unit,
          value: price.value,
          string
        };
      }
      function getCurrencySettingsFromCommerceSettings(commerceSettings) {
        const getTheStuff = typeof commerceSettings.getIn === "function" ? (
          // $FlowFixMe getIn is being manually checked for
          (keyPath, defaultValue) => commerceSettings.getIn(keyPath, defaultValue)
        ) : (keyPath, defaultValue) => (0, _get.default)(commerceSettings, keyPath, defaultValue);
        return {
          hideDecimalForWholeNumbers: getTheStuff(["defaultCurrencyFormat", "hideDecimalForWholeNumbers"], false),
          fractionDigits: getTheStuff(["defaultCurrencyFormat", "fractionDigits"], 2),
          template: getTheStuff(["defaultCurrencyFormat", "template"], ""),
          decimal: getTheStuff(["defaultCurrencyFormat", "decimal"], "."),
          group: getTheStuff(["defaultCurrencyFormat", "group"], ","),
          symbol: getTheStuff(["defaultCurrencyFormat", "symbol"], "$"),
          currencyCode: getTheStuff(["defaultCurrency"], "USD")
        };
      }
      var _nonBreakingSpace = String.fromCharCode(160);
      var _replaceAllSpaceWithNBSP = (str) => str.replace(/\s/g, _nonBreakingSpace);
      function renderAmountFromSettings(amount, amountSettings = {}) {
        if (typeof amount === "undefined") {
          return "";
        }
        if (typeof amount === "string") {
          if (amount === "\u221E") {
            return amount;
          }
          throw new Error(`amount has type string: got ${amount}, expected \u221E`);
        }
        const jsValue = amount / parseFloat(`1${"0".repeat(amountSettings.fractionDigits || 0)}`);
        const precision = (0, _isInteger.default)(jsValue) && amountSettings.hideDecimalForWholeNumbers ? 0 : amountSettings.fractionDigits;
        return (0, _accounting.formatMoney)(jsValue, {
          symbol: "",
          decimal: amountSettings.decimal,
          precision,
          thousand: amountSettings.group
        });
      }
      function renderPriceFromSettings(price, currencySettings = {}, renderOpts = {}) {
        const {
          template,
          currencyCode
        } = currencySettings;
        if (!template || price.unit !== currencyCode) {
          return (0, _CurrencyUtils.renderPrice)(price);
        }
        return (price.value < 0 ? "\u2212" : "") + // negative sign to appear before currency symbol e.g., -$ 5.00 USD
        (0, _simpleReplaceTokens.simpleReplaceTokens)((renderOpts.breakingWhitespace ? currencySettings.template : _replaceAllSpaceWithNBSP(currencySettings.template)) || "", {
          amount: renderAmountFromSettings(Math.abs(price.value), currencySettings),
          symbol: currencySettings.symbol,
          currencyCode: currencySettings.currencyCode
        });
      }
    }
  });

  // packages/systems/core/utils/CurrencyUtils/index.js
  var require_CurrencyUtils2 = __commonJS({
    "packages/systems/core/utils/CurrencyUtils/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _CurrencyUtils = require_CurrencyUtils();
      Object.keys(_CurrencyUtils).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports && exports[key] === _CurrencyUtils[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _CurrencyUtils[key];
          }
        });
      });
      var _renderPrice = require_renderPrice();
      Object.keys(_renderPrice).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports && exports[key] === _renderPrice[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _renderPrice[key];
          }
        });
      });
    }
  });

  // node_modules/lodash/_escapeHtmlChar.js
  var require_escapeHtmlChar = __commonJS({
    "node_modules/lodash/_escapeHtmlChar.js"(exports, module) {
      var basePropertyOf = require_basePropertyOf();
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      module.exports = escapeHtmlChar;
    }
  });

  // node_modules/lodash/escape.js
  var require_escape = __commonJS({
    "node_modules/lodash/escape.js"(exports, module) {
      var escapeHtmlChar = require_escapeHtmlChar();
      var toString4 = require_toString();
      var reUnescapedHtml = /[&<>"']/g;
      var reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      function escape2(string) {
        string = toString4(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      module.exports = escape2;
    }
  });

  // packages/systems/dynamo/utils/DynamoFormattingUtils/index.ts
  var DynamoFormattingUtils_exports = {};
  __export(DynamoFormattingUtils_exports, {
    formatEmail: () => formatEmail,
    formatNumber: () => formatNumber,
    formatPhone: () => formatPhone
  });
  function formatNumber(n, formatType) {
    if (typeof n === "number") {
      const precision = formatType === "" || formatType === "none" ? NaN : Number(formatType);
      if (!isNaN(precision)) {
        return n.toFixed(precision);
      } else {
        return String(n);
      }
    } else {
      return "";
    }
  }
  function formatEmail(email, subject, property) {
    const prefix = property === "href" ? "mailto:" : "";
    if (email && subject) {
      return prefix + email + "?subject=" + subject;
    } else if (email) {
      return prefix + email;
    } else {
      return null;
    }
  }
  function formatPhone(phone, property) {
    if (property === "href") {
      let tel = phone ? phone.replace(/\s/g, "") : "";
      if (/\d/.test(tel)) {
        const keypadMap = [
          [/a|b|c/gi, 2],
          [/d|e|f/gi, 3],
          [/g|h|i/gi, 4],
          [/j|k|l/gi, 5],
          [/m|n|o/gi, 6],
          [/p|q|r|s/gi, 7],
          [/t|u|v/gi, 8],
          [/w|x|y|z/gi, 9]
        ];
        keypadMap.forEach(([key, value]) => {
          tel = tel.replace(key, value.toString());
        });
      } else {
        phone = "#";
      }
      phone = /\d/.test(tel) ? "tel:" + tel : "#";
    }
    return phone;
  }
  var init_DynamoFormattingUtils = __esm({
    "packages/systems/dynamo/utils/DynamoFormattingUtils/index.ts"() {
    }
  });

  // packages/systems/dynamo/utils/Transformers/Transformers.js
  var require_Transformers = __commonJS({
    "packages/systems/dynamo/utils/Transformers/Transformers.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.transformers = void 0;
      var _escape = _interopRequireDefault(require_escape());
      var _momentTimezone = _interopRequireDefault(require_moment_timezone2());
      var _CurrencyUtils = require_CurrencyUtils2();
      var _DynamoFormattingUtils = (init_DynamoFormattingUtils(), __toCommonJS(DynamoFormattingUtils_exports));
      var isSimpleDateFormat = (value) => /^([0-9]{4})-([0-9]{2})-([0-9]{2})$/.test(value);
      var date = (value, [format], {
        timezone = "UTC"
      }) => {
        if (isSimpleDateFormat(value)) {
          timezone = "UTC";
        }
        const momentDate = _momentTimezone.default.utc(value, _momentTimezone.default.ISO_8601);
        if (momentDate.isValid()) {
          return momentDate.tz(timezone).format(format);
        } else {
          return "";
        }
      };
      var detailPage = (value, [collectionIdOrLegacySlug], {
        collectionSlugMap
      }) => {
        const collectionSlug2 = collectionSlugMap[collectionIdOrLegacySlug] || collectionIdOrLegacySlug;
        return value ? `/${collectionSlug2}/${value}` : null;
      };
      var style = (value, [styleProp]) => {
        if (styleProp === "background-image") {
          return value ? `url("${value}")` : "none";
        }
        return value;
      };
      var numberPrecision = (value, [precision]) => {
        return (0, _DynamoFormattingUtils.formatNumber)(value, precision);
      };
      var rich = (value, params, {
        pageLinkHrefPrefix,
        collectionSlugMap
      }) => {
        if (!value) {
          return null;
        }
        if (typeof value !== "string") {
          return value;
        }
        return value.replace(/<a\s+[^>]+/g, (linkString) => {
          const isPageLink = /\sdata-rt-link-type="page"/.test(linkString);
          const needsPrefix = pageLinkHrefPrefix && isPageLink;
          const collectionIdMatch = isPageLink && /\sdata-rt-link-collectionid="([a-z0-9]{24})"/.exec(linkString);
          if (needsPrefix || collectionIdMatch) {
            return linkString.replace(/(\shref=")([^"]+)/, (match2, begin, href) => {
              const end = collectionIdMatch ? replaceDetailPageHrefCollectionSlug(href, collectionIdMatch[1], collectionSlugMap) : href;
              const prefix = pageLinkHrefPrefix ? (0, _escape.default)(pageLinkHrefPrefix) : "";
              return `${begin}${prefix}${end}`;
            });
          } else {
            return linkString;
          }
        });
      };
      var replaceDetailPageHrefCollectionSlug = (href, collectionId, collectionSlugMap) => {
        const [emptyString, originalCollectionSlug, ...rest] = href.split("/");
        const collectionSlug2 = collectionSlugMap[collectionId] || originalCollectionSlug;
        return [emptyString, collectionSlug2, ...rest].join("/");
      };
      var get2 = (obj, key) => {
        if (obj != null && typeof obj.get === "function") {
          return obj.get(key);
        }
        return obj[key];
      };
      var price = (obj, params, context) => {
        if (!obj)
          return null;
        return (0, _CurrencyUtils.renderPriceFromSettings)({
          unit: get2(obj, "unit"),
          value: get2(obj, "value")
        }, context.currencySettings);
      };
      var transformerIndex = {
        date,
        detailPage,
        style,
        numberPrecision,
        rich,
        price
      };
      var transformers = (value, filter2, context) => {
        const {
          type: key,
          params
        } = filter2;
        const fn = transformerIndex[key];
        return fn ? fn(value, params, context) : value;
      };
      exports.transformers = transformers;
    }
  });

  // packages/systems/dynamo/utils/Transformers/index.js
  var require_Transformers2 = __commonJS({
    "packages/systems/dynamo/utils/Transformers/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _Transformers = require_Transformers();
      Object.keys(_Transformers).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (key in exports && exports[key] === _Transformers[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _Transformers[key];
          }
        });
      });
    }
  });

  // node_modules/lodash/_baseAssign.js
  var require_baseAssign = __commonJS({
    "node_modules/lodash/_baseAssign.js"(exports, module) {
      var copyObject = require_copyObject();
      var keys = require_keys();
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      module.exports = baseAssign;
    }
  });

  // node_modules/lodash/_baseAssignIn.js
  var require_baseAssignIn = __commonJS({
    "node_modules/lodash/_baseAssignIn.js"(exports, module) {
      var copyObject = require_copyObject();
      var keysIn = require_keysIn();
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      module.exports = baseAssignIn;
    }
  });

  // node_modules/lodash/_copySymbols.js
  var require_copySymbols = __commonJS({
    "node_modules/lodash/_copySymbols.js"(exports, module) {
      var copyObject = require_copyObject();
      var getSymbols = require_getSymbols();
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      module.exports = copySymbols;
    }
  });

  // node_modules/lodash/_copySymbolsIn.js
  var require_copySymbolsIn = __commonJS({
    "node_modules/lodash/_copySymbolsIn.js"(exports, module) {
      var copyObject = require_copyObject();
      var getSymbolsIn = require_getSymbolsIn();
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      module.exports = copySymbolsIn;
    }
  });

  // node_modules/lodash/_initCloneArray.js
  var require_initCloneArray = __commonJS({
    "node_modules/lodash/_initCloneArray.js"(exports, module) {
      var objectProto = Object.prototype;
      var hasOwnProperty3 = objectProto.hasOwnProperty;
      function initCloneArray(array) {
        var length2 = array.length, result = new array.constructor(length2);
        if (length2 && typeof array[0] == "string" && hasOwnProperty3.call(array, "index")) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }
      module.exports = initCloneArray;
    }
  });

  // node_modules/lodash/_cloneDataView.js
  var require_cloneDataView = __commonJS({
    "node_modules/lodash/_cloneDataView.js"(exports, module) {
      var cloneArrayBuffer = require_cloneArrayBuffer();
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      module.exports = cloneDataView;
    }
  });

  // node_modules/lodash/_cloneRegExp.js
  var require_cloneRegExp = __commonJS({
    "node_modules/lodash/_cloneRegExp.js"(exports, module) {
      var reFlags = /\w*$/;
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }
      module.exports = cloneRegExp;
    }
  });

  // node_modules/lodash/_cloneSymbol.js
  var require_cloneSymbol = __commonJS({
    "node_modules/lodash/_cloneSymbol.js"(exports, module) {
      var Symbol2 = require_Symbol();
      var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
      var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }
      module.exports = cloneSymbol;
    }
  });

  // node_modules/lodash/_initCloneByTag.js
  var require_initCloneByTag = __commonJS({
    "node_modules/lodash/_initCloneByTag.js"(exports, module) {
      var cloneArrayBuffer = require_cloneArrayBuffer();
      var cloneDataView = require_cloneDataView();
      var cloneRegExp = require_cloneRegExp();
      var cloneSymbol = require_cloneSymbol();
      var cloneTypedArray = require_cloneTypedArray();
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var symbolTag = "[object Symbol]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var float32Tag = "[object Float32Array]";
      var float64Tag = "[object Float64Array]";
      var int8Tag = "[object Int8Array]";
      var int16Tag = "[object Int16Array]";
      var int32Tag = "[object Int32Array]";
      var uint8Tag = "[object Uint8Array]";
      var uint8ClampedTag = "[object Uint8ClampedArray]";
      var uint16Tag = "[object Uint16Array]";
      var uint32Tag = "[object Uint32Array]";
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      module.exports = initCloneByTag;
    }
  });

  // node_modules/lodash/_baseIsMap.js
  var require_baseIsMap = __commonJS({
    "node_modules/lodash/_baseIsMap.js"(exports, module) {
      var getTag = require_getTag();
      var isObjectLike = require_isObjectLike();
      var mapTag = "[object Map]";
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      module.exports = baseIsMap;
    }
  });

  // node_modules/lodash/isMap.js
  var require_isMap = __commonJS({
    "node_modules/lodash/isMap.js"(exports, module) {
      var baseIsMap = require_baseIsMap();
      var baseUnary = require_baseUnary();
      var nodeUtil = require_nodeUtil();
      var nodeIsMap = nodeUtil && nodeUtil.isMap;
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      module.exports = isMap;
    }
  });

  // node_modules/lodash/_baseIsSet.js
  var require_baseIsSet = __commonJS({
    "node_modules/lodash/_baseIsSet.js"(exports, module) {
      var getTag = require_getTag();
      var isObjectLike = require_isObjectLike();
      var setTag = "[object Set]";
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      module.exports = baseIsSet;
    }
  });

  // node_modules/lodash/isSet.js
  var require_isSet = __commonJS({
    "node_modules/lodash/isSet.js"(exports, module) {
      var baseIsSet = require_baseIsSet();
      var baseUnary = require_baseUnary();
      var nodeUtil = require_nodeUtil();
      var nodeIsSet = nodeUtil && nodeUtil.isSet;
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      module.exports = isSet;
    }
  });

  // node_modules/lodash/_baseClone.js
  var require_baseClone = __commonJS({
    "node_modules/lodash/_baseClone.js"(exports, module) {
      var Stack = require_Stack();
      var arrayEach = require_arrayEach();
      var assignValue = require_assignValue();
      var baseAssign = require_baseAssign();
      var baseAssignIn = require_baseAssignIn();
      var cloneBuffer = require_cloneBuffer();
      var copyArray = require_copyArray();
      var copySymbols = require_copySymbols();
      var copySymbolsIn = require_copySymbolsIn();
      var getAllKeys = require_getAllKeys();
      var getAllKeysIn = require_getAllKeysIn();
      var getTag = require_getTag();
      var initCloneArray = require_initCloneArray();
      var initCloneByTag = require_initCloneByTag();
      var initCloneObject = require_initCloneObject();
      var isArray = require_isArray();
      var isBuffer = require_isBuffer();
      var isMap = require_isMap();
      var isObject2 = require_isObject();
      var isSet = require_isSet();
      var keys = require_keys();
      var keysIn = require_keysIn();
      var CLONE_DEEP_FLAG = 1;
      var CLONE_FLAT_FLAG = 2;
      var CLONE_SYMBOLS_FLAG = 4;
      var argsTag = "[object Arguments]";
      var arrayTag = "[object Array]";
      var boolTag = "[object Boolean]";
      var dateTag = "[object Date]";
      var errorTag = "[object Error]";
      var funcTag = "[object Function]";
      var genTag = "[object GeneratorFunction]";
      var mapTag = "[object Map]";
      var numberTag = "[object Number]";
      var objectTag = "[object Object]";
      var regexpTag = "[object RegExp]";
      var setTag = "[object Set]";
      var stringTag = "[object String]";
      var symbolTag = "[object Symbol]";
      var weakMapTag = "[object WeakMap]";
      var arrayBufferTag = "[object ArrayBuffer]";
      var dataViewTag = "[object DataView]";
      var float32Tag = "[object Float32Array]";
      var float64Tag = "[object Float64Array]";
      var int8Tag = "[object Int8Array]";
      var int16Tag = "[object Int16Array]";
      var int32Tag = "[object Int32Array]";
      var uint8Tag = "[object Uint8Array]";
      var uint8ClampedTag = "[object Uint8ClampedArray]";
      var uint16Tag = "[object Uint16Array]";
      var uint32Tag = "[object Uint32Array]";
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== void 0) {
          return result;
        }
        if (!isObject2(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);
        if (isSet(value)) {
          value.forEach(function(subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key2) {
            result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? void 0 : keysFunc(value);
        arrayEach(props || value, function(subValue, key2) {
          if (props) {
            key2 = subValue;
            subValue = value[key2];
          }
          assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
        return result;
      }
      module.exports = baseClone;
    }
  });

  // node_modules/lodash/cloneDeep.js
  var require_cloneDeep = __commonJS({
    "node_modules/lodash/cloneDeep.js"(exports, module) {
      var baseClone = require_baseClone();
      var CLONE_DEEP_FLAG = 1;
      var CLONE_SYMBOLS_FLAG = 4;
      function cloneDeep2(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      module.exports = cloneDeep2;
    }
  });

  // node_modules/lodash/transform.js
  var require_transform = __commonJS({
    "node_modules/lodash/transform.js"(exports, module) {
      var arrayEach = require_arrayEach();
      var baseCreate = require_baseCreate();
      var baseForOwn = require_baseForOwn();
      var baseIteratee = require_baseIteratee();
      var getPrototype = require_getPrototype();
      var isArray = require_isArray();
      var isBuffer = require_isBuffer();
      var isFunction3 = require_isFunction();
      var isObject2 = require_isObject();
      var isTypedArray = require_isTypedArray();
      function transform(object, iteratee, accumulator) {
        var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee = baseIteratee(iteratee, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject2(object)) {
            accumulator = isFunction3(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
          return iteratee(accumulator, value, index, object2);
        });
        return accumulator;
      }
      module.exports = transform;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/rendering.js
  var require_rendering = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/rendering.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.renderTree = exports.applySkuBoundConditionalVisibility = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _Transformers = require_Transformers2();
      var _escape = _interopRequireDefault(require_escape());
      var _cloneDeep = _interopRequireDefault(require_cloneDeep());
      var _transform = _interopRequireDefault(require_transform());
      var _constants = require_constants2();
      var _constants2 = (init_constants(), __toCommonJS(constants_exports));
      var _RenderingUtils = require_RenderingUtils2();
      var _commerceUtils = require_commerceUtils();
      var _DynamoFormattingUtils = (init_DynamoFormattingUtils(), __toCommonJS(DynamoFormattingUtils_exports));
      var _site = require_site();
      var allowedFieldTypes = (0, _extends2.default)({}, _constants2.SHARED_ALLOWED_FIELD_TYPES, {
        "data-commerce-sku-id": ["ItemRef"]
      });
      var isBindingPropToFieldTypeAllowed = (bindingProperty, type) => {
        const allowedTypes = allowedFieldTypes[bindingProperty];
        return allowedTypes instanceof Array ? allowedTypes.indexOf(type) > -1 : allowedTypes && type in allowedTypes;
      };
      var getIn = (object, path) => {
        const nextDotIndex = path.indexOf(".");
        if (object == null) {
          return null;
        }
        if (nextDotIndex !== -1) {
          const pathPart = path.slice(0, nextDotIndex);
          const restOfPath = path.slice(nextDotIndex + 1, path.length);
          return getIn(object[pathPart], restOfPath);
        }
        return object[path];
      };
      var applyBindingsMutation = ({
        bindingProperty,
        type,
        filter: filter2,
        path,
        timezone,
        pageLinkHrefPrefix,
        collectionSlugMap = {},
        data,
        node,
        emailLinkSubject = ""
      }) => {
        if (!isBindingPropToFieldTypeAllowed(bindingProperty, type)) {
          return;
        }
        const prefix = "data.";
        let suffix = "";
        if (type === "ImageRef" && bindingProperty === "src") {
          suffix = ".url";
        }
        let rawValue;
        if (type === "CommercePropValues") {
          rawValue = getCommercePropValue(data, `${prefix}${path}`);
        } else {
          rawValue = getIn(data, `${prefix}${path}${suffix}`);
        }
        const transformedValue = (0, _Transformers.transformers)(rawValue, filter2, {
          timezone,
          pageLinkHrefPrefix,
          collectionSlugMap,
          currencySettings: window.__WEBFLOW_CURRENCY_SETTINGS
        });
        const propertyMutator = getPropertyMutator(bindingProperty, emailLinkSubject);
        if (typeof propertyMutator === "function") {
          propertyMutator(node, type, transformedValue);
        }
      };
      var applyBindings = (bindings, data, node) => {
        if (bindings == null) {
          return;
        }
        bindings.forEach((binding) => {
          Object.keys(binding).forEach((bindingProperty) => {
            const bindingValue = binding[bindingProperty];
            const {
              type,
              filter: filter2,
              dataPath: path,
              timezone,
              pageLinkHrefPrefix,
              collectionSlugMap,
              emailLinkSubject
            } = bindingValue;
            applyBindingsMutation({
              bindingProperty,
              type,
              filter: filter2,
              path,
              timezone,
              pageLinkHrefPrefix,
              collectionSlugMap,
              data,
              node,
              emailLinkSubject
            });
          });
        });
      };
      var applyConditionalVisibility = (conditionData, data, node) => {
        if (!conditionData) {
          return;
        }
        const {
          dataPath,
          meta
        } = conditionData;
        const prefixedDataPath = `data.${dataPath}`;
        const item = meta && meta.type === "CommercePropValues" ? {
          name: getIn(data, `${prefixedDataPath}.name`),
          value: getCommercePropValue(data, prefixedDataPath)
        } : getIn(data, prefixedDataPath);
        (0, _RenderingUtils.applyConditionToNode)(node, item, conditionData, true);
      };
      var applySkuBoundConditionalVisibility = ({
        conditionData,
        newSkuItem,
        node
      }) => {
        const {
          condition
        } = conditionData;
        const skuConditionData = (0, _transform.default)(condition.fields, (data, val, field) => {
          const skuField = field.split("default-sku:");
          if (skuField.length > 1) {
            data[skuField[1]] = val;
            return data;
          }
        });
        const inventoryQuantity = newSkuItem.inventory.type === "infinite" ? null : newSkuItem.inventory.quantity;
        const itemWithFlattenedInventory = (0, _extends2.default)({}, newSkuItem, {
          ecSkuInventoryQuantity: inventoryQuantity
        });
        (0, _RenderingUtils.applyConditionToNode)(node, itemWithFlattenedInventory, (0, _extends2.default)({}, conditionData, {
          condition: {
            fields: skuConditionData
          }
        }), true);
      };
      exports.applySkuBoundConditionalVisibility = applySkuBoundConditionalVisibility;
      var createStyleMutator = (property) => (node, type, value) => {
        if (!(node instanceof HTMLElement && typeof value === "string")) {
          return;
        }
        if (type === "ImageRef") {
          node.style.setProperty(property, `url(${value})`);
        }
        node.style.setProperty(property, value);
      };
      var createAttributeMutator = (attribute) => (node, type, value) => {
        const sanitizedString = value != null ? String(value) : "";
        node.setAttribute(attribute, sanitizedString);
        if (attribute === "src" && sanitizedString) {
          (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
        }
      };
      var valueMutator = (node, type, value) => {
        if (node.hasRendered) {
          return;
        }
        let sanitizedString;
        if (node.tagName === "SELECT") {
          sanitizedString = value != null ? String(value) : node.value || "";
        } else {
          sanitizedString = value != null ? String(value) : "";
        }
        node.setAttribute("value", sanitizedString);
        if (node.tagName === "INPUT" && String(node.type).toLowerCase() === "text") {
          node.hasRendered = true;
        }
        node.value = sanitizedString;
      };
      var checkedMutator = (node, type, value) => {
        node.checked = Boolean(value);
      };
      var aspectRatio = ({
        height,
        width
      }) => {
        return height && width ? height / width : 0;
      };
      var mutators = {
        innerHTML: (node, type, value) => {
          const originalValue = value;
          if (type === "Video") {
            value = value != null && value.metadata != null && typeof value.metadata.html === "string" ? value.metadata.html : null;
          }
          const valueString = value != null ? String(value) : "";
          if (allowedFieldTypes.innerHTML[type] === "innerHTML") {
            node.innerHTML = valueString;
          } else if (allowedFieldTypes.innerHTML[type] === "innerText") {
            node.innerHTML = (0, _escape.default)(valueString);
          }
          if (type === "Video" && originalValue && originalValue.metadata && node instanceof HTMLElement) {
            node.style.setProperty("padding-top", `${aspectRatio(originalValue.metadata) * 100}%`);
          }
          if (node.innerHTML) {
            (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
          }
        },
        "style.color": createStyleMutator("color"),
        "style.background-color": createStyleMutator("background-color"),
        "style.border-color": createStyleMutator("border-color"),
        "style.background-image": createStyleMutator("background-image"),
        src: createAttributeMutator("src"),
        alt: createAttributeMutator("alt"),
        id: createAttributeMutator("id"),
        for: createAttributeMutator("for"),
        value: valueMutator,
        checked: checkedMutator,
        "data-commerce-sku-id": createAttributeMutator("data-commerce-sku-id")
      };
      var hrefMutator = (emailLinkSubject) => (node, type, value) => {
        if (value) {
          const href = String(value);
          switch (type) {
            case "Phone": {
              node.setAttribute("href", (0, _DynamoFormattingUtils.formatPhone)(href, "href"));
              break;
            }
            case "Email": {
              let subject;
              try {
                subject = encodeURIComponent(emailLinkSubject);
              } catch (e) {
                subject = "";
              }
              const formattedEmail = (0, _DynamoFormattingUtils.formatEmail)(href, subject, "href");
              node.setAttribute("href", formattedEmail || "#");
              break;
            }
            default: {
              node.setAttribute("href", href);
              break;
            }
          }
        } else {
          node.setAttribute("href", "#");
        }
      };
      var getPropertyMutator = (bindingProperty, emailLinkSubject) => {
        if (bindingProperty === "href" || bindingProperty === "dataWHref") {
          return hrefMutator(emailLinkSubject);
        }
        if (typeof mutators[bindingProperty] === "function") {
          return mutators[bindingProperty];
        }
        return null;
      };
      var getCommercePropValue = (data, path) => {
        const option = getIn(data, path);
        if (option) {
          const pathToOptionAsArray = path.split(".");
          const pathToCommercePropValues = pathToOptionAsArray.slice(0, pathToOptionAsArray.indexOf("product")).concat(["sku", "f_sku_values_3dr"]).join(".");
          const skuValues = getIn(data, pathToCommercePropValues);
          if (Array.isArray(skuValues)) {
            return (0, _site.getProductOptionValueName)(option, (0, _site.simplifySkuValues)(skuValues));
          }
        }
        return "";
      };
      var getTemplateScript = (node) => {
        const templateId = node.getAttribute(_constants.WF_TEMPLATE_ID_DATA_KEY);
        const templateScript = templateId && node.parentElement && node.parentElement.querySelector(`#${templateId}`);
        return templateScript;
      };
      var createDomFragment = (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.children[0];
      };
      var getTemplateString = (node, index) => {
        const templateScript = getTemplateScript(node);
        const rawTemplateContent = templateScript && templateScript.textContent;
        const instanceRegEx = /([a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}_instance-)\d+/gi;
        const decodedTemplate = rawTemplateContent && decodeURIComponent(rawTemplateContent).replace(instanceRegEx, `$1${index}`);
        if (Boolean(decodedTemplate) && node.hasAttribute(_constants.WF_COLLECTION_DATA_KEY)) {
          const collectionPath = node.getAttribute(_constants.WF_COLLECTION_DATA_KEY);
          if (collectionPath && typeof collectionPath === "string") {
            const searchTerm = encodeURIComponent(`${(0, _escape.default)(collectionPath)}[]`).replace(/\./g, "\\.");
            const templateSearchTerm = encodeURIComponent(`${(0, _escape.default)(collectionPath)}${encodeURIComponent("[]")}`).replace(/\./g, "\\.");
            const collectionPathRegExp = new RegExp(`${searchTerm}|${templateSearchTerm}`, "g");
            return decodedTemplate && decodedTemplate.replace(collectionPathRegExp, `${collectionPath}.${index}`);
          }
        }
        return decodedTemplate;
      };
      var getTemplateCollection = (node, data) => {
        const collectionPath = node.hasAttribute(_constants.WF_COLLECTION_DATA_KEY) && node.getAttribute(_constants.WF_COLLECTION_DATA_KEY);
        return collectionPath ? getIn(data, `data.${collectionPath}`) : [];
      };
      var checkForAndApplyTemplateCollection = (node, data) => {
        if (node && node.hasAttribute(_constants.WF_TEMPLATE_ID_DATA_KEY)) {
          const collection = getTemplateCollection(node, data);
          node.innerHTML = "";
          if (collection != null && collection.length > 0) {
            for (let index = 0; index < collection.length; index++) {
              const templateString = getTemplateString(node, index);
              const template = templateString && createDomFragment(templateString);
              if (template instanceof Element) {
                if (typeof node.append === "function") {
                  node.append(renderTree(template, data));
                } else if (typeof node.appendChild === "function") {
                  node.appendChild(renderTree(template, data));
                } else {
                  throw new Error("Could not append child to node");
                }
              }
            }
          }
        }
      };
      var checkForAndApplyBindings = (node, data) => {
        if (node && node.hasAttribute(_constants.WF_BINDING_DATA_KEY)) {
          const bindingData = (0, _commerceUtils.safeParseJson)(node.getAttribute(_constants.WF_BINDING_DATA_KEY));
          applyBindings(bindingData, data, node);
        }
      };
      var checkForAndApplyConditionalVisibility = (node, data) => {
        if (node && node.hasAttribute(_constants.WF_CONDITION_DATA_KEY)) {
          const conditionData = (0, _commerceUtils.safeParseJson)(node.getAttribute(_constants.WF_CONDITION_DATA_KEY));
          applyConditionalVisibility(conditionData, data, node);
        }
      };
      var renderTree = (tree, data) => {
        data = flattenOrderData(data);
        return (0, _RenderingUtils.walkDOM)(tree, (node) => {
          checkForAndApplyTemplateCollection(node, data);
          checkForAndApplyBindings(node, data);
          checkForAndApplyConditionalVisibility(node, data);
        });
      };
      exports.renderTree = renderTree;
      var shippingDataReplacementPaths = {
        cardProvider: ["customerInfo", "stripePayment", "card", "provider"],
        cardLastFour: ["customerInfo", "stripePayment", "card", "last4"],
        cardExpiresMonth: ["customerInfo", "stripePayment", "card", "expires", "month"],
        cardExpiresYear: ["customerInfo", "stripePayment", "card", "expires", "year"],
        customerEmail: ["customerInfo", "identity", "email"],
        shippingAddressAddressee: ["customerInfo", "shippingAddress", "addressee"],
        shippingAddressLine1: ["customerInfo", "shippingAddress", "line1"],
        shippingAddressLine2: ["customerInfo", "shippingAddress", "line2"],
        shippingAddressCity: ["customerInfo", "shippingAddress", "city"],
        shippingAddressState: ["customerInfo", "shippingAddress", "state"],
        shippingAddressCountry: ["customerInfo", "shippingAddress", "country"],
        shippingAddressPostalCode: ["customerInfo", "shippingAddress", "postalCode"],
        billingAddressAddressee: ["customerInfo", "billingAddress", "addressee"],
        billingAddressLine1: ["customerInfo", "billingAddress", "line1"],
        billingAddressLine2: ["customerInfo", "billingAddress", "line2"],
        billingAddressCity: ["customerInfo", "billingAddress", "city"],
        billingAddressPostalCode: ["customerInfo", "billingAddress", "postalCode"],
        billingAddressState: ["customerInfo", "billingAddress", "state"],
        billingAddressCountry: ["customerInfo", "billingAddress", "country"],
        requiresShipping: ["statusFlags", "requiresShipping"],
        hasDownloads: ["statusFlags", "hasDownloads"]
      };
      var flattenCustomData = (customData) => (
        // $FlowIgnore - Flow 0.121.0
        customData.reduce((flattenedData, data) => {
          if (data.textArea) {
            flattenedData.additionalTextArea = data.textArea;
          } else if (data.textInput) {
            flattenedData.additionalTextInput = data.textInput;
          } else if (data.checkbox !== null) {
            flattenedData.additionalCheckbox = data.checkbox;
          }
          return flattenedData;
        }, {})
      );
      var flattenOrderData = (data) => {
        const orderExists = data && data.data && data.data.database && data.data.database.commerceOrder !== null;
        if (!orderExists) {
          return data;
        }
        const {
          commerceOrder
        } = data.data.database;
        const paymentProcessor = commerceOrder.paymentProcessor;
        const availableShippingMethods = commerceOrder.availableShippingMethods || [];
        const selectedShippingMethod = availableShippingMethods.find((shippingMethod) => shippingMethod.selected === true);
        const flattenedCustomData = commerceOrder.customData ? flattenCustomData(commerceOrder.customData) : {};
        const flattenedOrderData = (0, _extends2.default)({}, commerceOrder, {
          shippingMethodName: selectedShippingMethod && selectedShippingMethod.name,
          shippingMethodDescription: selectedShippingMethod && selectedShippingMethod.description
        }, flattenedCustomData);
        const clonedData = (0, _cloneDeep.default)(data);
        clonedData.data.database.commerceOrder = Object.keys(shippingDataReplacementPaths).reduce((updatedData, flattenPath) => {
          if (flattenPath === "cardProvider" && paymentProcessor === "paypal") {
            updatedData = (0, _extends2.default)({}, updatedData, {
              cardProvider: "PayPal"
            });
            return updatedData;
          }
          const replacementFrom = shippingDataReplacementPaths[flattenPath];
          const replacementData = replacementFrom.reduce((acc, key) => acc && acc[key], updatedData);
          updatedData[flattenPath] = replacementData;
          return updatedData;
        }, flattenedOrderData);
        return clonedData;
      };
    }
  });

  // packages/shared/render/plugins/Commerce/modules/addToCartStore.js
  var require_addToCartStore = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/addToCartStore.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.createNewStore = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var initialState = {
        selectedSku: "",
        skuValues: {},
        requiresUserSession: false
      };
      var createNewStore = () => {
        const store = {};
        const watchers = {};
        const fetchFromStore = (instanceId, key) => {
          return store[instanceId] ? store[instanceId][key] : void 0;
        };
        const updateStore = (instanceId, newValues) => {
          if (!store[instanceId]) {
            store[instanceId] = (0, _extends2.default)({}, initialState);
          }
          for (const key of Object.keys(newValues)) {
            if (!store[instanceId].hasOwnProperty(key)) {
              continue;
            }
            const previousValue = store[instanceId][key];
            store[instanceId][key] = newValues[key];
            if (watchers[instanceId] && watchers[instanceId][key]) {
              for (const watcher of watchers[instanceId][key]) {
                watcher(newValues[key], previousValue);
              }
            }
          }
        };
        const addStoreWatcher = (instanceId, key, cb) => {
          if (!watchers[instanceId]) {
            watchers[instanceId] = {};
          }
          if (watchers[instanceId][key]) {
            watchers[instanceId][key].push(cb);
          } else {
            watchers[instanceId][key] = [cb];
          }
        };
        return {
          fetchFromStore,
          updateStore,
          addStoreWatcher
        };
      };
      exports.createNewStore = createNewStore;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/components/PillGroup/index.js
  var require_PillGroup = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/components/PillGroup/index.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.PillGroups = void 0;
      var _defineProperty2 = _interopRequireDefault(require_defineProperty2());
      var _constants = require_constants2();
      var KEY_CODES = Object.freeze({
        RETURN: 13,
        SPACE: 32,
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        DOWN: 40
      });
      var PillGroups = class {
        static hasPillGroups(form) {
          return form.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP}"]`).length > 0;
        }
        constructor(form, onSelect) {
          this.form = form;
          this.pillGroups = {};
          this.onSelect = onSelect;
        }
        init() {
          const groupNodes = this.form.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP}"]`);
          for (const group of groupNodes) {
            const pillGroup = new PillGroup(group, this.onSelect, this);
            pillGroup.init();
            this.pillGroups[pillGroup.optionSetId] = pillGroup;
          }
        }
        setSelectedPillsForSkuValues(skuValues) {
          for (const optionSetId of Object.keys(skuValues)) {
            const optionId = skuValues[optionSetId];
            const pillGroup = this.pillGroups[optionSetId];
            if (pillGroup) {
              const pill = pillGroup.findPillById(String(optionId));
              pillGroup.updatePillsWithNewSelected(pill);
            }
          }
        }
      };
      exports.PillGroups = PillGroups;
      var PillGroup = class {
        constructor(node, onSelect, groups) {
          this.node = node;
          this.optionSetId = String(node.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID));
          this.onSelect = onSelect;
          this.pills = [];
          this.groups = groups;
        }
        get firstEnabledPill() {
          return this.pills.find((pill) => pill.disabled === false);
        }
        // hacky fake option set compat
        get value() {
          const possiblePill = this.pills.find((pill) => pill.checked === true);
          return possiblePill ? possiblePill.value : "";
        }
        // hacky fake option set compat
        get options() {
          return this.pills;
        }
        // hacky fake option set compat
        // eslint-disable-next-line accessor-pairs
        set selectedIndex(index) {
          const pill = this.pills[index] || null;
          this.emitSelected(pill);
        }
        // hacky fake option set compat
        // we only want to support the one DOM attribute, which we have on this group, just not
        // directly exposed, as we don't directly expose the DOM element for the group
        getAttribute(attr) {
          if (attr === _constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) {
            return this.optionSetId;
          } else {
            throw new Error(`PillGroup: Attempted to fetch unsupported attribute ${attr}`);
          }
        }
        init() {
          const pills = this.node.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL}"]`);
          this.pills = Array.from(pills).map((pillNode) => {
            const pill = new Pill(pillNode, this);
            pill.init();
            return pill;
          });
          if (this.firstEnabledPill) {
            this.firstEnabledPill.tabIndex = 0;
          }
          this.node._wfPillGroup = this;
        }
        findPillById(optionId) {
          return this.pills.find((pill) => pill.optionId === optionId);
        }
        updatePillsWithNewSelected(selectedPill) {
          for (const pill of this.pills) {
            pill.tabIndex = -1;
            pill.checked = false;
          }
          if (selectedPill instanceof Pill) {
            selectedPill.tabIndex = 0;
            selectedPill.checked = true;
          } else {
            if (this.firstEnabledPill) {
              this.firstEnabledPill.tabIndex = 0;
            }
          }
        }
        emitSelected(selectedPill) {
          this.onSelect({
            optionId: selectedPill.optionId,
            optionSetId: this.optionSetId,
            groups: Object.values(this.groups.pillGroups)
          });
        }
        traverseAndEmitSelected(currentPill, direction) {
          const currentIndex = this.pills.indexOf(currentPill);
          let found = false;
          let idx = currentIndex;
          let nextIndex;
          while (!found) {
            if (direction === "previous") {
              nextIndex = idx - 1;
              if (nextIndex < 0) {
                nextIndex = this.pills.length - 1;
              }
            } else if (direction === "next") {
              nextIndex = idx + 1;
              if (nextIndex === this.pills.length) {
                nextIndex = 0;
              }
            } else {
              throw new Error(`Unknown pill traversal direction "${direction}", use "previous" or "next"`);
            }
            if (nextIndex === currentIndex) {
              break;
            }
            const pill = this.pills[nextIndex];
            if (!pill.disabled) {
              this.emitSelected(pill);
              pill.focus();
              found = true;
            } else {
              idx = nextIndex;
            }
          }
        }
      };
      var Pill = class {
        constructor(node, group) {
          (0, _defineProperty2.default)(this, "handleKeyDown", (ev) => {
            let eventHandled = false;
            if (ev.altKey || ev.metaKey) {
              return;
            }
            switch (ev.keyCode) {
              case KEY_CODES.RETURN:
              case KEY_CODES.SPACE:
                this.handleClick();
                eventHandled = true;
                break;
              case KEY_CODES.UP:
              case KEY_CODES.LEFT:
                this.group.traverseAndEmitSelected(this, "previous");
                eventHandled = true;
                break;
              case KEY_CODES.DOWN:
              case KEY_CODES.RIGHT:
                this.group.traverseAndEmitSelected(this, "next");
                eventHandled = true;
                break;
              default:
                break;
            }
            if (eventHandled) {
              ev.stopPropagation();
              ev.preventDefault();
            }
          });
          (0, _defineProperty2.default)(this, "handleClick", () => {
            if (this.disabled || this.checked) {
              return;
            }
            this.focus();
            this.group.emitSelected(this);
          });
          this.node = node;
          this.optionId = String(this.node.getAttribute("data-option-id"));
          this.group = group;
        }
        init() {
          this.tabIndex = -1;
          this.checked = false;
          this.node.addEventListener("keydown", this.handleKeyDown);
          this.node.addEventListener("click", this.handleClick);
        }
        get tabIndex() {
          return this.node.tabIndex;
        }
        set tabIndex(index) {
          this.node.tabIndex = index;
        }
        get value() {
          return this.optionId;
        }
        get checked() {
          return this.node.getAttribute("aria-checked") === "true";
        }
        set checked(checked) {
          this.node.setAttribute("aria-checked", String(checked));
          if (checked) {
            this.node.classList.add("w--ecommerce-pill-selected");
          } else {
            this.node.classList.remove("w--ecommerce-pill-selected");
          }
        }
        get disabled() {
          return this.node.getAttribute("aria-disabled") === "true";
        }
        set disabled(disabled) {
          this.node.setAttribute("aria-disabled", String(disabled));
          if (disabled) {
            this.node.classList.add("w--ecommerce-pill-disabled");
            this.checked = false;
            this.tabIndex = -1;
          } else {
            this.node.classList.remove("w--ecommerce-pill-disabled");
          }
        }
        get enabled() {
          return !this.disabled;
        }
        set enabled(enabled) {
          this.disabled = !enabled;
        }
        focus() {
          this.node.focus();
        }
      };
    }
  });

  // node_modules/promise-polyfill/src/finally.js
  function finally_default(callback) {
    var constructor = this.constructor;
    return this.then(
      function(value) {
        return constructor.resolve(callback()).then(function() {
          return value;
        });
      },
      function(reason) {
        return constructor.resolve(callback()).then(function() {
          return constructor.reject(reason);
        });
      }
    );
  }
  var init_finally = __esm({
    "node_modules/promise-polyfill/src/finally.js"() {
    }
  });

  // node_modules/promise-polyfill/src/index.js
  function noop() {
  }
  function bind(fn, thisArg) {
    return function() {
      fn.apply(thisArg, arguments);
    };
  }
  function Promise2(fn) {
    if (!(this instanceof Promise2))
      throw new TypeError("Promises must be constructed via new");
    if (typeof fn !== "function")
      throw new TypeError("not a function");
    this._state = 0;
    this._handled = false;
    this._value = void 0;
    this._deferreds = [];
    doResolve(fn, this);
  }
  function handle(self2, deferred) {
    while (self2._state === 3) {
      self2 = self2._value;
    }
    if (self2._state === 0) {
      self2._deferreds.push(deferred);
      return;
    }
    self2._handled = true;
    Promise2._immediateFn(function() {
      var cb = self2._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self2._state === 1 ? resolve : reject)(deferred.promise, self2._value);
        return;
      }
      var ret;
      try {
        ret = cb(self2._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }
  function resolve(self2, newValue) {
    try {
      if (newValue === self2)
        throw new TypeError("A promise cannot be resolved with itself.");
      if (newValue && (typeof newValue === "object" || typeof newValue === "function")) {
        var then = newValue.then;
        if (newValue instanceof Promise2) {
          self2._state = 3;
          self2._value = newValue;
          finale(self2);
          return;
        } else if (typeof then === "function") {
          doResolve(bind(then, newValue), self2);
          return;
        }
      }
      self2._state = 1;
      self2._value = newValue;
      finale(self2);
    } catch (e) {
      reject(self2, e);
    }
  }
  function reject(self2, newValue) {
    self2._state = 2;
    self2._value = newValue;
    finale(self2);
  }
  function finale(self2) {
    if (self2._state === 2 && self2._deferreds.length === 0) {
      Promise2._immediateFn(function() {
        if (!self2._handled) {
          Promise2._unhandledRejectionFn(self2._value);
        }
      });
    }
    for (var i = 0, len = self2._deferreds.length; i < len; i++) {
      handle(self2, self2._deferreds[i]);
    }
    self2._deferreds = null;
  }
  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === "function" ? onFulfilled : null;
    this.onRejected = typeof onRejected === "function" ? onRejected : null;
    this.promise = promise;
  }
  function doResolve(fn, self2) {
    var done = false;
    try {
      fn(
        function(value) {
          if (done)
            return;
          done = true;
          resolve(self2, value);
        },
        function(reason) {
          if (done)
            return;
          done = true;
          reject(self2, reason);
        }
      );
    } catch (ex) {
      if (done)
        return;
      done = true;
      reject(self2, ex);
    }
  }
  var setTimeoutFunc, src_default;
  var init_src = __esm({
    "node_modules/promise-polyfill/src/index.js"() {
      init_finally();
      setTimeoutFunc = setTimeout;
      Promise2.prototype["catch"] = function(onRejected) {
        return this.then(null, onRejected);
      };
      Promise2.prototype.then = function(onFulfilled, onRejected) {
        var prom = new this.constructor(noop);
        handle(this, new Handler(onFulfilled, onRejected, prom));
        return prom;
      };
      Promise2.prototype["finally"] = finally_default;
      Promise2.all = function(arr) {
        return new Promise2(function(resolve2, reject2) {
          if (!arr || typeof arr.length === "undefined")
            throw new TypeError("Promise.all accepts an array");
          var args = Array.prototype.slice.call(arr);
          if (args.length === 0)
            return resolve2([]);
          var remaining = args.length;
          function res(i2, val) {
            try {
              if (val && (typeof val === "object" || typeof val === "function")) {
                var then = val.then;
                if (typeof then === "function") {
                  then.call(
                    val,
                    function(val2) {
                      res(i2, val2);
                    },
                    reject2
                  );
                  return;
                }
              }
              args[i2] = val;
              if (--remaining === 0) {
                resolve2(args);
              }
            } catch (ex) {
              reject2(ex);
            }
          }
          for (var i = 0; i < args.length; i++) {
            res(i, args[i]);
          }
        });
      };
      Promise2.resolve = function(value) {
        if (value && typeof value === "object" && value.constructor === Promise2) {
          return value;
        }
        return new Promise2(function(resolve2) {
          resolve2(value);
        });
      };
      Promise2.reject = function(value) {
        return new Promise2(function(resolve2, reject2) {
          reject2(value);
        });
      };
      Promise2.race = function(values2) {
        return new Promise2(function(resolve2, reject2) {
          for (var i = 0, len = values2.length; i < len; i++) {
            values2[i].then(resolve2, reject2);
          }
        });
      };
      Promise2._immediateFn = typeof setImmediate === "function" && function(fn) {
        setImmediate(fn);
      } || function(fn) {
        setTimeoutFunc(fn, 0);
      };
      Promise2._unhandledRejectionFn = function _unhandledRejectionFn(err) {
        if (typeof console !== "undefined" && console) {
          console.warn("Possible Unhandled Promise Rejection:", err);
        }
      };
      src_default = Promise2;
    }
  });

  // node_modules/promise-polyfill/src/polyfill.js
  var polyfill_exports = {};
  var globalNS;
  var init_polyfill = __esm({
    "node_modules/promise-polyfill/src/polyfill.js"() {
      init_src();
      init_finally();
      globalNS = function() {
        if (typeof self !== "undefined") {
          return self;
        }
        if (typeof window !== "undefined") {
          return window;
        }
        if (typeof global !== "undefined") {
          return global;
        }
        throw new Error("unable to locate global object");
      }();
      if (!globalNS.Promise) {
        globalNS.Promise = src_default;
      } else if (!globalNS.Promise.prototype["finally"]) {
        globalNS.Promise.prototype["finally"] = finally_default;
      }
    }
  });

  // node_modules/unfetch/dist/unfetch.js
  var require_unfetch = __commonJS({
    "node_modules/unfetch/dist/unfetch.js"(exports, module) {
      var e = "function" == typeof fetch ? fetch.bind() : function(e2, t) {
        return t = t || {}, new Promise(function(n, r) {
          function s() {
            var e3, t2 = [], n2 = [], r2 = {};
            return o.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(s2, o2, u2) {
              t2.push(o2 = o2.toLowerCase()), n2.push([o2, u2]), e3 = r2[o2], r2[o2] = e3 ? e3 + "," + u2 : u2;
            }), { ok: 2 == (o.status / 100 | 0), status: o.status, statusText: o.statusText, url: o.responseURL, clone: s, text: function() {
              return Promise.resolve(o.responseText);
            }, json: function() {
              return Promise.resolve(o.responseText).then(JSON.parse);
            }, blob: function() {
              return Promise.resolve(new Blob([o.response]));
            }, headers: { keys: function() {
              return t2;
            }, entries: function() {
              return n2;
            }, get: function(e4) {
              return r2[e4.toLowerCase()];
            }, has: function(e4) {
              return e4.toLowerCase() in r2;
            } } };
          }
          var o = new XMLHttpRequest();
          o.open(t.method || "get", e2, true);
          for (var u in t.headers)
            o.setRequestHeader(u, t.headers[u]);
          o.withCredentials = "include" == t.credentials, o.onload = function() {
            n(s());
          }, o.onerror = r, o.send(t.body);
        });
      };
      module.exports = e;
    }
  });

  // node_modules/unfetch/polyfill.js
  var require_polyfill2 = __commonJS({
    "node_modules/unfetch/polyfill.js"() {
      if (!window.fetch)
        window.fetch = require_unfetch().default || require_unfetch();
    }
  });

  // node_modules/core-js/internals/native-url.js
  var require_native_url = __commonJS({
    "node_modules/core-js/internals/native-url.js"(exports, module) {
      var fails = require_fails();
      var wellKnownSymbol = require_well_known_symbol();
      var IS_PURE = require_is_pure();
      var ITERATOR = wellKnownSymbol("iterator");
      module.exports = !fails(function() {
        var url = new URL("b?a=1&b=2&c=3", "http://a");
        var searchParams = url.searchParams;
        var result = "";
        url.pathname = "c%20d";
        searchParams.forEach(function(value, key) {
          searchParams["delete"]("b");
          result += key + value;
        });
        return IS_PURE && !url.toJSON || !searchParams.sort || url.href !== "http://a/c%20d?a=1&c=3" || searchParams.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !searchParams[ITERATOR] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://\u0442\u0435\u0441\u0442").host !== "xn--e1aybc" || new URL("http://a#\u0431").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", void 0).host !== "x";
      });
    }
  });

  // node_modules/core-js/modules/web.url-search-params.js
  var require_web_url_search_params = __commonJS({
    "node_modules/core-js/modules/web.url-search-params.js"(exports, module) {
      "use strict";
      require_es_array_iterator();
      var $2 = require_export();
      var global2 = require_global();
      var getBuiltIn = require_get_built_in();
      var call = require_function_call();
      var uncurryThis = require_function_uncurry_this();
      var USE_NATIVE_URL = require_native_url();
      var redefine = require_redefine();
      var redefineAll = require_redefine_all();
      var setToStringTag = require_set_to_string_tag();
      var createIteratorConstructor = require_create_iterator_constructor();
      var InternalStateModule = require_internal_state();
      var anInstance = require_an_instance();
      var isCallable = require_is_callable();
      var hasOwn4 = require_has_own_property();
      var bind2 = require_function_bind_context();
      var classof = require_classof();
      var anObject = require_an_object();
      var isObject2 = require_is_object();
      var $toString = require_to_string();
      var create5 = require_object_create();
      var createPropertyDescriptor = require_create_property_descriptor();
      var getIterator = require_get_iterator();
      var getIteratorMethod = require_get_iterator_method();
      var wellKnownSymbol = require_well_known_symbol();
      var arraySort = require_array_sort();
      var ITERATOR = wellKnownSymbol("iterator");
      var URL_SEARCH_PARAMS = "URLSearchParams";
      var URL_SEARCH_PARAMS_ITERATOR = URL_SEARCH_PARAMS + "Iterator";
      var setInternalState = InternalStateModule.set;
      var getInternalParamsState = InternalStateModule.getterFor(URL_SEARCH_PARAMS);
      var getInternalIteratorState = InternalStateModule.getterFor(URL_SEARCH_PARAMS_ITERATOR);
      var n$Fetch = getBuiltIn("fetch");
      var N$Request = getBuiltIn("Request");
      var Headers = getBuiltIn("Headers");
      var RequestPrototype = N$Request && N$Request.prototype;
      var HeadersPrototype = Headers && Headers.prototype;
      var RegExp2 = global2.RegExp;
      var TypeError2 = global2.TypeError;
      var decodeURIComponent2 = global2.decodeURIComponent;
      var encodeURIComponent2 = global2.encodeURIComponent;
      var charAt = uncurryThis("".charAt);
      var join = uncurryThis([].join);
      var push = uncurryThis([].push);
      var replace2 = uncurryThis("".replace);
      var shift = uncurryThis([].shift);
      var splice = uncurryThis([].splice);
      var split4 = uncurryThis("".split);
      var stringSlice = uncurryThis("".slice);
      var plus = /\+/g;
      var sequences = Array(4);
      var percentSequence = function(bytes) {
        return sequences[bytes - 1] || (sequences[bytes - 1] = RegExp2("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
      };
      var percentDecode = function(sequence) {
        try {
          return decodeURIComponent2(sequence);
        } catch (error) {
          return sequence;
        }
      };
      var deserialize = function(it) {
        var result = replace2(it, plus, " ");
        var bytes = 4;
        try {
          return decodeURIComponent2(result);
        } catch (error) {
          while (bytes) {
            result = replace2(result, percentSequence(bytes--), percentDecode);
          }
          return result;
        }
      };
      var find2 = /[!'()~]|%20/g;
      var replacements = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+"
      };
      var replacer = function(match2) {
        return replacements[match2];
      };
      var serialize = function(it) {
        return replace2(encodeURIComponent2(it), find2, replacer);
      };
      var parseSearchParams = function(result, query) {
        if (query) {
          var attributes = split4(query, "&");
          var index = 0;
          var attribute, entry;
          while (index < attributes.length) {
            attribute = attributes[index++];
            if (attribute.length) {
              entry = split4(attribute, "=");
              push(result, {
                key: deserialize(shift(entry)),
                value: deserialize(join(entry, "="))
              });
            }
          }
        }
      };
      var updateSearchParams = function(query) {
        this.entries.length = 0;
        parseSearchParams(this.entries, query);
      };
      var validateArgumentsLength = function(passed, required) {
        if (passed < required)
          throw TypeError2("Not enough arguments");
      };
      var URLSearchParamsIterator = createIteratorConstructor(function Iterator(params, kind) {
        setInternalState(this, {
          type: URL_SEARCH_PARAMS_ITERATOR,
          iterator: getIterator(getInternalParamsState(params).entries),
          kind
        });
      }, "Iterator", function next() {
        var state = getInternalIteratorState(this);
        var kind = state.kind;
        var step = state.iterator.next();
        var entry = step.value;
        if (!step.done) {
          step.value = kind === "keys" ? entry.key : kind === "values" ? entry.value : [entry.key, entry.value];
        }
        return step;
      });
      var URLSearchParamsConstructor = function URLSearchParams2() {
        anInstance(this, URLSearchParamsPrototype);
        var init = arguments.length > 0 ? arguments[0] : void 0;
        var that = this;
        var entries2 = [];
        var iteratorMethod, iterator, next, step, entryIterator, entryNext, first2, second, key;
        setInternalState(that, {
          type: URL_SEARCH_PARAMS,
          entries: entries2,
          updateURL: function() {
          },
          updateSearchParams
        });
        if (init !== void 0) {
          if (isObject2(init)) {
            iteratorMethod = getIteratorMethod(init);
            if (iteratorMethod) {
              iterator = getIterator(init, iteratorMethod);
              next = iterator.next;
              while (!(step = call(next, iterator)).done) {
                entryIterator = getIterator(anObject(step.value));
                entryNext = entryIterator.next;
                if ((first2 = call(entryNext, entryIterator)).done || (second = call(entryNext, entryIterator)).done || !call(entryNext, entryIterator).done)
                  throw TypeError2("Expected sequence with length 2");
                push(entries2, { key: $toString(first2.value), value: $toString(second.value) });
              }
            } else
              for (key in init)
                if (hasOwn4(init, key))
                  push(entries2, { key, value: $toString(init[key]) });
          } else {
            parseSearchParams(
              entries2,
              typeof init == "string" ? charAt(init, 0) === "?" ? stringSlice(init, 1) : init : $toString(init)
            );
          }
        }
      };
      var URLSearchParamsPrototype = URLSearchParamsConstructor.prototype;
      redefineAll(URLSearchParamsPrototype, {
        // `URLSearchParams.prototype.append` method
        // https://url.spec.whatwg.org/#dom-urlsearchparams-append
        append: function append2(name, value) {
          validateArgumentsLength(arguments.length, 2);
          var state = getInternalParamsState(this);
          push(state.entries, { key: $toString(name), value: $toString(value) });
          state.updateURL();
        },
        // `URLSearchParams.prototype.delete` method
        // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
        "delete": function(name) {
          validateArgumentsLength(arguments.length, 1);
          var state = getInternalParamsState(this);
          var entries2 = state.entries;
          var key = $toString(name);
          var index = 0;
          while (index < entries2.length) {
            if (entries2[index].key === key)
              splice(entries2, index, 1);
            else
              index++;
          }
          state.updateURL();
        },
        // `URLSearchParams.prototype.get` method
        // https://url.spec.whatwg.org/#dom-urlsearchparams-get
        get: function get2(name) {
          validateArgumentsLength(arguments.length, 1);
          var entries2 = getInternalParamsState(this).entries;
          var key = $toString(name);
          var index = 0;
          for (; index < entries2.length; index++) {
            if (entries2[index].key === key)
              return entries2[index].value;
          }
          return null;
        },
        // `URLSearchParams.prototype.getAll` method
        // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
        getAll: function getAll(name) {
          validateArgumentsLength(arguments.length, 1);
          var entries2 = getInternalParamsState(this).entries;
          var key = $toString(name);
          var result = [];
          var index = 0;
          for (; index < entries2.length; index++) {
            if (entries2[index].key === key)
              push(result, entries2[index].value);
          }
          return result;
        },
        // `URLSearchParams.prototype.has` method
        // https://url.spec.whatwg.org/#dom-urlsearchparams-has
        has: function has2(name) {
          validateArgumentsLength(arguments.length, 1);
          var entries2 = getInternalParamsState(this).entries;
          var key = $toString(name);
          var index = 0;
          while (index < entries2.length) {
            if (entries2[index++].key === key)
              return true;
          }
          return false;
        },
        // `URLSearchParams.prototype.set` method
        // https://url.spec.whatwg.org/#dom-urlsearchparams-set
        set: function set2(name, value) {
          validateArgumentsLength(arguments.length, 1);
          var state = getInternalParamsState(this);
          var entries2 = state.entries;
          var found = false;
          var key = $toString(name);
          var val = $toString(value);
          var index = 0;
          var entry;
          for (; index < entries2.length; index++) {
            entry = entries2[index];
            if (entry.key === key) {
              if (found)
                splice(entries2, index--, 1);
              else {
                found = true;
                entry.value = val;
              }
            }
          }
          if (!found)
            push(entries2, { key, value: val });
          state.updateURL();
        },
        // `URLSearchParams.prototype.sort` method
        // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
        sort: function sort() {
          var state = getInternalParamsState(this);
          arraySort(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
          });
          state.updateURL();
        },
        // `URLSearchParams.prototype.forEach` method
        forEach: function forEach(callback) {
          var entries2 = getInternalParamsState(this).entries;
          var boundFunction = bind2(callback, arguments.length > 1 ? arguments[1] : void 0);
          var index = 0;
          var entry;
          while (index < entries2.length) {
            entry = entries2[index++];
            boundFunction(entry.value, entry.key, this);
          }
        },
        // `URLSearchParams.prototype.keys` method
        keys: function keys() {
          return new URLSearchParamsIterator(this, "keys");
        },
        // `URLSearchParams.prototype.values` method
        values: function values2() {
          return new URLSearchParamsIterator(this, "values");
        },
        // `URLSearchParams.prototype.entries` method
        entries: function entries2() {
          return new URLSearchParamsIterator(this, "entries");
        }
      }, { enumerable: true });
      redefine(URLSearchParamsPrototype, ITERATOR, URLSearchParamsPrototype.entries, { name: "entries" });
      redefine(URLSearchParamsPrototype, "toString", function toString4() {
        var entries2 = getInternalParamsState(this).entries;
        var result = [];
        var index = 0;
        var entry;
        while (index < entries2.length) {
          entry = entries2[index++];
          push(result, serialize(entry.key) + "=" + serialize(entry.value));
        }
        return join(result, "&");
      }, { enumerable: true });
      setToStringTag(URLSearchParamsConstructor, URL_SEARCH_PARAMS);
      $2({ global: true, forced: !USE_NATIVE_URL }, {
        URLSearchParams: URLSearchParamsConstructor
      });
      if (!USE_NATIVE_URL && isCallable(Headers)) {
        headersHas = uncurryThis(HeadersPrototype.has);
        headersSet = uncurryThis(HeadersPrototype.set);
        wrapRequestOptions = function(init) {
          if (isObject2(init)) {
            var body = init.body;
            var headers;
            if (classof(body) === URL_SEARCH_PARAMS) {
              headers = init.headers ? new Headers(init.headers) : new Headers();
              if (!headersHas(headers, "content-type")) {
                headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
              }
              return create5(init, {
                body: createPropertyDescriptor(0, $toString(body)),
                headers: createPropertyDescriptor(0, headers)
              });
            }
          }
          return init;
        };
        if (isCallable(n$Fetch)) {
          $2({ global: true, enumerable: true, forced: true }, {
            fetch: function fetch2(input) {
              return n$Fetch(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
            }
          });
        }
        if (isCallable(N$Request)) {
          RequestConstructor = function Request(input) {
            anInstance(this, RequestPrototype);
            return new N$Request(input, arguments.length > 1 ? wrapRequestOptions(arguments[1]) : {});
          };
          RequestPrototype.constructor = RequestConstructor;
          RequestConstructor.prototype = RequestPrototype;
          $2({ global: true, forced: true }, {
            Request: RequestConstructor
          });
        }
      }
      var headersHas;
      var headersSet;
      var wrapRequestOptions;
      var RequestConstructor;
      module.exports = {
        URLSearchParams: URLSearchParamsConstructor,
        getState: getInternalParamsState
      };
    }
  });

  // node_modules/core-js/web/url-search-params.js
  var require_url_search_params = __commonJS({
    "node_modules/core-js/web/url-search-params.js"(exports, module) {
      require_web_url_search_params();
      var path = require_path();
      module.exports = path.URLSearchParams;
    }
  });

  // packages/systems/users/siteBundles/utils.js
  var require_utils2 = __commonJS({
    "packages/systems/users/siteBundles/utils.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.addHiddenClass = addHiddenClass;
      exports.disableSubmit = disableSubmit;
      exports.getDomParser = getDomParser;
      exports.getErrorAttrName = void 0;
      exports.getRedirectPath = getRedirectPath;
      exports.handleErrorNode = exports.getSignupErrorCode = void 0;
      exports.handleRedirect = handleRedirect;
      exports.hideElement = hideElement;
      exports.redirectWithUsrdir = redirectWithUsrdir;
      exports.removeHiddenClass = removeHiddenClass;
      exports.resetSubmit = resetSubmit;
      exports.showAndFocusElement = showAndFocusElement;
      exports.showElement = showElement;
      exports.userSystemsRequestClient = exports.userFormError = void 0;
      var _apolloClient = (init_apolloClient(), __toCommonJS(apolloClient_exports));
      var _constants = require_constants3();
      var GQL_QUERY_PATH = "/.wf_graphql/usys/apollo";
      var userSystemsRequestClient = (0, _apolloClient.createApolloClient)({
        path: GQL_QUERY_PATH,
        useCsrf: true,
        retryConfig: {
          maxAttempts: 5
        }
      });
      exports.userSystemsRequestClient = userSystemsRequestClient;
      function addHiddenClass(el) {
        if (el) {
          el.classList.add("w-hidden");
        }
      }
      function removeHiddenClass(el) {
        if (el) {
          el.classList.remove("w-hidden");
        }
      }
      function showElement(el) {
        if (el) {
          el.style.display = "block";
        }
      }
      function showAndFocusElement(el) {
        if (el) {
          el.style.display = "block";
          el.focus();
        }
      }
      function hideElement(el) {
        if (el) {
          el.style.display = "none";
        }
      }
      function getDomParser() {
        const domParser = new window.DOMParser();
        return {
          /**
           * Returns an html node for an encoded string
           * @param {string} str - Encoded string to parse
           */
          getHtmlFromString(str) {
            const decodedString = decodeURIComponent(str);
            const parsedHtml = domParser.parseFromString(decodedString, "text/html");
            if (!parsedHtml || !parsedHtml.body || !parsedHtml.body.firstChild)
              return null;
            return parsedHtml.body.firstChild;
          }
        };
      }
      var getErrorAttrName = (errorAttr, errorCode) => {
        const formattedErrorCode = errorCode.replace("_", "-").toLowerCase();
        return `${errorAttr}-${formattedErrorCode}-error`;
      };
      exports.getErrorAttrName = getErrorAttrName;
      var handleErrorNode = (errorMsgNode, errorStateNode, errorCode, errorAttrPrefix, defaultErrorCopy2) => {
        const errorAttr = getErrorAttrName(errorAttrPrefix, errorCode);
        const errorCopy = errorMsgNode && errorMsgNode.getAttribute(errorAttr);
        errorMsgNode.setAttribute("aria-live", "assertive");
        errorMsgNode.textContent = errorCopy ? errorCopy : defaultErrorCopy2;
        showElement(errorStateNode);
      };
      exports.handleErrorNode = handleErrorNode;
      function disableSubmit(submit) {
        if (!(submit instanceof HTMLInputElement))
          return "";
        submit.setAttribute("disabled", "true");
        const value = submit.getAttribute("value");
        const waitText = submit.getAttribute("data-wait");
        if (waitText)
          submit.setAttribute("value", waitText);
        return value !== null && value !== void 0 ? value : "";
      }
      function resetSubmit(submit, text) {
        if (!(submit instanceof HTMLInputElement))
          return;
        submit.removeAttribute("disabled");
        submit.setAttribute("value", text);
      }
      function getRedirectPath() {
        const queryString = window.location.search;
        const redirectParam = queryString.match(/[?|&]usredir=([^@&?=]+)/g);
        if (!redirectParam)
          return void 0;
        const encodedPath = redirectParam[0].substring("?usredir=".length);
        return decodeURIComponent(encodedPath);
      }
      function redirectWithUsrdir(location) {
        const redirectParam = getRedirectPath();
        let encodedPath;
        if (redirectParam) {
          encodedPath = redirectParam[0].substring("?usredir=".length);
        } else {
          encodedPath = encodeURIComponent(window.location.pathname);
        }
        window.location = location + `?usredir=${encodedPath}`;
      }
      function normalizedRedirectPath(path) {
        const hasLeadingSymbol = /\/|\.|\@/g.test(path[0]);
        return hasLeadingSymbol ? path.substring(1) : path;
      }
      function handleRedirect(defaultRedirectPath, includeDelay = false) {
        const redirectPath = getRedirectPath();
        const redirectUrl = (() => {
          if (redirectPath) {
            return `${window.location.origin}/${normalizedRedirectPath(redirectPath)}`;
          }
          if (defaultRedirectPath) {
            return `${window.location.origin}/${normalizedRedirectPath(defaultRedirectPath)}`;
          }
          return;
        })();
        if (!redirectUrl)
          return;
        return includeDelay ? setTimeout(() => window.Webflow.location(redirectUrl), 3e3) : window.Webflow.location(redirectUrl);
      }
      var wrapperSelectors = [".w-file-upload-error"];
      var setErrorMsg = (wrapper, fieldElements, name) => {
        for (let i = 0; i < fieldElements.length; ++i) {
          const errorText = fieldElements[i].getAttribute(name);
          if (errorText) {
            fieldElements[i].innerHTML = errorText;
            removeHiddenClass(wrapper);
            return true;
          }
        }
      };
      var handleValidationErrors = (form, failedValidations) => {
        const wrappers = [];
        wrapperSelectors.forEach((wrapperSelector) => {
          const _wrappers = form.querySelectorAll(wrapperSelector);
          for (let i = 0; i < _wrappers.length; ++i) {
            wrappers.push(_wrappers[i]);
          }
        });
        wrappers.forEach((wrapper) => {
          for (let i = 0; i < failedValidations.length; ++i) {
            const failedValidation = failedValidations[i];
            const name = failedValidation.name;
            const fieldId = failedValidation.fieldId;
            const fieldElements = wrapper.querySelectorAll("[" + _constants.USYS_DATA_ATTRS.field + '="' + fieldId + '"]');
            if (fieldElements && setErrorMsg(wrapper, fieldElements, name)) {
              break;
            }
          }
        });
      };
      var defaultErrorCopy = _constants.signUpErrorStates[_constants.SIGNUP_UI_ERROR_CODES.GENERAL_ERROR].copy;
      var userFormError = (form, errorState, formType) => (error) => {
        var _error$graphQLErrors, _error$graphQLErrors$, _error$graphQLErrors$2, _error$graphQLErrors2, _error$graphQLErrors3;
        if (errorState === null || form === null)
          return;
        const errorMsgNode = errorState.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
        const failedValidations = (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : (_error$graphQLErrors$ = _error$graphQLErrors[0]) === null || _error$graphQLErrors$ === void 0 ? void 0 : _error$graphQLErrors$.failedValidations;
        if (failedValidations) {
          handleValidationErrors(form, failedValidations);
        }
        const elementErrorCode = (_error$graphQLErrors$2 = error === null || error === void 0 ? void 0 : (_error$graphQLErrors2 = error.graphQLErrors) === null || _error$graphQLErrors2 === void 0 ? void 0 : (_error$graphQLErrors3 = _error$graphQLErrors2[0]) === null || _error$graphQLErrors3 === void 0 ? void 0 : _error$graphQLErrors3.code) !== null && _error$graphQLErrors$2 !== void 0 ? _error$graphQLErrors$2 : "";
        const errorCode = getSignupErrorCode(elementErrorCode);
        handleErrorNode(errorMsgNode, errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX[formType], defaultErrorCopy);
      };
      exports.userFormError = userFormError;
      var getSignupErrorCode = (error) => {
        let errorCode;
        switch (error) {
          case "UsysInvalidUserData":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.VALIDATION_FAILED;
            break;
          case "UsysUnauthorizedEmail":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.NOT_ALLOWED;
            break;
          case "UsysMustUseInvitation":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.USE_INVITE_EMAIL;
            break;
          case "UsysDuplicateEmail":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.EMAIL_ALREADY_EXIST;
            break;
          case "UsysInvalidEmail":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.INVALID_EMAIL;
            break;
          case "UsysInvalidPassword":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.INVALID_PASSWORD;
            break;
          case "UsysInvalidToken":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.NOT_VERIFIED;
            break;
          case "UsysExpiredToken":
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.EXPIRED_TOKEN;
            break;
          default:
            errorCode = _constants.SIGNUP_UI_ERROR_CODES.GENERAL_ERROR;
        }
        return errorCode;
      };
      exports.getSignupErrorCode = getSignupErrorCode;
    }
  });

  // packages/systems/users/siteBundles/mutations.js
  var require_mutations = __commonJS({
    "packages/systems/users/siteBundles/mutations.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.buildUpdateUsysUserDataMutation = buildUpdateUsysUserDataMutation;
      exports.verifyEmailMutation = exports.updatePasswordMutation = exports.signupMutation = exports.resetPasswordMutation = exports.logoutMutation = exports.loginMutation = exports.getUploadURLMutation = exports.cancelSubscriptionMutation = void 0;
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var loginMutation = (0, _graphqlTag.default)`
  mutation UserLoginRequest($email: String!, $authPassword: String!) {
    usysCreateSession(email: $email, authPassword: $authPassword) {
      user {
        id
        email
        createdOn
        emailVerified
      }
    }
  }
`;
      exports.loginMutation = loginMutation;
      function buildUpdateUsysUserDataMutation(dataFields) {
        return (0, _graphqlTag.default)`
    mutation UpdateUsysUserData(
      $data: usys_update_user_data!
    ) {
      usysUpdateUserData(
        data: $data
    ) {
      data {
      ${dataFields.map((field) => {
          const base = `${field.key}: ${field.type}(id: "${field.id}")`;
          if (field.type === "option") {
            return base + "{\n slug \n}";
          }
          if (field.type === "fileRef") {
            return base + "{\n id \n}";
          }
          return base;
        }).join("\n")}
        }
      }
    }
  `;
      }
      var signupMutation = (0, _graphqlTag.default)`
  mutation UserSignupRequest(
    $email: String!
    $name: String!
    $acceptPrivacy: Boolean
    $acceptCommunications: Boolean
    $authPassword: String!
    $inviteToken: String
    $redirectPath: String
    $data: usys_update_user_data
  ) {
    usysCreateUser(
      email: $email
      name: $name
      acceptPrivacy: $acceptPrivacy
      acceptCommunications: $acceptCommunications
      authPassword: $authPassword
      inviteToken: $inviteToken
      redirectPath: $redirectPath
      data: $data
    ) {
      user {
        id
        email
        name
        createdOn
        emailVerified
      }
    }
  }
`;
      exports.signupMutation = signupMutation;
      var logoutMutation = (0, _graphqlTag.default)`
  mutation UserLogoutRequest {
    usysDestroySession {
      ok
    }
  }
`;
      exports.logoutMutation = logoutMutation;
      var resetPasswordMutation = (0, _graphqlTag.default)`
  mutation UserResetPasswordRequest($email: String!) {
    usysResetPassword(email: $email) {
      ok
    }
  }
`;
      exports.resetPasswordMutation = resetPasswordMutation;
      var updatePasswordMutation = (0, _graphqlTag.default)`
  mutation UserUpdatePasswordRequest($authPassword: String!, $token: String!) {
    usysUpdatePassword(authPassword: $authPassword, token: $token) {
      ok
    }
  }
`;
      exports.updatePasswordMutation = updatePasswordMutation;
      var verifyEmailMutation = (0, _graphqlTag.default)`
  mutation UserVerifyEmail($verifyToken: String!, $redirectPath: String) {
    usysVerifyEmail(verifyToken: $verifyToken, redirectPath: $redirectPath) {
      ok
    }
  }
`;
      exports.verifyEmailMutation = verifyEmailMutation;
      var cancelSubscriptionMutation = (0, _graphqlTag.default)`
  mutation CancelSiteUserSubscription($subscriptionId: String!) {
    ecommerceCancelSubscriptionForSiteUser(subscriptionId: $subscriptionId) {
      ok
    }
  }
`;
      exports.cancelSubscriptionMutation = cancelSubscriptionMutation;
      var getUploadURLMutation = (0, _graphqlTag.default)`
  mutation getUploadURL($fieldId: String!, $filename: String!) {
    usysGetUploadURL(fieldId: $fieldId, filename: $filename) {
      presignedPOST {
        url
        fields {
          key
          value
        }
      }
      key
    }
  }
`;
      exports.getUploadURLMutation = getUploadURLMutation;
    }
  });

  // packages/systems/users/siteBundles/login.js
  var require_login = __commonJS({
    "packages/systems/users/siteBundles/login.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.asyncLogInUser = asyncLogInUser;
      exports.handleLogInForms = handleLogInForms;
      exports.handleLoginRedirects = handleLoginRedirects;
      var _utils = require_utils2();
      var _constants = require_constants3();
      var _mutations = require_mutations();
      function getLoginLinks() {
        return Array.prototype.slice.call(document.links).filter((link) => link.getAttribute("href") === "/log-in");
      }
      function handleLoginRedirects() {
        getLoginLinks().forEach((link) => {
          const queryString = window.location.search;
          const redirectParam = queryString.match(/\?usredir=([^&]+)/g);
          if (redirectParam) {
            link.href = link.href.concat(redirectParam[0]);
          }
        });
      }
      var loginFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.login}"]`;
      var errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
      var defaultErrorCopy = _constants.logInErrorStates[_constants.LOGIN_UI_ERROR_CODES.GENERAL_ERROR].copy;
      var errorMsgNode = document.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
      var getLogInErrorCode = (error) => {
        let errorCode;
        switch (error) {
          case "UsysInvalidCredentials":
            errorCode = _constants.LOGIN_UI_ERROR_CODES.INVALID_EMAIL_OR_PASSWORD;
            break;
          default:
            errorCode = _constants.LOGIN_UI_ERROR_CODES.GENERAL_ERROR;
        }
        return errorCode;
      };
      function getLoginForms() {
        const loginForms = document.querySelectorAll(loginFormQuerySelector);
        return Array.prototype.slice.call(loginForms).filter((loginForm) => loginForm instanceof HTMLFormElement);
      }
      function handleLogInForms() {
        getLoginForms().forEach((loginForm) => {
          loginForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const form = event.currentTarget;
            if (!(form instanceof HTMLFormElement)) {
              return;
            }
            const submit = form.querySelector('input[type="submit"]');
            const submitText = (0, _utils.disableSubmit)(submit);
            (0, _utils.hideElement)(errorState);
            const emailInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`);
            const passwordInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.password}"]`);
            if (!(emailInput instanceof HTMLInputElement) || !(passwordInput instanceof HTMLInputElement)) {
              return;
            }
            const onSuccessRedirectUrl = form.getAttribute(_constants.USYS_DATA_ATTRS.redirectUrl);
            asyncLogInUser(emailInput.value, passwordInput.value).then(() => {
              (0, _utils.handleRedirect)(onSuccessRedirectUrl);
            }).catch((error) => {
              (0, _utils.resetSubmit)(submit, submitText);
              if (errorState) {
                var _error$graphQLErrors$, _error$graphQLErrors, _error$graphQLErrors$2;
                const elementErrorCode = (_error$graphQLErrors$ = error === null || error === void 0 ? void 0 : (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : (_error$graphQLErrors$2 = _error$graphQLErrors[0]) === null || _error$graphQLErrors$2 === void 0 ? void 0 : _error$graphQLErrors$2.code) !== null && _error$graphQLErrors$ !== void 0 ? _error$graphQLErrors$ : "";
                const errorCode = getLogInErrorCode(elementErrorCode);
                (0, _utils.handleErrorNode)(errorMsgNode, errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX.LOGIN, defaultErrorCopy);
              }
            });
          });
        });
      }
      function asyncLogInUser(email, password) {
        return _utils.userSystemsRequestClient.mutate({
          mutation: _mutations.loginMutation,
          variables: {
            email,
            authPassword: password
          }
        });
      }
    }
  });

  // packages/systems/users/utils/universalUtils/index.js
  var require_universalUtils = __commonJS({
    "packages/systems/users/utils/universalUtils/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.setUserFileKey = exports.setTempUserFileKey = exports.removeTempUserFileKey = exports.parseWfUsysVariant = exports.getUserFileKey = exports.getTempUserFileKey = exports.appendUserInputClasses = void 0;
      exports.uploadFileToS3 = uploadFileToS3;
      var _constants = require_constants3();
      var appendUserInputClasses = (node, classes) => {
        const updatedClasses = classes.push("w-input");
        if (node.getIn(["data", "attr", "disabled"])) {
          return updatedClasses.push("w-input-disabled");
        }
        return updatedClasses;
      };
      exports.appendUserInputClasses = appendUserInputClasses;
      var parseWfUsysVariant = (wfUsysVariant) => {
        if (!wfUsysVariant)
          return [];
        let results = [];
        for (const wfUsysVariantKey of wfUsysVariant.split(",")) {
          if (_constants.USER_ACCESS_META_OPTIONS.includes(wfUsysVariantKey) && !results.includes(wfUsysVariantKey)) {
            results.push(wfUsysVariantKey);
          } else {
            console.error(`UnexpectedWfUsysVariant: Renderer received unexpected wf-usys-variant`);
            results = [];
            break;
          }
        }
        return results;
      };
      exports.parseWfUsysVariant = parseWfUsysVariant;
      function uploadFileToS3(url, fields, file) {
        return new Promise((resolve2, reject2) => {
          const formData = new FormData();
          Object.entries(fields).forEach(([key, value]) => {
            formData.append(key, value);
          });
          formData.append("file", file);
          fetch(url, {
            method: "POST",
            body: formData
          }).then((response) => {
            if (response.ok) {
              resolve2();
            } else {
              return response.text();
            }
          }).then((text) => {
            reject2(text);
          });
        });
      }
      var getUserFileKey = (element) => {
        return element.getAttribute(_constants.USYS_DATA_ATTRS.fileUploadKey);
      };
      exports.getUserFileKey = getUserFileKey;
      var setUserFileKey = (element, value) => {
        element.setAttribute(_constants.USYS_DATA_ATTRS.fileUploadKey, value);
      };
      exports.setUserFileKey = setUserFileKey;
      var getTempUserFileKey = (element) => {
        return element.getAttribute(_constants.USYS_DATA_ATTRS.unsavedFileUploadKey);
      };
      exports.getTempUserFileKey = getTempUserFileKey;
      var setTempUserFileKey = (element, value) => {
        element.setAttribute(_constants.USYS_DATA_ATTRS.unsavedFileUploadKey, value);
      };
      exports.setTempUserFileKey = setTempUserFileKey;
      var removeTempUserFileKey = (element) => {
        element.removeAttribute(_constants.USYS_DATA_ATTRS.unsavedFileUploadKey);
      };
      exports.removeTempUserFileKey = removeTempUserFileKey;
    }
  });

  // packages/systems/users/siteBundles/fields.js
  var require_fields = __commonJS({
    "packages/systems/users/siteBundles/fields.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.getCustomFields = exports.getCommonFields = exports.commonFields = void 0;
      exports.getFieldValueById = getFieldValueById;
      exports.getFieldsAsTypeKeys = getFieldsAsTypeKeys;
      exports.getFieldsForFetch = void 0;
      var _constants = require_constants3();
      var _universalUtils = require_universalUtils();
      var getTextInput = (element) => element instanceof HTMLInputElement ? element.value : "";
      var typeGetter = {
        PlainText: getTextInput,
        Email: getTextInput,
        Bool: (element) => element instanceof HTMLInputElement ? element.checked : false,
        Number: getTextInput,
        Option: (element) => element instanceof HTMLSelectElement ? element.value : "",
        Link: getTextInput,
        FileRef: (element) => {
          const fileKey = (0, _universalUtils.getUserFileKey)(element);
          const tempFileKey = (0, _universalUtils.getTempUserFileKey)(element);
          if (tempFileKey) {
            return {
              key: tempFileKey
            };
          }
          if (fileKey === "DELETE") {
            return null;
          }
          if (fileKey) {
            return {
              _id: fileKey
            };
          }
        }
      };
      var customFieldTypes = ["PlainText", "Bool", "Email", "Number", "Option", "Link", "FileRef"];
      var commonFields = [{
        type: "Email",
        slug: "email",
        selector: (container) => container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`)
      }, {
        type: "PlainText",
        slug: "name",
        selector: (container) => container.querySelector(`input[${_constants.USYS_DATA_ATTRS.field}="${_constants.RESERVED_USER_FIELDS.name}"]`) || container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.name}"]`)
      }, {
        type: "PlainText",
        slug: "password",
        selector: (container) => container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.password}"]`)
      }, {
        type: "Bool",
        slug: "accept-privacy",
        selector: (container) => container.querySelector(`input[${_constants.USYS_DATA_ATTRS.field}="${_constants.RESERVED_USER_FIELDS.acceptPrivacy}"]`) || container.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.acceptPrivacy}"]`)
      }, {
        type: "Bool",
        slug: "accept-communications",
        selector: (container) => container.querySelector(`input[${_constants.USYS_DATA_ATTRS.field}="${_constants.RESERVED_USER_FIELDS.acceptCommunications}"]`)
      }];
      exports.commonFields = commonFields;
      var toCamelCase = (str) => {
        const pascalCase = str.split("-").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join("");
        return pascalCase.charAt(0).toLowerCase() + pascalCase.slice(1);
      };
      var getCommonFields = (form, requestedFields) => {
        const payload = [];
        commonFields.forEach((field) => {
          if (requestedFields && !requestedFields.includes(field.slug))
            return;
          const ele = field.selector(form);
          if (!ele || !typeGetter[field.type])
            return;
          payload.push({
            key: toCamelCase(field.slug),
            type: toCamelCase(field.type),
            id: field.slug,
            value: typeGetter[field.type](ele, field.id)
          });
        });
        return payload;
      };
      exports.getCommonFields = getCommonFields;
      var getCustomFields = (form, includeValue = true) => {
        const payload = [];
        customFieldTypes.forEach((fieldType) => {
          const camelFieldType = toCamelCase(fieldType);
          const inputEles = form.querySelectorAll(`input[${_constants.USYS_DATA_ATTRS.fieldType}="${fieldType}"], select[${_constants.USYS_DATA_ATTRS.fieldType}="${fieldType}"]`);
          if (inputEles.length === 0 || !typeGetter[fieldType])
            return;
          inputEles.forEach((ele) => {
            const id = ele.getAttribute(_constants.USYS_DATA_ATTRS.field);
            if (!id)
              return;
            const elementData = {
              key: `f_${id}`,
              type: camelFieldType,
              id
            };
            if (includeValue) {
              const value = typeGetter[fieldType](ele, id);
              if (value === "") {
                elementData.value = null;
              } else {
                elementData.value = value;
              }
            }
            payload.push(elementData);
          });
        });
        return payload;
      };
      exports.getCustomFields = getCustomFields;
      var getFieldsForFetch = (forms) => {
        const custom = [];
        const nested = [];
        const alreadyFound = (customField) => {
          return custom.find((item) => item.id === customField.id);
        };
        forms.forEach((form) => {
          nested.push([...getCommonFields(form), ...getCustomFields(form, false)]);
        });
        nested.forEach((getCustomFieldRes) => {
          getCustomFieldRes.forEach((customField) => {
            if (!alreadyFound(customField)) {
              custom.push(customField);
            }
          });
        });
        return custom;
      };
      exports.getFieldsForFetch = getFieldsForFetch;
      function getFieldValueById(id, fieldsArray) {
        const match2 = fieldsArray.find((field) => field.id === id);
        if (!match2)
          return null;
        return match2.value;
      }
      function getFieldsAsTypeKeys(fieldsArray) {
        const memo = {};
        fieldsArray.forEach((field) => {
          const {
            key,
            type,
            value
          } = field;
          if (!memo[type])
            memo[type] = [];
          memo[type].push({
            id: key.replace("f_", ""),
            value
          });
        });
        return memo;
      }
    }
  });

  // packages/systems/users/siteBundles/signup.js
  var require_signup = __commonJS({
    "packages/systems/users/siteBundles/signup.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.asyncSignUpUser = asyncSignUpUser;
      exports.handleSignUpForms = handleSignUpForms;
      var _utils = require_utils2();
      var _constants = require_constants3();
      var _mutations = require_mutations();
      var _fields = require_fields();
      var signupFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.signup}"]`;
      var verificationMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formVerfication}`);
      function getSignupForms() {
        const signupForms = document.querySelectorAll(signupFormQuerySelector);
        return Array.prototype.slice.call(signupForms).filter((signupForm) => signupForm instanceof HTMLFormElement);
      }
      function handleUserInvite(email) {
        const form = document.querySelector(signupFormQuerySelector);
        if (!(form instanceof HTMLFormElement)) {
          return;
        }
        const emailInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`);
        if (!(emailInput instanceof HTMLInputElement)) {
          return;
        }
        emailInput.disabled = true;
        emailInput.classList.add("w-input-disabled");
        emailInput.value = email;
      }
      function handleEmailVerifcation(token, errorState) {
        const form = document.querySelector(signupFormQuerySelector);
        (0, _utils.hideElement)(form);
        asyncVerifyEmailToken(token).then(() => {
          var _redirectAnchor$getAt;
          const successMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formSuccess}`);
          const redirectAnchor = document.querySelector(`[${_constants.USYS_DATA_ATTRS.redirectUrl}] a`);
          const redirectPath = (0, _utils.getRedirectPath)();
          if (redirectPath && redirectAnchor) {
            redirectAnchor.setAttribute("href", encodeURIComponent(redirectPath));
          }
          (0, _utils.showElement)(successMessage);
          (0, _utils.handleRedirect)((_redirectAnchor$getAt = redirectAnchor === null || redirectAnchor === void 0 ? void 0 : redirectAnchor.getAttribute("href")) !== null && _redirectAnchor$getAt !== void 0 ? _redirectAnchor$getAt : "/", true);
        }).catch((error) => {
          (0, _utils.showElement)(verificationMessage);
          (0, _utils.userFormError)(form, errorState, "SIGNUP")(error);
        });
      }
      function handleSignUpForms() {
        const params = new URLSearchParams(window.location.search);
        const inviteToken = params.get("inviteToken") || "";
        const verifyToken = params.get("verifyToken") || "";
        const errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
        getSignupForms().forEach((signupForm) => {
          if (inviteToken) {
            const email = params.get("email") || "";
            handleUserInvite(email);
          }
          if (verifyToken) {
            handleEmailVerifcation(verifyToken, errorState);
          }
          signupForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const form = event.currentTarget;
            if (!(form instanceof HTMLFormElement)) {
              return;
            }
            const submit = form.querySelector('input[type="submit"]');
            const submitText = (0, _utils.disableSubmit)(submit);
            const commonFields = (0, _fields.getCommonFields)(form);
            const customFields = (0, _fields.getCustomFields)(form);
            (0, _utils.hideElement)(errorState);
            asyncSignUpUser((0, _fields.getFieldValueById)("email", commonFields) || "", (0, _fields.getFieldValueById)("name", commonFields) || "", (0, _fields.getFieldValueById)("password", commonFields) || "", (0, _fields.getFieldValueById)("accept-privacy", commonFields) || false, (0, _fields.getFieldValueById)("accept-communications", commonFields) || false, customFields, inviteToken).then(() => {
              if (inviteToken) {
                window.location = "/log-in";
              } else {
                (0, _utils.hideElement)(form);
                (0, _utils.showAndFocusElement)(verificationMessage);
              }
            }).catch((0, _utils.userFormError)(form, errorState, "SIGNUP")).finally(() => {
              (0, _utils.resetSubmit)(submit, submitText);
            });
          });
        });
      }
      function asyncSignUpUser(email, name = "", password, acceptPrivacy, acceptCommunications, customFields, inviteToken) {
        const variables = {
          email,
          name,
          acceptPrivacy,
          acceptCommunications,
          authPassword: password,
          data: (0, _fields.getFieldsAsTypeKeys)(customFields),
          inviteToken: inviteToken || void 0,
          redirectPath: (0, _utils.getRedirectPath)()
        };
        return _utils.userSystemsRequestClient.mutate({
          mutation: _mutations.signupMutation,
          variables
        });
      }
      function asyncVerifyEmailToken(verifyToken) {
        return _utils.userSystemsRequestClient.mutate({
          mutation: _mutations.verifyEmailMutation,
          variables: {
            verifyToken,
            redirectPath: (0, _utils.getRedirectPath)()
          }
        });
      }
    }
  });

  // packages/systems/users/siteBundles/logout.js
  var require_logout = __commonJS({
    "packages/systems/users/siteBundles/logout.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.asyncLogOutUser = asyncLogOutUser;
      exports.handleLogInLogOutButton = handleLogInLogOutButton;
      var _utils = require_utils2();
      var _constants = require_constants3();
      var _mutations = require_mutations();
      var logoutButtonQuerySelector = `[${_constants.USYS_DATA_ATTRS.logout}]`;
      function getLogoutButtons() {
        const logoutButtons = document.querySelectorAll(logoutButtonQuerySelector);
        return Array.prototype.slice.call(logoutButtons).filter((logoutButton) => logoutButton instanceof HTMLButtonElement);
      }
      function handleGoToLoginClick() {
        if (window.Webflow.env("preview")) {
          return;
        }
        window.location = "/log-in";
      }
      function handleLogOutButtonClick(event) {
        event.preventDefault();
        asyncLogOutUser().then(() => {
          window.Webflow.location("/");
        });
      }
      function handleLogInLogOutButton() {
        getLogoutButtons().forEach((logoutButton) => {
          if (document.cookie.split(";").some((cookie) => cookie.indexOf(_constants.LOGGEDIN_COOKIE_NAME) > -1)) {
            logoutButton.innerHTML = logoutButton.getAttribute(_constants.USYS_DATA_ATTRS.logout) || "Log out";
            logoutButton.removeEventListener("click", handleGoToLoginClick);
            logoutButton.addEventListener("click", handleLogOutButtonClick);
          } else if (!window.Webflow.env("design")) {
            logoutButton.innerHTML = logoutButton.getAttribute(_constants.USYS_DATA_ATTRS.login) || "Log in";
            logoutButton.removeEventListener("click", handleLogOutButtonClick);
            logoutButton.addEventListener("click", handleGoToLoginClick);
          }
        });
      }
      function asyncLogOutUser() {
        return _utils.userSystemsRequestClient.mutate({
          mutation: _mutations.logoutMutation
        });
      }
    }
  });

  // packages/systems/users/siteBundles/resetPassword.js
  var require_resetPassword = __commonJS({
    "packages/systems/users/siteBundles/resetPassword.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.asyncRequestResetPassword = asyncRequestResetPassword;
      exports.handleResetPasswordForms = handleResetPasswordForms;
      var _utils = require_utils2();
      var _constants = require_constants3();
      var _mutations = require_mutations();
      var resetPasswordFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.resetPassword}"]`;
      var errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
      var defaultErrorCopy = _constants.resetPasswordErrorStates[_constants.RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR].copy;
      var errorMsgNode = document.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
      var getResetPasswordErrorCode = (error) => {
        let errorCode;
        switch (error) {
          default:
            errorCode = _constants.RESET_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR;
        }
        return errorCode;
      };
      function getResetPasswordForms() {
        const resetPasswordForms = document.querySelectorAll(resetPasswordFormQuerySelector);
        return Array.prototype.slice.call(resetPasswordForms).filter((resetPasswordForm) => resetPasswordForm instanceof HTMLFormElement);
      }
      function handleResetPasswordForms() {
        getResetPasswordForms().forEach((resetPasswordForm) => {
          resetPasswordForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const form = event.currentTarget;
            const successMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formSuccess}`);
            if (!(form instanceof HTMLFormElement)) {
              return;
            }
            (0, _utils.hideElement)(errorState);
            const emailInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.email}"]`);
            if (!(emailInput instanceof HTMLInputElement)) {
              return;
            }
            asyncRequestResetPassword(emailInput.value).then(() => {
              (0, _utils.hideElement)(form);
              (0, _utils.showAndFocusElement)(successMessage);
            }).catch((error) => {
              if (errorState) {
                var _error$graphQLErrors$, _error$graphQLErrors, _error$graphQLErrors$2;
                const elementErrorCode = (_error$graphQLErrors$ = error === null || error === void 0 ? void 0 : (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : (_error$graphQLErrors$2 = _error$graphQLErrors[0]) === null || _error$graphQLErrors$2 === void 0 ? void 0 : _error$graphQLErrors$2.code) !== null && _error$graphQLErrors$ !== void 0 ? _error$graphQLErrors$ : "";
                const errorCode = getResetPasswordErrorCode(elementErrorCode);
                (0, _utils.handleErrorNode)(errorMsgNode, errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX.RESET_PASSWORD, defaultErrorCopy);
              }
            });
          });
        });
      }
      function asyncRequestResetPassword(email) {
        return _utils.userSystemsRequestClient.mutate({
          mutation: _mutations.resetPasswordMutation,
          variables: {
            email
          }
        });
      }
    }
  });

  // packages/systems/users/siteBundles/updatePassword.js
  var require_updatePassword = __commonJS({
    "packages/systems/users/siteBundles/updatePassword.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.asyncRequestUpdatePassword = asyncRequestUpdatePassword;
      exports.handleUpdatePasswordForms = handleUpdatePasswordForms;
      var _utils = require_utils2();
      var _constants = require_constants3();
      var _mutations = require_mutations();
      var updatePasswordFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.updatePassword}"]`;
      var errorState = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
      var defaultErrorCopy = _constants.updatePasswordErrorStates[_constants.UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR].copy;
      var errorMsgNode = document.querySelector(`.${_constants.ERROR_MSG_CLASS}`);
      var getUpdatePasswordErrorCode = (error) => {
        let errorCode;
        switch (error) {
          case "UsysInvalidPassword":
            errorCode = _constants.UPDATE_PASSWORD_UI_ERROR_CODES.WEAK_PASSWORD;
            break;
          default:
            errorCode = _constants.UPDATE_PASSWORD_UI_ERROR_CODES.GENERAL_ERROR;
        }
        return errorCode;
      };
      function getUpdatePasswordForms() {
        const updatePasswordForms = document.querySelectorAll(updatePasswordFormQuerySelector);
        return Array.prototype.slice.call(updatePasswordForms).filter((updatePasswordForm) => updatePasswordForm instanceof HTMLFormElement);
      }
      function handleUpdatePasswordForms() {
        getUpdatePasswordForms().forEach((updatePasswordForm) => {
          updatePasswordForm.addEventListener("submit", (event) => {
            event.preventDefault();
            const form = event.currentTarget;
            const successMessage = document.querySelector(`.${_constants.USYS_DOM_CLASS_NAMES.formSuccess}`);
            if (!(form instanceof HTMLFormElement)) {
              return;
            }
            const errorElement = document.querySelector(`[${_constants.USYS_DATA_ATTRS.formError}]`);
            (0, _utils.hideElement)(errorElement);
            const passwordInput = form.querySelector(`input[${_constants.USYS_DATA_ATTRS.inputType}="${_constants.USYS_INPUT_TYPES.password}"]`);
            if (!(passwordInput instanceof HTMLInputElement)) {
              return;
            }
            const params = new URLSearchParams(window.location.search);
            const token = params.get("token") || "";
            asyncRequestUpdatePassword(passwordInput.value, token).then(() => {
              (0, _utils.hideElement)(form);
              (0, _utils.showAndFocusElement)(successMessage);
            }).catch((error) => {
              if (errorState) {
                var _error$graphQLErrors$, _error$graphQLErrors, _error$graphQLErrors$2;
                const elementErrorCode = (_error$graphQLErrors$ = error === null || error === void 0 ? void 0 : (_error$graphQLErrors = error.graphQLErrors) === null || _error$graphQLErrors === void 0 ? void 0 : (_error$graphQLErrors$2 = _error$graphQLErrors[0]) === null || _error$graphQLErrors$2 === void 0 ? void 0 : _error$graphQLErrors$2.code) !== null && _error$graphQLErrors$ !== void 0 ? _error$graphQLErrors$ : "";
                const errorCode = getUpdatePasswordErrorCode(elementErrorCode);
                (0, _utils.handleErrorNode)(errorMsgNode, errorState, errorCode, _constants.ERROR_ATTRIBUTE_PREFIX.UPDATE_PASSWORD, defaultErrorCopy);
              }
            });
          });
        });
      }
      function asyncRequestUpdatePassword(authPassword, token) {
        return _utils.userSystemsRequestClient.mutate({
          mutation: _mutations.updatePasswordMutation,
          variables: {
            authPassword,
            token
          }
        });
      }
    }
  });

  // packages/systems/users/siteBundles/queries.js
  var require_queries = __commonJS({
    "packages/systems/users/siteBundles/queries.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.buildGetLoggedInUserQuery = buildGetLoggedInUserQuery;
      exports.getUserSubscriptions = exports.getFieldValidations = void 0;
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var getUserSubscriptions = (0, _graphqlTag.default)`
  query FetchSubscriptions {
    database {
      userSubscriptions {
        _id
        productName
        variantPrice {
          string
          unit
          value
        }
        variantImage {
          url
          alt
        }
        status
        lastInvoiced
        periodEnd
        subCreatedOn
        canceledOn
        billingAddressAddressee
        billingAddressLine1
        billingAddressLine2
        billingAddressCity
        billingAddressState
        billingAddressPostalCode
        billingAddressCountry
        cardLast4
        cardExpiresMonth
        cardExpiresYear
      }
    }
  }
`;
      exports.getUserSubscriptions = getUserSubscriptions;
      function buildGetLoggedInUserQuery(dataFields = []) {
        return (0, _graphqlTag.default)`
    query FetchUser {
        site {
          siteUser {
            createdOn
            ${dataFields.length > 0 ? `
            data {
              ${dataFields.map((field) => {
          const base = `${field.key}: ${field.type}(id: "${field.id}")`;
          if (field.type === "option") {
            return base + "{\n slug \n}";
          }
          if (field.type === "fileRef") {
            return base + "{\n url \n \n id \n}";
          }
          return base;
        }).join("\n")}
            }` : ""}
        }
      }
    }
  `;
      }
      var getFieldValidations = (0, _graphqlTag.default)`
  query GetFieldValidations {
    site {
      usysFieldSchema {
        id
        required
        validations {
          minLength
          maxLength
          min
          max
          step
          extensions
          options {
            slug
            name
          }
        }
      }
    }
  }
`;
      exports.getFieldValidations = getFieldValidations;
    }
  });

  // packages/systems/users/siteBundles/rendering.js
  var require_rendering2 = __commonJS({
    "packages/systems/users/siteBundles/rendering.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.applyBindingsAndConditionalVisibility = applyBindingsAndConditionalVisibility;
      exports.applyUserAccountData = applyUserAccountData;
      var _escape = _interopRequireDefault(require_escape());
      var _get = _interopRequireDefault(require_get());
      var _Transformers = require_Transformers2();
      var _RenderingUtils = require_RenderingUtils2();
      var _constants = (init_constants(), __toCommonJS(constants_exports));
      var _constants2 = require_constants2();
      var _constants3 = require_constants3();
      var _universalUtils = require_universalUtils();
      var _utils = require_utils2();
      var getPropertyMutator = (bindingProperty) => {
        if (typeof mutators[bindingProperty] === "function") {
          return mutators[bindingProperty];
        }
        return null;
      };
      var mutators = {
        innerHTML: (node, type, value) => {
          const valueString = value != null ? String(value) : "";
          if (_constants.SHARED_ALLOWED_FIELD_TYPES.innerHTML[type] === "innerHTML") {
            node.innerHTML = valueString;
          } else if (_constants.SHARED_ALLOWED_FIELD_TYPES.innerHTML[type] === "innerText") {
            node.innerHTML = (0, _escape.default)(valueString);
          }
          if (node.innerHTML) {
            node.classList.remove("w-dyn-bind-empty");
          }
        },
        src: (node, type, value) => {
          if (value && value.url) {
            node.setAttribute("src", value.url);
          }
          node.classList.remove("w-dyn-bind-empty");
        }
      };
      var bindDataToNode = (node, data, bindings) => {
        bindings.forEach((binding) => {
          Object.keys(binding).forEach((bindingProperty) => {
            const bindingValue = binding[bindingProperty];
            const {
              dataPath,
              filter: filter2,
              timezone,
              type
            } = bindingValue;
            const rawValue = (0, _get.default)(data, dataPath);
            const transformedValue = (0, _Transformers.transformers)(rawValue, filter2, {
              timezone,
              collectionSlugMap: {},
              currencySettings: window.__WEBFLOW_CURRENCY_SETTINGS
            });
            const propertyMutator = getPropertyMutator(bindingProperty);
            if (propertyMutator) {
              propertyMutator(node, type, transformedValue);
            }
          });
        });
      };
      function applyBindingsAndConditionalVisibility(node, data) {
        if (node.hasAttribute(_constants2.WF_BINDING_DATA_KEY)) {
          const bindingsStr = node.getAttribute(_constants2.WF_BINDING_DATA_KEY) || "";
          const bindings = JSON.parse(decodeURIComponent(bindingsStr));
          if (bindings) {
            bindDataToNode(node, data, bindings);
          }
        }
        if (node.hasAttribute(_constants2.WF_CONDITION_DATA_KEY)) {
          const conditionsStr = node.getAttribute(_constants2.WF_CONDITION_DATA_KEY) || "";
          const conditionData = JSON.parse(decodeURIComponent(conditionsStr));
          if (conditionData) {
            (0, _RenderingUtils.applyConditionToNode)(node, data, conditionData);
          }
        }
      }
      function getFirstAncestor(element, pred) {
        if (element.parentNode === null) {
          return null;
        }
        if (pred(element)) {
          return element;
        }
        return getFirstAncestor(element.parentNode, pred);
      }
      function hasFormFileUploadWrapperClass(element) {
        return element.classList.contains("w-file-upload");
      }
      function setFileUploadValue(node, fileId) {
        if (!fileId)
          return;
        (0, _universalUtils.setUserFileKey)(node, fileId);
        const formFileUploadWrapper = getFirstAncestor(node, hasFormFileUploadWrapperClass);
        if (formFileUploadWrapper === null)
          return;
        const formFileDefault = formFileUploadWrapper.querySelector(".w-file-upload-default");
        const formFileSuccess = formFileUploadWrapper.querySelector(".w-file-upload-success");
        const formFileError = formFileUploadWrapper.querySelector(".w-file-upload-error");
        const formFileUploading = formFileUploadWrapper.querySelector(".w-file-upload-uploading");
        (0, _utils.addHiddenClass)(formFileDefault);
        (0, _utils.addHiddenClass)(formFileError);
        (0, _utils.addHiddenClass)(formFileUploading);
        (0, _utils.removeHiddenClass)(formFileSuccess);
      }
      function applyUserAccountData(node, userData) {
        if (node.hasAttribute(_constants3.USYS_DATA_ATTRS.field)) {
          const field = node.getAttribute(_constants3.USYS_DATA_ATTRS.field) || "";
          const fieldType = node.getAttribute(_constants3.USYS_DATA_ATTRS.fieldType) || "";
          if (fieldType === "Option") {
            node.value = (0, _get.default)(userData, [`f_${field}`, "slug"], "");
            return;
          }
          if (fieldType === "FileRef") {
            setFileUploadValue(node, (0, _get.default)(userData, [`f_${field}`, "id"], ""));
            return;
          }
          const dataPath = field && field.includes(_constants3.RESERVED_USER_PREFIX) ? _constants3.KEY_FROM_RESERVED_USER_FIELD[field] : `f_${field}`;
          const value = (0, _get.default)(userData, [dataPath], "");
          if (node.type === "checkbox" && node.checked !== Boolean(value) && node.click) {
            node.click();
            return;
          }
          node.value = value;
        }
        if (node.hasAttribute(_constants3.USYS_DATA_ATTRS.inputType)) {
          const dataPath = node.getAttribute(_constants3.USYS_DATA_ATTRS.inputType) || "";
          const value = (0, _get.default)(userData, [dataPath], "");
          if (value) {
            node.value = value;
          }
        }
      }
    }
  });

  // packages/systems/users/siteBundles/account.js
  var require_account = __commonJS({
    "packages/systems/users/siteBundles/account.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.handleUserAccount = handleUserAccount;
      exports.handleUserSubscriptionLists = handleUserSubscriptionLists;
      var _constants = require_constants3();
      var _constants2 = require_constants2();
      var _RenderingUtils = require_RenderingUtils2();
      var _utils = require_utils2();
      var _queries = require_queries();
      var _mutations = require_mutations();
      var _rendering = require_rendering2();
      var _fields = require_fields();
      function asyncGetUserSubscriptions() {
        return _utils.userSystemsRequestClient.query({
          query: _queries.getUserSubscriptions
        });
      }
      function asyncGetUser(dataFields) {
        return _utils.userSystemsRequestClient.query({
          query: (0, _queries.buildGetLoggedInUserQuery)(dataFields)
        });
      }
      function asyncSubmitUserData(dataFields) {
        const data = (0, _fields.getFieldsAsTypeKeys)(dataFields);
        return _utils.userSystemsRequestClient.mutate({
          mutation: (0, _mutations.buildUpdateUsysUserDataMutation)(dataFields),
          variables: {
            data
          }
        });
      }
      var subscriptionListSelector = `[${_constants.USYS_DATA_ATTRS.userSubscriptions}]`;
      var EmptyStateSelector = `[${_constants.USYS_DATA_ATTRS.userSubscriptionsEmptyState}]`;
      var templateSelector = `script[type='${_constants2.WF_TEMPLATE_TYPE}']`;
      function getUserSubscriptionLists() {
        const subscriptionLists = document.querySelectorAll(subscriptionListSelector);
        return Array.from(subscriptionLists);
      }
      var userAccountFormQuerySelector = `form[${_constants.USYS_DATA_ATTRS.formType}="${_constants.USYS_FORM_TYPES.account}"]`;
      function getUserAccountForms() {
        const accountForms = document.querySelectorAll(userAccountFormQuerySelector);
        return Array.prototype.slice.call(accountForms).filter((accountForm) => accountForm instanceof HTMLFormElement);
      }
      function handleUserSubscriptionLists(domParser) {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        const subscriptionLists = getUserSubscriptionLists();
        if (subscriptionLists.length > 0) {
          asyncGetUserSubscriptions().then((response) => {
            var _response$data, _response$data$databa;
            const userSubscriptions = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$databa = _response$data.database) === null || _response$data$databa === void 0 ? void 0 : _response$data$databa.userSubscriptions;
            const noUserSubscriptions = userSubscriptions.length === 0;
            if (noUserSubscriptions)
              return renderEmptySubscriptionList(subscriptionLists);
            renderUserSubscriptionLists(subscriptionLists, domParser, userSubscriptions);
          }).catch((error) => {
            const graphQLErrors = (error === null || error === void 0 ? void 0 : error.graphQLErrors) || [];
            const errorsHandled = graphQLErrors.reduce((hasUnhandledError, graphQLError) => {
              if ((graphQLError === null || graphQLError === void 0 ? void 0 : graphQLError.code) === "NoCommerceCustomerFound") {
                renderEmptySubscriptionList(subscriptionLists);
                return hasUnhandledError;
              }
              return false;
            }, graphQLErrors.length > 0);
            if (!errorsHandled)
              throw error;
          });
        }
      }
      function renderEmptySubscriptionList(subscriptionListElements) {
        subscriptionListElements.forEach((subscriptionListElement) => {
          const EmptyStateElement = subscriptionListElement.querySelector(EmptyStateSelector);
          (0, _utils.showElement)(EmptyStateElement);
        });
      }
      function renderUserSubscriptionLists(subscriptionListElements, domParser, userSubscriptions = []) {
        subscriptionListElements.forEach((subscriptionListElement) => {
          const EmptyStateElement = subscriptionListElement.querySelector(EmptyStateSelector);
          (0, _utils.hideElement)(EmptyStateElement);
          const templateScript = subscriptionListElement.querySelector(templateSelector);
          if (!templateScript) {
            return;
          }
          const templateId = templateScript.getAttribute("id");
          if (!templateId) {
            return;
          }
          const listWrapperElement = document.querySelector(`[${_constants2.WF_TEMPLATE_ID_DATA_KEY}='${templateId}']`);
          if (!(listWrapperElement instanceof Element)) {
            return;
          }
          const templateElement = domParser.getHtmlFromString(templateScript.innerHTML);
          if (!(templateElement instanceof Element)) {
            return;
          }
          userSubscriptions.forEach((subscription) => {
            const templateClone = templateElement.cloneNode(true);
            listWrapperElement.appendChild(templateClone);
            (0, _RenderingUtils.walkDOM)(templateClone, (node) => {
              (0, _rendering.applyBindingsAndConditionalVisibility)(node, subscription);
              if (node.hasAttribute(_constants.USYS_DATA_ATTRS.subscriptionCancel)) {
                addCancelButtonEventListener(node, subscription._id);
              }
            });
          });
        });
      }
      function addCancelButtonEventListener(node, subscriptionId) {
        node.addEventListener("click", function() {
          _utils.userSystemsRequestClient.mutate({
            mutation: _mutations.cancelSubscriptionMutation,
            variables: {
              subscriptionId
            }
          }).then(() => {
            window.location.reload();
          });
        });
      }
      function handleUserAccount() {
        const userAccount = document.querySelector(`[${_constants.USYS_DATA_ATTRS.userAccount}]`);
        if (!userAccount || window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        const successMessage = userAccount.querySelector("." + _constants.USYS_DOM_CLASS_NAMES.formSuccess);
        const errorMessage = userAccount.querySelector("." + _constants.USYS_DOM_CLASS_NAMES.formError);
        const userAccountForms = getUserAccountForms();
        if (userAccountForms.length > 0) {
          const fields = (0, _fields.getFieldsForFetch)(userAccountForms);
          asyncGetUser(fields).then((response) => {
            var _response$data2, _response$data2$site;
            const siteUser = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$site = _response$data2.site) === null || _response$data2$site === void 0 ? void 0 : _response$data2$site.siteUser;
            if (!siteUser)
              return;
            const userData = siteUser.data;
            userAccountForms.forEach((accountForm) => {
              (0, _RenderingUtils.walkDOM)(userAccount, (node) => {
                (0, _rendering.applyUserAccountData)(node, userData);
              });
              if (!(accountForm instanceof HTMLFormElement))
                return;
              const submit = accountForm.querySelector('input[type="submit"]');
              accountForm.addEventListener("submit", (event) => {
                event.preventDefault();
                const form = event.currentTarget;
                if (!(form instanceof HTMLFormElement)) {
                  return;
                }
                (0, _utils.hideElement)(successMessage);
                (0, _utils.hideElement)(errorMessage);
                const submitText = (0, _utils.disableSubmit)(submit);
                const commonFields = (0, _fields.getCommonFields)(form, ["name", "accept-communications"]);
                const customFields = (0, _fields.getCustomFields)(form);
                asyncSubmitUserData([...commonFields, ...customFields]).then((res) => {
                  const newUserData = res && res.data && res.data.usysUpdateUserData && res.data.usysUpdateUserData.data;
                  if (newUserData) {
                    addResetEventListener(accountForm, userAccount, newUserData);
                  }
                  successMessage && (0, _utils.showAndFocusElement)(successMessage);
                }).catch((0, _utils.userFormError)(form, errorMessage, "ACCOUNT_UPDATE")).finally(() => {
                  (0, _utils.resetSubmit)(submit, submitText);
                });
              });
              accountForm.querySelectorAll("input").forEach((input) => input.addEventListener("input", () => {
                (0, _utils.hideElement)(successMessage);
                (0, _utils.hideElement)(errorMessage);
              }));
              addResetEventListener(accountForm, userAccount, userData);
            });
          });
        }
      }
      var addResetEventListener = (accountForm, userAccount, userData) => {
        accountForm.addEventListener("reset", (event) => {
          event.preventDefault();
          const form = event.currentTarget;
          if (!(form instanceof HTMLFormElement))
            return;
          if (userData) {
            (0, _RenderingUtils.walkDOM)(userAccount, (node) => {
              (0, _rendering.applyUserAccountData)(node, userData);
            });
          }
        });
      };
    }
  });

  // packages/systems/users/siteBundles/usysForm.js
  var require_usysForm = __commonJS({
    "packages/systems/users/siteBundles/usysForm.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.handleFields = handleFields;
      var _utils = require_utils2();
      var _queries = require_queries();
      var _constants = require_constants3();
      var _universalUtils = require_universalUtils();
      var _mutations = require_mutations();
      function asyncGetFieldValidations() {
        return _utils.userSystemsRequestClient.query({
          query: _queries.getFieldValidations
        });
      }
      function signFile(file, {
        fieldId
      }) {
        return _utils.userSystemsRequestClient.mutate({
          mutation: _mutations.getUploadURLMutation,
          variables: {
            fieldId,
            filename: file.name
          }
        });
      }
      function setRequired(input, userField) {
        if (userField.required == null)
          return;
        input.required = userField.required;
      }
      var inputAttributeMap = {
        minLength: "minlength",
        maxLength: "maxlength",
        min: "min",
        max: "max",
        step: "step",
        extensions: "accept"
      };
      var formatValueMap = {
        extensions: function accept(value) {
          return value.join(",");
        }
      };
      function convertToStr(value) {
        return String(value);
      }
      function setValidations(input, userField) {
        if (userField.validations == null)
          return;
        Object.keys(userField.validations).map((attr) => {
          const val = userField.validations[attr];
          if (attr === "options" && Array.isArray(val) && input instanceof HTMLSelectElement) {
            val.forEach((option) => {
              if (option.slug && option.name) {
                const opt = document.createElement("option");
                opt.value = option.slug;
                opt.innerHTML = option.name;
                input.appendChild(opt);
              }
            });
          }
          if (val !== null && inputAttributeMap[attr]) {
            let formatValue;
            if (formatValueMap[attr]) {
              formatValue = formatValueMap[attr];
            } else {
              formatValue = convertToStr;
            }
            input.setAttribute(inputAttributeMap[attr], formatValue(val));
          }
          if (attr === "maxLength" && val === null) {
            input.removeAttribute("maxlength");
          }
        });
      }
      function setUserFieldValidationAttr(input, userField) {
        const fieldType = input.getAttribute(_constants.USYS_DATA_ATTRS.fieldType);
        if (!_constants.NO_REQUIRED_ATTRIBUTE.includes(fieldType)) {
          setRequired(input, userField);
        }
        setValidations(input, userField);
      }
      function matchInputToData(input, userFieldData) {
        const fieldId = input.getAttribute(_constants.USYS_DATA_ATTRS.field);
        if (!fieldId) {
          return null;
        }
        for (let i = 0; i < userFieldData.length; i++) {
          if (userFieldData[i].id === fieldId) {
            return userFieldData[i];
          }
        }
        return null;
      }
      function setFieldValidation(customFieldInputs) {
        asyncGetFieldValidations().then((response) => {
          const userFieldData = response.data.site.usysFieldSchema;
          if (!userFieldData)
            return;
          for (let i = 0; i < customFieldInputs.length; i++) {
            const input = customFieldInputs[i];
            if (!input || !(input instanceof HTMLInputElement || input instanceof HTMLSelectElement) || input.getAttribute(_constants.USYS_DATA_ATTRS.fieldType) === "Bool") {
              continue;
            }
            const userField = matchInputToData(input, userFieldData);
            if (!userField)
              continue;
            setUserFieldValidationAttr(input, userField);
          }
        }).catch((err) => {
          console.error(err);
        });
      }
      function getMatchingSiblings(e, pred) {
        const siblings = [];
        if (e.target.parentNode === null) {
          return siblings;
        }
        [].slice.call(e.target.parentNode.children).forEach((element) => {
          if (pred(element)) {
            siblings.push(element);
          }
        });
        return siblings;
      }
      function isFormFileUploadWrapper(element) {
        return element.classList.contains("w-file-upload");
      }
      function getFirstAncestor(element, pred) {
        if (element.parentNode === null) {
          return null;
        }
        if (pred(element)) {
          return element;
        }
        return getFirstAncestor(element.parentNode, pred);
      }
      function handleFileRemoveLink(cancelRemoveLinkElement, inputElement, props) {
        const {
          deleteFile,
          cancelFile
        } = props;
        cancelRemoveLinkElement.addEventListener("click", function(e) {
          if (e.type === "keydown") {
            if (e.which !== 13 && e.which !== 32) {
              return;
            }
            e.preventDefault();
          }
          if ((0, _universalUtils.getUserFileKey)(inputElement)) {
            deleteFile();
            return;
          }
          cancelFile();
        });
      }
      function handleFileUploadInput(element, props) {
        const {
          showUploading,
          successUpload,
          errorUpload,
          changeFileNameText,
          disableSubmitButton,
          filesState
        } = props;
        const fieldId = element.getAttribute(_constants.USYS_DATA_ATTRS.field);
        element.addEventListener("change", function(e) {
          if (filesState.isUploading)
            return;
          const file = e.target && e.target.files && e.target.files[0];
          if (!file) {
            return;
          }
          showUploading();
          changeFileNameText(file.name);
          filesState.isUploading = true;
          if (!filesState.isUploading) {
            disableSubmitButton();
          }
          let key = "";
          signFile(file, {
            fieldId
          }).then((res) => {
            if (!res.data || !res.data.usysGetUploadURL || !res.data.usysGetUploadURL.presignedPOST) {
              throw Error(res);
            }
            const presignedPOST = res.data.usysGetUploadURL.presignedPOST;
            key = res.data.usysGetUploadURL.key;
            const AWSFields = {};
            presignedPOST.fields.forEach((field) => {
              const _key = field.key;
              const value = field.value;
              AWSFields[_key] = value;
            });
            return (0, _universalUtils.uploadFileToS3)(presignedPOST.url, AWSFields, file);
          }).then(() => {
            successUpload(key);
          }).catch((err) => {
            let code = _constants.SERVER_DATA_VALIDATION_ERRORS.DefaultError;
            if (typeof err === "string") {
              const content = new window.DOMParser().parseFromString(err, "text/xml");
              const codeElements = content.getElementsByTagName("Code");
              if (codeElements) {
                code = codeElements[0].innerHTML;
              }
            }
            if (typeof err === "object" && err.hasOwnProperty("graphQLErrors")) {
              if (err.graphQLErrors[0].code === "UsysForbiddenFileExtension") {
                code = _constants.SERVER_DATA_VALIDATION_ERRORS.ExtensionsError;
              }
            }
            errorUpload(code);
          }).finally(() => {
            filesState.isUploading = false;
          });
        });
      }
      var WF_SUBMIT_BUTTON_VALUE = "wf-submit-button-value";
      var adaptAWSErrors = (code) => {
        if (code === "EntityTooLarge")
          return _constants.SERVER_DATA_VALIDATION_ERRORS.MinSizeError;
        if (code === "EntityTooSmall")
          return _constants.SERVER_DATA_VALIDATION_ERRORS.MaxSizeError;
        return code;
      };
      function handleFileUploadInputs(customFieldInputs, props) {
        const {
          disableSubmitButton,
          enableSubmitButton
        } = props;
        const filesState = {
          isUploading: false
        };
        customFieldInputs.forEach((el) => {
          if (el.getAttribute("type") === "file") {
            let showUploading = function() {
              (0, _utils.addHiddenClass)(formFileDefault);
              (0, _utils.addHiddenClass)(formFileError);
              (0, _utils.addHiddenClass)(formFileSuccess);
              (0, _utils.removeHiddenClass)(formFileUploading);
              formFileUploading.focus();
              disableSubmitButton();
            }, successUpload = function(fileUrl) {
              (0, _utils.addHiddenClass)(formFileDefault);
              (0, _utils.addHiddenClass)(formFileError);
              (0, _utils.addHiddenClass)(formFileUploading);
              (0, _utils.removeHiddenClass)(formFileSuccess);
              formFileSuccess.focus();
              enableSubmitButton();
              (0, _universalUtils.setTempUserFileKey)(el, fileUrl);
            }, errorUpload = function(code = _constants.SERVER_DATA_VALIDATION_ERRORS.DefaultError) {
              const errorText = formFileErrorMsg.getAttribute(adaptAWSErrors(code).toLowerCase());
              (0, _utils.addHiddenClass)(formFileSuccess);
              (0, _utils.addHiddenClass)(formFileUploading);
              (0, _utils.removeHiddenClass)(formFileDefault);
              (0, _utils.removeHiddenClass)(formFileError);
              if (errorText) {
                formFileErrorMsg.innerHTML = errorText;
              }
              formFileError.focus();
              enableSubmitButton();
            }, showDefault = function() {
              (0, _utils.addHiddenClass)(formFileSuccess);
              (0, _utils.addHiddenClass)(formFileUploading);
              (0, _utils.addHiddenClass)(formFileError);
              (0, _utils.removeHiddenClass)(formFileDefault);
              fileUploadLabel.focus();
            }, changeFileNameText = function(filename) {
              fileUploadFileName.innerHTML = filename;
            }, cancelFile = function() {
              changeFileNameText("");
              (0, _universalUtils.removeTempUserFileKey)(el);
              showDefault();
            }, deleteFile = function() {
              (0, _universalUtils.setUserFileKey)(el, "DELETE");
              cancelFile();
            };
            const formFileUploadWrapper = getFirstAncestor(el, isFormFileUploadWrapper);
            const formFileDefault = formFileUploadWrapper.querySelector(".w-file-upload-default");
            const formFileSuccess = formFileUploadWrapper.querySelector(".w-file-upload-success");
            const formFileError = formFileUploadWrapper.querySelector(".w-file-upload-error");
            const formFileErrorMsg = formFileError.querySelector(".w-file-upload-error-msg");
            const formFileUploading = formFileUploadWrapper.querySelector(".w-file-upload-uploading");
            const fileUploadFileName = formFileUploadWrapper.querySelector(".w-file-upload-file-name");
            const fileRemoveLink = formFileUploadWrapper.querySelector(".w-file-remove-link");
            const fileUploadLabel = formFileUploadWrapper.querySelector(".w-file-upload-label");
            handleFileRemoveLink(fileRemoveLink, el, {
              deleteFile,
              cancelFile
            });
            handleFileUploadInput(el, {
              showUploading,
              successUpload,
              errorUpload,
              changeFileNameText,
              fileRemoveLink,
              filesState
            });
          }
        });
      }
      function handleFields() {
        const userForms = document.querySelectorAll(`form[${_constants.USYS_DATA_ATTRS.formType}]`);
        userForms.forEach((userForm) => {
          const customFieldInputs = userForm.querySelectorAll(`input[${_constants.USYS_DATA_ATTRS.field}], select[${_constants.USYS_DATA_ATTRS.field}]`);
          const submitButton = userForm.querySelector('input[type="submit"]');
          submitButton.setAttribute(WF_SUBMIT_BUTTON_VALUE, submitButton.value);
          function disableSubmitButton() {
            if (submitButton) {
              (0, _utils.disableSubmit)(submitButton);
            }
          }
          function enableSubmitButton() {
            if (submitButton) {
              submitButton.removeAttribute("disabled");
              submitButton.setAttribute("value", submitButton.getAttribute(WF_SUBMIT_BUTTON_VALUE) || "Submit");
            }
          }
          if (customFieldInputs.length > 0) {
            setFieldValidation(customFieldInputs);
            handleFileUploadInputs(customFieldInputs, {
              disableSubmitButton,
              enableSubmitButton
            });
          }
          const CHECKBOX_CLASS_NAME = "w-checkbox-input";
          const CHECKED_CLASS = "w--redirected-checked";
          const customCheckboxes = document.querySelectorAll(`form[${_constants.USYS_DATA_ATTRS.formType}] input[type="checkbox"]:not(` + CHECKBOX_CLASS_NAME + ")");
          customCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener("change", function(e) {
              getMatchingSiblings(e, (element) => {
                return element.classList.contains(CHECKBOX_CLASS_NAME);
              }).forEach((sibling) => {
                sibling.classList.toggle(CHECKED_CLASS);
              });
            });
          });
        });
      }
    }
  });

  // packages/systems/users/siteBundles/index.js
  var require_siteBundles = __commonJS({
    "packages/systems/users/siteBundles/index.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      var _exportNames = {
        usysSiteBundle: true,
        usysFormBundle: true
      };
      exports.usysSiteBundle = exports.usysFormBundle = void 0;
      init_polyfill();
      require_polyfill2();
      require_url_search_params();
      require_array3();
      var _login = require_login();
      var _signup = require_signup();
      var _logout = require_logout();
      var _resetPassword = require_resetPassword();
      var _updatePassword = require_updatePassword();
      var _account = require_account();
      var _utils = require_utils2();
      Object.keys(_utils).forEach(function(key) {
        if (key === "default" || key === "__esModule")
          return;
        if (Object.prototype.hasOwnProperty.call(_exportNames, key))
          return;
        if (key in exports && exports[key] === _utils[key])
          return;
        Object.defineProperty(exports, key, {
          enumerable: true,
          get: function() {
            return _utils[key];
          }
        });
      });
      var _usysForm = require_usysForm();
      var usysSiteBundle = () => {
        function init() {
          const domParser = (0, _utils.getDomParser)();
          (0, _login.handleLogInForms)();
          (0, _login.handleLoginRedirects)();
          (0, _signup.handleSignUpForms)();
          (0, _logout.handleLogInLogOutButton)();
          (0, _resetPassword.handleResetPasswordForms)();
          (0, _updatePassword.handleUpdatePasswordForms)();
          (0, _account.handleUserAccount)();
          (0, _account.handleUserSubscriptionLists)(domParser);
        }
        const ready = init;
        const design = init;
        const preview = init;
        return {
          init,
          ready,
          design,
          preview
        };
      };
      exports.usysSiteBundle = usysSiteBundle;
      var usysFormBundle = function(env) {
        function init() {
          if (env("design"))
            return;
          (0, _usysForm.handleFields)();
        }
        return {
          init,
          ready: init,
          preview: init
        };
      };
      exports.usysFormBundle = usysFormBundle;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/addToCartEvents.js
  var require_addToCartEvents = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/addToCartEvents.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.register = exports.default = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var _constants = require_constants2();
      var _constants2 = require_constants3();
      var _constants3 = (init_constants(), __toCommonJS(constants_exports));
      var _constants4 = require_constants4();
      var _utils = require_utils();
      var _get = _interopRequireDefault(require_get());
      var _site = require_site();
      var _eventHandlerProxyWithApolloClient = _interopRequireDefault(require_eventHandlerProxyWithApolloClient());
      var _commerceUtils = require_commerceUtils();
      var _RenderingUtils = require_RenderingUtils2();
      var _CurrencyUtils = require_CurrencyUtils2();
      var _debug = _interopRequireDefault(require_debug());
      var _forEach = _interopRequireDefault(require_forEach());
      var _find = _interopRequireDefault(require_find());
      var _rendering = require_rendering();
      var _addToCartStore = require_addToCartStore();
      var _PillGroup = require_PillGroup();
      var _siteBundles = require_siteBundles();
      var {
        fetchFromStore,
        updateStore,
        addStoreWatcher
      } = (0, _addToCartStore.createNewStore)();
      var getInstanceId = (form) => {
        const instanceId = form.getAttribute(_constants.DATA_ATTR_COMMERCE_PRODUCT_ID);
        if (instanceId) {
          return instanceId;
        } else {
          throw new Error("Incorrect form instance provided, has no instance ID");
        }
      };
      function trackAddToCartUsage(skuId, count, itemPrice) {
        const {
          decimalValue,
          unit
        } = itemPrice;
        if (typeof fbq === "function") {
          fbq("track", "AddToCart", {
            value: count * decimalValue,
            currency: unit,
            content_ids: [skuId],
            content_type: "product",
            contents: [{
              id: skuId,
              quantity: count,
              item_price: decimalValue
            }]
          });
        }
        if (typeof gtag === "function") {
          gtag("event", "add_to_cart", {
            items: [{
              id: skuId,
              quantity: count,
              price: decimalValue
            }]
          });
        }
      }
      var addToCartMutation = (0, _graphqlTag.default)`
  mutation AddToCart($skuId: String!, $count: Int!, $buyNow: Boolean) {
    ecommerceAddToCart(sku: $skuId, count: $count, buyNow: $buyNow) {
      ok
      itemId
      itemCount
      itemPrice {
        unit
        decimalValue
      }
    }
  }
`;
      var collectionsQuery = `
      collections {
        c_sku_ {
          items(filter: {f_product_: {eq: $productId}}) {
            id
            f_price_ {
              value
              unit
            }
            f_weight_
            f_width_
            f_length_
            f_height_
            f_sku_
            f_main_image_4dr {
              url
            }
            f_more_images_4dr {
              url
              alt
              file {
                origFileName
              }
            }
            f_sku_values_3dr {
              value {
                id
              }
              property {
                id
              }
            }
            inventory {
              type
              quantity
            }
            f_compare_at_price_7dr10dr {
              unit
              value
            }
            f_ec_sku_billing_method_2dr6dr14dr
          }
        }
        c_product_ {
          items(filter: {id: {eq: $productId}}) {
            f_default_sku_7dr {
              id
            }
            f_ec_product_type_2dr10dr {
              name
            }
          }
        }
      }`;
      var getAllVariants = (0, _graphqlTag.default)`
  query FetchAllVariants($productId: BasicId!) {
    database {
      id
      ${collectionsQuery}
    }
  }
`;
      var getAllVariantsAndMemberships = (0, _graphqlTag.default)`
  query FetchAllVariantsAndMemberships($productId: BasicId!) {
    database {
      id
      ${collectionsQuery}
      commerceMemberships(productIds: [$productId]) {
        productId
        orderId
        active
      }
    }
  }
`;
      var findCollectionItemWrapper = (node) => {
        const dynamoItemSelector = `.${_constants4.CLASS_NAME_DYNAMIC_LIST_ITEM}:not(.${_constants4.CLASS_NAME_DYNAMIC_LIST_REPEATER_ITEM})`;
        return $(node).closest(dynamoItemSelector)[0] || document.body;
      };
      var addToCartFormEventTargetMatcher = (event) => {
        if (event != null && event.target instanceof HTMLElement && event.target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM) {
          return event.target;
        }
        return false;
      };
      var getErrorType = (error) => {
        const defaultErrorType = "general";
        if (error && error.graphQLErrors && error.graphQLErrors.length > 0) {
          switch (error.graphQLErrors[0].code) {
            case "OutOfInventory":
              return "quantity";
            case "MixedCartError":
              return "mixed-cart";
            default:
              return defaultErrorType;
          }
        }
        return defaultErrorType;
      };
      var handleAtcSubmit = (event, apolloClient) => {
        event.preventDefault();
        const eventTarget = event.currentTarget;
        if (!(eventTarget instanceof HTMLFormElement && eventTarget.parentNode instanceof Element) || eventTarget.hasAttribute(_constants.ADD_TO_CART_LOADING)) {
          return;
        }
        const {
          parentNode
        } = eventTarget;
        const inputButton = eventTarget.querySelector('input[type="submit"]');
        if (!(0, _commerceUtils.isProtocolHttps)()) {
          window.alert("This site is currently unsecured so you cannot add products to your cart.");
          return;
        }
        if (!(inputButton instanceof HTMLInputElement)) {
          return;
        }
        const errorElement = parentNode.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR}"]`);
        if (errorElement instanceof Element) {
          errorElement.style.display = "none";
        }
        eventTarget.setAttribute(_constants.ADD_TO_CART_LOADING, "");
        const previousButtonValue = inputButton.value;
        const loadingTextFromButton = inputButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
        inputButton.value = loadingTextFromButton ? loadingTextFromButton : eventTarget.getAttribute(_constants.DATA_ATTR_LOADING_TEXT) || "";
        inputButton.setAttribute("aria-busy", "true");
        const skuId = fetchFromStore(getInstanceId(eventTarget), "selectedSku") || "";
        const formData = (0, _commerceUtils.formToObject)(eventTarget);
        const formCount = formData[_constants.NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT];
        const count = formCount ? parseInt(formCount, 10) : 1;
        if (!skuId && errorElement instanceof Element) {
          eventTarget.removeAttribute(_constants.ADD_TO_CART_LOADING);
          inputButton.value = previousButtonValue;
          inputButton.setAttribute("aria-busy", "false");
          const errorMsg = errorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
          if (!errorMsg) {
            return;
          }
          const errorText = errorMsg.getAttribute((0, _constants.getATCErrorMessageForType)("select-all-options")) || "Please select an option in each set.";
          errorMsg.textContent = errorText;
          errorElement.style.removeProperty("display");
          return;
        }
        const requiresUserSession = fetchFromStore(getInstanceId(eventTarget), "requiresUserSession");
        const hasUserSession = document.cookie.split(";").some((cookie) => cookie.indexOf(_constants2.LOGGEDIN_COOKIE_NAME) > -1);
        if (requiresUserSession && !hasUserSession) {
          (0, _siteBundles.redirectWithUsrdir)(`/${_constants2.USYS_PAGE_SETTINGS.signup.slug}`);
          return;
        }
        apolloClient.mutate({
          mutation: addToCartMutation,
          variables: {
            skuId,
            count,
            buyNow: false
          }
        }).then(({
          data
        }) => {
          (0, _commerceUtils.addLoadingCallback)(() => {
            eventTarget.removeAttribute(_constants.ADD_TO_CART_LOADING);
            inputButton.value = previousButtonValue;
            inputButton.setAttribute("aria-busy", "false");
            const cartElements = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_CART_WRAPPER}"][${_constants.DATA_ATTR_OPEN_PRODUCT}]`);
            cartElements.forEach((cart) => {
              const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
                bubbles: true,
                detail: {
                  open: true
                }
              });
              cart.dispatchEvent(evt);
            });
          });
          (0, _commerceUtils.triggerRender)(null);
          const itemPrice = data.ecommerceAddToCart.itemPrice || {};
          trackAddToCartUsage(skuId, count, itemPrice);
        }).catch((error) => {
          eventTarget.removeAttribute(_constants.ADD_TO_CART_LOADING);
          inputButton.value = previousButtonValue;
          inputButton.setAttribute("aria-busy", "false");
          if (errorElement) {
            errorElement.style.removeProperty("display");
            const errorMsg = errorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
            if (!errorMsg) {
              return;
            }
            const errorMessage = (0, _constants.getATCErrorMessageForType)(getErrorType(error));
            const errorText = errorMsg.getAttribute(errorMessage) || "";
            errorMsg.textContent = errorText;
          }
          _debug.default.error(error);
          (0, _commerceUtils.triggerRender)(null);
        });
      };
      var addToCartOptionSelectEventTargetMatcher = (event) => {
        if (event != null && event.target instanceof HTMLElement && event.target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT) {
          return event.target;
        }
        return false;
      };
      var queryAllWithoutOtherItemWrapperContents = (collectionItemWrapper, selector) => {
        return Array.from(collectionItemWrapper.querySelectorAll(selector)).filter((node) => findCollectionItemWrapper(node) === collectionItemWrapper);
      };
      var queryAllReferenceRepeaters = (collectionItemWrapper) => {
        return Array.from(collectionItemWrapper.querySelectorAll(`.${_constants4.CLASS_NAME_DYNAMIC_LIST_REPEATER_REF}`));
      };
      var removeClass = (element, className) => {
        element && // eslint-disable-next-line no-undef
        element.classList instanceof DOMTokenList && element.classList.remove(className);
        if (element.classList.length === 0) {
          element.removeAttribute("class");
        }
      };
      var showElement = (element) => removeClass(element, "w-dyn-hide");
      var hideElement = (element) => element && // eslint-disable-next-line no-undef
      element.classList instanceof DOMTokenList && element.classList.add("w-dyn-hide");
      var updateEmptyStateVisibility = (node, fn1, fn2) => {
        const emptyStateNodes = Array.from(node.querySelectorAll(".w-dyn-empty"));
        const emptyStateMoreImageFieldNodes = emptyStateNodes.filter((n) => {
          const itemsList = n.parentElement.querySelector(".w-dyn-items");
          return itemsList.dataset && itemsList.dataset.wfCollection && itemsList.dataset.wfCollection === "f_more_images_4dr";
        });
        return emptyStateMoreImageFieldNodes && emptyStateMoreImageFieldNodes.map((n) => {
          fn1(n);
          const itemsList = n.parentElement.querySelector(".w-dyn-items");
          if (itemsList && itemsList.dataset && itemsList.dataset.wfCollection && itemsList.dataset.wfCollection === "f_more_images_4dr" && // eslint-disable-next-line no-undef
          itemsList.classList instanceof DOMTokenList && itemsList.parentElement.classList.contains(_constants4.CLASS_NAME_DYNAMIC_LIST_REPEATER_REF)) {
            return fn2(itemsList);
          }
        });
      };
      var showEmptyStateAndHideItemsList = (node) => {
        updateEmptyStateVisibility(node, showElement, hideElement);
      };
      var hideEmptyStateAndShowItemsList = (node) => {
        updateEmptyStateVisibility(node, hideElement, showElement);
      };
      var updateDropdownsOnPage = (instanceId) => (newSkuValues) => {
        const dropdownsForProduct = Array.from(document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST}"][${_constants.DATA_ATTR_COMMERCE_PRODUCT_ID}="${instanceId}"] [${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT}"]`));
        for (const optionSetId of Object.keys(newSkuValues)) {
          const optionSetValue = newSkuValues[optionSetId];
          const matchingDropdownsForOptionSet = dropdownsForProduct.filter((d) => d.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) === optionSetId);
          for (const dropdown of matchingDropdownsForOptionSet) {
            dropdown.value = String(optionSetValue);
          }
        }
      };
      var disableOptionsOnChange = ({
        apolloClient,
        productId,
        optionSets,
        optionSetId
      }) => {
        apolloClient.query({
          query: getAllVariants,
          variables: {
            productId
          }
        }).then(({
          data
        }) => {
          var _data$database$collec, _data$database, _data$database$collec2, _data$database$collec3;
          const items = (_data$database$collec = data === null || data === void 0 ? void 0 : (_data$database = data.database) === null || _data$database === void 0 ? void 0 : (_data$database$collec2 = _data$database.collections) === null || _data$database$collec2 === void 0 ? void 0 : (_data$database$collec3 = _data$database$collec2.c_sku_) === null || _data$database$collec3 === void 0 ? void 0 : _data$database$collec3.items) !== null && _data$database$collec !== void 0 ? _data$database$collec : [];
          const optionSetData = optionSets.reduce((parsedSelectorOptionSets, selectorOptionSet) => {
            if (selectorOptionSet.value) {
              parsedSelectorOptionSets.selectedOptionSets.push(selectorOptionSet);
              if (selectorOptionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) === optionSetId) {
                parsedSelectorOptionSets.recentlySelectedOptionSet = selectorOptionSet;
              } else {
                parsedSelectorOptionSets.previouslySelectedOptionSets.push(selectorOptionSet);
              }
            } else {
              parsedSelectorOptionSets.unselectedOptionSets.push(selectorOptionSet);
            }
            return parsedSelectorOptionSets;
          }, {
            selectedOptionSets: [],
            recentlySelectedOptionSet: void 0,
            previouslySelectedOptionSets: [],
            unselectedOptionSets: []
          });
          let {
            selectedOptionSets,
            unselectedOptionSets
          } = optionSetData;
          const {
            recentlySelectedOptionSet,
            previouslySelectedOptionSets
          } = optionSetData;
          if (recentlySelectedOptionSet && selectedOptionSets.length > 1) {
            const recentlySelectedOptionSetValue = recentlySelectedOptionSet.value;
            (0, _forEach.default)(previouslySelectedOptionSets, (previouslySelectedOptionSet) => {
              const optionSetValueCombinationWithMostRecent = [recentlySelectedOptionSetValue, previouslySelectedOptionSet.value];
              const someAvailableItem = items.some((item) => {
                if (item.inventory.type === _constants.INVENTORY_TYPE_FINITE && item.inventory.quantity <= 0) {
                  return false;
                }
                const itemMappedBySkuValues = item.f_sku_values_3dr.map((skuValues) => skuValues.value.id);
                return optionSetValueCombinationWithMostRecent.every((value) => itemMappedBySkuValues.includes(value));
              });
              if (!someAvailableItem) {
                previouslySelectedOptionSet.selectedIndex = 0;
                selectedOptionSets = selectedOptionSets.filter((selectedOptionSet) => selectedOptionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID) !== previouslySelectedOptionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID));
                unselectedOptionSets = unselectedOptionSets.concat(previouslySelectedOptionSet);
              }
            });
          }
          (0, _forEach.default)(selectedOptionSets, (optionSet) => {
            const id = optionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
            (0, _forEach.default)(optionSet.options, (option) => {
              if (!option.value) {
                option.enabled = true;
              } else {
                disableVariantsWithNoStock(items, id, option);
              }
            });
          });
          (0, _forEach.default)(unselectedOptionSets, (optionSet) => {
            const id = optionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
            disableVariantsWithNoStockForRemainingSelections(items, selectedOptionSets, optionSet, id);
          });
        });
      };
      var handleAtcOptionSelectChange = (event, apolloClient) => {
        const eventTarget = event.currentTarget;
        if (!(eventTarget instanceof HTMLSelectElement)) {
          return;
        }
        const $2 = window.jQuery;
        const optionSetId = eventTarget.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
        const optionSetValue = eventTarget.value;
        const optionListElement = $2(eventTarget).closest(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST}"]`)[0];
        const addToCartForm = $2(eventTarget).closest(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM}"]`)[0];
        if (!(optionListElement instanceof Element) || !optionSetId || !(addToCartForm instanceof HTMLFormElement)) {
          return;
        }
        const instanceId = getInstanceId(addToCartForm);
        const currentSkuValues = fetchFromStore(instanceId, "skuValues");
        const newSkuValues = (0, _extends2.default)({}, currentSkuValues, {
          [optionSetId]: optionSetValue
        });
        updateStore(instanceId, {
          skuValues: newSkuValues
        });
        const productId = optionListElement && optionListElement.getAttribute(_constants.DATA_ATTR_COMMERCE_PRODUCT_ID);
        const allVariantSelectorsInCartForm = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_SELECT, addToCartForm);
        if (productId && allVariantSelectorsInCartForm.length > 0) {
          disableOptionsOnChange({
            apolloClient,
            productId,
            optionSets: allVariantSelectorsInCartForm,
            optionSetId
          });
        }
      };
      var updateSkuBindings = (binding, node, newSkuItem) => {
        if (["f_weight_", "f_width_", "f_length_", "f_height_", "f_sku_"].some((slug) => binding.from === slug)) {
          node[binding.to === "innerHTML" ? "innerText" : binding.to] = newSkuItem[binding.from] || "";
          updateTextNodeVisibility(node);
        }
        if (binding.from === "f_price_" && newSkuItem.f_price_) {
          node[binding.to === "innerHTML" ? "innerText" : binding.to] = (0, _CurrencyUtils.renderPriceFromSettings)(newSkuItem.f_price_, window.__WEBFLOW_CURRENCY_SETTINGS);
          updateTextNodeVisibility(node);
        }
        if (binding.from === "f_compare_at_price_7dr10dr") {
          if (newSkuItem.f_compare_at_price_7dr10dr) {
            node[binding.to === "innerHTML" ? "innerText" : binding.to] = (0, _CurrencyUtils.renderPriceFromSettings)(newSkuItem.f_compare_at_price_7dr10dr, window.__WEBFLOW_CURRENCY_SETTINGS);
          } else {
            node[binding.to === "innerHTML" ? "innerText" : binding.to] = "";
          }
          updateTextNodeVisibility(node);
        }
        if (binding.from === "f_main_image_4dr" || binding.from === "f_main_image_4dr.url") {
          const mainImage = (0, _get.default)(newSkuItem, binding.from.replace(/\.url$/, ""));
          if (binding.to === "style.background-image") {
            node.style.backgroundImage = mainImage && mainImage.url ? `url("${mainImage.url}")` : "none";
          } else if (binding.to === "media") {
            if (node.classList.contains("w-lightbox")) {
              updateLightboxJson(node, mainImage);
            }
          } else if (binding.to === "src") {
            if (mainImage && mainImage.url) {
              node.src = mainImage.url;
              (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
              if (node.hasAttribute("srcset")) {
                node.removeAttribute("srcset");
              }
            } else {
              node.removeAttribute("src");
              node.classList.add(_constants3.CLASS_NAME_W_DYN_BIND_EMPTY);
            }
          }
        }
        if (binding.from.startsWith("f_more_images_4dr.")) {
          const image = (0, _get.default)(newSkuItem, binding.from.replace(/\.url$/, ""));
          if (binding.to === "style.background-image") {
            node.style.backgroundImage = image ? `url("${image.url}")` : "none";
          } else if (binding.to === "media") {
            if (node.classList.contains("w-lightbox")) {
              updateLightboxJson(node, image);
            }
          } else if (binding.to === "src") {
            if (image && image.url) {
              node.src = image.url;
              node.alt = image.alt || "";
              (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
              if (node.hasAttribute("srcset")) {
                node.removeAttribute("srcset");
                node.removeAttribute("sizes");
              }
            } else {
              node.removeAttribute("src");
              node.removeAttribute("srcset");
              node.removeAttribute("sizes");
              node.removeAttribute("alt");
              node.classList.add(_constants3.CLASS_NAME_W_DYN_BIND_EMPTY);
            }
          }
        }
        if (binding.from === "ecSkuInventoryQuantity") {
          const inventoryQuantity = (0, _get.default)(newSkuItem, "inventory.type") === "infinite" ? null : (0, _get.default)(newSkuItem, "inventory.quantity");
          node[binding.to === "innerHTML" ? "innerText" : binding.to] = inventoryQuantity;
          updateTextNodeVisibility(node);
        }
      };
      var updatePageWithNewSkuValuesData = (instanceId, apolloClient) => (newSkuValues) => {
        const $2 = window.jQuery;
        apolloClient.query({
          query: getAllVariants,
          variables: {
            productId: instanceId
          }
        }).then(({
          data
        }) => {
          var _data$database$collec4, _data$database2, _data$database2$colle, _data$database2$colle2, _data$database$collec5, _data$database3, _data$database3$colle, _data$database3$colle2;
          const items = (_data$database$collec4 = data === null || data === void 0 ? void 0 : (_data$database2 = data.database) === null || _data$database2 === void 0 ? void 0 : (_data$database2$colle = _data$database2.collections) === null || _data$database2$colle === void 0 ? void 0 : (_data$database2$colle2 = _data$database2$colle.c_sku_) === null || _data$database2$colle2 === void 0 ? void 0 : _data$database2$colle2.items) !== null && _data$database$collec4 !== void 0 ? _data$database$collec4 : [];
          const products = (_data$database$collec5 = data === null || data === void 0 ? void 0 : (_data$database3 = data.database) === null || _data$database3 === void 0 ? void 0 : (_data$database3$colle = _data$database3.collections) === null || _data$database3$colle === void 0 ? void 0 : (_data$database3$colle2 = _data$database3$colle.c_product_) === null || _data$database3$colle2 === void 0 ? void 0 : _data$database3$colle2.items) !== null && _data$database$collec5 !== void 0 ? _data$database$collec5 : [];
          const productType = products[0] ? products[0].f_ec_product_type_2dr10dr.name : "Advanced";
          const newSkuItem = (0, _find.default)(items, (item) => {
            if (item.f_sku_values_3dr && Array.isArray(item.f_sku_values_3dr)) {
              const skuValues = (0, _site.simplifySkuValues)(item.f_sku_values_3dr);
              return Object.keys(newSkuValues).every((key) => newSkuValues[key] === skuValues[key]);
            }
          });
          if (newSkuItem && newSkuItem.id) {
            updateStore(instanceId, {
              selectedSku: newSkuItem.id
            });
            if (newSkuItem["f_ec_sku_billing_method_2dr6dr14dr"] === "subscription" || productType === "Membership") {
              updateStore(instanceId, {
                requiresUserSession: true
              });
            }
            const formsForProduct = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM}"][${_constants.DATA_ATTR_COMMERCE_PRODUCT_ID}="${instanceId}"]`);
            Array.from(formsForProduct).forEach((addToCartForm) => {
              const collectionItemWrapper = findCollectionItemWrapper(addToCartForm);
              const referenceRepeaters = queryAllReferenceRepeaters(collectionItemWrapper);
              const buyNowButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON, addToCartForm);
              if (buyNowButton) {
                if (newSkuItem["f_ec_sku_billing_method_2dr6dr14dr"] === "subscription") {
                  const addToCartButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON, addToCartForm);
                  const buyNowSubscriptionText = buyNowButton.getAttribute(_constants.DATA_ATTR_SUBSCRIPTION_TEXT) || "Subscribe now";
                  hideElement(addToCartButton);
                  buyNowButton.innerText = buyNowSubscriptionText;
                } else {
                  const buyNowDefaultText = buyNowButton.getAttribute(_constants.DATA_ATTR_DEFAULT_TEXT) || "Buy now";
                  buyNowButton.innerText = buyNowDefaultText;
                }
              }
              const moreImagesFieldLength = newSkuItem.f_more_images_4dr && newSkuItem.f_more_images_4dr.length || 0;
              if (referenceRepeaters.length > 0) {
                referenceRepeaters.forEach((referenceRepeater) => {
                  (0, _rendering.renderTree)(referenceRepeater, {
                    data: newSkuItem
                  });
                  if (moreImagesFieldLength > 0) {
                    hideEmptyStateAndShowItemsList(referenceRepeater);
                  } else {
                    showEmptyStateAndHideItemsList(referenceRepeater);
                  }
                });
              }
              const skuBoundNodes = queryAllWithoutOtherItemWrapperContents(collectionItemWrapper, `[${_constants.WF_SKU_BINDING_DATA_KEY}]`);
              (0, _forEach.default)(skuBoundNodes, (node) => {
                const skuBindingsData = node.getAttribute(_constants.WF_SKU_BINDING_DATA_KEY);
                if (skuBindingsData) {
                  const skuBindings = (0, _commerceUtils.safeParseJson)(skuBindingsData);
                  if (Array.isArray(skuBindings)) {
                    skuBindings.forEach((binding) => updateSkuBindings(binding, node, newSkuItem));
                  }
                }
              });
              const skuConditionBoundNodes = queryAllWithoutOtherItemWrapperContents(collectionItemWrapper, `[${_constants.WF_SKU_CONDITION_DATA_KEY}]`);
              (0, _forEach.default)(skuConditionBoundNodes, (node) => {
                const conditionData = (0, _commerceUtils.safeParseJson)(node.getAttribute(_constants.WF_SKU_CONDITION_DATA_KEY));
                if (conditionData) {
                  (0, _rendering.applySkuBoundConditionalVisibility)({
                    conditionData,
                    newSkuItem,
                    node
                  });
                }
              });
              const errorElement = $2(collectionItemWrapper).siblings(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR}"]`)[0];
              if (errorElement instanceof Element) {
                errorElement.style.display = "none";
              }
            });
            if (window.Webflow.require("lightbox")) {
              window.Webflow.require("lightbox").ready();
            }
          } else {
            updateStore(instanceId, {
              selectedSku: ""
            });
          }
        });
      };
      var updateSkuValuesOnPillSelect = (instanceId, apolloClient) => ({
        optionId,
        optionSetId,
        groups
      }) => {
        const currentSkuValues = fetchFromStore(instanceId, "skuValues");
        const newSkuValues = (0, _extends2.default)({}, currentSkuValues, {
          [optionSetId]: optionId
        });
        updateStore(instanceId, {
          skuValues: newSkuValues
        });
        disableOptionsOnChange({
          apolloClient,
          productId: instanceId,
          optionSets: Object.values(groups),
          optionSetId
        });
      };
      var handleAtcPageLoad = (event, apolloClient, stripeStore) => {
        if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
          return;
        }
        const addToCartForms = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM}"]`);
        if (window.Webflow.env("preview")) {
          if (event.detail.isInitial) {
            (0, _forEach.default)(addToCartForms, (addToCartForm) => {
              const groups = new _PillGroup.PillGroups(addToCartForm, ({
                optionId,
                optionSetId
              }) => {
                groups.setSelectedPillsForSkuValues({
                  [optionSetId]: optionId
                });
              });
              groups.init();
            });
          }
          return;
        }
        if (window.Webflow.env("design")) {
          return;
        }
        (0, _forEach.default)(addToCartForms, (addToCartForm) => {
          const addToCartButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_BUTTON, addToCartForm);
          if (addToCartButton) {
            const cartElementsThatOpenOnAdd = document.querySelectorAll(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_COMMERCE_CART_WRAPPER}"][${_constants.DATA_ATTR_OPEN_PRODUCT}]`);
            addToCartButton.setAttribute("aria-haspopup", cartElementsThatOpenOnAdd.length > 0 ? "dialog" : "false");
          }
          const buyNowButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON, addToCartForm);
          if (stripeStore && !stripeStore.isInitialized()) {
            if (buyNowButton) {
              hideElement(buyNowButton);
            }
          }
          const instanceId = getInstanceId(addToCartForm);
          if (event.detail.isInitial) {
            updateStore(instanceId, {
              selectedSku: addToCartForm instanceof Element ? addToCartForm.getAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID) : ""
            });
            addStoreWatcher(instanceId, "skuValues", updatePageWithNewSkuValuesData(instanceId, apolloClient));
            addStoreWatcher(instanceId, "skuValues", updateDropdownsOnPage(instanceId));
            if (_PillGroup.PillGroups.hasPillGroups(addToCartForm)) {
              const pillGroup = new _PillGroup.PillGroups(addToCartForm, updateSkuValuesOnPillSelect(instanceId, apolloClient));
              addStoreWatcher(instanceId, "skuValues", (newSkuValues) => {
                pillGroup.setSelectedPillsForSkuValues(newSkuValues);
              });
              pillGroup.init();
            }
          }
          const currentSkuId = fetchFromStore(instanceId, "selectedSku");
          if (!currentSkuId) {
            return;
          }
          const productId = addToCartForm && addToCartForm.getAttribute(_constants.DATA_ATTR_COMMERCE_PRODUCT_ID);
          if (productId) {
            apolloClient.query({
              query: getAllVariantsAndMemberships,
              variables: {
                productId
              }
            }).then(({
              data
            }) => {
              var _data$database$collec6, _data$database4, _data$database4$colle, _data$database4$colle2, _data$database$collec7, _data$database5, _data$database5$colle, _data$database5$colle2, _data$database$commer, _data$database6, _memberships$;
              const items = (_data$database$collec6 = data === null || data === void 0 ? void 0 : (_data$database4 = data.database) === null || _data$database4 === void 0 ? void 0 : (_data$database4$colle = _data$database4.collections) === null || _data$database4$colle === void 0 ? void 0 : (_data$database4$colle2 = _data$database4$colle.c_sku_) === null || _data$database4$colle2 === void 0 ? void 0 : _data$database4$colle2.items) !== null && _data$database$collec6 !== void 0 ? _data$database$collec6 : [];
              const products = (_data$database$collec7 = data === null || data === void 0 ? void 0 : (_data$database5 = data.database) === null || _data$database5 === void 0 ? void 0 : (_data$database5$colle = _data$database5.collections) === null || _data$database5$colle === void 0 ? void 0 : (_data$database5$colle2 = _data$database5$colle.c_product_) === null || _data$database5$colle2 === void 0 ? void 0 : _data$database5$colle2.items) !== null && _data$database$collec7 !== void 0 ? _data$database$collec7 : [];
              const productType = products[0] ? products[0].f_ec_product_type_2dr10dr.name : "Advanced";
              if (event.detail.isInitial && items[0].f_sku_values_3dr && items[0].f_sku_values_3dr.length > 0) {
                const skuValuesMap = items[0].f_sku_values_3dr.reduce((map2, sku) => {
                  map2[sku.property.id] = "";
                  return map2;
                }, {});
                updateStore(instanceId, {
                  skuValues: skuValuesMap
                });
              }
              const memberships = (_data$database$commer = data === null || data === void 0 ? void 0 : (_data$database6 = data.database) === null || _data$database6 === void 0 ? void 0 : _data$database6.commerceMemberships) !== null && _data$database$commer !== void 0 ? _data$database$commer : [];
              const hasActiveMemebership = Boolean((_memberships$ = memberships[0]) === null || _memberships$ === void 0 ? void 0 : _memberships$.active);
              if (hasActiveMemebership) {
                if (buyNowButton) {
                  buyNowButton.removeAttribute("href");
                  buyNowButton.setAttribute("role", "link");
                  buyNowButton.setAttribute("aria-disabled", "true");
                  buyNowButton.classList.add("w--ecommerce-buy-now-disabled");
                }
                if (addToCartButton) {
                  addToCartButton.setAttribute("disabled", "true");
                  addToCartButton.classList.add("w--ecommerce-add-to-cart-disabled");
                }
              }
              const currentSku = items.find((item) => item.id === currentSkuId);
              if (currentSku) {
                if (currentSku["f_ec_sku_billing_method_2dr6dr14dr"] === "subscription" || productType === "Membership") {
                  updateStore(instanceId, {
                    requiresUserSession: true
                  });
                }
                if (currentSku["f_ec_sku_billing_method_2dr6dr14dr"] === "subscription") {
                  hideElement(addToCartButton);
                  if (buyNowButton) {
                    const buyNowSubscriptionText = buyNowButton.getAttribute(_constants.DATA_ATTR_SUBSCRIPTION_TEXT) || "Subscribe now";
                    buyNowButton.innerText = buyNowSubscriptionText;
                  }
                } else if (buyNowButton) {
                  const buyNowDefaultText = buyNowButton.getAttribute(_constants.DATA_ATTR_DEFAULT_TEXT) || "Buy now";
                  buyNowButton.innerText = buyNowDefaultText;
                }
                const addToCartWrapper = addToCartForm.parentElement;
                const optionListElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_OPTION_LIST, addToCartWrapper);
                const outOfStockState = addToCartWrapper && addToCartWrapper.getElementsByClassName("w-commerce-commerceaddtocartoutofstock")[0];
                const hasVariantsWithStock = items.some((variant) => variant.inventory.type === _constants.INVENTORY_TYPE_FINITE && variant.inventory.quantity > 0 || variant.inventory.type === _constants.INVENTORY_TYPE_INFINITE);
                if (!hasVariantsWithStock && outOfStockState) {
                  outOfStockState.style.display = "";
                  addToCartForm.style.display = "none";
                }
                const optionSetsToUpdate = items[0].f_sku_values_3dr.map((skuValue) => skuValue.property.id);
                optionSetsToUpdate.forEach((optionToUpdateSetId) => {
                  let optionSet = addToCartForm.querySelector(`[${_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID}="${optionToUpdateSetId}"]`);
                  if (!(optionSet instanceof HTMLElement)) {
                    return;
                  }
                  const optionSetId = optionSet.getAttribute(_constants.DATA_ATTR_COMMERCE_OPTION_SET_ID);
                  if (optionSet.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_ADD_TO_CART_PILL_GROUP) {
                    optionSet = optionSet._wfPillGroup;
                  }
                  (0, _forEach.default)(optionSet.options, (option) => {
                    if (!option.value) {
                      option.enabled = true;
                    } else {
                      disableVariantsWithNoStock(items, optionSetId, option);
                    }
                  });
                  const selectedOptionSets = optionSetsToUpdate.filter((optionSetToUpdate) => optionSetToUpdate.value);
                  disableVariantsWithNoStockForRemainingSelections(items, selectedOptionSets, optionSet, optionSetId);
                  if (event.detail.isInitial && optionListElement && optionListElement.getAttribute(_constants.DATA_ATTR_PRESELECT_DEFAULT_VARIANT) === "true") {
                    const defaultSkuId = (0, _get.default)(data, ["database", "collections", "c_product_", "items", 0, "f_default_sku_7dr", "id"]);
                    const defaultSku = items.find((item) => item.id === defaultSkuId);
                    if (defaultSku && !(defaultSku.inventory.type === _constants.INVENTORY_TYPE_FINITE && defaultSku.inventory.quantity <= 0)) {
                      const defaultSkuIndex = Array.from(optionSet.options).findIndex((option) => defaultSku.f_sku_values_3dr.some((value) => value.value.id === option.value));
                      if (defaultSkuIndex > -1) {
                        optionSet.selectedIndex = defaultSkuIndex;
                        updateStore(instanceId, {
                          selectedSku: defaultSku.id,
                          // update the sku values map to set each property id to the value id
                          // for the current variant
                          skuValues: (0, _site.simplifySkuValues)(defaultSku.f_sku_values_3dr)
                        });
                      }
                    }
                  }
                });
              }
            });
          }
        });
      };
      var disableVariantsWithNoStockForRemainingSelections = (items, selectedOptionSets, optionSet, id) => {
        let possibleVariantSelections = items.filter((item) => {
          const itemMappedBySkuValues = item.f_sku_values_3dr.map((skuValues) => skuValues.value.id);
          const currentlySelectedSkuValues = selectedOptionSets.map((selectedOptionSet) => selectedOptionSet.value);
          return currentlySelectedSkuValues.every((selectedValue) => itemMappedBySkuValues.includes(selectedValue));
        });
        if (possibleVariantSelections.length === 1) {
          possibleVariantSelections = items;
        }
        (0, _forEach.default)(optionSet.options, (option) => {
          if (!option.value) {
            option.enabled = true;
          } else {
            const variantsFiltered = possibleVariantSelections.filter((variant) => {
              const sku = variant.f_sku_values_3dr.find((value) => value.property.id === id);
              return sku.value.id === option.value;
            });
            const hasVariantsWithStock = variantsFiltered.some((variant) => variant.inventory.type === _constants.INVENTORY_TYPE_FINITE && variant.inventory.quantity > 0 || variant.inventory.type === _constants.INVENTORY_TYPE_INFINITE);
            if (!hasVariantsWithStock) {
              option.disabled = true;
            } else {
              option.disabled = false;
            }
          }
        });
      };
      var disableVariantsWithNoStock = (items, optionSetId, option) => {
        if (!option.value) {
          return;
        }
        const variantsFiltered = items.filter((variant) => {
          const sku = variant.f_sku_values_3dr.find((value) => value.property.id === optionSetId);
          return sku.value.id === option.value;
        });
        const hasVariantsWithStock = variantsFiltered.some((variant) => variant.inventory.type === _constants.INVENTORY_TYPE_FINITE && variant.inventory.quantity > 0 || variant.inventory.type === _constants.INVENTORY_TYPE_INFINITE);
        if (!hasVariantsWithStock) {
          option.disabled = true;
        } else {
          option.disabled = false;
        }
      };
      var updateTextNodeVisibility = (node) => {
        if (node.innerText) {
          (0, _RenderingUtils.removeWDynBindEmptyClass)(node);
        }
        if (!node.innerText && !node.classList.contains(_constants3.CLASS_NAME_W_DYN_BIND_EMPTY)) {
          node.classList.add(_constants3.CLASS_NAME_W_DYN_BIND_EMPTY);
        }
      };
      var updateLightboxJson = (node, binding) => {
        const lightboxScript = node.querySelector("script.w-json");
        if (lightboxScript) {
          const nodeJsonData = JSON.parse(lightboxScript.innerHTML);
          lightboxScript.innerHTML = JSON.stringify((0, _utils.createJsonFromBoundMedia)(binding, nodeJsonData) || {
            items: [],
            group: nodeJsonData && nodeJsonData.group
          });
        }
      };
      var isBuyNowButtonEvent = ({
        target
      }) => target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_BUY_NOW_BUTTON;
      var handleBuyNow = (event, apolloClient) => {
        event.preventDefault();
        if (window.Webflow.env("preview")) {
          return;
        }
        const buyNowButton = event.target;
        const addToCartForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_FORM, buyNowButton);
        if (!(buyNowButton instanceof HTMLAnchorElement) || !(addToCartForm instanceof HTMLFormElement)) {
          return;
        }
        if (buyNowButton.classList.contains("w--ecommerce-buy-now-disabled")) {
          return;
        }
        const addToCartWrapper = addToCartForm.parentElement;
        if (!(addToCartWrapper instanceof Element)) {
          return;
        }
        const addToCartErrorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR, addToCartWrapper);
        if (!(addToCartErrorElement instanceof Element)) {
          return;
        }
        addToCartErrorElement.style.display = "none";
        if (!(0, _commerceUtils.isProtocolHttps)()) {
          window.alert("This site is currently unsecured so you cannot purchase this item.");
          return;
        }
        if (!addToCartForm.reportValidity()) {
          return;
        }
        const requiresUserSession = fetchFromStore(getInstanceId(addToCartForm), "requiresUserSession");
        const hasUserSession = document.cookie.split(";").some((cookie) => cookie.indexOf(_constants2.LOGGEDIN_COOKIE_NAME) > -1);
        if (requiresUserSession && !hasUserSession) {
          (0, _siteBundles.redirectWithUsrdir)(`/${_constants2.USYS_PAGE_SETTINGS.signup.slug}`);
          return;
        }
        const publishableKey = buyNowButton.getAttribute(_constants.DATA_ATTR_PUBLISHABLE_KEY);
        if (!publishableKey) {
          const errorMsg = addToCartErrorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
          if (!errorMsg) {
            return;
          }
          const errorText = errorMsg.getAttribute(_constants.CHECKOUT_DISABLED_ERROR_MESSAGE) || "Checkout is disabled.";
          errorMsg.textContent = errorText;
          addToCartErrorElement.style.removeProperty("display");
          return;
        }
        const skuId = fetchFromStore(getInstanceId(addToCartForm), "selectedSku") || "";
        const formData = (0, _commerceUtils.formToObject)(addToCartForm);
        const formCount = formData[_constants.NODE_NAME_COMMERCE_ADD_TO_CART_QUANTITY_INPUT];
        const count = formCount ? parseInt(formCount, 10) : 1;
        if (!skuId) {
          const errorMsg = addToCartErrorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
          if (!errorMsg) {
            return;
          }
          const errorText = errorMsg.getAttribute((0, _constants.getATCErrorMessageForType)("select-all-options")) || "Please select an option in each set.";
          errorMsg.textContent = errorText;
          addToCartErrorElement.style.removeProperty("display");
          return;
        }
        apolloClient.mutate({
          mutation: addToCartMutation,
          variables: {
            skuId,
            count,
            buyNow: true
          }
        }).then(({
          data
        }) => {
          const itemPrice = data.ecommerceAddToCart.itemPrice || {};
          trackAddToCartUsage(skuId, count, itemPrice);
          window.location = buyNowButton.href;
        }).catch((error) => {
          if (addToCartErrorElement) {
            addToCartErrorElement.style.removeProperty("display");
            const errorMsg = addToCartErrorElement.querySelector(`[${_constants.DATA_ATTR_NODE_TYPE}="${_constants.NODE_TYPE_ADD_TO_CART_ERROR}"]`);
            if (!errorMsg) {
              return;
            }
            const errorType = error.graphQLErrors && error.graphQLErrors.length > 0 && error.graphQLErrors[0].code === "OutOfInventory" ? "quantity" : "buy-now";
            const errorText = errorMsg.getAttribute((0, _constants.getATCErrorMessageForType)(errorType)) || "";
            errorMsg.textContent = errorText;
          }
          _debug.default.error(error);
          (0, _commerceUtils.triggerRender)(null);
        });
      };
      var register = (handlerProxy) => {
        handlerProxy.on("submit", addToCartFormEventTargetMatcher, handleAtcSubmit);
        handlerProxy.on("change", addToCartOptionSelectEventTargetMatcher, handleAtcOptionSelectChange);
        handlerProxy.on("click", isBuyNowButtonEvent, handleBuyNow);
        handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleAtcPageLoad);
      };
      exports.register = register;
      var _default = {
        register
      };
      exports.default = _default;
    }
  });

  // node_modules/lodash/mergeWith.js
  var require_mergeWith = __commonJS({
    "node_modules/lodash/mergeWith.js"(exports, module) {
      var baseMerge = require_baseMerge();
      var createAssigner = require_createAssigner();
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      module.exports = mergeWith;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/checkoutMutations.js
  var require_checkoutMutations = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/checkoutMutations.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.updateOrderStripePaymentMethodMutation = exports.updateOrderShippingMethodMutation = exports.updateOrderIdentityMutation = exports.updateOrderAddressMutation = exports.updateObfuscatedOrderAddressMutation = exports.updateCustomData = exports.syncPayPalOrderInfo = exports.requestPayPalOrderMutation = exports.recalcOrderEstimationsMutation = exports.estimateOrderTaxesMutation = exports.attemptSubmitOrderMutation = exports.applyDiscountMutation = void 0;
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var updateOrderIdentityMutation = (0, _graphqlTag.default)`
  mutation CheckoutUpdateOrderIdentity($email: String) {
    ecommerceUpdateIdentity(email: $email) {
      ok
    }
  }
`;
      exports.updateOrderIdentityMutation = updateOrderIdentityMutation;
      var updateOrderAddressMutation = (0, _graphqlTag.default)`
  mutation CheckoutUpdateOrderAddress(
    $type: String!
    $name: String
    $address_line1: String
    $address_line2: String
    $address_city: String
    $address_state: String
    $address_country: String
    $address_zip: String
  ) {
    ecommerceUpdateAddress(
      type: $type
      addressee: $name
      line1: $address_line1
      line2: $address_line2
      city: $address_city
      state: $address_state
      country: $address_country
      postalCode: $address_zip
    ) {
      ok
    }
  }
`;
      exports.updateOrderAddressMutation = updateOrderAddressMutation;
      var updateObfuscatedOrderAddressMutation = (0, _graphqlTag.default)`
  mutation CheckoutUpdateObfuscatedOrderAddress(
    $type: String!
    $name: String
    $address_line1: String
    $address_line2: String
    $address_city: String
    $address_state: String
    $address_country: String
    $address_zip: String
  ) {
    ecommerceUpdateObfuscatedAddress(
      type: $type
      addressee: $name
      line1: $address_line1
      line2: $address_line2
      city: $address_city
      state: $address_state
      country: $address_country
      postalCode: $address_zip
    ) {
      ok
    }
  }
`;
      exports.updateObfuscatedOrderAddressMutation = updateObfuscatedOrderAddressMutation;
      var updateOrderShippingMethodMutation = (0, _graphqlTag.default)`
  mutation CheckoutUpdateShippingMethod($id: String) {
    ecommerceUpdateShippingMethod(methodId: $id) {
      ok
    }
  }
`;
      exports.updateOrderShippingMethodMutation = updateOrderShippingMethodMutation;
      var updateOrderStripePaymentMethodMutation = (0, _graphqlTag.default)`
  mutation CheckoutUpdateStripePaymentMethod($paymentMethod: String!) {
    ecommerceStoreStripePaymentMethod(paymentMethod: $paymentMethod) {
      ok
    }
  }
`;
      exports.updateOrderStripePaymentMethodMutation = updateOrderStripePaymentMethodMutation;
      var updateCustomData = (0, _graphqlTag.default)`
  mutation CheckoutUpdateCustomData(
    $customData: [mutation_commerce_update_custom_data]!
  ) {
    ecommerceUpdateCustomData(customData: $customData) {
      ok
    }
  }
`;
      exports.updateCustomData = updateCustomData;
      var estimateOrderTaxesMutation = (0, _graphqlTag.default)`
  mutation CheckoutEstimateOrderTaxes {
    ecommerceEstimateTaxes {
      ok
    }
  }
`;
      exports.estimateOrderTaxesMutation = estimateOrderTaxesMutation;
      var recalcOrderEstimationsMutation = (0, _graphqlTag.default)`
  mutation CheckoutRecalcOrderEstimations {
    ecommerceRecalcEstimations {
      ok
    }
  }
`;
      exports.recalcOrderEstimationsMutation = recalcOrderEstimationsMutation;
      var requestPayPalOrderMutation = (0, _graphqlTag.default)`
  mutation CheckoutRequestPayPalOrder {
    ecommercePaypalOrderRequest {
      orderId
    }
  }
`;
      exports.requestPayPalOrderMutation = requestPayPalOrderMutation;
      var syncPayPalOrderInfo = (0, _graphqlTag.default)`
  mutation CheckoutSyncPayPalInfo {
    ecommerceSyncPaypalOrderInfoToWF {
      ok
    }
  }
`;
      exports.syncPayPalOrderInfo = syncPayPalOrderInfo;
      var attemptSubmitOrderMutation = (0, _graphqlTag.default)`
  mutation CheckoutAttemptSubmitOrder(
    $checkoutType: mutation_commerce_checkout_type
    $paymentIntentId: String
  ) {
    ecommerceAttemptSubmitOrder(
      checkoutType: $checkoutType
      paymentIntentId: $paymentIntentId
    ) {
      orderId
      token
      ok
      customerPaid {
        decimalValue
        unit
      }
      purchasedItems {
        id
        name
        count
        price {
          decimalValue
        }
      }
      status
      clientSecret
      nextAction
    }
  }
`;
      exports.attemptSubmitOrderMutation = attemptSubmitOrderMutation;
      var applyDiscountMutation = (0, _graphqlTag.default)`
  mutation CheckoutApplyDiscount($discountCode: String!) {
    ecommerceApplyDiscount(discountCode: $discountCode) {
      ok
    }
  }
`;
      exports.applyDiscountMutation = applyDiscountMutation;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/checkoutUtils.js
  var require_checkoutUtils = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/checkoutUtils.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.updateErrorMessage = exports.showErrorMessageForError = exports.renderCheckoutFormContainers = exports.redirectToOrderConfirmation = exports.orderRequiresAdditionalAction = exports.initializeStripeElements = exports.getOrderDataFromGraphQLResponse = exports.createUpdateObfuscatedOrderAddressMutation = exports.createStripePaymentMethodMutation = exports.createRecalcOrderEstimationsMutation = exports.createOrderShippingMethodMutation = exports.createOrderIdentityMutation = exports.createOrderAddressMutation = exports.createCustomDataMutation = exports.createAttemptSubmitOrderRequest = exports.beforeUnloadHandler = exports.applyDiscount = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _apolloClient = _interopRequireDefault(require_bundle_umd5());
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var _commerceUtils = require_commerceUtils();
      var _StyleMapObserver = _interopRequireDefault(require_StyleMapObserver());
      var _stripeStore = require_stripeStore();
      var _constants = require_constants2();
      var _rendering = require_rendering();
      var _webPaymentsEvents = require_webPaymentsEvents();
      var _checkoutMutations = require_checkoutMutations();
      var syncStylesToStripeElement = (stripeElement) => (appliedStyles) => {
        stripeElement.update({
          style: _StyleMapObserver.default.appliedStylesToStripeElementStyles(appliedStyles)
        });
      };
      var initializeStripeElements = (store) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview") || !store.isInitialized()) {
          return;
        }
        const checkoutFormContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
        const cartWrappers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER);
        const allStripeElements = [...checkoutFormContainers, ...cartWrappers];
        allStripeElements.forEach((element, index) => {
          store.createElementsInstance(index);
          element.setAttribute(_constants.STRIPE_ELEMENT_INSTANCE, String(index));
        });
        const stripeElements = document.querySelectorAll(`[${_constants.STRIPE_ELEMENT_TYPE}]`);
        Array.from(stripeElements).forEach((element) => {
          const type = element.getAttribute(_constants.STRIPE_ELEMENT_TYPE);
          if (!type) {
            throw new Error("Stripe element missing type string");
          }
          const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, element);
          if (!checkoutFormContainer) {
            return;
          }
          const index = parseInt(checkoutFormContainer.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
          const el = store.createElement(type, index, {
            style: (0, _commerceUtils.safeParseJson)(element.getAttribute(_constants.STRIPE_ELEMENT_STYLE) || "{}"),
            classes: {
              focus: "-wfp-focus"
            }
          });
          el.mount(element);
          const styleMapObserver = new _StyleMapObserver.default(element, {
            onChange: syncStylesToStripeElement(el)
          });
        });
      };
      exports.initializeStripeElements = initializeStripeElements;
      var errorCodeToCheckoutErrorType = (code, msg) => {
        switch (code) {
          case "OrderTotalRange":
            if (msg && msg.match(/too small/i)) {
              return "minimum";
            } else {
              return "info";
            }
          case "OrderExtrasChanged":
            return "extras";
          case "PriceChanged":
            return "pricing";
          case "StripeRejected":
            return "billing";
          case "NeedShippingAddress":
          case "InvalidShippingAddress":
          case "NeedShippingMethod":
            return "shipping";
          case "NeedPaymentMethod":
          case "StripeFailure":
            return "payment";
          case "ItemNotFound":
            return "product";
          case "InvalidDiscount":
          case "DiscountInvalid":
          case "DiscountDoesNotExist": {
            return "invalid-discount";
          }
          case "DiscountExpired": {
            return "expired-discount";
          }
          case "DiscountUsageReached": {
            return "usage-reached-discount";
          }
          case "DiscountRequirementsNotMet": {
            return "requirements-not-met";
          }
          default:
            return "info";
        }
      };
      var getErrorType = (error) => {
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          return errorCodeToCheckoutErrorType(error.graphQLErrors[0].code, error.graphQLErrors[0].message);
        }
        if (error.code) {
          return errorCodeToCheckoutErrorType(error.code, error.message);
        }
        return "info";
      };
      var updateErrorMessage = (element, error) => {
        const errorText = element.querySelector(_constants.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR);
        if (!errorText) {
          return;
        }
        if (error.type && error.type === "validation_error") {
          errorText.textContent = error.message;
          return;
        }
        const errorType = getErrorType(error);
        const errorData = _constants.CHECKOUT_ERRORS[errorType.toUpperCase().replace(/\W/g, "_")] || {};
        const defaultErrorMessage = errorData.copy;
        const errorMessage = errorText.getAttribute((0, _constants.getCheckoutErrorMessageForType)(errorType)) || defaultErrorMessage;
        errorText.textContent = errorMessage;
        if (errorData.requiresRefresh) {
          errorText.setAttribute(_constants.NEEDS_REFRESH, "true");
        } else {
          errorText.removeAttribute(_constants.NEEDS_REFRESH);
        }
        if (errorType === "shipping") {
          updateRequiredFields(error);
        }
      };
      exports.updateErrorMessage = updateErrorMessage;
      var elementNameByGraphQLError = {
        MISSING_STATE: "address_state"
      };
      var updateRequiredFields = (error) => {
        if (!error.graphQLErrors || error.graphQLErrors.length === 0) {
          return;
        }
        const invalidShippingAddressError = error.graphQLErrors.find((gqlError) => gqlError.code === "InvalidShippingAddress");
        if (!invalidShippingAddressError) {
          return;
        }
        invalidShippingAddressError.problems.forEach((problem) => {
          const {
            type
          } = problem;
          const elementName = elementNameByGraphQLError[type];
          if (!elementName) {
            return;
          }
          const element = document.getElementsByName(elementName)[0];
          if (!(element instanceof HTMLInputElement)) {
            return;
          }
          element.required = true;
          if (typeof element.reportValidity === "function") {
            element.reportValidity();
          }
        });
      };
      var showErrorMessageForError = (err, scope) => {
        const errorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE, scope);
        if (errorState) {
          errorState.style.removeProperty("display");
          updateErrorMessage(errorState, err);
        }
      };
      exports.showErrorMessageForError = showErrorMessageForError;
      var beforeUnloadHandler = (e) => {
        e.preventDefault();
        e.returnValue = "";
      };
      exports.beforeUnloadHandler = beforeUnloadHandler;
      var createOrderIdentityMutation = (apolloClient, email) => apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderIdentityMutation,
        variables: {
          email
        }
      });
      exports.createOrderIdentityMutation = createOrderIdentityMutation;
      var createOrderAddressMutation = (apolloClient, addressInfo) => apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderAddressMutation,
        variables: addressInfo
      });
      exports.createOrderAddressMutation = createOrderAddressMutation;
      var createOrderShippingMethodMutation = (apolloClient, id) => apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderShippingMethodMutation,
        variables: {
          id
        }
      });
      exports.createOrderShippingMethodMutation = createOrderShippingMethodMutation;
      var createCustomDataMutation = (apolloClient, customData) => apolloClient.mutate({
        mutation: _checkoutMutations.updateCustomData,
        variables: {
          customData
        }
      });
      exports.createCustomDataMutation = createCustomDataMutation;
      var createStripePaymentMethodMutation = (apolloClient, id) => apolloClient.mutate({
        mutation: _checkoutMutations.updateOrderStripePaymentMethodMutation,
        variables: {
          paymentMethod: id
        }
      });
      exports.createStripePaymentMethodMutation = createStripePaymentMethodMutation;
      var createRecalcOrderEstimationsMutation = (apolloClient) => apolloClient.mutate({
        mutation: _checkoutMutations.recalcOrderEstimationsMutation,
        errorPolicy: "ignore"
      });
      exports.createRecalcOrderEstimationsMutation = createRecalcOrderEstimationsMutation;
      var createUpdateObfuscatedOrderAddressMutation = (apolloClient, addressInfo) => apolloClient.mutate({
        mutation: _checkoutMutations.updateObfuscatedOrderAddressMutation,
        variables: addressInfo
      });
      exports.createUpdateObfuscatedOrderAddressMutation = createUpdateObfuscatedOrderAddressMutation;
      var renderCheckout = (checkout, data, prevFocusedInput) => {
        (0, _rendering.renderTree)(checkout, data);
        const shippingMethodsList = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_LIST, checkout);
        const shippingMethodsEmpty = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_EMPTY_STATE, checkout);
        const shippingAddressWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, checkout);
        const billingAddressWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkout);
        const billingAddressToggle = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX, checkout);
        const paymentInfoWrapper = checkout.querySelector(".w-commerce-commercecheckoutpaymentinfowrapper");
        if (!(shippingMethodsList instanceof Element) || !(shippingAddressWrapper instanceof Element) || !(billingAddressWrapper instanceof Element) || !(billingAddressToggle instanceof HTMLInputElement) || !(paymentInfoWrapper instanceof Element)) {
          return;
        }
        if (data.data && data.data.database && data.data.database.commerceOrder) {
          const {
            data: {
              database: {
                commerceOrder: {
                  availableShippingMethods,
                  statusFlags: {
                    requiresShipping,
                    isFreeOrder,
                    shippingAddressRequiresPostalCode,
                    billingAddressRequiresPostalCode,
                    hasSubscription
                  }
                }
              }
            }
          } = data;
          const shippingZipField = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_ZIP_FIELD, shippingAddressWrapper);
          if (shippingZipField instanceof HTMLInputElement) {
            shippingZipField.required = shippingAddressRequiresPostalCode;
          }
          const billingZipField = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_ZIP_FIELD, billingAddressWrapper);
          if (billingZipField instanceof HTMLInputElement) {
            billingZipField.required = billingAddressRequiresPostalCode;
          }
          const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
          const paypalButton = checkout.querySelector(`[${_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE}]`);
          if (paypalElement && paypalButton) {
            if (isFreeOrder || hasSubscription) {
              (0, _commerceUtils.hideElement)(paypalButton);
            } else {
              (0, _commerceUtils.showElement)(paypalButton);
            }
          }
          if (!requiresShipping && billingAddressToggle.checked && billingAddressToggle.parentElement && billingAddressToggle.parentElement.classList.contains("w-condition-invisible")) {
            (0, _commerceUtils.showElement)(billingAddressWrapper);
          }
          if (!availableShippingMethods || availableShippingMethods.length < 1) {
            (0, _commerceUtils.hideElement)(shippingMethodsList);
            if (shippingMethodsEmpty instanceof Element) {
              (0, _commerceUtils.showElement)(shippingMethodsEmpty);
            }
          } else {
            if (shippingMethodsEmpty instanceof Element) {
              (0, _commerceUtils.hideElement)(shippingMethodsEmpty);
            }
            (0, _commerceUtils.showElement)(shippingMethodsList);
          }
          if (isFreeOrder) {
            (0, _commerceUtils.hideElement)(paymentInfoWrapper);
          } else if (!isFreeOrder && paymentInfoWrapper.style.getPropertyValue("display") === "none") {
            (0, _commerceUtils.showElement)(paymentInfoWrapper);
          }
        } else {
          (0, _commerceUtils.hideElement)(shippingMethodsList);
          if (shippingMethodsEmpty instanceof Element) {
            (0, _commerceUtils.showElement)(shippingMethodsEmpty);
          }
          (0, _commerceUtils.showElement)(paymentInfoWrapper);
        }
        if (data.errors.length === 0 && prevFocusedInput) {
          let prevFocusedInputEle = document.getElementById(prevFocusedInput);
          if (!prevFocusedInputEle) {
            prevFocusedInputEle = document.querySelector(`[data-wf-bindings="${prevFocusedInput}"]`);
          }
          if (prevFocusedInputEle) {
            prevFocusedInputEle.focus();
          }
        }
      };
      var runRenderOnCheckoutElement = (checkoutFormContainer, data, errors, stripeStore, prevFocusedInput) => {
        renderCheckout(checkoutFormContainer, (0, _extends2.default)({}, data, {
          errors: errors.concat(data.errors).filter(Boolean)
        }), prevFocusedInput);
        if (stripeStore) {
          (0, _webPaymentsEvents.updateWebPaymentsButton)(checkoutFormContainer, data, stripeStore);
        }
      };
      var renderCheckoutFormContainers = (checkoutFormContainers, errors, apolloClient, stripeStore, prevFocusedInput) => {
        if (checkoutFormContainers.length === 0) {
          return;
        }
        checkoutFormContainers.forEach((checkoutFormContainer) => {
          const queryOptions = {
            query: (0, _graphqlTag.default)`
        ${checkoutFormContainer.getAttribute(_constants.CHECKOUT_QUERY)}
      `,
            fetchPolicy: "network-only",
            // errorPolicy is set to `all` so that we continue to get the cart data when an error occurs
            // this is important in cases like when the address entered doesn't have a shipping zone, as that returns
            // a graphQL error, but we still want to render what the customer has entered
            errorPolicy: "all"
          };
          apolloClient.query(queryOptions).then((data) => {
            if (data.data && data.data.database && data.data.database.commerceOrder && data.data.database.commerceOrder.availableShippingMethods) {
              const {
                data: {
                  database: {
                    commerceOrder: {
                      availableShippingMethods,
                      statusFlags: {
                        requiresShipping
                      }
                    }
                  }
                }
              } = data;
              const selectedMethod = availableShippingMethods.find((method) => method.selected === true);
              if (!selectedMethod && requiresShipping) {
                const id = availableShippingMethods[0] ? availableShippingMethods[0].id : null;
                return createOrderShippingMethodMutation(apolloClient, id).then(() => {
                  return createRecalcOrderEstimationsMutation(apolloClient);
                }).then(() => {
                  return apolloClient.query(queryOptions);
                }).then((newData) => {
                  runRenderOnCheckoutElement(checkoutFormContainer, newData, errors, stripeStore, prevFocusedInput);
                });
              }
            }
            if (data.data && data.data.database && data.data.database.commerceOrder && data.data.database.commerceOrder.statusFlags && data.data.database.commerceOrder.statusFlags.shouldRecalc) {
              return createRecalcOrderEstimationsMutation(apolloClient).then(() => {
                return apolloClient.query(queryOptions);
              }).then((newData) => {
                runRenderOnCheckoutElement(checkoutFormContainer, newData, errors, stripeStore, prevFocusedInput);
              });
            } else {
              runRenderOnCheckoutElement(checkoutFormContainer, data, errors, stripeStore, prevFocusedInput);
            }
          }).catch((err) => {
            errors.push(err);
            renderCheckout(checkoutFormContainer, {
              errors
            }, prevFocusedInput);
          });
        });
      };
      exports.renderCheckoutFormContainers = renderCheckoutFormContainers;
      var createAttemptSubmitOrderRequest = (apolloClient, variables) => {
        return apolloClient.mutate({
          mutation: _checkoutMutations.attemptSubmitOrderMutation,
          variables
        });
      };
      exports.createAttemptSubmitOrderRequest = createAttemptSubmitOrderRequest;
      var getOrderDataFromGraphQLResponse = (data) => {
        return data && data.data && data.data.ecommerceAttemptSubmitOrder;
      };
      exports.getOrderDataFromGraphQLResponse = getOrderDataFromGraphQLResponse;
      var orderRequiresAdditionalAction = (status) => status === _constants.REQUIRES_ACTION;
      exports.orderRequiresAdditionalAction = orderRequiresAdditionalAction;
      var redirectToOrderConfirmation = (order, isPayPal = false) => {
        const redirectUrl = `/order-confirmation?orderId=${order.orderId}&token=${order.token}`;
        if (isPayPal) {
          const message = {
            isWebflow: true,
            type: "success",
            detail: redirectUrl
          };
          window.parent.postMessage(JSON.stringify(message), window.location.origin);
        } else {
          window.location.href = redirectUrl;
        }
      };
      exports.redirectToOrderConfirmation = redirectToOrderConfirmation;
      var applyDiscount = (apolloClient, variables) => {
        return apolloClient.mutate({
          mutation: _checkoutMutations.applyDiscountMutation,
          variables
        });
      };
      exports.applyDiscount = applyDiscount;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/cartUtils.js
  var require_cartUtils = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/cartUtils.js"(exports) {
      "use strict";
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.showErrorMessageForError = exports.isCartOpen = void 0;
      var _constants = require_constants2();
      var _commerceUtils = require_commerceUtils();
      var isCartOpen = () => {
        const cartContainerEl = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER);
        if (!cartContainerEl)
          return false;
        return window.getComputedStyle(cartContainerEl).display !== "none";
      };
      exports.isCartOpen = isCartOpen;
      var updateErrorMessage = (element, error) => {
        const errorText = element.querySelector(_constants.CART_ERROR_MESSAGE_SELECTOR);
        if (!errorText)
          return;
        const errorType = getErrorType(error);
        const errorData = _constants.CART_ERRORS[errorType.toUpperCase()] || {};
        const defaultErrorMessage = errorData.msg;
        const errorMessage = errorText.getAttribute((0, _constants.getCheckoutErrorMessageForType)(errorType)) || defaultErrorMessage;
        errorText.textContent = errorMessage;
        if (errorData.requiresRefresh) {
          errorText.setAttribute(_constants.NEEDS_REFRESH, "true");
        } else {
          errorText.removeAttribute(_constants.NEEDS_REFRESH);
        }
      };
      var errorCodeToCartErrorType = (code, msg) => {
        switch (code) {
          case "OrderTotalRange": {
            if (msg && msg.match(/too small/i)) {
              return "cart_order_min";
            }
            return "general";
          }
          default:
            return "general";
        }
      };
      var getErrorType = (error) => {
        if (error.graphQLErrors && error.graphQLErrors.length > 0) {
          return errorCodeToCartErrorType(error.graphQLErrors[0].code, error.graphQLErrors[0].message);
        }
        if (error.code) {
          return errorCodeToCartErrorType(error.code, error.message);
        }
        return "general";
      };
      var showErrorMessageForError = (err, scope) => {
        const cartErrorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, scope);
        if (cartErrorState) {
          cartErrorState.style.removeProperty("display");
          updateErrorMessage(cartErrorState, err);
        }
      };
      exports.showErrorMessageForError = showErrorMessageForError;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/webPaymentsEvents.js
  var require_webPaymentsEvents = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/webPaymentsEvents.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.updateWebPaymentsButton = exports.register = exports.default = void 0;
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var _commerceUtils = require_commerceUtils();
      var _stripeStore = require_stripeStore();
      var _eventHandlerProxyWithApolloClient = _interopRequireDefault(require_eventHandlerProxyWithApolloClient());
      var _checkoutUtils = require_checkoutUtils();
      var _cartUtils = require_cartUtils();
      var _constants = require_constants2();
      var _debug = _interopRequireDefault(require_debug());
      var hasItems = (response) => response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.userItems && response.data.database.commerceOrder.userItems.length > 0;
      var isWebPaymentsButtonEvent = ({
        target
      }) => {
        const cartCheckoutButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON, target);
        const cartApplePayButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON, target);
        if (cartCheckoutButton) {
          return cartCheckoutButton;
        } else if (cartApplePayButton) {
          return cartApplePayButton;
        } else {
          return false;
        }
      };
      var updateWebPaymentsButton = (wrapper, data, stripeStore) => {
        const webPaymentsActionsElements = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_ACTIONS, wrapper);
        if (!webPaymentsActionsElements || webPaymentsActionsElements.length === 0 || !hasItems(data)) {
          return;
        }
        webPaymentsActionsElements.forEach((webPaymentsActions) => {
          (0, _commerceUtils.hideElement)(webPaymentsActions);
          if (!stripeStore || !stripeStore.isInitialized() || !data.data.site.commerce.quickCheckoutEnabled) {
            return;
          }
          const stripeInstance = parseInt(wrapper.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
          const paymentRequest = stripeStore.updateCartPaymentRequest(stripeInstance, data.data.database.commerceOrder, data.data.site.commerce);
          if (!paymentRequest || typeof paymentRequest.canMakePayment !== "function") {
            return;
          }
          if ((0, _commerceUtils.isFreeOrder)(data)) {
            return;
          }
          paymentRequest.canMakePayment().then((result) => {
            if (!result) {
              return;
            }
            const {
              applePay
            } = result;
            (0, _commerceUtils.showElement)(webPaymentsActions);
            const cartCheckoutButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_QUICK_CHECKOUT_BUTTON, webPaymentsActions);
            const cartApplePayButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_APPLE_PAY_BUTTON, webPaymentsActions);
            if (!cartCheckoutButton || !cartApplePayButton) {
              return;
            }
            if (applePay) {
              (0, _commerceUtils.hideElement)(cartCheckoutButton);
              (0, _commerceUtils.showElement)(cartApplePayButton);
            } else {
              (0, _commerceUtils.hideElement)(cartApplePayButton);
              (0, _commerceUtils.showElement)(cartCheckoutButton);
            }
          }).catch(() => {
            _debug.default.log("PaymentRequest not available in this browser \u2013 silently exiting");
          });
        });
      };
      exports.updateWebPaymentsButton = updateWebPaymentsButton;
      var getShippingMethodsQuery = (0, _graphqlTag.default)`
  query FetchShippingMethods {
    database {
      id
      commerceOrder {
        id
        availableShippingMethods {
          id
          name
          description
          price {
            value
          }
        }
      }
    }
  }
`;
      var handleWebPaymentsButton = (event, apolloClient, stripeStore) => {
        event.preventDefault();
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          if (window.Webflow.env("preview")) {
            window.alert("Web Payments is not available in preview mode.");
          }
          return;
        }
        const {
          currentTarget
        } = event;
        const stripeElement = (0, _commerceUtils.findClosestElementWithAttribute)(_constants.STRIPE_ELEMENT_INSTANCE, currentTarget);
        if (!(stripeElement instanceof Element)) {
          return;
        }
        const stripeInstance = parseInt(stripeElement.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
        const paymentRequest = stripeStore.getCartPaymentRequest(stripeInstance);
        paymentRequest.show();
        if (paymentRequest.hasRegisteredListener("paymentmethod")) {
          paymentRequest.removeAllListeners();
        }
        paymentRequest.on("shippingaddresschange", ({
          updateWith,
          shippingAddress
        }) => {
          let shippingMethods = [];
          const graphQlQuery = stripeElement.getAttribute(_constants.CART_QUERY) || stripeElement.getAttribute(_constants.CHECKOUT_QUERY);
          (0, _checkoutUtils.createUpdateObfuscatedOrderAddressMutation)(apolloClient, {
            type: "shipping",
            name: shippingAddress.recipient,
            address_line1: shippingAddress.addressLine[0],
            address_line2: shippingAddress.addressLine[1],
            address_city: shippingAddress.city,
            address_state: shippingAddress.region,
            address_country: shippingAddress.country,
            address_zip: shippingAddress.postalCode
          }).then(() => {
            return apolloClient.query({
              query: getShippingMethodsQuery,
              fetchPolicy: "network-only",
              errorPolicy: "all"
            });
          }).then(({
            data
          }) => {
            if (!data.database.commerceOrder.availableShippingMethods || data.database.commerceOrder.availableShippingMethods.length === 0) {
              updateWith({
                status: "invalid_shipping_address"
              });
              return Promise.reject("No valid shipping addresses");
            } else {
              shippingMethods = data.database.commerceOrder.availableShippingMethods;
              return (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, data.database.commerceOrder.availableShippingMethods[0].id);
            }
          }).then(() => {
            return (0, _checkoutUtils.createRecalcOrderEstimationsMutation)(apolloClient);
          }).then(() => {
            return apolloClient.query({
              query: (0, _graphqlTag.default)`
              ${graphQlQuery}
            `,
              fetchPolicy: "network-only",
              errorPolicy: "all"
            });
          }).then(({
            data
          }) => {
            updateWith({
              status: "success",
              displayItems: (0, _stripeStore.generateDisplayItemsFromOrder)(data.database.commerceOrder, true),
              shippingOptions: (0, _stripeStore.generateShippingOptionsFromMethods)(shippingMethods),
              total: {
                amount: data.database.commerceOrder.total.value,
                label: "Total",
                pending: false
              }
            });
          });
        });
        paymentRequest.on("shippingoptionchange", ({
          updateWith,
          shippingOption
        }) => {
          const graphQlQuery = stripeElement.getAttribute(_constants.CART_QUERY) || stripeElement.getAttribute(_constants.CHECKOUT_QUERY);
          (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, shippingOption.id).then(() => {
            return (0, _checkoutUtils.createRecalcOrderEstimationsMutation)(apolloClient);
          }).then(() => {
            return apolloClient.query({
              query: (0, _graphqlTag.default)`
            ${graphQlQuery}
          `,
              fetchPolicy: "network-only",
              errorPolicy: "all"
            });
          }).then(({
            data
          }) => {
            updateWith({
              status: "success",
              displayItems: (0, _stripeStore.generateDisplayItemsFromOrder)(data.database.commerceOrder, true),
              total: {
                amount: data.database.commerceOrder.total.value,
                label: "Total",
                pending: false
              }
            });
          });
        });
        paymentRequest.on("paymentmethod", (ev) => {
          (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({
            requiresShipping
          }) => {
            return Promise.all([(0, _checkoutUtils.createOrderIdentityMutation)(apolloClient, ev.payerEmail), requiresShipping ? (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, {
              type: "shipping",
              name: ev.shippingAddress.recipient,
              address_line1: ev.shippingAddress.addressLine[0],
              address_line2: ev.shippingAddress.addressLine[1],
              address_city: ev.shippingAddress.city,
              address_state: ev.shippingAddress.region,
              address_country: ev.shippingAddress.country,
              address_zip: ev.shippingAddress.postalCode
            }) : Promise.resolve(), (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, {
              type: "billing",
              name: ev.paymentMethod.billing_details.name,
              address_line1: ev.paymentMethod.billing_details.address.line1,
              address_line2: ev.paymentMethod.billing_details.address.line2,
              address_city: ev.paymentMethod.billing_details.address.city,
              address_state: ev.paymentMethod.billing_details.address.state,
              address_country: ev.paymentMethod.billing_details.address.country,
              address_zip: ev.paymentMethod.billing_details.address.postal_code
            }), requiresShipping ? (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, ev.shippingOption.id) : Promise.resolve(), (0, _checkoutUtils.createStripePaymentMethodMutation)(apolloClient, ev.paymentMethod.id)]);
          }).then(() => {
            return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
              checkoutType: "quickCheckout"
            });
          }).then((data) => {
            const order = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(data);
            if ((0, _checkoutUtils.orderRequiresAdditionalAction)(order.status)) {
              ev.complete("success");
              const stripe = stripeStore.getStripeInstance();
              return stripe.handleCardAction(order.clientSecret).then((result) => {
                if (result.error) {
                  return Promise.reject(new Error("payment_intent_failed"));
                }
                return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
                  checkoutType: "quickCheckout",
                  paymentIntentId: result.paymentIntent.id
                }).then((resp) => {
                  const finishedOrder = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(resp);
                  if (finishedOrder.ok) {
                    (0, _checkoutUtils.redirectToOrderConfirmation)(finishedOrder);
                  } else {
                    return Promise.reject(new Error("payment_intent_failed"));
                  }
                });
              });
            }
            if (order.ok) {
              ev.complete("success");
              (0, _checkoutUtils.redirectToOrderConfirmation)(order);
            } else {
              return Promise.reject(new Error("order_failed"));
            }
          }).catch((err) => {
            const hasGraphQLErrors = err && err.graphQLErrors && err.graphQLErrors.length > 0;
            if (hasGraphQLErrors) {
              switch (err.graphQLErrors[0].code) {
                case "PriceChanged": {
                  ev.complete("success");
                  setTimeout(() => {
                    window.alert("The prices of one or more items in your cart have changed. Please refresh this page and try again.");
                  }, 100);
                  return;
                }
                case "ItemNotFound": {
                  ev.complete("success");
                  setTimeout(() => {
                    window.alert("One or more of the products in your cart have been removed. Please refresh the page and try again.");
                  }, 100);
                  return;
                }
                case "OrderTotalRange": {
                  ev.complete("success");
                  (0, _checkoutUtils.showErrorMessageForError)(err, ev.currentTarget);
                  if ((0, _cartUtils.isCartOpen)()) {
                    (0, _cartUtils.showErrorMessageForError)(err, ev.currentTarget);
                  }
                  return;
                }
                default:
              }
            }
            if (err && err.message && err.message === "payment_intent_failed") {
              window.alert("There was an error processing your payment. Please try again, or contact us if you continue to have problems.");
            } else {
              ev.complete("fail");
            }
          });
        });
      };
      var register = (handlerProxy) => {
        handlerProxy.on("click", isWebPaymentsButtonEvent, handleWebPaymentsButton);
        handlerProxy.on("keydown", isWebPaymentsButtonEvent, (event, ...rest) => {
          if (event.which === 32) {
            event.preventDefault();
          }
          if (event.which === 13) {
            return handleWebPaymentsButton(event, ...rest);
          }
        });
        handlerProxy.on("keyup", isWebPaymentsButtonEvent, (event, ...rest) => {
          if (event.which === 32) {
            return handleWebPaymentsButton(event, ...rest);
          }
        });
      };
      exports.register = register;
      var _default = {
        register
      };
      exports.default = _default;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/cartEvents.js
  var require_cartEvents = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/cartEvents.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.renderCart = exports.register = exports.default = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var _mergeWith = _interopRequireDefault(require_mergeWith());
      var _forEach = _interopRequireDefault(require_forEach());
      var _constants = require_constants2();
      var _eventHandlerProxyWithApolloClient = _interopRequireDefault(require_eventHandlerProxyWithApolloClient());
      var _commerceUtils = require_commerceUtils();
      var _stripeStore = require_stripeStore();
      var _debug = _interopRequireDefault(require_debug());
      var _webPaymentsEvents = require_webPaymentsEvents();
      var _rendering = require_rendering();
      var _defaultTo = _interopRequireDefault(require_defaultTo());
      var {
        MODAL,
        LEFT_SIDEBAR,
        RIGHT_SIDEBAR,
        LEFT_DROPDOWN,
        RIGHT_DROPDOWN
      } = _constants.CART_TYPES;
      var {
        REMOVE_ITEM,
        UPDATE_ITEM_QUANTITY
      } = _constants.COMMERCE_CART_PUBLISHED_SITE_ACTIONS;
      var updateItemQuantityMutation = (0, _graphqlTag.default)`
  mutation AddToCart($skuId: String!, $count: Int!) {
    ecommerceUpdateCartItem(sku: $skuId, count: $count) {
      ok
      itemId
      itemCount
    }
  }
`;
      var forEachElementInForm = (form, callback) => {
        if (form instanceof HTMLFormElement && form.elements instanceof HTMLCollection) {
          Array.from(form.elements).forEach((input) => {
            if (input instanceof HTMLInputElement) {
              callback(input);
            }
          });
        }
      };
      var disableAllFormElements = (form) => {
        forEachElementInForm(form, (input) => {
          input.disabled = true;
        });
      };
      var enableAllFormElements = (form) => {
        forEachElementInForm(form, (input) => {
          input.disabled = false;
        });
      };
      var searchTreeForRemoveLink = (element) => {
        if (element instanceof Element && element.hasAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) && element.getAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) === REMOVE_ITEM && element.hasAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID)) {
          return element;
        } else {
          return element instanceof Element && element.parentElement ? searchTreeForRemoveLink(element.parentElement) : false;
        }
      };
      var isItemRemovedEvent = (event) => {
        return searchTreeForRemoveLink(event.target);
      };
      var isItemQuantityChangedEvent = (event) => event.target instanceof Element && event.target.hasAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) && event.target.getAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) === UPDATE_ITEM_QUANTITY && event.target.hasAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID) && event.target;
      var isItemQuantityInputEvent = (event) => event.target instanceof Element && event.target.hasAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) && event.target.getAttribute(_constants.COMMERCE_CART_PUBLISHED_SITE_ACTION_ATTR) === UPDATE_ITEM_QUANTITY && event.target.hasAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID) && event.target;
      var isCartButtonEvent = ({
        target
      }) => {
        const cartOpenLink = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK, target);
        const cartCloseLink = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CLOSE_LINK, target);
        if (cartOpenLink) {
          return cartOpenLink;
        } else if (cartCloseLink) {
          return cartCloseLink;
        } else {
          return false;
        }
      };
      var isCartCheckoutButtonEvent = ({
        target
      }) => {
        const cartCheckoutButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON, target);
        if (cartCheckoutButton) {
          return cartCheckoutButton;
        } else {
          return false;
        }
      };
      var isCartWrapperEvent = ({
        target
      }) => target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_WRAPPER && target;
      var isCartFormEvent = ({
        target
      }) => target instanceof Element && target.hasAttribute(_constants.DATA_ATTR_NODE_TYPE) && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_FORM;
      var getFormElement = (element) => {
        if (!(element instanceof Element)) {
          return null;
        }
        return element instanceof HTMLFormElement ? element : getFormElement(element.parentElement);
      };
      var handleItemRemoved = (event, apolloClient) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        event.preventDefault();
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof HTMLElement)) {
          return;
        }
        const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, currentTarget);
        if (!(commerceCartWrapper instanceof Element)) {
          return;
        }
        const errorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, commerceCartWrapper);
        if (!(errorElement instanceof Element)) {
          return;
        }
        errorElement.style.setProperty("display", "none");
        const skuId = currentTarget.getAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID);
        const count = 0;
        const form = getFormElement(currentTarget);
        disableAllFormElements(form);
        const cartItem = (0, _commerceUtils.findClosestElementByClassName)("w-commerce-commercecartitem", currentTarget);
        if (!(cartItem instanceof Element)) {
          return;
        }
        (0, _commerceUtils.addLoadingCallback)((0, _commerceUtils.setElementLoading)(cartItem));
        const removeLinkElement = searchTreeForRemoveLink(event.target);
        if (removeLinkElement instanceof HTMLAnchorElement) {
          removeLinkElement.style.pointerEvents = "none";
        }
        apolloClient.mutate({
          mutation: updateItemQuantityMutation,
          variables: {
            skuId,
            count
          }
        }).then(
          // eslint-disable-next-line no-unused-vars
          (data) => {
            (0, _commerceUtils.triggerRender)(null);
          },
          (error) => {
            _debug.default.error(error);
            errorElement.style.removeProperty("display");
            const errorMsg = errorElement.querySelector(_constants.CART_ERROR_MESSAGE_SELECTOR);
            if (!errorMsg) {
              return;
            }
            const errorText = errorMsg.getAttribute(_constants.CART_GENERAL_ERROR_MESSAGE) || "";
            errorMsg.textContent = errorText;
            (0, _commerceUtils.triggerRender)(error);
          }
        ).then(() => {
          if (removeLinkElement instanceof HTMLAnchorElement) {
            removeLinkElement.style.pointerEvents = "auto";
          }
          const cartContainer = currentTarget.closest(".w-commerce-commercecartcontainer");
          if (cartContainer instanceof HTMLElement) {
            const itemContainer = cartContainer.getElementsByClassName("w-commerce-commercecartitem");
            const focusableContent = getFocusableElements(cartContainer);
            if (itemContainer.length === 1 && focusableContent.length > 0) {
              focusableContent[0].focus();
            }
          }
        });
      };
      var handleItemQuantityChanged = (event, apolloClient) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        event.preventDefault();
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof HTMLInputElement)) {
          return;
        }
        if (currentTarget.form instanceof HTMLFormElement && currentTarget.form.reportValidity() === false) {
          return;
        }
        const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, currentTarget);
        if (!(commerceCartWrapper instanceof Element)) {
          return;
        }
        const errorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, commerceCartWrapper);
        if (!(errorElement instanceof Element)) {
          return;
        }
        errorElement.style.setProperty("display", "none");
        const cartItem = currentTarget.parentElement;
        if (!(cartItem instanceof Element)) {
          return;
        }
        (0, _commerceUtils.addLoadingCallback)((0, _commerceUtils.setElementLoading)(cartItem));
        const skuId = currentTarget.getAttribute(_constants.DATA_ATTR_COMMERCE_SKU_ID);
        const count = currentTarget.value;
        disableAllFormElements(currentTarget.form);
        apolloClient.mutate({
          mutation: updateItemQuantityMutation,
          variables: {
            skuId,
            count
          }
        }).then(
          // eslint-disable-next-line no-unused-vars
          (data) => {
            enableAllFormElements(currentTarget.form);
            (0, _commerceUtils.triggerRender)(null);
          },
          (error) => {
            enableAllFormElements(currentTarget.form);
            _debug.default.error(error);
            errorElement.style.removeProperty("display");
            const errorMsg = errorElement.querySelector(_constants.CART_ERROR_MESSAGE_SELECTOR);
            if (!errorMsg) {
              return;
            }
            const errorType = error.graphQLErrors && error.graphQLErrors.length > 0 && error.graphQLErrors[0].code === "OutOfInventory" ? "quantity" : "general";
            const errorText = errorMsg.getAttribute((0, _constants.getCartErrorMessageForType)(errorType)) || "";
            errorMsg.textContent = errorText;
            (0, _commerceUtils.triggerRender)(error);
          }
        );
      };
      var handleItemInputChanged = (event) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        event.preventDefault();
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof HTMLInputElement)) {
          return;
        }
        if (currentTarget.validity.valid === false && currentTarget.form instanceof HTMLFormElement) {
          currentTarget.form.reportValidity();
        }
      };
      var handleChangeCartStateEvent = (event) => {
        if (!(event.currentTarget instanceof Element) || !(event instanceof CustomEvent)) {
          return;
        }
        const {
          currentTarget,
          detail
        } = event;
        const isOpen = currentTarget.hasAttribute(_constants.CART_OPEN);
        const shouldOpen = detail && detail.open != null ? detail.open : !isOpen;
        const wrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER, currentTarget);
        if (!wrapper) {
          return;
        }
        const cartContainer = getCartContainer(wrapper);
        if (!cartContainer) {
          return;
        }
        const cartElement = wrapper.parentElement;
        if (!cartElement) {
          return;
        }
        const cartType = cartElement.getAttribute(_constants.CART_TYPE);
        const duration = (0, _defaultTo.default)(cartElement.getAttribute(_constants.DATA_ATTR_ANIMATION_DURATION), _constants.ANIMATION_DURATION_DEFAULT) + "ms";
        const containerEasing = (0, _defaultTo.default)(cartElement.getAttribute(_constants.DATA_ATTR_ANIMATION_EASING), _constants.ANIMATION_EASING_DEFAULT);
        const wrapperTransition = `opacity ${duration} ease 0ms`;
        const containerOutDelay = "50ms";
        const shouldAnimate = duration !== "0ms";
        let containerStepA;
        let containerStepB;
        switch (cartType) {
          case MODAL: {
            containerStepA = {
              scale: 0.95
            };
            containerStepB = {
              scale: 1
            };
            break;
          }
          case LEFT_SIDEBAR: {
            containerStepA = {
              x: -30
            };
            containerStepB = {
              x: 0
            };
            break;
          }
          case RIGHT_SIDEBAR: {
            containerStepA = {
              x: 30
            };
            containerStepB = {
              x: 0
            };
            break;
          }
          case LEFT_DROPDOWN:
          case RIGHT_DROPDOWN: {
            containerStepA = {
              y: -10
            };
            containerStepB = {
              y: 0
            };
            break;
          }
        }
        if (shouldOpen) {
          document.addEventListener("keydown", handleCartFocusTrap);
          currentTarget.setAttribute(_constants.CART_OPEN, "");
          wrapper.style.removeProperty("display");
          const focusableContent = getFocusableElements(cartContainer);
          if (focusableContent.length > 0) {
            focusableContent[0].focus();
          }
          if (shouldAnimate && !isOpen) {
            window.Webflow.tram(wrapper).add(wrapperTransition).set({
              opacity: 0
            }).start({
              opacity: 1
            });
            window.Webflow.tram(cartContainer).add(`transform ${duration} ${containerEasing} 0ms`).set(containerStepA).start(containerStepB);
          }
        } else {
          document.removeEventListener("keydown", handleCartFocusTrap);
          currentTarget.removeAttribute(_constants.CART_OPEN);
          if (shouldAnimate) {
            window.Webflow.tram(wrapper).add(wrapperTransition).start({
              opacity: 0
            }).then(() => {
              wrapper.style.display = "none";
              window.Webflow.tram(cartContainer).stop();
            });
            window.Webflow.tram(cartContainer).add(`transform ${duration} ${containerEasing} ${containerOutDelay}`).start(containerStepA);
          } else {
            wrapper.style.display = "none";
          }
          const cartOpenButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK, cartElement);
          if (cartOpenButton instanceof Element) {
            cartOpenButton.focus();
          }
        }
      };
      var handleCartButton = (event) => {
        if (window.Webflow.env("design")) {
          return;
        }
        const {
          currentTarget,
          type
        } = event;
        if (!(currentTarget instanceof Element)) {
          return;
        }
        const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, currentTarget);
        if (!(commerceCartWrapper instanceof Element)) {
          return;
        }
        const cartContainerWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER, commerceCartWrapper);
        let evt;
        if (type === "click" && (currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_CLOSE_LINK || currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK && !commerceCartWrapper.hasAttribute(_constants.DATA_ATTR_OPEN_ON_HOVER))) {
          evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
            bubbles: true
          });
          if (cartContainerWrapper && currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_CLOSE_LINK) {
            cartContainerWrapper.removeEventListener("mouseleave", handleCartContainerLeave);
            commerceCartWrapper.removeEventListener("mouseleave", handleCartContainerLeave);
          }
        } else if (type === "mouseover" && commerceCartWrapper.hasAttribute(_constants.DATA_ATTR_OPEN_ON_HOVER) && currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK) {
          evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
            bubbles: true,
            detail: {
              open: true
            }
          });
          if (cartContainerWrapper) {
            cartContainerWrapper.addEventListener("mouseleave", handleCartContainerLeave);
            currentTarget.addEventListener("mouseleave", handleCartContainerLeave);
          }
        }
        if (evt) {
          commerceCartWrapper.dispatchEvent(evt);
        }
      };
      var handleCartCheckoutButton = (event) => {
        if (window.Webflow.env("preview")) {
          return;
        }
        event.preventDefault();
        const {
          currentTarget: checkoutButton
        } = event;
        if (!(checkoutButton instanceof Element)) {
          return;
        }
        if (!(0, _commerceUtils.isProtocolHttps)()) {
          window.alert("This site is currently unsecured so you cannot enter checkout.");
          return;
        }
        const loadingText = checkoutButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
        const buttonText = checkoutButton.innerHTML;
        checkoutButton.innerHTML = loadingText ? loadingText : _constants.CART_CHECKOUT_LOADING_TEXT_DEFAULT;
        const commerceCartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, checkoutButton);
        if (!(commerceCartWrapper instanceof Element)) {
          return;
        }
        const publishableKey = checkoutButton.getAttribute(_constants.DATA_ATTR_PUBLISHABLE_KEY);
        const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
        if (!publishableKey && !paypalElement) {
          const errorElement = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_ERROR, commerceCartWrapper);
          if (!(errorElement instanceof Element)) {
            return;
          }
          errorElement.style.setProperty("display", "none");
          errorElement.style.removeProperty("display");
          const errorMsg = errorElement.querySelector(".w-cart-error-msg");
          if (!errorMsg) {
            return;
          }
          const errorText = errorMsg.getAttribute(`data-w-cart-checkout-error`) || "";
          errorMsg.textContent = errorText;
          checkoutButton.innerHTML = buttonText ? buttonText : _constants.CART_CHECKOUT_BUTTON_TEXT_DEFAULT;
          return;
        }
        if (!(checkoutButton instanceof HTMLAnchorElement)) {
          checkoutButton.innerHTML = buttonText ? buttonText : _constants.CART_CHECKOUT_BUTTON_TEXT_DEFAULT;
          return;
        }
        window.location = checkoutButton.href;
      };
      var handleSubmitForm = (event) => {
        if (window.Webflow.env("preview")) {
          return;
        }
        event.preventDefault();
      };
      var handleCartContainerLeave = (event) => {
        const {
          target,
          relatedTarget
        } = event;
        if (!(target instanceof Element) || !(relatedTarget instanceof Element)) {
          return;
        }
        const {
          parentElement
        } = target;
        if (!(parentElement instanceof Element)) {
          return;
        }
        const cartWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, relatedTarget);
        const cartContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER, relatedTarget);
        if (cartWrapper || cartContainer) {
          return;
        }
        const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
          bubbles: true,
          detail: {
            open: false
          }
        });
        parentElement.dispatchEvent(evt);
        cartWrapper && cartWrapper instanceof Element && cartWrapper.removeEventListener("mouseleave", handleCartContainerLeave);
        cartContainer && cartContainer instanceof Element && cartContainer.removeEventListener("mouseleave", handleCartContainerLeave);
      };
      var cartContainerStates = [];
      var handlePreviewMode = () => {
        const cartContainerElements = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER_WRAPPER);
        cartContainerElements.forEach((element) => {
          const wasOpen = element.style.display !== "none";
          cartContainerStates.push({
            element,
            wasOpen
          });
          if (wasOpen) {
            const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
              bubbles: true,
              detail: {
                open: true
              }
            });
            const {
              parentElement
            } = element;
            if (parentElement) {
              parentElement.dispatchEvent(evt);
            }
          }
        });
      };
      var handleDesignMode = () => {
        cartContainerStates.forEach(({
          element: wrapper,
          wasOpen
        }) => {
          window.Webflow.tram(wrapper).destroy();
          wrapper.style.opacity = "1";
          const cartContainer = getCartContainer(wrapper);
          if (cartContainer) {
            window.Webflow.tram(cartContainer).destroy();
            cartContainer.style.transform = "";
          }
          if (wasOpen) {
            wrapper.style.removeProperty("display");
          } else {
            wrapper.style.display = "none";
          }
          const cartElement = wrapper.parentElement;
          if (cartElement) {
            cartElement.removeAttribute(_constants.CART_OPEN);
          }
        });
        cartContainerStates = [];
      };
      var doForAllMatchingClass = (cart, className, fn) => Array.from(cart.getElementsByClassName(className)).forEach(fn);
      var showCartDefaultState = (cart) => {
        doForAllMatchingClass(cart, "w-commerce-commercecartemptystate", _commerceUtils.hideElement);
        doForAllMatchingClass(cart, "w-commerce-commercecartform", _commerceUtils.showElement);
      };
      var showCartEmptyState = (cart) => {
        doForAllMatchingClass(cart, "w-commerce-commercecartemptystate", _commerceUtils.showElement);
        doForAllMatchingClass(cart, "w-commerce-commercecartform", _commerceUtils.hideElement);
      };
      var hideErrorState = (cart) => {
        doForAllMatchingClass(cart, "w-commerce-commercecarterrorstate", _commerceUtils.hideElement);
      };
      var showErrorState = (cart) => {
        doForAllMatchingClass(cart, "w-commerce-commercecarterrorstate", _commerceUtils.showElement);
      };
      var hasItems = (response) => response && response.data && response.data.database && response.data.database.commerceOrder && response.data.database.commerceOrder.userItems && response.data.database.commerceOrder.userItems.length > 0;
      var hasErrors = (response) => response && response.errors && response.errors.length > 0;
      var updateCartA11Y = (cart) => {
        doForAllMatchingClass(cart, "w-commerce-commercecartopenlinkcount", (element) => {
          doForAllMatchingClass(cart, "w-commerce-commercecartopenlink", (openLinkElement) => {
            openLinkElement.setAttribute("aria-label", element.textContent === "0" ? "Open empty cart" : `Open cart containing ${element.textContent} items`);
          });
        });
      };
      var renderCart = (cart, data, stripeStore) => {
        hideErrorState(cart);
        if (hasErrors(data)) {
          showErrorState(cart);
        }
        doForAllMatchingClass(cart, "w-commerce-commercecartopenlinkcount", (element) => {
          const hideRule = element.getAttribute(_constants.DATA_ATTR_COUNT_HIDE_RULE);
          if (hideRule === _constants.CART_COUNT_HIDE_RULES.ALWAYS || hideRule === _constants.CART_COUNT_HIDE_RULES.EMPTY && !hasItems(data)) {
            (0, _commerceUtils.hideElement)(element);
          } else {
            (0, _commerceUtils.showElement)(element);
          }
        });
        const dataWithDefaults = (0, _mergeWith.default)({}, data, (obj, src, key) => {
          if (key === "commerceOrder" && src === null) {
            return {
              userItemsCount: 0
            };
          }
        });
        (0, _rendering.renderTree)(cart, dataWithDefaults);
        if (hasItems(data)) {
          showCartDefaultState(cart);
        } else {
          showCartEmptyState(cart);
        }
        const cartForm = cart.querySelector("form");
        if (cartForm instanceof HTMLFormElement) {
          enableAllFormElements(cartForm);
        }
        const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
        const checkoutButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CHECKOUT_BUTTON, cart);
        if (checkoutButton && paypalElement && stripeStore && !stripeStore.isInitialized()) {
          if ((0, _commerceUtils.isFreeOrder)(data)) {
            (0, _commerceUtils.showElement)(checkoutButton);
          } else {
            (0, _commerceUtils.hideElement)(checkoutButton);
          }
        }
        const paypalButton = cart.querySelector(`[${_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE}]`);
        if (paypalElement && paypalButton) {
          if ((0, _commerceUtils.isFreeOrder)(data) || (0, _commerceUtils.hasSubscription)(data)) {
            (0, _commerceUtils.hideElement)(paypalButton);
          } else {
            (0, _commerceUtils.showElement)(paypalButton);
          }
        }
        (0, _webPaymentsEvents.updateWebPaymentsButton)(cart, data, stripeStore);
        return cart;
      };
      exports.renderCart = renderCart;
      var handleRenderCart = (event, apolloClient, stripeStore) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
          return;
        }
        const errors = [];
        const {
          detail
        } = event;
        if (detail != null && detail.error) {
          errors.push(detail.error);
        }
        const orderConfirmationContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER);
        if (orderConfirmationContainer) {
          return;
        }
        const carts = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER);
        if (!carts.length) {
          (0, _commerceUtils.executeLoadingCallbacks)();
          return;
        }
        carts.forEach((cart) => {
          apolloClient.query({
            query: (0, _graphqlTag.default)`
          ${cart.getAttribute(_constants.CART_QUERY)}
        `,
            fetchPolicy: "network-only",
            errorPolicy: "all"
          }).then((data) => {
            (0, _commerceUtils.executeLoadingCallbacks)();
            renderCart(cart, (0, _extends2.default)({}, data, {
              errors: errors.concat(data.errors).filter(Boolean)
            }), stripeStore);
            updateCartA11Y(cart);
          }).catch((err) => {
            (0, _commerceUtils.executeLoadingCallbacks)();
            errors.push(err);
            renderCart(cart, {
              errors
            });
            updateCartA11Y(cart);
          });
        });
      };
      var handleCartKeyUp = (event) => {
        if (event.keyCode === 27) {
          const openCarts = Array.from(document.querySelectorAll(`[${_constants.CART_OPEN}]`));
          (0, _forEach.default)(openCarts, (cart) => {
            const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
              bubbles: true,
              detail: {
                open: false
              }
            });
            cart.dispatchEvent(evt);
          });
        }
        if (event.keyCode === 32 && event.target instanceof HTMLElement) {
          const htmlElement = event.target;
          if ((htmlElement.getAttribute("role") === "button" || htmlElement.getAttribute("role") === "link" || htmlElement.hasAttribute("href") || htmlElement.hasAttribute("onClick")) && (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_WRAPPER, event.target) != null) {
            event.preventDefault();
            htmlElement.click();
          }
        }
      };
      var getCartContainer = (parent) => (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_CONTAINER, parent);
      var handleClickCloseCart = ({
        target
      }) => {
        if (!(target instanceof Element)) {
          return;
        }
        const openCarts = Array.from(document.querySelectorAll(`[${_constants.CART_OPEN}]`));
        (0, _forEach.default)(openCarts, (cart) => {
          const cartContainer = getCartContainer(cart);
          const cartOpenButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CART_OPEN_LINK, cart);
          if (!(cartContainer instanceof Element) || !(cartOpenButton instanceof Element)) {
            return;
          }
          const cartType = cart.getAttribute(_constants.CART_TYPE);
          const isNotInside = cartType === LEFT_DROPDOWN || cartType === RIGHT_DROPDOWN ? !cart.contains(target) : !cartContainer.contains(target) && !cartOpenButton.contains(target);
          if (isNotInside) {
            const evt = new CustomEvent(_constants.CHANGE_CART_EVENT, {
              bubbles: true,
              detail: {
                open: false
              }
            });
            cart.dispatchEvent(evt);
          }
        });
      };
      var getFocusableElements = (container) => {
        const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        return [...container.querySelectorAll(focusableElements)].filter((element) => !element.hasAttribute("disabled") && element.offsetHeight > 0);
      };
      var handleCartFocusTrap = (event) => {
        if (event.key !== "Tab" && event.keyCode !== 9) {
          return;
        }
        const openCarts = Array.from(document.querySelectorAll(`[${_constants.CART_OPEN}]`));
        (0, _forEach.default)(openCarts, (cart) => {
          const cartContainer = getCartContainer(cart);
          if (!(cartContainer instanceof Element)) {
            return;
          }
          const focusableContent = getFocusableElements(cartContainer);
          const firstFocusableElement = focusableContent[0];
          const lastFocusableElement = focusableContent[focusableContent.length - 1];
          if (event.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              lastFocusableElement.focus();
              event.preventDefault();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              firstFocusableElement.focus();
              event.preventDefault();
            }
          }
        });
      };
      var register = (handlerProxy) => {
        handlerProxy.on("click", isItemRemovedEvent, handleItemRemoved);
        handlerProxy.on("change", isItemQuantityChangedEvent, handleItemQuantityChanged);
        handlerProxy.on("focus", isItemQuantityInputEvent, handleItemInputChanged);
        handlerProxy.on("click", isCartButtonEvent, handleCartButton);
        handlerProxy.on("click", isCartCheckoutButtonEvent, handleCartCheckoutButton);
        handlerProxy.on("mouseover", isCartButtonEvent, handleCartButton);
        handlerProxy.on(_constants.CHANGE_CART_EVENT, isCartWrapperEvent, handleChangeCartStateEvent);
        handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderCart);
        handlerProxy.on("submit", isCartFormEvent, handleSubmitForm);
        handlerProxy.on("keyup", Boolean, handleCartKeyUp);
        handlerProxy.on("click", Boolean, handleClickCloseCart);
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          window.addEventListener("__wf_preview", handlePreviewMode);
          window.addEventListener("__wf_design", handleDesignMode);
        }
      };
      exports.register = register;
      var _default = {
        register
      };
      exports.default = _default;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/checkoutEvents.js
  var require_checkoutEvents = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/checkoutEvents.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.register = exports.default = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _debounce = _interopRequireDefault(require_debounce());
      var _constants = require_constants2();
      var _eventHandlerProxyWithApolloClient = _interopRequireDefault(require_eventHandlerProxyWithApolloClient());
      var _commerceUtils = require_commerceUtils();
      var _checkoutUtils = require_checkoutUtils();
      var _debug = _interopRequireDefault(require_debug());
      var isInputInsideCustomerInfoEvent = ({
        target
      }) => {
        const checkoutFormContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
        if (!checkoutFormContainer) {
          return false;
        }
        const customerInfoWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER, target);
        if (customerInfoWrapper && target instanceof Element && target.tagName === "INPUT") {
          return target;
        } else {
          return false;
        }
      };
      var isInputInsideAddressWrapperEvent = ({
        target
      }) => {
        const checkoutFormContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
        if (!checkoutFormContainer || !(target instanceof Element)) {
          return false;
        }
        const shippingAddressWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, target);
        const billingAddressWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, target);
        if (shippingAddressWrapper) {
          return shippingAddressWrapper;
        } else if (billingAddressWrapper) {
          return billingAddressWrapper;
        } else {
          return false;
        }
      };
      var isInputInsideShippingMethodEvent = ({
        target
      }) => {
        const checkoutFormContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER) || (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER);
        if (!checkoutFormContainer) {
          return false;
        }
        const shippingMethodWrapper = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, target);
        if (shippingMethodWrapper && target instanceof Element && target.tagName === "INPUT") {
          return target;
        } else {
          return false;
        }
      };
      var isBillingAddressToggleEvent = ({
        target
      }) => {
        if (target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX) {
          return target;
        } else {
          return false;
        }
      };
      var isPlaceOrderButtonEvent = ({
        target
      }) => {
        const placeOrderButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, target);
        if (placeOrderButton && target instanceof Element) {
          return target;
        } else {
          return false;
        }
      };
      var isApplyDiscountFormEvent = ({
        target
      }) => {
        if (target instanceof Element && target.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM) {
          return target;
        } else {
          return false;
        }
      };
      var isFormInsideCheckoutContainerEvent = ({
        target
      }) => {
        const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, target);
        if (target instanceof HTMLFormElement && checkoutForm) {
          return target;
        } else {
          return false;
        }
      };
      var isInputInsideCheckoutFormEvent = ({
        target
      }) => {
        const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, target);
        if (target instanceof HTMLInputElement && checkoutForm) {
          return target;
        } else {
          return false;
        }
      };
      var handleRenderCheckout = (event, apolloClient, stripeStore) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
          return;
        }
        const errors = [];
        const {
          detail
        } = event;
        if (detail != null && detail.error) {
          errors.push(detail.error);
        }
        const focusedEle = window.document.activeElement;
        const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, focusedEle);
        let prevFocusedInput = null;
        if (focusedEle instanceof HTMLInputElement && checkoutForm) {
          prevFocusedInput = focusedEle.id;
          if (!prevFocusedInput) {
            prevFocusedInput = focusedEle.getAttribute("data-wf-bindings");
          }
          prevFocusedInput = prevFocusedInput ? null : prevFocusedInput;
        }
        const checkoutFormContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER);
        (0, _checkoutUtils.renderCheckoutFormContainers)(checkoutFormContainers, errors, apolloClient, stripeStore, prevFocusedInput);
      };
      var checkFormValidity = ({
        customerInfo,
        shippingAddress,
        shippingInfo,
        billingAddress,
        billingAddressToggle,
        additionalInfo,
        requiresShipping
      }) => {
        if (!HTMLFormElement.prototype.reportValidity) {
          return true;
        }
        if (!customerInfo.reportValidity() || requiresShipping && !shippingAddress.reportValidity() || requiresShipping && !shippingInfo.reportValidity() || // only check the billing address if the toggle is off, i.e. the billing address
        // form is being shown or if it does not require shipping
        (!requiresShipping || !billingAddressToggle.checked) && !billingAddress.reportValidity() || additionalInfo && additionalInfo instanceof HTMLFormElement && !additionalInfo.reportValidity()) {
          return false;
        }
        return true;
      };
      var placingOrder = false;
      var startOrderFlow = (placeOrderButton) => {
        placingOrder = true;
        window.addEventListener("beforeunload", _checkoutUtils.beforeUnloadHandler);
        const buttonText = placeOrderButton.innerHTML;
        const loadingText = placeOrderButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
        placeOrderButton.innerHTML = loadingText ? loadingText : _constants.CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT;
        const finishOrderFlow = (isRedirecting = false) => {
          if (!isRedirecting) {
            placingOrder = false;
          }
          window.removeEventListener("beforeunload", _checkoutUtils.beforeUnloadHandler);
          placeOrderButton.innerHTML = buttonText ? buttonText : _constants.CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT;
        };
        return finishOrderFlow;
      };
      var handlePlaceOrder = (event, apolloClient, stripeStore) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview") || placingOrder) {
          return;
        }
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof Element)) {
          return;
        }
        const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, currentTarget);
        if (!(checkoutFormContainer instanceof Element)) {
          return;
        }
        const errorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE, checkoutFormContainer);
        const customerInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER, checkoutFormContainer);
        const shippingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, checkoutFormContainer);
        const shippingInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, checkoutFormContainer);
        const billingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkoutFormContainer);
        const billingAddressToggle = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX, checkoutFormContainer);
        const placeOrderButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, checkoutFormContainer);
        const additionalInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO, checkoutFormContainer);
        if (!(errorState instanceof HTMLElement) || !(customerInfo instanceof HTMLFormElement) || !(shippingAddress instanceof HTMLFormElement) || !(shippingInfo instanceof HTMLFormElement) || !(billingAddress instanceof HTMLFormElement) || !(billingAddressToggle instanceof HTMLInputElement) || !(placeOrderButton instanceof Element)) {
          return;
        }
        const errorMessage = errorState.querySelector(_constants.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR);
        if (errorMessage && errorMessage.hasAttribute(_constants.NEEDS_REFRESH)) {
          return;
        }
        const hasAdditionalInfo = additionalInfo && additionalInfo instanceof HTMLElement;
        const finishOrderFlow = startOrderFlow(placeOrderButton);
        errorState.style.setProperty("display", "none");
        (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({
          requiresShipping,
          isFreeOrder
        }) => {
          const isFormValid = checkFormValidity({
            customerInfo,
            shippingAddress,
            shippingInfo,
            billingAddress,
            billingAddressToggle,
            additionalInfo,
            requiresShipping
          });
          if (!isFormValid) {
            finishOrderFlow();
            return;
          }
          const customerInfoFormData = (0, _commerceUtils.formToObject)(customerInfo);
          const email = String(customerInfoFormData.email).trim();
          const shippingAddressInfo = (0, _extends2.default)({
            type: "shipping"
          }, (0, _commerceUtils.formToObject)(shippingAddress, true));
          const billingAddressInfo = (0, _extends2.default)({
            type: "billing"
          }, (0, _commerceUtils.formToObject)(!billingAddressToggle.checked || !requiresShipping ? billingAddress : shippingAddress, true));
          const stripeBillingAddressInfo = {
            billing_details: {
              name: billingAddressInfo.name,
              email,
              address: {
                line1: billingAddressInfo.address_line1,
                line2: billingAddressInfo.address_line2,
                city: billingAddressInfo.address_city,
                state: billingAddressInfo.address_state,
                country: billingAddressInfo.address_country,
                postal_code: billingAddressInfo.address_zip
              }
            }
          };
          let shippingMethodId = "";
          if (requiresShipping && shippingInfo.elements["shipping-method-choice"]) {
            const shippingMethodChoice = shippingInfo.querySelector('input[name="shipping-method-choice"]:checked');
            if (shippingMethodChoice) {
              shippingMethodId = shippingMethodChoice.value;
            }
          }
          const customData = hasAdditionalInfo ? (0, _commerceUtils.customDataFormToArray)(additionalInfo) : [];
          const syncCheckoutForm = Promise.all([(0, _checkoutUtils.createOrderIdentityMutation)(apolloClient, email), (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, billingAddressInfo), requiresShipping ? (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, shippingAddressInfo) : Promise.resolve(), requiresShipping ? (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, shippingMethodId) : Promise.resolve(), hasAdditionalInfo ? (0, _checkoutUtils.createCustomDataMutation)(apolloClient, customData) : Promise.resolve()]);
          syncCheckoutForm.then(() => {
            if (isFreeOrder) {
              return Promise.resolve();
            }
            if (!stripeStore.isInitialized()) {
              return Promise.reject(new Error("Stripe has not been set up for this project \u2013 Go to the project's Ecommerce Payment settings in the Designer to link Stripe."));
            }
            const stripe = stripeStore.getStripeInstance();
            const checkoutFormInstance = parseInt(checkoutFormContainer.getAttribute(_constants.STRIPE_ELEMENT_INSTANCE), 10);
            const card = stripeStore.getElement("cardNumber", checkoutFormInstance);
            return stripe.createPaymentMethod("card", card, stripeBillingAddressInfo);
          }).then((data) => {
            if (!data || isFreeOrder) {
              return Promise.resolve();
            }
            if (data.error) {
              return Promise.reject(data.error);
            }
            return (0, _checkoutUtils.createStripePaymentMethodMutation)(apolloClient, data.paymentMethod.id);
          }).then(() => {
            return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
              checkoutType: "normal"
            });
          }).then((data) => {
            _debug.default.log(data);
            const order = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(data);
            if ((0, _checkoutUtils.orderRequiresAdditionalAction)(order.status)) {
              const stripe = stripeStore.getStripeInstance();
              return stripe.retrievePaymentIntent(order.clientSecret).then((retrieveResult) => {
                const intent = retrieveResult && retrieveResult.paymentIntent || {};
                const actionPromise = intent.confirmation_method === "automatic" ? stripe.confirmCardPayment(order.clientSecret) : stripe.handleCardAction(order.clientSecret);
                return actionPromise.then((result) => {
                  if (result.error) {
                    return Promise.reject(result.error);
                  }
                  return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
                    checkoutType: "normal",
                    paymentIntentId: result.paymentIntent.id
                  }).then((resp) => {
                    const finishedOrder = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(resp);
                    if (finishedOrder.ok) {
                      finishOrderFlow(true);
                      (0, _checkoutUtils.redirectToOrderConfirmation)(finishedOrder);
                    }
                  });
                });
              });
            }
            if (order.ok) {
              finishOrderFlow(true);
              (0, _checkoutUtils.redirectToOrderConfirmation)(order);
            }
          }).catch((err) => {
            finishOrderFlow();
            _debug.default.error(err);
            errorState.style.removeProperty("display");
            (0, _checkoutUtils.updateErrorMessage)(errorState, err);
          });
        });
      };
      var handleApplyDiscount = (event, apolloClient) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof Element)) {
          return;
        }
        const inputEl = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT, currentTarget);
        const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, currentTarget) || (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER, currentTarget);
        if (!checkoutFormContainer) {
          return;
        }
        const errorStateEl = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ERROR_STATE, checkoutFormContainer);
        if (!(inputEl instanceof HTMLInputElement && errorStateEl instanceof HTMLElement)) {
          return;
        }
        const discountCode = inputEl.value.trim().toUpperCase();
        (0, _checkoutUtils.applyDiscount)(apolloClient, {
          discountCode
        }).then(() => {
          inputEl.value = "";
          errorStateEl.style.display = "none";
          (0, _commerceUtils.triggerRender)(null);
        }).catch((error) => (0, _checkoutUtils.showErrorMessageForError)(error, checkoutFormContainer));
      };
      var handleUpdateCustomerInfo = (event, apolloClient) => {
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof HTMLInputElement)) {
          return;
        }
        const value = currentTarget.value.trim();
        const email = value == null || value === "" ? null : value;
        (0, _checkoutUtils.createOrderIdentityMutation)(apolloClient, email).then(() => {
          (0, _commerceUtils.triggerRender)(null);
        }).catch((err) => {
          (0, _commerceUtils.triggerRender)(err);
        });
      };
      var handleUpdateAddress = (0, _debounce.default)((event, apolloClient) => {
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof HTMLFormElement)) {
          return;
        }
        const type = currentTarget.getAttribute(_constants.DATA_ATTR_NODE_TYPE) === _constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER ? "shipping" : "billing";
        const addressInfo = (0, _extends2.default)({
          type
        }, (0, _commerceUtils.formToObject)(currentTarget, true));
        (0, _checkoutUtils.createOrderAddressMutation)(apolloClient, addressInfo).then(() => {
          (0, _commerceUtils.triggerRender)(null);
        }).catch((err) => {
          (0, _commerceUtils.triggerRender)(err);
        });
      }, 500);
      var handleToggleBillingAddress = ({
        currentTarget
      }) => {
        const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, currentTarget);
        if (!checkoutFormContainer) {
          return;
        }
        const billingAddressWrapper = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkoutFormContainer);
        if (!billingAddressWrapper || !(currentTarget instanceof HTMLInputElement)) {
          return;
        }
        if (currentTarget.checked) {
          billingAddressWrapper.style.setProperty("display", "none");
        } else {
          billingAddressWrapper.style.removeProperty("display");
        }
      };
      var handleChooseShippingMethod = ({
        currentTarget
      }, apolloClient) => {
        if (!(currentTarget instanceof HTMLInputElement)) {
          return;
        }
        (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, currentTarget.id).then(() => {
          (0, _commerceUtils.triggerRender)(null);
        }).catch((err) => {
          (0, _commerceUtils.triggerRender)(err);
        });
      };
      var handleSubmitFormInsideCheckoutContainer = (event, apolloClient) => {
        if (event.type === "submit") {
          event.preventDefault();
        }
        if (event.type === "keyup" && event.keyCode !== 13 || !(event.currentTarget instanceof Element)) {
          return;
        }
        if (event.target === (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_INPUT)) {
          return;
        }
        const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_FORM_CONTAINER, event.currentTarget);
        if (!(checkoutFormContainer instanceof Element)) {
          return;
        }
        const customerInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_CUSTOMER_INFO_WRAPPER, checkoutFormContainer);
        const shippingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_ADDRESS_WRAPPER, checkoutFormContainer);
        const shippingInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, checkoutFormContainer);
        const billingAddress = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_WRAPPER, checkoutFormContainer);
        const billingAddressToggle = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_BILLING_ADDRESS_TOGGLE_CHECKBOX, checkoutFormContainer);
        const additionalInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO, checkoutFormContainer);
        if (!(customerInfo instanceof HTMLFormElement) || !(shippingAddress instanceof HTMLFormElement) || !(shippingInfo instanceof HTMLFormElement) || !(billingAddress instanceof HTMLFormElement) || !(billingAddressToggle instanceof HTMLInputElement)) {
          return;
        }
        const hasAdditionalInfo = additionalInfo && additionalInfo instanceof HTMLFormElement;
        (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({
          requiresShipping
        }) => {
          checkFormValidity({
            customerInfo,
            shippingAddress,
            shippingInfo,
            billingAddress,
            billingAddressToggle,
            additionalInfo: hasAdditionalInfo ? additionalInfo : null,
            requiresShipping
          });
        });
      };
      var register = (handlerProxy) => {
        handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderCheckout);
        handlerProxy.on("click", isPlaceOrderButtonEvent, handlePlaceOrder);
        handlerProxy.on("keydown", isPlaceOrderButtonEvent, (event, apolloClient, StripeStore) => {
          if (event.which === 32) {
            event.preventDefault();
          }
          if (event.which === 13) {
            return handlePlaceOrder(event, apolloClient, StripeStore);
          }
        });
        handlerProxy.on("keyup", isPlaceOrderButtonEvent, (event, apolloClient, StripeStore) => {
          if (event.which === 32) {
            return handlePlaceOrder(event, apolloClient, StripeStore);
          }
        });
        handlerProxy.on("submit", isApplyDiscountFormEvent, handleApplyDiscount);
        handlerProxy.on("change", isInputInsideCustomerInfoEvent, handleUpdateCustomerInfo);
        handlerProxy.on("change", isInputInsideAddressWrapperEvent, handleUpdateAddress);
        handlerProxy.on("change", isBillingAddressToggleEvent, handleToggleBillingAddress);
        handlerProxy.on("change", isInputInsideShippingMethodEvent, handleChooseShippingMethod);
        handlerProxy.on("submit", isFormInsideCheckoutContainerEvent, handleSubmitFormInsideCheckoutContainer);
        handlerProxy.on("keyup", isInputInsideCheckoutFormEvent, handleSubmitFormInsideCheckoutContainer);
      };
      exports.register = register;
      var _default = {
        register
      };
      exports.default = _default;
    }
  });

  // node_modules/qs/lib/utils.js
  var require_utils3 = __commonJS({
    "node_modules/qs/lib/utils.js"(exports, module) {
      "use strict";
      var has2 = Object.prototype.hasOwnProperty;
      var isArray = Array.isArray;
      var hexTable = function() {
        var array = [];
        for (var i = 0; i < 256; ++i) {
          array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
        }
        return array;
      }();
      var compactQueue = function compactQueue2(queue) {
        while (queue.length > 1) {
          var item = queue.pop();
          var obj = item.obj[item.prop];
          if (isArray(obj)) {
            var compacted = [];
            for (var j = 0; j < obj.length; ++j) {
              if (typeof obj[j] !== "undefined") {
                compacted.push(obj[j]);
              }
            }
            item.obj[item.prop] = compacted;
          }
        }
      };
      var arrayToObject = function arrayToObject2(source, options) {
        var obj = options && options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        for (var i = 0; i < source.length; ++i) {
          if (typeof source[i] !== "undefined") {
            obj[i] = source[i];
          }
        }
        return obj;
      };
      var merge2 = function merge3(target, source, options) {
        if (!source) {
          return target;
        }
        if (typeof source !== "object") {
          if (isArray(target)) {
            target.push(source);
          } else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !has2.call(Object.prototype, source)) {
              target[source] = true;
            }
          } else {
            return [target, source];
          }
          return target;
        }
        if (!target || typeof target !== "object") {
          return [target].concat(source);
        }
        var mergeTarget = target;
        if (isArray(target) && !isArray(source)) {
          mergeTarget = arrayToObject(target, options);
        }
        if (isArray(target) && isArray(source)) {
          source.forEach(function(item, i) {
            if (has2.call(target, i)) {
              var targetItem = target[i];
              if (targetItem && typeof targetItem === "object" && item && typeof item === "object") {
                target[i] = merge3(targetItem, item, options);
              } else {
                target.push(item);
              }
            } else {
              target[i] = item;
            }
          });
          return target;
        }
        return Object.keys(source).reduce(function(acc, key) {
          var value = source[key];
          if (has2.call(acc, key)) {
            acc[key] = merge3(acc[key], value, options);
          } else {
            acc[key] = value;
          }
          return acc;
        }, mergeTarget);
      };
      var assign2 = function assignSingleSource(target, source) {
        return Object.keys(source).reduce(function(acc, key) {
          acc[key] = source[key];
          return acc;
        }, target);
      };
      var decode = function(str, decoder, charset) {
        var strWithoutPlus = str.replace(/\+/g, " ");
        if (charset === "iso-8859-1") {
          return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
        }
        try {
          return decodeURIComponent(strWithoutPlus);
        } catch (e) {
          return strWithoutPlus;
        }
      };
      var encode = function encode2(str, defaultEncoder, charset) {
        if (str.length === 0) {
          return str;
        }
        var string = str;
        if (typeof str === "symbol") {
          string = Symbol.prototype.toString.call(str);
        } else if (typeof str !== "string") {
          string = String(str);
        }
        if (charset === "iso-8859-1") {
          return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
            return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
          });
        }
        var out = "";
        for (var i = 0; i < string.length; ++i) {
          var c = string.charCodeAt(i);
          if (c === 45 || c === 46 || c === 95 || c === 126 || c >= 48 && c <= 57 || c >= 65 && c <= 90 || c >= 97 && c <= 122) {
            out += string.charAt(i);
            continue;
          }
          if (c < 128) {
            out = out + hexTable[c];
            continue;
          }
          if (c < 2048) {
            out = out + (hexTable[192 | c >> 6] + hexTable[128 | c & 63]);
            continue;
          }
          if (c < 55296 || c >= 57344) {
            out = out + (hexTable[224 | c >> 12] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63]);
            continue;
          }
          i += 1;
          c = 65536 + ((c & 1023) << 10 | string.charCodeAt(i) & 1023);
          out += hexTable[240 | c >> 18] + hexTable[128 | c >> 12 & 63] + hexTable[128 | c >> 6 & 63] + hexTable[128 | c & 63];
        }
        return out;
      };
      var compact = function compact2(value) {
        var queue = [{ obj: { o: value }, prop: "o" }];
        var refs = [];
        for (var i = 0; i < queue.length; ++i) {
          var item = queue[i];
          var obj = item.obj[item.prop];
          var keys = Object.keys(obj);
          for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
              queue.push({ obj, prop: key });
              refs.push(val);
            }
          }
        }
        compactQueue(queue);
        return value;
      };
      var isRegExp = function isRegExp2(obj) {
        return Object.prototype.toString.call(obj) === "[object RegExp]";
      };
      var isBuffer = function isBuffer2(obj) {
        if (!obj || typeof obj !== "object") {
          return false;
        }
        return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
      };
      var combine = function combine2(a, b) {
        return [].concat(a, b);
      };
      var maybeMap = function maybeMap2(val, fn) {
        if (isArray(val)) {
          var mapped = [];
          for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
          }
          return mapped;
        }
        return fn(val);
      };
      module.exports = {
        arrayToObject,
        assign: assign2,
        combine,
        compact,
        decode,
        encode,
        isBuffer,
        isRegExp,
        maybeMap,
        merge: merge2
      };
    }
  });

  // node_modules/qs/lib/formats.js
  var require_formats = __commonJS({
    "node_modules/qs/lib/formats.js"(exports, module) {
      "use strict";
      var replace2 = String.prototype.replace;
      var percentTwenties = /%20/g;
      var util = require_utils3();
      var Format = {
        RFC1738: "RFC1738",
        RFC3986: "RFC3986"
      };
      module.exports = util.assign(
        {
          "default": Format.RFC3986,
          formatters: {
            RFC1738: function(value) {
              return replace2.call(value, percentTwenties, "+");
            },
            RFC3986: function(value) {
              return String(value);
            }
          }
        },
        Format
      );
    }
  });

  // node_modules/qs/lib/stringify.js
  var require_stringify = __commonJS({
    "node_modules/qs/lib/stringify.js"(exports, module) {
      "use strict";
      var utils = require_utils3();
      var formats = require_formats();
      var has2 = Object.prototype.hasOwnProperty;
      var arrayPrefixGenerators = {
        brackets: function brackets(prefix) {
          return prefix + "[]";
        },
        comma: "comma",
        indices: function indices(prefix, key) {
          return prefix + "[" + key + "]";
        },
        repeat: function repeat(prefix) {
          return prefix;
        }
      };
      var isArray = Array.isArray;
      var push = Array.prototype.push;
      var pushToArray = function(arr, valueOrArray) {
        push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
      };
      var toISO = Date.prototype.toISOString;
      var defaultFormat = formats["default"];
      var defaults = {
        addQueryPrefix: false,
        allowDots: false,
        charset: "utf-8",
        charsetSentinel: false,
        delimiter: "&",
        encode: true,
        encoder: utils.encode,
        encodeValuesOnly: false,
        format: defaultFormat,
        formatter: formats.formatters[defaultFormat],
        // deprecated
        indices: false,
        serializeDate: function serializeDate(date) {
          return toISO.call(date);
        },
        skipNulls: false,
        strictNullHandling: false
      };
      var isNonNullishPrimitive = function isNonNullishPrimitive2(v) {
        return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
      };
      var stringify4 = function stringify5(object, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encoder, filter2, sort, allowDots, serializeDate, formatter, encodeValuesOnly, charset) {
        var obj = object;
        if (typeof filter2 === "function") {
          obj = filter2(prefix, obj);
        } else if (obj instanceof Date) {
          obj = serializeDate(obj);
        } else if (generateArrayPrefix === "comma" && isArray(obj)) {
          obj = utils.maybeMap(obj, function(value2) {
            if (value2 instanceof Date) {
              return serializeDate(value2);
            }
            return value2;
          }).join(",");
        }
        if (obj === null) {
          if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, "key") : prefix;
          }
          obj = "";
        }
        if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
          if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, "key");
            return [formatter(keyValue) + "=" + formatter(encoder(obj, defaults.encoder, charset, "value"))];
          }
          return [formatter(prefix) + "=" + formatter(String(obj))];
        }
        var values2 = [];
        if (typeof obj === "undefined") {
          return values2;
        }
        var objKeys;
        if (isArray(filter2)) {
          objKeys = filter2;
        } else {
          var keys = Object.keys(obj);
          objKeys = sort ? keys.sort(sort) : keys;
        }
        for (var i = 0; i < objKeys.length; ++i) {
          var key = objKeys[i];
          var value = obj[key];
          if (skipNulls && value === null) {
            continue;
          }
          var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(prefix, key) : prefix : prefix + (allowDots ? "." + key : "[" + key + "]");
          pushToArray(values2, stringify5(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter2,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly,
            charset
          ));
        }
        return values2;
      };
      var normalizeStringifyOptions = function normalizeStringifyOptions2(opts) {
        if (!opts) {
          return defaults;
        }
        if (opts.encoder !== null && opts.encoder !== void 0 && typeof opts.encoder !== "function") {
          throw new TypeError("Encoder has to be a function.");
        }
        var charset = opts.charset || defaults.charset;
        if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
          throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        }
        var format = formats["default"];
        if (typeof opts.format !== "undefined") {
          if (!has2.call(formats.formatters, opts.format)) {
            throw new TypeError("Unknown format option provided.");
          }
          format = opts.format;
        }
        var formatter = formats.formatters[format];
        var filter2 = defaults.filter;
        if (typeof opts.filter === "function" || isArray(opts.filter)) {
          filter2 = opts.filter;
        }
        return {
          addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : defaults.addQueryPrefix,
          allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
          charset,
          charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
          delimiter: typeof opts.delimiter === "undefined" ? defaults.delimiter : opts.delimiter,
          encode: typeof opts.encode === "boolean" ? opts.encode : defaults.encode,
          encoder: typeof opts.encoder === "function" ? opts.encoder : defaults.encoder,
          encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
          filter: filter2,
          formatter,
          serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : defaults.serializeDate,
          skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : defaults.skipNulls,
          sort: typeof opts.sort === "function" ? opts.sort : null,
          strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
        };
      };
      module.exports = function(object, opts) {
        var obj = object;
        var options = normalizeStringifyOptions(opts);
        var objKeys;
        var filter2;
        if (typeof options.filter === "function") {
          filter2 = options.filter;
          obj = filter2("", obj);
        } else if (isArray(options.filter)) {
          filter2 = options.filter;
          objKeys = filter2;
        }
        var keys = [];
        if (typeof obj !== "object" || obj === null) {
          return "";
        }
        var arrayFormat;
        if (opts && opts.arrayFormat in arrayPrefixGenerators) {
          arrayFormat = opts.arrayFormat;
        } else if (opts && "indices" in opts) {
          arrayFormat = opts.indices ? "indices" : "repeat";
        } else {
          arrayFormat = "indices";
        }
        var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
        if (!objKeys) {
          objKeys = Object.keys(obj);
        }
        if (options.sort) {
          objKeys.sort(options.sort);
        }
        for (var i = 0; i < objKeys.length; ++i) {
          var key = objKeys[i];
          if (options.skipNulls && obj[key] === null) {
            continue;
          }
          pushToArray(keys, stringify4(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
          ));
        }
        var joined = keys.join(options.delimiter);
        var prefix = options.addQueryPrefix === true ? "?" : "";
        if (options.charsetSentinel) {
          if (options.charset === "iso-8859-1") {
            prefix += "utf8=%26%2310003%3B&";
          } else {
            prefix += "utf8=%E2%9C%93&";
          }
        }
        return joined.length > 0 ? prefix + joined : "";
      };
    }
  });

  // node_modules/qs/lib/parse.js
  var require_parse = __commonJS({
    "node_modules/qs/lib/parse.js"(exports, module) {
      "use strict";
      var utils = require_utils3();
      var has2 = Object.prototype.hasOwnProperty;
      var isArray = Array.isArray;
      var defaults = {
        allowDots: false,
        allowPrototypes: false,
        arrayLimit: 20,
        charset: "utf-8",
        charsetSentinel: false,
        comma: false,
        decoder: utils.decode,
        delimiter: "&",
        depth: 5,
        ignoreQueryPrefix: false,
        interpretNumericEntities: false,
        parameterLimit: 1e3,
        parseArrays: true,
        plainObjects: false,
        strictNullHandling: false
      };
      var interpretNumericEntities = function(str) {
        return str.replace(/&#(\d+);/g, function($0, numberStr) {
          return String.fromCharCode(parseInt(numberStr, 10));
        });
      };
      var parseArrayValue = function(val, options) {
        if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) {
          return val.split(",");
        }
        return val;
      };
      var isoSentinel = "utf8=%26%2310003%3B";
      var charsetSentinel = "utf8=%E2%9C%93";
      var parseValues = function parseQueryStringValues(str, options) {
        var obj = {};
        var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
        var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
        var parts = cleanStr.split(options.delimiter, limit);
        var skipIndex = -1;
        var i;
        var charset = options.charset;
        if (options.charsetSentinel) {
          for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf("utf8=") === 0) {
              if (parts[i] === charsetSentinel) {
                charset = "utf-8";
              } else if (parts[i] === isoSentinel) {
                charset = "iso-8859-1";
              }
              skipIndex = i;
              i = parts.length;
            }
          }
        }
        for (i = 0; i < parts.length; ++i) {
          if (i === skipIndex) {
            continue;
          }
          var part = parts[i];
          var bracketEqualsPos = part.indexOf("]=");
          var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
          var key, val;
          if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
          } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, "key");
            val = utils.maybeMap(
              parseArrayValue(part.slice(pos + 1), options),
              function(encodedVal) {
                return options.decoder(encodedVal, defaults.decoder, charset, "value");
              }
            );
          }
          if (val && options.interpretNumericEntities && charset === "iso-8859-1") {
            val = interpretNumericEntities(val);
          }
          if (part.indexOf("[]=") > -1) {
            val = isArray(val) ? [val] : val;
          }
          if (has2.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
          } else {
            obj[key] = val;
          }
        }
        return obj;
      };
      var parseObject = function(chain, val, options, valuesParsed) {
        var leaf = valuesParsed ? val : parseArrayValue(val, options);
        for (var i = chain.length - 1; i >= 0; --i) {
          var obj;
          var root = chain[i];
          if (root === "[]" && options.parseArrays) {
            obj = [].concat(leaf);
          } else {
            obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === "") {
              obj = { 0: leaf };
            } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && (options.parseArrays && index <= options.arrayLimit)) {
              obj = [];
              obj[index] = leaf;
            } else {
              obj[cleanRoot] = leaf;
            }
          }
          leaf = obj;
        }
        return leaf;
      };
      var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
        if (!givenKey) {
          return;
        }
        var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
        var brackets = /(\[[^[\]]*])/;
        var child = /(\[[^[\]]*])/g;
        var segment = options.depth > 0 && brackets.exec(key);
        var parent = segment ? key.slice(0, segment.index) : key;
        var keys = [];
        if (parent) {
          if (!options.plainObjects && has2.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
              return;
            }
          }
          keys.push(parent);
        }
        var i = 0;
        while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
          i += 1;
          if (!options.plainObjects && has2.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
              return;
            }
          }
          keys.push(segment[1]);
        }
        if (segment) {
          keys.push("[" + key.slice(segment.index) + "]");
        }
        return parseObject(keys, val, options, valuesParsed);
      };
      var normalizeParseOptions = function normalizeParseOptions2(opts) {
        if (!opts) {
          return defaults;
        }
        if (opts.decoder !== null && opts.decoder !== void 0 && typeof opts.decoder !== "function") {
          throw new TypeError("Decoder has to be a function.");
        }
        if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") {
          throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        }
        var charset = typeof opts.charset === "undefined" ? defaults.charset : opts.charset;
        return {
          allowDots: typeof opts.allowDots === "undefined" ? defaults.allowDots : !!opts.allowDots,
          allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : defaults.allowPrototypes,
          arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : defaults.arrayLimit,
          charset,
          charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : defaults.charsetSentinel,
          comma: typeof opts.comma === "boolean" ? opts.comma : defaults.comma,
          decoder: typeof opts.decoder === "function" ? opts.decoder : defaults.decoder,
          delimiter: typeof opts.delimiter === "string" || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
          // eslint-disable-next-line no-implicit-coercion, no-extra-parens
          depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : defaults.depth,
          ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
          interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
          parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : defaults.parameterLimit,
          parseArrays: opts.parseArrays !== false,
          plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : defaults.plainObjects,
          strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : defaults.strictNullHandling
        };
      };
      module.exports = function(str, opts) {
        var options = normalizeParseOptions(opts);
        if (str === "" || str === null || typeof str === "undefined") {
          return options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        }
        var tempObj = typeof str === "string" ? parseValues(str, options) : str;
        var obj = options.plainObjects ? /* @__PURE__ */ Object.create(null) : {};
        var keys = Object.keys(tempObj);
        for (var i = 0; i < keys.length; ++i) {
          var key = keys[i];
          var newObj = parseKeys(key, tempObj[key], options, typeof str === "string");
          obj = utils.merge(obj, newObj, options);
        }
        return utils.compact(obj);
      };
    }
  });

  // node_modules/qs/lib/index.js
  var require_lib5 = __commonJS({
    "node_modules/qs/lib/index.js"(exports, module) {
      "use strict";
      var stringify4 = require_stringify();
      var parse = require_parse();
      var formats = require_formats();
      module.exports = {
        formats,
        parse,
        stringify: stringify4
      };
    }
  });

  // packages/shared/render/plugins/Commerce/modules/orderConfirmationEvents.js
  var require_orderConfirmationEvents = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/orderConfirmationEvents.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.register = exports.default = void 0;
      var _extends2 = _interopRequireDefault(require_extends());
      var _graphqlTag = _interopRequireDefault(require_graphql_tag_umd());
      var _qs = _interopRequireDefault(require_lib5());
      var _eventHandlerProxyWithApolloClient = _interopRequireDefault(require_eventHandlerProxyWithApolloClient());
      var _commerceUtils = require_commerceUtils();
      var _rendering = require_rendering();
      var _constants = require_constants2();
      var renderOrderConfirmation = (orderConfirmation, data) => {
        (0, _rendering.renderTree)(orderConfirmation, data);
      };
      var handleRenderOrderConfirmation = (event, apolloClient) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
          return;
        }
        const errors = [];
        const {
          detail
        } = event;
        if (detail != null && detail.error) {
          errors.push(detail.error);
        }
        const orderConfirmationContainer = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER);
        if (!orderConfirmationContainer) {
          return;
        }
        const {
          orderId,
          token
        } = _qs.default.parse(window.location.search.substring(1));
        if (!orderId || !token) {
          return;
        }
        const finalizedOrder = {
          orderId,
          token
        };
        (0, _commerceUtils.trackOrder)(apolloClient, finalizedOrder);
        const allOrderConfirmationContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_ORDER_CONFIRMATION_WRAPPER);
        apolloClient.query({
          query: (0, _graphqlTag.default)`
        ${orderConfirmationContainer.getAttribute(_constants.ORDER_QUERY)}
      `,
          variables: {
            finalizedOrder
          },
          fetchPolicy: "network-only",
          // errorPolicy is set to `all` so that we continue to get the cart data when an error occurs
          // this is important in cases like when the address entered doesn't have a shipping zone, as that returns
          // a graphQL error, but we still want to render what the customer has entered
          errorPolicy: "all"
        }).then((data) => {
          allOrderConfirmationContainers.forEach((orderConfirmationContainerNode) => {
            renderOrderConfirmation(orderConfirmationContainerNode, (0, _extends2.default)({}, data, {
              errors: errors.concat(data.errors).filter(Boolean)
            }));
          });
        }).catch((err) => {
          errors.push(err);
          allOrderConfirmationContainers.forEach((orderConfirmationContainerNode) => {
            renderOrderConfirmation(orderConfirmationContainerNode, {
              errors
            });
          });
        });
      };
      var register = (handlerProxy) => {
        handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderOrderConfirmation);
      };
      exports.register = register;
      var _default = {
        register
      };
      exports.default = _default;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/paypalEvents.js
  var require_paypalEvents = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/paypalEvents.js"(exports) {
      "use strict";
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.renderPaypalButtons = exports.default = void 0;
      var _eventHandlerProxyWithApolloClient = _interopRequireDefault(require_eventHandlerProxyWithApolloClient());
      var _commerceUtils = require_commerceUtils();
      var _checkoutUtils = require_checkoutUtils();
      var _cartUtils = require_cartUtils();
      var _debug = _interopRequireDefault(require_debug());
      var _checkoutMutations = require_checkoutMutations();
      var _constants = require_constants2();
      var isPlaceOrderButtonEvent = ({
        target
      }) => {
        const placeOrderButton = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, target);
        if (placeOrderButton && target instanceof Element) {
          return target;
        } else {
          return false;
        }
      };
      var hasSyncedWithPaypal = false;
      var handleRenderPayPalCheckout = (event, apolloClient) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview")) {
          return;
        }
        if (!(event instanceof CustomEvent && event.type === _constants.RENDER_TREE_EVENT)) {
          return;
        }
        const checkoutFormContainers = (0, _commerceUtils.findAllElementsByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER);
        if (!checkoutFormContainers || checkoutFormContainers.length === 0) {
          return;
        }
        const errors = [];
        const {
          detail
        } = event;
        if (detail != null && detail.error) {
          errors.push(detail.error);
        }
        const focusedEle = window.document.activeElement;
        const checkoutForm = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER, focusedEle);
        let prevFocusedInput = null;
        if (focusedEle instanceof HTMLInputElement && checkoutForm) {
          prevFocusedInput = focusedEle.id;
          if (!prevFocusedInput) {
            prevFocusedInput = focusedEle.getAttribute("data-wf-bindings");
          }
          prevFocusedInput = prevFocusedInput ? null : prevFocusedInput;
        }
        const syncWithPayPalIfNeeded = !hasSyncedWithPaypal ? apolloClient.mutate({
          mutation: _checkoutMutations.syncPayPalOrderInfo
        }) : Promise.resolve();
        syncWithPayPalIfNeeded.then(() => {
          hasSyncedWithPaypal = true;
          (0, _checkoutUtils.renderCheckoutFormContainers)(checkoutFormContainers, errors, apolloClient, void 0, prevFocusedInput);
        });
      };
      var placingOrder = false;
      var startOrderFlow = (placeOrderButton) => {
        placingOrder = true;
        window.addEventListener("beforeunload", _checkoutUtils.beforeUnloadHandler);
        const buttonText = placeOrderButton.innerHTML;
        const loadingText = placeOrderButton.getAttribute(_constants.DATA_ATTR_LOADING_TEXT);
        placeOrderButton.innerHTML = loadingText ? loadingText : _constants.CHECKOUT_PLACE_ORDER_LOADING_TEXT_DEFAULT;
        const finishOrderFlow = (isRedirecting = false) => {
          if (!isRedirecting) {
            placingOrder = false;
          }
          window.removeEventListener("beforeunload", _checkoutUtils.beforeUnloadHandler);
          placeOrderButton.innerHTML = buttonText ? buttonText : _constants.CHECKOUT_PLACE_ORDER_BUTTON_TEXT_DEFAULT;
        };
        return finishOrderFlow;
      };
      var checkFormValidity = ({
        shippingInfo,
        additionalInfo,
        requiresShipping
      }) => {
        if (!HTMLFormElement.prototype.reportValidity) {
          return true;
        }
        if (requiresShipping && !shippingInfo.reportValidity() || additionalInfo && additionalInfo instanceof HTMLFormElement && !additionalInfo.reportValidity()) {
          return false;
        }
        return true;
      };
      var handlePlaceOrder = (event, apolloClient) => {
        if (window.Webflow.env("design") || window.Webflow.env("preview") || placingOrder) {
          return;
        }
        const {
          currentTarget
        } = event;
        if (!(currentTarget instanceof Element)) {
          return;
        }
        const checkoutFormContainer = (0, _commerceUtils.findClosestElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_FORM_CONTAINER, currentTarget);
        if (!(checkoutFormContainer instanceof Element)) {
          return;
        }
        const errorState = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_PAYPAL_CHECKOUT_ERROR_STATE, checkoutFormContainer);
        const shippingInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_SHIPPING_METHODS_WRAPPER, checkoutFormContainer);
        const placeOrderButton = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_PLACE_ORDER_BUTTON, checkoutFormContainer);
        const additionalInfo = (0, _commerceUtils.findElementByNodeType)(_constants.NODE_TYPE_COMMERCE_CHECKOUT_ADDITIONAL_INFO, checkoutFormContainer);
        if (!(errorState instanceof HTMLElement) || !(shippingInfo instanceof HTMLFormElement) || !(placeOrderButton instanceof Element)) {
          return;
        }
        const errorMessage = errorState.querySelector(_constants.CART_CHECKOUT_ERROR_MESSAGE_SELECTOR);
        if (errorMessage && errorMessage.hasAttribute(_constants.NEEDS_REFRESH)) {
          return;
        }
        const hasAdditionalInfo = additionalInfo && additionalInfo instanceof HTMLElement;
        const finishOrderFlow = startOrderFlow(placeOrderButton);
        errorState.style.setProperty("display", "none");
        (0, _commerceUtils.fetchOrderStatusFlags)(apolloClient).then(({
          requiresShipping
        }) => {
          const isFormValid = checkFormValidity({
            shippingInfo,
            additionalInfo,
            requiresShipping
          });
          if (!isFormValid) {
            finishOrderFlow();
            return;
          }
          let shippingMethodId = "";
          if (requiresShipping && shippingInfo.elements["shipping-method-choice"]) {
            const shippingMethodChoice = shippingInfo.querySelector('input[name="shipping-method-choice"]:checked');
            if (shippingMethodChoice) {
              shippingMethodId = shippingMethodChoice.value;
            }
          }
          const customData = hasAdditionalInfo ? (0, _commerceUtils.customDataFormToArray)(additionalInfo) : [];
          const syncPayPalCheckoutForm = Promise.all([requiresShipping ? (0, _checkoutUtils.createOrderShippingMethodMutation)(apolloClient, shippingMethodId) : Promise.resolve(), hasAdditionalInfo ? (0, _checkoutUtils.createCustomDataMutation)(apolloClient, customData) : Promise.resolve()]);
          syncPayPalCheckoutForm.then(() => {
            return (0, _checkoutUtils.createAttemptSubmitOrderRequest)(apolloClient, {
              checkoutType: "paypal"
            });
          }).then((data) => {
            _debug.default.log(data);
            const order = (0, _checkoutUtils.getOrderDataFromGraphQLResponse)(data);
            if (order.ok) {
              finishOrderFlow(true);
              (0, _checkoutUtils.redirectToOrderConfirmation)(order, true);
            }
          }).catch((err) => {
            finishOrderFlow();
            _debug.default.error(err);
            errorState.style.removeProperty("display");
            (0, _checkoutUtils.updateErrorMessage)(errorState, err);
            if (err.graphQLErrors && err.graphQLErrors[0] && err.graphQLErrors[0].message) {
              const parsedError = (0, _commerceUtils.safeParseJson)(err.graphQLErrors[0].message);
              if (!parsedError) {
                return;
              }
              if (parsedError.details && parsedError.details[0] && parsedError.details[0].issue === "INSTRUMENT_DECLINED") {
                const message = {
                  isWebflow: true,
                  type: "error",
                  detail: parsedError
                };
                window.parent.postMessage(JSON.stringify(message), window.location.origin);
              }
            }
          });
        });
      };
      var iframeStyle = `
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  width: 100vw;
  height: 100vh;
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
  z-index: 2147483647;
  border: 0;
  background-color: #ffffff;
`;
      var createConfirmationIframe = (actions) => {
        const documentRoot = document.documentElement;
        const documentBody = document.querySelector("body");
        if (!documentRoot || !documentBody) {
          return;
        }
        const iframe = document.createElement("iframe");
        iframe.setAttribute("style", iframeStyle);
        iframe.setAttribute("src", "/paypal-checkout");
        if (!documentBody.parentNode) {
          return;
        }
        documentBody.parentNode.appendChild(iframe);
        const previousRootOverflow = documentRoot.style.overflow;
        documentRoot.style.overflow = "hidden";
        const previousBodyDisplay = documentBody.style.display;
        documentBody.style.display = "none";
        const paypalMessageHandler = (event) => {
          if (event.origin !== window.location.origin) {
            return;
          }
          const data = (0, _commerceUtils.safeParseJson)(String(event.data));
          if (!data || data.isWebflow !== true || !data.type || !data.detail) {
            return;
          }
          if (data.type === "success") {
            window.removeEventListener("message", paypalMessageHandler);
            window.location.href = data.detail;
          }
          if (data.type === "error") {
            window.removeEventListener("message", paypalMessageHandler);
            if (previousRootOverflow) {
              documentRoot.style.overflow = previousRootOverflow;
            } else {
              documentRoot.style.overflow = "";
            }
            if (previousBodyDisplay) {
              documentBody.style.display = previousBodyDisplay;
            } else {
              documentBody.style.display = "";
            }
            if (documentBody.parentNode) {
              documentBody.parentNode.removeChild(iframe);
            }
            actions.restart();
          }
        };
        window.addEventListener("message", paypalMessageHandler);
      };
      var renderPaypalButtons = (apolloClient) => () => {
        const paypalElement = document.querySelector(`[${_constants.PAYPAL_ELEMENT_INSTANCE}]`);
        const buttons = Array.from(document.querySelectorAll(`[${_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE}]`));
        if (paypalElement && buttons && buttons.length > 0) {
          buttons.forEach((button) => {
            const style = (0, _commerceUtils.safeParseJson)(button.getAttribute(_constants.PAYPAL_BUTTON_ELEMENT_INSTANCE));
            window.paypal.Buttons({
              style,
              createOrder() {
                return apolloClient.mutate({
                  mutation: _checkoutMutations.requestPayPalOrderMutation
                }).then((data) => {
                  const {
                    data: {
                      ecommercePaypalOrderRequest: {
                        orderId
                      }
                    }
                  } = data;
                  return orderId;
                }).catch((err) => {
                  (0, _checkoutUtils.showErrorMessageForError)(err);
                  if ((0, _cartUtils.isCartOpen)()) {
                    (0, _cartUtils.showErrorMessageForError)(err);
                  }
                  throw err;
                });
              },
              onApprove(data, actions) {
                createConfirmationIframe(actions);
              }
            }).render(button);
          });
        }
      };
      exports.renderPaypalButtons = renderPaypalButtons;
      var register = (handlerProxy) => {
        handlerProxy.on(_constants.RENDER_TREE_EVENT, Boolean, handleRenderPayPalCheckout);
        handlerProxy.on("click", isPlaceOrderButtonEvent, handlePlaceOrder);
        handlerProxy.on("keydown", isPlaceOrderButtonEvent, (event, apolloClient) => {
          if (event.which === 32) {
            event.preventDefault();
          }
          if (event.which === 13) {
            return handlePlaceOrder(event, apolloClient);
          }
        });
        handlerProxy.on("keyup", isPlaceOrderButtonEvent, (event, apolloClient) => {
          if (event.which === 32) {
            return handlePlaceOrder(event, apolloClient);
          }
        });
      };
      var _default = {
        register
      };
      exports.default = _default;
    }
  });

  // packages/shared/render/plugins/Commerce/modules/index.js
  var require_modules = __commonJS({
    "packages/shared/render/plugins/Commerce/modules/index.js"(exports) {
      "use strict";
      var _interopRequireWildcard = require_interopRequireWildcard().default;
      var _interopRequireDefault = require_interopRequireDefault().default;
      Object.defineProperty(exports, "__esModule", {
        value: true
      });
      exports.design = design;
      exports.destroy = destroy;
      exports.init = init;
      exports.preview = preview;
      require_polyfill();
      require_symbol3();
      require_array3();
      require_repeat3();
      require_entries3();
      require_for_each2();
      require_number3();
      var _apolloClient = (init_apolloClient(), __toCommonJS(apolloClient_exports));
      var _eventHandlerProxyWithApolloClient = _interopRequireDefault(require_eventHandlerProxyWithApolloClient());
      var _addToCartEvents = _interopRequireDefault(require_addToCartEvents());
      var _cartEvents = _interopRequireDefault(require_cartEvents());
      var _checkoutEvents = _interopRequireDefault(require_checkoutEvents());
      var _orderConfirmationEvents = _interopRequireDefault(require_orderConfirmationEvents());
      var _webPaymentsEvents = _interopRequireDefault(require_webPaymentsEvents());
      var _stripeStore = require_stripeStore();
      var _commerceUtils = require_commerceUtils();
      init_polyfill();
      require_polyfill2();
      var _checkoutUtils = require_checkoutUtils();
      var _paypalEvents = _interopRequireWildcard(require_paypalEvents());
      var GQL_QUERY_PATH = "/.wf_graphql/apollo";
      var handlerProxy;
      var apolloClient;
      var stripeStore;
      function attachHandlers() {
        handlerProxy && handlerProxy.attachHandlers(window);
      }
      function detachHandlers() {
        handlerProxy && handlerProxy.removeHandlers(window);
      }
      function init({
        siteId
      }) {
        apolloClient = (0, _apolloClient.createApolloClient)({
          path: window.Webflow.env("design") || window.Webflow.env("preview") ? `/api/v1/sites/${siteId}/apollo` : GQL_QUERY_PATH,
          retryConfig: {
            maxAttempts: 5
          },
          useCsrf: true
        });
        stripeStore = new _stripeStore.StripeStore(document);
        handlerProxy = new _eventHandlerProxyWithApolloClient.default(apolloClient, stripeStore);
        _addToCartEvents.default.register(handlerProxy);
        _cartEvents.default.register(handlerProxy);
        _checkoutEvents.default.register(handlerProxy);
        _orderConfirmationEvents.default.register(handlerProxy);
        _webPaymentsEvents.default.register(handlerProxy);
        _paypalEvents.default.register(handlerProxy);
        (0, _checkoutUtils.initializeStripeElements)(stripeStore);
        detachHandlers();
        attachHandlers();
        (0, _commerceUtils.triggerRender)(null, true);
        if (!window.Webflow.env()) {
          window.Webflow.load((0, _paypalEvents.renderPaypalButtons)(apolloClient));
        }
      }
      function preview() {
        detachHandlers();
        attachHandlers();
        (0, _commerceUtils.triggerRender)(null, true);
      }
      function design() {
        detachHandlers();
        if (apolloClient && apolloClient.store) {
          apolloClient.resetStore();
        }
      }
      function destroy() {
        detachHandlers();
      }
    }
  });

  // packages/shared/render/plugins/Commerce/webflow-commerce.js
  var require_webflow_commerce = __commonJS({
    "packages/shared/render/plugins/Commerce/webflow-commerce.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      var {
        design,
        destroy,
        init,
        preview
      } = require_modules();
      Webflow2.define("commerce", module.exports = function() {
        return {
          design,
          destroy,
          init,
          preview
        };
      });
    }
  });

  // packages/shared/render/plugins/Dropdown/webflow-dropdown.js
  var require_webflow_dropdown = __commonJS({
    "packages/shared/render/plugins/Dropdown/webflow-dropdown.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      var IXEvents = require_webflow_ix2_events();
      var KEY_CODES = {
        ARROW_LEFT: 37,
        ARROW_UP: 38,
        ARROW_RIGHT: 39,
        ARROW_DOWN: 40,
        ESCAPE: 27,
        SPACE: 32,
        ENTER: 13,
        HOME: 36,
        END: 35
      };
      var FORCE_CLOSE = true;
      var INTERNAL_PAGE_LINK_HASHES_PATTERN = /^#[a-zA-Z0-9\-_]+$/;
      Webflow2.define("dropdown", module.exports = function($2, _) {
        var debounce = _.debounce;
        var api = {};
        var inApp = Webflow2.env();
        var inPreview = false;
        var inDesigner;
        var touch = Webflow2.env.touch;
        var namespace = ".w-dropdown";
        var openStateClassName = "w--open";
        var ix = IXEvents.triggers;
        var defaultZIndex = 900;
        var focusOutEvent = "focusout" + namespace;
        var keydownEvent = "keydown" + namespace;
        var mouseEnterEvent = "mouseenter" + namespace;
        var mouseMoveEvent = "mousemove" + namespace;
        var mouseLeaveEvent = "mouseleave" + namespace;
        var mouseUpEvent = (touch ? "click" : "mouseup") + namespace;
        var closeEvent = "w-close" + namespace;
        var settingEvent = "setting" + namespace;
        var $doc = $2(document);
        var $dropdowns;
        api.ready = init;
        api.design = function() {
          if (inPreview) {
            closeAll();
          }
          inPreview = false;
          init();
        };
        api.preview = function() {
          inPreview = true;
          init();
        };
        function init() {
          inDesigner = inApp && Webflow2.env("design");
          $dropdowns = $doc.find(namespace);
          $dropdowns.each(build);
        }
        function build(i, el) {
          var $el = $2(el);
          var data = $2.data(el, namespace);
          if (!data) {
            data = $2.data(el, namespace, {
              open: false,
              el: $el,
              config: {},
              selectedIdx: -1
            });
          }
          data.toggle = data.el.children(".w-dropdown-toggle");
          data.list = data.el.children(".w-dropdown-list");
          data.links = data.list.find("a:not(.w-dropdown .w-dropdown a)");
          data.complete = complete(data);
          data.mouseLeave = makeMouseLeaveHandler(data);
          data.mouseUpOutside = outside(data);
          data.mouseMoveOutside = moveOutside(data);
          configure(data);
          var toggleId = data.toggle.attr("id");
          var listId = data.list.attr("id");
          if (!toggleId) {
            toggleId = "w-dropdown-toggle-" + i;
          }
          if (!listId) {
            listId = "w-dropdown-list-" + i;
          }
          data.toggle.attr("id", toggleId);
          data.toggle.attr("aria-controls", listId);
          data.toggle.attr("aria-haspopup", "menu");
          data.toggle.attr("aria-expanded", "false");
          data.toggle.find(".w-icon-dropdown-toggle").attr("aria-hidden", "true");
          if (data.toggle.prop("tagName") !== "BUTTON") {
            data.toggle.attr("role", "button");
            if (!data.toggle.attr("tabindex")) {
              data.toggle.attr("tabindex", "0");
            }
          }
          data.list.attr("id", listId);
          data.list.attr("aria-labelledby", toggleId);
          data.links.each(function(idx, link) {
            if (!link.hasAttribute("tabindex"))
              link.setAttribute("tabindex", "0");
            if (INTERNAL_PAGE_LINK_HASHES_PATTERN.test(link.hash)) {
              link.addEventListener("click", close.bind(null, data));
            }
          });
          data.el.off(namespace);
          data.toggle.off(namespace);
          if (data.nav) {
            data.nav.off(namespace);
          }
          var initialToggler = makeToggler(data, FORCE_CLOSE);
          if (inDesigner) {
            data.el.on(settingEvent, makeSettingEventHandler(data));
          }
          if (!inDesigner) {
            if (inApp) {
              data.hovering = false;
              close(data);
            }
            if (data.config.hover) {
              data.toggle.on(mouseEnterEvent, makeMouseEnterHandler(data));
            }
            data.el.on(closeEvent, initialToggler);
            data.el.on(keydownEvent, makeDropdownKeydownHandler(data));
            data.el.on(focusOutEvent, makeDropdownFocusOutHandler(data));
            data.toggle.on(mouseUpEvent, initialToggler);
            data.toggle.on(keydownEvent, makeToggleKeydownHandler(data));
            data.nav = data.el.closest(".w-nav");
            data.nav.on(closeEvent, initialToggler);
          }
        }
        function configure(data) {
          var zIndex = Number(data.el.css("z-index"));
          data.manageZ = zIndex === defaultZIndex || zIndex === defaultZIndex + 1;
          data.config = {
            hover: data.el.attr("data-hover") === "true" && !touch,
            delay: data.el.attr("data-delay")
          };
        }
        function makeSettingEventHandler(data) {
          return function(evt, options) {
            options = options || {};
            configure(data);
            options.open === true && open(data, true);
            options.open === false && close(data, {
              immediate: true
            });
          };
        }
        function makeToggler(data, forceClose) {
          return debounce(function(evt) {
            if (data.open || evt && evt.type === "w-close") {
              return close(data, {
                forceClose
              });
            }
            open(data);
          });
        }
        function open(data) {
          if (data.open) {
            return;
          }
          closeOthers(data);
          data.open = true;
          data.list.addClass(openStateClassName);
          data.toggle.addClass(openStateClassName);
          data.toggle.attr("aria-expanded", "true");
          ix.intro(0, data.el[0]);
          Webflow2.redraw.up();
          data.manageZ && data.el.css("z-index", defaultZIndex + 1);
          var isEditor = Webflow2.env("editor");
          if (!inDesigner) {
            $doc.on(mouseUpEvent, data.mouseUpOutside);
          }
          if (data.hovering && !isEditor) {
            data.el.on(mouseLeaveEvent, data.mouseLeave);
          }
          if (data.hovering && isEditor) {
            $doc.on(mouseMoveEvent, data.mouseMoveOutside);
          }
          window.clearTimeout(data.delayId);
        }
        function close(data, {
          immediate,
          forceClose
        } = {}) {
          if (!data.open) {
            return;
          }
          if (data.config.hover && data.hovering && !forceClose) {
            return;
          }
          data.toggle.attr("aria-expanded", "false");
          data.open = false;
          var config = data.config;
          ix.outro(0, data.el[0]);
          $doc.off(mouseUpEvent, data.mouseUpOutside);
          $doc.off(mouseMoveEvent, data.mouseMoveOutside);
          data.el.off(mouseLeaveEvent, data.mouseLeave);
          window.clearTimeout(data.delayId);
          if (!config.delay || immediate) {
            return data.complete();
          }
          data.delayId = window.setTimeout(data.complete, config.delay);
        }
        function closeAll() {
          $doc.find(namespace).each(function(i, el) {
            $2(el).triggerHandler(closeEvent);
          });
        }
        function closeOthers(data) {
          var self2 = data.el[0];
          $dropdowns.each(function(i, other) {
            var $other = $2(other);
            if ($other.is(self2) || $other.has(self2).length) {
              return;
            }
            $other.triggerHandler(closeEvent);
          });
        }
        function outside(data) {
          if (data.mouseUpOutside) {
            $doc.off(mouseUpEvent, data.mouseUpOutside);
          }
          return debounce(function(evt) {
            if (!data.open) {
              return;
            }
            var $target = $2(evt.target);
            if ($target.closest(".w-dropdown-toggle").length) {
              return;
            }
            var isEventOutsideDropdowns = $2.inArray(data.el[0], $target.parents(namespace)) === -1;
            var isEditor = Webflow2.env("editor");
            if (isEventOutsideDropdowns) {
              if (isEditor) {
                var isEventOnDetachedSvg = $target.parents().length === 1 && $target.parents("svg").length === 1;
                var isEventOnHoverControls = $target.parents(".w-editor-bem-EditorHoverControls").length;
                if (isEventOnDetachedSvg || isEventOnHoverControls) {
                  return;
                }
              }
              close(data);
            }
          });
        }
        function complete(data) {
          return function() {
            data.list.removeClass(openStateClassName);
            data.toggle.removeClass(openStateClassName);
            data.manageZ && data.el.css("z-index", "");
          };
        }
        function makeMouseEnterHandler(data) {
          return function() {
            data.hovering = true;
            open(data);
          };
        }
        function makeMouseLeaveHandler(data) {
          return function() {
            data.hovering = false;
            if (!data.links.is(":focus")) {
              close(data);
            }
          };
        }
        function moveOutside(data) {
          return debounce(function(evt) {
            if (!data.open) {
              return;
            }
            var $target = $2(evt.target);
            var isEventOutsideDropdowns = $2.inArray(data.el[0], $target.parents(namespace)) === -1;
            if (isEventOutsideDropdowns) {
              var isEventOnHoverControls = $target.parents(".w-editor-bem-EditorHoverControls").length;
              var isEventOnHoverToolbar = $target.parents(".w-editor-bem-RTToolbar").length;
              var $editorOverlay = $2(".w-editor-bem-EditorOverlay");
              var isDropdownInEdition = $editorOverlay.find(".w-editor-edit-outline").length || $editorOverlay.find(".w-editor-bem-RTToolbar").length;
              if (isEventOnHoverControls || isEventOnHoverToolbar || isDropdownInEdition) {
                return;
              }
              data.hovering = false;
              close(data);
            }
          });
        }
        function makeDropdownKeydownHandler(data) {
          return function(evt) {
            if (inDesigner || !data.open) {
              return;
            }
            data.selectedIdx = data.links.index(document.activeElement);
            switch (evt.keyCode) {
              case KEY_CODES.HOME: {
                if (!data.open)
                  return;
                data.selectedIdx = 0;
                focusSelectedLink(data);
                return evt.preventDefault();
              }
              case KEY_CODES.END: {
                if (!data.open)
                  return;
                data.selectedIdx = data.links.length - 1;
                focusSelectedLink(data);
                return evt.preventDefault();
              }
              case KEY_CODES.ESCAPE: {
                close(data);
                data.toggle.focus();
                return evt.stopPropagation();
              }
              case KEY_CODES.ARROW_RIGHT:
              case KEY_CODES.ARROW_DOWN: {
                data.selectedIdx = Math.min(data.links.length - 1, data.selectedIdx + 1);
                focusSelectedLink(data);
                return evt.preventDefault();
              }
              case KEY_CODES.ARROW_LEFT:
              case KEY_CODES.ARROW_UP: {
                data.selectedIdx = Math.max(-1, data.selectedIdx - 1);
                focusSelectedLink(data);
                return evt.preventDefault();
              }
            }
          };
        }
        function focusSelectedLink(data) {
          if (data.links[data.selectedIdx]) {
            data.links[data.selectedIdx].focus();
          }
        }
        function makeToggleKeydownHandler(data) {
          var toggler = makeToggler(data, FORCE_CLOSE);
          return function(evt) {
            if (inDesigner)
              return;
            if (!data.open) {
              switch (evt.keyCode) {
                case KEY_CODES.ARROW_UP:
                case KEY_CODES.ARROW_DOWN: {
                  return evt.stopPropagation();
                }
              }
            }
            switch (evt.keyCode) {
              case KEY_CODES.SPACE:
              case KEY_CODES.ENTER: {
                toggler();
                evt.stopPropagation();
                return evt.preventDefault();
              }
            }
          };
        }
        function makeDropdownFocusOutHandler(data) {
          return debounce(function(evt) {
            var {
              relatedTarget,
              target
            } = evt;
            var menuEl = data.el[0];
            var menuContainsFocus = menuEl.contains(relatedTarget) || menuEl.contains(target);
            if (!menuContainsFocus) {
              close(data);
            }
            return evt.stopPropagation();
          });
        }
        return api;
      });
    }
  });

  // packages/shared/render/plugins/Form/webflow-forms.js
  var require_webflow_forms = __commonJS({
    "packages/shared/render/plugins/Form/webflow-forms.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      Webflow2.define("forms", module.exports = function($2, _) {
        var api = {};
        var $doc = $2(document);
        var $forms;
        var loc = window.location;
        var retro = window.XDomainRequest && !window.atob;
        var namespace = ".w-form";
        var siteId;
        var emailField = /e(-)?mail/i;
        var emailValue = /^\S+@\S+$/;
        var alert = window.alert;
        var inApp = Webflow2.env();
        var listening;
        var formUrl;
        var signFileUrl;
        var chimpRegex = /list-manage[1-9]?.com/i;
        var disconnected = _.debounce(function() {
          alert("Oops! This page has improperly configured forms. Please contact your website administrator to fix this issue.");
        }, 100);
        api.ready = api.design = api.preview = function() {
          init();
          if (!inApp && !listening) {
            addListeners();
          }
        };
        function init() {
          siteId = $2("html").attr("data-wf-site");
          formUrl = "https://webflow.com/api/v1/form/" + siteId;
          if (retro && formUrl.indexOf("https://webflow.com") >= 0) {
            formUrl = formUrl.replace("https://webflow.com", "https://formdata.webflow.com");
          }
          signFileUrl = `${formUrl}/signFile`;
          $forms = $2(namespace + " form");
          if (!$forms.length) {
            return;
          }
          $forms.each(build);
        }
        function build(i, el) {
          var $el = $2(el);
          var data = $2.data(el, namespace);
          if (!data) {
            data = $2.data(el, namespace, {
              form: $el
            });
          }
          reset(data);
          var wrap2 = $el.closest("div.w-form");
          data.done = wrap2.find("> .w-form-done");
          data.fail = wrap2.find("> .w-form-fail");
          data.fileUploads = wrap2.find(".w-file-upload");
          data.fileUploads.each(function(j) {
            initFileUpload(j, data);
          });
          var formName = data.form.attr("aria-label") || data.form.attr("data-name") || "Form";
          if (!data.done.attr("aria-label")) {
            data.form.attr("aria-label", formName);
          }
          data.done.attr("tabindex", "-1");
          data.done.attr("role", "region");
          if (!data.done.attr("aria-label")) {
            data.done.attr("aria-label", formName + " success");
          }
          data.fail.attr("tabindex", "-1");
          data.fail.attr("role", "region");
          if (!data.fail.attr("aria-label")) {
            data.fail.attr("aria-label", formName + " failure");
          }
          var action = data.action = $el.attr("action");
          data.handler = null;
          data.redirect = $el.attr("data-redirect");
          if (chimpRegex.test(action)) {
            data.handler = submitMailChimp;
            return;
          }
          if (action) {
            return;
          }
          if (siteId) {
            data.handler = true ? exportedSubmitWebflow : (() => {
              const hostedSubmitHandler = null.default;
              return hostedSubmitHandler(reset, loc, Webflow2, collectEnterpriseTrackingCookies, preventDefault, findFields, alert, findFileUploads, disableBtn, siteId, afterSubmit, $2, formUrl);
            })();
            return;
          }
          disconnected();
        }
        function addListeners() {
          listening = true;
          $doc.on("submit", namespace + " form", function(evt) {
            var data = $2.data(this, namespace);
            if (data.handler) {
              data.evt = evt;
              data.handler(data);
            }
          });
          const CHECKBOX_CLASS_NAME = ".w-checkbox-input";
          const RADIO_INPUT_CLASS_NAME = ".w-radio-input";
          const CHECKED_CLASS = "w--redirected-checked";
          const FOCUSED_CLASS = "w--redirected-focus";
          const FOCUSED_VISIBLE_CLASS = "w--redirected-focus-visible";
          const focusVisibleSelectors = ":focus-visible, [data-wf-focus-visible]";
          const CUSTOM_CONTROLS = [["checkbox", CHECKBOX_CLASS_NAME], ["radio", RADIO_INPUT_CLASS_NAME]];
          $doc.on("change", namespace + ` form input[type="checkbox"]:not(` + CHECKBOX_CLASS_NAME + ")", (evt) => {
            $2(evt.target).siblings(CHECKBOX_CLASS_NAME).toggleClass(CHECKED_CLASS);
          });
          $doc.on("change", namespace + ` form input[type="radio"]`, (evt) => {
            $2(`input[name="${evt.target.name}"]:not(${CHECKBOX_CLASS_NAME})`).map((i, el) => $2(el).siblings(RADIO_INPUT_CLASS_NAME).removeClass(CHECKED_CLASS));
            const $target = $2(evt.target);
            if (!$target.hasClass("w-radio-input")) {
              $target.siblings(RADIO_INPUT_CLASS_NAME).addClass(CHECKED_CLASS);
            }
          });
          CUSTOM_CONTROLS.forEach(([controlType, customControlClassName]) => {
            $doc.on("focus", namespace + ` form input[type="${controlType}"]:not(` + customControlClassName + ")", (evt) => {
              $2(evt.target).siblings(customControlClassName).addClass(FOCUSED_CLASS);
              $2(evt.target).filter(focusVisibleSelectors).siblings(customControlClassName).addClass(FOCUSED_VISIBLE_CLASS);
            });
            $doc.on("blur", namespace + ` form input[type="${controlType}"]:not(` + customControlClassName + ")", (evt) => {
              $2(evt.target).siblings(customControlClassName).removeClass(`${FOCUSED_CLASS} ${FOCUSED_VISIBLE_CLASS}`);
            });
          });
        }
        function reset(data) {
          var btn = data.btn = data.form.find(':input[type="submit"]');
          data.wait = data.btn.attr("data-wait") || null;
          data.success = false;
          btn.prop("disabled", false);
          data.label && btn.val(data.label);
        }
        function disableBtn(data) {
          var btn = data.btn;
          var wait = data.wait;
          btn.prop("disabled", true);
          if (wait) {
            data.label = btn.val();
            btn.val(wait);
          }
        }
        function findFields(form, result) {
          var status = null;
          result = result || {};
          form.find(':input:not([type="submit"]):not([type="file"])').each(function(i, el) {
            var field = $2(el);
            var type = field.attr("type");
            var name = field.attr("data-name") || field.attr("name") || "Field " + (i + 1);
            var value = field.val();
            if (type === "checkbox") {
              value = field.is(":checked");
            } else if (type === "radio") {
              if (result[name] === null || typeof result[name] === "string") {
                return;
              }
              value = form.find('input[name="' + field.attr("name") + '"]:checked').val() || null;
            }
            if (typeof value === "string") {
              value = $2.trim(value);
            }
            result[name] = value;
            status = status || getStatus(field, type, name, value);
          });
          return status;
        }
        function findFileUploads(form) {
          var result = {};
          form.find(':input[type="file"]').each(function(i, el) {
            var field = $2(el);
            var name = field.attr("data-name") || field.attr("name") || "File " + (i + 1);
            var value = field.attr("data-value");
            if (typeof value === "string") {
              value = $2.trim(value);
            }
            result[name] = value;
          });
          return result;
        }
        const trackingCookieNameMap = {
          _mkto_trk: "marketo"
          // __hstc: 'hubspot',
        };
        function collectEnterpriseTrackingCookies() {
          const cookies = document.cookie.split("; ").reduce(function(acc, cookie) {
            const splitCookie = cookie.split("=");
            const name = splitCookie[0];
            if (name in trackingCookieNameMap) {
              const mappedName = trackingCookieNameMap[name];
              const value = splitCookie.slice(1).join("=");
              acc[mappedName] = value;
            }
            return acc;
          }, {});
          return cookies;
        }
        function getStatus(field, type, name, value) {
          var status = null;
          if (type === "password") {
            status = "Passwords cannot be submitted.";
          } else if (field.attr("required")) {
            if (!value) {
              status = "Please fill out the required field: " + name;
            } else if (emailField.test(field.attr("type"))) {
              if (!emailValue.test(value)) {
                status = "Please enter a valid email address for: " + name;
              }
            }
          } else if (name === "g-recaptcha-response" && !value) {
            status = "Please confirm you\u2019re not a robot.";
          }
          return status;
        }
        function exportedSubmitWebflow(data) {
          preventDefault(data);
          afterSubmit(data);
        }
        function submitMailChimp(data) {
          reset(data);
          var form = data.form;
          var payload = {};
          if (/^https/.test(loc.href) && !/^https/.test(data.action)) {
            form.attr("method", "post");
            return;
          }
          preventDefault(data);
          var status = findFields(form, payload);
          if (status) {
            return alert(status);
          }
          disableBtn(data);
          var fullName;
          _.each(payload, function(value, key) {
            if (emailField.test(key)) {
              payload.EMAIL = value;
            }
            if (/^((full[ _-]?)?name)$/i.test(key)) {
              fullName = value;
            }
            if (/^(first[ _-]?name)$/i.test(key)) {
              payload.FNAME = value;
            }
            if (/^(last[ _-]?name)$/i.test(key)) {
              payload.LNAME = value;
            }
          });
          if (fullName && !payload.FNAME) {
            fullName = fullName.split(" ");
            payload.FNAME = fullName[0];
            payload.LNAME = payload.LNAME || fullName[1];
          }
          var url = data.action.replace("/post?", "/post-json?") + "&c=?";
          var userId = url.indexOf("u=") + 2;
          userId = url.substring(userId, url.indexOf("&", userId));
          var listId = url.indexOf("id=") + 3;
          listId = url.substring(listId, url.indexOf("&", listId));
          payload["b_" + userId + "_" + listId] = "";
          $2.ajax({
            url,
            data: payload,
            dataType: "jsonp"
          }).done(function(resp) {
            data.success = resp.result === "success" || /already/.test(resp.msg);
            if (!data.success) {
              console.info("MailChimp error: " + resp.msg);
            }
            afterSubmit(data);
          }).fail(function() {
            afterSubmit(data);
          });
        }
        function afterSubmit(data) {
          var form = data.form;
          var redirect = data.redirect;
          var success = data.success;
          if (success && redirect) {
            Webflow2.location(redirect);
            return;
          }
          data.done.toggle(success);
          data.fail.toggle(!success);
          if (success) {
            data.done.focus();
          } else {
            data.fail.focus();
          }
          form.toggle(!success);
          reset(data);
        }
        function preventDefault(data) {
          data.evt && data.evt.preventDefault();
          data.evt = null;
        }
        function initFileUpload(i, form) {
          if (!form.fileUploads || !form.fileUploads[i]) {
            return;
          }
          var file;
          var $el = $2(form.fileUploads[i]);
          var $defaultWrap = $el.find("> .w-file-upload-default");
          var $uploadingWrap = $el.find("> .w-file-upload-uploading");
          var $successWrap = $el.find("> .w-file-upload-success");
          var $errorWrap = $el.find("> .w-file-upload-error");
          var $input = $defaultWrap.find(".w-file-upload-input");
          var $label = $defaultWrap.find(".w-file-upload-label");
          var $labelChildren = $label.children();
          var $errorMsgEl = $errorWrap.find(".w-file-upload-error-msg");
          var $fileEl = $successWrap.find(".w-file-upload-file");
          var $removeEl = $successWrap.find(".w-file-remove-link");
          var $fileNameEl = $fileEl.find(".w-file-upload-file-name");
          var sizeErrMsg = $errorMsgEl.attr("data-w-size-error");
          var typeErrMsg = $errorMsgEl.attr("data-w-type-error");
          var genericErrMsg = $errorMsgEl.attr("data-w-generic-error");
          if (!inApp) {
            $label.on("click keydown", function(e) {
              if (e.type === "keydown" && e.which !== 13 && e.which !== 32) {
                return;
              }
              e.preventDefault();
              $input.click();
            });
          }
          $label.find(".w-icon-file-upload-icon").attr("aria-hidden", "true");
          $removeEl.find(".w-icon-file-upload-remove").attr("aria-hidden", "true");
          if (!inApp) {
            $removeEl.on("click keydown", function(e) {
              if (e.type === "keydown") {
                if (e.which !== 13 && e.which !== 32) {
                  return;
                }
                e.preventDefault();
              }
              $input.removeAttr("data-value");
              $input.val("");
              $fileNameEl.html("");
              $defaultWrap.toggle(true);
              $successWrap.toggle(false);
              $label.focus();
            });
            $input.on("change", function(e) {
              file = e.target && e.target.files && e.target.files[0];
              if (!file) {
                return;
              }
              $defaultWrap.toggle(false);
              $errorWrap.toggle(false);
              $uploadingWrap.toggle(true);
              $uploadingWrap.focus();
              $fileNameEl.text(file.name);
              if (!isUploading()) {
                disableBtn(form);
              }
              form.fileUploads[i].uploading = true;
              signFile(file, afterSign);
            });
            var height = $label.outerHeight();
            $input.height(height);
            $input.width(1);
          } else {
            $input.on("click", function(e) {
              e.preventDefault();
            });
            $label.on("click", function(e) {
              e.preventDefault();
            });
            $labelChildren.on("click", function(e) {
              e.preventDefault();
            });
          }
          function parseError(err) {
            var errorMsg = err.responseJSON && err.responseJSON.msg;
            var userError = genericErrMsg;
            if (typeof errorMsg === "string" && errorMsg.indexOf("InvalidFileTypeError") === 0) {
              userError = typeErrMsg;
            } else if (typeof errorMsg === "string" && errorMsg.indexOf("MaxFileSizeError") === 0) {
              userError = sizeErrMsg;
            }
            $errorMsgEl.text(userError);
            $input.removeAttr("data-value");
            $input.val("");
            $uploadingWrap.toggle(false);
            $defaultWrap.toggle(true);
            $errorWrap.toggle(true);
            $errorWrap.focus();
            form.fileUploads[i].uploading = false;
            if (!isUploading()) {
              reset(form);
            }
          }
          function afterSign(err, data) {
            if (err) {
              return parseError(err);
            }
            var fileName = data.fileName;
            var postData = data.postData;
            var fileId = data.fileId;
            var s3Url = data.s3Url;
            $input.attr("data-value", fileId);
            uploadS3(s3Url, postData, file, fileName, afterUpload);
          }
          function afterUpload(err) {
            if (err) {
              return parseError(err);
            }
            $uploadingWrap.toggle(false);
            $successWrap.css("display", "inline-block");
            $successWrap.focus();
            form.fileUploads[i].uploading = false;
            if (!isUploading()) {
              reset(form);
            }
          }
          function isUploading() {
            var uploads = form.fileUploads && form.fileUploads.toArray() || [];
            return uploads.some(function(value) {
              return value.uploading;
            });
          }
        }
        function signFile(file, cb) {
          var payload = new URLSearchParams({
            name: file.name,
            size: file.size
          });
          $2.ajax({
            type: "GET",
            url: `${signFileUrl}?${payload}`,
            crossDomain: true
          }).done(function(data) {
            cb(null, data);
          }).fail(function(err) {
            cb(err);
          });
        }
        function uploadS3(url, data, file, fileName, cb) {
          var formData = new FormData();
          for (var k in data) {
            formData.append(k, data[k]);
          }
          formData.append("file", file, fileName);
          $2.ajax({
            type: "POST",
            url,
            data: formData,
            processData: false,
            contentType: false
          }).done(function() {
            cb(null);
          }).fail(function(err) {
            cb(err);
          });
        }
        return api;
      });
    }
  });

  // packages/shared/render/plugins/Navbar/webflow-navbar.js
  var require_webflow_navbar = __commonJS({
    "packages/shared/render/plugins/Navbar/webflow-navbar.js"(exports, module) {
      var Webflow2 = require_webflow_lib();
      var IXEvents = require_webflow_ix2_events();
      var KEY_CODES = {
        ARROW_LEFT: 37,
        ARROW_UP: 38,
        ARROW_RIGHT: 39,
        ARROW_DOWN: 40,
        ESCAPE: 27,
        SPACE: 32,
        ENTER: 13,
        HOME: 36,
        END: 35
      };
      Webflow2.define("navbar", module.exports = function($2, _) {
        var api = {};
        var tram = $2.tram;
        var $win = $2(window);
        var $doc = $2(document);
        var debounce = _.debounce;
        var $body;
        var $navbars;
        var designer;
        var inEditor;
        var inApp = Webflow2.env();
        var overlay = '<div class="w-nav-overlay" data-wf-ignore />';
        var namespace = ".w-nav";
        var navbarOpenedButton = "w--open";
        var navbarOpenedDropdown = "w--nav-dropdown-open";
        var navbarOpenedDropdownToggle = "w--nav-dropdown-toggle-open";
        var navbarOpenedDropdownList = "w--nav-dropdown-list-open";
        var navbarOpenedLink = "w--nav-link-open";
        var ix = IXEvents.triggers;
        var menuSibling = $2();
        api.ready = api.design = api.preview = init;
        api.destroy = function() {
          menuSibling = $2();
          removeListeners();
          if ($navbars && $navbars.length) {
            $navbars.each(teardown);
          }
        };
        function init() {
          designer = inApp && Webflow2.env("design");
          inEditor = Webflow2.env("editor");
          $body = $2(document.body);
          $navbars = $doc.find(namespace);
          if (!$navbars.length) {
            return;
          }
          $navbars.each(build);
          removeListeners();
          addListeners();
        }
        function removeListeners() {
          Webflow2.resize.off(resizeAll);
        }
        function addListeners() {
          Webflow2.resize.on(resizeAll);
        }
        function resizeAll() {
          $navbars.each(resize);
        }
        function build(i, el) {
          var $el = $2(el);
          var data = $2.data(el, namespace);
          if (!data) {
            data = $2.data(el, namespace, {
              open: false,
              el: $el,
              config: {},
              selectedIdx: -1
            });
          }
          data.menu = $el.find(".w-nav-menu");
          data.links = data.menu.find(".w-nav-link");
          data.dropdowns = data.menu.find(".w-dropdown");
          data.dropdownToggle = data.menu.find(".w-dropdown-toggle");
          data.dropdownList = data.menu.find(".w-dropdown-list");
          data.button = $el.find(".w-nav-button");
          data.container = $el.find(".w-container");
          data.overlayContainerId = "w-nav-overlay-" + i;
          data.outside = outside(data);
          var navBrandLink = $el.find(".w-nav-brand");
          if (navBrandLink && navBrandLink.attr("href") === "/" && navBrandLink.attr("aria-label") == null) {
            navBrandLink.attr("aria-label", "home");
          }
          data.button.attr("style", "-webkit-user-select: text;");
          if (data.button.attr("aria-label") == null) {
            data.button.attr("aria-label", "menu");
          }
          data.button.attr("role", "button");
          data.button.attr("tabindex", "0");
          data.button.attr("aria-controls", data.overlayContainerId);
          data.button.attr("aria-haspopup", "menu");
          data.button.attr("aria-expanded", "false");
          data.el.off(namespace);
          data.button.off(namespace);
          data.menu.off(namespace);
          configure(data);
          if (designer) {
            removeOverlay(data);
            data.el.on("setting" + namespace, handler(data));
          } else {
            addOverlay(data);
            data.button.on("click" + namespace, toggle(data));
            data.menu.on("click" + namespace, "a", navigate(data));
            data.button.on("keydown" + namespace, makeToggleButtonKeyboardHandler(data));
            data.el.on("keydown" + namespace, makeLinksKeyboardHandler(data));
          }
          resize(i, el);
        }
        function teardown(i, el) {
          var data = $2.data(el, namespace);
          if (data) {
            removeOverlay(data);
            $2.removeData(el, namespace);
          }
        }
        function removeOverlay(data) {
          if (!data.overlay) {
            return;
          }
          close(data, true);
          data.overlay.remove();
          data.overlay = null;
        }
        function addOverlay(data) {
          if (data.overlay) {
            return;
          }
          data.overlay = $2(overlay).appendTo(data.el);
          data.overlay.attr("id", data.overlayContainerId);
          data.parent = data.menu.parent();
          close(data, true);
        }
        function configure(data) {
          var config = {};
          var old = data.config || {};
          var animation = config.animation = data.el.attr("data-animation") || "default";
          config.animOver = /^over/.test(animation);
          config.animDirect = /left$/.test(animation) ? -1 : 1;
          if (old.animation !== animation) {
            data.open && _.defer(reopen, data);
          }
          config.easing = data.el.attr("data-easing") || "ease";
          config.easing2 = data.el.attr("data-easing2") || "ease";
          var duration = data.el.attr("data-duration");
          config.duration = duration != null ? Number(duration) : 400;
          config.docHeight = data.el.attr("data-doc-height");
          data.config = config;
        }
        function handler(data) {
          return function(evt, options) {
            options = options || {};
            var winWidth = $win.width();
            configure(data);
            options.open === true && open(data, true);
            options.open === false && close(data, true);
            data.open && _.defer(function() {
              if (winWidth !== $win.width()) {
                reopen(data);
              }
            });
          };
        }
        function makeToggleButtonKeyboardHandler(data) {
          return function(evt) {
            switch (evt.keyCode) {
              case KEY_CODES.SPACE:
              case KEY_CODES.ENTER: {
                toggle(data)();
                evt.preventDefault();
                return evt.stopPropagation();
              }
              case KEY_CODES.ESCAPE: {
                close(data);
                evt.preventDefault();
                return evt.stopPropagation();
              }
              case KEY_CODES.ARROW_RIGHT:
              case KEY_CODES.ARROW_DOWN:
              case KEY_CODES.HOME:
              case KEY_CODES.END: {
                if (!data.open) {
                  evt.preventDefault();
                  return evt.stopPropagation();
                }
                if (evt.keyCode === KEY_CODES.END) {
                  data.selectedIdx = data.links.length - 1;
                } else {
                  data.selectedIdx = 0;
                }
                focusSelectedLink(data);
                evt.preventDefault();
                return evt.stopPropagation();
              }
            }
          };
        }
        function makeLinksKeyboardHandler(data) {
          return function(evt) {
            if (!data.open) {
              return;
            }
            data.selectedIdx = data.links.index(document.activeElement);
            switch (evt.keyCode) {
              case KEY_CODES.HOME:
              case KEY_CODES.END: {
                if (evt.keyCode === KEY_CODES.END) {
                  data.selectedIdx = data.links.length - 1;
                } else {
                  data.selectedIdx = 0;
                }
                focusSelectedLink(data);
                evt.preventDefault();
                return evt.stopPropagation();
              }
              case KEY_CODES.ESCAPE: {
                close(data);
                data.button.focus();
                evt.preventDefault();
                return evt.stopPropagation();
              }
              case KEY_CODES.ARROW_LEFT:
              case KEY_CODES.ARROW_UP: {
                data.selectedIdx = Math.max(-1, data.selectedIdx - 1);
                focusSelectedLink(data);
                evt.preventDefault();
                return evt.stopPropagation();
              }
              case KEY_CODES.ARROW_RIGHT:
              case KEY_CODES.ARROW_DOWN: {
                data.selectedIdx = Math.min(data.links.length - 1, data.selectedIdx + 1);
                focusSelectedLink(data);
                evt.preventDefault();
                return evt.stopPropagation();
              }
            }
          };
        }
        function focusSelectedLink(data) {
          if (data.links[data.selectedIdx]) {
            var selectedElement = data.links[data.selectedIdx];
            selectedElement.focus();
            navigate(selectedElement);
          }
        }
        function reopen(data) {
          if (!data.open) {
            return;
          }
          close(data, true);
          open(data, true);
        }
        function toggle(data) {
          return debounce(function() {
            data.open ? close(data) : open(data);
          });
        }
        function navigate(data) {
          return function(evt) {
            var link = $2(this);
            var href = link.attr("href");
            if (!Webflow2.validClick(evt.currentTarget)) {
              evt.preventDefault();
              return;
            }
            if (href && href.indexOf("#") === 0 && data.open) {
              close(data);
            }
          };
        }
        function outside(data) {
          if (data.outside) {
            $doc.off("click" + namespace, data.outside);
          }
          return function(evt) {
            var $target = $2(evt.target);
            if (inEditor && $target.closest(".w-editor-bem-EditorOverlay").length) {
              return;
            }
            outsideDebounced(data, $target);
          };
        }
        var outsideDebounced = debounce(function(data, $target) {
          if (!data.open) {
            return;
          }
          var menu = $target.closest(".w-nav-menu");
          if (!data.menu.is(menu)) {
            close(data);
          }
        });
        function resize(i, el) {
          var data = $2.data(el, namespace);
          var collapsed = data.collapsed = data.button.css("display") !== "none";
          if (data.open && !collapsed && !designer) {
            close(data, true);
          }
          if (data.container.length) {
            var updateEachMax = updateMax(data);
            data.links.each(updateEachMax);
            data.dropdowns.each(updateEachMax);
          }
          if (data.open) {
            setOverlayHeight(data);
          }
        }
        var maxWidth = "max-width";
        function updateMax(data) {
          var containMax = data.container.css(maxWidth);
          if (containMax === "none") {
            containMax = "";
          }
          return function(i, link) {
            link = $2(link);
            link.css(maxWidth, "");
            if (link.css(maxWidth) === "none") {
              link.css(maxWidth, containMax);
            }
          };
        }
        function addMenuOpen(i, el) {
          el.setAttribute("data-nav-menu-open", "");
        }
        function removeMenuOpen(i, el) {
          el.removeAttribute("data-nav-menu-open");
        }
        function open(data, immediate) {
          if (data.open) {
            return;
          }
          data.open = true;
          data.menu.each(addMenuOpen);
          data.links.addClass(navbarOpenedLink);
          data.dropdowns.addClass(navbarOpenedDropdown);
          data.dropdownToggle.addClass(navbarOpenedDropdownToggle);
          data.dropdownList.addClass(navbarOpenedDropdownList);
          data.button.addClass(navbarOpenedButton);
          var config = data.config;
          var animation = config.animation;
          if (animation === "none" || !tram.support.transform || config.duration <= 0) {
            immediate = true;
          }
          var bodyHeight = setOverlayHeight(data);
          var menuHeight = data.menu.outerHeight(true);
          var menuWidth = data.menu.outerWidth(true);
          var navHeight = data.el.height();
          var navbarEl = data.el[0];
          resize(0, navbarEl);
          ix.intro(0, navbarEl);
          Webflow2.redraw.up();
          if (!designer) {
            $doc.on("click" + namespace, data.outside);
          }
          if (immediate) {
            complete();
            return;
          }
          var transConfig = "transform " + config.duration + "ms " + config.easing;
          if (data.overlay) {
            menuSibling = data.menu.prev();
            data.overlay.show().append(data.menu);
          }
          if (config.animOver) {
            tram(data.menu).add(transConfig).set({
              x: config.animDirect * menuWidth,
              height: bodyHeight
            }).start({
              x: 0
            }).then(complete);
            data.overlay && data.overlay.width(menuWidth);
            return;
          }
          var offsetY = navHeight + menuHeight;
          tram(data.menu).add(transConfig).set({
            y: -offsetY
          }).start({
            y: 0
          }).then(complete);
          function complete() {
            data.button.attr("aria-expanded", "true");
          }
        }
        function setOverlayHeight(data) {
          var config = data.config;
          var bodyHeight = config.docHeight ? $doc.height() : $body.height();
          if (config.animOver) {
            data.menu.height(bodyHeight);
          } else if (data.el.css("position") !== "fixed") {
            bodyHeight -= data.el.outerHeight(true);
          }
          data.overlay && data.overlay.height(bodyHeight);
          return bodyHeight;
        }
        function close(data, immediate) {
          if (!data.open) {
            return;
          }
          data.open = false;
          data.button.removeClass(navbarOpenedButton);
          var config = data.config;
          if (config.animation === "none" || !tram.support.transform || config.duration <= 0) {
            immediate = true;
          }
          ix.outro(0, data.el[0]);
          $doc.off("click" + namespace, data.outside);
          if (immediate) {
            tram(data.menu).stop();
            complete();
            return;
          }
          var transConfig = "transform " + config.duration + "ms " + config.easing2;
          var menuHeight = data.menu.outerHeight(true);
          var menuWidth = data.menu.outerWidth(true);
          var navHeight = data.el.height();
          if (config.animOver) {
            tram(data.menu).add(transConfig).start({
              x: menuWidth * config.animDirect
            }).then(complete);
            return;
          }
          var offsetY = navHeight + menuHeight;
          tram(data.menu).add(transConfig).start({
            y: -offsetY
          }).then(complete);
          function complete() {
            data.menu.height("");
            tram(data.menu).set({
              x: 0,
              y: 0
            });
            data.menu.each(removeMenuOpen);
            data.links.removeClass(navbarOpenedLink);
            data.dropdowns.removeClass(navbarOpenedDropdown);
            data.dropdownToggle.removeClass(navbarOpenedDropdownToggle);
            data.dropdownList.removeClass(navbarOpenedDropdownList);
            if (data.overlay && data.overlay.children().length) {
              menuSibling.length ? data.menu.insertAfter(menuSibling) : data.menu.prependTo(data.parent);
              data.overlay.attr("style", "").hide();
            }
            data.el.triggerHandler("w-close");
            data.button.attr("aria-expanded", "false");
          }
        }
        return api;
      });
    }
  });

  // <stdin>
  require_objectFitPolyfill_basic();
  require_webflow_bgvideo();
  require_webflow_brand();
  require_webflow_focus_visible();
  require_webflow_focus();
  require_webflow_ix2_events();
  require_webflow_ix2();
  require_webflow_links();
  require_webflow_scroll();
  require_webflow_touch();
  require_webflow_commerce();
  require_webflow_dropdown();
  require_webflow_forms();
  require_webflow_navbar();
})();
/*!
 * tram.js v0.8.2-global
 * Cross-browser CSS3 transitions in JavaScript
 * https://github.com/bkwld/tram
 * MIT License
 */
/*!
 * Webflow._ (aka) Underscore.js 1.6.0 (custom build)
 * _.each
 * _.map
 * _.find
 * _.filter
 * _.any
 * _.contains
 * _.delay
 * _.defer
 * _.throttle (webflow)
 * _.debounce
 * _.keys
 * _.has
 * _.now
 * _.template (webflow: upgraded to 1.13.6)
 *
 * http://underscorejs.org
 * (c) 2009-2013 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Underscore may be freely distributed under the MIT license.
 * @license MIT
 */
/*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)

tslib/tslib.es6.js:
  (*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
  
  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
  
  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** *)

moment/moment.js:
  (*! moment.js *)

moment-timezone/moment-timezone.js:
  (*! moment-timezone.js *)
  (*! version : 0.5.31 *)
  (*! Copyright (c) JS Foundation and other contributors *)
  (*! license : MIT *)
  (*! github.com/moment/moment-timezone *)

accounting/accounting.js:
  (*!
   * accounting.js v0.4.1
   * Copyright 2014 Open Exchange Rates
   *
   * Freely distributable under the MIT license.
   * Portions of accounting.js are inspired or borrowed from underscore.js
   *
   * Full details and documentation:
   * http://openexchangerates.github.io/accounting.js/
   *)
*/
/**
 * ----------------------------------------------------------------------
 * Webflow: Interactions 2.0: Init
 */
Webflow.require('ix2').init(
{"events":{"e-3":{"id":"e-3","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-3","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-12"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"75346636-2ee5-2bef-04f0-70b5cf607ada","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"75346636-2ee5-2bef-04f0-70b5cf607ada","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1667123397372},"e-5":{"id":"e-5","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-4","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-14"}},"mediaQueries":["main"],"target":{"selector":".c-main-img-lightbox","originalId":"64805aa0bbbc71169f5593fb|aa4582fb-4ed2-defd-796d-63dbcbb9ea17","appliesTo":"CLASS"},"targets":[{"selector":".c-main-img-lightbox","originalId":"64805aa0bbbc71169f5593fb|aa4582fb-4ed2-defd-796d-63dbcbb9ea17","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1613901259615},"e-6":{"id":"e-6","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-5","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-13"}},"mediaQueries":["main"],"target":{"selector":".c-main-img-lightbox","originalId":"64805aa0bbbc71169f5593fb|aa4582fb-4ed2-defd-796d-63dbcbb9ea17","appliesTo":"CLASS"},"targets":[{"selector":".c-main-img-lightbox","originalId":"64805aa0bbbc71169f5593fb|aa4582fb-4ed2-defd-796d-63dbcbb9ea17","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1613901259616},"e-23":{"id":"e-23","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-6","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-24"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d92","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d92","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686289244879},"e-25":{"id":"e-25","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-26"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d94","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d94","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686289244879},"e-27":{"id":"e-27","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-8","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-28"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d96","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d96","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686289244879},"e-29":{"id":"e-29","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-9","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-30"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d98","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|2a8c9a59-de6f-4716-b865-a3d9a8f19d98","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686289244879},"e-31":{"id":"e-31","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-10","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|f5082fa6-bccb-cfcb-81cb-21490dee54f4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|f5082fa6-bccb-cfcb-81cb-21490dee54f4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686289990877},"e-33":{"id":"e-33","name":"","animationType":"custom","eventTypeId":"DROPDOWN_OPEN","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-34"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|abd5a06a-8527-9524-8237-f9e8d1cca1c5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|abd5a06a-8527-9524-8237-f9e8d1cca1c5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1606862675728},"e-34":{"id":"e-34","name":"","animationType":"custom","eventTypeId":"DROPDOWN_CLOSE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-12","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-33"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|abd5a06a-8527-9524-8237-f9e8d1cca1c5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|abd5a06a-8527-9524-8237-f9e8d1cca1c5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1606862675729},"e-35":{"id":"e-35","name":"","animationType":"preset","eventTypeId":"DROPDOWN_OPEN","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-36"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|99ba5ed1-8a45-423e-2892-c25617535455","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|99ba5ed1-8a45-423e-2892-c25617535455","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686294730168},"e-36":{"id":"e-36","name":"","animationType":"preset","eventTypeId":"DROPDOWN_CLOSE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-12","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-35"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|99ba5ed1-8a45-423e-2892-c25617535455","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|99ba5ed1-8a45-423e-2892-c25617535455","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686294730168},"e-37":{"id":"e-37","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-14","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-38"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"648071efbbbc71169f726e82","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"648071efbbbc71169f726e82","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686312356513},"e-39":{"id":"e-39","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-40"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"d5ff3e2c-3fbf-d5fb-bad2-e45eda605f81","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"d5ff3e2c-3fbf-d5fb-bad2-e45eda605f81","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":null,"effectIn":true},"createdOn":1686313120080},"e-41":{"id":"e-41","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-42"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cd7b7a-541f-ee46-ab21-a96bb8d58ad9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cd7b7a-541f-ee46-ab21-a96bb8d58ad9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686313359661},"e-43":{"id":"e-43","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-44"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64cd7b7a-541f-ee46-ab21-a96bb8d58adb","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64cd7b7a-541f-ee46-ab21-a96bb8d58adb","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686317539897},"e-45":{"id":"e-45","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-46"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"2fc84b52-de13-8c6b-cd80-227af021ffd5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"2fc84b52-de13-8c6b-cd80-227af021ffd5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686317669421},"e-47":{"id":"e-47","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-48"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"0d61385a-e525-8530-1069-5cf367f883be","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"0d61385a-e525-8530-1069-5cf367f883be","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686317694096},"e-49":{"id":"e-49","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-50"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"1592c5e5-00df-fc47-3398-715fca2e923f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"1592c5e5-00df-fc47-3398-715fca2e923f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686317709487},"e-53":{"id":"e-53","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-54"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"bb0658fd-943c-ea3f-992b-3d32b91944ec","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"bb0658fd-943c-ea3f-992b-3d32b91944ec","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686317831852},"e-55":{"id":"e-55","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-56"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e06f6e7b-02cd-9242-5ce0-6dc21376d566","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e06f6e7b-02cd-9242-5ce0-6dc21376d566","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686317846062},"e-59":{"id":"e-59","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-60"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"648071a062f7edb0c74e3ec7","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"648071a062f7edb0c74e3ec7","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686318061179},"e-61":{"id":"e-61","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-62"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b323cb2c-615d-b46c-f118-264def703955","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b323cb2c-615d-b46c-f118-264def703955","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686318173492},"e-63":{"id":"e-63","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-64"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"68f9a25c-ebcb-6f57-2e4d-3c9656fef3ba","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"68f9a25c-ebcb-6f57-2e4d-3c9656fef3ba","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686318189108},"e-79":{"id":"e-79","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-80"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f6ee2693-eb5a-abd2-cd07-dcc221dafe8e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"f6ee2693-eb5a-abd2-cd07-dcc221dafe8e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686318468485},"e-81":{"id":"e-81","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-82"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fd|c2b31986-f8da-af2c-c8d4-6f88ea96c73b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fd|c2b31986-f8da-af2c-c8d4-6f88ea96c73b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686318478806},"e-83":{"id":"e-83","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-84"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"18d894c6-5a69-bcd6-6d1e-6cfdfaa015db","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"18d894c6-5a69-bcd6-6d1e-6cfdfaa015db","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686318558945},"e-85":{"id":"e-85","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-86"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f559404|0eaa317c-96ae-65cb-ba91-825be9f370ab","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f559404|0eaa317c-96ae-65cb-ba91-825be9f370ab","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686318577218},"e-89":{"id":"e-89","name":"","animationType":"custom","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-17","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-90"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686318635853},"e-91":{"id":"e-91","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-92"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc792","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc792","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686318704678},"e-93":{"id":"e-93","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-94"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc797","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc797","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319270042},"e-94":{"id":"e-94","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-93"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc797","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc797","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319270044},"e-95":{"id":"e-95","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-96"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"2fc84b52-de13-8c6b-cd80-227af021ffe5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"2fc84b52-de13-8c6b-cd80-227af021ffe5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319770760},"e-96":{"id":"e-96","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-95"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"2fc84b52-de13-8c6b-cd80-227af021ffe5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"2fc84b52-de13-8c6b-cd80-227af021ffe5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319770806},"e-97":{"id":"e-97","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-98"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f559404|0eaa317c-96ae-65cb-ba91-825be9f370b0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f559404|0eaa317c-96ae-65cb-ba91-825be9f370b0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319875057},"e-98":{"id":"e-98","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-97"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f559404|0eaa317c-96ae-65cb-ba91-825be9f370b0","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f559404|0eaa317c-96ae-65cb-ba91-825be9f370b0","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319875059},"e-99":{"id":"e-99","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-100"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593f9|23b21af2-6c67-848c-fd83-b0344358b932","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593f9|23b21af2-6c67-848c-fd83-b0344358b932","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319910413},"e-100":{"id":"e-100","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-99"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593f9|23b21af2-6c67-848c-fd83-b0344358b932","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593f9|23b21af2-6c67-848c-fd83-b0344358b932","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686319910458},"e-101":{"id":"e-101","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-102"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fa|0ab661f6-1f47-92a7-19a8-3b77dba9dff5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fa|0ab661f6-1f47-92a7-19a8-3b77dba9dff5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686365057326},"e-103":{"id":"e-103","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-104"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fa|f594e3f0-9d6f-0ade-6c7b-31dd1d322c0d","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fa|f594e3f0-9d6f-0ade-6c7b-31dd1d322c0d","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686365131959},"e-105":{"id":"e-105","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-106"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fa|f594e3f0-9d6f-0ade-6c7b-31dd1d322c1f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fa|f594e3f0-9d6f-0ade-6c7b-31dd1d322c1f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686365131959},"e-106":{"id":"e-106","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fa|f594e3f0-9d6f-0ade-6c7b-31dd1d322c1f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fa|f594e3f0-9d6f-0ade-6c7b-31dd1d322c1f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1686365131959},"e-107":{"id":"e-107","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-108"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593f9|628ac644-7ca1-2ad3-5d59-ef351268c803","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593f9|628ac644-7ca1-2ad3-5d59-ef351268c803","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1686814478048},"e-109":{"id":"e-109","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-110"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"ed442ef2-1f0e-d002-7189-17474d1aca26","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"ed442ef2-1f0e-d002-7189-17474d1aca26","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1688728315075},"e-113":{"id":"e-113","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-114"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"1bd1105e-81b7-466b-58a1-295b3a31d346","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"1bd1105e-81b7-466b-58a1-295b3a31d346","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1695862103609},"e-115":{"id":"e-115","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-116"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5221b813-a406-fb7e-f8ac-0b2f27225170","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"5221b813-a406-fb7e-f8ac-0b2f27225170","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1695862105750},"e-117":{"id":"e-117","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-118"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"6c3b6fa3-6904-cbc1-e6e2-859d10836519","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6c3b6fa3-6904-cbc1-e6e2-859d10836519","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1695862106832},"e-119":{"id":"e-119","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-120"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"20e4ffe6-103f-c94c-0484-c7163c790171","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"20e4ffe6-103f-c94c-0484-c7163c790171","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1695862107704},"e-121":{"id":"e-121","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-122"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"277bcf24-e355-fd7f-c21c-f0c29058f3f7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"277bcf24-e355-fd7f-c21c-f0c29058f3f7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1695862108522},"e-123":{"id":"e-123","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"7b83bfe5-a7bc-d868-865a-58878586eeac","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"7b83bfe5-a7bc-d868-865a-58878586eeac","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1695862109216},"e-125":{"id":"e-125","name":"","animationType":"preset","eventTypeId":"DROPDOWN_OPEN","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|110ec331-61b9-50cb-5004-1c2e0fcc3a43","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|110ec331-61b9-50cb-5004-1c2e0fcc3a43","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1695873129201},"e-126":{"id":"e-126","name":"","animationType":"preset","eventTypeId":"DROPDOWN_CLOSE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-12","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-125"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|110ec331-61b9-50cb-5004-1c2e0fcc3a43","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|110ec331-61b9-50cb-5004-1c2e0fcc3a43","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1695873129201},"e-127":{"id":"e-127","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-128"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"7906428c-6ad6-ff2b-416c-06c09e4fafea","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"7906428c-6ad6-ff2b-416c-06c09e4fafea","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1695875722256},"e-129":{"id":"e-129","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-18","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-130"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"7906428c-6ad6-ff2b-416c-06c09e4fafef","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"7906428c-6ad6-ff2b-416c-06c09e4fafef","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1695875722256},"e-130":{"id":"e-130","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-19","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-129"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"7906428c-6ad6-ff2b-416c-06c09e4fafef","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"7906428c-6ad6-ff2b-416c-06c09e4fafef","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1695875722256},"e-131":{"id":"e-131","name":"","animationType":"preset","eventTypeId":"DROPDOWN_OPEN","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-11","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-132"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|bc498430-fe75-2255-1b61-2c493ffe2f35","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|bc498430-fe75-2255-1b61-2c493ffe2f35","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1695876732451},"e-132":{"id":"e-132","name":"","animationType":"preset","eventTypeId":"DROPDOWN_CLOSE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-12","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-131"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"64805aa0bbbc71169f5593fb|bc498430-fe75-2255-1b61-2c493ffe2f35","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"64805aa0bbbc71169f5593fb|bc498430-fe75-2255-1b61-2c493ffe2f35","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1695876732451}},"actionLists":{"a-3":{"id":"a-3","title":"Close Announcement Nav","actionItemGroups":[{"actionItems":[{"id":"a-3-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":300,"target":{"selector":".announcement-content","selectorGuids":["59f1dbd0-505e-095f-549a-e5bb4e662170"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-3-n-4","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"easeOut","duration":300,"target":{"useEventTarget":"PARENT","selector":".announcement-nav","selectorGuids":["248eb00d-1710-8d5f-8d92-74fb810a1847"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}}]},{"actionItems":[{"id":"a-3-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".announcement-nav","selectorGuids":["248eb00d-1710-8d5f-8d92-74fb810a1847"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1667073323115},"a-4":{"id":"a-4","title":"Main Lightbox IN","actionItemGroups":[{"actionItems":[{"id":"a-4-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".c-main-img-overlay-lightbox","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72dfa2"]},"value":"none"}},{"id":"a-4-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".c-main-img-overlay-lightbox","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72dfa2"]},"value":0,"unit":""}},{"id":"a-4-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".main-img-overlay-icon","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72df94"]},"yValue":50,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-4-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".main-img-overlay-icon","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72df94"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-4-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".c-main-img-overlay-lightbox","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72dfa2"]},"value":"flex"}}]},{"actionItems":[{"id":"a-4-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".c-main-img-overlay-lightbox","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72dfa2"]},"value":1,"unit":""}},{"id":"a-4-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".main-img-overlay-icon","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72df94"]},"yValue":0,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-4-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".main-img-overlay-icon","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72df94"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1613901263167},"a-5":{"id":"a-5","title":"Main Lightbox OUT","actionItemGroups":[{"actionItems":[{"id":"a-5-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".c-main-img-overlay-lightbox","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72dfa2"]},"value":0,"unit":""}},{"id":"a-5-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".main-img-overlay-icon","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72df94"]},"yValue":50,"xUnit":"PX","yUnit":"%","zUnit":"PX"}},{"id":"a-5-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":350,"target":{"useEventTarget":"CHILDREN","selector":".main-img-overlay-icon","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72df94"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-5-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".c-main-img-overlay-lightbox","selectorGuids":["e07479d0-18c1-e5db-e73b-aa3a0b72dfa2"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1613901263167},"a-6":{"id":"a-6","title":"thumbnail 1","actionItemGroups":[{"actionItems":[{"id":"a-6-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":750,"target":{"selector":".img._1","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2d1"]},"value":1,"unit":""}},{"id":"a-6-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._2","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cf"]},"value":0,"unit":""}},{"id":"a-6-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._3","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cb"]},"value":0,"unit":""}},{"id":"a-6-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}},{"id":"a-6-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1642360357349},"a-7":{"id":"a-7","title":"thumbnail 2","actionItemGroups":[{"actionItems":[{"id":"a-7-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".img._2","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cf"]},"value":"block"}},{"id":"a-7-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".img._2","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cf"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-7-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._3","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cb"]},"value":0,"unit":""}},{"id":"a-7-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._4","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cd"]},"value":0,"unit":""}},{"id":"a-7-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}},{"id":"a-7-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":750,"target":{"selector":".img._2","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cf"]},"value":1,"unit":""}},{"id":"a-7-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1642360357349},"a-8":{"id":"a-8","title":"thumbnail 3","actionItemGroups":[{"actionItems":[{"id":"a-8-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".img._3","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cb"]},"value":"block"}},{"id":"a-8-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".img._3","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cb"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-8-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":750,"target":{"selector":".img._3","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cb"]},"value":1,"unit":""}},{"id":"a-8-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._2","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cf"]},"value":0,"unit":""}},{"id":"a-8-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._4","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cd"]},"value":0,"unit":""}},{"id":"a-8-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}},{"id":"a-8-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1642360357349},"a-9":{"id":"a-9","title":"thumbnail 4","actionItemGroups":[{"actionItems":[{"id":"a-9-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".img._4","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cd"]},"value":"block"}},{"id":"a-9-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".img._4","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cd"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-9-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":750,"target":{"selector":".img._4","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cd"]},"value":1,"unit":""}},{"id":"a-9-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._2","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cf"]},"value":0,"unit":""}},{"id":"a-9-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._3","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cb"]},"value":0,"unit":""}},{"id":"a-9-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}},{"id":"a-9-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1642360357349},"a-10":{"id":"a-10","title":"thumbnail 5","actionItemGroups":[{"actionItems":[{"id":"a-10-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":"block"}},{"id":"a-10-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-10-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":750,"target":{"selector":".img._5","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","d7fa74b7-e921-59be-01dc-4e78767dae06"]},"value":1,"unit":""}},{"id":"a-10-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._2","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cf"]},"value":0,"unit":""}},{"id":"a-10-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._3","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cb"]},"value":0,"unit":""}},{"id":"a-10-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._1","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2d1"]},"value":0,"unit":""}},{"id":"a-10-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":500,"target":{"selector":".img._4","selectorGuids":["75e1e709-bf20-13da-6b41-485b0c9dd2bb","75e1e709-bf20-13da-6b41-485b0c9dd2cd"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1642360357349},"a-11":{"id":"a-11","title":"Accordion open","actionItemGroups":[{"actionItems":[{"id":"a-11-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64805aa0bbbc71169f5593fb|abd5a06a-8527-9524-8237-f9e8d1cca1c5"},"heightValue":80,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-11-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".accordion-icon","selectorGuids":["227868a9-92d8-e38a-2195-5f2689ffca0d"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-11-n-3","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":true,"id":"64805aa0bbbc71169f5593fb|abd5a06a-8527-9524-8237-f9e8d1cca1c5"},"widthUnit":"PX","heightUnit":"AUTO","locked":false}},{"id":"a-11-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".accordion-icon","selectorGuids":["227868a9-92d8-e38a-2195-5f2689ffca0d"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1606862693281},"a-12":{"id":"a-12","title":"Accordion close","actionItemGroups":[{"actionItems":[{"id":"a-12-n","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"easeInOut","duration":500,"target":{"useEventTarget":true,"id":"64805aa0bbbc71169f5593fb|abd5a06a-8527-9524-8237-f9e8d1cca1c5"},"heightValue":80,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-12-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".accordion-icon","selectorGuids":["227868a9-92d8-e38a-2195-5f2689ffca0d"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1606866824674},"a-14":{"id":"a-14","title":"Quote Ease In","actionItemGroups":[{"actionItems":[{"id":"a-14-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"c2db01e1-2943-df18-2460-b6b9ce5bfe99"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-14-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":1500,"target":{"id":"c2db01e1-2943-df18-2460-b6b9ce5bfe99"},"value":1,"unit":""}},{"id":"a-14-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":1000,"target":{"id":"c2db01e1-2943-df18-2460-b6b9ce5bfe99"},"xValue":0,"yValue":-8,"xUnit":"px","yUnit":"px","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1686312363079},"a-15":{"id":"a-15","title":"Fade In","actionItemGroups":[{"actionItems":[{"id":"a-15-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"64cd7b7a-541f-ee46-ab21-a96bb8d58adb"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-15-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":500,"target":{"useEventTarget":true,"id":"64cd7b7a-541f-ee46-ab21-a96bb8d58adb"},"yValue":-8,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-15-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":800,"target":{"useEventTarget":true,"id":"64cd7b7a-541f-ee46-ab21-a96bb8d58adb"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1686313170094},"a-16":{"id":"a-16","title":"Chapter 1 Fade In","actionItemGroups":[{"actionItems":[{"id":"a-16-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"a9d81c29-fc6d-82d7-9b17-69828c63aa49"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-16-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"a9d81c29-fc6d-82d7-9b17-69828c63aa49"},"yValue":-8,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-16-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":1000,"target":{"id":"a9d81c29-fc6d-82d7-9b17-69828c63aa49"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1686318066976},"a-17":{"id":"a-17","title":"Product Page Fadein","actionItemGroups":[{"actionItems":[{"id":"a-17-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"id":"64805aa0bbbc71169f5593fb|e2e42abe-eb06-0b19-2c9f-fc0fb2a8ce67"},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-17-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":1000,"target":{"id":"64805aa0bbbc71169f5593fb|e2e42abe-eb06-0b19-2c9f-fc0fb2a8ce67"},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1686318641361},"a-18":{"id":"a-18","title":"Product Hover In","actionItemGroups":[{"actionItems":[{"id":"a-18-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":300,"target":{"useEventTarget":true,"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc797"},"yValue":-10,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1686319284000},"a-19":{"id":"a-19","title":"Product Hover Out","actionItemGroups":[{"actionItems":[{"id":"a-19-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":300,"target":{"useEventTarget":true,"id":"64805aa0bbbc71169f5593fb|eaead3bb-8438-be84-7b0e-04cc14dbc797"},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1686319358172}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}
);
